import React__default, { useRef, useState, useEffect, useMemo, createElement, createContext, PureComponent, forwardRef, Component, cloneElement, Children, useContext, useLayoutEffect, useCallback, createRef } from 'react';
import { useLocation, useHistory, BrowserRouter, Link as Link$2, Redirect } from 'react-router-dom';
import { DefaultPalette as DefaultPalette$2, Stack, Icon, Text, Label, List, ActivityItem, TextField, Checkbox, FontWeights as FontWeights$2, GroupedList as GroupedList$2, SelectionMode, SearchBox, Separator, Callout, mergeStyles as mergeStyles$1, DatePicker, DayOfWeek, DialogFooter, PrimaryButton, DefaultButton, ShimmeredDetailsList, ColumnActionsMode, ConstrainMode, DetailsListLayoutMode, ContextualMenu, DirectionalHint, ContextualMenuItemType, Spinner, SpinnerSize, Dropdown, IconButton, Panel as Panel$1, PanelType as PanelType$1, Layer, MessageBar, MessageBarType, Link as Link$1, DefaultEffects as DefaultEffects$2, TooltipHost, Image, Persona, PersonaSize, CommandBarButton, Nav, CommandBar, Pivot, PivotLinkSize, Dialog, DialogType, mergeStyleSets, TeachingBubble, Sticky, StickyPositionType, DetailsHeader, NormalPeoplePicker, Modal, getTheme as getTheme$1 } from 'office-ui-fabric-react';
import { setupI18n } from '@lingui/core';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Provider as Provider$1, Subscribe } from 'unstated';
import { I18nProvider } from '@lingui/react';
import { Image as Image$1 } from 'office-ui-fabric-react/lib/Image';
import { DetailsRow, DetailsRowCheck, Selection, DetailsList, ColumnActionsMode as ColumnActionsMode$1, DetailsListLayoutMode as DetailsListLayoutMode$1, CheckboxVisibility, SelectionMode as SelectionMode$1 } from 'office-ui-fabric-react/lib/DetailsList';
import fs from 'fs';
import crypto$1 from 'crypto';
import stream from 'stream';
import PropTypes from 'prop-types';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

// A packages cache that makes sure that we don't inject the same packageName twice in the same bundle -
// this cache is local to the module closure inside this bundle
var packagesCache = {}; // Cache access to window to avoid IE11 memory leak.

var _win = undefined;

try {
  _win = window;
} catch (e) {
  /* no-op */
}

function setVersion(packageName, packageVersion) {
  if (typeof _win !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var packages = _win.__packages__ = _win.__packages__ || {}; // We allow either the global packages or local packages caches to invalidate so testing can
    // just clear the global to set this state

    if (!packages[packageName] || !packagesCache[packageName]) {
      packagesCache[packageName] = packageVersion;
      var versions = packages[packageName] = packages[packageName] || [];
      versions.push(packageVersion);
    }
  }
}

setVersion('@uifabric/set-version', '6.0.0');

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */

function startOfToday() {
  return startOfDay(Date.now());
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // TODO: Remove String()

    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters$1 = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, delimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

function convertToFP(fn, arity, a) {
  a = a || [];

  if (a.length >= arity) {
    return fn.apply(null, a.slice(0, arity).reverse());
  }

  return function () {
    var args = Array.prototype.slice.call(arguments);
    return convertToFP(fn, arity, a.concat(args));
  };
}

// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
var format$1 = convertToFP(format, 2);

/* eslint-disable */
var messages = {
  languageData: {
    "plurals": function (n, ord) {
      var s = String(n).split("."),
          i = s[0],
          t0 = Number(s[0]) == n;
      if (ord) return "other";
      return n == 1 || !t0 && (i == 0 || i == 1) ? "one" : "other";
    }
  },
  messages: {
    "\"": "\"",
    "\"Short name\" is used to identify the IT system and the manually roles in assignments and activities. The name will always be in capital letters with max 20 characters and numbers. You can also use the special characthers \"-\" and \"_\".": "\"Kort navn\" bruges til at identificere IT systemet og de tilknytninger og aktiviteter  der vises p\xE5 det manuelle IT system. \"Kort navn\" vil altid v\xE6re med maksimalt 20 karakterer af store bogstaver og eller tal. Det er muligt at bruge b\xE5de \"-\" og \"_\".",
    "%cStop!": "%cStop!",
    "%cThis is a browser feature intended for developers. If someone asked you to copy and paste something here, please contact your IT administrator.": "%cDette er en browserfunktion, der er tilt\xE6nkt udviklere. Hvis nogen har bedt dig om at kopiere og inds\xE6tte noget her, s\xE5 skal du kontakte din IT-administrator.",
    "(Constraints)": "(Dataafgr\xE6nsninger)",
    "({0} of {1} shown)": function (a) {
      return ["(", a("0"), " af ", a("1"), " vist)"];
    },
    "1 month": "1 m\xE5ned",
    "1 week": "1 uge",
    "3 months": "3 m\xE5neder",
    "A to Z": "A til \xC5",
    "Accept": "Godkend",
    "Accept selected username": "Accepter valgte brugernavn",
    "Access Denied": "Adgang N\xE6gtet",
    "Access to ID Connect always requires a two-step verification.": "Adgang til ID Connect kr\xE6ver altid en totrinsbekr\xE6ftelse.",
    "Account information": "Konto information",
    "Action": "Handling",
    "Action:": "H\xE6ndelse:",
    "Activate Employee": "Aktiver Medarbejder",
    "Activate IT access": "Aktiver IT adgang",
    "Active from": "Aktiv fra",
    "Active to": "Aktiv til",
    "Activity List": "Aktivitetsliste",
    "Activity list": "Aktivitetsliste",
    "Add": "Tilf\xF8j",
    "Add Constraints to System Role": "Tilf\xF8j begr\xE6nsninger til systemrolle",
    "Add a comment to the task": "Tilf\xF8j en kommentar til opgaven",
    "Added": "Tilknyttet",
    "Affects": "P\xE5virker",
    "All Business Roles": "Alle Profilroller",
    "All Technical Roles": "Alle Funktionsroller",
    "All roles that is assigned to the employee will be removed from the employee!": "Medarbejderen vil f\xE5 fjernet alle sine roller!",
    "All roles will be deleted from the user, the IT account will be deactivated and the user will be put into quarantine.": "Alle roller slettes fra brugeren, IT-kontoen deaktiveres og brugeren s\xE6ttes i karant\xE6ne.",
    "Allow to add comment / explanations when the role is assigned.": "Tillad at tilf\xF8je kommentarer n\xE5r rollen tildeles",
    "Alphabetical": "Alfabetisk",
    "Amount of employees assigned:": "Antal af medarbejdere tilknyttet:",
    "Amount of role groups assigned:": "Antal af profilroller tilknyttet:",
    "Amount of system roles assigned:": "Antal systemroller tilknyttet:",
    "Amount of technical roles assigned:": "Antal af funktionsroller tilknyttet:",
    "An error occurred while fetching the user data.": "Fejl ved indl\xE6sning af brugerdata.",
    "Apply": "Anvend",
    "Apply changes": "Gem \xE6ndringer",
    "Approval ID:": "Anmodnings ID",
    "Approval for assignment": "Anmodning om tildeling",
    "Approval for removal": "Anmodning om fjernelse",
    "Approvals": "Godkendelser",
    "Approve": "Godkend",
    "Approve Request": "Godkend Anmodning",
    "Approve and activate": "Godkend og aktiver",
    "Approve and activate the employee to be able to assign roles": "Godkend og aktiver medarbejderen for at kunne tildele roller",
    "Approve and restore": "Godkend og gendan",
    "Approve and restore the employee to be able to assign roles": "Godkend og gendan medarbejderen for at kunne tildele roller",
    "Approve mapping changes": "Godkend tilknytnings\xE6ndringerne",
    "Approving and activating the mapping changes to the organisational unit has following consequences for": "Godkendelse og aktivering af tilknytnings\xE6ndringerne til organisationsenheden har f\xF8lgende konsekvenser for",
    "Approving and activating the mapping changes to the organisational unit, have no impact on employees' rights in the unit.": "Godkendelse og aktivering af tilknytnings\xE6ndringerne til organisationsenheden, har ingen konsevenser for medarbejdernes rettigheder i enheden.",
    "Apr": "Apr",
    "April": "April",
    "Assign": "Tilknyt",
    "Assign Employees": "Tilknyt Medarbejdere",
    "Assign Employements": "Tilknyt Ans\xE6ttelser",
    "Assign Employments": "Tilknyt Ans\xE6ttelser",
    "Assign Organisation Units": "Tilknyt organisationsenheder",
    "Assign Organisational Units": "Tilknyt Organisationsenheder",
    "Assigned": "Tildelt",
    "Assigning template \"{templateName}\" to system \"{0}\"": function (a) {
      return ["Tilknyning af template \"", a("templateName"), "\" til system \"", a("0"), "\""];
    },
    "Assignment": "Tildeling",
    "Assignment Type": "Tildelings type",
    "Assignment is waiting for approval": "Tildeling afventer godkendelse",
    "Assignments that will not be removed:": "Tilknytninger som ikke fjernes:",
    "Assignments to be removed": "Tilknytninger som fjernes",
    "Assignments to be removed:": "Tilknytninger som fjernes:",
    "Associated Accounts": "Forbundne Konti",
    "Attention!": "Bem\xE6rk!",
    "Aug": "Aug",
    "August": "August",
    "Awaiting approval before added": "Afventer godkendelse",
    "Awaiting approval before removed": "Afventer godkendelse",
    "Back to Dashboard": "Tilbage til Dashboard",
    "Blocked": "Blokeret",
    "Body": "Indhold",
    "Bookmark the login page below instead of your current page.": "Bookmark nedenst\xE5ende login side i stedet for din nuv\xE6rende side.",
    "Brief deciption of the request": "Kort beskrivelse af anmodningen",
    "Brief deciption of the request.": "Kort beskrivelse af anmodningen.",
    "Business Role": "Profilrolle",
    "Business Role - Employment": "Profilrolle - Ans\xE6ttelse",
    "Business Role Name": "Profilrollen's navn",
    "Business Roles": "Profilroller",
    "Business manager": "Funktionsleder",
    "Business role": "Profilrolle",
    "Business role is marked to be deleted": "Profilrollen er markeret til at blive slettet",
    "Business roles": "Profilroller",
    "Business roles ({addedBusinessRoleCount})": function (a) {
      return ["Profilroller (", a("addedBusinessRoleCount"), ")"];
    },
    "Business roles ({removedBusinessRoleCount})": function (a) {
      return ["Profilroller (", a("removedBusinessRoleCount"), ")"];
    },
    "CSV files of more than 1.000.000 rows cannot be imported into Excel.": "CSV-filer p\xE5 mere end 1.000.000 r\xE6kker kan ikke importeres til Excel",
    "Cancel": "Annuller",
    "Cancel Changes": "Annuller \xC6ndringer",
    "Cannot": "Kan ikke",
    "Cannot copy masked value": "Maskeret v\xE6rdi kan ikke kopieres",
    "Category": "Kategori",
    "Change Multi-Factor Authentication": "Skift Multi-Faktor.",
    "Change name of the copied": "Skift navnet p\xE5 den kopierede",
    "Change settings for list view": "Skift indstillinger for visning",
    "Changing the name of the copied {text} is optional. If you do not enter any, the copied {text} will be given a generated name": function (a) {
      return ["\xC6ndring af navnet p\xE5 den kopierede ", a("text"), " er valgfri. Hvis du ikke indtaster nogen, vil den kopierede ", a("text"), " f\xE5 et genereret navn"];
    },
    "Choose organisational units": "V\xE6lg organisationsenheder",
    "Clear all": "Ryd alt",
    "Clear filter": "Ryd filter",
    "Click for more details": "Klik for at se mere",
    "Click to select user": "Klik for at v\xE6lge bruger",
    "Close": "Luk",
    "Comment": "Kommentar",
    "Comment from approver": "Kommentar fra godkender",
    "Comment from assigner": "Kommentar fra tildeler",
    "Comment from requester": "Kommentar fra anmoder",
    "Comment will be added to the request and the email sent to the receiver(s) of this request.": "Din kommentar vil blive tilf\xF8jet p\xE5 anmodningen, samt p\xE5 den mail, som vil blive sendt til modtager(ne) af denne anmodning.",
    "Comment will be added to the request and the email sent to {requester}.": function (a) {
      return ["Din kommentar vil blive tilf\xF8jet p\xE5 anmodningen og sendt til ", a("requester"), "."];
    },
    "Constraints": "Afgr\xE6nsninger",
    "Contact Information": "Kontaktinformation",
    "Continue Editing": "Forts\xE6t Redigering",
    "Copied!": "Kopieret!",
    "Copy": "Kopier",
    "Copy {text}": function (a) {
      return ["Kopier ", a("text")];
    },
    "Could not download username and password to file. Please copy the values manually": "Brugernavn og password kunnne ikke downloades til filen. Kopier venligst v\xE6rdierne manuelt.",
    "Create Position": "Opret ans\xE6ttelsesforhold",
    "Create new": "Opret ny",
    "Create new organisational unit": "Opret organisationsenhed",
    "Create new service account": "Opret ny service konto",
    "Create new user / employment": "Opret ny bruger / ans\xE6ttelsesforhold",
    "Created": "Oprettet",
    "DUBU": "DUBU",
    "Danish": "Dansk",
    "Date": "Dato",
    "Date:": "Dato:",
    "Deactivate": "Deaktiver",
    "Deactivate IT access": "Deaktiver IT adgang",
    "Deactivation date:": "Deaktiveringsdato:",
    "Dec": "Dec",
    "December": "December",
    "Default": "Standard",
    "Default filter": "Standard filter",
    "Default filter is activated on the Technical role list. To see all Technical roles assigend to the user, remove the filter": "Standard filter er aktiveret p\xE5 listen med Funktionsroller. For at se alle de Funktionsroller, som er tilknyttet til brugeren skal du fjerne filteret",
    "Default mail receiver": "Default mail modtager",
    "Delete": "Slet",
    "Delete \"{name}\"?": function (a) {
      return ["Slet \"", a("name"), "\"?"];
    },
    "Delete organisational unit": "Slet organisationsenhed",
    "Delete user": "Slet bruger",
    "Deleting": "Sletter",
    "Deleting item": "Sletter enheden",
    "Deleting organisational unit...": "Sletter organisationsenheden...",
    "Deletion in process": "Sletning er sat igang",
    "Denied": "Afvist",
    "Deny": "Afvis",
    "Deny Request": "Afvis Anmodning",
    "Deny mapping changes": "Afvis tilknytnings\xE6ndringerne",
    "Denying the mapping changes to the organisational unit has following consequences for": "Afvisningen af tilknytnings\xE6ndringerne til organisationsenheden, har f\xF8lgende konsevenser for",
    "Denying the mapping changes to the organisational unit, have no impact on employees' rights in the unit.": "Afvisningen af tilknytnings\xE6ndringerne til organisationsenheden, har ingen konsevenser for medarbejderne i enheden.",
    "Departments": "Afdeleinger",
    "Description": "Beskrivelse",
    "Detailed consequences:": "Detaljerede konsekvenser:",
    "Direct": "Direkte",
    "Direct Roles": "Direkte Roller",
    "Disable": "Deaktiver",
    "Disable IT account": "Deaktiver IT konto",
    "Display name": "Vist navn",
    "Do you have questions?": "Har du et sp\xF8rgsm\xE5l?",
    "Do you understand the consequences": "Forst\xE5r du konsekvenserne",
    "Do you want to assign the role to underlying organisational units as well?": "\xD8nsker du at tilknytte rollen til underliggende organisationsenheder?",
    "Do you want to continue?": "\xD8nsker du at fors\xE6tte?",
    "Do you want to remove the role from underlying organisational units as well?": "\xD8nsker du at fjerne rollen fra underliggende organisationsenheder?",
    "Do you wish to continue?": "\xD8nsker du at fors\xE6tte?",
    "Download": "Download",
    "Downloading report...": "Downloader rapporten...",
    "Earlier": "Tidligere",
    "Edit": "Rediger",
    "Edit Business Manager": "Rediger Funktionsleder",
    "Edit Employment": "Rediger ans\xE6ttelse",
    "Edit KLE": "Rediger KLE",
    "Edit Mappings": "Rediger Tilknytninger",
    "Edit Profile": "Rediger profil",
    "Edit Roles": "Rediger roller",
    "Edit User": "Rediger Bruger",
    "Edit employment": "Rediger ans\xE6ttelse",
    "Edit organisation": "Rediger organisationsenhed",
    "Edit organisational unit": "Rediger orgaisationsenhed",
    "Edit username": "Rediger brugernavn",
    "Email is required. Please enter one or more emails.": "E-mail er kr\xE6vet. Venligst indtast en eller flere e-mail adresser.",
    "Email subject": "E-mail emne",
    "Emails": "Emails",
    "Employed in": "Ansat i",
    "Employed in {0} ({1})": function (a) {
      return ["Ansat i ", a("0"), " (", a("1"), ")"];
    },
    "Employees": "Medarbejdere",
    "Employees in the organisational unit will be effected as following:": "Medarbejdere i organisationsenheden p\xE5virkes p\xE5 f\xF8lgende m\xE5de:",
    "Employees:": "Medarbejdere:",
    "Employment": "Ans\xE6ttelse",
    "Employment Roles": "Ans\xE6ttelses Roller",
    "Employment information": "Ans\xE6ttelsesforhold information",
    "Employment type": "Ans\xE6ttelsesforholdstype",
    "Employments": "Ans\xE6ttelser",
    "Employments found from national ID registry": "Ans\xE6ttelser fundet fra CPR-registeret",
    "End time": "Sluttid",
    "English": "Engelsk",
    "Enter Email address": "Indtast e-mail adresse",
    "Enter IT system UUIDs": "Indtast IT system UUIDs",
    "Enter KLE constraints": "Indtast KLE afgr\xE6nsninger",
    "Enter comment to the assignment:": "Indtast en kommentar til tilknytningen:",
    "Enter one or more emails": "Indtast en eller flere e-mails",
    "Enter one or more emails. On new role creation the email(s) will be added as default mail receiver. Notice, it can be changed manually on the Technical role.": "Inds\xE6t en eller flere e-mail adresser. N\xE5r der senere oprettes funktionsroller hvor systemrollen indg\xE5r, foresl\xE5s \"mail modtage(e)\" automatisk.\"Mail modtager(e)\" kan \xE6ndres n\xE5r funktionsrollen oprettes",
    "Enter one or more emails. When the technical role will be asigned mail receivers will be notified by email. The email contains a link to ID Connect, where assignment can be approved or denied.": "Inds\xE6t en eller flere email adresser. N\xE5r funktionsrollen tilknyttes bliver mail modtagere informeret via en notification indeholdende et link til en godkendelses proces i ID Connect",
    "Enter one or more emails. When the technical role will be assigned mail receivers will be notified by email. The email contains a link to ID Connect, where assignment can be approved or denied.": "Indtast en eller flere e-mails. Hvorn\xE5r den tekniske rolle vil blive tildelt, vil mailmodtagere f\xE5 besked via e-mail. Mailen indeholder et link til ID Connect, hvor opgaven kan godkendes eller afvises.",
    "Enter the constraints": "Indtast dataafgr\xE6nsningerne",
    "Entity ID": "Enhedens ID",
    "Entity Name": "Enhedens Navn",
    "Entity Type": "Enhedstype",
    "Error": "Fejl",
    "Event Type": "Aktivitetstype",
    "Event type": "Event type",
    "Expand report": "Fuld sk\xE6rm",
    "Explain what the receiver have to do in order to assign the role": "Beskriv hvad modtageren skal g\xF8re for at tildele rollen",
    "Explain what the receiver have to do in order to assign the role.": "Beskriv hvad modtageren skal g\xF8re for at tildele rollen.",
    "Explore all apps": "Se alle Apps",
    "Explore all groups": "Se alle profilroller",
    "Explore all roles": "Se alle funktionsroller",
    "FAQ": "FAQ",
    "Feb": "Feb",
    "February": "Februar",
    "Fetching Report": "Henter rapport",
    "Fetching organisational units...": "Henter organisationsenheder...",
    "Filter by": "Filtrer efter",
    "Format": "formater",
    "Fr": "Fr",
    "Friday": "Fredag",
    "From Date": "Fra dato",
    "Generate CSV report": "Generer CSV-rapport",
    "Generate report": "Generer rapport",
    "Get Report": "Hent Rapport",
    "Get an overview with the Management Report": "F\xE5 et overblik med Ledelsesrapporten",
    "Get an overview with the System Report": "F\xE5 et overblik med System rapporten",
    "Get next username suggestions": "Hente flere brugernavn forslag",
    "Give feedback": "Giv feedback",
    "Go Back": "G\xE5 tilbage",
    "Go back to the login page and sign in again with the correct token.": "G\xE5 tilbage til login siden og login igen med korrekt token.",
    "Go to next month": "G\xE5 til n\xE6ste m\xE5ned",
    "Go to next year": "G\xE5 til n\xE6ste \xE5r",
    "Go to previous month": "G\xE5 til forrige m\xE5ned",
    "Go to previous year": "G\xE5 til forrige \xE5r",
    "Go to today": "G\xE5 til i dag",
    "Go to user": "G\xE5 til bruger",
    "Good afternoon": "Godeftermiddag",
    "Good evening": "Godaften",
    "Good morning": "Godmorgen",
    "Grouped": "Grupperet",
    "Grouped By Date": "Grupperet p\xE5 dato",
    "Has unassigned mandatory constraints": "Har utildelte, obligatoriske afgr\xE6nsninger",
    "Help": "Hj\xE6lp",
    "Here you can change the type of two-step verification you use to log in to ID Connect.": "Her kan du \xE6ndre den type totrinsbekr\xE6ftelse, du bruger til at logge ind i ID Connect.",
    "Here you can deactivate your IT account. Note that you cannot reactivate it yourself. To have the account reactivated, contact your user administrator.": "Her kan du deaktivere din IT-konto. Bem\xE6rk, at du ikke selv kan aktivere den igen. For at f\xE5 kontoen aktiveret igen, skal du kontakte din brugeradministrator.",
    "Hide Info Badge": "Skjul Info Badge",
    "Hide details": "Skjul detaljer",
    "Home": "Hjem",
    "I understand the consequences": "Jeg forst\xE5r konsekvenserne",
    "IT System": "IT System",
    "IT System identifier. Click for more information.": "IT System id. Klik for mere information.",
    "IT System name": "IT System navn",
    "IT access for the employee is deactivated.": "Brugerens IT adgang er deaktiveret.",
    "IT-System": "IT-System",
    "Id": "Id",
    "If the problem persists, please contact your system administrator or IT support immediately.": "Hvis problemet forts\xE6tter, kontakt venligst din systemadministrator eller IT-support.",
    "If you want to create a new user or employment relationship, you fill in the right side of the screen and press create.": "\xD8nsker du at oprette en ny bruger eller ans\xE6ttelsesforhold, udfylder du h\xF8jre side af sk\xE6rmen og trykker p\xE5 opret.",
    "If you want to use one of the existing employment relationships or user account, press cancel and find the user under users in the User module.": "\xD8nsker du at benytte et af de eksisterende ans\xE6ttelsesforhold eller brugerkonto trykker du p\xE5 annuller og finder brugeren frem under brugere i User modulet.",
    "Illegal Action": "Ulovlig Handling",
    "Include": "Inkluder",
    "Incorrect link": "Forkert link",
    "Info": "Info",
    "Information regarding approval process": "Information om anmodnings proces",
    "Information regarding assignment process": "Information omkring tildelingsproces",
    "Instead, if you want to maintain your entry manually, e.g. if the IT system is not found in the list, the IT system UUID must be entered in the format 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.": "\xD8nsker du i stedet at vedligeholde din indtastning manuelt, f.eks. hvis IT systemet ikke findes i idconnect skal It systemets UUID indtastes i formatet 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'. ",
    "Instead, if you want to maintain your entry manually, e.g. if the organisational unit is not found in the organisation, the organisational unit's UUID must be entered in the format 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'": "\xD8nsker du i stedet at vedligeholde din indtastning manuelt, f.eks. hvis organisationsenheden ikke findes i organisationen skal organisationsenhedens UUID indtastes i formatet 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'. ",
    "Instead, if you want to maintain your entry manually, the KLE number must be entered in 6 digits in the format 'xx.xx.xx'. Here it is also possible to use * selection at the first and second levels of the KLE hierarchy. This selects either all (*) or level 1 and all the underlying numbers. For example, '32. *.' or more areas with example 32.*,33.*,etc.": "\xD8nsker du i stedet at vedligeholde din indtastning manuelt, skal KLE-tallet indtastes med 6-cifre i formatet 'xx.xx.xx'. Her er det ogs\xE5 muligt at bruge * markering p\xE5 f\xF8rste og andet niveau i KLE hierarkiet. Dermed v\xE6lges enten alle (*) eller niveau 1 og alle de underliggende tal. For eksempel '32. *.' eller flere omr\xE5der med eksempel 32.*,33.*,etc.",
    "Invalid date format.": "Ugyldigt datoformat",
    "It is now recommended that you close this window before continuing your work.": "Det anbefales nu at du lukker dette vindue f\xF8r du forts\xE6tter dit arbejde.",
    "Item is Being Added": "Elementet er ved at blive tilf\xF8jet",
    "Item is Being Removed": "Elementet er ved at blive slettet",
    "Item is Updating": "Elementet er ved at blive opdateret",
    "Items per page:": "Antal pr. side:",
    "Its the first time the user is activated, therefore you must change the username.": "Det er f\xF8rste gang brugerens IT konto aktiveres og derfor er det et krav at brugernavnet bliver skiftet.",
    "Jan": "Jan",
    "January": "Januar",
    "Jul": "Jul",
    "July": "Juli",
    "Jun": "Jun",
    "June": "Juni",
    "KLE": "KLE",
    "KLE Interest": "KLE Indsigt",
    "KLE Perform": "KLE Udf\xF8rer",
    "KLE interest": "KLE indsigt",
    "KLE interest ({addedKleInterestCount})": function (a) {
      return ["KLE indsigt (", a("addedKleInterestCount"), ")"];
    },
    "KLE interest ({addedKlePerformCount})": function (a) {
      return ["KLE indsigt (", a("addedKlePerformCount"), ")"];
    },
    "KLE interest ({removedKlePerformCount})": function (a) {
      return ["KLE indsigt (", a("removedKlePerformCount"), ")"];
    },
    "KLE is required. Please select or enter KLE values.": "KLE er kr\xE6vet. Venlist v\xE6lg eller indtast KLE.",
    "KLE perform": "KLE udf\xF8rer",
    "KLE perform ({addedKleInterestCount})": function (a) {
      return ["KLE udf\xF8r (", a("addedKleInterestCount"), ")"];
    },
    "KLE perform ({addedKlePerformCount})": function (a) {
      return ["KLE udf\xF8r (", a("addedKlePerformCount"), ")"];
    },
    "KLE perform ({removedKleInterestCount})": function (a) {
      return ["KLE udf\xF8r (", a("removedKleInterestCount"), ")"];
    },
    "KOMBIT does not support a description with more than 1000 characters.": "KOMBIT unders\xF8tter ikke en beskrivelse p\xE5 mere end 1000 karakterer.",
    "Last month": "Sidste m\xE5ned",
    "Last week": "Sidste uge",
    "Latest {eventsShown} events shown": function (a) {
      return ["Seneste ", a("eventsShown"), " h\xE6ndelser vises"];
    },
    "Learn more about opening CSV files in Excel": "F\xE5 mere at vide om at \xE5bne CSV filer i Excel",
    "Learn more about the {0} application": function (a) {
      return ["F\xE5 mere at vide om ", a("0"), " applikationen"];
    },
    "Learn more about {0}": function (a) {
      return ["L\xE6r mere om ", a("0")];
    },
    "List": "Liste",
    "Loading Activity...": "Henter Aktivitet...",
    "Loading Business Role...": "Henter Profilrolle...",
    "Loading Managers...": "Henter ledere...",
    "Loading Organisational Unit...": "Henter organisationsenhed...",
    "Loading System...": "Henter System...",
    "Loading Technical Role...": "Henter Funktionsrolle...",
    "Loading data...": "Henter data...",
    "Loading employee employments...": "Henter medarbejderens ans\xE6ttelser",
    "Loading employees..": "Henter medarbejdere..",
    "Loading employees...": "Henter medarbejdere...",
    "Loading employments..": "Henter ans\xE6ttelser..",
    "Loading item...": "Henter data...",
    "Loading items...": "Henter data...",
    "Loading organisation units...": "Henter organisationsenheder",
    "Loading organisational unit template...": "Henter organisationsenheds template...",
    "Loading profile...": "Henter profilen...",
    "Loading system roles...": "Henter system roller...",
    "Loading tasks..": "Henter opgaver..",
    "Loading, please wait...": "Indl\xE6ser data, vent venligst...",
    "Logout": "Logud",
    "Make this position primary": "G\xF8r denne ans\xE6ttelse til den prim\xE6re",
    "Manage your account": "Administrer din konto",
    "Manager": "Leder",
    "Manager employment": "Lederans\xE6ttelse",
    "Managers": "Ledere",
    "Mandatory": "Obligatorisk",
    "Manual editing of UUID": "Manuel indtastning af UUID",
    "Manual entry:": "Manuel indtastning:",
    "Manual system": "Manuelt system",
    "Manually change uuid assignment": "Manuel indtastning af UUID",
    "Manually edit UUID": "Manuel indtastning af UUID",
    "Manuel edit KLE areas": "Manuel indtastning af KLE",
    "Mapping": "Tilknytning",
    "Mappings": "Tilknytninger",
    "Mar": "Mar",
    "March": "Marts",
    "May": "Maj",
    "Message from requester:": "Besked fra anmoder:",
    "Mo": "Ma",
    "Mobile": "Mobil",
    "Monday": "Mandag",
    "Multi factor is required on login and multi factor is not configured for your user.": "Multifaktor er p\xE5kr\xE6vet ved login, og og din bruger opfylder ikke denne betingelse.",
    "My Account": "Min Konto",
    "My Profile": "Min Profil",
    "Name": "Navn",
    "Name id": "Navneid",
    "New": "Ny",
    "New Business Role": "Ny Profilrolle",
    "New Manuel System": "Nyt Manuelt System",
    "New Technical Role": "Ny Funktionsrolle",
    "New assignments that will be removed:": "Nye tilknytninger som vil blive fjernet:",
    "New assignments:": "Nye tilknytninger:",
    "New employment": "Ny ans\xE6ttelse",
    "Newest on top": "Nyeste \xF8verst",
    "Next": "N\xE6ste",
    "No": "Nej",
    "No Business Roles assigned yet!": "Ingen profilroller tilf\xF8jet endnu!",
    "No Changes": "Ingen \xE6ndringer",
    "No Constraint": "Ingen Afgr\xE6nsning",
    "No Constraint selected": "Ingen afgr\xE6nsning valgt",
    "No IT Account": "Ingen IT adgang",
    "No IT systems selected": "Ingen It systemer valgt",
    "No KLE numbers selected": "Inge KLE numre er valgt",
    "No Technical Roles assigned yet!": "Ingen funktionsroller tilf\xF8jet endnu",
    "No User Profile Data Found": "Brugerens profil blev ikke fundet",
    "No changes": "Ingen \xE6ndringer",
    "No display name listed": "Ingen vist navn anf\xF8rt",
    "No email addresse listed": "Ingen e-mail adresser er listet",
    "No email addresses listed": "Ingen emailadresser anf\xF8rt",
    "No end date": "Ingen slut dato",
    "No item matches search.": "Der blev ikke fundet nogen resultater.",
    "No items are assigned.": "Ingen elementer er tildelt endnu.",
    "No items available": "Ingen elementer til r\xE5dighed",
    "No items available to show.": "Der er ingen elementer at vise.",
    "No items match your search.": "Ingen elementer matcher din s\xF8gning.",
    "No items matches search.": "Der blev ikke fundet nogen resultater.",
    "No items to show.": "Ingen resultater at vise.",
    "No organisation": "Ingen organisation",
    "No organisational units found": "Ingen organisationsenheder fundet",
    "No phone numbers listed": "Ingen telefonnumre anf\xF8rt",
    "No salary number listed": "Ingen l\xF8nl\xF8nner anf\xF8rt",
    "No status available": "Ingen tilg\xE6nglig status",
    "No users or employments found from social security number.": "Ingen brugere eller ans\xE6ttelser fundet p\xE5 indtastede CPR-nummer.",
    "No {0} listed": function (a) {
      return ["Ingen ", a("0"), " anf\xF8rt"];
    },
    "Not activated": "Ikke aktiveret",
    "Note": "Bem\xE6rk",
    "Note that manual entry of multiple UUIDs must be separated by a comma (,)": "Bem\xE6rk at manuel indtastning af flere UUID'er skal adskilles med et komma (,)",
    "Note that manual entry of multiple numbers must be separated by a comma (,)": "Bem\xE6rk at manuel indtastning af flere numre skal adskilles med et komma (,)",
    "Note that this can only be undone by your user administrator.": "Bem\xE6rk at dette kun kan fortrydes af din brugeradministrator.",
    "Note:": "Bem\xE6rk:",
    "Notice: Do not press \"Assigned\" until the right has been assigned in the requested system.": "Bem\xE6rk: Du m\xE5 ikke trykke p\xE5 \"Tildelt\" f\xF8r rettigheden er tildelt i det anmodede system.",
    "Notice: Do not press \"Removed\" until the right has been deassigned in the requested system.": "Bem\xE6rk: Du m\xE5 ikke trykke p\xE5 \"Fjernet\" f\xF8r rettigheden er frataget brugeren i fagsystemet.",
    "Notice: This user has Technical Roles assigned via": "Bem\xE6rk: Brugeren har funktionsroller tilknyttet via",
    "Nov": "Nov",
    "November": "November",
    "Number": "Nummer",
    "Oct": "Okt",
    "October": "Oktober",
    "Ok": "OK",
    "Older": "\xC6ldre",
    "Oldest on top": "\xC6ldste \xF8verst",
    "One or more of the selected employees doesnt exist": "En eller flere af de valgte medarbejdere eksisterer ikke",
    "One or more of the selected employments doesnt exist": "En eller flere af de valgte ans\xE6ttelser eksisterer ikke",
    "Optional": "Optionel",
    "Optional Roles": "Optionelle Roller",
    "Organisation": "Organisation",
    "Organisational Unit": "Organisationsenhed",
    "Organisational Unit - Business Role": "Organisationsenhed - Profilrolle",
    "Organisational Units": "Organisationsenheder",
    "Organisational unit": "Organisationsenhed",
    "Organisational unit information": "Organisationsenheds information",
    "Organisational unit mapping": "Organisationsenhed tilknytning",
    "Organisational unit type": "Organisationsenheds type",
    "Organisational units": "Organisationsenheder",
    "Other informations": "Andre informationer",
    "Page:": "Side:",
    "Password": "Adgangskode",
    "Path": "Sti",
    "Performed": "Udf\xF8rt",
    "Performed By": "Udf\xF8rt Af",
    "Performed On": "Udf\xF8rt P\xE5",
    "Performed Type": "Udf\xF8relsestype",
    "Performed by": "Udf\xF8rt af",
    "Permanent": "Permanent",
    "Phone Numbers": "Telefonnumre",
    "Please approve mapping changes to \"": "Venligst godkend \xE6ndringerne til \"",
    "Please change time to after start time": "Venligst \xE6ndre tiden til efter start tiden",
    "Please check you have the correct url / adress to the system you are trying to access.": "Kontroller om du har den rigtige url / adresse til det system du fors\xF8ger at logge p\xE5.",
    "Please contact your system administrator to get the solved.": "Kontakt venligst din systemadministrator for at f\xE5 l\xF8st problemet",
    "Please enter a social security number to get a template": "Venligst skriv et cpr nummer for at f\xE5 en template",
    "Please enter a valid social security number.": "Tast venligst et gyldigt CPR-nummer.",
    "Please enter text here": "Skriv venligst her",
    "Please enter valid time": "Venligst indtast en valid tid",
    "Please fill out form below to create a new organisational unit": "Venligst udfyld den nedenst\xE5ende formular for at oprette en ny organisationsenhed",
    "Please fill out form below, to create a new employeement": "Venligst udfyld den nedenst\xE5ende formular for at oprette et nyt ans\xE6ttelsesforhold",
    "Please fill out form below, to create a new service account": "Venligst udfyld den nedenst\xE5ende formular for at oprette en ny servicekonto",
    "Please read the following:": "L\xE6s venligst nedenst\xE5ende:",
    "Please search from social security number.": "S\xF8g p\xE5 CPR-nummer.",
    "Please select a new username for the user": "V\xE6lg venligst et nyt brugernavn til brugeren",
    "Please select a primary employment by clicking on the star on the employment.": "V\xE6lg venligst en prim\xE6r ans\xE6ttelse ved at klikke p\xE5 stjernen p\xE5 ans\xE6ttelsen.",
    "Please select an employment on which you wish to edit roles.": "V\xE6lg venligst den ans\xE6ttelse, som du \xF8nsker at redigere roller p\xE5.",
    "Please try logging in again later or contact your administrator if the problem persists.": "Pr\xF8v at logge ind igen senere eller kontakt din administrator hvis problemet fors\xE6tter.",
    "Please try logging in again or contact your administrator if the": "Pr\xF8v at logge ind igen eller kontakt din administrator hvis",
    "Please try logging in again or contact your administrator if the problem persists.": "Pr\xF8v at logge ind igen eller kontakt din administrator hvis problemet ikke l\xF8ses.",
    "Please type \"{confirmationText}\" to confirm:": function (a) {
      return ["Tast \"", a("confirmationText"), "\" for at bekr\xE6fte:"];
    },
    "Please wait... do not close the window!": "Vent venligst... Luk ikke vinduet!",
    "Please write a comment to your approval request.": "Skriv venligst en kommentar til godkendelses anmodningen.",
    "Position": "Stilling",
    "Previous": "Forrige",
    "Primary employment": "Prim\xE6r ans\xE6ttelse",
    "Primary position": "Prim\xE6r ans\xE6ttelse",
    "Primary position updated successfully": "Prim\xE6r ans\xE6ttelse opdateret",
    "Processed": "Behandlet",
    "Profile": "Profil",
    "Questions can be directed to": "Sp\xF8rgsm\xE5l kan rettes til",
    "Quick Links": "Links",
    "Quick links": "Links",
    "Read more in the User Manual": "L\xE6s mere i brugermanualen",
    "Read more in the user manual": "L\xE6s mere i brugermanualen",
    "Receiver:": "Modtager:",
    "Receivers": "Modtagere",
    "Regular Expression": "Regular Expression",
    "Remember to copy password!": "Husk at kopiere adgangskoden!",
    "Removal is waiting for approval": "Fjernelsen afventer godkendelse",
    "Remove": "Fjern",
    "Remove System Role": "Fjern Systemrollen",
    "Removed": "Fjernet",
    "Reports": "Rapporter",
    "Request ID": "Anmodnings ID",
    "Request concerns:": "Anmodning vedr\xF8rer",
    "Requested": "Anmodet",
    "Requester": "Anmodet af",
    "Requester:": "Anmodet af:",
    "Reset": "Nulstil",
    "Reset MFA": "Nulstil MFA",
    "Reset Multifactor Authentication": "Nulstil Multifaktor Autentifikation",
    "Restore Employee": "Gendan Medarbejder",
    "Restore User": "Gendan Bruger",
    "Retry Login": "Log ind igen",
    "Retry login": "Pr\xF8v at logge ind igen",
    "Return to Dashboard": "Vend tilbage til Dashboard",
    "Return to main page": "Tilbage til hovedsiden",
    "Rights in ID Connect": "Rettigheder i ID Connect",
    "Role": "Funktionsrolle",
    "Role assignment": "Rolletilknytning",
    "Role assignment directly to user": "Rolletilknytning direkte p\xE5 brugeren",
    "Role assignment to user employment: {positionName}": function (a) {
      return ["Rolletilknytning til brugerens ans\xE6ttelsesforhold: ", a("positionName")];
    },
    "Role is Being Deleted": "Rollen er ved at blive slettet",
    "Role removal": "Rolle fjernelse",
    "Role with waiting approvals": "Funktionsrolle med afventede godkendelser",
    "Roles are assigned via an organisational unit and business role": "Roller er tilknyttet via organisationsenhed og profilrolle",
    "Sa": "L\xF8",
    "Salary number": "L\xF8nnummer",
    "Saturday": "L\xF8rdag",
    "Save": "Gem",
    "Save Manager": "Gem Leder",
    "Save changes": "Gem \xE6ndringer",
    "Save mapping to unit \"{0}\"": function (a) {
      return ["Gemmer tilknytninger til enheden \"", a("0"), "\""];
    },
    "Save mappings": "Gem tilknytning",
    "Saving changes...": "Gemmer \xE6ndringer...",
    "Saving..": "Gemmer..",
    "Saving...": "Gemmer...",
    "Search by name or id": "S\xF8g p\xE5 navn eller id",
    "Search by name or uuid": "S\xF8g p\xE5 navn eller id",
    "Search for department, name or username": "S\xF8g p\xE5 afdeling, navn eller brugernavn",
    "Search national ID registry": "S\xF8g cpr registeret",
    "Search on IT System name": "S\xF8g p\xE5 IT-system navn",
    "Search on IT system": "S\xF8g p\xE5 IT system",
    "Search on KLE value": "S\xF8g p\xE5 KLE",
    "Search on KLE value ({0} of {1} shown)": function (a) {
      return ["S\xF8g p\xE5 KLE (", a("0"), " of ", a("1"), " shown)"];
    },
    "Search on department, name or username": "S\xF8g p\xE5 afdeling, navn eller brugernavn",
    "Search on social security number": "S\xF8g p\xE5 CPR-nummer",
    "Search on template name": "S\xF8g p\xE5 skabelonnavn",
    "Search on:": "S\xF8g p\xE5:",
    "Search or Select an IT-System": "S\xF8g eller V\xE6lg et IT-System",
    "Search, eg. \"{searchHint}\"": function (a) {
      return ["S\xF8g, eks. \"", a("searchHint"), "\""];
    },
    "Search...": "S\xF8g...",
    "Search:": "S\xF8g:",
    "See how this is done.": "Se hvordan du skifter her.",
    "Select": "V\xE6lg",
    "Select 2-Step Verification": "V\xE6lg Totrinsbekr\xE6ftelse",
    "Select IT systems": "V\xE6lg IT systemer",
    "Select a Language": "V\xE6lg et sprog",
    "Select a System": "V\xE6lg et system",
    "Select a employment type": "V\xE6lg en ans\xE6ttelsesforholdstype",
    "Select a new username for the user": "V\xE6lgt et nyt brugernavn til brugeren",
    "Select a organisational unit type": "V\xE6lg en organisationsenheds type",
    "Select a service account type": "V\xE6lg en service konto type",
    "Select a template": "V\xE6lg en template",
    "Select an Organisational Unit": "V\xE6lg en Organisationsenhed",
    "Select an item in the menu to the left": "V\xE6lg et element i menuen til venstre",
    "Select an option": "V\xE6lg",
    "Select employment": "V\xE6lg ans\xE6ttelse",
    "Select employment type": "V\xE6lg ans\xE6ttelsesforholdstype",
    "Select organisational unit": "V\xE6lg organisationsenhed",
    "Select organisational unit type": "V\xE6lg en organisationsenheds type",
    "Select organisational units": "V\xE6lg organisationsenheder",
    "Select service account type": "V\xE6lg servicekonto type",
    "Select the type of employment that you want to create.": "V\xE6lg den type ans\xE6ttelsesforhold, som du \xF8nsker at oprette.",
    "Select the type of organisational unit that you want to create.": "V\xE6lg den type af organisationsenhed du vil oprette",
    "Select the type of service account that you want to create.": "V\xE6lg den type service konto du vil oprette.",
    "Select username": "V\xE6lg brugernavn",
    "Selected employment period is not allowed, please select a new period": "Valgte ans\xE6ttelsesperiode er ikke tilladt, v\xE6lg venligst en ny periode",
    "Selected parent organisational unit:": "Valgte overliggende organisationsenhed:",
    "Send": "Send",
    "Send for approval": "Send til godkendelse",
    "Sensitivity": "F\xF8lsomhed",
    "Sep": "Sep",
    "September": "September",
    "Service account": "Servicekonto",
    "Service account type": "Servicekonto type",
    "Service accounts": "Servicekontoer",
    "Service codes": "Ydelseskoder",
    "Set as primary employment": "S\xE6t som prim\xE6r ans\xE6ttelse",
    "Settings": "Indstillinger",
    "Short name": "Kort navn",
    "Show All Activity in List": "Vis Al aktivitet i en liste",
    "Show Info Badge": "Vis Info Badge",
    "Show Summary": "Vis Opsummering",
    "Show details": "Vis detaljer",
    "Show elements and details in a flat list": "F\xE5 vist elementer og detaljer p\xE5 en flad liste",
    "Show elements and details in a grouped list": "F\xE5 vist elementer og detaljer p\xE5 en grupperet liste",
    "Sign Out": "Log ud",
    "Social Security number": "CPR-nummer",
    "Solution": "L\xF8sning",
    "Some entities are \"static\" in order to secure certain functionality, have waiting approvals or because you don't have the rights to change them.": "Nogle entiteter er \"statiske\" for at sikre at visse ting virker, har ventende godkendelser eller fordi din bruger ikke har rettigheder til at \xE6ndre p\xE5 dem.",
    "Something went wrong! </br>The employee was not updated. Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["Noget gik galt! </br>Medarbejderen blev ikke opdateret. Kontakt venligst din systemadministrator. </br><p style=\"font-size:10px\">Fejlkode: ", a("0"), "</p>"];
    },
    "Something went wrong! Please contact your system administrator if the problem persists.": "Noget gik galt! Kontakt venligst din systemadministrator hvis problemet forts\xE6tter.",
    "Something went wrong!</br>Please contact your system administrator.": "Noget gik galt!</br>Kontakt din systemadministrator for at f\xE5 l\xF8st problemet.",
    "Something went wrong!</br>Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["Noget gik galt!</br>Kontakt din systemadministrator for at f\xE5 l\xF8st problemet. </br><p style=\"font-size:10px\">Fejlkode: ", a("0"), "</p>"];
    },
    "Start by searching for the CPR number. If the user is found in the system, the user's existing employment relationship or user account is displayed.": "Start med at s\xF8ge p\xE5 CPR nummer. Findes brugeren i systemet vises brugerens eksisterende ans\xE6ttelsesforhold eller brugerkonto.",
    "Start by selecting the parent organisational unit under which you want to create a new unit. Then fill in the right side of the screen and press create.": "Start med at v\xE6lge den overliggende organisationsenhed, som du \xF8nsker at oprette en ny enhed under. Herefter udfylder du h\xF8jre side af sk\xE6rmen og trykker p\xE5 opret.",
    "Start date is required.": "Start dato er kr\xE6vet",
    "Start time": "Starttid",
    "Status": "Status",
    "Status:": "Status:",
    "Su": "S\xF8",
    "Subject": "Emne",
    "Success": "Success",
    "Sunday": "S\xF8ndag",
    "Switch Language": "Skift Sprog",
    "Sync Status": "Synkroniseringsstatus",
    "System": "System",
    "System Name": "Systemnavn",
    "System Roles": "Systemroller",
    "Take me back to edit constraints!": "Tag mig tilbage til redigering af afgr\xE6nsninger!",
    "Task confirmed": "Opgave udf\xF8rt",
    "Task declined": "Opgave afvist",
    "Task: Request for approval": "Opgave: Anmodning til godkendelse",
    "Task: Request for assignment": "Opgave: Anmodning om tildeling",
    "Task: Request for removal": "Opgave: Anmodning om fjernelse",
    "Tasks": "Opgaver",
    "Technical Role": "Funktionsrolle",
    "Technical Role Name": "Funktionsrollen's navn",
    "Technical Roles": "Funktionsroller",
    "Technical Roles are assigned via a business role": "Funktionsroller er tilknyttet via en profilrolle",
    "Technical Roles are assigned via an organisational unit": "Funktionsroller er tilknyttet via en organisationsenhed",
    "Technical Roles on manuel systems can be added and removed from users in user application.": "Funktionsroller fra manuelle systemer\", kan tildeles og fjernes fra brugere igennem bruger applikationen.",
    "Technical role": "Funktionsrolle",
    "Technical role assignment": "Funktionsrolle tilknytning",
    "Technical role change has been denied": "Funktionsrolle \xE6ndringen er afvist",
    "Technical roles": "Funktionsroller",
    "Technical roles ({addedTechnicalRoleCount})": function (a) {
      return ["Funktionsroller (", a("addedTechnicalRoleCount"), ")"];
    },
    "Technical roles ({removedTechnicalRoleCount})": function (a) {
      return ["Funktionsroller (", a("removedTechnicalRoleCount"), ")"];
    },
    "Temporary": "Midlertidig",
    "Th": "To",
    "The Business Role \"{0}\" has been assigned to the organisational unit \"{name} \".": function (a) {
      return ["Profilrollen \"", a("0"), "\" er blevet tildelt til Organisationsenheden \"", a("name"), "\"."];
    },
    "The Business Role \"{0}\" has been removed from the organisational unit \"{name} \".": function (a) {
      return ["Profilrollen \"", a("0"), "\" er blevet fjernet fra Organisationsenheden \"", a("name"), "\"."];
    },
    "The Business Role was successfully updated.": "Profilrollen blev opdateret.",
    "The Business Role's name must be between 5 and 250 characters long.": "Profilrollen's navn skal v\xE6re mellem 5 og 250 tegn.",
    "The Organisational unit was successfully updated.": "Organisationsen er opdateret",
    "The Service Account was successfully created.": "Servicekontoen er oprettet.",
    "The System Role will be unassigned.": "Systemrollen vil blive fjernet.",
    "The Technical Role \"{0}\" has been assigned to the Business Role \"{name}\".": function (a) {
      return ["Funktionsrollen \"", a("0"), "\" er blevet tildelt til Profilrollen \"", a("name"), "\"."];
    },
    "The Technical Role \"{0}\" has been assigned to the organisational unit \"{name} \".": function (a) {
      return ["Funktionsrollen \"", a("0"), "\" er blevet tildelt til Organisationsenheden \"", a("name"), "\"."];
    },
    "The Technical Role \"{0}\" has been removed from the Business Role \"{name}\".": function (a) {
      return ["Funktionsrollen \"", a("0"), "\" er blevet fjernet fra Profilrollen \"", a("name"), "\"."];
    },
    "The Technical Role \"{0}\" has been removed from the organisational unit \"{name}\".": function (a) {
      return ["Funktionsrollen \"", a("0"), "\" er blevet fjernet fra organisationsenheden \"", a("name"), "\"."];
    },
    "The Technical Role name must be between 5 and 250 characters long.": "Funktionsrollens navn skal v\xE6re mellem 5 og 250 karakterer.",
    "The Technical Role was successfully updated.": "Funktionsrollen blev opdateret.",
    "The changes to the unit has following consequences for": "\xC6ndringerne til enheden har f\xF8lgende konsekvenser for",
    "The changes to the unit has following consequences:": "\xC6ndringerne til enheden har f\xF8lgende konsekvenser:",
    "The current value is invalid. For more information, click the info icon.": "Den nuv\xE6rende v\xE6rdi er ugyldig. Klik p\xE5 info-ikonet for mere information.",
    "The employee cannot be activated before the employee is associated with an organisational unit in the administrative organisation": "Medarbejderen kan ikke aktiveres f\xF8r medarbejderen er tilknyttet en organisationsenhed i den administrative organisation",
    "The employee don't exist anymore.": "Medarbejderen findes ikke mere.",
    "The employee employments was successfully asssigned to the Business Role.": "Medarbejdernes ans\xE6ttelser er nu tilknyttet til profilrollen.",
    "The employee employments was successfully asssigned to the Technical Role.": "Medarbejdernes ans\xE6ttelser er nu tilknyttet til funktionsrollen",
    "The employee employments was successfully unasssigned to the Business Role.": "Medarbejdernes ans\xE6ttelser er nu fjernet fra profilrollen.",
    "The employee employments was successfully unasssigned to the Technical Role.": "Medarbejdernes ans\xE6ttelser er nu fjernet fra funktionsrollen.",
    "The employee has no associated accounts.": "Medarbejderen har ingen forbundne konti.",
    "The employee have already been activated by another user.</br>For more information go to activity list.": "Medarbejderen er allerede blevet aktiveret af en anden bruger.</br>For mere information se i aktivitetslisten for medarbejderen.",
    "The employee have already been restored by another user.</br>For more information go to activity list.": "Medarbejderen er allerede blevet genskabt af en anden bruger.</br>For mere information se i aktivitetslisten for medarbejderen.",
    "The employee is in quarantine": "Medarbejderen er i karant\xE6ne",
    "The employee is in quarantine.": "Medarbejderen er i karant\xE6ne.",
    "The employee is no longer available in ID Connect.": "Medarbejderen er ikke l\xE6ngere tilg\xE6ngelig i ID Connect.",
    "The employee is not activated and cannot be edited. Please contact support for more information": "Medarbejderen er ikke aktiveret og kan dermed ikke redigeres. Tag fat i support for yderligere information",
    "The employee is not associated with an organisational unit in the administrative organisation": "Medarbejderen er ikke tilknyttet en organisationsenhed i den administrative organisation",
    "The employee was not updated! </br>ID Connect does not have sufficient access to update the user. Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["Medarbejderen blev ikke opdateret! </br>ID Connect har ikke adgang til at opdatere brugeren. Kontakt venligst din systemadministrator. </br></br><p style=\"font-size:10px\">Fejlkode: ", a("0"), "</p>"];
    },
    "The employee was not updated! </br>ID Connect does not have sufficient rights to update IT access on users. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["Medarbejderen blev ikke opdateret! </br>ID Connect har ikke adgang til at opdatere brugerens IT adgang. </br><p style=\"font-size:10px\">Fejlkode: ", a("0"), "</p>"];
    },
    "The employee was not updated! Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["Medarbejderen blev ikke opdateret! Kontakt venligst din systemadministrator. </br><p style=\"font-size:10px\">Fejlkode: ", a("0"), "</p>"];
    },
    "The employee's IT access has been {0} by another user in ID Connect. </br>See the employee's activity list for more information.": function (a) {
      return ["Medarbejderens IT adgang er blevet ", a("0"), " af en anden bruger i ID Connect. </br>Se aktivitetslisten p\xE5 medarbejderen for yderligere information."];
    },
    "The employment has been created": "Ans\xE6ttelsesforholdet er oprettet",
    "The entered values containts a not existing KLE value.": "Indtastede indeholder et eller flere KLE numre, som ikke findes.",
    "The input for this field is validated using the following regular expression:": "Inputfeltet valideres med f\xF8lgende regul\xE6re udtryk:",
    "The multi-factor authentication has been reset.": "Multi-faktor autentificering er blevet nulstillet.",
    "The name must be between 5 and 250 characters long.": "Navnet skal v\xE6re mellem 5 og 250 karakterer.",
    "The new name must be either empty or more than five characters": "Det nye navn skal enten v\xE6re tomt eller mere end fem tegn",
    "The organisational unit has been created successfully.": "Organisationsenheden er blevet oprettet.",
    "The organisational unit has been deleted": "Organisationsenheden er blevet slettet.",
    "The organisational unit has been updated successfully.": "Organisationsenheden er blevet opdateret.",
    "The organisational unit has no business manager": "Organisationsenheden har ingen funktionsleder",
    "The organisational unit has no mappings": "Organisationsenheden har ingen organisationstilknytninger",
    "The organisational unit has waiting approvals": "Organisationsenheden har ventede godkendelser",
    "The organisational unit will be deleted from ID Connect and from your active directory": "Organisationsenheden slettes fra ID Connect og fra jeres Active directory.",
    "The organisational units was successfully asssigned to the Business Role.": "Profilrolle er nu tilknyttet til Organisationsenhederne.",
    "The organisational units was successfully asssigned to the Technical Role.": "Funktionsrollen er nu tilknyttet til Organisationsenhederne",
    "The organisational units was successfully unasssigned from the Business Role.": "Profilrollen er nu fjernet fra Organisationsenhederne.",
    "The organisational units was successfully unasssigned from the Technical Role.": "Funktionsrollen er nu fjernet fra Organisationsenhederne.",
    "The page you're trying to access doesn't exits.": "Siden du leder efter, findes ikke",
    "The position was successfully updated.": "Ans\xE6ttelsesforholdet er opdateret.",
    "The report is generating and will be sent to your email once its done": "Rapporten genereres og vil blive sendt til din e-mail, n\xE5r den er f\xE6rdig",
    "The report {0} is not available": function (a) {
      return ["Denne rapport ", a("0"), " er ikke tilg\xE6ngelig"];
    },
    "The role do not exits": "Rollen findes ikke",
    "The short name must be between 4 and 20 characters long.": "Kort navn skal v\xE6re mellem 4 og 20 karakterer.",
    "The short name must only contain characters, numbers, \"-\" and \"_\".": "Kort navnet m\xE5 kun indeholde karakterer, numre, \"-\" and \"_\".",
    "The system name must be between 5 and 250 characters long.": "System navnet skal v\xE6re mellem 5 og 250 karakterer.",
    "The system was successfully updated.": "Systemet er opdateret.",
    "The system will list all user employments with entered social security number.": "Systemet vil liste alle ans\xE6ttelser, p\xE5 brugeren med indtastede CPR-nummer.",
    "The tecnical role has mandatory constraints with no values!": "Funktionsrollen har obligatoriske dataafgr\xE6nsninger der ikke er udfyldt!",
    "The unit can only have one mapping.": "Enheden kan kun have en tilknytning.",
    "The unit cannot be mapped.": "Enheden kan ikke tilknyttes.",
    "The unit has already a mapping witing for approval.": "Enheden har allerede en tilknytning som afventer godkendelse.",
    "The unit has mapping changes waiting for approval.": "Enheden har tilknytnings\xE6ndringer som afventer godkendelse.",
    "The unit has mappings waiting to be approved": "Enheden har tilknytninger som afventer godkendelse",
    "The unit is already mapped to a organisational unit:": "Enheden er allerede tilknyttet til en organisationsenhed:",
    "The user already exist in ID Connect with no employments": "Brugeren findes allerede i ID Connect uden ans\xE6ttelser",
    "The user already exists in ID Connect with employments": "Brugeren findes allerede i ID Connect med ans\xE6ttelser",
    "The user does not exist in ID Connect": "Brugeren findes ikke i ID Connect",
    "The user employment was successfully created.": "Ans\xE6ttelsesforholdet er oprettet.",
    "The user was successfully updated.": "Brugeren er opdateret.",
    "The username entered is either in use or not allowed.": "Det valgte brugernavn er enten i brug eller ikke tilladt",
    "The {categoryName} name must be between 5 and 250 characters long.": function (a) {
      return [a("categoryName"), "'s navn skal v\xE6re mellem 5 og 250 tegn."];
    },
    "The {text} was copied successfully.": function (a) {
      return [a("text"), " er kopieret."];
    },
    "There are insufficient rights to update users in Active Dierctory! Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["Der er ikke tilstr\xE6kkelige med rettigheder til at opdatere brugeren i Active Dierctory! Kontakt venligst din systemadministrator. </br><p style=\"font-size:10px\">Fejlkode: ", a("0"), "</p>"];
    },
    "There are no receiver": "Der er ingen modtager",
    "There are one or more unassigned mandatory constraints. Mandatory constraints have to be assigned for the System Role to work correctly. Choose one of the following options:": "Der er en eller flere utildelte, obligatoriske afgr\xE6nsninger. Obligatoriske afgr\xE6nsninger skal tildeles for at Systemrollen virker korrekt. V\xE6lg en af f\xF8lgende to muligheder:",
    "There has been no activity on the item": "Der er har ikke v\xE6ret noget aktivitet p\xE5 dette element",
    "There is no items to choose between. Please contact your IT administrator to get this problem solved.": "Der er ingen i listen. Kontakt venligst din IT administrator for at f\xE5 dette problem l\xF8st.",
    "There is no selected Org units": "Der er ingen valgte organisationsenheder",
    "There is no system roles assigned to the role, and thereby no receiver. This means that no email can be sent.": "Ingen systemrolle er tilknyttet funktionsrollen og derved ingen modtager. Det betyder at der ikke kan sendes en mail. ",
    "There is no system roles assigned to the system. Please assign a system role.": "Der er ikke tilknyttet en systemrolle til systemet. Tilknyt en systemrolle til systemet.",
    "There is no system roles assigned to the technical role.": "Funktionsrollen har ingen systemrolle tilknyttet.",
    "There is system role assignments with missing mandatory contraint values. This can result in non functionalities and synchronization errors.": "Der er en systemrolle tilknyttet, som mangler at f\xE5 udfyldt obligatoriske dataafgr\xE6nsninger. Dette kan resultere i manglende funktionalitets- og synkroniseringsfejl.",
    "There was a problem looking up the entered national id. If the problem persists, please contact your system administrator or IT support.": "Der opstod et problem med at finde det indtastede nationale ID. Hvis problemet forts\xE6tter, bedes du kontakte din systemadministrator eller IT-support.",
    "There was an error adding the Business Role. Please try again.": "Der skete en fejl ved tildelingen af profilrollen. Pr\xF8v venligst igen.",
    "There was an error adding the Technical Role. Please try again.": "Der skete en fejl ved tildelingen af funktionsrollen. Pr\xF8v venligst igen.",
    "There was an error assigning the employee employments. Please try again.": "Der skete en fejl ved tilknytningen af medarbejderens ans\xE6ttelser. Pr\xF8v venligst igen.",
    "There was an error assigning the employees. Please contact your system administrator if the problem persists": "Der skete en fejl ved tilknytningen af medarbejderne. Kontakt venligst din systemadministrator hvis problemet forts\xE6tter.",
    "There was an error assigning the employees. Please try again.": "Der skete en fejl ved tilknytningen af medarbejderne. Pr\xF8v venligst igen.",
    "There was an error assigning the organisational units. Please try again.": "Der skete en fejl ved tilknytningen af organisationsenhederne. Pr\xF8v venligst igen.",
    "There was an error copying the {text}. Please try again.": function (a) {
      return ["Der opstod en fejl under kopiering af ", a("text"), ". Pr\xF8v venligst igen."];
    },
    "There was an error creating the {type}. Please contact your administrator if the problem persist.": function (a) {
      return ["Der opstod et problem ved oprettelsen af ", a("type"), ". Kontakt venligst din systemadministrator hvis problemet forts\xE6tter."];
    },
    "There was an error disabling the it account. Please contact your system administrator if the problem persist.": "Der opstod en fejl under deaktiveringen af IT adgangen. Kontakt venligst din systemadministrator hvis problemet forts\xE6tter.",
    "There was an error generating the report. Please contact your system administrator if the problem persist": "Der opstod en fejl under generering af rapporten. Kontakt venligst din systemadministrator, hvis problemet forts\xE6tter",
    "There was an error removing the Business Role. Please try again.": "Der skete en fejl ved fjernelsen af profilrollen. Pr\xF8v venligst igen.",
    "There was an error removing the Technical Role. Please try again.": "Der skete en fejl ved fjernelsen af funktionsrollen. Pr\xF8v venligst igen.",
    "There was an error removing the employees. Please contact your system administrator if the problem persists": "Der skete en fejl ved fjernelsen af medarbejderne. Kontakt venligst din systemadministrator hvis problemet forts\xE6tter.",
    "There was an error resetting the multi-factor authentication. Please contact your administrator if the problem persists.": "Der opstod en fejl under nulstillingen af multi-faktor autentificeringen. Kontakt venligst din administrator hvis problemet forts\xE6tter.",
    "There was an error saving the employment. Please contact your IT administrator.": "Der opstod en fejl da ans\xE6ttelsesforholdet skulle gemmes. Kontakt venligst din IT-administrator.",
    "There was an error saving the item: Short name already taken.": "Der skete en fejl: Kort navnet eksisterer allerede.",
    "There was an error saving the service account. Please contact your IT administrator.": "Der opstod en fejl under oprettelsen af service kontoen. Venligst kontakt din IT-administrator.",
    "There was an error saving the {type}: Name already taken.": function (a) {
      return ["Der skete en fejl under oprettelsen af ", a("type"), ": Navnet eksisterer allerede."];
    },
    "There was an error updating the item. Please try again.": "Der skete en fejl under opdateringen. Pr\xF8v venligst igen.",
    "There was an error updating the position. Please contact your system administrator.": "Der skete en fejl ved opdateringen af ans\xE6ttelsesforholdet. Kontakt venligst din systemadministrator.",
    "There was an error updating the user. Please contact your system administrator.": "Der skete en fejl under opdateringen. Kontakt venligst din systemadministrator.",
    "This Month": "Denne M\xE5ned",
    "This Week": "Denne Uge",
    "This action": "Denne handling",
    "This action cannot be undone!": "Denne handling kan ikke fortrydes!",
    "This business role will be deleted, when all tasks have been completed.": "Denne profilrolle vil blive slettet, n\xE5r alle opgaver er f\xE6rdige.",
    "This constraint type cannot be validated because of an error in the type itself. This constraint type has been disabled.": "Denne afgr\xE6nsning kan ikke valideres pga en fejl i selve afgr\xE6nsningstypen. Denne afgr\xE6nsning er derfor blevet deaktiveret.",
    "This is a \"mandatory\" constraint, which means that it must always have a value selected. Therefore you cannot deselect this item. Instead you can select another item in the list and then deselect this one.": "Dette er en \"mandatory\" afgr\xE6nsning, hvilket betyder at den altid skal have en v\xE6rdi tilvalgt. Derfor kan man ikke fjerne denne afgr\xE6nsningsv\xE6rdi f\xF8r en anden afgr\xE6nsningsv\xE6rdi er blevet tilf\xF8jet.",
    "This is a \"readonly\" Business Role that cannot be edited or deleted.": "Dette er en \"readonly\" profilrolle der hverken kan rettes eller slettes.",
    "This is a \"readonly\" Technical Role that cannot be edited or deleted.": "Dette er en \"readonly\" funktionsrolle der hverken kan rettes eller slettes.",
    "This is a \"static\" Business Role that cannot be removed from a user.": "Dette er en \"static\" profilrolle der ikke kan fjernes fra brugere.",
    "This is a \"static\" Technical Role that cannot be added or removed from a user.": "Dette er en  \"static\" funktionsrolle der ikke kan tilknyttes eller fjernes fra brugere.",
    "This is a \"static\" system.": "Dette er et \"static\" system.",
    "This is a Static Entity": "Dette er en Statisk Entitet",
    "This is a new employee, that has not been activated yet": "Dette er en ny medarbejder, som endnu ikke er aktiveret",
    "This is required. Please enter a value.": "Dette felt er kr\xE6vet. Venlist indtast en v\xE6rdi.",
    "This is taking longer than expected...": "Dette tager l\xE6ngere tid end forventet...",
    "This is taking too long. It's likely that there has been an error.": "Dette har taget for l\xE6nge. Det er sandsynligvist sket en fejl.",
    "This is the ONLY time the users temporary password is shown. Remember to copy the password and save it.": "Dette er den ENESTE gang brugerens midlertidige adgangskode vises. Husk at kopiere adgangskoden.",
    "This is the ONLY time you can copy password. Please copy and save password.": "Dette er den ENESTE gang du kan kopiere adgangskoden. Venligst kopier og gem adgangskoden.",
    "This may take a few minutes...": "Dette kan tage et par minutter...",
    "This month": "Denne m\xE5ned",
    "This week": "Denne uge",
    "This will permanently delete \"{name}\" and all of it's assignments.": function (a) {
      return ["Dette vil permanent slette \"", a("name"), "\" og alle tilknytninger."];
    },
    "This will permanently delete IT System \"{name}\".": function (a) {
      return ["Dette vil permanent slette IT System \"", a("name"), "\"."];
    },
    "Three weeks ago": "Tre uger siden",
    "Thursday": "Torsdag",
    "To Date": "Til Dato",
    "Today": "I dag",
    "Trace id:": "Trace id:",
    "Tree View": "Hierarkisk",
    "Tu": "Ti",
    "Tuesday": "Tirsdag",
    "Type": "Type",
    "Unassign": "Fjern",
    "Unassign Employees": "Fjern Medarbejdere",
    "Unassign Employements": "Fjern Ans\xE6ttelser",
    "Unassign Employments": "Fjern Ans\xE6ttelser",
    "Unassign Organisational Units": "Fjern Organisationsenheder",
    "Unassigned Mandatory Constraints": "Utildelte, Obligatoriske Afgr\xE6nsninger",
    "Unassignment": "Fjernelse",
    "Unfortunately, you have ended up on the wrong page. It may be due to one of the reasons below.": "Du er desv\xE6rre havnet p\xE5 en forkert side. Det kan skyldes en af nedenst\xE5ende grunde.",
    "Update Successful": "Opdateringen lykkedes",
    "Update failed. Please try again.": "Der skete en fejl. Pr\xF8v venligst igen.",
    "Update organisational unit: {0}": function (a) {
      return ["Opdater organisationsenhed ", a("0")];
    },
    "User": "Bruger",
    "User ID": "Bruger ID",
    "User Login": "Bruger Login",
    "User account": "Bruger konto",
    "User accounts": "Bruger konto",
    "User information": "Bruger information",
    "User will be put into quarantine!": "Brugeren vil blive sat i karant\xE6ne!",
    "Username": "Brugernavn",
    "Username already exists on another user. Please select a new username from the list.": "Brugernavn findes allerede p\xE5 en anden bruger. V\xE6lg venligst et nyt brugernavn fra listen.",
    "Username is already in use": "Brugernavnet er allerede i brug",
    "Username:": "Brugernavn:",
    "Username: {0}": function (a) {
      return ["Brugernavn: ", a("0")];
    },
    "Username: {username}": function (a) {
      return ["Brugernavn: ", a("username")];
    },
    "Users with waiting approvals": "Bruger med ventede godkendelser",
    "View Activity List": "Vis Aktivitetsliste",
    "View my account": "Se min konto",
    "View your profile": "Se din profil",
    "Wait while constraint is being updated": "Vent venligst mens afgr\xE6nsningen bliver opdateret...",
    "Waiting approval": "Afventer godkendelse",
    "Waiting approvals": "Afventende godkendelser",
    "Waiting assignment": "Afventer tildeling",
    "Waiting assignments": "Afventende tildelinger",
    "Waiting for approval": "Afventer godkendelse",
    "Waiting removal": "Afventer fjernelse",
    "Warning": "Advarsel",
    "We": "On",
    "We noticed that you are using email token as your second factor login authentication. To improve security and compliance, please switch to mobile app authentication.": "Vi kan se at du bruger e-mail token til anden faktor login bekr\xE6ftelse. Af hensyn til sikkerhed og compliance, anbefaler vi dig straks at skifte til mobile app bekr\xE6ftelse.",
    "Wednesday": "Onsdag",
    "Welcome": "Velkommen",
    "When you assign a template to a manuel system, it cannot be undone, so you have to make sure, that you choose the right template the first time.": "N\xE5r du tilknytter en template til et manuelt system, kan det ikke laves om igen. S\xE5 du skal v\xE6re sikker p\xE5 at det er den rigtige template f\xF8rste gang.",
    "Whoops": "Hovsa",
    "Whoops, something went wrong!": "Hovsa, noget gik galt",
    "Without manager": "Uden funktionsleder",
    "Without mappings": "Uden tilknytninger",
    "Work": "Arbejde",
    "Wrong 2 factor": "Forkert 2 faktor",
    "Wrong login page": "Forket login side",
    "Yes": "Ja",
    "Yesterday": "I g\xE5r",
    "You are about to delete organisational unit:": "Du er ved at slette organisationsenhed:",
    "You are about to delete user": "Du er ved at slette bruger",
    "You are about to make a {0} deactivation of IT access for user": function (a) {
      return ["Du er ved at foretage en ", a("0"), " deaktivering af IT adgang for bruger"];
    },
    "You are about to reset the Multifactor authentication for this user": "Du er ved at nulstille Multifaktor godkendelse for denne bruger",
    "You are not a manager for any employees, so you are not authorized to download a manager report.": "Du er ikke leder for nogen medarbejdere, s\xE5 du har ikke rettigheder til at hente en leder rapport",
    "You are not a system owner for any IT-systems, so you are not authorized to download a system report.": "Du er ikke systemejer for noget IT-system, s\xE5 du har ikke rettigheder til at hente systemrapporten.",
    "You are not authorized to access this application.": "Du har ikke adgang til denne applikation.",
    "You are not authorized to create new Technical Roles.": "Du har ikke rettigheder til at oprette en ny funktionsrolle.",
    "You are not authorized to edit the business manager.": "Du har ikke rettigheder til at \xE6ndre funktionslederen.",
    "You are not authorized to edit this Technical Role.": "Du har ikke rettigheder til at redigere i denne funktionsrolle.",
    "You are trying to edit a \"readonly\" Technical Role. This role type cannot be edited.": "Du fors\xF8ger at redigere en \"readonly\" funktionsrolle. Denne type af rolle kan ikke redigeres.",
    "You are trying to edit a \"readonly\" system. This system type cannot be edited.": "Du pr\xF8ver at rette et \"readonly\" system. Dette system kan ikke editeres.",
    "You can click on [Add] and select the organisational units constraints. This solution is the primary recommendation for building and maintaining the organisation constraints.": "Du kan klikke p\xE5 [Tilf\xF8j] og v\xE6lge de organisationsenheder som der skal dataafgr\xE6nses p\xE5. Denne l\xF8sning er den prim\xE6re anbefaling til opbygning og vedligeholdelse af organisations dataafgr\xE6sninger.",
    "You can enter a comment to this request. Your comment will be added to the request and the email sent to the receiver(s) of this request.": "Du kan indtaste en kommentar til modtager af din anmodning. Din kommentar vil blive tilf\xF8jet p\xE5 din anmodning i ID Connect, samt blive tilf\xF8jet i mailen til modtager af din anmodning.",
    "You can enter a comment to this request. Your comment will be added to the request and the email sent to {requester}.": function (a) {
      return ["Du har mulighed for at tilf\xF8je en kommentar til denne anmodning. Din kommentar vil blive tilf\xF8jet p\xE5 anmodningen og sendt ", a("requester"), "."];
    },
    "You can search by KLE number and then select the KLE number(s) in your search result that you need. This solution is the primary recommendation for building and maintaining KLE markings.": "Du kan s\xF8ge p\xE5 KLE nummer og dern\xE6st v\xE6lge den eller de KLE-numre i dit s\xF8geresultat som du har brug for. Denne l\xF8sning er den prim\xE6re anbefaling til opbygning og vedligeholdelse af KLE opm\xE6rkning.",
    "You can search for IT systems and select them from the list. This solution is the primary recommendation for building and maintaining IT system constraints.": "Du kan s\xF8ge p\xE5 IT systemer og dern\xE6st v\xE6lge den eller de IT systemer i dit s\xF8geresultat som du har brug for. Denne l\xF8sning er den prim\xE6re anbefaling til opbygning og vedligeholdelse af IT systemer.",
    "You can see which Technical Roles and Business Roles are assigned to the user, via an organisational unit, by looking at the assignment information for each technical role or business role. To edit those assignments, you have to open the \"Organisation\" app.": "Du kan se hvilke funktionsroller og profilroller, som er tilknyttet til brugeren via en organisationsenhed, ved at se p\xE5 tilknytningsinformationen for hver funktionsrolle eller profilrolle i listen. Redigering af tilknytninger via organisationsenheder skal ske igennem \"Organisations\" applikationen.",
    "You can see which Technical Roles are assigned to the user via a business role, by looking at the assignment information for each technical role. To edit the user's business roles, you have to click on the \"Business Roles\" tab.": "Du kan se hvilke funktionsroller, som er tilknyttet til brugeren via en profilrolle, ved at se p\xE5 tilknytningsinformationen for hver funktionsrolle. Redigering af brugeres profilroller skal ske via \"Profilrolle\" fanen.",
    "You can see which roles are assigned to the user, via an organisational unit and a business role, by looking at the assignment information for each role. To edit organisation assignments, you have to open the \"Organisation\" app. To edit the business roles assignment, you have to click on the \"Business Roles\" tab.": "Du kan se hvilke roller, som er tilknyttet til brugeren via en organisationsenhed og en profilrolle, ved at se tilknytningsinformationen for hver rolle i listen. Redigering af organisationstilknytninger skal ske i \"Organisations\" applikationen. Redigering af profilroller skal ske via \"Profilrolle\" fanen.",
    "You cannot assign manual roles to business roles that are assigned to employments or organizational units.": "Du kan ikke tildele manuelle roller til profilroller, der er tildelt til ans\xE6ttelser eller organisationsenheder.",
    "You cannot delete an organisational unit that has children or users assigned.": "Du kan ikke slette en organisationsenhed der har underliggende enheder eller brugere tilknyttet.",
    "You currently have no apps assigned": "Du har ingen apps tildelt",
    "You do not have rights to activate the employee.": "Du har ikke rettigheder til at aktivere medarbejderen.",
    "You do not have rights to create service accounts. Please contact your IT administrator for more information.": "Du har ikke rettigheder til at oprette servicekonto. Kontakt venligst din IT administrator for mere information.",
    "You do not have rights to create user employments. Please contact your IT administrator for more information.": "Du har ikke rettigheder til at oprette brugerans\xE6ttelser. Kontakt venligst din IT administrator for mere information.",
    "You do not have rights to edit this user": "Du har ikke rettigheder til at redigere denne bruger",
    "You do not have sufficient access in ID Connect to {0}  IT access for the employee. Please contact your system administrator.": function (a) {
      return ["Du har ikke rettighed i ID Connect til at ", a("0"), " IT adgang for medarbejderen. Kontakt venligst din systemadministrator."];
    },
    "You do not have sufficient rights in ID Connect to edit profile data on user.": "Du har ikke rettigheder i ID Connect til at redigere profildata p\xE5 bruger.",
    "You do not have the rights to assign or unassign roles": "Du har ikke rettigheder til at tilknytte eller fjerne roller",
    "You have been signed out...": "Du er nu logget ud",
    "You have no pinned apps.": "Du har ingen fastgjorte apps",
    "You may have saved an incorrect link to the login page.": "Du kan have gemt et forkert link til loginsiden.",
    "You may have typed in the wrong token as 2 factor authentication.": "Du kan have tastet en forkert token/kode ind, som 2 faktor validering.",
    "You might have used a wrong loginpage.": "Du kan have brugt en forkert login side.",
    "You must enter a valid uuid": "Du skal indtaste et gyldigt uuid",
    "Your changes will remove the existing mapping. Do you want to continue?": "Dine \xE6ndringer vil fjerne eksisterende tilknytninger. \xD8nsker du at fors\xE6tte?",
    "Z to A": "\xC5 til A",
    "activate": "aktivere",
    "activated": "aktiveret",
    "are roles that are assigned directly to users within the ou where the role is assigned.": "er roller, der er tildelt direkte til brugere inden for denne OU, hvor rollen er tildelt.",
    "are roles that users with permission to assign roles can assign to users within the ou where the role is assigned.": "er roller, som brugere med rettigheder til at tildele roller kan tildele til brugere inden for denne OU, hvor rollen er tildelt.",
    "be undone": "fortrydes",
    "be undone.": "fortrydes",
    "business role": "profilrolle",
    "deactivate": "deaktivere",
    "deactivated": "deaktiveret",
    "default": "standard",
    "delete": "slet",
    "employee": "medarbejder",
    "employees": "medarbejdere",
    "has been processed": "er blevet behandlet",
    "home": "hjem",
    "hours": "timer",
    "in": "i",
    "mobile": "mobil",
    "none": "ingen",
    "of": "af",
    "organisational unit": "organisationsenhed",
    "organisational unit and bussiness role": "organisationsenhed og profilrolle",
    "permanent": "permanent",
    "team": "team",
    "technical role": "funktionsrolle",
    "trace id:": "trace id:",
    "work": "arbejde",
    "{0}": function (a) {
      return [a("0")];
    },
    "{0} in {1}": function (a) {
      return [a("0"), " i ", a("1")];
    },
    "{0} in {1} ({2})": function (a) {
      return [a("0"), " i ", a("1"), " (", a("2"), ")"];
    },
    "{0} is required. Please enter one or more UUIDs.": function (a) {
      return [a("0"), " er kr\xE6vet. Venligst v\xE6lg en fra listen.."];
    },
    "{0} is required. Please select an option.": function (a) {
      return [a("0"), " er kr\xE6vet. Venligst v\xE6lg en fra listen.."];
    },
    "{0} is required. Please select one ore more options.": function (a) {
      return [a("0"), " er kr\xE6vet. Venligst v\xE6lg en eller flere fra listen."];
    },
    "{0}: Employed in {1}": function (a) {
      return [a("0"), ": Ansat i ", a("1")];
    },
    "{0}: {1} in {2}": function (a) {
      return [a("0"), ": ", a("1"), " i ", a("2")];
    },
    "{name} is currently quarantined.": function (a) {
      return [a("name"), " er i karant\xE6ne."];
    },
    "{name} is not activated yet.": function (a) {
      return [a("name"), " er ikke aktiveret endnu."];
    }
  }
};

/* eslint-disable */
var messages$1 = {
  languageData: {
    "plurals": function (n, ord) {
      var s = String(n).split("."),
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);
      if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
      return n == 1 && v0 ? "one" : "other";
    }
  },
  messages: {
    "\"": "\"",
    "\"Short name\" is used to identify the IT system and the manually roles in assignments and activities. The name will always be in capital letters with max 20 characters and numbers. You can also use the special characthers \"-\" and \"_\".": "\"Short name\" is used to identify the IT system and the manually roles in assignments and activities. The name will always be in capital letters with max 20 characters and numbers. You can also use the special characthers \"-\" and \"_\".",
    "%cStop!": "%cStop!",
    "%cThis is a browser feature intended for developers. If someone asked you to copy and paste something here, please contact your IT administrator.": "%cThis is a browser feature intended for developers. If someone asked you to copy and paste something here, please contact your IT administrator.",
    "(Constraints)": "(Constraints)",
    "({0} of {1} shown)": function (a) {
      return ["(", a("0"), " of ", a("1"), " shown)"];
    },
    "1 month": "1 month",
    "1 week": "1 week",
    "3 months": "3 months",
    "A to Z": "A to Z",
    "Accept": "Accept",
    "Accept selected username": "Accept selected username",
    "Access Denied": "Access Denied",
    "Access to ID Connect always requires a two-step verification.": "Access to ID Connect always requires a two-step verification.",
    "Account information": "Account information",
    "Action": "Action",
    "Action:": "Action:",
    "Activate Employee": "Activate Employee",
    "Activate IT access": "Activate IT access",
    "Active from": "Active from",
    "Active to": "Active to",
    "Activity List": "Activity List",
    "Activity list": "Activity list",
    "Add": "Add",
    "Add Constraints to System Role": "Add Constraints to System Role",
    "Add a comment to the task": "Add a comment to the task",
    "Added": "Added",
    "Affects": "Affects",
    "All Business Roles": "All Business Roles",
    "All Technical Roles": "All Technical Roles",
    "All roles that is assigned to the employee will be removed from the employee!": "All roles that is assigned to the employee will be removed from the employee!",
    "All roles will be deleted from the user, the IT account will be deactivated and the user will be put into quarantine.": "All roles will be deleted from the user, the IT account will be deactivated and the user will be put into quarantine.",
    "Allow to add comment / explanations when the role is assigned.": "Allow to add comment / explanations when the role is assigned.",
    "Alphabetical": "Alphabetical",
    "Amount of employees assigned:": "Amount of employees assigned:",
    "Amount of role groups assigned:": "Amount of role groups assigned:",
    "Amount of system roles assigned:": "Amount of system roles assigned:",
    "Amount of technical roles assigned:": "Amount of technical roles assigned:",
    "An error occurred while fetching the user data.": "An error occurred while fetching the user data.",
    "Apply": "Apply",
    "Apply changes": "Apply changes",
    "Approval ID:": "Approval ID:",
    "Approval for assignment": "Approval for assignment",
    "Approval for removal": "Approval for removal",
    "Approvals": "Approvals",
    "Approve": "Approve",
    "Approve Request": "Approve Request",
    "Approve and activate": "Approve and activate",
    "Approve and activate the employee to be able to assign roles": "Approve and activate the employee to be able to assign roles",
    "Approve and restore": "Approve and restore",
    "Approve and restore the employee to be able to assign roles": "Approve and restore the employee to be able to assign roles",
    "Approve mapping changes": "Approve mapping changes",
    "Approving and activating the mapping changes to the organisational unit has following consequences for": "Approving and activating the mapping changes to the organisational unit has following consequences for",
    "Approving and activating the mapping changes to the organisational unit, have no impact on employees' rights in the unit.": "Approving and activating the mapping changes to the organisational unit, have no impact on employees' rights in the unit.",
    "Apr": "Apr",
    "April": "April",
    "Assign": "Assign",
    "Assign Employees": "Assign Employees",
    "Assign Employements": "Assign Employements",
    "Assign Employments": "Assign Employments",
    "Assign Organisation Units": "Assign Organisation Units",
    "Assign Organisational Units": "Assign Organisational Units",
    "Assigned": "Assigned",
    "Assigning template \"{templateName}\" to system \"{0}\"": function (a) {
      return ["Assigning template \"", a("templateName"), "\" to system \"", a("0"), "\""];
    },
    "Assignment": "Assignment",
    "Assignment Type": "Assignment Type",
    "Assignment is waiting for approval": "Assignment is waiting for approval",
    "Assignments that will not be removed:": "Assignments that will not be removed:",
    "Assignments to be removed": "Assignments to be removed",
    "Assignments to be removed:": "Assignments to be removed:",
    "Associated Accounts": "Associated Accounts",
    "Attention!": "Attention!",
    "Aug": "Aug",
    "August": "August",
    "Awaiting approval before added": "Awaiting approval before added",
    "Awaiting approval before removed": "Awaiting approval before removed",
    "Back to Dashboard": "Back to Dashboard",
    "Blocked": "Blocked",
    "Body": "Body",
    "Bookmark the login page below instead of your current page.": "Bookmark the login page below instead of your current page.",
    "Brief deciption of the request": "Brief deciption of the request",
    "Brief deciption of the request.": "Brief deciption of the request.\"",
    "Business Role": "Business Role",
    "Business Role - Employment": "Business Role - Employment",
    "Business Role Name": "Business Role Name",
    "Business Roles": "Business Roles",
    "Business manager": "Business manager",
    "Business role": "Business role",
    "Business role is marked to be deleted": "Business role is marked to be deleted",
    "Business roles": "Business roles",
    "Business roles ({addedBusinessRoleCount})": function (a) {
      return ["Business roles (", a("addedBusinessRoleCount"), ")"];
    },
    "Business roles ({removedBusinessRoleCount})": function (a) {
      return ["Business roles (", a("removedBusinessRoleCount"), ")"];
    },
    "CSV files of more than 1.000.000 rows cannot be imported into Excel.": "CSV files of more than 1.000.000 rows cannot be imported into Excel.",
    "Cancel": "Cancel",
    "Cancel Changes": "Cancel Changes",
    "Cannot": "Cannot",
    "Cannot copy masked value": "Cannot copy masked value",
    "Category": "Category",
    "Change Multi-Factor Authentication": "Change Multi-Factor Authentication",
    "Change name of the copied": "Change name of the copied",
    "Change settings for list view": "Change settings for list view",
    "Changing the name of the copied {text} is optional. If you do not enter any, the copied {text} will be given a generated name": function (a) {
      return ["Changing the name of the copied ", a("text"), " is optional. If you do not enter any, the copied ", a("text"), " will be given a generated name"];
    },
    "Choose organisational units": "Choose organisational units",
    "Clear all": "Clear all",
    "Clear filter": "Clear filter",
    "Click for more details": "Click for more details",
    "Click to select user": "Click to select user",
    "Close": "Close",
    "Comment": "Comment",
    "Comment from approver": "Comment from approver",
    "Comment from assigner": "Comment from assigner",
    "Comment from requester": "Comment from requester",
    "Comment will be added to the request and the email sent to the receiver(s) of this request.": "Comment will be added to the request and the email sent to the receiver(s) of this request.",
    "Comment will be added to the request and the email sent to {requester}.": function (a) {
      return ["Comment will be added to the request and the email sent to ", a("requester"), "."];
    },
    "Constraints": "Constraints",
    "Contact Information": "Contact Information",
    "Continue Editing": "Continue Editing",
    "Copied!": "Copied!",
    "Copy": "Copy",
    "Copy {text}": function (a) {
      return ["Copy ", a("text")];
    },
    "Could not download username and password to file. Please copy the values manually": "Could not download username and password to file. Please copy the values manually",
    "Create Position": "Create Position",
    "Create new": "Create new",
    "Create new organisational unit": "Create new organisational unit",
    "Create new service account": "Create new service account",
    "Create new user / employment": "Create new user / employment",
    "Created": "Created",
    "DUBU": "DUBU",
    "Danish": "Danish",
    "Date": "Date",
    "Date:": "Date:",
    "Deactivate": "Deactivate",
    "Deactivate IT access": "Deactivate IT access",
    "Deactivation date:": "Deactivation date:",
    "Dec": "Dec",
    "December": "December",
    "Default": "Default",
    "Default filter": "Default filter",
    "Default filter is activated on the Technical role list. To see all Technical roles assigend to the user, remove the filter": "Default filter is activated on the Technical role list. To see all Technical roles assigend to the user, remove the filter",
    "Default mail receiver": "Default mail receiver",
    "Delete": "Delete",
    "Delete \"{name}\"?": function (a) {
      return ["Delete \"", a("name"), "\"?"];
    },
    "Delete organisational unit": "Delete organisational unit",
    "Delete user": "Delete user",
    "Deleting": "Deleting",
    "Deleting item": "Deleting item",
    "Deleting organisational unit...": "Deleting organisational unit...",
    "Deletion in process": "Deletion in process",
    "Denied": "Denied",
    "Deny": "Deny",
    "Deny Request": "Deny Request",
    "Deny mapping changes": "Deny mapping changes",
    "Denying the mapping changes to the organisational unit has following consequences for": "Denying the map\"to the organisational unit has following consequences for",
    "Denying the mapping changes to the organisational unit, have no impact on employees' rights in the unit.": "Denying the mapping changes to the organisational unit, have no impact on employees' rights in the unit.",
    "Departments": "Departments",
    "Description": "Description",
    "Detailed consequences:": "Detailed consequences:",
    "Direct": "Direct",
    "Direct Roles": "Direct Roles",
    "Disable": "Disable",
    "Disable IT account": "Disable IT account",
    "Display name": "Display name",
    "Do you have questions?": "Do you have questions?",
    "Do you understand the consequences": "Do you understand the consequences",
    "Do you want to assign the role to underlying organisational units as well?": "Do you want to assign the role to underlying organisational units as well?",
    "Do you want to continue?": "Do you want to continue?",
    "Do you want to remove the role from underlying organisational units as well?": "Do you want to remove the role from underlying organisational units as well?",
    "Do you wish to continue?": "Do you wish to continue?",
    "Download": "Download",
    "Downloading report...": "Downloading report...",
    "Earlier": "Earlier",
    "Edit": "Edit",
    "Edit Business Manager": "Edit Business Manager",
    "Edit Employment": "Edit Employment",
    "Edit KLE": "Edit KLE",
    "Edit Mappings": "Edit Mappings",
    "Edit Profile": "Edit Profile",
    "Edit Roles": "Edit Roles",
    "Edit User": "Edit User",
    "Edit employment": "Edit employment",
    "Edit organisation": "Edit organisation",
    "Edit organisational unit": "Edit organisational unit",
    "Edit username": "Edit username",
    "Email is required. Please enter one or more emails.": "Email is required. Please enter one or more emails.",
    "Email subject": "Email subject",
    "Emails": "Emails",
    "Employed in": "Employed in",
    "Employed in {0} ({1})": function (a) {
      return ["Employed in ", a("0"), " (", a("1"), ")"];
    },
    "Employees": "Employees",
    "Employees in the organisational unit will be effected as following:": "Employees in the organisational unit will be effected as following:",
    "Employees:": "Employees:",
    "Employment": "Employment",
    "Employment Roles": "Employment Roles",
    "Employment information": "Employment information",
    "Employment type": "Employment type",
    "Employments": "Employments",
    "Employments found from national ID registry": "Employments found from national ID registry",
    "End time": "End time",
    "English": "English",
    "Enter Email address": "Enter Email address",
    "Enter IT system UUIDs": "Enter IT system UUIDs",
    "Enter KLE constraints": "Enter \"ts",
    "Enter comment to the assignment:": "Enter comment to the assignment:",
    "Enter one or more emails": "Enter one or more emails",
    "Enter one or more emails. On new role creation the email(s) will be added as default mail receiver. Notice, it can be changed manually on the Technical role.": "Enter one or more emails. On new role creation the email(s) will be added as default mail receiver. Notice, it can be changed manually on the Technical role.",
    "Enter one or more emails. When the technical role will be asigned mail receivers will be notified by email. The email contains a link to ID Connect, where assignment can be approved or denied.": "Enter one or more emails. When the technical role will be asigned mail receivers will be notified by email. The email contains a link to ID Connect, where assignment can be approved or denied.",
    "Enter one or more emails. When the technical role will be assigned mail receivers will be notified by email. The email contains a link to ID Connect, where assignment can be approved or denied.": "Enter one or more emails. When the technical role will be assigned mail receivers will be notified by email. The email contains a link to ID Connect, where assignment can be approved or denied.",
    "Enter the constraints": "Enter the constraints",
    "Entity ID": "Entity ID",
    "Entity Name": "Entity Name",
    "Entity Type": "Entity Type",
    "Error": "Error",
    "Event Type": "Event Type",
    "Event type": "Event type",
    "Expand report": "Expand report",
    "Explain what the receiver have to do in order to assign the role": "Explain what the receiver have to do in order to assign the role",
    "Explain what the receiver have to do in order to assign the role.": "Explain what the receiver have to do in order to assign the role.",
    "Explore all apps": "Explore all apps",
    "Explore all groups": "Explore all groups",
    "Explore all roles": "Explore all roles",
    "FAQ": "FAQ",
    "Feb": "Feb",
    "February": "February",
    "Fetching Report": "Fetching Report",
    "Fetching organisational units...": "Fetching organisational units...",
    "Filter by": "Filter by",
    "Format": "Format",
    "Fr": "Fr",
    "Friday": "Friday",
    "From Date": "From Date",
    "Generate CSV report": "Generate CSV report",
    "Generate report": "Generate report",
    "Get Report": "Get Report",
    "Get an overview with the Management Report": "Get an overview with the Management Report",
    "Get an overview with the System Report": "Get an overview with the System Report",
    "Get next username suggestions": "Get next username suggestions",
    "Give feedback": "Give feedback",
    "Go Back": "Go Back",
    "Go back to the login page and sign in again with the correct token.": "Go back to the login page and sign in again with the correct token.",
    "Go to next month": "Go to next month",
    "Go to next year": "Go to next year",
    "Go to previous month": "Go to previous month",
    "Go to previous year": "Go to previous year",
    "Go to today": "Go to today",
    "Go to user": "Go to user",
    "Good afternoon": "Good afternoon",
    "Good evening": "Good evening",
    "Good morning": "Good morning",
    "Grouped": "Grouped",
    "Grouped By Date": "Grouped By Date",
    "Has unassigned mandatory constraints": "Has unassigned mandatory constraints",
    "Help": "Help",
    "Here you can change the type of two-step verification you use to log in to ID Connect.": "Here you can change the type of two-step verification you use to log in to ID Connect.",
    "Here you can deactivate your IT account. Note that you cannot reactivate it yourself. To have the account reactivated, contact your user administrator.": "Here you can deactivate your IT account. Note that you cannot reactivate it yourself. To have the account reactivated, contact your user administrator.",
    "Hide Info Badge": "Hide Info Badge",
    "Hide details": "Hide details",
    "Home": "Home",
    "I understand the consequences": "I understand the consequences",
    "IT System": "IT System",
    "IT System identifier. Click for more information.": "IT System identifier. Click for more information.",
    "IT System name": "IT System name",
    "IT access for the employee is deactivated.": "IT access for the employee is deactivated.",
    "IT-System": "IT-System",
    "Id": "Id",
    "If the problem persists, please contact your system administrator or IT support immediately.": "If the problem persists, please contact your system administrator or IT support immediately.",
    "If you want to create a new user or employment relationship, you fill in the right side of the screen and press create.": "If you want to create a new user or employment relationship, you fill in the right side of the screen and press create.",
    "If you want to use one of the existing employment relationships or user account, press cancel and find the user under users in the User module.": "If you want to use one of the existing employment relationships or user account, press cancel and find the user under users in the User module.",
    "Illegal Action": "Illegal Action",
    "Include": "Include",
    "Incorrect link": "Incorrect link",
    "Info": "Info",
    "Information regarding approval process": "Information regarding approval process",
    "Information regarding assignment process": "Information regarding assignment process",
    "Instead, if you want to maintain your entry manually, e.g. if the IT system is not found in the list, the IT system UUID must be entered in the format 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.": "Instead, if you want to maintain your entry manually, e.g. if the IT system is not found in the list, the IT system UUID must be entered in the format 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.",
    "Instead, if you want to maintain your entry manually, e.g. if the organisational unit is not found in the organisation, the organisational unit's UUID must be entered in the format 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'": "Instead, if you want to maintain your entry manually, e.g. if the organisational unit is not found in the organisation, the organisational unit's UUID must be entered in the format 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'",
    "Instead, if you want to maintain your entry manually, the KLE number must be entered in 6 digits in the format 'xx.xx.xx'. Here it is also possible to use * selection at the first and second levels of the KLE hierarchy. This selects either all (*) or level 1 and all the underlying numbers. For example, '32. *.' or more areas with example 32.*,33.*,etc.": "Instead, if you want to maintain your entry manually, the KLE number must be entered in 6 digits in the format 'xx.xx.xx'. Here it is also possible to use * selection at the first and second levels of the KLE hierarchy. This selects either all (*) or level 1 and all the underlying numbers. For example, '32. *.' or more areas with example 32.*,33.*,etc.",
    "Invalid date format.": "Invalid date format.",
    "It is now recommended that you close this window before continuing your work.": "It is now recommended that you close this window before continuing your work.",
    "Item is Being Added": "Item is Being Added",
    "Item is Being Removed": "Item is Being Removed",
    "Item is Updating": "Item is Updating",
    "Items per page:": "Items per page:",
    "Its the first time the user is activated, therefore you must change the username.": "Its the first time the user is activated, therefore you must change the username.",
    "Jan": "Jan",
    "January": "January",
    "Jul": "Jul",
    "July": "July",
    "Jun": "Jun",
    "June": "June",
    "KLE": "KLE",
    "KLE Interest": "KLE Interest",
    "KLE Perform": "KLE Perform",
    "KLE interest": "KLE interest",
    "KLE interest ({addedKleInterestCount})": function (a) {
      return ["KLE interest (", a("addedKleInterestCount"), ")"];
    },
    "KLE interest ({addedKlePerformCount})": function (a) {
      return ["KLE interest (", a("addedKlePerformCount"), ")"];
    },
    "KLE interest ({removedKlePerformCount})": function (a) {
      return ["KLE interest (", a("removedKlePerformCount"), ")"];
    },
    "KLE is required. Please select or enter KLE values.": "KLE is required. Please select or enter KLE values.",
    "KLE perform": "KLE perform",
    "KLE perform ({addedKleInterestCount})": function (a) {
      return ["KLE perform (", a("addedKleInterestCount"), ")"];
    },
    "KLE perform ({addedKlePerformCount})": function (a) {
      return ["KLE perform (", a("addedKlePerformCount"), ")"];
    },
    "KLE perform ({removedKleInterestCount})": function (a) {
      return ["KLE perform (", a("removedKleInterestCount"), ")"];
    },
    "KOMBIT does not support a description with more than 1000 characters.": "KOMBIT does not support a description with more than 1000 characters.",
    "Last month": "Last month",
    "Last week": "Last week",
    "Latest {eventsShown} events shown": function (a) {
      return ["Latest ", a("eventsShown"), " events shown"];
    },
    "Learn more about opening CSV files in Excel": "Learn more about opening CSV files in Excel",
    "Learn more about the {0} application": function (a) {
      return ["Learn more about the ", a("0"), " application"];
    },
    "Learn more about {0}": function (a) {
      return ["Learn more about ", a("0")];
    },
    "List": "List",
    "Loading Activity...": "Loading Activity...",
    "Loading Business Role...": "Loading Business Role...",
    "Loading Managers...": "Loading Managers...",
    "Loading Organisational Unit...": "Loading Organisational Unit...",
    "Loading System...": "Loading System...",
    "Loading Technical Role...": "Loading Technical Role...",
    "Loading data...": "Loading data...",
    "Loading employee employments...": "Loading employee employments...",
    "Loading employees..": "Loading employees..",
    "Loading employees...": "Loading employees...",
    "Loading employments..": "Loading employments..",
    "Loading item...": "Loading item...",
    "Loading items...": "Loading items...",
    "Loading organisation units...": "Loading organisation units...",
    "Loading organisational unit template...": "Loading organisational unit template...",
    "Loading profile...": "Loading profile...",
    "Loading system roles...": "Loading system roles...",
    "Loading tasks..": "Loading tasks..",
    "Loading, please wait...": "Loading, please wait...",
    "Logout": "Logout",
    "Make this position primary": "Make this position primary",
    "Manage your account": "Manage your account",
    "Manager": "Manager",
    "Manager employment": "Manager employment",
    "Managers": "Managers",
    "Mandatory": "Mandatory",
    "Manual editing of UUID": "Manual editing of UUID",
    "Manual entry:": "Manual entry:",
    "Manual system": "Manual system",
    "Manually change uuid assignment": "Manually change uuid assignment",
    "Manually edit UUID": "Manually edit UUID",
    "Manuel edit KLE areas": "Manuel edit KLE areas",
    "Mapping": "Mapping",
    "Mappings": "Mappings",
    "Mar": "Mar",
    "March": "March",
    "May": "May",
    "Message from requester:": "Message from requester:",
    "Mo": "Mo",
    "Mobile": "Mobile",
    "Monday": "Monday",
    "Multi factor is required on login and multi factor is not configured for your user.": "Multi factor is required on login and multi factor is not configured for your user.",
    "My Account": "My Account",
    "My Profile": "My Profile",
    "Name": "Name",
    "Name id": "Name id",
    "New": "New",
    "New Business Role": "New Business Role",
    "New Manuel System": "New Manuel System",
    "New Technical Role": "New Technical Role",
    "New assignments that will be removed:": "New assignments that will be removed:",
    "New assignments:": "New assignments:",
    "New employment": "New employment",
    "Newest on top": "Newest on top",
    "Next": "Next",
    "No": "No",
    "No Business Roles assigned yet!": "No Business Roles assigned yet!",
    "No Changes": "No Changes",
    "No Constraint": "No Constraint",
    "No Constraint selected": "No Constraint selected",
    "No IT Account": "No IT Account",
    "No IT systems selected": "No IT systems selected",
    "No KLE numbers selected": "No KLE numbers selected",
    "No Technical Roles assigned yet!": "No Technical Roles assigned yet!",
    "No User Profile Data Found": "No User Profile Data Found",
    "No changes": "No changes",
    "No display name listed": "No display name listed",
    "No email addresse listed": "No email addresse listed",
    "No email addresses listed": "No email addresses listed",
    "No end date": "No end date",
    "No item matches search.": "No item matches search.",
    "No items are assigned.": "No items are assigned.",
    "No items available": "No items available",
    "No items available to show.": "No items available to show.",
    "No items match your search.": "No items match your search.",
    "No items matches search.": "No items matches search.",
    "No items to show.": "No items to show.",
    "No organisation": "No organisation",
    "No organisational units found": "No organisational units found",
    "No phone numbers listed": "No phone numbers listed",
    "No salary number listed": "No salary number listed",
    "No status available": "No status available",
    "No users or employments found from social security number.": "No users or employments found from social security number.",
    "No {0} listed": function (a) {
      return ["No ", a("0"), " listed"];
    },
    "Not activated": "Not activated",
    "Note": "Note",
    "Note that manual entry of multiple UUIDs must be separated by a comma (,)": "Note that manual entry of multiple UUIDs must be separated by a comma (,)",
    "Note that manual entry of multiple numbers must be separated by a comma (,)": "Note that manual entry of multiple numbers must be separated by a comma (,)",
    "Note that this can only be undone by your user administrator.": "Note that this can only be undone by your user administrator.",
    "Note:": "Note:",
    "Notice: Do not press \"Assigned\" until the right has been assigned in the requested system.": "Notice: Do not press \"Assigned\" until the right has been assigned in the requested system.",
    "Notice: Do not press \"Removed\" until the right has been deassigned in the requested system.": "Notice: Do not press \"Removed\" until the right has been deassigned in the requested system.",
    "Notice: This user has Technical Roles assigned via": "Notice: This user has Technical Roles assigned via",
    "Nov": "Nov",
    "November": "November",
    "Number": "Number",
    "Oct": "Oct",
    "October": "October",
    "Ok": "Ok",
    "Older": "Older",
    "Oldest on top": "Oldest on top",
    "One or more of the selected employees doesnt exist": "One or more of the selected employees doesnt exist",
    "One or more of the selected employments doesnt exist": "One or more of the selected employments doesnt exist",
    "Optional": "Optional",
    "Optional Roles": "Optional Roles",
    "Organisation": "Organisation",
    "Organisational Unit": "Organisational Unit",
    "Organisational Unit - Business Role": "Organisational Unit - Business Role",
    "Organisational Units": "Organisational Units",
    "Organisational unit": "Organisational unit",
    "Organisational unit information": "Organisational unit information",
    "Organisational unit mapping": "Organisational unit mapping",
    "Organisational unit type": "Organisational unit type",
    "Organisational units": "Organisational units",
    "Other informations": "Other informations",
    "Page:": "Page:",
    "Password": "Password",
    "Path": "Path",
    "Performed": "Performed",
    "Performed By": "Performed By",
    "Performed On": "Performed On",
    "Performed Type": "Performed Type",
    "Performed by": "Performed by",
    "Permanent": "Permanent",
    "Phone Numbers": "Phone Numbers",
    "Please approve mapping changes to \"": "Please approve mapping changes to \"",
    "Please change time to after start time": "Please change time to after start time",
    "Please check you have the correct url / adress to the system you are trying to access.": "Please check you have the correct url / adress to the system you are trying to access.",
    "Please contact your system administrator to get the solved.": "Please contact your system administrator to get the solved.",
    "Please enter a social security number to get a template": "Please enter a social security number to get a template",
    "Please enter a valid social security number.": "Please enter a valid social security number.",
    "Please enter text here": "Please enter text here",
    "Please enter valid time": "Please enter valid time",
    "Please fill out form below to create a new organisational unit": "Please fill out form below to create a new organisational unit",
    "Please fill out form below, to create a new employeement": "Please fill out form below, to create a new employeement",
    "Please fill out form below, to create a new service account": "Please fill out form below, to create a new service account",
    "Please read the following:": "Please read the following:",
    "Please search from social security number.": "Please search from social security number.",
    "Please select a new username for the user": "Please select a new username for the user",
    "Please select a primary employment by clicking on the star on the employment.": "Please select a primary employment by clicking on the star on the employment.",
    "Please select an employment on which you wish to edit roles.": "Please select an employment on which you wish to edit roles.",
    "Please try logging in again later or contact your administrator if the problem persists.": "Please try logging in again later or contact your administrator if the problem persists.",
    "Please try logging in again or contact your administrator if the": "Please try logging in again or contact your administrator if the",
    "Please try logging in again or contact your administrator if the problem persists.": "Please try logging in again or contact your administrator if the problem persists.",
    "Please type \"{confirmationText}\" to confirm:": function (a) {
      return ["Please type \"", a("confirmationText"), "\" to confirm:"];
    },
    "Please wait... do not close the window!": "Please wait... do not close the window!",
    "Please write a comment to your approval request.": "Please write a comment to your approval request.",
    "Position": "Position",
    "Previous": "Previous",
    "Primary employment": "Primary employment",
    "Primary position": "Primary position",
    "Primary position updated successfully": "Primary position updated successfully",
    "Processed": "Processed",
    "Profile": "Profile",
    "Questions can be directed to": "Questions can be directed to",
    "Quick Links": "Quick Links",
    "Quick links": "Quick links",
    "Read more in the User Manual": "Read more in the User Manual",
    "Read more in the user manual": "Read more in the user manual",
    "Receiver:": "Receiver:",
    "Receivers": "Receivers",
    "Regular Expression": "Regular Expression",
    "Remember to copy password!": "Remember to copy password!",
    "Removal is waiting for approval": "Removal is waiting for appr",
    "Remove": "Remove",
    "Remove System Role": "Remove System Role",
    "Removed": "Removed",
    "Reports": "Reports",
    "Request ID": "Request ID",
    "Request concerns:": "Request concerns:",
    "Requested": "Requested",
    "Requester": "Requester",
    "Requester:": "Requester:",
    "Reset": "Reset",
    "Reset MFA": "Reset MFA",
    "Reset Multifactor Authentication": "Reset Multifactor Authentication",
    "Restore Employee": "Restore Employee",
    "Restore User": "Restore User",
    "Retry Login": "Retry Login",
    "Retry login": "Retry login",
    "Return to Dashboard": "Return to Dashboard",
    "Return to main page": "Return to main page",
    "Rights in ID Connect": "Rights in ID Connect",
    "Role": "Role",
    "Role assignment": "Role assignment",
    "Role assignment directly to user": "Role assignment directly to user",
    "Role assignment to user employment: {positionName}": function (a) {
      return ["Role assignment to user employment: ", a("positionName")];
    },
    "Role is Being Deleted": "Role is Being Deleted",
    "Role removal": "Role removal",
    "Role with waiting approvals": "Role with waiting approvals",
    "Roles are assigned via an organisational unit and business role": "Roles are assigned via an organisational unit and business role",
    "Sa": "Sa",
    "Salary number": "Salary number",
    "Saturday": "Saturday",
    "Save": "Save",
    "Save Manager": "Save Manager",
    "Save changes": "Save changes",
    "Save mapping to unit \"{0}\"": function (a) {
      return ["Save mapping to unit \"", a("0"), "\""];
    },
    "Save mappings": "Save mappings",
    "Saving changes...": "Saving changes...",
    "Saving..": "Saving..",
    "Saving...": "Saving...",
    "Search by name or id": "Search by name or id",
    "Search by name or uuid": "Search by name or uuid",
    "Search for department, name or username": "Search for department, name or username",
    "Search national ID registry": "Search national ID registry",
    "Search on IT System name": "Search on IT",
    "Search on IT system": "Search on IT system",
    "Search on KLE value": "Search on KLE value",
    "Search on KLE value ({0} of {1} shown)": function (a) {
      return ["Search on KLE value (", a("0"), " of ", a("1"), " shown)"];
    },
    "Search on department, name or username": "Search on department, name or username",
    "Search on social security number": "Search on social security number",
    "Search on template name": "Search on template name",
    "Search on:": "Search on:",
    "Search or Select an IT-System": "Search or Select an IT-System",
    "Search, eg. \"{searchHint}\"": function (a) {
      return ["Search, eg. \"", a("searchHint"), "\""];
    },
    "Search...": "Search...",
    "Search:": "Search:",
    "See how this is done.": "See how this is done.",
    "Select": "Select",
    "Select 2-Step Verification": "Select 2-Step Verification",
    "Select IT systems": "Select IT systems",
    "Select a Language": "Select a Language",
    "Select a System": "Select a System",
    "Select a employment type": "Select a employment type",
    "Select a new username for the user": "Select a new username for the user",
    "Select a organisational unit type": "Select a organisational unit type",
    "Select a service account type": "Select a service account type",
    "Select a template": "Select a template",
    "Select an Organisational Unit": "Select an Organisational Unit",
    "Select an item in the menu to the left": "Select an item in the menu to the left",
    "Select an option": "Select an option",
    "Select employment": "Select employment",
    "Select employment type": "Select employment type",
    "Select organisational unit": "Select organisational unit",
    "Select organisational unit type": "Select organisational unit type",
    "Select organisational units": "Select organisational units",
    "Select service account type": "Select service account type",
    "Select the type of employment that you want to create.": "Select the type of employment that you want to create.",
    "Select the type of organisational unit that you want to create.": "Select the type of organisational unit that you want to create.",
    "Select the type of service account that you want to create.": "Select the type of service account that you want to create.",
    "Select username": "Select username",
    "Selected employment period is not allowed, please select a new period": "Selected employment period is not allowed, please select a new period",
    "Selected parent organisational unit:": "Selected parent organisational unit:",
    "Send": "Send",
    "Send for approval": "Send for approval",
    "Sensitivity": "Sensitivity",
    "Sep": "Sep",
    "September": "September",
    "Service account": "Service account",
    "Service account type": "Service account type",
    "Service accounts": "Service accounts",
    "Service codes": "Service codes",
    "Set as primary employment": "Set as primary employment",
    "Settings": "Settings",
    "Short name": "Short name",
    "Show All Activity in List": "Show All Activity in List",
    "Show Info Badge": "Show Info Badge",
    "Show Summary": "Show Summary",
    "Show details": "Show details",
    "Show elements and details in a flat list": "Show elements and details in a flat list",
    "Show elements and details in a grouped list": "Show elements and details in a grouped list",
    "Sign Out": "Sign Out",
    "Social Security number": "Social Security number",
    "Solution": "Solution",
    "Some entities are \"static\" in order to secure certain functionality, have waiting approvals or because you don't have the rights to change them.": "Some entities are \"static\" in order to secure certain functionality, have waiting approvals or because you don't have the rights to change them.",
    "Something went wrong! </br>The employee was not updated. Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["Something went wrong! </br>The employee was not updated. Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: ", a("0"), "</p>"];
    },
    "Something went wrong! Please contact your system administrator if the problem persists.": "Something went wrong! Please contact your system administrator if the problem persists.",
    "Something went wrong!</br>Please contact your system administrator.": "Something went wrong!</br>Please contact your system administrator.",
    "Something went wrong!</br>Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["Something went wrong!</br>Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: ", a("0"), "</p>"];
    },
    "Start by searching for the CPR number. If the user is found in the system, the user's existing employment relationship or user account is displayed.": "Start by searching for the CPR number. If the user is found in the system, the user's existing employment relationship or user account is displayed.",
    "Start by selecting the parent organisational unit under which you want to create a new unit. Then fill in the right side of the screen and press create.": "Start by selecting the parent organisational unit under which you want to create a new unit. Then fill in the right side of the screen and press create.",
    "Start date is required.": "Start date is required.",
    "Start time": "Start time",
    "Status": "Status",
    "Status:": "Status:",
    "Su": "Su",
    "Subject": "Subject",
    "Success": "Success",
    "Sunday": "Sunday",
    "Switch Language": "Switch Language",
    "Sync Status": "Sync Status",
    "System": "System",
    "System Name": "System Name",
    "System Roles": "System Roles",
    "Take me back to edit constraints!": "Take me back to edit constraints!",
    "Task confirmed": "Task confirmed",
    "Task declined": "Task declined",
    "Task: Request for approval": "Task: Request for approval",
    "Task: Request for assignment": "Task: Request for assignment",
    "Task: Request for removal": "Task: Request for removal",
    "Tasks": "Tasks",
    "Technical Role": "Technical Role",
    "Technical Role Name": "Technical Role Name",
    "Technical Roles": "Technical Roles",
    "Technical Roles are assigned via a business role": "Technical Roles are assigned via a business role",
    "Technical Roles are assigned via an organisational unit": "Technical Roles are assigned via an organisational unit",
    "Technical Roles on manuel systems can be added and removed from users in user application.": "Technical Roles on manuel systems can be added and removed from users in user application.",
    "Technical role": "Technical role",
    "Technical role assignment": "Technical role assignment",
    "Technical role change has been denied": "Technical role change has been denied",
    "Technical roles": "Technical roles",
    "Technical roles ({addedTechnicalRoleCount})": function (a) {
      return ["Technical roles (", a("addedTechnicalRoleCount"), ")"];
    },
    "Technical roles ({removedTechnicalRoleCount})": function (a) {
      return ["Technical roles (", a("removedTechnicalRoleCount"), ")"];
    },
    "Temporary": "Temporary",
    "Th": "Th",
    "The Business Role \"{0}\" has been assigned to the organisational unit \"{name} \".": function (a) {
      return ["The Business Role \"", a("0"), "\" has been assigned to the organisational unit \"", a("name"), " \"."];
    },
    "The Business Role \"{0}\" has been removed from the organisational unit \"{name} \".": function (a) {
      return ["The Business Role \"", a("0"), "\" has been removed from the organisational unit \"", a("name"), " \"."];
    },
    "The Business Role was successfully updated.": "The Business Role was successfully updated.",
    "The Business Role's name must be between 5 and 250 characters long.": "The Business Role's name must be between 5 and 250 characters long.",
    "The Organisational unit was successfully updated.": "The Organisational unit was successfully updated.",
    "The Service Account was successfully created.": "The Service Account was successfully created.",
    "The System Role will be unassigned.": "The System Role will be unassigned.",
    "The Technical Role \"{0}\" has been assigned to the Business Role \"{name}\".": function (a) {
      return ["The Technical Role \"", a("0"), "\" has been assigned to the Business Role \"", a("name"), "\"."];
    },
    "The Technical Role \"{0}\" has been assigned to the organisational unit \"{name} \".": function (a) {
      return ["The Technical Role \"", a("0"), "\" has been assigned to the organisational unit \"", a("name"), " \"."];
    },
    "The Technical Role \"{0}\" has been removed from the Business Role \"{name}\".": function (a) {
      return ["The Technical Role \"", a("0"), "\" has been removed from the Business Role \"", a("name"), "\"."];
    },
    "The Technical Role \"{0}\" has been removed from the organisational unit \"{name}\".": function (a) {
      return ["The Technical Role \"", a("0"), "\" has been removed from the organisational unit \"", a("name"), "\"."];
    },
    "The Technical Role name must be between 5 and 250 characters long.": "The Technical Role name must be between 5 and 250 characters long.",
    "The Technical Role was successfully updated.": "The Technical Role was successfully updated.",
    "The changes to the unit has following consequences for": "The changes to the unit has following consequences for",
    "The changes to the unit has following consequences:": "The changes to the unit has following consequences:",
    "The current value is invalid. For more information, click the info icon.": "The current value is invalid. For more information, click the info icon.",
    "The employee cannot be activated before the employee is associated with an organisational unit in the administrative organisation": "The employee cannot be activated before the employee is associated with an organisational unit in the administrative organisation",
    "The employee don't exist anymore.": "The employee don't exist anymore.",
    "The employee employments was successfully asssigned to the Business Role.": "The employee employments was successfully asssigned to the Business Role.",
    "The employee employments was successfully asssigned to the Technical Role.": "The employee employments was successfully asssigned to the Technical Role.",
    "The employee employments was successfully unasssigned to the Business Role.": "The employee employments was successfully unasssigned to the Business Role.",
    "The employee employments was successfully unasssigned to the Technical Role.": "The employee employments was successfully unasssigned to the Technical Role.",
    "The employee has no associated accounts.": "The employee has no associated accounts.",
    "The employee have already been activated by another user.</br>For more information go to activity list.": "The employee have already been activated by another user.</br>For more information go to activity list.",
    "The employee have already been restored by another user.</br>For more information go to activity list.": "The employee have already been restored by another user.</br>For more information go to activity list.",
    "The employee is in quarantine": "The employee is in quarantine",
    "The employee is in quarantine.": "The employee is in quarantine.",
    "The employee is no longer available in ID Connect.": "The employee is no longer available in ID Connect.",
    "The employee is not activated and cannot be edited. Please contact support for more information": "The employee is not activated and cannot be edited. Please contact support for more information",
    "The employee is not associated with an organisational unit in the administrative organisation": "The employee is not associated with an organisational unit in the administrative organisation",
    "The employee was not updated! </br>ID Connect does not have sufficient access to update the user. Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["The employee was not updated! </br>ID Connect does not have sufficient access to update the user. Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: ", a("0"), "</p>"];
    },
    "The employee was not updated! </br>ID Connect does not have sufficient rights to update IT access on users. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["The employee was not updated! </br>ID Connect does not have sufficient rights to update IT access on users. </br><p style=\"font-size:10px\">Error code: ", a("0"), "</p>"];
    },
    "The employee was not updated! Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["The employee was not updated! Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: ", a("0"), "</p>"];
    },
    "The employee's IT access has been {0} by another user in ID Connect. </br>See the employee's activity list for more information.": function (a) {
      return ["The employee's IT access has been ", a("0"), " by another user in ID Connect. </br>See the employee's activity list for more information."];
    },
    "The employment has been created": "The employment has been created",
    "The entered values containts a not existing KLE value.": "The entered values containts a not existing KLE value.",
    "The input for this field is validated using the following regular expression:": "The input for this field is validated using the following regular expression:",
    "The multi-factor authentication has been reset.": "The multi-factor authentication has been reset.",
    "The name must be between 5 and 250 characters long.": "The name must be between 5 and 250 characters long.",
    "The new name must be either empty or more than five characters": "The new name must be either empty or more than five characters",
    "The organisational unit has been created successfully.": "The organisational unit has been created successfully.",
    "The organisational unit has been deleted": "The organisational unit has been deleted",
    "The organisational unit has been updated successfully.": "The organisational unit has been updated successfully.",
    "The organisational unit has no business manager": "The organisational unit has no business manager",
    "The organisational unit has no mappings": "The organisational unit has no mappings",
    "The organisational unit has waiting approvals": "The organisational unit has waiting approvals",
    "The organisational unit will be deleted from ID Connect and from your active directory": "The organisational unit will be deleted from ID Connect and from your active directory",
    "The organisational units was successfully asssigned to the Business Role.": "The organisational units was successfully asssigned to the Business Role.",
    "The organisational units was successfully asssigned to the Technical Role.": "The organisational units was successfully asssigned to the Technical Role.\"",
    "The organisational units was successfully unasssigned from the Business Role.": "The organisational units was successfully unasssigned from the Business Role.",
    "The organisational units was successfully unasssigned from the Technical Role.": "The organisational units was successfully unasssigned from the Technical Role.",
    "The page you're trying to access doesn't exits.": "The page you're trying to access doesn't exits.",
    "The position was successfully updated.": "The position was successfully updated.",
    "The report is generating and will be sent to your email once its done": "The report is generating and will be sent to your email once its done",
    "The report {0} is not available": function (a) {
      return ["The report ", a("0"), " is not available"];
    },
    "The role do not exits": "The role do not exits",
    "The short name must be between 4 and 20 characters long.": "The short name must be between 4 and 20 chara",
    "The short name must only contain characters, numbers, \"-\" and \"_\".": "The short name must only contain characters, numbers, \"-\" and \"_\".",
    "The system name must be between 5 and 250 characters long.": "The system name must be between 5 and 250 characters long.",
    "The system was successfully updated.": "The system was successfully updated.",
    "The system will list all user employments with entered social security number.": "The system will list all user employments with entered social security number.",
    "The tecnical role has mandatory constraints with no values!": "The tecnical role has mandatory constraints with no values!",
    "The unit can only have one mapping.": "The unit can only have one mapping.",
    "The unit cannot be mapped.": "The unit cannot be mapped.",
    "The unit has already a mapping witing for approval.": "The unit has already a mapping witing for approval.",
    "The unit has mapping changes waiting for approval.": "The unit has mapping changes waiting for approval.",
    "The unit has mappings waiting to be approved": "The unit has mappings waiting to be approved",
    "The unit is already mapped to a organisational unit:": "The unit is already mapped to a organisational unit:",
    "The user already exist in ID Connect with no employments": "The user already exist in ID Connect with no employments",
    "The user already exists in ID Connect with employments": "The user already exists in ID Connect with employments",
    "The user does not exist in ID Connect": "The user does not exist in ID Connect",
    "The user employment was successfully created.": "The user employment was successfully created.",
    "The user was successfully updated.": "The user was successfully updated.",
    "The username entered is either in use or not allowed.": "The username entered is either in use or not allowed.",
    "The {categoryName} name must be between 5 and 250 characters long.": function (a) {
      return ["The ", a("categoryName"), " name must be between 5 and 250 characters long."];
    },
    "The {text} was copied successfully.": function (a) {
      return ["The ", a("text"), " was copied successfully."];
    },
    "There are insufficient rights to update users in Active Dierctory! Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: {0}</p>": function (a) {
      return ["There are insufficient rights to update users in Active Dierctory! Please contact your system administrator. </br><p style=\"font-size:10px\">Error code: ", a("0"), "</p>"];
    },
    "There are no receiver": "There are no receiver",
    "There are one or more unassigned mandatory constraints. Mandatory constraints have to be assigned for the System Role to work correctly. Choose one of the following options:": "There are one or more unassigned mandatory constraints. Mandatory constraints have to be assigned for the System Role to work correctly. Choose one of the following options:",
    "There has been no activity on the item": "There has been no activity on the item",
    "There is no items to choose between. Please contact your IT administrator to get this problem solved.": "There is no items to choose between. Please contact your IT administrator to get this problem solved.",
    "There is no selected Org units": "There is no selected Org units",
    "There is no system roles assigned to the role, and thereby no receiver. This means that no email can be sent.": "There is no system roles assigned to the role, and thereby no receiver. This means that no email can be sent.",
    "There is no system roles assigned to the system. Please assign a system role.": "There is no system roles assigned to the system. Please assign a system role.",
    "There is no system roles assigned to the technical role.": "There is no system roles assigned to the technical role.",
    "There is system role assignments with missing mandatory contraint values. This can result in non functionalities and synchronization errors.": "There is system role assignments with missing mandatory contraint values. This can result in non functionalities and synchronization errors.",
    "There was a problem looking up the entered national id. If the problem persists, please contact your system administrator or IT support.": "There was a problem looking up the entered national id. If the problem persists, please contact your system administrator or IT support.",
    "There was an error adding the Business Role. Please try again.": "There was an error adding the Business Role. Please try again.",
    "There was an error adding the Technical Role. Please try again.": "There was an error adding the Technical Role. Please try again.",
    "There was an error assigning the employee employments. Please try again.": "There was an error assigning the employee employments. Please try again.",
    "There was an error assigning the employees. Please contact your system administrator if the problem persists": "There was an error assigning the employees. Please contact your system administrator if the problem persists",
    "There was an error assigning the employees. Please try again.": "There was an error assigning the employees. Please try again.",
    "There was an error assigning the organisational units. Please try again.": "There was an error assigning the organisational units. Please try again.",
    "There was an error copying the {text}. Please try again.": function (a) {
      return ["There was an error copying the ", a("text"), ". Please try again."];
    },
    "There was an error creating the {type}. Please contact your administrator if the problem persist.": function (a) {
      return ["There was an error creating the ", a("type"), ". Please contact your administrator if the problem persist."];
    },
    "There was an error disabling the it account. Please contact your system administrator if the problem persist.": "There was an error disabling the it account. Please contact your system administrator if the problem persist.",
    "There was an error generating the report. Please contact your system administrator if the problem persist": "There was an error generating the report. Please contact your system administrator if the problem persist",
    "There was an error removing the Business Role. Please try again.": "There was an error removing the Business Role. Please try again.",
    "There was an error removing the Technical Role. Please try again.": "There was an error removing the Technical Role. Please try again.",
    "There was an error removing the employees. Please contact your system administrator if the problem persists": "There was an error removing the employees. Please contact your system administrator if the problem persists",
    "There was an error resetting the multi-factor authentication. Please contact your administrator if the problem persists.": "There was an error resetting the multi-factor authentication. Please contact your administrator if the problem persists.",
    "There was an error saving the employment. Please contact your IT administrator.": "There was an error saving the employment. Please contact your IT administrator.",
    "There was an error saving the item: Short name already taken.": "There was an error saving the item: Short name already taken.",
    "There was an error saving the service account. Please contact your IT administrator.": "There was an error saving the service account. Please contact your IT administrator.",
    "There was an error saving the {type}: Name already taken.": function (a) {
      return ["There was an error saving the ", a("type"), ": Name already taken."];
    },
    "There was an error updating the item. Please try again.": "There was an error updating the item. Please try again.",
    "There was an error updating the position. Please contact your system administrator.": "There was an error updating the position. Please contact your system administrator.",
    "There was an error updating the user. Please contact your system administrator.": "There was an error updating the user. Please contact your system administrator.",
    "This Month": "This Month",
    "This Week": "This Week",
    "This action": "This action",
    "This action cannot be undone!": "This action cannot be undone!",
    "This business role will be deleted, when all tasks have been completed.": "This business role will be deleted, when all tasks have been completed.",
    "This constraint type cannot be validated because of an error in the type itself. This constraint type has been disabled.": "This constraint type cannot be validated because of an error in the type itself. This constraint type has been disabled.",
    "This is a \"mandatory\" constraint, which means that it must always have a value selected. Therefore you cannot deselect this item. Instead you can select another item in the list and then deselect this one.": "This is a \"mandatory\" constraint, which means that it must always have a value selected. Therefore you cannot deselect this item. Instead you can select another item in the list and then deselect this one.",
    "This is a \"readonly\" Business Role that cannot be edited or deleted.": "This is a \"readonly\" Business Role that cannot be edited or deleted.",
    "This is a \"readonly\" Technical Role that cannot be edited or deleted.": "This is a \"readonly\" Technical Role that cannot be edited or deleted.",
    "This is a \"static\" Business Role that cannot be removed from a user.": "This is a \"static\" Business Role that cannot be removed from a user.",
    "This is a \"static\" Technical Role that cannot be added or removed from a user.": "This is a \"static\" Technical Role that cannot be added or removed from a user.",
    "This is a \"static\" system.": "This is a \"static\" system.",
    "This is a Static Entity": "This is a Static Entity",
    "This is a new employee, that has not been activated yet": "This is a new employee, that has not been activated yet",
    "This is required. Please enter a value.": "This is required. Please enter a value.",
    "This is taking longer than expected...": "This is taking longer than expected...",
    "This is taking too long. It's likely that there has been an error.": "This is taking too long. It's likely that there has been an error.",
    "This is the ONLY time the users temporary password is shown. Remember to copy the password and save it.": "This is the ONLY time the users temporary password is shown. Remember to copy the password and save it.",
    "This is the ONLY time you can copy password. Please copy and save password.": "This is the ONLY time you can copy password. Please copy and save password.",
    "This may take a few minutes...": "This may take a few minutes...",
    "This month": "This month",
    "This week": "This week",
    "This will permanently delete \"{name}\" and all of it's assignments.": function (a) {
      return ["This will permanently delete \"", a("name"), "\" and all of it's assignments."];
    },
    "This will permanently delete IT System \"{name}\".": function (a) {
      return ["This will permanently delete IT System \"", a("name"), "\"."];
    },
    "Three weeks ago": "Three weeks ago",
    "Thursday": "Thursday",
    "To Date": "To Date",
    "Today": "Today",
    "Trace id:": "Trace id:",
    "Tree View": "Tree View",
    "Tu": "Tu",
    "Tuesday": "Tuesday",
    "Type": "Type",
    "Unassign": "Unassign",
    "Unassign Employees": "Unassign Employees",
    "Unassign Employements": "Unassign Employements",
    "Unassign Employments": "Unassign Employments",
    "Unassign Organisational Units": "Unassign Organisational Units",
    "Unassigned Mandatory Constraints": "Unassigned Mandatory Constraints",
    "Unassignment": "Unassignment",
    "Unfortunately, you have ended up on the wrong page. It may be due to one of the reasons below.": "Unfortunately, you have ended up on the wrong page. It may be due to one of the reasons below.",
    "Update Successful": "Update Successful",
    "Update failed. Please try again.": "Update failed. Please try again.",
    "Update organisational unit: {0}": function (a) {
      return ["Update organisational unit: ", a("0")];
    },
    "User": "User",
    "User ID": "User ID",
    "User Login": "User Login",
    "User account": "User account",
    "User accounts": "User accounts",
    "User information": "User information",
    "User will be put into quarantine!": "User will be put into quarantine!",
    "Username": "Username",
    "Username already exists on another user. Please select a new username from the list.": "Username already exists on another user. Please select a new username from the list.",
    "Username is already in use": "Username is already in use",
    "Username:": "Username:",
    "Username: {0}": function (a) {
      return ["Username: ", a("0")];
    },
    "Username: {username}": function (a) {
      return ["Username: ", a("username")];
    },
    "Users with waiting approvals": "Users with waiting approvals",
    "View Activity List": "View Activity List",
    "View my account": "View my account",
    "View your profile": "View your profile",
    "Wait while constraint is being updated": "Wait while constraint is being updated",
    "Waiting approval": "Waiting approval",
    "Waiting approvals": "Waiting approvals",
    "Waiting assignment": "Waiting assignment",
    "Waiting assignments": "Waiting assignments",
    "Waiting for approval": "Waiting for approval",
    "Waiting removal": "Waiting removal",
    "Warning": "Warning",
    "We": "We",
    "We noticed that you are using email token as your second factor login authentication. To improve security and compliance, please switch to mobile app authentication.": "We noticed that you are using email token as your second factor login authentication. To improve security and compliance, please switch to mobile app authentication.",
    "Wednesday": "Wednesday",
    "Welcome": "Welcome",
    "When you assign a template to a manuel system, it cannot be undone, so you have to make sure, that you choose the right template the first time.": "When you assign a template to a manuel system, it cannot be undone, so you have to make sure, that you choose the right template the first time.",
    "Whoops": "Whoops",
    "Whoops, something went wrong!": "Whoops, something went wrong!",
    "Without manager": "Without manager",
    "Without mappings": "Without mappings",
    "Work": "Work",
    "Wrong 2 factor": "Wrong 2 factor",
    "Wrong login page": "Wrong login page",
    "Yes": "Yes",
    "Yesterday": "Yesterday",
    "You are about to delete organisational unit:": "You are about to delete organisational unit:",
    "You are about to delete user": "You are about to delete user",
    "You are about to make a {0} deactivation of IT access for user": function (a) {
      return ["You are about to make a ", a("0"), " deactivation of IT access for user"];
    },
    "You are about to reset the Multifactor authentication for this user": "You are about to reset the Multifactor authentication for this user",
    "You are not a manager for any employees, so you are not authorized to download a manager report.": "You are not a manager for any employees, so you are not authorized to download a manager report.",
    "You are not a system owner for any IT-systems, so you are not authorized to download a system report.": "You are not a system owner for any IT-systems, so you are not authorized to download a system report.",
    "You are not authorized to access this application.": "You are not authorized to access this application.",
    "You are not authorized to create new Technical Roles.": "You are not authorized to create new Technical Roles.",
    "You are not authorized to edit the business manager.": "You are not authorized to edit the business manager.",
    "You are not authorized to edit this Technical Role.": "You are not authorized to edit this Technical Role.",
    "You are trying to edit a \"readonly\" Technical Role. This role type cannot be edited.": "You are trying to edit a \"readonly\" Technical Role. This role type cannot be edited.",
    "You are trying to edit a \"readonly\" system. This system type cannot be edited.": "You are trying to edit a \"readonly\" system. This system type cannot be edited.",
    "You can click on [Add] and select the organisational units constraints. This solution is the primary recommendation for building and maintaining the organisation constraints.": "You can click on [Add] and select the organisational units constraints. This solution is the primary recommendation for building and maintaining the organisation constraints.",
    "You can enter a comment to this request. Your comment will be added to the request and the email sent to the receiver(s) of this request.": "You can enter a comment to this request. Your comment will be added to the request and the email sent to the receiver(s) of this request.",
    "You can enter a comment to this request. Your comment will be added to the request and the email sent to {requester}.": function (a) {
      return ["You can enter a comment to this request. Your comment will be added to the request and the email sent to ", a("requester"), "."];
    },
    "You can search by KLE number and then select the KLE number(s) in your search result that you need. This solution is the primary recommendation for building and maintaining KLE markings.": "You can search by KLE number and then select the KLE number(s) in your search result that you need. This solution is the primary recommendation for building and maintaining KLE markings.",
    "You can search for IT systems and select them from the list. This solution is the primary recommendation for building and maintaining IT system constraints.": "You can search for IT systems and select them from the list. This solution is the primary recommendation for building and maintaining IT system constraints.",
    "You can see which Technical Roles and Business Roles are assigned to the user, via an organisational unit, by looking at the assignment information for each technical role or business role. To edit those assignments, you have to open the \"Organisation\" app.": "You can see which Technical Roles and Business Roles are assigned to the user, via an organisational unit, by looking at the assignment information for each technical role or business role. To edit those assignments, you have to open the \"Organisation\" app.",
    "You can see which Technical Roles are assigned to the user via a business role, by looking at the assignment information for each technical role. To edit the user's business roles, you have to click on the \"Business Roles\" tab.": "You can see which Technical Roles are assigned to the user via a business role, by looking at the assignment information for each technical role. To edit the user's business roles, you have to click on the \"Business Roles\" tab.",
    "You can see which roles are assigned to the user, via an organisational unit and a business role, by looking at the assignment information for each role. To edit organisation assignments, you have to open the \"Organisation\" app. To edit the business roles assignment, you have to click on the \"Business Roles\" tab.": "You can see which roles are assigned to the user, via an organisational unit and a business role, by looking at the assignment information for each role. To edit organisation assignments, you have to open the \"Organisation\" app. To edit the business roles assignment, you have to click on the \"Business Roles\" tab.",
    "You cannot assign manual roles to business roles that are assigned to employments or organizational units.": "You cannot assign manual roles to business roles that are assigned to employments or organizational units.",
    "You cannot delete an organisational unit that has children or users assigned.": "You cannot delete an organisational unit that has children or users assigned.",
    "You currently have no apps assigned": "You currently have no apps assigned",
    "You do not have rights to activate the employee.": "You do not have rights to activate the employee.",
    "You do not have rights to create service accounts. Please contact your IT administrator for more information.": "You do not have rights to create service accounts. Please contact your IT administrator for more information.",
    "You do not have rights to create user employments. Please contact your IT administrator for more information.": "You do not have rights to create user employments. Please contact your IT administrator for more information.",
    "You do not have rights to edit this user": "You do not have rights to edit this user",
    "You do not have sufficient access in ID Connect to {0}  IT access for the employee. Please contact your system administrator.": function (a) {
      return ["You do not have sufficient access in ID Connect to ", a("0"), "  IT access for the employee. Please contact your system administrator."];
    },
    "You do not have sufficient rights in ID Connect to edit profile data on user.": "You do not have sufficient rights in ID Connect to edit profile data on user.",
    "You do not have the rights to assign or unassign roles": "You do not have the rights to assign or unassign roles",
    "You have been signed out...": "You have been signed out...",
    "You have no pinned apps.": "You have no pinned apps.",
    "You may have saved an incorrect link to the login page.": "You may have saved an incorrect link to the login page.",
    "You may have typed in the wrong token as 2 factor authentication.": "You may have typed in the wrong token as 2 factor authentication.",
    "You might have used a wrong loginpage.": "You might have used a wrong loginpage.",
    "You must enter a valid uuid": "You must enter a valid uuid",
    "Your changes will remove the existing mapping. Do you want to continue?": "Your changes will remove the existing mapping. Do you want to continue?",
    "Z to A": "Z to A",
    "activate": "activate",
    "activated": "activated",
    "are roles that are assigned directly to users within the ou where the role is assigned.": "are roles that are assigned directly to users within the ou where the role is assigned.",
    "are roles that users with permission to assign roles can assign to users within the ou where the role is assigned.": "are roles that users with permission to assign roles can assign to users within the ou where the role is assigned.",
    "be undone": "be undone",
    "be undone.": "be undone.",
    "business role": "business role",
    "deactivate": "deactivate",
    "deactivated": "deactivated",
    "default": "default",
    "delete": "delete",
    "employee": "employee",
    "employees": "employees",
    "has been processed": "has been processed",
    "home": "home",
    "hours": "hours",
    "in": "in",
    "mobile": "mobile",
    "none": "none",
    "of": "of",
    "organisational unit": "organisational unit",
    "organisational unit and bussiness role": "organisational unit and bussiness role",
    "permanent": "permanent",
    "team": "team",
    "technical role": "technical role",
    "trace id:": "trace id:",
    "work": "work",
    "{0}": function (a) {
      return [a("0")];
    },
    "{0} in {1}": function (a) {
      return [a("0"), " in ", a("1")];
    },
    "{0} in {1} ({2})": function (a) {
      return [a("0"), " in ", a("1"), " (", a("2"), ")"];
    },
    "{0} is required. Please enter one or more UUIDs.": function (a) {
      return [a("0"), " is required. Please enter one or more UUIDs."];
    },
    "{0} is required. Please select an option.": function (a) {
      return [a("0"), " is required. Please select an option."];
    },
    "{0} is required. Please select one ore more options.": function (a) {
      return [a("0"), " is required. Please select one ore more options."];
    },
    "{0}: Employed in {1}": function (a) {
      return [a("0"), ": Employed in ", a("1")];
    },
    "{0}: {1} in {2}": function (a) {
      return [a("0"), ": ", a("1"), " in ", a("2")];
    },
    "{name} is currently quarantined.": function (a) {
      return [a("name"), " is currently quarantined."];
    },
    "{name} is not activated yet.": function (a) {
      return [a("name"), " is not activated yet."];
    }
  }
};

var catalogs = {
  da: messages,
  en: messages$1
}; // gets user preferred language

var getPreferredLanguage = function getPreferredLanguage() {
  var lang; // Get the preferred list of languages from the browser if there is any.

  if (navigator.languages && navigator.languages.length) {
    lang = navigator.languages[0];
  } else {
    // Check on various browsers and browser versions, but default to "da".
    lang = navigator.userLanguage || navigator.language || navigator.browserLanguage || "en-US";
  }

  return lang;
};
var setPreferredLanguage = function setPreferredLanguage(lang) {
  return window.localStorage.setItem("preferredLanguage", lang);
}; // I18n utility method for rendering outside components

var i18n = setupI18n({
  // Make sure language is always only the first two characters of the browsers
  // language string.
  language: getPreferredLanguage().substring(0, 2),
  catalogs: catalogs
});

var enableIconProps = {
  key: "enableicon",
  iconName: "Shield",
  styles: {
    root: {
      color: DefaultPalette$2.themePrimary
    }
  }
};
var disableIconProps = {
  key: "disableicon",
  iconName: "BlockedSite",
  styles: {
    root: {
      color: DefaultPalette$2.neutralPrimary
    }
  }
};
var assignIconProps = {
  key: "assignicon",
  iconName: "Assign",
  styles: {
    root: {
      color: DefaultPalette$2.themePrimary
    }
  }
};
var removeIconProps = {
  key: "removeicon",
  iconName: "ErrorBadge",
  styles: {
    root: {
      color: DefaultPalette$2.neutralPrimary
    }
  }
};
var createIconProps = {
  key: "createicon",
  iconName: "CircleAddition",
  styles: {
    root: {
      color: DefaultPalette$2.themePrimary
    }
  }
};
var deleteIconProps = {
  key: "deleteicon",
  iconName: "Delete",
  styles: {
    root: {
      color: DefaultPalette$2.neutralPrimary
    }
  }
};
var loginIconProps = {
  key: "signinicon",
  iconName: "Signin",
  styles: {
    root: {
      color: DefaultPalette$2.themePrimary
    }
  }
};
var updateIconProps = {
  key: "updateicon",
  iconName: "Completed",
  styles: {
    root: {
      color: DefaultPalette$2.themePrimary
    }
  }
};
var executeIconProps = {
  key: "executeicon",
  iconName: "CloudImportExport",
  styles: {
    root: {
      color: DefaultPalette$2.themePrimary
    }
  }
};
var eventTypeConfig = {
  LOGIN: {
    iconProps: loginIconProps
  },
  CREATE: {
    iconProps: createIconProps
  },
  UPDATE: {
    iconProps: updateIconProps
  },
  DELETE: {
    iconProps: deleteIconProps
  },
  ASSIGN: {
    iconProps: assignIconProps
  },
  REMOVE: {
    iconProps: removeIconProps
  },
  ENABLE: {
    iconProps: enableIconProps
  },
  DISABLE: {
    iconProps: disableIconProps
  },
  EXECUTE: {
    iconProps: executeIconProps
  }
}; // Properties for clear filter button

function hasFilterItems(filterItems) {
  if (!filterItems) return false;
  var params = [];
  filterItems.forEach(function (p) {
    var val = p.split("="); // Page number and page size and sort choises should not activate clear filter button

    if (val[0] !== "pageno" && val[0] !== "pagesize" && val[0] !== "sortby" && val[0] !== "sortorder" && val[1]) params.push(val[0]);
  });
  return params.length > 0;
}

function columns(params) {
  var baseColumns = [{
    key: "date",
    name: i18n._(
    /*i18n*/
    {
      id: "Date"
    }),
    fieldName: "timestamp",
    isResizable: true,
    isSorted: true,
    isSortedDescending: true,
    minWidth: 120,
    maxWidth: 120,
    applyColumnClick: true,
    columnFilterProps: {
      filterName: "timestamp",
      filterHandlerType: "ENDPOINT_FILTER",
      filterHandler: {}
    },
    applyColumnContextMenu: true,
    columnContextMenuProps: {
      filterType: "DATES",
      filterHandlerType: "ENDPOINT_FILTER",
      filterHandler: {}
    },
    onRender: function onRender(item) {
      return /*#__PURE__*/React__default.createElement("span", null, format$1("dd-MM-yyyy HH:mm")(item.timestamp));
    }
  }, {
    key: "performedBy",
    name: i18n._(
    /*i18n*/
    {
      id: "Performed By"
    }),
    fieldName: "username",
    isResizable: true,
    minWidth: 150,
    maxWidth: 150,
    applyColumnClick: false
  }, {
    key: "assignment",
    name: i18n._(
    /*i18n*/
    {
      id: "Event Type"
    }),
    fieldName: "assignment",
    isResizable: true,
    minWidth: 150,
    maxWidth: 150,
    applyColumnClick: false
  }, {
    key: "entityType",
    name: i18n._(
    /*i18n*/
    {
      id: "Entity Type"
    }),
    fieldName: "uiEntityType",
    isResizable: true,
    minWidth: 120,
    maxWidth: 120,
    applyColumnClick: false
  }, {
    key: "entityName",
    name: i18n._(
    /*i18n*/
    {
      id: "Entity Name"
    }),
    fieldName: "entityName",
    isResizable: true,
    minWidth: 210,
    maxWidth: 500,
    applyColumnFilter: false,
    applyColumnClick: false
  }, {
    key: "assignedTo",
    name: i18n._(
    /*i18n*/
    {
      id: "Performed On"
    }),
    fieldName: "assignmentName",
    isResizable: true,
    minWidth: 150,
    applyColumnFilter: false,
    applyColumnClick: false
  }, {
    key: "assignmentType",
    name: i18n._(
    /*i18n*/
    {
      id: "Performed Type"
    }),
    fieldName: "uiAssignmentType",
    isResizable: true,
    minWidth: 110,
    maxWidth: 120,
    applyColumnClick: false
  }];
  var clearFilterColumn = {
    key: "clearfilter",
    name: " " + i18n._(
    /*i18n*/
    {
      id: "Clear filter"
    }),
    fieldName: "fieldName",
    isResizable: false,
    minWidth: 100,
    maxWidth: 100,
    iconName: "ClearFilter",
    applyColumnClick: true,
    applyPagingClearFilter: true,
    columnClearProps: {
      filterHandlerType: "ENDPOINT_FILTER",
      filterHandler: {}
    }
  };
  return hasFilterItems(params) ? [].concat(baseColumns, [clearFilterColumn]) : [].concat(baseColumns);
}

var StringToHTML = function StringToHTML(_ref) {
  var text = _ref.text;
  var spanRef = useRef(null);

  var _useState = useState(text),
      _useState2 = _slicedToArray(_useState, 2),
      someHTML = _useState2[0],
      setSomeHTML = _useState2[1];

  useEffect(function () {
    setSomeHTML(text);
  }, [text]);
  useEffect(function () {
    if (spanRef.current) {
      spanRef.current.innerHTML = someHTML;
    }
  }, [spanRef.current, someHTML]);
  return /*#__PURE__*/React__default.createElement("span", {
    ref: spanRef
  });
};
var HTMLToString = function HTMLToString(text) {
  return text ? text.replaceAll("<br>", "\n") : text;
};

var listItemProps = function listItemProps(item) {
  var iconProps = eventTypeConfig[item.icon].iconProps;
  return {
    key: "".concat(Math.random()),
    // TODO: fix id() with node-resolve in rollup config
    // and use that instead.
    timeStamp: format$1("PPPP, HH:mm")(item.timestamp),
    activityIcon: /*#__PURE__*/React__default.createElement(Stack, {
      styles: {
        root: {
          position: "relative",
          minWidth: "16px",
          marginLeft: 8,
          marginRight: 4,
          marginTop: 4
        }
      }
    }, /*#__PURE__*/React__default.createElement(Icon, iconProps)),
    activityDescription: /*#__PURE__*/React__default.createElement(Text, {
      variant: "medium"
    }, /*#__PURE__*/React__default.createElement(StringToHTML, {
      text: item.uiText
    }))
  };
};

var onRenderCell = function onRenderCell(item) {
  return /*#__PURE__*/React__default.createElement(ActivityItem, _extends({
    styles: {
      root: {
        marginTop: 8
      }
    }
  }, item, {
    key: item.key
  }));
};

var SummaryList = function SummaryList(_ref) {
  var items = _ref.items,
      title = _ref.title;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      listItems = _useState2[0],
      setListItems = _useState2[1];

  useEffect(function () {
    if (!items) return;
    setListItems(items.map(function (item) {
      return listItemProps(item);
    }));
  }, [items]);
  return items && items.length ? /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        margin: 16
      }
    }
  }, /*#__PURE__*/React__default.createElement(Label, null, title), /*#__PURE__*/React__default.createElement(List, {
    items: listItems,
    onRenderCell: onRenderCell
  })) : null;
};

var Summary = function Summary(_ref) {
  var activities = _ref.activities;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      dateIntervals = _useState2[0],
      setDateIntervals = _useState2[1];

  useEffect(function () {
    var dateRangeLists = {
      today: [],
      week: [],
      month: [],
      rest: []
    };
    var currentDate = new Date();
    var today = startOfToday();
    var thisWeek = startOfISOWeek(currentDate);
    var thisMonth = startOfMonth(currentDate);
    var newDateIntervals = activities.content.reduce(function (acc, log) {
      if (isBefore(log.timestamp, thisMonth)) {
        acc.rest.push(log);
      } else if (isBefore(log.timestamp, thisWeek)) {
        acc.month.push(log);
      } else if (isBefore(log.timestamp, today)) {
        acc.week.push(log);
      } else {
        acc.today.push(log);
      }

      return acc;
    }, dateRangeLists);
    setDateIntervals(newDateIntervals);
  }, [activities.content]);
  return /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(SummaryList, {
    items: dateIntervals.today,
    title: i18n._(
    /*i18n*/
    {
      id: "Today"
    })
  }), /*#__PURE__*/React__default.createElement(SummaryList, {
    items: dateIntervals.week,
    title: i18n._(
    /*i18n*/
    {
      id: "This Week"
    })
  }), /*#__PURE__*/React__default.createElement(SummaryList, {
    items: dateIntervals.month,
    title: i18n._(
    /*i18n*/
    {
      id: "This Month"
    })
  }), /*#__PURE__*/React__default.createElement(SummaryList, {
    items: dateIntervals.rest,
    title: i18n._(
    /*i18n*/
    {
      id: "Earlier"
    })
  }));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var moment = createCommonjsModule(function (module, exports) {

(function (global, factory) {
   module.exports = factory() ;
})(commonjsGlobal, function () {

  var hookCallback;

  function hooks() {
    return hookCallback.apply(null, arguments);
  } // This is done to register the method called with moment()
  // without creating circular dependencies.


  function setHookCallback(callback) {
    hookCallback = callback;
  }

  function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
  }

  function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
  }

  function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  }

  function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
      return Object.getOwnPropertyNames(obj).length === 0;
    } else {
      var k;

      for (k in obj) {
        if (hasOwnProp(obj, k)) {
          return false;
        }
      }

      return true;
    }
  }

  function isUndefined(input) {
    return input === void 0;
  }

  function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
  }

  function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
  }

  function map(arr, fn) {
    var res = [],
        i;

    for (i = 0; i < arr.length; ++i) {
      res.push(fn(arr[i], i));
    }

    return res;
  }

  function extend(a, b) {
    for (var i in b) {
      if (hasOwnProp(b, i)) {
        a[i] = b[i];
      }
    }

    if (hasOwnProp(b, 'toString')) {
      a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
      a.valueOf = b.valueOf;
    }

    return a;
  }

  function createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
  }

  function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
      empty: false,
      unusedTokens: [],
      unusedInput: [],
      overflow: -2,
      charsLeftOver: 0,
      nullInput: false,
      invalidEra: null,
      invalidMonth: null,
      invalidFormat: false,
      userInvalidated: false,
      iso: false,
      parsedDateParts: [],
      era: null,
      meridiem: null,
      rfc2822: false,
      weekdayMismatch: false
    };
  }

  function getParsingFlags(m) {
    if (m._pf == null) {
      m._pf = defaultParsingFlags();
    }

    return m._pf;
  }

  var some;

  if (Array.prototype.some) {
    some = Array.prototype.some;
  } else {
    some = function (fun) {
      var t = Object(this),
          len = t.length >>> 0,
          i;

      for (i = 0; i < len; i++) {
        if (i in t && fun.call(this, t[i], i, t)) {
          return true;
        }
      }

      return false;
    };
  }

  function isValid(m) {
    if (m._isValid == null) {
      var flags = getParsingFlags(m),
          parsedParts = some.call(flags.parsedDateParts, function (i) {
        return i != null;
      }),
          isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

      if (m._strict) {
        isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
      }

      if (Object.isFrozen == null || !Object.isFrozen(m)) {
        m._isValid = isNowValid;
      } else {
        return isNowValid;
      }
    }

    return m._isValid;
  }

  function createInvalid(flags) {
    var m = createUTC(NaN);

    if (flags != null) {
      extend(getParsingFlags(m), flags);
    } else {
      getParsingFlags(m).userInvalidated = true;
    }

    return m;
  } // Plugins that add properties should also add the key here (null value),
  // so we can properly clone ourselves.


  var momentProperties = hooks.momentProperties = [],
      updateInProgress = false;

  function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
      to._isAMomentObject = from._isAMomentObject;
    }

    if (!isUndefined(from._i)) {
      to._i = from._i;
    }

    if (!isUndefined(from._f)) {
      to._f = from._f;
    }

    if (!isUndefined(from._l)) {
      to._l = from._l;
    }

    if (!isUndefined(from._strict)) {
      to._strict = from._strict;
    }

    if (!isUndefined(from._tzm)) {
      to._tzm = from._tzm;
    }

    if (!isUndefined(from._isUTC)) {
      to._isUTC = from._isUTC;
    }

    if (!isUndefined(from._offset)) {
      to._offset = from._offset;
    }

    if (!isUndefined(from._pf)) {
      to._pf = getParsingFlags(from);
    }

    if (!isUndefined(from._locale)) {
      to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
      for (i = 0; i < momentProperties.length; i++) {
        prop = momentProperties[i];
        val = from[prop];

        if (!isUndefined(val)) {
          to[prop] = val;
        }
      }
    }

    return to;
  } // Moment prototype object


  function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);

    if (!this.isValid()) {
      this._d = new Date(NaN);
    } // Prevent infinite loop in case updateOffset creates new moment
    // objects.


    if (updateInProgress === false) {
      updateInProgress = true;
      hooks.updateOffset(this);
      updateInProgress = false;
    }
  }

  function isMoment(obj) {
    return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
  }

  function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
      console.warn('Deprecation warning: ' + msg);
    }
  }

  function deprecate(msg, fn) {
    var firstTime = true;
    return extend(function () {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(null, msg);
      }

      if (firstTime) {
        var args = [],
            arg,
            i,
            key;

        for (i = 0; i < arguments.length; i++) {
          arg = '';

          if (typeof arguments[i] === 'object') {
            arg += '\n[' + i + '] ';

            for (key in arguments[0]) {
              if (hasOwnProp(arguments[0], key)) {
                arg += key + ': ' + arguments[0][key] + ', ';
              }
            }

            arg = arg.slice(0, -2); // Remove trailing comma and space
          } else {
            arg = arguments[i];
          }

          args.push(arg);
        }

        warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
        firstTime = false;
      }

      return fn.apply(this, arguments);
    }, fn);
  }

  var deprecations = {};

  function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(name, msg);
    }

    if (!deprecations[name]) {
      warn(msg);
      deprecations[name] = true;
    }
  }

  hooks.suppressDeprecationWarnings = false;
  hooks.deprecationHandler = null;

  function isFunction(input) {
    return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
  }

  function set(config) {
    var prop, i;

    for (i in config) {
      if (hasOwnProp(config, i)) {
        prop = config[i];

        if (isFunction(prop)) {
          this[i] = prop;
        } else {
          this['_' + i] = prop;
        }
      }
    }

    this._config = config; // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.

    this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
  }

  function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig),
        prop;

    for (prop in childConfig) {
      if (hasOwnProp(childConfig, prop)) {
        if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
          res[prop] = {};
          extend(res[prop], parentConfig[prop]);
          extend(res[prop], childConfig[prop]);
        } else if (childConfig[prop] != null) {
          res[prop] = childConfig[prop];
        } else {
          delete res[prop];
        }
      }
    }

    for (prop in parentConfig) {
      if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
        // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
      }
    }

    return res;
  }

  function Locale(config) {
    if (config != null) {
      this.set(config);
    }
  }

  var keys;

  if (Object.keys) {
    keys = Object.keys;
  } else {
    keys = function (obj) {
      var i,
          res = [];

      for (i in obj) {
        if (hasOwnProp(obj, i)) {
          res.push(i);
        }
      }

      return res;
    };
  }

  var defaultCalendar = {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L'
  };

  function calendar(key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
  }

  function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
  }

  var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      formatFunctions = {},
      formatTokenFunctions = {}; // token:    'M'
  // padded:   ['MM', 2]
  // ordinal:  'Mo'
  // callback: function () { this.month() + 1 }

  function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;

    if (typeof callback === 'string') {
      func = function () {
        return this[callback]();
      };
    }

    if (token) {
      formatTokenFunctions[token] = func;
    }

    if (padded) {
      formatTokenFunctions[padded[0]] = function () {
        return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
      };
    }

    if (ordinal) {
      formatTokenFunctions[ordinal] = function () {
        return this.localeData().ordinal(func.apply(this, arguments), token);
      };
    }
  }

  function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
      return input.replace(/^\[|\]$/g, '');
    }

    return input.replace(/\\/g, '');
  }

  function makeFormatFunction(format) {
    var array = format.match(formattingTokens),
        i,
        length;

    for (i = 0, length = array.length; i < length; i++) {
      if (formatTokenFunctions[array[i]]) {
        array[i] = formatTokenFunctions[array[i]];
      } else {
        array[i] = removeFormattingTokens(array[i]);
      }
    }

    return function (mom) {
      var output = '',
          i;

      for (i = 0; i < length; i++) {
        output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
      }

      return output;
    };
  } // format date using native date object


  function formatMoment(m, format) {
    if (!m.isValid()) {
      return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
    return formatFunctions[format](m);
  }

  function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
      return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;

    while (i >= 0 && localFormattingTokens.test(format)) {
      format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
      localFormattingTokens.lastIndex = 0;
      i -= 1;
    }

    return format;
  }

  var defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A'
  };

  function longDateFormat(key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
      return format;
    }

    this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
      if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
        return tok.slice(1);
      }

      return tok;
    }).join('');
    return this._longDateFormat[key];
  }

  var defaultInvalidDate = 'Invalid date';

  function invalidDate() {
    return this._invalidDate;
  }

  var defaultOrdinal = '%d',
      defaultDayOfMonthOrdinalParse = /\d{1,2}/;

  function ordinal(number) {
    return this._ordinal.replace('%d', number);
  }

  var defaultRelativeTime = {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    w: 'a week',
    ww: '%d weeks',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  };

  function relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
  }

  function pastFuture(diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
  }

  var aliases = {};

  function addUnitAlias(unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
  }

  function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
  }

  function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
      if (hasOwnProp(inputObject, prop)) {
        normalizedProp = normalizeUnits(prop);

        if (normalizedProp) {
          normalizedInput[normalizedProp] = inputObject[prop];
        }
      }
    }

    return normalizedInput;
  }

  var priorities = {};

  function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
  }

  function getPrioritizedUnits(unitsObj) {
    var units = [],
        u;

    for (u in unitsObj) {
      if (hasOwnProp(unitsObj, u)) {
        units.push({
          unit: u,
          priority: priorities[u]
        });
      }
    }

    units.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return units;
  }

  function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  }

  function absFloor(number) {
    if (number < 0) {
      // -0 -> 0
      return Math.ceil(number) || 0;
    } else {
      return Math.floor(number);
    }
  }

  function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
      value = absFloor(coercedNumber);
    }

    return value;
  }

  function makeGetSet(unit, keepTime) {
    return function (value) {
      if (value != null) {
        set$1(this, unit, value);
        hooks.updateOffset(this, keepTime);
        return this;
      } else {
        return get(this, unit);
      }
    };
  }

  function get(mom, unit) {
    return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
  }

  function set$1(mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
      if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
        value = toInt(value);

        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
      } else {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
      }
    }
  } // MOMENTS


  function stringGet(units) {
    units = normalizeUnits(units);

    if (isFunction(this[units])) {
      return this[units]();
    }

    return this;
  }

  function stringSet(units, value) {
    if (typeof units === 'object') {
      units = normalizeObjectUnits(units);
      var prioritized = getPrioritizedUnits(units),
          i;

      for (i = 0; i < prioritized.length; i++) {
        this[prioritized[i].unit](units[prioritized[i].unit]);
      }
    } else {
      units = normalizeUnits(units);

      if (isFunction(this[units])) {
        return this[units](value);
      }
    }

    return this;
  }

  var match1 = /\d/,
      //       0 - 9
  match2 = /\d\d/,
      //      00 - 99
  match3 = /\d{3}/,
      //     000 - 999
  match4 = /\d{4}/,
      //    0000 - 9999
  match6 = /[+-]?\d{6}/,
      // -999999 - 999999
  match1to2 = /\d\d?/,
      //       0 - 99
  match3to4 = /\d\d\d\d?/,
      //     999 - 9999
  match5to6 = /\d\d\d\d\d\d?/,
      //   99999 - 999999
  match1to3 = /\d{1,3}/,
      //       0 - 999
  match1to4 = /\d{1,4}/,
      //       0 - 9999
  match1to6 = /[+-]?\d{1,6}/,
      // -999999 - 999999
  matchUnsigned = /\d+/,
      //       0 - inf
  matchSigned = /[+-]?\d+/,
      //    -inf - inf
  matchOffset = /Z|[+-]\d\d:?\d\d/gi,
      // +00:00 -00:00 +0000 -0000 or Z
  matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
      // +00 -00 +00:00 -00:00 +0000 -0000 or Z
  matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
      // 123456789 123456789.123
  // any word (or two) characters or numbers including two/three word month in arabic.
  // includes scottish gaelic two word and hyphenated months
  matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      regexes;
  regexes = {};

  function addRegexToken(token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
      return isStrict && strictRegex ? strictRegex : regex;
    };
  }

  function getParseRegexForToken(token, config) {
    if (!hasOwnProp(regexes, token)) {
      return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
  } // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript


  function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
      return p1 || p2 || p3 || p4;
    }));
  }

  function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }

  var tokens = {};

  function addParseToken(token, callback) {
    var i,
        func = callback;

    if (typeof token === 'string') {
      token = [token];
    }

    if (isNumber(callback)) {
      func = function (input, array) {
        array[callback] = toInt(input);
      };
    }

    for (i = 0; i < token.length; i++) {
      tokens[token[i]] = func;
    }
  }

  function addWeekParseToken(token, callback) {
    addParseToken(token, function (input, array, config, token) {
      config._w = config._w || {};
      callback(input, config._w, config, token);
    });
  }

  function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
      tokens[token](input, config._a, config, token);
    }
  }

  var YEAR = 0,
      MONTH = 1,
      DATE = 2,
      HOUR = 3,
      MINUTE = 4,
      SECOND = 5,
      MILLISECOND = 6,
      WEEK = 7,
      WEEKDAY = 8;

  function mod(n, x) {
    return (n % x + x) % x;
  }

  var indexOf;

  if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
  } else {
    indexOf = function (o) {
      // I know
      var i;

      for (i = 0; i < this.length; ++i) {
        if (this[i] === o) {
          return i;
        }
      }

      return -1;
    };
  }

  function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
      return NaN;
    }

    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
  } // FORMATTING


  addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
  });
  addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
  });
  addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
  }); // ALIASES

  addUnitAlias('month', 'M'); // PRIORITY

  addUnitPriority('month', 8); // PARSING

  addRegexToken('M', match1to2);
  addRegexToken('MM', match1to2, match2);
  addRegexToken('MMM', function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
  });
  addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
  });
  addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
  });
  addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict); // if we didn't find a month name, mark the date as invalid.


    if (month != null) {
      array[MONTH] = month;
    } else {
      getParsingFlags(config).invalidMonth = input;
    }
  }); // LOCALES

  var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      defaultMonthsShortRegex = matchWord,
      defaultMonthsRegex = matchWord;

  function localeMonths(m, format) {
    if (!m) {
      return isArray(this._months) ? this._months : this._months['standalone'];
    }

    return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
  }

  function localeMonthsShort(m, format) {
    if (!m) {
      return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
    }

    return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
  }

  function handleStrictParse(monthName, format, strict) {
    var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();

    if (!this._monthsParse) {
      // this is not used
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];

      for (i = 0; i < 12; ++i) {
        mom = createUTC([2000, i]);
        this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
        this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
      }
    }

    if (strict) {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }

  function localeMonthsParse(monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
      return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
    } // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse


    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, i]);

      if (strict && !this._longMonthsParse[i]) {
        this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
        this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
      }

      if (!strict && !this._monthsParse[i]) {
        regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
        this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
      } // test the regex


      if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
        return i;
      } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
        return i;
      } else if (!strict && this._monthsParse[i].test(monthName)) {
        return i;
      }
    }
  } // MOMENTS


  function setMonth(mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
      // No op
      return mom;
    }

    if (typeof value === 'string') {
      if (/^\d+$/.test(value)) {
        value = toInt(value);
      } else {
        value = mom.localeData().monthsParse(value); // TODO: Another silent failure?

        if (!isNumber(value)) {
          return mom;
        }
      }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));

    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);

    return mom;
  }

  function getSetMonth(value) {
    if (value != null) {
      setMonth(this, value);
      hooks.updateOffset(this, true);
      return this;
    } else {
      return get(this, 'Month');
    }
  }

  function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
  }

  function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }

      if (isStrict) {
        return this._monthsShortStrictRegex;
      } else {
        return this._monthsShortRegex;
      }
    } else {
      if (!hasOwnProp(this, '_monthsShortRegex')) {
        this._monthsShortRegex = defaultMonthsShortRegex;
      }

      return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
    }
  }

  function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }

      if (isStrict) {
        return this._monthsStrictRegex;
      } else {
        return this._monthsRegex;
      }
    } else {
      if (!hasOwnProp(this, '_monthsRegex')) {
        this._monthsRegex = defaultMonthsRegex;
      }

      return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
    }
  }

  function computeMonthsParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }

    var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;

    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, i]);
      shortPieces.push(this.monthsShort(mom, ''));
      longPieces.push(this.months(mom, ''));
      mixedPieces.push(this.months(mom, ''));
      mixedPieces.push(this.monthsShort(mom, ''));
    } // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.


    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);

    for (i = 0; i < 12; i++) {
      shortPieces[i] = regexEscape(shortPieces[i]);
      longPieces[i] = regexEscape(longPieces[i]);
    }

    for (i = 0; i < 24; i++) {
      mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
  } // FORMATTING


  addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? zeroFill(y, 4) : '+' + y;
  });
  addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
  });
  addFormatToken(0, ['YYYY', 4], 0, 'year');
  addFormatToken(0, ['YYYYY', 5], 0, 'year');
  addFormatToken(0, ['YYYYYY', 6, true], 0, 'year'); // ALIASES

  addUnitAlias('year', 'y'); // PRIORITIES

  addUnitPriority('year', 1); // PARSING

  addRegexToken('Y', matchSigned);
  addRegexToken('YY', match1to2, match2);
  addRegexToken('YYYY', match1to4, match4);
  addRegexToken('YYYYY', match1to6, match6);
  addRegexToken('YYYYYY', match1to6, match6);
  addParseToken(['YYYYY', 'YYYYYY'], YEAR);
  addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
  });
  addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
  });
  addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
  }); // HELPERS

  function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
  } // HOOKS


  hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
  }; // MOMENTS


  var getSetYear = makeGetSet('FullYear', true);

  function getIsLeapYear() {
    return isLeapYear(this.year());
  }

  function createDate(y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date; // the date constructor remaps years 0-99 to 1900-1999

    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      date = new Date(y + 400, m, d, h, M, s, ms);

      if (isFinite(date.getFullYear())) {
        date.setFullYear(y);
      }
    } else {
      date = new Date(y, m, d, h, M, s, ms);
    }

    return date;
  }

  function createUTCDate(y) {
    var date, args; // the Date.UTC function remaps years 0-99 to 1900-1999

    if (y < 100 && y >= 0) {
      args = Array.prototype.slice.call(arguments); // preserve leap years using a full 400 year cycle, then reset

      args[0] = y + 400;
      date = new Date(Date.UTC.apply(null, args));

      if (isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
      }
    } else {
      date = new Date(Date.UTC.apply(null, arguments));
    }

    return date;
  } // start-of-first-week - start-of-year


  function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
    fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
  } // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday


  function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;

    if (dayOfYear <= 0) {
      resYear = year - 1;
      resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
      resYear = year + 1;
      resDayOfYear = dayOfYear - daysInYear(year);
    } else {
      resYear = year;
      resDayOfYear = dayOfYear;
    }

    return {
      year: resYear,
      dayOfYear: resDayOfYear
    };
  }

  function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;

    if (week < 1) {
      resYear = mom.year() - 1;
      resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
      resWeek = week - weeksInYear(mom.year(), dow, doy);
      resYear = mom.year() + 1;
    } else {
      resYear = mom.year();
      resWeek = week;
    }

    return {
      week: resWeek,
      year: resYear
    };
  }

  function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
  } // FORMATTING


  addFormatToken('w', ['ww', 2], 'wo', 'week');
  addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek'); // ALIASES

  addUnitAlias('week', 'w');
  addUnitAlias('isoWeek', 'W'); // PRIORITIES

  addUnitPriority('week', 5);
  addUnitPriority('isoWeek', 5); // PARSING

  addRegexToken('w', match1to2);
  addRegexToken('ww', match1to2, match2);
  addRegexToken('W', match1to2);
  addRegexToken('WW', match1to2, match2);
  addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
  }); // HELPERS
  // LOCALES

  function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
  }

  var defaultLocaleWeek = {
    dow: 0,
    // Sunday is the first day of the week.
    doy: 6 // The week that contains Jan 6th is the first week of the year.

  };

  function localeFirstDayOfWeek() {
    return this._week.dow;
  }

  function localeFirstDayOfYear() {
    return this._week.doy;
  } // MOMENTS


  function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
  }

  function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
  } // FORMATTING


  addFormatToken('d', 0, 'do', 'day');
  addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
  });
  addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
  });
  addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
  });
  addFormatToken('e', 0, 0, 'weekday');
  addFormatToken('E', 0, 0, 'isoWeekday'); // ALIASES

  addUnitAlias('day', 'd');
  addUnitAlias('weekday', 'e');
  addUnitAlias('isoWeekday', 'E'); // PRIORITY

  addUnitPriority('day', 11);
  addUnitPriority('weekday', 11);
  addUnitPriority('isoWeekday', 11); // PARSING

  addRegexToken('d', match1to2);
  addRegexToken('e', match1to2);
  addRegexToken('E', match1to2);
  addRegexToken('dd', function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
  });
  addRegexToken('ddd', function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
  });
  addRegexToken('dddd', function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
  });
  addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict); // if we didn't get a weekday name, mark the date as invalid


    if (weekday != null) {
      week.d = weekday;
    } else {
      getParsingFlags(config).invalidWeekday = input;
    }
  });
  addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
  }); // HELPERS

  function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
      return input;
    }

    if (!isNaN(input)) {
      return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);

    if (typeof input === 'number') {
      return input;
    }

    return null;
  }

  function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
      return locale.weekdaysParse(input) % 7 || 7;
    }

    return isNaN(input) ? null : input;
  } // LOCALES


  function shiftWeekdays(ws, n) {
    return ws.slice(n, 7).concat(ws.slice(0, n));
  }

  var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      defaultWeekdaysRegex = matchWord,
      defaultWeekdaysShortRegex = matchWord,
      defaultWeekdaysMinRegex = matchWord;

  function localeWeekdays(m, format) {
    var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
    return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
  }

  function localeWeekdaysShort(m) {
    return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
  }

  function localeWeekdaysMin(m) {
    return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
  }

  function handleStrictParse$1(weekdayName, format, strict) {
    var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();

    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._minWeekdaysParse = [];

      for (i = 0; i < 7; ++i) {
        mom = createUTC([2000, 1]).day(i);
        this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
        this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
        this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
      }
    }

    if (strict) {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._shortWeekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._weekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._weekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }

  function localeWeekdaysParse(weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
      return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._minWeekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, 1]).day(i);

      if (strict && !this._fullWeekdaysParse[i]) {
        this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
        this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
        this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
      }

      if (!this._weekdaysParse[i]) {
        regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
        this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
      } // test the regex


      if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
        return i;
      }
    }
  } // MOMENTS


  function getSetDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();

    if (input != null) {
      input = parseWeekday(input, this.localeData());
      return this.add(input - day, 'd');
    } else {
      return day;
    }
  }

  function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
  }

  function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    } // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.


    if (input != null) {
      var weekday = parseIsoWeekday(input, this.localeData());
      return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
      return this.day() || 7;
    }
  }

  function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }

      if (isStrict) {
        return this._weekdaysStrictRegex;
      } else {
        return this._weekdaysRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        this._weekdaysRegex = defaultWeekdaysRegex;
      }

      return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
    }
  }

  function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }

      if (isStrict) {
        return this._weekdaysShortStrictRegex;
      } else {
        return this._weekdaysShortRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysShortRegex')) {
        this._weekdaysShortRegex = defaultWeekdaysShortRegex;
      }

      return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
  }

  function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }

      if (isStrict) {
        return this._weekdaysMinStrictRegex;
      } else {
        return this._weekdaysMinRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysMinRegex')) {
        this._weekdaysMinRegex = defaultWeekdaysMinRegex;
      }

      return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
  }

  function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }

    var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;

    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, 1]).day(i);
      minp = regexEscape(this.weekdaysMin(mom, ''));
      shortp = regexEscape(this.weekdaysShort(mom, ''));
      longp = regexEscape(this.weekdays(mom, ''));
      minPieces.push(minp);
      shortPieces.push(shortp);
      longPieces.push(longp);
      mixedPieces.push(minp);
      mixedPieces.push(shortp);
      mixedPieces.push(longp);
    } // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.


    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;
    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
  } // FORMATTING


  function hFormat() {
    return this.hours() % 12 || 12;
  }

  function kFormat() {
    return this.hours() || 24;
  }

  addFormatToken('H', ['HH', 2], 0, 'hour');
  addFormatToken('h', ['hh', 2], 0, hFormat);
  addFormatToken('k', ['kk', 2], 0, kFormat);
  addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
  });
  addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });
  addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
  });
  addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });

  function meridiem(token, lowercase) {
    addFormatToken(token, 0, 0, function () {
      return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
  }

  meridiem('a', true);
  meridiem('A', false); // ALIASES

  addUnitAlias('hour', 'h'); // PRIORITY

  addUnitPriority('hour', 13); // PARSING

  function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
  }

  addRegexToken('a', matchMeridiem);
  addRegexToken('A', matchMeridiem);
  addRegexToken('H', match1to2);
  addRegexToken('h', match1to2);
  addRegexToken('k', match1to2);
  addRegexToken('HH', match1to2, match2);
  addRegexToken('hh', match1to2, match2);
  addRegexToken('kk', match1to2, match2);
  addRegexToken('hmm', match3to4);
  addRegexToken('hmmss', match5to6);
  addRegexToken('Hmm', match3to4);
  addRegexToken('Hmmss', match5to6);
  addParseToken(['H', 'HH'], HOUR);
  addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
  });
  addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
  });
  addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
        pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
  });
  addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
        pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
  }); // LOCALES

  function localeIsPM(input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return (input + '').toLowerCase().charAt(0) === 'p';
  }

  var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
      // Setting the hour should keep the time, because the user explicitly
  // specified which hour they want. So trying to maintain the same hour (in
  // a new timezone) makes sense. Adding/subtracting hours does not follow
  // this rule.
  getSetHour = makeGetSet('Hours', true);

  function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) {
      return isLower ? 'pm' : 'PM';
    } else {
      return isLower ? 'am' : 'AM';
    }
  }

  var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,
    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,
    week: defaultLocaleWeek,
    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,
    meridiemParse: defaultLocaleMeridiemParse
  }; // internal storage for locale config files

  var locales = {},
      localeFamilies = {},
      globalLocale;

  function commonPrefix(arr1, arr2) {
    var i,
        minl = Math.min(arr1.length, arr2.length);

    for (i = 0; i < minl; i += 1) {
      if (arr1[i] !== arr2[i]) {
        return i;
      }
    }

    return minl;
  }

  function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
  } // pick the locale from the array
  // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
  // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root


  function chooseLocale(names) {
    var i = 0,
        j,
        next,
        locale,
        split;

    while (i < names.length) {
      split = normalizeLocale(names[i]).split('-');
      j = split.length;
      next = normalizeLocale(names[i + 1]);
      next = next ? next.split('-') : null;

      while (j > 0) {
        locale = loadLocale(split.slice(0, j).join('-'));

        if (locale) {
          return locale;
        }

        if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
          //the next array item is better than a shallower substring of this one
          break;
        }

        j--;
      }

      i++;
    }

    return globalLocale;
  }

  function loadLocale(name) {
    var oldLocale = null,
        aliasedRequire; // TODO: Find a better way to register and load all the locales in Node

    if (locales[name] === undefined && 'object' !== 'undefined' && module && module.exports) {
      try {
        oldLocale = globalLocale._abbr;
        aliasedRequire = commonjsRequire;
        aliasedRequire('./locale/' + name);
        getSetGlobalLocale(oldLocale);
      } catch (e) {
        // mark as not found to avoid repeating expensive file require call causing high CPU
        // when trying to find en-US, en_US, en-us for every format call
        locales[name] = null; // null means not found
      }
    }

    return locales[name];
  } // This function will load locale and then set the global locale.  If
  // no arguments are passed in, it will simply return the current global
  // locale key.


  function getSetGlobalLocale(key, values) {
    var data;

    if (key) {
      if (isUndefined(values)) {
        data = getLocale(key);
      } else {
        data = defineLocale(key, values);
      }

      if (data) {
        // moment.duration._locale = moment._locale = data;
        globalLocale = data;
      } else {
        if (typeof console !== 'undefined' && console.warn) {
          //warn user if arguments are passed but the locale could not be set
          console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
      }
    }

    return globalLocale._abbr;
  }

  function defineLocale(name, config) {
    if (config !== null) {
      var locale,
          parentConfig = baseConfig;
      config.abbr = name;

      if (locales[name] != null) {
        deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
        parentConfig = locales[name]._config;
      } else if (config.parentLocale != null) {
        if (locales[config.parentLocale] != null) {
          parentConfig = locales[config.parentLocale]._config;
        } else {
          locale = loadLocale(config.parentLocale);

          if (locale != null) {
            parentConfig = locale._config;
          } else {
            if (!localeFamilies[config.parentLocale]) {
              localeFamilies[config.parentLocale] = [];
            }

            localeFamilies[config.parentLocale].push({
              name: name,
              config: config
            });
            return null;
          }
        }
      }

      locales[name] = new Locale(mergeConfigs(parentConfig, config));

      if (localeFamilies[name]) {
        localeFamilies[name].forEach(function (x) {
          defineLocale(x.name, x.config);
        });
      } // backwards compat for now: also set the locale
      // make sure we set the locale AFTER all child locales have been
      // created, so we won't end up with the child locale set.


      getSetGlobalLocale(name);
      return locales[name];
    } else {
      // useful for testing
      delete locales[name];
      return null;
    }
  }

  function updateLocale(name, config) {
    if (config != null) {
      var locale,
          tmpLocale,
          parentConfig = baseConfig;

      if (locales[name] != null && locales[name].parentLocale != null) {
        // Update existing child locale in-place to avoid memory-leaks
        locales[name].set(mergeConfigs(locales[name]._config, config));
      } else {
        // MERGE
        tmpLocale = loadLocale(name);

        if (tmpLocale != null) {
          parentConfig = tmpLocale._config;
        }

        config = mergeConfigs(parentConfig, config);

        if (tmpLocale == null) {
          // updateLocale is called for creating a new locale
          // Set abbr so it will have a name (getters return
          // undefined otherwise).
          config.abbr = name;
        }

        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;
      } // backwards compat for now: also set the locale


      getSetGlobalLocale(name);
    } else {
      // pass null for config to unupdate, useful for tests
      if (locales[name] != null) {
        if (locales[name].parentLocale != null) {
          locales[name] = locales[name].parentLocale;

          if (name === getSetGlobalLocale()) {
            getSetGlobalLocale(name);
          }
        } else if (locales[name] != null) {
          delete locales[name];
        }
      }
    }

    return locales[name];
  } // returns locale data


  function getLocale(key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
      key = key._locale._abbr;
    }

    if (!key) {
      return globalLocale;
    }

    if (!isArray(key)) {
      //short-circuit everything else
      locale = loadLocale(key);

      if (locale) {
        return locale;
      }

      key = [key];
    }

    return chooseLocale(key);
  }

  function listLocales() {
    return keys(locales);
  }

  function checkOverflow(m) {
    var overflow,
        a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
      overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

      if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
        overflow = DATE;
      }

      if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
        overflow = WEEK;
      }

      if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
        overflow = WEEKDAY;
      }

      getParsingFlags(m).overflow = overflow;
    }

    return m;
  } // iso 8601 regex
  // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)


  var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
      isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
      // iso time formats and regexes
  isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
      // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
  rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
  }; // date from iso format

  function configFromISO(config) {
    var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat;

    if (match) {
      getParsingFlags(config).iso = true;

      for (i = 0, l = isoDates.length; i < l; i++) {
        if (isoDates[i][1].exec(match[1])) {
          dateFormat = isoDates[i][0];
          allowTime = isoDates[i][2] !== false;
          break;
        }
      }

      if (dateFormat == null) {
        config._isValid = false;
        return;
      }

      if (match[3]) {
        for (i = 0, l = isoTimes.length; i < l; i++) {
          if (isoTimes[i][1].exec(match[3])) {
            // match[2] should be 'T' or space
            timeFormat = (match[2] || ' ') + isoTimes[i][0];
            break;
          }
        }

        if (timeFormat == null) {
          config._isValid = false;
          return;
        }
      }

      if (!allowTime && timeFormat != null) {
        config._isValid = false;
        return;
      }

      if (match[4]) {
        if (tzRegex.exec(match[4])) {
          tzFormat = 'Z';
        } else {
          config._isValid = false;
          return;
        }
      }

      config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
      configFromStringAndFormat(config);
    } else {
      config._isValid = false;
    }
  }

  function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

    if (secondStr) {
      result.push(parseInt(secondStr, 10));
    }

    return result;
  }

  function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);

    if (year <= 49) {
      return 2000 + year;
    } else if (year <= 999) {
      return 1900 + year;
    }

    return year;
  }

  function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
  }

  function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
      // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
      var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();

      if (weekdayProvided !== weekdayActual) {
        getParsingFlags(config).weekdayMismatch = true;
        config._isValid = false;
        return false;
      }
    }

    return true;
  }

  function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
      return obsOffsets[obsOffset];
    } else if (militaryOffset) {
      // the only allowed military tz is Z
      return 0;
    } else {
      var hm = parseInt(numOffset, 10),
          m = hm % 100,
          h = (hm - m) / 100;
      return h * 60 + m;
    }
  } // date and time from ref 2822 format


  function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;

    if (match) {
      parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);

      if (!checkWeekday(match[1], parsedArray, config)) {
        return;
      }

      config._a = parsedArray;
      config._tzm = calculateOffset(match[8], match[9], match[10]);
      config._d = createUTCDate.apply(null, config._a);

      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

      getParsingFlags(config).rfc2822 = true;
    } else {
      config._isValid = false;
    }
  } // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict


  function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
      config._d = new Date(+matched[1]);
      return;
    }

    configFromISO(config);

    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    }

    configFromRFC2822(config);

    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    }

    if (config._strict) {
      config._isValid = false;
    } else {
      // Final attempt, use Input Fallback
      hooks.createFromInputFallback(config);
    }
  }

  hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
    config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
  }); // Pick the first defined of two or three arguments.

  function defaults(a, b, c) {
    if (a != null) {
      return a;
    }

    if (b != null) {
      return b;
    }

    return c;
  }

  function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());

    if (config._useUTC) {
      return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }

    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
  } // convert an array to a date.
  // the array should mirror the parameters below
  // note: all values past the year are optional and will default to the lowest possible value.
  // [year, month, day , hour, minute, second, millisecond]


  function configFromArray(config) {
    var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;

    if (config._d) {
      return;
    }

    currentDate = currentDateArray(config); //compute day of the year from weeks and weekdays

    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
      dayOfYearFromWeekInfo(config);
    } //if the day of the year is set, figure out what it is


    if (config._dayOfYear != null) {
      yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

      if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
        getParsingFlags(config)._overflowDayOfYear = true;
      }

      date = createUTCDate(yearToUse, 0, config._dayOfYear);
      config._a[MONTH] = date.getUTCMonth();
      config._a[DATE] = date.getUTCDate();
    } // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything


    for (i = 0; i < 3 && config._a[i] == null; ++i) {
      config._a[i] = input[i] = currentDate[i];
    } // Zero out whatever was not defaulted, including time


    for (; i < 7; i++) {
      config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
    } // Check for 24:00:00.000


    if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
      config._nextDay = true;
      config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay(); // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.

    if (config._tzm != null) {
      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
      config._a[HOUR] = 24;
    } // check for mismatching day of week


    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
      getParsingFlags(config).weekdayMismatch = true;
    }
  }

  function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
    w = config._w;

    if (w.GG != null || w.W != null || w.E != null) {
      dow = 1;
      doy = 4; // TODO: We need to take the current isoWeekYear, but that depends on
      // how we interpret now (local, utc, fixed offset). So create
      // a now version of current config (take local/utc/offset flags, and
      // create now).

      weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
      week = defaults(w.W, 1);
      weekday = defaults(w.E, 1);

      if (weekday < 1 || weekday > 7) {
        weekdayOverflow = true;
      }
    } else {
      dow = config._locale._week.dow;
      doy = config._locale._week.doy;
      curWeek = weekOfYear(createLocal(), dow, doy);
      weekYear = defaults(w.gg, config._a[YEAR], curWeek.year); // Default to current week.

      week = defaults(w.w, curWeek.week);

      if (w.d != null) {
        // weekday -- low day numbers are considered next week
        weekday = w.d;

        if (weekday < 0 || weekday > 6) {
          weekdayOverflow = true;
        }
      } else if (w.e != null) {
        // local weekday -- counting starts from beginning of week
        weekday = w.e + dow;

        if (w.e < 0 || w.e > 6) {
          weekdayOverflow = true;
        }
      } else {
        // default to beginning of week
        weekday = dow;
      }
    }

    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
      getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
      getParsingFlags(config)._overflowWeekday = true;
    } else {
      temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
      config._a[YEAR] = temp.year;
      config._dayOfYear = temp.dayOfYear;
    }
  } // constant that refers to the ISO standard


  hooks.ISO_8601 = function () {}; // constant that refers to the RFC 2822 form


  hooks.RFC_2822 = function () {}; // date from string and format string


  function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
      configFromISO(config);
      return;
    }

    if (config._f === hooks.RFC_2822) {
      configFromRFC2822(config);
      return;
    }

    config._a = [];
    getParsingFlags(config).empty = true; // This array is used to make a Date, either with `new Date` or `Date.UTC`

    var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era;
    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];
      parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];

      if (parsedInput) {
        skipped = string.substr(0, string.indexOf(parsedInput));

        if (skipped.length > 0) {
          getParsingFlags(config).unusedInput.push(skipped);
        }

        string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
        totalParsedInputLength += parsedInput.length;
      } // don't parse if it's not a known token


      if (formatTokenFunctions[token]) {
        if (parsedInput) {
          getParsingFlags(config).empty = false;
        } else {
          getParsingFlags(config).unusedTokens.push(token);
        }

        addTimeToArrayFromToken(token, parsedInput, config);
      } else if (config._strict && !parsedInput) {
        getParsingFlags(config).unusedTokens.push(token);
      }
    } // add remaining unparsed input length to the string


    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;

    if (string.length > 0) {
      getParsingFlags(config).unusedInput.push(string);
    } // clear _12h flag if hour is <= 12


    if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
      getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem; // handle meridiem

    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem); // handle era

    era = getParsingFlags(config).era;

    if (era !== null) {
      config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
    }

    configFromArray(config);
    checkOverflow(config);
  }

  function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
      // nothing to do
      return hour;
    }

    if (locale.meridiemHour != null) {
      return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
      // Fallback
      isPm = locale.isPM(meridiem);

      if (isPm && hour < 12) {
        hour += 12;
      }

      if (!isPm && hour === 12) {
        hour = 0;
      }

      return hour;
    } else {
      // this is not supposed to happen
      return hour;
    }
  } // date from string and array of format strings


  function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false;

    if (config._f.length === 0) {
      getParsingFlags(config).invalidFormat = true;
      config._d = new Date(NaN);
      return;
    }

    for (i = 0; i < config._f.length; i++) {
      currentScore = 0;
      validFormatFound = false;
      tempConfig = copyConfig({}, config);

      if (config._useUTC != null) {
        tempConfig._useUTC = config._useUTC;
      }

      tempConfig._f = config._f[i];
      configFromStringAndFormat(tempConfig);

      if (isValid(tempConfig)) {
        validFormatFound = true;
      } // if there is any input that was not parsed add a penalty for that format


      currentScore += getParsingFlags(tempConfig).charsLeftOver; //or tokens

      currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
      getParsingFlags(tempConfig).score = currentScore;

      if (!bestFormatIsValid) {
        if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;

          if (validFormatFound) {
            bestFormatIsValid = true;
          }
        }
      } else {
        if (currentScore < scoreToBeat) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
        }
      }
    }

    extend(config, bestMoment || tempConfig);
  }

  function configFromObject(config) {
    if (config._d) {
      return;
    }

    var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
    config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
      return obj && parseInt(obj, 10);
    });
    configFromArray(config);
  }

  function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));

    if (res._nextDay) {
      // Adding is smart enough around DST
      res.add(1, 'd');
      res._nextDay = undefined;
    }

    return res;
  }

  function prepareConfig(config) {
    var input = config._i,
        format = config._f;
    config._locale = config._locale || getLocale(config._l);

    if (input === null || format === undefined && input === '') {
      return createInvalid({
        nullInput: true
      });
    }

    if (typeof input === 'string') {
      config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
      return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
      config._d = input;
    } else if (isArray(format)) {
      configFromStringAndArray(config);
    } else if (format) {
      configFromStringAndFormat(config);
    } else {
      configFromInput(config);
    }

    if (!isValid(config)) {
      config._d = null;
    }

    return config;
  }

  function configFromInput(config) {
    var input = config._i;

    if (isUndefined(input)) {
      config._d = new Date(hooks.now());
    } else if (isDate(input)) {
      config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
      configFromString(config);
    } else if (isArray(input)) {
      config._a = map(input.slice(0), function (obj) {
        return parseInt(obj, 10);
      });
      configFromArray(config);
    } else if (isObject(input)) {
      configFromObject(config);
    } else if (isNumber(input)) {
      // from milliseconds
      config._d = new Date(input);
    } else {
      hooks.createFromInputFallback(config);
    }
  }

  function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};

    if (format === true || format === false) {
      strict = format;
      format = undefined;
    }

    if (locale === true || locale === false) {
      strict = locale;
      locale = undefined;
    }

    if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
      input = undefined;
    } // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423


    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;
    return createFromConfig(c);
  }

  function createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
  }

  var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
    var other = createLocal.apply(null, arguments);

    if (this.isValid() && other.isValid()) {
      return other < this ? this : other;
    } else {
      return createInvalid();
    }
  }),
      prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
    var other = createLocal.apply(null, arguments);

    if (this.isValid() && other.isValid()) {
      return other > this ? this : other;
    } else {
      return createInvalid();
    }
  }); // Pick a moment m from moments so that m[fn](other) is true for all
  // other. This relies on the function fn to be transitive.
  //
  // moments should either be an array of moment objects or an array, whose
  // first element is an array of moment objects.

  function pickBy(fn, moments) {
    var res, i;

    if (moments.length === 1 && isArray(moments[0])) {
      moments = moments[0];
    }

    if (!moments.length) {
      return createLocal();
    }

    res = moments[0];

    for (i = 1; i < moments.length; ++i) {
      if (!moments[i].isValid() || moments[i][fn](res)) {
        res = moments[i];
      }
    }

    return res;
  } // TODO: Use [].sort instead?


  function min() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isBefore', args);
  }

  function max() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isAfter', args);
  }

  var now = function () {
    return Date.now ? Date.now() : +new Date();
  };

  var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

  function isDurationValid(m) {
    var key,
        unitHasDecimal = false,
        i;

    for (key in m) {
      if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
        return false;
      }
    }

    for (i = 0; i < ordering.length; ++i) {
      if (m[ordering[i]]) {
        if (unitHasDecimal) {
          return false; // only allow non-integers for smallest unit
        }

        if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
          unitHasDecimal = true;
        }
      }
    }

    return true;
  }

  function isValid$1() {
    return this._isValid;
  }

  function createInvalid$1() {
    return createDuration(NaN);
  }

  function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;
    this._isValid = isDurationValid(normalizedInput); // representation for dateAddRemove

    this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
    minutes * 6e4 + // 1000 * 60
    hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately

    this._days = +days + weeks * 7; // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.

    this._months = +months + quarters * 3 + years * 12;
    this._data = {};
    this._locale = getLocale();

    this._bubble();
  }

  function isDuration(obj) {
    return obj instanceof Duration;
  }

  function absRound(number) {
    if (number < 0) {
      return Math.round(-1 * number) * -1;
    } else {
      return Math.round(number);
    }
  } // compare two arrays, return the number of differences


  function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;

    for (i = 0; i < len; i++) {
      if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
        diffs++;
      }
    }

    return diffs + lengthDiff;
  } // FORMATTING


  function offset(token, separator) {
    addFormatToken(token, 0, 0, function () {
      var offset = this.utcOffset(),
          sign = '+';

      if (offset < 0) {
        offset = -offset;
        sign = '-';
      }

      return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
    });
  }

  offset('Z', ':');
  offset('ZZ', ''); // PARSING

  addRegexToken('Z', matchShortOffset);
  addRegexToken('ZZ', matchShortOffset);
  addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
  }); // HELPERS
  // timezone chunker
  // '+10:00' > ['10',  '00']
  // '-1530'  > ['-15', '30']

  var chunkOffset = /([\+\-]|\d\d)/gi;

  function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;

    if (matches === null) {
      return null;
    }

    chunk = matches[matches.length - 1] || [];
    parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    minutes = +(parts[1] * 60) + toInt(parts[2]);
    return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
  } // Return a moment from input, that is local/utc/zone equivalent to model.


  function cloneWithOffset(input, model) {
    var res, diff;

    if (model._isUTC) {
      res = model.clone();
      diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf(); // Use low-level api, because this fn is low-level api.

      res._d.setTime(res._d.valueOf() + diff);

      hooks.updateOffset(res, false);
      return res;
    } else {
      return createLocal(input).local();
    }
  }

  function getDateOffset(m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset());
  } // HOOKS
  // This function will be called whenever a moment is mutated.
  // It is intended to keep the offset in sync with the timezone.


  hooks.updateOffset = function () {}; // MOMENTS
  // keepLocalTime = true means only change the timezone, without
  // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
  // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
  // +0200, so we adjust the time as needed, to be valid.
  //
  // Keeping the time actually adds/subtracts (one hour)
  // from the actual represented time. That is why we call updateOffset
  // a second time. In case it wants us to change the offset again
  // _changeInProgress == true case, then we have to adjust, because
  // there is no such time in the given timezone.


  function getSetOffset(input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;

    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    if (input != null) {
      if (typeof input === 'string') {
        input = offsetFromString(matchShortOffset, input);

        if (input === null) {
          return this;
        }
      } else if (Math.abs(input) < 16 && !keepMinutes) {
        input = input * 60;
      }

      if (!this._isUTC && keepLocalTime) {
        localAdjust = getDateOffset(this);
      }

      this._offset = input;
      this._isUTC = true;

      if (localAdjust != null) {
        this.add(localAdjust, 'm');
      }

      if (offset !== input) {
        if (!keepLocalTime || this._changeInProgress) {
          addSubtract(this, createDuration(input - offset, 'm'), 1, false);
        } else if (!this._changeInProgress) {
          this._changeInProgress = true;
          hooks.updateOffset(this, true);
          this._changeInProgress = null;
        }
      }

      return this;
    } else {
      return this._isUTC ? offset : getDateOffset(this);
    }
  }

  function getSetZone(input, keepLocalTime) {
    if (input != null) {
      if (typeof input !== 'string') {
        input = -input;
      }

      this.utcOffset(input, keepLocalTime);
      return this;
    } else {
      return -this.utcOffset();
    }
  }

  function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
  }

  function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
      this.utcOffset(0, keepLocalTime);
      this._isUTC = false;

      if (keepLocalTime) {
        this.subtract(getDateOffset(this), 'm');
      }
    }

    return this;
  }

  function setOffsetToParsedOffset() {
    if (this._tzm != null) {
      this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
      var tZone = offsetFromString(matchOffset, this._i);

      if (tZone != null) {
        this.utcOffset(tZone);
      } else {
        this.utcOffset(0, true);
      }
    }

    return this;
  }

  function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
      return false;
    }

    input = input ? createLocal(input).utcOffset() : 0;
    return (this.utcOffset() - input) % 60 === 0;
  }

  function isDaylightSavingTime() {
    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
  }

  function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) {
      return this._isDSTShifted;
    }

    var c = {},
        other;
    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
      other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
      this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
    } else {
      this._isDSTShifted = false;
    }

    return this._isDSTShifted;
  }

  function isLocal() {
    return this.isValid() ? !this._isUTC : false;
  }

  function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
  }

  function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
  } // ASP.NET json date format regex


  var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
  // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
  // and further modified to allow for strings containing both week and day
  isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

  function createDuration(input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
    match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
      duration = {
        ms: input._milliseconds,
        d: input._days,
        M: input._months
      };
    } else if (isNumber(input) || !isNaN(+input)) {
      duration = {};

      if (key) {
        duration[key] = +input;
      } else {
        duration.milliseconds = +input;
      }
    } else if (match = aspNetRegex.exec(input)) {
      sign = match[1] === '-' ? -1 : 1;
      duration = {
        y: 0,
        d: toInt(match[DATE]) * sign,
        h: toInt(match[HOUR]) * sign,
        m: toInt(match[MINUTE]) * sign,
        s: toInt(match[SECOND]) * sign,
        ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match

      };
    } else if (match = isoRegex.exec(input)) {
      sign = match[1] === '-' ? -1 : 1;
      duration = {
        y: parseIso(match[2], sign),
        M: parseIso(match[3], sign),
        w: parseIso(match[4], sign),
        d: parseIso(match[5], sign),
        h: parseIso(match[6], sign),
        m: parseIso(match[7], sign),
        s: parseIso(match[8], sign)
      };
    } else if (duration == null) {
      // checks for null or undefined
      duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
      diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
      duration = {};
      duration.ms = diffRes.milliseconds;
      duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
      ret._locale = input._locale;
    }

    if (isDuration(input) && hasOwnProp(input, '_isValid')) {
      ret._isValid = input._isValid;
    }

    return ret;
  }

  createDuration.fn = Duration.prototype;
  createDuration.invalid = createInvalid$1;

  function parseIso(inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.')); // apply sign while we're at it

    return (isNaN(res) ? 0 : res) * sign;
  }

  function positiveMomentsDifference(base, other) {
    var res = {};
    res.months = other.month() - base.month() + (other.year() - base.year()) * 12;

    if (base.clone().add(res.months, 'M').isAfter(other)) {
      --res.months;
    }

    res.milliseconds = +other - +base.clone().add(res.months, 'M');
    return res;
  }

  function momentsDifference(base, other) {
    var res;

    if (!(base.isValid() && other.isValid())) {
      return {
        milliseconds: 0,
        months: 0
      };
    }

    other = cloneWithOffset(other, base);

    if (base.isBefore(other)) {
      res = positiveMomentsDifference(base, other);
    } else {
      res = positiveMomentsDifference(other, base);
      res.milliseconds = -res.milliseconds;
      res.months = -res.months;
    }

    return res;
  } // TODO: remove 'name' arg after deprecation is removed


  function createAdder(direction, name) {
    return function (val, period) {
      var dur, tmp; //invert the arguments, but complain about it

      if (period !== null && !isNaN(+period)) {
        deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
        tmp = val;
        val = period;
        period = tmp;
      }

      dur = createDuration(val, period);
      addSubtract(this, dur, direction);
      return this;
    };
  }

  function addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
      // No op
      return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
      setMonth(mom, get(mom, 'Month') + months * isAdding);
    }

    if (days) {
      set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }

    if (milliseconds) {
      mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }

    if (updateOffset) {
      hooks.updateOffset(mom, days || months);
    }
  }

  var add = createAdder(1, 'add'),
      subtract = createAdder(-1, 'subtract');

  function isString(input) {
    return typeof input === 'string' || input instanceof String;
  } // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined


  function isMomentInput(input) {
    return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
  }

  function isMomentInputObject(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
        i,
        property;

    for (i = 0; i < properties.length; i += 1) {
      property = properties[i];
      propertyTest = propertyTest || hasOwnProp(input, property);
    }

    return objectTest && propertyTest;
  }

  function isNumberOrStringArray(input) {
    var arrayTest = isArray(input),
        dataTypeTest = false;

    if (arrayTest) {
      dataTypeTest = input.filter(function (item) {
        return !isNumber(item) && isString(input);
      }).length === 0;
    }

    return arrayTest && dataTypeTest;
  }

  function isCalendarSpec(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
        i,
        property;

    for (i = 0; i < properties.length; i += 1) {
      property = properties[i];
      propertyTest = propertyTest || hasOwnProp(input, property);
    }

    return objectTest && propertyTest;
  }

  function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
  }

  function calendar$1(time, formats) {
    // Support for single parameter, formats only overload to the calendar function
    if (arguments.length === 1) {
      if (!arguments[0]) {
        time = undefined;
        formats = undefined;
      } else if (isMomentInput(arguments[0])) {
        time = arguments[0];
        formats = undefined;
      } else if (isCalendarSpec(arguments[0])) {
        formats = arguments[0];
        time = undefined;
      }
    } // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.


    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
  }

  function clone() {
    return new Moment(this);
  }

  function isAfter(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);

    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }

    units = normalizeUnits(units) || 'millisecond';

    if (units === 'millisecond') {
      return this.valueOf() > localInput.valueOf();
    } else {
      return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
  }

  function isBefore(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);

    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }

    units = normalizeUnits(units) || 'millisecond';

    if (units === 'millisecond') {
      return this.valueOf() < localInput.valueOf();
    } else {
      return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
  }

  function isBetween(from, to, units, inclusivity) {
    var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);

    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
      return false;
    }

    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
  }

  function isSame(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;

    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }

    units = normalizeUnits(units) || 'millisecond';

    if (units === 'millisecond') {
      return this.valueOf() === localInput.valueOf();
    } else {
      inputMs = localInput.valueOf();
      return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
  }

  function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
  }

  function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
  }

  function diff(input, units, asFloat) {
    var that, zoneDelta, output;

    if (!this.isValid()) {
      return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
      return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
    units = normalizeUnits(units);

    switch (units) {
      case 'year':
        output = monthDiff(this, that) / 12;
        break;

      case 'month':
        output = monthDiff(this, that);
        break;

      case 'quarter':
        output = monthDiff(this, that) / 3;
        break;

      case 'second':
        output = (this - that) / 1e3;
        break;
      // 1000

      case 'minute':
        output = (this - that) / 6e4;
        break;
      // 1000 * 60

      case 'hour':
        output = (this - that) / 36e5;
        break;
      // 1000 * 60 * 60

      case 'day':
        output = (this - that - zoneDelta) / 864e5;
        break;
      // 1000 * 60 * 60 * 24, negate dst

      case 'week':
        output = (this - that - zoneDelta) / 6048e5;
        break;
      // 1000 * 60 * 60 * 24 * 7, negate dst

      default:
        output = this - that;
    }

    return asFloat ? output : absFloor(output);
  }

  function monthDiff(a, b) {
    if (a.date() < b.date()) {
      // end-of-month calculations work correct when the start month has more
      // days than the end month.
      return -monthDiff(b, a);
    } // difference in months


    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
    anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;

    if (b - anchor < 0) {
      anchor2 = a.clone().add(wholeMonthDiff - 1, 'months'); // linear across the month

      adjust = (b - anchor) / (anchor - anchor2);
    } else {
      anchor2 = a.clone().add(wholeMonthDiff + 1, 'months'); // linear across the month

      adjust = (b - anchor) / (anchor2 - anchor);
    } //check for negative zero, return zero if negative zero


    return -(wholeMonthDiff + adjust) || 0;
  }

  hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
  hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

  function toString() {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
  }

  function toISOString(keepOffset) {
    if (!this.isValid()) {
      return null;
    }

    var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;

    if (m.year() < 0 || m.year() > 9999) {
      return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    if (isFunction(Date.prototype.toISOString)) {
      // native implementation is ~50x faster, use it when we can
      if (utc) {
        return this.toDate().toISOString();
      } else {
        return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
      }
    }

    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
  }
  /**
   * Return a human readable representation of a moment that can
   * also be evaluated to get a new moment which is the same
   *
   * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
   */


  function inspect() {
    if (!this.isValid()) {
      return 'moment.invalid(/* ' + this._i + ' */)';
    }

    var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;

    if (!this.isLocal()) {
      func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
      zone = 'Z';
    }

    prefix = '[' + func + '("]';
    year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
    datetime = '-MM-DD[T]HH:mm:ss.SSS';
    suffix = zone + '[")]';
    return this.format(prefix + year + datetime + suffix);
  }

  function format(inputString) {
    if (!inputString) {
      inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }

    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
  }

  function from(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({
        to: this,
        from: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }

  function fromNow(withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
  }

  function to(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({
        from: this,
        to: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }

  function toNow(withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
  } // If passed a locale key, it will set the locale for this
  // instance.  Otherwise, it will return the locale configuration
  // variables for this instance.


  function locale(key) {
    var newLocaleData;

    if (key === undefined) {
      return this._locale._abbr;
    } else {
      newLocaleData = getLocale(key);

      if (newLocaleData != null) {
        this._locale = newLocaleData;
      }

      return this;
    }
  }

  var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
    if (key === undefined) {
      return this.localeData();
    } else {
      return this.locale(key);
    }
  });

  function localeData() {
    return this._locale;
  }

  var MS_PER_SECOND = 1000,
      MS_PER_MINUTE = 60 * MS_PER_SECOND,
      MS_PER_HOUR = 60 * MS_PER_MINUTE,
      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR; // actual modulo - handles negative numbers (for dates before 1970):

  function mod$1(dividend, divisor) {
    return (dividend % divisor + divisor) % divisor;
  }

  function localStartOfDate(y, m, d) {
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      return new Date(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
      return new Date(y, m, d).valueOf();
    }
  }

  function utcStartOfDate(y, m, d) {
    // Date.UTC remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
      return Date.UTC(y, m, d);
    }
  }

  function startOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);

    if (units === undefined || units === 'millisecond' || !this.isValid()) {
      return this;
    }

    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

    switch (units) {
      case 'year':
        time = startOfDate(this.year(), 0, 1);
        break;

      case 'quarter':
        time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
        break;

      case 'month':
        time = startOfDate(this.year(), this.month(), 1);
        break;

      case 'week':
        time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
        break;

      case 'isoWeek':
        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
        break;

      case 'day':
      case 'date':
        time = startOfDate(this.year(), this.month(), this.date());
        break;

      case 'hour':
        time = this._d.valueOf();
        time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
        break;

      case 'minute':
        time = this._d.valueOf();
        time -= mod$1(time, MS_PER_MINUTE);
        break;

      case 'second':
        time = this._d.valueOf();
        time -= mod$1(time, MS_PER_SECOND);
        break;
    }

    this._d.setTime(time);

    hooks.updateOffset(this, true);
    return this;
  }

  function endOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);

    if (units === undefined || units === 'millisecond' || !this.isValid()) {
      return this;
    }

    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

    switch (units) {
      case 'year':
        time = startOfDate(this.year() + 1, 0, 1) - 1;
        break;

      case 'quarter':
        time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
        break;

      case 'month':
        time = startOfDate(this.year(), this.month() + 1, 1) - 1;
        break;

      case 'week':
        time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
        break;

      case 'isoWeek':
        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
        break;

      case 'day':
      case 'date':
        time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
        break;

      case 'hour':
        time = this._d.valueOf();
        time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
        break;

      case 'minute':
        time = this._d.valueOf();
        time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
        break;

      case 'second':
        time = this._d.valueOf();
        time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
        break;
    }

    this._d.setTime(time);

    hooks.updateOffset(this, true);
    return this;
  }

  function valueOf() {
    return this._d.valueOf() - (this._offset || 0) * 60000;
  }

  function unix() {
    return Math.floor(this.valueOf() / 1000);
  }

  function toDate() {
    return new Date(this.valueOf());
  }

  function toArray() {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
  }

  function toObject() {
    var m = this;
    return {
      years: m.year(),
      months: m.month(),
      date: m.date(),
      hours: m.hours(),
      minutes: m.minutes(),
      seconds: m.seconds(),
      milliseconds: m.milliseconds()
    };
  }

  function toJSON() {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
  }

  function isValid$2() {
    return isValid(this);
  }

  function parsingFlags() {
    return extend({}, getParsingFlags(this));
  }

  function invalidAt() {
    return getParsingFlags(this).overflow;
  }

  function creationData() {
    return {
      input: this._i,
      format: this._f,
      locale: this._locale,
      isUTC: this._isUTC,
      strict: this._strict
    };
  }

  addFormatToken('N', 0, 0, 'eraAbbr');
  addFormatToken('NN', 0, 0, 'eraAbbr');
  addFormatToken('NNN', 0, 0, 'eraAbbr');
  addFormatToken('NNNN', 0, 0, 'eraName');
  addFormatToken('NNNNN', 0, 0, 'eraNarrow');
  addFormatToken('y', ['y', 1], 'yo', 'eraYear');
  addFormatToken('y', ['yy', 2], 0, 'eraYear');
  addFormatToken('y', ['yyy', 3], 0, 'eraYear');
  addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
  addRegexToken('N', matchEraAbbr);
  addRegexToken('NN', matchEraAbbr);
  addRegexToken('NNN', matchEraAbbr);
  addRegexToken('NNNN', matchEraName);
  addRegexToken('NNNNN', matchEraNarrow);
  addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
    var era = config._locale.erasParse(input, token, config._strict);

    if (era) {
      getParsingFlags(config).era = era;
    } else {
      getParsingFlags(config).invalidEra = input;
    }
  });
  addRegexToken('y', matchUnsigned);
  addRegexToken('yy', matchUnsigned);
  addRegexToken('yyy', matchUnsigned);
  addRegexToken('yyyy', matchUnsigned);
  addRegexToken('yo', matchEraYearOrdinal);
  addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
  addParseToken(['yo'], function (input, array, config, token) {
    var match;

    if (config._locale._eraYearOrdinalRegex) {
      match = input.match(config._locale._eraYearOrdinalRegex);
    }

    if (config._locale.eraYearOrdinalParse) {
      array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
    } else {
      array[YEAR] = parseInt(input, 10);
    }
  });

  function localeEras(m, format) {
    var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras;

    for (i = 0, l = eras.length; i < l; ++i) {
      switch (typeof eras[i].since) {
        case 'string':
          // truncate time
          date = hooks(eras[i].since).startOf('day');
          eras[i].since = date.valueOf();
          break;
      }

      switch (typeof eras[i].until) {
        case 'undefined':
          eras[i].until = +Infinity;
          break;

        case 'string':
          // truncate time
          date = hooks(eras[i].until).startOf('day').valueOf();
          eras[i].until = date.valueOf();
          break;
      }
    }

    return eras;
  }

  function localeErasParse(eraName, format, strict) {
    var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
    eraName = eraName.toUpperCase();

    for (i = 0, l = eras.length; i < l; ++i) {
      name = eras[i].name.toUpperCase();
      abbr = eras[i].abbr.toUpperCase();
      narrow = eras[i].narrow.toUpperCase();

      if (strict) {
        switch (format) {
          case 'N':
          case 'NN':
          case 'NNN':
            if (abbr === eraName) {
              return eras[i];
            }

            break;

          case 'NNNN':
            if (name === eraName) {
              return eras[i];
            }

            break;

          case 'NNNNN':
            if (narrow === eraName) {
              return eras[i];
            }

            break;
        }
      } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
        return eras[i];
      }
    }
  }

  function localeErasConvertYear(era, year) {
    var dir = era.since <= era.until ? +1 : -1;

    if (year === undefined) {
      return hooks(era.since).year();
    } else {
      return hooks(era.since).year() + (year - era.offset) * dir;
    }
  }

  function getEraName() {
    var i,
        l,
        val,
        eras = this.localeData().eras();

    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();

      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].name;
      }

      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].name;
      }
    }

    return '';
  }

  function getEraNarrow() {
    var i,
        l,
        val,
        eras = this.localeData().eras();

    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();

      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].narrow;
      }

      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].narrow;
      }
    }

    return '';
  }

  function getEraAbbr() {
    var i,
        l,
        val,
        eras = this.localeData().eras();

    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();

      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].abbr;
      }

      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].abbr;
      }
    }

    return '';
  }

  function getEraYear() {
    var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();

    for (i = 0, l = eras.length; i < l; ++i) {
      dir = eras[i].since <= eras[i].until ? +1 : -1; // truncate time

      val = this.clone().startOf('day').valueOf();

      if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
        return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
      }
    }

    return this.year();
  }

  function erasNameRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNameRegex')) {
      computeErasParse.call(this);
    }

    return isStrict ? this._erasNameRegex : this._erasRegex;
  }

  function erasAbbrRegex(isStrict) {
    if (!hasOwnProp(this, '_erasAbbrRegex')) {
      computeErasParse.call(this);
    }

    return isStrict ? this._erasAbbrRegex : this._erasRegex;
  }

  function erasNarrowRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNarrowRegex')) {
      computeErasParse.call(this);
    }

    return isStrict ? this._erasNarrowRegex : this._erasRegex;
  }

  function matchEraAbbr(isStrict, locale) {
    return locale.erasAbbrRegex(isStrict);
  }

  function matchEraName(isStrict, locale) {
    return locale.erasNameRegex(isStrict);
  }

  function matchEraNarrow(isStrict, locale) {
    return locale.erasNarrowRegex(isStrict);
  }

  function matchEraYearOrdinal(isStrict, locale) {
    return locale._eraYearOrdinalRegex || matchUnsigned;
  }

  function computeErasParse() {
    var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras();

    for (i = 0, l = eras.length; i < l; ++i) {
      namePieces.push(regexEscape(eras[i].name));
      abbrPieces.push(regexEscape(eras[i].abbr));
      narrowPieces.push(regexEscape(eras[i].narrow));
      mixedPieces.push(regexEscape(eras[i].name));
      mixedPieces.push(regexEscape(eras[i].abbr));
      mixedPieces.push(regexEscape(eras[i].narrow));
    }

    this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
    this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
    this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
  } // FORMATTING


  addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
  });
  addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
  });

  function addWeekYearFormatToken(token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
  }

  addWeekYearFormatToken('gggg', 'weekYear');
  addWeekYearFormatToken('ggggg', 'weekYear');
  addWeekYearFormatToken('GGGG', 'isoWeekYear');
  addWeekYearFormatToken('GGGGG', 'isoWeekYear'); // ALIASES

  addUnitAlias('weekYear', 'gg');
  addUnitAlias('isoWeekYear', 'GG'); // PRIORITY

  addUnitPriority('weekYear', 1);
  addUnitPriority('isoWeekYear', 1); // PARSING

  addRegexToken('G', matchSigned);
  addRegexToken('g', matchSigned);
  addRegexToken('GG', match1to2, match2);
  addRegexToken('gg', match1to2, match2);
  addRegexToken('GGGG', match1to4, match4);
  addRegexToken('gggg', match1to4, match4);
  addRegexToken('GGGGG', match1to6, match6);
  addRegexToken('ggggg', match1to6, match6);
  addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
  });
  addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
  }); // MOMENTS

  function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
  }

  function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
  }

  function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
  }

  function getISOWeeksInISOWeekYear() {
    return weeksInYear(this.isoWeekYear(), 1, 4);
  }

  function getWeeksInYear() {
    var weekInfo = this.localeData()._week;

    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
  }

  function getWeeksInWeekYear() {
    var weekInfo = this.localeData()._week;

    return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
  }

  function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;

    if (input == null) {
      return weekOfYear(this, dow, doy).year;
    } else {
      weeksTarget = weeksInYear(input, dow, doy);

      if (week > weeksTarget) {
        week = weeksTarget;
      }

      return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
  }

  function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
  } // FORMATTING


  addFormatToken('Q', 0, 'Qo', 'quarter'); // ALIASES

  addUnitAlias('quarter', 'Q'); // PRIORITY

  addUnitPriority('quarter', 7); // PARSING

  addRegexToken('Q', match1);
  addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
  }); // MOMENTS

  function getSetQuarter(input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
  } // FORMATTING


  addFormatToken('D', ['DD', 2], 'Do', 'date'); // ALIASES

  addUnitAlias('date', 'D'); // PRIORITY

  addUnitPriority('date', 9); // PARSING

  addRegexToken('D', match1to2);
  addRegexToken('DD', match1to2, match2);
  addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
  });
  addParseToken(['D', 'DD'], DATE);
  addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
  }); // MOMENTS

  var getSetDayOfMonth = makeGetSet('Date', true); // FORMATTING

  addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear'); // ALIASES

  addUnitAlias('dayOfYear', 'DDD'); // PRIORITY

  addUnitPriority('dayOfYear', 4); // PARSING

  addRegexToken('DDD', match1to3);
  addRegexToken('DDDD', match3);
  addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
  }); // HELPERS
  // MOMENTS

  function getSetDayOfYear(input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
  } // FORMATTING


  addFormatToken('m', ['mm', 2], 0, 'minute'); // ALIASES

  addUnitAlias('minute', 'm'); // PRIORITY

  addUnitPriority('minute', 14); // PARSING

  addRegexToken('m', match1to2);
  addRegexToken('mm', match1to2, match2);
  addParseToken(['m', 'mm'], MINUTE); // MOMENTS

  var getSetMinute = makeGetSet('Minutes', false); // FORMATTING

  addFormatToken('s', ['ss', 2], 0, 'second'); // ALIASES

  addUnitAlias('second', 's'); // PRIORITY

  addUnitPriority('second', 15); // PARSING

  addRegexToken('s', match1to2);
  addRegexToken('ss', match1to2, match2);
  addParseToken(['s', 'ss'], SECOND); // MOMENTS

  var getSetSecond = makeGetSet('Seconds', false); // FORMATTING

  addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
  });
  addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
  });
  addFormatToken(0, ['SSS', 3], 0, 'millisecond');
  addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
  });
  addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
  });
  addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
  });
  addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
  });
  addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
  });
  addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
  }); // ALIASES

  addUnitAlias('millisecond', 'ms'); // PRIORITY

  addUnitPriority('millisecond', 16); // PARSING

  addRegexToken('S', match1to3, match1);
  addRegexToken('SS', match1to3, match2);
  addRegexToken('SSS', match1to3, match3);
  var token, getSetMillisecond;

  for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
  }

  function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
  }

  for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
  }

  getSetMillisecond = makeGetSet('Milliseconds', false); // FORMATTING

  addFormatToken('z', 0, 0, 'zoneAbbr');
  addFormatToken('zz', 0, 0, 'zoneName'); // MOMENTS

  function getZoneAbbr() {
    return this._isUTC ? 'UTC' : '';
  }

  function getZoneName() {
    return this._isUTC ? 'Coordinated Universal Time' : '';
  }

  var proto = Moment.prototype;
  proto.add = add;
  proto.calendar = calendar$1;
  proto.clone = clone;
  proto.diff = diff;
  proto.endOf = endOf;
  proto.format = format;
  proto.from = from;
  proto.fromNow = fromNow;
  proto.to = to;
  proto.toNow = toNow;
  proto.get = stringGet;
  proto.invalidAt = invalidAt;
  proto.isAfter = isAfter;
  proto.isBefore = isBefore;
  proto.isBetween = isBetween;
  proto.isSame = isSame;
  proto.isSameOrAfter = isSameOrAfter;
  proto.isSameOrBefore = isSameOrBefore;
  proto.isValid = isValid$2;
  proto.lang = lang;
  proto.locale = locale;
  proto.localeData = localeData;
  proto.max = prototypeMax;
  proto.min = prototypeMin;
  proto.parsingFlags = parsingFlags;
  proto.set = stringSet;
  proto.startOf = startOf;
  proto.subtract = subtract;
  proto.toArray = toArray;
  proto.toObject = toObject;
  proto.toDate = toDate;
  proto.toISOString = toISOString;
  proto.inspect = inspect;

  if (typeof Symbol !== 'undefined' && Symbol.for != null) {
    proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
      return 'Moment<' + this.format() + '>';
    };
  }

  proto.toJSON = toJSON;
  proto.toString = toString;
  proto.unix = unix;
  proto.valueOf = valueOf;
  proto.creationData = creationData;
  proto.eraName = getEraName;
  proto.eraNarrow = getEraNarrow;
  proto.eraAbbr = getEraAbbr;
  proto.eraYear = getEraYear;
  proto.year = getSetYear;
  proto.isLeapYear = getIsLeapYear;
  proto.weekYear = getSetWeekYear;
  proto.isoWeekYear = getSetISOWeekYear;
  proto.quarter = proto.quarters = getSetQuarter;
  proto.month = getSetMonth;
  proto.daysInMonth = getDaysInMonth;
  proto.week = proto.weeks = getSetWeek;
  proto.isoWeek = proto.isoWeeks = getSetISOWeek;
  proto.weeksInYear = getWeeksInYear;
  proto.weeksInWeekYear = getWeeksInWeekYear;
  proto.isoWeeksInYear = getISOWeeksInYear;
  proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
  proto.date = getSetDayOfMonth;
  proto.day = proto.days = getSetDayOfWeek;
  proto.weekday = getSetLocaleDayOfWeek;
  proto.isoWeekday = getSetISODayOfWeek;
  proto.dayOfYear = getSetDayOfYear;
  proto.hour = proto.hours = getSetHour;
  proto.minute = proto.minutes = getSetMinute;
  proto.second = proto.seconds = getSetSecond;
  proto.millisecond = proto.milliseconds = getSetMillisecond;
  proto.utcOffset = getSetOffset;
  proto.utc = setOffsetToUTC;
  proto.local = setOffsetToLocal;
  proto.parseZone = setOffsetToParsedOffset;
  proto.hasAlignedHourOffset = hasAlignedHourOffset;
  proto.isDST = isDaylightSavingTime;
  proto.isLocal = isLocal;
  proto.isUtcOffset = isUtcOffset;
  proto.isUtc = isUtc;
  proto.isUTC = isUtc;
  proto.zoneAbbr = getZoneAbbr;
  proto.zoneName = getZoneName;
  proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
  proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
  proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
  proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
  proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

  function createUnix(input) {
    return createLocal(input * 1000);
  }

  function createInZone() {
    return createLocal.apply(null, arguments).parseZone();
  }

  function preParsePostFormat(string) {
    return string;
  }

  var proto$1 = Locale.prototype;
  proto$1.calendar = calendar;
  proto$1.longDateFormat = longDateFormat;
  proto$1.invalidDate = invalidDate;
  proto$1.ordinal = ordinal;
  proto$1.preparse = preParsePostFormat;
  proto$1.postformat = preParsePostFormat;
  proto$1.relativeTime = relativeTime;
  proto$1.pastFuture = pastFuture;
  proto$1.set = set;
  proto$1.eras = localeEras;
  proto$1.erasParse = localeErasParse;
  proto$1.erasConvertYear = localeErasConvertYear;
  proto$1.erasAbbrRegex = erasAbbrRegex;
  proto$1.erasNameRegex = erasNameRegex;
  proto$1.erasNarrowRegex = erasNarrowRegex;
  proto$1.months = localeMonths;
  proto$1.monthsShort = localeMonthsShort;
  proto$1.monthsParse = localeMonthsParse;
  proto$1.monthsRegex = monthsRegex;
  proto$1.monthsShortRegex = monthsShortRegex;
  proto$1.week = localeWeek;
  proto$1.firstDayOfYear = localeFirstDayOfYear;
  proto$1.firstDayOfWeek = localeFirstDayOfWeek;
  proto$1.weekdays = localeWeekdays;
  proto$1.weekdaysMin = localeWeekdaysMin;
  proto$1.weekdaysShort = localeWeekdaysShort;
  proto$1.weekdaysParse = localeWeekdaysParse;
  proto$1.weekdaysRegex = weekdaysRegex;
  proto$1.weekdaysShortRegex = weekdaysShortRegex;
  proto$1.weekdaysMinRegex = weekdaysMinRegex;
  proto$1.isPM = localeIsPM;
  proto$1.meridiem = localeMeridiem;

  function get$1(format, index, field, setter) {
    var locale = getLocale(),
        utc = createUTC().set(setter, index);
    return locale[field](utc, format);
  }

  function listMonthsImpl(format, index, field) {
    if (isNumber(format)) {
      index = format;
      format = undefined;
    }

    format = format || '';

    if (index != null) {
      return get$1(format, index, field, 'month');
    }

    var i,
        out = [];

    for (i = 0; i < 12; i++) {
      out[i] = get$1(format, i, field, 'month');
    }

    return out;
  } // ()
  // (5)
  // (fmt, 5)
  // (fmt)
  // (true)
  // (true, 5)
  // (true, fmt, 5)
  // (true, fmt)


  function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }

      format = format || '';
    } else {
      format = localeSorted;
      index = format;
      localeSorted = false;

      if (isNumber(format)) {
        index = format;
        format = undefined;
      }

      format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];

    if (index != null) {
      return get$1(format, (index + shift) % 7, field, 'day');
    }

    for (i = 0; i < 7; i++) {
      out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }

    return out;
  }

  function listMonths(format, index) {
    return listMonthsImpl(format, index, 'months');
  }

  function listMonthsShort(format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
  }

  function listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
  }

  function listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
  }

  function listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
  }

  getSetGlobalLocale('en', {
    eras: [{
      since: '0001-01-01',
      until: +Infinity,
      offset: 1,
      name: 'Anno Domini',
      narrow: 'AD',
      abbr: 'AD'
    }, {
      since: '0000-12-31',
      until: -Infinity,
      offset: 1,
      name: 'Before Christ',
      narrow: 'BC',
      abbr: 'BC'
    }],
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function (number) {
      var b = number % 10,
          output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
      return number + output;
    }
  }); // Side effect imports

  hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
  hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
  var mathAbs = Math.abs;

  function abs() {
    var data = this._data;
    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);
    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);
    return this;
  }

  function addSubtract$1(duration, input, value, direction) {
    var other = createDuration(input, value);
    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;
    return duration._bubble();
  } // supports only 2.0-style add(1, 's') or add(duration)


  function add$1(input, value) {
    return addSubtract$1(this, input, value, 1);
  } // supports only 2.0-style subtract(1, 's') or subtract(duration)


  function subtract$1(input, value) {
    return addSubtract$1(this, input, value, -1);
  }

  function absCeil(number) {
    if (number < 0) {
      return Math.floor(number);
    } else {
      return Math.ceil(number);
    }
  }

  function bubble() {
    var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays; // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166

    if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
      milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
      days = 0;
      months = 0;
    } // The following code bubbles up values, see the tests for
    // examples of what that means.


    data.milliseconds = milliseconds % 1000;
    seconds = absFloor(milliseconds / 1000);
    data.seconds = seconds % 60;
    minutes = absFloor(seconds / 60);
    data.minutes = minutes % 60;
    hours = absFloor(minutes / 60);
    data.hours = hours % 24;
    days += absFloor(hours / 24); // convert days to months

    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays)); // 12 months -> 1 year

    years = absFloor(months / 12);
    months %= 12;
    data.days = days;
    data.months = months;
    data.years = years;
    return this;
  }

  function daysToMonths(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
  }

  function monthsToDays(months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
  }

  function as(units) {
    if (!this.isValid()) {
      return NaN;
    }

    var days,
        months,
        milliseconds = this._milliseconds;
    units = normalizeUnits(units);

    if (units === 'month' || units === 'quarter' || units === 'year') {
      days = this._days + milliseconds / 864e5;
      months = this._months + daysToMonths(days);

      switch (units) {
        case 'month':
          return months;

        case 'quarter':
          return months / 3;

        case 'year':
          return months / 12;
      }
    } else {
      // handle milliseconds separately because of floating point math errors (issue #1867)
      days = this._days + Math.round(monthsToDays(this._months));

      switch (units) {
        case 'week':
          return days / 7 + milliseconds / 6048e5;

        case 'day':
          return days + milliseconds / 864e5;

        case 'hour':
          return days * 24 + milliseconds / 36e5;

        case 'minute':
          return days * 1440 + milliseconds / 6e4;

        case 'second':
          return days * 86400 + milliseconds / 1000;
        // Math.floor prevents floating point math errors here

        case 'millisecond':
          return Math.floor(days * 864e5) + milliseconds;

        default:
          throw new Error('Unknown unit ' + units);
      }
    }
  } // TODO: Use this.as('ms')?


  function valueOf$1() {
    if (!this.isValid()) {
      return NaN;
    }

    return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
  }

  function makeAs(alias) {
    return function () {
      return this.as(alias);
    };
  }

  var asMilliseconds = makeAs('ms'),
      asSeconds = makeAs('s'),
      asMinutes = makeAs('m'),
      asHours = makeAs('h'),
      asDays = makeAs('d'),
      asWeeks = makeAs('w'),
      asMonths = makeAs('M'),
      asQuarters = makeAs('Q'),
      asYears = makeAs('y');

  function clone$1() {
    return createDuration(this);
  }

  function get$2(units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
  }

  function makeGetter(name) {
    return function () {
      return this.isValid() ? this._data[name] : NaN;
    };
  }

  var milliseconds = makeGetter('milliseconds'),
      seconds = makeGetter('seconds'),
      minutes = makeGetter('minutes'),
      hours = makeGetter('hours'),
      days = makeGetter('days'),
      months = makeGetter('months'),
      years = makeGetter('years');

  function weeks() {
    return absFloor(this.days() / 7);
  }

  var round = Math.round,
      thresholds = {
    ss: 44,
    // a few seconds to seconds
    s: 45,
    // seconds to minute
    m: 45,
    // minutes to hour
    h: 22,
    // hours to day
    d: 26,
    // days to month/week
    w: null,
    // weeks to month
    M: 11 // months to year

  }; // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize

  function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
  }

  function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
    var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];

    if (thresholds.w != null) {
      a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
    }

    a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
  } // This function allows you to set the rounding function for relative time strings


  function getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === undefined) {
      return round;
    }

    if (typeof roundingFunction === 'function') {
      round = roundingFunction;
      return true;
    }

    return false;
  } // This function allows you to set a threshold for relative time strings


  function getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) {
      return false;
    }

    if (limit === undefined) {
      return thresholds[threshold];
    }

    thresholds[threshold] = limit;

    if (threshold === 's') {
      thresholds.ss = limit - 1;
    }

    return true;
  }

  function humanize(argWithSuffix, argThresholds) {
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }

    var withSuffix = false,
        th = thresholds,
        locale,
        output;

    if (typeof argWithSuffix === 'object') {
      argThresholds = argWithSuffix;
      argWithSuffix = false;
    }

    if (typeof argWithSuffix === 'boolean') {
      withSuffix = argWithSuffix;
    }

    if (typeof argThresholds === 'object') {
      th = Object.assign({}, thresholds, argThresholds);

      if (argThresholds.s != null && argThresholds.ss == null) {
        th.ss = argThresholds.s - 1;
      }
    }

    locale = this.localeData();
    output = relativeTime$1(this, !withSuffix, th, locale);

    if (withSuffix) {
      output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
  }

  var abs$1 = Math.abs;

  function sign(x) {
    return (x > 0) - (x < 0) || +x;
  }

  function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;

    if (!total) {
      // this is the same as C#'s (Noda) and python (isodate)...
      // but not other JS (goog.date)
      return 'P0D';
    } // 3600 seconds -> 60 minutes -> 1 hour


    minutes = absFloor(seconds / 60);
    hours = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60; // 12 months -> 1 year

    years = absFloor(months / 12);
    months %= 12; // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js

    s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    totalSign = total < 0 ? '-' : '';
    ymSign = sign(this._months) !== sign(total) ? '-' : '';
    daysSign = sign(this._days) !== sign(total) ? '-' : '';
    hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
    return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
  }

  var proto$2 = Duration.prototype;
  proto$2.isValid = isValid$1;
  proto$2.abs = abs;
  proto$2.add = add$1;
  proto$2.subtract = subtract$1;
  proto$2.as = as;
  proto$2.asMilliseconds = asMilliseconds;
  proto$2.asSeconds = asSeconds;
  proto$2.asMinutes = asMinutes;
  proto$2.asHours = asHours;
  proto$2.asDays = asDays;
  proto$2.asWeeks = asWeeks;
  proto$2.asMonths = asMonths;
  proto$2.asQuarters = asQuarters;
  proto$2.asYears = asYears;
  proto$2.valueOf = valueOf$1;
  proto$2._bubble = bubble;
  proto$2.clone = clone$1;
  proto$2.get = get$2;
  proto$2.milliseconds = milliseconds;
  proto$2.seconds = seconds;
  proto$2.minutes = minutes;
  proto$2.hours = hours;
  proto$2.days = days;
  proto$2.weeks = weeks;
  proto$2.months = months;
  proto$2.years = years;
  proto$2.humanize = humanize;
  proto$2.toISOString = toISOString$1;
  proto$2.toString = toISOString$1;
  proto$2.toJSON = toISOString$1;
  proto$2.locale = locale;
  proto$2.localeData = localeData;
  proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
  proto$2.lang = lang; // FORMATTING

  addFormatToken('X', 0, 0, 'unix');
  addFormatToken('x', 0, 0, 'valueOf'); // PARSING

  addRegexToken('x', matchSigned);
  addRegexToken('X', matchTimestamp);
  addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input) * 1000);
  });
  addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
  }); //! moment.js

  hooks.version = '2.29.1';
  setHookCallback(createLocal);
  hooks.fn = proto;
  hooks.min = min;
  hooks.max = max;
  hooks.now = now;
  hooks.utc = createUTC;
  hooks.unix = createUnix;
  hooks.months = listMonths;
  hooks.isDate = isDate;
  hooks.locale = getSetGlobalLocale;
  hooks.invalid = createInvalid;
  hooks.duration = createDuration;
  hooks.isMoment = isMoment;
  hooks.weekdays = listWeekdays;
  hooks.parseZone = createInZone;
  hooks.localeData = getLocale;
  hooks.isDuration = isDuration;
  hooks.monthsShort = listMonthsShort;
  hooks.weekdaysMin = listWeekdaysMin;
  hooks.defineLocale = defineLocale;
  hooks.updateLocale = updateLocale;
  hooks.locales = listLocales;
  hooks.weekdaysShort = listWeekdaysShort;
  hooks.normalizeUnits = normalizeUnits;
  hooks.relativeTimeRounding = getSetRelativeTimeRounding;
  hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
  hooks.calendarFormat = getCalendarFormat;
  hooks.prototype = proto; // currently HTML5 input type only supports 24-hour formats

  hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
    // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
    // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
    // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',
    // <input type="date" />
    TIME: 'HH:mm',
    // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',
    // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',
    // <input type="time" step="0.001" />
    WEEK: 'GGGG-[W]WW',
    // <input type="week" />
    MONTH: 'YYYY-MM' // <input type="month" />

  };
  return hooks;
});
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };

  return extendStatics(d, b);
};

function __extends(d, b) {
  extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
}

var InjectionMode = {
  /**
   * Avoids style injection, use getRules() to read the styles.
   */
  none: 0,

  /**
   * Inserts rules using the insertRule api.
   */
  insertNode: 1,

  /**
   * Appends rules using appendChild.
   */
  appendChild: 2
};
var STYLESHEET_SETTING = '__stylesheet__';
/**
 * MSIE 11 doesn't cascade styles based on DOM ordering, but rather on the order that each style node
 * is created. As such, to maintain consistent priority, IE11 should reuse a single style node.
 */

var REUSE_STYLE_NODE = typeof navigator !== 'undefined' && /rv:11.0/.test(navigator.userAgent);
var _global = {}; // Grab window.

try {
  _global = window;
} catch (_a) {
  /* leave as blank object */
}

var _stylesheet;
/**
 * Represents the state of styles registered in the page. Abstracts
 * the surface for adding styles to the stylesheet, exposes helpers
 * for reading the styles registered in server rendered scenarios.
 *
 * @public
 */


var Stylesheet =
/** @class */
function () {
  function Stylesheet(config) {
    this._rules = [];
    this._preservedRules = [];
    this._rulesToInsert = [];
    this._counter = 0;
    this._keyToClassName = {};
    this._onResetCallbacks = [];
    this._classNameToArgs = {};
    this._config = __assign({
      injectionMode: InjectionMode.insertNode,
      defaultPrefix: 'css',
      namespace: undefined,
      cspSettings: undefined
    }, config);
    this._keyToClassName = this._config.classNameCache || {};
  }
  /**
   * Gets the singleton instance.
   */


  Stylesheet.getInstance = function () {
    var _a;

    _stylesheet = _global[STYLESHEET_SETTING];

    if (!_stylesheet || _stylesheet._lastStyleElement && _stylesheet._lastStyleElement.ownerDocument !== document) {
      var fabricConfig = ((_a = _global) === null || _a === void 0 ? void 0 : _a.FabricConfig) || {};
      _stylesheet = _global[STYLESHEET_SETTING] = new Stylesheet(fabricConfig.mergeStyles);
    }

    return _stylesheet;
  };
  /**
   * Configures the stylesheet.
   */


  Stylesheet.prototype.setConfig = function (config) {
    this._config = __assign(__assign({}, this._config), config);
  };
  /**
   * Configures a reset callback.
   *
   * @param callback - A callback which will be called when the Stylesheet is reset.
   */


  Stylesheet.prototype.onReset = function (callback) {
    this._onResetCallbacks.push(callback);
  };
  /**
   * Generates a unique classname.
   *
   * @param displayName - Optional value to use as a prefix.
   */


  Stylesheet.prototype.getClassName = function (displayName) {
    var namespace = this._config.namespace;
    var prefix = displayName || this._config.defaultPrefix;
    return "" + (namespace ? namespace + '-' : '') + prefix + "-" + this._counter++;
  };
  /**
   * Used internally to cache information about a class which was
   * registered with the stylesheet.
   */


  Stylesheet.prototype.cacheClassName = function (className, key, args, rules) {
    this._keyToClassName[key] = className;
    this._classNameToArgs[className] = {
      args: args,
      rules: rules
    };
  };
  /**
   * Gets the appropriate classname given a key which was previously
   * registered using cacheClassName.
   */


  Stylesheet.prototype.classNameFromKey = function (key) {
    return this._keyToClassName[key];
  };
  /**
   * Gets all classnames cache with the stylesheet.
   */


  Stylesheet.prototype.getClassNameCache = function () {
    return this._keyToClassName;
  };
  /**
   * Gets the arguments associated with a given classname which was
   * previously registered using cacheClassName.
   */


  Stylesheet.prototype.argsFromClassName = function (className) {
    var entry = this._classNameToArgs[className];
    return entry && entry.args;
  };
  /**
   * Gets the arguments associated with a given classname which was
   * previously registered using cacheClassName.
   */


  Stylesheet.prototype.insertedRulesFromClassName = function (className) {
    var entry = this._classNameToArgs[className];
    return entry && entry.rules;
  };
  /**
   * Inserts a css rule into the stylesheet.
   * @param preserve - Preserves the rule beyond a reset boundary.
   */


  Stylesheet.prototype.insertRule = function (rule, preserve) {
    var injectionMode = this._config.injectionMode;
    var element = injectionMode !== InjectionMode.none ? this._getStyleElement() : undefined;

    if (preserve) {
      this._preservedRules.push(rule);
    }

    if (element) {
      switch (this._config.injectionMode) {
        case InjectionMode.insertNode:
          var sheet = element.sheet;

          try {
            sheet.insertRule(rule, sheet.cssRules.length);
          } catch (e) {// The browser will throw exceptions on unsupported rules (such as a moz prefix in webkit.)
            // We need to swallow the exceptions for this scenario, otherwise we'd need to filter
            // which could be slower and bulkier.
          }

          break;

        case InjectionMode.appendChild:
          element.appendChild(document.createTextNode(rule));
          break;
      }
    } else {
      this._rules.push(rule);
    }

    if (this._config.onInsertRule) {
      this._config.onInsertRule(rule);
    }
  };
  /**
   * Gets all rules registered with the stylesheet; only valid when
   * using InsertionMode.none.
   */


  Stylesheet.prototype.getRules = function (includePreservedRules) {
    return (includePreservedRules ? this._preservedRules.join('') : '') + this._rules.join('') + this._rulesToInsert.join('');
  };
  /**
   * Resets the internal state of the stylesheet. Only used in server
   * rendered scenarios where we're using InsertionMode.none.
   */


  Stylesheet.prototype.reset = function () {
    this._rules = [];
    this._rulesToInsert = [];
    this._counter = 0;
    this._classNameToArgs = {};
    this._keyToClassName = {};

    this._onResetCallbacks.forEach(function (callback) {
      return callback();
    });
  }; // Forces the regeneration of incoming styles without totally resetting the stylesheet.


  Stylesheet.prototype.resetKeys = function () {
    this._keyToClassName = {};
  };

  Stylesheet.prototype._getStyleElement = function () {
    var _this = this;

    if (!this._styleElement && typeof document !== 'undefined') {
      this._styleElement = this._createStyleElement();

      if (!REUSE_STYLE_NODE) {
        // Reset the style element on the next frame.
        window.requestAnimationFrame(function () {
          _this._styleElement = undefined;
        });
      }
    }

    return this._styleElement;
  };

  Stylesheet.prototype._createStyleElement = function () {
    var head = document.head;
    var styleElement = document.createElement('style');
    styleElement.setAttribute('data-merge-styles', 'true');
    var cspSettings = this._config.cspSettings;

    if (cspSettings) {
      if (cspSettings.nonce) {
        styleElement.setAttribute('nonce', cspSettings.nonce);
      }
    }

    if (this._lastStyleElement) {
      // If the `nextElementSibling` is null, then the insertBefore will act as a regular append.
      // https://developer.mozilla.org/en-US/docs/Web/API/Node/insertBefore#Syntax
      head.insertBefore(styleElement, this._lastStyleElement.nextElementSibling);
    } else {
      var placeholderStyleTag = this._findPlaceholderStyleTag();

      if (placeholderStyleTag) {
        head.insertBefore(styleElement, placeholderStyleTag.nextElementSibling);
      } else {
        head.insertBefore(styleElement, head.childNodes[0]);
      }
    }

    this._lastStyleElement = styleElement;
    return styleElement;
  };

  Stylesheet.prototype._findPlaceholderStyleTag = function () {
    var head = document.head;

    if (head) {
      return head.querySelector('style[data-merge-styles]');
    }

    return null;
  };

  return Stylesheet;
}();

/**
 * Separates the classes and style objects. Any classes that are pre-registered
 * args are auto expanded into objects.
 */

function extractStyleParts() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var classes = [];
  var objects = [];
  var stylesheet = Stylesheet.getInstance();

  function _processArgs(argsList) {
    for (var _i = 0, argsList_1 = argsList; _i < argsList_1.length; _i++) {
      var arg = argsList_1[_i];

      if (arg) {
        if (typeof arg === 'string') {
          if (arg.indexOf(' ') >= 0) {
            _processArgs(arg.split(' '));
          } else {
            var translatedArgs = stylesheet.argsFromClassName(arg);

            if (translatedArgs) {
              _processArgs(translatedArgs);
            } else {
              // Avoid adding the same class twice.
              if (classes.indexOf(arg) === -1) {
                classes.push(arg);
              }
            }
          }
        } else if (Array.isArray(arg)) {
          _processArgs(arg);
        } else if (typeof arg === 'object') {
          objects.push(arg);
        }
      }
    }
  }

  _processArgs(args);

  return {
    classes: classes,
    objects: objects
  };
}

/**
 * Sets the current RTL value.
 */
function setRTL(isRTL) {
  if (_rtl !== isRTL) {
    _rtl = isRTL;
  }
}
/**
 * Gets the current RTL value.
 */

function getRTL() {
  if (_rtl === undefined) {
    _rtl = typeof document !== 'undefined' && !!document.documentElement && document.documentElement.getAttribute('dir') === 'rtl';
  }

  return _rtl;
} // This has been split into 2 lines because it was working in Fabric due to the code being transpiled to es5, so this
// was converted to var while not working in Fluent that uses babel to transpile the code to be es6-like. Splitting the
// logic into two lines, however, allows it to work in both scenarios.

var _rtl;

_rtl = getRTL();
function getStyleOptions() {
  return {
    rtl: getRTL()
  };
}

var rules = {};
function kebabRules(rulePairs, index) {
  var rule = rulePairs[index];

  if (rule.charAt(0) !== '-') {
    rulePairs[index] = rules[rule] = rules[rule] || rule.replace(/([A-Z])/g, '-$1').toLowerCase();
  }
}

var _vendorSettings;

function getVendorSettings() {
  if (!_vendorSettings) {
    var doc = typeof document !== 'undefined' ? document : undefined;
    var nav = typeof navigator !== 'undefined' ? navigator : undefined;
    var userAgent = nav ? nav.userAgent.toLowerCase() : undefined;

    if (!doc) {
      _vendorSettings = {
        isWebkit: true,
        isMoz: true,
        isOpera: true,
        isMs: true
      };
    } else {
      _vendorSettings = {
        isWebkit: !!(doc && 'WebkitAppearance' in doc.documentElement.style),
        isMoz: !!(userAgent && userAgent.indexOf('firefox') > -1),
        isOpera: !!(userAgent && userAgent.indexOf('opera') > -1),
        isMs: !!(nav && (/rv:11.0/i.test(nav.userAgent) || /Edge\/\d./i.test(navigator.userAgent)))
      };
    }
  }

  return _vendorSettings;
}

var autoPrefixNames = {
  'user-select': 1
};
function prefixRules(rulePairs, index) {
  var vendorSettings = getVendorSettings();
  var name = rulePairs[index];

  if (autoPrefixNames[name]) {
    var value = rulePairs[index + 1];

    if (autoPrefixNames[name]) {
      if (vendorSettings.isWebkit) {
        rulePairs.push('-webkit-' + name, value);
      }

      if (vendorSettings.isMoz) {
        rulePairs.push('-moz-' + name, value);
      }

      if (vendorSettings.isMs) {
        rulePairs.push('-ms-' + name, value);
      }

      if (vendorSettings.isOpera) {
        rulePairs.push('-o-' + name, value);
      }
    }
  }
}

var NON_PIXEL_NUMBER_PROPS = ['column-count', 'font-weight', 'flex', 'flex-grow', 'flex-shrink', 'fill-opacity', 'opacity', 'order', 'z-index', 'zoom'];
function provideUnits(rulePairs, index) {
  var name = rulePairs[index];
  var value = rulePairs[index + 1];

  if (typeof value === 'number') {
    var isNonPixelProp = NON_PIXEL_NUMBER_PROPS.indexOf(name) > -1;
    var isVariableOrPrefixed = name.indexOf('--') > -1;
    var unit = isNonPixelProp || isVariableOrPrefixed ? '' : 'px';
    rulePairs[index + 1] = "" + value + unit;
  }
}

var _a;

var LEFT = 'left';
var RIGHT = 'right';
var NO_FLIP = '@noflip';
var NAME_REPLACEMENTS = (_a = {}, _a[LEFT] = RIGHT, _a[RIGHT] = LEFT, _a);
var VALUE_REPLACEMENTS = {
  'w-resize': 'e-resize',
  'sw-resize': 'se-resize',
  'nw-resize': 'ne-resize'
};
/**
 * RTLifies the rulePair in the array at the current index. This mutates the array for performance
 * reasons.
 */

function rtlifyRules(options, rulePairs, index) {
  if (options.rtl) {
    var name_1 = rulePairs[index];

    if (!name_1) {
      return;
    }

    var value = rulePairs[index + 1];

    if (typeof value === 'string' && value.indexOf(NO_FLIP) >= 0) {
      rulePairs[index + 1] = value.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g, '');
    } else if (name_1.indexOf(LEFT) >= 0) {
      rulePairs[index] = name_1.replace(LEFT, RIGHT);
    } else if (name_1.indexOf(RIGHT) >= 0) {
      rulePairs[index] = name_1.replace(RIGHT, LEFT);
    } else if (String(value).indexOf(LEFT) >= 0) {
      rulePairs[index + 1] = value.replace(LEFT, RIGHT);
    } else if (String(value).indexOf(RIGHT) >= 0) {
      rulePairs[index + 1] = value.replace(RIGHT, LEFT);
    } else if (NAME_REPLACEMENTS[name_1]) {
      rulePairs[index] = NAME_REPLACEMENTS[name_1];
    } else if (VALUE_REPLACEMENTS[value]) {
      rulePairs[index + 1] = VALUE_REPLACEMENTS[value];
    } else {
      switch (name_1) {
        case 'margin':
        case 'padding':
          rulePairs[index + 1] = flipQuad(value);
          break;

        case 'box-shadow':
          rulePairs[index + 1] = negateNum(value, 0);
          break;
      }
    }
  }
}
/**
 * Given a string value in a space delimited format (e.g. "1 2 3 4"), negates a particular value.
 */

function negateNum(value, partIndex) {
  var parts = value.split(' ');
  var numberVal = parseInt(parts[partIndex], 10);
  parts[0] = parts[0].replace(String(numberVal), String(numberVal * -1));
  return parts.join(' ');
}
/**
 * Given a string quad, flips the left and right values.
 */


function flipQuad(value) {
  if (typeof value === 'string') {
    var parts = value.split(' ');

    if (parts.length === 4) {
      return parts[0] + " " + parts[3] + " " + parts[2] + " " + parts[1];
    }
  }

  return value;
}

var DISPLAY_NAME = 'displayName';

function getDisplayName(rules) {
  var rootStyle = rules && rules['&'];
  return rootStyle ? rootStyle.displayName : undefined;
}

var globalSelectorRegExp = /\:global\((.+?)\)/g;
/**
 * Finds comma separated selectors in a :global() e.g. ":global(.class1, .class2, .class3)"
 * and wraps them each in their own global ":global(.class1), :global(.class2), :global(.class3)"
 *
 * @param selectorWithGlobals The selector to process
 * @returns The updated selector
 */

function expandCommaSeparatedGlobals(selectorWithGlobals) {
  // We the selector does not have a :global() we can shortcut
  if (!globalSelectorRegExp.test(selectorWithGlobals)) {
    return selectorWithGlobals;
  }

  var replacementInfo = [];
  var findGlobal = /\:global\((.+?)\)/g;
  var match = null; // Create a result list for global selectors so we can replace them.

  while (match = findGlobal.exec(selectorWithGlobals)) {
    // Only if the found selector is a comma separated list we'll process it.
    if (match[1].indexOf(',') > -1) {
      replacementInfo.push([match.index, match.index + match[0].length, // Wrap each of the found selectors in :global()
      match[1].split(',').map(function (v) {
        return ":global(" + v.trim() + ")";
      }).join(', ')]);
    }
  } // Replace the found selectors with their wrapped variants in reverse order


  return replacementInfo.reverse().reduce(function (selector, _a) {
    var matchIndex = _a[0],
        matchEndIndex = _a[1],
        replacement = _a[2];
    var prefix = selector.slice(0, matchIndex);
    var suffix = selector.slice(matchEndIndex);
    return prefix + replacement + suffix;
  }, selectorWithGlobals);
}

function expandSelector(newSelector, currentSelector) {
  if (newSelector.indexOf(':global(') >= 0) {
    return newSelector.replace(globalSelectorRegExp, '$1');
  } else if (newSelector.indexOf(':') === 0) {
    return currentSelector + newSelector;
  } else if (newSelector.indexOf('&') < 0) {
    return currentSelector + ' ' + newSelector;
  }

  return newSelector;
}

function extractSelector(currentSelector, rules, selector, value) {
  if (rules === void 0) {
    rules = {
      __order: []
    };
  }

  if (selector.indexOf('@') === 0) {
    selector = selector + '{' + currentSelector;
    extractRules([value], rules, selector);
  } else if (selector.indexOf(',') > -1) {
    expandCommaSeparatedGlobals(selector).split(',').map(function (s) {
      return s.trim();
    }).forEach(function (separatedSelector) {
      return extractRules([value], rules, expandSelector(separatedSelector, currentSelector));
    });
  } else {
    extractRules([value], rules, expandSelector(selector, currentSelector));
  }
}

function extractRules(args, rules, currentSelector) {
  if (rules === void 0) {
    rules = {
      __order: []
    };
  }

  if (currentSelector === void 0) {
    currentSelector = '&';
  }

  var stylesheet = Stylesheet.getInstance();
  var currentRules = rules[currentSelector];

  if (!currentRules) {
    currentRules = {};
    rules[currentSelector] = currentRules;

    rules.__order.push(currentSelector);
  }

  for (var _i = 0, args_1 = args; _i < args_1.length; _i++) {
    var arg = args_1[_i]; // If the arg is a string, we need to look up the class map and merge.

    if (typeof arg === 'string') {
      var expandedRules = stylesheet.argsFromClassName(arg);

      if (expandedRules) {
        extractRules(expandedRules, rules, currentSelector);
      } // Else if the arg is an array, we need to recurse in.

    } else if (Array.isArray(arg)) {
      extractRules(arg, rules, currentSelector);
    } else {
      for (var prop in arg) {
        if (arg.hasOwnProperty(prop)) {
          var propValue = arg[prop];

          if (prop === 'selectors') {
            // every child is a selector.
            var selectors = arg.selectors;

            for (var newSelector in selectors) {
              if (selectors.hasOwnProperty(newSelector)) {
                extractSelector(currentSelector, rules, newSelector, selectors[newSelector]);
              }
            }
          } else if (typeof propValue === 'object') {
            // prop is a selector.
            if (propValue !== null) {
              extractSelector(currentSelector, rules, prop, propValue);
            }
          } else {
            if (propValue !== undefined) {
              // Else, add the rule to the currentSelector.
              if (prop === 'margin' || prop === 'padding') {
                expandQuads(currentRules, prop, propValue);
              } else {
                currentRules[prop] = propValue;
              }
            }
          }
        }
      }
    }
  }

  return rules;
}

function expandQuads(currentRules, name, value) {
  var parts = typeof value === 'string' ? value.split(' ') : [value];
  currentRules[name + 'Top'] = parts[0];
  currentRules[name + 'Right'] = parts[1] || parts[0];
  currentRules[name + 'Bottom'] = parts[2] || parts[0];
  currentRules[name + 'Left'] = parts[3] || parts[1] || parts[0];
}

function getKeyForRules(options, rules) {
  var serialized = [options.rtl ? 'rtl' : 'ltr'];
  var hasProps = false;

  for (var _i = 0, _a = rules.__order; _i < _a.length; _i++) {
    var selector = _a[_i];
    serialized.push(selector);
    var rulesForSelector = rules[selector];

    for (var propName in rulesForSelector) {
      if (rulesForSelector.hasOwnProperty(propName) && rulesForSelector[propName] !== undefined) {
        hasProps = true;
        serialized.push(propName, rulesForSelector[propName]);
      }
    }
  }

  return hasProps ? serialized.join('') : undefined;
}

function repeatString(target, count) {
  if (count <= 0) {
    return '';
  }

  if (count === 1) {
    return target;
  }

  return target + repeatString(target, count - 1);
}

function serializeRuleEntries(options, ruleEntries) {
  if (!ruleEntries) {
    return '';
  }

  var allEntries = [];

  for (var entry in ruleEntries) {
    if (ruleEntries.hasOwnProperty(entry) && entry !== DISPLAY_NAME && ruleEntries[entry] !== undefined) {
      allEntries.push(entry, ruleEntries[entry]);
    }
  } // Apply transforms.


  for (var i = 0; i < allEntries.length; i += 2) {
    kebabRules(allEntries, i);
    provideUnits(allEntries, i);
    rtlifyRules(options, allEntries, i);
    prefixRules(allEntries, i);
  } // Apply punctuation.


  for (var i = 1; i < allEntries.length; i += 4) {
    allEntries.splice(i, 1, ':', allEntries[i], ';');
  }

  return allEntries.join('');
}
function styleToRegistration(options) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  var rules = extractRules(args);
  var key = getKeyForRules(options, rules);

  if (key) {
    var stylesheet = Stylesheet.getInstance();
    var registration = {
      className: stylesheet.classNameFromKey(key),
      key: key,
      args: args
    };

    if (!registration.className) {
      registration.className = stylesheet.getClassName(getDisplayName(rules));
      var rulesToInsert = [];

      for (var _a = 0, _b = rules.__order; _a < _b.length; _a++) {
        var selector = _b[_a];
        rulesToInsert.push(selector, serializeRuleEntries(options, rules[selector]));
      }

      registration.rulesToInsert = rulesToInsert;
    }

    return registration;
  }

  return undefined;
}
/**
 * Insert style to stylesheet.
 * @param registration Style registration.
 * @param specificityMultiplier Number of times classname selector is repeated in the css rule.
 * This is to increase css specificity in case it's needed. Default to 1.
 */

function applyRegistration(registration, specificityMultiplier) {
  if (specificityMultiplier === void 0) {
    specificityMultiplier = 1;
  }

  var stylesheet = Stylesheet.getInstance();
  var className = registration.className,
      key = registration.key,
      args = registration.args,
      rulesToInsert = registration.rulesToInsert;

  if (rulesToInsert) {
    // rulesToInsert is an ordered array of selector/rule pairs.
    for (var i = 0; i < rulesToInsert.length; i += 2) {
      var rules = rulesToInsert[i + 1];

      if (rules) {
        var selector = rulesToInsert[i];
        selector = selector.replace(/&/g, repeatString("." + registration.className, specificityMultiplier)); // Insert. Note if a media query, we must close the query with a final bracket.

        var processedRule = selector + "{" + rules + "}" + (selector.indexOf('@') === 0 ? '}' : '');
        stylesheet.insertRule(processedRule);
      }
    }

    stylesheet.cacheClassName(className, key, args, rulesToInsert);
  }
}
function styleToClassName(options) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  var registration = styleToRegistration.apply(void 0, __spreadArrays([options], args));

  if (registration) {
    applyRegistration(registration, options.specificityMultiplier);
    return registration.className;
  }

  return '';
}

/**
 * Concatenation helper, which can merge class names together. Skips over falsey values.
 *
 * @public
 */

function mergeStyles() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return mergeCss(args, getStyleOptions());
}
/**
 * Concatenation helper, which can merge class names together. Skips over falsey values.
 * Accepts a set of options that will be used when calculating styles.
 *
 * @public
 */

function mergeCss(args, options) {
  var styleArgs = args instanceof Array ? args : [args];

  var _a = extractStyleParts(styleArgs),
      classes = _a.classes,
      objects = _a.objects;

  if (objects.length) {
    classes.push(styleToClassName(options || {}, objects));
  }

  return classes.join(' ');
}

/**
 * Registers a font face.
 * @public
 */

function fontFace(font) {
  Stylesheet.getInstance().insertRule("@font-face{" + serializeRuleEntries(getStyleOptions(), font) + "}", true);
}

/**
 * Registers keyframe definitions.
 *
 * @public
 */

function keyframes(timeline) {
  var stylesheet = Stylesheet.getInstance();
  var name = stylesheet.getClassName();
  var rulesArray = [];

  for (var prop in timeline) {
    if (timeline.hasOwnProperty(prop)) {
      rulesArray.push(prop, '{', serializeRuleEntries(getStyleOptions(), timeline[prop]), '}');
    }
  }

  var rules = rulesArray.join('');
  stylesheet.insertRule("@keyframes " + name + "{" + rules + "}", true);
  stylesheet.cacheClassName(name, rules, [], ['keyframes', rules]);
  return name;
}

var _window = undefined; // Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
// Caching the window value at the file scope lets us minimize the impact.

try {
  _window = window;
} catch (e) {
  /* no-op */
}
/**
 * Helper to get the window object. The helper will make sure to use a cached variable
 * of "window", to avoid overhead and memory leaks in IE11. Note that in popup scenarios the
 * window object won't match the "global" window object, and for these scenarios, you should
 * pass in an element hosted within the popup.
 *
 * @public
 */


function getWindow(rootElement) {
  if ( typeof _window === 'undefined') {
    return undefined;
  } else {
    var el = rootElement;
    return el && el.ownerDocument && el.ownerDocument.defaultView ? el.ownerDocument.defaultView : _window;
  }
}

/**
 * Helper to get the document object. Note that in popup window cases, document
 * might be the wrong document, which is why we look at ownerDocument for the
 * truth. Also note that the SSR flag is used to test ssr scenarios even if
 * document is defined (from JSDOM for example.)
 *
 * @public
 */

function getDocument(rootElement) {
  if ( typeof document === 'undefined') {
    return undefined;
  } else {
    var el = rootElement;
    return el && el.ownerDocument ? el.ownerDocument : document;
  }
}

var DisabledScrollClassName = mergeStyles({
  overflow: 'hidden !important'
});
/**
 * Placing this attribute on scrollable divs optimizes detection to know
 * if the div is scrollable or not (given we can avoid expensive operations
 * like getComputedStyle.)
 *
 * @public
 */

var DATA_IS_SCROLLABLE_ATTRIBUTE = 'data-is-scrollable';
/**
 * Traverses up the DOM for the element with the data-is-scrollable=true attribute, or returns
 * document.body.
 *
 * @public
 */

function findScrollableParent(startingElement) {
  var el = startingElement;
  var doc = getDocument(startingElement); // First do a quick scan for the scrollable attribute.

  while (el && el !== doc.body) {
    if (el.getAttribute(DATA_IS_SCROLLABLE_ATTRIBUTE) === 'true') {
      return el;
    }

    el = el.parentElement;
  } // If we haven't found it, the use the slower method: compute styles to evaluate if overflow is set.


  el = startingElement;

  while (el && el !== doc.body) {
    if (el.getAttribute(DATA_IS_SCROLLABLE_ATTRIBUTE) !== 'false') {
      var computedStyles = getComputedStyle(el);
      var overflowY = computedStyles ? computedStyles.getPropertyValue('overflow-y') : '';

      if (overflowY && (overflowY === 'scroll' || overflowY === 'auto')) {
        return el;
      }
    }

    el = el.parentElement;
  } // Fall back to window scroll.


  if (!el || el === doc.body) {
    el = getWindow(startingElement);
  }

  return el;
}

/* eslint-disable no-console */
/**
 * Sends a warning to console, if the api is present.
 *
 * @public
 * @param message - Warning message.
 */

function warn(message) {
  if (console && console.warn) {
    console.warn(message);
  }
}

/**
 * Warns when a deprecated props are being used.
 *
 * @public
 * @param componentName - The name of the component being used.
 * @param props - The props passed into the component.
 * @param deprecationMap - The map of deprecations, where key is the prop name and the value is
 * either null or a replacement prop name.
 */

function warnDeprecations(componentName, props, deprecationMap) {
  if (process.env.NODE_ENV !== 'production') {
    for (var propName in deprecationMap) {
      if (props && propName in props) {
        var deprecationMessage = componentName + " property '" + propName + "' was used but has been deprecated.";
        var replacementPropName = deprecationMap[propName];

        if (replacementPropName) {
          deprecationMessage += " Use '" + replacementPropName + "' instead.";
        }

        warn(deprecationMessage);
      }
    }
  }
}

/**
 * Storing global state in local module variables has issues when more than one copy
 * if the module gets loaded on the page (due to a bundling error or simply by consuming
 * a prebundled script.)
 *
 * This file contains helpers to deal with the getting and setting local state, and allows
 * callers to get called back when it mutates.
 */

var GLOBAL_SETTINGS_PROP_NAME = '__globalSettings__';
var CALLBACK_STATE_PROP_NAME = '__callbacks__';
var _counter = 0;
/**
 * Global settings helper, which stores settings in the global (window) namespace.
 * If window is not provided, it will store settings in module scope. Provides a
 * way to observe changes as well when their values change.
 *
 * @public
 * {@docCategory GlobalSettings}
 */

var GlobalSettings =
/** @class */
function () {
  function GlobalSettings() {}

  GlobalSettings.getValue = function (key, defaultValue) {
    var globalSettings = _getGlobalSettings();

    if (globalSettings[key] === undefined) {
      globalSettings[key] = typeof defaultValue === 'function' ? defaultValue() : defaultValue;
    }

    return globalSettings[key];
  };

  GlobalSettings.setValue = function (key, value) {
    var globalSettings = _getGlobalSettings();

    var callbacks = globalSettings[CALLBACK_STATE_PROP_NAME];
    var oldValue = globalSettings[key];

    if (value !== oldValue) {
      globalSettings[key] = value;
      var changeDescription = {
        oldValue: oldValue,
        value: value,
        key: key
      };

      for (var id in callbacks) {
        if (callbacks.hasOwnProperty(id)) {
          callbacks[id](changeDescription);
        }
      }
    }

    return value;
  };

  GlobalSettings.addChangeListener = function (cb) {
    // Note: we use generated ids on the callbacks to create a map of the callbacks, which optimizes removal.
    // (It's faster to delete a key than it is to look up the index of an object and splice an array.)
    var id = cb.__id__;

    var callbacks = _getCallbacks();

    if (!id) {
      id = cb.__id__ = String(_counter++);
    }

    callbacks[id] = cb;
  };

  GlobalSettings.removeChangeListener = function (cb) {
    var callbacks = _getCallbacks();

    delete callbacks[cb.__id__];
  };

  return GlobalSettings;
}();

function _getGlobalSettings() {
  var _a;

  var win = getWindow(); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var globalObj = win || {};

  if (!globalObj[GLOBAL_SETTINGS_PROP_NAME]) {
    globalObj[GLOBAL_SETTINGS_PROP_NAME] = (_a = {}, _a[CALLBACK_STATE_PROP_NAME] = {}, _a);
  }

  return globalObj[GLOBAL_SETTINGS_PROP_NAME];
}

function _getCallbacks() {
  var globalSettings = _getGlobalSettings();

  return globalSettings[CALLBACK_STATE_PROP_NAME];
}

/**
 * Simulated enum for keycodes. These will get inlined by uglify when used much like an enum
 *
 * @public
 * {@docCategory KeyCodes}
 */
var KeyCodes = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  ctrl: 17,
  alt: 18,
  pauseBreak: 19,
  capslock: 20,
  escape: 27,
  space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  insert: 45,
  del: 46,
  zero: 48,
  one: 49,
  two: 50,
  three: 51,
  four: 52,
  five: 53,
  six: 54,
  seven: 55,
  eight: 56,
  nine: 57,
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  leftWindow: 91,
  rightWindow: 92,
  select: 93,

  /* eslint-disable @typescript-eslint/naming-convention */
  zero_numpad: 96,
  one_numpad: 97,
  two_numpad: 98,
  three_numpad: 99,
  four_numpad: 100,
  five_numpad: 101,
  six_numpad: 102,
  seven_numpad: 103,
  eight_numpad: 104,
  nine_numpad: 105,

  /* eslint-enable @typescript-eslint/naming-convention */
  multiply: 106,
  add: 107,
  subtract: 109,
  decimalPoint: 110,
  divide: 111,
  f1: 112,
  f2: 113,
  f3: 114,
  f4: 115,
  f5: 116,
  f6: 117,
  f7: 118,
  f8: 119,
  f9: 120,
  f10: 121,
  f11: 122,
  f12: 123,
  numlock: 144,
  scrollLock: 145,
  semicolon: 186,
  equalSign: 187,
  comma: 188,
  dash: 189,
  period: 190,
  forwardSlash: 191,
  graveAccent: 192,
  openBracket: 219,
  backSlash: 220,
  closeBracket: 221,
  singleQuote: 222
};

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Returns a single function which will call each of the given functions in the context of the
 * parent.
 */
function appendFunction(parent) {
  var functions = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    functions[_i - 1] = arguments[_i];
  }

  if (functions.length < 2) {
    return functions[0];
  }

  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    functions.forEach(function (f) {
      return f && f.apply(parent, args);
    });
  };
}

/**
 * Helper to find the index of an item within an array, using a callback to
 * determine the match.
 *
 * @public
 * @param array - Array to search.
 * @param cb - Callback which returns true on matches.
 * @param fromIndex - Optional index to start from (defaults to 0)
 */
/**
 * Returns a boolean indicating if the two given arrays are equal in length and values.
 *
 * @param array1 - First array to compare
 * @param array2 - Second array to compare
 * @returns True if the arrays are the same length and have the same values in the same positions, false otherwise.
 */

function arraysEqual(array1, array2) {
  if (array1.length !== array2.length) {
    return false;
  }

  for (var i = 0; i < array1.length; i++) {
    if (array1[i] !== array2[i]) {
      return false;
    }
  }

  return true;
}

/**
 * Fetches an item from session storage without throwing an exception
 * @param key The key of the item to fetch from session storage
 */

function getItem(key) {
  var result = null;

  try {
    var win = getWindow();
    result = win ? win.sessionStorage.getItem(key) : null;
  } catch (e) {
    /* Eat the exception */
  }

  return result;
}
/**
 * Inserts an item into session storage without throwing an exception
 * @param key The key of the item to add to session storage
 * @param data The data to put into session storage
 */

function setItem(key, data) {
  var _a;

  try {
    (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem(key, data);
  } catch (e) {
    /* Eat the exception */
  }
}

var RTL_LOCAL_STORAGE_KEY = 'isRTL'; // Default to undefined so that we initialize on first read.

var _isRTL;
/**
 * Gets the rtl state of the page (returns true if in rtl.)
 */


function getRTL$1(theme) {
  if (theme === void 0) {
    theme = {};
  }

  if (theme.rtl !== undefined) {
    return theme.rtl;
  }

  if (_isRTL === undefined) {
    // Fabric supports persisting the RTL setting between page refreshes via session storage
    var savedRTL = getItem(RTL_LOCAL_STORAGE_KEY);

    if (savedRTL !== null) {
      _isRTL = savedRTL === '1';
      setRTL$1(_isRTL);
    }

    var doc = getDocument();

    if (_isRTL === undefined && doc) {
      _isRTL = (doc.body && doc.body.getAttribute('dir') || doc.documentElement.getAttribute('dir')) === 'rtl';
      setRTL(_isRTL);
    }
  }

  return !!_isRTL;
}
/**
 * Sets the rtl state of the page (by adjusting the dir attribute of the html element.)
 */

function setRTL$1(isRTL, persistSetting) {
  if (persistSetting === void 0) {
    persistSetting = false;
  }

  var doc = getDocument();

  if (doc) {
    doc.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
  }

  if (persistSetting) {
    setItem(RTL_LOCAL_STORAGE_KEY, isRTL ? '1' : '0');
  }

  _isRTL = isRTL;
  setRTL(_isRTL);
}

/**
 * Determines whether or not an element has the virtual hierarchy extension.
 *
 * @public
 */
function isVirtualElement(element) {
  return element && !!element._virtual;
}

/**
 * Gets the virtual parent given the child element, if it exists.
 *
 * @public
 */

function getVirtualParent(child) {
  var parent;

  if (child && isVirtualElement(child)) {
    parent = child._virtual.parent;
  }

  return parent;
}

/**
 * Gets the element which is the parent of a given element.
 * If `allowVirtuaParents` is `true`, this method prefers the virtual parent over
 * real DOM parent when present.
 *
 * @public
 */

function getParent(child, allowVirtualParents) {
  if (allowVirtualParents === void 0) {
    allowVirtualParents = true;
  }

  return child && (allowVirtualParents && getVirtualParent(child) || child.parentNode && child.parentNode);
}

/**
 * Determines whether or not a parent element contains a given child element.
 * If `allowVirtualParents` is true, this method may return `true` if the child
 * has the parent in its virtual element hierarchy.
 *
 * @public
 */

function elementContains(parent, child, allowVirtualParents) {
  if (allowVirtualParents === void 0) {
    allowVirtualParents = true;
  }

  var isContained = false;

  if (parent && child) {
    if (allowVirtualParents) {
      if (parent === child) {
        isContained = true;
      } else {
        isContained = false;

        while (child) {
          var nextParent = getParent(child);

          if (nextParent === parent) {
            isContained = true;
            break;
          }

          child = nextParent;
        }
      }
    } else if (parent.contains) {
      isContained = parent.contains(child);
    }
  }

  return isContained;
}

/**
 * Finds the first parent element where the matchFunction returns true
 * @param element - element to start searching at
 * @param matchFunction - the function that determines if the element is a match
 * @returns the matched element or null no match was found
 */

function findElementRecursive(element, matchFunction) {
  if (!element || element === document.body) {
    return null;
  }

  return matchFunction(element) ? element : findElementRecursive(getParent(element), matchFunction);
}

/**
 * Determines if an element, or any of its ancestors, contain the given attribute
 * @param element - element to start searching at
 * @param attribute - the attribute to search for
 * @returns the value of the first instance found
 */

function elementContainsAttribute(element, attribute) {
  var elementMatch = findElementRecursive(element, function (testElement) {
    return testElement.hasAttribute(attribute);
  });
  return elementMatch && elementMatch.getAttribute(attribute);
}

var DATA_PORTAL_ATTRIBUTE = 'data-portal-element';

/**
 * Determine whether a target is within a portal from perspective of root or optional parent.
 * This function only works against portal components that use the setPortalAttribute function.
 * If both parent and child are within the same portal this function will return false.
 * @param target - Element to query portal containment status of.
 * @param parent - Optional parent perspective. Search for containing portal stops at parent
 * (or root if parent is undefined or invalid.)
 */

function portalContainsElement(target, parent) {
  var elementMatch = findElementRecursive(target, function (testElement) {
    return parent === testElement || testElement.hasAttribute(DATA_PORTAL_ATTRIBUTE);
  });
  return elementMatch !== null && elementMatch.hasAttribute(DATA_PORTAL_ATTRIBUTE);
}

/** Raises a click event. */
function raiseClick(target) {
  var event = createNewEvent('MouseEvents');
  event.initEvent('click', true, true);
  target.dispatchEvent(event);
}

function createNewEvent(eventName) {
  var event;

  if (typeof Event === 'function') {
    // Chrome, Opera, Firefox
    event = new Event(eventName);
  } else {
    // IE
    event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
  }

  return event;
}

/**
 * Concatination helper, which can merge class names together. Skips over falsey values.
 *
 * @public
 */
function css() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var classes = [];

  for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
    var arg = args_1[_a];

    if (arg) {
      if (typeof arg === 'string') {
        classes.push(arg);
      } else if (arg.hasOwnProperty('toString') && typeof arg.toString === 'function') {
        classes.push(arg.toString());
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        for (var key in arg) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          if (arg[key]) {
            classes.push(key);
          }
        }
      }
    }
  }

  return classes.join(' ');
}

var CustomizationsGlobalKey = 'customizations';
var NO_CUSTOMIZATIONS = {
  settings: {},
  scopedSettings: {},
  inCustomizerContext: false
};

var _allSettings = GlobalSettings.getValue(CustomizationsGlobalKey, {
  settings: {},
  scopedSettings: {},
  inCustomizerContext: false
});

var _events = [];

var Customizations =
/** @class */
function () {
  function Customizations() {}

  Customizations.reset = function () {
    _allSettings.settings = {};
    _allSettings.scopedSettings = {};
  };
  /** Apply global Customization settings.
   * @example Customizations.applySettings(\{ theme: \{...\} \});
   */


  Customizations.applySettings = function (settings) {
    _allSettings.settings = __assign(__assign({}, _allSettings.settings), settings);

    Customizations._raiseChange();
  };
  /** Apply Customizations to a particular named scope, like a component.
   * @example Customizations.applyScopedSettings('Nav', \{ styles: () =\> \{\} \});
   */


  Customizations.applyScopedSettings = function (scopeName, settings) {
    _allSettings.scopedSettings[scopeName] = __assign(__assign({}, _allSettings.scopedSettings[scopeName]), settings);

    Customizations._raiseChange();
  };

  Customizations.getSettings = function (properties, scopeName, localSettings) {
    if (localSettings === void 0) {
      localSettings = NO_CUSTOMIZATIONS;
    }

    var settings = {};
    var localScopedSettings = scopeName && localSettings.scopedSettings[scopeName] || {};
    var globalScopedSettings = scopeName && _allSettings.scopedSettings[scopeName] || {};

    for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
      var property = properties_1[_i];
      settings[property] = localScopedSettings[property] || localSettings.settings[property] || globalScopedSettings[property] || _allSettings.settings[property];
    }

    return settings;
  };
  /** Used to run some code that sets Customizations without triggering an update until the end.
   * Useful for applying Customizations that don't affect anything currently rendered, or for
   * applying many customizations at once.
   * @param suppressUpdate - Do not raise the change event at the end, preventing all updates
   */


  Customizations.applyBatchedUpdates = function (code, suppressUpdate) {
    Customizations._suppressUpdates = true;

    try {
      code();
    } catch (_a) {
      /* do nothing */
    }

    Customizations._suppressUpdates = false;

    if (!suppressUpdate) {
      Customizations._raiseChange();
    }
  };

  Customizations.observe = function (onChange) {
    _events.push(onChange);
  };

  Customizations.unobserve = function (onChange) {
    _events = _events.filter(function (cb) {
      return cb !== onChange;
    });
  };

  Customizations._raiseChange = function () {
    if (!Customizations._suppressUpdates) {
      _events.forEach(function (cb) {
        return cb();
      });
    }
  };

  return Customizations;
}();

/**
 * Extends a component's lifetime methods by appending new functions to the existing lifetime functions.
 */

function extendComponent(parent, methods) {
  for (var name_1 in methods) {
    if (methods.hasOwnProperty(name_1)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parent[name_1] = appendFunction(parent, parent[name_1], methods[name_1]);
    }
  }
}

var IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';
var IS_VISIBLE_ATTRIBUTE = 'data-is-visible';
var FOCUSZONE_ID_ATTRIBUTE = 'data-focuszone-id';
var FOCUSZONE_SUB_ATTRIBUTE = 'data-is-sub-focuszone';
/**
 * Traverse to find the previous element.
 * If tabbable is true, the element must have tabIndex != -1.
 *
 * @public
 */

function getPreviousElement(rootElement, currentElement, checkNode, suppressParentTraversal, traverseChildren, includeElementsInFocusZones, allowFocusRoot, tabbable) {
  if (!currentElement || !allowFocusRoot && currentElement === rootElement) {
    return null;
  }

  var isCurrentElementVisible = isElementVisible(currentElement); // Check its children.

  if (traverseChildren && isCurrentElementVisible && (includeElementsInFocusZones || !(isElementFocusZone(currentElement) || isElementFocusSubZone(currentElement)))) {
    var childMatch = getPreviousElement(rootElement, currentElement.lastElementChild, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);

    if (childMatch) {
      if (tabbable && isElementTabbable(childMatch, true) || !tabbable) {
        return childMatch;
      }

      var childMatchSiblingMatch = getPreviousElement(rootElement, childMatch.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);

      if (childMatchSiblingMatch) {
        return childMatchSiblingMatch;
      }

      var childMatchParent = childMatch.parentElement; // At this point if we have not found any potential matches
      // start looking at the rest of the subtree under the currentParent.
      // NOTE: We do not want to recurse here because doing so could
      // cause elements to get skipped.

      while (childMatchParent && childMatchParent !== currentElement) {
        var childMatchParentMatch = getPreviousElement(rootElement, childMatchParent.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);

        if (childMatchParentMatch) {
          return childMatchParentMatch;
        }

        childMatchParent = childMatchParent.parentElement;
      }
    }
  } // Check the current node, if it's not the first traversal.


  if (checkNode && isCurrentElementVisible && isElementTabbable(currentElement, tabbable)) {
    return currentElement;
  } // Check its previous sibling.


  var siblingMatch = getPreviousElement(rootElement, currentElement.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);

  if (siblingMatch) {
    return siblingMatch;
  } // Check its parent.


  if (!suppressParentTraversal) {
    return getPreviousElement(rootElement, currentElement.parentElement, true, false, false, includeElementsInFocusZones, allowFocusRoot, tabbable);
  }

  return null;
}
/**
 * Traverse to find the next focusable element.
 * If tabbable is true, the element must have tabIndex != -1.
 *
 * @public
 * @param checkNode - Include currentElement in search when true.
 */

function getNextElement(rootElement, currentElement, checkNode, suppressParentTraversal, suppressChildTraversal, includeElementsInFocusZones, allowFocusRoot, tabbable) {
  if (!currentElement || currentElement === rootElement && suppressChildTraversal && !allowFocusRoot) {
    return null;
  }

  var isCurrentElementVisible = isElementVisible(currentElement); // Check the current node, if it's not the first traversal.

  if (checkNode && isCurrentElementVisible && isElementTabbable(currentElement, tabbable)) {
    return currentElement;
  } // Check its children.


  if (!suppressChildTraversal && isCurrentElementVisible && (includeElementsInFocusZones || !(isElementFocusZone(currentElement) || isElementFocusSubZone(currentElement)))) {
    var childMatch = getNextElement(rootElement, currentElement.firstElementChild, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable);

    if (childMatch) {
      return childMatch;
    }
  }

  if (currentElement === rootElement) {
    return null;
  } // Check its sibling.


  var siblingMatch = getNextElement(rootElement, currentElement.nextElementSibling, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable);

  if (siblingMatch) {
    return siblingMatch;
  }

  if (!suppressParentTraversal) {
    return getNextElement(rootElement, currentElement.parentElement, false, false, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
  }

  return null;
}
/**
 * Determines if an element is visible.
 *
 * @public
 */

function isElementVisible(element) {
  // If the element is not valid, return false.
  if (!element || !element.getAttribute) {
    return false;
  }

  var visibilityAttribute = element.getAttribute(IS_VISIBLE_ATTRIBUTE); // If the element is explicitly marked with the visibility attribute, return that value as boolean.

  if (visibilityAttribute !== null && visibilityAttribute !== undefined) {
    return visibilityAttribute === 'true';
  } // Fallback to other methods of determining actual visibility.


  return element.offsetHeight !== 0 || element.offsetParent !== null || // eslint-disable-next-line @typescript-eslint/no-explicit-any
  element.isVisible === true; // used as a workaround for testing.
}
/**
 * Determines if an element can receive focus programmatically or via a mouse click.
 * If checkTabIndex is true, additionally checks to ensure the element can be focused with the tab key,
 * meaning tabIndex != -1.
 *
 * @public
 */

function isElementTabbable(element, checkTabIndex) {
  // If this element is null or is disabled, it is not considered tabbable.
  if (!element || element.disabled) {
    return false;
  }

  var tabIndex = 0;
  var tabIndexAttributeValue = null;

  if (element && element.getAttribute) {
    tabIndexAttributeValue = element.getAttribute('tabIndex');

    if (tabIndexAttributeValue) {
      tabIndex = parseInt(tabIndexAttributeValue, 10);
    }
  }

  var isFocusableAttribute = element.getAttribute ? element.getAttribute(IS_FOCUSABLE_ATTRIBUTE) : null;
  var isTabIndexSet = tabIndexAttributeValue !== null && tabIndex >= 0;
  var result = !!element && isFocusableAttribute !== 'false' && (element.tagName === 'A' || element.tagName === 'BUTTON' || element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.tagName === 'SELECT' || isFocusableAttribute === 'true' || isTabIndexSet);
  return checkTabIndex ? tabIndex !== -1 && result : result;
}
/**
 * Determines if a given element is a focus zone.
 *
 * @public
 */

function isElementFocusZone(element) {
  return !!(element && element.getAttribute && !!element.getAttribute(FOCUSZONE_ID_ATTRIBUTE));
}
/**
 * Determines if a given element is a focus sub zone.
 *
 * @public
 */

function isElementFocusSubZone(element) {
  return !!(element && element.getAttribute && element.getAttribute(FOCUSZONE_SUB_ATTRIBUTE) === 'true');
}
/**
 * Determines if an, or any of its ancestors, sepcificies that it doesn't want focus to wrap
 * @param element - element to start searching from
 * @param noWrapDataAttribute - the no wrap data attribute to match (either)
 * @returns true if focus should wrap, false otherwise
 */

function shouldWrapFocus(element, noWrapDataAttribute) {
  return elementContainsAttribute(element, noWrapDataAttribute) === 'true' ? false : true;
}
/**
 * Finds the closest focusable element via an index path from a parent. See
 * `getElementIndexPath` for getting an index path from an element to a child.
 */

function getFocusableByIndexPath(parent, path) {
  var element = parent;

  for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
    var index = path_1[_i];
    var nextChild = element.children[Math.min(index, element.children.length - 1)];

    if (!nextChild) {
      break;
    }

    element = nextChild;
  }

  element = isElementTabbable(element) && isElementVisible(element) ? element : getNextElement(parent, element, true) || getPreviousElement(parent, element);
  return element;
}
/**
 * Finds the element index path from a parent element to a child element.
 *
 * If you had this node structure: "A has children [B, C] and C has child D",
 * the index path from A to D would be [1, 0], or `parent.chidren[1].children[0]`.
 */

function getElementIndexPath(fromElement, toElement) {
  var path = [];

  while (toElement && fromElement && toElement !== fromElement) {
    var parent_1 = getParent(toElement, true);

    if (parent_1 === null) {
      return [];
    }

    path.unshift(Array.prototype.indexOf.call(parent_1.children, toElement));
    toElement = parent_1;
  }

  return path;
}

var CURRENT_ID_PROPERTY = '__currentId__';
var DEFAULT_ID_STRING = 'id__'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var _global$1 = getWindow() || {};

if (_global$1[CURRENT_ID_PROPERTY] === undefined) {
  _global$1[CURRENT_ID_PROPERTY] = 0;
}

var _initializedStylesheetResets = false;
/**
 * Generates a unique id in the global scope (this spans across duplicate copies of the same library.)
 *
 * @public
 */

function getId(prefix) {
  if (!_initializedStylesheetResets) {
    // Configure ids to reset on stylesheet resets.
    var stylesheet = Stylesheet.getInstance();

    if (stylesheet && stylesheet.onReset) {
      stylesheet.onReset(resetIds);
    }

    _initializedStylesheetResets = true;
  }

  var index = _global$1[CURRENT_ID_PROPERTY]++;
  return (prefix === undefined ? DEFAULT_ID_STRING : prefix) + index;
}
/**
 * Resets id counter to an (optional) number.
 *
 * @public
 */

function resetIds(counter) {
  if (counter === void 0) {
    counter = 0;
  }

  _global$1[CURRENT_ID_PROPERTY] = counter;
}

var toObjectMap = function () {
  var items = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    items[_i] = arguments[_i];
  }

  var result = {};

  for (var _a = 0, items_1 = items; _a < items_1.length; _a++) {
    var item = items_1[_a];
    var keys = Array.isArray(item) ? item : Object.keys(item);

    for (var _b = 0, keys_1 = keys; _b < keys_1.length; _b++) {
      var key = keys_1[_b];
      result[key] = 1;
    }
  }

  return result;
};
/**
 * An array of events that are allowed on every html element type.
 *
 * @public
 */


var baseElementEvents = toObjectMap(['onCopy', 'onCut', 'onPaste', 'onCompositionEnd', 'onCompositionStart', 'onCompositionUpdate', 'onFocus', 'onFocusCapture', 'onBlur', 'onBlurCapture', 'onChange', 'onInput', 'onSubmit', 'onLoad', 'onError', 'onKeyDown', 'onKeyDownCapture', 'onKeyPress', 'onKeyUp', 'onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting', 'onClick', 'onClickCapture', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseDownCapture', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onMouseUpCapture', 'onSelect', 'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'onScroll', 'onWheel', 'onPointerCancel', 'onPointerDown', 'onPointerEnter', 'onPointerLeave', 'onPointerMove', 'onPointerOut', 'onPointerOver', 'onPointerUp', 'onGotPointerCapture', 'onLostPointerCapture']);
/**
 * An array of element attributes which are allowed on every html element type.
 *
 * @public
 */

var baseElementProperties = toObjectMap(['accessKey', 'children', 'className', 'contentEditable', 'dir', 'draggable', 'hidden', 'htmlFor', 'id', 'lang', 'ref', 'role', 'style', 'tabIndex', 'title', 'translate', 'spellCheck', 'name']);
/**
 * An array of HTML element properties and events.
 *
 * @public
 */

var htmlElementProperties = toObjectMap(baseElementProperties, baseElementEvents);
/**
 * An array of LABEL tag properties and events.
 *
 * @public
 */

var labelProperties = toObjectMap(htmlElementProperties, ['form']);
/**
 * An array of AUDIO tag properties and events.

 * @public
 */

var audioProperties = toObjectMap(htmlElementProperties, ['height', 'loop', 'muted', 'preload', 'src', 'width']);
/**
 * An array of VIDEO tag properties and events.
 *
 * @public
 */

var videoProperties = toObjectMap(audioProperties, ['poster']);
/**
 * An array of OL tag properties and events.
 *
 * @public
 */

var olProperties = toObjectMap(htmlElementProperties, ['start']);
/**
 * An array of LI tag properties and events.
 *
 * @public
 */

var liProperties = toObjectMap(htmlElementProperties, ['value']);
/**
 * An array of A tag properties and events.
 *
 * @public
 */

var anchorProperties = toObjectMap(htmlElementProperties, ['download', 'href', 'hrefLang', 'media', 'rel', 'target', 'type']);
/**
 * An array of BUTTON tag properties and events.
 *
 * @public
 */

var buttonProperties = toObjectMap(htmlElementProperties, ['autoFocus', 'disabled', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'type', 'value']);
/**
 * An array of INPUT tag properties and events.
 *
 * @public
 */

var inputProperties = toObjectMap(buttonProperties, ['accept', 'alt', 'autoCapitalize', 'autoComplete', 'checked', 'dirname', 'form', 'height', 'inputMode', 'list', 'max', 'maxLength', 'min', 'multiple', 'pattern', 'placeholder', 'readOnly', 'required', 'src', 'step', 'size', 'type', 'value', 'width']);
/**
 * An array of TEXTAREA tag properties and events.
 *
 * @public
 */

var textAreaProperties = toObjectMap(buttonProperties, ['autoCapitalize', 'cols', 'dirname', 'form', 'maxLength', 'placeholder', 'readOnly', 'required', 'rows', 'wrap']);
/**
 * An array of SELECT tag properties and events.
 *
 * @public
 */

var selectProperties = toObjectMap(buttonProperties, ['form', 'multiple', 'required']);
var optionProperties = toObjectMap(htmlElementProperties, ['selected', 'value']);
/**
 * An array of TABLE tag properties and events.
 *
 * @public
 */

var tableProperties = toObjectMap(htmlElementProperties, ['cellPadding', 'cellSpacing']);
/**
 * An array of TH tag properties and events.
 *
 * @public
 */

var thProperties = toObjectMap(htmlElementProperties, ['rowSpan', 'scope']);
/**
 * An array of TD tag properties and events.
 *
 * @public
 */

var tdProperties = toObjectMap(htmlElementProperties, ['colSpan', 'headers', 'rowSpan', 'scope']);
var colGroupProperties = toObjectMap(htmlElementProperties, ['span']);
var colProperties = toObjectMap(htmlElementProperties, ['span']);
/**
 * An array of FORM tag properties and events.
 *
 * @public
 */

var formProperties = toObjectMap(htmlElementProperties, ['acceptCharset', 'action', 'encType', 'encType', 'method', 'noValidate', 'target']);
/**
 * An array of IFRAME tag properties and events.
 *
 * @public
 */

var iframeProperties = toObjectMap(htmlElementProperties, ['allow', 'allowFullScreen', 'allowPaymentRequest', 'allowTransparency', 'csp', 'height', 'importance', 'referrerPolicy', 'sandbox', 'src', 'srcDoc', 'width']);
/**
 * An array of IMAGE tag properties and events.
 *
 * @public
 */

var imgProperties = toObjectMap(htmlElementProperties, ['alt', 'crossOrigin', 'height', 'src', 'srcSet', 'useMap', 'width']);
/**
 * Gets native supported props for an html element provided the allowance set. Use one of the property
 * sets defined (divProperties, buttonPropertes, etc) to filter out supported properties from a given
 * props set. Note that all data- and aria- prefixed attributes will be allowed.
 * NOTE: getNativeProps should always be applied first when adding props to a react component. The
 * non-native props should be applied second. This will prevent getNativeProps from overriding your custom props.
 * For example, if props passed to getNativeProps has an onClick function and getNativeProps is added to
 * the component after an onClick function is added, then the getNativeProps onClick will override it.
 *
 * @public
 * @param props - The unfiltered input props
 * @param allowedPropsNames - The array or record of allowed prop names.
 * @returns The filtered props
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

function getNativeProps( // eslint-disable-next-line @typescript-eslint/no-explicit-any
props, allowedPropNames, excludedPropNames) {
  // It'd be great to properly type this while allowing 'aria-` and 'data-' attributes like TypeScript does for
  // JSX attributes, but that ability is hardcoded into the TS compiler with no analog in TypeScript typings.
  // Then we'd be able to enforce props extends native props (including aria- and data- attributes), and then
  // return native props.
  // We should be able to do this once this PR is merged: https://github.com/microsoft/TypeScript/pull/26797
  var _a;

  var isArray = Array.isArray(allowedPropNames); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var result = {};
  var keys = Object.keys(props);

  for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
    var key = keys_2[_i];
    var isNativeProp = !isArray && allowedPropNames[key] || isArray && allowedPropNames.indexOf(key) >= 0 || key.indexOf('data-') === 0 || key.indexOf('aria-') === 0;

    if (isNativeProp && (!excludedPropNames || ((_a = excludedPropNames) === null || _a === void 0 ? void 0 : _a.indexOf(key)) === -1)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      result[key] = props[key];
    }
  }

  return result;
}

/**
 * Helper to manage componentRef resolution. Internally appends logic to
 * lifetime methods to resolve componentRef to the passed in object.
 *
 * Usage: call initializeComponentRef(this) in the constructor,
 */

function initializeComponentRef(obj) {
  extendComponent(obj, {
    componentDidMount: _onMount,
    componentDidUpdate: _onUpdate,
    componentWillUnmount: _onUnmount
  });
}

function _onMount() {
  _setComponentRef(this.props.componentRef, this);
}

function _onUpdate(prevProps) {
  if (prevProps.componentRef !== this.props.componentRef) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _setComponentRef(prevProps.componentRef, null);

    _setComponentRef(this.props.componentRef, this);
  }
}

function _onUnmount() {
  _setComponentRef(this.props.componentRef, null);
}

function _setComponentRef(componentRef, value) {
  if (componentRef) {
    if (typeof componentRef === 'object') {
      componentRef.current = value;
    } else if (typeof componentRef === 'function') {
      componentRef(value);
    }
  }
}

/**
 * Fetches an item from local storage without throwing an exception
 * @param key The key of the item to fetch from local storage
 */

function getItem$1(key) {
  var result = null;

  try {
    var win = getWindow();
    result = win ? win.localStorage.getItem(key) : null;
  } catch (e) {
    /* Eat the exception */
  }

  return result;
}

var _language;

var STORAGE_KEY = 'language';
/**
 * Gets the language set for the page.
 * @param persistenceType - Where to persist the value. Default is `localStorage` if available.
 * (In version 8, the default will be `sessionStorage`.)
 */

function getLanguage(persistenceType) {
  if (persistenceType === void 0) {
    persistenceType = 'localStorage';
  }

  if (_language === undefined) {
    var doc = getDocument();
    var savedLanguage = persistenceType === 'localStorage' ? getItem$1(STORAGE_KEY) : persistenceType === 'sessionStorage' ? getItem(STORAGE_KEY) : undefined;

    if (savedLanguage) {
      _language = savedLanguage;
    }

    if (_language === undefined && doc) {
      _language = doc.documentElement.getAttribute('lang');
    }

    if (_language === undefined) {
      _language = 'en';
    }
  }

  return _language;
}

/**
 * Simple deep merge function. Takes all arguments and returns a deep copy of the objects merged
 * together in the order provided. If an object creates a circular reference, it will assign the
 * original reference.
 */
function merge(target) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
    var arg = args_1[_a];

    _merge(target || {}, arg);
  }

  return target;
}
/**
 * The _merge helper iterates through all props on source and assigns them to target.
 * When the value is an object, we will create a deep clone of the object. However if
 * there is a circular reference, the value will not be deep cloned and will persist
 * the reference.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

function _merge(target, source, circularReferences) {
  if (circularReferences === void 0) {
    circularReferences = [];
  }

  circularReferences.push(source);

  for (var name_1 in source) {
    if (source.hasOwnProperty(name_1)) {
      if (name_1 !== '__proto__' && name_1 !== 'constructor' && name_1 !== 'prototype') {
        var value = source[name_1];

        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
          var isCircularReference = circularReferences.indexOf(value) > -1;
          target[name_1] = isCircularReference ? value : _merge(target[name_1] || {}, value, circularReferences);
        } else {
          target[name_1] = value;
        }
      }
    }
  }

  circularReferences.pop();
  return target;
}

/**
 * Set up a ref resolver function given internal state managed for the ref.
 * @param local Set
 */

var createResolver = function (local) {
  return function (newValue) {
    for (var _i = 0, _a = local.refs; _i < _a.length; _i++) {
      var ref = _a[_i];

      if (typeof ref === 'function') {
        ref(newValue);
      } else if (ref) {
        // work around the immutability of the React.Ref type
        ref.current = newValue;
      }
    }
  };
};
/**
 * Helper to merge refs from within class components.
 */


var createMergedRef = function (value) {
  var local = {
    refs: []
  };
  return function () {
    var newRefs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      newRefs[_i] = arguments[_i];
    }

    if (!local.resolver || !arraysEqual(local.refs, newRefs)) {
      local.resolver = createResolver(local);
    }

    local.refs = newRefs;
    return local.resolver;
  };
};

var ICON_SETTING_NAME = 'icons';

var _iconSettings = GlobalSettings.getValue(ICON_SETTING_NAME, {
  __options: {
    disableWarnings: false,
    warnOnMissingIcons: true
  },
  __remapped: {}
}); // Reset icon registration on stylesheet resets.


var stylesheet = Stylesheet.getInstance();

if (stylesheet && stylesheet.onReset) {
  stylesheet.onReset(function () {
    for (var name_1 in _iconSettings) {
      if (_iconSettings.hasOwnProperty(name_1) && !!_iconSettings[name_1].subset) {
        _iconSettings[name_1].subset.className = undefined;
      }
    }
  });
}
/**
 * Normalizes an icon name for consistent mapping.
 * Current implementation is to convert the icon name to lower case.
 *
 * @param name - Icon name to normalize.
 * @returns {string} Normalized icon name to use for indexing and mapping.
 */


var normalizeIconName = function (name) {
  return name.toLowerCase();
};
/**
 * Registers a given subset of icons.
 *
 * @param iconSubset - the icon subset definition.
 */


function registerIcons(iconSubset, options) {
  var subset = __assign(__assign({}, iconSubset), {
    isRegistered: false,
    className: undefined
  });

  var icons = iconSubset.icons; // Grab options, optionally mix user provided ones on top.

  options = options ? __assign(__assign({}, _iconSettings.__options), options) : _iconSettings.__options;

  for (var iconName in icons) {
    if (icons.hasOwnProperty(iconName)) {
      var code = icons[iconName];
      var normalizedIconName = normalizeIconName(iconName);

      if (_iconSettings[normalizedIconName]) {
        _warnDuplicateIcon(iconName);
      } else {
        _iconSettings[normalizedIconName] = {
          code: code,
          subset: subset
        };
      }
    }
  }
}
var _missingIcons = [];
var _missingIconsTimer = undefined;

function _warnDuplicateIcon(iconName) {
  var options = _iconSettings.__options;
  var warningDelay = 2000;
  var maxIconsInMessage = 10;

  if (!options.disableWarnings) {
    _missingIcons.push(iconName);

    if (_missingIconsTimer === undefined) {
      _missingIconsTimer = setTimeout(function () {
        warn("Some icons were re-registered. Applications should only call registerIcons for any given " + "icon once. Redefining what an icon is may have unintended consequences. Duplicates " + "include: \n" + _missingIcons.slice(0, maxIconsInMessage).join(', ') + (_missingIcons.length > maxIconsInMessage ? " (+ " + (_missingIcons.length - maxIconsInMessage) + " more)" : ''));
        _missingIconsTimer = undefined;
        _missingIcons = [];
      }, warningDelay);
    }
  }
}

/* Register the keyframes */

var EASING_FUNCTION_1 = 'cubic-bezier(.1,.9,.2,1)';
var EASING_FUNCTION_2 = 'cubic-bezier(.1,.25,.75,.9)';
var DURATION_1 = '0.167s';
var DURATION_2 = '0.267s';
var DURATION_3 = '0.367s';
var DURATION_4 = '0.467s';
var FADE_IN = keyframes({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
var FADE_OUT = keyframes({
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    visibility: 'hidden'
  }
});

var SLIDE_RIGHT_IN10 = _createSlideInX(-10);

var SLIDE_RIGHT_IN20 = _createSlideInX(-20);

var SLIDE_RIGHT_IN40 = _createSlideInX(-40);

var SLIDE_RIGHT_IN400 = _createSlideInX(-400);

var SLIDE_LEFT_IN10 = _createSlideInX(10);

var SLIDE_LEFT_IN20 = _createSlideInX(20);

var SLIDE_LEFT_IN40 = _createSlideInX(40);

var SLIDE_LEFT_IN400 = _createSlideInX(400);

var SLIDE_UP_IN10 = _createSlideInY(10);

var SLIDE_UP_IN20 = _createSlideInY(20);

var SLIDE_DOWN_IN10 = _createSlideInY(-10);

var SLIDE_DOWN_IN20 = _createSlideInY(-20);

var SLIDE_RIGHT_OUT10 = _createSlideOutX(10);

var SLIDE_RIGHT_OUT20 = _createSlideOutX(20);

var SLIDE_RIGHT_OUT40 = _createSlideOutX(40);

var SLIDE_RIGHT_OUT400 = _createSlideOutX(400);

var SLIDE_LEFT_OUT10 = _createSlideOutX(-10);

var SLIDE_LEFT_OUT20 = _createSlideOutX(-20);

var SLIDE_LEFT_OUT40 = _createSlideOutX(-40);

var SLIDE_LEFT_OUT400 = _createSlideOutX(-400);

var SLIDE_UP_OUT10 = _createSlideOutY(-10);

var SLIDE_UP_OUT20 = _createSlideOutY(-20);

var SLIDE_DOWN_OUT10 = _createSlideOutY(10);

var SLIDE_DOWN_OUT20 = _createSlideOutY(20);

var SCALE_UP100 = keyframes({
  from: {
    transform: 'scale3d(.98,.98,1)'
  },
  to: {
    transform: 'scale3d(1,1,1)'
  }
});
var SCALE_DOWN98 = keyframes({
  from: {
    transform: 'scale3d(1,1,1)'
  },
  to: {
    transform: 'scale3d(.98,.98,1)'
  }
});
var SCALE_DOWN100 = keyframes({
  from: {
    transform: 'scale3d(1.03,1.03,1)'
  },
  to: {
    transform: 'scale3d(1,1,1)'
  }
});
var SCALE_UP103 = keyframes({
  from: {
    transform: 'scale3d(1,1,1)'
  },
  to: {
    transform: 'scale3d(1.03,1.03,1)'
  }
});
var ROTATE90 = keyframes({
  from: {
    transform: 'rotateZ(0deg)'
  },
  to: {
    transform: 'rotateZ(90deg)'
  }
});
var ROTATE_N90 = keyframes({
  from: {
    transform: 'rotateZ(0deg)'
  },
  to: {
    transform: 'rotateZ(-90deg)'
  }
});
/**
 * All Fabric standard animations, exposed as json objects referencing predefined
 * keyframes. These objects can be mixed in with other class definitions.
 */

var AnimationStyles = {
  slideRightIn10: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN10, DURATION_3, EASING_FUNCTION_1),
  slideRightIn20: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN20, DURATION_3, EASING_FUNCTION_1),
  slideRightIn40: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN40, DURATION_3, EASING_FUNCTION_1),
  slideRightIn400: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN400, DURATION_3, EASING_FUNCTION_1),
  slideLeftIn10: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN10, DURATION_3, EASING_FUNCTION_1),
  slideLeftIn20: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN20, DURATION_3, EASING_FUNCTION_1),
  slideLeftIn40: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN40, DURATION_3, EASING_FUNCTION_1),
  slideLeftIn400: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN400, DURATION_3, EASING_FUNCTION_1),
  slideUpIn10: _createAnimation(FADE_IN + "," + SLIDE_UP_IN10, DURATION_3, EASING_FUNCTION_1),
  slideUpIn20: _createAnimation(FADE_IN + "," + SLIDE_UP_IN20, DURATION_3, EASING_FUNCTION_1),
  slideDownIn10: _createAnimation(FADE_IN + "," + SLIDE_DOWN_IN10, DURATION_3, EASING_FUNCTION_1),
  slideDownIn20: _createAnimation(FADE_IN + "," + SLIDE_DOWN_IN20, DURATION_3, EASING_FUNCTION_1),
  slideRightOut10: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT10, DURATION_3, EASING_FUNCTION_1),
  slideRightOut20: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT20, DURATION_3, EASING_FUNCTION_1),
  slideRightOut40: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT40, DURATION_3, EASING_FUNCTION_1),
  slideRightOut400: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT400, DURATION_3, EASING_FUNCTION_1),
  slideLeftOut10: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT10, DURATION_3, EASING_FUNCTION_1),
  slideLeftOut20: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT20, DURATION_3, EASING_FUNCTION_1),
  slideLeftOut40: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT40, DURATION_3, EASING_FUNCTION_1),
  slideLeftOut400: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT400, DURATION_3, EASING_FUNCTION_1),
  slideUpOut10: _createAnimation(FADE_OUT + "," + SLIDE_UP_OUT10, DURATION_3, EASING_FUNCTION_1),
  slideUpOut20: _createAnimation(FADE_OUT + "," + SLIDE_UP_OUT20, DURATION_3, EASING_FUNCTION_1),
  slideDownOut10: _createAnimation(FADE_OUT + "," + SLIDE_DOWN_OUT10, DURATION_3, EASING_FUNCTION_1),
  slideDownOut20: _createAnimation(FADE_OUT + "," + SLIDE_DOWN_OUT20, DURATION_3, EASING_FUNCTION_1),
  scaleUpIn100: _createAnimation(FADE_IN + "," + SCALE_UP100, DURATION_3, EASING_FUNCTION_1),
  scaleDownIn100: _createAnimation(FADE_IN + "," + SCALE_DOWN100, DURATION_3, EASING_FUNCTION_1),
  scaleUpOut103: _createAnimation(FADE_OUT + "," + SCALE_UP103, DURATION_1, EASING_FUNCTION_2),
  scaleDownOut98: _createAnimation(FADE_OUT + "," + SCALE_DOWN98, DURATION_1, EASING_FUNCTION_2),
  fadeIn100: _createAnimation(FADE_IN, DURATION_1, EASING_FUNCTION_2),
  fadeIn200: _createAnimation(FADE_IN, DURATION_2, EASING_FUNCTION_2),
  fadeIn400: _createAnimation(FADE_IN, DURATION_3, EASING_FUNCTION_2),
  fadeIn500: _createAnimation(FADE_IN, DURATION_4, EASING_FUNCTION_2),
  fadeOut100: _createAnimation(FADE_OUT, DURATION_1, EASING_FUNCTION_2),
  fadeOut200: _createAnimation(FADE_OUT, DURATION_2, EASING_FUNCTION_2),
  fadeOut400: _createAnimation(FADE_OUT, DURATION_3, EASING_FUNCTION_2),
  fadeOut500: _createAnimation(FADE_OUT, DURATION_4, EASING_FUNCTION_2),
  rotate90deg: _createAnimation(ROTATE90, '0.1s', EASING_FUNCTION_2),
  rotateN90deg: _createAnimation(ROTATE_N90, '0.1s', EASING_FUNCTION_2)
};

function _createAnimation(animationName, animationDuration, animationTimingFunction) {
  return {
    animationName: animationName,
    animationDuration: animationDuration,
    animationTimingFunction: animationTimingFunction,
    animationFillMode: 'both'
  };
}

function _createSlideInX(fromX) {
  return keyframes({
    from: {
      transform: "translate3d(" + fromX + "px,0,0)",
      pointerEvents: 'none'
    },
    to: {
      transform: "translate3d(0,0,0)",
      pointerEvents: 'auto'
    }
  });
}

function _createSlideInY(fromY) {
  return keyframes({
    from: {
      transform: "translate3d(0," + fromY + "px,0)",
      pointerEvents: 'none'
    },
    to: {
      transform: "translate3d(0,0,0)",
      pointerEvents: 'auto'
    }
  });
}

function _createSlideOutX(toX) {
  return keyframes({
    from: {
      transform: "translate3d(0,0,0)"
    },
    to: {
      transform: "translate3d(" + toX + "px,0,0)"
    }
  });
}

function _createSlideOutY(toY) {
  return keyframes({
    from: {
      transform: "translate3d(0,0,0)"
    },
    to: {
      transform: "translate3d(0," + toY + "px,0)"
    }
  });
}

// When adding or removing a color, make sure you keep this consistent with IColorClassNames
// by adding the color variants.
var DefaultPalette = {
  themeDarker: '#004578',
  themeDark: '#005a9e',
  themeDarkAlt: '#106ebe',
  themePrimary: '#0078d4',
  themeSecondary: '#2b88d8',
  themeTertiary: '#71afe5',
  themeLight: '#c7e0f4',
  themeLighter: '#deecf9',
  themeLighterAlt: '#eff6fc',
  black: '#000000',
  blackTranslucent40: 'rgba(0,0,0,.4)',
  neutralDark: '#201f1e',
  neutralPrimary: '#323130',
  neutralPrimaryAlt: '#3b3a39',
  neutralSecondary: '#605e5c',
  neutralSecondaryAlt: '#8a8886',
  neutralTertiary: '#a19f9d',
  neutralTertiaryAlt: '#c8c6c4',
  neutralQuaternary: '#d2d0ce',
  neutralQuaternaryAlt: '#e1dfdd',
  neutralLight: '#edebe9',
  neutralLighter: '#f3f2f1',
  neutralLighterAlt: '#faf9f8',
  accent: '#0078d4',
  white: '#ffffff',
  whiteTranslucent40: 'rgba(255,255,255,.4)',
  yellowDark: '#d29200',
  yellow: '#ffb900',
  yellowLight: '#fff100',
  orange: '#d83b01',
  orangeLight: '#ea4300',
  orangeLighter: '#ff8c00',
  redDark: '#a4262c',
  red: '#e81123',
  magentaDark: '#5c005c',
  magenta: '#b4009e',
  magentaLight: '#e3008c',
  purpleDark: '#32145a',
  purple: '#5c2d91',
  purpleLight: '#b4a0ff',
  blueDark: '#002050',
  blueMid: '#00188f',
  blue: '#0078d4',
  blueLight: '#00bcf2',
  tealDark: '#004b50',
  teal: '#008272',
  tealLight: '#00b294',
  greenDark: '#004b1c',
  green: '#107c10',
  greenLight: '#bad80a'
};

var Depths;

(function (Depths) {
  Depths.depth0 = '0 0 0 0 transparent';
  Depths.depth4 = '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)';
  Depths.depth8 = '0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)';
  Depths.depth16 = '0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)';
  Depths.depth64 = '0 25.6px 57.6px 0 rgba(0, 0, 0, 0.22), 0 4.8px 14.4px 0 rgba(0, 0, 0, 0.18)';
})(Depths || (Depths = {}));

var DefaultEffects = {
  elevation4: Depths.depth4,
  elevation8: Depths.depth8,
  elevation16: Depths.depth16,
  elevation64: Depths.depth64,
  roundedCorner2: '2px',
  roundedCorner4: '4px',
  roundedCorner6: '6px'
};

// Font face names to be registered.
var LocalizedFontNames;

(function (LocalizedFontNames) {
  LocalizedFontNames.Arabic = 'Segoe UI Web (Arabic)';
  LocalizedFontNames.Cyrillic = 'Segoe UI Web (Cyrillic)';
  LocalizedFontNames.EastEuropean = 'Segoe UI Web (East European)';
  LocalizedFontNames.Greek = 'Segoe UI Web (Greek)';
  LocalizedFontNames.Hebrew = 'Segoe UI Web (Hebrew)';
  LocalizedFontNames.Thai = 'Leelawadee UI Web';
  LocalizedFontNames.Vietnamese = 'Segoe UI Web (Vietnamese)';
  LocalizedFontNames.WestEuropean = 'Segoe UI Web (West European)';
  LocalizedFontNames.Selawik = 'Selawik Web';
  LocalizedFontNames.Armenian = 'Segoe UI Web (Armenian)';
  LocalizedFontNames.Georgian = 'Segoe UI Web (Georgian)';
})(LocalizedFontNames || (LocalizedFontNames = {})); // Font families with fallbacks, for the general regions.


var LocalizedFontFamilies;

(function (LocalizedFontFamilies) {
  LocalizedFontFamilies.Arabic = "'" + LocalizedFontNames.Arabic + "'";
  LocalizedFontFamilies.ChineseSimplified = "'Microsoft Yahei UI', Verdana, Simsun";
  LocalizedFontFamilies.ChineseTraditional = "'Microsoft Jhenghei UI', Pmingliu";
  LocalizedFontFamilies.Cyrillic = "'" + LocalizedFontNames.Cyrillic + "'";
  LocalizedFontFamilies.EastEuropean = "'" + LocalizedFontNames.EastEuropean + "'";
  LocalizedFontFamilies.Greek = "'" + LocalizedFontNames.Greek + "'";
  LocalizedFontFamilies.Hebrew = "'" + LocalizedFontNames.Hebrew + "'";
  LocalizedFontFamilies.Hindi = "'Nirmala UI'";
  LocalizedFontFamilies.Japanese = "'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka";
  LocalizedFontFamilies.Korean = "'Malgun Gothic', Gulim";
  LocalizedFontFamilies.Selawik = "'" + LocalizedFontNames.Selawik + "'";
  LocalizedFontFamilies.Thai = "'Leelawadee UI Web', 'Kmer UI'";
  LocalizedFontFamilies.Vietnamese = "'" + LocalizedFontNames.Vietnamese + "'";
  LocalizedFontFamilies.WestEuropean = "'" + LocalizedFontNames.WestEuropean + "'";
  LocalizedFontFamilies.Armenian = "'" + LocalizedFontNames.Armenian + "'";
  LocalizedFontFamilies.Georgian = "'" + LocalizedFontNames.Georgian + "'";
})(LocalizedFontFamilies || (LocalizedFontFamilies = {})); // Standard font sizes.


var FontSizes;

(function (FontSizes) {
  FontSizes.size10 = '10px';
  FontSizes.size12 = '12px';
  FontSizes.size14 = '14px';
  FontSizes.size16 = '16px';
  FontSizes.size18 = '18px';
  FontSizes.size20 = '20px';
  FontSizes.size24 = '24px';
  FontSizes.size28 = '28px';
  FontSizes.size32 = '32px';
  FontSizes.size42 = '42px';
  FontSizes.size68 = '68px';
  FontSizes.mini = '10px';
  FontSizes.xSmall = '10px';
  FontSizes.small = '12px';
  FontSizes.smallPlus = '12px';
  FontSizes.medium = '14px';
  FontSizes.mediumPlus = '16px';
  FontSizes.icon = '16px';
  FontSizes.large = '18px';
  FontSizes.xLarge = '20px';
  FontSizes.xLargePlus = '24px';
  FontSizes.xxLarge = '28px';
  FontSizes.xxLargePlus = '32px';
  FontSizes.superLarge = '42px';
  FontSizes.mega = '68px';
})(FontSizes || (FontSizes = {})); // Standard font weights.


var FontWeights;

(function (FontWeights) {
  FontWeights.light = 100;
  FontWeights.semilight = 300;
  FontWeights.regular = 400;
  FontWeights.semibold = 600;
  FontWeights.bold = 700;
})(FontWeights || (FontWeights = {})); // Standard Icon Sizes.


var IconFontSizes;

(function (IconFontSizes) {
  IconFontSizes.xSmall = '10px';
  IconFontSizes.small = '12px';
  IconFontSizes.medium = '16px';
  IconFontSizes.large = '20px';
})(IconFontSizes || (IconFontSizes = {}));

var FontFamilyFallbacks = "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif"; // By default, we favor system fonts for the default.
// All localized fonts use a web font and never use the system font.

var defaultFontFamily = "'Segoe UI', '" + LocalizedFontNames.WestEuropean + "'"; // Mapping of language prefix to to font family.

var LanguageToFontMap = {
  ar: LocalizedFontFamilies.Arabic,
  bg: LocalizedFontFamilies.Cyrillic,
  cs: LocalizedFontFamilies.EastEuropean,
  el: LocalizedFontFamilies.Greek,
  et: LocalizedFontFamilies.EastEuropean,
  he: LocalizedFontFamilies.Hebrew,
  hi: LocalizedFontFamilies.Hindi,
  hr: LocalizedFontFamilies.EastEuropean,
  hu: LocalizedFontFamilies.EastEuropean,
  ja: LocalizedFontFamilies.Japanese,
  kk: LocalizedFontFamilies.EastEuropean,
  ko: LocalizedFontFamilies.Korean,
  lt: LocalizedFontFamilies.EastEuropean,
  lv: LocalizedFontFamilies.EastEuropean,
  pl: LocalizedFontFamilies.EastEuropean,
  ru: LocalizedFontFamilies.Cyrillic,
  sk: LocalizedFontFamilies.EastEuropean,
  'sr-latn': LocalizedFontFamilies.EastEuropean,
  th: LocalizedFontFamilies.Thai,
  tr: LocalizedFontFamilies.EastEuropean,
  uk: LocalizedFontFamilies.Cyrillic,
  vi: LocalizedFontFamilies.Vietnamese,
  'zh-hans': LocalizedFontFamilies.ChineseSimplified,
  'zh-hant': LocalizedFontFamilies.ChineseTraditional,
  hy: LocalizedFontFamilies.Armenian,
  ka: LocalizedFontFamilies.Georgian
};

function _fontFamilyWithFallbacks(fontFamily) {
  return fontFamily + ", " + FontFamilyFallbacks;
}
/**
 * If there is a localized font for this language, return that.
 * Returns undefined if there is no localized font for that language.
 */


function _getLocalizedFontFamily(language) {
  for (var lang in LanguageToFontMap) {
    if (LanguageToFontMap.hasOwnProperty(lang) && language && lang.indexOf(language) === 0) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return LanguageToFontMap[lang];
    }
  }

  return defaultFontFamily;
}

function _createFont(size, weight, fontFamily) {
  return {
    fontFamily: fontFamily,
    MozOsxFontSmoothing: 'grayscale',
    WebkitFontSmoothing: 'antialiased',
    fontSize: size,
    fontWeight: weight
  };
}

function createFontStyles(localeCode) {
  var localizedFont = _getLocalizedFontFamily(localeCode);

  var fontFamilyWithFallback = _fontFamilyWithFallbacks(localizedFont);

  var fontStyles = {
    tiny: _createFont(FontSizes.mini, FontWeights.regular, fontFamilyWithFallback),
    xSmall: _createFont(FontSizes.xSmall, FontWeights.regular, fontFamilyWithFallback),
    small: _createFont(FontSizes.small, FontWeights.regular, fontFamilyWithFallback),
    smallPlus: _createFont(FontSizes.smallPlus, FontWeights.regular, fontFamilyWithFallback),
    medium: _createFont(FontSizes.medium, FontWeights.regular, fontFamilyWithFallback),
    mediumPlus: _createFont(FontSizes.mediumPlus, FontWeights.regular, fontFamilyWithFallback),
    large: _createFont(FontSizes.large, FontWeights.regular, fontFamilyWithFallback),
    xLarge: _createFont(FontSizes.xLarge, FontWeights.semibold, fontFamilyWithFallback),
    xLargePlus: _createFont(FontSizes.xLargePlus, FontWeights.semibold, fontFamilyWithFallback),
    xxLarge: _createFont(FontSizes.xxLarge, FontWeights.semibold, fontFamilyWithFallback),
    xxLargePlus: _createFont(FontSizes.xxLargePlus, FontWeights.semibold, fontFamilyWithFallback),
    superLarge: _createFont(FontSizes.superLarge, FontWeights.semibold, fontFamilyWithFallback),
    mega: _createFont(FontSizes.mega, FontWeights.semibold, fontFamilyWithFallback)
  };
  return fontStyles;
}

var DefaultBaseUrl = 'https://static2.sharepointonline.com/files/fabric/assets'; // Standard font styling.

var DefaultFontStyles = createFontStyles(getLanguage('sessionStorage'));

function _registerFontFace(fontFamily, url, fontWeight, localFontName) {
  fontFamily = "'" + fontFamily + "'";
  var localFontSrc = localFontName !== undefined ? "local('" + localFontName + "')," : '';
  fontFace({
    fontFamily: fontFamily,
    src: localFontSrc + ("url('" + url + ".woff2') format('woff2'),") + ("url('" + url + ".woff') format('woff')"),
    fontWeight: fontWeight,
    fontStyle: 'normal',
    fontDisplay: 'swap'
  });
}

function _registerFontFaceSet(baseUrl, fontFamily, cdnFolder, cdnFontName, localFontName) {
  if (cdnFontName === void 0) {
    cdnFontName = 'segoeui';
  }

  var urlBase = baseUrl + "/" + cdnFolder + "/" + cdnFontName;

  _registerFontFace(fontFamily, urlBase + '-light', FontWeights.light, localFontName && localFontName + ' Light');

  _registerFontFace(fontFamily, urlBase + '-semilight', FontWeights.semilight, localFontName && localFontName + ' SemiLight');

  _registerFontFace(fontFamily, urlBase + '-regular', FontWeights.regular, localFontName);

  _registerFontFace(fontFamily, urlBase + '-semibold', FontWeights.semibold, localFontName && localFontName + ' SemiBold');

  _registerFontFace(fontFamily, urlBase + '-bold', FontWeights.bold, localFontName && localFontName + ' Bold');
}

function registerDefaultFontFaces(baseUrl) {
  if (baseUrl) {
    var fontUrl = baseUrl + "/fonts"; // Produce @font-face definitions for all supported web fonts.

    _registerFontFaceSet(fontUrl, LocalizedFontNames.Thai, 'leelawadeeui-thai', 'leelawadeeui');

    _registerFontFaceSet(fontUrl, LocalizedFontNames.Arabic, 'segoeui-arabic');

    _registerFontFaceSet(fontUrl, LocalizedFontNames.Cyrillic, 'segoeui-cyrillic');

    _registerFontFaceSet(fontUrl, LocalizedFontNames.EastEuropean, 'segoeui-easteuropean');

    _registerFontFaceSet(fontUrl, LocalizedFontNames.Greek, 'segoeui-greek');

    _registerFontFaceSet(fontUrl, LocalizedFontNames.Hebrew, 'segoeui-hebrew');

    _registerFontFaceSet(fontUrl, LocalizedFontNames.Vietnamese, 'segoeui-vietnamese');

    _registerFontFaceSet(fontUrl, LocalizedFontNames.WestEuropean, 'segoeui-westeuropean', 'segoeui', 'Segoe UI');

    _registerFontFaceSet(fontUrl, LocalizedFontFamilies.Selawik, 'selawik', 'selawik');

    _registerFontFaceSet(fontUrl, LocalizedFontNames.Armenian, 'segoeui-armenian');

    _registerFontFaceSet(fontUrl, LocalizedFontNames.Georgian, 'segoeui-georgian'); // Leelawadee UI (Thai) does not have a 'light' weight, so we override
    // the font-face generated above to use the 'semilight' weight instead.


    _registerFontFace('Leelawadee UI Web', fontUrl + "/leelawadeeui-thai/leelawadeeui-semilight", FontWeights.light); // Leelawadee UI (Thai) does not have a 'semibold' weight, so we override
    // the font-face generated above to use the 'bold' weight instead.


    _registerFontFace('Leelawadee UI Web', fontUrl + "/leelawadeeui-thai/leelawadeeui-bold", FontWeights.semibold);
  }
}
/**
 * Reads the fontBaseUrl from window.FabricConfig.fontBaseUrl or falls back to a default.
 */

function _getFontBaseUrl() {
  var _a, _b, _c; // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var fabricConfig = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.FabricConfig;
  return _c = (_b = fabricConfig) === null || _b === void 0 ? void 0 : _b.fontBaseUrl, _c !== null && _c !== void 0 ? _c : DefaultBaseUrl;
}
/**
 * Register the font faces.
 */


registerDefaultFontFaces(_getFontBaseUrl());

// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
var __assign$1 = undefined && undefined.__assign || function () {
  __assign$1 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign$1.apply(this, arguments);
}; // Store the theming state in __themeState__ global scope for reuse in the case of duplicate
// load-themed-styles hosted on the page.


var _root = typeof window === 'undefined' ? global : window; // eslint-disable-line @typescript-eslint/no-explicit-any
// Nonce string to inject into script tag if one provided. This is used in CSP (Content Security Policy).


var _styleNonce = _root && _root.CSPSettings && _root.CSPSettings.nonce;

var _themeState = initializeThemeState();
/**
 * initialize global state object
 */


function initializeThemeState() {
  var state = _root.__themeState__ || {
    theme: undefined,
    lastStyleElement: undefined,
    registeredStyles: []
  };

  if (!state.runState) {
    state = __assign$1(__assign$1({}, state), {
      perf: {
        count: 0,
        duration: 0
      },
      runState: {
        flushTimer: 0,
        mode: 0
        /* sync */
        ,
        buffer: []
      }
    });
  }

  if (!state.registeredThemableStyles) {
    state = __assign$1(__assign$1({}, state), {
      registeredThemableStyles: []
    });
  }

  _root.__themeState__ = state;
  return state;
}
/**
 * Loads a set of style text. If it is registered too early, we will register it when the window.load event
 * is fired.
 * @param {string} styleText Style to register.
 * @param {IStyleRecord} styleRecord Existing style record to re-apply.
 */


function applyThemableStyles(stylesArray, styleRecord) {
  if (_themeState.loadStyles) {
    _themeState.loadStyles(resolveThemableArray(stylesArray).styleString, stylesArray);
  } else {
    registerStyles(stylesArray);
  }
}
/**
 * Registers a set theme tokens to find and replace. If styles were already registered, they will be
 * replaced.
 * @param {theme} theme JSON object of theme tokens to values.
 */


function loadTheme(theme) {
  _themeState.theme = theme; // reload styles.

  reloadStyles();
}
/**
 * Clear already registered style elements and style records in theme_State object
 * @param option - specify which group of registered styles should be cleared.
 * Default to be both themable and non-themable styles will be cleared
 */

function clearStyles(option) {
  if (option === void 0) {
    option = 3
    /* all */
    ;
  }

  if (option === 3
  /* all */
  || option === 2
  /* onlyNonThemable */
  ) {
    clearStylesInternal(_themeState.registeredStyles);
    _themeState.registeredStyles = [];
  }

  if (option === 3
  /* all */
  || option === 1
  /* onlyThemable */
  ) {
    clearStylesInternal(_themeState.registeredThemableStyles);
    _themeState.registeredThemableStyles = [];
  }
}

function clearStylesInternal(records) {
  records.forEach(function (styleRecord) {
    var styleElement = styleRecord && styleRecord.styleElement;

    if (styleElement && styleElement.parentElement) {
      styleElement.parentElement.removeChild(styleElement);
    }
  });
}
/**
 * Reloads styles.
 */


function reloadStyles() {
  if (_themeState.theme) {
    var themableStyles = [];

    for (var _i = 0, _a = _themeState.registeredThemableStyles; _i < _a.length; _i++) {
      var styleRecord = _a[_i];
      themableStyles.push(styleRecord.themableStyle);
    }

    if (themableStyles.length > 0) {
      clearStyles(1
      /* onlyThemable */
      );
      applyThemableStyles([].concat.apply([], themableStyles));
    }
  }
}
/**
 * Resolves ThemingInstruction objects in an array and joins the result into a string.
 * @param {ThemableArray} splitStyleArray ThemableArray to resolve and join.
 */

function resolveThemableArray(splitStyleArray) {
  var theme = _themeState.theme;
  var themable = false; // Resolve the array of theming instructions to an array of strings.
  // Then join the array to produce the final CSS string.

  var resolvedArray = (splitStyleArray || []).map(function (currentValue) {
    var themeSlot = currentValue.theme;

    if (themeSlot) {
      themable = true; // A theming annotation. Resolve it.

      var themedValue = theme ? theme[themeSlot] : undefined;
      var defaultValue = currentValue.defaultValue || 'inherit'; // Warn to console if we hit an unthemed value even when themes are provided, but only if "DEBUG" is true.
      // Allow the themedValue to be undefined to explicitly request the default value.

      if (theme && !themedValue && console && !(themeSlot in theme) && typeof DEBUG !== 'undefined' && DEBUG) {
        console.warn("Theming value not provided for \"" + themeSlot + "\". Falling back to \"" + defaultValue + "\".");
      }

      return themedValue || defaultValue;
    } else {
      // A non-themable string. Preserve it.
      return currentValue.rawString;
    }
  });
  return {
    styleString: resolvedArray.join(''),
    themable: themable
  };
}
/**
 * Registers a set of style text. If it is registered too early, we will register it when the
 * window.load event is fired.
 * @param {ThemableArray} styleArray Array of IThemingInstruction objects to register.
 * @param {IStyleRecord} styleRecord May specify a style Element to update.
 */

function registerStyles(styleArray) {
  if (typeof document === 'undefined') {
    return;
  }

  var head = document.getElementsByTagName('head')[0];
  var styleElement = document.createElement('style');

  var _a = resolveThemableArray(styleArray),
      styleString = _a.styleString,
      themable = _a.themable;

  styleElement.setAttribute('data-load-themed-styles', 'true');

  if (_styleNonce) {
    styleElement.setAttribute('nonce', _styleNonce);
  }

  styleElement.appendChild(document.createTextNode(styleString));
  _themeState.perf.count++;
  head.appendChild(styleElement);
  var ev = document.createEvent('HTMLEvents');
  ev.initEvent('styleinsert', true
  /* bubbleEvent */
  , false
  /* cancelable */
  );
  ev.args = {
    newStyle: styleElement
  };
  document.dispatchEvent(ev);
  var record = {
    styleElement: styleElement,
    themableStyle: styleArray
  };

  if (themable) {
    _themeState.registeredThemableStyles.push(record);
  } else {
    _themeState.registeredStyles.push(record);
  }
}

/** Generates all the semantic slot colors based on the theme so far
 * We'll use these as fallbacks for semantic slots that the passed in theme did not define.
 * The caller must still mix in the customized semantic slots at the end.
 */

function makeSemanticColors(p, e, s, isInverted, depComments) {
  if (depComments === void 0) {
    depComments = false;
  }

  var semanticColors = __assign({
    primaryButtonBorder: 'transparent',
    errorText: !isInverted ? '#a4262c' : '#F1707B',
    messageText: !isInverted ? '#323130' : '#F3F2F1',
    messageLink: !isInverted ? '#005A9E' : '#6CB8F6',
    messageLinkHovered: !isInverted ? '#004578' : '#82C7FF',
    infoIcon: !isInverted ? '#605e5c' : '#C8C6C4',
    errorIcon: !isInverted ? '#A80000' : '#F1707B',
    blockingIcon: !isInverted ? '#FDE7E9' : '#442726',
    warningIcon: !isInverted ? '#797775' : '#C8C6C4',
    severeWarningIcon: !isInverted ? '#D83B01' : '#FCE100',
    successIcon: !isInverted ? '#107C10' : '#92C353',
    infoBackground: !isInverted ? '#f3f2f1' : '#323130',
    errorBackground: !isInverted ? '#FDE7E9' : '#442726',
    blockingBackground: !isInverted ? '#FDE7E9' : '#442726',
    warningBackground: !isInverted ? '#FFF4CE' : '#433519',
    severeWarningBackground: !isInverted ? '#FED9CC' : '#4F2A0F',
    successBackground: !isInverted ? '#DFF6DD' : '#393D1B',
    // deprecated
    warningHighlight: !isInverted ? '#ffb900' : '#fff100',
    successText: !isInverted ? '#107C10' : '#92c353'
  }, s);

  var fullSemanticColors = getSemanticColors(p, e, semanticColors, isInverted);
  return _fixDeprecatedSlots(fullSemanticColors, depComments);
}
/**
 * Map partial platte and effects to partial semantic colors.
 */

function getSemanticColors(p, e, s, isInverted, depComments) {

  var _a, _b, _c;

  var result = {}; // map palette

  var _d = p || {},
      white = _d.white,
      black = _d.black,
      themePrimary = _d.themePrimary,
      themeDark = _d.themeDark,
      themeDarker = _d.themeDarker,
      themeDarkAlt = _d.themeDarkAlt,
      themeLighter = _d.themeLighter,
      neutralLight = _d.neutralLight,
      neutralLighter = _d.neutralLighter,
      neutralDark = _d.neutralDark,
      neutralQuaternary = _d.neutralQuaternary,
      neutralQuaternaryAlt = _d.neutralQuaternaryAlt,
      neutralPrimary = _d.neutralPrimary,
      neutralSecondary = _d.neutralSecondary,
      neutralSecondaryAlt = _d.neutralSecondaryAlt,
      neutralTertiary = _d.neutralTertiary,
      neutralTertiaryAlt = _d.neutralTertiaryAlt,
      neutralLighterAlt = _d.neutralLighterAlt,
      accent = _d.accent;

  if (white) {
    result.bodyBackground = white;
    result.bodyFrameBackground = white;
    result.accentButtonText = white;
    result.buttonBackground = white;
    result.primaryButtonText = white;
    result.primaryButtonTextHovered = white;
    result.primaryButtonTextPressed = white;
    result.inputBackground = white;
    result.inputForegroundChecked = white;
    result.listBackground = white;
    result.menuBackground = white;
    result.cardStandoutBackground = white;
  }

  if (black) {
    result.bodyTextChecked = black;
    result.buttonTextCheckedHovered = black;
  }

  if (themePrimary) {
    result.link = themePrimary;
    result.primaryButtonBackground = themePrimary;
    result.inputBackgroundChecked = themePrimary;
    result.inputIcon = themePrimary;
    result.inputFocusBorderAlt = themePrimary;
    result.menuIcon = themePrimary;
    result.menuHeader = themePrimary;
    result.accentButtonBackground = themePrimary;
  }

  if (themeDark) {
    result.primaryButtonBackgroundPressed = themeDark;
    result.inputBackgroundCheckedHovered = themeDark;
    result.inputIconHovered = themeDark;
  }

  if (themeDarker) {
    result.linkHovered = themeDarker;
  }

  if (themeDarkAlt) {
    result.primaryButtonBackgroundHovered = themeDarkAlt;
  }

  if (themeLighter) {
    result.inputPlaceholderBackgroundChecked = themeLighter;
  }

  if (neutralLight) {
    result.bodyBackgroundChecked = neutralLight;
    result.bodyFrameDivider = neutralLight;
    result.bodyDivider = neutralLight;
    result.variantBorder = neutralLight;
    result.buttonBackgroundCheckedHovered = neutralLight;
    result.buttonBackgroundPressed = neutralLight;
    result.listItemBackgroundChecked = neutralLight;
    result.listHeaderBackgroundPressed = neutralLight;
    result.menuItemBackgroundPressed = neutralLight; // eslint-disable-next-line deprecation/deprecation

    result.menuItemBackgroundChecked = neutralLight;
  }

  if (neutralLighter) {
    result.bodyBackgroundHovered = neutralLighter;
    result.buttonBackgroundHovered = neutralLighter;
    result.buttonBackgroundDisabled = neutralLighter;
    result.buttonBorderDisabled = neutralLighter;
    result.primaryButtonBackgroundDisabled = neutralLighter;
    result.disabledBackground = neutralLighter;
    result.listItemBackgroundHovered = neutralLighter;
    result.listHeaderBackgroundHovered = neutralLighter;
    result.menuItemBackgroundHovered = neutralLighter;
  }

  if (neutralQuaternary) {
    result.primaryButtonTextDisabled = neutralQuaternary;
    result.disabledSubtext = neutralQuaternary;
  }

  if (neutralQuaternaryAlt) {
    result.listItemBackgroundCheckedHovered = neutralQuaternaryAlt;
  }

  if (neutralTertiary) {
    result.disabledBodyText = neutralTertiary;
    result.variantBorderHovered = ((_a = s) === null || _a === void 0 ? void 0 : _a.variantBorderHovered) || neutralTertiary;
    result.buttonTextDisabled = neutralTertiary;
    result.inputIconDisabled = neutralTertiary;
    result.disabledText = neutralTertiary;
  }

  if (neutralPrimary) {
    result.bodyText = neutralPrimary;
    result.actionLink = neutralPrimary;
    result.buttonText = neutralPrimary;
    result.inputBorderHovered = neutralPrimary;
    result.inputText = neutralPrimary;
    result.listText = neutralPrimary;
    result.menuItemText = neutralPrimary;
  }

  if (neutralLighterAlt) {
    result.bodyStandoutBackground = neutralLighterAlt;
    result.defaultStateBackground = neutralLighterAlt;
  }

  if (neutralDark) {
    result.actionLinkHovered = neutralDark;
    result.buttonTextHovered = neutralDark;
    result.buttonTextChecked = neutralDark;
    result.buttonTextPressed = neutralDark;
    result.inputTextHovered = neutralDark;
    result.menuItemTextHovered = neutralDark;
  }

  if (neutralSecondary) {
    result.bodySubtext = neutralSecondary;
    result.focusBorder = neutralSecondary;
    result.inputBorder = neutralSecondary;
    result.smallInputBorder = neutralSecondary;
    result.inputPlaceholderText = neutralSecondary;
  }

  if (neutralSecondaryAlt) {
    result.buttonBorder = neutralSecondaryAlt;
  }

  if (neutralTertiaryAlt) {
    result.disabledBodySubtext = neutralTertiaryAlt;
    result.disabledBorder = neutralTertiaryAlt;
    result.buttonBackgroundChecked = neutralTertiaryAlt;
    result.menuDivider = neutralTertiaryAlt;
  }

  if (accent) {
    result.accentButtonBackground = accent;
  } // map effects


  if ((_b = e) === null || _b === void 0 ? void 0 : _b.elevation4) {
    result.cardShadow = e.elevation4;
  }

  if (!isInverted && ((_c = e) === null || _c === void 0 ? void 0 : _c.elevation8)) {
    result.cardShadowHovered = e.elevation8;
  } else if (result.variantBorderHovered) {
    result.cardShadowHovered = '0 0 1px ' + result.variantBorderHovered;
  }

  result = __assign(__assign({}, result), s);
  return result;
}

function _fixDeprecatedSlots(s, depComments) {
  // Add @deprecated tag as comment if enabled
  var dep = '';

  if (depComments === true) {
    dep = ' /* @deprecated */';
  }
  /* eslint-disable deprecation/deprecation */


  s.listTextColor = s.listText + dep;
  s.menuItemBackgroundChecked += dep;
  s.warningHighlight += dep;
  s.warningText = s.messageText + dep;
  s.successText += dep;
  /* eslint-enable deprecation/deprecation */

  return s;
}

/**
 * Merge a partial/full theme into a full theme and returns a merged full theme.
 */

function mergeThemes(theme, partialTheme) {
  if (partialTheme === void 0) {
    partialTheme = {};
  }

  var _a, _b, _c, _d;

  var mergedTheme = merge({}, theme, partialTheme, {
    semanticColors: getSemanticColors(partialTheme.palette, partialTheme.effects, partialTheme.semanticColors, partialTheme.isInverted === undefined ? theme.isInverted : partialTheme.isInverted)
  });

  if (((_a = partialTheme.palette) === null || _a === void 0 ? void 0 : _a.themePrimary) && !((_b = partialTheme.palette) === null || _b === void 0 ? void 0 : _b.accent)) {
    mergedTheme.palette.accent = partialTheme.palette.themePrimary;
  }

  if (partialTheme.defaultFontStyle) {
    for (var _i = 0, _e = Object.keys(mergedTheme.fonts); _i < _e.length; _i++) {
      var fontStyle = _e[_i];
      mergedTheme.fonts[fontStyle] = merge(mergedTheme.fonts[fontStyle], partialTheme.defaultFontStyle, (_d = (_c = partialTheme) === null || _c === void 0 ? void 0 : _c.fonts) === null || _d === void 0 ? void 0 : _d[fontStyle]);
    }
  }

  if (partialTheme.stylesheets) {
    mergedTheme.stylesheets = (theme.stylesheets || []).concat(partialTheme.stylesheets);
  }

  return mergedTheme;
}

var DefaultSpacing = {
  s2: '4px',
  s1: '8px',
  m: '16px',
  l1: '20px',
  l2: '32px'
};

/**
 * Creates a custom theme definition.
 * @param theme - Partial theme object.
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */

function createTheme(theme, depComments) {
  if (theme === void 0) {
    theme = {};
  }

  if (depComments === void 0) {
    depComments = false;
  }

  var isInverted = !!theme.isInverted;
  var baseTheme = {
    palette: DefaultPalette,
    effects: DefaultEffects,
    fonts: DefaultFontStyles,
    spacing: DefaultSpacing,
    isInverted: isInverted,
    disableGlobalClassNames: false,
    semanticColors: makeSemanticColors(DefaultPalette, DefaultEffects, undefined, isInverted, depComments),
    rtl: undefined
  };
  return mergeThemes(baseTheme, theme);
}

var _theme = createTheme({});

var _onThemeChangeCallbacks = [];
var ThemeSettingName = 'theme';
function initializeThemeInCustomizations() {
  var _a;

  var _b, _c, _d, _e; // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var win = getWindow();

  if ((_c = (_b = win) === null || _b === void 0 ? void 0 : _b.FabricConfig) === null || _c === void 0 ? void 0 : _c.legacyTheme) {
    // does everything the `else` clause does and more, such as invoke legacy theming
    loadTheme$1(win.FabricConfig.legacyTheme);
  } else if (!Customizations.getSettings([ThemeSettingName]).theme) {
    if ((_e = (_d = win) === null || _d === void 0 ? void 0 : _d.FabricConfig) === null || _e === void 0 ? void 0 : _e.theme) {
      _theme = createTheme(win.FabricConfig.theme);
    } // Set the default theme.


    Customizations.applySettings((_a = {}, _a[ThemeSettingName] = _theme, _a));
  }
}
initializeThemeInCustomizations();
/**
 * Gets the theme object
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */

function getTheme(depComments) {
  if (depComments === void 0) {
    depComments = false;
  }

  if (depComments === true) {
    _theme = createTheme({}, depComments);
  }

  return _theme;
}
/**
 * Applies the theme, while filling in missing slots.
 * @param theme - Partial theme object.
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */

function loadTheme$1(theme, depComments) {
  var _a;

  if (depComments === void 0) {
    depComments = false;
  }

  _theme = createTheme(theme, depComments); // Invoke the legacy method of theming the page as well.

  loadTheme(__assign(__assign(__assign(__assign({}, _theme.palette), _theme.semanticColors), _theme.effects), _loadFonts(_theme)));
  Customizations.applySettings((_a = {}, _a[ThemeSettingName] = _theme, _a));

  _onThemeChangeCallbacks.forEach(function (callback) {
    try {
      callback(_theme);
    } catch (e) {// don't let a bad callback break everything else
    }
  });

  return _theme;
}
/**
 * Loads font variables into a JSON object.
 * @param theme - The theme object
 */

function _loadFonts(theme) {
  var lines = {};

  for (var _i = 0, _a = Object.keys(theme.fonts); _i < _a.length; _i++) {
    var fontName = _a[_i];
    var font = theme.fonts[fontName];

    for (var _b = 0, _c = Object.keys(font); _b < _c.length; _b++) {
      var propName = _c[_b];
      var name_1 = fontName + propName.charAt(0).toUpperCase() + propName.slice(1);
      var value = font[propName];

      if (propName === 'fontSize' && typeof value === 'number') {
        // if it's a number, convert it to px by default like our theming system does
        value = value + 'px';
      }

      lines[name_1] = value;
    }
  }

  return lines;
}

// Do not modify this file; it is generated as part of publish.
setVersion('@uifabric/styling', '7.19.1');

initializeThemeInCustomizations();

var NoItems = function NoItems(_ref) {
  var type = _ref.type;
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        height: 70,
        backgroundColor: DefaultPalette$2.neutralLight
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, null, type === "search" ? i18n._(
  /*i18n*/
  {
    id: "No items match your search."
  }) : i18n._(
  /*i18n*/
  {
    id: "No items are assigned."
  })));
};

var Tag = (function (_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus",
    styles: {
      root: {
        backgroundColor: DefaultPalette$2.neutralLight,
        borderRadius: 4,
        color: DefaultPalette$2.neutralPrimary,
        padding: "4px 8px",
        marginRight: 8
      }
    }
  }, children);
});

var ColumnFilterList = function ColumnFilterList(_ref) {
  var columnFilters = _ref.columnFilters,
      onChangeFilterText = _ref.onChangeFilterText,
      clearFilterText = _ref.clearFilterText;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    if (clearFilterText && value) {
      setValue("");
      onChangeFilterText(null, "");
    }
  }, [clearFilterText]);
  return /*#__PURE__*/React__default.createElement(TextField, {
    styles: {
      subComponentStyles: {
        label: {
          root: {
            marginBottom: 4
          }
        }
      }
    },
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, i18n._(
    /*i18n*/
    {
      id: "Search on:"
    }), " ", columnFilters.map(function (c, index) {
      return /*#__PURE__*/React__default.createElement(Tag, {
        key: index
      }, c.name);
    })),
    value: value,
    onChange: function onChange(e, value) {
      setValue(value);
      onChangeFilterText(e, value);
    }
  });
};

/**
 * A constructor class for orchestrating org structures.
 */
var Organisation = function Organisation(org) {
  var _this = this;

  _classCallCheck(this, Organisation);

  _defineProperty(this, "getRootItemId", function () {
    return _this.org.id;
  });

  _defineProperty(this, "_createOus", function (ous) {
    var parentUuid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var breadcrumb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return ous.reduce(function (acc, ou) {
      var item = _objectSpread2(_objectSpread2({}, ou), {}, {
        parentUuid: parentUuid,
        breadcrumb: [].concat(_toConsumableArray(breadcrumb), [ou.id])
      });

      if (ou.children && ou.children.length) {
        var newBreadcrumb = [].concat(_toConsumableArray(breadcrumb), [ou.id]);

        var children = _this._createOus(ou.children, ou.id, newBreadcrumb);

        return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, item.id, item), children);
      }

      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, item.id, item));
    }, {});
  });

  _defineProperty(this, "getItemContext", function (id) {
    var itemDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var item = _objectSpread2(_objectSpread2({}, _this.ous[id]), itemDetails);

    var parentUuid = item.parentUuid,
        children = item.children;
    var parent = parentUuid ? _this.ous[parentUuid] : null;
    var siblings = parentUuid ? parent.children : null; // The `returnLinkItem` should link to the ou, that is the parent of the
    // first item in the list.

    var returnLinkItem = children && children.length ? parentUuid ? _this.ous[parentUuid] : null : parentUuid ? _this.ous[parent.parentUuid] : null;
    return {
      item: item,
      parent: parent,
      siblings: siblings,
      returnLinkItem: returnLinkItem,
      children: children
    };
  });

  _defineProperty(this, "getItems", function () {
    var _sortOus = function _sortOus(ous) {
      return ous.map(function (ou) {
        if (ou.children && ou.children.length) {
          var children = _sortOus(ou.children.sort(function (a, b) {
            return a.name.localeCompare(b.name);
          }));

          return _objectSpread2(_objectSpread2({}, ou), {}, {
            children: children
          });
        }

        return _objectSpread2({}, ou);
      });
    };

    return _sortOus(Object.values(_this.ous).map(function (item) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        id: item.id
      });
    }));
  });

  _defineProperty(this, "getOptionsHierarchy", function () {
    if (!_this.org) return;

    function mapOUstoList(ous) {
      var key = ous.id,
          text = ous.name;
      var list = getOuHierarchy(ous, 0);
      return [{
        key: key,
        text: text,
        disabled: ous.options && ous.options.split(",").find(function (i) {
          return i === "READ_ONLY";
        }) ? true : false
      }].concat(_toConsumableArray(list));
    }

    function getOuHierarchy(parentOu, level) {
      var list = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (parentOu.children && parentOu.children.length !== 0) {
        parentOu.children.forEach(function (childOu) {
          var prefix = "";

          for (var i = 0; i <= level; i++) {
            prefix += "--";
          }

          var item = {
            key: childOu.id,
            text: prefix + childOu.name,
            disabled: childOu.options.split(",").find(function (i) {
              return i === "READ_ONLY";
            }) ? true : false
          };
          list.push(item);
          getOuHierarchy(childOu, level + 1, list);
        });
      }

      return list;
    }

    return mapOUstoList(_this.org);
  });

  this.org = org;
  this.ous = this._createOus([org]);
};

var OrgHelper = /*#__PURE__*/function () {
  function OrgHelper() {
    _classCallCheck(this, OrgHelper);
  }

  _createClass(OrgHelper, null, [{
    key: "itemShouldBeHidden",
    value: function itemShouldBeHidden(item) {
      return new Organisation(item).getItems().filter(function (ou) {
        return ou.readOnly === false;
      }).length === 0;
    }
  }, {
    key: "setCanSelectProps",
    value: function setCanSelectProps(item) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        canSelect: !item.readOnly,
        isHidden: OrgHelper.itemShouldBeHidden(item)
      });
    }
  }, {
    key: "setChildrenCanSelectProps",
    value: function setChildrenCanSelectProps(children) {
      var newChildren = children.map(function (c) {
        var child = OrgHelper.setCanSelectProps(c);
        return _objectSpread2(_objectSpread2({}, child), {}, {
          children: c.children.length ? OrgHelper.setChildrenCanSelectProps(c.children) : []
        });
      });
      return newChildren;
    }
  }, {
    key: "applyCheckboxOptions",
    value: function applyCheckboxOptions(options) {
      var ous = OrgHelper.setCanSelectProps(options);

      if (options.children && options.children.length) {
        ous = _objectSpread2(_objectSpread2({}, ous), {}, {
          children: OrgHelper.setChildrenCanSelectProps(options.children)
        });
      }

      return ous;
    }
  }, {
    key: "getSearchedItems",
    value: function getSearchedItems(result, root) {
      var ids = new Set(getIds());

      function checkNode(node) {
        if (!node.children) return node;
        return _objectSpread2(_objectSpread2({}, node), {}, {
          isCollapsed: false,
          children: node.children.filter(function (c) {
            return ids.has(c.id);
          }).map(function (c) {
            return checkNode(c);
          }).filter(function (c) {
            return c !== undefined;
          })
        });
      }

      function getIds() {
        var ids = [];
        result.forEach(function (item) {
          var array = [];
          array.push(item.id);
          if (item.breadcrumb) array = [].concat(_toConsumableArray(array), _toConsumableArray(item.breadcrumb));
          ids = [].concat(_toConsumableArray(ids), _toConsumableArray(array));
        });
        return _toConsumableArray(new Set(ids));
      }

      return checkNode(root);
    }
  }]);

  return OrgHelper;
}();

var usePrevious = function (state) {
  var ref = useRef();
  useEffect(function () {
    ref.current = state;
  });
  return ref.current;
};

var TreeListItem = function TreeListItem(_ref) {
  var item = _ref.item,
      listItemProps = _ref.listItemProps,
      onItemClick = _ref.onItemClick,
      _onChange = _ref.onChange,
      ouLimit = _ref.ouLimit;
  var id = item.id,
      layer = item.layer,
      isChecked = item.isChecked,
      canSelect = item.canSelect,
      isIndeterminate = item.isIndeterminate,
      isSelected = item.isSelected;
  var _listItemProps$iconPr = listItemProps.iconProps,
      iconProps = _listItemProps$iconPr === void 0 ? {} : _listItemProps$iconPr,
      primaryTextKey = listItemProps.primaryTextKey,
      secondaryTextKey = listItemProps.secondaryTextKey;
  var primaryText = primaryTextKey ? item[primaryTextKey] : null;
  var secondaryText = secondaryTextKey ? item[secondaryTextKey] : null;

  var _useState = useState(isChecked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var iconStyles = {
    root: {
      color: canSelect ? iconProps.color : DefaultPalette$2.neutralTertiaryAlt,
      padding: 6,
      fontSize: 12
    }
  };
  useEffect(function () {
    setChecked(isChecked); // eslint-disable-next-line
  }, [isChecked]);
  var mergedIconStyles = iconProps.styles ? Object.assign(iconStyles, iconProps.styles) : iconStyles;
  var layers = new Array(layer).fill(0);
  var dividers = layers.map(function (n, i) {
    return /*#__PURE__*/React__default.createElement(Stack, {
      key: i,
      horizontal: true,
      horizontalAlign: "space-between",
      verticalAlign: "center",
      styles: {
        root: {
          minWidth: 26
        }
      }
    });
  });
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    horizontalAlign: "start"
  }, layer > 0 && dividers, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    styles: {
      root: {
        width: "calc(100% - ".concat(layer * 30, "px)"),
        backgroundColor: ouLimit && isSelected ? DefaultPalette$2.neutralLighter : "",
        selectors: {
          "&:hover": {
            backgroundColor: DefaultPalette$2.neutralLighter,
            cursor: canSelect ? "pointer" : "default"
          }
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    horizontalAlign: "start",
    verticalAlign: "center"
  }, item.children.length > 0 && item.children.some(function (c) {
    return !c.isHidden;
  }) ? /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        padding: 6,
        selectors: {
          "&:hover": {
            backgroundColor: DefaultPalette$2.neutralLighter
          }
        }
      }
    },
    onClick: function onClick() {
      return onItemClick(item, true);
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: item.isCollapsed ? "ChevronRightMed" : "ChevronDownMed"
  })) : /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        padding: 13
      }
    }
  }), /*#__PURE__*/React__default.createElement(Stack, {
    onClick: ouLimit && canSelect ? function () {
      return _onChange(id);
    } : function () {},
    id: ouLimit ? id : "Stack" + id,
    key: ouLimit ? id : "Stack" + id,
    horizontal: true,
    horizontalAlign: "start",
    verticalAlign: "center"
  }, !ouLimit && /*#__PURE__*/React__default.createElement(Checkbox, {
    id: id,
    key: id,
    onChange: function onChange(e) {
      setChecked(!checked);

      _onChange(e, !checked);
    },
    disabled: !canSelect,
    checked: checked,
    indeterminate: isIndeterminate
  }), /*#__PURE__*/React__default.createElement(Icon, {
    iconName: iconProps.iconName,
    styles: mergedIconStyles
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium",
    nowrap: true,
    block: true,
    styles: !canSelect ? {
      root: {
        color: DefaultPalette$2.neutralTertiaryAlt
      }
    } : isSelected && ouLimit ? {
      root: {
        fontWeight: FontWeights$2.semibold
      }
    } : {}
  }, primaryText, " ", secondaryText)))));
};

var GroupedListItem = function GroupedListItem(_ref) {
  var item = _ref.item,
      onCheckboxChange = _ref.onCheckboxChange,
      listItemProps = _ref.listItemProps;
  var iconProps = listItemProps.iconProps,
      primaryTextKey = listItemProps.primaryTextKey;
  var primaryText = primaryTextKey ? item[primaryTextKey] : null;
  var id = item.id,
      isChecked = item.isChecked;
  var iconStyles = {
    root: {
      color: iconProps.color,
      padding: 6,
      fontSize: 12
    }
  };
  var mergedIconStyles = iconProps.styles ? Object.assign(iconStyles, iconProps.styles) : iconStyles;
  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true
  }, /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        padding: 13
      }
    }
  }), /*#__PURE__*/React__default.createElement(Checkbox, {
    id: id,
    key: id,
    onChange: onCheckboxChange,
    checked: isChecked
  }), /*#__PURE__*/React__default.createElement(Icon, {
    iconName: iconProps.iconName,
    styles: mergedIconStyles
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium",
    nowrap: true,
    block: true
  }, primaryText)));
};

var TreeList = function TreeList(_ref) {
  var items = _ref.items,
      listItemProps = _ref.listItemProps,
      onChange = _ref.onChange,
      _ref$ouLimit = _ref.ouLimit,
      ouLimit = _ref$ouLimit === void 0 ? false : _ref$ouLimit,
      _ref$defaultedCollaps = _ref.defaultedCollapsed,
      defaultedCollapsed = _ref$defaultedCollaps === void 0 ? false : _ref$defaultedCollaps,
      OnRenderCell = _ref.OnRenderCell,
      noResults = _ref.noResults;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listItems = _useState2[0],
      setListItems = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      noItems = _useState4[0],
      setNoItems = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      itemHierarchy = _useState6[0],
      setItemHierarchy = _useState6[1];

  var previousItems = usePrevious(items); // Update the hierarchy

  useEffect(function () {
    if (!items) return;
    var rootItem = [items.find(function (item) {
      return item.parentUuid === null;
    })]; // Calculates the state of the individual element in the hierarchy

    var getItemContext = function getItemContext(isRootItem, layer) {
      var isCollapsed = layer > 1 ? defaultedCollapsed : false;
      return {
        isCollapsed: isCollapsed,
        isRootItem: isRootItem
      };
    }; // Creates the initial hierarchal structure based on the root item


    var createHierarchy = function createHierarchy(newItems) {
      var layer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var breadcrumb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var isRootItem = layer === 0;
      return newItems.map(function (item) {
        var itemContext = getItemContext(isRootItem, layer);
        var newBreadcrumb = [].concat(_toConsumableArray(breadcrumb), [item.id]);
        return _objectSpread2(_objectSpread2(_objectSpread2({}, item), itemContext), {}, {
          isRootItem: isRootItem,
          layer: layer,
          breadcrumb: newBreadcrumb,
          children: item.children ? createHierarchy(item.children, layer + 1, newBreadcrumb) : null
        });
      });
    }; // Updates the hierarchy when state changes


    var updateHierarchy = function updateHierarchy(_ref2) {
      var newItems = _ref2.newItems,
          oldItems = _ref2.oldItems,
          remeberCollaps = _ref2.remeberCollaps;
      var updateItems = newItems.map(function (item) {
        var itemContext = getItemContext(item.isRootItem);
        var i = oldItems.find(function (e) {
          return e.id === item.id;
        });
        return _objectSpread2(_objectSpread2(_objectSpread2({}, item), itemContext), {}, {
          isRootItem: i.isRootItem,
          layer: i.layer,
          breadcrumb: i.breadcrumb,
          children: item.children ? updateHierarchy({
            newItems: item.children,
            oldItems: oldItems,
            remeberCollaps: remeberCollaps
          }) : null,
          isCollapsed: remeberCollaps ? i.isCollapsed : item.isCollapsed
        });
      });
      return updateItems;
    };

    var oldItems = itemHierarchy ? new Organisation(itemHierarchy[0]).getItems() : {};
    var newItems = new Organisation(rootItem[0]).getItems();
    var itemsChanged = oldItems.length >= newItems.length;
    var remeberCollaps = oldItems.length === newItems.length;
    setItemHierarchy(itemHierarchy && itemsChanged ? updateHierarchy({
      newItems: rootItem,
      oldItems: oldItems,
      remeberCollaps: remeberCollaps
    }) : createHierarchy(rootItem)); //eslint-disable-next-line
  }, [items]); // Creates the actual list

  useEffect(function () {
    if (!items || !itemHierarchy) return;

    var createNewListItems = function createNewListItems(items) {
      return items.reduce(function (acc, item) {
        if (listItems && listItems.some(function (i) {
          return i.id === item.id && item.isCollapsed;
        })) item.isCollapsed = item.isCollapsed || true;
        if (item.isCollapsed) return [].concat(_toConsumableArray(acc), [item]);
        return [].concat(_toConsumableArray(acc), [item], _toConsumableArray(createNewListItems(item.children)));
      }, []);
    };

    var newListItems = createNewListItems(itemHierarchy); // In order to correctly show bottom borders, we need to know what layer
    // the next item is on.

    var newListLength = newListItems.length;
    newListItems.forEach(function (item, idx) {
      item.nextLayer = idx + 1 === newListLength ? 0 : newListItems[idx + 1].layer;
    });
    newListItems.forEach(function (e) {
      items.forEach(function (i) {
        if (i.id === e.id) e.isIndeterminate = i.isIndeterminate;
      });
    });
    setNoItems(!newListItems.filter(function (i) {
      return i.isHidden === false;
    }).length);
    setListItems(newListItems); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemHierarchy]);

  var onItemClick = function onItemClick(item) {
    var toggle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // Only toggle the item if the toggle button is clicked
    item.isCollapsed = toggle ? !item.isCollapsed : false;
    setItemHierarchy(_toConsumableArray(itemHierarchy));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "100%",
      overflow: "auto"
    }
  }, noResults ? /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        height: "70%",
        minHeight: "200px",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        gap: "10px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "Org",
    style: {
      fontSize: "50px",
      color: "#107c10"
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "mediumPlus"
  }, i18n._(
  /*i18n*/
  {
    id: "No organisational units found"
  }))) : noItems ? /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        height: "70%",
        minHeight: "200px",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        gap: "10px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "Org",
    style: {
      fontSize: "50px",
      color: "#107c10"
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "mediumPlus"
  }, i18n._(
  /*i18n*/
  {
    id: "No items available"
  }))) : /*#__PURE__*/React__default.createElement(List, {
    items: listItems,
    renderedWindowsAhead: 100,
    onRenderCell: function onRenderCell(item) {
      return !item.isHidden ? OnRenderCell ? /*#__PURE__*/React__default.createElement(OnRenderCell, {
        item: item,
        listItemProps: listItemProps,
        onItemClick: onItemClick,
        onChange: onChange,
        ouLimit: ouLimit
      }) : /*#__PURE__*/React__default.createElement(TreeListItem, {
        item: item,
        listItemProps: listItemProps,
        onItemClick: onItemClick,
        onChange: onChange,
        ouLimit: ouLimit
      }) : "";
    }
  }));
};

var onRenderHeader = function onRenderHeader(_ref) {
  var group = _ref.group,
      onToggleCollapse = _ref.onToggleCollapse;
  var name = group.name,
      isCollapsed = group.isCollapsed;
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    onClick: function onClick() {
      return onToggleCollapse(group);
    },
    styles: {
      root: {
        minHeight: 40,
        cursor: "pointer"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        padding: 8,
        selectors: {
          "&:hover": {
            backgroundColor: DefaultPalette$2.neutralLighter
          }
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: isCollapsed ? "ChevronRightMed" : "ChevronDownMed"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium",
    nowrap: true,
    block: true
  }, name));
};

var _onRenderCell = function onRenderCell(options) {
  return options.listItemProps.onRenderGroup ? options.listItemProps.onRenderGroup(options) : /*#__PURE__*/React__default.createElement(GroupedListItem, options);
};

var GroupedList = function GroupedList(_ref2) {
  var items = _ref2.items,
      onCheckboxChange = _ref2.onCheckboxChange,
      listItemProps = _ref2.listItemProps;
  var groupedListKey = listItemProps.groupedListKey;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listItems = _useState2[0],
      setListItems = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      listGroups = _useState4[0],
      setListGroups = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedIndex = _useState6[0],
      setSelectedIndex = _useState6[1];

  useEffect(function () {
    if (!items) return;
    var newSortedListItems = items.sort(function (a, b) {
      return a[groupedListKey].localeCompare(b[groupedListKey]);
    });
    setSelectedIndex(-1); // Add `isLast` to the items, denoting if the item is the last in its group

    var newListItemsWithGroupContext = newSortedListItems.map(function (item, idx, items) {
      var itemGroup = item[groupedListKey];
      var nextItemsGroup = items[idx + 1] && items[idx + 1][groupedListKey];
      item.isLast = itemGroup !== nextItemsGroup;
      return item;
    });
    setListItems(newListItemsWithGroupContext);
  }, [groupedListKey, items]);
  useEffect(function () {
    if (!listItems) return;
    setListGroups(function (prevGroups) {
      var previousCollapsedState = prevGroups.reduce(function (acc, group) {
        acc[group.name] = group.isCollapsed;
        return acc;
      }, {});
      var newGroups = listItems.reduce(function (acc, item, idx) {
        var groupName = item[groupedListKey];

        if (!acc[groupName]) {
          var isCollapsed = previousCollapsedState[groupName] !== undefined ? previousCollapsedState[groupName] : false;
          acc[groupName] = {
            name: groupName,
            key: groupName,
            level: 0,
            startIndex: idx,
            count: 1,
            isCollapsed: isCollapsed
          };
        } else {
          acc[groupName].count++;
        }

        return acc;
      }, {});
      return Object.keys(newGroups).map(function (groupName) {
        var group = newGroups[groupName];
        var startIndex = group.startIndex;
        var endIndex = group.startIndex + group.count;
        var containsSelectedItem = selectedIndex >= startIndex && selectedIndex < endIndex;
        group.isCollapsed = containsSelectedItem ? false : group.isCollapsed;
        group.endIndex = endIndex;
        return group;
      });
    });
  }, [groupedListKey, items, listItems, selectedIndex]);
  return /*#__PURE__*/React__default.createElement(GroupedList$2, {
    items: listItems,
    groups: listGroups,
    onRenderCell: function onRenderCell(nestingDepth, item, index) {
      return _onRenderCell({
        item: item,
        index: index,
        listGroups: listGroups,
        selected: false,
        listItemProps: listItemProps,
        onCheckboxChange: onCheckboxChange
      });
    },
    selectionMode: SelectionMode.none,
    groupProps: {
      onRenderHeader: onRenderHeader
    }
  });
};

function deepCompare(a, b) {
  if (_typeof(a) !== _typeof(b)) {
    return false;
  }

  if (_typeof(a) === "object" && a !== null && b !== null) {
    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) {
        return false;
      }

      var found = Array(a.length).fill(false);

      for (var index = 0; index < a.length; index++) {
        for (var i = 0; i < b.length; i++) {
          if (!found[i] && deepCompare(a[index], b[i])) {
            found[i] = true;
            break;
          }
        }
      }

      return found.every(function (match) {
        return match;
      });
    } else {
      var keysA = Object.keys(a);
      var keysB = Object.keys(b);

      if (keysA.length !== keysB.length) {
        return false;
      }

      for (var _i = 0, _keysA = keysA; _i < _keysA.length; _i++) {
        var key = _keysA[_i];

        if (!keysB.includes(key) || !deepCompare(a[key], b[key])) {
          return false;
        }
      }
    }

    return true;
  } else {
    if (a !== b) {
      return false;
    }

    return true;
  }
}

/**
 * @param {object} data the tree which the search is performed on
 * @param {array} keys the keys to search in
 **/

function useTreeSearch(data) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      previousSearchValue = _useState4[0],
      setPreviousSearchValue = _useState4[1];

  var _useState5 = useState(data),
      _useState6 = _slicedToArray(_useState5, 2),
      previousData = _useState6[0],
      setPreviousData = _useState6[1];

  var _useState7 = useState(undefined),
      _useState8 = _slicedToArray(_useState7, 2),
      previousResult = _useState8[0],
      setPreviousResult = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      noResults = _useState10[0],
      setNoResults = _useState10[1];

  var filteredOptions = useMemo(function () {
    if (!data) return undefined;

    if (searchValue === previousSearchValue && deepCompare(data, previousData)) {
      return previousResult;
    }

    if (searchValue === "" && !previousSearchValue === searchValue) {
      setNoResults(false);
      setPreviousSearchValue(searchValue);
      return data;
    }

    setPreviousSearchValue(searchValue);
    setPreviousData(data);
    var flatOus = new Organisation(data).getItems();
    var result = flatOus.filter(function (item) {
      return !item.isHidden && keys.some(function (key) {
        var value = item[key];

        if (typeof value === "string") {
          return value.toLowerCase().includes(searchValue.toLowerCase());
        }

        return false;
      });
    });
    setNoResults(result.length === 0 || result.length === 1 && result[0].readOnly);
    var res = OrgHelper.getSearchedItems(result, data);
    setPreviousResult(res);
    return res;
  }, [data, keys, searchValue]);
  return {
    searchValue: searchValue,
    setSearchValue: setSearchValue,
    filteredOptions: filteredOptions,
    noResults: noResults
  };
}

function handleIndeterminateItems(items) {
  return items.map(function (item) {
    var children = item.children.length ? handleIndeterminateItems(item.children) : [];
    return _objectSpread2(_objectSpread2({}, item), {}, {
      isIndeterminate: !item.isChecked ? new Organisation(item).getItems().filter(function (o) {
        return o.isChecked === true;
      }).length > 0 : false,
      children: children
    });
  });
} // Set items isChecked from selected items


function handleSelectedItems(items, selectedItems) {
  return items.map(function (item) {
    var children = item.children.length ? handleSelectedItems(item.children, selectedItems) : [];
    return _objectSpread2(_objectSpread2({}, item), {}, {
      isChecked: selectedItems.find(function (id) {
        return id === item.id;
      }) ? true : false,
      canSelect: !item.readOnly,
      isHidden: item.isHidden,
      children: children
    });
  });
} // Set isHidden from readonly items


function handleHiddenItems(items) {
  return items.map(function (item) {
    var children = item.children.length ? handleHiddenItems(item.children) : [];
    return _objectSpread2(_objectSpread2({}, item), {}, {
      isHidden: item.readOnly ? new Organisation(item).getItems().filter(function (o) {
        return o.readOnly !== true;
      }).length === 0 : false,
      children: children
    });
  });
} // Set readonyly from filted items


function handleReadOnlyItems(items, filterItems) {
  if (!filterItems) return items;
  return items.map(function (item) {
    var children = item.children.length ? handleReadOnlyItems(item.children, filterItems) : [];
    return _objectSpread2(_objectSpread2({}, item), {}, {
      readOnly: !filterItems.find(function (id) {
        return id === item.id;
      }) ? true : item.readOnly,
      children: children
    });
  });
}

function handleFilterItems(items, filterItems) {
  return handleHiddenItems(handleReadOnlyItems(items, filterItems));
}

var SelectionTreeList = function SelectionTreeList(_ref) {
  var items = _ref.items,
      filterItems = _ref.filterItems,
      selectedFilterItems = _ref.selectedFilterItems,
      setSelectedFilterItems = _ref.setSelectedFilterItems,
      disableSecondaryTextKey = _ref.disableSecondaryTextKey;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      orgItems = _useState2[0],
      setOrgItems = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      defaultedCollapsed = _useState4[0],
      setDefaultedCollapsed = _useState4[1];

  var _useTreeSearch = useTreeSearch(items, ["name", "id"]),
      searchValue = _useTreeSearch.searchValue,
      setSearchValue = _useTreeSearch.setSearchValue,
      filteredOptions = _useTreeSearch.filteredOptions,
      noResults = _useTreeSearch.noResults;

  useEffect(function () {
    if (!items) return; // set tree item propperties

    var ous = handleIndeterminateItems(handleSelectedItems(handleFilterItems([OrgHelper.applyCheckboxOptions(filteredOptions || items)], filterItems), selectedFilterItems))[0]; // List should be collaped if more than 30 items is shown in the list

    if (defaultedCollapsed) setDefaultedCollapsed(new Organisation(ous).getItems().filter(function (o) {
      return o.isHidden === false;
    }).length > 30);
    setOrgItems([ous]); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredOptions, items, selectedFilterItems, filterItems]); //

  var handleCheckboxChange = function handleCheckboxChange(ous, id, checked) {
    var selectedItems = checked ? ous.concat(selectedFilterItems.filter(function (i) {
      return ous.indexOf(i) < 0;
    })) : selectedFilterItems.filter(function (i) {
      return i !== id;
    });
    setSelectedFilterItems(selectedItems);
  };

  var onCheckboxChange = function onCheckboxChange(e, checked) {
    setDefaultedCollapsed(false);

    function setOrgItemChecked(ous, id, checked) {
      ous.map(function (ou) {
        // Handle item and all its children on selected id
        if (ou.id === id) handleCheckboxChange(new Organisation(ou).getItems().filter(function (i) {
          return !i.isHidden;
        }).map(function (o) {
          return o.id;
        }), id, checked);else setOrgItemChecked(ou.children, id, checked);
      });
    }

    setOrgItemChecked(filteredOptions ? [filteredOptions] : orgItems, e.target.id, checked);
  };

  if (!orgItems.length) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(SearchBox, {
    autoFocus: true,
    placeholder: i18n._(
    /*i18n*/
    {
      id: "Search by name or uuid"
    }),
    value: searchValue,
    onChange: function onChange(e) {
      var _e$target, _e$target$value;

      setSearchValue((e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$value = _e$target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.trim()) || "");
    },
    styles: {
      root: {
        marginBottom: "5px"
      }
    }
  }), /*#__PURE__*/React__default.createElement(Separator, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "calc(100vh - 300px)",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React__default.createElement(TreeList, {
    items: orgItems,
    onChange: onCheckboxChange,
    listItemProps: {
      orgName: "administrative",
      iconProps: {
        iconName: "Org",
        color: DefaultPalette$2.green,
        colorLighter: DefaultPalette$2.greenLight,
        inverted: false
      },
      primaryTextKey: "name",
      secondaryTextKey: !disableSecondaryTextKey ? "employeeCount" : ""
    },
    defaultedCollapsed: defaultedCollapsed,
    noResults: noResults
  })));
};

var ItSystem = function ItSystem(_ref) {
  var items = _ref.items,
      filterItems = _ref.filterItems,
      filterItemsKey = _ref.filterItemsKey,
      selectedFilterItems = _ref.selectedFilterItems,
      setSelectedFilterItems = _ref.setSelectedFilterItems,
      clearSelectedFilterItems = _ref.clearSelectedFilterItems,
      setClearSelectedFilterItems = _ref.setClearSelectedFilterItems,
      reRenderFilter = _ref.reRenderFilter;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      systemItems = _useState2[0],
      setSystemItems = _useState2[1]; // Clear selected Items


  useEffect(function () {
    var newSystemItems = [];

    if (systemItems && clearSelectedFilterItems) {
      systemItems.forEach(function (item) {
        item.isChecked = false;
        newSystemItems.push(item);
      });
      setClearSelectedFilterItems(false);
      setSystemItems(newSystemItems);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [clearSelectedFilterItems]);
  useEffect(function () {
    if (items) {
      //Find IT systems that can be filtered
      var itemSystemList = _toConsumableArray(new Set(items.map(function (i) {
        return i[filterItemsKey] ? i[filterItemsKey].id : null;
      })));

      var systemList = [];
      filterItems.forEach(function (system) {
        if (itemSystemList.some(function (l) {
          return l === system.id && system.category !== "";
        })) systemList.push(system);
      });
      setSystemItems(setCheckboxProps(systemList));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [items, filterItems, filterItemsKey, reRenderFilter]);

  var setCheckboxProps = function setCheckboxProps(items) {
    var newItems = items.map(function (item) {
      return {
        name: item.name,
        id: item.id,
        category: item.category,
        canSelect: true,
        isHidden: false,
        isChecked: selectedFilterItems.some(function (i) {
          return i === item.id;
        })
      };
    });
    return newItems;
  }; // Handle IT systems selected


  var handleSelectedItem = function handleSelectedItem(id, checked) {
    var newSelectedItems = [];

    if (checked) {
      selectedFilterItems.forEach(function (item) {
        newSelectedItems.push(item);
      });
      newSelectedItems.push(id);
      selectedFilterItems = newSelectedItems;
    } else {
      selectedFilterItems.forEach(function (item) {
        if (item !== id) {
          newSelectedItems.push(item);
        }
      });
      selectedFilterItems = newSelectedItems;
    }

    setSelectedFilterItems(selectedFilterItems);
  };

  var handleItemIsChecked = function handleItemIsChecked(id, checked) {
    var newSystemItems = [];
    systemItems.forEach(function (systemItem) {
      if (systemItem.id === id) systemItem.isChecked = checked;
      newSystemItems.push(systemItem);
    });
    setSystemItems(newSystemItems);
  };

  var onCheckboxChange = function onCheckboxChange(e, checked) {
    var id = e.target.id;
    handleSelectedItem(id, checked);
    handleItemIsChecked(id, checked);
  };

  return /*#__PURE__*/React__default.createElement(GroupedList, {
    items: systemItems,
    onCheckboxChange: onCheckboxChange,
    listItemProps: {
      iconProps: {
        iconName: "System",
        color: DefaultPalette$2.orange,
        colorLighter: DefaultPalette$2.orangeLight,
        inverted: false
      },
      primaryTextKey: "name",
      groupedListKey: "category"
    }
  });
};

/**
 * Hook to generate a unique ID in the global scope (spanning across duplicate copies of the same library).
 *
 * @param prefix - Optional prefix for the ID
 * @param providedId - Optional id provided by a parent component. Defaults to the provided value if present,
 *  without conditioning the hook call
 * @returns The ID
 */

function useId(prefix, providedId) {
  // getId should only be called once since it updates the global constant for the next ID value.
  // (While an extra update isn't likely to cause problems in practice, it's better to avoid it.)
  var ref = useRef(providedId);

  if (!ref.current) {
    ref.current = getId(prefix);
  }

  return ref.current;
}

var stackTokens = {
  childrenGap: 4,
  maxWidth: 300
};
var CustomLabel = function CustomLabel(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isCalloutVisible = _useState2[0],
      toggleIsCalloutVisible = _useState2[1];

  var descriptionId = useId("description");
  var iconButtonId = useId("iconButton");
  var _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles,
      required = props.required,
      label = props.label,
      labelIconProps = props.labelIconProps;
  var iconButtonStyles = {
    root: {
      marginBottom: -3,
      padding: 5,
      color: DefaultPalette.blue,
      selectors: {
        "&:hover": {
          backgroundColor: DefaultPalette.neutralLighter,
          cursor: "pointer"
        }
      }
    }
  };
  var iconStyles = {
    root: {
      marginBottom: -3,
      paddingLeft: 5,
      color: DefaultPalette.blue
    }
  };
  var labelCalloutStackStyles = {
    root: {
      padding: 20
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    tokens: stackTokens
  }, required ? /*#__PURE__*/React__default.createElement(Label, {
    styles: styles,
    required: true
  }, label) : /*#__PURE__*/React__default.createElement(Label, {
    styles: styles
  }, label), labelIconProps ? labelIconProps.callOutText ? /*#__PURE__*/React__default.createElement(Icon, {
    id: iconButtonId,
    iconName: labelIconProps.iconName,
    callOutText: labelIconProps.callOutText,
    title: labelIconProps.title,
    ariaLabel: labelIconProps.ariaLabel,
    onClick: function onClick() {
      return toggleIsCalloutVisible(true);
    },
    styles: iconButtonStyles
  }) : /*#__PURE__*/React__default.createElement(Icon, {
    id: iconButtonId,
    iconName: labelIconProps.iconName,
    title: labelIconProps.title,
    ariaLabel: labelIconProps.ariaLabel,
    styles: iconStyles
  }) : ""), isCalloutVisible && labelIconProps && labelIconProps.callOutText && /*#__PURE__*/React__default.createElement(Callout, {
    target: "#" + iconButtonId,
    setInitialFocus: true,
    onDismiss: function onDismiss() {
      return toggleIsCalloutVisible(false);
    },
    ariaDescribedBy: descriptionId,
    role: "alertdialog"
  }, /*#__PURE__*/React__default.createElement(Stack, {
    tokens: stackTokens,
    horizontalAlign: "start",
    styles: labelCalloutStackStyles
  }, /*#__PURE__*/React__default.createElement("span", {
    id: descriptionId,
    style: {
      whiteSpace: "pre-wrap"
    }
  }, labelIconProps.callOutText))));
};

var rootClass = mergeStyles$1({
  maxWidth: 300,
  selectors: {
    "> *": {
      marginBottom: 15
    }
  }
}); // Translation of DatePicker values

var DayPickerStrings = {
  months: [i18n._(
  /*i18n*/
  {
    id: "January"
  }), i18n._(
  /*i18n*/
  {
    id: "February"
  }), i18n._(
  /*i18n*/
  {
    id: "March"
  }), i18n._(
  /*i18n*/
  {
    id: "April"
  }), i18n._(
  /*i18n*/
  {
    id: "May"
  }), i18n._(
  /*i18n*/
  {
    id: "June"
  }), i18n._(
  /*i18n*/
  {
    id: "July"
  }), i18n._(
  /*i18n*/
  {
    id: "August"
  }), i18n._(
  /*i18n*/
  {
    id: "September"
  }), i18n._(
  /*i18n*/
  {
    id: "October"
  }), i18n._(
  /*i18n*/
  {
    id: "November"
  }), i18n._(
  /*i18n*/
  {
    id: "December"
  })],
  shortMonths: [i18n._(
  /*i18n*/
  {
    id: "Jan"
  }), i18n._(
  /*i18n*/
  {
    id: "Feb"
  }), i18n._(
  /*i18n*/
  {
    id: "Mar"
  }), i18n._(
  /*i18n*/
  {
    id: "Apr"
  }), i18n._(
  /*i18n*/
  {
    id: "May"
  }), i18n._(
  /*i18n*/
  {
    id: "Jun"
  }), i18n._(
  /*i18n*/
  {
    id: "Jul"
  }), i18n._(
  /*i18n*/
  {
    id: "Aug"
  }), i18n._(
  /*i18n*/
  {
    id: "Sep"
  }), i18n._(
  /*i18n*/
  {
    id: "Oct"
  }), i18n._(
  /*i18n*/
  {
    id: "Nov"
  }), i18n._(
  /*i18n*/
  {
    id: "Dec"
  })],
  days: [i18n._(
  /*i18n*/
  {
    id: "Sunday"
  }), i18n._(
  /*i18n*/
  {
    id: "Monday"
  }), i18n._(
  /*i18n*/
  {
    id: "Tuesday"
  }), i18n._(
  /*i18n*/
  {
    id: "Wednesday"
  }), i18n._(
  /*i18n*/
  {
    id: "Thursday"
  }), i18n._(
  /*i18n*/
  {
    id: "Friday"
  }), i18n._(
  /*i18n*/
  {
    id: "Saturday"
  })],
  shortDays: [i18n._(
  /*i18n*/
  {
    id: "Sunday"
  }).substring(0, 1), i18n._(
  /*i18n*/
  {
    id: "Monday"
  }).substring(0, 1), i18n._(
  /*i18n*/
  {
    id: "Tuesday"
  }).substring(0, 1), i18n._(
  /*i18n*/
  {
    id: "Wednesday"
  }).substring(0, 1), i18n._(
  /*i18n*/
  {
    id: "Thursday"
  }).substring(0, 1), i18n._(
  /*i18n*/
  {
    id: "Friday"
  }).substring(0, 1), i18n._(
  /*i18n*/
  {
    id: "Saturday"
  }).substring(0, 1)],
  goToToday: i18n._(
  /*i18n*/
  {
    id: "Go to today"
  }),
  prevMonthAriaLabel: i18n._(
  /*i18n*/
  {
    id: "Go to previous month"
  }),
  nextMonthAriaLabel: i18n._(
  /*i18n*/
  {
    id: "Go to next month"
  }),
  prevYearAriaLabel: i18n._(
  /*i18n*/
  {
    id: "Go to previous year"
  }),
  nextYearAriaLabel: i18n._(
  /*i18n*/
  {
    id: "Go to next year"
  }),
  isRequiredErrorMessage: i18n._(
  /*i18n*/
  {
    id: "Start date is required."
  }),
  invalidInputErrorMessage: i18n._(
  /*i18n*/
  {
    id: "Invalid date format."
  })
};
/**
 * @description Date picker field
 * @param {object} props
 *  @param {date} value Date value to DatePicker
 *  @param {date} minDate Minimum date to be picked in DatePicker
 *  @param {boolean} disabled Disable fields true or false
 *  @param {string} required Whether field is required or not - "true" or "false"
 *  @param {string} label Label text
 *  @param {object} labelIconProps CustomLabel settings
 *    @param {string} iconName
 *    @param {string} title
 *    @param {string} callOutText
 *    @param {string} ariaLabel
 *  @param {function} onSelectDate Handler to when date is changed
 */

var DatePickerField = function DatePickerField(props) {
  return /*#__PURE__*/React__default.createElement(Stack, null, props.label && /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: props.label,
    required: props.required ? props.required : false,
    labelIconProps: props.labelIconProps ? props.labelIconProps : {}
  }), /*#__PURE__*/React__default.createElement("div", {
    className: rootClass
  }, /*#__PURE__*/React__default.createElement(DatePicker, {
    value: props.value,
    firstDayOfWeek: DayOfWeek.Monday,
    showWeekNumbers: true,
    firstWeekOfYear: 2,
    showMonthPickerAsOverlay: true,
    formatDateTime: function formatDateTime(date) {
      return "".concat(date.getDate(), "-").concat(date.getMonth() + 1, "-").concat(date.getFullYear());
    },
    disabled: props.disabled ? props.disabled : false,
    onSelectDate: props.onSelectDate,
    minDate: props.minDate,
    strings: DayPickerStrings
  })));
};

var Dates = function Dates(_ref) {
  var selectedFilterItems = _ref.selectedFilterItems,
      setSelectedFilterItems = _ref.setSelectedFilterItems,
      clearSelectedFilterItems = _ref.clearSelectedFilterItems,
      setClearSelectedFilterItems = _ref.setClearSelectedFilterItems;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedFromDate = _useState2[0],
      setSelectedFromDate = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedToDate = _useState4[0],
      setSelectedToDate = _useState4[1]; // Handle clear and contextmenu selected filter items


  useEffect(function () {
    if (selectedFilterItems && selectedFilterItems.start) setSelectedFromDate(selectedFilterItems.start);else if (clearSelectedFilterItems) setSelectedFromDate("");
    if (selectedFilterItems && selectedFilterItems.end) setSelectedToDate(selectedFilterItems.end);else if (clearSelectedFilterItems) setSelectedToDate("");
    if (clearSelectedFilterItems) setClearSelectedFilterItems(false);
  }, [clearSelectedFilterItems, selectedFilterItems]); // Handle selected dates

  useEffect(function () {
    var newSelectedFilterItems = selectedFilterItems;

    if (selectedFromDate) {
      newSelectedFilterItems = _objectSpread2(_objectSpread2({}, newSelectedFilterItems), {}, {
        start: selectedFromDate
      });
    }

    if (selectedToDate) {
      newSelectedFilterItems = _objectSpread2(_objectSpread2({}, newSelectedFilterItems), {}, {
        end: selectedToDate
      });
    }

    setSelectedFilterItems(newSelectedFilterItems);
  }, [selectedFromDate, selectedToDate]);
  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(DatePickerField, {
    label: i18n._(
    /*i18n*/
    {
      id: "From Date"
    }),
    value: selectedFromDate,
    onSelectDate: function onSelectDate(date) {
      return setSelectedFromDate(date);
    }
  }), /*#__PURE__*/React__default.createElement(DatePickerField, {
    label: i18n._(
    /*i18n*/
    {
      id: "To Date"
    }),
    value: selectedToDate,
    onSelectDate: function onSelectDate(date) {
      return setSelectedToDate(date);
    }
  }));
};

var FilterPanel = function FilterPanel(_ref) {
  var column = _ref.column,
      isPanelOpen = _ref.isPanelOpen,
      onPanelClose = _ref.onPanelClose,
      filterProps = _ref.filterProps,
      handleApplyFilter = _ref.handleApplyFilter,
      defaultFilterItems = _ref.defaultFilterItems,
      setDefaultFilterItems = _ref.setDefaultFilterItems,
      clearFilter = _ref.clearFilter,
      handleClearFilter = _ref.handleClearFilter;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      filterName = _useState2[0],
      setFilterName = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedFilterItems = _useState4[0],
      setSelectedFilterItems = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      countFilters = _useState6[0],
      setCountFilters = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      reRenderFilter = _useState8[0],
      setReRenderFilter = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isApplyDisabled = _useState10[0],
      setIsApplyDisabled = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      clearSelectedFilterItems = _useState12[0],
      setClearSelectedFilterItems = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      originalSelectedFilterItems = _useState14[0],
      setOriginalSelectedFilterItems = _useState14[1];

  var location = useLocation();
  var history = useHistory();

  var clearSelected = function clearSelected(ev) {
    // Clear all filters
    setSelectedFilterItems([]);
    setClearSelectedFilterItems(true);
    setDefaultFilterItems(_objectSpread2(_objectSpread2({}, defaultFilterItems), {}, {
      isDefaultFilter: false
    }));
  }; // Set selected filter items


  useEffect(function () {
    if (!filterProps || !column) return;
    var newSelectedFilterItems = selectedFilterItems;

    if (filterProps.length) {
      filterProps.forEach(function (p) {
        if (p.column && p.column.key === column.key) {
          newSelectedFilterItems = p.selectedItems;
        }
      });
      setSelectedFilterItems(newSelectedFilterItems);
      setOriginalSelectedFilterItems(selectedFilterItems);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [column, filterProps]);
  useEffect(function () {
    // When selected filter items changes the filter selection should be rerendered
    // Used on list that updates automatically
    if (selectedFilterItems !== reRenderFilter) setReRenderFilter(""); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilterItems]);
  useEffect(function () {
    if (!column) return;
    var newCount = 0;

    if (props.filterHandlerType !== "ENDPOINT_FILTER" && selectedFilterItems) {
      // Count selected filter items to show in filter header
      selectedFilterItems.forEach(function (item) {
        if (column.columnContextMenuProps.filterItems.some(function (filterItem) {
          return filterItem[column.columnContextMenuProps.itemsKey] === item;
        })) newCount++;
      });
      setCountFilters(newCount);
    } // Set name of filter header to column name


    setFilterName(column.name); // Set status on Apply button

    setIsApplyDisabled(selectedFilterItems === originalSelectedFilterItems); // If default filter set default filter items

    if (defaultFilterItems && defaultFilterItems.showButton) {
      var defaultSelectedFilterItems = defaultFilterItems.filter.selectedItems;
      var isDefaultFilter = true;
      if (selectedFilterItems.length === 0) isDefaultFilter = false;else if (selectedFilterItems.length === defaultSelectedFilterItems.length) {
        selectedFilterItems.forEach(function (item) {
          if (!defaultSelectedFilterItems.some(function (i) {
            return i === item;
          })) isDefaultFilter = false;
        });
      } else isDefaultFilter = false;
      setDefaultFilterItems(_objectSpread2(_objectSpread2({}, defaultFilterItems), {}, {
        isDefaultFilter: isDefaultFilter
      }));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [column, selectedFilterItems]);
  useEffect(function () {
    if (clearFilter) {
      //clearSelected();
      handleApplyFilter([{
        column: column,
        selectedItems: []
      }]);
    }
  }, [clearFilter]);
  if (!column) return "";

  var props = _objectSpread2({}, column.columnContextMenuProps); // Run `onPanelClose` when panel is dismissed, to validate any new assignments.


  function handleOnDismiss(e) {
    setSelectedFilterItems(originalSelectedFilterItems);
    e.preventDefault();
    onPanelClose();
  }

  var filterDefault = function filterDefault(ev) {
    // Return to default filter
    setSelectedFilterItems(defaultFilterItems.filter.selectedItems);
    setReRenderFilter(defaultFilterItems.filter.selectedItems);
    setDefaultFilterItems(_objectSpread2(_objectSpread2({}, defaultFilterItems), {}, {
      isDefaultFilter: true
    }));
  };

  function validateValue(value, time) {
    // If value is a date
    if (value && Object.prototype.toString.call(value) === "[object Date]" && !isNaN(value)) {
      var newTime = time ? time : {
        hour: 0,
        minutes: 0,
        seconds: 0
      };
      var date = value.setHours(newTime.hour, newTime.minutes, newTime.seconds);
      return format$1("yyyy-MM-dd HH:mm:ss")(date);
    } else return value;
  } // Used for paging filter


  var searchSelected = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ev) {
      var queryParams;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!props || !props.filterHandler)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              queryParams = new URLSearchParams(location.search); // If no dates set on apply, then clear filter

              if (selectedFilterItems.length === 0) {
                handleClearFilter();
              } else {
                Object.keys(selectedFilterItems).map(function (key) {
                  var value = validateValue(selectedFilterItems[key], key === "end" ? {
                    hour: 23,
                    minutes: 59,
                    seconds: 59
                  } : "");
                  queryParams.set(key, encodeURIComponent(value));
                  return "".concat(key, "=").concat(encodeURIComponent(value));
                });
                history.replace({
                  search: queryParams.toString()
                });
              }

              handleApplyFilter([{
                column: column,
                selectedItems: selectedFilterItems
              }]);
              onPanelClose();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function searchSelected(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var filterSelected = function filterSelected(ev) {
    // Filter on selected checkbokses
    handleApplyFilter([{
      column: column,
      itemsType: props.itemsType,
      itemsKey: props.itemsKey,
      selectedItems: selectedFilterItems
    }]);
    onPanelClose();
  };

  var onRenderFooterContent = function onRenderFooterContent() {
    return /*#__PURE__*/React__default.createElement(Stack, {
      styles: {
        root: {
          height: 80
        }
      }
    }, /*#__PURE__*/React__default.createElement(Separator, null), /*#__PURE__*/React__default.createElement(DialogFooter, null, /*#__PURE__*/React__default.createElement(PrimaryButton, {
      disabled: isApplyDisabled,
      onClick: props.filterHandlerType === "ENDPOINT_FILTER" ? searchSelected : filterSelected,
      text: i18n._(
      /*i18n*/
      {
        id: "Apply"
      })
    }), defaultFilterItems && defaultFilterItems.showButton && /*#__PURE__*/React__default.createElement(PrimaryButton, {
      disabled: defaultFilterItems.isDefaultFilter,
      onClick: filterDefault,
      text: i18n._(
      /*i18n*/
      {
        id: "Default filter"
      })
    }), /*#__PURE__*/React__default.createElement(DefaultButton, {
      onClick: clearSelected,
      text: i18n._(
      /*i18n*/
      {
        id: "Clear filter"
      })
    })));
  };

  return /*#__PURE__*/React__default.createElement(Panel, {
    isOpen: isPanelOpen,
    type: PanelType.medium,
    onDismiss: handleOnDismiss,
    headerText: countFilters ? i18n._(
    /*i18n*/
    {
      id: "Filter by"
    }) + " \"" + filterName + "\"" + " (" + countFilters + ")" : i18n._(
    /*i18n*/
    {
      id: "Filter by"
    }) + " \"" + filterName + "\"",
    closeButtonAriaLabel: i18n._(
    /*i18n*/
    {
      id: "Close"
    }),
    onRenderFooterContent: onRenderFooterContent
  }, props.filterType === "ORGUNITS" && /*#__PURE__*/React__default.createElement(SelectionTreeList, {
    items: props.items,
    filterItems: props.filterItems && props.filterItems.map(function (i) {
      return i.id;
    }),
    selectedFilterItems: selectedFilterItems,
    setSelectedFilterItems: setSelectedFilterItems,
    disableSecondaryTextKey: props.disableSecondaryTextKey
  }), props.filterType === "ITSYSTEM" && /*#__PURE__*/React__default.createElement(ItSystem, {
    items: props.items,
    filterItems: props.filterItems,
    filterItemsKey: props.itemsType,
    selectedFilterItems: selectedFilterItems,
    setSelectedFilterItems: setSelectedFilterItems,
    clearSelectedFilterItems: clearSelectedFilterItems,
    setClearSelectedFilterItems: setClearSelectedFilterItems,
    reRenderFilter: reRenderFilter
  }), props.filterType === "DATES" && /*#__PURE__*/React__default.createElement(Dates, {
    selectedFilterItems: selectedFilterItems,
    setSelectedFilterItems: setSelectedFilterItems,
    clearSelectedFilterItems: clearSelectedFilterItems,
    setClearSelectedFilterItems: setClearSelectedFilterItems
  }));
};

/**
 * @description The ViewDetailsList component implements the
 * @fluentui/reacts DetailsList component for the various item lists
 * across the idc apps, where items only need to be viewed, and not selected or
 * deselected.
 * @param {Object} props
 *    @param {Array} items The items to be displayed in the list
 *    @param {Array} columns The column definitions for the items
 *    @param {Boolean} alwaysShowColumns True if column should be shown even if theres is no items
 *    @param {Object} listItemProps The object to defined list type (ex. grouped list)
 *    @param {Boolean} urlParams True if url params should be used to filter items
 */

var ViewDetailsList = function ViewDetailsList(props) {
  var _props$shimmer = props.shimmer,
      shimmer = _props$shimmer === void 0 ? false : _props$shimmer,
      _props$urlParams = props.urlParams,
      urlParams = _props$urlParams === void 0 ? false : _props$urlParams;
  var filterIcon = "Filter"; // Icon on column when filter i selected

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      columnFilters = _useState2[0],
      setColumnFilters = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      columnSearchFilters = _useState4[0],
      setColumnSearchFilters = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      originalItems = _useState6[0],
      setOriginalItems = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      searchValue = _useState8[0],
      setSearchValue = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      sortColumns = _useState10[0],
      setSortColumns = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      items = _useState12[0],
      setItems = _useState12[1];

  var _useState13 = useState(""),
      _useState14 = _slicedToArray(_useState13, 2),
      pivotIcon = _useState14[0],
      setPivotIcon = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      clearFilter = _useState16[0],
      setClearFilter = _useState16[1]; // Defineds if defaultFilter is set
  // TODO should support endpoint filters


  var _useState17 = useState({
    setFilter: (props.defaultFilterItems && props.defaultFilterItems.selectedItems && props.defaultFilterItems.selectedItems.length) > 0 ? true : false,
    filter: props.defaultFilterItems,
    isDefaultFilter: false,
    showButton: (props.defaultFilterItems && props.defaultFilterItems.selectedItems && props.defaultFilterItems.selectedItems.length) > 0 ? true : false
  }),
      _useState18 = _slicedToArray(_useState17, 2),
      defaultFilterItems = _useState18[0],
      setDefaultFilterItems = _useState18[1];

  var _useState19 = useState(),
      _useState20 = _slicedToArray(_useState19, 2),
      columns = _useState20[0],
      setColumns = _useState20[1];

  var _useState21 = useState(),
      _useState22 = _slicedToArray(_useState21, 2),
      contextualMenuProps = _useState22[0],
      setContextualMenuProps = _useState22[1];

  var _useState23 = useState(),
      _useState24 = _slicedToArray(_useState23, 2),
      column = _useState24[0],
      setColumn = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      isPanelOpen = _useState26[0],
      setIsPanelOpen = _useState26[1];

  var _useState27 = useState(),
      _useState28 = _slicedToArray(_useState27, 2),
      selectedItemProps = _useState28[0],
      setSelectedItemProps = _useState28[1];

  var _useState29 = useState({}),
      _useState30 = _slicedToArray(_useState29, 2),
      contextualMenuItemTypeChecked = _useState30[0],
      setContextualMenuItemTypeChecked = _useState30[1];

  var _useState31 = useState(),
      _useState32 = _slicedToArray(_useState31, 2),
      groups = _useState32[0],
      setGroups = _useState32[1];

  var _useState33 = useState(),
      _useState34 = _slicedToArray(_useState33, 2),
      groupProps = _useState34[0],
      setGroupProps = _useState34[1];

  var _useState35 = useState(),
      _useState36 = _slicedToArray(_useState35, 2),
      listView = _useState36[0],
      setListView = _useState36[1];

  var _useState37 = useState(true),
      _useState38 = _slicedToArray(_useState37, 2),
      isAllCollapsed = _useState38[0],
      setIsAllCollapsed = _useState38[1];

  var location = useLocation();
  var history = useHistory(); // If different listviews

  useEffect(function () {
    if (props.listItemProps && props.listItemProps.listType) setListView(props.listItemProps.listType);
  }, [props.listItemProps]); // Handle column filters

  useEffect(function () {
    if (!props.columns) return;
    var newColumnFilters = props.columns.filter(function (column) {
      return column && column.applyColumnFilter;
    }); // Set column to filter on

    setColumnSearchFilters(newColumnFilters); // Set column if props.columns changes

    if (props.columns && columns && columns.length > 0) {
      setColumns(props.columns.filter(function (c) {
        return c !== null;
      }));
    }
  }, [props.columns]); // Handle filter items based on user entered input

  useEffect(function () {
    // If no items to show in the filter return
    if (!props.items) return;
    var listItemProps = props.listItemProps ? props.listItemProps : {}; // Set column to filter on

    if (props.columns && (!columns || columns.length === 0)) {
      setColumns(props.columns.filter(function (c) {
        return c !== null;
      }));
      return;
    } // Set orgininal items


    var newItems = props.items.map(function (item) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        key: item.id || item.id
      });
    }); // Sets original items to filter on based on user entered input

    setOriginalItems(newItems); // filter items based on user entered input

    var newUnsortedItems = searchValue ? newItems.filter(function (i) {
      return columnSearchFilters.some(function (c) {
        return (// Handle null and undefined values
          !!i[c.fieldName] && i[c.fieldName].toString().toLowerCase().indexOf(searchValue.toLowerCase()) > -1
        );
      });
    }) : newItems; // If default filter set it on first run
    // TODO Should support endpoint filters

    if (defaultFilterItems && defaultFilterItems.setFilter) {
      var _column = columns.find(function (c) {
        return c.key === defaultFilterItems.filter.columnKey;
      });

      var columnFilterProps = _column.columnContextMenuProps;
      if (!columnFilterProps.filterItems) return;
      var filterItemsKey = columnFilterProps.itemsKey;
      var selectedItems = defaultFilterItems.filter.selectedItems; // Only activate default filter if the items contains elements default filter can filter on

      var activateFilter = columnFilterProps.filterItems.some(function (item) {
        if (selectedItems.some(function (defaultItem) {
          return item[filterItemsKey] === defaultItem;
        })) return false;
        return true;
      }); // Activate default filter and set auto select selected items

      if (activateFilter) {
        var filterProps = [{
          column: _column,
          itemsType: columnFilterProps.itemsType,
          itemsKey: filterItemsKey,
          selectedItems: selectedItems
        }];
        setColumnFilters(filterProps);
        setSelectedItemProps(filterProps); // Set filter icon on pivot when filter is activated

        setPivotIcon(filterIcon);
      }

      setDefaultFilterItems(_objectSpread2(_objectSpread2({}, defaultFilterItems), {}, {
        setFilter: false,
        isDefaultFilter: activateFilter,
        showButton: activateFilter
      })); // If filter items selected filter on selected
    } else if (selectedItemProps) {
      selectedItemProps.forEach(function (itemProps) {
        if (itemProps.selectedItems.length) {
          newUnsortedItems = filterSelectedItems(newUnsortedItems, itemProps.itemsType, itemProps.itemsKey, itemProps.selectedItems);
        }
      });
    } // Find default or endpoint sort column


    if (columns) {
      var hasEndpointFilters = columns.find(function (col) {
        return col.isSorted && col.columnContextMenuProps && col.columnContextMenuProps.filterHandlerType === "ENDPOINT_FILTER";
      });

      if (!sortColumns || hasEndpointFilters) {
        setSortColumns(columns.find(function (col) {
          return col.isSorted;
        }));
      } // Else set selected sort column
      else {
        columns.forEach(function (col) {
          if (col.key === sortColumns.key) {
            col.isSorted = true;
            col.isSortedDescending = sortColumns.isSortedDescending;
          } else {
            col.isSorted = false;
            col.isSortedDescending = false;
          }
        });
      }
    }

    var sortedItems = sortColumns ? sortListItems(newUnsortedItems, sortColumns) : newUnsortedItems; // Set Listview

    if (listView === "grouped") {
      // If grouped listview
      if (!listItemProps.groups) return; // Set groupProps

      if (listItemProps.groupProps) setGroupProps(listItemProps.groupProps);
      var groupKey = listItemProps.groupedListKey; // Find startIndex and count per group from groupedListKey

      if (groupKey) {
        // If sort on groupKey
        var sortedGroups = listItemProps.groups;

        if (sortColumns && sortColumns.isSorted && sortColumns.key === groupKey) {
          sortedGroups = listItemProps.sort(function (a, b) {
            return a.name.localeCompare(b.name.toLowerCase());
          });
        } // Sort items on group key


        var newGroupedItems = sortGroupedItems(sortedItems, sortedGroups, groupKey);
        var startIndex = 0;
        var count = 0; // Set group index and count

        var indexedGroups = sortedGroups.map(function (g) {
          startIndex = startIndex + count;
          count = newGroupedItems.filter(function (i) {
            return i[groupKey] === g.key;
          }).length;
          return _objectSpread2(_objectSpread2({}, g), {}, {
            startIndex: startIndex,
            count: newGroupedItems.filter(function (i) {
              return i[groupKey] === g.key;
            }).length
          });
        });
        sortedItems = newGroupedItems;
        var newGroups = listItemProps.groupProps.showEmptyGroups ? indexedGroups : indexedGroups.filter(function (i) {
          return i.count > 0;
        });
        setGroups(newGroups.map(function (g) {
          return _objectSpread2(_objectSpread2({}, g), {}, {
            isCollapsed: searchValue === undefined || searchValue === "" ? g.isCollapsed : false
          });
        }));
      } else setGroups(listItemProps.groups);
    } else {
      // If flat list view
      setGroups();
      setGroupProps();
    } // Sort list


    setItems(sortedItems); // Set amount and filter icon og filtered items on pivot

    if (props.setAmountOfItems && selectedItemProps) props.setAmountOfItems({
      amount: newUnsortedItems.length,
      icon: pivotIcon,
      isDefaultFilter: defaultFilterItems.isDefaultFilter
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns, searchValue, sortColumns, columnFilters, props.items, selectedItemProps, listView]); // Handle cleared filter

  useEffect(function () {
    if (clearFilter) setClearFilter(false);
  }, [clearFilter]); // Set isAllCollapsed on groups

  useEffect(function () {
    if (!groups) return;
    var newGroups = groups.map(function (g) {
      return _objectSpread2(_objectSpread2({}, g), {}, {
        isCollapsed: isAllCollapsed
      });
    });
    props.setGroups(newGroups);
  }, [isAllCollapsed]); // Function to filter selected

  function filterSelectedItems(items, itemType, itemKey, selectedItems) {
    var newItems = items.filter(function (item) {
      return selectedItems.some(function (i) {
        if (item[itemType].length > 0) {
          return item[itemType].some(function (t) {
            return t[itemKey] === i || isNaN(t[itemKey]) && t[itemKey].toLowerCase().indexOf(i) > -1;
          });
        } else {
          return item[itemType][itemKey] ? item[itemType][itemKey] === i || isNaN(item[itemType][itemKey]) && item[itemType][itemKey].toLowerCase().indexOf(i) > -1 : item[itemType] === i || isNaN(item[itemType]) && item[itemType].toLowerCase().indexOf(i) > -1;
        }
      });
    });
    return newItems;
  } // Handle context menu dismissed


  var onContextualMenuDismissed = function onContextualMenuDismissed() {
    setContextualMenuProps(undefined);
  }; // Context menu items


  function getContextualMenuItems(ev, column, type) {
    // Filter panel elements
    var filterElements = [{
      key: "filter",
      name: i18n._(
      /*i18n*/
      {
        id: "Filter by"
      }),
      canCheck: true,
      checked: columnFilters.some(function (c) {
        return c.column && c.column.key === column.key && c.selectedItems.length > 0;
      }),
      onClick: function onClick() {
        return onFilterColumn(ev, column);
      },
      style: {
        borderTop: "1px solid ".concat(DefaultPalette.neutralLight)
      }
    }]; // Date elements

    var dateChoices = [{
      key: "section1",
      itemType: ContextualMenuItemType.Section,
      sectionProps: {
        topDivider: true,
        bottomDivider: true,
        title: i18n._(
        /*i18n*/
        {
          id: "Filter by"
        }),
        items: [{
          key: "oneweek",
          name: i18n._(
          /*i18n*/
          {
            id: "1 week"
          }),
          iconProps: {
            iconName: "Calendar"
          },
          canCheck: true,
          checked: contextualMenuItemTypeChecked[column.key] === 1,
          onClick: function onClick() {
            var d = new Date();
            d.setDate(d.getDate() - 7);
            setContextualMenuItemTypeChecked(_defineProperty({}, column.key, 1));
            onDaysClickedColumn(ev, column, d);
          }
        }, {
          key: "onemonth",
          name: i18n._(
          /*i18n*/
          {
            id: "1 month"
          }),
          iconProps: {
            iconName: "Calendar"
          },
          canCheck: true,
          checked: contextualMenuItemTypeChecked[column.key] === 2,
          onClick: function onClick() {
            var d = new Date();
            d.setMonth(d.getMonth() - 1);
            setContextualMenuItemTypeChecked(_defineProperty({}, column.key, 2));
            onDaysClickedColumn(ev, column, d);
          }
        }, {
          key: "treemonths",
          name: i18n._(
          /*i18n*/
          {
            id: "3 months"
          }),
          iconProps: {
            iconName: "Calendar"
          },
          canCheck: true,
          checked: contextualMenuItemTypeChecked[column.key] === 3,
          onClick: function onClick() {
            var d = new Date();
            d.setMonth(d.getMonth() - 3);
            setContextualMenuItemTypeChecked(_defineProperty({}, column.key, 3));
            onDaysClickedColumn(ev, column, d);
          }
        }].concat(filterElements)
      }
    }]; // Sort on date elements

    var sortOnDateElements = [{
      key: "oldest",
      name: i18n._(
      /*i18n*/
      {
        id: "Oldest on top"
      }),
      iconProps: {
        iconName: "SortUp"
      },
      canCheck: true,
      checked: column.isSorted && !column.isSortedDescending,
      onClick: function onClick() {
        return onSortClickedColumn(ev, column);
      }
    }, {
      key: "newest",
      name: i18n._(
      /*i18n*/
      {
        id: "Newest on top"
      }),
      iconProps: {
        iconName: "SortDown"
      },
      canCheck: true,
      checked: column.isSorted && column.isSortedDescending,
      onClick: function onClick() {
        return onSortClickedColumn(ev, column);
      }
    }]; // Sort alphabetical elements

    var sortAlphabeticalElements = [{
      key: "aToZ",
      name: i18n._(
      /*i18n*/
      {
        id: "A to Z"
      }),
      iconProps: {
        iconName: "SortUp"
      },
      canCheck: true,
      checked: column.isSorted && !column.isSortedDescending,
      onClick: function onClick() {
        return onSortClickedColumn(ev, column);
      }
    }, {
      key: "zToA",
      name: i18n._(
      /*i18n*/
      {
        id: "Z to A"
      }),
      iconProps: {
        iconName: "SortDown"
      },
      canCheck: true,
      checked: column.isSorted && column.isSortedDescending,
      onClick: function onClick() {
        return onSortClickedColumn(ev, column);
      }
    }];

    switch (type) {
      case "DATES":
        return [].concat(sortOnDateElements, dateChoices);

      default:
        return [].concat(sortAlphabeticalElements, filterElements);
    }
  } // Context menu properties


  var getContextualMenuProps = function getContextualMenuProps(ev, column) {
    var type = column.columnContextMenuProps ? column.columnContextMenuProps.filterType : "";
    var elements = getContextualMenuItems(ev, column, type);
    setContextualMenuProps({
      items: elements,
      target: ev.currentTarget,
      directionalHint: DirectionalHint.bottomLeftEdge,
      isBeakVisible: false,
      onDismiss: onContextualMenuDismissed,
      styles: {
        root: {
          height: type === "DATES" ? 254 : 110
        }
      }
    });
  };

  var onColumnContextMenu = function onColumnContextMenu(ev, column) {
    getContextualMenuProps(ev, column);
  }; // Clear paging filters


  var handleClearFilter = function handleClearFilter() {
    setClearFilter(true);
    if (!urlParams) return;
    var queryParams = new URLSearchParams(location.search);
    var params = Array.from(queryParams); // Remove search and filter paramenters from URL

    params.forEach(function (key) {
      if (key[0] !== "pagesize" && key[0] !== "pageno") queryParams["delete"](key[0]);
    }); // Set default pagenumber

    queryParams.set("pageno", 1);
    history.replace({
      search: queryParams.toString()
    });
  }; // Context menu date selection handler


  var onDaysClickedColumn = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ev, column, date) {
      var queryParams;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(column.columnContextMenuProps && column.columnContextMenuProps.filterHandlerType === "ENDPOINT_FILTER")) {
                _context.next = 8;
                break;
              }

              props.setMoveToFirst(true);

              if (urlParams) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              // Get items from endpoint with filter
              queryParams = new URLSearchParams(location.search);
              queryParams.set("start", format$1("yyyy-MM-dd HH:mm:ss")(date));
              queryParams.set("end", moment().format("YYYY-MM-DD HH:mm:ss"));
              history.replace({
                search: queryParams.toString()
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onDaysClickedColumn(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(); // Context menu sort handler


  var onSortClickedColumn = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ev, column) {
      var newColumns, currColumn, queryParams;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              newColumns = _toConsumableArray(columns);
              currColumn = newColumns.find(function (newCol) {
                return column.key === newCol.key;
              }); // Update the columns to reflect the user's selection.

              newColumns.forEach(function (col) {
                if (col === currColumn) {
                  // If the current column is already sorted, then reverse the sort,
                  // otherwise we sort descending.
                  currColumn.isSortedDescending = !currColumn.isSorted ? false : !currColumn.isSortedDescending;
                  currColumn.isSorted = true;
                } else {
                  col.isSorted = false;
                }
              });

              if (urlParams) {
                queryParams = new URLSearchParams(location.search);
                queryParams.set("sortby", column.fieldName);
                queryParams.set("sortorder", currColumn.isSortedDescending ? "desc" : "asc");
                history.replace({
                  search: queryParams.toString()
                });
              } // Set the new items and columns.


              setSortColumns(currColumn);
              setColumns(newColumns);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSortClickedColumn(_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }(); // Column click handler


  var onColumnClick = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ev, column) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (column.applyColumnContextMenu) {
                onColumnContextMenu(ev, column);
              } else if (column.applyPagingClearFilter) {
                handleClearFilter();
              } else {
                onSortClickedColumn(ev, column);
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function onColumnClick(_x6, _x7) {
      return _ref3.apply(this, arguments);
    };
  }(); // Panel close handler


  function onPanelClose() {
    setIsPanelOpen(false);
  } // Context menu panel filter choise handler


  var onFilterColumn = function onFilterColumn(ev, column) {
    setColumn(column);
    setIsPanelOpen(true);
  }; // Apply filter handler for filter panel


  var handleApplyFilter = function handleApplyFilter(filterProps) {
    setContextualMenuItemTypeChecked({});
    setColumnFilters(filterProps);
    setSelectedItemProps(filterProps);
    var hasSelectedItems = false;
    filterProps.forEach(function (column) {
      if (column.selectedItems.length) hasSelectedItems = true;
    });
    if (hasSelectedItems) setPivotIcon(filterIcon);else setPivotIcon("");
  }; // Search handler


  var onChangeFilterText = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(ev, text) {
      var filterHandlers, queryParams, newUnsortedItems;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              filterHandlers = columnSearchFilters.filter(function (c) {
                return c.columnFilterProps && c.columnFilterProps.filterHandlerType === "ENDPOINT_FILTER";
              }); // If filter by endpoint search

              if (filterHandlers && filterHandlers.length > 0 && urlParams) {
                queryParams = new URLSearchParams(location.search);
                props.setMoveToFirst(true);
                filterHandlers.map(function (f) {
                  if (!encodeURIComponent(text) || text === "") {
                    queryParams["delete"](f.fieldName);
                  } else {
                    // Set default pagenumber
                    queryParams.set(f.fieldName, encodeURIComponent(text));
                  }
                });
                history.replace({
                  search: queryParams.toString()
                });
              } else {
                // filter items based on user input
                newUnsortedItems = text ? originalItems.filter(function (i) {
                  return columnFilters.some(function (c) {
                    return (// Handle null and undefined values
                      !!i[c.fieldName] && i[c.fieldName].toLowerCase().indexOf(text.toLowerCase()) > -1
                    );
                  });
                }) : originalItems;
                setItems(newUnsortedItems);
                setSearchValue(text);
              }

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function onChangeFilterText(_x8, _x9) {
      return _ref4.apply(this, arguments);
    };
  }();

  function _hasValues(selectedItems) {
    var params = [];
    Object.keys(selectedItems).forEach(function (key) {
      if (selectedItems[key]) params.push(selectedItems[key]);
    });
    return params.length > 0;
  }

  function _renderItemColumn(item, index, column) {
    var fieldContent = item[column.fieldName];
    var url = item.url ? item.url : item.userUrl ? item.userUrl : null;

    switch (column.key) {
      //Field with link
      case "fieldWithUrl":
        if (!url) return /*#__PURE__*/React__default.createElement("span", null, typeof fieldContent === "boolean" ? fieldContent ? i18n._(
        /*i18n*/
        {
          id: "Yes"
        }) : i18n._(
        /*i18n*/
        {
          id: "No"
        }) : fieldContent);
        return /*#__PURE__*/React__default.createElement(Link, {
          href: url,
          target: "_blank"
        }, fieldContent);

      default:
        return /*#__PURE__*/React__default.createElement("span", null, typeof fieldContent === "boolean" ? fieldContent ? i18n._(
        /*i18n*/
        {
          id: "Yes"
        }) : i18n._(
        /*i18n*/
        {
          id: "No"
        }) : fieldContent);
    }
  }

  if (!items || !columnFilters || !columns) return null;
  if ((!props.items || !props.items.length) && !props.alwaysShowColumns) return /*#__PURE__*/React__default.createElement(NoItems, {
    type: "assigned"
  });
  return /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        marginBottom: 24,
        padding: 8
      }
    }
  }, /*#__PURE__*/React__default.createElement(FilterPanel, {
    column: column,
    isPanelOpen: isPanelOpen,
    onPanelClose: onPanelClose,
    handleApplyFilter: handleApplyFilter,
    filterProps: columnFilters,
    defaultFilterItems: defaultFilterItems,
    setDefaultFilterItems: setDefaultFilterItems,
    clearFilter: clearFilter,
    handleClearFilter: handleClearFilter
  }), columnSearchFilters && columnSearchFilters.length > 0 && /*#__PURE__*/React__default.createElement(ColumnFilterList, {
    columnFilters: columnSearchFilters,
    onChangeFilterText: onChangeFilterText,
    clearFilterText: clearFilter
  }), props.onRenderRow ? /*#__PURE__*/React__default.createElement(ShimmeredDetailsList, {
    setKey: "items",
    items: items,
    groups: groups,
    groupProps: _objectSpread2(_objectSpread2({}, groupProps), {}, {
      onToggleCollapseAll: setIsAllCollapsed
    }),
    styles: {
      root: {
        overflowX: "hidden"
      }
    },
    onRenderRow: props.onRenderRow,
    columns: columns.map(function (c) {
      return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, c), c.applyColumnClick && {
        onColumnClick: onColumnClick
      }), c.applyColumnContextMenu && {
        onColumnContextMenu: onColumnContextMenu
      }), c.applyColumnContextMenu && {
        columnActionsMode: ColumnActionsMode.hasDropdown
      }), c.applyColumnDisabled && {
        columnActionsMode: ColumnActionsMode.disabled
      }), {}, {
        isFiltered: columnFilters.some(function (column) {
          return column.column && column.column.key === c.key && (!Array.isArray(column.selectedItems) && _hasValues(column.selectedItems) || column.selectedItems.length > 0);
        })
      });
    }),
    selectionMode: SelectionMode.none,
    constrainMode: ConstrainMode.horizontalConstrained,
    layoutMode: DetailsListLayoutMode.unconstrained,
    onRenderItemColumn: _renderItemColumn,
    enableShimmer: shimmer
  }) : /*#__PURE__*/React__default.createElement(ShimmeredDetailsList, {
    setKey: "items",
    items: items,
    groups: groups,
    groupProps: _objectSpread2(_objectSpread2({}, groupProps), {}, {
      onToggleCollapseAll: setIsAllCollapsed
    }),
    styles: {
      root: {
        overflowX: "hidden"
      }
    },
    columns: columns.map(function (c) {
      return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, c), c.applyColumnClick && {
        onColumnClick: onColumnClick
      }), c.applyColumnContextMenu && {
        onColumnContextMenu: onColumnContextMenu
      }), c.applyColumnContextMenu && {
        columnActionsMode: ColumnActionsMode.hasDropdown
      }), c.applyColumnDisabled && {
        columnActionsMode: ColumnActionsMode.disabled
      }), {}, {
        isFiltered: columnFilters.some(function (column) {
          return column.column && column.column.key === c.key && (!Array.isArray(column.selectedItems) && _hasValues(column.selectedItems) || column.selectedItems.length > 0);
        })
      });
    }),
    selectionMode: SelectionMode.none,
    constrainMode: ConstrainMode.horizontalConstrained,
    layoutMode: DetailsListLayoutMode.unconstrained,
    onRenderItemColumn: _renderItemColumn,
    enableShimmer: shimmer
  }), !items.length && /*#__PURE__*/React__default.createElement(NoItems, {
    type: "search"
  }), contextualMenuProps && /*#__PURE__*/React__default.createElement(ContextualMenu, contextualMenuProps));
};

function sortGroupedItems(items, groups, key) {
  var index = 0;
  var newGroups = groups.map(function (group) {
    index = index + 1;
    return _objectSpread2(_objectSpread2({}, group), {}, {
      sord: index
    });
  });
  var newItems = items.map(function (item) {
    return _objectSpread2(_objectSpread2({}, item), {}, {
      sord: newGroups.filter(function (group) {
        return group.key === item[key];
      }).length && newGroups.filter(function (group) {
        return group.key === item[key];
      })[0].sord
    });
  });
  return newItems.sort(function (a, b) {
    return a.sord - b.sord;
  });
} // Orders by the fieldName of the column that should be sorted. Makes sure to
// leave all items with an `undefined` value at the bottom of the list.


function sortListItems(items, column) {
  if (!column) {
    return items.sort(function (a, b) {
      return a.name.toLowerCase().toString().localeCompare(b.name.toLowerCase().toString());
    });
  }

  return items.sort(function (a, b) {
    if (a[column.fieldName] === undefined) return 1;
    if (b[column.fieldName] === undefined) return -1;
    var aValue = typeof a[column.fieldName] === "string" ? a[column.fieldName].toLowerCase() : a[column.fieldName].toString();
    var bValue = typeof b[column.fieldName] === "string" ? b[column.fieldName].toLowerCase() : b[column.fieldName].toString();
    var comparison = aValue.localeCompare(bValue);

    if (comparison !== 0) {
      return column.isSortedDescending ? -comparison : comparison;
    }

    return 0;
  });
}

function usePaging(dataset) {
  var location = useLocation();
  var history = useHistory();

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      totalPages = _useState2[0],
      setTotalPages = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      totalElements = _useState4[0],
      setTotalElements = _useState4[1];

  var _useState5 = useState(1),
      _useState6 = _slicedToArray(_useState5, 2),
      pageNo = _useState6[0],
      setPageNo = _useState6[1];

  var _useState7 = useState("50"),
      _useState8 = _slicedToArray(_useState7, 2),
      pageSize = _useState8[0],
      setPageSize = _useState8[1]; // Handle page choice


  useEffect(function () {
    setTotalPages(dataset ? dataset.totalPages : 0);
    setTotalElements(dataset ? dataset.totalElements : 0); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataset]);
  useEffect(function () {
    updateURL(pageNo, pageSize);
  }, [dataset, pageNo, pageSize]);

  var updateURL = function updateURL(page, pageSize) {
    var queryParams = new URLSearchParams(location.search);
    queryParams.set("pageno", page);
    queryParams.set("pagesize", pageSize);
    history.replace({
      search: queryParams.toString()
    });
  };

  function moveToFirst() {
    setPageNo(1);
  }

  function moveToLast() {
    setPageNo(Math.floor(totalPages));
  }

  function movePrevious() {
    var newPage = pageNo - 1;
    setPageNo(newPage);
  }

  function moveNext() {
    var newPage = pageNo + 1;
    setPageNo(newPage);
  }

  function handlePageSize(option) {
    setPageSize(option.key);
    moveToFirst();
  }

  return {
    pageNo: pageNo,
    totalPages: totalPages,
    totalElements: totalElements,
    pageSize: pageSize,
    moveToFirst: moveToFirst,
    movePrevious: movePrevious,
    moveNext: moveNext,
    moveToLast: moveToLast,
    handlePageSize: handlePageSize
  };
}

var PagingHeader = function PagingHeader(_ref) {
  var dataset = _ref.dataset,
      isFetching = _ref.isFetching,
      isFetchingTotal = _ref.isFetchingTotal;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      startNo = _useState2[0],
      setStartNo = _useState2[1];

  var _useState3 = useState(50),
      _useState4 = _slicedToArray(_useState3, 2),
      endNo = _useState4[0],
      setEndNo = _useState4[1];

  var _usePaging = usePaging(dataset),
      pageNo = _usePaging.pageNo,
      _usePaging$pageSize = _usePaging.pageSize,
      pageSize = _usePaging$pageSize === void 0 ? 50 : _usePaging$pageSize,
      _usePaging$totalEleme = _usePaging.totalElements,
      totalElements = _usePaging$totalEleme === void 0 ? 0 : _usePaging$totalEleme,
      moveToFirst = _usePaging.moveToFirst,
      movePrevious = _usePaging.movePrevious,
      moveNext = _usePaging.moveNext,
      moveToLast = _usePaging.moveToLast,
      handlePageSize = _usePaging.handlePageSize;

  var dropdownOptions = [{
    key: "50",
    text: "50"
  }, {
    key: "100",
    text: "100"
  }, {
    key: "250",
    text: "250"
  }, {
    key: "500",
    text: "500"
  }];
  useEffect(function () {
    if (!dataset) return;
    if (dataset.moveToFirst) moveToFirst();
    dataset.setMoveToFirst(false);
  }, [dataset]);
  useEffect(function () {
    setStartNo(pageNo ? (pageNo - 1) * pageSize + 1 : 1);
    setEndNo(pageSize * pageNo);
  }, [pageNo, pageSize]);
  return /*#__PURE__*/React__default.createElement(Stack, {
    grow: true,
    horizontal: true,
    horizontalAlign: "space-between"
  }, /*#__PURE__*/React__default.createElement(Stack.Item, {
    styles: {
      root: {
        margin: 0,
        padding: 0,
        width: "100%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    grow: true,
    horizontal: true,
    horizontalAlign: "space-between"
  }, /*#__PURE__*/React__default.createElement(Stack, {
    align: "center",
    horizontal: true,
    styles: {
      root: {
        minHeight: 20,
        padding: 6
      }
    }
  }, startNo, " - ", endNo, " ", i18n._(
  /*i18n*/
  {
    id: "of"
  }), " ", isFetchingTotal ? /*#__PURE__*/React__default.createElement(Spinner, {
    size: SpinnerSize.small,
    styles: {
      root: {
        marginTop: 2,
        marginLeft: "6px !important"
      }
    }
  }) : totalElements), /*#__PURE__*/React__default.createElement(Stack.Item, {
    align: "center",
    styles: {
      root: {
        position: "relative",
        "float": "right"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center"
  }, /*#__PURE__*/React__default.createElement("span", null, i18n._(
  /*i18n*/
  {
    id: "Items per page:"
  })), /*#__PURE__*/React__default.createElement(Dropdown, {
    styles: {
      root: {
        paddingLeft: "5px",
        paddingRight: "20px",
        width: "70px"
      }
    },
    defaultSelectedKey: pageSize,
    options: dropdownOptions,
    onChange: function onChange(ev, item) {
      return handlePageSize(item);
    },
    disabled: isFetching
  }), /*#__PURE__*/React__default.createElement(IconButton, {
    iconProps: {
      iconName: "DoubleChevronLeft"
    },
    onClick: moveToFirst,
    disabled: !dataset || !dataset.paging.hasPreviousPage || isFetching
  }), /*#__PURE__*/React__default.createElement(IconButton, {
    iconProps: {
      iconName: "ChevronLeft"
    },
    onClick: movePrevious,
    disabled: !dataset || !dataset.paging.hasPreviousPage || isFetching
  }), /*#__PURE__*/React__default.createElement("span", null, i18n._(
  /*i18n*/
  {
    id: "Page:"
  }), " ", pageNo), /*#__PURE__*/React__default.createElement(IconButton, {
    iconProps: {
      iconName: "ChevronRight"
    },
    onClick: moveNext,
    disabled: !dataset || !dataset.paging.hasNextPage || isFetching
  }), /*#__PURE__*/React__default.createElement(IconButton, {
    iconProps: {
      iconName: "DoubleChevronRight"
    },
    onClick: moveToLast,
    disabled: !dataset || !dataset.paging.hasNextPage || isFetching
  }))))));
};

// Because BE expects an index

var updatePageNo = function updatePageNo(url, pageno) {
  var newUrl = url;
  var firstIdx = url.indexOf("pageno=") + 7;

  if (firstIdx > 6) {
    var lastIdx = url.substr(firstIdx + 1, url.length - 1).indexOf("&") + firstIdx + 1;
    newUrl = "".concat(url.substr(0, firstIdx)).concat(pageno).concat(lastIdx > firstIdx ? url.substr(lastIdx, url.length - 1) : "");
  }

  return newUrl;
};

function PagedDetailList(_ref) {
  var item = _ref.item,
      pagingCountAvailable = _ref.pagingCountAvailable,
      listColumn = _ref.listColumn,
      isFetching = _ref.isFetching,
      isFetchingTotal = _ref.isFetchingTotal,
      getPagingReport = _ref.getPagingReport,
      contents = _ref.contents;
  var location = useLocation();
  var history = useHistory();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      columns = _useState2[0],
      setColumns = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      items = _useState4[0],
      setItems = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      dataset = _useState6[0],
      setDataset = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      params = _useState8[0],
      setParams = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      moveToFirst = _useState10[0],
      setMoveToFirst = _useState10[1];

  useEffect(function () {
    var queryParams = new URLSearchParams(location.search);
    queryParams.forEach(function (_, key) {
      if (key[0] === "pagesize" || key[0] === "pageno" || key[0] === "username" || key[0] === "start" || key[0] === "end") queryParams["delete"](key);
    });
    history.replace({
      search: queryParams.toString()
    });
  }, [item]);
  useEffect(function () {
    if (!item) return;
    var urlParams = new URLSearchParams(location.search);
    if (!urlParams) return;
    var entries = Array.from(urlParams.entries());
    var hasUndefinedParam = false;
    var pageno;
    var paramsArray = entries.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      if (value === undefined) {
        hasUndefinedParam = true;
      }

      if (key === "pageno") pageno = value - 1;
      return "".concat(key, "=").concat(value);
    });
    if (hasUndefinedParam || paramsArray.length === 0) return;
    var stringedParams = updatePageNo(urlParams.toString(), pageno);
    if (!stringedParams || stringedParams === "") return;

    var fetchAsync = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getPagingReport(item, pagingCountAvailable, stringedParams);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchAsync() {
        return _ref4.apply(this, arguments);
      };
    }();

    setParams(paramsArray);
    fetchAsync();
  }, [location.search, item.endpoint]); // Handle columns and clear filter button

  useEffect(function () {
    if (!item) return;
    setColumns(listColumn(params, item.fieldDefinition, {})); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, params, contents]); // Handle contents view

  useEffect(function () {
    if (!contents) return;
    var newDataset = {
      sortedRecordIds: contents ? contents.content : [],
      totalPages: contents && contents.totalPages,
      totalElements: contents && contents.totalElements,
      pageSize: contents && contents.size,
      paging: {
        hasPreviousPage: contents && contents.number > 0,
        hasNextPage: contents && contents.number + 1 < contents.totalPages
      },
      moveToFirst: moveToFirst,
      setMoveToFirst: setMoveToFirst
    };
    setDataset(newDataset);
    if (!contents || !contents.content) return;
    setItems(contents.content); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contents]);
  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(PagingHeader, {
    dataset: dataset,
    isFetching: isFetching,
    isFetchingTotal: isFetchingTotal
  })), !columns || !dataset ? /*#__PURE__*/React__default.createElement(Spinner, {
    label: i18n._(
    /*i18n*/
    {
      id: "Loading items..."
    })
  }) : /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(ViewDetailsList, {
    items: items,
    columns: columns,
    alwaysShowColumns: true,
    shimmer: isFetching,
    setMoveToFirst: setMoveToFirst,
    urlParams: true
  })));
}

var _onRenderBody = function onRenderBody(item, activities, isFetchingActivity) {
  var isFetchingActivityTotal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var showSummary = arguments.length > 4 ? arguments[4] : undefined;
  var getItemActivity = arguments.length > 5 ? arguments[5] : undefined;

  if (showSummary === false) {
    return /*#__PURE__*/React__default.createElement(Stack, {
      styles: {
        root: {
          margin: 16
        }
      }
    }, /*#__PURE__*/React__default.createElement(PagedDetailList, {
      item: item,
      pagingCountAvailable: "",
      listColumn: columns,
      isFetching: isFetchingActivity,
      isFetchingTotal: isFetchingActivityTotal,
      contents: activities,
      getPagingReport: getItemActivity
    }));
  }

  if (!activities || isFetchingActivity) {
    return /*#__PURE__*/React__default.createElement(Stack, {
      horizontalAlign: "center",
      verticalAlign: "center",
      verticalFill: true
    }, /*#__PURE__*/React__default.createElement(Spinner, {
      label: i18n._(
      /*i18n*/
      {
        id: "Loading Activity..."
      }),
      labelPosition: "bottom"
    }));
  }

  if (!activities.content.length) {
    return /*#__PURE__*/React__default.createElement(Stack, {
      horizontalAlign: "center",
      verticalAlign: "center",
      verticalFill: true,
      tokens: {
        padding: 32
      }
    }, /*#__PURE__*/React__default.createElement(Text, {
      variant: "medium",
      styles: {
        root: {
          textAlign: "center"
        }
      }
    }, i18n._(
    /*i18n*/
    {
      id: "There has been no activity on the item"
    })));
  }

  return /*#__PURE__*/React__default.createElement(Summary, {
    activities: activities
  });
};
/**
 * The ActivityPanel is a right-side Panel component with information on any
 * activity on the currently displayed item. It shows two distinctly different
 * lists: A Summary list, with textual information for each activity, and a
 * Details list, using the ViewDetailsList component.
 *
 * @param {object} item the current item for which activities should be shown.
 * @param {object} activitiesThe item's activities.
 * @param {function} getItemActivity calls the API for activity data on the item baced on days
 * @param {function} setIsActivityVisible sets the visibility of the panel
 * @param {boolean} isActivityVisible declares the visibility of the panel
 * @param {boolean} isFetchingActivity declares the fetching state of activity
 * @param {boolean} isFetchingActivityTotal declares the fetching state of activity counts
 */


var ActivityPanel = function ActivityPanel(_ref) {
  var item = _ref.item,
      activities = _ref.activities,
      getItemActivity = _ref.getItemActivity,
      setIsActivityVisible = _ref.setIsActivityVisible,
      isActivityVisible = _ref.isActivityVisible,
      isFetchingActivity = _ref.isFetchingActivity,
      isFetchingActivityTotal = _ref.isFetchingActivityTotal;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      showSummary = _useState2[0],
      setShowSummary = _useState2[1];

  var eventsShown = 50;
  var location = useLocation();
  var history = useHistory();
  useEffect(function () {
    if (!isActivityVisible) {
      var queryParams = new URLSearchParams(location.search);
      var params = Array.from(queryParams); // Clear activity list paramenters from URL when activity list is not shown

      params.forEach(function (key) {
        if (key[0] === "pagesize" || key[0] === "pageno" || key[0] === "username" || key[0] === "start" || key[0] === "end") queryParams["delete"](key[0]);
      });
      history.replace({
        search: queryParams.toString()
      });
    }
  }, [isActivityVisible]);
  useEffect(function () {
    if (!item || !isActivityVisible || !showSummary) return;
    getItemActivity(item, eventsShown); //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActivityVisible, item, showSummary]);
  return /*#__PURE__*/React__default.createElement(Panel$1, {
    isOpen: isActivityVisible,
    type: showSummary ? PanelType$1.smallFixedFar : PanelType$1.extraLarge,
    hasCloseButton: true,
    onDismiss: function onDismiss() {
      setShowSummary(true);
      setIsActivityVisible(false);
    },
    isLightDismiss: true,
    isFooterAtBottom: true,
    headerText:  showSummary ? /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, null, i18n._(
    /*i18n*/
    {
      id: "Activity list"
    })), /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Text, {
      variant: "mediumPlus"
    }, i18n._(
    /*i18n*/
    {
      id: "Latest {eventsShown} events shown",
      values: {
        eventsShown: eventsShown
      }
    })))) : i18n._(
    /*i18n*/
    {
      id: "Activity List"
    }),
    onRenderBody: function onRenderBody() {
      return _onRenderBody(item, activities, isFetchingActivity, isFetchingActivityTotal, showSummary, getItemActivity);
    },
    onRenderFooterContent: function onRenderFooterContent() {
      return /*#__PURE__*/React__default.createElement(Stack, {
        horizontalAlign: "right"
      }, /*#__PURE__*/React__default.createElement(DefaultButton, {
        text: showSummary ? i18n._(
        /*i18n*/
        {
          id: "Show All Activity in List"
        }) : i18n._(
        /*i18n*/
        {
          id: "Show Summary"
        }),
        onClick: function onClick() {
          return setShowSummary(!showSummary);
        }
      }));
    }
  });
};

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
function initializeFabricIcons() {
  var subset = {
    style: {
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontStyle: "normal",
      fontWeight: "normal",
      speak: "none"
    },
    fontFace: {
      fontFamily: "\"FabricMDL2Icons\"",
      src: "url('fonts/fabric-icons-a9789667.ttf') format('ttf')"
    },
    icons: {
      "12PointStar": "\uF505",
      "6PointStar": "\uF504",
      AADLogo: "\uED68",
      Accept: "\uE8FB",
      AcceptMedium: "\uF78C",
      AccessibiltyChecker: "\uF835",
      AccessLogo: "\uED69",
      AccountActivity: "\uEFF4",
      AccountBrowser: "\uF652",
      AccountManagement: "\uF55C",
      Accounts: "\uE910",
      ActionCenter: "\uE91C",
      ActivateOrders: "\uEFE0",
      ActivityFeed: "\uF056",
      Add: "\uE710",
      AddBookmark: "\uF5B7",
      AddConnection: "\uF4E1",
      AddEvent: "\uEEB5",
      AddFavorite: "\uF0C8",
      AddFavoriteFill: "\uF0C9",
      AddField: "\uE4C7",
      AddFriend: "\uE8FA",
      AddGroup: "\uEE3D",
      AddHome: "\uF17B",
      AddIn: "\uF775",
      AddLink: "\uE35E",
      AddMedium: "\uECA1",
      AddMultiple: "\uE9C5",
      AddNotes: "\uEAE3",
      AddOnlineMeeting: "\uED8E",
      AddPhone: "\uED96",
      AddReaction: "\uF85D",
      AddSpaceAfter: "\uE3DF",
      AddSpaceBefore: "\uE3DE",
      AddTable: "\uE4C6",
      AddTo: "\uECC8",
      AddToShoppingList: "\uEA9A",
      AddWork: "\uF17C",
      Admin: "\uE7EF",
      AdminALogo32: "\uF4BA",
      AdminALogoFill32: "\uF4BB",
      AdminALogoInverse32: "\uED6A",
      AdminCLogoInverse32: "\uED6B",
      AdminDLogoInverse32: "\uED6C",
      AdminELogoInverse32: "\uED6D",
      AdminLLogoInverse32: "\uED6E",
      AdminMLogoInverse32: "\uED6F",
      AdminOLogoInverse32: "\uED70",
      AdminPLogoInverse32: "\uED71",
      AdminSLogoInverse32: "\uED72",
      AdminYLogoInverse32: "\uED73",
      Airplane: "\uE709",
      AirplaneSolid: "\uEB4C",
      AirTickets: "\uEF7A",
      AlarmClock: "\uE919",
      Album: "\uE7AB",
      AlbumRemove: "\uEC62",
      AlertSettings: "\uF8B6",
      AlertSolid: "\uF331",
      AlignCenter: "\uE8E3",
      AlignHorizontalCenter: "\uF4F4",
      AlignHorizontalLeft: "\uF4F3",
      AlignHorizontalRight: "\uF4F5",
      AlignJustify: "\uF51E",
      AlignLeft: "\uE8E4",
      AlignRight: "\uE8E2",
      AlignVerticalBottom: "\uF4F8",
      AlignVerticalCenter: "\uF4F7",
      AlignVerticalTop: "\uF4F6",
      AllApps: "\uE71D",
      AllAppsMirrored: "\uEA40",
      AllCurrency: "\uEAE4",
      AltText: "\uE397",
      AnalyticsLogo: "\uF1DE",
      AnalyticsQuery: "\uF1DF",
      AnalyticsReport: "\uF1E1",
      AnalyticsView: "\uF5F1",
      AnchorLock: "\uF511",
      Annotation: "\uE924",
      AppIconDefault: "\uECAA",
      AppIconDefaultAdd: "\uEFDA",
      AppIconDefaultEdit: "\uEFDC",
      AppIconDefaultList: "\uEFDE",
      AppIconSecure: "\uE657",
      AppsContent: "\uEE54",
      Archive: "\uF03F",
      ArchiveUndo: "\uE3A1",
      AreaChart: "\uE9D2",
      ArrangeBringForward: "\uF509",
      ArrangeBringToFront: "\uF506",
      ArrangeByFrom: "\uF678",
      ArrangeSendBackward: "\uF508",
      ArrangeSendToBack: "\uF507",
      Arrivals: "\uEB34",
      ArrowDownRight8: "\uEED5",
      ArrowDownRightMirrored8: "\uEEF0",
      ArrowTallDownLeft: "\uF2BF",
      ArrowTallDownRight: "\uF2C0",
      ArrowTallUpLeft: "\uF2BD",
      ArrowTallUpRight: "\uF2BE",
      ArrowUpRight: "\uF069",
      ArrowUpRight8: "\uEED4",
      ArrowUpRightMirrored8: "\uEEEF",
      Articles: "\uEAC1",
      Ascending: "\uEDC0",
      AspectRatio: "\uE799",
      AssessmentGroup: "\uF31A",
      AssessmentGroupTemplate: "\uF2B1",
      AssetLibrary: "\uEEB6",
      Assign: "\uE9D3",
      AssignPolicy: "\uE461",
      Asterisk: "\uEA38",
      AsteriskSolid: "\uF34D",
      ATPLogo: "\uEF85",
      Attach: "\uE723",
      AustralianRules: "\uEE70",
      AuthenticatorApp: "\uF6B1",
      AutoDeploySettings: "\uF3FA",
      AutoEnhanceOff: "\uE78E",
      AutoEnhanceOn: "\uE78D",
      AutoFillTemplate: "\uF313",
      AutoFitContents: "\uE3E8",
      AutoFitWindow: "\uE3E9",
      AutoHeight: "\uF512",
      AutomateFlow: "\uE3F5",
      AutoRacing: "\uEB24",
      AwayStatus: "\uEE6A",
      AzureAPIManagement: "\uF37F",
      AzureDataExplorer: "\uE439",
      AzureIcon: "\uEB6A",
      AzureKeyVault: "\uF3B4",
      AzureServiceEndpoint: "\uF380",
      Back: "\uE72B",
      BackgroundColor: "\uF42B",
      Backlog: "\uF2AC",
      BacklogBoard: "\uF444",
      BacklogList: "\uF6BF",
      BackToWindow: "\uE73F",
      Badge: "\uEC1B",
      Balloons: "\uED7E",
      Bank: "\uE825",
      BankSolid: "\uF34F",
      BarChart4: "\uEAE7",
      BarChartHorizontal: "\uE9EB",
      BarChartVertical: "\uE9EC",
      BarChartVerticalEdit: "\uF89D",
      BarChartVerticalFill: "\uF830",
      BarChartVerticalFilter: "\uF77E",
      BarChartVerticalFilterSolid: "\uF77F",
      Baseball: "\uEB20",
      BeerMug: "\uF49E",
      BIDashboard: "\uF543",
      BidiLtr: "\uE9AA",
      BidiRtl: "\uE9AB",
      Bill: "\uE5FA",
      BingLogo: "\uEB6B",
      BirthdayCake: "\uEF8D",
      BlobStorage: "\uE436",
      BlockContact: "\uE8F8",
      Blocked: "\uE733",
      Blocked12: "\uF62E",
      Blocked2: "\uECE4",
      Blocked2Solid: "\uF737",
      BlockedSite: "\uE72F",
      BlockedSiteSolid12: "\uF70A",
      BlockedSolid: "\uF531",
      Blog: "\uF22B",
      BlowingSnow: "\uE9C9",
      Blur: "\uF28E",
      Boards: "\uEF68",
      Bold: "\uE8DD",
      BoldBulgarian: "\uE5C5",
      BoldF: "\uE5B5",
      BoldG: "\uE5B3",
      BoldK: "\uE5C6",
      BoldKazakh: "\uE5C9",
      BoldKorean: "\uE5BD",
      BoldN: "\uE5B7",
      BoldP: "\uE5C7",
      BoldRussion: "\uE5B9",
      BoldSerbian: "\uE5CA",
      BoldT: "\uE5C8",
      BookAnswers: "\uF8A4",
      BookingsLogo: "\uEDC7",
      BookmarkReport: "\uF76B",
      Bookmarks: "\uE8A4",
      BookmarksMirrored: "\uEA41",
      BooleanData: "\uE678",
      BorderAll: "\uE5F4",
      BorderDash: "\uF50A",
      BorderDot: "\uF50B",
      BorderInside: "\uE5F3",
      BorderInsideHorizontal: "\uE5F2",
      BorderInsideVertical: "\uE5F1",
      BorderNone: "\uE5F0",
      BoxAdditionSolid: "\uF2D4",
      BoxCheckmarkSolid: "\uF2D7",
      BoxMultiplySolid: "\uF2D5",
      BoxPlaySolid: "\uF2D6",
      BoxSubtractSolid: "\uF2D3",
      BranchCommit: "\uF293",
      BranchCompare: "\uF294",
      BranchFork: "\uF173",
      BranchFork2: "\uF291",
      BranchLocked: "\uF292",
      BranchMerge: "\uF295",
      BranchPullRequest: "\uF296",
      BranchSearch: "\uF297",
      BranchShelveset: "\uF298",
      Breadcrumb: "\uEF8C",
      Breakfast: "\uF49C",
      Brightness: "\uE706",
      Broom: "\uEA99",
      BrowserScreenShot: "\uEBED",
      BrowserTab: "\uF5D7",
      BrowserTabScreenshot: "\uF5D8",
      Brunch: "\uF49D",
      Brush: "\uECFF",
      BucketColor: "\uF1B6",
      BucketColorFill: "\uF1B7",
      BufferTimeAfter: "\uF0D0",
      BufferTimeBefore: "\uF0CF",
      BufferTimeBoth: "\uF0D1",
      Bug: "\uEBE8",
      BugAction: "\uE358",
      BugBlock: "\uE400",
      BugSolid: "\uF335",
      BugSync: "\uE3FF",
      BugWarning: "\uE357",
      Build: "\uF28F",
      BuildDefinition: "\uF6E9",
      BuildIssue: "\uF319",
      BuildQueue: "\uF24F",
      BuildQueueNew: "\uF250",
      BulkPageBlock: "\uE553",
      BulkUpload: "\uF548",
      BulletedList: "\uE8FD",
      BulletedList2: "\uF2C7",
      BulletedList2Mirrored: "\uF2C8",
      BulletedListBullet: "\uF793",
      BulletedListBulletMirrored: "\uF795",
      BulletedListMirrored: "\uEA42",
      BulletedListText: "\uF792",
      BulletedListTextMirrored: "\uF794",
      BulletedTreeList: "\uF84C",
      Bullseye: "\uF272",
      BullseyeTarget: "\uF5F0",
      BullseyeTargetAdd: "\uE664",
      BullseyeTargetDelete: "\uF6C1",
      BullseyeTargetEdit: "\uE319",
      Bus: "\uE806",
      BusinessCard: "\uE5FB",
      BusinessCenterLogo: "\uF4B2",
      BusinessHoursSign: "\uF310",
      BusinessRule: "\uE562",
      BusSolid: "\uEB47",
      ButtonControl: "\uF6C0",
      Cafe: "\uEC32",
      Cake: "\uECA4",
      CalculatedTable: "\uE4BE",
      Calculator: "\uE8EF",
      CalculatorAddition: "\uE948",
      CalculatorDelta: "\uE406",
      CalculatorEqualTo: "\uE94E",
      CalculatorGroup: "\uE462",
      CalculatorMultiply: "\uE947",
      CalculatorNotEqualTo: "\uF2D2",
      CalculatorPercentage: "\uE94C",
      CalculatorSubtract: "\uE949",
      Calendar: "\uE787",
      CalendarAgenda: "\uEE9A",
      CalendarDay: "\uE8BF",
      CalendarMirrored: "\uED28",
      CalendarReply: "\uE8F5",
      CalendarSettings: "\uF558",
      CalendarSettingsMirrored: "\uF559",
      CalendarWeek: "\uE8C0",
      CalendarWorkWeek: "\uEF51",
      CalendarYear: "\uE371",
      Calories: "\uECAD",
      CaloriesAdd: "\uF172",
      Camera: "\uE722",
      CampaignTemplate: "\uF811",
      Cancel: "\uE711",
      CannedChat: "\uF0F2",
      CanvasAppTemplate32: "\uE5FE",
      Car: "\uE804",
      CareActivity: "\uE549",
      CarePlan: "\uE54A",
      CarePlanTemplate: "\uE61E",
      CaretBottomLeftCenter8: "\uF365",
      CaretBottomLeftSolid8: "\uF121",
      CaretBottomRightCenter8: "\uF364",
      CaretBottomRightSolid8: "\uF122",
      CaretDown8: "\uEDD8",
      CaretDownSolid8: "\uEDDC",
      CaretHollow: "\uE817",
      CaretHollowMirrored: "\uEA45",
      CaretLeft8: "\uEDD5",
      CaretLeftSolid8: "\uEDD9",
      CaretRight: "\uF06B",
      CaretRight8: "\uEDD6",
      CaretRightSolid8: "\uEDDA",
      CaretSolid: "\uE818",
      CaretSolid16: "\uEE62",
      CaretSolidAlt: "\uE483",
      CaretSolidDown: "\uF08E",
      CaretSolidLeft: "\uF08D",
      CaretSolidMirrored: "\uEA46",
      CaretSolidRight: "\uF08F",
      CaretSolidUp: "\uF090",
      CaretTopLeftCenter8: "\uF367",
      CaretTopLeftSolid8: "\uEF54",
      CaretTopRightCenter8: "\uF366",
      CaretTopRightSolid8: "\uEF55",
      CaretUp8: "\uEDD7",
      CaretUpSolid8: "\uEDDB",
      Cat: "\uED7F",
      CategoryClassification: "\uE48C",
      CC: "\uE7F0",
      CCSolid: "\uE4F4",
      CellPhone: "\uE8EA",
      CellSplitVertical: "\uE66C",
      Certificate: "\uEB95",
      CertifiedDatabase: "\uF5BB",
      ChangeEntitlements: "\uE310",
      Chart: "\uE999",
      CharticulatorArrangePolar: "\uE632",
      CharticulatorArrangePolarAngles: "\uE633",
      CharticulatorBand: "\uE634",
      CharticulatorGuideCoordinator: "\uE635",
      CharticulatorGuideX: "\uE636",
      CharticulatorGuideY: "\uE637",
      CharticulatorLegend: "\uE638",
      CharticulatorLine: "\uE639",
      CharticulatorLineStyleDashed: "\uE63A",
      CharticulatorLineStyleDotted: "\uE63B",
      CharticulatorLinkingData: "\uE63C",
      CharticulatorLinkingSequence: "\uE63D",
      CharticulatorOrderColumn: "\uE63E",
      CharticulatorOrderRow: "\uE63F",
      CharticulatorPlotCartesian: "\uE640",
      CharticulatorPlotCurve: "\uE641",
      CharticulatorPolarCoordinates: "\uE642",
      CharticulatorSpiral: "\uE643",
      CharticulatorStackRadial: "\uE644",
      CharticulatorStackY: "\uE645",
      ChartSeries: "\uF513",
      ChartTemplate: "\uF812",
      ChartXAngle: "\uF514",
      ChartYAngle: "\uF515",
      Chat: "\uE901",
      ChatBot: "\uF08B",
      ChatInviteFriend: "\uECFE",
      ChatSettings: "\uE600",
      ChatSolid: "\uF344",
      Checkbox: "\uE739",
      CheckboxComposite: "\uE73A",
      CheckboxCompositeReversed: "\uE73D",
      CheckboxFill: "\uE73B",
      CheckboxIndeterminate: "\uE73C",
      CheckboxIndeterminateCombo: "\uF16E",
      CheckedOutByOther12: "\uF630",
      CheckedOutByYou12: "\uF631",
      CheckList: "\uE9D5",
      CheckListCheck: "\uF7A9",
      CheckListCheckMirrored: "\uF7AB",
      CheckListText: "\uF7A8",
      CheckListTextMirrored: "\uF7AA",
      CheckMark: "\uE73E",
      ChevronDown: "\uE70D",
      ChevronDownEnd: "\uF5E4",
      ChevronDownEnd6: "\uF36F",
      ChevronDownMed: "\uE972",
      ChevronDownSmall: "\uE96E",
      ChevronFold10: "\uF36A",
      ChevronLeft: "\uE76B",
      ChevronLeftEnd6: "\uF371",
      ChevronLeftMed: "\uE973",
      ChevronLeftSmall: "\uE96F",
      ChevronRight: "\uE76C",
      ChevronRightEnd6: "\uF372",
      ChevronRightMed: "\uE974",
      ChevronRightSmall: "\uE970",
      ChevronUnfold10: "\uF369",
      ChevronUp: "\uE70E",
      ChevronUpEnd: "\uE55B",
      ChevronUpEnd6: "\uF370",
      ChevronUpMed: "\uE971",
      ChevronUpSmall: "\uE96D",
      Childof: "\uF82D",
      ChoiceColumn: "\uE4AE",
      Chopsticks: "\uF4A2",
      ChromeBack: "\uE830",
      ChromeBackMirrored: "\uEA47",
      ChromeClose: "\uE8BB",
      ChromeFullScreen: "\uE92D",
      ChromeMinimize: "\uE921",
      ChromeRestore: "\uE923",
      CircleAddition: "\uF2E3",
      CircleAdditionSolid: "\uF2E4",
      CircleDollar: "\uEAED",
      CircleFill: "\uEA3B",
      CircleHalfFull: "\uED9E",
      CirclePause: "\uF2D9",
      CirclePauseSolid: "\uF2D8",
      CirclePlus: "\uEAEE",
      CircleRing: "\uEA3A",
      CircleShape: "\uF1A5",
      CircleShapeSolid: "\uF63C",
      CircleStop: "\uF2DC",
      CircleStopSolid: "\uF2DB",
      CityNext: "\uEC06",
      CityNext2: "\uEC07",
      ClassNotebookLogo16: "\uF488",
      ClassNotebookLogo32: "\uF486",
      ClassNotebookLogoFill16: "\uF489",
      ClassNotebookLogoFill32: "\uF487",
      ClassNotebookLogoInverse: "\uEDC8",
      ClassNotebookLogoInverse16: "\uF48B",
      ClassNotebookLogoInverse32: "\uF48A",
      ClassroomLogo: "\uEF75",
      Clear: "\uE894",
      ClearFilter: "\uEF8F",
      ClearFormatting: "\uEDDD",
      ClearFormattingA: "\uF79D",
      ClearFormattingEraser: "\uF79E",
      ClearNight: "\uE9C2",
      ClearSelection: "\uE8E6",
      ClearSelectionMirrored: "\uEA48",
      Clicked: "\uF268",
      ClinicalImpression: "\uE54B",
      ClipboardList: "\uF0E3",
      ClipboardListAdd: "\uE4EF",
      ClipboardListMirrored: "\uF0E4",
      ClipboardListQuestion: "\uE4F0",
      ClipboardListReply: "\uE4F1",
      ClipboardSolid: "\uF5DC",
      Clock: "\uE917",
      CloneToDesktop: "\uF28C",
      ClosedCaption: "\uEF84",
      ClosePane: "\uE89F",
      ClosePaneMirrored: "\uEA49",
      Cloud: "\uE753",
      CloudAdd: "\uECA9",
      CloudDownload: "\uEBD3",
      CloudEdit: "\uE4C8",
      CloudFlow: "\uE5EA",
      CloudImportExport: "\uEE55",
      CloudLink: "\uE4C9",
      CloudNotSynced: "\uEC9C",
      CloudPrinter: "\uEDA6",
      CloudSearch: "\uEDE4",
      CloudSecure: "\uE4D5",
      CloudUpload: "\uEC8E",
      CloudWeather: "\uE9BE",
      Cloudy: "\uE9BF",
      Cocktails: "\uEA9D",
      Code: "\uE943",
      CodeEdit: "\uF544",
      Coffee: "\uEAEF",
      CoffeeScript: "\uF2FA",
      CollapseAll: "\uF85A",
      CollapseContent: "\uF165",
      CollapseContentSingle: "\uF166",
      CollapseMenu: "\uEF66",
      CollegeFootball: "\uEB26",
      CollegeHoops: "\uEB25",
      Color: "\uE790",
      ColorSolid: "\uF354",
      Column: "\uE438",
      ColumnFunction: "\uE4C2",
      ColumnLeftTwoThirds: "\uF1D6",
      ColumnLeftTwoThirdsEdit: "\uF324",
      ColumnOptions: "\uF317",
      ColumnQuestion: "\uE4C0",
      ColumnQuestionMirrored: "\uE4C1",
      ColumnRightTwoThirds: "\uF1D7",
      ColumnRightTwoThirdsEdit: "\uF325",
      ColumnSigma: "\uE4BF",
      ColumnVerticalSection: "\uF81E",
      ColumnVerticalSectionEdit: "\uF806",
      Combine: "\uEDBB",
      Combobox: "\uF516",
      CommandPrompt: "\uE756",
      Comment: "\uE90A",
      CommentActive: "\uF804",
      CommentAdd: "\uF2B3",
      CommentNext: "\uF2B4",
      CommentPrevious: "\uF2B5",
      CommentSolid: "\uE30E",
      CommentUrgent: "\uF307",
      Commitments: "\uEC4D",
      CommonDataServiceCDS: "\uE377",
      CommunicationDetails: "\uE4CF",
      CommunicationDetailsMirrored: "\uE4D0",
      Communications: "\uE95A",
      CompanyDirectory: "\uEF0D",
      CompanyDirectoryMirrored: "\uEF2B",
      Compare: "\uF057",
      CompareUneven: "\uE42E",
      CompassNW: "\uE942",
      Completed: "\uE930",
      Completed12: "\uE559",
      CompletedSolid: "\uEC61",
      ComplianceAudit: "\uE369",
      ConfigurationSolid: "\uF334",
      ConfirmEvent: "\uE680",
      ConnectContacts: "\uEFD4",
      ConnectVirtualMachine: "\uEE9D",
      ConstructionCone: "\uE98F",
      ConstructionConeSolid: "\uF339",
      Contact: "\uE77B",
      ContactCard: "\uEEBD",
      ContactCardSettings: "\uF556",
      ContactCardSettingsMirrored: "\uF557",
      ContactHeart: "\uF862",
      ContactInfo: "\uE779",
      ContactInfoMirrored: "\uEA4A",
      ContactLink: "\uF25F",
      ContactList: "\uF7E5",
      ContactLock: "\uF400",
      ContentFeed: "\uE428",
      ContentSettings: "\uF647",
      ContentUnderstandingApp: "\uE4FB",
      ContextMenu: "\uF37C",
      Contrast: "\uE7A1",
      Copy: "\uE8C8",
      CopyEdit: "\uE464",
      CortanaLogoBeckonInner: "\uF4C6",
      CortanaLogoBeckonOuter: "\uF4C7",
      CortanaLogoInner: "\uE832",
      CortanaLogoOuter: "\uE831",
      CortanaLogoReadyInner: "\uF4C8",
      CortanaLogoReadyOuter: "\uF4C9",
      CostContralLedgerAdmin: "\uF208",
      CostControl: "\uF207",
      Cotton: "\uEAF3",
      Count: "\uE9EE",
      Coupon: "\uF7BC",
      CPlusPlus: "\uF2F4",
      CPlusPlusLanguage: "\uF2F3",
      CreateMailRule: "\uF67A",
      CreditCardBill: "\uECD6",
      Cricket: "\uEB1E",
      CriticalErrorSolid: "\uF5C9",
      CRMLead: "\uEFD6",
      CRMProcesses: "\uEFB1",
      CRMReport: "\uEFFE",
      CRMResourceOptimizationApp32: "\uF6EF",
      CRMServices: "\uEFD2",
      Crop: "\uE7A8",
      Crown: "\uED01",
      CrownSolid: "\uF336",
      CSharp: "\uF2F0",
      CSharpLanguage: "\uF2EF",
      CSS: "\uEBEF",
      CtrlButton: "\uE4B8",
      CubeShape: "\uF1AA",
      CubeShapeSolid: "\uE421",
      Currency: "\uEAF5",
      CustomActivity: "\uEFF0",
      CustomEntity: "\uEFF7",
      CustomerAssets: "\uF426",
      CustomizeToolbar: "\uF828",
      CustomList: "\uEEBE",
      CustomListMirrored: "\uEEBF",
      Cut: "\uE8C6",
      Cycling: "\uEAC7",
      D365BusinessCentral: "\uF833",
      D365CoreHR: "\uF6BD",
      D365CustomerInsights: "\uF3C8",
      D365CustomerVoiceApp: "\uE4F7",
      D365ProjectOperations: "\uE432",
      D365TalentInsight: "\uF6BC",
      D365TalentLearn: "\uF6BB",
      DashboardAdd: "\uF52D",
      Database: "\uEFC7",
      DatabaseActivity: "\uE670",
      DatabaseBlock: "\uE617",
      DatabaseRefresh: "\uE67F",
      DatabaseSource: "\uE30A",
      DatabaseSwap: "\uE671",
      DatabaseSync: "\uF842",
      DatabaseView: "\uE437",
      DataConnectionLibrary: "\uEEB7",
      DataEnrichment: "\uE4F5",
      DataFlow: "\uE577",
      Dataflows: "\uF7DD",
      DataflowsLink: "\uE366",
      DataManagementSettings: "\uEFC8",
      Dataverse: "\uE659",
      DateTime: "\uEC92",
      DateTime12: "\uF38F",
      DateTime2: "\uEA17",
      DateTimeMirrored: "\uEE93",
      DeactivateOrders: "\uEFE1",
      Decimals: "\uF218",
      DecisionSolid: "\uF350",
      DeclineCall: "\uF405",
      DecreaseIndent: "\uE39B",
      DecreaseIndentArrow: "\uF7A3",
      DecreaseIndentArrowMirrored: "\uF7A7",
      DecreaseIndentMirrored: "\uE39C",
      DecreaseIndentText: "\uF7A2",
      DecreaseIndentTextMirrored: "\uF7A6",
      DefaultRatio: "\uF529",
      DefaultSettings: "\uF648",
      DefectSolid: "\uF449",
      DefenderApp: "\uE83D",
      DefenderBadge12: "\uF0FB",
      DefenderTVM: "\uF6B3",
      Delete: "\uE74D",
      DeleteColumns: "\uF64E",
      DeleteRows: "\uF64F",
      DeleteRowsMirrored: "\uF650",
      DeleteTable: "\uF651",
      DeliveryTruck: "\uEBF4",
      DelveAnalytics: "\uEEEE",
      DelveAnalyticsLogo: "\uEDCA",
      DelveLogo: "\uF280",
      DelveLogoFill: "\uF281",
      DelveLogoInverse: "\uED76",
      DensityComfy: "\uE4BA",
      DensityDefault: "\uE4B9",
      DependencyAdd: "\uE344",
      DependencyRemove: "\uE345",
      Deploy: "\uF29D",
      Descending: "\uEDC1",
      Design: "\uEB3C",
      DesktopFlow: "\uE4F3",
      DesktopScreenshot: "\uF5D9",
      DeveloperTools: "\uEC7A",
      DeviceBug: "\uE424",
      DeviceOff: "\uE402",
      DeviceRun: "\uE401",
      Devices2: "\uE975",
      Devices3: "\uEA6C",
      Devices4: "\uEB66",
      Diagnostic: "\uE9D9",
      DiagnosticDataBarTooltip: "\uF7DF",
      DiagnosticDataViewerApp: "\uF568",
      Dialpad: "\uE75F",
      Diamond: "\uED02",
      DiamondSolid: "\uF34C",
      DiamondUser: "\uE4F9",
      Dictionary: "\uE82D",
      DictionaryRemove: "\uF69A",
      DietPlanNotebook: "\uEAC8",
      DiffInline: "\uF309",
      DiffSideBySide: "\uF30A",
      Diploma: "\uF320",
      DisableUpdates: "\uE8D8",
      DisconnectVirtualMachine: "\uF873",
      Dislike: "\uE8E0",
      DislikeSolid: "\uF3C0",
      DistributeDown: "\uF76A",
      DockLeft: "\uE90C",
      DockLeftMirrored: "\uEA4C",
      DockRight: "\uE90D",
      DocLibrary: "\uEEB8",
      DocsLogoInverse: "\uEDCB",
      Document: "\uE8A5",
      DocumentApproval: "\uF28B",
      Documentation: "\uEC17",
      DocumentManagement: "\uEFFC",
      DocumentReply: "\uEF57",
      DocumentSearch: "\uEF6C",
      DocumentSet: "\uEED6",
      DOM: "\uEC8D",
      DonutChart: "\uF368",
      Door: "\uEB75",
      DoubleBookmark: "\uEB8F",
      DoubleChevronDown: "\uEE04",
      DoubleChevronDown12: "\uEE97",
      DoubleChevronDown8: "\uF36B",
      DoubleChevronLeft: "\uEDBE",
      DoubleChevronLeft12: "\uEE98",
      DoubleChevronLeft8: "\uF36D",
      DoubleChevronLeftMed: "\uE991",
      DoubleChevronLeftMedMirrored: "\uEA4D",
      DoubleChevronRight: "\uEDBF",
      DoubleChevronRight12: "\uEE99",
      DoubleChevronRight8: "\uF36E",
      DoubleChevronUp: "\uEDBD",
      DoubleChevronUp12: "\uEE96",
      DoubleChevronUp8: "\uF36C",
      DoubleColumn: "\uF1D4",
      DoubleColumnEdit: "\uF322",
      DoubleDownArrow: "\uF769",
      Down: "\uE74B",
      Download: "\uE896",
      DownloadDocument: "\uF549",
      DragObject: "\uF553",
      DrillDown: "\uF532",
      DrillDownSolid: "\uF533",
      DrillExpand: "\uF534",
      DrillShow: "\uF535",
      DrillThrough: "\uF5B9",
      DriverOff: "\uE3FB",
      DRM: "\uECA8",
      Drop: "\uEB42",
      Dropdown: "\uEDC5",
      DropShape: "\uF1A8",
      DropShapeSolid: "\uF63F",
      DuplicateRow: "\uF82A",
      Duststorm: "\uE9CD",
      DynamicList: "\uE491",
      Dynamics365Logo: "\uEDCC",
      DynamicSMBLogo: "\uEDCD",
      EaseOfAccess: "\uE776",
      EatDrink: "\uE807",
      EdgeLogo: "\uE3AB",
      EdgeLogo16: "\uE3AA",
      EdgeOldLogo: "\uEC60",
      eDiscovery: "\uE370",
      Edit: "\uE70F",
      EditContact: "\uEFD3",
      EditCreate: "\uF3C9",
      EditEvent: "\uF05B",
      EditListPencil: "\uE61B",
      EditMail: "\uEF61",
      EditMirrored: "\uEB7E",
      EditNote: "\uED9D",
      EditPhoto: "\uEF77",
      EditSolid12: "\uF4B5",
      EditSolidMirrored12: "\uF4B6",
      EditStyle: "\uEF60",
      EditTable: "\uE4C4",
      Education: "\uE7BE",
      Ellipse: "\uF4FB",
      Embed: "\uECCE",
      EMI: "\uE731",
      Emoji: "\uE899",
      Emoji2: "\uE76E",
      EmojiDisappointed: "\uEA88",
      EmojiNeutral: "\uEA87",
      EmojiTabSymbols: "\uED58",
      EmployeeSelfService: "\uEE24",
      EmptyRecycleBin: "\uEF88",
      Encounter: "\uE54C",
      Encryption: "\uF69D",
      EndPointSolid: "\uEB4B",
      EngineeringGroup: "\uF362",
      EntitlementPolicy: "\uE346",
      EntitlementRedemption: "\uE347",
      EntityExtraction: "\uE467",
      EntryDecline: "\uF555",
      EntryView: "\uF554",
      Equalizer: "\uE9E9",
      EraseTool: "\uE75C",
      Error: "\uE783",
      ErrorBadge: "\uEA39",
      ErrorBadge12: "\uE558",
      Event: "\uECA3",
      Event12: "\uF763",
      EventAccepted: "\uF422",
      EventDate: "\uF059",
      EventDateMissed12: "\uF764",
      EventDeclined: "\uF425",
      EventInfo: "\uED8B",
      EventTentative: "\uF423",
      EventTentativeMirrored: "\uF424",
      EventToDoLogo: "\uF869",
      ExcelDocument: "\uEF73",
      ExcelLogo: "\uF1E5",
      ExcelLogo16: "\uF397",
      ExcelLogoInverse: "\uEC28",
      ExcelLogoInverse16: "\uF396",
      ExchangeLogo: "\uF284",
      ExchangeLogoInverse: "\uED78",
      ExerciseTracker: "\uEACC",
      ExpandAll: "\uF859",
      ExpandMenu: "\uEF67",
      ExploreContent: "\uECCD",
      ExploreContentSingle: "\uF164",
      ExploreData: "\uF5B6",
      Export: "\uEDE1",
      ExportMirrored: "\uEDE2",
      ExpressRouteCircuits: "\uE557",
      ExternalBuild: "\uF445",
      ExternalTFVC: "\uF446",
      ExternalUser: "\uE4CA",
      ExternalXAML: "\uF447",
      Eyedropper: "\uEF3C",
      EyeShadow: "\uF7EB",
      F12DevTools: "\uEBEE",
      FabricAssetLibrary: "\uF09C",
      FabricChannelFolder: "\uE4FA",
      FabricDataConnectionLibrary: "\uF09D",
      FabricDocLibrary: "\uF09E",
      FabricFolder: "\uF0A9",
      FabricFolderConfirm: "\uF7FF",
      FabricFolderFill: "\uF0AA",
      FabricFolderLink: "\uE45C",
      FabricFolderSearch: "\uF0A4",
      FabricFolderUpload: "\uE3AC",
      FabricFormLibrary: "\uF09F",
      FabricFormLibraryMirrored: "\uF0A0",
      FabricMovetoFolder: "\uF0A5",
      FabricNetworkFolder: "\uF5E6",
      FabricNewFolder: "\uF0AB",
      FabricOpenFolderHorizontal: "\uF0A8",
      FabricPictureLibrary: "\uF0AC",
      FabricPublicFolder: "\uF0A3",
      FabricReportLibrary: "\uF0A1",
      FabricReportLibraryMirrored: "\uF0A2",
      FabricSyncFolder: "\uF0A7",
      FabricTextHighlight: "\uF79C",
      FabricTextHighlightComposite: "\uF7DA",
      FabricUnsyncFolder: "\uF0A6",
      FabricUserFolder: "\uF5E5",
      Factory: "\uE60E",
      Family: "\uEBDA",
      FangBody: "\uECEB",
      FastForward: "\uEB9D",
      FastForwardEightX: "\uE443",
      FastForwardFourX: "\uE442",
      FastForwardOneFiveX: "\uE440",
      FastForwardOneX: "\uE43F",
      FastForwardPointFiveX: "\uE43E",
      FastForwardTwoX: "\uE441",
      FastMode: "\uF19A",
      Favicon: "\uE737",
      FavoriteBlock: "\uE67E",
      FavoriteList: "\uE728",
      FavoriteStar: "\uE734",
      FavoriteStarFill: "\uE735",
      Fax: "\uEF5C",
      Feedback: "\uED15",
      FeedbackRequestMirroredSolid: "\uF35A",
      FeedbackRequestSolid: "\uF359",
      FeedbackResponseSolid: "\uF35B",
      Ferry: "\uE7E3",
      FerrySolid: "\uEB48",
      FieldChanged: "\uF2C3",
      FieldEmpty: "\uF2C1",
      FieldFilled: "\uF2C2",
      FieldNotChanged: "\uF2C4",
      FieldReadOnly: "\uF442",
      FieldRequired: "\uF443",
      FileASPX: "\uF2E9",
      FileBug: "\uF30D",
      FileCode: "\uF30E",
      FileComment: "\uF30F",
      FileCSS: "\uF2EA",
      FileHTML: "\uF2ED",
      FileImage: "\uF311",
      FileJAVA: "\uF2E8",
      FileLess: "\uF2EC",
      FileOff: "\uE3FC",
      FilePDB: "\uF2E5",
      FileRequest: "\uF789",
      FileSass: "\uF2EB",
      FileSQL: "\uF2E7",
      FileSymlink: "\uF312",
      FileSystem: "\uE433",
      FileTemplate: "\uF2E6",
      FileTypeSolution: "\uF387",
      FileYML: "\uF5DA",
      Filter: "\uE71C",
      FilterAscending: "\uF21A",
      FilterDescending: "\uF21B",
      Filters: "\uE795",
      FilterSettings: "\uF76C",
      FilterSolid: "\uF412",
      FiltersSolid: "\uF353",
      Financial: "\uE7BB",
      FinancialMirroredSolid: "\uF347",
      FinancialSolid: "\uF346",
      Fingerprint: "\uE928",
      FitPage: "\uE9A6",
      FitWidth: "\uE9A7",
      FiveTileGrid: "\uF274",
      FixedAssetManagement: "\uEF93",
      FixedColumnWidth: "\uE3EA",
      Flag: "\uE7C1",
      FlameSolid: "\uF1F3",
      FlashAuto: "\uE95C",
      Flashlight: "\uE754",
      FlashOff: "\uEA6E",
      FlickDown: "\uE935",
      FlickLeft: "\uE937",
      FlickRight: "\uE938",
      FlickUp: "\uE936",
      Flow: "\uEF90",
      FlowChart: "\uE9D4",
      Flower: "\uF54E",
      FlowTemplate: "\uE49C",
      FlowTrigger: "\uE60C",
      FluidLogo: "\uE48A",
      FocalPoint: "\uF277",
      Focus: "\uEA6F",
      FocusView: "\uF1A3",
      Fog: "\uE9CB",
      Folder: "\uE8B7",
      FolderFill: "\uE8D5",
      FolderHorizontal: "\uF12B",
      FolderList: "\uF2CE",
      FolderListMirrored: "\uF2CF",
      FolderOpen: "\uE838",
      FolderQuery: "\uF2CD",
      FolderSearch: "\uEF65",
      FollowUser: "\uEE05",
      Font: "\uE8D2",
      FontColor: "\uE8D3",
      FontColorA: "\uF4EC",
      FontColorKorean: "\uE5BE",
      FontColorSwatch: "\uF4ED",
      FontDecrease: "\uE8E7",
      FontIncrease: "\uE8E8",
      FontSize: "\uE8E9",
      FontSize2: "\uE3C0",
      FontStyleKorean: "\uE5BA",
      Footer: "\uF82E",
      FormatPainter: "\uE3DC",
      FormLibrary: "\uEEB9",
      FormLibraryMirrored: "\uEEBA",
      FormProcessing: "\uE48B",
      Forum: "\uE378",
      Forward: "\uE72A",
      ForwardEvent: "\uED8C",
      Freezing: "\uE9EF",
      FreezingRain: "\uE475",
      Frigid: "\uE9CA",
      FrontCamera: "\uE96B",
      FSharp: "\uF2F6",
      FSharpLanguage: "\uF2F5",
      FullCircleMask: "\uE91F",
      FullHistory: "\uF31C",
      FullScreen: "\uE740",
      FullView: "\uF1A2",
      FullWidth: "\uF2FE",
      FullWidthEdit: "\uF2FF",
      FunctionalManagerDashboard: "\uF542",
      FunnelChart: "\uE9F1",
      GallatinLogo: "\uF496",
      Game: "\uE7FC",
      Gather: "\uE460",
      Generate: "\uE9DA",
      GenericScan: "\uEE6F",
      GenericScanFilled: "\uF7E3",
      GIF: "\uF4A9",
      Giftbox: "\uEC1F",
      GiftboxOpen: "\uF133",
      GiftBoxSolid: "\uF341",
      GiftCard: "\uEB8E",
      GitGraph: "\uF2CA",
      Glasses: "\uEA16",
      Glimmer: "\uECF4",
      GlobalNavButton: "\uE700",
      GlobalNavButtonActive: "\uF89F",
      Globe: "\uE774",
      Globe2: "\uF49A",
      GlobeFavorite: "\uEF53",
      Go: "\uE8AD",
      Golf: "\uEB1F",
      GoMirrored: "\uEA4F",
      GoToDashboard: "\uEEED",
      GotoToday: "\uE8D1",
      GraphSymbol: "\uE35D",
      GreetingCard: "\uF54B",
      GridViewLarge: "\uF234",
      GridViewMedium: "\uF233",
      GridViewSmall: "\uF232",
      GripperBarHorizontal: "\uE76F",
      GripperBarVertical: "\uE784",
      GripperDotsVertical: "\uF772",
      GripperTool: "\uE75E",
      Group: "\uE902",
      GroupedAscending: "\uEE67",
      GroupedDescending: "\uEE66",
      GroupedList: "\uEF74",
      GroupList: "\uF168",
      GroupObject: "\uF4F1",
      GroupRemove: "\uE495",
      GUID: "\uF52B",
      Guitar: "\uF49B",
      HailDay: "\uEA00",
      HailNight: "\uEA13",
      HalfAlpha: "\uE97E",
      HalfCircle: "\uF501",
      HandsFree: "\uEAD0",
      Handwriting: "\uE929",
      HardDrive: "\uEDA2",
      HardDriveGroup: "\uF18F",
      HardDriveLock: "\uF55A",
      HardDriveUnlock: "\uF55B",
      HazyDay: "\uE46B",
      HazyNight: "\uE479",
      Header: "\uF82F",
      Header1: "\uEA19",
      Header2: "\uEF36",
      Header3: "\uEF37",
      Header4: "\uEF38",
      Headset: "\uE95B",
      HeadsetSolid: "\uF348",
      Health: "\uE95E",
      HealthRefresh: "\uE3BD",
      HealthSolid: "\uF33F",
      Heart: "\uEB51",
      HeartBroken: "\uEA92",
      HeartFill: "\uEB52",
      Help: "\uE897",
      HelpMirrored: "\uEA51",
      HexaditeInvestigation: "\uE3F8",
      HexaditeInvestigationCancel: "\uE3F9",
      HexaditeInvestigationSemiAuto: "\uE3FA",
      Hexagon: "\uF4FE",
      Hide: "\uED1A",
      Hide2: "\uEF89",
      Hide3: "\uF6AC",
      HideVisualFilter: "\uF403",
      Highlight: "\uE7E6",
      HighlightMappedShapes: "\uF2A1",
      HintText: "\uF50F",
      HistoricalWeather: "\uEB43",
      History: "\uE81C",
      Home: "\uE80F",
      HomeDropdown: "\uE427",
      HomeGroup: "\uEC26",
      HomeSolid: "\uEA8A",
      HomeVerify: "\uF00E",
      HorizontalDistributeCenter: "\uF4F9",
      HorizontalTabKey: "\uE7FD",
      Hospital: "\uE91D",
      Hot: "\uECE2",
      Hotel: "\uE824",
      HourGlass: "\uEA03",
      Ice: "\uE473",
      IconSetsFlag: "\uF2A4",
      IDBadge: "\uF427",
      IgnoreConversation: "\uE372",
      ImageCrosshair: "\uF2C9",
      ImageDiff: "\uF30B",
      ImageInAR: "\uE420",
      ImagePixel: "\uF30C",
      ImageSearch: "\uF4E8",
      Import: "\uE8B5",
      ImportAllMirrored: "\uEA53",
      Important: "\uE8C9",
      ImportMirrored: "\uEA52",
      Inbox: "\uF41C",
      InboxActive: "\uE497",
      InboxCheck: "\uEF64",
      IncidentTriangle: "\uE814",
      IncomingCall: "\uE77E",
      IncreaseIndent: "\uE399",
      IncreaseIndentArrow: "\uF7A1",
      IncreaseIndentArrowMirrored: "\uF7A5",
      IncreaseIndentHanging: "\uE39D",
      IncreaseIndentHangingMirrored: "\uE39E",
      IncreaseIndentMirrored: "\uE39A",
      IncreaseIndentText: "\uF7A0",
      IncreaseIndentTextMirrored: "\uF7A4",
      IndentFirstLine: "\uE3DD",
      Info: "\uE946",
      Info12: "\uE55A",
      Info2: "\uEA1F",
      InformationBarriers: "\uF803",
      InfoSolid: "\uF167",
      InkingTool: "\uE76D",
      InputAddress: "\uE41E",
      Insert: "\uF278",
      InsertColumnsLeft: "\uF64A",
      InsertColumnsRight: "\uF64B",
      InsertRowsAbove: "\uF64C",
      InsertRowsBelow: "\uF64D",
      InsertSignatureLine: "\uF677",
      InsertTextBox: "\uEC7D",
      InsertTextBoxKorean: "\uE5D3",
      Insights: "\uE3AF",
      Installation: "\uE311",
      InstallToDrive: "\uF28D",
      IntermittentCloudsDay: "\uE46A",
      IntermittentCloudsNight: "\uE478",
      InternalInvestigation: "\uF854",
      InternetSharing: "\uE704",
      IntersectShape: "\uF8FD",
      Invoice: "\uE9DC",
      IOT: "\uF22C",
      IoTSecure: "\uE4D6",
      IRMForward: "\uF41F",
      IRMForwardMirrored: "\uF420",
      IRMReply: "\uF41D",
      IRMReplyMirrored: "\uF41E",
      IssueSolid: "\uF448",
      IssueTracking: "\uEEC0",
      IssueTrackingMirrored: "\uEEC1",
      Italic: "\uE8DB",
      ItalicC: "\uE5B2",
      ItalicD: "\uE5CE",
      ItalicK: "\uE5B6",
      ItalicKazakh: "\uE5D2",
      ItalicKorean: "\uE5BC",
      ItalicL: "\uE5D1",
      ItalicS: "\uE5CF",
      ItalicT: "\uE5D0",
      JavaScriptLanguage: "\uF2EE",
      JoinOnlineMeeting: "\uED8F",
      JS: "\uEBF0",
      KaizalaLogo: "\uF492",
      KeyboardClassic: "\uE765",
      KeyPhraseExtraction: "\uE395",
      KnowledgeArticle: "\uF000",
      KnowledgeManagementApp: "\uE4FC",
      Label: "\uE932",
      LadybugSolid: "\uF44A",
      Lamp: "\uEB19",
      LandscapeOrientation: "\uEF6B",
      LaptopSecure: "\uF552",
      LaptopSelected: "\uEC76",
      LargeGrid: "\uEECB",
      LearningApp: "\uE5D8",
      LearningTools: "\uF7DB",
      Leave: "\uF627",
      LeaveUser: "\uE3A8",
      Library: "\uE8F1",
      LibraryAddTo: "\uE60D",
      Lifesaver: "\uEF62",
      LifesaverLock: "\uEF63",
      Light: "\uE793",
      Lightbulb: "\uEA80",
      LightbulbSolid: "\uE681",
      LightningBolt: "\uE945",
      LightningBoltSolid: "\uE45F",
      LightningSecure: "\uE4D3",
      LightSnow: "\uEA02",
      LightWeight: "\uF4EE",
      Like: "\uE8E1",
      LikeSolid: "\uF3BF",
      Line: "\uF4FC",
      LineChart: "\uE9E6",
      LineSpacing: "\uF517",
      LineStyle: "\uF50C",
      LineThickness: "\uF50D",
      Link: "\uE71B",
      Link12: "\uF6E3",
      LinkedDatabase: "\uF779",
      LinkedInLogo: "\uF20A",
      List: "\uEA37",
      ListMirrored: "\uEA55",
      LiveSite: "\uF6A6",
      LocalAdmin: "\uF1FB",
      LocaleLanguage: "\uF2B7",
      Location: "\uE81D",
      LocationCircle: "\uE80E",
      LocationDot: "\uE827",
      LocationFill: "\uE920",
      LocationOutline: "\uF2D0",
      Lock: "\uE72E",
      Lock12: "\uF6E6",
      LockShare: "\uE455",
      LockSolid: "\uE9A2",
      LogRemove: "\uF316",
      LookupEntities: "\uF5B5",
      LowerBrightness: "\uEC8A",
      LowerCase: "\uE5EE",
      LyncLogo: "\uED79",
      M365InvoicingLogo: "\uF7C1",
      MachineLearning: "\uE3B8",
      Mail: "\uE715",
      MailAlert: "\uED80",
      MailAttached: "\uF774",
      MailCheck: "\uED81",
      MailFill: "\uE8A8",
      MailForward: "\uE89C",
      MailForwardMirrored: "\uEA56",
      MailLink: "\uEFAC",
      MailLowImportance: "\uED82",
      MailOptions: "\uF82C",
      MailPause: "\uED83",
      MailReminder: "\uF418",
      MailRepeat: "\uED84",
      MailReply: "\uE8CA",
      MailReplyAll: "\uE8C2",
      MailReplyAllMirrored: "\uEA58",
      MailReplyMirrored: "\uEA57",
      MailSchedule: "\uF72E",
      MailSecure: "\uE4D4",
      MailSolid: "\uF343",
      MailTentative: "\uF416",
      MailTentativeMirrored: "\uF417",
      MailUndelivered: "\uF415",
      ManagerSelfService: "\uEE23",
      Manufacturing: "\uE99C",
      MapDirections: "\uE816",
      MapLayers: "\uE81E",
      MapPin: "\uE707",
      MapPin12: "\uE3AE",
      MapPinSolid: "\uF52E",
      MarkAsProtected: "\uF6AE",
      MarkDownLanguage: "\uF2FB",
      Market: "\uEAFC",
      MarketDown: "\uEF42",
      MasterDatabase: "\uF5BA",
      MaximumValue: "\uF5BC",
      Medal: "\uEE38",
      MedalSolid: "\uF6B9",
      Media: "\uEA69",
      MediaAdd: "\uF510",
      Medical: "\uEAD4",
      MedicalCare: "\uE54D",
      MedicationAdmin: "\uE54E",
      MedicationRequest: "\uE54F",
      Megaphone: "\uE789",
      MegaphoneSolid: "\uF332",
      Memo: "\uE77C",
      Merge: "\uE7D5",
      MergeCase: "\uEFC9",
      MergeDuplicate: "\uF29A",
      Message: "\uE8BD",
      MessageFill: "\uEC70",
      MessageFriendRequest: "\uF055",
      MetricsFailure: "\uE4CE",
      MetricsInstall: "\uE4CD",
      MetricsUsage: "\uE4CC",
      MicOff: "\uEC54",
      MicOff2: "\uF781",
      Microphone: "\uE720",
      MicrosoftStaffhubLogo: "\uF130",
      MicrosoftTranslatorLogo: "\uF782",
      MicrosoftTranslatorLogoBlue: "\uF853",
      MicrosoftTranslatorLogoGreen: "\uF852",
      MiniContract: "\uE93B",
      MiniContractMirrored: "\uEA59",
      MiniExpand: "\uE93A",
      MiniExpandMirrored: "\uEA5A",
      MiniLink: "\uE732",
      MinimumValue: "\uF5BD",
      MobileAngled: "\uE463",
      MobileReport: "\uF18A",
      MobileSelected: "\uEC75",
      ModelAppTemplate32: "\uE5FD",
      ModelingView: "\uF871",
      Money: "\uEAFD",
      More: "\uE712",
      MoreSports: "\uEB22",
      MoreVertical: "\uF2BC",
      MostyClearNight: "\uE476",
      MostyCloudyFlurriesDay: "\uE471",
      MostyCloudyFlurriesNight: "\uE47D",
      MostyCloudyShowersDay: "\uE46D",
      MostyCloudyTStormsDay: "\uE46F",
      MostyCloudyTStormsNight: "\uE47B",
      MostySunnyDay: "\uE468",
      MountainClimbing: "\uF6DB",
      Move: "\uE7C2",
      Movers: "\uEBCD",
      MoveToFolder: "\uE8DE",
      MSListsConnected: "\uE601",
      MSNLogo: "\uEB6C",
      MSNVideos: "\uEB1C",
      MSNVideosSolid: "\uF2DA",
      MSNVolume: "\uEB15",
      MultiSelect: "\uE762",
      MultiSelectMirrored: "\uEA98",
      MusicInCollection: "\uE940",
      MusicInCollectionFill: "\uEA36",
      MusicNote: "\uEC4F",
      MuteChat: "\uF17A",
      MyMoviesTV: "\uEE6C",
      MyNetwork: "\uEC27",
      Nav2DMapView: "\uE800",
      NavigateBack: "\uF2DD",
      NavigateBackMirrored: "\uF2DE",
      NavigateExternalInline: "\uF35F",
      NavigateForward: "\uF2DF",
      NavigateForwardMirrored: "\uF2E0",
      NavigationFlipper: "\uF51D",
      NetworkDeviceScanning: "\uE4F6",
      NetworkTower: "\uEC05",
      NewAnalyticsQuery: "\uF1E0",
      NewFolder: "\uE8F4",
      NewMail: "\uF7EA",
      News: "\uE900",
      NewsSearch: "\uF4E9",
      NewTeamProject: "\uF2B2",
      Next: "\uE893",
      NormalWeight: "\uF4EF",
      NoteForward: "\uED99",
      NotePinned: "\uED9A",
      NoteReply: "\uED98",
      NotExecuted: "\uF440",
      NotImpactedSolid: "\uF441",
      NugetLogo: "\uF44C",
      NUIFace: "\uEB68",
      Number: "\uF691",
      NumberedList: "\uEA1C",
      NumberedListMirrored: "\uE398",
      NumberedListNumber: "\uF797",
      NumberedListNumberMirrored: "\uF799",
      NumberedListText: "\uF796",
      NumberedListTextMirrored: "\uF798",
      NumberField: "\uEDC4",
      NumberSequence: "\uF52A",
      NumberSymbol: "\uF7AC",
      Oauth: "\uE5C3",
      ObjectRecognition: "\uE4EE",
      Octagon: "\uF4FD",
      ODLink: "\uE4BB",
      ODLink12: "\uE4BC",
      ODSharedChannel: "\uE649",
      ODSharedChannel12: "\uE64A",
      OEM: "\uE74C",
      OfficeAddinsLogo: "\uEEC7",
      OfficeAssistantLogo: "\uEDCE",
      OfficeCatchUp: "\uE490",
      OfficeChat: "\uF70F",
      OfficeChatSolid: "\uF710",
      OfficeFormsLogo: "\uF434",
      OfficeFormsLogo16: "\uF436",
      OfficeFormsLogo24: "\uF43B",
      OfficeFormsLogoInverse: "\uEF86",
      OfficeFormsLogoInverse16: "\uF433",
      OfficeFormsLogoInverse24: "\uF43A",
      OfficeLogo: "\uEB6E",
      OfficeStoreLogo: "\uEDCF",
      OfficeVideoLogo: "\uF282",
      OfficeVideoLogoFill: "\uF283",
      OfficeVideoLogoInverse: "\uED7A",
      OfflineOneDriveParachute: "\uEEC8",
      OfflineOneDriveParachuteDisabled: "\uEEC9",
      OfflineStorage: "\uEC8C",
      OfflineStorageSolid: "\uF34E",
      Onboarding: "\uF3BA",
      OneDriveAdd: "\uEF32",
      OneDriveFolder16: "\uF53B",
      OneDriveLogo: "\uE941",
      OneNoteDocType: "\uF04F",
      OneNoteEduLogoInverse: "\uEDD0",
      OneNoteLogo: "\uF1E7",
      OneNoteLogo16: "\uF39A",
      OneNoteLogoInverse: "\uEC0D",
      OneNoteLogoInverse16: "\uF399",
      OpenEnrollment: "\uEF1C",
      OpenFile: "\uE8E5",
      OpenFolderHorizontal: "\uED25",
      OpenInNewTab: "\uF6AB",
      OpenInNewWindow: "\uE8A7",
      OpenPane: "\uE8A0",
      OpenPaneMirrored: "\uEA5B",
      OpenSource: "\uEBC2",
      OpenWith: "\uE7AC",
      OpenWithMirrored: "\uEA5C",
      Opportunities: "\uF05F",
      OrderLock: "\uE4CB",
      Org: "\uECA6",
      Orientation: "\uE8B4",
      Orientation2: "\uF7E1",
      OutlookLogo: "\uF1E9",
      OutlookLogo16: "\uF39D",
      OutlookLogoInverse: "\uEB6D",
      OutlookLogoInverse16: "\uF39C",
      OutlookSpacesBucket: "\uE481",
      OutOfOffice: "\uED34",
      PAAction: "\uE60B",
      Package: "\uE7B8",
      Packages: "\uF318",
      Padding: "\uF518",
      PaddingBottom: "\uF51A",
      PaddingLeft: "\uF51B",
      PaddingRight: "\uF51C",
      PaddingTop: "\uF519",
      Page: "\uE7C3",
      PageAdd: "\uEA1A",
      PageArrowRight: "\uEFB8",
      PageBlock: "\uEFB5",
      PageCheckedin: "\uF104",
      PageCheckedOut: "\uF02C",
      PageData: "\uE31C",
      PageEdit: "\uEFB6",
      PageHeader: "\uECEE",
      PageHeaderEdit: "\uE31D",
      PageLeft: "\uE760",
      PageLink: "\uE302",
      PageList: "\uF106",
      PageListFilter: "\uF813",
      PageListMirroredSolid: "\uF33B",
      PageListSolid: "\uF33A",
      PageLock: "\uF43F",
      PagePermission: "\uE618",
      PageRemove: "\uEFBA",
      PageRight: "\uE761",
      PageShared: "\uF02D",
      PageSolid: "\uE729",
      PanoIndicator: "\uE7B0",
      Parachute: "\uF351",
      ParachuteSolid: "\uF352",
      Parameter: "\uF306",
      ParkingLocation: "\uE811",
      ParkingLocationMirrored: "\uEA5E",
      ParkingMirroredSolid: "\uF34B",
      ParkingSolid: "\uF34A",
      PartlyClearNight: "\uE477",
      PartlyCloudyDay: "\uE9C0",
      PartlyCloudyNight: "\uE9C1",
      PartlySunnyDay: "\uE469",
      PartlySunnyFlurriesDay: "\uE472",
      PartlySunnyShowersDay: "\uE46E",
      PartlySunnyShowersNight: "\uE47A",
      PartlySunnyTStormsDay: "\uE470",
      PartlySunnyTStormsNight: "\uE47C",
      PartyLeader: "\uECA7",
      PassiveAuthentication: "\uF32A",
      PasswordField: "\uF6AA",
      Paste: "\uE77F",
      PasteAsCode: "\uF5D6",
      PasteAsText: "\uF5D5",
      Pause: "\uE769",
      PaymentCard: "\uE8C7",
      PBIAnomaliesMarker: "\uE554",
      PBIAnomaly: "\uE548",
      PBIColumn: "\uE67A",
      PBIConnectPoints: "\uE67B",
      PBIDirectQuery: "\uE4E9",
      PBIDual: "\uE4EA",
      PBIGap: "\uE67C",
      PBIGoalEntry: "\uE615",
      PBIGoalEntryAdd: "\uE616",
      PBIHomeLayoutDefault: "\uE65B",
      PBIHomeLayoutExpanded: "\uE65C",
      PBIImport: "\uE4EB",
      PBILiveConnect: "\uE4EC",
      PBIPerspective: "\uE658",
      PBIReportTemplate: "\uE5EC",
      PBIZero: "\uE67D",
      PC1: "\uE977",
      PDF: "\uEA90",
      PencilReply: "\uEF7B",
      Pentagon: "\uF4FF",
      PenWorkspace: "\uEDC6",
      People: "\uE716",
      PeopleAdd: "\uEA15",
      PeopleAlert: "\uED93",
      PeopleBlock: "\uED91",
      PeopleExternalShare: "\uE5EF",
      PeoplePause: "\uED94",
      PeopleRepeat: "\uED92",
      Permissions: "\uE8D7",
      PermissionsSolid: "\uF349",
      Personalize: "\uE771",
      Phishing: "\uF679",
      PhishingCampaign: "\uE48D",
      PhishingHook: "\uE48E",
      Phone: "\uE717",
      Photo: "\uE91B",
      Photo2: "\uEB9F",
      Photo2Add: "\uECAB",
      Photo2Fill: "\uF79F",
      Photo2Remove: "\uECAC",
      PhotoBlock: "\uE4C3",
      PhotoCollection: "\uE7AA",
      PhotoError: "\uE3F7",
      PhotoVideoMedia: "\uF0B1",
      Picture: "\uE8B9",
      PictureCenter: "\uF522",
      PictureFill: "\uF523",
      PictureLibrary: "\uEEC2",
      PicturePosition: "\uF524",
      PictureStretch: "\uF525",
      PictureTile: "\uF526",
      PieDouble: "\uEB04",
      PieSingle: "\uEB05",
      PieSingleSolid: "\uF530",
      Pill: "\uEACB",
      Pin: "\uE718",
      Pinned: "\uE840",
      PinnedFill: "\uE842",
      PinnedSolid: "\uF676",
      PinSolid12: "\uE352",
      PinSolidOff12: "\uE353",
      PinToTab: "\uE5E5",
      PivotChart: "\uF24C",
      PlainText: "\uF834",
      PlannerLogo: "\uEDD1",
      PlanView: "\uF360",
      Play: "\uE768",
      PlaybackRate1x: "\uEC57",
      PlayerSettings: "\uEF58",
      PlaylistMusic: "\uE93F",
      PlayResume: "\uF2C6",
      PlayReverse: "\uF3E5",
      PlayReverseResume: "\uF3E4",
      PlaySolid: "\uF5B0",
      Plug: "\uF300",
      PlugConnected: "\uF302",
      PlugDisconnected: "\uF303",
      PlugSolid: "\uF301",
      POI: "\uECAF",
      POISolid: "\uF2D1",
      PollResults: "\uF8A0",
      PopExpand: "\uE49A",
      PortalAppTemplate32: "\uE5FC",
      PostUpdate: "\uE8F3",
      PowerApps: "\uEDD2",
      PowerApps2Logo: "\uF092",
      PowerAppsLogo: "\uF091",
      PowerAppsTemplate: "\uE4AC",
      PowerAutomateLogo: "\uF4B1",
      PowerBILogo: "\uEA1E",
      PowerBILogo16: "\uF790",
      PowerBILogoBackplate16: "\uF791",
      PowerButton: "\uE7E8",
      PowerPointDocument: "\uEF72",
      PowerPointLogo: "\uF1EB",
      PowerPointLogo16: "\uF394",
      PowerPointLogoInverse: "\uEC2A",
      PowerPointLogoInverse16: "\uF393",
      PowerShell: "\uF1FD",
      PowerShell2: "\uF730",
      PowerStandby: "\uE55C",
      PowerVirtualAgentsLogo: "\uE484",
      Precipitation: "\uE9CF",
      PresenceChickletVideo: "\uE979",
      Presentation: "\uF6E4",
      Presentation12: "\uF6E5",
      Preview: "\uE8FF",
      PreviewBelow: "\uE5D5",
      PreviewLink: "\uE8A1",
      PreviewSideBySide: "\uE5D6",
      Previous: "\uE892",
      PrimaryCalendar: "\uF4AE",
      Print: "\uE749",
      PrintfaxPrinterFile: "\uE956",
      Priority: "\uE8D0",
      Process: "\uE9F3",
      ProcessAdvisor: "\uE5E4",
      Processing: "\uE9F5",
      ProcessingCancel: "\uE403",
      ProcessingPause: "\uE405",
      ProcessingRun: "\uE404",
      ProcessMap: "\uE9F6",
      ProcessMetaTask: "\uF290",
      Product: "\uECDC",
      ProductCatalog: "\uEFE8",
      ProductionFloorManagement: "\uEE29",
      ProductList: "\uE31E",
      ProductRelease: "\uEE2E",
      ProductVariant: "\uEE30",
      ProductWarning: "\uE5C0",
      ProfileSearch: "\uEF35",
      ProFootball: "\uEB27",
      ProgressLoopInner: "\uECDE",
      ProgressLoopOuter: "\uECDF",
      ProgressRing5: "\uEDF6",
      ProgressRingDots: "\uF16A",
      ProHockey: "\uEB28",
      ProjectCollection: "\uF363",
      ProjectDocument: "\uF759",
      ProjectLogo16: "\uF480",
      ProjectLogo32: "\uF47E",
      ProjectLogoInverse: "\uEDD4",
      ProjectManagement: "\uE9DE",
      PromotedDatabase: "\uF77D",
      Pronouns: "\uE556",
      ProtectedDocument: "\uE8A6",
      ProtectionCenterLogo32: "\uF494",
      ProtectRestrict: "\uF22A",
      ProvisioningPackage: "\uE835",
      PublicCalendar: "\uEF6D",
      PublicContactCard: "\uEF6E",
      PublicContactCardMirrored: "\uF230",
      PublicEmail: "\uEF6F",
      PublicFolder: "\uEF70",
      PublishContent: "\uF0D4",
      PublishCourse: "\uF699",
      PublisherLogo: "\uF1ED",
      PublisherLogo16: "\uF3A0",
      PublisherLogoInverse16: "\uF39F",
      Puzzle: "\uEA86",
      PY: "\uF2F9",
      PythonLanguage: "\uF2F8",
      QandA: "\uF8A2",
      QandAMirror: "\uF8A3",
      QRCode: "\uED14",
      QuadColumn: "\uF66F",
      Quantity: "\uE9F8",
      QuarterCircle: "\uF502",
      QueryList: "\uF2B8",
      Questionnaire: "\uEE19",
      QuestionnaireMirrored: "\uEE4B",
      QueueAdvanced: "\uE62E",
      QuickNote: "\uE70B",
      QuickNoteSolid: "\uF338",
      Quotes: "\uF067",
      R: "\uF4EB",
      RadioBtnOff: "\uECCA",
      RadioBtnOn: "\uECCB",
      RadioBullet: "\uE915",
      Rain: "\uE9C4",
      RainShowersDay: "\uE9C3",
      RainShowersNight: "\uEA0F",
      RainSnow: "\uE9C7",
      Rate: "\uEB07",
      RawSource: "\uF299",
      Read: "\uE8C3",
      ReadingMode: "\uE736",
      ReadingModeSolid: "\uF33D",
      ReadOutLoud: "\uF112",
      RealEstate: "\uE758",
      ReceiptCheck: "\uEF5B",
      ReceiptForward: "\uEF59",
      ReceiptProcessing: "\uE496",
      ReceiptReply: "\uEF5A",
      ReceiptTentative: "\uF41A",
      ReceiptTentativeMirrored: "\uF41B",
      ReceiptUndelivered: "\uF419",
      Recent: "\uE823",
      Record2: "\uEA3F",
      RecordRouting: "\uE62D",
      RecruitmentManagement: "\uEE12",
      RectangleShape: "\uF1A9",
      RectangleShapeSolid: "\uF640",
      RectangularClipping: "\uF407",
      RecurringEvent: "\uEF5D",
      RecurringTask: "\uEDB2",
      RecycleBin: "\uEF87",
      Redeploy: "\uF29E",
      RedEye: "\uE7B3",
      RedEye12: "\uE3AD",
      Redo: "\uE7A6",
      Refresh: "\uE72C",
      RegistryEditor: "\uF1FF",
      Relationship: "\uF003",
      ReleaseDefinition: "\uF6EA",
      ReleaseGate: "\uF7BE",
      ReleaseGateCheck: "\uF7BF",
      ReleaseGateError: "\uF7C0",
      ReminderGroup: "\uEBF8",
      ReminderPerson: "\uEBF7",
      ReminderTime: "\uEBF9",
      Remote: "\uE8AF",
      RemoteApplication: "\uF621",
      Remove: "\uE738",
      RemoveContent: "\uECC7",
      RemoveEvent: "\uED8A",
      RemoveFilter: "\uEB08",
      RemoveFromShoppingList: "\uF7D5",
      RemoveFromTrash: "\uF82B",
      RemoveLink: "\uED90",
      RemoveLinkChain: "\uF79A",
      RemoveLinkX: "\uF79B",
      RemoveOccurrence: "\uED9B",
      Rename: "\uE8AC",
      RenewalCurrent: "\uF545",
      RenewalFuture: "\uF546",
      ReopenPages: "\uED50",
      Repair: "\uE90F",
      RepeatAll: "\uE8EE",
      RepeatHeaderRows: "\uE3EB",
      RepeatOne: "\uE8ED",
      Reply: "\uE97A",
      ReplyAll: "\uEE0A",
      ReplyAllAlt: "\uEF5F",
      ReplyAllMirrored: "\uEE36",
      ReplyAlt: "\uEF5E",
      ReplyMirrored: "\uEE35",
      Repo: "\uF2CB",
      ReportAdd: "\uF52C",
      ReportAlert: "\uF721",
      ReportAlertMirrored: "\uF722",
      ReportDocument: "\uE9F9",
      ReportHacked: "\uE730",
      ReportLibrary: "\uEEBB",
      ReportLibraryMirrored: "\uEEBC",
      ReportLock: "\uF875",
      ReportTrophy: "\uE614",
      ReportWarning: "\uF569",
      RepoSolid: "\uF2CC",
      Rerun: "\uF8A1",
      ReservationOrders: "\uF845",
      Reset: "\uE423",
      ResetDevice: "\uED10",
      ResponsesMenu: "\uF768",
      ReturnKey: "\uE751",
      ReturnToSession: "\uED24",
      RevenueManagement: "\uF85E",
      ReviewRequestMirroredSolid: "\uF357",
      ReviewRequestSolid: "\uF356",
      ReviewResponseSolid: "\uF358",
      ReviewSolid: "\uF355",
      RevToggleKey: "\uE845",
      RewardsLogo: "\uED4E",
      RewardsLogoArt64: "\uEEF2",
      RewardsLogoSolid: "\uED4F",
      Rewind: "\uEB9E",
      RewindEightX: "\uE449",
      RewindFourX: "\uE448",
      RewindOneFiveX: "\uE446",
      RewindOneX: "\uE445",
      RewindPointFiveX: "\uE444",
      RewindTwoX: "\uE447",
      Ribbon: "\uE9D1",
      Ribbon2: "\uF19B",
      RibbonSolid: "\uF345",
      RightDoubleQuote: "\uE9B1",
      RightTriangle: "\uF500",
      Ringer: "\uEA8F",
      RingerActive: "\uE498",
      RingerOff: "\uF2C5",
      RingerRemove: "\uF279",
      RingerSolid: "\uEF3A",
      Robot: "\uE99A",
      Rocket: "\uF3B3",
      Room: "\uED9F",
      Rotate: "\uE7AD",
      Rotate90Clockwise: "\uF80D",
      Rotate90CounterClockwise: "\uF80E",
      RowsChild: "\uF29C",
      RowsGroup: "\uF29B",
      Rugby: "\uEB2D",
      Running: "\uEADA",
      Sad: "\uE757",
      SadSolid: "\uF33E",
      SamsungGallery: "\uE4E2",
      Save: "\uE74E",
      SaveAll: "\uF203",
      SaveAndClose: "\uF038",
      SaveAs: "\uE792",
      SavedOffline: "\uE546",
      SaveTemplate: "\uF6EC",
      SaveToMobile: "\uF7E0",
      Savings: "\uEB0B",
      ScaleUp: "\uED09",
      ScaleVolume: "\uF18C",
      ScatterChart: "\uEFEB",
      ScheduleEventAction: "\uF1EF",
      SchoolDataSyncLogo: "\uE34C",
      ScopeTemplate: "\uF2B0",
      Screen: "\uEF39",
      ScreenCast: "\uF7E2",
      ScreenPreviewOn: "\uF11E",
      ScreenTime: "\uF182",
      Script: "\uF03A",
      ScrollUpDown: "\uEC8F",
      SDCard: "\uE7F1",
      Search: "\uE721",
      SearchAndApps: "\uE773",
      SearchArt64: "\uEEF5",
      SearchBookmark: "\uF5B8",
      SearchCalendar: "\uF4AF",
      SearchData: "\uF3F1",
      SearchIssue: "\uF09A",
      SearchIssueMirrored: "\uF09B",
      SearchNearby: "\uE820",
      SecondaryNav: "\uF814",
      Section: "\uEC0C",
      Sections: "\uEF76",
      SecurityCamera: "\uEB35",
      SecurityGroup: "\uED85",
      SecurityTest: "\uE48F",
      SeeDo: "\uE808",
      SelectAll: "\uE8B3",
      Sell: "\uEB0C",
      SemiboldWeight: "\uF4F0",
      Send: "\uE724",
      SendMirrored: "\uEA63",
      SentimentAnalysis: "\uE393",
      Separator: "\uF35E",
      Server: "\uF201",
      ServerEnviroment: "\uF29F",
      ServerProcesses: "\uF1FE",
      ServiceActivity: "\uEFF1",
      ServiceOff: "\uE3FD",
      SetAction: "\uF071",
      Settings: "\uE713",
      SettingsAdd: "\uE35A",
      SettingsSecure: "\uE4D2",
      SettingsSync: "\uE359",
      ShakeDevice: "\uF80A",
      Shapes: "\uEC7C",
      ShapeSolid: "\uE422",
      Share: "\uE72D",
      SharedDatabase: "\uE3D9",
      SharedNotes: "\uF481",
      ShareiOS: "\uEF79",
      Sharepoint2013LogoInverse: "\uE480",
      SharepointAppIcon16: "\uE365",
      SharepointLogo: "\uF27E",
      SharepointLogoInverse: "\uED18",
      Shield: "\uEA18",
      ShieldAlert: "\uF7D7",
      ShieldSolid: "\uF340",
      Shirt: "\uED00",
      Shop: "\uE719",
      ShoppingCart: "\uE7BF",
      ShoppingCartSolid: "\uF342",
      ShopServer: "\uF2B6",
      Showers: "\uE46C",
      ShowGrid: "\uF7DE",
      ShowResults: "\uE8BC",
      ShowResultsMirrored: "\uEA65",
      ShowTimeAs: "\uF787",
      ShowVisualFilter: "\uF4DE",
      SidePanel: "\uEF52",
      SidePanelMirrored: "\uF221",
      Signin: "\uF286",
      SignOut: "\uF3B1",
      SimplifiedView: "\uE5C1",
      SingleBookmark: "\uEDFF",
      SingleBookmarkSolid: "\uEE00",
      SingleColumn: "\uF1D3",
      SingleColumnEdit: "\uF321",
      SIPMove: "\uE759",
      SiteScan: "\uEBEC",
      SizeLegacy: "\uE2B2",
      SkipBack10: "\uED3C",
      SkipForward30: "\uED3D",
      SkiResorts: "\uEB45",
      SkypeArrow: "\uF748",
      SkypeCheck: "\uEF80",
      SkypeCircleArrow: "\uF747",
      SkypeCircleCheck: "\uEF7D",
      SkypeCircleClock: "\uEF7E",
      SkypeCircleMinus: "\uEF7F",
      SkypeCircleSlash: "\uF825",
      SkypeClock: "\uEF81",
      SkypeForBusinessLogo: "\uF0FC",
      SkypeForBusinessLogo16: "\uF40F",
      SkypeForBusinessLogoFill: "\uF27D",
      SkypeForBusinessLogoFill16: "\uF410",
      SkypeLogo: "\uEB6F",
      SkypeLogo16: "\uF40E",
      SkypeMessage: "\uEF83",
      SkypeMinus: "\uEF82",
      SkypeSlash: "\uF826",
      Sleet: "\uE474",
      Slider: "\uF527",
      SliderHandleSize: "\uF528",
      SliderThumb: "\uEC13",
      Slideshow: "\uE786",
      SmartGlassRemote: "\uF80B",
      SnapToGrid: "\uF7E4",
      Snooze: "\uF4BD",
      Snow: "\uE9C8",
      Snowflake: "\uEB46",
      SnowShowerDay: "\uE9FD",
      SnowShowerNight: "\uEA11",
      Soccer: "\uEB21",
      SocialListeningLogo: "\uED7C",
      Sort: "\uE8CB",
      SortDown: "\uEE69",
      SortLines: "\uE9D0",
      SortLinesAscending: "\uE43A",
      SortUp: "\uEE68",
      Source: "\uEB1B",
      Spacer: "\uF40D",
      Speakers: "\uE7F5",
      SpecialEvent: "\uF536",
      Speech: "\uEFA9",
      SpeechOff: "\uF8BA",
      SpeedHigh: "\uEC4A",
      Spelling: "\uF87B",
      Split: "\uEDBC",
      SplitObject: "\uF547",
      Sprint: "\uF3B0",
      SQLAnalyticsPool: "\uE434",
      SQLServerLogo: "\uE61A",
      Squalls: "\uE9CC",
      SquareShape: "\uF1A6",
      SquareShapeSolid: "\uF63D",
      Stack: "\uF26F",
      StackColumnChart: "\uE9FC",
      StackedBarChart: "\uF24D",
      StackedBarChartFull: "\uF668",
      StackedColumnChart2: "\uF666",
      StackedColumnChart2Fill: "\uF831",
      StackedLineChart: "\uF24E",
      StackIndicator: "\uE7FF",
      StaffNotebookLogo16: "\uF48E",
      StaffNotebookLogo32: "\uF48C",
      StaffNotebookLogoFill16: "\uF48F",
      StaffNotebookLogoFill32: "\uF48D",
      StaffNotebookLogoInverted16: "\uF491",
      StaffNotebookLogoInverted32: "\uF490",
      Starburst: "\uEF78",
      StarburstSolid: "\uF33C",
      StatusCircleBlock: "\uF140",
      StatusCircleBlock2: "\uF141",
      StatusCircleCheckmark: "\uF13E",
      StatusCircleErrorX: "\uF13D",
      StatusCircleExclamation: "\uF13C",
      StatusCircleInfo: "\uF13F",
      StatusCircleInner: "\uF137",
      StatusCircleOuter: "\uF136",
      StatusCircleQuestionMark: "\uF142",
      StatusCircleRing: "\uF138",
      StatusCircleSync: "\uF143",
      StatusErrorFull: "\uEB90",
      StatusTriangle: "\uEA82",
      StatusTriangleExclamation: "\uF13B",
      StatusTriangleInner: "\uF13A",
      StatusTriangleOuter: "\uF139",
      Step: "\uF241",
      StepInsert: "\uF242",
      StepShared: "\uF243",
      StepSharedAdd: "\uF244",
      StepSharedInsert: "\uF245",
      StickyNotesOutlineAppIcon: "\uE36A",
      StickyNotesSolidAppIcon: "\uE36B",
      StockDown: "\uEB0F",
      StockUp: "\uEB11",
      Stop: "\uE71A",
      StopSolid: "\uEE95",
      Stopwatch: "\uE916",
      StorageAcount: "\uE435",
      StorageOptical: "\uE958",
      StoreLogo16: "\uEA96",
      StoreLogoMed20: "\uEA04",
      Storyboard: "\uF308",
      StreamDiscover: "\uF7D9",
      Streaming: "\uE93E",
      StreamingDataflow: "\uE668",
      StreamingDataset: "\uE667",
      StreamingOff: "\uF2BB",
      StreamLogo: "\uF329",
      StreamPlaylist: "\uE669",
      Street: "\uE913",
      StreetsideSplitMinimize: "\uE802",
      Strikethrough: "\uEDE0",
      StrikethroughKorean: "\uE5D4",
      Subscribe: "\uEDA1",
      Subscript: "\uEDDF",
      SubstitutionsIn: "\uEB31",
      SubtractShape: "\uF8FC",
      Suitcase: "\uEDD3",
      SummaryChart: "\uE9FE",
      SunAdd: "\uEF69",
      Sunny: "\uE9BD",
      SunQuestionMark: "\uEF6A",
      Superscript: "\uEDDE",
      SurveyQuestionResponse: "\uE4F2",
      SurveyQuestions: "\uF01B",
      SwayLogo16: "\uF484",
      SwayLogo32: "\uF482",
      SwayLogoFill16: "\uF485",
      SwayLogoFill32: "\uF483",
      SwayLogoInverse: "\uED29",
      Switch: "\uE8AB",
      SwitcherStartEnd: "\uE810",
      SwitchUser: "\uE748",
      Sync: "\uE895",
      SyncError: "\uEA6A",
      SyncFolder: "\uE8F7",
      SyncOccurence: "\uF4A3",
      SyncOccurenceCancel: "\uF7E7",
      SyncStatus: "\uF751",
      SyncStatusSolid: "\uF752",
      SyncToPC: "\uEE6E",
      System: "\uE770",
      Tab: "\uE7E9",
      TabCenter: "\uF100",
      Table: "\uED86",
      TableBrandedColumn: "\uE3F1",
      TableBrandedRow: "\uE3EE",
      TableColumn: "\uE4BD",
      TableComputed: "\uF8F5",
      TableFirstColumn: "\uE3EF",
      TableGroup: "\uF6D9",
      TableHeaderRow: "\uE3EC",
      TableLastColumn: "\uE3F0",
      TableLink: "\uF77A",
      TablePermission: "\uE619",
      Tablet: "\uE70A",
      TabletMode: "\uEBFC",
      TableTotalRow: "\uE3ED",
      TabletSelected: "\uEC74",
      TabOneColumn: "\uF849",
      TabThreeColumn: "\uF84B",
      TabTwoColumn: "\uF84A",
      Tag: "\uE8EC",
      TagGroup: "\uE3F6",
      TagSolid: "\uF70E",
      TagUnknown: "\uF6DF",
      TagUnknown12: "\uF6E1",
      TagUnknown12Mirror: "\uF6E2",
      TagUnknownMirror: "\uF6E0",
      TaskAdd: "\uE4FD",
      Taskboard: "\uF1C2",
      TaskGroup: "\uF2AE",
      TaskGroupMirrored: "\uF2AF",
      TaskList: "\uE3B6",
      TaskLogo: "\uF493",
      TaskManager: "\uEDB7",
      TaskManagerMirrored: "\uEDB8",
      TaskSolid: "\uF333",
      Taxi: "\uF4A1",
      TeamFavorite: "\uF2AD",
      TeamsLogo: "\uF27B",
      TeamsLogo16: "\uF40A",
      TeamsLogoInverse: "\uF27A",
      Teamwork: "\uEA12",
      Teeth: "\uF4A0",
      Telemarketer: "\uE7B9",
      TemporaryAccessPass: "\uE4AD",
      TemporaryUser: "\uEE58",
      Tennis: "\uEB33",
      TestAdd: "\uE4DC",
      TestAutoSolid: "\uF3A8",
      TestBeaker: "\uF3A5",
      TestBeakerSolid: "\uF3A6",
      TestCase: "\uF3AF",
      TestExploreSolid: "\uF3A7",
      TestImpactSolid: "\uF3AA",
      TestParameter: "\uF3AD",
      TestPlan: "\uF3AB",
      TestRemove: "\uE4E1",
      TestStep: "\uF3AC",
      TestSuite: "\uF3AE",
      TestUserSolid: "\uF3A9",
      TextAlignBottom: "\uE3E2",
      TextAlignMiddle: "\uE3E1",
      TextAlignTop: "\uE3E0",
      TextBox: "\uEDC2",
      TextCallout: "\uF2A2",
      TextDocument: "\uF029",
      TextDocumentEdit: "\uE43B",
      TextDocumentSettings: "\uE4AA",
      TextDocumentShared: "\uF02B",
      TextField: "\uEDC3",
      TextOverflow: "\uF51F",
      TextParagraphOption: "\uE3E3",
      TextRecognition: "\uE394",
      TextRotate270Degrees: "\uE3E7",
      TextRotate90Degrees: "\uE3E6",
      TextRotateHorizontal: "\uE3E5",
      TextRotation: "\uE3E4",
      TFVCLogo: "\uF44D",
      ThisPC: "\uEC4E",
      ThreeQuarterCircle: "\uF503",
      ThumbnailView: "\uE7B6",
      ThumbnailViewMirrored: "\uEA67",
      Thunderstorms: "\uE9C6",
      Ticket: "\uEB54",
      Tiles: "\uECA5",
      Tiles2: "\uEF7C",
      TimeEntry: "\uEF95",
      Timeline: "\uED9C",
      TimelineDelivery: "\uF2AB",
      TimelineMatrixView: "\uF361",
      TimelineProgress: "\uF2AA",
      TimePicker: "\uE367",
      Timer: "\uE91E",
      TimeSheet: "\uEA05",
      Title: "\uF23B",
      TitleMirrored: "\uF23C",
      ToDoLogoBottom: "\uF4B3",
      ToDoLogoInverse: "\uF4BC",
      ToDoLogoOutline: "\uF75B",
      ToDoLogoTop: "\uF4B4",
      ToggleBorder: "\uEC12",
      ToggleFilled: "\uEC11",
      ToggleLeft: "\uF19E",
      ToggleRight: "\uF19F",
      ToggleThumb: "\uEC14",
      Toll: "\uF160",
      Toolbox: "\uECED",
      Total: "\uE9DF",
      Touch: "\uE815",
      TouchPointer: "\uE7C9",
      Trackers: "\uEADF",
      TrackersMirrored: "\uEE92",
      Train: "\uE7C0",
      TrainSolid: "\uEB4D",
      TransferCall: "\uED95",
      Transition: "\uF3BC",
      TransitionEffect: "\uF5B4",
      TransitionPop: "\uF5B2",
      TransitionPush: "\uF5B3",
      Translate: "\uE7B2",
      Transportation: "\uEBF1",
      Trending12: "\uF62D",
      TriangleDown12: "\uEED1",
      TriangleLeft12: "\uEED2",
      TriangleRight12: "\uEED3",
      TriangleShape: "\uF1A7",
      TriangleShapeSolid: "\uF63E",
      TriangleSolid: "\uEA08",
      TriangleSolidDown12: "\uEECD",
      TriangleSolidLeft12: "\uEECE",
      TriangleSolidRight12: "\uEECF",
      TriangleSolidUp12: "\uEECC",
      TriangleUp12: "\uEED0",
      TriggerApproval: "\uF3B2",
      TriggerAuto: "\uF24A",
      TriggerPhrase: "\uE5FF",
      TriggerUser: "\uF24B",
      Trim: "\uE78A",
      TrimEnd: "\uF8BC",
      TrimStart: "\uF8BB",
      TripleColumn: "\uF1D5",
      TripleColumnEdit: "\uF323",
      TripleColumnWide: "\uF66E",
      Trophy: "\uED3F",
      Trophy2: "\uF1AE",
      Trophy2Solid: "\uF337",
      TurnRight: "\uE7DB",
      TVMonitor: "\uE7F4",
      TVMonitorSelected: "\uEC77",
      TypeScriptLanguage: "\uF2F7",
      Umbrella: "\uEC04",
      UnavailableOffline: "\uE545",
      Underline: "\uE8DC",
      UnderlineA: "\uE5CC",
      UnderlineKorean: "\uE5BB",
      UnderlineP: "\uE5CD",
      UnderlineRussian: "\uE5B8",
      UnderlineS: "\uE5B4",
      UnderlineSerbian: "\uE5CB",
      Undo: "\uE7A7",
      Uneditable: "\uED1D",
      Uneditable2: "\uF876",
      Uneditable2Mirrored: "\uF877",
      UneditableMirrored: "\uF4B9",
      UneditableSolid12: "\uF4B7",
      UneditableSolidMirrored12: "\uF4B8",
      Unfavorite: "\uE8D9",
      UngroupObject: "\uF4F2",
      UniteShape: "\uF8FB",
      Unknown: "\uE9CE",
      UnknownCall: "\uED97",
      UnknownMirrored: "\uF22E",
      UnknownMirroredSolid: "\uF2E2",
      UnknownSolid: "\uF2E1",
      Unlock: "\uE785",
      UnlockSolid: "\uF304",
      Unpin: "\uE77A",
      UnpublishContent: "\uE31F",
      UnSetColor: "\uF3F9",
      UnstackSelected: "\uE7FE",
      Unsubscribe: "\uEDA0",
      UnsyncFolder: "\uE8F6",
      UnsyncOccurence: "\uF4A4",
      Untag: "\uF60B",
      Up: "\uE74A",
      UpdateRestore: "\uE777",
      UpgradeAnalysis: "\uEA0B",
      Upload: "\uE898",
      UpperCase: "\uE5ED",
      URLBlock: "\uE3FE",
      USB: "\uE88E",
      UserClapper: "\uE666",
      UserEvent: "\uF69C",
      UserFollowed: "\uF25C",
      UserGauge: "\uF6ED",
      UserOptional: "\uF767",
      UserPause: "\uF2BA",
      UserRemove: "\uF69B",
      UserSync: "\uF2B9",
      UserWarning: "\uE368",
      UserWindow: "\uE4ED",
      Vacation: "\uF49F",
      Vaccination: "\uEAE0",
      VaccinationRecent: "\uE550",
      Variable: "\uF305",
      Variable2: "\uF86D",
      Variable3: "\uE4D1",
      VariableGroup: "\uF31B",
      VB: "\uF2F2",
      VennDiagram: "\uF273",
      VerifiedBrand: "\uF7BD",
      VerifiedBrandSolid: "\uF6AD",
      VersionControlPush: "\uF664",
      VerticalDistributeCenter: "\uF4FA",
      Video: "\uE714",
      Video360Generic: "\uF609",
      VideoAdd: "\uE430",
      VideoLightOff: "\uEA74",
      VideoOff: "\uF4B0",
      VideoOff2: "\uE43C",
      VideoSearch: "\uF4EA",
      VideoSolid: "\uEA0C",
      View: "\uE890",
      ViewAll: "\uE8A9",
      ViewAll2: "\uEF56",
      ViewDashboard: "\uF246",
      ViewInAR: "\uE41F",
      ViewList: "\uF247",
      ViewListGroup: "\uF248",
      ViewListTree: "\uF249",
      ViewOriginal: "\uE7B4",
      VirtualNetwork: "\uF815",
      VisioDiagram: "\uF2A0",
      VisioDiagramSync: "\uF762",
      VisioDocument: "\uF2A9",
      VisioLogo: "\uF2A7",
      VisioLogo16: "\uF3A3",
      VisioLogoInverse: "\uED7D",
      VisioLogoInverse16: "\uF3A2",
      VisualBasicLanguage: "\uF2F1",
      VisuallyImpaired: "\uF866",
      VisualsFolder: "\uF520",
      VisualsStore: "\uF521",
      VisualStudioForWindows: "\uF5D0",
      VisualStudioForWindowsAlt: "\uEC22",
      VoicemailForward: "\uED87",
      VoicemailIRM: "\uF421",
      VoicemailReply: "\uED88",
      Volume0: "\uE992",
      Volume1: "\uE993",
      Volume2: "\uE994",
      Volume3: "\uE995",
      VolumeDisabled: "\uEA85",
      VSTSAltLogo1: "\uF382",
      VSTSAltLogo2: "\uF383",
      VSTSLogo: "\uF381",
      Waffle: "\uED89",
      WaffleOffice365: "\uF4E0",
      WaitlistConfirm: "\uF550",
      WaitlistConfirmMirrored: "\uF551",
      Warning: "\uE7BA",
      Warning12: "\uF62F",
      WarningSolid: "\uF736",
      WavingHand: "\uF807",
      WebAppBuilderFragment: "\uE314",
      WebAppBuilderFragmentCreate: "\uE31B",
      WebAppBuilderFragmentLock: "\uE4DD",
      WebAppBuilderFragmentTest: "\uE4DE",
      WebAppBuilderModule: "\uE313",
      WebAppBuilderModuleLock: "\uE4DF",
      WebAppBuilderModuleTest: "\uE4E0",
      WebAppBuilderSlot: "\uE315",
      Webcam2: "\uE960",
      Webcam2Off: "\uE36D",
      WebComponents: "\uEC8B",
      WebEnvironment: "\uE3DB",
      WebPublish: "\uF52F",
      WebSearch: "\uF6FA",
      Website: "\uEB41",
      WebTemplate: "\uF6B2",
      Weights: "\uEADB",
      Wheelchair: "\uF31F",
      Whiteboard: "\uF784",
      WhiteBoardApp16: "\uF673",
      WhiteBoardApp32: "\uF674",
      WifiEthernet: "\uEE77",
      WifiWarning4: "\uEB63",
      WindDirection: "\uEBE6",
      WindowEdit: "\uF50E",
      WindowsLogo: "\uE782",
      Wines: "\uEABF",
      WipePhone: "\uED8D",
      WordDocument: "\uEF71",
      WordLogo: "\uF1E3",
      WordLogo16: "\uF391",
      WordLogoInverse: "\uEC29",
      WordLogoInverse16: "\uF390",
      Work: "\uE821",
      WorkFlow: "\uEA01",
      WorkforceManagement: "\uEE0F",
      WorkItem: "\uF314",
      WorkItemAlert: "\uF78F",
      WorkItemBar: "\uF35C",
      WorkItemBarSolid: "\uF35D",
      WorkItemBug: "\uF315",
      World: "\uE909",
      WorldClock: "\uE918",
      XPowerY: "\uF7CA",
      XRay: "\uE551",
      YammerLogo: "\uED19",
      ZeroDayCalendar: "\uE547",
      ZeroDayPatch: "\uE665",
      ZipFolder: "\uF012",
      Zoom: "\uE71E",
      ZoomIn: "\uE8A3",
      ZoomOut: "\uE71F",
      ZoomToFit: "\uF649"
    }
  };
  registerIcons(subset);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$2 = function () {
  __assign$2 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign$2.apply(this, arguments);
};

var InjectionMode$1 = {
  /**
   * Avoids style injection, use getRules() to read the styles.
   */
  none: 0,

  /**
   * Inserts rules using the insertRule api.
   */
  insertNode: 1,

  /**
   * Appends rules using appendChild.
   */
  appendChild: 2
};
var STYLESHEET_SETTING$1 = '__stylesheet__';
/**
 * MSIE 11 doesn't cascade styles based on DOM ordering, but rather on the order that each style node
 * is created. As such, to maintain consistent priority, IE11 should reuse a single style node.
 */

var REUSE_STYLE_NODE$1 = typeof navigator !== 'undefined' && /rv:11.0/.test(navigator.userAgent);
var _global$2 = {}; // Grab window.

try {
  // Why the cast?
  // if compiled/type checked in same program with `@fluentui/font-icons-mdl2` which extends `Window` on global
  // ( check packages/font-icons-mdl2/src/index.ts ) the definitions don't match! Thus the need of this extra assertion
  _global$2 = window || {};
} catch (_a) {
  /* leave as blank object */
}

var _stylesheet$1;
/**
 * Represents the state of styles registered in the page. Abstracts
 * the surface for adding styles to the stylesheet, exposes helpers
 * for reading the styles registered in server rendered scenarios.
 *
 * @public
 */


var Stylesheet$1 =
/** @class */
function () {
  function Stylesheet(config, serializedStylesheet) {
    var _a, _b, _c, _d, _e, _f;

    this._rules = [];
    this._preservedRules = [];
    this._counter = 0;
    this._keyToClassName = {};
    this._onInsertRuleCallbacks = [];
    this._onResetCallbacks = [];
    this._classNameToArgs = {};
    this._config = __assign$2({
      // If there is no document we won't have an element to inject into.
      injectionMode: typeof document === 'undefined' ? InjectionMode$1.none : InjectionMode$1.insertNode,
      defaultPrefix: 'css',
      namespace: undefined,
      cspSettings: undefined
    }, config);
    this._classNameToArgs = (_a = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.classNameToArgs) !== null && _a !== void 0 ? _a : this._classNameToArgs;
    this._counter = (_b = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.counter) !== null && _b !== void 0 ? _b : this._counter;
    this._keyToClassName = (_d = (_c = this._config.classNameCache) !== null && _c !== void 0 ? _c : serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.keyToClassName) !== null && _d !== void 0 ? _d : this._keyToClassName;
    this._preservedRules = (_e = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.preservedRules) !== null && _e !== void 0 ? _e : this._preservedRules;
    this._rules = (_f = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.rules) !== null && _f !== void 0 ? _f : this._rules;
  }
  /**
   * Gets the singleton instance.
   */


  Stylesheet.getInstance = function () {
    _stylesheet$1 = _global$2[STYLESHEET_SETTING$1];

    if (!_stylesheet$1 || _stylesheet$1._lastStyleElement && _stylesheet$1._lastStyleElement.ownerDocument !== document) {
      var fabricConfig = (_global$2 === null || _global$2 === void 0 ? void 0 : _global$2.FabricConfig) || {};
      var stylesheet = new Stylesheet(fabricConfig.mergeStyles, fabricConfig.serializedStylesheet);
      _stylesheet$1 = stylesheet;
      _global$2[STYLESHEET_SETTING$1] = stylesheet;
    }

    return _stylesheet$1;
  };
  /**
   * Serializes the Stylesheet instance into a format which allows rehydration on creation.
   * @returns string representation of `ISerializedStylesheet` interface.
   */


  Stylesheet.prototype.serialize = function () {
    return JSON.stringify({
      classNameToArgs: this._classNameToArgs,
      counter: this._counter,
      keyToClassName: this._keyToClassName,
      preservedRules: this._preservedRules,
      rules: this._rules
    });
  };
  /**
   * Configures the stylesheet.
   */


  Stylesheet.prototype.setConfig = function (config) {
    this._config = __assign$2(__assign$2({}, this._config), config);
  };
  /**
   * Configures a reset callback.
   *
   * @param callback - A callback which will be called when the Stylesheet is reset.
   * @returns function which when called un-registers provided callback.
   */


  Stylesheet.prototype.onReset = function (callback) {
    var _this = this;

    this._onResetCallbacks.push(callback);

    return function () {
      _this._onResetCallbacks = _this._onResetCallbacks.filter(function (cb) {
        return cb !== callback;
      });
    };
  };
  /**
   * Configures an insert rule callback.
   *
   * @param callback - A callback which will be called when a rule is inserted.
   * @returns function which when called un-registers provided callback.
   */


  Stylesheet.prototype.onInsertRule = function (callback) {
    var _this = this;

    this._onInsertRuleCallbacks.push(callback);

    return function () {
      _this._onInsertRuleCallbacks = _this._onInsertRuleCallbacks.filter(function (cb) {
        return cb !== callback;
      });
    };
  };
  /**
   * Generates a unique classname.
   *
   * @param displayName - Optional value to use as a prefix.
   */


  Stylesheet.prototype.getClassName = function (displayName) {
    var namespace = this._config.namespace;
    var prefix = displayName || this._config.defaultPrefix;
    return "" + (namespace ? namespace + '-' : '') + prefix + "-" + this._counter++;
  };
  /**
   * Used internally to cache information about a class which was
   * registered with the stylesheet.
   */


  Stylesheet.prototype.cacheClassName = function (className, key, args, rules) {
    this._keyToClassName[key] = className;
    this._classNameToArgs[className] = {
      args: args,
      rules: rules
    };
  };
  /**
   * Gets the appropriate classname given a key which was previously
   * registered using cacheClassName.
   */


  Stylesheet.prototype.classNameFromKey = function (key) {
    return this._keyToClassName[key];
  };
  /**
   * Gets all classnames cache with the stylesheet.
   */


  Stylesheet.prototype.getClassNameCache = function () {
    return this._keyToClassName;
  };
  /**
   * Gets the arguments associated with a given classname which was
   * previously registered using cacheClassName.
   */


  Stylesheet.prototype.argsFromClassName = function (className) {
    var entry = this._classNameToArgs[className];
    return entry && entry.args;
  };
  /**
   * Gets the rules associated with a given classname which was
   * previously registered using cacheClassName.
   */


  Stylesheet.prototype.insertedRulesFromClassName = function (className) {
    var entry = this._classNameToArgs[className];
    return entry && entry.rules;
  };
  /**
   * Inserts a css rule into the stylesheet.
   * @param preserve - Preserves the rule beyond a reset boundary.
   */


  Stylesheet.prototype.insertRule = function (rule, preserve) {
    var injectionMode = this._config.injectionMode;
    var element = injectionMode !== InjectionMode$1.none ? this._getStyleElement() : undefined;

    if (preserve) {
      this._preservedRules.push(rule);
    }

    if (element) {
      switch (injectionMode) {
        case InjectionMode$1.insertNode:
          var sheet = element.sheet;

          try {
            sheet.insertRule(rule, sheet.cssRules.length);
          } catch (e) {// The browser will throw exceptions on unsupported rules (such as a moz prefix in webkit.)
            // We need to swallow the exceptions for this scenario, otherwise we'd need to filter
            // which could be slower and bulkier.
          }

          break;

        case InjectionMode$1.appendChild:
          element.appendChild(document.createTextNode(rule));
          break;
      }
    } else {
      this._rules.push(rule);
    } // eslint-disable-next-line deprecation/deprecation


    if (this._config.onInsertRule) {
      // eslint-disable-next-line deprecation/deprecation
      this._config.onInsertRule(rule);
    }

    this._onInsertRuleCallbacks.forEach(function (callback) {
      return callback();
    });
  };
  /**
   * Gets all rules registered with the stylesheet; only valid when
   * using InsertionMode.none.
   */


  Stylesheet.prototype.getRules = function (includePreservedRules) {
    return (includePreservedRules ? this._preservedRules.join('') : '') + this._rules.join('');
  };
  /**
   * Resets the internal state of the stylesheet. Only used in server
   * rendered scenarios where we're using InsertionMode.none.
   */


  Stylesheet.prototype.reset = function () {
    this._rules = [];
    this._counter = 0;
    this._classNameToArgs = {};
    this._keyToClassName = {};

    this._onResetCallbacks.forEach(function (callback) {
      return callback();
    });
  }; // Forces the regeneration of incoming styles without totally resetting the stylesheet.


  Stylesheet.prototype.resetKeys = function () {
    this._keyToClassName = {};
  };

  Stylesheet.prototype._getStyleElement = function () {
    var _this = this;

    if (!this._styleElement && typeof document !== 'undefined') {
      this._styleElement = this._createStyleElement();

      if (!REUSE_STYLE_NODE$1) {
        // Reset the style element on the next frame.
        window.requestAnimationFrame(function () {
          _this._styleElement = undefined;
        });
      }
    }

    return this._styleElement;
  };

  Stylesheet.prototype._createStyleElement = function () {
    var head = document.head;
    var styleElement = document.createElement('style');
    var nodeToInsertBefore = null;
    styleElement.setAttribute('data-merge-styles', 'true');
    var cspSettings = this._config.cspSettings;

    if (cspSettings) {
      if (cspSettings.nonce) {
        styleElement.setAttribute('nonce', cspSettings.nonce);
      }
    }

    if (this._lastStyleElement) {
      // If the `nextElementSibling` is null, then the insertBefore will act as a regular append.
      // https://developer.mozilla.org/en-US/docs/Web/API/Node/insertBefore#Syntax
      nodeToInsertBefore = this._lastStyleElement.nextElementSibling;
    } else {
      var placeholderStyleTag = this._findPlaceholderStyleTag();

      if (placeholderStyleTag) {
        nodeToInsertBefore = placeholderStyleTag.nextElementSibling;
      } else {
        nodeToInsertBefore = head.childNodes[0];
      }
    }

    head.insertBefore(styleElement, head.contains(nodeToInsertBefore) ? nodeToInsertBefore : null);
    this._lastStyleElement = styleElement;
    return styleElement;
  };

  Stylesheet.prototype._findPlaceholderStyleTag = function () {
    var head = document.head;

    if (head) {
      return head.querySelector('style[data-merge-styles]');
    }

    return null;
  };

  return Stylesheet;
}();

/**
 * Sets the current RTL value.
 */
/**
 * Gets the current RTL value.
 */

function getRTL$2() {
  if (_rtl$1 === undefined) {
    _rtl$1 = typeof document !== 'undefined' && !!document.documentElement && document.documentElement.getAttribute('dir') === 'rtl';
  }

  return _rtl$1;
} // This has been split into 2 lines because it was working in Fabric due to the code being transpiled to es5, so this
// was converted to var while not working in Fluent that uses babel to transpile the code to be es6-like. Splitting the
// logic into two lines, however, allows it to work in both scenarios.

var _rtl$1;

_rtl$1 = getRTL$2();
function getStyleOptions$1() {
  return {
    rtl: getRTL$2()
  };
}

var rules$1 = {};
function kebabRules$1(rulePairs, index) {
  var rule = rulePairs[index];

  if (rule.charAt(0) !== '-') {
    rulePairs[index] = rules$1[rule] = rules$1[rule] || rule.replace(/([A-Z])/g, '-$1').toLowerCase();
  }
}

var _vendorSettings$1;

function getVendorSettings$1() {
  var _a;

  if (!_vendorSettings$1) {
    var doc = typeof document !== 'undefined' ? document : undefined;
    var nav = typeof navigator !== 'undefined' ? navigator : undefined;
    var userAgent = (_a = nav === null || nav === void 0 ? void 0 : nav.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase();

    if (!doc) {
      _vendorSettings$1 = {
        isWebkit: true,
        isMoz: true,
        isOpera: true,
        isMs: true
      };
    } else {
      _vendorSettings$1 = {
        isWebkit: !!(doc && 'WebkitAppearance' in doc.documentElement.style),
        isMoz: !!(userAgent && userAgent.indexOf('firefox') > -1),
        isOpera: !!(userAgent && userAgent.indexOf('opera') > -1),
        isMs: !!(nav && (/rv:11.0/i.test(nav.userAgent) || /Edge\/\d./i.test(navigator.userAgent)))
      };
    }
  }

  return _vendorSettings$1;
}

var autoPrefixNames$1 = {
  'user-select': 1
};
function prefixRules$1(rulePairs, index) {
  var vendorSettings = getVendorSettings$1();
  var name = rulePairs[index];

  if (autoPrefixNames$1[name]) {
    var value = rulePairs[index + 1];

    if (autoPrefixNames$1[name]) {
      if (vendorSettings.isWebkit) {
        rulePairs.push('-webkit-' + name, value);
      }

      if (vendorSettings.isMoz) {
        rulePairs.push('-moz-' + name, value);
      }

      if (vendorSettings.isMs) {
        rulePairs.push('-ms-' + name, value);
      }

      if (vendorSettings.isOpera) {
        rulePairs.push('-o-' + name, value);
      }
    }
  }
}

var NON_PIXEL_NUMBER_PROPS$1 = ['column-count', 'font-weight', 'flex', 'flex-grow', 'flex-shrink', 'fill-opacity', 'opacity', 'order', 'z-index', 'zoom'];
function provideUnits$1(rulePairs, index) {
  var name = rulePairs[index];
  var value = rulePairs[index + 1];

  if (typeof value === 'number') {
    var isNonPixelProp = NON_PIXEL_NUMBER_PROPS$1.indexOf(name) > -1;
    var isVariableOrPrefixed = name.indexOf('--') > -1;
    var unit = isNonPixelProp || isVariableOrPrefixed ? '' : 'px';
    rulePairs[index + 1] = "" + value + unit;
  }
}

var _a$1;

var LEFT$1 = 'left';
var RIGHT$1 = 'right';
var NO_FLIP$1 = '@noflip';
var NAME_REPLACEMENTS$1 = (_a$1 = {}, _a$1[LEFT$1] = RIGHT$1, _a$1[RIGHT$1] = LEFT$1, _a$1);
var VALUE_REPLACEMENTS$1 = {
  'w-resize': 'e-resize',
  'sw-resize': 'se-resize',
  'nw-resize': 'ne-resize'
};
/**
 * RTLifies the rulePair in the array at the current index. This mutates the array for performance
 * reasons.
 */

function rtlifyRules$1(options, rulePairs, index) {
  if (options.rtl) {
    var name_1 = rulePairs[index];

    if (!name_1) {
      return;
    }

    var value = rulePairs[index + 1];

    if (typeof value === 'string' && value.indexOf(NO_FLIP$1) >= 0) {
      rulePairs[index + 1] = value.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g, '');
    } else if (name_1.indexOf(LEFT$1) >= 0) {
      rulePairs[index] = name_1.replace(LEFT$1, RIGHT$1);
    } else if (name_1.indexOf(RIGHT$1) >= 0) {
      rulePairs[index] = name_1.replace(RIGHT$1, LEFT$1);
    } else if (String(value).indexOf(LEFT$1) >= 0) {
      rulePairs[index + 1] = value.replace(LEFT$1, RIGHT$1);
    } else if (String(value).indexOf(RIGHT$1) >= 0) {
      rulePairs[index + 1] = value.replace(RIGHT$1, LEFT$1);
    } else if (NAME_REPLACEMENTS$1[name_1]) {
      rulePairs[index] = NAME_REPLACEMENTS$1[name_1];
    } else if (VALUE_REPLACEMENTS$1[value]) {
      rulePairs[index + 1] = VALUE_REPLACEMENTS$1[value];
    } else {
      switch (name_1) {
        case 'margin':
        case 'padding':
          rulePairs[index + 1] = flipQuad$1(value);
          break;

        case 'box-shadow':
          rulePairs[index + 1] = negateNum$1(value, 0);
          break;
      }
    }
  }
}
/**
 * Given a string value in a space delimited format (e.g. "1 2 3 4"), negates a particular value.
 */

function negateNum$1(value, partIndex) {
  var parts = value.split(' ');
  var numberVal = parseInt(parts[partIndex], 10);
  parts[0] = parts[0].replace(String(numberVal), String(numberVal * -1));
  return parts.join(' ');
}
/**
 * Given a string quad, flips the left and right values.
 */


function flipQuad$1(value) {
  if (typeof value === 'string') {
    var parts = value.split(' ');

    if (parts.length === 4) {
      return parts[0] + " " + parts[3] + " " + parts[2] + " " + parts[1];
    }
  }

  return value;
}

var DISPLAY_NAME$1 = 'displayName';

function serializeRuleEntries$1(options, ruleEntries) {
  if (!ruleEntries) {
    return '';
  }

  var allEntries = [];

  for (var entry in ruleEntries) {
    if (ruleEntries.hasOwnProperty(entry) && entry !== DISPLAY_NAME$1 && ruleEntries[entry] !== undefined) {
      allEntries.push(entry, ruleEntries[entry]);
    }
  } // Apply transforms.


  for (var i = 0; i < allEntries.length; i += 2) {
    kebabRules$1(allEntries, i);
    provideUnits$1(allEntries, i);
    rtlifyRules$1(options, allEntries, i);
    prefixRules$1(allEntries, i);
  } // Apply punctuation.


  for (var i = 1; i < allEntries.length; i += 4) {
    allEntries.splice(i, 1, ':', allEntries[i], ';');
  }

  return allEntries.join('');
}

/**
 * Registers a font face.
 * @public
 */

function fontFace$1(font) {
  var stylesheet = Stylesheet$1.getInstance();
  var rule = serializeRuleEntries$1(getStyleOptions$1(), font);
  var className = stylesheet.classNameFromKey(rule);

  if (className) {
    return;
  }

  var name = stylesheet.getClassName();
  stylesheet.insertRule("@font-face{" + rule + "}", true);
  stylesheet.cacheClassName(name, rule, [], ['font-face', rule]);
}

// A packages cache that makes sure that we don't inject the same packageName twice in the same bundle -
// this cache is local to the module closure inside this bundle
var packagesCache$1 = {}; // Cache access to window to avoid IE11 memory leak.

var _win$1 = undefined;

try {
  _win$1 = window;
} catch (e) {
  /* no-op */
}

function setVersion$1(packageName, packageVersion) {
  if (typeof _win$1 !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var packages = _win$1.__packages__ = _win$1.__packages__ || {}; // We allow either the global packages or local packages caches to invalidate so testing can
    // just clear the global to set this state

    if (!packages[packageName] || !packagesCache$1[packageName]) {
      packagesCache$1[packageName] = packageVersion;
      var versions = packages[packageName] = packages[packageName] || [];
      versions.push(packageVersion);
    }
  }
}

setVersion$1('@fluentui/set-version', '6.0.0');

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$3 = function () {
  __assign$3 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign$3.apply(this, arguments);
};

/**
 * Verifies if an application can use DOM.
 */
function canUseDOM() {
  return typeof window !== 'undefined' && !!(window.document && // eslint-disable-next-line deprecation/deprecation
  window.document.createElement);
}

var _window$1 = undefined; // Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
// Caching the window value at the file scope lets us minimize the impact.

try {
  _window$1 = window;
} catch (e) {
  /* no-op */
}
/**
 * Helper to get the window object. The helper will make sure to use a cached variable
 * of "window", to avoid overhead and memory leaks in IE11. Note that in popup scenarios the
 * window object won't match the "global" window object, and for these scenarios, you should
 * pass in an element hosted within the popup.
 *
 * @public
 */


function getWindow$1(rootElement) {
  if (!canUseDOM() || typeof _window$1 === 'undefined') {
    return undefined;
  } else {
    var el = rootElement;
    return el && el.ownerDocument && el.ownerDocument.defaultView ? el.ownerDocument.defaultView : _window$1;
  }
}

/**
 * Helper to get the document object. Note that in popup window cases, document
 * might be the wrong document, which is why we look at ownerDocument for the
 * truth.
 *
 * @public
 */

function getDocument$1(rootElement) {
  if (!canUseDOM() || typeof document === 'undefined') {
    return undefined;
  } else {
    var el = rootElement;
    return el && el.ownerDocument ? el.ownerDocument : document;
  }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$4 = function () {
  __assign$4 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign$4.apply(this, arguments);
};

/* eslint-disable no-console */
/**
 * Sends a warning to console, if the api is present.
 *
 * @public
 * @param message - Warning message.
 */

function warn$1(message) {
  if (console && console.warn) {
    console.warn(message);
  }
}

/**
 * Storing global state in local module variables has issues when more than one copy
 * if the module gets loaded on the page (due to a bundling error or simply by consuming
 * a prebundled script.)
 *
 * This file contains helpers to deal with the getting and setting local state, and allows
 * callers to get called back when it mutates.
 */

var GLOBAL_SETTINGS_PROP_NAME$1 = '__globalSettings__';
var CALLBACK_STATE_PROP_NAME$1 = '__callbacks__';
var _counter$1 = 0;
/**
 * Global settings helper, which stores settings in the global (window) namespace.
 * If window is not provided, it will store settings in module scope. Provides a
 * way to observe changes as well when their values change.
 *
 * @public
 * {@docCategory GlobalSettings}
 */

var GlobalSettings$1 =
/** @class */
function () {
  function GlobalSettings() {}

  GlobalSettings.getValue = function (key, defaultValue) {
    var globalSettings = _getGlobalSettings$1();

    if (globalSettings[key] === undefined) {
      globalSettings[key] = typeof defaultValue === 'function' ? defaultValue() : defaultValue;
    }

    return globalSettings[key];
  };

  GlobalSettings.setValue = function (key, value) {
    var globalSettings = _getGlobalSettings$1();

    var callbacks = globalSettings[CALLBACK_STATE_PROP_NAME$1];
    var oldValue = globalSettings[key];

    if (value !== oldValue) {
      globalSettings[key] = value;
      var changeDescription = {
        oldValue: oldValue,
        value: value,
        key: key
      };

      for (var id in callbacks) {
        if (callbacks.hasOwnProperty(id)) {
          callbacks[id](changeDescription);
        }
      }
    }

    return value;
  };

  GlobalSettings.addChangeListener = function (cb) {
    // Note: we use generated ids on the callbacks to create a map of the callbacks, which optimizes removal.
    // (It's faster to delete a key than it is to look up the index of an object and splice an array.)
    var id = cb.__id__;

    var callbacks = _getCallbacks$1();

    if (!id) {
      id = cb.__id__ = String(_counter$1++);
    }

    callbacks[id] = cb;
  };

  GlobalSettings.removeChangeListener = function (cb) {
    var callbacks = _getCallbacks$1();

    delete callbacks[cb.__id__];
  };

  return GlobalSettings;
}();

function _getGlobalSettings$1() {
  var _a;

  var win = getWindow$1(); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var globalObj = win || {};

  if (!globalObj[GLOBAL_SETTINGS_PROP_NAME$1]) {
    globalObj[GLOBAL_SETTINGS_PROP_NAME$1] = (_a = {}, _a[CALLBACK_STATE_PROP_NAME$1] = {}, _a);
  }

  return globalObj[GLOBAL_SETTINGS_PROP_NAME$1];
}

function _getCallbacks$1() {
  var globalSettings = _getGlobalSettings$1();

  return globalSettings[CALLBACK_STATE_PROP_NAME$1];
}

/**
 * Fetches an item from session storage without throwing an exception
 * @param key The key of the item to fetch from session storage
 */

function getItem$2(key) {
  var result = null;

  try {
    var win = getWindow$1();
    result = win ? win.sessionStorage.getItem(key) : null;
  } catch (e) {
    /* Eat the exception */
  }

  return result;
}

var CustomizationsGlobalKey$1 = 'customizations';
var NO_CUSTOMIZATIONS$1 = {
  settings: {},
  scopedSettings: {},
  inCustomizerContext: false
};

var _allSettings$1 = GlobalSettings$1.getValue(CustomizationsGlobalKey$1, {
  settings: {},
  scopedSettings: {},
  inCustomizerContext: false
});

var _events$1 = [];

var Customizations$1 =
/** @class */
function () {
  function Customizations() {}

  Customizations.reset = function () {
    _allSettings$1.settings = {};
    _allSettings$1.scopedSettings = {};
  };
  /** Apply global Customization settings.
   * @example Customizations.applySettings(\{ theme: \{...\} \});
   */


  Customizations.applySettings = function (settings) {
    _allSettings$1.settings = __assign$4(__assign$4({}, _allSettings$1.settings), settings);

    Customizations._raiseChange();
  };
  /** Apply Customizations to a particular named scope, like a component.
   * @example Customizations.applyScopedSettings('Nav', \{ styles: () =\> \{\} \});
   */


  Customizations.applyScopedSettings = function (scopeName, settings) {
    _allSettings$1.scopedSettings[scopeName] = __assign$4(__assign$4({}, _allSettings$1.scopedSettings[scopeName]), settings);

    Customizations._raiseChange();
  };

  Customizations.getSettings = function (properties, scopeName, localSettings) {
    if (localSettings === void 0) {
      localSettings = NO_CUSTOMIZATIONS$1;
    }

    var settings = {};
    var localScopedSettings = scopeName && localSettings.scopedSettings[scopeName] || {};
    var globalScopedSettings = scopeName && _allSettings$1.scopedSettings[scopeName] || {};

    for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
      var property = properties_1[_i];
      settings[property] = localScopedSettings[property] || localSettings.settings[property] || globalScopedSettings[property] || _allSettings$1.settings[property];
    }

    return settings;
  };
  /** Used to run some code that sets Customizations without triggering an update until the end.
   * Useful for applying Customizations that don't affect anything currently rendered, or for
   * applying many customizations at once.
   * @param suppressUpdate - Do not raise the change event at the end, preventing all updates
   */


  Customizations.applyBatchedUpdates = function (code, suppressUpdate) {
    Customizations._suppressUpdates = true;

    try {
      code();
    } catch (_a) {
      /* do nothing */
    }

    Customizations._suppressUpdates = false;

    if (!suppressUpdate) {
      Customizations._raiseChange();
    }
  };

  Customizations.observe = function (onChange) {
    _events$1.push(onChange);
  };

  Customizations.unobserve = function (onChange) {
    _events$1 = _events$1.filter(function (cb) {
      return cb !== onChange;
    });
  };

  Customizations._raiseChange = function () {
    if (!Customizations._suppressUpdates) {
      _events$1.forEach(function (cb) {
        return cb();
      });
    }
  };

  return Customizations;
}();

/**
 * Fetches an item from local storage without throwing an exception
 * @param key The key of the item to fetch from local storage
 */

function getItem$3(key) {
  var result = null;

  try {
    var win = getWindow$1();
    result = win ? win.localStorage.getItem(key) : null;
  } catch (e) {
    /* Eat the exception */
  }

  return result;
}

var _language$1;

var STORAGE_KEY$1 = 'language';
/**
 * Gets the language set for the page.
 * @param persistenceType - Where to persist the value. Default is `sessionStorage` if available.
 */

function getLanguage$1(persistenceType) {
  if (persistenceType === void 0) {
    persistenceType = 'sessionStorage';
  }

  if (_language$1 === undefined) {
    var doc = getDocument$1();
    var savedLanguage = persistenceType === 'localStorage' ? getItem$3(STORAGE_KEY$1) : persistenceType === 'sessionStorage' ? getItem$2(STORAGE_KEY$1) : undefined;

    if (savedLanguage) {
      _language$1 = savedLanguage;
    }

    if (_language$1 === undefined && doc) {
      _language$1 = doc.documentElement.getAttribute('lang');
    }

    if (_language$1 === undefined) {
      _language$1 = 'en';
    }
  }

  return _language$1;
}

/**
 * Simple deep merge function. Takes all arguments and returns a deep copy of the objects merged
 * together in the order provided. If an object creates a circular reference, it will assign the
 * original reference.
 */
function merge$1(target) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
    var arg = args_1[_a];

    _merge$1(target || {}, arg);
  }

  return target;
}
/**
 * The _merge helper iterates through all props on source and assigns them to target.
 * When the value is an object, we will create a deep clone of the object. However if
 * there is a circular reference, the value will not be deep cloned and will persist
 * the reference.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

function _merge$1(target, source, circularReferences) {
  if (circularReferences === void 0) {
    circularReferences = [];
  }

  circularReferences.push(source);

  for (var name_1 in source) {
    if (source.hasOwnProperty(name_1)) {
      if (name_1 !== '__proto__' && name_1 !== 'constructor' && name_1 !== 'prototype') {
        var value = source[name_1];

        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
          var isCircularReference = circularReferences.indexOf(value) > -1;
          target[name_1] = isCircularReference ? value : _merge$1(target[name_1] || {}, value, circularReferences);
        } else {
          target[name_1] = value;
        }
      }
    }
  }

  circularReferences.pop();
  return target;
}

var ICON_SETTING_NAME$1 = 'icons';

var _iconSettings$1 = GlobalSettings$1.getValue(ICON_SETTING_NAME$1, {
  __options: {
    disableWarnings: false,
    warnOnMissingIcons: true
  },
  __remapped: {}
}); // Reset icon registration on stylesheet resets.


var stylesheet$1 = Stylesheet$1.getInstance();

if (stylesheet$1 && stylesheet$1.onReset) {
  stylesheet$1.onReset(function () {
    for (var name_1 in _iconSettings$1) {
      if (_iconSettings$1.hasOwnProperty(name_1) && !!_iconSettings$1[name_1].subset) {
        _iconSettings$1[name_1].subset.className = undefined;
      }
    }
  });
}
/**
 * Normalizes an icon name for consistent mapping.
 * Current implementation is to convert the icon name to lower case.
 *
 * @param name - Icon name to normalize.
 * @returns {string} Normalized icon name to use for indexing and mapping.
 */


var normalizeIconName$1 = function (name) {
  return name.toLowerCase();
};
/**
 * Registers a given subset of icons.
 *
 * @param iconSubset - the icon subset definition.
 */


function registerIcons$1(iconSubset, options) {
  var subset = __assign$3(__assign$3({}, iconSubset), {
    isRegistered: false,
    className: undefined
  });

  var icons = iconSubset.icons; // Grab options, optionally mix user provided ones on top.

  options = options ? __assign$3(__assign$3({}, _iconSettings$1.__options), options) : _iconSettings$1.__options;

  for (var iconName in icons) {
    if (icons.hasOwnProperty(iconName)) {
      var code = icons[iconName];
      var normalizedIconName = normalizeIconName$1(iconName);

      if (_iconSettings$1[normalizedIconName]) {
        _warnDuplicateIcon$1(iconName);
      } else {
        _iconSettings$1[normalizedIconName] = {
          code: code,
          subset: subset
        };
      }
    }
  }
}
var _missingIcons$1 = [];
var _missingIconsTimer$1 = undefined;

function _warnDuplicateIcon$1(iconName) {
  var options = _iconSettings$1.__options;
  var warningDelay = 2000;
  var maxIconsInMessage = 10;

  if (!options.disableWarnings) {
    _missingIcons$1.push(iconName);

    if (_missingIconsTimer$1 === undefined) {
      _missingIconsTimer$1 = setTimeout(function () {
        warn$1("Some icons were re-registered. Applications should only call registerIcons for any given " + "icon once. Redefining what an icon is may have unintended consequences. Duplicates " + "include: \n" + _missingIcons$1.slice(0, maxIconsInMessage).join(', ') + (_missingIcons$1.length > maxIconsInMessage ? " (+ " + (_missingIcons$1.length - maxIconsInMessage) + " more)" : ''));
        _missingIconsTimer$1 = undefined;
        _missingIcons$1 = [];
      }, warningDelay);
    }
  }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$5 = function () {
  __assign$5 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign$5.apply(this, arguments);
};

/** Generates all the semantic slot colors based on the theme so far
 * We'll use these as fallbacks for semantic slots that the passed in theme did not define.
 * The caller must still mix in the customized semantic slots at the end.
 */

function makeSemanticColors$1(p, e, s, isInverted, depComments) {
  if (depComments === void 0) {
    depComments = false;
  }

  var semanticColors = __assign$5({
    primaryButtonBorder: 'transparent',
    errorText: !isInverted ? '#a4262c' : '#F1707B',
    messageText: !isInverted ? '#323130' : '#F3F2F1',
    messageLink: !isInverted ? '#005A9E' : '#6CB8F6',
    messageLinkHovered: !isInverted ? '#004578' : '#82C7FF',
    infoIcon: !isInverted ? '#605e5c' : '#C8C6C4',
    errorIcon: !isInverted ? '#A80000' : '#F1707B',
    blockingIcon: !isInverted ? '#FDE7E9' : '#442726',
    warningIcon: !isInverted ? '#797775' : '#C8C6C4',
    severeWarningIcon: !isInverted ? '#D83B01' : '#FCE100',
    successIcon: !isInverted ? '#107C10' : '#92C353',
    infoBackground: !isInverted ? '#f3f2f1' : '#323130',
    errorBackground: !isInverted ? '#FDE7E9' : '#442726',
    blockingBackground: !isInverted ? '#FDE7E9' : '#442726',
    warningBackground: !isInverted ? '#FFF4CE' : '#433519',
    severeWarningBackground: !isInverted ? '#FED9CC' : '#4F2A0F',
    successBackground: !isInverted ? '#DFF6DD' : '#393D1B',
    // deprecated
    warningHighlight: !isInverted ? '#ffb900' : '#fff100',
    successText: !isInverted ? '#107C10' : '#92c353'
  }, s);

  var fullSemanticColors = getSemanticColors$1(p, e, semanticColors, isInverted);
  return _fixDeprecatedSlots$1(fullSemanticColors, depComments);
}
/**
 * Map partial platte and effects to partial semantic colors.
 */

function getSemanticColors$1(p, e, s, isInverted, depComments) {

  var result = {}; // map palette

  var _a = p || {},
      white = _a.white,
      black = _a.black,
      themePrimary = _a.themePrimary,
      themeDark = _a.themeDark,
      themeDarker = _a.themeDarker,
      themeDarkAlt = _a.themeDarkAlt,
      themeLighter = _a.themeLighter,
      neutralLight = _a.neutralLight,
      neutralLighter = _a.neutralLighter,
      neutralDark = _a.neutralDark,
      neutralQuaternary = _a.neutralQuaternary,
      neutralQuaternaryAlt = _a.neutralQuaternaryAlt,
      neutralPrimary = _a.neutralPrimary,
      neutralSecondary = _a.neutralSecondary,
      neutralSecondaryAlt = _a.neutralSecondaryAlt,
      neutralTertiary = _a.neutralTertiary,
      neutralTertiaryAlt = _a.neutralTertiaryAlt,
      neutralLighterAlt = _a.neutralLighterAlt,
      accent = _a.accent;

  if (white) {
    result.bodyBackground = white;
    result.bodyFrameBackground = white;
    result.accentButtonText = white;
    result.buttonBackground = white;
    result.primaryButtonText = white;
    result.primaryButtonTextHovered = white;
    result.primaryButtonTextPressed = white;
    result.inputBackground = white;
    result.inputForegroundChecked = white;
    result.listBackground = white;
    result.menuBackground = white;
    result.cardStandoutBackground = white;
  }

  if (black) {
    result.bodyTextChecked = black;
    result.buttonTextCheckedHovered = black;
  }

  if (themePrimary) {
    result.link = themePrimary;
    result.primaryButtonBackground = themePrimary;
    result.inputBackgroundChecked = themePrimary;
    result.inputIcon = themePrimary;
    result.inputFocusBorderAlt = themePrimary;
    result.menuIcon = themePrimary;
    result.menuHeader = themePrimary;
    result.accentButtonBackground = themePrimary;
  }

  if (themeDark) {
    result.primaryButtonBackgroundPressed = themeDark;
    result.inputBackgroundCheckedHovered = themeDark;
    result.inputIconHovered = themeDark;
  }

  if (themeDarker) {
    result.linkHovered = themeDarker;
  }

  if (themeDarkAlt) {
    result.primaryButtonBackgroundHovered = themeDarkAlt;
  }

  if (themeLighter) {
    result.inputPlaceholderBackgroundChecked = themeLighter;
  }

  if (neutralLight) {
    result.bodyBackgroundChecked = neutralLight;
    result.bodyFrameDivider = neutralLight;
    result.bodyDivider = neutralLight;
    result.variantBorder = neutralLight;
    result.buttonBackgroundCheckedHovered = neutralLight;
    result.buttonBackgroundPressed = neutralLight;
    result.listItemBackgroundChecked = neutralLight;
    result.listHeaderBackgroundPressed = neutralLight;
    result.menuItemBackgroundPressed = neutralLight; // eslint-disable-next-line deprecation/deprecation

    result.menuItemBackgroundChecked = neutralLight;
  }

  if (neutralLighter) {
    result.bodyBackgroundHovered = neutralLighter;
    result.buttonBackgroundHovered = neutralLighter;
    result.buttonBackgroundDisabled = neutralLighter;
    result.buttonBorderDisabled = neutralLighter;
    result.primaryButtonBackgroundDisabled = neutralLighter;
    result.disabledBackground = neutralLighter;
    result.listItemBackgroundHovered = neutralLighter;
    result.listHeaderBackgroundHovered = neutralLighter;
    result.menuItemBackgroundHovered = neutralLighter;
  }

  if (neutralQuaternary) {
    result.primaryButtonTextDisabled = neutralQuaternary;
    result.disabledSubtext = neutralQuaternary;
  }

  if (neutralQuaternaryAlt) {
    result.listItemBackgroundCheckedHovered = neutralQuaternaryAlt;
  }

  if (neutralTertiary) {
    result.disabledBodyText = neutralTertiary;
    result.variantBorderHovered = (s === null || s === void 0 ? void 0 : s.variantBorderHovered) || neutralTertiary;
    result.buttonTextDisabled = neutralTertiary;
    result.inputIconDisabled = neutralTertiary;
    result.disabledText = neutralTertiary;
  }

  if (neutralPrimary) {
    result.bodyText = neutralPrimary;
    result.actionLink = neutralPrimary;
    result.buttonText = neutralPrimary;
    result.inputBorderHovered = neutralPrimary;
    result.inputText = neutralPrimary;
    result.listText = neutralPrimary;
    result.menuItemText = neutralPrimary;
  }

  if (neutralLighterAlt) {
    result.bodyStandoutBackground = neutralLighterAlt;
    result.defaultStateBackground = neutralLighterAlt;
  }

  if (neutralDark) {
    result.actionLinkHovered = neutralDark;
    result.buttonTextHovered = neutralDark;
    result.buttonTextChecked = neutralDark;
    result.buttonTextPressed = neutralDark;
    result.inputTextHovered = neutralDark;
    result.menuItemTextHovered = neutralDark;
  }

  if (neutralSecondary) {
    result.bodySubtext = neutralSecondary;
    result.focusBorder = neutralSecondary;
    result.inputBorder = neutralSecondary;
    result.smallInputBorder = neutralSecondary;
    result.inputPlaceholderText = neutralSecondary;
  }

  if (neutralSecondaryAlt) {
    result.buttonBorder = neutralSecondaryAlt;
  }

  if (neutralTertiaryAlt) {
    result.disabledBodySubtext = neutralTertiaryAlt;
    result.disabledBorder = neutralTertiaryAlt;
    result.buttonBackgroundChecked = neutralTertiaryAlt;
    result.menuDivider = neutralTertiaryAlt;
  }

  if (accent) {
    result.accentButtonBackground = accent;
  } // map effects


  if (e === null || e === void 0 ? void 0 : e.elevation4) {
    result.cardShadow = e.elevation4;
  }

  if (!isInverted && (e === null || e === void 0 ? void 0 : e.elevation8)) {
    result.cardShadowHovered = e.elevation8;
  } else if (result.variantBorderHovered) {
    result.cardShadowHovered = '0 0 1px ' + result.variantBorderHovered;
  }

  result = __assign$5(__assign$5({}, result), s);
  return result;
}

function _fixDeprecatedSlots$1(s, depComments) {
  // Add @deprecated tag as comment if enabled
  var dep = '';

  if (depComments === true) {
    dep = ' /* @deprecated */';
  }
  /* eslint-disable deprecation/deprecation */


  s.listTextColor = s.listText + dep;
  s.menuItemBackgroundChecked += dep;
  s.warningHighlight += dep;
  s.warningText = s.messageText + dep;
  s.successText += dep;
  /* eslint-enable deprecation/deprecation */

  return s;
}

/**
 * Merge a partial/full theme into a full theme and returns a merged full theme.
 */

function mergeThemes$1(theme, partialTheme) {
  var _a, _b, _c;

  if (partialTheme === void 0) {
    partialTheme = {};
  }

  var mergedTheme = merge$1({}, theme, partialTheme, {
    semanticColors: getSemanticColors$1(partialTheme.palette, partialTheme.effects, partialTheme.semanticColors, partialTheme.isInverted === undefined ? theme.isInverted : partialTheme.isInverted)
  });

  if (((_a = partialTheme.palette) === null || _a === void 0 ? void 0 : _a.themePrimary) && !((_b = partialTheme.palette) === null || _b === void 0 ? void 0 : _b.accent)) {
    mergedTheme.palette.accent = partialTheme.palette.themePrimary;
  }

  if (partialTheme.defaultFontStyle) {
    for (var _i = 0, _d = Object.keys(mergedTheme.fonts); _i < _d.length; _i++) {
      var fontStyle = _d[_i];
      mergedTheme.fonts[fontStyle] = merge$1(mergedTheme.fonts[fontStyle], partialTheme.defaultFontStyle, (_c = partialTheme === null || partialTheme === void 0 ? void 0 : partialTheme.fonts) === null || _c === void 0 ? void 0 : _c[fontStyle]);
    }
  }

  return mergedTheme;
}

// When adding or removing a color, make sure you keep this consistent with IColorClassNames
// by adding the color variants.
var DefaultPalette$1 = {
  themeDarker: '#004578',
  themeDark: '#005a9e',
  themeDarkAlt: '#106ebe',
  themePrimary: '#0078d4',
  themeSecondary: '#2b88d8',
  themeTertiary: '#71afe5',
  themeLight: '#c7e0f4',
  themeLighter: '#deecf9',
  themeLighterAlt: '#eff6fc',
  black: '#000000',
  blackTranslucent40: 'rgba(0,0,0,.4)',
  neutralDark: '#201f1e',
  neutralPrimary: '#323130',
  neutralPrimaryAlt: '#3b3a39',
  neutralSecondary: '#605e5c',
  neutralSecondaryAlt: '#8a8886',
  neutralTertiary: '#a19f9d',
  neutralTertiaryAlt: '#c8c6c4',
  neutralQuaternary: '#d2d0ce',
  neutralQuaternaryAlt: '#e1dfdd',
  neutralLight: '#edebe9',
  neutralLighter: '#f3f2f1',
  neutralLighterAlt: '#faf9f8',
  accent: '#0078d4',
  white: '#ffffff',
  whiteTranslucent40: 'rgba(255,255,255,.4)',
  yellowDark: '#d29200',
  yellow: '#ffb900',
  yellowLight: '#fff100',
  orange: '#d83b01',
  orangeLight: '#ea4300',
  orangeLighter: '#ff8c00',
  redDark: '#a4262c',
  red: '#e81123',
  magentaDark: '#5c005c',
  magenta: '#b4009e',
  magentaLight: '#e3008c',
  purpleDark: '#32145a',
  purple: '#5c2d91',
  purpleLight: '#b4a0ff',
  blueDark: '#002050',
  blueMid: '#00188f',
  blue: '#0078d4',
  blueLight: '#00bcf2',
  tealDark: '#004b50',
  teal: '#008272',
  tealLight: '#00b294',
  greenDark: '#004b1c',
  green: '#107c10',
  greenLight: '#bad80a'
};

var Depths$1;

(function (Depths) {
  Depths.depth0 = '0 0 0 0 transparent';
  Depths.depth4 = '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)';
  Depths.depth8 = '0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)';
  Depths.depth16 = '0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)';
  Depths.depth64 = '0 25.6px 57.6px 0 rgba(0, 0, 0, 0.22), 0 4.8px 14.4px 0 rgba(0, 0, 0, 0.18)';
})(Depths$1 || (Depths$1 = {}));

var DefaultEffects$1 = {
  elevation4: Depths$1.depth4,
  elevation8: Depths$1.depth8,
  elevation16: Depths$1.depth16,
  elevation64: Depths$1.depth64,
  roundedCorner2: '2px',
  roundedCorner4: '4px',
  roundedCorner6: '6px'
};

var DefaultSpacing$1 = {
  s2: '4px',
  s1: '8px',
  m: '16px',
  l1: '20px',
  l2: '32px'
};

// Font face names to be registered.
var LocalizedFontNames$1;

(function (LocalizedFontNames) {
  LocalizedFontNames.Arabic = 'Segoe UI Web (Arabic)';
  LocalizedFontNames.Cyrillic = 'Segoe UI Web (Cyrillic)';
  LocalizedFontNames.EastEuropean = 'Segoe UI Web (East European)';
  LocalizedFontNames.Greek = 'Segoe UI Web (Greek)';
  LocalizedFontNames.Hebrew = 'Segoe UI Web (Hebrew)';
  LocalizedFontNames.Thai = 'Leelawadee UI Web';
  LocalizedFontNames.Vietnamese = 'Segoe UI Web (Vietnamese)';
  LocalizedFontNames.WestEuropean = 'Segoe UI Web (West European)';
  LocalizedFontNames.Selawik = 'Selawik Web';
  LocalizedFontNames.Armenian = 'Segoe UI Web (Armenian)';
  LocalizedFontNames.Georgian = 'Segoe UI Web (Georgian)';
})(LocalizedFontNames$1 || (LocalizedFontNames$1 = {})); // Font families with fallbacks, for the general regions.


var LocalizedFontFamilies$1;

(function (LocalizedFontFamilies) {
  LocalizedFontFamilies.Arabic = "'" + LocalizedFontNames$1.Arabic + "'";
  LocalizedFontFamilies.ChineseSimplified = "'Microsoft Yahei UI', Verdana, Simsun";
  LocalizedFontFamilies.ChineseTraditional = "'Microsoft Jhenghei UI', Pmingliu";
  LocalizedFontFamilies.Cyrillic = "'" + LocalizedFontNames$1.Cyrillic + "'";
  LocalizedFontFamilies.EastEuropean = "'" + LocalizedFontNames$1.EastEuropean + "'";
  LocalizedFontFamilies.Greek = "'" + LocalizedFontNames$1.Greek + "'";
  LocalizedFontFamilies.Hebrew = "'" + LocalizedFontNames$1.Hebrew + "'";
  LocalizedFontFamilies.Hindi = "'Nirmala UI'";
  LocalizedFontFamilies.Japanese = "'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka";
  LocalizedFontFamilies.Korean = "'Malgun Gothic', Gulim";
  LocalizedFontFamilies.Selawik = "'" + LocalizedFontNames$1.Selawik + "'";
  LocalizedFontFamilies.Thai = "'Leelawadee UI Web', 'Kmer UI'";
  LocalizedFontFamilies.Vietnamese = "'" + LocalizedFontNames$1.Vietnamese + "'";
  LocalizedFontFamilies.WestEuropean = "'" + LocalizedFontNames$1.WestEuropean + "'";
  LocalizedFontFamilies.Armenian = "'" + LocalizedFontNames$1.Armenian + "'";
  LocalizedFontFamilies.Georgian = "'" + LocalizedFontNames$1.Georgian + "'";
})(LocalizedFontFamilies$1 || (LocalizedFontFamilies$1 = {})); // Standard font sizes.


var FontSizes$1;

(function (FontSizes) {
  FontSizes.size10 = '10px';
  FontSizes.size12 = '12px';
  FontSizes.size14 = '14px';
  FontSizes.size16 = '16px';
  FontSizes.size18 = '18px';
  FontSizes.size20 = '20px';
  FontSizes.size24 = '24px';
  FontSizes.size28 = '28px';
  FontSizes.size32 = '32px';
  FontSizes.size42 = '42px';
  FontSizes.size68 = '68px';
  FontSizes.mini = '10px';
  FontSizes.xSmall = '10px';
  FontSizes.small = '12px';
  FontSizes.smallPlus = '12px';
  FontSizes.medium = '14px';
  FontSizes.mediumPlus = '16px';
  FontSizes.icon = '16px';
  FontSizes.large = '18px';
  FontSizes.xLarge = '20px';
  FontSizes.xLargePlus = '24px';
  FontSizes.xxLarge = '28px';
  FontSizes.xxLargePlus = '32px';
  FontSizes.superLarge = '42px';
  FontSizes.mega = '68px';
})(FontSizes$1 || (FontSizes$1 = {})); // Standard font weights.


var FontWeights$1;

(function (FontWeights) {
  FontWeights.light = 100;
  FontWeights.semilight = 300;
  FontWeights.regular = 400;
  FontWeights.semibold = 600;
  FontWeights.bold = 700;
})(FontWeights$1 || (FontWeights$1 = {})); // Standard Icon Sizes.


var IconFontSizes$1;

(function (IconFontSizes) {
  IconFontSizes.xSmall = '10px';
  IconFontSizes.small = '12px';
  IconFontSizes.medium = '16px';
  IconFontSizes.large = '20px';
})(IconFontSizes$1 || (IconFontSizes$1 = {}));

var FontFamilyFallbacks$1 = "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif"; // By default, we favor system fonts for the default.
// All localized fonts use a web font and never use the system font.

var defaultFontFamily$1 = "'Segoe UI', '" + LocalizedFontNames$1.WestEuropean + "'"; // Mapping of language prefix to to font family.

var LanguageToFontMap$1 = {
  ar: LocalizedFontFamilies$1.Arabic,
  bg: LocalizedFontFamilies$1.Cyrillic,
  cs: LocalizedFontFamilies$1.EastEuropean,
  el: LocalizedFontFamilies$1.Greek,
  et: LocalizedFontFamilies$1.EastEuropean,
  he: LocalizedFontFamilies$1.Hebrew,
  hi: LocalizedFontFamilies$1.Hindi,
  hr: LocalizedFontFamilies$1.EastEuropean,
  hu: LocalizedFontFamilies$1.EastEuropean,
  ja: LocalizedFontFamilies$1.Japanese,
  kk: LocalizedFontFamilies$1.EastEuropean,
  ko: LocalizedFontFamilies$1.Korean,
  lt: LocalizedFontFamilies$1.EastEuropean,
  lv: LocalizedFontFamilies$1.EastEuropean,
  pl: LocalizedFontFamilies$1.EastEuropean,
  ru: LocalizedFontFamilies$1.Cyrillic,
  sk: LocalizedFontFamilies$1.EastEuropean,
  'sr-latn': LocalizedFontFamilies$1.EastEuropean,
  th: LocalizedFontFamilies$1.Thai,
  tr: LocalizedFontFamilies$1.EastEuropean,
  uk: LocalizedFontFamilies$1.Cyrillic,
  vi: LocalizedFontFamilies$1.Vietnamese,
  'zh-hans': LocalizedFontFamilies$1.ChineseSimplified,
  'zh-hant': LocalizedFontFamilies$1.ChineseTraditional,
  hy: LocalizedFontFamilies$1.Armenian,
  ka: LocalizedFontFamilies$1.Georgian
};

function _fontFamilyWithFallbacks$1(fontFamily) {
  return fontFamily + ", " + FontFamilyFallbacks$1;
}
/**
 * If there is a localized font for this language, return that.
 * Returns undefined if there is no localized font for that language.
 */


function _getLocalizedFontFamily$1(language) {
  for (var lang in LanguageToFontMap$1) {
    if (LanguageToFontMap$1.hasOwnProperty(lang) && language && lang.indexOf(language) === 0) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return LanguageToFontMap$1[lang];
    }
  }

  return defaultFontFamily$1;
}

function _createFont$1(size, weight, fontFamily) {
  return {
    fontFamily: fontFamily,
    MozOsxFontSmoothing: 'grayscale',
    WebkitFontSmoothing: 'antialiased',
    fontSize: size,
    fontWeight: weight
  };
}

function createFontStyles$1(localeCode) {
  var localizedFont = _getLocalizedFontFamily$1(localeCode);

  var fontFamilyWithFallback = _fontFamilyWithFallbacks$1(localizedFont);

  var fontStyles = {
    tiny: _createFont$1(FontSizes$1.mini, FontWeights$1.regular, fontFamilyWithFallback),
    xSmall: _createFont$1(FontSizes$1.xSmall, FontWeights$1.regular, fontFamilyWithFallback),
    small: _createFont$1(FontSizes$1.small, FontWeights$1.regular, fontFamilyWithFallback),
    smallPlus: _createFont$1(FontSizes$1.smallPlus, FontWeights$1.regular, fontFamilyWithFallback),
    medium: _createFont$1(FontSizes$1.medium, FontWeights$1.regular, fontFamilyWithFallback),
    mediumPlus: _createFont$1(FontSizes$1.mediumPlus, FontWeights$1.regular, fontFamilyWithFallback),
    large: _createFont$1(FontSizes$1.large, FontWeights$1.regular, fontFamilyWithFallback),
    xLarge: _createFont$1(FontSizes$1.xLarge, FontWeights$1.semibold, fontFamilyWithFallback),
    xLargePlus: _createFont$1(FontSizes$1.xLargePlus, FontWeights$1.semibold, fontFamilyWithFallback),
    xxLarge: _createFont$1(FontSizes$1.xxLarge, FontWeights$1.semibold, fontFamilyWithFallback),
    xxLargePlus: _createFont$1(FontSizes$1.xxLargePlus, FontWeights$1.semibold, fontFamilyWithFallback),
    superLarge: _createFont$1(FontSizes$1.superLarge, FontWeights$1.semibold, fontFamilyWithFallback),
    mega: _createFont$1(FontSizes$1.mega, FontWeights$1.semibold, fontFamilyWithFallback)
  };
  return fontStyles;
}

var DefaultBaseUrl$1 = 'https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets'; // Standard font styling.

var DefaultFontStyles$1 = createFontStyles$1(getLanguage$1());

function _registerFontFace$1(fontFamily, url, fontWeight, localFontName) {
  fontFamily = "'" + fontFamily + "'";
  var localFontSrc = localFontName !== undefined ? "local('" + localFontName + "')," : '';
  fontFace$1({
    fontFamily: fontFamily,
    src: localFontSrc + ("url('" + url + ".woff2') format('woff2'),") + ("url('" + url + ".woff') format('woff')"),
    fontWeight: fontWeight,
    fontStyle: 'normal',
    fontDisplay: 'swap'
  });
}

function _registerFontFaceSet$1(baseUrl, fontFamily, cdnFolder, cdnFontName, localFontName) {
  if (cdnFontName === void 0) {
    cdnFontName = 'segoeui';
  }

  var urlBase = baseUrl + "/" + cdnFolder + "/" + cdnFontName;

  _registerFontFace$1(fontFamily, urlBase + '-light', FontWeights$1.light, localFontName && localFontName + ' Light');

  _registerFontFace$1(fontFamily, urlBase + '-semilight', FontWeights$1.semilight, localFontName && localFontName + ' SemiLight');

  _registerFontFace$1(fontFamily, urlBase + '-regular', FontWeights$1.regular, localFontName);

  _registerFontFace$1(fontFamily, urlBase + '-semibold', FontWeights$1.semibold, localFontName && localFontName + ' SemiBold');

  _registerFontFace$1(fontFamily, urlBase + '-bold', FontWeights$1.bold, localFontName && localFontName + ' Bold');
}

function registerDefaultFontFaces$1(baseUrl) {
  if (baseUrl) {
    var fontUrl = baseUrl + "/fonts"; // Produce @font-face definitions for all supported web fonts.

    _registerFontFaceSet$1(fontUrl, LocalizedFontNames$1.Thai, 'leelawadeeui-thai', 'leelawadeeui');

    _registerFontFaceSet$1(fontUrl, LocalizedFontNames$1.Arabic, 'segoeui-arabic');

    _registerFontFaceSet$1(fontUrl, LocalizedFontNames$1.Cyrillic, 'segoeui-cyrillic');

    _registerFontFaceSet$1(fontUrl, LocalizedFontNames$1.EastEuropean, 'segoeui-easteuropean');

    _registerFontFaceSet$1(fontUrl, LocalizedFontNames$1.Greek, 'segoeui-greek');

    _registerFontFaceSet$1(fontUrl, LocalizedFontNames$1.Hebrew, 'segoeui-hebrew');

    _registerFontFaceSet$1(fontUrl, LocalizedFontNames$1.Vietnamese, 'segoeui-vietnamese');

    _registerFontFaceSet$1(fontUrl, LocalizedFontNames$1.WestEuropean, 'segoeui-westeuropean', 'segoeui', 'Segoe UI');

    _registerFontFaceSet$1(fontUrl, LocalizedFontFamilies$1.Selawik, 'selawik', 'selawik');

    _registerFontFaceSet$1(fontUrl, LocalizedFontNames$1.Armenian, 'segoeui-armenian');

    _registerFontFaceSet$1(fontUrl, LocalizedFontNames$1.Georgian, 'segoeui-georgian'); // Leelawadee UI (Thai) does not have a 'light' weight, so we override
    // the font-face generated above to use the 'semilight' weight instead.


    _registerFontFace$1('Leelawadee UI Web', fontUrl + "/leelawadeeui-thai/leelawadeeui-semilight", FontWeights$1.light); // Leelawadee UI (Thai) does not have a 'semibold' weight, so we override
    // the font-face generated above to use the 'bold' weight instead.


    _registerFontFace$1('Leelawadee UI Web', fontUrl + "/leelawadeeui-thai/leelawadeeui-bold", FontWeights$1.semibold);
  }
}
/**
 * Reads the fontBaseUrl from window.FabricConfig.fontBaseUrl or falls back to a default.
 */

function _getFontBaseUrl$1() {
  var _a, _b; // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var fabricConfig = (_a = getWindow$1()) === null || _a === void 0 ? void 0 : _a.FabricConfig;
  return (_b = fabricConfig === null || fabricConfig === void 0 ? void 0 : fabricConfig.fontBaseUrl) !== null && _b !== void 0 ? _b : DefaultBaseUrl$1;
}
/**
 * Register the font faces.
 */


registerDefaultFontFaces$1(_getFontBaseUrl$1());

/**
 * Creates a custom theme definition.
 * @param theme - Partial theme object.
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */

function createTheme$1(theme, depComments) {
  if (theme === void 0) {
    theme = {};
  }

  if (depComments === void 0) {
    depComments = false;
  }

  var isInverted = !!theme.isInverted;
  var baseTheme = {
    palette: DefaultPalette$1,
    effects: DefaultEffects$1,
    fonts: DefaultFontStyles$1,
    spacing: DefaultSpacing$1,
    isInverted: isInverted,
    disableGlobalClassNames: false,
    semanticColors: makeSemanticColors$1(DefaultPalette$1, DefaultEffects$1, undefined, isInverted, depComments),
    rtl: undefined
  };
  return mergeThemes$1(baseTheme, theme);
}

var _theme$1 = createTheme$1({});

var _onThemeChangeCallbacks$1 = [];
var ThemeSettingName$1 = 'theme';
function initializeThemeInCustomizations$1() {
  var _a;

  var _b, _c; // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var win = getWindow$1();

  if ((_b = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _b === void 0 ? void 0 : _b.legacyTheme) {
    // does everything the `else` clause does and more, such as invoke legacy theming
    loadTheme$2(win.FabricConfig.legacyTheme);
  } else if (!Customizations$1.getSettings([ThemeSettingName$1]).theme) {
    if ((_c = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _c === void 0 ? void 0 : _c.theme) {
      _theme$1 = createTheme$1(win.FabricConfig.theme);
    } // Set the default theme.


    Customizations$1.applySettings((_a = {}, _a[ThemeSettingName$1] = _theme$1, _a));
  }
}
initializeThemeInCustomizations$1();
/**
 * Applies the theme, while filling in missing slots.
 * @param theme - Partial theme object.
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */

function loadTheme$2(theme, depComments) {
  var _a;

  if (depComments === void 0) {
    depComments = false;
  }

  _theme$1 = createTheme$1(theme, depComments); // Invoke the legacy method of theming the page as well.

  loadTheme(__assign$3(__assign$3(__assign$3(__assign$3({}, _theme$1.palette), _theme$1.semanticColors), _theme$1.effects), _loadFonts$1(_theme$1)));
  Customizations$1.applySettings((_a = {}, _a[ThemeSettingName$1] = _theme$1, _a));

  _onThemeChangeCallbacks$1.forEach(function (callback) {
    try {
      callback(_theme$1);
    } catch (e) {// don't let a bad callback break everything else
    }
  });

  return _theme$1;
}
/**
 * Loads font variables into a JSON object.
 * @param theme - The theme object
 */

function _loadFonts$1(theme) {
  var lines = {};

  for (var _i = 0, _a = Object.keys(theme.fonts); _i < _a.length; _i++) {
    var fontName = _a[_i];
    var font = theme.fonts[fontName];

    for (var _b = 0, _c = Object.keys(font); _b < _c.length; _b++) {
      var propName = _c[_b];
      var name_1 = fontName + propName.charAt(0).toUpperCase() + propName.slice(1);
      var value = font[propName];

      if (propName === 'fontSize' && typeof value === 'number') {
        // if it's a number, convert it to px by default like our theming system does
        value = value + 'px';
      }

      lines[name_1] = value;
    }
  }

  return lines;
}

var FLUENT_CDN_BASE_URL = 'https://res.cdn.office.net/files/fabric-cdn-prod_20230427.001';

// Do not modify this file; it is generated as part of publish.
setVersion$1('@fluentui/style-utilities', '8.9.10');

initializeThemeInCustomizations$1();

/**
 * Enumeration of icon file names, and what extensions they map to.
 * Please keep items alphabetical. Items without extensions may require specific logic in the code to map.
 * Always use getFileTypeIconProps to get the most up-to-date icon at the right pixel density.
 */
var FileTypeIconMap = {
  accdb: {
    extensions: ['accdb', 'mdb']
  },
  archive: {
    extensions: ['7z', 'ace', 'arc', 'arj', 'dmg', 'gz', 'iso', 'lzh', 'pkg', 'rar', 'sit', 'tgz', 'tar', 'z']
  },
  audio: {
    extensions: ['aif', 'aiff', 'aac', 'alac', 'amr', 'ape', 'au', 'awb', 'dct', 'dss', 'dvf', 'flac', 'gsm', 'm4a', 'm4p', 'mid', 'mmf', 'mp3', 'oga', 'ra', 'rm', 'wav', 'wma', 'wv']
  },
  calendar: {
    extensions: ['ical', 'icalendar', 'ics', 'ifb', 'vcs']
  },
  classifier: {
    extensions: ['classifier']
  },
  clipchamp: {
    extensions: ['clipchamp']
  },
  code: {
    extensions: ['abap', 'ada', 'adp', 'ahk', 'as', 'as3', 'asc', 'ascx', 'asm', 'asp', 'awk', 'bash', 'bash_login', 'bash_logout', 'bash_profile', 'bashrc', 'bat', 'bib', 'bsh', 'build', 'builder', 'c', 'cbl', 'c++', 'capfile', 'cc', 'cfc', 'cfm', 'cfml', 'cl', 'clj', 'cls', 'cmake', 'cmd', 'coffee', 'config', 'cpp', 'cpt', 'cpy', 'cs', 'cshtml', 'cson', 'csproj', 'css', 'ctp', 'cxx', 'd', 'ddl', 'di', 'disco', 'dml', 'dtd', 'dtml', 'el', 'emakefile', 'erb', 'erl', 'f', 'f90', 'f95', 'fs', 'fsi', 'fsscript', 'fsx', 'gemfile', 'gemspec', 'gitconfig', 'go', 'groovy', 'gvy', 'h', 'h++', 'haml', 'handlebars', 'hbs', 'hcp', 'hh', 'hpp', 'hrl', 'hs', 'htc', 'hxx', 'idl', 'iim', 'inc', 'inf', 'ini', 'inl', 'ipp', 'irbrc', 'jade', 'jav', 'java', 'js', 'json', 'jsp', 'jsproj', 'jsx', 'l', 'less', 'lhs', 'lisp', 'log', 'lst', 'ltx', 'lua', 'm', 'mak', 'make', 'manifest', 'master', 'md', 'markdn', 'markdown', 'mdown', 'mkdn', 'ml', 'mli', 'mll', 'mly', 'mm', 'mud', 'nfo', 'opml', 'osascript', 'p', 'pas', 'patch', 'php', 'php2', 'php3', 'php4', 'php5', 'phtml', 'pl', 'pm', 'pod', 'pp', 'profile', 'ps1', 'ps1xml', 'psd1', 'psm1', 'pss', 'pt', 'py', 'pyw', 'r', 'rake', 'rb', 'rbx', 'rc', 'rdf', 're', 'reg', 'rest', 'resw', 'resx', 'rhtml', 'rjs', 'rprofile', 'rpy', 'rss', 'rst', 'ruby', 'rxml', 's', 'sass', 'scala', 'scm', 'sconscript', 'sconstruct', 'script', 'scss', 'sgml', 'sh', 'shtml', 'sml', 'svn-base', 'swift', 'sql', 'sty', 'tcl', 'tex', 'textile', 'tld', 'tli', 'tmpl', 'tpl', 'vb', 'vi', 'vim', 'vmg', 'webpart', 'wsp', 'wsdl', 'xhtml', 'xoml', 'xsd', 'xslt', 'yaml', 'yaws', 'yml', 'zsh']
  },
  contact: {
    extensions: ['vcf']
  },

  /*  css: {},  not broken out yet, snapping to 'code' for now */
  csv: {
    extensions: ['csv']
  },
  desktopfolder: {},
  docset: {},
  documentsfolder: {},
  docx: {
    extensions: ['doc', 'docm', 'docx', 'docb']
  },
  dotx: {
    extensions: ['dot', 'dotm', 'dotx']
  },
  email: {
    extensions: ['eml', 'msg', 'oft', 'ost', 'pst']
  },
  exe: {
    extensions: ['application', 'appref-ms', 'apk', 'app', 'appx', 'exe', 'ipa', 'msi', 'xap']
  },
  favoritesfolder: {},
  folder: {},
  font: {
    extensions: ['ttf', 'otf', 'woff']
  },
  form: {},
  genericfile: {},
  html: {
    extensions: ['htm', 'html', 'mht']
  },
  ipynb: {
    extensions: ['nnb', 'ipynb']
  },
  link: {
    extensions: ['lnk', 'link', 'url', 'website', 'webloc']
  },
  linkedfolder: {},
  listitem: {},
  loop: {
    extensions: ['fluid', 'loop', 'note']
  },
  loopworkspace: {},
  officescript: {
    extensions: ['osts']
  },
  splist: {},
  model: {
    extensions: ['3ds', '3mf', 'blend', 'cool', 'dae', 'df', 'dwfx', 'dwg', 'dxf', 'fbx', 'glb', 'gltf', 'holo', 'layer', 'layout', 'max', 'mcworld', 'mtl', 'obj', 'off', 'ply', 'skp', 'stp', 'stl', 't', 'thl', 'x']
  },
  mpp: {
    extensions: ['mpp']
  },
  mpt: {
    extensions: ['mpt']
  },
  multiple: {},
  one: {
    // This is a partial OneNote page or section export. Not whole notebooks, see "onetoc"
    extensions: ['one']
  },
  onetoc: {
    // This is an entire OneNote notebook.
    extensions: ['ms-one-stub', 'onetoc', 'onetoc2', 'onepkg'] // This represents a complete, logical notebook.

  },
  pbiapp: {},
  pdf: {
    extensions: ['pdf']
  },
  photo: {
    extensions: ['arw', 'bmp', 'cr2', 'crw', 'dic', 'dicm', 'dcm', 'dcm30', 'dcr', 'dds', 'dib', 'dng', 'erf', 'gif', 'heic', 'heif', 'ico', 'jfi', 'jfif', 'jif', 'jpe', 'jpeg', 'jpg', 'jxr', 'kdc', 'mrw', 'nef', 'orf', 'pct', 'pict', 'png', 'pns', 'psb', 'psd', 'raw', 'tga', 'tif', 'tiff', 'wdp']
  },
  photo360: {},
  picturesfolder: {},
  potx: {
    extensions: ['pot', 'potm', 'potx']
  },
  powerbi: {
    extensions: ['pbids', 'pbix']
  },
  ppsx: {
    extensions: ['pps', 'ppsm', 'ppsx']
  },
  pptx: {
    extensions: ['ppt', 'pptm', 'pptx', 'sldx', 'sldm']
  },
  presentation: {
    extensions: ['odp', 'gslides', 'key']
  },
  pub: {
    extensions: ['pub']
  },
  spo: {
    extensions: ['aspx']
  },
  sponews: {},
  spreadsheet: {
    extensions: ['odc', 'ods', 'gsheet', 'numbers', 'tsv']
  },
  rtf: {
    extensions: ['epub', 'gdoc', 'odt', 'rtf', 'wri', 'pages']
  },
  sharedfolder: {},
  playlist: {},
  sway: {},
  sysfile: {
    extensions: ['bak', 'bin', 'cab', 'cache', 'cat', 'cer', 'class', 'dat', 'db', 'dbg', 'dl_', 'dll', 'ithmb', 'jar', 'kb', 'ldt', 'lrprev', 'pkpass', 'ppa', 'ppam', 'pdb', 'rom', 'thm', 'thmx', 'vsl', 'xla', 'xlam', 'xlb', 'xll']
  },
  txt: {
    extensions: ['dif', 'diff', 'readme', 'out', 'plist', 'properties', 'text', 'txt']
  },
  vaultclosed: {},
  vaultopen: {},
  vector: {
    extensions: ['ai', 'ait', 'cvs', 'dgn', 'gdraw', 'pd', 'emf', 'eps', 'fig', 'ind', 'indd', 'indl', 'indt', 'indb', 'ps', 'svg', 'svgz', 'wmf', 'oxps', 'xps', 'xd', 'sketch']
  },
  video: {
    extensions: ['3g2', '3gp', '3gp2', '3gpp', 'asf', 'avi', 'dvr-ms', 'flv', 'm1v', 'm4v', 'mkv', 'mod', 'mov', 'mm4p', 'mp2', 'mp2v', 'mp4', 'mp4v', 'mpa', 'mpe', 'mpeg', 'mpg', 'mpv', 'mpv2', 'mts', 'ogg', 'qt', 'swf', 'ts', 'vob', 'webm', 'wlmp', 'wm', 'wmv', 'wmx']
  },
  video360: {},
  vsdx: {
    extensions: ['vdx', 'vsd', 'vsdm', 'vsdx', 'vsw', 'vdw']
  },
  vssx: {
    extensions: ['vss', 'vssm', 'vssx']
  },
  vstx: {
    extensions: ['vst', 'vstm', 'vstx', 'vsx']
  },
  whiteboard: {
    extensions: ['whiteboard', 'wbtx']
  },
  xlsx: {
    extensions: ['xlc', 'xls', 'xlsb', 'xlsm', 'xlsx', 'xlw']
  },
  xltx: {
    extensions: ['xlt', 'xltm', 'xltx']
  },
  xml: {
    extensions: ['xaml', 'xml', 'xsl']
  },
  xsn: {
    extensions: ['xsn']
  },
  zip: {
    extensions: ['zip']
  }
};

var PNG_SUFFIX = '_png';
var SVG_SUFFIX = '_svg';
var DEFAULT_BASE_URL = FLUENT_CDN_BASE_URL + "/assets/item-types/";
var ICON_SIZES = [16, 20, 24, 32, 40, 48, 64, 96];
function initializeFileTypeIcons(baseUrl, options) {
  if (baseUrl === void 0) {
    baseUrl = DEFAULT_BASE_URL;
  }

  ICON_SIZES.forEach(function (size) {
    _initializeIcons(baseUrl, size, options);
  });
}

function _initializeIcons(baseUrl, size, options) {
  var iconTypes = Object.keys(FileTypeIconMap);
  var fileTypeIcons = {};
  iconTypes.forEach(function (type) {
    var baseUrlSizeType = baseUrl + size + '/' + type;
    fileTypeIcons[type + size + PNG_SUFFIX] = createElement("img", {
      src: baseUrlSizeType + '.png',
      alt: ""
    });
    fileTypeIcons[type + size + SVG_SUFFIX] = createElement("img", {
      src: baseUrlSizeType + '.svg',
      alt: ""
    }); // For high resolution screens, register additional versions
    // Apply height=100% and width=100% to force image to fit into containing element
    // SVGs scale well, so you can generally use the default image.
    // 1.5x is a special case where both SVGs and PNGs need a different image.

    fileTypeIcons[type + size + '_1.5x' + PNG_SUFFIX] = createElement("img", {
      src: baseUrl + size + '_1.5x/' + type + '.png',
      height: "100%",
      width: "100%",
      alt: ""
    });
    fileTypeIcons[type + size + '_1.5x' + SVG_SUFFIX] = createElement("img", {
      src: baseUrl + size + '_1.5x/' + type + '.svg',
      height: "100%",
      width: "100%",
      alt: ""
    });
    fileTypeIcons[type + size + '_2x' + PNG_SUFFIX] = createElement("img", {
      src: baseUrl + size + '_2x/' + type + '.png',
      height: "100%",
      width: "100%",
      alt: ""
    });
    fileTypeIcons[type + size + '_3x' + PNG_SUFFIX] = createElement("img", {
      src: baseUrl + size + '_3x/' + type + '.png',
      height: "100%",
      width: "100%",
      alt: ""
    });
    fileTypeIcons[type + size + '_4x' + PNG_SUFFIX] = createElement("img", {
      src: baseUrl + size + '_4x/' + type + '.png',
      height: "100%",
      width: "100%",
      alt: ""
    });
  });
  registerIcons$1({
    fontFace: {},
    style: {
      width: size,
      height: size,
      overflow: 'hidden'
    },
    icons: fileTypeIcons,
    mergeImageProps: true
  }, options);
}

initializeFabricIcons();
initializeFileTypeIcons(); // disable console.log in production

var disableConsoleLog = function disableConsoleLog() {
  if (process.env.NODE_ENV === "production") {
    console.log(i18n._(
    /*i18n*/
    {
      id: "%cStop!"
    }), "color: #a4262c; font-size: 68px; margin-bottom: 8px");
    console.log(i18n._(
    /*i18n*/
    {
      id: "%cThis is a browser feature intended for developers. If someone asked you to copy and paste something here, please contact your IT administrator."
    }), "color: #3b3a39; font-size: 24px; margin-bottom: 10px");
    console.groupCollapsed();

    console.log = function () {};
  }
}; // disable react-dev-tools for this project in produktion


var disableReactDevTools = function disableReactDevTools() {
  if (process.env.NODE_ENV === "development") return;

  var noop = function noop() {
    return undefined;
  };

  var DEV_TOOLS = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;

  if (_typeof(DEV_TOOLS) === "object") {
    for (var _i = 0, _Object$entries = Object.entries(DEV_TOOLS); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      DEV_TOOLS[key] = typeof value === "function" ? noop : null;
    }
  }
};

var BaseApp = function BaseApp(_ref) {
  var Stores = _ref.Stores,
      children = _ref.children;
  disableReactDevTools();
  disableConsoleLog();
  return /*#__PURE__*/React__default.createElement(BrowserRouter, null, /*#__PURE__*/React__default.createElement(Provider$1, null, /*#__PURE__*/React__default.createElement(Subscribe, {
    to: Stores
  }, function (store) {
    return /*#__PURE__*/React__default.createElement(I18nProvider, {
      language: store.state.language,
      catalogs: catalogs,
      i18n: i18n
    }, children);
  })));
};

var layerStackStyles = {
  root: {
    height: "100vh",
    backgroundColor: "rgba(255, 255, 255, 0.8)"
  }
};
var BlockingSpinner = function BlockingSpinner(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? "loading..." : _ref$label,
      _ref$labelPosition = _ref.labelPosition,
      labelPosition = _ref$labelPosition === void 0 ? "bottom" : _ref$labelPosition;
  return /*#__PURE__*/React__default.createElement(Layer, null, /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: layerStackStyles
  }, /*#__PURE__*/React__default.createElement(Spinner, {
    label: label,
    labelPosition: labelPosition
  })));
};

var clamp = function (min, max) {
  return function (v) {
    return Math.max(Math.min(v, max), min);
  };
};

var sanitize = function (v) {
  return v % 1 ? Number(v.toFixed(5)) : v;
};

var floatRegex = /(-)?(\d[\d\.]*)/g;
var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
var singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
var number = {
  test: function (v) {
    return typeof v === 'number';
  },
  parse: parseFloat,
  transform: function (v) {
    return v;
  }
};

var alpha = __assign(__assign({}, number), {
  transform: clamp(0, 1)
});

var scale = __assign(__assign({}, number), {
  default: 1
});

var createUnitType = function (unit) {
  return {
    test: function (v) {
      return typeof v === 'string' && v.endsWith(unit) && v.split(' ').length === 1;
    },
    parse: parseFloat,
    transform: function (v) {
      return "" + v + unit;
    }
  };
};

var degrees = createUnitType('deg');
var percent = createUnitType('%');
var px = createUnitType('px');
var vh = createUnitType('vh');
var vw = createUnitType('vw');

var progressPercentage = __assign(__assign({}, percent), {
  parse: function (v) {
    return percent.parse(v) / 100;
  },
  transform: function (v) {
    return percent.transform(v * 100);
  }
});

var getValueFromFunctionString = function (value) {
  return value.substring(value.indexOf('(') + 1, value.lastIndexOf(')'));
};

var clampRgbUnit = clamp(0, 255);

var isRgba = function (v) {
  return v.red !== undefined;
};

var isHsla = function (v) {
  return v.hue !== undefined;
};

function getValuesAsArray(value) {
  return getValueFromFunctionString(value).replace(/(,|\/)/g, ' ').split(/ \s*/);
}

var splitColorValues = function (terms) {
  return function (v) {
    if (typeof v !== 'string') return v;
    var values = {};
    var valuesArray = getValuesAsArray(v);

    for (var i = 0; i < 4; i++) {
      values[terms[i]] = valuesArray[i] !== undefined ? parseFloat(valuesArray[i]) : 1;
    }

    return values;
  };
};

var rgbaTemplate = function (_a) {
  var red = _a.red,
      green = _a.green,
      blue = _a.blue,
      _b = _a.alpha,
      alpha = _b === void 0 ? 1 : _b;
  return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
};

var hslaTemplate = function (_a) {
  var hue = _a.hue,
      saturation = _a.saturation,
      lightness = _a.lightness,
      _b = _a.alpha,
      alpha = _b === void 0 ? 1 : _b;
  return "hsla(" + hue + ", " + saturation + ", " + lightness + ", " + alpha + ")";
};

var rgbUnit = __assign(__assign({}, number), {
  transform: function (v) {
    return Math.round(clampRgbUnit(v));
  }
});

function isColorString(color, colorType) {
  return color.startsWith(colorType) && singleColorRegex.test(color);
}

var rgba = {
  test: function (v) {
    return typeof v === 'string' ? isColorString(v, 'rgb') : isRgba(v);
  },
  parse: splitColorValues(['red', 'green', 'blue', 'alpha']),
  transform: function (_a) {
    var red = _a.red,
        green = _a.green,
        blue = _a.blue,
        _b = _a.alpha,
        alpha$1 = _b === void 0 ? 1 : _b;
    return rgbaTemplate({
      red: rgbUnit.transform(red),
      green: rgbUnit.transform(green),
      blue: rgbUnit.transform(blue),
      alpha: sanitize(alpha.transform(alpha$1))
    });
  }
};
var hsla = {
  test: function (v) {
    return typeof v === 'string' ? isColorString(v, 'hsl') : isHsla(v);
  },
  parse: splitColorValues(['hue', 'saturation', 'lightness', 'alpha']),
  transform: function (_a) {
    var hue = _a.hue,
        saturation = _a.saturation,
        lightness = _a.lightness,
        _b = _a.alpha,
        alpha$1 = _b === void 0 ? 1 : _b;
    return hslaTemplate({
      hue: Math.round(hue),
      saturation: percent.transform(sanitize(saturation)),
      lightness: percent.transform(sanitize(lightness)),
      alpha: sanitize(alpha.transform(alpha$1))
    });
  }
};

var hex = __assign(__assign({}, rgba), {
  test: function (v) {
    return typeof v === 'string' && isColorString(v, '#');
  },
  parse: function (v) {
    var r = '';
    var g = '';
    var b = '';

    if (v.length > 4) {
      r = v.substr(1, 2);
      g = v.substr(3, 2);
      b = v.substr(5, 2);
    } else {
      r = v.substr(1, 1);
      g = v.substr(2, 1);
      b = v.substr(3, 1);
      r += r;
      g += g;
      b += b;
    }

    return {
      red: parseInt(r, 16),
      green: parseInt(g, 16),
      blue: parseInt(b, 16),
      alpha: 1
    };
  }
});

var color = {
  test: function (v) {
    return typeof v === 'string' && singleColorRegex.test(v) || isRgba(v) || isHsla(v);
  },
  parse: function (v) {
    if (rgba.test(v)) {
      return rgba.parse(v);
    } else if (hsla.test(v)) {
      return hsla.parse(v);
    } else if (hex.test(v)) {
      return hex.parse(v);
    }

    return v;
  },
  transform: function (v) {
    if (isRgba(v)) {
      return rgba.transform(v);
    } else if (isHsla(v)) {
      return hsla.transform(v);
    }

    return v;
  }
};
var COLOR_TOKEN = '${c}';
var NUMBER_TOKEN = '${n}';

var convertNumbersToZero = function (v) {
  return typeof v === 'number' ? 0 : v;
};

var complex = {
  test: function (v) {
    if (typeof v !== 'string' || !isNaN(v)) return false;
    var numValues = 0;
    var foundNumbers = v.match(floatRegex);
    var foundColors = v.match(colorRegex);
    if (foundNumbers) numValues += foundNumbers.length;
    if (foundColors) numValues += foundColors.length;
    return numValues > 0;
  },
  parse: function (v) {
    var input = v;
    var parsed = [];
    var foundColors = input.match(colorRegex);

    if (foundColors) {
      input = input.replace(colorRegex, COLOR_TOKEN);
      parsed.push.apply(parsed, foundColors.map(color.parse));
    }

    var foundNumbers = input.match(floatRegex);

    if (foundNumbers) {
      parsed.push.apply(parsed, foundNumbers.map(number.parse));
    }

    return parsed;
  },
  createTransformer: function (prop) {
    var template = prop;
    var token = 0;
    var foundColors = prop.match(colorRegex);
    var numColors = foundColors ? foundColors.length : 0;

    if (foundColors) {
      for (var i = 0; i < numColors; i++) {
        template = template.replace(foundColors[i], COLOR_TOKEN);
        token++;
      }
    }

    var foundNumbers = template.match(floatRegex);
    var numNumbers = foundNumbers ? foundNumbers.length : 0;

    if (foundNumbers) {
      for (var i = 0; i < numNumbers; i++) {
        template = template.replace(foundNumbers[i], NUMBER_TOKEN);
        token++;
      }
    }

    return function (v) {
      var output = template;

      for (var i = 0; i < token; i++) {
        output = output.replace(i < numColors ? COLOR_TOKEN : NUMBER_TOKEN, i < numColors ? color.transform(v[i]) : sanitize(v[i]));
      }

      return output;
    };
  },
  getAnimatableNone: function (target) {
    var parsedTarget = complex.parse(target);
    var targetTransformer = complex.createTransformer(target);
    return targetTransformer(parsedTarget.map(convertNumbersToZero));
  }
};

var warning = function () {};

var invariant = function () {};

if (process.env.NODE_ENV !== 'production') {
  warning = function (check, message) {
    if (!check && typeof console !== 'undefined') {
      console.warn(message);
    }
  };

  invariant = function (check, message) {
    if (!check) {
      throw new Error(message);
    }
  };
}

var prevTime = 0;
var onNextFrame = typeof window !== 'undefined' && window.requestAnimationFrame !== undefined ? function (callback) {
  return window.requestAnimationFrame(callback);
} : function (callback) {
  var timestamp = Date.now();
  var timeToCall = Math.max(0, 16.7 - (timestamp - prevTime));
  prevTime = timestamp + timeToCall;
  setTimeout(function () {
    return callback(prevTime);
  }, timeToCall);
};

var createStep = function (setRunNextFrame) {
  var processToRun = [];
  var processToRunNextFrame = [];
  var numThisFrame = 0;
  var isProcessing = false;
  var i = 0;
  var cancelled = new WeakSet();
  var toKeepAlive = new WeakSet();
  var renderStep = {
    cancel: function (process) {
      var indexOfCallback = processToRunNextFrame.indexOf(process);
      cancelled.add(process);

      if (indexOfCallback !== -1) {
        processToRunNextFrame.splice(indexOfCallback, 1);
      }
    },
    process: function (frame) {
      var _a;

      isProcessing = true;
      _a = [processToRunNextFrame, processToRun], processToRun = _a[0], processToRunNextFrame = _a[1];
      processToRunNextFrame.length = 0;
      numThisFrame = processToRun.length;

      if (numThisFrame) {
        var process_1;

        for (i = 0; i < numThisFrame; i++) {
          process_1 = processToRun[i];
          process_1(frame);

          if (toKeepAlive.has(process_1) === true && !cancelled.has(process_1)) {
            renderStep.schedule(process_1);
            setRunNextFrame(true);
          }
        }
      }

      isProcessing = false;
    },
    schedule: function (process, keepAlive, immediate) {
      if (keepAlive === void 0) {
        keepAlive = false;
      }

      if (immediate === void 0) {
        immediate = false;
      }

      invariant(typeof process === "function", "Argument must be a function");
      var addToCurrentBuffer = immediate && isProcessing;
      var buffer = addToCurrentBuffer ? processToRun : processToRunNextFrame;
      cancelled.delete(process);
      if (keepAlive) toKeepAlive.add(process);

      if (buffer.indexOf(process) === -1) {
        buffer.push(process);
        if (addToCurrentBuffer) numThisFrame = processToRun.length;
      }
    }
  };
  return renderStep;
};

var maxElapsed = 40;
var defaultElapsed = 1 / 60 * 1000;
var useDefaultElapsed = true;
var willRunNextFrame = false;
var isProcessing = false;
var frame = {
  delta: 0,
  timestamp: 0
};
var stepsOrder = ["read", "update", "preRender", "render", "postRender"];

var setWillRunNextFrame = function (willRun) {
  return willRunNextFrame = willRun;
};

var steps = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
  acc[key] = createStep(setWillRunNextFrame);
  return acc;
}, {});
var sync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
  var step = steps[key];

  acc[key] = function (process, keepAlive, immediate) {
    if (keepAlive === void 0) {
      keepAlive = false;
    }

    if (immediate === void 0) {
      immediate = false;
    }

    if (!willRunNextFrame) startLoop();
    step.schedule(process, keepAlive, immediate);
    return process;
  };

  return acc;
}, {});
var cancelSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
  acc[key] = steps[key].cancel;
  return acc;
}, {});

var processStep = function (stepId) {
  return steps[stepId].process(frame);
};

var processFrame = function (timestamp) {
  willRunNextFrame = false;
  frame.delta = useDefaultElapsed ? defaultElapsed : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
  if (!useDefaultElapsed) defaultElapsed = frame.delta;
  frame.timestamp = timestamp;
  isProcessing = true;
  stepsOrder.forEach(processStep);
  isProcessing = false;

  if (willRunNextFrame) {
    useDefaultElapsed = false;
    onNextFrame(processFrame);
  }
};

var startLoop = function () {
  willRunNextFrame = true;
  useDefaultElapsed = true;
  if (!isProcessing) onNextFrame(processFrame);
};

var getFrameData = function () {
  return frame;
};

var DEFAULT_OVERSHOOT_STRENGTH = 1.525;

var reversed = function (easing) {
  return function (p) {
    return 1 - easing(1 - p);
  };
};

var mirrored = function (easing) {
  return function (p) {
    return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
  };
};

var createReversedEasing = reversed;

var createExpoIn = function (power) {
  return function (p) {
    return Math.pow(p, power);
  };
};

var createBackIn = function (power) {
  return function (p) {
    return p * p * ((power + 1) * p - power);
  };
};

var createAnticipateEasing = function (power) {
  var backEasing = createBackIn(power);
  return function (p) {
    return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
  };
};

var linear = function (p) {
  return p;
};

var easeIn = /*#__PURE__*/createExpoIn(2);
var easeOut = /*#__PURE__*/reversed(easeIn);
var easeInOut = /*#__PURE__*/mirrored(easeIn);

var circIn = function (p) {
  return 1 - Math.sin(Math.acos(p));
};

var circOut = /*#__PURE__*/reversed(circIn);
var circInOut = /*#__PURE__*/mirrored(circOut);
var backIn = /*#__PURE__*/createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
var backOut = /*#__PURE__*/reversed(backIn);
var backInOut = /*#__PURE__*/mirrored(backIn);
var anticipate = /*#__PURE__*/createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH);

var NEWTON_ITERATIONS = 8;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var K_SPLINE_TABLE_SIZE = 11;
var K_SAMPLE_STEP_SIZE = 1.0 / (K_SPLINE_TABLE_SIZE - 1.0);
var FLOAT_32_SUPPORTED = typeof Float32Array !== 'undefined';

var a = function (a1, a2) {
  return 1.0 - 3.0 * a2 + 3.0 * a1;
};

var b = function (a1, a2) {
  return 3.0 * a2 - 6.0 * a1;
};

var c = function (a1) {
  return 3.0 * a1;
};

var getSlope = function (t, a1, a2) {
  return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
};

var calcBezier = function (t, a1, a2) {
  return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
};

function cubicBezier(mX1, mY1, mX2, mY2) {
  var sampleValues = FLOAT_32_SUPPORTED ? new Float32Array(K_SPLINE_TABLE_SIZE) : new Array(K_SPLINE_TABLE_SIZE);

  var binarySubdivide = function (aX, aA, aB) {
    var i = 0;
    var currentX;
    var currentT;

    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;

      if (currentX > 0.0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

    return currentT;
  };

  var newtonRaphsonIterate = function (aX, aGuessT) {
    var i = 0;
    var currentSlope = 0;
    var currentX;

    for (; i < NEWTON_ITERATIONS; ++i) {
      currentSlope = getSlope(aGuessT, mX1, mX2);

      if (currentSlope === 0.0) {
        return aGuessT;
      }

      currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }

    return aGuessT;
  };

  var calcSampleValues = function () {
    for (var i = 0; i < K_SPLINE_TABLE_SIZE; ++i) {
      sampleValues[i] = calcBezier(i * K_SAMPLE_STEP_SIZE, mX1, mX2);
    }
  };

  var getTForX = function (aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = K_SPLINE_TABLE_SIZE - 1;
    var dist = 0.0;
    var guessForT = 0.0;
    var initialSlope = 0.0;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += K_SAMPLE_STEP_SIZE;
    }

    --currentSample;
    dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    guessForT = intervalStart + dist * K_SAMPLE_STEP_SIZE;
    initialSlope = getSlope(guessForT, mX1, mX2);

    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + K_SAMPLE_STEP_SIZE);
    }
  };

  calcSampleValues();

  var resolver = function (aX) {
    var returnValue;

    if (mX1 === mY1 && mX2 === mY2) {
      returnValue = aX;
    } else if (aX === 0) {
      returnValue = 0;
    } else if (aX === 1) {
      returnValue = 1;
    } else {
      returnValue = calcBezier(getTForX(aX), mY1, mY2);
    }

    return returnValue;
  };

  return resolver;
}

var zeroPoint = {
  x: 0,
  y: 0,
  z: 0
};

var isNum = function (v) {
  return typeof v === 'number';
};

var radiansToDegrees = function (radians) {
  return radians * 180 / Math.PI;
};

var angle = function (a, b) {
  if (b === void 0) {
    b = zeroPoint;
  }

  return radiansToDegrees(Math.atan2(b.y - a.y, b.x - a.x));
};

var applyOffset = function (from, to) {
  var hasReceivedFrom = true;

  if (to === undefined) {
    to = from;
    hasReceivedFrom = false;
  }

  return function (v) {
    if (hasReceivedFrom) {
      return v - from + to;
    } else {
      from = v;
      hasReceivedFrom = true;
      return to;
    }
  };
};

var curryRange = function (func) {
  return function (min, max, v) {
    return v !== undefined ? func(min, max, v) : function (cv) {
      return func(min, max, cv);
    };
  };
};

var clamp$1 = function (min, max, v) {
  return Math.min(Math.max(v, min), max);
};

var clamp$1$1 = curryRange(clamp$1);

var conditional = function (check, apply) {
  return function (v) {
    return check(v) ? apply(v) : v;
  };
};

var isPoint = function (point) {
  return point.hasOwnProperty('x') && point.hasOwnProperty('y');
};

var isPoint3D = function (point) {
  return isPoint(point) && point.hasOwnProperty('z');
};

var distance1D = function (a, b) {
  return Math.abs(a - b);
};

var distance = function (a, b) {
  if (b === void 0) {
    b = zeroPoint;
  }

  if (isNum(a) && isNum(b)) {
    return distance1D(a, b);
  } else if (isPoint(a) && isPoint(b)) {
    var xDelta = distance1D(a.x, b.x);
    var yDelta = distance1D(a.y, b.y);
    var zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
  }

  return 0;
};

var progress = function (from, to, value) {
  var toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

var mix = function (from, to, progress) {
  return -progress * from + progress * to + from;
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


var __assign$6 = function () {
  __assign$6 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign$6.apply(this, arguments);
};

var mixLinearColor = function (from, to, v) {
  var fromExpo = from * from;
  var toExpo = to * to;
  return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};

var colorTypes = [hex, rgba, hsla];

var getColorType = function (v) {
  return colorTypes.find(function (type) {
    return type.test(v);
  });
};

var notAnimatable = function (color$$1) {
  return "'" + color$$1 + "' is not an animatable color. Use the equivalent color code instead.";
};

var mixColor = function (from, to) {
  var fromColorType = getColorType(from);
  var toColorType = getColorType(to);
  invariant(!!fromColorType, notAnimatable(from));
  invariant(!!toColorType, notAnimatable(to));
  invariant(fromColorType.transform === toColorType.transform, 'Both colors must be hex/RGBA, OR both must be HSLA.');
  var fromColor = fromColorType.parse(from);
  var toColor = toColorType.parse(to);

  var blended = __assign$6({}, fromColor);

  var mixFunc = fromColorType === hsla ? mix : mixLinearColor;
  return function (v) {
    for (var key in blended) {
      if (key !== 'alpha') {
        blended[key] = mixFunc(fromColor[key], toColor[key], v);
      }
    }

    blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
    return fromColorType.transform(blended);
  };
};

var combineFunctions = function (a, b) {
  return function (v) {
    return b(a(v));
  };
};

var pipe = function () {
  var transformers = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    transformers[_i] = arguments[_i];
  }

  return transformers.reduce(combineFunctions);
};

function getMixer(origin, target) {
  if (isNum(origin)) {
    return function (v) {
      return mix(origin, target, v);
    };
  } else if (color.test(origin)) {
    return mixColor(origin, target);
  } else {
    return mixComplex(origin, target);
  }
}

var mixArray = function (from, to) {
  var output = from.slice();
  var numValues = output.length;
  var blendValue = from.map(function (fromThis, i) {
    return getMixer(fromThis, to[i]);
  });
  return function (v) {
    for (var i = 0; i < numValues; i++) {
      output[i] = blendValue[i](v);
    }

    return output;
  };
};

var mixObject = function (origin, target) {
  var output = __assign$6({}, origin, target);

  var blendValue = {};

  for (var key in output) {
    if (origin[key] !== undefined && target[key] !== undefined) {
      blendValue[key] = getMixer(origin[key], target[key]);
    }
  }

  return function (v) {
    for (var key in blendValue) {
      output[key] = blendValue[key](v);
    }

    return output;
  };
};

function analyse(value) {
  var parsed = complex.parse(value);
  var numValues = parsed.length;
  var numNumbers = 0;
  var numRGB = 0;
  var numHSL = 0;

  for (var i = 0; i < numValues; i++) {
    if (numNumbers || typeof parsed[i] === 'number') {
      numNumbers++;
    } else {
      if (parsed[i].hue !== undefined) {
        numHSL++;
      } else {
        numRGB++;
      }
    }
  }

  return {
    parsed: parsed,
    numNumbers: numNumbers,
    numRGB: numRGB,
    numHSL: numHSL
  };
}

var mixComplex = function (origin, target) {
  var template = complex.createTransformer(target);
  var originStats = analyse(origin);
  var targetStats = analyse(target);
  invariant(originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
  return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
};

var mixNumber = function (from, to) {
  return function (p) {
    return mix(from, to, p);
  };
};

function detectMixerFactory(v) {
  if (typeof v === 'number') {
    return mixNumber;
  } else if (typeof v === 'string') {
    if (color.test(v)) {
      return mixColor;
    } else {
      return mixComplex;
    }
  } else if (Array.isArray(v)) {
    return mixArray;
  } else if (typeof v === 'object') {
    return mixObject;
  }
}

function createMixers(output, ease, customMixer) {
  var mixers = [];
  var mixerFactory = customMixer || detectMixerFactory(output[0]);
  var numMixers = output.length - 1;

  for (var i = 0; i < numMixers; i++) {
    var mixer = mixerFactory(output[i], output[i + 1]);

    if (ease) {
      var easingFunction = Array.isArray(ease) ? ease[i] : ease;
      mixer = pipe(easingFunction, mixer);
    }

    mixers.push(mixer);
  }

  return mixers;
}

function fastInterpolate(_a, _b) {
  var from = _a[0],
      to = _a[1];
  var mixer = _b[0];
  return function (v) {
    return mixer(progress(from, to, v));
  };
}

function slowInterpolate(input, mixers) {
  var inputLength = input.length;
  var lastInputIndex = inputLength - 1;
  return function (v) {
    var mixerIndex = 0;
    var foundMixerIndex = false;

    if (v <= input[0]) {
      foundMixerIndex = true;
    } else if (v >= input[lastInputIndex]) {
      mixerIndex = lastInputIndex - 1;
      foundMixerIndex = true;
    }

    if (!foundMixerIndex) {
      var i = 1;

      for (; i < inputLength; i++) {
        if (input[i] > v || i === lastInputIndex) {
          break;
        }
      }

      mixerIndex = i - 1;
    }

    var progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v);
    return mixers[mixerIndex](progressInRange);
  };
}

function interpolate(input, output, _a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.clamp,
      clamp = _c === void 0 ? true : _c,
      ease = _b.ease,
      mixer = _b.mixer;

  var inputLength = input.length;
  invariant(inputLength === output.length, 'Both input and output ranges must be the same length');
  invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');

  if (input[0] > input[inputLength - 1]) {
    input = [].concat(input);
    output = [].concat(output);
    input.reverse();
    output.reverse();
  }

  var mixers = createMixers(output, ease, mixer);
  var interpolator = inputLength === 2 ? fastInterpolate(input, mixers) : slowInterpolate(input, mixers);
  return clamp ? pipe(clamp$1$1(input[0], input[inputLength - 1]), interpolator) : interpolator;
}

var toDecimal = function (num, precision) {
  if (precision === void 0) {
    precision = 2;
  }

  precision = Math.pow(10, precision);
  return Math.round(num * precision) / precision;
};

var smoothFrame = function (prevValue, nextValue, duration, smoothing) {
  if (smoothing === void 0) {
    smoothing = 0;
  }

  return toDecimal(prevValue + duration * (nextValue - prevValue) / Math.max(smoothing, duration));
};

var smooth = function (strength) {
  if (strength === void 0) {
    strength = 50;
  }

  var previousValue = 0;
  var lastUpdated = 0;
  return function (v) {
    var currentFramestamp = getFrameData().timestamp;
    var timeDelta = currentFramestamp !== lastUpdated ? currentFramestamp - lastUpdated : 0;
    var newValue = timeDelta ? smoothFrame(previousValue, v, timeDelta, strength) : previousValue;
    lastUpdated = currentFramestamp;
    previousValue = newValue;
    return newValue;
  };
};

var snap = function (points) {
  if (typeof points === 'number') {
    return function (v) {
      return Math.round(v / points) * points;
    };
  } else {
    var i_1 = 0;
    var numPoints_1 = points.length;
    return function (v) {
      var lastDistance = Math.abs(points[0] - v);

      for (i_1 = 1; i_1 < numPoints_1; i_1++) {
        var point = points[i_1];
        var distance = Math.abs(point - v);
        if (distance === 0) return point;
        if (distance > lastDistance) return points[i_1 - 1];
        if (i_1 === numPoints_1 - 1) return point;
        lastDistance = distance;
      }
    };
  }
};

var identity = function (v) {
  return v;
};

var springForce = function (alterDisplacement) {
  if (alterDisplacement === void 0) {
    alterDisplacement = identity;
  }

  return curryRange(function (constant, origin, v) {
    var displacement = origin - v;
    var springModifiedDisplacement = -(0 - constant + 1) * (0 - alterDisplacement(Math.abs(displacement)));
    return displacement <= 0 ? origin + springModifiedDisplacement : origin - springModifiedDisplacement;
  });
};

var springForceLinear = springForce();
var springForceExpo = springForce(Math.sqrt);

var velocityPerFrame = function (xps, frameDuration) {
  return isNum(xps) ? xps / (1000 / frameDuration) : 0;
};

var velocityPerSecond = function (velocity, frameDuration) {
  return frameDuration ? velocity * (1000 / frameDuration) : 0;
};

var wrap = function (min, max, v) {
  var rangeSize = max - min;
  return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};

var wrap$1 = curryRange(wrap);
var clampProgress = clamp$1$1(0, 1);

var createStyler = function (_a) {
  var onRead = _a.onRead,
      onRender = _a.onRender,
      _b = _a.uncachedValues,
      uncachedValues = _b === void 0 ? new Set() : _b,
      _c = _a.useCache,
      useCache = _c === void 0 ? true : _c;
  return function (_a) {
    if (_a === void 0) {
      _a = {};
    }

    var props = __rest(_a, []);

    var state = {};
    var changedValues = [];
    var hasChanged = false;

    function setValue(key, value) {
      if (key.startsWith('--')) {
        props.hasCSSVariable = true;
      }

      var currentValue = state[key];
      state[key] = value;
      if (state[key] === currentValue) return;

      if (changedValues.indexOf(key) === -1) {
        changedValues.push(key);
      }

      if (!hasChanged) {
        hasChanged = true;
        sync.render(styler.render);
      }
    }

    var styler = {
      get: function (key, forceRead) {
        if (forceRead === void 0) {
          forceRead = false;
        }

        var useCached = !forceRead && useCache && !uncachedValues.has(key) && state[key] !== undefined;
        return useCached ? state[key] : onRead(key, props);
      },
      set: function (values, value) {
        if (typeof values === 'string') {
          setValue(values, value);
        } else {
          for (var key in values) {
            setValue(key, values[key]);
          }
        }

        return this;
      },
      render: function (forceRender) {
        if (forceRender === void 0) {
          forceRender = false;
        }

        if (hasChanged || forceRender === true) {
          onRender(state, props, changedValues);
          hasChanged = false;
          changedValues.length = 0;
        }

        return this;
      }
    };
    return styler;
  };
};

var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = '$1-$2';

var camelToDash = function (str) {
  return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};

var camelCache = /*#__PURE__*/new Map();
var dashCache = /*#__PURE__*/new Map();
var prefixes = ['Webkit', 'Moz', 'O', 'ms', ''];
var numPrefixes = prefixes.length;
var isBrowser = typeof document !== 'undefined';
var testElement;

var setDashPrefix = function (key, prefixed) {
  return dashCache.set(key, camelToDash(prefixed));
};

var testPrefix = function (key) {
  testElement = testElement || document.createElement('div');

  for (var i = 0; i < numPrefixes; i++) {
    var prefix = prefixes[i];
    var noPrefix = prefix === '';
    var prefixedPropertyName = noPrefix ? key : prefix + key.charAt(0).toUpperCase() + key.slice(1);

    if (prefixedPropertyName in testElement.style || noPrefix) {
      if (noPrefix && key === 'clipPath' && dashCache.has(key)) {
        return;
      }

      camelCache.set(key, prefixedPropertyName);
      setDashPrefix(key, "" + (noPrefix ? '' : '-') + camelToDash(prefixedPropertyName));
    }
  }
};

var setServerProperty = function (key) {
  return setDashPrefix(key, key);
};

var prefixer = function (key, asDashCase) {
  if (asDashCase === void 0) {
    asDashCase = false;
  }

  var cache = asDashCase ? dashCache : camelCache;

  if (!cache.has(key)) {
    isBrowser ? testPrefix(key) : setServerProperty(key);
  }

  return cache.get(key) || key;
};

var axes = ['', 'X', 'Y', 'Z'];
var order = ['translate', 'scale', 'rotate', 'skew', 'transformPerspective'];
var transformProps = /*#__PURE__*/order.reduce(function (acc, key) {
  return axes.reduce(function (axesAcc, axesKey) {
    axesAcc.push(key + axesKey);
    return axesAcc;
  }, acc);
}, ['x', 'y', 'z']);
var transformPropDictionary = /*#__PURE__*/transformProps.reduce(function (dict, key) {
  dict[key] = true;
  return dict;
}, {});

function isTransformProp(key) {
  return transformPropDictionary[key] === true;
}

function sortTransformProps(a, b) {
  return transformProps.indexOf(a) - transformProps.indexOf(b);
}

var transformOriginProps = /*#__PURE__*/new Set(['originX', 'originY', 'originZ']);

function isTransformOriginProp(key) {
  return transformOriginProps.has(key);
}

var int = /*#__PURE__*/__assign( /*#__PURE__*/__assign({}, number), {
  transform: Math.round
});

var valueTypes = {
  color: color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale: scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  zIndex: int,
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};

var getValueType = function (key) {
  return valueTypes[key];
};

var getValueAsType = function (value, type) {
  return type && typeof value === 'number' ? type.transform(value) : value;
};

var SCROLL_LEFT = 'scrollLeft';
var SCROLL_TOP = 'scrollTop';
var scrollKeys = /*#__PURE__*/new Set([SCROLL_LEFT, SCROLL_TOP]);
var blacklist = /*#__PURE__*/new Set([SCROLL_LEFT, SCROLL_TOP, 'transform']);
var translateAlias = {
  x: 'translateX',
  y: 'translateY',
  z: 'translateZ'
};

function isCustomTemplate(v) {
  return typeof v === 'function';
}

function buildTransform(state, transform, transformKeys, transformIsDefault, enableHardwareAcceleration, allowTransformNone) {
  if (allowTransformNone === void 0) {
    allowTransformNone = true;
  }

  var transformString = '';
  var transformHasZ = false;
  transformKeys.sort(sortTransformProps);
  var numTransformKeys = transformKeys.length;

  for (var i = 0; i < numTransformKeys; i++) {
    var key = transformKeys[i];
    transformString += (translateAlias[key] || key) + "(" + transform[key] + ") ";
    transformHasZ = key === 'z' ? true : transformHasZ;
  }

  if (!transformHasZ && enableHardwareAcceleration) {
    transformString += 'translateZ(0)';
  } else {
    transformString = transformString.trim();
  }

  if (isCustomTemplate(state.transform)) {
    transformString = state.transform(transform, transformIsDefault ? '' : transformString);
  } else if (allowTransformNone && transformIsDefault) {
    transformString = 'none';
  }

  return transformString;
}

function buildStyleProperty(state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, isDashCase, allowTransformNone) {
  if (enableHardwareAcceleration === void 0) {
    enableHardwareAcceleration = true;
  }

  if (styles === void 0) {
    styles = {};
  }

  if (transform === void 0) {
    transform = {};
  }

  if (transformOrigin === void 0) {
    transformOrigin = {};
  }

  if (transformKeys === void 0) {
    transformKeys = [];
  }

  if (isDashCase === void 0) {
    isDashCase = false;
  }

  if (allowTransformNone === void 0) {
    allowTransformNone = true;
  }

  var transformIsDefault = true;
  var hasTransform = false;
  var hasTransformOrigin = false;

  for (var key in state) {
    var value = state[key];
    var valueType = getValueType(key);
    var valueAsType = getValueAsType(value, valueType);

    if (isTransformProp(key)) {
      hasTransform = true;
      transform[key] = valueAsType;
      transformKeys.push(key);

      if (transformIsDefault) {
        if (valueType.default && value !== valueType.default || !valueType.default && value !== 0) {
          transformIsDefault = false;
        }
      }
    } else if (isTransformOriginProp(key)) {
      transformOrigin[key] = valueAsType;
      hasTransformOrigin = true;
    } else if (!blacklist.has(key) || !isCustomTemplate(valueAsType)) {
      styles[prefixer(key, isDashCase)] = valueAsType;
    }
  }

  if (hasTransform || typeof state.transform === 'function') {
    styles.transform = buildTransform(state, transform, transformKeys, transformIsDefault, enableHardwareAcceleration, allowTransformNone);
  }

  if (hasTransformOrigin) {
    styles.transformOrigin = (transformOrigin.originX || '50%') + " " + (transformOrigin.originY || '50%') + " " + (transformOrigin.originZ || 0);
  }

  return styles;
}

function createStyleBuilder(_a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.enableHardwareAcceleration,
      enableHardwareAcceleration = _c === void 0 ? true : _c,
      _d = _b.isDashCase,
      isDashCase = _d === void 0 ? true : _d,
      _e = _b.allowTransformNone,
      allowTransformNone = _e === void 0 ? true : _e;

  var styles = {};
  var transform = {};
  var transformOrigin = {};
  var transformKeys = [];
  return function (state) {
    transformKeys.length = 0;
    buildStyleProperty(state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, isDashCase, allowTransformNone);
    return styles;
  };
}

function onRead(key, options) {
  var element = options.element,
      preparseOutput = options.preparseOutput;
  var defaultValueType = getValueType(key);

  if (isTransformProp(key)) {
    return defaultValueType ? defaultValueType.default || 0 : 0;
  } else if (scrollKeys.has(key)) {
    return element[key];
  } else {
    var domValue = window.getComputedStyle(element, null).getPropertyValue(prefixer(key, true)) || 0;
    return preparseOutput && defaultValueType && defaultValueType.test(domValue) && defaultValueType.parse ? defaultValueType.parse(domValue) : domValue;
  }
}

function onRender(state, _a, changedValues) {
  var element = _a.element,
      buildStyles = _a.buildStyles,
      hasCSSVariable = _a.hasCSSVariable;
  Object.assign(element.style, buildStyles(state));

  if (hasCSSVariable) {
    var numChangedValues = changedValues.length;

    for (var i = 0; i < numChangedValues; i++) {
      var key = changedValues[i];

      if (key.startsWith('--')) {
        element.style.setProperty(key, state[key]);
      }
    }
  }

  if (changedValues.indexOf(SCROLL_LEFT) !== -1) {
    element[SCROLL_LEFT] = state[SCROLL_LEFT];
  }

  if (changedValues.indexOf(SCROLL_TOP) !== -1) {
    element[SCROLL_TOP] = state[SCROLL_TOP];
  }
}

var cssStyler = /*#__PURE__*/createStyler({
  onRead: onRead,
  onRender: onRender,
  uncachedValues: scrollKeys
});

function createCssStyler(element, _a) {
  if (_a === void 0) {
    _a = {};
  }

  var enableHardwareAcceleration = _a.enableHardwareAcceleration,
      allowTransformNone = _a.allowTransformNone,
      props = __rest(_a, ["enableHardwareAcceleration", "allowTransformNone"]);

  return cssStyler(__assign({
    element: element,
    buildStyles: createStyleBuilder({
      enableHardwareAcceleration: enableHardwareAcceleration,
      allowTransformNone: allowTransformNone
    }),
    preparseOutput: true
  }, props));
}

var camelCaseAttributes = /*#__PURE__*/new Set(['baseFrequency', 'diffuseConstant', 'kernelMatrix', 'kernelUnitLength', 'keySplines', 'keyTimes', 'limitingConeAngle', 'markerHeight', 'markerWidth', 'numOctaves', 'targetX', 'targetY', 'surfaceScale', 'specularConstant', 'specularExponent', 'stdDeviation', 'tableValues']);
var defaultOrigin = 0.5;

var svgAttrsTemplate = function () {
  return {
    style: {}
  };
};

var progressToPixels = function (progress, length) {
  return px.transform(progress * length);
};

var unmeasured = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};

function calcOrigin(origin, offset, size) {
  return typeof origin === 'string' ? origin : px.transform(offset + size * origin);
}

function calculateSVGTransformOrigin(dimensions, originX, originY) {
  return calcOrigin(originX, dimensions.x, dimensions.width) + " " + calcOrigin(originY, dimensions.y, dimensions.height);
}

var svgStyleConfig = {
  enableHardwareAcceleration: false,
  isDashCase: false
};

function buildSVGAttrs(_a, dimensions, totalPathLength, cssBuilder, attrs, isDashCase) {
  if (dimensions === void 0) {
    dimensions = unmeasured;
  }

  if (cssBuilder === void 0) {
    cssBuilder = createStyleBuilder(svgStyleConfig);
  }

  if (attrs === void 0) {
    attrs = svgAttrsTemplate();
  }

  if (isDashCase === void 0) {
    isDashCase = true;
  }

  var attrX = _a.attrX,
      attrY = _a.attrY,
      originX = _a.originX,
      originY = _a.originY,
      pathLength = _a.pathLength,
      _b = _a.pathSpacing,
      pathSpacing = _b === void 0 ? 1 : _b,
      _c = _a.pathOffset,
      pathOffset = _c === void 0 ? 0 : _c,
      state = __rest(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);

  var style = cssBuilder(state);

  for (var key in style) {
    if (key === 'transform') {
      attrs.style.transform = style[key];
    } else {
      var attrKey = isDashCase && !camelCaseAttributes.has(key) ? camelToDash(key) : key;
      attrs[attrKey] = style[key];
    }
  }

  if (originX !== undefined || originY !== undefined || style.transform) {
    attrs.style.transformOrigin = calculateSVGTransformOrigin(dimensions, originX !== undefined ? originX : defaultOrigin, originY !== undefined ? originY : defaultOrigin);
  }

  if (attrX !== undefined) attrs.x = attrX;
  if (attrY !== undefined) attrs.y = attrY;

  if (totalPathLength !== undefined && pathLength !== undefined) {
    attrs[isDashCase ? 'stroke-dashoffset' : 'strokeDashoffset'] = progressToPixels(-pathOffset, totalPathLength);
    attrs[isDashCase ? 'stroke-dasharray' : 'strokeDasharray'] = progressToPixels(pathLength, totalPathLength) + " " + progressToPixels(pathSpacing, totalPathLength);
  }

  return attrs;
}

function createAttrBuilder(dimensions, totalPathLength, isDashCase) {
  if (isDashCase === void 0) {
    isDashCase = true;
  }

  var attrs = svgAttrsTemplate();
  var cssBuilder = createStyleBuilder(svgStyleConfig);
  return function (state) {
    return buildSVGAttrs(state, dimensions, totalPathLength, cssBuilder, attrs, isDashCase);
  };
}

var getDimensions = function (element) {
  return typeof element.getBBox === 'function' ? element.getBBox() : element.getBoundingClientRect();
};

var getSVGElementDimensions = function (element) {
  try {
    return getDimensions(element);
  } catch (e) {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
};

var isPath = function (element) {
  return element.tagName === 'path';
};

var svgStyler = /*#__PURE__*/createStyler({
  onRead: function (key, _a) {
    var element = _a.element;
    key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;

    if (!isTransformProp(key)) {
      return element.getAttribute(key);
    } else {
      var valueType = getValueType(key);
      return valueType ? valueType.default || 0 : 0;
    }
  },
  onRender: function (state, _a) {
    var element = _a.element,
        buildAttrs = _a.buildAttrs;
    var attrs = buildAttrs(state);

    for (var key in attrs) {
      if (key === 'style') {
        Object.assign(element.style, attrs.style);
      } else {
        element.setAttribute(key, attrs[key]);
      }
    }
  }
});

var svg = function (element) {
  var dimensions = getSVGElementDimensions(element);
  var pathLength = isPath(element) && element.getTotalLength ? element.getTotalLength() : undefined;
  return svgStyler({
    element: element,
    buildAttrs: createAttrBuilder(dimensions, pathLength)
  });
};

var viewport = /*#__PURE__*/createStyler({
  useCache: false,
  onRead: function (key) {
    return key === 'scrollTop' ? window.pageYOffset : window.pageXOffset;
  },
  onRender: function (_a) {
    var _b = _a.scrollTop,
        scrollTop = _b === void 0 ? 0 : _b,
        _c = _a.scrollLeft,
        scrollLeft = _c === void 0 ? 0 : _c;
    return window.scrollTo(scrollLeft, scrollTop);
  }
});
var cache = /*#__PURE__*/new WeakMap();

var isHTMLElement = function (node) {
  return node instanceof HTMLElement || typeof node.click === 'function';
};

var isSVGElement = function (node) {
  return node instanceof SVGElement || 'ownerSVGElement' in node;
};

var createDOMStyler = function (node, props) {
  var styler;

  if (node === window) {
    styler = viewport(node);
  } else if (isHTMLElement(node)) {
    styler = createCssStyler(node, props);
  } else if (isSVGElement(node)) {
    styler = svg(node);
  }

  invariant(styler !== undefined, 'No valid node provided. Node must be HTMLElement, SVGElement or window.');
  cache.set(node, styler);
  return styler;
};

var getStyler = function (node, props) {
  return cache.has(node) ? cache.get(node) : createDOMStyler(node, props);
};

function index(nodeOrSelector, props) {
  var node = typeof nodeOrSelector === 'string' ? document.querySelector(nodeOrSelector) : nodeOrSelector;
  return getStyler(node, props);
}

var Chainable = /*#__PURE__*/function () {
  function Chainable(props) {
    if (props === void 0) {
      props = {};
    }

    this.props = props;
  }

  Chainable.prototype.applyMiddleware = function (middleware) {
    return this.create(__assign(__assign({}, this.props), {
      middleware: this.props.middleware ? __spreadArrays([middleware], this.props.middleware) : [middleware]
    }));
  };

  Chainable.prototype.pipe = function () {
    var funcs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      funcs[_i] = arguments[_i];
    }

    var pipedUpdate = funcs.length === 1 ? funcs[0] : pipe.apply(void 0, funcs);
    return this.applyMiddleware(function (update) {
      return function (v) {
        return update(pipedUpdate(v));
      };
    });
  };

  Chainable.prototype.while = function (predicate) {
    return this.applyMiddleware(function (update, complete) {
      return function (v) {
        return predicate(v) ? update(v) : complete();
      };
    });
  };

  Chainable.prototype.filter = function (predicate) {
    return this.applyMiddleware(function (update) {
      return function (v) {
        return predicate(v) && update(v);
      };
    });
  };

  return Chainable;
}();

var Observer = /*#__PURE__*/function () {
  function Observer(_a, observer) {
    var _this = this;

    var middleware = _a.middleware,
        onComplete = _a.onComplete;
    this.isActive = true;

    this.update = function (v) {
      if (_this.observer.update) _this.updateObserver(v);
    };

    this.complete = function () {
      if (_this.observer.complete && _this.isActive) _this.observer.complete();
      if (_this.onComplete) _this.onComplete();
      _this.isActive = false;
    };

    this.error = function (err) {
      if (_this.observer.error && _this.isActive) _this.observer.error(err);
      _this.isActive = false;
    };

    this.observer = observer;

    this.updateObserver = function (v) {
      return observer.update(v);
    };

    this.onComplete = onComplete;

    if (observer.update && middleware && middleware.length) {
      middleware.forEach(function (m) {
        return _this.updateObserver = m(_this.updateObserver, _this.complete);
      });
    }
  }

  return Observer;
}();

var createObserver = function (observerCandidate, _a, onComplete) {
  var middleware = _a.middleware;

  if (typeof observerCandidate === 'function') {
    return new Observer({
      middleware: middleware,
      onComplete: onComplete
    }, {
      update: observerCandidate
    });
  } else {
    return new Observer({
      middleware: middleware,
      onComplete: onComplete
    }, observerCandidate);
  }
};

var Action = /*#__PURE__*/function (_super) {
  __extends(Action, _super);

  function Action() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Action.prototype.create = function (props) {
    return new Action(props);
  };

  Action.prototype.start = function (observerCandidate) {
    if (observerCandidate === void 0) {
      observerCandidate = {};
    }

    var isComplete = false;
    var subscription = {
      stop: function () {
        return undefined;
      }
    };

    var _a = this.props,
        init = _a.init,
        observerProps = __rest(_a, ["init"]);

    var observer = createObserver(observerCandidate, observerProps, function () {
      isComplete = true;
      subscription.stop();
    });
    var api = init(observer);
    subscription = api ? __assign(__assign({}, subscription), api) : subscription;

    if (observerCandidate.registerParent) {
      observerCandidate.registerParent(subscription);
    }

    if (isComplete) subscription.stop();
    return subscription;
  };

  return Action;
}(Chainable);

var action = function (init) {
  return new Action({
    init: init
  });
};

var BaseMulticast = /*#__PURE__*/function (_super) {
  __extends(BaseMulticast, _super);

  function BaseMulticast() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.subscribers = [];
    return _this;
  }

  BaseMulticast.prototype.complete = function () {
    this.subscribers.forEach(function (subscriber) {
      return subscriber.complete();
    });
  };

  BaseMulticast.prototype.error = function (err) {
    this.subscribers.forEach(function (subscriber) {
      return subscriber.error(err);
    });
  };

  BaseMulticast.prototype.update = function (v) {
    for (var i = 0; i < this.subscribers.length; i++) {
      this.subscribers[i].update(v);
    }
  };

  BaseMulticast.prototype.subscribe = function (observerCandidate) {
    var _this = this;

    var observer = createObserver(observerCandidate, this.props);
    this.subscribers.push(observer);
    var subscription = {
      unsubscribe: function () {
        var index = _this.subscribers.indexOf(observer);

        if (index !== -1) _this.subscribers.splice(index, 1);
      }
    };
    return subscription;
  };

  BaseMulticast.prototype.stop = function () {
    if (this.parent) this.parent.stop();
  };

  BaseMulticast.prototype.registerParent = function (subscription) {
    this.stop();
    this.parent = subscription;
  };

  return BaseMulticast;
}(Chainable);

var stepProgress = function (steps, progress) {
  var segment = 1 / (steps - 1);
  var subsegment = 1 / (2 * (steps - 1));
  var percentProgressOfTarget = Math.min(progress, 1);
  var subsegmentProgressOfTarget = percentProgressOfTarget / subsegment;
  var segmentProgressOfTarget = Math.floor((subsegmentProgressOfTarget + 1) / 2);
  return segmentProgressOfTarget * segment;
};

var isValueList = function (v) {
  return Array.isArray(v);
};

var isSingleValue = function (v) {
  var typeOfV = typeof v;
  return typeOfV === 'string' || typeOfV === 'number';
};

var ValueReaction = /*#__PURE__*/function (_super) {
  __extends(ValueReaction, _super);

  function ValueReaction(props) {
    var _this = _super.call(this, props) || this;

    _this.scheduleVelocityCheck = function () {
      return sync.postRender(_this.velocityCheck);
    };

    _this.velocityCheck = function (_a) {
      var timestamp = _a.timestamp;

      if (timestamp !== _this.lastUpdated) {
        _this.prev = _this.current;
      }
    };

    _this.prev = _this.current = props.value || 0;

    if (isSingleValue(_this.current)) {
      _this.updateCurrent = function (v) {
        return _this.current = v;
      };

      _this.getVelocityOfCurrent = function () {
        return _this.getSingleVelocity(_this.current, _this.prev);
      };
    } else if (isValueList(_this.current)) {
      _this.updateCurrent = function (v) {
        return _this.current = __spreadArrays(v);
      };

      _this.getVelocityOfCurrent = function () {
        return _this.getListVelocity();
      };
    } else {
      _this.updateCurrent = function (v) {
        _this.current = {};

        for (var key in v) {
          if (v.hasOwnProperty(key)) {
            _this.current[key] = v[key];
          }
        }
      };

      _this.getVelocityOfCurrent = function () {
        return _this.getMapVelocity();
      };
    }

    if (props.initialSubscription) _this.subscribe(props.initialSubscription);
    return _this;
  }

  ValueReaction.prototype.create = function (props) {
    return new ValueReaction(props);
  };

  ValueReaction.prototype.get = function () {
    return this.current;
  };

  ValueReaction.prototype.getVelocity = function () {
    return this.getVelocityOfCurrent();
  };

  ValueReaction.prototype.update = function (v) {
    _super.prototype.update.call(this, v);

    this.prev = this.current;
    this.updateCurrent(v);

    var _a = getFrameData(),
        delta = _a.delta,
        timestamp = _a.timestamp;

    this.timeDelta = delta;
    this.lastUpdated = timestamp;
    sync.postRender(this.scheduleVelocityCheck);
  };

  ValueReaction.prototype.subscribe = function (observerCandidate) {
    var sub = _super.prototype.subscribe.call(this, observerCandidate);

    this.subscribers[this.subscribers.length - 1].update(this.current);
    return sub;
  };

  ValueReaction.prototype.getSingleVelocity = function (current, prev) {
    return typeof current === 'number' && typeof prev === 'number' ? velocityPerSecond(current - prev, this.timeDelta) : velocityPerSecond(parseFloat(current) - parseFloat(prev), this.timeDelta) || 0;
  };

  ValueReaction.prototype.getListVelocity = function () {
    var _this = this;

    return this.current.map(function (c, i) {
      return _this.getSingleVelocity(c, _this.prev[i]);
    });
  };

  ValueReaction.prototype.getMapVelocity = function () {
    var velocity = {};

    for (var key in this.current) {
      if (this.current.hasOwnProperty(key)) {
        velocity[key] = this.getSingleVelocity(this.current[key], this.prev[key]);
      }
    }

    return velocity;
  };

  return ValueReaction;
}(BaseMulticast);

var value = function (value, initialSubscription) {
  return new ValueReaction({
    value: value,
    initialSubscription: initialSubscription
  });
};

var multi = function (_a) {
  var getCount = _a.getCount,
      getFirst = _a.getFirst,
      getOutput = _a.getOutput,
      mapApi = _a.mapApi,
      setProp = _a.setProp,
      startActions = _a.startActions;
  return function (actions) {
    return action(function (_a) {
      var update = _a.update,
          complete = _a.complete,
          error = _a.error;
      var numActions = getCount(actions);
      var output = getOutput();

      var updateOutput = function () {
        return update(output);
      };

      var numCompletedActions = 0;
      var subs = startActions(actions, function (a, name) {
        var hasCompleted = false;
        return a.start({
          complete: function () {
            if (!hasCompleted) {
              hasCompleted = true;
              numCompletedActions++;
              if (numCompletedActions === numActions) sync.update(complete);
            }
          },
          error: error,
          update: function (v) {
            setProp(output, name, v);
            sync.update(updateOutput, false, true);
          }
        });
      });
      return Object.keys(getFirst(subs)).reduce(function (api, methodName) {
        api[methodName] = mapApi(subs, methodName);
        return api;
      }, {});
    });
  };
};

var composite = /*#__PURE__*/multi({
  getOutput: function () {
    return {};
  },
  getCount: function (subs) {
    return Object.keys(subs).length;
  },
  getFirst: function (subs) {
    return subs[Object.keys(subs)[0]];
  },
  mapApi: function (subs, methodName) {
    return function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return Object.keys(subs).reduce(function (output, propKey) {
        var _a;

        if (subs[propKey][methodName]) {
          args[0] && args[0][propKey] !== undefined ? output[propKey] = subs[propKey][methodName](args[0][propKey]) : output[propKey] = (_a = subs[propKey])[methodName].apply(_a, args);
        }

        return output;
      }, {});
    };
  },
  setProp: function (output, name, v) {
    return output[name] = v;
  },
  startActions: function (actions, starter) {
    return Object.keys(actions).reduce(function (subs, key) {
      subs[key] = starter(actions[key], key);
      return subs;
    }, {});
  }
});
var parallel = /*#__PURE__*/multi({
  getOutput: function () {
    return [];
  },
  getCount: function (subs) {
    return subs.length;
  },
  getFirst: function (subs) {
    return subs[0];
  },
  mapApi: function (subs, methodName) {
    return function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return subs.map(function (sub, i) {
        if (sub[methodName]) {
          return Array.isArray(args[0]) ? sub[methodName](args[0][i]) : sub[methodName].apply(sub, args);
        }
      });
    };
  },
  setProp: function (output, name, v) {
    return output[name] = v;
  },
  startActions: function (actions, starter) {
    return actions.map(function (action, i) {
      return starter(action, i);
    });
  }
});

var parallel$1 = function () {
  var actions = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    actions[_i] = arguments[_i];
  }

  return parallel(actions);
};

var createVectorTests = function (typeTests) {
  var testNames = Object.keys(typeTests);

  var isVectorProp = function (prop, key) {
    return prop !== undefined && !typeTests[key](prop);
  };

  var getVectorKeys = function (props) {
    return testNames.reduce(function (vectorKeys, key) {
      if (isVectorProp(props[key], key)) vectorKeys.push(key);
      return vectorKeys;
    }, []);
  };

  var testVectorProps = function (props) {
    return props && testNames.some(function (key) {
      return isVectorProp(props[key], key);
    });
  };

  return {
    getVectorKeys: getVectorKeys,
    testVectorProps: testVectorProps
  };
};

var unitTypes = [px, percent, degrees, vh, vw];

var findUnitType = function (prop) {
  return unitTypes.find(function (type) {
    return type.test(prop);
  });
};

var isUnitProp = function (prop) {
  return Boolean(findUnitType(prop));
};

var createAction = function (action, props) {
  return action(props);
};

var reduceArrayValue = function (i) {
  return function (props, key) {
    props[key] = props[key][i];
    return props;
  };
};

var createArrayAction = function (action, props, vectorKeys) {
  var firstVectorKey = vectorKeys[0];
  var actionList = props[firstVectorKey].map(function (v, i) {
    var childActionProps = vectorKeys.reduce(reduceArrayValue(i), __assign({}, props));
    return getActionCreator(v)(action, childActionProps);
  });
  return parallel$1.apply(void 0, actionList);
};

var reduceObjectValue = function (key) {
  return function (props, propKey) {
    props[propKey] = props[propKey][key];
    return props;
  };
};

var createObjectAction = function (action, props, vectorKeys) {
  var firstVectorKey = vectorKeys[0];
  var actionMap = Object.keys(props[firstVectorKey]).reduce(function (map, key) {
    var childActionProps = vectorKeys.reduce(reduceObjectValue(key), __assign({}, props));
    map[key] = getActionCreator(props[firstVectorKey][key])(action, childActionProps);
    return map;
  }, {});
  return composite(actionMap);
};

var createUnitAction = function (action, _a) {
  var from = _a.from,
      to = _a.to,
      props = __rest(_a, ["from", "to"]);

  var unitType = findUnitType(from) || findUnitType(to);
  var transform = unitType.transform,
      parse = unitType.parse;
  return action(__assign(__assign({}, props), {
    from: typeof from === 'string' ? parse(from) : from,
    to: typeof to === 'string' ? parse(to) : to
  })).pipe(transform);
};

var createMixerAction = function (mixer) {
  return function (action, _a) {
    var from = _a.from,
        to = _a.to,
        props = __rest(_a, ["from", "to"]);

    return action(__assign(__assign({}, props), {
      from: 0,
      to: 1
    })).pipe(mixer(from, to));
  };
};

var createColorAction = /*#__PURE__*/createMixerAction(mixColor);
var createComplexAction = /*#__PURE__*/createMixerAction(mixComplex);

var createVectorAction = function (action, typeTests) {
  var _a = createVectorTests(typeTests),
      testVectorProps = _a.testVectorProps,
      getVectorKeys = _a.getVectorKeys;

  var vectorAction = function (props) {
    var isVector = testVectorProps(props);
    if (!isVector) return action(props);
    var vectorKeys = getVectorKeys(props);
    var testKey = vectorKeys[0];
    var testProp = props[testKey];
    return getActionCreator(testProp)(action, props, vectorKeys);
  };

  return vectorAction;
};

var getActionCreator = function (prop) {
  if (typeof prop === 'number') {
    return createAction;
  } else if (Array.isArray(prop)) {
    return createArrayAction;
  } else if (isUnitProp(prop)) {
    return createUnitAction;
  } else if (color.test(prop)) {
    return createColorAction;
  } else if (complex.test(prop)) {
    return createComplexAction;
  } else if (typeof prop === 'object') {
    return createObjectAction;
  } else {
    return createAction;
  }
};

var decay = function (props) {
  if (props === void 0) {
    props = {};
  }

  return action(function (_a) {
    var complete = _a.complete,
        update = _a.update;
    var _b = props.velocity,
        velocity = _b === void 0 ? 0 : _b,
        _c = props.from,
        from = _c === void 0 ? 0 : _c,
        _d = props.power,
        power = _d === void 0 ? 0.8 : _d,
        _e = props.timeConstant,
        timeConstant = _e === void 0 ? 350 : _e,
        _f = props.restDelta,
        restDelta = _f === void 0 ? 0.5 : _f,
        modifyTarget = props.modifyTarget;
    var elapsed = 0;
    var amplitude = power * velocity;
    var idealTarget = from + amplitude;
    var target = typeof modifyTarget === 'undefined' ? idealTarget : modifyTarget(idealTarget);
    if (target !== idealTarget) amplitude = target - from;
    var process = sync.update(function (_a) {
      var frameDelta = _a.delta;
      elapsed += frameDelta;
      var delta = -amplitude * Math.exp(-elapsed / timeConstant);
      var isMoving = delta > restDelta || delta < -restDelta;
      var current = isMoving ? target + delta : target;
      update(current);

      if (!isMoving) {
        cancelSync.update(process);
        complete();
      }
    }, true);
    return {
      stop: function () {
        return cancelSync.update(process);
      }
    };
  });
};

var vectorDecay = /*#__PURE__*/createVectorAction(decay, {
  from: number.test,
  modifyTarget: function (func) {
    return typeof func === 'function';
  },
  velocity: number.test
});

var spring = function (props) {
  if (props === void 0) {
    props = {};
  }

  return action(function (_a) {
    var update = _a.update,
        complete = _a.complete;
    var _b = props.velocity,
        velocity = _b === void 0 ? 0.0 : _b;
    var _c = props.from,
        from = _c === void 0 ? 0.0 : _c,
        _d = props.to,
        to = _d === void 0 ? 0.0 : _d,
        _e = props.stiffness,
        stiffness = _e === void 0 ? 100 : _e,
        _f = props.damping,
        damping = _f === void 0 ? 10 : _f,
        _g = props.mass,
        mass = _g === void 0 ? 1.0 : _g,
        _h = props.restSpeed,
        restSpeed = _h === void 0 ? 0.01 : _h,
        _j = props.restDelta,
        restDelta = _j === void 0 ? 0.01 : _j;
    var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
    var t = 0;
    var delta = to - from;
    var position = from;
    var prevPosition = position;
    var process = sync.update(function (_a) {
      var timeDelta = _a.delta;
      t += timeDelta;
      var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
      var angularFreq = Math.sqrt(stiffness / mass) / 1000;
      prevPosition = position;

      if (dampingRatio < 1) {
        var envelope = Math.exp(-dampingRatio * angularFreq * t);
        var expoDecay = angularFreq * Math.sqrt(1.0 - dampingRatio * dampingRatio);
        position = to - envelope * ((initialVelocity + dampingRatio * angularFreq * delta) / expoDecay * Math.sin(expoDecay * t) + delta * Math.cos(expoDecay * t));
      } else {
        var envelope = Math.exp(-angularFreq * t);
        position = to - envelope * (delta + (initialVelocity + angularFreq * delta) * t);
      }

      velocity = velocityPerSecond(position - prevPosition, timeDelta);
      var isBelowVelocityThreshold = Math.abs(velocity) <= restSpeed;
      var isBelowDisplacementThreshold = Math.abs(to - position) <= restDelta;

      if (isBelowVelocityThreshold && isBelowDisplacementThreshold) {
        position = to;
        update(position);
        cancelSync.update(process);
        complete();
      } else {
        update(position);
      }
    }, true);
    return {
      stop: function () {
        return cancelSync.update(process);
      }
    };
  });
};

var vectorSpring = /*#__PURE__*/createVectorAction(spring, {
  from: number.test,
  to: number.test,
  stiffness: number.test,
  damping: number.test,
  mass: number.test,
  velocity: number.test
});

var scrubber = function (_a) {
  var _b = _a.from,
      from = _b === void 0 ? 0 : _b,
      _c = _a.to,
      to = _c === void 0 ? 1 : _c,
      _d = _a.ease,
      ease = _d === void 0 ? linear : _d,
      _e = _a.reverseEase,
      reverseEase = _e === void 0 ? false : _e;

  if (reverseEase) {
    ease = createReversedEasing(ease);
  }

  return action(function (_a) {
    var update = _a.update;
    return {
      seek: function (progress) {
        return update(progress);
      }
    };
  }).pipe(ease, function (v) {
    return mix(from, to, v);
  });
};

var vectorScrubber = /*#__PURE__*/createVectorAction(scrubber, {
  ease: function (func) {
    return typeof func === 'function';
  },
  from: number.test,
  to: number.test
});
var clampProgress$1 = /*#__PURE__*/clamp$1$1(0, 1);

var tween = function (props) {
  if (props === void 0) {
    props = {};
  }

  return action(function (_a) {
    var update = _a.update,
        complete = _a.complete;
    var _b = props.duration,
        duration = _b === void 0 ? 300 : _b,
        _c = props.ease,
        ease = _c === void 0 ? easeOut : _c,
        _d = props.flip,
        flip = _d === void 0 ? 0 : _d,
        _e = props.loop,
        loop = _e === void 0 ? 0 : _e,
        _f = props.yoyo,
        yoyo = _f === void 0 ? 0 : _f,
        _g = props.repeatDelay,
        repeatDelay = _g === void 0 ? 0 : _g;
    var _h = props.from,
        from = _h === void 0 ? 0 : _h,
        _j = props.to,
        to = _j === void 0 ? 1 : _j,
        _k = props.elapsed,
        elapsed = _k === void 0 ? 0 : _k,
        _l = props.flipCount,
        flipCount = _l === void 0 ? 0 : _l,
        _m = props.yoyoCount,
        yoyoCount = _m === void 0 ? 0 : _m,
        _o = props.loopCount,
        loopCount = _o === void 0 ? 0 : _o;
    var playhead = vectorScrubber({
      from: from,
      to: to,
      ease: ease
    }).start(update);
    var currentProgress = 0;
    var process;
    var isActive = false;

    var reverseAnimation = function (reverseEase) {
      var _a;

      if (reverseEase === void 0) {
        reverseEase = false;
      }

      _a = [to, from], from = _a[0], to = _a[1];
      playhead = vectorScrubber({
        from: from,
        to: to,
        ease: ease,
        reverseEase: reverseEase
      }).start(update);
    };

    var isTweenComplete = function () {
      var isComplete = isActive && elapsed > duration + repeatDelay;
      if (!isComplete) return false;
      if (isComplete && !loop && !flip && !yoyo) return true;
      elapsed = duration - (elapsed - repeatDelay);

      if (loop && loopCount < loop) {
        loopCount++;
        return false;
      } else if (flip && flipCount < flip) {
        flipCount++;
        reverseAnimation();
        return false;
      } else if (yoyo && yoyoCount < yoyo) {
        yoyoCount++;
        reverseAnimation(yoyoCount % 2 !== 0);
        return false;
      }

      return true;
    };

    var updateTween = function () {
      currentProgress = clampProgress$1(progress(0, duration, elapsed));
      playhead.seek(currentProgress);
    };

    var startTimer = function () {
      isActive = true;
      process = sync.update(function (_a) {
        var delta = _a.delta;
        elapsed += delta;
        updateTween();

        if (isTweenComplete()) {
          cancelSync.update(process);
          complete && sync.update(complete, false, true);
        }
      }, true);
    };

    var stopTimer = function () {
      isActive = false;
      if (process) cancelSync.update(process);
    };

    startTimer();
    return {
      isActive: function () {
        return isActive;
      },
      getElapsed: function () {
        return clamp$1$1(0, duration, elapsed);
      },
      getProgress: function () {
        return currentProgress;
      },
      stop: function () {
        stopTimer();
      },
      pause: function () {
        stopTimer();
        return this;
      },
      resume: function () {
        if (!isActive) startTimer();
        return this;
      },
      seek: function (newProgress) {
        elapsed = mix(0, duration, newProgress);
        sync.update(updateTween, false, true);
        return this;
      },
      reverse: function () {
        reverseAnimation();
        return this;
      }
    };
  });
};

var clampProgress$1$1 = /*#__PURE__*/clamp$1$1(0, 1);

var defaultEasings = function (values, easing) {
  return values.map(function () {
    return easing || easeOut;
  }).splice(0, values.length - 1);
};

var defaultTimings = function (values) {
  var numValues = values.length;
  return values.map(function (value, i) {
    return i !== 0 ? i / (numValues - 1) : 0;
  });
};

var interpolateScrubbers = function (input, scrubbers, update) {
  var rangeLength = input.length;
  var finalInputIndex = rangeLength - 1;
  var finalScrubberIndex = finalInputIndex - 1;
  var subs = scrubbers.map(function (scrub) {
    return scrub.start(update);
  });
  return function (v) {
    if (v <= input[0]) {
      subs[0].seek(0);
    }

    if (v >= input[finalInputIndex]) {
      subs[finalScrubberIndex].seek(1);
    }

    var i = 1;

    for (; i < rangeLength; i++) {
      if (input[i] > v || i === finalInputIndex) break;
    }

    var progressInRange = progress(input[i - 1], input[i], v);
    subs[i - 1].seek(clampProgress$1$1(progressInRange));
  };
};

var keyframes$1 = function (_a) {
  var easings = _a.easings,
      _b = _a.ease,
      ease = _b === void 0 ? linear : _b,
      times = _a.times,
      values = _a.values,
      tweenProps = __rest(_a, ["easings", "ease", "times", "values"]);

  easings = Array.isArray(easings) ? easings : defaultEasings(values, easings);
  times = times || defaultTimings(values);
  var scrubbers = easings.map(function (easing, i) {
    return vectorScrubber({
      from: values[i],
      to: values[i + 1],
      ease: easing
    });
  });
  return tween(__assign(__assign({}, tweenProps), {
    ease: ease
  })).applyMiddleware(function (update) {
    return interpolateScrubbers(times, scrubbers, update);
  });
};

var physics = function (props) {
  if (props === void 0) {
    props = {};
  }

  return action(function (_a) {
    var complete = _a.complete,
        update = _a.update;
    var _b = props.acceleration,
        acceleration = _b === void 0 ? 0 : _b,
        _c = props.friction,
        friction = _c === void 0 ? 0 : _c,
        _d = props.velocity,
        velocity = _d === void 0 ? 0 : _d,
        springStrength = props.springStrength,
        to = props.to;
    var _e = props.restSpeed,
        restSpeed = _e === void 0 ? 0.001 : _e,
        _f = props.from,
        from = _f === void 0 ? 0 : _f;
    var current = from;
    var process = sync.update(function (_a) {
      var delta = _a.delta;
      var elapsed = Math.max(delta, 16);
      if (acceleration) velocity += velocityPerFrame(acceleration, elapsed);
      if (friction) velocity *= Math.pow(1 - friction, elapsed / 100);

      if (springStrength !== undefined && to !== undefined) {
        var distanceToTarget = to - current;
        velocity += distanceToTarget * velocityPerFrame(springStrength, elapsed);
      }

      current += velocityPerFrame(velocity, elapsed);
      update(current);
      var isComplete = restSpeed !== false && (!velocity || Math.abs(velocity) <= restSpeed);

      if (isComplete) {
        cancelSync.update(process);
        complete();
      }
    }, true);
    return {
      set: function (v) {
        current = v;
        return this;
      },
      setAcceleration: function (v) {
        acceleration = v;
        return this;
      },
      setFriction: function (v) {
        friction = v;
        return this;
      },
      setSpringStrength: function (v) {
        springStrength = v;
        return this;
      },
      setSpringTarget: function (v) {
        to = v;
        return this;
      },
      setVelocity: function (v) {
        velocity = v;
        return this;
      },
      stop: function () {
        return cancelSync.update(process);
      }
    };
  });
};

var vectorPhysics = /*#__PURE__*/createVectorAction(physics, {
  acceleration: number.test,
  friction: number.test,
  velocity: number.test,
  from: number.test,
  to: number.test,
  springStrength: number.test
});

var listen = function (element, events, options) {
  return action(function (_a) {
    var update = _a.update;
    var eventNames = events.split(' ').map(function (eventName) {
      element.addEventListener(eventName, update, options);
      return eventName;
    });
    return {
      stop: function () {
        return eventNames.forEach(function (eventName) {
          return element.removeEventListener(eventName, update, options);
        });
      }
    };
  });
};

var defaultPointerPos = function () {
  return {
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    x: 0,
    y: 0
  };
};

var eventToPoint = function (e, point) {
  if (point === void 0) {
    point = defaultPointerPos();
  }

  point.clientX = point.x = e.clientX;
  point.clientY = point.y = e.clientY;
  point.pageX = e.pageX;
  point.pageY = e.pageY;
  return point;
};

var points = [/*#__PURE__*/defaultPointerPos()];
var isTouchDevice = false;

if (typeof document !== 'undefined') {
  var updatePointsLocation = function (_a) {
    var touches = _a.touches;
    isTouchDevice = true;
    var numTouches = touches.length;
    points.length = 0;

    for (var i = 0; i < numTouches; i++) {
      var thisTouch = touches[i];
      points.push(eventToPoint(thisTouch));
    }
  };

  listen(document, 'touchstart touchmove', {
    passive: true,
    capture: true
  }).start(updatePointsLocation);
}

var multitouch = function (_a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.preventDefault,
      preventDefault = _c === void 0 ? true : _c,
      _d = _b.scale,
      scale = _d === void 0 ? 1.0 : _d,
      _e = _b.rotate,
      rotate = _e === void 0 ? 0.0 : _e;

  return action(function (_a) {
    var update = _a.update;
    var output = {
      touches: points,
      scale: scale,
      rotate: rotate
    };
    var initialDistance = 0.0;
    var initialRotation = 0.0;
    var isGesture = points.length > 1;

    if (isGesture) {
      var firstTouch = points[0],
          secondTouch = points[1];
      initialDistance = distance(firstTouch, secondTouch);
      initialRotation = angle(firstTouch, secondTouch);
    }

    var updatePoint = function () {
      if (isGesture) {
        var firstTouch = points[0],
            secondTouch = points[1];
        var newDistance = distance(firstTouch, secondTouch);
        var newRotation = angle(firstTouch, secondTouch);
        output.scale = scale * (newDistance / initialDistance);
        output.rotate = rotate + (newRotation - initialRotation);
      }

      update(output);
    };

    var onMove = function (e) {
      if (preventDefault || e.touches.length > 1) e.preventDefault();
      sync.update(updatePoint);
    };

    var updateOnMove = listen(document, 'touchmove', {
      passive: !preventDefault
    }).start(onMove);
    if (isTouchDevice) sync.update(updatePoint);
    return {
      stop: function () {
        cancelSync.update(updatePoint);
        updateOnMove.stop();
      }
    };
  });
};

var getIsTouchDevice = function () {
  return isTouchDevice;
};

var point = /*#__PURE__*/defaultPointerPos();
var isMouseDevice = false;

if (typeof document !== 'undefined') {
  var updatePointLocation = function (e) {
    isMouseDevice = true;
    eventToPoint(e, point);
  };

  listen(document, 'mousedown mousemove', true).start(updatePointLocation);
}

var mouse = function (_a) {
  var _b = (_a === void 0 ? {} : _a).preventDefault,
      preventDefault = _b === void 0 ? true : _b;
  return action(function (_a) {
    var update = _a.update;

    var updatePoint = function () {
      return update(point);
    };

    var onMove = function (e) {
      if (preventDefault) e.preventDefault();
      sync.update(updatePoint);
    };

    var updateOnMove = listen(document, 'mousemove').start(onMove);
    if (isMouseDevice) sync.update(updatePoint);
    return {
      stop: function () {
        cancelSync.update(updatePoint);
        updateOnMove.stop();
      }
    };
  });
};

var getFirstTouch = function (_a) {
  var firstTouch = _a[0];
  return firstTouch;
};

var pointer = function (props) {
  if (props === void 0) {
    props = {};
  }

  return getIsTouchDevice() ? multitouch(props).pipe(function (_a) {
    var touches = _a.touches;
    return touches;
  }, getFirstTouch) : mouse(props);
};

var index$1 = function (_a) {
  if (_a === void 0) {
    _a = {};
  }

  var x = _a.x,
      y = _a.y,
      props = __rest(_a, ["x", "y"]);

  if (x !== undefined || y !== undefined) {
    var applyXOffset_1 = applyOffset(x || 0);
    var applyYOffset_1 = applyOffset(y || 0);
    var delta_1 = {
      x: 0,
      y: 0
    };
    return pointer(props).pipe(function (point) {
      delta_1.x = applyXOffset_1(point.x);
      delta_1.y = applyYOffset_1(point.y);
      return delta_1;
    });
  } else {
    return pointer(props);
  }
};

var chain = function () {
  var actions = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    actions[_i] = arguments[_i];
  }

  return action(function (_a) {
    var update = _a.update,
        complete = _a.complete;
    var i = 0;
    var current;

    var playCurrent = function () {
      current = actions[i].start({
        complete: function () {
          i++;
          i >= actions.length ? complete() : playCurrent();
        },
        update: update
      });
    };

    playCurrent();
    return {
      stop: function () {
        return current && current.stop();
      }
    };
  });
};

var delay = function (timeToDelay) {
  return action(function (_a) {
    var complete = _a.complete;
    var timeout = setTimeout(complete, timeToDelay);
    return {
      stop: function () {
        return clearTimeout(timeout);
      }
    };
  });
};

var appendUnit = function (unit) {
  return function (v) {
    return "" + v + unit;
  };
};

var steps$1 = function (st, min, max) {
  if (min === void 0) {
    min = 0;
  }

  if (max === void 0) {
    max = 1;
  }

  return function (v) {
    var current = progress(min, max, v);
    return mix(min, max, stepProgress(st, current));
  };
};

var transformMap = function (childTransformers) {
  return function (v) {
    var output = __assign({}, v);

    for (var key in childTransformers) {
      if (childTransformers.hasOwnProperty(key)) {
        var childTransformer = childTransformers[key];
        output[key] = childTransformer(v[key]);
      }
    }

    return output;
  };
};

var transformers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  applyOffset: applyOffset,
  clamp: clamp$1$1,
  conditional: conditional,
  interpolate: interpolate,
  blendArray: mixArray,
  blendColor: mixColor,
  pipe: pipe,
  smooth: smooth,
  snap: snap,
  generateStaticSpring: springForce,
  nonlinearSpring: springForceExpo,
  linearSpring: springForceLinear,
  wrap: wrap$1,
  appendUnit: appendUnit,
  steps: steps$1,
  transformMap: transformMap
});

var getPoseValues = function (_a) {
  var transition = _a.transition,
      flip = _a.flip,
      delay = _a.delay,
      delayChildren = _a.delayChildren,
      staggerChildren = _a.staggerChildren,
      staggerDirection = _a.staggerDirection,
      afterChildren = _a.afterChildren,
      beforeChildren = _a.beforeChildren,
      preTransition = _a.preTransition,
      applyAtStart = _a.applyAtStart,
      applyAtEnd = _a.applyAtEnd,
      props = __rest(_a, ["transition", "flip", "delay", "delayChildren", "staggerChildren", "staggerDirection", "afterChildren", "beforeChildren", "preTransition", "applyAtStart", "applyAtEnd"]);

  return props;
};

var selectPoses = function (_a) {
  var label = _a.label,
      props = _a.props,
      values = _a.values,
      parentValues = _a.parentValues,
      ancestorValues = _a.ancestorValues,
      onChange = _a.onChange,
      passive = _a.passive,
      initialPose = _a.initialPose,
      poses = __rest(_a, ["label", "props", "values", "parentValues", "ancestorValues", "onChange", "passive", "initialPose"]);

  return poses;
};

var selectAllValues = function (values, selectValue) {
  var allValues = {};
  values.forEach(function (value, key) {
    return allValues[key] = selectValue(value);
  });
  return allValues;
};

var resolveProp = function (target, props) {
  return typeof target === 'function' ? target(props) : target;
};

var poseDefault = function (pose, prop, defaultValue, resolveProps) {
  return pose && pose[prop] !== undefined ? resolveProp(pose[prop], resolveProps) : defaultValue;
};

var startChildAnimations = function (children, next, pose, props) {
  var animations = [];
  var delay = poseDefault(pose, 'delayChildren', 0, props);
  var stagger = poseDefault(pose, 'staggerChildren', 0, props);
  var staggerDirection = poseDefault(pose, 'staggerDirection', 1, props);
  var maxStaggerDuration = (children.size - 1) * stagger;
  var generateStaggerDuration = staggerDirection === 1 ? function (i) {
    return i * stagger;
  } : function (i) {
    return maxStaggerDuration - i * stagger;
  };
  Array.from(children).forEach(function (child, i) {
    animations.push(child.set(next, {
      delay: delay + generateStaggerDuration(i)
    }));
  });
  return animations;
};

var resolveTransition = function (transition, key, value, props, convertTransitionDefinition, getInstantTransition) {
  var resolvedTransition;

  if (typeof transition === 'function') {
    var resolvedTransitionMap = transition(props);
    resolvedTransition = resolveTransition(resolvedTransitionMap, key, value, props, convertTransitionDefinition, getInstantTransition);
  } else if (transition[key] || transition.default) {
    var keyTransition = transition[key] || transition.default;

    if (typeof keyTransition === 'function') {
      resolvedTransition = keyTransition(props);
    } else {
      resolvedTransition = keyTransition;
    }
  } else {
    resolvedTransition = transition;
  }

  return resolvedTransition === false ? getInstantTransition(value, props) : convertTransitionDefinition(value, resolvedTransition, props);
};

var findInsertionIndex = function (poseList, priorityList, priorityIndex) {
  var insertionIndex = 0;

  for (var i = priorityIndex - 1; i >= 0; i--) {
    var nextHighestPriorityIndex = poseList.indexOf(priorityList[i]);

    if (nextHighestPriorityIndex !== -1) {
      insertionIndex = nextHighestPriorityIndex + 1;
      break;
    }
  }

  return insertionIndex;
};

var applyValues = function (toApply, values, props, setValue, setValueNative) {
  invariant(typeof toApply === 'object', 'applyAtStart and applyAtEnd must be of type object');
  return Object.keys(toApply).forEach(function (key) {
    var valueToSet = resolveProp(toApply[key], props);
    values.has(key) ? setValue(values.get(key), valueToSet) : setValueNative(key, valueToSet, props);
  });
};

var createPoseSetter = function (setterProps) {
  var state = setterProps.state,
      poses = setterProps.poses,
      startAction = setterProps.startAction,
      stopAction = setterProps.stopAction,
      getInstantTransition = setterProps.getInstantTransition,
      addActionDelay = setterProps.addActionDelay,
      getTransitionProps = setterProps.getTransitionProps,
      resolveTarget = setterProps.resolveTarget,
      transformPose = setterProps.transformPose,
      posePriority = setterProps.posePriority,
      convertTransitionDefinition = setterProps.convertTransitionDefinition,
      setValue = setterProps.setValue,
      setValueNative = setterProps.setValueNative,
      forceRender = setterProps.forceRender;
  return function (next, nextProps, propagate) {
    if (nextProps === void 0) {
      nextProps = {};
    }

    if (propagate === void 0) {
      propagate = true;
    }

    var children = state.children,
        values = state.values,
        props = state.props,
        activeActions = state.activeActions,
        activePoses = state.activePoses;
    var _a = nextProps.delay,
        delay = _a === void 0 ? 0 : _a;
    var hasChildren = children.size;

    var baseTransitionProps = __assign(__assign({}, props), nextProps);

    var nextPose = poses[next];

    var getChildAnimations = function () {
      return hasChildren && propagate ? startChildAnimations(children, next, nextPose, baseTransitionProps) : [];
    };

    var getParentAnimations = function () {
      if (!nextPose) return [];
      var applyAtStart = nextPose.applyAtStart;

      if (applyAtStart) {
        applyValues(applyAtStart, values, baseTransitionProps, setValue, setValueNative);
        if (forceRender) forceRender(baseTransitionProps);
      }

      if (transformPose) nextPose = transformPose(nextPose, next, state);
      var preTransition = nextPose.preTransition,
          getTransition = nextPose.transition,
          applyAtEnd = nextPose.applyAtEnd;
      if (preTransition) preTransition(baseTransitionProps);
      var animations = Object.keys(getPoseValues(nextPose)).map(function (key) {
        var valuePoses = activePoses.has(key) ? activePoses.get(key) : (activePoses.set(key, []), activePoses.get(key));
        var existingIndex = valuePoses.indexOf(next);
        if (existingIndex !== -1) valuePoses.splice(existingIndex, 1);
        var priority = posePriority ? posePriority.indexOf(next) : 0;
        var insertionIndex = priority <= 0 ? 0 : findInsertionIndex(valuePoses, posePriority, priority);
        valuePoses.splice(insertionIndex, 0, next);
        return insertionIndex === 0 ? new Promise(function (complete) {
          var value = values.get(key);

          var transitionProps = __assign(__assign({}, baseTransitionProps), {
            key: key,
            value: value
          });

          var target = resolveTarget(value, resolveProp(nextPose[key], transitionProps));
          if (activeActions.has(key)) stopAction(activeActions.get(key));

          var resolveTransitionProps = __assign(__assign({
            to: target
          }, transitionProps), getTransitionProps(value, target, transitionProps));

          var transition = resolveTransition(getTransition, key, value, resolveTransitionProps, convertTransitionDefinition, getInstantTransition);
          var poseDelay = delay || resolveProp(nextPose.delay, transitionProps);

          if (poseDelay) {
            transition = addActionDelay(poseDelay, transition);
          }

          activeActions.set(key, startAction(value, transition, complete));
        }) : Promise.resolve();
      });
      return applyAtEnd ? [Promise.all(animations).then(function () {
        applyValues(applyAtEnd, values, baseTransitionProps, setValue, setValueNative);
      })] : animations;
    };

    if (nextPose && hasChildren) {
      if (resolveProp(nextPose.beforeChildren, baseTransitionProps)) {
        return Promise.all(getParentAnimations()).then(function () {
          return Promise.all(getChildAnimations());
        });
      } else if (resolveProp(nextPose.afterChildren, baseTransitionProps)) {
        return Promise.all(getChildAnimations()).then(function () {
          return Promise.all(getParentAnimations());
        });
      }
    }

    return Promise.all(__spreadArrays(getParentAnimations(), getChildAnimations()));
  };
};

var DEFAULT_INITIAL_POSE = 'init';

var isScale = function (key) {
  return key.includes('scale');
};

var defaultReadValueFromSource = function (key) {
  return isScale(key) ? 1 : 0;
};

var readValueFromPose = function (pose, key, props) {
  var valueToResolve = pose.applyAtEnd && pose.applyAtEnd[key] !== undefined ? pose.applyAtEnd[key] : pose[key] !== undefined ? pose[key] : pose.applyAtStart && pose.applyAtStart[key] !== undefined ? pose.applyAtStart[key] : 0;
  return resolveProp(valueToResolve, props);
};

var getPosesToSearch = function (pose) {
  var posesToSearch = Array.isArray(pose) ? pose : [pose];
  posesToSearch.push(DEFAULT_INITIAL_POSE);
  return posesToSearch;
};

var getInitialValue = function (poses, key, initialPose, props, readValueFromSource, activePoses) {
  if (readValueFromSource === void 0) {
    readValueFromSource = defaultReadValueFromSource;
  }

  var posesToSearch = getPosesToSearch(initialPose);
  var pose = posesToSearch.filter(Boolean).find(function (name) {
    var thisPose = poses[name];
    return thisPose && (thisPose[key] !== undefined || thisPose.applyAtStart && thisPose.applyAtStart[key] !== undefined || thisPose.applyAtEnd && thisPose.applyAtEnd[key] !== undefined);
  });
  activePoses.set(key, [pose || DEFAULT_INITIAL_POSE]);
  return pose ? readValueFromPose(poses[pose], key, props) : readValueFromSource(key, props);
};

var createValues = function (values, _a) {
  var userSetValues = _a.userSetValues,
      createValue = _a.createValue,
      convertValue = _a.convertValue,
      readValueFromSource = _a.readValueFromSource,
      initialPose = _a.initialPose,
      poses = _a.poses,
      activePoses = _a.activePoses,
      props = _a.props;
  return function (key) {
    if (values.has(key)) return;
    var value;

    if (userSetValues && userSetValues[key] !== undefined) {
      value = convertValue(userSetValues[key], key, props);
    } else {
      var initValue = getInitialValue(poses, key, initialPose, props, readValueFromSource, activePoses);
      value = createValue(initValue, key, props);
    }

    values.set(key, value);
  };
};

var scrapeValuesFromPose = function (values, props) {
  return function (key) {
    var pose = props.poses[key];
    Object.keys(getPoseValues(pose)).forEach(createValues(values, props));
  };
};

var getAncestorValue = function (key, fromParent, ancestors) {
  if (fromParent === true) {
    return ancestors[0] && ancestors[0].values.get(key);
  } else {
    var foundAncestor = ancestors.find(function (_a) {
      var label = _a.label;
      return label === fromParent;
    });
    return foundAncestor && foundAncestor.values.get(key);
  }
};

var bindPassiveValues = function (values, _a) {
  var passive = _a.passive,
      ancestorValues = _a.ancestorValues,
      createValue = _a.createValue,
      readValue = _a.readValue,
      props = _a.props;
  return function (key) {
    var _a = passive[key],
        valueKey = _a[0],
        passiveProps = _a[1],
        fromParent = _a[2];
    var valueToBind = fromParent && ancestorValues.length ? getAncestorValue(valueKey, fromParent, ancestorValues) : values.has(valueKey) ? values.get(valueKey) : false;
    if (!valueToBind) return;
    var newValue = createValue(readValue(valueToBind), key, props, {
      passiveParentKey: valueKey,
      passiveParent: valueToBind,
      passiveProps: passiveProps
    });
    values.set(key, newValue);
  };
};

var setNativeValues = function (_a) {
  var setValueNative = _a.setValueNative,
      initialPose = _a.initialPose,
      props = _a.props,
      poses = _a.poses;
  var valuesHaveSet = new Set();

  var setValues = function (pose, propKey) {
    if (pose[propKey]) {
      for (var key in pose[propKey]) {
        if (!valuesHaveSet.has(key)) {
          valuesHaveSet.add(key);
          setValueNative(key, resolveProp(pose[propKey][key], props), props);
        }
      }
    }
  };

  getPosesToSearch(initialPose).forEach(function (poseKey) {
    var pose = poses[poseKey];

    if (pose) {
      setValues(pose, 'applyAtEnd');
      setValues(pose, 'applyAtStart');
    }
  });
};

var createValueMap = function (props) {
  var poses = props.poses,
      passive = props.passive;
  var values = new Map();
  Object.keys(poses).forEach(scrapeValuesFromPose(values, props));
  setNativeValues(props);
  if (passive) Object.keys(passive).forEach(bindPassiveValues(values, props));
  return values;
};

var applyDefaultTransition = function (pose, key, defaultTransitions) {
  return __assign(__assign({}, pose), {
    transition: defaultTransitions.has(key) ? defaultTransitions.get(key) : defaultTransitions.get('default')
  });
};

var generateTransitions = function (poses, defaultTransitions) {
  Object.keys(poses).forEach(function (key) {
    var pose = poses[key];
    invariant(typeof pose === 'object', "Pose '" + key + "' is of invalid type. All poses should be objects.");
    poses[key] = pose.transition !== undefined ? pose : applyDefaultTransition(pose, key, defaultTransitions);
  });
  return poses;
};

var sortByReversePriority = function (priorityOrder) {
  return function (a, b) {
    var aP = priorityOrder.indexOf(a);
    var bP = priorityOrder.indexOf(b);
    if (aP === -1 && bP !== -1) return -1;
    if (aP !== -1 && bP === -1) return 1;
    return aP - bP;
  };
};

var poseFactory = function (_a) {
  var getDefaultProps = _a.getDefaultProps,
      defaultTransitions = _a.defaultTransitions,
      bindOnChange = _a.bindOnChange,
      startAction = _a.startAction,
      stopAction = _a.stopAction,
      readValue = _a.readValue,
      readValueFromSource = _a.readValueFromSource,
      resolveTarget = _a.resolveTarget,
      setValue = _a.setValue,
      setValueNative = _a.setValueNative,
      createValue = _a.createValue,
      convertValue = _a.convertValue,
      getInstantTransition = _a.getInstantTransition,
      getTransitionProps = _a.getTransitionProps,
      addActionDelay = _a.addActionDelay,
      selectValueToRead = _a.selectValueToRead,
      convertTransitionDefinition = _a.convertTransitionDefinition,
      transformPose = _a.transformPose,
      posePriority = _a.posePriority,
      forceRender = _a.forceRender,
      extendAPI = _a.extendAPI;
  return function (config) {
    var parentValues = config.parentValues,
        _a = config.ancestorValues,
        ancestorValues = _a === void 0 ? [] : _a;
    if (parentValues) ancestorValues.unshift({
      values: parentValues
    });
    var activeActions = new Map();
    var activePoses = new Map();
    var children = new Set();
    var poses = generateTransitions(selectPoses(config), defaultTransitions);
    var _b = config.props,
        props = _b === void 0 ? {} : _b;
    if (getDefaultProps) props = __assign(__assign({}, getDefaultProps(config)), props);
    var passive = config.passive,
        userSetValues = config.values,
        _c = config.initialPose,
        initialPose = _c === void 0 ? DEFAULT_INITIAL_POSE : _c;
    var values = createValueMap({
      poses: poses,
      passive: passive,
      ancestorValues: ancestorValues,
      readValue: readValue,
      setValueNative: setValueNative,
      createValue: createValue,
      convertValue: convertValue,
      readValueFromSource: readValueFromSource,
      userSetValues: userSetValues,
      initialPose: initialPose,
      activePoses: activePoses,
      props: props
    });
    var state = {
      activeActions: activeActions,
      activePoses: activePoses,
      children: children,
      props: props,
      values: values
    };
    var onChange = config.onChange;
    if (onChange) Object.keys(onChange).forEach(bindOnChange(values, onChange));
    var set = createPoseSetter({
      state: state,
      poses: poses,
      getInstantTransition: getInstantTransition,
      getTransitionProps: getTransitionProps,
      convertTransitionDefinition: convertTransitionDefinition,
      setValue: setValue,
      setValueNative: setValueNative,
      startAction: startAction,
      stopAction: stopAction,
      resolveTarget: resolveTarget,
      addActionDelay: addActionDelay,
      transformPose: transformPose,
      posePriority: posePriority,
      forceRender: forceRender
    });

    var has = function (poseName) {
      return !!poses[poseName];
    };

    var api = {
      set: set,
      unset: function (poseName, poseProps) {
        var posesToSet = [];
        activePoses.forEach(function (valuePoses) {
          var poseIndex = valuePoses.indexOf(poseName);
          if (poseIndex === -1) return;
          var currentPose = valuePoses[0];
          valuePoses.splice(poseIndex, 1);
          var nextPose = valuePoses[0];
          if (nextPose === currentPose) return;

          if (posesToSet.indexOf(nextPose) === -1) {
            posesToSet.push(nextPose);
          }
        });
        var animationsToResolve = posesToSet.sort(sortByReversePriority(posePriority)).map(function (poseToSet) {
          return set(poseToSet, poseProps, false);
        });
        children.forEach(function (child) {
          return animationsToResolve.push(child.unset(poseName));
        });
        return Promise.all(animationsToResolve);
      },
      get: function (valueName) {
        return valueName ? selectValueToRead(values.get(valueName)) : selectAllValues(values, selectValueToRead);
      },
      has: has,
      setProps: function (newProps) {
        return state.props = __assign(__assign({}, state.props), newProps);
      },
      _addChild: function (childConfig, factory) {
        var child = factory(__assign(__assign({
          initialPose: initialPose
        }, childConfig), {
          ancestorValues: __spreadArrays([{
            label: config.label,
            values: values
          }], ancestorValues)
        }));
        children.add(child);
        return child;
      },
      removeChild: function (child) {
        return children.delete(child);
      },
      clearChildren: function () {
        children.forEach(function (child) {
          return child.destroy();
        });
        children.clear();
      },
      destroy: function () {
        activeActions.forEach(stopAction);
        children.forEach(function (child) {
          return child.destroy();
        });
      }
    };
    return extendAPI(api, state, config);
  };
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign$7 = function () {
  __assign$7 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign$7.apply(this, arguments);
};

function __rest$1(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var BoundingBoxDimension;

(function (BoundingBoxDimension) {
  BoundingBoxDimension["width"] = "width";
  BoundingBoxDimension["height"] = "height";
  BoundingBoxDimension["left"] = "left";
  BoundingBoxDimension["right"] = "right";
  BoundingBoxDimension["top"] = "top";
  BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));

var measureWithoutTransform = function (element) {
  var transform$$1 = element.style.transform;
  element.style.transform = '';
  var bbox = element.getBoundingClientRect();
  element.style.transform = transform$$1;
  return bbox;
};

var resolveProp$1 = function (target, props) {
  return typeof target === 'function' ? target(props) : target;
};

var interpolate$1 = transformers.interpolate;

var singleAxisPointer = function (axis) {
  return function (from) {
    var _a;

    return index$1((_a = {}, _a[axis] = typeof from === 'string' ? parseFloat(from) : from, _a)).pipe(function (v) {
      return v[axis];
    });
  };
};

var pointerX = /*#__PURE__*/singleAxisPointer('x');
var pointerY = /*#__PURE__*/singleAxisPointer('y');

var createPointer = function (axisPointerCreator, min, max, measurement) {
  return function (transitionProps) {
    var from = transitionProps.from,
        type = transitionProps.type,
        dimensions = transitionProps.dimensions,
        dragBounds = transitionProps.dragBounds;
    var axisPointer = axisPointerCreator(dimensions.measurementAsPixels(measurement, from, type));
    var transformQueue = [];

    if (dragBounds) {
      var resolvedDragBounds_1 = resolveProp$1(dragBounds, transitionProps);

      if (resolvedDragBounds_1[min] !== undefined) {
        transformQueue.push(function (v) {
          return Math.max(v, dimensions.measurementAsPixels(measurement, resolvedDragBounds_1[min], type));
        });
      }

      if (resolvedDragBounds_1[max] !== undefined) {
        transformQueue.push(function (v) {
          return Math.min(v, dimensions.measurementAsPixels(measurement, resolvedDragBounds_1[max], type));
        });
      }
    }

    if (type === percent) {
      transformQueue.push(interpolate$1([0, dimensions.get(measurement)], [0, 100], {
        clamp: false
      }), function (v) {
        return v + '%';
      });
    }

    return transformQueue.length ? axisPointer.pipe.apply(axisPointer, transformQueue) : axisPointer;
  };
};

var just = function (from) {
  return action(function (_a) {
    var update = _a.update,
        complete = _a.complete;
    update(from);
    complete();
  });
};

var underDampedSpring = function (_a) {
  var from = _a.from,
      velocity = _a.velocity,
      to = _a.to;
  return vectorSpring({
    from: from,
    to: to,
    velocity: velocity,
    stiffness: 500,
    damping: 25,
    restDelta: 0.5,
    restSpeed: 10
  });
};

var overDampedSpring = function (_a) {
  var from = _a.from,
      velocity = _a.velocity,
      to = _a.to;
  return vectorSpring({
    from: from,
    to: to,
    velocity: velocity,
    stiffness: 700,
    damping: to === 0 ? 100 : 35
  });
};

var linearTween = function (_a) {
  var from = _a.from,
      to = _a.to;
  return tween({
    from: from,
    to: to,
    ease: linear
  });
};

var intelligentTransition = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: overDampedSpring,
  scaleY: overDampedSpring,
  scale: overDampedSpring,
  opacity: linearTween,
  default: tween
};

var dragAction = /*#__PURE__*/__assign$7( /*#__PURE__*/__assign$7({}, intelligentTransition), {
  x: /*#__PURE__*/createPointer(pointerX, 'left', 'right', BoundingBoxDimension.width),
  y: /*#__PURE__*/createPointer(pointerY, 'top', 'bottom', BoundingBoxDimension.height)
});

var justAxis = function (_a) {
  var from = _a.from;
  return just(from);
};

var intelligentDragEnd = /*#__PURE__*/__assign$7( /*#__PURE__*/__assign$7({}, intelligentTransition), {
  x: justAxis,
  y: justAxis
});

var defaultTransitions = /*#__PURE__*/new Map([['default', intelligentTransition], ['drag', dragAction], ['dragEnd', intelligentDragEnd]]);
var animationLookup = {
  tween: tween,
  spring: vectorSpring,
  decay: vectorDecay,
  keyframes: keyframes$1,
  physics: vectorPhysics
};
var easingLookup = {
  linear: linear,
  easeIn: easeIn,
  easeOut: easeOut,
  easeInOut: easeInOut,
  circIn: circIn,
  circOut: circOut,
  circInOut: circInOut,
  backIn: backIn,
  backOut: backOut,
  backInOut: backInOut,
  anticipate: anticipate
};
var auto = {
  test: function (v) {
    return v === 'auto';
  },
  parse: function (v) {
    return v;
  }
};
var valueTypeTests = [number, degrees, percent, px, vw, vh, auto];

var testValueType = function (v) {
  return function (type) {
    return type.test(v);
  };
};

var getValueType$1 = function (v) {
  return valueTypeTests.find(testValueType(v));
};

var createPassiveValue = function (init, parent, transform$$1) {
  var raw = value(transform$$1(init));
  parent.raw.subscribe(function (v) {
    return raw.update(transform$$1(v));
  });
  return {
    raw: raw
  };
};

var createValue = function (init) {
  var type = getValueType$1(init);
  var raw = value(init);
  return {
    raw: raw,
    type: type
  };
};

var addActionDelay = function (delay$$1, transition) {
  if (delay$$1 === void 0) {
    delay$$1 = 0;
  }

  return chain(delay(delay$$1), transition);
};

var isCubicBezierArgs = function (args) {
  return typeof args[0] === 'number';
};

var getAction = function (v, _a, _b) {
  var from = _b.from,
      to = _b.to,
      velocity = _b.velocity;

  var _c = _a.type,
      type = _c === void 0 ? 'tween' : _c,
      definedEase = _a.ease,
      def = __rest$1(_a, ["type", "ease"]);

  invariant(animationLookup[type] !== undefined, "Invalid transition type '" + type + "'. Valid transition types are: tween, spring, decay, physics and keyframes.");
  var ease;

  if (type === 'tween') {
    if (typeof definedEase !== 'function') {
      if (typeof definedEase === 'string') {
        invariant(easingLookup[definedEase] !== undefined, "Invalid easing type '" + definedEase + "'. popmotion.io/pose/api/config");
        ease = easingLookup[definedEase];
      } else if (Array.isArray(definedEase) && isCubicBezierArgs(definedEase)) {
        invariant(definedEase.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var x1 = definedEase[0],
            y1 = definedEase[1],
            x2 = definedEase[2],
            y2 = definedEase[3];
        ease = cubicBezier(x1, y1, x2, y2);
      }
    }
  }

  ease = ease || definedEase;
  var baseProps = type !== 'keyframes' ? {
    from: from,
    to: to,
    velocity: velocity,
    ease: ease
  } : {
    ease: ease
  };
  return animationLookup[type](__assign$7(__assign$7({}, baseProps), def));
};

var isAction = function (action$$1) {
  return typeof action$$1.start !== 'undefined';
};

var pose = function (_a) {
  var transformPose = _a.transformPose,
      addListenerToValue = _a.addListenerToValue,
      extendAPI = _a.extendAPI,
      readValueFromSource = _a.readValueFromSource,
      posePriority = _a.posePriority,
      setValueNative = _a.setValueNative;
  return poseFactory({
    bindOnChange: function (values, onChange) {
      return function (key) {
        if (!values.has(key)) return;
        var raw = values.get(key).raw;
        raw.subscribe(onChange[key]);
      };
    },
    readValue: function (_a) {
      var raw = _a.raw;
      return raw.get();
    },
    setValue: function (_a, to) {
      var raw = _a.raw;
      return raw.update(to);
    },
    createValue: function (init, key, _a, _b) {
      var elementStyler = _a.elementStyler;

      var _c = _b === void 0 ? {} : _b,
          passiveParent = _c.passiveParent,
          passiveProps = _c.passiveProps;

      var val = passiveParent ? createPassiveValue(init, passiveParent, passiveProps) : createValue(init);
      val.raw.subscribe(addListenerToValue(key, elementStyler));
      return val;
    },
    convertValue: function (raw, key, _a) {
      var elementStyler = _a.elementStyler;
      raw.subscribe(addListenerToValue(key, elementStyler));
      return {
        raw: raw,
        type: getValueType$1(raw.get())
      };
    },
    getTransitionProps: function (_a, to) {
      var raw = _a.raw,
          type = _a.type;
      return {
        from: raw.get(),
        velocity: raw.getVelocity(),
        to: to,
        type: type
      };
    },
    resolveTarget: function (_, to) {
      return to;
    },
    selectValueToRead: function (_a) {
      var raw = _a.raw;
      return raw;
    },
    startAction: function (_a, action$$1, complete) {
      var raw = _a.raw;
      var reaction = {
        update: function (v) {
          return raw.update(v);
        },
        complete: complete
      };
      return action$$1.start(reaction);
    },
    stopAction: function (action$$1) {
      return action$$1.stop();
    },
    getInstantTransition: function (_, _a) {
      var to = _a.to;
      return just(to);
    },
    convertTransitionDefinition: function (val, def, props) {
      if (isAction(def)) return def;

      var delay$$1 = def.delay,
          min = def.min,
          max = def.max,
          round = def.round,
          remainingDef = __rest$1(def, ["delay", "min", "max", "round"]);

      var action$$1 = getAction(val, remainingDef, props);
      var outputPipe = [];
      if (delay$$1) action$$1 = addActionDelay(delay$$1, action$$1);
      if (min !== undefined) outputPipe.push(function (v) {
        return Math.max(v, min);
      });
      if (max !== undefined) outputPipe.push(function (v) {
        return Math.min(v, max);
      });
      if (round) outputPipe.push(Math.round);
      return outputPipe.length ? action$$1.pipe.apply(action$$1, outputPipe) : action$$1;
    },
    setValueNative: setValueNative,
    addActionDelay: addActionDelay,
    defaultTransitions: defaultTransitions,
    transformPose: transformPose,
    readValueFromSource: readValueFromSource,
    posePriority: posePriority,
    extendAPI: extendAPI
  });
};

var createDimensions = function (element) {
  var hasMeasured = false;
  var current = {
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  };
  return {
    get: function (measurement) {
      return measurement ? current[measurement] : current;
    },
    measure: function () {
      current = element.getBoundingClientRect();
      hasMeasured = true;
      return current;
    },
    measurementAsPixels: function (measurement, value$$1, type) {
      return type === percent ? (typeof value$$1 === 'string' ? parseFloat(value$$1) : value$$1) / 100 * current[measurement] : value$$1;
    },
    has: function () {
      return hasMeasured;
    }
  };
};

var makeUIEventApplicator = function (_a) {
  var startEvents = _a.startEvents,
      endEvents = _a.endEvents,
      startPose = _a.startPose,
      endPose = _a.endPose,
      startCallback = _a.startCallback,
      endCallback = _a.endCallback,
      useDocumentToEnd = _a.useDocumentToEnd,
      preventScroll = _a.preventScroll;
  return function (element, activeActions, poser, config) {
    var startListener = startPose + 'Start';
    var endListener = startPose + 'End';
    var moveListener = startPose + 'Move';

    if (preventScroll) {
      var touchMoveListener = listen(element, 'touchmove', {
        passive: false
      }).start(function (e) {
        e.preventDefault();
      });
      activeActions.set(moveListener, touchMoveListener);
    }

    var eventStartListener = listen(element, startEvents).start(function (startEvent) {
      poser.unset(endPose);
      poser.set(startPose);
      if (startCallback && config[startCallback]) config[startCallback](startEvent);
      var eventEndListener = listen(useDocumentToEnd ? document.documentElement : element, endEvents + (useDocumentToEnd ? ' mouseenter' : '')).start(function (endEvent) {
        if (useDocumentToEnd && endEvent.type === 'mouseenter' && endEvent.buttons === 1) {
          return;
        }

        activeActions.get(endListener).stop();
        poser.unset(startPose);
        poser.set(endPose);
        if (endCallback && config[endCallback]) config[endCallback](endEvent);
      });
      activeActions.set(endListener, eventEndListener);
    });
    activeActions.set(startListener, eventStartListener);
  };
};

var events = {
  draggable: /*#__PURE__*/makeUIEventApplicator({
    startEvents: 'mousedown touchstart',
    endEvents: 'mouseup touchend',
    startPose: 'drag',
    endPose: 'dragEnd',
    startCallback: 'onDragStart',
    endCallback: 'onDragEnd',
    useDocumentToEnd: true,
    preventScroll: true
  }),
  hoverable: /*#__PURE__*/makeUIEventApplicator({
    startEvents: 'mouseenter',
    endEvents: 'mouseleave',
    startPose: 'hover',
    endPose: 'hoverEnd'
  }),
  focusable: /*#__PURE__*/makeUIEventApplicator({
    startEvents: 'focus',
    endEvents: 'blur',
    startPose: 'focus',
    endPose: 'blur'
  }),
  pressable: /*#__PURE__*/makeUIEventApplicator({
    startEvents: 'mousedown touchstart',
    endEvents: 'mouseup touchend',
    startPose: 'press',
    endPose: 'pressEnd',
    startCallback: 'onPressStart',
    endCallback: 'onPressEnd',
    useDocumentToEnd: true
  })
};
var eventKeys = /*#__PURE__*/Object.keys(events);

var appendEventListeners = function (element, activeActions, poser, _a) {
  var props = _a.props;
  return eventKeys.forEach(function (key) {
    if (props[key]) events[key](element, activeActions, poser, props);
  });
};

var ORIGIN_START = 0;
var ORIGIN_CENTER = '50%';
var ORIGIN_END = '100%';

var findCenter = function (_a) {
  var top = _a.top,
      right = _a.right,
      bottom = _a.bottom,
      left = _a.left;
  return {
    x: (left + right) / 2,
    y: (top + bottom) / 2
  };
};

var positionalProps = ['width', 'height', 'top', 'left', 'bottom', 'right'];
var positionalPropsDict = /*#__PURE__*/new Set(positionalProps);

var checkPositionalProp = function (key) {
  return positionalPropsDict.has(key);
};

var hasPositionalProps = function (pose) {
  return Object.keys(pose).some(checkPositionalProp);
};

var isFlipPose = function (flip, key, state) {
  return state.props.element instanceof HTMLElement && (flip === true || key === 'flip');
};

var setValue = function (_a, key, to) {
  var values = _a.values,
      props = _a.props;

  if (values.has(key)) {
    var raw = values.get(key).raw;
    raw.update(to);
    raw.update(to);
  } else {
    values.set(key, {
      raw: value(to, function (v) {
        return props.elementStyler.set(key, v);
      })
    });
  }
};

var explicitlyFlipPose = function (state, nextPose) {
  var _a = state.props,
      dimensions = _a.dimensions,
      elementStyler = _a.elementStyler;
  dimensions.measure();

  var width = nextPose.width,
      height = nextPose.height,
      top = nextPose.top,
      left = nextPose.left,
      bottom = nextPose.bottom,
      right = nextPose.right,
      position = nextPose.position,
      remainingPose = __rest$1(nextPose, ["width", "height", "top", "left", "bottom", "right", "position"]);

  var propsToSet = positionalProps.concat('position').reduce(function (acc, key) {
    if (nextPose[key] !== undefined) {
      acc[key] = resolveProp$1(nextPose[key], state.props);
    }

    return acc;
  }, {});
  elementStyler.set(propsToSet).render();
  return implicitlyFlipPose(state, remainingPose);
};

var implicitlyFlipPose = function (state, nextPose) {
  var _a = state.props,
      dimensions = _a.dimensions,
      element = _a.element,
      elementStyler = _a.elementStyler;
  if (!dimensions.has()) return {};
  var prev = dimensions.get();
  var next = measureWithoutTransform(element);
  var originX = prev.left === next.left ? ORIGIN_START : prev.right === next.right ? ORIGIN_END : ORIGIN_CENTER;
  var originY = prev.top === next.top ? ORIGIN_START : prev.bottom === next.bottom ? ORIGIN_END : ORIGIN_CENTER;
  elementStyler.set({
    originX: originX,
    originY: originY
  });

  if (prev.width !== next.width) {
    setValue(state, 'scaleX', prev.width / next.width);
    nextPose.scaleX = 1;
  }

  if (prev.height !== next.height) {
    setValue(state, 'scaleY', prev.height / next.height);
    nextPose.scaleY = 1;
  }

  var prevCenter = findCenter(prev);
  var nextCenter = findCenter(next);

  if (originX === ORIGIN_CENTER) {
    setValue(state, 'x', prevCenter.x - nextCenter.x);
    nextPose.x = 0;
  }

  if (originY === ORIGIN_CENTER) {
    setValue(state, 'y', prevCenter.y - nextCenter.y);
    nextPose.y = 0;
  }

  elementStyler.render();
  return nextPose;
};

var flipPose = function (props, nextPose) {
  return hasPositionalProps(nextPose) ? explicitlyFlipPose(props, nextPose) : implicitlyFlipPose(props, nextPose);
};

var getPosFromMatrix = function (matrix, pos) {
  return parseFloat(matrix.split(', ')[pos]);
};

var getTranslateFromMatrix = function (pos2, pos3) {
  return function (element, bbox, _a) {
    var transform$$1 = _a.transform;
    if (!transform$$1 || transform$$1 === 'none') return 0;
    var matrix3d = transform$$1.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) return getPosFromMatrix(matrix3d[1], pos3);
    return getPosFromMatrix(transform$$1.match(/^matrix\((.+)\)$/)[1], pos2);
  };
};

var positionalValues = {
  width: function (element, _a) {
    var width = _a.width;
    return width;
  },
  height: function (element, _a) {
    var height = _a.height;
    return height;
  },
  top: function (element, bbox, _a) {
    var top = _a.top;
    return parseFloat(top);
  },
  left: function (element, bbox, _a) {
    var left = _a.left;
    return parseFloat(left);
  },
  bottom: function (element, _a, _b) {
    var height = _a.height;
    var top = _b.top;
    return parseFloat(top) + height;
  },
  right: function (element, _a, _b) {
    var width = _a.width;
    var left = _b.left;
    return parseFloat(left) + width;
  },
  x: /*#__PURE__*/getTranslateFromMatrix(4, 13),
  y: /*#__PURE__*/getTranslateFromMatrix(5, 14)
};

var isPositionalKey = function (v) {
  return positionalValues[v] !== undefined;
};

var isPositional = function (pose) {
  return Object.keys(pose).some(isPositionalKey);
};

var convertPositionalUnits = function (state, nextPose) {
  var values = state.values,
      props = state.props;
  var element = props.element,
      elementStyler = props.elementStyler;
  var positionalPoseKeys = Object.keys(nextPose).filter(isPositionalKey);
  var changedPositionalKeys = [];
  var elementComputedStyle = getComputedStyle(element);
  var applyAtEndHasBeenCopied = false;
  positionalPoseKeys.forEach(function (key) {
    var value$$1 = values.get(key);
    var fromValueType = getValueType$1(value$$1.raw.get());
    var to = resolveProp$1(nextPose[key], props);
    var toValueType = getValueType$1(to);

    if (fromValueType !== toValueType) {
      changedPositionalKeys.push(key);

      if (!applyAtEndHasBeenCopied) {
        applyAtEndHasBeenCopied = true;
        nextPose.applyAtEnd = nextPose.applyAtEnd ? __assign$7({}, nextPose.applyAtEnd) : {};
      }

      nextPose.applyAtEnd[key] = nextPose.applyAtEnd[key] || nextPose[key];
      setValue(state, key, to);
    }
  });
  if (!changedPositionalKeys.length) return nextPose;
  var originBbox = element.getBoundingClientRect();
  var top = elementComputedStyle.top,
      left = elementComputedStyle.left,
      bottom = elementComputedStyle.bottom,
      right = elementComputedStyle.right,
      transform$$1 = elementComputedStyle.transform;
  var originComputedStyle = {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    transform: transform$$1
  };
  elementStyler.render();
  var targetBbox = element.getBoundingClientRect();
  changedPositionalKeys.forEach(function (key) {
    setValue(state, key, positionalValues[key](element, originBbox, originComputedStyle));
    nextPose[key] = positionalValues[key](element, targetBbox, elementComputedStyle);
  });
  elementStyler.render();
  return nextPose;
};

var getCurrent = function (prop) {
  return function (_a) {
    var elementStyler = _a.elementStyler;
    return elementStyler.get(prop);
  };
};

var dragPoses = function (draggable) {
  var drag = {
    preTransition: function (_a) {
      var dimensions = _a.dimensions;
      return dimensions.measure();
    }
  };
  var dragEnd = {};

  if (draggable === true || draggable === 'x') {
    drag.x = dragEnd.x = getCurrent('x');
  }

  if (draggable === true || draggable === 'y') {
    drag.y = dragEnd.y = getCurrent('y');
  }

  return {
    drag: drag,
    dragEnd: dragEnd
  };
};

var createPoseConfig = function (element, _a) {
  var onDragStart = _a.onDragStart,
      onDragEnd = _a.onDragEnd,
      onPressStart = _a.onPressStart,
      onPressEnd = _a.onPressEnd,
      draggable = _a.draggable,
      hoverable = _a.hoverable,
      focusable = _a.focusable,
      pressable = _a.pressable,
      dragBounds = _a.dragBounds,
      config = __rest$1(_a, ["onDragStart", "onDragEnd", "onPressStart", "onPressEnd", "draggable", "hoverable", "focusable", "pressable", "dragBounds"]);

  var poseConfig = __assign$7(__assign$7({
    flip: {}
  }, config), {
    props: __assign$7(__assign$7({}, config.props), {
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      onPressStart: onPressStart,
      onPressEnd: onPressEnd,
      dragBounds: dragBounds,
      draggable: draggable,
      hoverable: hoverable,
      focusable: focusable,
      pressable: pressable,
      element: element,
      elementStyler: index(element, {
        preparseOutput: false
      }),
      dimensions: createDimensions(element)
    })
  });

  if (draggable) {
    var _b = dragPoses(draggable),
        drag = _b.drag,
        dragEnd = _b.dragEnd;

    poseConfig.drag = __assign$7(__assign$7({}, drag), poseConfig.drag);
    poseConfig.dragEnd = __assign$7(__assign$7({}, dragEnd), poseConfig.dragEnd);
  }

  return poseConfig;
};

var domPose = /*#__PURE__*/pose({
  posePriority: ['drag', 'press', 'focus', 'hover'],
  transformPose: function (_a, name, state) {
    var flip = _a.flip,
        pose$$1 = __rest$1(_a, ["flip"]);

    if (isFlipPose(flip, name, state)) {
      return flipPose(state, pose$$1);
    } else if (isPositional(pose$$1)) {
      return convertPositionalUnits(state, pose$$1);
    }

    return pose$$1;
  },
  forceRender: function (_a) {
    var elementStyler = _a.elementStyler;
    elementStyler.render();
  },
  addListenerToValue: function (key, elementStyler) {
    return function (v) {
      return elementStyler.set(key, v);
    };
  },
  readValueFromSource: function (key, _a) {
    var elementStyler = _a.elementStyler,
        dragBounds = _a.dragBounds;
    var value$$1 = elementStyler.get(key);

    if (dragBounds && (key === 'x' || key === 'y')) {
      var bound = key === 'x' ? dragBounds.left || dragBounds.right : dragBounds.top || dragBounds.bottom;

      if (bound) {
        var boundType = getValueType$1(bound);
        value$$1 = boundType.transform(value$$1);
      }
    }

    return isNaN(value$$1) ? value$$1 : parseFloat(value$$1);
  },
  setValueNative: function (key, to, _a) {
    var elementStyler = _a.elementStyler;
    return elementStyler.set(key, to);
  },
  extendAPI: function (api, _a, config) {
    var props = _a.props,
        activeActions = _a.activeActions;
    var measure = props.dimensions.measure;

    var poserApi = __assign$7(__assign$7({}, api), {
      addChild: function (element, childConfig) {
        return api._addChild(createPoseConfig(element, childConfig), domPose);
      },
      measure: measure,
      flip: function (op) {
        if (op) {
          measure();
          op();
        }

        return api.set('flip');
      }
    });

    props.elementStyler.render();
    appendEventListeners(props.element, activeActions, poserApi, config);
    return poserApi;
  }
});

var domPose$1 = function (element, config) {
  return domPose(createPoseConfig(element, config));
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index$2 = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var hasChanged = function (prev, next) {
  if (prev === next) return false;
  var prevIsArray = Array.isArray(prev);
  var nextIsArray = Array.isArray(next);

  if (prevIsArray !== nextIsArray || !prevIsArray && !nextIsArray) {
    return true;
  } else if (prevIsArray && nextIsArray) {
    var numPrev = prev.length;
    var numNext = next.length;
    if (numPrev !== numNext) return true;

    for (var i = 0; i < numPrev; i++) {
      if (prev[i] !== next[i]) return true;
    }
  }

  return false;
};

var pickAssign = function (shouldPick, sources) {
  return sources.reduce(function (picked, source) {
    for (var key in source) {
      if (shouldPick(key)) {
        picked[key] = source[key];
      }
    }

    return picked;
  }, {});
};

var _a$2 = createContext({}),
    PoseParentConsumer = _a$2.Consumer,
    PoseParentProvider = _a$2.Provider;

var calcPopFromFlowStyle = function (el) {
  var offsetTop = el.offsetTop,
      offsetLeft = el.offsetLeft,
      offsetWidth = el.offsetWidth,
      offsetHeight = el.offsetHeight;
  return {
    position: 'absolute',
    top: offsetTop,
    left: offsetLeft,
    width: offsetWidth,
    height: offsetHeight
  };
};

var hasPose = function (pose, key) {
  return Array.isArray(pose) ? pose.indexOf(key) !== -1 : pose === key;
};

var objectToMap = function (obj) {
  return Object.keys(obj).reduce(function (map, key) {
    map.set(key, {
      raw: obj[key]
    });
    return map;
  }, new Map());
};

var testAlwaysTrue = function () {
  return true;
};

var filterProps = function (_a) {
  var elementType = _a.elementType,
      poseConfig = _a.poseConfig,
      onValueChange = _a.onValueChange,
      innerRef = _a.innerRef,
      _pose = _a._pose,
      pose = _a.pose,
      initialPose = _a.initialPose,
      poseKey = _a.poseKey,
      onPoseComplete = _a.onPoseComplete,
      getParentPoseConfig = _a.getParentPoseConfig,
      registerChild = _a.registerChild,
      onUnmount = _a.onUnmount,
      getInitialPoseFromParent = _a.getInitialPoseFromParent,
      popFromFlow = _a.popFromFlow,
      values = _a.values,
      parentValues = _a.parentValues,
      onDragStart = _a.onDragStart,
      onDragEnd = _a.onDragEnd,
      onPressStart = _a.onPressStart,
      onPressEnd = _a.onPressEnd,
      props = __rest(_a, ["elementType", "poseConfig", "onValueChange", "innerRef", "_pose", "pose", "initialPose", "poseKey", "onPoseComplete", "getParentPoseConfig", "registerChild", "onUnmount", "getInitialPoseFromParent", "popFromFlow", "values", "parentValues", "onDragStart", "onDragEnd", "onPressStart", "onPressEnd"]);

  return props;
};

var PoseElement = function (_super) {
  __extends(PoseElement, _super);

  function PoseElement(props) {
    var _this = _super.call(this, props) || this;

    _this.children = new Set();
    _this.childrenHandlers = {
      registerChild: function (props) {
        _this.children.add(props);

        if (_this.poser) _this.flushChildren();
      },
      onUnmount: function (child) {
        return _this.poser.removeChild(child);
      },
      getParentPoseConfig: function () {
        return _this.poseConfig;
      },
      getInitialPoseFromParent: function () {
        return _this.getInitialPose();
      }
    };

    _this.setRef = function (ref) {
      warning(ref === null || ref instanceof Element && _this.ref === undefined, 'ref must be provided to the same DOM component for the entire lifecycle of a posed component.');
      _this.ref = ref;
      var innerRef = _this.props.innerRef;
      if (!innerRef) return;

      if (typeof innerRef === 'function') {
        innerRef(ref);
      } else {
        innerRef.current = ref;
      }
    };

    _this.shouldForwardProp = typeof _this.props.elementType === 'string' ? index$2 : testAlwaysTrue;
    var poseConfig = _this.props.poseConfig;
    _this.poseConfig = typeof poseConfig === 'function' ? poseConfig(filterProps(props)) : poseConfig;
    return _this;
  }

  PoseElement.prototype.getInitialPose = function () {
    var _a = this.props,
        getInitialPoseFromParent = _a.getInitialPoseFromParent,
        pose = _a.pose,
        _pose = _a._pose,
        initialPose = _a.initialPose;

    if (initialPose) {
      return initialPose;
    } else {
      var parentPose = getInitialPoseFromParent && getInitialPoseFromParent();
      var initialPoses = (Array.isArray(parentPose) ? parentPose : [parentPose]).concat(pose, _pose).filter(Boolean);
      return initialPoses.length > 0 ? initialPoses : undefined;
    }
  };

  PoseElement.prototype.getFirstPose = function () {
    var _a = this.props,
        initialPose = _a.initialPose,
        pose = _a.pose,
        _pose = _a._pose;
    if (!initialPose) return;
    var firstPose = (Array.isArray(pose) ? pose : [pose]).concat(_pose).filter(Boolean);
    return firstPose.length === 1 ? firstPose[0] : firstPose;
  };

  PoseElement.prototype.getSetProps = function () {
    var props = filterProps(this.props);

    if (this.props.popFromFlow && this.ref && this.ref instanceof HTMLElement) {
      if (!this.popStyle) {
        props.style = __assign(__assign({}, props.style), calcPopFromFlowStyle(this.ref));
        this.popStyle = props.style;
      } else {
        props.style = this.popStyle;
      }
    } else {
      this.popStyle = null;
    }

    return props;
  };

  PoseElement.prototype.componentDidMount = function () {
    var _this = this;

    invariant(this.ref instanceof Element, "No valid DOM ref found. If you're converting an existing component via posed(Component), you must ensure you're passing the ref to the host DOM node via the React.forwardRef function.");
    var _a = this.props,
        onValueChange = _a.onValueChange,
        registerChild = _a.registerChild,
        values = _a.values,
        parentValues = _a.parentValues,
        onDragStart = _a.onDragStart,
        onDragEnd = _a.onDragEnd,
        onPressStart = _a.onPressStart,
        onPressEnd = _a.onPressEnd;

    var config = __assign(__assign({}, this.poseConfig), {
      initialPose: this.getInitialPose(),
      values: values || this.poseConfig.values,
      parentValues: parentValues ? objectToMap(parentValues) : undefined,
      props: this.getSetProps(),
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      onPressStart: onPressStart,
      onPressEnd: onPressEnd,
      onChange: onValueChange
    });

    if (!registerChild) {
      this.initPoser(domPose$1(this.ref, config));
    } else {
      registerChild({
        element: this.ref,
        poseConfig: config,
        onRegistered: function (poser) {
          return _this.initPoser(poser);
        }
      });
    }
  };

  PoseElement.prototype.getSnapshotBeforeUpdate = function () {
    var _a = this.props,
        pose = _a.pose,
        _pose = _a._pose;
    if (hasPose(pose, 'flip') || hasPose(_pose, 'flip')) this.poser.measure();
    return null;
  };

  PoseElement.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        pose = _a.pose,
        _pose = _a._pose,
        poseKey = _a.poseKey;
    this.poser.setProps(this.getSetProps());

    if (poseKey !== prevProps.poseKey || hasChanged(prevProps.pose, pose) || pose === 'flip') {
      this.setPose(pose);
    }

    if (_pose !== prevProps._pose || _pose === 'flip') this.setPose(_pose);
  };

  PoseElement.prototype.componentWillUnmount = function () {
    if (!this.poser) return;
    var onUnmount = this.props.onUnmount;
    if (onUnmount) onUnmount(this.poser);
    this.poser.destroy();
  };

  PoseElement.prototype.initPoser = function (poser) {
    this.poser = poser;
    this.flushChildren();
    var firstPose = this.getFirstPose();
    if (firstPose) this.setPose(firstPose);
  };

  PoseElement.prototype.setPose = function (pose) {
    var _this = this;

    var onPoseComplete = this.props.onPoseComplete;
    var poseList = Array.isArray(pose) ? pose : [pose];
    Promise.all(poseList.map(function (key) {
      return key && _this.poser.set(key);
    })).then(function () {
      return onPoseComplete && onPoseComplete(pose);
    });
  };

  PoseElement.prototype.flushChildren = function () {
    var _this = this;

    this.children.forEach(function (_a) {
      var element = _a.element,
          poseConfig = _a.poseConfig,
          onRegistered = _a.onRegistered;
      return onRegistered(_this.poser.addChild(element, poseConfig));
    });
    this.children.clear();
  };

  PoseElement.prototype.render = function () {
    var elementType = this.props.elementType;
    return React__default.createElement(PoseParentProvider, {
      value: this.childrenHandlers
    }, createElement(elementType, pickAssign(this.shouldForwardProp, [this.getSetProps(), {
      ref: this.setRef
    }])));
  };

  return PoseElement;
}(PureComponent);

var supportedElements = ['a', 'article', 'aside', 'audio', 'b', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dialog', 'div', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'label', 'legend', 'li', 'nav', 'object', 'ol', 'option', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'section', 'select', 'span', 'strong', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'ul', 'video', 'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
var componentCache = new Map();

var createComponentFactory = function (key) {
  var componentFactory = function (poseConfig) {
    if (poseConfig === void 0) {
      poseConfig = {};
    }

    return forwardRef(function (_a, ref) {
      var _b = _a.withParent,
          withParent = _b === void 0 ? true : _b,
          props = __rest(_a, ["withParent"]);

      warning(props.innerRef === undefined, 'innerRef is deprecated. Please use ref instead.');
      return !withParent || props.parentValues ? React__default.createElement(PoseElement, __assign({
        poseConfig: poseConfig,
        innerRef: ref,
        elementType: key
      }, props)) : React__default.createElement(PoseParentConsumer, null, function (parentCtx) {
        return React__default.createElement(PoseElement, __assign({
          poseConfig: poseConfig,
          elementType: key,
          innerRef: ref
        }, props, parentCtx));
      });
    });
  };

  componentCache.set(key, componentFactory);
  return componentFactory;
};

var getComponentFactory = function (key) {
  return componentCache.has(key) ? componentCache.get(key) : createComponentFactory(key);
};

var posed = function (component) {
  return getComponentFactory(component);
};

supportedElements.reduce(function (acc, key) {
  acc[key] = createComponentFactory(key);
  return acc;
}, posed);

var getKey = function (child) {
  invariant(child && child.key !== null, 'Every child of Transition must be given a unique key');
  var childKey = typeof child.key === 'number' ? child.key.toString() : child.key;
  return childKey.replace('.$', '');
};

var prependProps = function (element, props) {
  return createElement(element.type, __assign(__assign({
    key: element.key,
    ref: element.ref
  }, props), element.props));
};

var handleTransition = function (_a, _b) {
  var displayedChildren = _b.displayedChildren,
      finishedLeaving = _b.finishedLeaving,
      hasInitialized = _b.hasInitialized,
      indexedChildren = _b.indexedChildren,
      scheduleChildRemoval = _b.scheduleChildRemoval;

  var incomingChildren = _a.children,
      preEnterPose = _a.preEnterPose,
      enterPose = _a.enterPose,
      exitPose = _a.exitPose,
      animateOnMount = _a.animateOnMount,
      enterAfterExit = _a.enterAfterExit,
      flipMove = _a.flipMove,
      onRest = _a.onRest,
      propsForChildren = __rest(_a, ["children", "preEnterPose", "enterPose", "exitPose", "animateOnMount", "enterAfterExit", "flipMove", "onRest"]);

  var targetChildren = makeChildList(incomingChildren);
  var nextState = {
    displayedChildren: []
  };

  if (process.env.NODE_ENV !== 'production') {
    warning(!propsForChildren.onPoseComplete, "<Transition/> (or <PoseGroup/>) doesn't accept onPoseComplete prop.");
  }

  var prevKeys = displayedChildren.map(getKey);
  var nextKeys = targetChildren.map(getKey);
  var hasPropsForChildren = Object.keys(propsForChildren).length !== 0;
  var entering = new Set(nextKeys.filter(function (key) {
    return finishedLeaving.hasOwnProperty(key) || prevKeys.indexOf(key) === -1;
  }));
  entering.forEach(function (key) {
    return delete finishedLeaving[key];
  });
  var leaving = [];
  var newlyLeaving = {};
  prevKeys.forEach(function (key) {
    if (entering.has(key)) {
      return;
    }

    var isLeaving = finishedLeaving.hasOwnProperty(key);

    if (!isLeaving && nextKeys.indexOf(key) !== -1) {
      return;
    }

    leaving.push(key);

    if (!isLeaving) {
      finishedLeaving[key] = false;
      newlyLeaving[key] = true;
    }
  });
  var moving = new Set(prevKeys.filter(function (key, i) {
    return !entering.has(key) || leaving.indexOf(key) === -1;
  }));
  targetChildren.forEach(function (child) {
    var newChildProps = {};

    if (entering.has(child.key)) {
      if (hasInitialized || animateOnMount) {
        newChildProps.initialPose = preEnterPose;
      }

      newChildProps._pose = enterPose;
    } else if (moving.has(child.key) && flipMove) {
      newChildProps._pose = [enterPose, 'flip'];
    } else {
      newChildProps._pose = enterPose;
    }

    var newChild = cloneElement(child, newChildProps);
    indexedChildren[child.key] = newChild;
    nextState.displayedChildren.push(hasPropsForChildren ? prependProps(newChild, propsForChildren) : newChild);
  });
  leaving.forEach(function (key) {
    var child = indexedChildren[key];
    var newChild = newlyLeaving[key] ? cloneElement(child, {
      _pose: exitPose,
      onPoseComplete: function (pose) {
        if (pose === exitPose) scheduleChildRemoval(key);
        var onPoseComplete = child.props.onPoseComplete;
        if (onPoseComplete) onPoseComplete(pose);
      },
      popFromFlow: flipMove
    }) : child;
    var insertionIndex = prevKeys.indexOf(key);
    indexedChildren[child.key] = newChild;
    nextState.displayedChildren.splice(insertionIndex, 0, hasPropsForChildren ? prependProps(newChild, propsForChildren) : newChild);
  });
  return nextState;
};

var handleChildrenTransitions = function (props, state) {
  var newState = handleTransition(props, state);
  newState.hasInitialized = true;
  return newState;
};

var makeChildList = function (children) {
  var list = [];
  Children.forEach(children, function (child) {
    return child && list.push(child);
  });
  return list;
};

var Transition = function (_super) {
  __extends(Transition, _super);

  function Transition() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      displayedChildren: [],
      finishedLeaving: {},
      hasInitialized: false,
      indexedChildren: {},
      scheduleChildRemoval: function (key) {
        return _this.removeChild(key);
      }
    };
    return _this;
  }

  Transition.prototype.removeChild = function (key) {
    var _a = this.state,
        displayedChildren = _a.displayedChildren,
        finishedLeaving = _a.finishedLeaving;
    var _b = this.props,
        enterAfterExit = _b.enterAfterExit,
        onRest = _b.onRest;
    if (!finishedLeaving.hasOwnProperty(key)) return;
    finishedLeaving[key] = true;

    if (!Object.keys(finishedLeaving).every(function (leavingKey) {
      return finishedLeaving[leavingKey];
    })) {
      return;
    }

    var targetChildren = displayedChildren.filter(function (child) {
      return !finishedLeaving.hasOwnProperty(child.key);
    });
    var newState = enterAfterExit ? __assign({
      finishedLeaving: {}
    }, handleChildrenTransitions(__assign(__assign({}, this.props), {
      enterAfterExit: false
    }), __assign(__assign({}, this.state), {
      displayedChildren: targetChildren
    }))) : {
      finishedLeaving: {},
      displayedChildren: targetChildren
    };
    this.setState(newState, onRest);
  };

  Transition.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    return this.state !== nextState;
  };

  Transition.prototype.render = function () {
    return this.state.displayedChildren;
  };

  Transition.defaultProps = {
    flipMove: false,
    enterAfterExit: false,
    preEnterPose: 'exit',
    enterPose: 'enter',
    exitPose: 'exit'
  };
  Transition.getDerivedStateFromProps = handleChildrenTransitions;
  return Transition;
}(Component);

var PoseGroup = function (_super) {
  __extends(PoseGroup, _super);

  function PoseGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PoseGroup.prototype.render = function () {
    return createElement(Transition, __assign({}, this.props));
  };

  PoseGroup.defaultProps = {
    flipMove: true
  };
  return PoseGroup;
}(Component);

var Notification = posed.div({
  enter: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: 0
  }
});
var NotificationsList = function NotificationsList(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _onDismiss = _ref.onDismiss;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovering = _useState2[0],
      setIsHovering = _useState2[1];

  var isTypeValid = function isTypeValid(type) {
    return MessageBarType[type] !== undefined;
  };

  var copyToClipboard = function copyToClipboard(text) {
    navigator.clipboard.writeText(text);
  };

  return /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        position: "fixed",
        bottom: 20,
        right: 20,
        width: 400,
        zIndex: 1000001
      }
    }
  }, /*#__PURE__*/React__default.createElement(PoseGroup, null, items.map(function (item) {
    return /*#__PURE__*/React__default.createElement(Notification, {
      key: item.key,
      style: {
        marginBottom: 16
      }
    }, /*#__PURE__*/React__default.createElement(MessageBar, {
      messageBarType: isTypeValid(item.type) ? MessageBarType[item.type] : MessageBarType.info,
      onDismiss: function onDismiss() {
        return _onDismiss(item.key);
      }
    }, /*#__PURE__*/React__default.createElement(item.message, null), item.traceId && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Text, {
      variant: "xSmall",
      styles: {
        root: {
          position: "relative",
          width: "100%",
          paddingRight: 50
        }
      },
      onMouseEnter: function onMouseEnter() {
        return setIsHovering(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHovering(false);
      }
    }, i18n._(
    /*i18n*/
    {
      id: "Trace id:"
    }), " ", item.traceId, isHovering && /*#__PURE__*/React__default.createElement(IconButton, {
      styles: {
        root: {
          color: "black",
          width: 20,
          height: 20,
          marginBottom: -3,
          padding: "5px",
          position: "absolute",
          right: "5%",
          top: "50%",
          transform: "translateY(-50%)"
        },
        rootHovered: {
          color: "black",
          backgroundColor: "#f4d3d5",
          borderRadius: "5px",
          padding: "5px"
        }
      },
      iconProps: {
        iconName: "Copy"
      },
      onClick: function onClick() {
        return copyToClipboard("".concat(item.message(), "\n").concat(i18n._(
        /*i18n*/
        {
          id: "trace id:"
        }), " ").concat(item.traceId));
      }
    })))));
  })));
};

// Dashboard.

function DashboardLink(_ref) {
  var url = _ref.url;
  return /*#__PURE__*/React__default.createElement(Stack, {
    verticalAlign: "center",
    styles: {
      root: {
        width: 150,
        position: "absolute",
        top: 0,
        right: 0,
        backgroundColor: DefaultPalette$2.white,
        fontSize: 21,
        height: 50
      }
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    className: "unstyled-link",
    href: url
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    styles: {
      root: {
        color: DefaultPalette$2.themeSecondary
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xLarge",
    styles: {
      root: {
        marginRight: 4,
        paddingBottom: 4
      }
    }
  }, "Dashboard"), /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "NavigateForward"
  }))));
}

var config = {
  large: {
    stackRoot: {
      width: 88,
      height: 88,
      cursor: "pointer",
      selectors: {
        "&:hover": {
          boxShadow: DefaultEffects$2.elevation8
        }
      }
    },
    stackRootDisabled: {
      width: 88,
      height: 88
    },
    horizontal: false,
    horizontalAlign: "center",
    verticalAlign: "center",
    imageStyles: {
      height: 48,
      width: 48,
      imageRoot: {}
    },
    nameStyles: {
      nameRoot: {
        textAlign: "center",
        width: 80
      }
    }
  },
  medium: {
    stackRoot: {
      width: 143,
      height: 36,
      padding: 4,
      selectors: {
        "&:hover": {
          boxShadow: DefaultEffects$2.elevation8
        }
      }
    },
    horizontal: true,
    horizontalAlign: "start",
    verticalAlign: "center",
    imageStyles: {
      height: 24,
      width: 24,
      imageRoot: {
        marginRight: 4,
        marginLeft: 4
      }
    },
    nameStyles: {
      nameRoot: {
        marginLeft: 4
      }
    }
  }
};
function AppTile(_ref) {
  var app = _ref.app,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size;
  var _config$size = config[size],
      stackRoot = _config$size.stackRoot,
      horizontal = _config$size.horizontal,
      horizontalAlign = _config$size.horizontalAlign,
      verticalAlign = _config$size.verticalAlign,
      imageStyles = _config$size.imageStyles,
      nameStyles = _config$size.nameStyles;
  var nameEl = useRef();
  return /*#__PURE__*/React__default.createElement(TooltipHost, {
    calloutProps: {
      doNotLayer: true
    },
    content: nameEl.current && nameEl.current.offsetWidth > nameStyles.nameRoot.width ? app.name : undefined
  }, /*#__PURE__*/React__default.createElement("a", {
    className: "unstyled-link",
    href: app.systemUrl,
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: horizontal,
    horizontalAlign: horizontalAlign,
    verticalAlign: verticalAlign,
    styles: {
      root: stackRoot
    }
  }, /*#__PURE__*/React__default.createElement(Image, {
    height: imageStyles.height,
    width: imageStyles.width,
    styles: {
      root: imageStyles.imageRoot
    },
    src: app.iconUrl
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium",
    styles: {
      root: nameStyles.nameRoot
    },
    block: true,
    nowrap: true
  }, /*#__PURE__*/React__default.createElement("span", {
    ref: nameEl
  }, app.name)))));
}

/**
 * Enumeration of icon file names, and what extensions they map to.
 * Please keep items alphabetical. Items without extensions may require specific logic in the code to map.
 * Always use getFileTypeIconProps to get the most up-to-date icon at the right pixel density.
 */
var FileTypeIconMap$1 = {
  accdb: {
    extensions: ['accdb', 'mdb']
  },
  archive: {
    extensions: ['7z', 'ace', 'arc', 'arj', 'dmg', 'gz', 'iso', 'lzh', 'pkg', 'rar', 'sit', 'tgz', 'tar', 'z']
  },
  audio: {
    extensions: ['aif', 'aiff', 'aac', 'alac', 'amr', 'ape', 'au', 'awb', 'dct', 'dss', 'dvf', 'flac', 'gsm', 'm4a', 'm4p', 'mid', 'mmf', 'mp3', 'oga', 'ra', 'rm', 'wav', 'wma', 'wv']
  },
  calendar: {
    extensions: ['ical', 'icalendar', 'ics', 'ifb', 'vcs']
  },
  code: {
    extensions: ['abap', 'ada', 'adp', 'ahk', 'as', 'as3', 'asc', 'ascx', 'asm', 'asp', 'awk', 'bash', 'bash_login', 'bash_logout', 'bash_profile', 'bashrc', 'bat', 'bib', 'bsh', 'build', 'builder', 'c', 'cbl', 'c++', 'capfile', 'cc', 'cfc', 'cfm', 'cfml', 'cl', 'clj', 'cls', 'cmake', 'cmd', 'coffee', 'config', 'cpp', 'cpt', 'cpy', 'cs', 'cshtml', 'cson', 'csproj', 'css', 'ctp', 'cxx', 'd', 'ddl', 'di', 'disco', 'dml', 'dtd', 'dtml', 'el', 'emakefile', 'erb', 'erl', 'f', 'f90', 'f95', 'fs', 'fsi', 'fsscript', 'fsx', 'gemfile', 'gemspec', 'gitconfig', 'go', 'groovy', 'gvy', 'h', 'h++', 'haml', 'handlebars', 'hbs', 'hcp', 'hh', 'hpp', 'hrl', 'hs', 'htc', 'hxx', 'idl', 'iim', 'inc', 'inf', 'ini', 'inl', 'ipp', 'irbrc', 'jade', 'jav', 'java', 'js', 'json', 'jsp', 'jsproj', 'jsx', 'l', 'less', 'lhs', 'lisp', 'log', 'lst', 'ltx', 'lua', 'm', 'mak', 'make', 'manifest', 'master', 'md', 'markdn', 'markdown', 'mdown', 'mkdn', 'ml', 'mli', 'mll', 'mly', 'mm', 'mud', 'nfo', 'opml', 'osascript', 'p', 'pas', 'patch', 'php', 'php2', 'php3', 'php4', 'php5', 'phtml', 'pl', 'pm', 'pod', 'pp', 'profile', 'ps1', 'ps1xml', 'psd1', 'psm1', 'pss', 'pt', 'py', 'pyw', 'r', 'rake', 'rb', 'rbx', 'rc', 'rdf', 're', 'reg', 'rest', 'resw', 'resx', 'rhtml', 'rjs', 'rprofile', 'rpy', 'rss', 'rst', 'ruby', 'rxml', 's', 'sass', 'scala', 'scm', 'sconscript', 'sconstruct', 'script', 'scss', 'sgml', 'sh', 'shtml', 'sml', 'svn-base', 'swift', 'sql', 'sty', 'tcl', 'tex', 'textile', 'tld', 'tli', 'tmpl', 'tpl', 'vb', 'vi', 'vim', 'vmg', 'webpart', 'wsp', 'wsdl', 'xhtml', 'xoml', 'xsd', 'xslt', 'yaml', 'yaws', 'yml', 'zsh']
  },
  contact: {
    extensions: ['vcf']
  },

  /*  css: {},  not broken out yet, snapping to 'code' for now */
  csv: {
    extensions: ['csv']
  },
  desktopfolder: {},
  docset: {},
  documentfolder: {},
  docx: {
    extensions: ['doc', 'docm', 'docx', 'docb']
  },
  dotx: {
    extensions: ['dot', 'dotm', 'dotx']
  },
  email: {
    extensions: ['eml', 'msg', 'oft', 'ost', 'pst']
  },
  exe: {
    extensions: ['application', 'appref-ms', 'apk', 'app', 'appx', 'exe', 'ipa', 'msi', 'xap']
  },
  folder: {},
  font: {
    extensions: ['ttf', 'otf', 'woff']
  },
  fluid: {
    extensions: ['fluid', 'loop']
  },
  form: {},
  genericfile: {},
  html: {
    extensions: ['htm', 'html', 'mht']
  },
  link: {
    extensions: ['lnk', 'link', 'url', 'website', 'webloc']
  },
  linkedfolder: {},
  listitem: {},
  officescript: {
    extensions: ['osts']
  },
  splist: {},
  model: {
    extensions: ['3ds', '3mf', 'blend', 'cool', 'dae', 'df', 'dwfx', 'dwg', 'dxf', 'fbx', 'glb', 'gltf', 'holo', 'layer', 'layout', 'max', 'mcworld', 'mtl', 'obj', 'off', 'ply', 'skp', 'stp', 'stl', 't', 'thl', 'x']
  },
  mpp: {
    extensions: ['mpp']
  },
  mpt: {
    extensions: ['mpt']
  },
  multiple: {},
  one: {
    // This represents a single Fluid Note, or a partial exported section/page of a notebook.
    extensions: ['note', 'one']
  },
  onetoc: {
    extensions: ['ms-one-stub', 'onetoc', 'onetoc2', 'onepkg']
  },
  pbiapp: {},
  pdf: {
    extensions: ['pdf']
  },
  photo: {
    extensions: ['arw', 'bmp', 'cr2', 'crw', 'dic', 'dicm', 'dcm', 'dcm30', 'dcr', 'dds', 'dib', 'dng', 'erf', 'gif', 'heic', 'heif', 'ico', 'jfi', 'jfif', 'jif', 'jpe', 'jpeg', 'jpg', 'jxr', 'kdc', 'mrw', 'nef', 'orf', 'pct', 'pict', 'png', 'pns', 'psb', 'psd', 'raw', 'tga', 'tif', 'tiff', 'wdp']
  },
  photo360: {},
  picturesfolder: {},
  potx: {
    extensions: ['pot', 'potm', 'potx']
  },
  powerbi: {
    extensions: ['pbids', 'pbix']
  },
  ppsx: {
    extensions: ['pps', 'ppsm', 'ppsx']
  },
  pptx: {
    extensions: ['ppt', 'pptm', 'pptx', 'sldx', 'sldm']
  },
  presentation: {
    extensions: ['odp', 'gslides', 'key']
  },
  pub: {
    extensions: ['pub']
  },
  spo: {
    extensions: ['aspx', 'classifier']
  },
  sponews: {},
  spreadsheet: {
    extensions: ['odc', 'ods', 'gsheet', 'numbers', 'tsv']
  },
  stream: {},
  rtf: {
    extensions: ['epub', 'gdoc', 'odt', 'rtf', 'wri', 'pages']
  },
  sharedfolder: {},
  sway: {},
  sysfile: {
    extensions: ['bak', 'bin', 'cab', 'cache', 'cat', 'cer', 'class', 'dat', 'db', 'dbg', 'dl_', 'dll', 'ithmb', 'jar', 'kb', 'ldt', 'lrprev', 'pkpass', 'ppa', 'ppam', 'pdb', 'rom', 'thm', 'thmx', 'vsl', 'xla', 'xlam', 'xlb', 'xll']
  },
  txt: {
    extensions: ['dif', 'diff', 'readme', 'out', 'plist', 'properties', 'text', 'txt']
  },
  vaultclosed: {},
  vaultopen: {},
  vector: {
    extensions: ['ai', 'ait', 'cvs', 'dgn', 'gdraw', 'pd', 'emf', 'eps', 'fig', 'ind', 'indd', 'indl', 'indt', 'indb', 'ps', 'svg', 'svgz', 'wmf', 'oxps', 'xps', 'xd', 'sketch']
  },
  video: {
    extensions: ['3g2', '3gp', '3gp2', '3gpp', 'asf', 'avi', 'dvr-ms', 'flv', 'm1v', 'm4v', 'mkv', 'mod', 'mov', 'mm4p', 'mp2', 'mp2v', 'mp4', 'mp4v', 'mpa', 'mpe', 'mpeg', 'mpg', 'mpv', 'mpv2', 'mts', 'ogg', 'qt', 'swf', 'ts', 'vob', 'webm', 'wlmp', 'wm', 'wmv', 'wmx']
  },
  video360: {},
  vsdx: {
    extensions: ['vdx', 'vsd', 'vsdm', 'vsdx', 'vsw', 'vdw']
  },
  vssx: {
    extensions: ['vss', 'vssm', 'vssx']
  },
  vstx: {
    extensions: ['vst', 'vstm', 'vstx', 'vsx']
  },
  whiteboard: {
    extensions: ['whiteboard']
  },
  xlsx: {
    extensions: ['xlc', 'xls', 'xlsb', 'xlsm', 'xlsx', 'xlw']
  },
  xltx: {
    extensions: ['xlt', 'xltm', 'xltx']
  },
  xml: {
    extensions: ['xaml', 'xml', 'xsl']
  },
  xsn: {
    extensions: ['xsn']
  },
  zip: {
    extensions: ['zip']
  }
};

/**
 * Enumerates special file type icons that do not map to any file extensions.
 * For example, the 'pptx' icon maps to the extensions 'ppt', 'pptm', 'pptx',
 * but the 'folder' icon does not map to any extensions and should be obtained
 * via this enum.
 */
var FileIconType;

(function (FileIconType) {
  FileIconType[FileIconType["docset"] = 1] = "docset";
  FileIconType[FileIconType["folder"] = 2] = "folder";
  FileIconType[FileIconType["genericFile"] = 3] = "genericFile";
  FileIconType[FileIconType["listItem"] = 4] = "listItem";
  FileIconType[FileIconType["sharedFolder"] = 5] = "sharedFolder";
  FileIconType[FileIconType["multiple"] = 6] = "multiple";
  FileIconType[FileIconType["stream"] = 7] = "stream";
  FileIconType[FileIconType["news"] = 8] = "news";
  FileIconType[FileIconType["desktopFolder"] = 9] = "desktopFolder";
  FileIconType[FileIconType["documentsFolder"] = 10] = "documentsFolder";
  FileIconType[FileIconType["picturesFolder"] = 11] = "picturesFolder";
  FileIconType[FileIconType["linkedFolder"] = 12] = "linkedFolder";
  FileIconType[FileIconType["list"] = 13] = "list";
  FileIconType[FileIconType["form"] = 14] = "form";
  FileIconType[FileIconType["sway"] = 15] = "sway";
})(FileIconType || (FileIconType = {}));

var _extensionToIconName;

var GENERIC_FILE = 'genericfile';
var FOLDER = 'folder';
var SHARED_FOLDER = 'sharedfolder';
var DOCSET_FOLDER = 'docset';
var LIST_ITEM = 'listitem';
var LIST = 'splist';
var MULTIPLE_ITEMS = 'multiple';
var NEWS = 'sponews';
var STREAM = 'stream';
var DESKTOP_FOLDER = 'desktopfolder';
var DOCUMENTS_FOLDER = 'documentfolder';
var PICTURES_FOLDER = 'picturesfolder';
var LINKED_FOLDER = 'linkedfolder';
var FORM = 'form';
var SWAY = 'sway';
var DEFAULT_ICON_SIZE = 16;
/**
 * This function returns properties for a file type icon given the IFileTypeIconOptions.
 * It accounts for different device pixel ratios. For example,
 * getFileTypeIconProps({extension: 'doc', size: 16, imageFileType: 'png'})
 * will return { iconName: 'docx16_2x_png' } if the devicePixelRatio is 2.
 *
 * @param options
 */

function getFileTypeIconProps(options) {
  // First, obtain the base name of the icon using the extension or type.
  var iconBaseName;
  var extension = options.extension,
      type = options.type,
      size = options.size,
      imageFileType = options.imageFileType;
  iconBaseName = getFileTypeIconNameFromExtensionOrType(extension, type); // Next, obtain the suffix using the icon size, user's device pixel ratio, and
  // preference for svg or png

  var _size = size || DEFAULT_ICON_SIZE;

  var suffix = getFileTypeIconSuffix(_size, imageFileType);
  return {
    iconName: iconBaseName + suffix,
    'aria-label': extension
  };
}
function getFileTypeIconNameFromExtensionOrType(extension, type) {
  var iconBaseName;

  if (extension) {
    if (!_extensionToIconName) {
      _extensionToIconName = {};

      for (var iconName in FileTypeIconMap$1) {
        if (FileTypeIconMap$1.hasOwnProperty(iconName)) {
          var extensions = FileTypeIconMap$1[iconName].extensions;

          if (extensions) {
            for (var i = 0; i < extensions.length; i++) {
              _extensionToIconName[extensions[i]] = iconName;
            }
          }
        }
      }
    } // Strip periods, force lowercase.


    extension = extension.replace('.', '').toLowerCase();
    return _extensionToIconName[extension] || GENERIC_FILE;
  } else if (type) {
    switch (type) {
      case FileIconType.docset:
        iconBaseName = DOCSET_FOLDER;
        break;

      case FileIconType.folder:
        iconBaseName = FOLDER;
        break;

      case FileIconType.listItem:
        iconBaseName = LIST_ITEM;
        break;

      case FileIconType.sharedFolder:
        iconBaseName = SHARED_FOLDER;
        break;

      case FileIconType.stream:
        iconBaseName = STREAM;
        break;

      case FileIconType.multiple:
        iconBaseName = MULTIPLE_ITEMS;
        break;

      case FileIconType.news:
        iconBaseName = NEWS;
        break;

      case FileIconType.desktopFolder:
        iconBaseName = DESKTOP_FOLDER;
        break;

      case FileIconType.documentsFolder:
        iconBaseName = DOCUMENTS_FOLDER;
        break;

      case FileIconType.picturesFolder:
        iconBaseName = PICTURES_FOLDER;
        break;

      case FileIconType.linkedFolder:
        iconBaseName = LINKED_FOLDER;
        break;

      case FileIconType.list:
        iconBaseName = LIST;
        break;

      case FileIconType.form:
        iconBaseName = FORM;
        break;

      case FileIconType.sway:
        iconBaseName = SWAY;
        break;
    }
  }

  return iconBaseName || GENERIC_FILE;
}
function getFileTypeIconSuffix(size, imageFileType) {
  if (imageFileType === void 0) {
    imageFileType = 'svg';
  }

  var devicePixelRatio = window.devicePixelRatio;
  var devicePixelRatioSuffix = ''; // Default is 1x
  // SVGs scale well, so you can generally use the default image.
  // 1.5x is a special case where SVGs need a different image.

  if (imageFileType === 'svg' && devicePixelRatio > 1 && devicePixelRatio <= 1.5) {
    // Currently missing 1.5x SVGs at size 20, snap to 1x for now
    if (size !== 20) {
      devicePixelRatioSuffix = '_1.5x';
    }
  } else if (imageFileType === 'png') {
    // To look good, PNGs should use a different image for higher device pixel ratios
    if (devicePixelRatio > 1 && devicePixelRatio <= 1.5) {
      // Currently missing 1.5x icons for size 20, snap to 2x for now
      devicePixelRatioSuffix = size === 20 ? '_2x' : '_1.5x';
    } else if (devicePixelRatio > 1.5 && devicePixelRatio <= 2) {
      devicePixelRatioSuffix = '_2x';
    } else if (devicePixelRatio > 2 && devicePixelRatio <= 3) {
      devicePixelRatioSuffix = '_3x';
    } else if (devicePixelRatio > 3) {
      devicePixelRatioSuffix = '_4x';
    }
  }

  return size + devicePixelRatioSuffix + '_' + imageFileType;
}

var config$1 = {
  large: {
    stackRoot: {
      width: 88,
      height: 88,
      cursor: "pointer",
      selectors: {
        "&:hover": {
          boxShadow: DefaultEffects$2.elevation8
        }
      }
    },
    stackRootDisabled: {
      width: 88,
      height: 88
    },
    horizontal: false,
    horizontalAlign: "center",
    verticalAlign: "center",
    imageStyles: {
      height: 48,
      width: 48,
      imageRoot: {}
    },
    nameStyles: {
      nameRoot: {
        textAlign: "center",
        width: 80
      }
    }
  },
  medium: {
    stackRoot: {
      width: 143,
      height: 36,
      padding: 4,
      selectors: {
        "&:hover": {
          boxShadow: DefaultEffects$2.elevation8
        }
      }
    },
    horizontal: true,
    horizontalAlign: "start",
    verticalAlign: "center",
    imageStyles: {
      height: 24,
      width: 24,
      imageRoot: {
        marginRight: 4,
        marginLeft: 4
      }
    },
    nameStyles: {
      nameRoot: {
        marginLeft: 4
      }
    }
  }
};

function getFileType(type) {
  switch (type) {
    case "CSV":
      return {
        icon: "csv"
      };

    case "XLSX":
      return {
        icon: "xlsx"
      };

    case "HTML":
      return {
        icon: "html"
      };

    default:
      return {
        icon: "txt"
      };
  }
}

function ReportTile(_ref) {
  var report = _ref.report,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      setIsDialogHidden = _ref.setIsDialogHidden,
      isFetchingReport = _ref.isFetchingReport;
  var _config$size = config$1[size],
      stackRoot = _config$size.stackRoot,
      stackRootDisabled = _config$size.stackRootDisabled,
      horizontal = _config$size.horizontal,
      horizontalAlign = _config$size.horizontalAlign,
      verticalAlign = _config$size.verticalAlign,
      nameStyles = _config$size.nameStyles;
  var nameEl = useRef();
  var fileType = getFileType(report.fileType);
  var disabled = report.history && !report.history.length || isFetchingReport;
  var tooltipText = isFetchingReport ? undefined : report.history && !report.history.length ? i18n._(
  /*i18n*/
  {
    id: "The report {0} is not available",
    values: {
      0: report.name
    }
  }) : report.name;
  return /*#__PURE__*/React__default.createElement(TooltipHost, {
    calloutProps: {
      doNotLayer: true
    },
    content: nameEl.current && nameEl.current.offsetWidth > nameStyles.nameRoot.width || disabled ? tooltipText : undefined
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: horizontal,
    horizontalAlign: horizontalAlign,
    verticalAlign: verticalAlign,
    styles: {
      root: disabled ? stackRootDisabled : stackRoot
    }
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    iconProps: getFileTypeIconProps({
      extension: fileType.icon,
      size: 48,
      imageFileType: "png"
    }),
    onClick: function onClick() {
      return setIsDialogHidden(disabled);
    },
    styles: {
      root: {
        opacity: disabled ? "0.3" : "1",
        margin: "8px 0 8px 0"
      }
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium",
    styles: {
      root: nameStyles.nameRoot
    },
    block: true,
    nowrap: true
  }, /*#__PURE__*/React__default.createElement("span", {
    ref: nameEl
  }, report.name))));
}

var config$2 = {
  xLarge: {
    stackRoot: {
      position: "relative",
      minWidth: 200,
      height: 84,
      backgroundColor: "#fff",
      boxShadow: DefaultEffects$2.elevation4,
      cursor: "pointer",
      selectors: {
        "&:hover": {
          boxShadow: DefaultEffects$2.elevation16,
          backgroundColor: "#fff"
        }
      }
    },
    stackRootAttention: {
      position: "relative",
      minWidth: 200,
      height: 84,
      backgroundColor: "#fff4ce",
      boxShadow: DefaultEffects$2.elevation4,
      cursor: "pointer",
      selectors: {
        "&:hover": {
          boxShadow: DefaultEffects$2.elevation16,
          backgroundColor: "#fff4ce"
        }
      }
    },
    horizontal: false,
    horizontalAlign: "center",
    verticalAlign: "top",
    imageStyles: {
      imageRoot: {
        paddingTop: 10,
        fontSize: 28
      }
    },
    nameStyles: {
      nameRoot: {
        textAlign: "center",
        width: 160,
        paddingTop: 10
      }
    }
  },
  medium: {
    stackRoot: {
      width: 143,
      height: 36,
      padding: 4,
      selectors: {
        "&:hover": {
          boxShadow: DefaultEffects$2.elevation8
        }
      }
    },
    horizontal: true,
    horizontalAlign: "start",
    verticalAlign: "center",
    imageStyles: {
      imageRoot: {
        marginRight: 4,
        marginLeft: 4,
        fontSize: 20
      }
    },
    nameStyles: {
      nameRoot: {
        marginLeft: 4
      }
    }
  }
};
function LinkTile(_ref) {
  var link = _ref.link,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "xLarge" : _ref$size;
  var _config$size = config$2[size],
      stackRoot = _config$size.stackRoot,
      stackRootAttention = _config$size.stackRootAttention,
      horizontal = _config$size.horizontal,
      horizontalAlign = _config$size.horizontalAlign,
      verticalAlign = _config$size.verticalAlign,
      nameStyles = _config$size.nameStyles,
      imageStyles = _config$size.imageStyles;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, link.link ? /*#__PURE__*/React__default.createElement("a", {
    href: link.link,
    className: "unstyled-link"
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: horizontal,
    horizontalAlign: horizontalAlign,
    verticalAlign: verticalAlign,
    styles: {
      root: link.attention ? stackRootAttention : stackRoot
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: link.icon,
    styles: {
      root: imageStyles.imageRoot
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium",
    styles: {
      root: nameStyles.nameRoot
    },
    block: true,
    nowrap: true
  }, link.name))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null));
}

var NotificationIconItem = function NotificationIconItem(_ref) {
  var item = _ref.item;

  if (!item) {
    return /*#__PURE__*/React__default.createElement(Stack, {
      styles: {
        root: {
          width: "18px"
        }
      }
    });
  }

  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: item.iconProps.iconName,
    styles: {
      root: {
        color: item.iconProps.color ? item.iconProps.color : "",
        fontSize: 14,
        selectors: {
          "&:hover": {
            cursor: "pointer"
          }
        }
      }
    },
    title: item.iconProps.title
  }));
};

var NotificationIcons = function NotificationIcons(_ref) {
  var item = _ref.item,
      infoIcons = _ref.infoIcons;
  if (!infoIcons || !item) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      iconProps = _useState4[0],
      setIconProps = _useState4[1];

  useEffect(function () {
    var newIconIcons = infoIcons.sort(function (a, b) {
      return a.placeholder - b.placeholder;
    });
    var newItems = newIconIcons.filter(function (icon) {
      return item[icon.key] === true;
    });
    setItems(newItems !== undefined ? newItems : []);
    setIconProps(newIconIcons);
  }, [item, infoIcons]);
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 8
    }
  }, items.length > 0 ? iconProps.map(function (infoIcon) {
    return item[infoIcon.key] && /*#__PURE__*/React__default.createElement(NotificationIconItem, {
      key: infoIcon.key,
      item: infoIcon
    });
  }) : "");
};

var config$3 = {
  medium: {
    stackRoot: {
      position: "relative",
      minWidth: 350,
      height: 70,
      padding: "10px 10px 10px 10px",
      backgroundColor: "#fff",
      boxShadow: DefaultEffects$2.elevation4,
      cursor: "pointer",
      selectors: {
        "&:hover": {
          boxShadow: DefaultEffects$2.elevation16,
          backgroundColor: DefaultPalette$2.themeLighter
        }
      }
    },
    stackRootSelected: {
      position: "relative",
      minWidth: 350,
      height: 70,
      padding: "10px 10px 10px 10px",
      backgroundColor: DefaultPalette$2.themeLighter,
      boxShadow: DefaultEffects$2.elevation16,
      cursor: "pointer",
      selectors: {
        "&:hover": {
          boxShadow: DefaultEffects$2.elevation16,
          backgroundColor: DefaultPalette$2.themeLighter
        }
      }
    }
  }
};
var infoIcons = [{
  key: "quarantine",
  placeholder: 1,
  iconProps: {
    iconName: "Delete",
    title: i18n._(
    /*i18n*/
    {
      id: "The employee is in quarantine"
    }),
    color: "#ffaa44",
    hoverBackgroundColor: DefaultPalette$2.neutralLighterAlt,
    hoverSelectedBackgroundColor: DefaultPalette$2.themeLighter
  }
}];
function ProfileTile(_ref) {
  var profile = _ref.profile,
      selectedProfile = _ref.selectedProfile,
      setSelectedProfile = _ref.setSelectedProfile,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size;
  var _config$size = config$3[size],
      stackRoot = _config$size.stackRoot,
      stackRootSelected = _config$size.stackRootSelected;
  var imageUrl = profile.imageUrl,
      imageInitials = profile.imageInitials,
      name = profile.name,
      userName = profile.userName,
      employment = profile.employment;
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    styles: {
      root: selectedProfile === profile ? stackRootSelected : stackRoot
    },
    onClick: function onClick() {
      return setSelectedProfile(profile);
    }
  }, /*#__PURE__*/React__default.createElement(Persona, {
    size: PersonaSize.size48,
    imageUrl: imageUrl,
    imageInitials: imageInitials,
    text: "".concat(name, " (").concat(userName, ")").length > 30 ? "".concat(name, " (").concat(userName, ")").substring(0, 30) + "..." : "".concat(name, " (").concat(userName, ")"),
    secondaryText: employment && employment.length && employment.length > 30 ? employment.substring(0, 30) + "..." : employment
  }), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        position: "absolute",
        right: "30px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(NotificationIcons, {
    item: profile,
    infoIcons: infoIcons
  })), selectedProfile === profile && /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        position: "absolute",
        right: "10px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "ChevronRight"
  }))));
}

var DefaultPanelButton = function DefaultPanelButton(_ref) {
  var onClick = _ref.onClick,
      title = _ref.title,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? "" : _ref$iconName,
      _ref$buttonStyles = _ref.buttonStyles,
      buttonStyles = _ref$buttonStyles === void 0 ? {} : _ref$buttonStyles;
  return /*#__PURE__*/React__default.createElement(IconButton, {
    className: "ms-fadeIn200",
    iconProps: {
      iconName: iconName,
      styles: {
        root: {
          fontSize: "22px",
          color: "#333"
        }
      }
    },
    title: title,
    onClick: onClick,
    styles: {
      root: _objectSpread2({
        height: 50,
        minWidth: 50,
        maxWidth: 50,
        padding: 9,
        backgroundColor: "#fff",
        border: "none"
      }, buttonStyles)
    }
  });
};
var PanelContainer = (function (_ref2) {
  var children = _ref2.children,
      _ref2$panelType = _ref2.panelType,
      panelType = _ref2$panelType === void 0 ? PanelType$1.smallFixedFar : _ref2$panelType,
      _ref2$hasCloseButton = _ref2.hasCloseButton,
      hasCloseButton = _ref2$hasCloseButton === void 0 ? true : _ref2$hasCloseButton,
      _ref2$isLightOnDismis = _ref2.isLightOnDismiss,
      isLightOnDismiss = _ref2$isLightOnDismis === void 0 ? true : _ref2$isLightOnDismis,
      _ref2$isFooterAtBotto = _ref2.isFooterAtBottom,
      isFooterAtBottom = _ref2$isFooterAtBotto === void 0 ? true : _ref2$isFooterAtBotto,
      _ref2$headerText = _ref2.headerText,
      headerText = _ref2$headerText === void 0 ? "" : _ref2$headerText,
      panelButton = _ref2.panelButton,
      panelButtonIcon = _ref2.panelButtonIcon,
      onRenderFooterContent = _ref2.onRenderFooterContent,
      _ref2$panelStyles = _ref2.panelStyles,
      panelStyles = _ref2$panelStyles === void 0 ? {} : _ref2$panelStyles;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  function openPanel() {
    setIsOpen(true);
  }

  function closePanel() {
    setIsOpen(false);
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, panelButton ? panelButton(openPanel) : /*#__PURE__*/React__default.createElement(DefaultPanelButton, {
    onClick: openPanel,
    iconName: panelButtonIcon
  }), /*#__PURE__*/React__default.createElement(Panel$1, {
    isOpen: isOpen,
    type: panelType,
    hasCloseButton: hasCloseButton,
    onDismiss: closePanel,
    isLightDismiss: isLightOnDismiss,
    isFooterAtBottom: isFooterAtBottom,
    headerText: headerText,
    onRenderFooterContent: onRenderFooterContent,
    styles: _objectSpread2({
      headerText: {
        position: "absolute",
        top: 7,
        left: 20,
        fontWeight: 400
      }
    }, panelStyles)
  }, children({
    closePanel: closePanel
  })));
});

var panelStyles = {
  main: {
    backgroundColor: "transparent",
    width: 340
  },
  contentInner: {
    backgroundColor: DefaultPalette$2.white,
    marginTop: 40,
    paddingTop: 20
  }
};
var AppsPanel = (function (_ref) {
  var store = _ref.store;
  var isDashboard = process.env.REACT_APP_NAME === "dashboard" && window.location.pathname === "/";
  var _store$state$loggedIn = store.state.loggedInUser,
      apps = _store$state$loggedIn.apps,
      settings = _store$state$loggedIn.settings;
  var _store$state$reports = store.state.reports,
      reports = _store$state$reports === void 0 ? [] : _store$state$reports;
  var titleList = apps.map(function (app) {
    return app.category;
  });
  var titles = titleList.filter(function (elem, pos) {
    return titleList.indexOf(elem) === pos;
  });
  return /*#__PURE__*/React__default.createElement(PanelContainer, {
    panelType: PanelType$1.smallFixedNear,
    hasCloseButton: false,
    panelButtonIcon: "Waffle",
    panelStyles: panelStyles
  }, function (_ref2) {
    var closePanel = _ref2.closePanel;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DefaultPanelButton, {
      title: "Close",
      onClick: closePanel,
      buttonStyles: {
        position: "absolute",
        top: 0,
        left: 0,
        backgroundColor: "transparent"
      }
    }), !isDashboard ? /*#__PURE__*/React__default.createElement(DashboardLink, {
      url: store.urls.app.dashboard
    }) : null, /*#__PURE__*/React__default.createElement(Stack, {
      style: {
        paddingTop: 10
      }
    }), apps.length ? titles.map(function (title) {
      return /*#__PURE__*/React__default.createElement(Stack, {
        key: title,
        tokens: {
          childrenGap: 8
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        variant: "large"
      }, title), /*#__PURE__*/React__default.createElement(Stack, {
        horizontal: true,
        wrap: true,
        styles: {
          root: {
            marginBottom: 16
          }
        },
        tokens: {
          childrenGap: 4
        }
      }, apps.map(function (app) {
        return app.category === title && /*#__PURE__*/React__default.createElement(AppTile, {
          app: app,
          key: app.id,
          size: "medium"
        });
      })));
    }) : /*#__PURE__*/React__default.createElement(Stack, {
      horizontalAlign: "center",
      verticalAlign: "center"
    }, /*#__PURE__*/React__default.createElement(Text, {
      variant: "medium"
    }, i18n._(
    /*i18n*/
    {
      id: "You currently have no apps assigned"
    }))), reports.reports && reports.reports.length > 0 && settings && settings.quickLinks && settings.quickLinks.length && /*#__PURE__*/React__default.createElement(Stack, {
      key: "Quick Links",
      tokens: {
        childrenGap: 8
      }
    }, /*#__PURE__*/React__default.createElement(Text, {
      variant: "large"
    }, i18n._(
    /*i18n*/
    {
      id: "Quick Links"
    })), /*#__PURE__*/React__default.createElement(Stack, {
      horizontal: true,
      wrap: true,
      styles: {
        root: {
          marginBottom: 16
        }
      },
      tokens: {
        childrenGap: 4
      }
    }, settings.quickLinks.length ? settings.quickLinks.map(function (link) {
      return /*#__PURE__*/React__default.createElement(LinkTile, {
        key: link.id,
        link: link,
        size: "medium"
      });
    }) : null)));
  });
});

var defaultLogoURL = process.env.REACT_APP_LOGO_PATH;
var Logo = (function () {
  return /*#__PURE__*/React__default.createElement(Link$2, {
    to: "/"
  }, /*#__PURE__*/React__default.createElement(Image$1, {
    src: defaultLogoURL,
    height: 24,
    styles: {
      root: {
        padding: "14px 16px 0 16px"
      }
    }
  }));
});

var appName = process.env.REACT_APP_NAME;

var Divider = function Divider() {
  return /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        height: 30,
        marginRight: 16,
        width: 1,
        backgroundColor: DefaultPalette$2.neutralLight
      }
    }
  });
};

var AppName = (function () {
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(Text, {
    variant: "xLarge",
    styles: {
      root: {
        paddingBottom: 4,
        fontWeight: 100,
        textTransform: "capitalize"
      }
    }
  }, appName));
});

var _onRenderFooterContent = function onRenderFooterContent(loggedInUser) {
  var copyToClipboard = function copyToClipboard() {
    var copyItems = ["".concat(process.env.REACT_APP_NAME, " v").concat(process.env.REACT_APP_VERSION), "gateway v".concat(loggedInUser.gatewayVersion)].concat(_toConsumableArray(loggedInUser.versions));
    navigator.clipboard.writeText(copyItems.join("\n"));
  };

  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "end",
    styles: {
      root: {
        color: DefaultPalette$2.neutralTertiary
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "Copy",
    onClick: copyToClipboard,
    styles: {
      root: {
        cursor: "pointer",
        selectors: {
          "&:hover": {
            backgroundColor: DefaultPalette$2.neutralLighter
          }
        }
      }
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus",
    block: true
  }, process.env.REACT_APP_NAME, " v", process.env.REACT_APP_VERSION), /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus",
    block: true
  }, "gateway v", loggedInUser.gatewayVersion), loggedInUser.versions.length ? loggedInUser.versions.map(function (version) {
    return /*#__PURE__*/React__default.createElement(Text, {
      key: version,
      variant: "smallPlus",
      block: true
    }, version);
  }) : null);
};

var HelpPanel = (function (_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(PanelContainer, {
    headerText: i18n._(
    /*i18n*/
    {
      id: "Help"
    }),
    panelButtonIcon: "Help",
    onRenderFooterContent: function onRenderFooterContent() {
      return _onRenderFooterContent(store.state.loggedInUser);
    }
  }, function () {
    return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Text, {
      variant: "large",
      styles: {
        root: {
          marginTop: "20px",
          paddingBottom: "10px"
        }
      }
    }, i18n._(
    /*i18n*/
    {
      id: "Do you have questions?"
    })), /*#__PURE__*/React__default.createElement(Stack, {
      styles: {
        root: {
          marginBottom: "40px",
          gap: "8px"
        }
      }
    }, /*#__PURE__*/React__default.createElement(Link$1, {
      href: store.appName === "System" ? "https://usermanual.idconnect.dk/vejledninger/system-applikationen" : store.appName === "Organisation" ? "https://usermanual.idconnect.dk/vejledninger/organisation-applikationen" : store.appName === "Role" ? "https://usermanual.idconnect.dk/vejledninger/role-applikationen" : store.appName === "User" ? "https://usermanual.idconnect.dk/vejledninger/user-applikationen" : "https://usermanual.idconnect.dk/vejledninger",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React__default.createElement(Stack, {
      horizontal: true,
      verticalAlign: "center",
      tokens: {
        childrenGap: 4
      }
    }, /*#__PURE__*/React__default.createElement(Text, null, i18n._(
    /*i18n*/
    {
      id: "Learn more about the {0} application",
      values: {
        0: store.appName
      }
    })))), store.appName === "System" && /*#__PURE__*/React__default.createElement(Link$1, {
      href: "https://usermanual.idconnect.dk/vejledninger/rapporter/systemejer",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React__default.createElement(Stack, {
      horizontal: true,
      verticalAlign: "center",
      tokens: {
        childrenGap: 4
      }
    }, /*#__PURE__*/React__default.createElement(Text, null, i18n._(
    /*i18n*/
    {
      id: "Get an overview with the System Report"
    })))), (store.appName === "User" || store.appName === "Role") && /*#__PURE__*/React__default.createElement(Link$1, {
      href: "https://usermanual.idconnect.dk/vejledninger/rapporter/ledelse",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React__default.createElement(Stack, {
      horizontal: true,
      verticalAlign: "center",
      tokens: {
        childrenGap: 4
      }
    }, /*#__PURE__*/React__default.createElement(Text, null, i18n._(
    /*i18n*/
    {
      id: "Get an overview with the Management Report"
    })))), /*#__PURE__*/React__default.createElement(Link$1, {
      href: store.appName === "System" ? "https://usermanual.idconnect.dk/rettigheder-i-id-connect/applikationer/rettigheder-til-applikationer" : store.appName === "Organisation" ? "https://usermanual.idconnect.dk/rettigheder-i-id-connect/applikationer/organisation-applikationen" : store.appName === "Role" ? "https://usermanual.idconnect.dk/rettigheder-i-id-connect/applikationer/role-applikationen" : store.appName === "User" ? "https://usermanual.idconnect.dk/rettigheder-i-id-connect/applikationer/user-applikationen" : "https://usermanual.idconnect.dk/rettigheder-i-id-connect",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React__default.createElement(Stack, {
      horizontal: true,
      verticalAlign: "center",
      tokens: {
        childrenGap: 4
      }
    }, /*#__PURE__*/React__default.createElement(Text, null, i18n._(
    /*i18n*/
    {
      id: "Rights in ID Connect"
    })))), store.appName === undefined && /*#__PURE__*/React__default.createElement(Link$1, {
      href: "https://usermanual.idconnect.dk/vejledninger/rapporter/rapport-auditlog/hent-auditlog-rapporten-som-csv-fil",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React__default.createElement(Stack, {
      horizontal: true,
      verticalAlign: "center",
      tokens: {
        childrenGap: 4
      }
    }, /*#__PURE__*/React__default.createElement(Text, null, i18n._(
    /*i18n*/
    {
      id: "Learn more about opening CSV files in Excel"
    }))))), /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, {
      horizontal: true,
      verticalAlign: "center",
      tokens: {
        childrenGap: 4
      },
      styles: {
        root: {
          paddingBottom: "10px"
        }
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      iconName: "Dictionary",
      styles: {
        root: {
          paddingRight: "6px",
          ontSize: 14
        }
      }
    }), /*#__PURE__*/React__default.createElement(Link$1, {
      href: "https://usermanual.idconnect.dk/faq",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React__default.createElement(Text, null, i18n._(
    /*i18n*/
    {
      id: "FAQ"
    })))), /*#__PURE__*/React__default.createElement(Stack, {
      horizontal: true,
      verticalAlign: "center",
      tokens: {
        childrenGap: 4
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      iconName: "Feedback",
      styles: {
        root: {
          paddingRight: "6px",
          ontSize: 14
        }
      }
    }), /*#__PURE__*/React__default.createElement(Link$1, {
      href: "https://idconnect.dk/kontakt/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React__default.createElement(Text, null, i18n._(
    /*i18n*/
    {
      id: "Give feedback"
    }))))));
  });
});

var personaStyles = {
  root: {
    height: 50,
    width: 50,
    padding: 5,
    cursor: "pointer",
    selectors: {
      "&:hover": {
        backgroundColor: DefaultPalette$2.neutralLight
      }
    }
  }
};
function PanelButton(_ref) {
  var profile = _ref.profile,
      openPanel = _ref.openPanel;
  return /*#__PURE__*/React__default.createElement(Persona, {
    styles: personaStyles,
    size: PersonaSize.size40,
    imageUrl: profile.thumbnail,
    imageInitials: profile.name.initials,
    initialsColor: DefaultPalette$2.neutralPrimary,
    onClick: openPanel
  });
}

var linkStyles = {
  root: {
    textDecoration: "none",
    selectors: {
      "&:hover, &:visited": {
        textDecoration: "none"
      }
    }
  }
};
function ProfileLink(_ref) {
  var href = _ref.href,
      as = _ref.as,
      onClick = _ref.onClick,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement(Link$1, {
    href: href,
    to: href,
    as: as,
    onClick: onClick,
    styles: linkStyles
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium"
  }, children));
}

function ProfilePanel(_ref) {
  var store = _ref.store;
  var loggedInUser = store.state.loggedInUser;
  if (!loggedInUser) return null;
  var name = loggedInUser.name,
      emails = loggedInUser.emails,
      thumbnail = loggedInUser.thumbnail;
  var isDashboardApp = process.env.REACT_APP_NAME === "dashboard";
  return /*#__PURE__*/React__default.createElement(PanelContainer, {
    headerText: i18n._(
    /*i18n*/
    {
      id: "My Account"
    }),
    panelButton: function panelButton(openPanel) {
      return /*#__PURE__*/React__default.createElement(PanelButton, {
        profile: loggedInUser,
        openPanel: openPanel
      });
    }
  }, function (_ref2) {
    var closePanel = _ref2.closePanel;
    return /*#__PURE__*/React__default.createElement(Stack, {
      styles: {
        root: {
          backgroundColor: DefaultPalette$2.neutralLighter,
          margin: "0 -16px",
          padding: "16px 0"
        }
      }
    }, /*#__PURE__*/React__default.createElement(Persona, {
      text: name.fullName,
      secondaryText: emails ? emails["default"] : "",
      tertiaryText: /*#__PURE__*/React__default.createElement(Stack, {
        styles: {
          root: {
            marginTop: 8
          }
        }
      }, isDashboardApp ? /*#__PURE__*/React__default.createElement(ProfileLink, {
        as: Link$2,
        href: store.urls.profile,
        onClick: closePanel
      }, i18n._(
      /*i18n*/
      {
        id: "My Profile"
      })) : /*#__PURE__*/React__default.createElement(ProfileLink, {
        href: store.urls.profile
      }, i18n._(
      /*i18n*/
      {
        id: "My Profile"
      })), isDashboardApp ? /*#__PURE__*/React__default.createElement(ProfileLink, {
        as: Link$2,
        href: store.urls.account,
        onClick: closePanel
      }, i18n._(
      /*i18n*/
      {
        id: "View my account"
      })) : /*#__PURE__*/React__default.createElement(ProfileLink, {
        href: store.urls.account
      }, i18n._(
      /*i18n*/
      {
        id: "View my account"
      })), /*#__PURE__*/React__default.createElement(ProfileLink, {
        href: store.urls.logout
      }, i18n._(
      /*i18n*/
      {
        id: "Sign Out"
      }))),
      styles: {
        root: {
          margin: 16
        }
      },
      size: PersonaSize.size72,
      imageUrl: thumbnail,
      imageInitials: name.initials,
      initialsColor: DefaultPalette$2.neutralPrimary
    }));
  });
}

var Metabar = function Metabar(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(Stack, {
    as: "header",
    horizontal: true,
    horizontalAlign: "space-between",
    styles: {
      root: {
        backgroundColor: DefaultPalette$2.white,
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight)
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true
  }, /*#__PURE__*/React__default.createElement(AppsPanel, {
    store: store
  }), /*#__PURE__*/React__default.createElement(Logo, null), /*#__PURE__*/React__default.createElement(AppName, null)), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true
  }, /*#__PURE__*/React__default.createElement(HelpPanel, {
    store: store
  }), /*#__PURE__*/React__default.createElement(ProfilePanel, {
    store: store
  })));
};

var Urls = (function (appName) {
  var _process$env = process.env,
      REACT_APP_API_BASE_URL = _process$env.REACT_APP_API_BASE_URL,
      REACT_APP_DASHBOARD_URL = _process$env.REACT_APP_DASHBOARD_URL,
      REACT_APP_ROLE_URL = _process$env.REACT_APP_ROLE_URL,
      REACT_APP_USER_URL = _process$env.REACT_APP_USER_URL,
      REACT_APP_ORGANISATION_URL = _process$env.REACT_APP_ORGANISATION_URL,
      REACT_APP_SYSTEM_URL = _process$env.REACT_APP_SYSTEM_URL,
      REACT_APP_DASHBOARD_PROFILE_PATH = _process$env.REACT_APP_DASHBOARD_PROFILE_PATH,
      REACT_APP_DASHBOARD_ACCOUNT_PATH = _process$env.REACT_APP_DASHBOARD_ACCOUNT_PATH,
      REACT_APP_LOGIN_PATH = _process$env.REACT_APP_LOGIN_PATH,
      REACT_APP_LOGOUT_PATH = _process$env.REACT_APP_LOGOUT_PATH,
      REACT_APP_ERROR_PATH = _process$env.REACT_APP_ERROR_PATH,
      REACT_APP_ERROR_404_PATH = _process$env.REACT_APP_ERROR_404_PATH,
      REACT_APP_ERROR_ACCESS_DENIED_PATH = _process$env.REACT_APP_ERROR_ACCESS_DENIED_PATH,
      REACT_APP_ME_API = _process$env.REACT_APP_ME_API,
      REACT_APP_USERS_API = _process$env.REACT_APP_USERS_API,
      REACT_APP_ROLES_API = _process$env.REACT_APP_ROLES_API,
      REACT_APP_ROLEGROUPS_API = _process$env.REACT_APP_ROLEGROUPS_API,
      REACT_APP_OUS_API = _process$env.REACT_APP_OUS_API,
      REACT_APP_SYSTEMS_API = _process$env.REACT_APP_SYSTEMS_API,
      REACT_APP_SYSTEMROLES_API = _process$env.REACT_APP_SYSTEMROLES_API,
      REACT_APP_POSITIONS_API = _process$env.REACT_APP_POSITIONS_API,
      REACT_APP_REPORTS_API = _process$env.REACT_APP_REPORTS_API,
      REACT_APP_GOOGLE_TOTP_API = _process$env.REACT_APP_GOOGLE_TOTP_API,
      REACT_APP_KLE_API = _process$env.REACT_APP_KLE_API,
      REACT_APP_APPROVALS_API = _process$env.REACT_APP_APPROVALS_API,
      REACT_APP_NOTIFICATIONS_API = _process$env.REACT_APP_NOTIFICATIONS_API;
  return {
    api: {
      base: REACT_APP_API_BASE_URL,
      me: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_ME_API),
      users: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_USERS_API),
      roles: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_ROLES_API),
      rolegroups: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_ROLEGROUPS_API),
      ous: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_OUS_API),
      systems: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_SYSTEMS_API),
      systemroles: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_SYSTEMROLES_API),
      positions: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_POSITIONS_API),
      reports: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_REPORTS_API),
      kle: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_KLE_API),
      approvals: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_APPROVALS_API),
      notifications: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_NOTIFICATIONS_API)
    },
    app: {
      dashboard: appName === "Dashboard" ? "/" : REACT_APP_DASHBOARD_URL,
      role: appName === "Role" ? "/" : REACT_APP_ROLE_URL,
      user: appName === "User" ? "/" : REACT_APP_USER_URL,
      organisation: appName === "Organisation" ? "/" : REACT_APP_ORGANISATION_URL,
      system: appName === "System" ? "/" : REACT_APP_SYSTEM_URL
    },
    account: appName === "Dashboard" ? REACT_APP_DASHBOARD_ACCOUNT_PATH : "".concat(REACT_APP_DASHBOARD_URL).concat(REACT_APP_DASHBOARD_ACCOUNT_PATH),
    profile: appName === "Dashboard" ? REACT_APP_DASHBOARD_PROFILE_PATH : "".concat(REACT_APP_DASHBOARD_URL).concat(REACT_APP_DASHBOARD_PROFILE_PATH),
    login: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_LOGIN_PATH),
    logout: "".concat(REACT_APP_API_BASE_URL).concat(REACT_APP_LOGOUT_PATH),
    error: {
      fourOhFour: REACT_APP_ERROR_404_PATH,
      accessDenied: REACT_APP_ERROR_ACCESS_DENIED_PATH,
      other: REACT_APP_ERROR_PATH
    }
  };
});

var urls = Urls(process.env.REACT_APP_NAME);
var FetchingUserProfile = function FetchingUserProfile() {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      timeoutStage = _useState2[0],
      setTimeoutStage = _useState2[1];

  var timeouts = [{
    waitInMS: 7000
  }, {
    waitInMS: 10000,
    message: function message() {
      return i18n._(
      /*i18n*/
      {
        id: "This is taking longer than expected..."
      });
    }
  }, {
    waitInMS: 15000,
    message: function message() {
      return i18n._(
      /*i18n*/
      {
        id: "This is taking too long. It's likely that there has been an error."
      });
    }
  }];
  useEffect(function () {
    var timer;

    if (timeoutStage < 3) {
      timer = setTimeout(function () {
        setTimeoutStage(timeoutStage + 1);
        timer = null;
      }, timeouts[timeoutStage].waitInMS);
    }

    return function () {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [timeoutStage, timeouts]);
  if (timeoutStage > 2) return /*#__PURE__*/React__default.createElement(Redirect, {
    to: "/no-user-data"
  });
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    verticalFill: true,
    grow: true,
    tokens: {
      childrenGap: 20
    }
  }, /*#__PURE__*/React__default.createElement(Spinner, {
    label: i18n._(
    /*i18n*/
    {
      id: "Loading data..."
    })
  }), timeoutStage > 0 ? /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    tokens: {
      childrenGap: 20
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    block: true
  }, timeouts[timeoutStage].message()), /*#__PURE__*/React__default.createElement(DefaultButton, {
    text: i18n._(
    /*i18n*/
    {
      id: "Retry login"
    }),
    href: urls.logout,
    styles: {
      root: {
        maxWidth: 120
      }
    }
  })) : null);
};

var util = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClient = typeof window === 'object';

exports.on = function (obj) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  return obj.addEventListener.apply(obj, args);
};

exports.off = function (obj) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  return obj.removeEventListener.apply(obj, args);
};
});

unwrapExports(util);
var util_1 = util.isClient;
var util_2 = util.on;
var util_3 = util.off;

var useLocalStorage_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});





var useLocalStorage = function (key, initialValue, raw) {
  if (!util.isClient) {
    return [initialValue, function () {}];
  }

  var _a = React__default.useState(function () {
    try {
      var localStorageValue = localStorage.getItem(key);

      if (typeof localStorageValue !== 'string') {
        localStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
        return initialValue;
      } else {
        return raw ? localStorageValue : JSON.parse(localStorageValue || 'null');
      }
    } catch (_a) {
      // If user is in private mode or has storage restriction
      // localStorage can throw. JSON.parse and JSON.stringify
      // can throw, too.
      return initialValue;
    }
  }),
      state = _a[0],
      setState = _a[1];

  React__default.useEffect(function () {
    try {
      var serializedState = raw ? String(state) : JSON.stringify(state);
      localStorage.setItem(key, serializedState);
    } catch (_a) {// If user is in private mode or has storage restriction
      // localStorage can throw. Also JSON.stringify can throw.
    }
  }, [state]);
  return [state, setState];
};

exports.default = useLocalStorage;
});

var useLocalStorage = unwrapExports(useLocalStorage_1);

var __extends$1 = undefined && undefined.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign$8 = undefined && undefined.__assign || function () {
  __assign$8 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign$8.apply(this, arguments);
};
var styles = {
  top: {
    width: '100%',
    height: '10px',
    top: '-5px',
    left: '0px',
    cursor: 'row-resize'
  },
  right: {
    width: '10px',
    height: '100%',
    top: '0px',
    right: '-5px',
    cursor: 'col-resize'
  },
  bottom: {
    width: '100%',
    height: '10px',
    bottom: '-5px',
    left: '0px',
    cursor: 'row-resize'
  },
  left: {
    width: '10px',
    height: '100%',
    top: '0px',
    left: '-5px',
    cursor: 'col-resize'
  },
  topRight: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    right: '-10px',
    top: '-10px',
    cursor: 'ne-resize'
  },
  bottomRight: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    right: '-10px',
    bottom: '-10px',
    cursor: 'se-resize'
  },
  bottomLeft: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    left: '-10px',
    bottom: '-10px',
    cursor: 'sw-resize'
  },
  topLeft: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    left: '-10px',
    top: '-10px',
    cursor: 'nw-resize'
  }
};

var Resizer =
/** @class */
function (_super) {
  __extends$1(Resizer, _super);

  function Resizer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onMouseDown = function (e) {
      _this.props.onResizeStart(e, _this.props.direction);
    };

    _this.onTouchStart = function (e) {
      _this.props.onResizeStart(e, _this.props.direction);
    };

    return _this;
  }

  Resizer.prototype.render = function () {
    return createElement("div", {
      className: this.props.className || '',
      style: __assign$8(__assign$8({
        position: 'absolute',
        userSelect: 'none'
      }, styles[this.props.direction]), this.props.replaceStyles || {}),
      onMouseDown: this.onMouseDown,
      onTouchStart: this.onTouchStart
    }, this.props.children);
  };

  return Resizer;
}(PureComponent);

//
// Main
//
function memoize$1(fn, options) {
  var cache = options && options.cache ? options.cache : cacheDefault;
  var serializer = options && options.serializer ? options.serializer : serializerDefault;
  var strategy = options && options.strategy ? options.strategy : strategyDefault;
  return strategy(fn, {
    cache: cache,
    serializer: serializer
  });
} //
// Strategy
//


function isPrimitive(value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}

function monadic(fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
  var computedValue = cache.get(cacheKey);

  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }

  return computedValue;
}

function variadic(fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3);
  var cacheKey = serializer(args);
  var computedValue = cache.get(cacheKey);

  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }

  return computedValue;
}

function assemble(fn, context, strategy, cache, serialize) {
  return strategy.bind(context, fn, cache, serialize);
}

function strategyDefault(fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic;
  return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}

function strategyVariadic(fn, options) {
  var strategy = variadic;
  return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}

function strategyMonadic(fn, options) {
  var strategy = monadic;
  return assemble(fn, this, strategy, options.cache.create(), options.serializer);
} //
// Serializer
//


function serializerDefault() {
  return JSON.stringify(arguments);
} //
// Cache
//


function ObjectWithoutPrototypeCache() {
  this.cache = Object.create(null);
}

ObjectWithoutPrototypeCache.prototype.has = function (key) {
  return key in this.cache;
};

ObjectWithoutPrototypeCache.prototype.get = function (key) {
  return this.cache[key];
};

ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
  this.cache[key] = value;
};

var cacheDefault = {
  create: function create() {
    return new ObjectWithoutPrototypeCache();
  }
}; //
// API
//

var src = memoize$1;
var strategies = {
  variadic: strategyVariadic,
  monadic: strategyMonadic
};
src.strategies = strategies;

var __extends$2 = undefined && undefined.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign$9 = undefined && undefined.__assign || function () {
  __assign$9 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign$9.apply(this, arguments);
};
var DEFAULT_SIZE = {
  width: 'auto',
  height: 'auto'
};
var clamp$2 = src(function (n, min, max) {
  return Math.max(Math.min(n, max), min);
});
var snap$1 = src(function (n, size) {
  return Math.round(n / size) * size;
});
var hasDirection = src(function (dir, target) {
  return new RegExp(dir, 'i').test(target);
}); // INFO: In case of window is a Proxy and does not porxy Events correctly, use isTouchEvent & isMouseEvent to distinguish event type instead of `instanceof`.

var isTouchEvent = function (event) {
  return Boolean(event.touches && event.touches.length);
};

var isMouseEvent = function (event) {
  return Boolean((event.clientX || event.clientX === 0) && (event.clientY || event.clientY === 0));
};

var findClosestSnap = src(function (n, snapArray, snapGap) {
  if (snapGap === void 0) {
    snapGap = 0;
  }

  var closestGapIndex = snapArray.reduce(function (prev, curr, index) {
    return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
  }, 0);
  var gap = Math.abs(snapArray[closestGapIndex] - n);
  return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var endsWith = src(function (str, searchStr) {
  return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var getStringSize = src(function (n) {
  n = n.toString();

  if (n === 'auto') {
    return n;
  }

  if (endsWith(n, 'px')) {
    return n;
  }

  if (endsWith(n, '%')) {
    return n;
  }

  if (endsWith(n, 'vh')) {
    return n;
  }

  if (endsWith(n, 'vw')) {
    return n;
  }

  if (endsWith(n, 'vmax')) {
    return n;
  }

  if (endsWith(n, 'vmin')) {
    return n;
  }

  return n + "px";
});

var getPixelSize = function (size, parentSize, innerWidth, innerHeight) {
  if (size && typeof size === 'string') {
    if (endsWith(size, 'px')) {
      return Number(size.replace('px', ''));
    }

    if (endsWith(size, '%')) {
      var ratio = Number(size.replace('%', '')) / 100;
      return parentSize * ratio;
    }

    if (endsWith(size, 'vw')) {
      var ratio = Number(size.replace('vw', '')) / 100;
      return innerWidth * ratio;
    }

    if (endsWith(size, 'vh')) {
      var ratio = Number(size.replace('vh', '')) / 100;
      return innerHeight * ratio;
    }
  }

  return size;
};

var calculateNewMax = src(function (parentSize, innerWidth, innerHeight, maxWidth, maxHeight, minWidth, minHeight) {
  maxWidth = getPixelSize(maxWidth, parentSize.width, innerWidth, innerHeight);
  maxHeight = getPixelSize(maxHeight, parentSize.height, innerWidth, innerHeight);
  minWidth = getPixelSize(minWidth, parentSize.width, innerWidth, innerHeight);
  minHeight = getPixelSize(minHeight, parentSize.height, innerWidth, innerHeight);
  return {
    maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
    maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
    minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
    minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
  };
});
var definedProps = ['as', 'style', 'className', 'grid', 'snap', 'bounds', 'boundsByDirection', 'size', 'defaultSize', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight', 'lockAspectRatio', 'lockAspectRatioExtraWidth', 'lockAspectRatioExtraHeight', 'enable', 'handleStyles', 'handleClasses', 'handleWrapperStyle', 'handleWrapperClass', 'children', 'onResizeStart', 'onResize', 'onResizeStop', 'handleComponent', 'scale', 'resizeRatio', 'snapGap']; // HACK: This class is used to calculate % size.

var baseClassName = '__resizable_base__';

var Resizable =
/** @class */
function (_super) {
  __extends$2(Resizable, _super);

  function Resizable(props) {
    var _this = _super.call(this, props) || this;

    _this.ratio = 1;
    _this.resizable = null; // For parent boundary

    _this.parentLeft = 0;
    _this.parentTop = 0; // For boundary

    _this.resizableLeft = 0;
    _this.resizableRight = 0;
    _this.resizableTop = 0;
    _this.resizableBottom = 0; // For target boundary

    _this.targetLeft = 0;
    _this.targetTop = 0;

    _this.appendBase = function () {
      if (!_this.resizable || !_this.window) {
        return null;
      }

      var parent = _this.parentNode;

      if (!parent) {
        return null;
      }

      var element = _this.window.document.createElement('div');

      element.style.width = '100%';
      element.style.height = '100%';
      element.style.position = 'absolute';
      element.style.transform = 'scale(0, 0)';
      element.style.left = '0';
      element.style.flex = '0';

      if (element.classList) {
        element.classList.add(baseClassName);
      } else {
        element.className += baseClassName;
      }

      parent.appendChild(element);
      return element;
    };

    _this.removeBase = function (base) {
      var parent = _this.parentNode;

      if (!parent) {
        return;
      }

      parent.removeChild(base);
    };

    _this.ref = function (c) {
      if (c) {
        _this.resizable = c;
      }
    };

    _this.state = {
      isResizing: false,
      width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
      height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
      direction: 'right',
      original: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      backgroundStyle: {
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0,0,0,0)',
        cursor: 'auto',
        opacity: 0,
        position: 'fixed',
        zIndex: 9999,
        top: '0',
        left: '0',
        bottom: '0',
        right: '0'
      },
      flexBasis: undefined
    };
    _this.onResizeStart = _this.onResizeStart.bind(_this);
    _this.onMouseMove = _this.onMouseMove.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);
    return _this;
  }

  Object.defineProperty(Resizable.prototype, "parentNode", {
    get: function () {
      if (!this.resizable) {
        return null;
      }

      return this.resizable.parentNode;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Resizable.prototype, "window", {
    get: function () {
      if (!this.resizable) {
        return null;
      }

      if (!this.resizable.ownerDocument) {
        return null;
      }

      return this.resizable.ownerDocument.defaultView;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Resizable.prototype, "propsSize", {
    get: function () {
      return this.props.size || this.props.defaultSize || DEFAULT_SIZE;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Resizable.prototype, "size", {
    get: function () {
      var width = 0;
      var height = 0;

      if (this.resizable && this.window) {
        var orgWidth = this.resizable.offsetWidth;
        var orgHeight = this.resizable.offsetHeight; // HACK: Set position `relative` to get parent size.
        //       This is because when re-resizable set `absolute`, I can not get base width correctly.

        var orgPosition = this.resizable.style.position;

        if (orgPosition !== 'relative') {
          this.resizable.style.position = 'relative';
        } // INFO: Use original width or height if set auto.


        width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
        height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight; // Restore original position

        this.resizable.style.position = orgPosition;
      }

      return {
        width: width,
        height: height
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Resizable.prototype, "sizeStyle", {
    get: function () {
      var _this = this;

      var size = this.props.size;

      var getSize = function (key) {
        if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') {
          return 'auto';
        }

        if (_this.propsSize && _this.propsSize[key] && endsWith(_this.propsSize[key].toString(), '%')) {
          if (endsWith(_this.state[key].toString(), '%')) {
            return _this.state[key].toString();
          }

          var parentSize = _this.getParentSize();

          var value = Number(_this.state[key].toString().replace('px', ''));
          var percent = value / parentSize[key] * 100;
          return percent + "%";
        }

        return getStringSize(_this.state[key]);
      };

      var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? getStringSize(size.width) : getSize('width');
      var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? getStringSize(size.height) : getSize('height');
      return {
        width: width,
        height: height
      };
    },
    enumerable: false,
    configurable: true
  });

  Resizable.prototype.getParentSize = function () {
    if (!this.parentNode) {
      if (!this.window) {
        return {
          width: 0,
          height: 0
        };
      }

      return {
        width: this.window.innerWidth,
        height: this.window.innerHeight
      };
    }

    var base = this.appendBase();

    if (!base) {
      return {
        width: 0,
        height: 0
      };
    } // INFO: To calculate parent width with flex layout


    var wrapChanged = false;
    var wrap = this.parentNode.style.flexWrap;

    if (wrap !== 'wrap') {
      wrapChanged = true;
      this.parentNode.style.flexWrap = 'wrap'; // HACK: Use relative to get parent padding size
    }

    base.style.position = 'relative';
    base.style.minWidth = '100%';
    var size = {
      width: base.offsetWidth,
      height: base.offsetHeight
    };

    if (wrapChanged) {
      this.parentNode.style.flexWrap = wrap;
    }

    this.removeBase(base);
    return size;
  };

  Resizable.prototype.bindEvents = function () {
    if (this.window) {
      this.window.addEventListener('mouseup', this.onMouseUp);
      this.window.addEventListener('mousemove', this.onMouseMove);
      this.window.addEventListener('mouseleave', this.onMouseUp);
      this.window.addEventListener('touchmove', this.onMouseMove, {
        capture: true,
        passive: false
      });
      this.window.addEventListener('touchend', this.onMouseUp);
    }
  };

  Resizable.prototype.unbindEvents = function () {
    if (this.window) {
      this.window.removeEventListener('mouseup', this.onMouseUp);
      this.window.removeEventListener('mousemove', this.onMouseMove);
      this.window.removeEventListener('mouseleave', this.onMouseUp);
      this.window.removeEventListener('touchmove', this.onMouseMove, true);
      this.window.removeEventListener('touchend', this.onMouseUp);
    }
  };

  Resizable.prototype.componentDidMount = function () {
    if (!this.resizable || !this.window) {
      return;
    }

    var computedStyle = this.window.getComputedStyle(this.resizable);
    this.setState({
      width: this.state.width || this.size.width,
      height: this.state.height || this.size.height,
      flexBasis: computedStyle.flexBasis !== 'auto' ? computedStyle.flexBasis : undefined
    });
  };

  Resizable.prototype.componentWillUnmount = function () {
    if (this.window) {
      this.unbindEvents();
    }
  };

  Resizable.prototype.createSizeForCssProperty = function (newSize, kind) {
    var propsSize = this.propsSize && this.propsSize[kind];
    return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
  };

  Resizable.prototype.calculateNewMaxFromBoundary = function (maxWidth, maxHeight) {
    var boundsByDirection = this.props.boundsByDirection;
    var direction = this.state.direction;
    var widthByDirection = boundsByDirection && hasDirection('left', direction);
    var heightByDirection = boundsByDirection && hasDirection('top', direction);
    var boundWidth;
    var boundHeight;

    if (this.props.bounds === 'parent') {
      var parent_1 = this.parentNode;

      if (parent_1) {
        boundWidth = widthByDirection ? this.resizableRight - this.parentLeft : parent_1.offsetWidth + (this.parentLeft - this.resizableLeft);
        boundHeight = heightByDirection ? this.resizableBottom - this.parentTop : parent_1.offsetHeight + (this.parentTop - this.resizableTop);
      }
    } else if (this.props.bounds === 'window') {
      if (this.window) {
        boundWidth = widthByDirection ? this.resizableRight : this.window.innerWidth - this.resizableLeft;
        boundHeight = heightByDirection ? this.resizableBottom : this.window.innerHeight - this.resizableTop;
      }
    } else if (this.props.bounds) {
      boundWidth = widthByDirection ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
      boundHeight = heightByDirection ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
    }

    if (boundWidth && Number.isFinite(boundWidth)) {
      maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
    }

    if (boundHeight && Number.isFinite(boundHeight)) {
      maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
    }

    return {
      maxWidth: maxWidth,
      maxHeight: maxHeight
    };
  };

  Resizable.prototype.calculateNewSizeFromDirection = function (clientX, clientY) {
    var scale = this.props.scale || 1;
    var resizeRatio = this.props.resizeRatio || 1;
    var _a = this.state,
        direction = _a.direction,
        original = _a.original;
    var _b = this.props,
        lockAspectRatio = _b.lockAspectRatio,
        lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight,
        lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
    var newWidth = original.width;
    var newHeight = original.height;
    var extraHeight = lockAspectRatioExtraHeight || 0;
    var extraWidth = lockAspectRatioExtraWidth || 0;

    if (hasDirection('right', direction)) {
      newWidth = original.width + (clientX - original.x) * resizeRatio / scale;

      if (lockAspectRatio) {
        newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
      }
    }

    if (hasDirection('left', direction)) {
      newWidth = original.width - (clientX - original.x) * resizeRatio / scale;

      if (lockAspectRatio) {
        newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
      }
    }

    if (hasDirection('bottom', direction)) {
      newHeight = original.height + (clientY - original.y) * resizeRatio / scale;

      if (lockAspectRatio) {
        newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
      }
    }

    if (hasDirection('top', direction)) {
      newHeight = original.height - (clientY - original.y) * resizeRatio / scale;

      if (lockAspectRatio) {
        newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
      }
    }

    return {
      newWidth: newWidth,
      newHeight: newHeight
    };
  };

  Resizable.prototype.calculateNewSizeFromAspectRatio = function (newWidth, newHeight, max, min) {
    var _a = this.props,
        lockAspectRatio = _a.lockAspectRatio,
        lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight,
        lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
    var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
    var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
    var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
    var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
    var extraHeight = lockAspectRatioExtraHeight || 0;
    var extraWidth = lockAspectRatioExtraWidth || 0;

    if (lockAspectRatio) {
      var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
      var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
      var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
      var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
      var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
      var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
      var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
      var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
      newWidth = clamp$2(newWidth, lockedMinWidth, lockedMaxWidth);
      newHeight = clamp$2(newHeight, lockedMinHeight, lockedMaxHeight);
    } else {
      newWidth = clamp$2(newWidth, computedMinWidth, computedMaxWidth);
      newHeight = clamp$2(newHeight, computedMinHeight, computedMaxHeight);
    }

    return {
      newWidth: newWidth,
      newHeight: newHeight
    };
  };

  Resizable.prototype.setBoundingClientRect = function () {
    // For parent boundary
    if (this.props.bounds === 'parent') {
      var parent_2 = this.parentNode;

      if (parent_2) {
        var parentRect = parent_2.getBoundingClientRect();
        this.parentLeft = parentRect.left;
        this.parentTop = parentRect.top;
      }
    } // For target(html element) boundary


    if (this.props.bounds && typeof this.props.bounds !== 'string') {
      var targetRect = this.props.bounds.getBoundingClientRect();
      this.targetLeft = targetRect.left;
      this.targetTop = targetRect.top;
    } // For boundary


    if (this.resizable) {
      var _a = this.resizable.getBoundingClientRect(),
          left = _a.left,
          top_1 = _a.top,
          right = _a.right,
          bottom = _a.bottom;

      this.resizableLeft = left;
      this.resizableRight = right;
      this.resizableTop = top_1;
      this.resizableBottom = bottom;
    }
  };

  Resizable.prototype.onResizeStart = function (event, direction) {
    if (!this.resizable || !this.window) {
      return;
    }

    var clientX = 0;
    var clientY = 0;

    if (event.nativeEvent && isMouseEvent(event.nativeEvent)) {
      clientX = event.nativeEvent.clientX;
      clientY = event.nativeEvent.clientY;
    } else if (event.nativeEvent && isTouchEvent(event.nativeEvent)) {
      clientX = event.nativeEvent.touches[0].clientX;
      clientY = event.nativeEvent.touches[0].clientY;
    }

    if (this.props.onResizeStart) {
      if (this.resizable) {
        var startResize = this.props.onResizeStart(event, direction, this.resizable);

        if (startResize === false) {
          return;
        }
      }
    } // Fix #168


    if (this.props.size) {
      if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) {
        this.setState({
          height: this.props.size.height
        });
      }

      if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) {
        this.setState({
          width: this.props.size.width
        });
      }
    } // For lockAspectRatio case


    this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
    var flexBasis;
    var computedStyle = this.window.getComputedStyle(this.resizable);

    if (computedStyle.flexBasis !== 'auto') {
      var parent_3 = this.parentNode;

      if (parent_3) {
        var dir = this.window.getComputedStyle(parent_3).flexDirection;
        this.flexDir = dir.startsWith('row') ? 'row' : 'column';
        flexBasis = computedStyle.flexBasis;
      }
    } // For boundary


    this.setBoundingClientRect();
    this.bindEvents();
    var state = {
      original: {
        x: clientX,
        y: clientY,
        width: this.size.width,
        height: this.size.height
      },
      isResizing: true,
      backgroundStyle: __assign$9(__assign$9({}, this.state.backgroundStyle), {
        cursor: this.window.getComputedStyle(event.target).cursor || 'auto'
      }),
      direction: direction,
      flexBasis: flexBasis
    };
    this.setState(state);
  };

  Resizable.prototype.onMouseMove = function (event) {
    if (!this.state.isResizing || !this.resizable || !this.window) {
      return;
    }

    if (this.window.TouchEvent && isTouchEvent(event)) {
      try {
        event.preventDefault();
        event.stopPropagation();
      } catch (e) {// Ignore on fail
      }
    }

    var _a = this.props,
        maxWidth = _a.maxWidth,
        maxHeight = _a.maxHeight,
        minWidth = _a.minWidth,
        minHeight = _a.minHeight;
    var clientX = isTouchEvent(event) ? event.touches[0].clientX : event.clientX;
    var clientY = isTouchEvent(event) ? event.touches[0].clientY : event.clientY;
    var _b = this.state,
        direction = _b.direction,
        original = _b.original,
        width = _b.width,
        height = _b.height;
    var parentSize = this.getParentSize();
    var max = calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
    maxWidth = max.maxWidth;
    maxHeight = max.maxHeight;
    minWidth = max.minWidth;
    minHeight = max.minHeight; // Calculate new size

    var _c = this.calculateNewSizeFromDirection(clientX, clientY),
        newHeight = _c.newHeight,
        newWidth = _c.newWidth; // Calculate max size from boundary settings


    var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight); // Calculate new size from aspect ratio

    var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
      width: boundaryMax.maxWidth,
      height: boundaryMax.maxHeight
    }, {
      width: minWidth,
      height: minHeight
    });
    newWidth = newSize.newWidth;
    newHeight = newSize.newHeight;

    if (this.props.grid) {
      var newGridWidth = snap$1(newWidth, this.props.grid[0]);
      var newGridHeight = snap$1(newHeight, this.props.grid[1]);
      var gap = this.props.snapGap || 0;
      newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
      newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
    }

    if (this.props.snap && this.props.snap.x) {
      newWidth = findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
    }

    if (this.props.snap && this.props.snap.y) {
      newHeight = findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
    }

    var delta = {
      width: newWidth - original.width,
      height: newHeight - original.height
    };

    if (width && typeof width === 'string') {
      if (endsWith(width, '%')) {
        var percent = newWidth / parentSize.width * 100;
        newWidth = percent + "%";
      } else if (endsWith(width, 'vw')) {
        var vw = newWidth / this.window.innerWidth * 100;
        newWidth = vw + "vw";
      } else if (endsWith(width, 'vh')) {
        var vh = newWidth / this.window.innerHeight * 100;
        newWidth = vh + "vh";
      }
    }

    if (height && typeof height === 'string') {
      if (endsWith(height, '%')) {
        var percent = newHeight / parentSize.height * 100;
        newHeight = percent + "%";
      } else if (endsWith(height, 'vw')) {
        var vw = newHeight / this.window.innerWidth * 100;
        newHeight = vw + "vw";
      } else if (endsWith(height, 'vh')) {
        var vh = newHeight / this.window.innerHeight * 100;
        newHeight = vh + "vh";
      }
    }

    var newState = {
      width: this.createSizeForCssProperty(newWidth, 'width'),
      height: this.createSizeForCssProperty(newHeight, 'height')
    };

    if (this.flexDir === 'row') {
      newState.flexBasis = newState.width;
    } else if (this.flexDir === 'column') {
      newState.flexBasis = newState.height;
    }

    this.setState(newState);

    if (this.props.onResize) {
      this.props.onResize(event, direction, this.resizable, delta);
    }
  };

  Resizable.prototype.onMouseUp = function (event) {
    var _a = this.state,
        isResizing = _a.isResizing,
        direction = _a.direction,
        original = _a.original;

    if (!isResizing || !this.resizable) {
      return;
    }

    var delta = {
      width: this.size.width - original.width,
      height: this.size.height - original.height
    };

    if (this.props.onResizeStop) {
      this.props.onResizeStop(event, direction, this.resizable, delta);
    }

    if (this.props.size) {
      this.setState(this.props.size);
    }

    this.unbindEvents();
    this.setState({
      isResizing: false,
      backgroundStyle: __assign$9(__assign$9({}, this.state.backgroundStyle), {
        cursor: 'auto'
      })
    });
  };

  Resizable.prototype.updateSize = function (size) {
    this.setState({
      width: size.width,
      height: size.height
    });
  };

  Resizable.prototype.renderResizer = function () {
    var _this = this;

    var _a = this.props,
        enable = _a.enable,
        handleStyles = _a.handleStyles,
        handleClasses = _a.handleClasses,
        handleWrapperStyle = _a.handleWrapperStyle,
        handleWrapperClass = _a.handleWrapperClass,
        handleComponent = _a.handleComponent;

    if (!enable) {
      return null;
    }

    var resizers = Object.keys(enable).map(function (dir) {
      if (enable[dir] !== false) {
        return createElement(Resizer, {
          key: dir,
          direction: dir,
          onResizeStart: _this.onResizeStart,
          replaceStyles: handleStyles && handleStyles[dir],
          className: handleClasses && handleClasses[dir]
        }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
      }

      return null;
    }); // #93 Wrap the resize box in span (will not break 100% width/height)

    return createElement("div", {
      className: handleWrapperClass,
      style: handleWrapperStyle
    }, resizers);
  };

  Resizable.prototype.render = function () {
    var _this = this;

    var extendsProps = Object.keys(this.props).reduce(function (acc, key) {
      if (definedProps.indexOf(key) !== -1) {
        return acc;
      }

      acc[key] = _this.props[key];
      return acc;
    }, {});

    var style = __assign$9(__assign$9(__assign$9({
      position: 'relative',
      userSelect: this.state.isResizing ? 'none' : 'auto'
    }, this.props.style), this.sizeStyle), {
      maxWidth: this.props.maxWidth,
      maxHeight: this.props.maxHeight,
      minWidth: this.props.minWidth,
      minHeight: this.props.minHeight,
      boxSizing: 'border-box',
      flexShrink: 0
    });

    if (this.state.flexBasis) {
      style.flexBasis = this.state.flexBasis;
    }

    var Wrapper = this.props.as || 'div';
    return createElement(Wrapper, __assign$9({
      ref: this.ref,
      style: style,
      className: this.props.className
    }, extendsProps), this.state.isResizing && createElement("div", {
      style: this.state.backgroundStyle
    }), this.props.children, this.renderResizer());
  };

  Resizable.defaultProps = {
    as: 'div',
    onResizeStart: function () {},
    onResize: function () {},
    onResizeStop: function () {},
    enable: {
      top: true,
      right: true,
      bottom: true,
      left: true,
      topRight: true,
      bottomRight: true,
      bottomLeft: true,
      topLeft: true
    },
    style: {},
    grid: [1, 1],
    lockAspectRatio: false,
    lockAspectRatioExtraWidth: 0,
    lockAspectRatioExtraHeight: 0,
    scale: 1,
    resizeRatio: 1,
    snapGap: 0
  };
  return Resizable;
}(PureComponent);

var appBarSystems = {
  "role.idconnect.dk": {
    name: "Role",
    titel: "Role",
    key: "role",
    icon: "EngineeringGroup",
    url: process.env.REACT_APP_ROLE_URL,
    sortOrder: 0
  },
  "user.idconnect.dk": {
    name: "User",
    titel: "User",
    key: "user",
    icon: "Group",
    url: process.env.REACT_APP_USER_URL,
    sortOrder: 1
  },
  "organisation.idconnect.dk": {
    name: "Organisation",
    titel: "Organisation",
    key: "organisation",
    icon: "Org",
    url: process.env.REACT_APP_ORGANISATION_URL,
    sortOrder: 2
  },
  "system.idconnect.dk": {
    name: "System",
    titel: "System",
    key: "system",
    icon: "System",
    url: process.env.REACT_APP_SYSTEM_URL,
    sortOrder: 3
  }
}; // Create the list of apps that the user has access to.

var getAppList = function getAppList() {
  var systems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var appBarSystemIdentifiers = Object.keys(appBarSystems);
  return systems.reduce(function (acc, system) {
    if (appBarSystemIdentifiers.includes(system.identifier)) {
      return [].concat(_toConsumableArray(acc), [appBarSystems[system.identifier]]);
    }

    return acc;
  }, []).sort(function (a, b) {
    return a.sortOrder - b.sortOrder;
  });
};
/**
 * @description The AppBar shows an icon list of IDC apps at the bottom of the
 *   NavMenu component. The styles and orientation of the list is dependent on
 *   the collapsed state of the NavMenu.
 * @param {Object[]} systems - Array of systems the user has access to.
 * @param {boolean} isCollapsed - The collapsed state of the NavMenu.
 */


var AppBar = function AppBar(_ref) {
  var apps = _ref.apps,
      isCollapsed = _ref.isCollapsed;
  var appList = getAppList(apps);
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: !isCollapsed,
    verticalAlign: "center",
    horizontalAlign: "space-around",
    styles: {
      root: {
        boxSizing: "border-box",
        borderTop: "1px solid ".concat(DefaultPalette.neutralLight),
        backgroundColor: isCollapsed ? DefaultPalette.white : DefaultPalette.neutralLighter
      }
    }
  }, appList.map(function (app) {
    var disabled = process.env.REACT_APP_NAME === app.key;
    return /*#__PURE__*/React__default.createElement(IconButton, {
      disabled: disabled,
      key: app.key,
      title: app.titel,
      href: app.url,
      iconProps: {
        iconName: app.icon
      },
      styles: {
        root: {
          color: DefaultPalette.neutralTertiary,
          fontSize: 40,
          height: 48,
          width: 48
        },
        rootHovered: {
          color: DefaultPalette.themeDark,
          backgroundColor: disabled ? DefaultPalette.neutralLighter : DefaultPalette.neutralLight
        },
        iconDisabled: {
          color: DefaultPalette.themeDark
        }
      }
    });
  }));
};

var minWidth = 198;
var maxWidth = 320;
var collapsedWidth = 49;
/**
 * @description The NavMenu shows a series of top-level menus, that determine
 *   what is in the MainContent section.
 * @param {Object} store - The app instance store
 * @param {Object[]} groups - A collection of link groups to display in the Nav
 *   https://developer.microsoft.com/en-us/fabric#/controls/web/nav#INavLinkGroup
 *   @param {Object[]} links - Links to render within this group:
 *     https://developer.microsoft.com/en-us/fabric#/controls/web/nav#INavLink
 *   @param {string} links.key - Unique, stable key for the link, used when rendering
 *     the list of links and for tracking the currently selected link.
 *   @param {string} links.name - Text to render for this link
 *   @param {string} links.url - URL to navigate to for this link
 *   @param {string} links.icon - Name of an icon to render next to the link button.
 */

var NavMenu = function NavMenu(_ref) {
  var store = _ref.store,
      groups = _ref.groups;
  var _store$state = store.state,
      loggedInUser = _store$state.loggedInUser,
      category = _store$state.category; // The NavMenu is both resizable and collapsible. The content changes based on
  // its `isCollapsed` state. Both its `width` and its `isCollapsed` state are
  // stored in localStorage.

  var _useLocalStorage = useLocalStorage("navMenuWidth", minWidth),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      width = _useLocalStorage2[0],
      setWidth = _useLocalStorage2[1];

  var _useLocalStorage3 = useLocalStorage("isNavMenuCollapsed", true),
      _useLocalStorage4 = _slicedToArray(_useLocalStorage3, 2),
      isCollapsed = _useLocalStorage4[0],
      setIsCollapsed = _useLocalStorage4[1];

  var renderNavLink = function renderNavLink(_ref2) {
    var href = _ref2.href,
        className = _ref2.className,
        iconProps = _ref2.iconProps,
        title = _ref2.title,
        children = _ref2.children;
    return isCollapsed ? /*#__PURE__*/React__default.createElement(Link$2, {
      to: href,
      className: className,
      style: {
        color: "inherit",
        boxSizing: "border-box",
        margin: 0,
        padding: 0
      },
      title: title
    }, /*#__PURE__*/React__default.createElement(Stack, {
      verticalAlign: "center",
      horizontalAlign: "center",
      verticalFill: true,
      grow: true,
      styles: {
        root: {
          fontSize: 16
        }
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      iconName: iconProps.iconName
    }))) : /*#__PURE__*/React__default.createElement(Link$2, {
      to: href,
      className: className,
      style: {
        color: "inherit",
        boxSizing: "border-box",
        paddingLeft: 16
      },
      title: title
    }, /*#__PURE__*/React__default.createElement(Stack, {
      horizontal: true
    }, /*#__PURE__*/React__default.createElement(Icon, {
      iconName: iconProps.iconName,
      styles: {
        root: {
          fontSize: 16,
          marginRight: 16
        }
      }
    }), children));
  };

  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Resizable, {
    enable: {
      right: !isCollapsed
    },
    minWidth: isCollapsed ? collapsedWidth : minWidth,
    maxWidth: maxWidth,
    size: {
      width: isCollapsed ? collapsedWidth : width,
      height: "100%"
    },
    onResizeStop: function onResizeStop(e, direction, ref, delta) {
      setWidth(delta.width + width);
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    verticalFill: true
  }, /*#__PURE__*/React__default.createElement(CommandBarButton, {
    styles: {
      root: {
        minHeight: 44,
        width: collapsedWidth
      }
    },
    iconProps: {
      iconName: "GlobalNavButton"
    },
    onClick: function onClick() {
      return setIsCollapsed(!isCollapsed);
    }
  }), /*#__PURE__*/React__default.createElement(Stack, {
    verticalAlign: "space-between",
    verticalFill: true,
    styles: {
      root: {
        overflowX: "auto",
        overflowY: "auto",
        borderRight: "1px solid ".concat(DefaultPalette.neutralLight),
        borderTop: "1px solid ".concat(DefaultPalette.neutralLight)
      }
    }
  }, /*#__PURE__*/React__default.createElement(Nav, {
    selectedKey: category,
    groups: groups,
    linkAs: renderNavLink
  }), /*#__PURE__*/React__default.createElement(AppBar, {
    apps: loggedInUser.apps,
    isCollapsed: isCollapsed
  })))));
};

var strictUriEncode = function (str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

function encoderForArrayFormat(opts) {
  switch (opts.arrayFormat) {
    case 'index':
      return function (key, value, index) {
        return value === null ? [encode(key, opts), '[', index, ']'].join('') : [encode(key, opts), '[', encode(index, opts), ']=', encode(value, opts)].join('');
      };

    case 'bracket':
      return function (key, value) {
        return value === null ? encode(key, opts) : [encode(key, opts), '[]=', encode(value, opts)].join('');
      };

    default:
      return function (key, value) {
        return value === null ? encode(key, opts) : [encode(key, opts), '=', encode(value, opts)].join('');
      };
  }
}

function parserForArrayFormat(opts) {
  var result;

  switch (opts.arrayFormat) {
    case 'index':
      return function (key, value, accumulator) {
        result = /\[(\d*)\]$/.exec(key);
        key = key.replace(/\[\d*\]$/, '');

        if (!result) {
          accumulator[key] = value;
          return;
        }

        if (accumulator[key] === undefined) {
          accumulator[key] = {};
        }

        accumulator[key][result[1]] = value;
      };

    case 'bracket':
      return function (key, value, accumulator) {
        result = /(\[\])$/.exec(key);
        key = key.replace(/\[\]$/, '');

        if (!result) {
          accumulator[key] = value;
          return;
        } else if (accumulator[key] === undefined) {
          accumulator[key] = [value];
          return;
        }

        accumulator[key] = [].concat(accumulator[key], value);
      };

    default:
      return function (key, value, accumulator) {
        if (accumulator[key] === undefined) {
          accumulator[key] = value;
          return;
        }

        accumulator[key] = [].concat(accumulator[key], value);
      };
  }
}

function encode(value, opts) {
  if (opts.encode) {
    return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
  }

  return value;
}

function keysSorter(input) {
  if (Array.isArray(input)) {
    return input.sort();
  } else if (typeof input === 'object') {
    return keysSorter(Object.keys(input)).sort(function (a, b) {
      return Number(a) - Number(b);
    }).map(function (key) {
      return input[key];
    });
  }

  return input;
}

var extract = function (str) {
  return str.split('?')[1] || '';
};

var parse = function (str, opts) {
  opts = objectAssign({
    arrayFormat: 'none'
  }, opts);
  var formatter = parserForArrayFormat(opts); // Create an object with no prototype
  // https://github.com/sindresorhus/query-string/issues/47

  var ret = Object.create(null);

  if (typeof str !== 'string') {
    return ret;
  }

  str = str.trim().replace(/^(\?|#|&)/, '');

  if (!str) {
    return ret;
  }

  str.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('='); // Firefox (pre 40) decodes `%3D` to `=`
    // https://github.com/sindresorhus/query-string/pull/37

    var key = parts.shift();
    var val = parts.length > 0 ? parts.join('=') : undefined; // missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters

    val = val === undefined ? null : decodeURIComponent(val);
    formatter(decodeURIComponent(key), val, ret);
  });
  return Object.keys(ret).sort().reduce(function (result, key) {
    var val = ret[key];

    if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
      // Sort object keys, not values
      result[key] = keysSorter(val);
    } else {
      result[key] = val;
    }

    return result;
  }, Object.create(null));
};

var stringify = function (obj, opts) {
  var defaults = {
    encode: true,
    strict: true,
    arrayFormat: 'none'
  };
  opts = objectAssign(defaults, opts);
  var formatter = encoderForArrayFormat(opts);
  return obj ? Object.keys(obj).sort().map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return '';
    }

    if (val === null) {
      return encode(key, opts);
    }

    if (Array.isArray(val)) {
      var result = [];
      val.slice().forEach(function (val2) {
        if (val2 === undefined) {
          return;
        }

        result.push(formatter(key, val2, result.length));
      });
      return result.join('&');
    }

    return encode(key, opts) + '=' + encode(val, opts);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : '';
};

var queryString = {
	extract: extract,
	parse: parse,
	stringify: stringify
};

var rootStackStyles = {
  root: {
    height: "calc(100vh - (100vh - 100%))",
    minWidth: "990px",
    overflowY: "hidden"
  }
};
var BaseLayout = function BaseLayout(_ref) {
  var store = _ref.store,
      match = _ref.match,
      onUrlChange = _ref.onUrlChange,
      navMenuGroups = _ref.navMenuGroups,
      children = _ref.children;
  var state = store.state,
      getLoggedInUser = store.getLoggedInUser,
      updateState = store.updateState;
  var blockUI = state.blockUI,
      blockUiText = state.blockUiText,
      notifications = state.notifications,
      loggedInUser = state.loggedInUser;
  var _match$params = match.params,
      page = _match$params.page,
      category = _match$params.category,
      action = _match$params.action,
      id = _match$params.id;
  var location = useLocation();
  var history = useHistory();
  useEffect(function () {
    var queryParams = new URLSearchParams(location.search);
    var firstAttempt = queryString.parse(location.search).firstAttempt;

    if (firstAttempt) {
      queryParams["delete"]("firstAttempt");
      history.replace({
        search: queryParams.toString()
      });
    }

    getLoggedInUser(firstAttempt === "true");
  }, [getLoggedInUser]);
  useEffect(function () {
    // TODO Pages only implemented on Reports for now
    page === "reports" ? onUrlChange(store, page, category, action, id) : onUrlChange(store, category, action, id);
  }, [page, category, action, id, updateState, onUrlChange, store]);
  if (!loggedInUser.uuid) return /*#__PURE__*/React__default.createElement(Stack, {
    grow: true,
    verticalFill: true,
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        height: "100%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(FetchingUserProfile, null));
  return /*#__PURE__*/React__default.createElement(Stack, {
    vertical: true,
    grow: true,
    styles: rootStackStyles
  }, blockUI ? /*#__PURE__*/React__default.createElement(BlockingSpinner, {
    label: blockUiText
  }) : null, /*#__PURE__*/React__default.createElement(NotificationsList, {
    items: notifications,
    onDismiss: store.notifications.onDismiss
  }), category !== "notifications" && /*#__PURE__*/React__default.createElement(Metabar, {
    store: store
  }), /*#__PURE__*/React__default.createElement(Stack, {
    as: "main",
    horizontal: true,
    styles: {
      root: {
        height: "calc(100% - 50px)"
      }
    }
  }, /*#__PURE__*/React__default.createElement(NavMenu, {
    groups: navMenuGroups,
    store: store
  }), /*#__PURE__*/React__default.createElement(Stack, {
    as: "section",
    grow: true,
    verticalFill: true,
    styles: {
      root: {
        width: 0
      }
    }
  }, children)));
};

var ContextBar = function ContextBar(_ref) {
  var items = _ref.items,
      _ref$farItems = _ref.farItems,
      farItems = _ref$farItems === void 0 ? [] : _ref$farItems,
      _ref$overflowItems = _ref.overflowItems,
      overflowItems = _ref$overflowItems === void 0 ? [] : _ref$overflowItems;
  return /*#__PURE__*/React__default.createElement(CommandBar, {
    styles: {
      root: {
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight)
      }
    },
    items: items,
    farItems: farItems,
    overflowItems: overflowItems,
    doNotLayer: true
  });
};

var ItemContent = function ItemContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(Stack, {
    grow: true,
    verticalFill: true,
    styles: {
      root: {
        overflowY: "hidden",
        padding: "8px",
        backgroundColor: "rgb(243, 242, 241)"
      }
    }
  }, children);
};

var ItemDetails = function ItemDetails(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(Stack, {
    grow: true,
    verticalFill: true,
    styles: {
      root: {
        overflowX: "hidden",
        overflowY: "auto",
        width: "100%",
        height: "calc(100vh - 266px)"
      }
    },
    tokens: {
      childrenGap: 16,
      padding: 24
    }
  }, children);
};

var ItemTop = function ItemTop(_ref) {
  var buttons = _ref.buttons,
      farButtons = _ref.farButtons,
      text = _ref.text,
      secondaryText = _ref.secondaryText,
      tertiaryText = _ref.tertiaryText,
      personaProps = _ref.personaProps,
      avatarProps = _ref.avatarProps;
  return /*#__PURE__*/React__default.createElement(Stack, {
    className: AnimationStyles.fadeIn200
  }, /*#__PURE__*/React__default.createElement(Stack, {
    verticalFill: true,
    styles: {
      root: {
        backgroundColor: DefaultPalette.white,
        borderRadius: 4,
        borderBottom: "2px solid ".concat(DefaultPalette.themePrimary),
        minHeight: 153
      }
    }
  }, avatarProps && /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: {
      root: {
        marginTop: 24,
        marginLeft: 24
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: avatarProps.iconName,
    styles: {
      root: {
        color: "#fff",
        backgroundColor: avatarProps.iconColor,
        padding: 20,
        fontSize: 32,
        borderRadius: "50%"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Stack, {
    verticalAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xLargePlus",
    styles: {
      root: {
        margin: "0 0 0px 14px"
      }
    }
  }, text), secondaryText && /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Text, {
    styles: {
      root: {
        margin: "0 0 0px 14px"
      }
    }
  }, secondaryText)))), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        marginTop: 24,
        marginLeft: 24,
        marginBottom: 10
      }
    }
  }, personaProps && /*#__PURE__*/React__default.createElement(Persona, {
    size: PersonaSize.size72,
    imageUrl: personaProps.imageUrl,
    imageInitials: personaProps.imageInitials,
    text: text,
    secondaryText: secondaryText,
    tertiaryText: tertiaryText
  })), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        borderTop: "1px solid ".concat(DefaultPalette.neutralLight)
      }
    }
  }, buttons && /*#__PURE__*/React__default.createElement(CommandBar, {
    items: buttons,
    farItems: farButtons,
    onReduceData: function onReduceData() {
      return undefined;
    },
    doNotLayer: true
  }))));
};

var PivotMenu = function PivotMenu(_ref) {
  var children = _ref.children,
      selectedKey = _ref.selectedKey,
      onLinkClick = _ref.onLinkClick;
  return /*#__PURE__*/React__default.createElement(Pivot, {
    styles: {
      root: {
        height: 45,
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight),
        marginBottom: 10
      }
    },
    linkSize: PivotLinkSize.normal,
    selectedKey: selectedKey,
    onLinkClick: onLinkClick
  }, children);
};

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
/**
 * Module exports.
 * @public
 */

var parse_1 = parse$1;
var serialize_1 = serialize;
/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode$1 = encodeURIComponent;
var pairSplitRegExp = /; */;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse$1(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {};
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('='); // skip things that don't look like key=value

    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim();
    var val = pair.substr(++eq_idx, pair.length).trim(); // quoted values

    if ('"' == val[0]) {
      val = val.slice(1, -1);
    } // only assign once


    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */


function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode$1;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;

      case 'lax':
        str += '; SameSite=Lax';
        break;

      case 'strict':
        str += '; SameSite=Strict';
        break;

      case 'none':
        str += '; SameSite=None';
        break;

      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */


function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

function hasDocumentCookie() {
  // Can we get/set cookies on document.cookie?
  return typeof document === 'object' && typeof document.cookie === 'string';
}
function parseCookies(cookies, options) {
  if (typeof cookies === 'string') {
    return parse_1(cookies, options);
  } else if (typeof cookies === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}
function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}
function readCookie(value, options) {
  if (options === void 0) {
    options = {};
  }

  var cleanValue = cleanupCookieValue(value);

  if (isParsingCookie(cleanValue, options.doNotParse)) {
    try {
      return JSON.parse(cleanValue);
    } catch (e) {// At least we tried
    }
  } // Ignore clean value if we failed the deserialization
  // It is not relevant anymore to trim those values


  return value;
}

function cleanupCookieValue(value) {
  // express prepend j: before serializing a cookie
  if (value && value[0] === 'j' && value[1] === ':') {
    return value.substr(2);
  }

  return value;
}

var __assign$a = undefined && undefined.__assign || function () {
  __assign$a = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign$a.apply(this, arguments);
};

var Cookies =
/** @class */
function () {
  function Cookies(cookies, options) {
    var _this = this;

    this.changeListeners = [];
    this.HAS_DOCUMENT_COOKIE = false;
    this.cookies = parseCookies(cookies, options);
    new Promise(function () {
      _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
    }).catch(function () {});
  }

  Cookies.prototype._updateBrowserValues = function (parseOptions) {
    if (!this.HAS_DOCUMENT_COOKIE) {
      return;
    }

    this.cookies = parse_1(document.cookie, parseOptions);
  };

  Cookies.prototype._emitChange = function (params) {
    for (var i = 0; i < this.changeListeners.length; ++i) {
      this.changeListeners[i](params);
    }
  };

  Cookies.prototype.get = function (name, options, parseOptions) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues(parseOptions);

    return readCookie(this.cookies[name], options);
  };

  Cookies.prototype.getAll = function (options, parseOptions) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues(parseOptions);

    var result = {};

    for (var name_1 in this.cookies) {
      result[name_1] = readCookie(this.cookies[name_1], options);
    }

    return result;
  };

  Cookies.prototype.set = function (name, value, options) {
    var _a;

    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }

    this.cookies = __assign$a(__assign$a({}, this.cookies), (_a = {}, _a[name] = value, _a));

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, value, options);
    }

    this._emitChange({
      name: name,
      value: value,
      options: options
    });
  };

  Cookies.prototype.remove = function (name, options) {
    var finalOptions = options = __assign$a(__assign$a({}, options), {
      expires: new Date(1970, 1, 1, 0, 0, 1),
      maxAge: 0
    });

    this.cookies = __assign$a({}, this.cookies);
    delete this.cookies[name];

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, '', finalOptions);
    }

    this._emitChange({
      name: name,
      value: undefined,
      options: options
    });
  };

  Cookies.prototype.addChangeListener = function (callback) {
    this.changeListeners.push(callback);
  };

  Cookies.prototype.removeChangeListener = function (callback) {
    var idx = this.changeListeners.indexOf(callback);

    if (idx >= 0) {
      this.changeListeners.splice(idx, 1);
    }
  };

  return Cookies;
}();

var CookiesContext = createContext(new Cookies());
var Provider = CookiesContext.Provider,
    Consumer = CookiesContext.Consumer;

function isInBrowser() {
  return typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
}

function useCookies(dependencies) {
  var cookies = useContext(CookiesContext);

  if (!cookies) {
    throw new Error('Missing <CookiesProvider>');
  }

  var initialCookies = cookies.getAll();

  var _a = useState(initialCookies),
      allCookies = _a[0],
      setCookies = _a[1];

  var previousCookiesRef = useRef(allCookies);

  if (isInBrowser()) {
    useLayoutEffect(function () {
      function onChange() {
        var newCookies = cookies.getAll();

        if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
          setCookies(newCookies);
        }

        previousCookiesRef.current = newCookies;
      }

      cookies.addChangeListener(onChange);
      return function () {
        cookies.removeChangeListener(onChange);
      };
    }, [cookies]);
  }

  var setCookie = useMemo(function () {
    return cookies.set.bind(cookies);
  }, [cookies]);
  var removeCookie = useMemo(function () {
    return cookies.remove.bind(cookies);
  }, [cookies]);
  return [allCookies, setCookie, removeCookie];
}

function shouldUpdate(dependencies, newCookies, oldCookies) {
  if (!dependencies) {
    return true;
  }

  for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
    var dependency = dependencies_1[_i];

    if (newCookies[dependency] !== oldCookies[dependency]) {
      return true;
    }
  }

  return false;
}

var lodash_orderby = createCommonjsModule(function (module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */

var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */

var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */

var freeExports =  exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */

var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */

var nodeUtil = function () {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}();
/* Node.js helper references. */


var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */


function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }

  return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */


function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */


function baseSortBy(array, comparer) {
  var length = array.length;
  array.sort(comparer);

  while (length--) {
    array[length] = array[length].value;
  }

  return array;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */


function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */


function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */


function getValue(object, key) {
  return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */


function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;

  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }

  return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */


function mapToArray(map) {
  var index = -1,
      result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */


function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */


function setToArray(set) {
  var index = -1,
      result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}
/** Used for built-in method references. */


var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */

var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */


var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */

var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */

var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */

var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */


function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */


function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */


function listCacheClear() {
  this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */


function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */

function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;
  this.__data__ = new MapCache();

  while (++index < length) {
    this.add(values[index]);
  }
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */


function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);

  return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */


function setCacheHas(value) {
  return this.__data__.has(value);
} // Add methods to `SetCache`.


SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Stack(entries) {
  this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */


function stackClear() {
  this.__data__ = new ListCache();
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function stackDelete(key) {
  return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function stackGet(key) {
  return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function stackHas(key) {
  return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */


function stackSet(key, value) {
  var cache = this.__data__;

  if (cache instanceof ListCache) {
    var pairs = cache.__data__;

    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      return this;
    }

    cache = this.__data__ = new MapCache(pairs);
  }

  cache.set(key, value);
  return this;
} // Add methods to `Stack`.


Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }

  return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */


var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */

var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */

function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */


function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }

  return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */


function baseGetTag(value) {
  return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */


function baseHasIn(object, key) {
  return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */


function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }

  if (value == null || other == null || !isObject(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }

  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */


function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }

  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }

  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }

  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }

  if (!isSameTag) {
    return false;
  }

  stack || (stack = new Stack());
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */


function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }

  object = Object(object);

  while (index--) {
    var data = matchData[index];

    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }

  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();

      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }

      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) {
        return false;
      }
    }
  }

  return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */


function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */


function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */


function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }

  if (value == null) {
    return identity;
  }

  if (typeof value == 'object') {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }

  return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */


function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */


function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */


function baseMatches(source) {
  var matchData = getMatchData(source);

  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }

  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */


function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }

  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */


function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
  var result = baseMap(collection, function (value, key, collection) {
    var criteria = arrayMap(iteratees, function (iteratee) {
      return iteratee(value);
    });
    return {
      'criteria': criteria,
      'index': ++index,
      'value': value
    };
  });
  return baseSortBy(result, function (object, other) {
    return compareMultiple(object, other, orders);
  });
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */


function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */


function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */


function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */


function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);
    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }

    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }

  return 0;
}
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */


function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);

    if (result) {
      if (index >= ordersLength) {
        return result;
      }

      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  } // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.


  return object.index - other.index;
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */


function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }

    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }

    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }

    return collection;
  };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */


function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];

      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }

    return object;
  };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */


function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  } // Assume cyclic values are equal.


  var stacked = stack.get(array);

  if (stacked && stack.get(other)) {
    return stacked == other;
  }

  var index = -1,
      result = true,
      seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array); // Ignore non-index properties.

  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }

    if (compared !== undefined) {
      if (compared) {
        continue;
      }

      result = false;
      break;
    } // Recursively compare arrays (susceptible to call stack limits).


    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
          return seen.add(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
      result = false;
      break;
    }
  }

  stack['delete'](array);
  stack['delete'](other);
  return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */


function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }

      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }

      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      } // Assume cyclic values are equal.


      var stacked = stack.get(object);

      if (stacked) {
        return stacked == other;
      }

      bitmask |= UNORDERED_COMPARE_FLAG; // Recursively compare objects (susceptible to call stack limits).

      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }

  }

  return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */


function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }

  var index = objLength;

  while (index--) {
    var key = objProps[index];

    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  } // Assume cyclic values are equal.


  var stacked = stack.get(object);

  if (stacked && stack.get(other)) {
    return stacked == other;
  }

  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;

  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    } // Recursively compare objects (susceptible to call stack limits).


    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
      result = false;
      break;
    }

    skipCtor || (skipCtor = key == 'constructor');
  }

  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }

  stack['delete'](object);
  stack['delete'](other);
  return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */


function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }

  return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */


var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.

if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
  getTag = function (value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;

        case mapCtorString:
          return mapTag;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag;

        case weakMapCtorString:
          return weakMapTag;
      }
    }

    return result;
  };
}
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */


function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);
  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);

    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }

    object = object[key];
  }

  if (result) {
    return result;
  }

  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */


function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */


function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }

  var type = typeof value;

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */


function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */


function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
  return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */


function isStrictComparable(value) {
  return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */


function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }

    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */


var stringToPath = memoize(function (string) {
  string = toString(string);
  var result = [];

  if (reLeadingDot.test(string)) {
    result.push('');
  }

  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */


function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */


function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }

  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }

  orders = guard ? undefined : orders;

  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }

  return baseOrderBy(collection, iteratees, orders);
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */


function memoize(func, resolver) {
  if (typeof func != 'function' || resolver && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function () {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };

  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
} // Assign cache to `_.memoize`.


memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */


function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */


var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */


function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */


function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */


function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike(value) {
  return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */


var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString(value) {
  return value == null ? '' : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */


function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */


function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */


function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */


function identity(value) {
  return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */


function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = orderBy;
});

var SearchField = function SearchField(_ref) {
  var searchText = _ref.searchText,
      setSearchText = _ref.setSearchText,
      showListItemView = _ref.showListItemView,
      filterProps = _ref.filterProps,
      filters = _ref.filters,
      searchHint = _ref.searchHint,
      setDisabled = _ref.setDisabled,
      _ref$debounceDelay = _ref.debounceDelay,
      debounceDelay = _ref$debounceDelay === void 0 ? 0 : _ref$debounceDelay;

  var _useState = useState(searchText),
      _useState2 = _slicedToArray(_useState, 2),
      localSearchText = _useState2[0],
      setLocalSearchText = _useState2[1];

  var debounceTimeout = useRef(null);
  useEffect(function () {
    setLocalSearchText(searchText);
  }, [searchText]);

  var handleSearchChange = function handleSearchChange(e, val) {
    setLocalSearchText(val);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    if (debounceDelay > 0) {
      debounceTimeout.current = setTimeout(function () {
        setSearchText(val);
      }, debounceDelay);
    } else {
      setSearchText(val);
    }
  };

  var handleClear = function handleClear() {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    setLocalSearchText("");
    setSearchText("");
  };

  useEffect(function () {
    return function () {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(SearchBox, {
    placeholder: searchHint ? i18n._(
    /*i18n*/
    {
      id: "Search, eg. \"{searchHint}\"",
      values: {
        searchHint: searchHint
      }
    }) : i18n._(
    /*i18n*/
    {
      id: "Search:"
    }),
    value: localSearchText,
    onChange: handleSearchChange,
    onClear: handleClear,
    underlined: true,
    autoComplete: "off",
    disabled: setDisabled,
    styles: {
      root: {
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight),
        minHeight: 40,
        width: "100%",
        paddingRight: showListItemView ? filterProps ? 83 : filters ? 76 : 38 : filterProps ? 45 : filters ? 38 : 0
      }
    }
  });
};

function handleSetCookies(setCookies, cookieName, cookieValue) {
  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "/";
  var now = new Date();
  var oneYr = new Date();
  oneYr.setYear(now.getFullYear() + 1);
  setCookies(cookieName, cookieValue, {
    path: path,
    expires: oneYr
  });
}

var ListViewMenu = function ListViewMenu(_ref) {
  var listView = _ref.listView,
      setListView = _ref.setListView,
      listItemProps = _ref.listItemProps,
      setCookies = _ref.setCookies;
  var groupedListKey = listItemProps.groupedListKey,
      treeListItems = listItemProps.treeListItems,
      showGroupedByDate = listItemProps.showGroupedByDate;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var types = useMemo(function () {
    return {
      alphabetical: {
        key: "alphabetical",
        text: i18n._(
        /*i18n*/
        {
          id: "Alphabetical"
        }),
        iconProps: {
          iconName: "Ascending"
        },
        onClick: function onClick() {
          return listItemProps.listTypeCookieName ? handleSetCookie("alphabetical") : setListView("alphabetical");
        },
        isVisible: true,
        disabled: listView === "alphabetical"
      },
      grouped: {
        key: "grouped",
        text: i18n._(
        /*i18n*/
        {
          id: "Grouped"
        }),
        iconProps: {
          iconName: "GroupedList"
        },
        onClick: function onClick() {
          return listItemProps.listTypeCookieName ? handleSetCookie("grouped") : setListView("grouped");
        },
        isVisible: !!groupedListKey,
        disabled: listView === "grouped"
      },
      groupedByDate: {
        key: "groupedByDate",
        text: i18n._(
        /*i18n*/
        {
          id: "Grouped By Date"
        }),
        iconProps: {
          iconName: "DateTime"
        },
        onClick: function onClick() {
          return listItemProps.listTypeCookieName ? handleSetCookie("groupedByDate") : setListView("groupedByDate");
        },
        isVisible: showGroupedByDate,
        disabled: listView === "groupedByDate"
      },
      tree: {
        key: "tree",
        text: i18n._(
        /*i18n*/
        {
          id: "Tree View"
        }),
        iconProps: {
          iconName: "ViewListTree"
        },
        onClick: function onClick() {
          return listItemProps.listTypeCookieName ? handleSetCookie("tree") : setListView("tree");
        },
        isVisible: treeListItems,
        disabled: listView === "tree"
      }
    };
  }, [groupedListKey, listView, setListView, treeListItems]);
  useEffect(function () {
    setItems(Object.values(types).filter(function (i) {
      return i.isVisible;
    }));
  }, [types]);

  function handleSetCookie(cookieValue) {
    handleSetCookies(setCookies, listItemProps.listTypeCookieName, cookieValue);
    setListView(cookieValue);
  }

  return /*#__PURE__*/React__default.createElement(IconButton, {
    menuProps: {
      items: items,
      isBeakVisible: false
    },
    iconProps: listView ? types[listView].iconProps : {},
    styles: {
      root: {
        position: "absolute",
        right: 0,
        minWidth: 38,
        minHeight: 40,
        selectors: {
          "& .ms-Button-menuIcon": {
            display: "none"
          }
        }
      }
    }
  });
};

var FilterMenu = function FilterMenu(_ref) {
  var listItemProps = _ref.listItemProps,
      hasListTypeMenu = _ref.hasListTypeMenu;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  useEffect(function () {
    setItems(Object.values(listItemProps.filters));
  }, [listItemProps.filters]);
  return /*#__PURE__*/React__default.createElement(IconButton, {
    menuProps: {
      items: items,
      isBeakVisible: false
    },
    iconProps: {
      iconName: "Filter"
    },
    styles: {
      root: {
        position: "absolute",
        right: hasListTypeMenu ? 40 : 0,
        minWidth: 38,
        minHeight: 40,
        selectors: {
          "& .ms-Button-menuIcon": {
            display: "none"
          }
        }
      }
    }
  });
};

var FilterChoice = function FilterChoice(_ref) {
  var filterProps = _ref.filterProps,
      hasListTypeMenu = _ref.hasListTypeMenu,
      setFilterProps = _ref.setFilterProps;
  return /*#__PURE__*/React__default.createElement("div", {
    title: i18n._(
    /*i18n*/
    {
      id: "Remove"
    }),
    onClick: function onClick() {
      return setFilterProps("");
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: {
      root: {
        position: "absolute",
        right: hasListTypeMenu ? 40 : 5,
        minWidth: 45,
        minHeight: 25,
        marginTop: 7,
        borderRadius: "30px 30px 30px 30px",
        paddingLeft: 8,
        backgroundColor: DefaultPalette$2.neutralLight,
        selectors: {
          "&:hover": {
            backgroundColor: DefaultPalette$2.neutralLighter
          }
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: filterProps.iconProps.iconName,
    styles: {
      root: {
        fontSize: 10,
        paddingTop: 7
      }
    }
  }), /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "ChromeClose",
    styles: {
      root: {
        fontSize: 8,
        paddingLeft: 10,
        paddingTop: 8
      }
    }
  })));
};

function FilterSection(_ref) {
  var listView = _ref.listView,
      setListView = _ref.setListView,
      filterProps = _ref.filterProps,
      setFilterProps = _ref.setFilterProps,
      searchText = _ref.searchText,
      setSearchText = _ref.setSearchText,
      searchHint = _ref.searchHint,
      searchFieldDisabled = _ref.searchFieldDisabled,
      listItemProps = _ref.listItemProps,
      setCookies = _ref.setCookies,
      searchDebounceDelay = _ref.searchDebounceDelay;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showListItemView = _useState2[0],
      setShowListItemView = _useState2[1]; // Update the list view options menu next to the search field


  useEffect(function () {
    var groupedListKey = listItemProps.groupedListKey,
        treeListItems = listItemProps.treeListItems;
    var isVisible = !!groupedListKey || !!treeListItems;
    setShowListItemView(isVisible);
  }, [listItemProps]);
  return /*#__PURE__*/React__default.createElement(Stack, {
    as: "section",
    horizontal: true
  }, /*#__PURE__*/React__default.createElement(SearchField, {
    searchText: searchText,
    setSearchText: setSearchText,
    showListItemView: showListItemView,
    filterProps: filterProps,
    filters: listItemProps.filters,
    searchHint: searchHint,
    setDisabled: searchFieldDisabled,
    debounceDelay: searchDebounceDelay
  }), listItemProps.filters && filterProps ? /*#__PURE__*/React__default.createElement(FilterChoice, {
    filterProps: filterProps,
    hasListTypeMenu: showListItemView,
    setFilterProps: setFilterProps
  }) : null, listItemProps.filters && !filterProps ? /*#__PURE__*/React__default.createElement(FilterMenu, {
    listItemProps: listItemProps,
    hasListTypeMenu: showListItemView
  }) : null, showListItemView ? /*#__PURE__*/React__default.createElement(ListViewMenu, {
    listView: listView,
    setListView: setListView,
    listItemProps: listItemProps,
    setCookies: setCookies
  }) : null);
}

var FlatListItem = function FlatListItem(_ref) {
  var item = _ref.item,
      index = _ref.index,
      setSelectedIndex = _ref.setSelectedIndex,
      selected = _ref.selected,
      listItemProps = _ref.listItemProps;
  var page = listItemProps.page,
      category = listItemProps.category,
      iconProps = listItemProps.iconProps,
      infoIcons = listItemProps.infoIcons,
      _listItemProps$disabl = listItemProps.disableOnReadOnly,
      disableOnReadOnly = _listItemProps$disabl === void 0 ? false : _listItemProps$disabl,
      primaryTextKey = listItemProps.primaryTextKey,
      onRenderPrimaryText = listItemProps.onRenderPrimaryText,
      secondaryTextKey = listItemProps.secondaryTextKey,
      onRenderSecondaryText = listItemProps.onRenderSecondaryText,
      tertiaryTextKey = listItemProps.tertiaryTextKey,
      onRenderTertiaryText = listItemProps.onRenderTertiaryText;
  var primaryText = primaryTextKey ? item[primaryTextKey] : null;
  var secondaryText = secondaryTextKey ? item[secondaryTextKey] : null;
  var tertiaryText = tertiaryTextKey ? item[tertiaryTextKey] : null;
  return /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        position: "relative"
      }
    }
  }, item.markedForDeletion && disableOnReadOnly ? /*#__PURE__*/React__default.createElement(TooltipHost, {
    content: i18n._(
    /*i18n*/
    {
      id: "Deletion in process"
    }) + "..",
    directionalHint: DirectionalHint.topCenter
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    horizontalAlign: "space-between",
    verticalAlign: "center",
    tokens: {
      childrenGap: 4
    },
    styles: {
      root: {
        maxWidth: "100%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: {
      root: {
        padding: 10,
        width: "100%",
        maxWidth: "100%",
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight),
        backgroundColor: DefaultPalette$2.white,
        minHeight: 60
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        color: DefaultPalette$2.white,
        fontSize: 14,
        backgroundColor: DefaultPalette$2.neutralDark,
        marginRight: 8,
        marginTop: 4,
        minHeight: 28,
        maxHeight: 28,
        minWidth: 28,
        border: "none",
        borderRadius: "50%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "CalculatorMultiply"
  })), /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 4
    },
    styles: {
      root: {
        overflow: "hidden",
        color: DefaultPalette$2.neutralTertiary
      }
    }
  }, onRenderPrimaryText ? onRenderPrimaryText({
    primaryText: primaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "mediumPlus",
    nowrap: true,
    block: true
  }, primaryText), onRenderSecondaryText ? onRenderSecondaryText({
    secondaryText: secondaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus",
    nowrap: true,
    block: true
  }, secondaryText), onRenderTertiaryText ? onRenderTertiaryText({
    tertiaryText: tertiaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "small",
    block: true,
    nowrap: true
  }, tertiaryText))))) : /*#__PURE__*/React__default.createElement(Link$2, {
    className: "unstyled-link" // TODO Pages only implemented for reports for now
    ,
    to: item.readOnly && disableOnReadOnly ? "#" : page && page !== "undefined" ? "/".concat(page, "/").concat(category, "/view/").concat(item.id) : "/".concat(category, "/view/").concat(item.id),
    onClick: function onClick() {
      return setSelectedIndex(index);
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    horizontalAlign: "space-between",
    verticalAlign: "center",
    tokens: {
      childrenGap: 4
    },
    styles: {
      root: {
        maxWidth: "100%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: {
      root: {
        color: item.readOnly && disableOnReadOnly ? DefaultPalette$2.neutralTertiary : "",
        padding: 10,
        width: "100%",
        maxWidth: "100%",
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight),
        backgroundColor: selected ? DefaultPalette$2.themeLighter : DefaultPalette$2.white,
        minHeight: 60,
        selectors: {
          "&:hover": {
            backgroundColor: selected ? DefaultPalette$2.themeLight : DefaultPalette$2.neutralLighter,
            cursor: "pointer"
          }
        }
      }
    }
  }, item.markedForDeletion ? /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        color: DefaultPalette$2.white,
        fontSize: 14,
        backgroundColor: DefaultPalette$2.neutralDark,
        marginRight: 8,
        marginTop: 4,
        minHeight: 28,
        maxHeight: 28,
        minWidth: 28,
        border: "none",
        borderRadius: "50%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "CalculatorMultiply"
  })) : /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        color: iconProps.inverted ? iconProps.color : DefaultPalette$2.white,
        fontSize: 14,
        backgroundColor: iconProps.inverted ? selected ? DefaultPalette$2.themeLighter : DefaultPalette$2.white : iconProps.onRenderIconColor ? iconProps.onRenderIconColor(item) : iconProps.color,
        marginRight: 8,
        marginTop: 4,
        minHeight: 28,
        maxHeight: 28,
        minWidth: 28,
        border: iconProps.inverted ? "1px solid ".concat(selected ? DefaultPalette$2.white : DefaultPalette$2.neutralLight) : "none",
        borderRadius: "50%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: iconProps.onRenderIconName ? iconProps.onRenderIconName(item) : iconProps.iconName,
    styles: iconProps.styles
  })), /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 4
    },
    styles: {
      root: {
        overflow: "hidden"
      }
    }
  }, onRenderPrimaryText ? onRenderPrimaryText({
    primaryText: primaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "mediumPlus",
    nowrap: true,
    block: true
  }, primaryText), onRenderSecondaryText ? onRenderSecondaryText({
    secondaryText: secondaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus",
    nowrap: true,
    block: true
  }, secondaryText), onRenderTertiaryText ? onRenderTertiaryText({
    tertiaryText: tertiaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "small",
    block: true,
    nowrap: true
  }, tertiaryText)), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        minWidth: infoIcons ? "calc(".concat(infoIcons.length, " * 20px)") : ""
      }
    }
  }), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        position: "absolute",
        right: "10px",
        minHeight: "40px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(NotificationIcons, {
    item: item,
    infoIcons: infoIcons
  }))))));
};

var Divider$1 = function Divider(_ref) {
  var layer = _ref.layer,
      hasBottomBorder = _ref.hasBottomBorder;
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    horizontalAlign: "space-between",
    verticalAlign: "center",
    styles: {
      root: {
        minWidth: 30,
        minHeight: 60,
        borderLeft: layer > 0 ? "1px dotted ".concat(DefaultPalette$2.neutralLight) : "none",
        borderBottom: hasBottomBorder ? "1px solid ".concat(DefaultPalette$2.neutralLight) : "none"
      }
    }
  });
};

var GroupedListItem$1 = function GroupedListItem(_ref) {
  var item = _ref.item,
      index = _ref.index,
      setSelectedIndex = _ref.setSelectedIndex,
      selected = _ref.selected,
      listItemProps = _ref.listItemProps;
  var category = listItemProps.category,
      iconProps = listItemProps.iconProps,
      infoIcons = listItemProps.infoIcons,
      disableOnReadOnly = listItemProps.disableOnReadOnly,
      primaryTextKey = listItemProps.primaryTextKey,
      onRenderPrimaryText = listItemProps.onRenderPrimaryText,
      secondaryTextKey = listItemProps.secondaryTextKey,
      onRenderSecondaryText = listItemProps.onRenderSecondaryText,
      tertiaryTextKey = listItemProps.tertiaryTextKey,
      onRenderTertiaryText = listItemProps.onRenderTertiaryText;
  var primaryText = primaryTextKey ? item[primaryTextKey] : null;
  var secondaryText = secondaryTextKey ? item[secondaryTextKey] : null;
  var tertiaryText = tertiaryTextKey ? item[tertiaryTextKey] : null;
  return /*#__PURE__*/React__default.createElement(Stack, null, item.markedForDeletion ? /*#__PURE__*/React__default.createElement(TooltipHost, {
    content: i18n._(
    /*i18n*/
    {
      id: "Deletion in process"
    }) + "..",
    directionalHint: DirectionalHint.topCenter
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true
  }, /*#__PURE__*/React__default.createElement(Divider$1, {
    layer: 0,
    hasBottomBorder: item.isLast
  }), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: {
      root: {
        padding: 10,
        width: "100%",
        maxWidth: "calc(100% - 30px)",
        borderLeft: "1px solid ".concat(DefaultPalette$2.neutralLight),
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight),
        backgroundColor: DefaultPalette$2.white,
        minHeight: 68
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        color: DefaultPalette$2.white,
        fontSize: 14,
        backgroundColor: DefaultPalette$2.neutralDark,
        marginRight: 8,
        marginTop: 4,
        minHeight: 28,
        maxHeight: 28,
        minWidth: 28,
        borderRadius: 14
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "CalculatorMultiply"
  })), /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 4
    },
    styles: {
      root: {
        overflow: "hidden",
        color: DefaultPalette$2.neutralTertiary
      }
    }
  }, onRenderPrimaryText ? onRenderPrimaryText({
    primaryText: primaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "mediumPlus",
    nowrap: true,
    block: true
  }, primaryText), onRenderSecondaryText ? onRenderSecondaryText({
    secondaryText: secondaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus",
    nowrap: true,
    block: true
  }, secondaryText), onRenderTertiaryText ? onRenderTertiaryText({
    tertiaryText: tertiaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "small",
    nowrap: true,
    block: true
  }, tertiaryText))))) : /*#__PURE__*/React__default.createElement(Link$2, {
    className: "unstyled-link",
    to: item.readOnly && disableOnReadOnly ? "#" : "/".concat(category, "/view/").concat(item.id),
    onClick: function onClick() {
      return setSelectedIndex(index);
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true
  }, /*#__PURE__*/React__default.createElement(Divider$1, {
    layer: 0,
    hasBottomBorder: item.isLast
  }), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: {
      root: {
        color: item.readOnly && disableOnReadOnly ? DefaultPalette$2.neutralTertiary : "",
        padding: 10,
        width: "100%",
        maxWidth: "calc(100% - 30px)",
        borderLeft: "1px solid ".concat(DefaultPalette$2.neutralLight),
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight),
        backgroundColor: selected ? DefaultPalette$2.themeLighter : DefaultPalette$2.white,
        minHeight: 68,
        selectors: {
          "&:hover": {
            backgroundColor: selected ? DefaultPalette$2.themeLight : DefaultPalette$2.neutralLighter,
            cursor: "pointer"
          }
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        color: DefaultPalette$2.white,
        fontSize: 14,
        backgroundColor: iconProps.color,
        marginRight: 8,
        marginTop: 4,
        minHeight: 28,
        maxHeight: 28,
        minWidth: 28,
        borderRadius: 14
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: iconProps.iconName,
    styles: iconProps.styles
  })), /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 4
    },
    styles: {
      root: {
        overflow: "hidden"
      }
    }
  }, onRenderPrimaryText ? onRenderPrimaryText({
    primaryText: primaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "mediumPlus",
    nowrap: true,
    block: true
  }, primaryText), onRenderSecondaryText ? onRenderSecondaryText({
    secondaryText: secondaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus",
    nowrap: true,
    block: true
  }, secondaryText), onRenderTertiaryText ? onRenderTertiaryText({
    tertiaryText: tertiaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "small",
    nowrap: true,
    block: true
  }, tertiaryText)), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        minWidth: infoIcons ? "calc(".concat(infoIcons.length, " * 30px)") : ""
      }
    }
  }), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        position: "absolute",
        right: "10px",
        minHeight: "40px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(NotificationIcons, {
    item: item,
    infoIcons: infoIcons
  }))))));
};

var TreeListItem$1 = function TreeListItem(_ref) {
  var item = _ref.item,
      listItemProps = _ref.listItemProps,
      onItemClick = _ref.onItemClick;
  var category = listItemProps.category,
      _listItemProps$iconPr = listItemProps.iconProps,
      iconProps = _listItemProps$iconPr === void 0 ? {} : _listItemProps$iconPr,
      infoIcons = listItemProps.infoIcons,
      disableOnReadOnly = listItemProps.disableOnReadOnly,
      primaryTextKey = listItemProps.primaryTextKey,
      onRenderPrimaryText = listItemProps.onRenderPrimaryText,
      secondaryTextKey = listItemProps.secondaryTextKey,
      onRenderSecondaryText = listItemProps.onRenderSecondaryText;
  var primaryText = primaryTextKey ? item[primaryTextKey] : null;
  var secondaryText = secondaryTextKey ? item[secondaryTextKey] : null;
  var iconStyles = {
    root: {
      color: item.containsSelected || item.isSelected ? iconProps.colorDarker : iconProps.color,
      margin: 8,
      padding: 8,
      fontSize: 14,
      border: item.isSelected ? "1px solid ".concat(DefaultPalette$2.white) : "1px solid ".concat(DefaultPalette$2.neutralLight),
      borderRadius: "50%",
      backgroundColor: item.containsSelected || item.isSelected ? DefaultPalette$2.themeLighter : DefaultPalette$2.white
    }
  };
  var mergedIconStyles = iconProps.styles ? Object.assign(iconStyles, iconProps.styles) : iconStyles;
  var layers = new Array(item.layer).fill(0);
  var layerDifference = item.layer - item.nextLayer;
  var dividers = layers.map(function (n, i) {
    var hasBottomBorder = i > layers.length - layerDifference - 1;
    return /*#__PURE__*/React__default.createElement(Divider$1, {
      key: i,
      layer: i,
      hasBottomBorder: hasBottomBorder
    });
  });
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    horizontalAlign: "start",
    styles: {
      root: {
        position: "relative"
      }
    }
  }, item.layer > 0 && dividers, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    horizontalAlign: "space-between",
    verticalAlign: "center",
    styles: {
      root: {
        color: item.readOnly && disableOnReadOnly ? DefaultPalette$2.neutralTertiary : "",
        width: "calc(100% - ".concat(item.layer * 30, "px)"),
        borderLeft: !item.isRootItem ? "1px solid ".concat(DefaultPalette$2.neutralLight) : "none",
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight),
        backgroundColor: item.isSelected ? DefaultPalette$2.themeLighter : DefaultPalette$2.white,
        minHeight: 60,
        selectors: {
          "&:hover": {
            backgroundColor: item.isSelected ? DefaultPalette$2.themeLight : DefaultPalette$2.neutralLighter,
            cursor: "pointer"
          }
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Link$2, {
    className: "unstyled-link",
    disabled: item.readonly && disableOnReadOnly,
    to: item.readOnly && disableOnReadOnly ? "#" : "/".concat(category, "/view/").concat(item.id),
    onClick: function onClick() {
      return onItemClick(item, true);
    },
    style: {
      overflow: "hidden",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    horizontalAlign: "start",
    verticalAlign: "center"
  }, item.children.length > 0 && /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        color: DefaultPalette$2.neutralPrimary,
        minWidth: 30,
        height: 60
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: item.isCollapsed ? "ChevronRightMed" : "ChevronDownMed"
  })), /*#__PURE__*/React__default.createElement(Icon, {
    iconName: iconProps.iconName,
    styles: mergedIconStyles
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "mediumPlus",
    nowrap: true,
    block: true,
    styles: {
      root: {
        color: item.containsSearched && !item.isSearched ? DefaultPalette$2.neutralQuaternary : "inherited"
      }
    }
  }, onRenderPrimaryText ? onRenderPrimaryText({
    primaryText: primaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "mediumPlus",
    nowrap: true,
    block: true
  }, primaryText, item.children.length > 0 && " ".concat("(".concat(item.children.length, ")"))), onRenderSecondaryText ? onRenderSecondaryText({
    secondaryText: secondaryText,
    item: item
  }) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus",
    nowrap: true,
    block: true
  }, secondaryText)), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        minWidth: infoIcons ? "calc(".concat(infoIcons.length, " * 20px)") : ""
      }
    }
  }), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        position: "absolute",
        right: "10px",
        minHeight: "40px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(NotificationIcons, {
    item: item,
    infoIcons: infoIcons
  }))))));
};

function timeout(delay) {
  return new Promise(function (res) {
    return setTimeout(res, delay);
  });
}

function setScroll(_x) {
  return _setScroll.apply(this, arguments);
}

function _setScroll() {
  _setScroll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
    var list, index;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return timeout(1);

          case 2:
            list = options.list, index = options.index;
            if (list.current) list.current.scrollToIndex(index);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setScroll.apply(this, arguments);
}

var _onRenderCell$1 = function onRenderCell(options, onRenderDefault) {
  if (onRenderDefault) {
    return onRenderDefault(options);
  }

  return /*#__PURE__*/React__default.createElement(FlatListItem, options);
};

var FlatList = function FlatList(_ref) {
  var itemId = _ref.itemId,
      items = _ref.items,
      listItemProps = _ref.listItemProps;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listItems = _useState2[0],
      setListItems = _useState2[1];

  var _useState3 = useState(-1),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedIndex = _useState4[0],
      setSelectedIndex = _useState4[1];

  var _useState5 = useState(-1),
      _useState6 = _slicedToArray(_useState5, 2),
      scrollIndex = _useState6[0],
      setScrollIndex = _useState6[1];

  var list = useRef(null); // Update list items when the selected item changes

  useEffect(function () {
    var newItems = _toConsumableArray(items);

    var item = itemId ? newItems.findIndex(function (i) {
      return String(i.id) === itemId;
    }) : -1;
    setListItems(newItems);
    setSelectedIndex(item);
    if (scrollIndex < 0) setScroll({
      list: list,
      index: item
    });
    setScrollIndex(item); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId, items]);
  return /*#__PURE__*/React__default.createElement(List, {
    items: listItems,
    componentRef: list,
    onRenderCell: function onRenderCell(item, index) {
      return _onRenderCell$1({
        item: item,
        index: index,
        selected: selectedIndex === index,
        setSelectedIndex: setSelectedIndex,
        listItemProps: listItemProps
      }, listItemProps.onRenderDefault);
    }
  });
};

function timeout$1(delay) {
  return new Promise(function (res) {
    return setTimeout(res, delay);
  });
}

function setScroll$1(_x) {
  return _setScroll$1.apply(this, arguments);
}

function _setScroll$1() {
  _setScroll$1 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
    var list, index;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return timeout$1(1);

          case 2:
            list = options.list, index = options.index;
            if (list.current) list.current.scrollToIndex(index);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setScroll$1.apply(this, arguments);
}

var onRenderHeader$1 = function onRenderHeader(_ref) {
  var group = _ref.group,
      onToggleCollapse = _ref.onToggleCollapse;
  var name = group.name,
      secondaryName = group.secondaryName,
      isCollapsed = group.isCollapsed,
      setHasBeenClicked = group.setHasBeenClicked,
      count = group.count;
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    onClick: function onClick() {
      setHasBeenClicked(true);
      onToggleCollapse(group);
    },
    tokens: {
      childrenGap: 8
    },
    styles: {
      root: {
        minHeight: 40,
        cursor: "pointer",
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight)
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    verticalFill: true,
    styles: {
      root: {
        minWidth: 30,
        minHeight: secondaryName ? 60 : 40,
        selectors: {
          "&:hover": {
            backgroundColor: DefaultPalette$2.neutralLighter
          }
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: isCollapsed ? "ChevronRightMed" : "ChevronDownMed"
  })), /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Text, {
    variant: "large",
    styles: {
      root: {
        fontWeight: "auto"
      }
    }
  }, name, " (", count, ")"), /*#__PURE__*/React__default.createElement(Text, {
    variant: "small",
    styles: {
      root: {
        fontWeight: "auto"
      }
    }
  }, secondaryName)));
};

var _onRenderCell$2 = function onRenderCell(options) {
  return options.listItemProps.onRenderGroup ? options.listItemProps.onRenderGroup(options) : /*#__PURE__*/React__default.createElement(GroupedListItem$1, options);
}; // This is the grouped list view, where the items are shown in sublists,
// created from the `groupedListKey` that is passed in with props. If no
// `groupedListKey` exists, the grouped list cannot be shown.


var GroupedList$1 = function GroupedList(_ref2) {
  var itemId = _ref2.itemId,
      items = _ref2.items,
      listItemProps = _ref2.listItemProps,
      hasSearchText = _ref2.hasSearchText;
  var groupedListKey = listItemProps.groupedListKey,
      groupedListSecondaryKey = listItemProps.groupedListSecondaryKey;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listItems = _useState2[0],
      setListItems = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      listGroups = _useState4[0],
      setListGroups = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedIndex = _useState6[0],
      setSelectedIndex = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedId = _useState8[0],
      setSelectedId = _useState8[1];

  var _useState9 = useState(-1),
      _useState10 = _slicedToArray(_useState9, 2),
      scrollIndex = _useState10[0],
      setScrollIndex = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      hasBeenClicked = _useState12[0],
      setHasBeenClicked = _useState12[1];

  var list = useRef(null); //Fix @fluentui/react bug: #5094 Grouped DetailsList has unexpected scrolling bevaviour when virtualized

  function getGroupHeight(group) {
    //Should be set to same value as minHeight in GroupedListItem
    var itemHeight = 68;
    var groupHeight = groupedListSecondaryKey ? 60 : 40;
    if (group.isCollapsed) return groupHeight;

    if (!group.children || !group.children.length) {
      return groupHeight + itemHeight * group.count;
    }

    return group.children.reduce(function (acc, child) {
      return acc + getGroupHeight(child);
    }, itemHeight);
  }

  useEffect(function () {
    // Handle id and selected index when id is not equals to itemId
    if (listItems && selectedIndex > -1) {
      var newSelectedId = listItems[selectedIndex].id;
      if (selectedId != newSelectedId) setSelectedId(newSelectedId);
    }
  }, [selectedIndex, listItems]);
  useEffect(function () {
    var newSortedListItems = items.sort(function (a, b) {
      return String(a[groupedListKey] || "").localeCompare(String(b[groupedListKey] || ""));
    });
    setSelectedIndex( // Handle id and selected index when id is not equals to itemId
    selectedId > -1 ? newSortedListItems.findIndex(function (i) {
      return String(i.id) === String(selectedId);
    }) : itemId ? newSortedListItems.findIndex(function (i) {
      return String(i.id) === itemId || String(i.id) === itemId;
    }) : -1); // Add `isLast` to the items, denoting if the item is the last in its group

    var newListItemsWithGroupContext = newSortedListItems.map(function (item, idx, items) {
      var itemGroup = item[groupedListKey];
      var nextItemsGroup = items[idx + 1] && items[idx + 1][groupedListKey];
      item.isLast = itemGroup !== nextItemsGroup;
      return item;
    });
    setListItems(newListItemsWithGroupContext);
  }, [groupedListKey, items, selectedId]);
  useEffect(function () {
    if (!itemId) setScrollIndex(1);
    if (scrollIndex > 0 || listGroups.length === 0 || items.length === 0 || !itemId) return;
    var item = items.find(function (i) {
      return String(i.id) === itemId;
    });
    if (!item) return; // Find group for selected item

    var itemGroup = item[groupedListKey]; // Set index to index for selected item group

    var index = listGroups.findIndex(function (i) {
      return i.key === itemGroup;
    });
    setScroll$1({
      list: list,
      index: index
    });
    setScrollIndex(index); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listGroups]);
  useEffect(function () {
    setListGroups(function (prevGroups) {
      var previousCollapsedState = prevGroups.reduce(function (acc, group) {
        acc[group.name] = group.isCollapsed;
        return acc;
      }, {});
      var newGroups = listItems.reduce(function (acc, item, idx) {
        var groupName = item[groupedListKey];
        var groupedSecondaryName = item[groupedListSecondaryKey];

        if (!acc[groupName]) {
          var isCollapsed = hasSearchText ? false : previousCollapsedState[groupName] !== undefined ? previousCollapsedState[groupName] : true;
          acc[groupName] = {
            name: groupName,
            secondaryName: groupedSecondaryName,
            key: groupName,
            level: 0,
            startIndex: idx,
            count: 1,
            isCollapsed: isCollapsed
          };
        } else {
          acc[groupName].count++;
        }

        return acc;
      }, {});
      return Object.keys(newGroups).map(function (groupName) {
        var group = newGroups[groupName];
        var startIndex = group.startIndex;
        var endIndex = group.startIndex + group.count;
        var containsSelectedItem = selectedIndex >= startIndex && selectedIndex < endIndex && !hasBeenClicked;
        group.isCollapsed = containsSelectedItem ? false : group.isCollapsed;
        group.setHasBeenClicked = containsSelectedItem ? setHasBeenClicked : function () {
          return;
        };
        group.endIndex = endIndex;
        return group;
      });
    });
  }, [groupedListKey, hasSearchText, itemId, items, listItems, selectedIndex]);
  return /*#__PURE__*/React__default.createElement(GroupedList$2, {
    items: listItems,
    groups: listGroups,
    componentRef: list,
    onRenderCell: function onRenderCell(nestingDepth, item, index) {
      return _onRenderCell$2({
        item: item,
        index: index,
        listGroups: listGroups,
        selected: selectedIndex === index,
        setSelectedIndex: setSelectedIndex,
        listItemProps: listItemProps
      });
    },
    selectionMode: SelectionMode.none,
    groupProps: {
      onRenderHeader: onRenderHeader$1
    } //Fix @fluentui/react bug: #5094 Grouped DetailsList has unexpected scrolling bevaviour when virtualized
    ,
    getGroupHeight: getGroupHeight
  });
};

/** The TreeList shows an hierarchical list, where each item with children has
 * a collapsed state. Ie. each element can either show or hide its own children.
 *
 * @param {string} itemId The id of the selected item
 * @param {array} items The original, flat list of list items
 * @param {object} listItemProps The props passed in to the parent component
 * @param {boolean} hasSearchText If the user has entered text in the search field
 * @param {array} searchResult The flat list of items that are the result of applying
 *   all filters and search
 */

function timeout$2(delay) {
  return new Promise(function (res) {
    return setTimeout(res, delay);
  });
}

function setScroll$2(_x) {
  return _setScroll$2.apply(this, arguments);
}

function _setScroll$2() {
  _setScroll$2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
    var list, index;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return timeout$2(1);

          case 2:
            list = options.list, index = options.index;
            if (list.current) list.current.scrollToIndex(index);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setScroll$2.apply(this, arguments);
}

var TreeList$1 = function TreeList(_ref) {
  var itemId = _ref.itemId,
      items = _ref.items,
      listItemProps = _ref.listItemProps,
      hasSearchText = _ref.hasSearchText,
      searchResult = _ref.searchResult;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listItems = _useState2[0],
      setListItems = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      itemHierarchy = _useState4[0],
      setItemHierarchy = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var _useState7 = useState(-1),
      _useState8 = _slicedToArray(_useState7, 2),
      scrollIndex = _useState8[0],
      setScrollIndex = _useState8[1];

  var list = useRef(null);
  var previousHasSearchText = usePrevious(hasSearchText);
  var itemLookup = useMemo(function () {
    return searchResult.reduce(function (acc, item) {
      acc[item.id] = item;
      return acc;
    }, {});
  }, [searchResult]);
  /** Creates the relevant state of results from a search update
   * @returns {object}
   *   @param {array} parentUuids list of ids of items that contain a searched item
   *   @param {array} resultIds list of ids of searched items
   */

  var search = useMemo(function () {
    if (!hasSearchText) return null;
    var resultIds = searchResult.map(function (item) {
      return item.id;
    });
    var searchedParents = searchResult.reduce(function (acc, item) {
      var parents = _toConsumableArray(item.breadcrumb); // Remove the last item to only have the parents


      parents.pop();
      return [].concat(_toConsumableArray(acc), _toConsumableArray(parents));
    }, []);

    var parentUuids = _toConsumableArray(new Set(searchedParents));

    return {
      parentUuids: parentUuids,
      resultIds: resultIds
    };
  }, [hasSearchText, searchResult]); // Update selected item

  useEffect(function () {
    var newSelectedItem = itemId ? itemLookup[itemId] : null;
    setSelected(newSelectedItem);
  }, [itemId, itemLookup]); // Update the hierarchy

  useEffect(function () {
    if (!items) return;
    var rootItem = [items.find(function (item) {
      return item.parentUuid === null;
    })]; // Calculates the state of the individual element in the hierarchy

    var getItemContext = function getItemContext(item, isRootItem) {
      var isSelected = selected && selected.id === item.id;
      var isSearched = hasSearchText ? search.resultIds.includes(item.id) : false;
      var containsSelected = selected ? selected.breadcrumb.includes(item.id) : false;
      var containsSearched = hasSearchText ? search.parentUuids.includes(item.id) : false; // The item should be in a collpsed state in the following circumstances:

      var isDoneSearching = previousHasSearchText && !hasSearchText;
      var isCollapsed;

      if (isRootItem) {
        isCollapsed = false;
      } else if (selected && containsSelected) {
        isCollapsed = false;
      } else if (isDoneSearching) {
        isCollapsed = true;
      } else if (hasSearchText) {
        isCollapsed = false;
      } else if (item.isCollapsed !== undefined) {
        isCollapsed = item.isCollapsed;
      } else {
        isCollapsed = true;
      }

      return {
        isSelected: isSelected,
        isSearched: isSearched,
        containsSelected: containsSelected,
        containsSearched: containsSearched,
        isCollapsed: isCollapsed,
        isRootItem: isRootItem
      };
    }; // Creates the initial hierarchal structure based on the root item


    var createHierarchy = function createHierarchy(newItems) {
      var layer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var breadcrumb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var isRootItem = layer === 0;
      return newItems.map(function (item) {
        var itemContext = getItemContext(item, isRootItem);
        var newBreadcrumb = [].concat(_toConsumableArray(breadcrumb), [item.id]);
        return _objectSpread2(_objectSpread2(_objectSpread2({}, item), itemContext), {}, {
          isRootItem: isRootItem,
          layer: layer,
          breadcrumb: newBreadcrumb,
          children: item.children ? createHierarchy(item.children, layer + 1, newBreadcrumb) : null
        });
      });
    }; // Updates the hierarchy when state changes


    var updateHierarchy = function updateHierarchy(newItems) {
      return newItems.map(function (item) {
        var children = item.children ? updateHierarchy(item.children) : null;
        var itemContext = getItemContext(item, item.isRootItem);
        return _objectSpread2(_objectSpread2(_objectSpread2({}, item), itemContext), {}, {
          children: children
        });
      });
    };

    setItemHierarchy(function (previous) {
      return previous ? updateHierarchy(previous) : createHierarchy(rootItem);
    });
  }, [items, selected, search, hasSearchText, previousHasSearchText]); // Creates the actual list

  useEffect(function () {
    if (!itemHierarchy) return;

    var createNewListItems = function createNewListItems(items) {
      return items.reduce(function (acc, item) {
        if (hasSearchText) {
          if (item.containsSearched) {
            return [].concat(_toConsumableArray(acc), [item], _toConsumableArray(createNewListItems(item.children)));
          } else if (item.isSearched) {
            return [].concat(_toConsumableArray(acc), [item]);
          }

          return acc;
        }

        if (item.isCollapsed) return [].concat(_toConsumableArray(acc), [item]);
        return [].concat(_toConsumableArray(acc), [item], _toConsumableArray(createNewListItems(item.children)));
      }, []);
    };

    var newListItems = createNewListItems(itemHierarchy); // In order to correctly show bottom borders, we need to know what layer
    // the next item is on.

    var newListLength = newListItems.length;
    newListItems.forEach(function (item, idx) {
      item.nextLayer = idx + 1 === newListLength ? 0 : newListItems[idx + 1].layer;
    });
    setListItems(newListItems); // Find index for selected item

    var selectedItem = itemId ? newListItems.findIndex(function (i) {
      return String(i.id) === itemId;
    }) : -1;
    if (scrollIndex < 0) setScroll$2({
      list: list,
      index: selectedItem
    });
    setScrollIndex(selectedItem); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasSearchText, itemHierarchy]);

  var onItemClick = function onItemClick(item) {
    var toggle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // Only toggle the item if the toggle button is clicked
    item.isCollapsed = toggle ? !item.isCollapsed : false;
    setItemHierarchy(_toConsumableArray(itemHierarchy));
  };

  return /*#__PURE__*/React__default.createElement(List, {
    items: listItems,
    componentRef: list,
    onRenderCell: function onRenderCell(item) {
      return /*#__PURE__*/React__default.createElement(TreeListItem$1, {
        item: item,
        listItemProps: listItemProps,
        onItemClick: onItemClick
      });
    }
  });
};

function timeout$3(delay) {
  return new Promise(function (res) {
    return setTimeout(res, delay);
  });
}

function setScroll$3(_x) {
  return _setScroll$3.apply(this, arguments);
}

function _setScroll$3() {
  _setScroll$3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
    var list, index;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return timeout$3(1);

          case 2:
            list = options.list, index = options.index;
            if (list.current) list.current.scrollToIndex(index);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setScroll$3.apply(this, arguments);
}

var onRenderHeader$2 = function onRenderHeader(_ref) {
  var group = _ref.group,
      onToggleCollapse = _ref.onToggleCollapse;
  var name = group.name,
      isCollapsed = group.isCollapsed,
      setHasBeenClicked = group.setHasBeenClicked,
      count = group.count;
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    onClick: function onClick() {
      setHasBeenClicked(true);
      onToggleCollapse(group);
    },
    tokens: {
      childrenGap: 8
    },
    styles: {
      root: {
        minHeight: 40,
        cursor: "pointer",
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight)
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    verticalFill: true,
    styles: {
      root: {
        minWidth: 30,
        minHeight: 40,
        selectors: {
          "&:hover": {
            backgroundColor: DefaultPalette$2.neutralLighter
          }
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: isCollapsed ? "ChevronRightMed" : "ChevronDownMed"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "large",
    styles: {
      root: {
        fontWeight: "auto"
      }
    }
  }, name, " (", count, ")"));
};

var _onRenderCell$3 = function onRenderCell(options) {
  return options.listItemProps.onRenderGroup ? options.listItemProps.onRenderGroup(options) : /*#__PURE__*/React__default.createElement(GroupedListItem$1, options);
}; // This is the grouped list view, where the items are shown in sublists,
// created from the `groupedByDateListKey` that is passed in with props. If no
// `groupedByDateListKey` exists, the grouped list cannot be shown.


var GroupedByDateList = function GroupedByDateList(_ref2) {
  var itemId = _ref2.itemId,
      items = _ref2.items,
      listItemProps = _ref2.listItemProps,
      hasSearchText = _ref2.hasSearchText;
  var groupedByDateListKey = listItemProps.groupedByDateListKey;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listItems = _useState2[0],
      setListItems = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      listGroups = _useState4[0],
      setListGroups = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedIndex = _useState6[0],
      setSelectedIndex = _useState6[1];

  var _useState7 = useState(-1),
      _useState8 = _slicedToArray(_useState7, 2),
      scrollIndex = _useState8[0],
      setScrollIndex = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      hasBeenClicked = _useState10[0],
      setHasBeenClicked = _useState10[1];

  var list = useRef(null); //Fix @fluentui/react bug: #5094 Grouped DetailsList has unexpected scrolling bevaviour when virtualized

  function getGroupHeight(group) {
    //Should be set to same value as minHeight in GroupedListItem
    var itemHeight = 68;
    var groupHeight = 40;
    if (group.isCollapsed) return groupHeight;

    if (!group.children || !group.children.length) {
      return groupHeight + itemHeight * group.count;
    }

    return group.children.reduce(function (acc, child) {
      return acc + getGroupHeight(child);
    }, itemHeight);
  }

  useEffect(function () {
    var newSortedListItems = orderByDate(items.sort(function (a, b) {
      return b[groupedByDateListKey] - a[groupedByDateListKey];
    }));
    setSelectedIndex(itemId ? newSortedListItems.findIndex(function (i) {
      return String(i.id) === itemId;
    }) : -1); // Add `isLast` to the items, denoting if the item is the last in its group

    var newListItemsWithGroupContext = newSortedListItems.map(function (item, idx, items) {
      var itemGroup = item[groupedByDateListKey];
      var nextItemsGroup = items[idx + 1] && items[idx + 1][groupedByDateListKey];
      item.isLast = itemGroup !== nextItemsGroup;
      return item;
    });
    setListItems(newListItemsWithGroupContext);
  }, [groupedByDateListKey, itemId, items]);
  useEffect(function () {
    if (!itemId) setScrollIndex(1);
    if (scrollIndex > 0 || listGroups.length === 0 || items.length === 0 || !itemId) return;
    var item = items.find(function (i) {
      return String(i.id) === itemId;
    });
    if (!item) return; // Find group for selected item

    var itemGroup = item[groupedByDateListKey]; // Set index to index for selected item group

    var index = listGroups.findIndex(function (i) {
      return i.key === itemGroup;
    });
    setScroll$3({
      list: list,
      index: index
    });
    setScrollIndex(index); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listGroups]);
  useEffect(function () {
    setListGroups(function (prevGroups) {
      var previousCollapsedState = prevGroups.reduce(function (acc, group) {
        acc[group.name] = group.isCollapsed;
        return acc;
      }, {});
      var newGroups = listItems.reduce(function (acc, item, idx) {
        var groupName = item[groupedByDateListKey];

        if (!acc[groupName]) {
          var isCollapsed = hasSearchText ? false : previousCollapsedState[groupName] !== undefined ? previousCollapsedState[groupName] : true;
          acc[groupName] = {
            name: groupName,
            key: groupName,
            level: 0,
            startIndex: idx,
            count: 1,
            isCollapsed: isCollapsed
          };
        } else {
          acc[groupName].count++;
        }

        return acc;
      }, {});
      return Object.keys(newGroups).map(function (groupName) {
        var group = newGroups[groupName];
        var startIndex = group.startIndex;
        var endIndex = group.startIndex + group.count;
        var containsSelectedItem = selectedIndex >= startIndex && selectedIndex < endIndex && !hasBeenClicked;
        group.isCollapsed = containsSelectedItem ? false : group.isCollapsed;
        group.setHasBeenClicked = containsSelectedItem ? setHasBeenClicked : function () {
          return;
        };
        group.endIndex = endIndex;
        return group;
      });
    });
  }, [groupedByDateListKey, hasSearchText, itemId, items, listItems, selectedIndex]);
  return /*#__PURE__*/React__default.createElement(GroupedList$2, {
    items: listItems,
    groups: listGroups,
    componentRef: list,
    onRenderCell: function onRenderCell(nestingDepth, item, index) {
      return _onRenderCell$3({
        item: item,
        index: index,
        listGroups: listGroups,
        selected: selectedIndex === index,
        setSelectedIndex: setSelectedIndex,
        listItemProps: listItemProps
      });
    },
    selectionMode: SelectionMode.none,
    groupProps: {
      onRenderHeader: onRenderHeader$2
    } //Fix @fluentui/react bug: #5094 Grouped DetailsList has unexpected scrolling bevaviour when virtualized
    ,
    getGroupHeight: getGroupHeight
  });
};

function orderByDate(items) {
  var order = [i18n._(
  /*i18n*/
  {
    id: "Today"
  }), i18n._(
  /*i18n*/
  {
    id: "Yesterday"
  }), i18n._(
  /*i18n*/
  {
    id: "This week"
  }), i18n._(
  /*i18n*/
  {
    id: "Last week"
  }), i18n._(
  /*i18n*/
  {
    id: "Three weeks ago"
  }), i18n._(
  /*i18n*/
  {
    id: "This month"
  }), i18n._(
  /*i18n*/
  {
    id: "Last month"
  }), i18n._(
  /*i18n*/
  {
    id: "Older"
  })];
  var result = items.sort(function (a, b) {
    return order.indexOf(a.created) - order.indexOf(b.created);
  });
  return result;
}

var fuseWorkerUrl = "data:application/javascript;base64,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";

function useFuse(_ref) {
  var items = _ref.items,
      searchKeys = _ref.searchKeys;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      searchResults = _useState2[0],
      setSearchResults = _useState2[1];

  var workerRef = useRef(null); // Instantiate the web worker and (re)initialise it with the data set.
  // The cleanup terminates the worker when items/searchKeys change or the
  // component unmounts, so workers are not leaked across re-renders.

  useEffect(function () {
    var worker = new Worker(fuseWorkerUrl);

    worker.onmessage = function (event) {
      var workerResult = JSON.parse(event.data);
      setSearchResults(workerResult);
    };

    worker.postMessage(JSON.stringify({
      command: "init",
      data: {
        items: items,
        searchKeys: searchKeys
      }
    }));
    workerRef.current = worker;
    return function () {
      worker.terminate();
      workerRef.current = null;
    };
  }, [items, searchKeys]);
  var search = useCallback(function (searchText) {
    if (!searchText || !searchText.length) return;
    var worker = workerRef.current;
    if (!worker) return;
    worker.postMessage(JSON.stringify({
      command: "search",
      data: searchText
    }));
  }, []);
  return {
    search: search,
    searchResults: searchResults
  };
}

var selectionListMinWidth = 320;
var selectionListMaxWidth = 700;

function sortByDate(items) {
  return items.sort(function (a, b) {
    return b.originCreated - a.originCreated;
  });
}

function sortAlphabetical(items) {
  return items.sort(function (a, b) {
    var nameA = a.name.toLowerCase(),
        nameB = b.name.toLowerCase();
    if (nameA < nameB) //sort string ascending
      return -1;
    if (nameA > nameB) return 1;
    return 0; //default return value (no sorting)
  });
}
/**
 * @description The SelectionList component is used to show a list of the main entities of
 * an app. For the role app, that might be roles and rolegroups. For the people
 * app, that would be users. In other cases it can be used to show favorites or
 * saved filters.
 * @param {object} store The store that holds the data needed to display the list.
 * @param {object} match The match object from react-router-dom.
 * @param {Array || undefined} searchKeys A list of property keys to search on
 *   when the user uses the search field.
 * @param {obj || undefined} listItemProps Options describing the display of list items.
 *   @param {string} category The category of the items. Eg. "systems" or "users".
 *   @param {string} groupedListKey The property the the items should be grouped on.
 *     it cannot be a nested property, eg. "itSystemName", not "itSystem.name".
 *   @param {object} iconProps
 *     @param {string} iconName The name of the Fabric icon to be used.
 *     @param {string} color Color of the icon
 *     @param {string} colorDarker A darker color for the icon
 *     @param {string} colorLighter A lighter color for the icon
 *   @param {string} primaryTextKey The property name that holds the primary text.
 *   @param {fn || undefined} onRenderPrimaryText A render function for the
 *     primary text field. The function should take the value of `primaryTextKey`
 *     as an argument.
 *   @param {string} secondaryTextKey The property name that holds the secondary text.
 *   @param {fn || undefined} onRenderSecondaryText A render function for the
 *     secondary text field. The function should take the value of `secondaryTextKey`
 *     as an argument.
 *   @param {Array{}} treeListItems A list of hirarchically organised, distinct
 *     tree list structures. Any top-level component should be the root item of
 *     a distinct list/list view.
 *   @param {fn || undefined} onRenderTertiaryText A render function for the
 *     tertiary text field. The function should take the value of `tertiaryTextKey`
 *     as an argument.
 *   @param {string} tertiaryTextKey The property name that holds the tertiary text.
 *     TODO: Support multiple list roots.
 *   @param {boolean || undefined} treeListItems A reference to whether there is
 *     a parent/child relationship between the items, and if it is appropriately
 *     set up for the TreeList to consume. Which means that the root item has a
 *     `parentUuid` property equal to `null`, and contains the entire tree.
 *   @param {string || undefined} defaultListType The list type that should be
 *     selected when the page loads.
 *   @param {object || undefined} orderBy Parameters for sorting the list.
 *     @param {string || Array{} || undefined} iteratees Field name(s) to sort by
 *     Default is "primaryTextKey"
 *     @param {string || Array{} || undefined} orders Ex. "desc" or "asc"
 *     Default is "asc"
 *  TODO IS THERE MORE FORGOTTON
 */

var SelectionList = function SelectionList(_ref) {
  var store = _ref.store,
      match = _ref.match,
      searchKeys = _ref.searchKeys,
      searchHint = _ref.searchHint,
      listItemProps = _ref.listItemProps;
  var state = store.state,
      setItemsFromListView = store.setItemsFromListView;
  var items = state.items,
      isFetchingItems = state.isFetchingItems;
  var itemId = match.params.id;

  var _useLocalStorage = useLocalStorage("selectionListWidth", selectionListMinWidth),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      currentWidth = _useLocalStorage2[0],
      setCurrentWidth = _useLocalStorage2[1];

  var _useCookies = useCookies(),
      _useCookies2 = _slicedToArray(_useCookies, 2),
      cookies = _useCookies2[0],
      setCookies = _useCookies2[1];

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      listItems = _useState2[0],
      setListItems = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      listView = _useState4[0],
      setListView = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      searchText = _useState6[0],
      setSearchText = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      noSearchResults = _useState8[0],
      setNoSearchResults = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      noItems = _useState10[0],
      setNoItems = _useState10[1];

  var _useState11 = useState(true),
      _useState12 = _slicedToArray(_useState11, 2),
      searchFieldDisabled = _useState12[0],
      setSearchFieldDisabled = _useState12[1];

  var _useState13 = useState(),
      _useState14 = _slicedToArray(_useState13, 2),
      filterProps = _useState14[0],
      setFilterProps = _useState14[1];

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      category = _useState16[0],
      setCategory = _useState16[1];

  var _useState17 = useState(),
      _useState18 = _slicedToArray(_useState17, 2),
      hasSearchText = _useState18[0],
      setHasSearchText = _useState18[1]; // initialize fuse search


  var _useFuse = useFuse({
    items: items,
    searchKeys: searchKeys
  }),
      search = _useFuse.search,
      searchResults = _useFuse.searchResults;

  useEffect(function () {
    if (!isFetchingItems && setItemsFromListView && category) {
      setItemsFromListView(listView, category);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isFetchingItems, listView, category]); //enable search when data is read into the list

  useEffect(function () {
    setNoSearchResults(false);
    setNoItems(false);
    setFilterProps("");
    if (isFetchingItems || !items) return;

    if (Array.isArray(items) && !items.length) {
      setNoItems(true);
      setListItems([]);
      return;
    }

    setHasSearchText(searchText.length > 0);
    search(searchText ? searchText : ""); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, isFetchingItems, searchText]); // If user has default filter it should be aktivated as default

  useEffect(function () {
    if (!listItemProps) return; // Set listView to defaultListType if listView is not set or category changes

    if (!listView || listItemProps.category !== category) {
      setListView(cookies[listItemProps.listTypeCookieName] ? cookies[listItemProps.listTypeCookieName] : listItemProps.defaultListType ? listItemProps.defaultListType : "alphabetical");
    }

    setCategory(listItemProps.category); // Set default filter automatically

    if (!listItemProps.filters || listItemProps.filters.length === 0) setFilterProps(undefined);else listItemProps.filters.forEach(function (filter) {
      if (filter.key === "defaultFilter" && filterProps === undefined) setFilterProps(filter.filterProps);
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listItemProps]); // Filter listItems

  useEffect(function () {
    if (isFetchingItems || !items) return; //enable search when data is read into the list

    setSearchFieldDisabled(false);
    var newListItems = !hasSearchText ? _toConsumableArray(items) : searchResults; // If a filter is selected items should be filtered

    var filteredItems = newListItems;

    if (filterProps) {
      filteredItems = filterSelectedItems(newListItems, filterProps.itemsType, filterProps.itemsKey, filterProps.filterItems);
    }

    setListView(cookies[listItemProps.listTypeCookieName] ? cookies[listItemProps.listTypeCookieName] : listItemProps.defaultListType ? listItemProps.defaultListType : "alphabetical");
    setNoSearchResults((searchText || filterProps) && !filteredItems.length);
    var sortedItems = listView === "tree" ? filteredItems : listView === "alphabetical" ? listItemProps.orderBy ? lodash_orderby(filteredItems, listItemProps.orderBy.iteratees ? listItemProps.orderBy.iteratees : sortAlphabetical(filteredItems), listItemProps.orderBy.orders ? listItemProps.orderBy.orders : "asc") : sortAlphabetical(filteredItems) : listView === "groupedByDate" ? sortByDate(filteredItems) : sortAlphabetical(filteredItems);
    setListItems(sortedItems); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, isFetchingItems, searchResults, filterProps, hasSearchText, listView]); // Filter function

  function filterSelectedItems(items, itemType, itemKey, filterItems) {
    var newItems = items.filter(function (item) {
      return filterItems.some(function (filterItem) {
        if (item[itemType] && typeof item[itemType] === "array" && item[itemType].length > 0) {
          return item[itemType].some(function (t) {
            return t[itemKey] === filterItem || t[itemKey] === filterItem[itemKey] || isNaN(t[itemKey]) && t[itemKey].toLowerCase().indexOf(filterItem) > -1;
          });
        } else {
          return item[itemType] && item[itemType][itemKey] ? item[itemType][itemKey] === filterItem || item[itemType][itemKey] === filterItem[itemKey] || isNaN(item[itemType][itemKey]) && item[itemType][itemKey].toLowerCase().indexOf(filterItem) > -1 : item[itemType] ? item[itemType] === filterItem || item[itemType] === filterItem[itemKey] || isNaN(item[itemType]) && item[itemType].toLowerCase().indexOf(filterItem) > -1 : false;
        }
      });
    });
    return newItems;
  } // Handle selected filter


  var handleFilterView = function handleFilterView(filterProps) {
    setFilterProps(filterProps);
    return;
  };

  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Resizable, {
    enable: {
      right: true
    },
    minWidth: selectionListMinWidth,
    maxWidth: selectionListMaxWidth,
    size: {
      width: currentWidth,
      height: "100%"
    },
    onResizeStop: function onResizeStop(e, d, r, delta) {
      return setCurrentWidth(delta.width + currentWidth);
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    vertical: true,
    styles: {
      root: {
        height: "calc(100vh - 100px)",
        borderRight: "1px solid ".concat(DefaultPalette$2.neutralLight)
      }
    }
  }, /*#__PURE__*/React__default.createElement(FilterSection, {
    listView: listView,
    setListView: setListView,
    filterProps: filterProps,
    setFilterProps: setFilterProps,
    searchText: searchText,
    setSearchText: setSearchText,
    searchHint: searchHint,
    searchFieldDisabled: searchFieldDisabled,
    listItemProps: _objectSpread2(_objectSpread2({}, listItemProps), {}, {
      filters: listItemProps.filters && listItemProps.filters.length > 0 ? listItemProps.filters.map(function (f) {
        return _objectSpread2(_objectSpread2({}, f), {}, {
          onClick: function onClick() {
            return handleFilterView(f.filterProps);
          }
        });
      }) : ""
    }),
    setCookies: setCookies
  }), !isFetchingItems && listItems && listItems.length > 0 ? /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        overflowX: "auto",
        overflowY: "auto"
      }
    }
  }, {
    alphabetical: /*#__PURE__*/React__default.createElement(FlatList, {
      itemId: itemId,
      items: listItems,
      listItemProps: listItemProps
    }),
    grouped: /*#__PURE__*/React__default.createElement(GroupedList$1, {
      itemId: itemId,
      items: listItems,
      listItemProps: listItemProps,
      hasSearchText: searchText.length > 0
    }),
    groupedByDate: /*#__PURE__*/React__default.createElement(GroupedByDateList, {
      itemId: itemId,
      items: listItems,
      listItemProps: listItemProps,
      hasSearchText: searchText.length > 0
    }),
    tree: /*#__PURE__*/React__default.createElement(TreeList$1, {
      itemId: itemId,
      items: items,
      listItemProps: listItemProps,
      hasSearchText: searchText.length > 0 || filterProps,
      searchResult: listItems
    })
  }[listView]) : /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        height: "100%"
      }
    }
  }, isFetchingItems && /*#__PURE__*/React__default.createElement(Spinner, {
    label: i18n._(
    /*i18n*/
    {
      id: "Loading items..."
    })
  }), noSearchResults && i18n._(
  /*i18n*/
  {
    id: "No item matches search."
  }), noItems && searchText === "" && i18n._(
  /*i18n*/
  {
    id: "No items to show."
  })))));
};

// Ensures that e.g. "options=not-activated&options=unmapped" becomes "options=unmapped",
// so a filter's param overrides the category's when both set the same key.

function dedupeQueryParams(qs) {
  if (!qs) return "";
  var params = new URLSearchParams(qs);
  var out = new URLSearchParams();

  var _iterator = _createForOfIteratorHelper(new Set(params.keys())),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      var values = params.getAll(key);
      out.set(key, values[values.length - 1]);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return out.toString();
} // `refreshToken` lets a caller force a re-poll from page 0 without changing the
// query (e.g. after an item is created). Changing it re-runs the effect below.


function usePolling(fn, queryParams, refreshToken) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      result = _useState2[0],
      setResult = _useState2[1];

  var polling = useRef(false);
  useEffect(function () {
    if (queryParams === undefined) return;
    setResult(null);
    polling.current = false;
    var active = true;
    var mergedParams = dedupeQueryParams(queryParams);
    var number = 0;

    var run = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(polling.current || !active)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                polling.current = true;
                _context.prev = 3;
                _context.next = 6;
                return fn(mergedParams + "&pageNo=" + number);

              case 6:
                res = _context.sent;

                if (active) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                if (res) {
                  _context.next = 12;
                  break;
                }

                polling.current = false;
                return _context.abrupt("return");

              case 12:
                number = res.pageNumber + 1;

                if (!(res.hasNext === false)) {
                  _context.next = 18;
                  break;
                }

                polling.current = false;
                active = false;
                setResult(res);
                return _context.abrupt("return");

              case 18:
                setResult(res);
                polling.current = false;
                run();
                _context.next = 28;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](3);

                if (active) {
                  _context.next = 27;
                  break;
                }

                return _context.abrupt("return");

              case 27:
                polling.current = false;

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 23]]);
      }));

      return function run() {
        return _ref.apply(this, arguments);
      };
    }();

    run();
    return function () {
      active = false;
      polling.current = false;
    };
  }, [fn, queryParams, refreshToken]);
  return result;
}

var selectionListMinWidth$1 = 320;
var selectionListMaxWidth$1 = 700;
var PagingSelectionList = function PagingSelectionList(_ref) {
  var store = _ref.store,
      match = _ref.match,
      searchHint = _ref.searchHint,
      listItemProps = _ref.listItemProps,
      getItems = _ref.getItems;
  var state = store.state,
      setItemsFromListView = store.setItemsFromListView;
  var items = state.items,
      isFetchingItems = state.isFetchingItems,
      itemsRefreshToken = state.itemsRefreshToken;
  var itemId = match.params.id;

  var _useLocalStorage = useLocalStorage("selectionListWidth", selectionListMinWidth$1),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      currentWidth = _useLocalStorage2[0],
      setCurrentWidth = _useLocalStorage2[1];

  var _useCookies = useCookies(),
      _useCookies2 = _slicedToArray(_useCookies, 2),
      cookies = _useCookies2[0],
      setCookies = _useCookies2[1];

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      listItems = _useState2[0],
      setListItems = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      listView = _useState4[0],
      setListView = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      searchText = _useState6[0],
      setSearchText = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      noSearchResults = _useState8[0],
      setNoSearchResults = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      noItems = _useState10[0],
      setNoItems = _useState10[1];

  var _useState11 = useState(true),
      _useState12 = _slicedToArray(_useState11, 2),
      searchFieldDisabled = _useState12[0],
      setSearchFieldDisabled = _useState12[1];

  var _useState13 = useState(),
      _useState14 = _slicedToArray(_useState13, 2),
      filterProps = _useState14[0],
      setFilterProps = _useState14[1];

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      category = _useState16[0],
      setCategory = _useState16[1];

  var _useState17 = useState(),
      _useState18 = _slicedToArray(_useState17, 2),
      queryParams = _useState18[0],
      setQueryParams = _useState18[1];

  var result = usePolling(getItems, queryParams, itemsRefreshToken);
  useEffect(function () {
    var paramMap = new Map();

    var addParams = function addParams(queryString) {
      if (!queryString) return;
      var params = queryString.split("&").filter(function (p) {
        return p;
      });
      params.forEach(function (param) {
        var _param$split = param.split("="),
            _param$split2 = _toArray(_param$split),
            key = _param$split2[0],
            valueParts = _param$split2.slice(1);

        var value = valueParts.join("=");

        if (key && value) {
          if (key === "options") {
            // "options" is a single-value mode on the backend (not-activated | unmapped |
            // quarantine), matched with equalsIgnoreCase - it can't be comma-joined like
            // bitmapIncludedFilter/bitmapExcludeFilter. Let the more specific source (a
            // selected filter) win over the category's base query.
            paramMap.set(key, value);
          } else if (paramMap.has(key)) {
            var existingValue = paramMap.get(key);
            paramMap.set(key, "".concat(existingValue, ",").concat(value));
          } else {
            paramMap.set(key, value);
          }
        }
      });
    };

    addParams(listItemProps.baseQueryParams);

    if (listView && listItemProps.listViewQueryParams && listItemProps.listViewQueryParams[listView]) {
      addParams(listItemProps.listViewQueryParams[listView]);
    }

    if (filterProps && filterProps.filterQuery) {
      addParams(filterProps.filterQuery);
    }

    if (searchText) {
      addParams("filter=".concat(searchText));
    }

    var params = Array.from(paramMap.entries()).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      return "".concat(key, "=").concat(value);
    }).join("&");
    setQueryParams(params);
  }, [filterProps, searchText, listItemProps.baseQueryParams, listView, listItemProps.listViewQueryParams]);
  useEffect(function () {
    if (!isFetchingItems && setItemsFromListView && category) {
      setItemsFromListView(listView, category);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isFetchingItems, listView, category]);
  useEffect(function () {
    setListItems([]);
  }, [queryParams, itemsRefreshToken]);
  useEffect(function () {
    if (!result) return;
    setListItems(function (prev) {
      return prev ? [].concat(_toConsumableArray(prev), _toConsumableArray(result.content)) : result.content;
    });

    if (result.content && result.content.length === 0 && result.pageNumber === 0) {
      if (searchText || filterProps) {
        setNoSearchResults(true);
      } else {
        setNoItems(true);
      }
    } else {
      setNoSearchResults(false);
      setNoItems(false);
    }

    setSearchFieldDisabled(false);
  }, [result, searchText, filterProps]);
  useEffect(function () {
    if (!listItemProps) return;

    if (!listView || listItemProps.category !== category) {
      setListView(cookies[listItemProps.listTypeCookieName] ? cookies[listItemProps.listTypeCookieName] : listItemProps.defaultListType ? listItemProps.defaultListType : "alphabetical");
    }

    setCategory(listItemProps.category);
    if (!listItemProps.filters || listItemProps.filters.length === 0) setFilterProps(undefined);else listItemProps.filters.forEach(function (filter) {
      if (filter.key === "defaultFilter" && filterProps === undefined) setFilterProps(filter.filterProps);
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listItemProps]);

  var handleFilterView = function handleFilterView(filterProps) {
    setFilterProps(filterProps);
    return;
  };

  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Resizable, {
    enable: {
      right: true
    },
    minWidth: selectionListMinWidth$1,
    maxWidth: selectionListMaxWidth$1,
    size: {
      width: currentWidth,
      height: "100%"
    },
    onResizeStop: function onResizeStop(e, d, r, delta) {
      return setCurrentWidth(delta.width + currentWidth);
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    vertical: true,
    styles: {
      root: {
        height: "calc(100vh - 100px)",
        borderRight: "1px solid ".concat(DefaultPalette$2.neutralLight)
      }
    }
  }, /*#__PURE__*/React__default.createElement(FilterSection, {
    listView: listView,
    setListView: setListView,
    filterProps: filterProps,
    setFilterProps: setFilterProps,
    searchText: searchText,
    setSearchText: setSearchText,
    searchHint: searchHint,
    searchFieldDisabled: searchFieldDisabled,
    searchDebounceDelay: 1000,
    listItemProps: _objectSpread2(_objectSpread2({}, listItemProps), {}, {
      filters: listItemProps.filters && listItemProps.filters.length > 0 ? listItemProps.filters.map(function (f) {
        return _objectSpread2(_objectSpread2({}, f), {}, {
          onClick: function onClick() {
            return handleFilterView(f.filterProps);
          }
        });
      }) : ""
    }),
    setCookies: setCookies
  }), listItems && listItems.length > 0 ? /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        overflowX: "auto",
        overflowY: "auto"
      }
    }
  }, {
    alphabetical: /*#__PURE__*/React__default.createElement(FlatList, {
      itemId: itemId,
      items: listItems,
      listItemProps: listItemProps
    }),
    grouped: /*#__PURE__*/React__default.createElement(GroupedList$1, {
      itemId: itemId,
      items: listItems,
      listItemProps: listItemProps,
      hasSearchText: searchText.length > 0
    }),
    groupedByDate: /*#__PURE__*/React__default.createElement(GroupedByDateList, {
      itemId: itemId,
      items: listItems,
      listItemProps: listItemProps,
      hasSearchText: searchText.length > 0
    }),
    tree: /*#__PURE__*/React__default.createElement(TreeList$1, {
      itemId: itemId,
      items: items,
      listItemProps: listItemProps,
      hasSearchText: searchText.length > 0 || filterProps,
      searchResult: listItems
    })
  }[listView]) : /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        height: "100%"
      }
    }
  }, !result ? /*#__PURE__*/React__default.createElement(Spinner, {
    label: i18n._(
    /*i18n*/
    {
      id: "Loading items..."
    })
  }) : noSearchResults ? i18n._(
  /*i18n*/
  {
    id: "No item matches search."
  }) : noItems ? i18n._(
  /*i18n*/
  {
    id: "No items to show."
  }) : null))));
};

/**
 * {@docCategory FocusZone}
 */
var FocusZoneTabbableElements = {
  /** Tabbing is not allowed */
  none: 0,

  /** All tabbing action is allowed */
  all: 1,

  /** Tabbing is allowed only on input elements */
  inputOnly: 2
};
/**
 * {@docCategory FocusZone}
 */

var FocusZoneDirection;

(function (FocusZoneDirection) {
  /** Only react to up/down arrows. */
  FocusZoneDirection[FocusZoneDirection["vertical"] = 0] = "vertical";
  /** Only react to left/right arrows. */

  FocusZoneDirection[FocusZoneDirection["horizontal"] = 1] = "horizontal";
  /** React to all arrows. */

  FocusZoneDirection[FocusZoneDirection["bidirectional"] = 2] = "bidirectional";
  /**
   * React to all arrows. Navigate next item in DOM on right/down arrow keys and previous - left/up arrow keys.
   * Right and Left arrow keys are swapped in RTL mode.
   */

  FocusZoneDirection[FocusZoneDirection["domOrder"] = 3] = "domOrder";
})(FocusZoneDirection || (FocusZoneDirection = {}));

var IS_FOCUSABLE_ATTRIBUTE$1 = 'data-is-focusable';
var IS_ENTER_DISABLED_ATTRIBUTE = 'data-disable-click-on-enter';
var FOCUSZONE_ID_ATTRIBUTE$1 = 'data-focuszone-id';
var TABINDEX = 'tabindex';
var NO_VERTICAL_WRAP = 'data-no-vertical-wrap';
var NO_HORIZONTAL_WRAP = 'data-no-horizontal-wrap';
var LARGE_DISTANCE_FROM_CENTER = 999999999;
var LARGE_NEGATIVE_DISTANCE_FROM_CENTER = -999999999;
var focusZoneStyles;
var focusZoneClass = 'ms-FocusZone'; // Helper function that will return a class for when the root is focused

function getRootClass() {
  if (!focusZoneStyles) {
    focusZoneStyles = mergeStyles({
      selectors: {
        ':focus': {
          outline: 'none'
        }
      }
    }, focusZoneClass);
  }

  return focusZoneStyles;
}

var _allInstances = {};

var _outerZones = new Set();

var ALLOWED_INPUT_TYPES = ['text', 'number', 'password', 'email', 'tel', 'url', 'search'];
var ALLOW_VIRTUAL_ELEMENTS = false;

var FocusZone =
/** @class */
function (_super) {
  __extends(FocusZone, _super);

  function FocusZone(props) {
    var _this = _super.call(this, props) || this;

    _this._root = createRef();
    _this._mergedRef = createMergedRef();

    _this._onFocus = function (ev) {
      if (_this._portalContainsElement(ev.target)) {
        // If the event target is inside a portal do not process the event.
        return;
      }

      var _a = _this.props,
          onActiveElementChanged = _a.onActiveElementChanged,
          // eslint-disable-next-line deprecation/deprecation
      doNotAllowFocusEventToPropagate = _a.doNotAllowFocusEventToPropagate,
          stopFocusPropagation = _a.stopFocusPropagation,
          // eslint-disable-next-line deprecation/deprecation
      onFocusNotification = _a.onFocusNotification,
          onFocus = _a.onFocus,
          shouldFocusInnerElementWhenReceivedFocus = _a.shouldFocusInnerElementWhenReceivedFocus,
          defaultTabbableElement = _a.defaultTabbableElement;

      var isImmediateDescendant = _this._isImmediateDescendantOfZone(ev.target);

      var newActiveElement;

      if (isImmediateDescendant) {
        newActiveElement = ev.target;
      } else {
        var parentElement = ev.target;

        while (parentElement && parentElement !== _this._root.current) {
          if (isElementTabbable(parentElement) && _this._isImmediateDescendantOfZone(parentElement)) {
            newActiveElement = parentElement;
            break;
          }

          parentElement = getParent(parentElement, ALLOW_VIRTUAL_ELEMENTS);
        }
      } // If an inner focusable element should be focused when FocusZone container receives focus


      if (shouldFocusInnerElementWhenReceivedFocus && ev.target === _this._root.current) {
        var maybeElementToFocus = defaultTabbableElement && typeof defaultTabbableElement === 'function' && defaultTabbableElement(_this._root.current); // try to focus defaultTabbable element

        if (maybeElementToFocus && isElementTabbable(maybeElementToFocus)) {
          newActiveElement = maybeElementToFocus;
          maybeElementToFocus.focus();
        } else {
          // force focus on first focusable element
          _this.focus(true);

          if (_this._activeElement) {
            // set to null as new active element was handled in method above
            newActiveElement = null;
          }
        }
      }

      var initialElementFocused = !_this._activeElement; // If the new active element is a child of this zone and received focus,
      // update alignment an immediate descendant

      if (newActiveElement && newActiveElement !== _this._activeElement) {
        if (isImmediateDescendant || initialElementFocused) {
          _this._setFocusAlignment(newActiveElement, true, true);
        }

        _this._activeElement = newActiveElement;

        if (initialElementFocused) {
          _this._updateTabIndexes();
        }
      }

      if (onActiveElementChanged) {
        onActiveElementChanged(_this._activeElement, ev);
      }

      if (stopFocusPropagation || doNotAllowFocusEventToPropagate) {
        ev.stopPropagation();
      }

      if (onFocus) {
        onFocus(ev);
      } else if (onFocusNotification) {
        onFocusNotification();
      }
    };

    _this._onBlur = function () {
      _this._setParkedFocus(false);
    };

    _this._onMouseDown = function (ev) {
      if (_this._portalContainsElement(ev.target)) {
        // If the event target is inside a portal do not process the event.
        return;
      }

      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      var target = ev.target;
      var path = [];

      while (target && target !== _this._root.current) {
        path.push(target);
        target = getParent(target, ALLOW_VIRTUAL_ELEMENTS);
      }

      while (path.length) {
        target = path.pop();

        if (target && isElementTabbable(target)) {
          _this._setActiveElement(target, true);
        }

        if (isElementFocusZone(target)) {
          // Stop here since the focus zone will take care of its own children.
          break;
        }
      }
    };
    /**
     * Handle the keystrokes.
     */


    _this._onKeyDown = function (ev, theme) {
      if (_this._portalContainsElement(ev.target)) {
        // If the event target is inside a portal do not process the event.
        return;
      } // eslint-disable-next-line deprecation/deprecation


      var _a = _this.props,
          direction = _a.direction,
          disabled = _a.disabled,
          isInnerZoneKeystroke = _a.isInnerZoneKeystroke,
          pagingSupportDisabled = _a.pagingSupportDisabled,
          shouldEnterInnerZone = _a.shouldEnterInnerZone;

      if (disabled) {
        return;
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(ev);
      } // If the default has been prevented, do not process keyboard events.


      if (ev.isDefaultPrevented()) {
        return;
      }

      if (_this._getDocument().activeElement === _this._root.current && _this._isInnerZone) {
        // If this element has focus, it is being controlled by a parent.
        // Ignore the keystroke.
        return;
      }

      if ((shouldEnterInnerZone && shouldEnterInnerZone(ev) || isInnerZoneKeystroke && isInnerZoneKeystroke(ev)) && _this._isImmediateDescendantOfZone(ev.target)) {
        // Try to focus
        var innerZone = _this._getFirstInnerZone();

        if (innerZone) {
          if (!innerZone.focus(true)) {
            return;
          }
        } else if (isElementFocusSubZone(ev.target)) {
          if (!_this.focusElement(getNextElement(ev.target, ev.target.firstChild, true))) {
            return;
          }
        } else {
          return;
        }
      } else if (ev.altKey) {
        return;
      } else {
        // eslint-disable-next-line @fluentui/deprecated-keyboard-event-props
        switch (ev.which) {
          case KeyCodes.space:
            if (_this._tryInvokeClickForFocusable(ev.target)) {
              break;
            }

            return;

          case KeyCodes.left:
            if (direction !== FocusZoneDirection.vertical) {
              _this._preventDefaultWhenHandled(ev);

              if (_this._moveFocusLeft(theme)) {
                break;
              }
            }

            return;

          case KeyCodes.right:
            if (direction !== FocusZoneDirection.vertical) {
              _this._preventDefaultWhenHandled(ev);

              if (_this._moveFocusRight(theme)) {
                break;
              }
            }

            return;

          case KeyCodes.up:
            if (direction !== FocusZoneDirection.horizontal) {
              _this._preventDefaultWhenHandled(ev);

              if (_this._moveFocusUp()) {
                break;
              }
            }

            return;

          case KeyCodes.down:
            if (direction !== FocusZoneDirection.horizontal) {
              _this._preventDefaultWhenHandled(ev);

              if (_this._moveFocusDown()) {
                break;
              }
            }

            return;

          case KeyCodes.pageDown:
            if (!pagingSupportDisabled && _this._moveFocusPaging(true)) {
              break;
            }

            return;

          case KeyCodes.pageUp:
            if (!pagingSupportDisabled && _this._moveFocusPaging(false)) {
              break;
            }

            return;

          case KeyCodes.tab:
            if ( // eslint-disable-next-line deprecation/deprecation
            _this.props.allowTabKey || _this.props.handleTabKey === FocusZoneTabbableElements.all || _this.props.handleTabKey === FocusZoneTabbableElements.inputOnly && _this._isElementInput(ev.target)) {
              var focusChanged = false;
              _this._processingTabKey = true;

              if (direction === FocusZoneDirection.vertical || !_this._shouldWrapFocus(_this._activeElement, NO_HORIZONTAL_WRAP)) {
                focusChanged = ev.shiftKey ? _this._moveFocusUp() : _this._moveFocusDown();
              } else {
                var tabWithDirection = getRTL$1(theme) ? !ev.shiftKey : ev.shiftKey;
                focusChanged = tabWithDirection ? _this._moveFocusLeft(theme) : _this._moveFocusRight(theme);
              }

              _this._processingTabKey = false;

              if (focusChanged) {
                break;
              } else if (_this.props.shouldResetActiveElementWhenTabFromZone) {
                _this._activeElement = null;
              }
            }

            return;

          case KeyCodes.home:
            if (_this._isContentEditableElement(ev.target) || _this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, false)) {
              return false;
            }

            var firstChild = _this._root.current && _this._root.current.firstChild;

            if (_this._root.current && firstChild && _this.focusElement(getNextElement(_this._root.current, firstChild, true))) {
              break;
            }

            return;

          case KeyCodes.end:
            if (_this._isContentEditableElement(ev.target) || _this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, true)) {
              return false;
            }

            var lastChild = _this._root.current && _this._root.current.lastChild;

            if (_this._root.current && _this.focusElement(getPreviousElement(_this._root.current, lastChild, true, true, true))) {
              break;
            }

            return;

          case KeyCodes.enter:
            if (_this._tryInvokeClickForFocusable(ev.target)) {
              break;
            }

            return;

          default:
            return;
        }
      }

      ev.preventDefault();
      ev.stopPropagation();
    };

    _this._getHorizontalDistanceFromCenter = function (isForward, activeRect, targetRect) {
      // eslint-disable-next-line deprecation/deprecation
      var leftAlignment = _this._focusAlignment.left || _this._focusAlignment.x || 0; // ClientRect values can be floats that differ by very small fractions of a decimal.
      // If the difference between top and bottom are within a pixel then we should treat
      // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
      // but without Math.Floor they will be handled incorrectly.

      var targetRectTop = Math.floor(targetRect.top);
      var activeRectBottom = Math.floor(activeRect.bottom);
      var targetRectBottom = Math.floor(targetRect.bottom);
      var activeRectTop = Math.floor(activeRect.top);
      var isValidCandidateOnpagingDown = isForward && targetRectTop > activeRectBottom;
      var isValidCandidateOnpagingUp = !isForward && targetRectBottom < activeRectTop;

      if (isValidCandidateOnpagingDown || isValidCandidateOnpagingUp) {
        if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
          return 0;
        }

        return Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
      }

      if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
        return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
      }

      return LARGE_DISTANCE_FROM_CENTER;
    }; // Manage componentRef resolution.


    initializeComponentRef(_this);

    if (process.env.NODE_ENV !== 'production') {
      warnDeprecations('FocusZone', props, {
        rootProps: undefined,
        allowTabKey: 'handleTabKey',
        elementType: 'as',
        ariaDescribedBy: 'aria-describedby',
        ariaLabelledBy: 'aria-labelledby'
      });
    }

    _this._id = getId('FocusZone');
    _this._focusAlignment = {
      left: 0,
      top: 0
    };
    _this._processingTabKey = false;
    return _this;
  }
  /** Used for testing purposes only. */


  FocusZone.getOuterZones = function () {
    return _outerZones.size;
  };
  /**
   * Handle global tab presses so that we can patch tabindexes on the fly.
   * HEADS UP: This must not be an arrow function in order to be referentially equal among instances
   * for ref counting to work correctly!
   */


  FocusZone._onKeyDownCapture = function (ev) {
    // eslint-disable-next-line deprecation/deprecation, @fluentui/deprecated-keyboard-event-props
    if (ev.which === KeyCodes.tab) {
      _outerZones.forEach(function (zone) {
        return zone._updateTabIndexes();
      });
    }
  };

  FocusZone.prototype.componentDidMount = function () {
    var root = this._root.current;
    _allInstances[this._id] = this;

    if (root) {
      this._windowElement = getWindow(root);
      var parentElement = getParent(root, ALLOW_VIRTUAL_ELEMENTS);

      while (parentElement && parentElement !== this._getDocument().body && parentElement.nodeType === 1) {
        if (isElementFocusZone(parentElement)) {
          this._isInnerZone = true;
          break;
        }

        parentElement = getParent(parentElement, ALLOW_VIRTUAL_ELEMENTS);
      }

      if (!this._isInnerZone) {
        _outerZones.add(this);

        if (this._windowElement && _outerZones.size === 1) {
          this._windowElement.addEventListener('keydown', FocusZone._onKeyDownCapture, true);
        }
      }

      this._root.current && this._root.current.addEventListener('blur', this._onBlur, true); // Assign initial tab indexes so that we can set initial focus as appropriate.

      this._updateTabIndexes();

      if (this.props.defaultTabbableElement && typeof this.props.defaultTabbableElement === 'string') {
        this._activeElement = this._getDocument().querySelector(this.props.defaultTabbableElement); // eslint-disable-next-line deprecation/deprecation
      } else if (this.props.defaultActiveElement) {
        // eslint-disable-next-line deprecation/deprecation
        this._activeElement = this._getDocument().querySelector(this.props.defaultActiveElement);
      }

      if (this.props.shouldFocusOnMount) {
        this.focus();
      }
    }
  };

  FocusZone.prototype.componentDidUpdate = function () {
    var root = this._root.current;

    var doc = this._getDocument();

    if (doc && this._lastIndexPath && (doc.activeElement === doc.body || doc.activeElement === null || !this.props.preventFocusRestoration && doc.activeElement === root)) {
      // The element has been removed after the render, attempt to restore focus.
      var elementToFocus = getFocusableByIndexPath(root, this._lastIndexPath);

      if (elementToFocus) {
        this._setActiveElement(elementToFocus, true);

        elementToFocus.focus();

        this._setParkedFocus(false);
      } else {
        // We had a focus path to restore, but now that path is unresolvable. Park focus
        // on the container until we can try again.
        this._setParkedFocus(true);
      }
    }
  };

  FocusZone.prototype.componentWillUnmount = function () {
    delete _allInstances[this._id];

    if (!this._isInnerZone) {
      _outerZones.delete(this); // If this is the last outer zone, remove the keydown listener.


      if (this._windowElement && _outerZones.size === 0) {
        this._windowElement.removeEventListener('keydown', FocusZone._onKeyDownCapture, true);
      }
    }

    if (this._root.current) {
      this._root.current.removeEventListener('blur', this._onBlur, true);
    }

    this._activeElement = null;
    this._defaultFocusElement = null;
  };

  FocusZone.prototype.render = function () {
    var _this = this; // eslint-disable-next-line deprecation/deprecation


    var _a = this.props,
        tag = _a.as,
        elementType = _a.elementType,
        rootProps = _a.rootProps,
        ariaDescribedBy = _a.ariaDescribedBy,
        ariaLabelledBy = _a.ariaLabelledBy,
        className = _a.className;
    var divProps = getNativeProps(this.props, htmlElementProperties);
    var Tag = tag || elementType || 'div'; // Note, right before rendering/reconciling proceeds, we need to record if focus
    // was in the zone before the update. This helper will track this and, if focus
    // was actually in the zone, what the index path to the element is at this time.
    // Then, later in componentDidUpdate, we can evaluate if we need to restore it in
    // the case the element was removed.

    this._evaluateFocusBeforeRender(); // Only support RTL defined in global theme, not contextual theme/RTL.


    var theme = getTheme();
    return createElement(Tag, __assign({
      "aria-labelledby": ariaLabelledBy,
      "aria-describedby": ariaDescribedBy
    }, divProps, rootProps, {
      // Once the getClassName correctly memoizes inputs this should
      // be replaced so that className is passed to getRootClass and is included there so
      // the class names will always be in the same order.
      className: css(getRootClass(), className),
      // eslint-disable-next-line deprecation/deprecation
      ref: this._mergedRef(this.props.elementRef, this._root),
      "data-focuszone-id": this._id,
      // eslint-disable-next-line react/jsx-no-bind
      onKeyDown: function (ev) {
        return _this._onKeyDown(ev, theme);
      },
      onFocus: this._onFocus,
      onMouseDownCapture: this._onMouseDown
    }), this.props.children);
  };
  /**
   * Sets focus to the first tabbable item in the zone.
   * @param forceIntoFirstElement - If true, focus will be forced into the first element, even
   * if focus is already in the focus zone.
   * @returns True if focus could be set to an active element, false if no operation was taken.
   */


  FocusZone.prototype.focus = function (forceIntoFirstElement) {
    if (forceIntoFirstElement === void 0) {
      forceIntoFirstElement = false;
    }

    if (this._root.current) {
      if (!forceIntoFirstElement && this._root.current.getAttribute(IS_FOCUSABLE_ATTRIBUTE$1) === 'true' && this._isInnerZone) {
        var ownerZoneElement = this._getOwnerZone(this._root.current);

        if (ownerZoneElement !== this._root.current) {
          var ownerZone = _allInstances[ownerZoneElement.getAttribute(FOCUSZONE_ID_ATTRIBUTE$1)];

          return !!ownerZone && ownerZone.focusElement(this._root.current);
        }

        return false;
      } else if (!forceIntoFirstElement && this._activeElement && elementContains(this._root.current, this._activeElement) && isElementTabbable(this._activeElement)) {
        this._activeElement.focus();

        return true;
      } else {
        var firstChild = this._root.current.firstChild;
        return this.focusElement(getNextElement(this._root.current, firstChild, true));
      }
    }

    return false;
  };
  /**
   * Sets focus to the last tabbable item in the zone.
   * @returns True if focus could be set to an active element, false if no operation was taken.
   */


  FocusZone.prototype.focusLast = function () {
    if (this._root.current) {
      var lastChild = this._root.current && this._root.current.lastChild;
      return this.focusElement(getPreviousElement(this._root.current, lastChild, true, true, true));
    }

    return false;
  };
  /**
   * Sets focus to a specific child element within the zone. This can be used in conjunction with
   * shouldReceiveFocus to create delayed focus scenarios (like animate the scroll position to the correct
   * location and then focus.)
   * @param element - The child element within the zone to focus.
   * @param forceAlignment - If true, focus alignment will be set according to the element provided.
   * @returns True if focus could be set to an active element, false if no operation was taken.
   */


  FocusZone.prototype.focusElement = function (element, forceAlignment) {
    // eslint-disable-next-line deprecation/deprecation
    var _a = this.props,
        onBeforeFocus = _a.onBeforeFocus,
        shouldReceiveFocus = _a.shouldReceiveFocus;

    if (shouldReceiveFocus && !shouldReceiveFocus(element) || onBeforeFocus && !onBeforeFocus(element)) {
      return false;
    }

    if (element) {
      // when we set focus to a specific child, we should recalculate the alignment depending on its position.
      this._setActiveElement(element, forceAlignment);

      if (this._activeElement) {
        this._activeElement.focus();
      }

      return true;
    }

    return false;
  };
  /**
   * Forces horizontal alignment in the context of vertical arrowing to use specific point as the reference,
   * rather than a center based on the last horizontal motion.
   * @param point - the new reference point.
   */


  FocusZone.prototype.setFocusAlignment = function (point) {
    this._focusAlignment = point;
  };

  FocusZone.prototype._evaluateFocusBeforeRender = function () {
    var root = this._root.current;

    var doc = this._getDocument();

    if (doc) {
      var focusedElement = doc.activeElement; // Only update the index path if we are not parked on the root.

      if (focusedElement !== root) {
        var shouldRestoreFocus = elementContains(root, focusedElement, false);
        this._lastIndexPath = shouldRestoreFocus ? getElementIndexPath(root, focusedElement) : undefined;
      }
    }
  };
  /**
   * When focus is in the zone at render time but then all focusable elements are removed,
   * we "park" focus temporarily on the root. Once we update with focusable children, we restore
   * focus to the closest path from previous. If the user tabs away from the parked container,
   * we restore focusability to the pre-parked state.
   */


  FocusZone.prototype._setParkedFocus = function (isParked) {
    var root = this._root.current;

    if (root && this._isParked !== isParked) {
      this._isParked = isParked;

      if (isParked) {
        if (!this.props.allowFocusRoot) {
          this._parkedTabIndex = root.getAttribute('tabindex');
          root.setAttribute('tabindex', '-1');
        }

        root.focus();
      } else if (!this.props.allowFocusRoot) {
        if (this._parkedTabIndex) {
          root.setAttribute('tabindex', this._parkedTabIndex);
          this._parkedTabIndex = undefined;
        } else {
          root.removeAttribute('tabindex');
        }
      }
    }
  };

  FocusZone.prototype._setActiveElement = function (element, forceAlignment) {
    var previousActiveElement = this._activeElement;
    this._activeElement = element;

    if (previousActiveElement) {
      if (isElementFocusZone(previousActiveElement)) {
        this._updateTabIndexes(previousActiveElement);
      }

      previousActiveElement.tabIndex = -1;
    }

    if (this._activeElement) {
      if (!this._focusAlignment || forceAlignment) {
        this._setFocusAlignment(element, true, true);
      }

      this._activeElement.tabIndex = 0;
    }
  };

  FocusZone.prototype._preventDefaultWhenHandled = function (ev) {
    this.props.preventDefaultWhenHandled && ev.preventDefault();
  };
  /**
   * Walk up the dom try to find a focusable element.
   */


  FocusZone.prototype._tryInvokeClickForFocusable = function (target) {
    if (target === this._root.current || !this.props.shouldRaiseClicks) {
      return false;
    }

    do {
      if (target.tagName === 'BUTTON' || target.tagName === 'A' || target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
        return false;
      }

      if (this._isImmediateDescendantOfZone(target) && target.getAttribute(IS_FOCUSABLE_ATTRIBUTE$1) === 'true' && target.getAttribute(IS_ENTER_DISABLED_ATTRIBUTE) !== 'true') {
        raiseClick(target);
        return true;
      }

      target = getParent(target, ALLOW_VIRTUAL_ELEMENTS);
    } while (target !== this._root.current);

    return false;
  };
  /**
   * Traverse to find first child zone.
   */


  FocusZone.prototype._getFirstInnerZone = function (rootElement) {
    rootElement = rootElement || this._activeElement || this._root.current;

    if (!rootElement) {
      return null;
    }

    if (isElementFocusZone(rootElement)) {
      return _allInstances[rootElement.getAttribute(FOCUSZONE_ID_ATTRIBUTE$1)];
    }

    var child = rootElement.firstElementChild;

    while (child) {
      if (isElementFocusZone(child)) {
        return _allInstances[child.getAttribute(FOCUSZONE_ID_ATTRIBUTE$1)];
      }

      var match = this._getFirstInnerZone(child);

      if (match) {
        return match;
      }

      child = child.nextElementSibling;
    }

    return null;
  };

  FocusZone.prototype._moveFocus = function (isForward, getDistanceFromCenter, ev, useDefaultWrap) {
    if (useDefaultWrap === void 0) {
      useDefaultWrap = true;
    }

    var element = this._activeElement;
    var candidateDistance = -1;
    var candidateElement = undefined;
    var changedFocus = false;
    var isBidirectional = this.props.direction === FocusZoneDirection.bidirectional;

    if (!element || !this._root.current) {
      return false;
    }

    if (this._isElementInput(element)) {
      if (!this._shouldInputLoseFocus(element, isForward)) {
        return false;
      }
    }

    var activeRect = isBidirectional ? element.getBoundingClientRect() : null;

    do {
      element = isForward ? getNextElement(this._root.current, element) : getPreviousElement(this._root.current, element);

      if (isBidirectional) {
        if (element) {
          var targetRect = element.getBoundingClientRect();
          var elementDistance = getDistanceFromCenter(activeRect, targetRect);

          if (elementDistance === -1 && candidateDistance === -1) {
            candidateElement = element;
            break;
          }

          if (elementDistance > -1 && (candidateDistance === -1 || elementDistance < candidateDistance)) {
            candidateDistance = elementDistance;
            candidateElement = element;
          }

          if (candidateDistance >= 0 && elementDistance < 0) {
            break;
          }
        }
      } else {
        candidateElement = element;
        break;
      }
    } while (element); // Focus the closest candidate


    if (candidateElement && candidateElement !== this._activeElement) {
      changedFocus = true;
      this.focusElement(candidateElement);
    } else if (this.props.isCircularNavigation && useDefaultWrap) {
      if (isForward) {
        return this.focusElement(getNextElement(this._root.current, this._root.current.firstElementChild, true));
      } else {
        return this.focusElement(getPreviousElement(this._root.current, this._root.current.lastElementChild, true, true, true));
      }
    }

    return changedFocus;
  };

  FocusZone.prototype._moveFocusDown = function () {
    var _this = this;

    var targetTop = -1; // eslint-disable-next-line deprecation/deprecation

    var leftAlignment = this._focusAlignment.left || this._focusAlignment.x || 0;

    if (this._moveFocus(true, function (activeRect, targetRect) {
      var distance = -1; // ClientRect values can be floats that differ by very small fractions of a decimal.
      // If the difference between top and bottom are within a pixel then we should treat
      // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
      // but without Math.Floor they will be handled incorrectly.

      var targetRectTop = Math.floor(targetRect.top);
      var activeRectBottom = Math.floor(activeRect.bottom);

      if (targetRectTop < activeRectBottom) {
        if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
          return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
        }

        return LARGE_DISTANCE_FROM_CENTER;
      }

      if (targetTop === -1 && targetRectTop >= activeRectBottom || targetRectTop === targetTop) {
        targetTop = targetRectTop;

        if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
          distance = 0;
        } else {
          distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
        }
      }

      return distance;
    })) {
      this._setFocusAlignment(this._activeElement, false, true);

      return true;
    }

    return false;
  };

  FocusZone.prototype._moveFocusUp = function () {
    var _this = this;

    var targetTop = -1; // eslint-disable-next-line deprecation/deprecation

    var leftAlignment = this._focusAlignment.left || this._focusAlignment.x || 0;

    if (this._moveFocus(false, function (activeRect, targetRect) {
      var distance = -1; // ClientRect values can be floats that differ by very small fractions of a decimal.
      // If the difference between top and bottom are within a pixel then we should treat
      // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
      // but without Math.Floor they will be handled incorrectly.

      var targetRectBottom = Math.floor(targetRect.bottom);
      var targetRectTop = Math.floor(targetRect.top);
      var activeRectTop = Math.floor(activeRect.top);

      if (targetRectBottom > activeRectTop) {
        if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
          return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
        }

        return LARGE_DISTANCE_FROM_CENTER;
      }

      if (targetTop === -1 && targetRectBottom <= activeRectTop || targetRectTop === targetTop) {
        targetTop = targetRectTop;

        if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
          distance = 0;
        } else {
          distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
        }
      }

      return distance;
    })) {
      this._setFocusAlignment(this._activeElement, false, true);

      return true;
    }

    return false;
  };

  FocusZone.prototype._moveFocusLeft = function (theme) {
    var _this = this;

    var shouldWrap = this._shouldWrapFocus(this._activeElement, NO_HORIZONTAL_WRAP);

    if (this._moveFocus(getRTL$1(theme), function (activeRect, targetRect) {
      var distance = -1;
      var topBottomComparison;

      if (getRTL$1(theme)) {
        // When in RTL, this comparison should be the same as the one in _moveFocusRight for LTR.
        // Going left at a leftmost rectangle will go down a line instead of up a line like in LTR.
        // This is important, because we want to be comparing the top of the target rect
        // with the bottom of the active rect.
        topBottomComparison = parseFloat(targetRect.top.toFixed(3)) < parseFloat(activeRect.bottom.toFixed(3));
      } else {
        topBottomComparison = parseFloat(targetRect.bottom.toFixed(3)) > parseFloat(activeRect.top.toFixed(3));
      }

      if (topBottomComparison && targetRect.right <= activeRect.right && _this.props.direction !== FocusZoneDirection.vertical) {
        distance = activeRect.right - targetRect.right;
      } else if (!shouldWrap) {
        distance = LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
      }

      return distance;
    }, undefined
    /*ev*/
    , shouldWrap)) {
      this._setFocusAlignment(this._activeElement, true, false);

      return true;
    }

    return false;
  };

  FocusZone.prototype._moveFocusRight = function (theme) {
    var _this = this;

    var shouldWrap = this._shouldWrapFocus(this._activeElement, NO_HORIZONTAL_WRAP);

    if (this._moveFocus(!getRTL$1(theme), function (activeRect, targetRect) {
      var distance = -1;
      var topBottomComparison;

      if (getRTL$1(theme)) {
        // When in RTL, this comparison should be the same as the one in _moveFocusLeft for LTR.
        // Going right at a rightmost rectangle will go up a line instead of down a line like in LTR.
        // This is important, because we want to be comparing the bottom of the target rect
        // with the top of the active rect.
        topBottomComparison = parseFloat(targetRect.bottom.toFixed(3)) > parseFloat(activeRect.top.toFixed(3));
      } else {
        topBottomComparison = parseFloat(targetRect.top.toFixed(3)) < parseFloat(activeRect.bottom.toFixed(3));
      }

      if (topBottomComparison && targetRect.left >= activeRect.left && _this.props.direction !== FocusZoneDirection.vertical) {
        distance = targetRect.left - activeRect.left;
      } else if (!shouldWrap) {
        distance = LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
      }

      return distance;
    }, undefined
    /*ev*/
    , shouldWrap)) {
      this._setFocusAlignment(this._activeElement, true, false);

      return true;
    }

    return false;
  };

  FocusZone.prototype._moveFocusPaging = function (isForward, useDefaultWrap) {
    if (useDefaultWrap === void 0) {
      useDefaultWrap = true;
    }

    var element = this._activeElement;

    if (!element || !this._root.current) {
      return false;
    }

    if (this._isElementInput(element)) {
      if (!this._shouldInputLoseFocus(element, isForward)) {
        return false;
      }
    }

    var scrollableParent = findScrollableParent(element);

    if (!scrollableParent) {
      return false;
    }

    var candidateDistance = -1;
    var candidateElement = undefined;
    var targetTop = -1;
    var targetBottom = -1;
    var pagesize = scrollableParent.clientHeight;
    var activeRect = element.getBoundingClientRect();

    do {
      element = isForward ? getNextElement(this._root.current, element) : getPreviousElement(this._root.current, element);

      if (element) {
        var targetRect = element.getBoundingClientRect();
        var targetRectTop = Math.floor(targetRect.top);
        var activeRectBottom = Math.floor(activeRect.bottom);
        var targetRectBottom = Math.floor(targetRect.bottom);
        var activeRectTop = Math.floor(activeRect.top);

        var elementDistance = this._getHorizontalDistanceFromCenter(isForward, activeRect, targetRect);

        var isElementPassedPageSizeOnPagingDown = isForward && targetRectTop > activeRectBottom + pagesize;
        var isElementPassedPageSizeOnPagingUp = !isForward && targetRectBottom < activeRectTop - pagesize;

        if (isElementPassedPageSizeOnPagingDown || isElementPassedPageSizeOnPagingUp) {
          break;
        }

        if (elementDistance > -1) {
          // for paging down
          if (isForward && targetRectTop > targetTop) {
            targetTop = targetRectTop;
            candidateDistance = elementDistance;
            candidateElement = element;
          } else if (!isForward && targetRectBottom < targetBottom) {
            // for paging up
            targetBottom = targetRectBottom;
            candidateDistance = elementDistance;
            candidateElement = element;
          } else if (candidateDistance === -1 || elementDistance <= candidateDistance) {
            candidateDistance = elementDistance;
            candidateElement = element;
          }
        }
      }
    } while (element);

    var changedFocus = false; // Focus the closest candidate

    if (candidateElement && candidateElement !== this._activeElement) {
      changedFocus = true;
      this.focusElement(candidateElement);

      this._setFocusAlignment(candidateElement, false, true);
    } else if (this.props.isCircularNavigation && useDefaultWrap) {
      if (isForward) {
        return this.focusElement(getNextElement(this._root.current, this._root.current.firstElementChild, true));
      }

      return this.focusElement(getPreviousElement(this._root.current, this._root.current.lastElementChild, true, true, true));
    }

    return changedFocus;
  };

  FocusZone.prototype._setFocusAlignment = function (element, isHorizontal, isVertical) {
    if (this.props.direction === FocusZoneDirection.bidirectional && (!this._focusAlignment || isHorizontal || isVertical)) {
      var rect = element.getBoundingClientRect();
      var left = rect.left + rect.width / 2;
      var top_1 = rect.top + rect.height / 2;

      if (!this._focusAlignment) {
        this._focusAlignment = {
          left: left,
          top: top_1
        };
      }

      if (isHorizontal) {
        this._focusAlignment.left = left;
      }

      if (isVertical) {
        this._focusAlignment.top = top_1;
      }
    }
  };

  FocusZone.prototype._isImmediateDescendantOfZone = function (element) {
    return this._getOwnerZone(element) === this._root.current;
  };

  FocusZone.prototype._getOwnerZone = function (element) {
    var parentElement = getParent(element, ALLOW_VIRTUAL_ELEMENTS);

    while (parentElement && parentElement !== this._root.current && parentElement !== this._getDocument().body) {
      if (isElementFocusZone(parentElement)) {
        return parentElement;
      }

      parentElement = getParent(parentElement, ALLOW_VIRTUAL_ELEMENTS);
    }

    return parentElement;
  };

  FocusZone.prototype._updateTabIndexes = function (element) {
    if (!this._activeElement && this.props.defaultTabbableElement && typeof this.props.defaultTabbableElement === 'function') {
      this._activeElement = this.props.defaultTabbableElement(this._root.current);
    }

    if (!element && this._root.current) {
      this._defaultFocusElement = null;
      element = this._root.current;

      if (this._activeElement && !elementContains(element, this._activeElement)) {
        this._activeElement = null;
      }
    } // If active element changes state to disabled, set it to null.
    // Otherwise, we lose keyboard accessibility to other elements in focus zone.


    if (this._activeElement && !isElementTabbable(this._activeElement)) {
      this._activeElement = null;
    }

    var childNodes = element && element.children;

    for (var childIndex = 0; childNodes && childIndex < childNodes.length; childIndex++) {
      var child = childNodes[childIndex];

      if (!isElementFocusZone(child)) {
        // If the item is explicitly set to not be focusable then TABINDEX needs to be set to -1.
        if (child.getAttribute && child.getAttribute(IS_FOCUSABLE_ATTRIBUTE$1) === 'false') {
          child.setAttribute(TABINDEX, '-1');
        }

        if (isElementTabbable(child)) {
          if (this.props.disabled) {
            child.setAttribute(TABINDEX, '-1');
          } else if (!this._isInnerZone && (!this._activeElement && !this._defaultFocusElement || this._activeElement === child)) {
            this._defaultFocusElement = child;

            if (child.getAttribute(TABINDEX) !== '0') {
              child.setAttribute(TABINDEX, '0');
            }
          } else if (child.getAttribute(TABINDEX) !== '-1') {
            child.setAttribute(TABINDEX, '-1');
          }
        } else if (child.tagName === 'svg' && child.getAttribute('focusable') !== 'false') {
          // Disgusting IE hack. Sad face.
          child.setAttribute('focusable', 'false');
        }
      } else if (child.getAttribute(IS_FOCUSABLE_ATTRIBUTE$1) === 'true') {
        if (!this._isInnerZone && (!this._activeElement && !this._defaultFocusElement || this._activeElement === child)) {
          this._defaultFocusElement = child;

          if (child.getAttribute(TABINDEX) !== '0') {
            child.setAttribute(TABINDEX, '0');
          }
        } else if (child.getAttribute(TABINDEX) !== '-1') {
          child.setAttribute(TABINDEX, '-1');
        }
      }

      this._updateTabIndexes(child);
    }
  };

  FocusZone.prototype._isContentEditableElement = function (element) {
    return element && element.getAttribute('contenteditable') === 'true';
  };

  FocusZone.prototype._isElementInput = function (element) {
    if (element && element.tagName && (element.tagName.toLowerCase() === 'input' || element.tagName.toLowerCase() === 'textarea')) {
      return true;
    }

    return false;
  };

  FocusZone.prototype._shouldInputLoseFocus = function (element, isForward) {
    // If a tab was used, we want to focus on the next element.
    if (!this._processingTabKey && element && element.type && ALLOWED_INPUT_TYPES.indexOf(element.type.toLowerCase()) > -1) {
      var selectionStart = element.selectionStart;
      var selectionEnd = element.selectionEnd;
      var isRangeSelected = selectionStart !== selectionEnd;
      var inputValue = element.value;
      var isReadonly = element.readOnly; // We shouldn't lose focus in the following cases:
      // 1. There is range selected.
      // 2. When selection start is larger than 0 and it is backward and not readOnly.
      // 3. when selection start is not the end of length, it is forward and not readOnly.
      // 4. We press any of the arrow keys when our handleTabKey isn't none or undefined (only losing focus if we hit
      // tab) and if shouldInputLoseFocusOnArrowKey is defined, if scenario prefers to not loose the focus which is
      // determined by calling the callback shouldInputLoseFocusOnArrowKey

      if (isRangeSelected || selectionStart > 0 && !isForward && !isReadonly || selectionStart !== inputValue.length && isForward && !isReadonly || !!this.props.handleTabKey && !(this.props.shouldInputLoseFocusOnArrowKey && this.props.shouldInputLoseFocusOnArrowKey(element))) {
        return false;
      }
    }

    return true;
  };

  FocusZone.prototype._shouldWrapFocus = function (element, noWrapDataAttribute) {
    return this.props.checkForNoWrap ? shouldWrapFocus(element, noWrapDataAttribute) : true;
  };
  /**
   * Returns true if the element is a descendant of the FocusZone through a React portal.
   */


  FocusZone.prototype._portalContainsElement = function (element) {
    return element && !!this._root.current && portalContainsElement(element, this._root.current);
  };

  FocusZone.prototype._getDocument = function () {
    return getDocument(this._root.current);
  };

  FocusZone.defaultProps = {
    isCircularNavigation: false,
    direction: FocusZoneDirection.bidirectional,
    shouldRaiseClicks: true
  };
  return FocusZone;
}(Component);

var FlatList$1 = function FlatList(_ref) {
  var listItems = _ref.listItems,
      handleSelection = _ref.handleSelection;

  var onRenderPersonaCell = function onRenderPersonaCell(item) {
    return /*#__PURE__*/React__default.createElement(Stack, {
      onClick: function onClick() {
        return handleSelection(item);
      },
      "data-is-focusable": true,
      styles: {
        root: {
          border: "1px solid ".concat(DefaultPalette$2.neutralLight),
          padding: "5px",
          cursor: "pointer",
          selectors: {
            "&:hover": {
              backgroundColor: DefaultPalette$2.neutralLight
            }
          }
        }
      }
    }, /*#__PURE__*/React__default.createElement(Persona, {
      size: PersonaSize.size32,
      text: item.name,
      item: item,
      onRenderPrimaryText: function onRenderPrimaryText(_ref2) {
        var item = _ref2.item;
        return item.name ? /*#__PURE__*/React__default.createElement(Text, {
          variant: "medium",
          nowrap: true,
          block: true
        }, item.displayText ? item.displayText : item.name) : undefined;
      }
    }));
  };

  return /*#__PURE__*/React__default.createElement(List, {
    items: listItems,
    onRenderCell: onRenderPersonaCell
  });
};

var SearchField$1 = function SearchField(_ref) {
  var items = _ref.items,
      selectedItem = _ref.selectedItem,
      isFetchingItems = _ref.isFetchingItems,
      searchProps = _ref.searchProps,
      handleSelection = _ref.handleSelection;
  var searchKeys = searchProps.searchKeys,
      searchHint = searchProps.searchHint;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      itemText = _useState2[0],
      setItemText = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      item = _useState4[0],
      setItem = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      fieldErrorMessage = _useState6[0],
      setFieldErrorMessage = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isLoadingItems = _useState8[0],
      setIsLoadingItems = _useState8[1];

  var _useState9 = useState(""),
      _useState10 = _slicedToArray(_useState9, 2),
      searchValue = _useState10[0],
      setSearchValue = _useState10[1];

  var _useState11 = useState(),
      _useState12 = _slicedToArray(_useState11, 2),
      iconProps = _useState12[0],
      setIconProps = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      emptyfield = _useState14[0],
      setEmptyfield = _useState14[1]; // initialize fuse search


  var _useFuse = useFuse({
    items: items,
    searchKeys: searchKeys
  }),
      search = _useFuse.search,
      searchResults = _useFuse.searchResults;

  useEffect(function () {
    // Spinner until data is ready
    setIsLoadingItems(isFetchingItems);
    if (searchValue) searchInItems(searchValue);
  }, [isFetchingItems]);
  useEffect(function () {
    // Set selected item
    if (!selectedItem) return;
    setItem(selectedItem);
    setItemText(selectedItem.displayText);
  }, [selectedItem]);
  useEffect(function () {
    // Set empty field icon
    if (searchValue != "" || item && item.displayText) {
      setIconProps({
        iconName: "Cancel",
        style: {
          pointerEvents: "auto",
          cursor: "pointer",
          selectors: {
            "&:hover": {
              backgroundColor: DefaultPalette$2.neutralLight
            }
          }
        },
        onClick: function onClick() {
          setEmptyfield(true);
        }
      });
    } else setIconProps(); // If no matching items


    if (searchValue != "" && searchResults.length === 0) setFieldErrorMessage(i18n._(
    /*i18n*/
    {
      id: "No item matches search."
    }));else setFieldErrorMessage("");
  }, [searchResults, searchValue, item]);
  useEffect(function () {
    // Empty field
    if (emptyfield) {
      setItem();
      setItemText("");
      setSearchValue("");
      handleSelection({});
      setIconProps();
    }

    setEmptyfield(false);
  }, [emptyfield]);

  function searchInItems(value) {
    // Set spinner if still fetching items
    setIsLoadingItems(isFetchingItems); // Return if still fetching items

    if (isFetchingItems) return; // No items to select between

    if (!items || items.length === 0) {
      setFieldErrorMessage(i18n._(
      /*i18n*/
      {
        id: "There is no items to choose between. Please contact your IT administrator to get this problem solved."
      }));
      return;
    } // If no search value is entered, emply item


    if (value === "") {
      setItem();
      setItemText("");
    }

    setSearchValue(value);
    search(value);
    handleSelection(value !== "" ? undefined : {});
  }

  function handleItemSelected(item) {
    setItem(item);
    setItemText(item.displayText);
    setSearchValue("");
    handleSelection(item);
  }

  return /*#__PURE__*/React__default.createElement(FocusZone, {
    direction: FocusZoneDirection.vertical
  }, /*#__PURE__*/React__default.createElement(TextField, {
    name: "searchitem",
    required: false,
    placeholder: searchHint,
    onChange: function onChange(e, value) {
      return searchInItems(value);
    },
    value: searchValue ? searchValue : item && item.displayText ? itemText : item && item.name ? item.name : "",
    errorMessage: fieldErrorMessage,
    autoComplete: "off",
    iconProps: iconProps
  }), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        paddingTop: "2px",
        position: "relative"
      }
    }
  }, searchResults.length > 0 && searchValue !== "" && (isLoadingItems ? /*#__PURE__*/React__default.createElement(Spinner, {
    size: SpinnerSize.small
  }) : /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        position: "absolute",
        backgroundColor: DefaultPalette$2.white,
        width: "100%",
        zIndex: 10,
        maxHeight: "calc(5 * 44px)",
        overflowY: "scroll",
        overflowX: "hidden"
      }
    }
  }, /*#__PURE__*/React__default.createElement(FlatList$1, {
    listItems: searchResults,
    handleSelection: function handleSelection(item) {
      return handleItemSelected(item);
    }
  })))));
};

var defaultLogoUrl = process.env.REACT_APP_LOGO_PATH;

var Logout = function Logout() {
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    verticalFill: true
  }, /*#__PURE__*/React__default.createElement(Image, {
    src: defaultLogoUrl,
    alt: "id connect logo",
    width: 120,
    styles: {
      root: {
        position: "absolute",
        top: 30,
        left: 30
      }
    }
  }), /*#__PURE__*/React__default.createElement(Dialog, {
    hidden: false,
    dialogContentProps: {
      type: DialogType.normal,
      title: i18n._(
      /*i18n*/
      {
        id: "You have been signed out..."
      }),
      showCloseButton: false,
      subText: i18n._(
      /*i18n*/
      {
        id: "It is now recommended that you close this window before continuing your work."
      })
    },
    modalProps: {
      isBlocking: true,
      containerClassName: "ms-dialogMainOverride"
    }
  }));
};

var NoItemSelected = function NoItemSelected(_ref) {
  var iconProps = _ref.iconProps;
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    verticalFill: true,
    styles: {
      root: {
        backgroundColor: DefaultPalette$2.white,
        borderRadius: 2
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    styles: {
      root: {
        fontSize: 48,
        marginBottom: 10,
        color: iconProps.color
      }
    },
    iconName: iconProps.iconName
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "Select an item in the menu to the left"
  })));
};

var defaultLogoUrl$1 = process.env.REACT_APP_LOGO_PATH;
var ErrorPageLogo = function ErrorPageLogo() {
  return /*#__PURE__*/React__default.createElement(Link$2, {
    to: "/"
  }, /*#__PURE__*/React__default.createElement(Image, {
    src: defaultLogoUrl$1,
    alt: "id connect logo",
    width: 120,
    styles: {
      root: {
        position: "absolute",
        top: 30,
        left: 30
      }
    }
  }));
};

var urls$1 = Urls(process.env.REACT_APP_NAME);

var AccessDenied = function AccessDenied() {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ErrorPageLogo, null), /*#__PURE__*/React__default.createElement(Stack, {
    grow: true,
    verticalFill: true,
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 16
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xxLargePlus"
  }, i18n._(
  /*i18n*/
  {
    id: "Access Denied"
  })), /*#__PURE__*/React__default.createElement(Stack, {
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "You are not authorized to access this application."
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "Please try logging in again or contact your administrator if the"
  }))), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(PrimaryButton, {
    href: process.env.REACT_APP_DASHBOARD_URL,
    text: i18n._(
    /*i18n*/
    {
      id: "Return to Dashboard"
    })
  }), /*#__PURE__*/React__default.createElement(DefaultButton, {
    href: urls$1.logout,
    text: i18n._(
    /*i18n*/
    {
      id: "Retry login"
    })
  }))));
};

var urls$2 = Urls(process.env.REACT_APP_NAME);

var NoUserProfileDataFound = function NoUserProfileDataFound() {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ErrorPageLogo, null), /*#__PURE__*/React__default.createElement(Stack, {
    grow: true,
    verticalFill: true,
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 16
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xxLargePlus"
  }, i18n._(
  /*i18n*/
  {
    id: "No User Profile Data Found"
  })), /*#__PURE__*/React__default.createElement(Stack, {
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "An error occurred while fetching the user data."
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "Please try logging in again or contact your administrator if the problem persists."
  }))), /*#__PURE__*/React__default.createElement(DefaultButton, {
    href: urls$2.logout,
    text: i18n._(
    /*i18n*/
    {
      id: "Retry login"
    })
  })));
};

var NotFound404 = function NotFound404() {
  return /*#__PURE__*/React__default.createElement(Stack, {
    grow: true,
    verticalFill: true,
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 16
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xxLargePlus"
  }, "404!"), /*#__PURE__*/React__default.createElement(Stack, {
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "The page you're trying to access doesn't exits."
  })), /*#__PURE__*/React__default.createElement(DefaultButton, {
    text: /*#__PURE__*/React__default.createElement(Link$2, {
      to: "/",
      className: "unstyled-link"
    }, i18n._(
    /*i18n*/
    {
      id: "Return to main page"
    }))
  })));
};

var urls$3 = Urls(process.env.REACT_APP_NAME);

var MissingMultiFactor = function MissingMultiFactor() {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ErrorPageLogo, null), /*#__PURE__*/React__default.createElement(Stack, {
    grow: true,
    verticalFill: true,
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 16
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xxLargePlus"
  }, i18n._(
  /*i18n*/
  {
    id: "Access Denied"
  })), /*#__PURE__*/React__default.createElement(Stack, {
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "Multi factor is required on login and multi factor is not configured for your user."
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "Please try logging in again later or contact your administrator if the problem persists."
  }))), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(PrimaryButton, {
    href: urls$3.logout,
    text: i18n._(
    /*i18n*/
    {
      id: "Retry login"
    })
  }))));
};

function getContent(type) {
  switch (type) {
    case "info":
      return {
        className: info,
        headerText: i18n._(
        /*i18n*/
        {
          id: "Info"
        }),
        iconName: "Info",
        key: 0
      };

    case "success":
      return {
        className: success,
        headerText: i18n._(
        /*i18n*/
        {
          id: "Success"
        }),
        iconName: "Completed",
        key: 4
      };

    case "error":
      return {
        className: error,
        headerText: i18n._(
        /*i18n*/
        {
          id: "Error"
        }),
        iconName: "ErrorBadge",
        key: 1
      };

    case "blocked":
      return {
        className: blocked,
        headerText: i18n._(
        /*i18n*/
        {
          id: "Blocked"
        }),
        iconName: "Blocked2",
        key: 2
      };

    case "serverWarning":
      return {
        className: serverWarning,
        headerText: i18n._(
        /*i18n*/
        {
          id: "Warning"
        }),
        iconName: "Warning",
        key: 3
      };

    case "warning":
      return {
        className: warning$1,
        headerText: i18n._(
        /*i18n*/
        {
          id: "Warning"
        }),
        iconName: "Info",
        key: 5
      };

    default:
      return null;
  }
}

var MessageBox = function MessageBox(_ref) {
  var messageBoxType = _ref.messageBoxType,
      children = _ref.children,
      text = _ref.text,
      variant = _ref.variant;

  var _getContent = getContent(messageBoxType),
      className = _getContent.className,
      headerText = _getContent.headerText,
      iconName = _getContent.iconName,
      key = _getContent.key;

  if (variant === "small") return /*#__PURE__*/React__default.createElement(MessageBar, {
    messageBarType: key,
    messageBarIconProps: {
      iconName: iconName
    },
    overflowButtonAriaLabel: "See more",
    onDismiss: null,
    dismissButtonAriaLabel: "Close",
    styles: {
      root: {
        marginBottom: "5px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, null, /*#__PURE__*/React__default.createElement("b", null, text ? text : headerText, " "), children));
  return /*#__PURE__*/React__default.createElement(Stack, {
    className: className.container
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: iconName,
    className: className.icon
  })), /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, {
    className: className.header
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, text ? text : headerText)), /*#__PURE__*/React__default.createElement(Stack, null, children))));
};
var containerDefault = {
  minWidth: "300px",
  padding: "10px 10px 20px 10px"
};
var info = mergeStyleSets({
  container: _objectSpread2({
    backgroundColor: DefaultPalette$2.neutralLighter,
    border: "1px solid ".concat(DefaultPalette$2.neutralQuaternary)
  }, containerDefault),
  header: {},
  icon: {
    color: DefaultPalette$2.neutralSecondaryAlt,
    fontSize: 20,
    paddingTop: "3px"
  }
});
var success = mergeStyleSets({
  container: _objectSpread2({
    backgroundColor: "#dff6dd",
    border: "1px solid #107c10"
  }, containerDefault),
  header: {
    color: "#107c10"
  },
  icon: {
    color: "#107c10",
    fontSize: 20,
    paddingTop: "3px"
  }
});
var error = mergeStyleSets({
  container: _objectSpread2({
    backgroundColor: "#fde7e9",
    border: "1px solid #a80000"
  }, containerDefault),
  header: {
    color: "#a80000"
  },
  icon: {
    color: "#a80000",
    fontSize: 20,
    paddingTop: "3px"
  }
});
var blocked = mergeStyleSets({
  container: _objectSpread2({
    backgroundColor: "#fde7e9",
    border: "1px solid #a80000"
  }, containerDefault),
  header: {
    color: "#a80000"
  },
  icon: {
    color: "#a80000",
    fontSize: 20,
    paddingTop: "3px"
  }
});
var serverWarning = mergeStyleSets({
  container: _objectSpread2({
    backgroundColor: "#fed9cc",
    border: "1px solid #d83b01"
  }, containerDefault),
  header: {
    color: "#d83b01"
  },
  icon: {
    color: "#d83b01",
    fontSize: 20,
    paddingTop: "3px"
  }
});
var warning$1 = mergeStyleSets({
  container: _objectSpread2({
    backgroundColor: "#fff4ce",
    border: "1px solid #ffaa44"
  }, containerDefault),
  header: {},
  icon: {
    color: "#ffaa44",
    fontSize: 20,
    paddingTop: "3px"
  }
});

var urls$4 = Urls(process.env.REACT_APP_NAME);

var Retry = function Retry() {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ErrorPageLogo, null), /*#__PURE__*/React__default.createElement(Stack, {
    grow: true,
    verticalFill: true,
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 16
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xxLargePlus"
  }, i18n._(
  /*i18n*/
  {
    id: "Whoops, something went wrong!"
  })), /*#__PURE__*/React__default.createElement(Stack, {
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        paddingBottom: "10px",
        width: "600px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(MessageBox, {
    messageBoxType: "warning",
    text: i18n._(
    /*i18n*/
    {
      id: "Note"
    })
  }, /*#__PURE__*/React__default.createElement(Text, null, i18n._(
  /*i18n*/
  {
    id: "Unfortunately, you have ended up on the wrong page. It may be due to one of the reasons below."
  })))), /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xxLarge"
  }, i18n._(
  /*i18n*/
  {
    id: "Wrong 2 factor"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "You may have typed in the wrong token as 2 factor authentication."
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "xLarge"
  }, i18n._(
  /*i18n*/
  {
    id: "Solution"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "Go back to the login page and sign in again with the correct token."
  }))), /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 8
    },
    styles: {
      root: {
        paddingTop: "30px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xxLarge"
  }, i18n._(
  /*i18n*/
  {
    id: "Incorrect link"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "You may have saved an incorrect link to the login page."
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "xLarge"
  }, i18n._(
  /*i18n*/
  {
    id: "Solution"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "Bookmark the login page below instead of your current page."
  })), /*#__PURE__*/React__default.createElement(Link$1, {
    href: "https://dashboard.idconnect.dk"
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "large",
    className: "unstyled-link"
  }, "https://dashboard.idconnect.dk")))), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        paddingTop: "10px",
        width: "600px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(MessageBox, {
    messageBoxType: "info"
  }, /*#__PURE__*/React__default.createElement(Text, null, " ", i18n._(
  /*i18n*/
  {
    id: "If the problem persists, please contact your system administrator or IT support immediately."
  }))))), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(PrimaryButton, {
    href: urls$4.logout,
    text: i18n._(
    /*i18n*/
    {
      id: "Retry Login"
    })
  }))));
};

var RetryKombit = function RetryKombit() {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ErrorPageLogo, null), /*#__PURE__*/React__default.createElement(Stack, {
    grow: true,
    verticalFill: true,
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 16
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xLargePlus"
  }, i18n._(
  /*i18n*/
  {
    id: "Whoops, something went wrong!"
  })), /*#__PURE__*/React__default.createElement(Stack, {
    verticalAlign: "center",
    horizontalAlign: "center",
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        paddingBottom: "10px",
        width: "600px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(MessageBox, {
    messageBoxType: "warning",
    text: i18n._(
    /*i18n*/
    {
      id: "Note"
    })
  }, /*#__PURE__*/React__default.createElement(Text, null, i18n._(
  /*i18n*/
  {
    id: "Unfortunately, you have ended up on the wrong page. It may be due to one of the reasons below."
  })))), /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xLarge"
  }, i18n._(
  /*i18n*/
  {
    id: "Wrong 2 factor"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium"
  }, i18n._(
  /*i18n*/
  {
    id: "You may have typed in the wrong token as 2 factor authentication."
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "Solution"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium"
  }, i18n._(
  /*i18n*/
  {
    id: "Go back to the login page and sign in again with the correct token."
  }))), /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 8
    },
    styles: {
      root: {
        paddingTop: "30px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xLarge"
  }, i18n._(
  /*i18n*/
  {
    id: "Wrong login page"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium"
  }, i18n._(
  /*i18n*/
  {
    id: "You might have used a wrong loginpage."
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, i18n._(
  /*i18n*/
  {
    id: "Solution"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium"
  }, i18n._(
  /*i18n*/
  {
    id: "Please check you have the correct url / adress to the system you are trying to access."
  })))), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        paddingTop: "10px",
        width: "600px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(MessageBox, {
    messageBoxType: "info"
  }, /*#__PURE__*/React__default.createElement(Text, null, " ", i18n._(
  /*i18n*/
  {
    id: "If the problem persists, please contact your system administrator or IT support immediately."
  })))))));
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */

var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */


function arrayFilter(array, predicate) {
  var index = -1,
      length = array ? array.length : 0,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */


function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */


function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }

  return false;
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */


function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */


function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }

  return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }

  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }

  return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */


function baseIsNaN(value) {
  return value !== value;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */


function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}
/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function cacheHas(cache, key) {
  return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */


function getValue(object, key) {
  return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */


function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;

  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }

  return result;
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */


function setToArray(set) {
  var index = -1,
      result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}
/** Used for built-in method references. */


var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */

var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */


var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */

var splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max;
/* Built-in method references that are verified to be native. */

var Map$1 = getNative(root, 'Map'),
    Set$1 = getNative(root, 'Set'),
    nativeCreate = getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */


function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */


function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */


function listCacheClear() {
  this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */


function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$1 || ListCache)(),
    'string': new Hash()
  };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */

function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;
  this.__data__ = new MapCache();

  while (++index < length) {
    this.add(values[index]);
  }
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */


function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);

  return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */


function setCacheHas(value) {
  return this.__data__.has(value);
} // Add methods to `SetCache`.


SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */


function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }

  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }

  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }

  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;
    value = comparator || value !== 0 ? value : 0;

    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;

      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }

      result.push(value);
    } else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }

  return result;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */


function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */


function baseRest(func, start) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */


function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);

    if (set) {
      return setToArray(set);
    }

    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }

  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;
    value = comparator || value !== 0 ? value : 0;

    if (isCommon && computed === computed) {
      var seenIndex = seen.length;

      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }

      if (iteratee) {
        seen.push(computed);
      }

      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }

      result.push(value);
    }
  }

  return result;
}
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */


function baseXor(arrays, iteratee, comparator) {
  var index = -1,
      length = arrays.length;

  while (++index < length) {
    var result = result ? arrayPush(baseDifference(result, arrays[index], iteratee, comparator), baseDifference(arrays[index], result, iteratee, comparator)) : arrays[index];
  }

  return result && result.length ? baseUniq(result, iteratee, comparator) : [];
}
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */


var createSet = !(Set$1 && 1 / setToArray(new Set$1([, -0]))[1] == INFINITY) ? noop : function (values) {
  return new Set$1(values);
};
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */


function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */


function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */


var xor = baseRest(function (arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */


function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */


function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */


function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */


function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike(value) {
  return !!value && typeof value == 'object';
}
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */


function noop() {// No operation performed.
}

var lodash_xor = xor;

function EmptyList() {
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        height: 70,
        backgroundColor: DefaultPalette$2.neutralLight
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, null, i18n._(
  /*i18n*/
  {
    id: "No items available to show."
  })));
}

/**
 * Orders by the fieldName of the column that should be sorted. Makes sure to
 * leave all items with an `undefined` value at the bottom of the list.
 * @param {*} items items
 * @param {*} column columns
 * @param {*} defaultSortOrder If defaultSortOrder exists as a prop, its passed
 * in and used to sort the items, when no column is selected.
 */
function sortListItems$1(items, column, defaultSortOrder) {
  var sortItems = function sortItems(items, iteratees, orders) {
    return items.map(function (item, index) {
      return {
        item: item,
        index: index
      };
    }).sort(function (a, b) {
      for (var i = 0; i < iteratees.length; i++) {
        var iteratee = iteratees[i];
        var order = orders[i];
        var valueA = iteratee(a.item);
        var valueB = iteratee(b.item);
        if (valueA === valueB) continue;
        if (valueA === undefined) return 1;
        if (valueB === undefined) return -1;
        var comparison = valueA < valueB ? -1 : 1;
        return order === "desc" ? -comparison : comparison;
      }

      return a.index - b.index;
    }).map(function (_ref) {
      var item = _ref.item;
      return item;
    });
  };

  if (!column) {
    if (!defaultSortOrder) {
      return sortItems(items, [function (item) {
        return item.selected;
      }, function (item) {
        return item.name.toLowerCase();
      }], ["desc", "asc"]);
    }

    return sortItems(items, defaultSortOrder.iteratees.map(function (column) {
      return function (row) {
        var value = row[column];
        return value !== undefined ? value.toString().toLowerCase() : typeof column === "function" ? column(row) : "";
      };
    }), defaultSortOrder.orders);
  }

  return sortItems(items, [function (item) {
    return item[column.fieldName] !== undefined;
  }, function (item) {
    return typeof item[column.fieldName] === "string" ? item[column.fieldName].toLowerCase() : item[column.fieldName];
  }], ["desc", !column.isSorted ? "asc" : column.isSortedDescending ? "desc" : "asc"]);
}

// Basic filtering for when the user searches the list
function filterListItems(items, columns, filterText) {
  var text = filterText.toLowerCase();
  return items.filter(function (item) {
    return columns.some(function (column) {
      return item[column.fieldName] ? item[column.fieldName].toLowerCase().indexOf(text) > -1 : false;
    });
  });
}

// when the user interacts with it. It also makes sure to render the StaticDetailsRow
// where necessary.

function CustomDetailsRow(props) {
  var item = props.item,
      handleCheckboxChange = props.handleCheckboxChange,
      handleKeyDown = props.handleKeyDown,
      itemsInLoadingState = props.itemsInLoadingState;
  if (item["static"]) return /*#__PURE__*/React__default.createElement(StaticDetailsRow, props);
  var isInLoadingState = itemsInLoadingState.includes(item.id);
  return /*#__PURE__*/React__default.createElement("div", {
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event, item);
    }
  }, /*#__PURE__*/React__default.createElement(DetailsRow, _extends({}, props, {
    onRenderCheck: function onRenderCheck(checkProps) {
      return isInLoadingState ? /*#__PURE__*/React__default.createElement(Stack, {
        horizontalAlign: "center",
        verticalAlign: "center",
        styles: {
          root: {
            height: 42,
            width: 48
          }
        }
      }, /*#__PURE__*/React__default.createElement(Spinner, {
        size: SpinnerSize.small
      })) : /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return handleCheckboxChange(item);
        }
      }, /*#__PURE__*/React__default.createElement(DetailsRowCheck, checkProps));
    }
  })));
}

function StaticDetailsRow(props) {
  return /*#__PURE__*/React__default.createElement(DetailsRow, _extends({}, props, {
    id: "staticDetailsRow",
    onRenderDetailsCheckbox: function onRenderDetailsCheckbox() {
      return /*#__PURE__*/React__default.createElement(StaticCheckbox, {
        item: props.item
      });
    }
  }));
} // Some entities are "static" in order to secure certain functionality. Their
// selection status cannot be changed.


function StaticCheckbox(_ref) {
  var item = _ref.item;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isTeachingBubbleVisible = _useState2[0],
      setIsTeachingBubbleVisible = _useState2[1];

  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative",
      width: 18,
      height: 18,
      verticalAlign: "top",
      borderRadius: "50%",
      backgroundColor: DefaultPalette$2.purple
    },
    onClick: function onClick() {
      return setIsTeachingBubbleVisible(true);
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "CircleRing",
    title: item.staticTitle ? item.staticTitle : "",
    style: {
      color: DefaultPalette$2.white,
      fontSize: 18,
      position: "absolute",
      top: 0,
      left: 0,
      width: 18,
      height: 18,
      textAlign: "center",
      verticalAlign: "center"
    }
  }), /*#__PURE__*/React__default.createElement(Icon, {
    iconName: item.selected ? "StatusCircleCheckmark" : "",
    title: item.staticTitle ? item.staticTitle : "",
    style: {
      color: DefaultPalette$2.white,
      fontSize: 16,
      fontWeight: 900,
      position: "absolute",
      top: 0,
      left: 0.5,
      width: 18,
      height: 18,
      textAlign: "center",
      verticalAlign: "center"
    }
  }), isTeachingBubbleVisible ? /*#__PURE__*/React__default.createElement(TeachingBubble, {
    target: "#staticDetailsRow",
    hasCondensedHeadline: true,
    onDismiss: function onDismiss() {
      return setIsTeachingBubbleVisible(false);
    },
    hasCloseIcon: true,
    headline: i18n._(
    /*i18n*/
    {
      id: "This is a Static Entity"
    })
  }, i18n._(
  /*i18n*/
  {
    id: "Some entities are \"static\" in order to secure certain functionality, have waiting approvals or because you don't have the rights to change them."
  })) : null);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Style_round__1vkl8 {\n  position: relative;\n}\n\n.Style_round__1vkl8 label {\n  visibility: visible;\n  background-color: #fff;\n  border: 1.9px solid #8a8886;\n  border-radius: 50%;\n  cursor: pointer;\n  height: 15px;\n  left: 1px;\n  position: absolute;\n  top: 13px;\n  width: 15px;\n}\n\n.Style_round__1vkl8 label:hover::before {\n  border: 1.9px solid #8a8886;\n  border-top: none;\n  border-right: none;\n  content: \"\";\n  height: 3px;\n  left: 4px;\n  position: absolute;\n  top: 4px;\n  transform: rotate(-45deg);\n  width: 5.5px;\n}\n\n.Style_round__1vkl8 label:after {\n  border: 1.9px solid #fff;\n  border-top: none;\n  border-right: none;\n  content: \"\";\n  height: 3px;\n  left: 4px;\n  opacity: 0;\n  position: absolute;\n  top: 4px;\n  transform: rotate(-45deg);\n  width: 5.5px;\n}\n\n.Style_round__1vkl8 input[type=\"checkbox\"]:checked + label {\n  background-color: #0078d4;\n  border-color: #fff;\n}\n\n.Style_round__1vkl8 input[type=\"checkbox\"]:checked + label:after {\n  opacity: 1;\n}\n\n.Style_round__1vkl8 input[type=\"checkbox\"] {\n  visibility: hidden;\n}\n";
var styles$1 = {"round":"Style_round__1vkl8"};
styleInject(css_248z);

var checkbox = function checkbox(props) {
  var checked = props.checked,
      onChange = props.onChange;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.round
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "checkbox",
    id: "checkbox",
    checked: !!checked,
    onChange: onChange
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "checkbox"
  }));
};

function sortGroupedItems$1(items, groups, key) {
  var index = 0;
  var newGroups = groups.map(function (group) {
    index = index + 1;
    return _objectSpread2(_objectSpread2({}, group), {}, {
      sord: index
    });
  });
  var newItems = items.map(function (item) {
    return _objectSpread2(_objectSpread2({}, item), {}, {
      sord: newGroups.filter(function (group) {
        return group.key === item[key];
      })[0] && newGroups.filter(function (group) {
        return group.key === item[key];
      })[0].sord
    });
  });
  return newItems.sort(function (a, b) {
    return a.sord - b.sord;
  });
}
/** The `SelectionDetailsList` component implements the
 * @fluentui/reacts DetailsList component for the various item lists
 * across the idc apps where items should be selectable/deselectable.
 * @param {*} props
 *    @param {} items The items to be displayed in the list
 *    @param {} selectedItems The items that should be selected once the list
 *    renders.
 *    @param {} columns The column definitions for the items
 *    @param {} handleItemChange callback function for when an item has been
 *    selected or deselected. Since `selection` is passed to handleItemChange,
 *    it can use it to change the selection based on its result.
 *    @param {Object} defaultSortOrder An object with two keys: `iteratees` and
 *    `orders`. These keys correspond to the `iteratees` and `orders` properties
 */


function SelectionDetailsList(props) {
  // Create a new selection that sets the key to the item id
  var selection = useMemo(function () {
    return new Selection({
      getKey: function getKey(item) {
        return item.id;
      }
    });
  }, []);
  var filterIcon = "Filter";

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      previousSelected = _useState2[0],
      setPreviousSelected = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      originalItems = _useState4[0],
      setOriginalItems = _useState4[1];

  var _useState5 = useState(originalItems),
      _useState6 = _slicedToArray(_useState5, 2),
      items = _useState6[0],
      setItems = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      groups = _useState8[0],
      setGroups = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      groupProps = _useState10[0],
      setGroupProps = _useState10[1];

  var _useState11 = useState(""),
      _useState12 = _slicedToArray(_useState11, 2),
      pivotIcon = _useState12[0],
      setPivotIcon = _useState12[1];

  var _useState13 = useState({
    setFilter: (props.defaultFilterItems && props.defaultFilterItems.selectedItems && props.defaultFilterItems.selectedItems.length) > 0 ? true : false,
    filter: props.defaultFilterItems,
    isDefaultFilter: false,
    showButton: (props.defaultFilterItems && props.defaultFilterItems.selectedItems && props.defaultFilterItems.selectedItems.length) > 0 ? true : false
  }),
      _useState14 = _slicedToArray(_useState13, 2),
      defaultFilterItems = _useState14[0],
      setDefaultFilterItems = _useState14[1];

  var _useState15 = useState(props.columns.filter(function (c) {
    return c !== null;
  })),
      _useState16 = _slicedToArray(_useState15, 2),
      columns = _useState16[0],
      setColumns = _useState16[1];

  var _useState17 = useState(""),
      _useState18 = _slicedToArray(_useState17, 2),
      filterText = _useState18[0],
      setFilterText = _useState18[1];

  var _useState19 = useState(),
      _useState20 = _slicedToArray(_useState19, 2),
      columnsToFilterOn = _useState20[0],
      setColumnsToFilterOn = _useState20[1];

  var _useState21 = useState(),
      _useState22 = _slicedToArray(_useState21, 2),
      sortedColumn = _useState22[0],
      setSortedColumn = _useState22[1];

  var _useState23 = useState([]),
      _useState24 = _slicedToArray(_useState23, 2),
      itemsInLoadingState = _useState24[0],
      setItemsInLoadingState = _useState24[1];

  var _useState25 = useState(),
      _useState26 = _slicedToArray(_useState25, 2),
      contextualMenuProps = _useState26[0],
      setContextualMenuProps = _useState26[1];

  var _useState27 = useState(),
      _useState28 = _slicedToArray(_useState27, 2),
      filterColumn = _useState28[0],
      setFilterColumn = _useState28[1];

  var _useState29 = useState(false),
      _useState30 = _slicedToArray(_useState29, 2),
      isPanelOpen = _useState30[0],
      setIsPanelOpen = _useState30[1];

  var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      isCheckedAll = _useState32[0],
      setIsCheckedAll = _useState32[1];

  var _useState33 = useState([]),
      _useState34 = _slicedToArray(_useState33, 2),
      columnFilters = _useState34[0],
      setColumnFilters = _useState34[1];

  var _useState35 = useState(false),
      _useState36 = _slicedToArray(_useState35, 2),
      clearColumnFilters = _useState36[0],
      setClearColumnFilters = _useState36[1];

  var _useState37 = useState(),
      _useState38 = _slicedToArray(_useState37, 2),
      listView = _useState38[0],
      setListView = _useState38[1];

  var _useState39 = useState(false),
      _useState40 = _slicedToArray(_useState39, 2),
      isAllCollapsed = _useState40[0],
      setIsAllCollapsed = _useState40[1]; // If different listviews


  useEffect(function () {
    if (props.listItemProps && props.listItemProps.listType) setListView(props.listItemProps.listType);
  }, [props.listItemProps]); // Handle checked-all checkbox

  useEffect(function () {
    if (!items || items.length === 0) return;
    var isNotAllSelected = items.some(function (item) {
      return !item.selected && !item["static"];
    });
    setIsCheckedAll(!isNotAllSelected);
  }, [items]); // No Items in list and checked-all checkedbox checked, clear checked-all checkbox

  useEffect(function () {
    if (items && items.length === 0 && isCheckedAll && columnFilters && columnFilters.length > 0) setClearColumnFilters(true);
  }, [columnFilters, items, isCheckedAll]); // Set columns

  useEffect(function () {
    if (props && props.columns) {
      setColumns(props.columns.filter(function (c) {
        return c !== null;
      }));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [props.columns]); // Handle column filter and sort

  useEffect(function () {
    // Set columns to filter on
    setColumnsToFilterOn(columns.filter(function (col) {
      return col.applyColumnFilter;
    })); // Find default sort column

    if (!sortedColumn) {
      setSortedColumn(columns.find(function (col) {
        return col.isSorted;
      }));
    } // Else set selected sort column
    else {
      columns.forEach(function (col) {
        if (col.key === sortedColumn.key) {
          col.isSorted = true;
          col.isSortedDescending = sortedColumn.isSortedDescending;
        } else {
          col.isSorted = false;
          col.isSortedDescending = false;
        }
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [columns]); // Clear all filters and checkboxes when items is updated and no items are shown

  useEffect(function () {
    if (clearColumnFilters) {
      // Clear column filters
      setColumnFilters([]); //Clear search filter

      setFilterText(""); // Clear selected filter items

      if (!columnFilters) return;
      var newColumnFilters = [];
      columnFilters.forEach(function (f) {
        f.selectedItems = [];
        newColumnFilters.push(f);
      });
      setColumnFilters(newColumnFilters);
      setClearColumnFilters(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [clearColumnFilters]); // Set isAllCollapsed on groups

  useEffect(function () {
    if (!groups) return;
    var newGroups = groups.map(function (g) {
      return _objectSpread2(_objectSpread2({}, g), {}, {
        isCollapsed: isAllCollapsed
      });
    });
    props.setGroups(newGroups);
  }, [isAllCollapsed]); // Update the `originalItems` when props change

  useEffect(function () {
    if (!props.items) return;
    var selectedIds = props.selectedItems && props.selectedItems.map(function (i) {
      return i && i.id;
    }); // Add the selection state of the item to the item list.
    // Remove static roles from the list if they are not selected - keep them if
    // they are..

    var newItems = props.items.reduce(function (acc, item) {
      var selected = selectedIds.includes(item.id);
      return [].concat(_toConsumableArray(acc), [_objectSpread2(_objectSpread2({}, item), {}, {
        selected: selected
      })]);
    }, []);
    setOriginalItems(newItems);
  }, [props.items, props.selectedItems]); // When selectedItems change, originalItems are updated, and we need to update
  // which items are in a loading state.

  useEffect(function () {
    if (!previousSelected) {
      setPreviousSelected(props.selectedItems.map(function (i) {
        return i && i.id;
      }));
      return;
    }

    var selectedIds = props.selectedItems.map(function (i) {
      return i && i.id;
    });
    var updatedItems = []; // Check if ItemsInLoadingState should be cleared

    if (!props.clearLoadingStateOnUpdate) {
      updatedItems = lodash_xor(selectedIds, previousSelected);
      setItemsInLoadingState(function (ids) {
        return ids.filter(function (id) {
          return !updatedItems.includes(id);
        });
      });
    } else setItemsInLoadingState([]);

    setPreviousSelected(selectedIds); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [originalItems]); // When the originalItems change the items need to be filtered and sorted

  useEffect(function () {
    if (!columnsToFilterOn) return;
    var filteredItems = originalItems;
    var listItemProps = props.listItemProps ? props.listItemProps : {}; // Filter from column filters

    if (defaultFilterItems && defaultFilterItems.setFilter) {
      var column = columns.find(function (c) {
        return c.key === props.defaultFilterItems.columnKey;
      });
      var columnFilterProps = column.columnContextMenuProps;
      var filterItemsKey = columnFilterProps.itemsKey;
      if (!columnFilterProps.filterItems) return;
      var activateFilter = columnFilterProps.filterItems.some(function (item) {
        if (props.defaultFilterItems.selectedItems.some(function (defaultItem) {
          return item[filterItemsKey] === defaultItem;
        })) return false;
        return true;
      });

      if (activateFilter) {
        var filterProps = [{
          column: column,
          itemsType: column.columnContextMenuProps.itemsType,
          itemsKey: column.columnContextMenuProps.itemsKey,
          selectedItems: props.defaultFilterItems.selectedItems
        }];
        setColumnFilters(filterProps);
        setPivotIcon(filterIcon);
      }

      setDefaultFilterItems(_objectSpread2(_objectSpread2({}, defaultFilterItems), {}, {
        setFilter: false,
        isDefaultFilter: activateFilter,
        showButton: activateFilter
      }));
    } else if (columnFilters) {
      columnFilters.forEach(function (itemProps) {
        if (itemProps.selectedItems.length) {
          filteredItems = filterSelectedItems(filteredItems, itemProps.itemsType, itemProps.itemsKey, itemProps.selectedItems);
        }
      });
    } // Filter from search text


    filteredItems = filterText ? filterListItems(filteredItems, columnsToFilterOn, filterText) : filteredItems; // Sort list

    var newItems = sortListItems$1(filteredItems, sortedColumn, props.defaultSortOrder); // Clearnup old selections

    selection._items.forEach(function (item) {
      selection.setKeySelected(item.id, false, true);
    }); // Set amountOfItems in Pivot


    if (props.setAmountOfItems) {
      var itemsSelected = [];
      newItems.forEach(function (item) {
        if (item.selected) itemsSelected.push(item);
      });
      props.setAmountOfItems({
        selected: itemsSelected.length,
        amount: newItems.length,
        icon: pivotIcon,
        isDefaultFilter: defaultFilterItems.isDefaultFilter
      });
    }

    selection.setAllSelected(false); // Set Listview

    if (listView === "grouped") {
      // If grouped listview
      if (!listItemProps.groups) {
        return;
      } // Set groupProps


      if (listItemProps.groupProps) setGroupProps(listItemProps.groupProps);
      var groupKey = listItemProps.groupedListKey; // Find startIndex and count per group from groupedListKey

      if (groupKey) {
        // If sort on groupKey
        var sortedGroups = listItemProps.groups;

        if (sortedColumn && sortedColumn.isSorted && sortedColumn.key === groupKey) {
          sortedGroups = listItemProps.groups.sort(function (a, b) {
            if (sortedColumn.isSortedDescending) return b.name.localeCompare(a.name);
            return a.name.localeCompare(b.name);
          });
        } // Sort items on group key


        var newGroupedItems = sortGroupedItems$1(newItems, sortedGroups, groupKey);
        var startIndex = 0;
        var count = 0; // Set group index and count

        var indexedGroups = sortedGroups.map(function (g) {
          startIndex = startIndex + count;
          count = newGroupedItems.filter(function (i) {
            return i[groupKey] === g.key;
          }).length;
          return _objectSpread2(_objectSpread2({}, g), {}, {
            startIndex: startIndex,
            count: newGroupedItems.filter(function (i) {
              return i[groupKey] === g.key;
            }).length,
            selected: newGroupedItems.filter(function (i) {
              return i[groupKey] === g.key && props.selectedItems.some(function (s) {
                return s.id === i.id;
              });
            }).length
          });
        });
        newItems = newGroupedItems;
        var newGroups = listItemProps.groupProps.showEmptyGroups ? indexedGroups : indexedGroups.filter(function (i) {
          return i.count > 0;
        });
        setGroups(newGroups.map(function (g) {
          return _objectSpread2(_objectSpread2({}, g), {}, {
            isCollapsed: filterText === undefined || filterText === "" ? g.isCollapsed : false
          });
        }));
      } else setGroups(listItemProps.groups);
    } else {
      // If flat list view
      setGroups();
      setGroupProps();
    } // Assign new items to selection and restore item selection


    selection.setItems(newItems, false);
    props.selectedItems.forEach(function (item) {
      if (item) selection.setKeySelected(item.id, true, true);
    });
    setItems(newItems); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnsToFilterOn, filterText, originalItems, sortedColumn, columnFilters, listView]);

  function filterSelectedItems(items, itemType, itemKey, selectedItems) {
    var newItems = items.filter(function (item) {
      return selectedItems.some(function (i) {
        if (item[itemType].length > 0) {
          return item[itemType].some(function (t) {
            return t[itemKey] === i || isNaN(t[itemKey]) && t[itemKey].toLowerCase().indexOf(i) > -1;
          });
        } else {
          return item[itemType][itemKey] ? item[itemType][itemKey] === i || isNaN(item[itemType][itemKey]) && item[itemType][itemKey].toLowerCase().indexOf(i) > -1 : item[itemType] === i || isNaN(item[itemType]) && item[itemType].toLowerCase().indexOf(i) > -1;
        }
      });
    });
    return newItems;
  } // Add sorting info to the column that is clicked


  var onColumnClick = function onColumnClick(ev, column) {
    var newColumns = _toConsumableArray(columns);

    var currColumn = newColumns.find(function (newCol) {
      return column.key === newCol.key;
    });

    if (column.applyColumnContextMenu) {
      onColumnContextMenu(ev, column);
    } else {
      newColumns.forEach(function (col) {
        if (col === currColumn) {
          // If the current column is already sorted, then reverse the sort,
          // otherwise we sort descending.
          currColumn.isSortedDescending = !currColumn.isSorted ? false : !currColumn.isSortedDescending;
          currColumn.isSorted = true;
        } else {
          col.isSorted = false;
        }
      }); // Set the new items and columns.

      setSortedColumn(currColumn);
      setColumns(newColumns);
    }
  };

  var handleAllCheckboxChange = function handleAllCheckboxChange(event) {
    var newIsCheckedAll = event.target.checked;
    var newItems = items.filter(function (item) {
      return item["static"] !== true;
    });
    if (props.setSelectedItems) props.setSelectedItems(newIsCheckedAll ? newItems : []);
  };

  var renderStickyHeader = function renderStickyHeader(detailsHeaderProps) {
    // We want the "select/unselect all" checkbox to match the style of the row checkboxes
    // so we define the checkbox here to override the fake div one that's the dedault
    if (props.applyCheckAll) detailsHeaderProps.onRenderDetailsCheckbox = function (props) {
      return (
        /*#__PURE__*/
        // Checkbox handles the click through its props, so don't allow outside changes
        React__default.createElement(checkbox, {
          checked: isCheckedAll,
          onChange: handleAllCheckboxChange
        })
      );
    };
    return /*#__PURE__*/React__default.createElement(Sticky, {
      stickyPosition: StickyPositionType.Header,
      isScrollSynced: true
    }, /*#__PURE__*/React__default.createElement(DetailsHeader, detailsHeaderProps));
  };

  var _renderItemColumn = function _renderItemColumn(item, index, column) {
    var fieldContent = item[column.fieldName];
    return typeof fieldContent === "boolean" ? fieldContent ? i18n._(
    /*i18n*/
    {
      id: "Yes"
    }) : i18n._(
    /*i18n*/
    {
      id: "No"
    }) : fieldContent;
  }; // Update the loading state and the item, when the item is changed


  var handleCheckboxChange = function handleCheckboxChange(item) {
    var keyAdded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!props.disableSingleRowSelection) setItemsInLoadingState([].concat(_toConsumableArray(itemsInLoadingState), [item.id]));
    var isAdded = keyAdded ? selection.isKeySelected(item.id) : !selection.isKeySelected(item.id); // Method for cancelling the selection/desection of an item.

    item.cancel = function () {
      setItemsInLoadingState(function (ids) {
        return ids.filter(function (id) {
          return id !== item.id;
        });
      });
      setOriginalItems(function (previous) {
        return _toConsumableArray(previous);
      });
    };

    props.handleItemChange({
      item: item,
      isAdded: isAdded
    });
  };

  var handleKeyDown = function handleKeyDown(event, item) {
    //Select/Deselect items with spacebar
    if (event.keyCode === 32) {
      selection.setKeySelected(item.id, !selection.isKeySelected(item.id), true);
      handleCheckboxChange(item, true);
    }
  };

  var onContextualMenuDismissed = function onContextualMenuDismissed() {
    setContextualMenuProps(undefined);
  };

  var getContextualMenuProps = function getContextualMenuProps(ev, column) {
    var elements = [{
      key: "aToZ",
      name: i18n._(
      /*i18n*/
      {
        id: "A to Z"
      }),
      iconProps: {
        iconName: "SortUp"
      },
      canCheck: true,
      checked: column.isSorted && !column.isSortedDescending,
      onClick: function onClick() {
        return onSortClickedColumn(ev, column);
      }
    }, {
      key: "zToA",
      name: i18n._(
      /*i18n*/
      {
        id: "Z to A"
      }),
      iconProps: {
        iconName: "SortDown"
      },
      canCheck: true,
      checked: column.isSorted && column.isSortedDescending,
      onClick: function onClick() {
        return onSortClickedColumn(ev, column);
      }
    }, {
      key: "filter",
      name: i18n._(
      /*i18n*/
      {
        id: "Filter by"
      }),
      canCheck: true,
      checked: columnFilters.some(function (c) {
        return c.column.key === column.key && c.selectedItems.length > 0;
      }),
      onClick: function onClick() {
        return onFilterColumn(ev, column);
      },
      style: {
        borderTop: "1px solid ".concat(DefaultPalette.neutralLight)
      }
    }];
    setContextualMenuProps({
      items: elements,
      target: ev.currentTarget,
      directionalHint: DirectionalHint.bottomLeftEdge,
      isBeakVisible: false,
      onDismiss: onContextualMenuDismissed
    });
  };

  var onColumnContextMenu = function onColumnContextMenu(ev, column) {
    getContextualMenuProps(ev, column);
  };

  var onSortClickedColumn = function onSortClickedColumn(ev, column) {
    var newColumns = _toConsumableArray(columns);

    var currColumn = newColumns.find(function (newCol) {
      return column.key === newCol.key;
    }); // Update the columns to reflect the user's selection.

    newColumns.forEach(function (col) {
      if (col === currColumn) {
        // If the current column is already sorted, then reverse the sort,
        // otherwise we sort descending.
        currColumn.isSortedDescending = !currColumn.isSorted ? false : !currColumn.isSortedDescending;
        currColumn.isSorted = true;
      } else {
        col.isSorted = false;
      }
    }); // Set the new items and columns.

    setSortedColumn(currColumn);
    setColumns(newColumns);
  };

  function onPanelClose() {
    setIsPanelOpen(false);
  }

  var onFilterColumn = function onFilterColumn(ev, column) {
    setFilterColumn(column);
    setIsPanelOpen(true);
  };

  var handleApplyFilter = function handleApplyFilter(filterProps) {
    setColumnFilters(filterProps);
    if (props.setSelectedItems) props.setSelectedItems([]);
    var hasSelectedItems = false;
    filterProps.forEach(function (column) {
      if (column.selectedItems.length) hasSelectedItems = true;
    });
    if (hasSelectedItems) setPivotIcon(filterIcon);else setPivotIcon("");
  };

  if (!originalItems.length) return /*#__PURE__*/React__default.createElement(EmptyList, null);
  return /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        marginBottom: 24,
        padding: 8
      }
    }
  }, /*#__PURE__*/React__default.createElement(FilterPanel, {
    column: filterColumn,
    isPanelOpen: isPanelOpen,
    onPanelClose: onPanelClose,
    handleApplyFilter: handleApplyFilter,
    filterProps: columnFilters,
    defaultFilterItems: defaultFilterItems,
    setDefaultFilterItems: setDefaultFilterItems
  }), !!columnsToFilterOn.length && /*#__PURE__*/React__default.createElement(TextField, {
    styles: {
      subComponentStyles: {
        label: {
          root: {
            marginBottom: 4
          }
        }
      }
    },
    label: /*#__PURE__*/React__default.createElement(Text, null, i18n._(
    /*i18n*/
    {
      id: "Search on:"
    }), " ", columnsToFilterOn.map(function (c, index) {
      return /*#__PURE__*/React__default.createElement(Tag, {
        key: index
      }, c.name);
    })),
    value: filterText,
    onChange: function onChange(e, text) {
      return setFilterText(text);
    }
  }), /*#__PURE__*/React__default.createElement(DetailsList, {
    items: items,
    groups: groups,
    groupProps: _objectSpread2(_objectSpread2({}, groupProps), {}, {
      onToggleCollapseAll: setIsAllCollapsed
    }),
    selection: selection,
    setKey: "set",
    onRenderRow: function onRenderRow(listProps) {
      return /*#__PURE__*/React__default.createElement(CustomDetailsRow, _extends({}, listProps, {
        itemsInLoadingState: itemsInLoadingState,
        handleCheckboxChange: handleCheckboxChange,
        handleKeyDown: handleKeyDown
      }));
    } // Columns need to be recomputed whenever the list reloads
    ,
    columns: columns.map(function (c) {
      return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, c), c.applyColumnClick && {
        onColumnClick: onColumnClick
      }), c.applyColumnContextMenu && {
        onColumnContextMenu: onColumnContextMenu
      }), c.applyColumnContextMenu && {
        columnActionsMode: ColumnActionsMode$1.hasDropdown
      }), c.applyColumnDisabled && {
        columnActionsMode: ColumnActionsMode$1.disabled
      }), {}, {
        isFiltered: columnFilters.some(function (column) {
          return column.column && column.column.key === c.key && column.selectedItems.length > 0;
        })
      });
    }) // constrainMode={ConstrainMode.horizontalConstrained}
    ,
    layoutMode: DetailsListLayoutMode$1.justified // Checkbox is always shown when editing
    ,
    checkboxVisibility: CheckboxVisibility.always // Allows the user to select multiple items
    ,
    selectionMode: SelectionMode$1.multiple // Allows the selection to persist when the user clicks outside the checkbox
    ,
    selectionPreservedOnEmptyClick: true // This disables the use of the keyboard for toggling checkboxes
    ,
    disableSelectionZone: true,
    onRenderItemColumn: _renderItemColumn,
    onRenderDetailsHeader: renderStickyHeader
  }), !items.length && /*#__PURE__*/React__default.createElement(Stack, {
    horizontalAlign: "center",
    verticalAlign: "center",
    styles: {
      root: {
        minHeight: "200px"
      }
    }
  }, i18n._(
  /*i18n*/
  {
    id: "No items matches search."
  })), contextualMenuProps && /*#__PURE__*/React__default.createElement(ContextualMenu, _extends({}, contextualMenuProps, {
    styles: {
      root: {
        height: 110
      }
    }
  })));
}

var iconProps = {
  iconName: "ChevronDown",
  style: {
    fontSize: "10px"
  }
}; // Default options values

var defaultOptions = [{
  key: "00:00",
  text: "00:00"
}, {
  key: "00:30",
  text: "00:30"
}, {
  key: "01:00",
  text: "01:00"
}, {
  key: "01:30",
  text: "01:30"
}, {
  key: "02:00",
  text: "02:00"
}, {
  key: "02:30",
  text: "02:30"
}, {
  key: "03:00",
  text: "03:00"
}, {
  key: "03:30",
  text: "03:30"
}, {
  key: "04:00",
  text: "04:00"
}, {
  key: "04:30",
  text: "04:30"
}, {
  key: "05:00",
  text: "05:00"
}, {
  key: "05:30",
  text: "05:30"
}, {
  key: "06:00",
  text: "06:00"
}, {
  key: "06:30",
  text: "06:30"
}, {
  key: "07:00",
  text: "07:00"
}, {
  key: "07:30",
  text: "07:30"
}, {
  key: "08:00",
  text: "08:00"
}, {
  key: "08:30",
  text: "08:30"
}, {
  key: "09:00",
  text: "09:00"
}, {
  key: "09:30",
  text: "09:30"
}, {
  key: "10:00",
  text: "10:00"
}, {
  key: "10:30",
  text: "10:30"
}, {
  key: "11:00",
  text: "11:00"
}, {
  key: "11:30",
  text: "11:30"
}, {
  key: "12:00",
  text: "12:00"
}, {
  key: "12:30",
  text: "12:30"
}, {
  key: "13:00",
  text: "13:00"
}, {
  key: "13:30",
  text: "13:30"
}, {
  key: "14:00",
  text: "14:00"
}, {
  key: "14:30",
  text: "14:30"
}, {
  key: "15:00",
  text: "15:00"
}, {
  key: "15:30",
  text: "15:30"
}, {
  key: "16:00",
  text: "16:00"
}, {
  key: "16:30",
  text: "16:30"
}, {
  key: "17:00",
  text: "17:00"
}, {
  key: "17:30",
  text: "17:30"
}, {
  key: "18:00",
  text: "18:00"
}, {
  key: "18:30",
  text: "18:30"
}, {
  key: "19:00",
  text: "19:00"
}, {
  key: "19:30",
  text: "19:30"
}, {
  key: "20:00",
  text: "20:00"
}, {
  key: "20:30",
  text: "20:30"
}, {
  key: "21:00",
  text: "21:00"
}, {
  key: "21:30",
  text: "21:30"
}, {
  key: "22:00",
  text: "22:00"
}, {
  key: "22:30",
  text: "22:30"
}, {
  key: "23:00",
  text: "23:00"
}, {
  key: "23:30",
  text: "23:30"
}];

function filterTimes(startTime, timeOptions) {
  var startMinutes = timeToMinutes(startTime);
  return timeOptions.filter(function (option) {
    var optionMinutes = timeToMinutes(option.key);
    return optionMinutes >= startMinutes;
  });
}

function timeToMinutes(time) {
  var _time$split$map = time.split(":").map(Number),
      _time$split$map2 = _slicedToArray(_time$split$map, 2),
      hours = _time$split$map2[0],
      minutes = _time$split$map2[1];

  return hours * 60 + minutes;
} // Find closesd index in option list


function getIndexOfTime(time, options) {
  var newSelectedIndex = options.findIndex(function (o) {
    return o.key === time;
  });

  if (newSelectedIndex < 0) {
    var option = time.split(":");
    var h = Number(option[0]);
    var m = Number(option[1]);
    h = m < 46 ? h : h + 1;
    m = m < 16 || m > 45 ? 0 : 30;
    newSelectedIndex = options.findIndex(function (o) {
      return o.key === "".concat(h < 10 ? "0".concat(h) : "".concat(h), ":").concat(m === 0 ? "00" : m);
    });
  }

  return newSelectedIndex;
} // Handle timeout delay


function timeout$4(delay) {
  return new Promise(function (res) {
    return setTimeout(res, delay);
  });
} // Set scroll in option list from index


function setScroll$4(_x) {
  return _setScroll$4.apply(this, arguments);
}
/**
 * @description Time picker field
 * @param {object} props
 *  @param {string} value Time value
 *  @param {string} required Whether field is required or not - "true" or "false"
 *  @param {boolean} disabled Disable field true or false
 *  @param {string} listCount Amount of items shown in dropdown
 *  @param {string} label Label text
 *  @param {object} labelIconProps CustomLabel settings
 *    @param {string} iconName
 *    @param {string} title
 *    @param {string} callOutText
 *    @param {string} ariaLabel
 *  @param {string} placeholder Placeholder text
 *  @param {string} errorMessage Error message
 *  @param {Array} options Options, if empty array default options is set
 *    @param {object}
 *      @param {string} key Option key
 *      @param {string} text Option text
 *  @param {function} onChange Handler to when time is changed
 */


function _setScroll$4() {
  _setScroll$4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
    var list, index;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return timeout$4(1);

          case 2:
            list = options.list, index = options.index;

            if (list.current) {
              list.current.scrollToIndex(index, function () {
                return 24;
              });
              list.current.forceUpdate();
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setScroll$4.apply(this, arguments);
}

var TimePickerField = function TimePickerField(props) {
  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      time = _useState2[0],
      setTime = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showList = _useState4[0],
      setShowList = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedIndex = _useState6[0],
      setSelectedIndex = _useState6[1];

  var list = useRef(null);
  var ref = useRef(null);
  var options = useMemo(function () {
    var newOptions = !props.options || props.options === "" || props.options.length === 0 ? defaultOptions : props.options;
    if (time) setSelectedIndex(getIndexOfTime(time, newOptions));

    if (props.minHour) {
      return filterTimes(props.minHour, newOptions);
    }

    return newOptions;
  }, [props.options, props.minHour]);
  var listStyle = mergeStyleSets({
    container: {
      position: "absolute",
      backgroundColor: DefaultPalette$2.white,
      width: "100%",
      zIndex: 10,
      maxHeight: "calc(".concat(props.listCount ? props.listCount : 5, " * 24px)"),
      overflowY: "scroll",
      overflowX: "hidden"
    }
  }); // Handle value

  useEffect(function () {
    if (!props.value) return;

    if (props.value !== time) {
      setTime(props.value);
      setScroll$4({
        list: list,
        index: getIndexOfTime(props.value, options)
      });
      setSelectedIndex(getIndexOfTime(props.value, options));
    }
  }, [props.value]); // Handle scroll

  useEffect(function () {
    if (showList && selectedIndex > 0) setScroll$4({
      list: list,
      index: selectedIndex
    });
    if (!props.onChange && showList) return;
    props.onChange(time); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showList]); // Handle selected index when time is changed

  var _onChange = function onChange(value, index) {
    if (index) setSelectedIndex(index);
    setTime(value);
  }; // Handle blur - don't show options


  var handleBlur = function handleBlur(e) {
    if (options.length) setTimeout(function () {
      setShowList(false);
    }, 200);
  };

  var handleClick = function handleClick() {
    if (ref.current.state.isFocused && !showList) setShowList(true);
  };

  var handleKeyDown = function handleKeyDown(e, i) {
    var newSelectedIndex = i; // Enter

    if (e.keyCode === 13) handleBlur();else if (!showList) setShowList(true); // Arrow down

    if (e.keyCode === 40 && i < options.length - 1) newSelectedIndex = i + 1; // Arrow up

    if (e.keyCode === 38 && i > 0) newSelectedIndex = i - 1;

    if (newSelectedIndex !== i) {
      setScroll$4({
        list: list,
        index: newSelectedIndex
      });
      setSelectedIndex(newSelectedIndex);
      setTime(options[newSelectedIndex].key);
    }
  }; // On Render cell handler


  var onRenderCell = function onRenderCell(option, index) {
    return /*#__PURE__*/React__default.createElement(Stack, {
      verticalAlign: "center",
      onClick: function onClick() {
        return _onChange(option.key, index);
      },
      styles: {
        root: {
          paddingLeft: "5px",
          height: "24px",
          cursor: "pointer",
          selectors: {
            "&:hover": {
              backgroundColor: DefaultPalette$2.neutralLight
            }
          },
          backgroundColor: selectedIndex === index ? DefaultPalette$2.neutralLighter : DefaultPalette$2.white
        }
      }
    }, option.text);
  };

  return /*#__PURE__*/React__default.createElement(Stack, null, props.label && /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: props.label,
    required: props.required ? props.required : false,
    labelIconProps: props.labelIconProps ? props.labelIconProps : {}
  }), /*#__PURE__*/React__default.createElement(FocusZone, {
    direction: FocusZoneDirection.vertical
  }, /*#__PURE__*/React__default.createElement(TextField, {
    ref: ref,
    placeholder: props.placeholder ? props.placeholder : "",
    onChange: function onChange(e, value) {
      return _onChange(value);
    },
    onFocus: function onFocus() {
      !showList && setShowList(true);
    },
    onClick: handleClick,
    onKeyDown: function onKeyDown(ev) {
      return handleKeyDown(ev, selectedIndex);
    },
    onBlur: handleBlur,
    value: time,
    errorMessage: props.errorMessage ? props.errorMessage : "",
    autoComplete: "off",
    iconProps: iconProps,
    styles: {
      root: {
        width: "135px"
      }
    },
    style: {
      cursor: "pointer"
    },
    disabled: props.disabled ? props.disabled : false
  }), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        paddingTop: "2px",
        position: "relative"
      }
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: listStyle.container,
    "data-is-scrollable": true
  }, showList && /*#__PURE__*/React__default.createElement(List, {
    items: options,
    componentRef: list,
    onRenderCell: onRenderCell
  })))));
};

/**
 * @description DateTime picker field
 * @param {object} props
 *  @param {object} value
 *    @param {date} date Date value to DatePickerField
 *    @param {string} time Time value to TimePickerField
 *  @param {date} minDate Minimum date to be picked in DatePickerField
 *  @param {string} minHour Minimum hour to be picked in DatePickerField
 *  @param {boolean} disabled Disable fields true or false
 *  @param {string} required Whether field is required or not - "true" or "false"
 *  @param {string} label Label text
 *  @param {object} labelIconProps CustomLabel settings
 *    @param {string} iconName
 *    @param {string} title
 *    @param {string} callOutText
 *    @param {string} ariaLabel
 *  @param {string} errorMessage Error message to TimePickerField
 *  @param {Array} options Options to TimePickerField if empty array, default options is set
 *    @param {object}
 *      @param {string} key Option key
 *      @param {string} text Option text
 *  @param {function} onChange Handler to when date or time is changed
 *  @param {object} timePickerFieldProps
 *    @param {number} listCount
 */

var DateTimePickerField = function DateTimePickerField(props) {
  var value = props.value;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      date = _useState2[0],
      setDate = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      time = _useState4[0],
      setTime = _useState4[1]; // Handler to when values changes


  useEffect(function () {
    if (!value) return;

    if (value.date && !date || value.date && (value.date.getDate() !== date.getDate() || value.date.getMonth() !== date.getMonth() || value.date.getYear() !== date.getYear())) {
      setDate(value.date);
    }

    if (value.time && time !== value.time) {
      setTime(value.time);
    }
  }, [value]); // Handler to then time or date changes

  useEffect(function () {
    if (!props.onChange) return;
    props.onChange({
      date: date ? date : "",
      time: time ? time : ""
    });
  }, [date, time]);
  return /*#__PURE__*/React__default.createElement(Stack, null, props.label && /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: props.label,
    required: props.required ? props.required : false,
    labelIconProps: props.labelIconProps ? props.labelIconProps : {}
  }), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(DatePickerField, {
    value: date ? date : "",
    onSelectDate: setDate,
    disabled: props.disabled ? props.disabled : false,
    minDate: props.minDate
  }), /*#__PURE__*/React__default.createElement(TimePickerField, {
    disabled: props.disabled ? props.disabled : false,
    value: time ? time : "",
    listCount: props.timePickerFieldProps && props.timePickerFieldProps.listCount ? props.timePickerFieldProps.listCount : 5,
    onChange: setTime,
    options: props.options ? props.options : "",
    errorMessage: props.errorMessage ? props.errorMessage : "",
    minHour: props.minHour ? props.minHour : undefined
  })));
};

var formatDateTimeSeconds = function formatDateTimeSeconds(item) {
  var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "yyyyMMddHHmmss";
  if (!isValidDate(item)) return;
  return format$1(form)(item);
}; // Format date and time

var formatDateTime = function formatDateTime(item) {
  var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dd-MM-yyyy HH:mm";
  if (!isValidDate(item)) return;
  return format$1(form)(item);
}; // Format date

var formatDate = function formatDate(item) {
  if (!isValidDate(item)) return;
  return format$1("dd-MM-yyyy")(item);
}; // Format time

var formatTime = function formatTime(item) {
  var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "HH:mm";
  if (!isValidDate(item)) return;
  return format$1(form)(item);
};
var getWeekday = function getWeekday(item) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "tiny";
  if (!isValidDate(item)) return;

  switch (variant) {
    case "tiny":
      return format$1("EEEEEE")(item) === "Mo" ? i18n._(
      /*i18n*/
      {
        id: "Mo"
      }) : format$1("EEEEEE")(item) === "Tu" ? i18n._(
      /*i18n*/
      {
        id: "Tu"
      }) : format$1("EEEEEE")(item) === "We" ? i18n._(
      /*i18n*/
      {
        id: "We"
      }) : format$1("EEEEEE")(item) === "Th" ? i18n._(
      /*i18n*/
      {
        id: "Th"
      }) : format$1("EEEEEE")(item) === "Fr" ? i18n._(
      /*i18n*/
      {
        id: "Fr"
      }) : format$1("EEEEEE")(item) === "Sa" ? i18n._(
      /*i18n*/
      {
        id: "Sa"
      }) : i18n._(
      /*i18n*/
      {
        id: "Su"
      });

    default:
      return "";
  }
}; // Check if valid date

var isValidDate = function isValidDate(item) {
  return moment(item).isValid();
}; // --------------------------------
// Date help functions
// --------------------------------
// Returns diffences between to dates in minutes

var diffenceInMinutes = function diffenceInMinutes(startItem, endItem) {
  if (!isValidDate(startItem) || !isValidDate(endItem)) return;
  return Math.abs(endItem - startItem) / (1000 * 60);
}; // Returns duration in minutes

var durationInMinutes = function durationInMinutes(date, durationValues) {
  // Ekspects durationValues in format "1y 1M 1d 1H"
  var values = durationValues.split(" ");
  var minutes = 0;
  values.forEach(function (value) {
    var endDate = new Date(date);
    if (value.indexOf("y") > 0) endDate.setFullYear(endDate.getFullYear() + Number(value.substring(0, value.length - 1)));
    if (value.indexOf("M") > 0) endDate.setMonth(endDate.getMonth() + Number(value.substring(0, value.length - 1)));
    if (value.indexOf("d") > 0) endDate.setDate(endDate.getDate() + Number(value.substring(0, value.length - 1)));
    if (value.indexOf("H") > 0 || value.indexOf("h") > 0) endDate.setHours(endDate.getHours() + Number(value.substring(0, value.length - 1)));
    minutes += Math.abs(endDate - date) / (1000 * 60);
  });
  return minutes;
}; // Returns the ISO week of the date.

var getWeekNumber = function getWeekNumber(item) {
  if (!isValidDate(item)) return 0;
  var date = new Date(item);
  date.setHours(0, 0, 0, 0); // Thursday in current week decides the year.

  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7); // January 4 is always in week 1.

  var week1 = new Date(date.getFullYear(), 0, 4); // Adjust to Thursday in week 1 and count number of weeks from date to week1.

  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
}; // Returns true if date is today

var isDateToday = function isDateToday(item) {
  var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  if (!isValidDate(item)) return false;
  var date = new Date(item);
  return date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear();
}; // Returns true if date is yesterday

var isDateYesterday = function isDateYesterday(item) {
  if (!isValidDate(item)) return false;
  var today = new Date(); // Subtract one day from today

  today.setDate(today.getDate() - 1);
  return isDateToday(item, today);
}; // Returns true if date is in this week

var isDateInThisWeek = function isDateInThisWeek(item) {
  var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  if (!isValidDate(item)) return false;
  var date = new Date(item);
  return getWeekNumber(date) === getWeekNumber(today) && isDateInThisYear(item);
}; // Returns true if date is in last week

var isDateInLastWeek = function isDateInLastWeek(item) {
  if (!isValidDate(item)) return false;
  var today = new Date(); // Subtract one week from today

  today.setDate(today.getDate() - 7);
  return isDateInThisWeek(item, today);
}; // Returns true if date is thee weeks ago

var isDateThreeWeekAgo = function isDateThreeWeekAgo(item) {
  if (!isValidDate(item)) return false;
  var today = new Date(); // Subtract two week from today

  today.setDate(today.getDate() - 14);
  return isDateInThisWeek(item, today);
}; // Returns true if date is in this month

var isDateInThisMonth = function isDateInThisMonth(item) {
  var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  if (!isValidDate(item)) return false;
  var date = new Date(item);
  return date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear();
}; // Returns true if date is in last month

var isDateInLastMonth = function isDateInLastMonth(item) {
  if (!isValidDate(item)) return false;
  var today = new Date(); // Subtract one month from today

  today.setMonth(today.getMonth() - 1);
  return isDateInThisMonth(item, today);
}; // Returns true if date is in this month

var isDateInThisYear = function isDateInThisYear(item) {
  var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  if (!isValidDate(item)) return false;
  var date = new Date(item);
  return date.getFullYear() == today.getFullYear();
}; // --------------------------------
// DateTimeObj
// Format = {date: {date}, time: {hh:mm}};
// --------------------------------
// Check if dateTime object contains valid date and time

var isValidDateObj = function isValidDateObj(obj) {
  if (!obj || !obj.date || !obj.time) return false;
  return isValidDate(dateTimeFromDateTimeObj(obj));
}; // Returns date and time from dateTime object

var dateTimeFromDateTimeObj = function dateTimeFromDateTimeObj(obj) {
  var newDate = new Date(obj.date);
  newDate.setMilliseconds(0);
  newDate.setSeconds(0);
  newDate.setHours(Number(obj.time.split(":")[0]));
  newDate.setMinutes(Number(obj.time.split(":")[1]));
  return newDate;
};

//Our Moduls

var handleEndDateTime = function handleEndDateTime(startDateTimeObj, minutes) {
  var date = new Date(dateTimeFromDateTimeObj(startDateTimeObj));
  date.setTime(date.getTime() + minutes * 60 * 1000);
  var newHours = "".concat(date.getHours() < 10 ? "0".concat(date.getHours()) : "".concat(date.getHours()));
  var newMinutes = "".concat(date.getMinutes() < 10 ? "0".concat(date.getMinutes()) : "".concat(date.getMinutes())); // Do not return end dates in the past

  return date > new Date() ? {
    date: date,
    time: "".concat(newHours, ":").concat(newMinutes)
  } : false;
}; // Handle options on endDateTime object

var handleOptions = function handleOptions(startDateTime) {
  var tHour = Number(startDateTime.time.split(":")[0]);
  var tMin = Number(startDateTime.time.split(":")[1]);
  var m = tMin < 30 ? tMin : tMin - 30;
  var h = tHour;
  var i = 0.5;
  var addHour = true;
  var newOptions = Array(46 - (tHour * 2 + (tMin > 29 ? 1 : 0))).fill().map(function (a, idx) {
    if (addHour) {
      h++;
    }

    i = i + 0.5;
    addHour = tMin > 29 ? idx % 2 === 0 : idx % 2 !== 0;
    var hour = h > 9 ? "".concat(h) : "0".concat(h);
    var minutes = !addHour ? m < 10 ? "0".concat(m) : "".concat(m) : "".concat(30 + m);
    return {
      key: "".concat(hour, ":").concat(minutes),
      text: "".concat(hour, ":").concat(minutes, " (").concat(i.toString().replace(".", ","), " ").concat(i18n._(
      /*i18n*/
      {
        id: "hours"
      }), ")")
    };
  });
  return newOptions;
};

/**
 * @description Date and time period picker
 * @param {object} props
 *  @param {boolean} disabled Disable fields true or false
 *  @param {string} durationValue Default duration value in format "1y 1M 1d 1H"
 *  @param {string} value Value
 *  @param {string} label Field label
 *  @param {string} required Whether field is required or not - "true" or "false"
 *  @param {object} labelIconProps CustomLabel settings
 *    @param {string} iconName
 *    @param {string} title
 *    @param {string} callOutText
 *    @param {string} ariaLabel
 *  @param {function} onChange Handler to when date or time is changed
 *  @param {boolean} dontAllowPastDates Don't allow past dates
 *  @param {object} timePickerFieldProps
 *    @param {number} listCount
 *   @param {object} checkBoxProps
 *    @param {boolean} checked
 *    @param {boolean} disabled
 */

var DateTimePeriodPicker = function DateTimePeriodPicker(props) {
  var _props$checkBoxProps;

  var _useState = useState(60),
      _useState2 = _slicedToArray(_useState, 2),
      minutes = _useState2[0],
      setMinutes = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      startDateTime = _useState4[0],
      setStartDateTime = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      endDateTime = _useState6[0],
      setEndDateTime = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      errorStartDateTimeMessage = _useState8[0],
      setErrorStartDateTimeMessage = _useState8[1];

  var _useState9 = useState(""),
      _useState10 = _slicedToArray(_useState9, 2),
      errorEndDateTimeMessage = _useState10[0],
      setErrorEndDateTimeMessage = _useState10[1];

  var _useState11 = useState(props.checkBoxProps && props.checkBoxProps.checked ? props.checkBoxProps.checked : false),
      _useState12 = _slicedToArray(_useState11, 2),
      noEndDate = _useState12[0],
      setNoEndDate = _useState12[1];

  var _useState13 = useState(),
      _useState14 = _slicedToArray(_useState13, 2),
      options = _useState14[0],
      setOptions = _useState14[1];

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      durationValue = _useState16[0],
      setDurationValue = _useState16[1]; // Handle default values


  useEffect(function () {
    setDurationValue(props.durationValue);
    var m = 60 * 24; // Default 1 day

    if (!props.value || props.value.split(";").length !== 2 || durationValue && durationValue != props.durationValue) {
      // If no values set yet or durationValue changes, set default values
      var defaultStartDate = props.defaultStartDate ? props.defaultStartDate : new Date();
      setEndDateTime(null);
      if (props.defaultStartTime) setStartDateTime({
        date: defaultStartDate,
        time: props.defaultStartTime
      });
      if (props.durationValue) m = durationInMinutes(defaultStartDate, props.durationValue);
      if (minutes !== m) setMinutes(m);
    } else if (!startDateTime) {
      // If no startDateTime, set startDateTime from value
      var newStartDateTime = {
        date: new Date(props.value.split(";")[0]),
        time: props.value.split(";")[0].split(" ")[1]
      };
      var newEndDateTime = {
        date: new Date(props.value.split(";")[1]),
        time: props.value.split(";")[1].split(" ")[1]
      };
      setStartDateTime(newStartDateTime);
      if (minutes !== m) setMinutes(diffenceInMinutes(dateTimeFromDateTimeObj(newStartDateTime), dateTimeFromDateTimeObj(newEndDateTime)));
    }
  }, [props.durationValue, props.value]); // Handle Error messages and endDateTime object options

  useEffect(function () {
    // Check if time is valid
    setErrorStartDateTimeMessage(isValidDateObj(startDateTime) ? "" : i18n._(
    /*i18n*/
    {
      id: "Please enter valid time"
    }));
    setErrorEndDateTimeMessage(isValidDateObj(endDateTime) ? "" : i18n._(
    /*i18n*/
    {
      id: "Please enter valid time"
    }));

    if (isValidDateObj(startDateTime) && isValidDateObj(endDateTime)) {
      // Set endDateTime object options
      if (startDateTime.date && startDateTime.date.getDate() === endDateTime.date.getDate() && startDateTime.date.getMonth() === endDateTime.date.getMonth() && startDateTime.date.getYear() === endDateTime.date.getYear()) setOptions(handleOptions(startDateTime));else setOptions([]); // Handle error message if end dateTime is before start dateTime

      if (dateTimeFromDateTimeObj(endDateTime) < dateTimeFromDateTimeObj(startDateTime)) setErrorEndDateTimeMessage(i18n._(
      /*i18n*/
      {
        id: "Please change time to after start time"
      }));else props.onChange("".concat(formatDateTime(dateTimeFromDateTimeObj(startDateTime), "yyyy-MM-dd HH:mm"), ";").concat(formatDateTime(dateTimeFromDateTimeObj(endDateTime), "yyyy-MM-dd HH:mm")));
    }
  }, [startDateTime, endDateTime]); // Handle endDateTime object values when startDateTime object changes

  useEffect(function () {
    if (!props.onChange || !isValidDateObj(startDateTime)) return;
    var newEndDateTime = handleEndDateTime(startDateTime, minutes);
    if (newEndDateTime && (!endDateTime || endDateTime.date !== newEndDateTime.date || endDateTime.time !== newEndDateTime.time)) setEndDateTime(newEndDateTime);
  }, [startDateTime, minutes]);
  var minHour = useMemo(function () {
    if (!props.dontAllowPastDates || !startDateTime || !startDateTime.date || startDateTime.date.getDate() !== new Date().getDate() || startDateTime.date.getMonth() !== new Date().getMonth() || startDateTime.date.getFullYear() !== new Date().getFullYear()) return;
    var now = new Date();
    var lastHalfHour = new Date();

    if (now.getMinutes() < 30) {
      lastHalfHour.setMinutes(0);
    } else {
      lastHalfHour.setMinutes(30);
    }

    lastHalfHour.setSeconds(0);
    lastHalfHour.setMilliseconds(0);
    return "".concat(lastHalfHour.getHours().toString().padStart(2, "0"), ":00"); //eslint-disable-next-line
  }, [startDateTime]); // Handle duration minutes when endDateTime object changes

  useEffect(function () {
    var isEndDateTimeValid = isValidDateObj(endDateTime);
    var isStartDateTimeValid = isValidDateObj(startDateTime);
    if (!isEndDateTimeValid || !isStartDateTimeValid || !props.onChange) return;
    var m = diffenceInMinutes(dateTimeFromDateTimeObj(startDateTime), dateTimeFromDateTimeObj(endDateTime));

    if (m !== minutes) {
      setMinutes(m);
    } //eslint-disable-next-line

  }, [endDateTime]);
  useEffect(function () {
    if (!props.checkBoxProps) {
      setNoEndDate(false);
      return;
    }

    setNoEndDate(props.checkBoxProps.checked === undefined ? false : props.checkBoxProps.checked);
    props.checkBoxProps.onChange(props.checkBoxProps.checked === undefined ? false : props.checkBoxProps.checked);
  }, [(_props$checkBoxProps = props.checkBoxProps) === null || _props$checkBoxProps === void 0 ? void 0 : _props$checkBoxProps.checked]);
  return /*#__PURE__*/React__default.createElement(Stack, null, startDateTime ? /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: props.label,
    required: props.required ? props.required : false,
    labelIconProps: props.labelIconProps ? props.labelIconProps : {}
  }), /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 4
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    styles: {
      root: {
        flexWrap: "wrap"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        width: "180px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: i18n._(
    /*i18n*/
    {
      id: "Start time"
    })
  })), /*#__PURE__*/React__default.createElement(DateTimePickerField, {
    value: startDateTime,
    onChange: setStartDateTime,
    minHour: minHour,
    disabled: props.disabled ? props.disabled : false,
    errorMessage: errorStartDateTimeMessage ? " " : "",
    timePickerFieldProps: props.timePickerFieldProps,
    minDate: props.dontAllowPastDates ? new Date() : props.minDate || null
  })), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    styles: {
      root: {
        flexWrap: "wrap"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        width: "180px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: i18n._(
    /*i18n*/
    {
      id: "End time"
    })
  })), /*#__PURE__*/React__default.createElement(DateTimePickerField, {
    key: "ToDate",
    value: endDateTime,
    minDate: startDateTime && startDateTime.date ? startDateTime.date : new Date(),
    onChange: setEndDateTime,
    disabled: props.disabled ? props.disabled : noEndDate ? noEndDate : false,
    options: options,
    errorMessage: errorEndDateTimeMessage ? " " : "",
    timePickerFieldProps: props.timePickerFieldProps
  })), props.checkBoxProps && props.checkBoxProps.show && /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    styles: {
      root: {
        flexWrap: "wrap"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        width: "180px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: i18n._(
    /*i18n*/
    {
      id: "No end date"
    })
  })), /*#__PURE__*/React__default.createElement(Checkbox, {
    disabled: props.disabled ? props.disabled : props.checkBoxProps.disabled ? props.checkBoxProps.disabled : false,
    checked: noEndDate,
    onChange: function onChange(e, checked) {
      setNoEndDate(checked);
      props.checkBoxProps.onChange(checked);
    }
  }))), /*#__PURE__*/React__default.createElement(Text, {
    variant: "small",
    styles: {
      root: {
        color: "#a80000"
      }
    }
  }, errorStartDateTimeMessage ? errorStartDateTimeMessage : errorEndDateTimeMessage)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null));
};

/**
 * @description Duration picker field
 * @param {object} props
 *  @param {boolean} disabled Disable fields true or false
 *  @param {string} durationValue Default duration value in format "1y 1M 1d 1H"
 *  @param {string} label Field label
 *  @param {string} required Whether field is required or not - "true" or "false"
 *  @param {object} labelIconProps CustomLabel settings
 *    @param {string} iconName
 *    @param {string} title
 *    @param {string} callOutText
 *    @param {string} ariaLabel
 *  @param {function} onChange Handler to when date or time is changed
 *  @param {boolean} dontAllowPastDates Don't allow past dates
 *  @param {object} timePickerFieldProps
 *  @param {object} timePickerFieldProps
 *    @param {number} listCount
 */

var DurationPickerField = function DurationPickerField(props) {
  var formattedNearestHour = "".concat(getLastHalfHour().getHours().toString().padStart(2, "0"), ":00");

  function getLastHalfHour() {
    var now = new Date();
    var lastHalfHour = new Date();

    if (now.getMinutes() < 30) {
      lastHalfHour.setMinutes(0);
    } else {
      lastHalfHour.setMinutes(30);
    }

    lastHalfHour.setSeconds(0);
    lastHalfHour.setMilliseconds(0);
    return lastHalfHour;
  }

  return /*#__PURE__*/React__default.createElement(DateTimePeriodPicker, {
    label: props.label,
    disabled: props.disabled,
    required: props.required,
    labelIconProps: props.labelIconProps,
    checkBoxProps: props.checkBoxProps,
    minDate: props.dontAllowPastDates ? new Date() : null,
    defaultStartDate: new Date(),
    dontAllowPastDates: props.dontAllowPastDates,
    defaultStartTime: props.dontAllowPastDates ? formattedNearestHour : "08:00",
    value: props.value,
    durationValue: props.durationValue,
    onChange: props.onChange,
    timePickerFieldProps: props.timePickerFieldProps
  });
};

function listContainsPersona(persona, personas) {
  if (!personas || !personas.length || personas.length === 0) {
    return false;
  }

  return personas.filter(function (item) {
    return item.text === persona.text;
  }).length > 0;
}
/**
 * @description People picker field
 * @param {object} props
 *  @param {Array{}} items List of users to select from
 *      @param {string} id Id on user
 *      @param {string} name Name on user. Used to search/filter on
        @param {string} text Text to be displayed
        @param {string} userName Username on user. Used to search/filter on
        @param {string} [secondaryText] Secondary text to be displayed
 *  @param {Array} selectedItems Array of default selected items. Array of user id's
 *  @param {function} onChange Handler to when list of selected items changes
 *  @param {boolean} [disabled=false] Disable people picker field
 */


var PeoplePickerField = function PeoplePickerField(props) {
  var onChange = props.onChange,
      items = props.items,
      selectedItems = props.selectedItems,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  var picker = useRef(null); // Handler to filter

  var onFilterChanged = function onFilterChanged(filterText, currentPersonas, limitResults) {
    if (filterText) {
      // Filter personas by text
      var filteredPersonas = items.filter(function (item) {
        return item.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 || item.userName.toLowerCase().indexOf(filterText.toLowerCase()) === 0;
      }); // Remove doublecates

      filteredPersonas = filteredPersonas.filter(function (persona) {
        return !listContainsPersona(persona, currentPersonas);
      });
      filteredPersonas = limitResults ? filteredPersonas.slice(0, limitResults) : filteredPersonas;
      return filteredPersonas;
    } else {
      return [];
    }
  };

  return /*#__PURE__*/React__default.createElement(NormalPeoplePicker, {
    disabled: disabled,
    onResolveSuggestions: onFilterChanged,
    onChange: onChange,
    componentRef: picker,
    defaultSelectedItems: items && selectedItems && items.filter(function (item) {
      return selectedItems.some(function (selectedItem) {
        return selectedItem === item.id;
      });
    })
  });
};

/**
 * @description Regexp text field
 * @param {object} props
 *  @param {string} value Value to textfield
 *  @param {string} required Whether field is required or not - "true" or "false"
 *  @param {boolean} disabled Disable field true or false
 *  @param {string} label Label text
 *  @param {object} labelIconProps CustomLabel settings
 *    @param {string} iconName
 *    @param {string} title
 *    @param {string} callOutText
 *    @param {string} ariaLabel
 *  @param {string} placeholder Placeholder text
 *  @param {string} autoComplete
 *  @param {string} errorMessage Error message
 *  @param {object} styles
 *  @param {function} onBlur OnBlur handler
 *  @param {function} onChange OnChange Hanlder
 *  @param {object} multiLineProps Multiline settings
 *   @param {number} rows
 *   @param {boolean} resizable Resizable true or false
 *   @param {boolean} multiline
 */

var RegexpTextField = function RegexpTextField(props) {
  if (!props) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement("div", {
    style: {}
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: {
      root: {
        flexWrap: "wrap"
      }
    }
  }, props.label && /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        width: "180px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: props.label,
    required: props.required ? props.required : false,
    labelIconProps: props.labelIconProps ? props.labelIconProps : {}
  })), /*#__PURE__*/React__default.createElement(Stack, {
    grow: true
  }, /*#__PURE__*/React__default.createElement(TextField, _extends({
    value: props.value,
    disabled: props.disabled ? props.disabled : false,
    placeholder: props.placeholder ? props.placeholder : "",
    onChange: function onChange(e, v) {
      if (props.onChange) props.onChange(e, v);else return;
    },
    onBlur: props.onBlur ? props.onBlur : function () {
      return;
    },
    autoComplete: props.autoComplete ? props.autoComplete : "off",
    errorMessage: props.errorMessage ? props.errorMessage : "",
    styles: props.styles ? props.styles : {}
  }, props.multiLineProps))))));
};

function ComboBoxPickerField(props) {
  var placeholder = props.placeholder,
      options = props.options,
      errorMessage = props.errorMessage,
      onChange = props.onChange,
      onBlur = props.onBlur;

  var _useState = useState(props.value || ""),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showDropdown = _useState4[0],
      setShowDropdown = _useState4[1];

  var _useState5 = useState(options),
      _useState6 = _slicedToArray(_useState5, 2),
      filteredOptions = _useState6[0],
      setFilteredOptions = _useState6[1];

  var _useState7 = useState(undefined),
      _useState8 = _slicedToArray(_useState7, 2),
      hoveredOptionIndex = _useState8[0],
      setHoveredOptionIndex = _useState8[1];

  useEffect(function () {
    setFilteredOptions(options);
  }, [options]);
  useEffect(function () {
    setFilteredOptions(filteredOptions.filter(function (option) {
      return option.text.toLowerCase().includes(value.toLowerCase());
    }));
  }, [value]);
  useEffect(function () {
    setHoveredOptionIndex(undefined);
  }, [showDropdown, options, filteredOptions]);

  var handleDropdownChange = function handleDropdownChange(e, option) {
    setValue(option.text);

    if (onChange) {
      onChange(e, {
        key: option.key,
        text: option.text
      });
    }

    setShowDropdown(false);
  };

  var handleTextChange = function handleTextChange(e, value) {
    setValue(value);
    setFilteredOptions(options.filter(function (option) {
      return option.text.toLowerCase().includes(value.toLowerCase());
    }));

    if (onChange) {
      onChange(e, {
        key: value,
        text: value
      });
    }

    if (value === "") {
      setFilteredOptions(options);
      setHoveredOptionIndex(undefined);
      setShowDropdown(true);
    }
  };

  var handleBlur = function handleBlur(e, value) {
    setFilteredOptions(options);
    setValue(value);
    setShowDropdown(false);

    if (onBlur) {
      onBlur(e, {
        key: value,
        text: value
      });
    }
  };

  var handleOnClick = function handleOnClick() {
    setShowDropdown(true);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (!showDropdown) {
      if (e.key === "Enter" || e.key === "ArrowDown") {
        setShowDropdown(true);
      }

      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setHoveredOptionIndex(function (current) {
          if (current === undefined || current >= filteredOptions.length - 1) {
            return 0;
          }

          return current + 1;
        });
        break;

      case "ArrowUp":
        e.preventDefault();
        setHoveredOptionIndex(function (current) {
          if (current === undefined || current <= 0) {
            return filteredOptions.length - 1;
          }

          return current - 1;
        });
        break;

      case "Enter":
        e.preventDefault();

        if (hoveredOptionIndex !== undefined && filteredOptions[hoveredOptionIndex]) {
          handleDropdownChange(e, filteredOptions[hoveredOptionIndex]);
          setValue(filteredOptions[hoveredOptionIndex].text);

          if (onChange) {
            onChange(e, {
              key: filteredOptions[hoveredOptionIndex].key,
              text: filteredOptions[hoveredOptionIndex].text
            });
          }

          setShowDropdown(false);
        }

        break;

      case "Escape":
        setShowDropdown(false);
        break;
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative",
      display: "inline-block",
      width: "100%",
      zIndex: 1
    }
  }, /*#__PURE__*/React__default.createElement(TextField, {
    placeholder: placeholder || i18n._(
    /*i18n*/
    {
      id: "Select an option"
    }),
    value: value,
    onChange: handleTextChange,
    onClick: handleOnClick,
    onBlur: function onBlur(e) {
      return handleBlur(e, value);
    },
    onKeyDown: handleKeyDown,
    errorMessage: errorMessage,
    iconProps: {
      iconName: "ChevronDown"
    },
    autoComplete: "off"
  }), showDropdown && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      backgroundColor: "white",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
      border: "1px solid #e0e0e0",
      borderRadius: "2px",
      maxHeight: "300px",
      overflowY: "auto",
      width: "100%",
      zIndex: 99999999,
      top: "100%",
      marginTop: "2px",
      left: 0
    }
  }, (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) > 0 && filteredOptions.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: option.key,
      onMouseEnter: function onMouseEnter() {
        return setHoveredOptionIndex(index);
      },
      onMouseLeave: function onMouseLeave() {
        return setHoveredOptionIndex(undefined);
      },
      onMouseDown: function onMouseDown(e) {
        handleDropdownChange(e, option);
        setShowDropdown(false);
      },
      style: {
        backgroundColor: index === hoveredOptionIndex ? "#f3f2f1" : "transparent",
        cursor: "pointer",
        padding: "8px 12px",
        display: "block"
      },
      className: "combo-box-option"
    }, option.text);
  })), /*#__PURE__*/React__default.createElement("style", null, "\n          .combo-box-option:hover {\n            background-color: #f3f2f1;\n          }\n        "));
}

/**
 * @description User id picker field
 * @param {object} props
 *  @param {string} value User id value
 *  @param {string} defaultSelectedKey
 *  @param {string} required Whether field is required or not - "true" or "false"
 *  @param {boolean} disabled Disable field true or false
 *  @param {string} label Label text
 *  @param {boolean} canEnterUsername Allow manual username entry
 *  @param {object} labelIconProps CustomLabel settings
 *    @param {string} iconName
 *    @param {string} title
 *    @param {string} callOutText
 *    @param {string} ariaLabel
 *  @param {string} tenant Tenant
 *  @param {boolean} isFetching Is fetching next username true/false
 *  @param {object} iconProps Next username icon props
 *  @param {function} onClick Next username handler
 *  @param {boolean} iconButtonDisabled disable next username suggestions true/false
 *  @param {string} placeholder Placeholder text
 *  @param {string} errorMessage Error message
 *  @param {object} styles
 *  @param {function} onChange OnChange Hanlder
 */

var UserIdPickerField = function UserIdPickerField(props) {
  var _useState = useState(props.options),
      _useState2 = _slicedToArray(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  useEffect(function () {
    if (!props) return;
    setOptions((props === null || props === void 0 ? void 0 : props.options) || []);
  }, [props.options]);

  var handleDropdownChange = function handleDropdownChange(e, option) {
    if (props.onChange) {
      props.onChange(e, option);
    }
  };

  if (!props) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement("div", {
    style: {}
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: {
      root: {
        flexWrap: "wrap"
      }
    }
  }, props.label && /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        width: "180px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: props.label,
    required: props.required ? props.required : false,
    labelIconProps: props.labelIconProps ? props.labelIconProps : {}
  })), props.disabled || props.options.length === 1 ? /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    grow: true
  }, /*#__PURE__*/React__default.createElement(Stack, {
    grow: true
  }, /*#__PURE__*/React__default.createElement(TextField, {
    value: props.value,
    disabled: true,
    placeholder: props.placeholder ? props.placeholder : "",
    onChange: function onChange() {},
    autoComplete: props.autoComplete ? props.autoComplete : "off",
    styles: props.styles ? props.styles : {}
  })), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        paddingTop: "5px",
        paddingLeft: "5px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TooltipHost, {
    content: props.tenant,
    DirectionalHint: DirectionalHint.topCenter
  }, "@".concat(props.tenant.length > 25 ? "".concat(props.tenant.substring(0, 22), "...") : props.tenant)))) : /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    grow: true
  }, (props === null || props === void 0 ? void 0 : props.canEnterUsername) === true ? /*#__PURE__*/React__default.createElement(Stack, {
    grow: true
  }, /*#__PURE__*/React__default.createElement(ComboBoxPickerField, {
    placeholder: props.placeholder ? props.placeholder : "",
    options: options,
    errorMessage: props.errorMessage ? props.errorMessage : "",
    onChange: handleDropdownChange,
    onBlur: handleDropdownChange
  })) : /*#__PURE__*/React__default.createElement(Dropdown, {
    disabled: props.disabled || options.length === 0,
    placeholder: props.placeholder ? props.placeholder : "",
    defaultSelectedKey: props.defaultSelectedKey ? props.defaultSelectedKey : {},
    onChange: handleDropdownChange,
    options: options,
    styles: props.styles ? props.styles : {},
    errorMessage: props.errorMessage ? props.errorMessage : ""
  }), " ", /*#__PURE__*/React__default.createElement(Text, {
    styles: {
      root: {
        paddingTop: "5px",
        paddingLeft: "5px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TooltipHost, {
    content: props.tenant,
    directionalHint: DirectionalHint.topCenter
  }, "@".concat(props.tenant.length > 25 ? "".concat(props.tenant.substring(0, 22), "...") : props.tenant))), props.isFetching ? /*#__PURE__*/React__default.createElement(Spinner, {
    styles: {
      root: {
        paddingLeft: 6,
        paddingRight: 6
      }
    }
  }) : /*#__PURE__*/React__default.createElement(TooltipHost, {
    calloutProps: {
      beakWidth: 8
    },
    directionalHint: DirectionalHint.topLeftEdge,
    content: i18n._(
    /*i18n*/
    {
      id: "Get next username suggestions"
    })
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    iconProps: props.iconProps ? props.iconProps : {},
    onClick: props.onClick ? props.onClick : function () {
      return;
    },
    disabled: props.disabled ? props.disabled : props.iconButtonDisabled ? props.iconButtonDisabled : options.length === 1 ? true : false
  }))))));
};

var useFocus = function useFocus() {
  var htmlElRef = useRef(null);

  var setFocus = function setFocus() {
    htmlElRef.current && htmlElRef.current.focus();
  };

  return [htmlElRef, setFocus];
};
/**
 * @description Organisational unit picker field
 * @param {object} props
 *  @param {string} required Whether field is required or not - "true" or "false"
 *  @param {boolean} disabled Disable field true or false
 *  @param {string} label Label text
 *  @param {object} labelIconProps CustomLabel settings
 *    @param {text} value Static value
 *    @param {string} iconName
 *    @param {string} title
 *    @param {string} callOutText
 *    @param {string} ariaLabel
 *  @param {string} placeholder Placeholder text
 *  @param {object} styles
 *  @param {function} onChange OnChange Handler
 */


var OusPickerField = function OusPickerField(props) {
  var options = props.options,
      onChange = props.onChange,
      value = props.value,
      setValue = props.setValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$horizontal = props.horizontal,
      horizontal = _props$horizontal === void 0 ? false : _props$horizontal,
      setProfileSync = props.setProfileSync;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      orgItems = _useState6[0],
      setOrgItems = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      canSelectUnits = _useState8[0],
      setCanSelectUnits = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      defaultedCollapsed = _useState10[0],
      setDefaultedCollapsed = _useState10[1];

  var _useState11 = useState([{
    key: 1,
    text: i18n._(
    /*i18n*/
    {
      id: "Select an option"
    })
  }]),
      _useState12 = _slicedToArray(_useState11, 2),
      dropdownOptions = _useState12[0],
      setDropdownOptions = _useState12[1];

  var _useFocus = useFocus(),
      _useFocus2 = _slicedToArray(_useFocus, 2),
      searchRef = _useFocus2[0],
      setSearchRef = _useFocus2[1];

  var _useTreeSearch = useTreeSearch(options, ["name", "id"]),
      searchValue = _useTreeSearch.searchValue,
      setSearchValue = _useTreeSearch.setSearchValue,
      filteredOptions = _useTreeSearch.filteredOptions,
      noResults = _useTreeSearch.noResults;

  useEffect(function () {
    if (setProfileSync) setProfileSync(!open);
    if (open) setTimeout(function () {
      setSearchRef();
    }, 100); //eslint-disable-next-line
  }, [open]);
  useEffect(function () {
    if (options) {
      // Find readOnly items
      var ous = OrgHelper.applyCheckboxOptions(filteredOptions || options); // List should be collaped if more than 30 items is shown in the list

      setDefaultedCollapsed(new Organisation(ous).getItems().filter(function (o) {
        return o.isHidden === false;
      }).length > 30);
      setOrgItems([ous]);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [options, filteredOptions]);
  useEffect(function () {
    // Guard on options too: value can arrive before the org tree has loaded,
    // and new Organisation(undefined) throws. Re-run once options arrive so the
    // current unit is still pre-selected.
    if (!value || !options) return;
    var org = new Organisation(options).getItems().filter(function (ou) {
      return ou.id === value;
    })[0];
    setSelected(org);
  }, [value, options]);
  useEffect(function () {
    if (orgItems.length && !selected) {
      // Auto select item if only one to select
      var itemsToSelect = new Organisation(orgItems[0]).getItems().filter(function (items) {
        return items.readOnly === false;
      });
      if (itemsToSelect.length === 1) setSelected(itemsToSelect[0]);
      if (!open) setCanSelectUnits(itemsToSelect.length > 1);
    }
  }, [orgItems]);
  useEffect(function () {
    // Handle item selected
    if (selected && setValue) setValue(selected);

    if (selected) {
      onChange(0, selected);
      setDropdownOptions([{
        key: selected.id,
        text: selected.name
      }]);
    } //eslint-disable-next-line

  }, [selected]);

  var handleSelectedItem = function handleSelectedItem(item, id) {
    if (item.id === id) {
      setSelected(item);
      return item;
    }

    if (item.children && item.children.length) {
      item.children.forEach(function (child) {
        handleSelectedItem(child, id);
      });
    }

    return item;
  };

  function onSelectedChange(e) {
    var id = e.target && e.target.id ? e.target.id : e;
    setOrgItems([handleSelectedItem(orgItems[0], id)]);
    setOpen(false);
  } //TODO make this work with keyboard


  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement("div", {
    style: {}
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: horizontal ? {
      root: {
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
      }
    } : {
      root: {
        flexWrap: "wrap"
      }
    }
  }, props.label && /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        width: horizontal ? "100%" : "180px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: props.label,
    required: props.required ? props.required : false,
    labelIconProps: props.labelIconProps ? props.labelIconProps : {}
  })), /*#__PURE__*/React__default.createElement(Stack, {
    grow: true
  }, /*#__PURE__*/React__default.createElement(Dropdown, {
    defaultSelectedKey: dropdownOptions[0].key,
    onClick: function onClick() {
      return setOpen(disabled || !canSelectUnits ? false : open ? false : true);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === "ArrowDown" || e.key === " ") {
        setOpen(disabled || !canSelectUnits ? false : open ? false : true);
      }
    },
    options: dropdownOptions,
    disabled: disabled ? disabled : !canSelectUnits,
    autoComplete: props.autoComplete ? props.autoComplete : "off",
    errorMessage: props.errorMessage ? props.errorMessage : ""
  })), /*#__PURE__*/React__default.createElement(Panel$1, {
    isOpen: open,
    isLightDismiss: true,
    type: PanelType$1.medium,
    headerText: i18n._(
    /*i18n*/
    {
      id: "Select organisational unit"
    }),
    closeButtonAriaLabel: i18n._(
    /*i18n*/
    {
      id: "Close"
    }),
    onDismiss: function onDismiss() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React__default.createElement(SearchBox, {
    ref: searchRef,
    placeholder: i18n._(
    /*i18n*/
    {
      id: "Search by name or id"
    }),
    value: searchValue,
    onChange: function onChange(e) {
      var _e$target, _e$target$value;

      setSearchValue((e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$value = _e$target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.trim()) || "");
    },
    styles: {
      root: {
        marginTop: "10px"
      }
    }
  }), /*#__PURE__*/React__default.createElement(Separator, {
    styles: {
      root: {
        margin: "10px 0px"
      }
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "calc(100vh - 200px)",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React__default.createElement(TreeList, {
    items: orgItems,
    ouLimit: true,
    onChange: onSelectedChange,
    listItemProps: {
      orgName: "administrative",
      iconProps: {
        iconName: "Org",
        color: DefaultPalette$2.green,
        colorLighter: DefaultPalette$2.greenLight,
        inverted: false
      },
      primaryTextKey: "name"
    },
    defaultedCollapsed: defaultedCollapsed,
    noResults: noResults
  }))))));
};

// Compiled RegExp cache keyed by pattern. Field validation calls validateRegex
// for every field on every keystroke (and again in the stores), so compiling a
// fresh RegExp each call was pure waste. Compilation semantics are unchanged:
// an invalid pattern still throws exactly as before (we cache only successes).
var regexCache = new Map(); // Validates a string against a regular expression.

var validateRegex = function validateRegex(text, regex) {
  var _regex = regexCache.get(regex);

  if (_regex === undefined) {
    _regex = RegExp(regex);
    regexCache.set(regex, _regex);
  }

  if (_regex === null) return false; // Replaces any regex match with an empty string. If there are any characters
  // left, the text is invalid.

  return text.replace(_regex, "") === "";
};

function parseToBoolean(value) {
  return value === "true" ? true : value === "false" ? false : value;
}

/**
 * @description Organisational unit picker field
 * @param {object} props
 *  @param {string} required Whether field is required or not - "true" or "false"
 *  @param {boolean} disabled Disable field true or false
 *  @param {string} label Label text
 *  @param {text} value Selected value
 *  @param {Array} defaultValues Selection options
 *  @param {object} labelIconProps CustomLabel settings *
 *    @param {string} iconName
 *    @param {string} title
 *    @param {string} callOutText
 *    @param {string} ariaLabel
 *  @param {string} placeholder Placeholder text
 *  @param {object} styles
 *  @param {function} onChange OnChange Handler
 *  @param {text} errorMessage
 */
var SelectPickerField = function SelectPickerField(props) {
  var value = props.value,
      defaultValues = props.defaultValues,
      _onChange = props.onChange,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      label = props.label,
      required = props.required,
      labelIconProps = props.labelIconProps,
      errorMessage = props.errorMessage;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  useEffect(function () {
    if (defaultValues) {
      var valueList = defaultValues.split(";");

      if (valueList.length) {
        var optionList = valueList.map(function (v) {
          return {
            key: v,
            text: v
          };
        });
        setOptions(optionList);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [defaultValues]);
  return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement("div", {
    style: {}
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: {
      root: {
        flexWrap: "wrap"
      }
    }
  }, label && /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        width: "180px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: label,
    required: required ? required : false,
    labelIconProps: labelIconProps ? labelIconProps : {}
  })), /*#__PURE__*/React__default.createElement(Stack, {
    grow: true
  }, /*#__PURE__*/React__default.createElement(Dropdown, {
    options: options,
    defaultSelectedKey: value,
    onChange: function onChange(e, v) {
      return _onChange(v.key);
    },
    disabled: disabled,
    autoComplete: "off",
    errorMessage: errorMessage ? errorMessage : ""
  })))));
};

/**
 * @param {Object} props
 *  @param {Object} options Options for the searchField
 *  @param {string} required Whether field is required or not - "true" or "false"
 *  @param {boolean} disabled Disable field true or false
 *  @param {string} label Label text
 *  @param {object} labelIconProps CustomLabel settings *
 *    @param {string} iconName
 *    @param {string} title
 *    @param {string} callOutText
 *    @param {string} ariaLabel
 *  @param {boolean} isFetchingManagers Whether the managers are being fetched
 *  @param {Array} defaultValues Selection options
 *  @param {string} placeholder Placeholder text
 *  @param {function} onChange OnChange Handler
 *  @param {text} errorMessage
 */
// Defined at module level so the reference is stable across renders. useFuse
// memoises its web worker on the searchKeys reference; a new array each render
// would respawn (and leak) a worker on every render.

var SEARCH_KEYS = ["name", "orgUnitName", "id", "userName"];
function ManagerPicker(props) {
  var searchProps = {
    searchKeys: SEARCH_KEYS,
    searchHint: i18n._(
    /*i18n*/
    {
      id: "Search for department, name or username"
    }),
    listType: "personaList"
  };
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: {
      root: {
        flexWrap: "wrap"
      }
    }
  }, props.label && /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        width: "180px"
      }
    },
    horizontal: true
  }, /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: props.label,
    required: props.required ? props.required : false,
    labelIconProps: props.labelIconProps ? props.labelIconProps : {}
  }), props.isFetchingManagers && /*#__PURE__*/React__default.createElement(Spinner, null)), props.isFetchingManagers ? /*#__PURE__*/React__default.createElement(Stack, {
    grow: true
  }, /*#__PURE__*/React__default.createElement(TextField, {
    value: i18n._(
    /*i18n*/
    {
      id: "Loading Managers..."
    }),
    onChange: function onChange() {
      return;
    },
    disabled: true
  })) : /*#__PURE__*/React__default.createElement(Stack, {
    grow: true
  }, /*#__PURE__*/React__default.createElement(SearchField$1, {
    items: props.options,
    selectedItem: props.value,
    isFetchingItems: props.isFetchingManagers,
    placeholder: props.placeholder,
    searchProps: searchProps,
    handleSelection: function handleSelection(e) {
      if (!e) return;

      if (props.onChange) {
        props.onChange(e.positionId ? e.positionId : "");
      } else return;
    },
    disabled: props.disabled,
    ariaLabel: props.label
  })), props.errorMessage && /*#__PURE__*/React__default.createElement(Text, {
    variant: "small",
    styles: {
      root: {
        color: "#A4262C"
      }
    }
  }, props.errorMessage));
}

var USERNAME_VALIDATION_DEBOUNCE_MS = 300; // Should only generate usernames if there is a USER_USERID field and it is not readonly

function shouldGenerateUsernames(template) {
  if (!template || !template.fields) return false;
  var field = template.fields.filter(function (f) {
    return f.identifier === "USER_USERID";
  });
  return field.length === 1 && !field[0].readonly;
} // Normalises a value for equality comparison. Several field components emit
// onChange from their own effects/mount/focus; comparing the normalised value
// lets handleChange ignore an emit that does not actually change anything.


function normalizeForCompare(v) {
  if (v instanceof Date) return v.getTime();
  return v;
} // A single rendered field. Memoised so that typing in one field does not
// re-render every other field row. All shared inputs handed in are either
// primitives or referentially stable (handleChange is a stable useCallback,
// the option/manager/period props are memoised), so an unrelated keystroke
// leaves this row's props unchanged and React skips re-rendering it.


var FieldRow = /*#__PURE__*/React__default.memo(function FieldRow(_ref) {
  var field = _ref.field,
      value = _ref.value,
      errorMessage = _ref.errorMessage,
      disabled = _ref.disabled,
      handleChange = _ref.handleChange,
      canEnterUsername = _ref.canEnterUsername,
      username = _ref.username,
      usernameOptions = _ref.usernameOptions,
      isFetchingUsernames = _ref.isFetchingUsernames,
      usernamePageNo = _ref.usernamePageNo,
      usernameFrom = _ref.usernameFrom,
      generateUsernames = _ref.generateUsernames,
      templateType = _ref.templateType,
      userIdPickerFieldProps = _ref.userIdPickerFieldProps,
      tenant = _ref.tenant,
      orgUnitOptions = _ref.orgUnitOptions,
      setProfileSync = _ref.setProfileSync,
      sortedManagers = _ref.sortedManagers,
      selectedManager = _ref.selectedManager,
      isFetchingManagers = _ref.isFetchingManagers,
      checkBoxProps = _ref.checkBoxProps,
      periodValue = _ref.periodValue,
      timePickerFieldProps = _ref.timePickerFieldProps;
  if (field.hidden) return null;
  var labelIconProps = field.descriptionLong ? {
    iconName: "Info",
    title: field.description,
    callOutText: field.descriptionLong
  } : {};
  var disableFields = disabled || field.readonly;

  switch (field.uiType) {
    case "REGEXPTEXTFIELD":
      return /*#__PURE__*/React__default.createElement(RegexpTextField, {
        label: field.fieldName,
        required: field.required,
        labelIconProps: labelIconProps,
        value: value,
        disabled: disableFields,
        placeholder: field.description,
        onBlur: function onBlur(event) {
          return handleChange(field.identifier, event.target.value);
        },
        onChange: function onChange(event) {
          return handleChange(field.identifier, event.target.value);
        },
        autoComplete: "new-password" //"new-password" hack, because "off" is not working
        ,
        errorMessage: errorMessage,
        styles: {
          root: {
            minWidth: "300px",
            width: "100%"
          }
        }
      });

    case "USERIDPICKERFIELD":
      return /*#__PURE__*/React__default.createElement(UserIdPickerField, {
        label: field.fieldName,
        required: field.required,
        labelIconProps: labelIconProps,
        value: disabled ? "" : value,
        canEnterUsername: canEnterUsername,
        placeholder: field.description,
        disabled: disableFields,
        defaultSelectedKey: username,
        onChange: function onChange(e, item) {
          return handleChange(field.identifier, item.key);
        },
        errorMessage: errorMessage,
        options: usernameOptions,
        styles: {
          root: {
            width: "100%",
            minWidth: "145px"
          }
        },
        tenant: tenant,
        isFetching: isFetchingUsernames,
        iconProps: {
          iconName: "Refresh"
        },
        iconButtonDisabled: disabled || field.readonly || !userIdPickerFieldProps || !userIdPickerFieldProps.name,
        onClick: function onClick() {
          return generateUsernames(userIdPickerFieldProps ? userIdPickerFieldProps.name : "", templateType, usernamePageNo, usernameFrom);
        }
      });

    case "OUSPICKERFIELD":
      return /*#__PURE__*/React__default.createElement(OusPickerField, {
        label: field.fieldName,
        required: field.required,
        labelIconProps: labelIconProps,
        placeholder: field.description,
        disabled: disableFields,
        onChange: function onChange(e, item) {
          return handleChange(field.identifier, item.id);
        },
        options: orgUnitOptions,
        value: value,
        styles: {
          root: {
            width: "100%"
          }
        },
        setProfileSync: setProfileSync
      });

    case "DATEPICKERFIELD":
      return /*#__PURE__*/React__default.createElement(DatePickerField, {
        label: field.fieldName,
        required: field.required,
        labelIconProps: labelIconProps,
        value: value,
        onSelectDate: function onSelectDate(date) {
          return handleChange(field.identifier, date);
        }
      });

    case "TIMEPICKERFIELD":
      return /*#__PURE__*/React__default.createElement(TimePickerField, {
        label: field.fieldName,
        required: field.required,
        labelIconProps: labelIconProps,
        value: value,
        onSelectDate: function onSelectDate(date) {
          return handleChange(field.identifier, date);
        },
        listCount: 5
      });

    case "DATETIMEPICKERFIELD":
      return /*#__PURE__*/React__default.createElement(DateTimePickerField, {
        label: field.fieldName,
        required: field.required,
        labelIconProps: labelIconProps,
        value: value,
        onSelectDate: function onSelectDate(date) {
          return handleChange(field.identifier, date);
        },
        timePickerFieldProps: timePickerFieldProps
      });

    case "PERIODPICKERFIELD":
      return /*#__PURE__*/React__default.createElement(DateTimePeriodPicker, {
        label: field.fieldName,
        disabled: disableFields,
        required: field.required,
        labelIconProps: labelIconProps,
        checkBoxProps: checkBoxProps,
        value: periodValue,
        onChange: function onChange(value) {
          return handleChange(field.identifier, value);
        },
        timePickerFieldProps: timePickerFieldProps
      });

    case "DURATIONPICKERFIELD":
      return /*#__PURE__*/React__default.createElement(DurationPickerField, {
        label: field.fieldName,
        disabled: disableFields,
        required: field.required,
        labelIconProps: labelIconProps,
        checkBoxProps: checkBoxProps,
        value: value,
        durationValue: field.defaultValue,
        onChange: function onChange(value) {
          return handleChange(field.identifier, value);
        },
        timePickerFieldProps: timePickerFieldProps
      });

    case "SELECTIONFIELD":
      return /*#__PURE__*/React__default.createElement(SelectPickerField, {
        label: field.fieldName,
        required: field.required,
        labelIconProps: labelIconProps,
        value: value,
        placeholder: field.description,
        disabled: disableFields,
        onChange: function onChange(value) {
          return handleChange(field.identifier, value);
        },
        defaultValues: field.defaultValue,
        styles: {
          root: {
            width: "100%"
          }
        },
        errorMessage: errorMessage
      });

    case "REGEXPTEXTBOXFIELD":
      return /*#__PURE__*/React__default.createElement(RegexpTextField, {
        label: field.fieldName,
        required: field.required,
        labelIconProps: labelIconProps,
        value: value,
        disabled: disableFields,
        placeholder: field.description,
        onBlur: function onBlur(event) {
          return handleChange(field.identifier, event.target.value);
        },
        onChange: function onChange(event) {
          return handleChange(field.identifier, event.target.value);
        },
        autoComplete: "new-password" //"new-password" hack, because "off" is not working
        ,
        errorMessage: errorMessage,
        styles: {
          root: {
            minWidth: "300px",
            width: "100%"
          }
        },
        multiLineProps: {
          multiline: true,
          resizable: false
        }
      });

    case "MANAGERPICKERFIELD":
      return /*#__PURE__*/React__default.createElement(ManagerPicker, {
        options: sortedManagers,
        required: field.required,
        disabled: disableFields,
        value: selectedManager,
        label: field.fieldName,
        labelIconProps: labelIconProps,
        isFetchingManagers: isFetchingManagers,
        defaultValues: field.defaultValue,
        placeholder: field.description,
        onChange: function onChange(value) {
          return handleChange(field.identifier, value);
        },
        errorMessage: errorMessage
      });

    default:
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  }
});
var ItemEditor = function ItemEditor(props) {
  var store = props.store,
      template = props.template,
      _props$templateType = props.templateType,
      templateType = _props$templateType === void 0 ? "" : _props$templateType,
      header = props.header,
      styles = props.styles,
      disabled = props.disabled,
      values = props.values,
      setValues = props.setValues,
      _props$userIdPickerFi = props.userIdPickerFieldProps,
      userIdPickerFieldProps = _props$userIdPickerFi === void 0 ? {} : _props$userIdPickerFi,
      _props$timePickerFiel = props.timePickerFieldProps,
      timePickerFieldProps = _props$timePickerFiel === void 0 ? {} : _props$timePickerFiel,
      _props$noAccess = props.noAccess,
      noAccess = _props$noAccess === void 0 ? false : _props$noAccess;
  var state = store.state,
      generateUsernames = store.generateUsernames,
      validateUsername = store.validateUsername,
      setProfileSync = store.setProfileSync,
      getManagers = store.getManagers;
  var loggedInUser = state.loggedInUser,
      isFetchingUsernames = state.isFetchingUsernames,
      usernames = state.usernames,
      organisations = state.organisations,
      organisationsForParent = state.organisationsForParent,
      isFetchingManagers = state.isFetchingManagers,
      managers = state.managers,
      _state$canEnterUserna = state.canEnterUsername,
      canEnterUsername = _state$canEnterUserna === void 0 ? false : _state$canEnterUserna;
  var tenant = loggedInUser.tenant;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      usernameOptions = _useState2[0],
      setUsernameOptions = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      username = _useState4[0],
      setUsername = _useState4[1];

  var _useState5 = useState(1),
      _useState6 = _slicedToArray(_useState5, 2),
      usernamePageNo = _useState6[0],
      setUsernamePageNo = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      usernameFrom = _useState8[0],
      setUsernameFrom = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      orgUnitOptions = _useState10[0],
      setOrgUnitOptions = _useState10[1]; // Async username availability check result for the USER_USERID field.


  var _useState11 = useState(""),
      _useState12 = _slicedToArray(_useState11, 2),
      usernameError = _useState12[0],
      setUsernameError = _useState12[1]; // `values` is the single source of truth (owned by the parent). Refs keep the
  // latest values/field descriptors available to the stable handleChange
  // without making it depend on — and be recreated by — every keystroke.


  var valuesRef = useRef(values);
  valuesRef.current = values; // Field identifiers the user has interacted with. Validation error messages
  // are only shown for touched fields, matching the previous behaviour where a
  // field's error was populated on its own change/blur, not up front.

  var touchedRef = useRef(new Set()); // Field descriptors derived from the template (sorted by order). This is
  // render metadata only — no field values are stored here.

  var fieldDescriptors = useMemo(function () {
    if (!template || !template.fields) return [];
    return _toConsumableArray(template.fields).sort(function (a, b) {
      return a.order - b.order;
    });
  }, [template]);
  var fieldsRef = useRef(fieldDescriptors);
  fieldsRef.current = fieldDescriptors; // Validation messages by identifier, from the template.

  var errorMessages = useMemo(function () {
    if (!template || !template.fields) return {};
    return template.fields.reduce(function (m, e) {
      return Object.assign(m, _defineProperty({}, e.identifier, e.fieldValidation));
    }, {});
  }, [template]); // Reset per-template interaction state when the template changes.

  useEffect(function () {
    touchedRef.current = new Set();
    setUsernameError("");
    if (getManagers) getManagers();
  }, [template]); // Commit a field change. Stable identity (empty dep list bar setValues) so
  // memoised rows keep their handler reference across renders. Emits the full
  // template-field object (unset fields default to "") exactly as before, and
  // derives POSITION_EMPLOYMENT_START/END when the employment period changes.
  // Idempotent: an incoming value equal to the current one is ignored, which
  // absorbs the redundant onChange emits some field components fire.

  var handleChange = useCallback(function (identifier, value) {
    var current = valuesRef.current || {};

    if (normalizeForCompare(current[identifier]) === normalizeForCompare(value)) {
      return;
    }

    if (!touchedRef.current.has(identifier)) {
      var next = new Set(touchedRef.current);
      next.add(identifier);
      touchedRef.current = next;
    }

    setValues(function (prev) {
      var base = prev || {};
      var nextValues = {};
      fieldsRef.current.forEach(function (f) {
        nextValues[f.identifier] = f.identifier === identifier ? value : base[f.identifier] !== undefined ? base[f.identifier] : "";
      });

      if (identifier === "POSITION_EMPLOYMENTPERIOD") {
        var dates = value && value !== "" ? value.toString().split(";") : undefined;

        if (dates && dates[0]) {
          nextValues["POSITION_EMPLOYMENT_START"] = dates[0];
        }

        if (dates && dates[1]) {
          nextValues["POSITION_EMPLOYMENT_END"] = dates[1];
        }
      }

      return nextValues;
    });
  }, [setValues]); // Set usernames options and default username from usernames list

  useEffect(function () {
    if (!userIdPickerFieldProps.name && usernameOptions.length > 0) {
      store.setState({
        usernames: []
      });
      setUsernameOptions([]);
      return;
    }

    if (!usernames || !usernames.length) return; // Set next page ready

    setUsernamePageNo(usernamePageNo + 1);
    setUsernameFrom(usernames[usernames.length - 1]);
    setUsername(usernames[0]);
    var hasUserId = fieldsRef.current.some(function (f) {
      return f.identifier === "USER_USERID";
    });
    if (hasUserId && !canEnterUsername) handleChange("USER_USERID", usernames[0]); // Create username options

    var options = usernames.map(function (username) {
      return {
        key: username,
        text: username
      };
    });
    setUsernameOptions(options); // eslint-disable-next-line
  }, [usernames, userIdPickerFieldProps.name]); // Set organisational units options from organisations list

  useEffect(function () {
    if (!organisations) return;
    setOrgUnitOptions(organisations);
  }, [organisations]);
  useEffect(function () {
    if (!organisationsForParent) return;
    setOrgUnitOptions(organisationsForParent);
  }, [organisationsForParent]); // Generate username from name

  useEffect(function () {
    if (!templateType || !shouldGenerateUsernames(template) || !userIdPickerFieldProps.name) return;
    generateUsernames(userIdPickerFieldProps.name, templateType);
  }, [template, templateType, userIdPickerFieldProps.name]); // Async username availability check for USER_USERID, debounced so it does not
  // fire on every keystroke. Only runs when the value passes the synchronous
  // checks, mirroring the previous validateFieldValues ordering.

  var userIdValue = values ? values["USER_USERID"] : undefined;
  useEffect(function () {
    var field = fieldsRef.current.find(function (f) {
      return f.identifier === "USER_USERID";
    });

    if (disabled || !field || !userIdValue) {
      setUsernameError("");
      return;
    }

    if (field.required && !userIdValue || userIdValue && !validateRegex(userIdValue.toString(), field.regex)) {
      // Synchronous validation handles the message in this case.
      setUsernameError("");
      return;
    }

    var active = true;
    var handle = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var valid;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return validateUsername(userIdValue);

            case 2:
              valid = _context.sent;

              if (active) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              setUsernameError(valid ? "" : i18n._(
              /*i18n*/
              {
                id: "The username entered is either in use or not allowed."
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), USERNAME_VALIDATION_DEBOUNCE_MS);
    return function () {
      active = false;
      clearTimeout(handle);
    }; // eslint-disable-next-line
  }, [userIdValue, disabled]);
  var endInfinityValue = values ? values["POSITION_EMPLOYMENT_ENDINFINITY"] : undefined;
  var checkBoxProps = useMemo(function () {
    var e = fieldDescriptors.find(function (f) {
      return (f === null || f === void 0 ? void 0 : f.identifier) === "POSITION_EMPLOYMENT_ENDINFINITY";
    });
    if (!e) return;
    var value = endInfinityValue ? parseToBoolean(endInfinityValue) : e.defaultValue ? parseToBoolean(e.defaultValue) : false;
    return {
      disabled: e.required ? true : false,
      checked: value,
      show: true,
      onChange: function onChange(checked) {
        handleChange("POSITION_EMPLOYMENT_ENDINFINITY", checked);
      }
    };
  }, [fieldDescriptors, endInfinityValue, handleChange]);
  var selectedManager = useMemo(function () {
    if (!managers || !values || !values["POSITION_MANAGER"]) return;
    var value = values["POSITION_MANAGER"].toString();
    if (!value) return;
    return managers.find(function (m) {
      return m.positionId.toString() === value;
    });
  }, [values, managers, isFetchingManagers]);
  var sortedManagers = useMemo(function () {
    return managers ? _toConsumableArray(managers).sort(function (a, b) {
      return a.name.localeCompare(b.name);
    }) : managers;
  }, [managers]);
  var startValue = values ? values["POSITION_EMPLOYMENT_START"] : undefined;
  var endValue = values ? values["POSITION_EMPLOYMENT_END"] : undefined;
  var periodValue = useMemo(function () {
    return startValue && endValue ? "".concat(startValue, ";").concat(endValue) : null;
  }, [startValue, endValue]); // Consumers pass these as fresh object literals every render. Stabilise them
  // on their meaningful contents so they don't break FieldRow's memoisation and
  // re-render every row on each keystroke. (name / listCount are the only
  // fields read from them.)

  var stableUserIdPickerFieldProps = useMemo(function () {
    return userIdPickerFieldProps;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [userIdPickerFieldProps.name]);
  var stableTimePickerFieldProps = useMemo(function () {
    return timePickerFieldProps;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [timePickerFieldProps.listCount]); // Compute the error message to show for a field. Only touched fields show an
  // error (as before). USER_USERID additionally surfaces the async result.

  var errorForField = function errorForField(field) {
    if (disabled || !touchedRef.current.has(field.identifier)) return "";
    var value = values ? values[field.identifier] : "";

    if (field.required && !value || value && !validateRegex(value.toString(), field.regex)) {
      return errorMessages[field.identifier] || "";
    }

    if (field.identifier === "USER_USERID" && value) {
      return usernameError;
    }

    return "";
  };

  if (noAccess) {
    return /*#__PURE__*/React__default.createElement(Stack, {
      horizontalAlign: "center",
      verticalFill: true,
      tokens: {
        childrenGap: 8
      },
      styles: styles
    }, /*#__PURE__*/React__default.createElement(MessageBox, {
      messageBoxType: "blocked"
    }, /*#__PURE__*/React__default.createElement(Text, null, i18n._(
    /*i18n*/
    {
      id: "You do not have sufficient rights in ID Connect to edit profile data on user."
    })), /*#__PURE__*/React__default.createElement(Text, null, i18n._(
    /*i18n*/
    {
      id: "Please contact your system administrator to get the solved."
    }))));
  }

  if (!fieldDescriptors.length) {
    return /*#__PURE__*/React__default.createElement(Stack, {
      horizontalAlign: "center",
      verticalAlign: "center",
      verticalFill: true,
      tokens: {
        childrenGap: 8
      },
      styles: styles
    }, /*#__PURE__*/React__default.createElement(Spinner, null));
  }

  return /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 8
    },
    styles: styles
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "mediumPlus"
  }, header), fieldDescriptors.map(function (field) {
    return /*#__PURE__*/React__default.createElement(FieldRow, {
      key: field.identifier,
      field: field,
      value: disabled ? "" : values ? values[field.identifier] : "",
      errorMessage: errorForField(field),
      disabled: disabled,
      handleChange: handleChange,
      canEnterUsername: canEnterUsername,
      username: username,
      usernameOptions: usernameOptions,
      isFetchingUsernames: isFetchingUsernames,
      usernamePageNo: usernamePageNo,
      usernameFrom: usernameFrom,
      generateUsernames: generateUsernames,
      templateType: templateType,
      userIdPickerFieldProps: stableUserIdPickerFieldProps,
      tenant: tenant,
      orgUnitOptions: orgUnitOptions,
      setProfileSync: setProfileSync,
      sortedManagers: sortedManagers,
      selectedManager: selectedManager,
      isFetchingManagers: isFetchingManagers,
      checkBoxProps: checkBoxProps,
      periodValue: periodValue,
      timePickerFieldProps: stableTimePickerFieldProps
    });
  }));
};

var DotLine = function DotLine() {
  return /*#__PURE__*/React__default.createElement(Stack, {
    verticalAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Stack, {
    style: {
      borderRightStyle: "dotted",
      height: 15,
      width: 18,
      borderRightWidth: 4,
      borderColor: DefaultPalette$2.neutralQuaternary
    }
  }));
};

var FlowHistory = function FlowHistory(_ref) {
  var props = _ref.props;
  if (!props) return /*#__PURE__*/React__default.createElement(Stack, null, i18n._(
  /*i18n*/
  {
    id: "No status available"
  }));
  var maxTextLength = 25;
  var index = 0;
  return /*#__PURE__*/React__default.createElement(Stack, null, props.length && props.map(function (prop) {
    var imageUrl = prop.imageUrl,
        imageInitials = prop.imageInitials,
        initialsColor = prop.initialsColor,
        text = prop.text,
        secondaryText = prop.secondaryText,
        tertiaryText = prop.tertiaryText,
        iconProps = prop.iconProps;
    index++;
    return /*#__PURE__*/React__default.createElement(Stack, {
      key: index
    }, text && /*#__PURE__*/React__default.createElement(Stack, {
      horizontal: true,
      styles: {
        root: {
          marginTop: 2
        }
      }
    }, index > 1 ? /*#__PURE__*/React__default.createElement(DotLine, null) : /*#__PURE__*/React__default.createElement(Stack, {
      styles: {
        root: {
          paddingLeft: 17
        }
      }
    }), /*#__PURE__*/React__default.createElement(Text, {
      variant: "smallPlus",
      styles: {
        root: {
          fontWeight: FontWeights$2.semibold,
          paddingLeft: 27
        }
      },
      nowrap: true,
      block: true
    }, text)), /*#__PURE__*/React__default.createElement(Stack, {
      horizontal: true
    }, !iconProps ? /*#__PURE__*/React__default.createElement(Persona, {
      imageUrl: imageUrl,
      imageInitials: imageInitials,
      initialsColor: initialsColor,
      size: PersonaSize.size32,
      text: secondaryText,
      hidePersonaDetails: true,
      styles: {
        root: {
          marginRight: 12
        }
      }
    }) : /*#__PURE__*/React__default.createElement(Stack, {
      horizontalAlign: "center",
      verticalAlign: "center",
      styles: {
        root: {
          color: iconProps.color,
          fontSize: 14,
          backgroundColor: iconProps.backgroundColor,
          marginRight: 11,
          minHeight: 34,
          maxHeight: 34,
          minWidth: 34,
          border: "1px solid ".concat(iconProps.color),
          borderRadius: "50%"
        }
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      iconName: iconProps.iconName,
      styles: {
        root: {
          color: iconProps.color
        }
      }
    })), /*#__PURE__*/React__default.createElement(Stack, {
      styles: {
        root: {
          overflow: "hidden"
        }
      }
    }, /*#__PURE__*/React__default.createElement(Text, {
      variant: "smallPlus",
      nowrap: true,
      block: true
    }, secondaryText && secondaryText.length > maxTextLength ? /*#__PURE__*/React__default.createElement(TooltipHost, {
      content: secondaryText,
      id: secondaryText,
      calloutProps: {
        gapSpace: 0
      },
      styles: {
        root: {
          display: "inline-block"
        }
      }
    }, secondaryText.substring(0, maxTextLength) + "...") : secondaryText), /*#__PURE__*/React__default.createElement(Text, {
      variant: "tiny",
      block: true,
      nowrap: true
    }, tertiaryText && tertiaryText.length > maxTextLength ? /*#__PURE__*/React__default.createElement(TooltipHost, {
      content: tertiaryText,
      id: tertiaryText,
      calloutProps: {
        gapSpace: 0
      },
      styles: {
        root: {
          display: "inline-block"
        }
      }
    }, tertiaryText.substring(0, maxTextLength) + "...") : tertiaryText))), props.length > index && /*#__PURE__*/React__default.createElement(DotLine, null));
  }));
};

/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */
const {
  entries,
  setPrototypeOf,
  isFrozen,
  getPrototypeOf,
  getOwnPropertyDescriptor
} = Object;
let {
  freeze,
  seal,
  create
} = Object; // eslint-disable-line import/no-mutable-exports

let {
  apply: apply$1,
  construct
} = typeof Reflect !== 'undefined' && Reflect;

if (!freeze) {
  freeze = function freeze(x) {
    return x;
  };
}

if (!seal) {
  seal = function seal(x) {
    return x;
  };
}

if (!apply$1) {
  apply$1 = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}

if (!construct) {
  construct = function construct(Func, args) {
    return new Func(...args);
  };
}

const arrayForEach = unapply(Array.prototype.forEach);
const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
const arrayPop = unapply(Array.prototype.pop);
const arrayPush$1 = unapply(Array.prototype.push);
const arraySplice = unapply(Array.prototype.splice);
const stringToLowerCase = unapply(String.prototype.toLowerCase);
const stringToString = unapply(String.prototype.toString);
const stringMatch = unapply(String.prototype.match);
const stringReplace = unapply(String.prototype.replace);
const stringIndexOf = unapply(String.prototype.indexOf);
const stringTrim = unapply(String.prototype.trim);
const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
const regExpTest = unapply(RegExp.prototype.test);
const typeErrorCreate = unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */

function unapply(func) {
  return function (thisArg) {
    if (thisArg instanceof RegExp) {
      thisArg.lastIndex = 0;
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return apply$1(func, thisArg, args);
  };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */


function unconstruct(func) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return construct(func, args);
  };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */


function addToSet(set, array) {
  let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;

  if (setPrototypeOf) {
    // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
  }

  let l = array.length;

  while (l--) {
    let element = array[l];

    if (typeof element === 'string') {
      const lcElement = transformCaseFunc(element);

      if (lcElement !== element) {
        // Config presets (e.g. tags.js, attrs.js) are immutable.
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }

        element = lcElement;
      }
    }

    set[element] = true;
  }

  return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */


function cleanArray(array) {
  for (let index = 0; index < array.length; index++) {
    const isPropertyExist = objectHasOwnProperty(array, index);

    if (!isPropertyExist) {
      array[index] = null;
    }
  }

  return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */


function clone(object) {
  const newObject = create(null);

  for (const [property, value] of entries(object)) {
    const isPropertyExist = objectHasOwnProperty(object, property);

    if (isPropertyExist) {
      if (Array.isArray(value)) {
        newObject[property] = cleanArray(value);
      } else if (value && typeof value === 'object' && value.constructor === Object) {
        newObject[property] = clone(value);
      } else {
        newObject[property] = value;
      }
    }
  }

  return newObject;
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */


function lookupGetter(object, prop) {
  while (object !== null) {
    const desc = getOwnPropertyDescriptor(object, prop);

    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }

      if (typeof desc.value === 'function') {
        return unapply(desc.value);
      }
    }

    object = getPrototypeOf(object);
  }

  function fallbackValue() {
    return null;
  }

  return fallbackValue;
}

const html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);
const svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
const svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.

const svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
const mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover', 'mprescripts']); // Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.

const mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
const text = freeze(['#text']);
const html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'popover', 'popovertarget', 'popovertargetaction', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'wrap', 'xmlns', 'slot']);
const svg$2 = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'amplitude', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'exponent', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'slope', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'tablevalues', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
const mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
const xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']); // eslint-disable-next-line unicorn/better-regex

const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex

const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape

const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const DOCTYPE_NAME = seal(/^html$/i);
const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
var EXPRESSIONS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ARIA_ATTR: ARIA_ATTR,
  ATTR_WHITESPACE: ATTR_WHITESPACE,
  CUSTOM_ELEMENT: CUSTOM_ELEMENT,
  DATA_ATTR: DATA_ATTR,
  DOCTYPE_NAME: DOCTYPE_NAME,
  ERB_EXPR: ERB_EXPR,
  IS_ALLOWED_URI: IS_ALLOWED_URI,
  IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
  MUSTACHE_EXPR: MUSTACHE_EXPR,
  TMPLIT_EXPR: TMPLIT_EXPR
});
/* eslint-disable @typescript-eslint/indent */
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType

const NODE_TYPE = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12 // Deprecated

};

const getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */


const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
  if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
    return null;
  } // Allow the callers to control the unique policy name
  // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
  // Policy creation with duplicate names throws in Trusted Types.


  let suffix = null;
  const ATTR_NAME = 'data-tt-policy-suffix';

  if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
    suffix = purifyHostElement.getAttribute(ATTR_NAME);
  }

  const policyName = 'dompurify' + (suffix ? '#' + suffix : '');

  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML(html) {
        return html;
      },

      createScriptURL(scriptUrl) {
        return scriptUrl;
      }

    });
  } catch (_) {
    // Policy creation failed (most likely another DOMPurify script has
    // already run). Skip creating the policy, as this will only cause errors
    // if TT are enforced.
    console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
    return null;
  }
};

const _createHooksMap = function _createHooksMap() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};

function createDOMPurify() {
  let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

  const DOMPurify = root => createDOMPurify(root);

  DOMPurify.version = '3.2.6';
  DOMPurify.removed = [];

  if (!window || !window.document || window.document.nodeType !== NODE_TYPE.document || !window.Element) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;
    return DOMPurify;
  }

  let {
    document
  } = window;
  const originalDocument = document;
  const currentScript = originalDocument.currentScript;
  const {
    DocumentFragment,
    HTMLTemplateElement,
    Node,
    Element,
    NodeFilter,
    NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap,
    HTMLFormElement,
    DOMParser,
    trustedTypes
  } = window;
  const ElementPrototype = Element.prototype;
  const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
  const remove = lookupGetter(ElementPrototype, 'remove');
  const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
  const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
  const getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.

  if (typeof HTMLTemplateElement === 'function') {
    const template = document.createElement('template');

    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }

  let trustedTypesPolicy;
  let emptyHTML = '';
  const {
    implementation,
    createNodeIterator,
    createDocumentFragment,
    getElementsByTagName
  } = document;
  const {
    importNode
  } = originalDocument;

  let hooks = _createHooksMap();
  /**
   * Expose whether this browser supports running the full DOMPurify.
   */


  DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
  const {
    MUSTACHE_EXPR,
    ERB_EXPR,
    TMPLIT_EXPR,
    DATA_ATTR,
    ARIA_ATTR,
    IS_SCRIPT_OR_DATA,
    ATTR_WHITESPACE,
    CUSTOM_ELEMENT
  } = EXPRESSIONS;
  let {
    IS_ALLOWED_URI: IS_ALLOWED_URI$1
  } = EXPRESSIONS;
  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */

  /* allowed element names */

  let ALLOWED_TAGS = null;
  const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
  /* Allowed attribute names */

  let ALLOWED_ATTR = null;
  const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg$2, ...mathMl, ...xml]);
  /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */

  let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));
  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

  let FORBID_TAGS = null;
  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

  let FORBID_ATTR = null;
  /* Decide if ARIA attributes are okay */

  let ALLOW_ARIA_ATTR = true;
  /* Decide if custom data attributes are okay */

  let ALLOW_DATA_ATTR = true;
  /* Decide if unknown protocols are okay */

  let ALLOW_UNKNOWN_PROTOCOLS = false;
  /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */

  let ALLOW_SELF_CLOSE_IN_ATTR = true;
  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */

  let SAFE_FOR_TEMPLATES = false;
  /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */

  let SAFE_FOR_XML = true;
  /* Decide if document with <html>... should be returned */

  let WHOLE_DOCUMENT = false;
  /* Track whether config is already set on this instance of DOMPurify. */

  let SET_CONFIG = false;
  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */

  let FORCE_BODY = false;
  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */

  let RETURN_DOM = false;
  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */

  let RETURN_DOM_FRAGMENT = false;
  /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */

  let RETURN_TRUSTED_TYPE = false;
  /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */

  let SANITIZE_DOM = true;
  /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */

  let SANITIZE_NAMED_PROPS = false;
  const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
  /* Keep element content when removing element? */

  let KEEP_CONTENT = true;
  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */

  let IN_PLACE = false;
  /* Allow usage of profiles like html, svg and mathMl */

  let USE_PROFILES = {};
  /* Tags to ignore content of when KEEP_CONTENT is true */

  let FORBID_CONTENTS = null;
  const DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
  /* Tags that are safe for data: URIs */

  let DATA_URI_TAGS = null;
  const DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
  /* Attributes safe for values like "javascript:" */

  let URI_SAFE_ATTRIBUTES = null;
  const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
  const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
  const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
  /* Document namespace */

  let NAMESPACE = HTML_NAMESPACE;
  let IS_EMPTY_INPUT = false;
  /* Allowed XHTML+XML namespaces */

  let ALLOWED_NAMESPACES = null;
  const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
  let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
  let HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']); // Certain elements are allowed in both SVG and HTML
  // namespace. We need to specify them explicitly
  // so that they don't get erroneously deleted from
  // HTML namespace.

  const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
  /* Parsing of strict XHTML documents */

  let PARSER_MEDIA_TYPE = null;
  const SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
  const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
  let transformCaseFunc = null;
  /* Keep a reference to config to pass to hooks */

  let CONFIG = null;
  /* Ideally, do not touch anything below this line */

  /* ______________________________________________ */

  const formElement = document.createElement('form');

  const isRegexOrFunction = function isRegexOrFunction(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };
  /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */
  // eslint-disable-next-line complexity


  const _parseConfig = function _parseConfig() {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (CONFIG && CONFIG === cfg) {
      return;
    }
    /* Shield configuration object from tampering */


    if (!cfg || typeof cfg !== 'object') {
      cfg = {};
    }
    /* Shield configuration object from prototype pollution */


    cfg = clone(cfg);
    PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

    transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
    /* Set configuration parameters */

    ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
    ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
    URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
    DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
    FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
    FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
    FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
    USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true

    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true

    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

    RETURN_DOM = cfg.RETURN_DOM || false; // Default false

    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

    FORCE_BODY = cfg.FORCE_BODY || false; // Default false

    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

    IN_PLACE = cfg.IN_PLACE || false; // Default false

    IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
    NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
    MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
    HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
    CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};

    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
    }

    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
    }

    if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
    }

    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }

    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    /* Parse profile info */


    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, text);
      ALLOWED_ATTR = [];

      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, html);
      }

      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg$2);
        addToSet(ALLOWED_ATTR, xml);
      }

      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg$2);
        addToSet(ALLOWED_ATTR, xml);
      }

      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, xml);
      }
    }
    /* Merge configuration parameters */


    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone(ALLOWED_TAGS);
      }

      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
    }

    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone(ALLOWED_ATTR);
      }

      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
    }

    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
    }

    if (cfg.FORBID_CONTENTS) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone(FORBID_CONTENTS);
      }

      addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
    }
    /* Add #text in case KEEP_CONTENT is set to true */


    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }
    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }
    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
      delete FORBID_TAGS.tbody;
    }

    if (cfg.TRUSTED_TYPES_POLICY) {
      if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      }

      if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      } // Overwrite existing TrustedTypes policy.


      trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY; // Sign local variables required by `sanitize`.

      emptyHTML = trustedTypesPolicy.createHTML('');
    } else {
      // Uninitialized policy, attempt to initialize the internal dompurify policy.
      if (trustedTypesPolicy === undefined) {
        trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
      } // If creating the internal policy succeeded sign internal variables.


      if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') {
        emptyHTML = trustedTypesPolicy.createHTML('');
      }
    } // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.


    if (freeze) {
      freeze(cfg);
    }

    CONFIG = cfg;
  };
  /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */


  const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
  const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
  /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */

  const _checkValidNamespace = function _checkValidNamespace(element) {
    let parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
    // can be null. We just simulate parent in this case.

    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: 'template'
      };
    }

    const tagName = stringToLowerCase(element.tagName);
    const parentTagName = stringToLowerCase(parent.tagName);

    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }

    if (element.namespaceURI === SVG_NAMESPACE) {
      // The only way to switch from HTML namespace to SVG
      // is via <svg>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'svg';
      } // The only way to switch from MathML to SVG is via`
      // svg if parent is either <annotation-xml> or MathML
      // text integration points.


      if (parent.namespaceURI === MATHML_NAMESPACE) {
        return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
      } // We only allow elements that are defined in SVG
      // spec. All others are disallowed in SVG namespace.


      return Boolean(ALL_SVG_TAGS[tagName]);
    }

    if (element.namespaceURI === MATHML_NAMESPACE) {
      // The only way to switch from HTML namespace to MathML
      // is via <math>. If it happens via any other tag, then
      // it should be killed.
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === 'math';
      } // The only way to switch from SVG to MathML is via
      // <math> and HTML integration points


      if (parent.namespaceURI === SVG_NAMESPACE) {
        return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
      } // We only allow elements that are defined in MathML
      // spec. All others are disallowed in MathML namespace.


      return Boolean(ALL_MATHML_TAGS[tagName]);
    }

    if (element.namespaceURI === HTML_NAMESPACE) {
      // The only way to switch from SVG to HTML is via
      // HTML integration points, and from MathML to HTML
      // is via MathML text integration points
      if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }

      if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
        return false;
      } // We disallow tags that are specific for MathML
      // or SVG and should never appear in HTML namespace


      return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    } // For XHTML and XML documents that support custom namespaces


    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    } // The code should never reach this place (this means
    // that the element somehow got namespace that is not
    // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
    // Return false just in case.


    return false;
  };
  /**
   * _forceRemove
   *
   * @param node a DOM node
   */


  const _forceRemove = function _forceRemove(node) {
    arrayPush$1(DOMPurify.removed, {
      element: node
    });

    try {
      // eslint-disable-next-line unicorn/prefer-dom-node-remove
      getParentNode(node).removeChild(node);
    } catch (_) {
      remove(node);
    }
  };
  /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */


  const _removeAttribute = function _removeAttribute(name, element) {
    try {
      arrayPush$1(DOMPurify.removed, {
        attribute: element.getAttributeNode(name),
        from: element
      });
    } catch (_) {
      arrayPush$1(DOMPurify.removed, {
        attribute: null,
        from: element
      });
    }

    element.removeAttribute(name); // We void attribute values for unremovable "is" attributes

    if (name === 'is') {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(element);
        } catch (_) {}
      } else {
        try {
          element.setAttribute(name, '');
        } catch (_) {}
      }
    }
  };
  /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */


  const _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    let doc = null;
    let leadingWhitespace = null;

    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    } else {
      /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
      const matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }

    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
      // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
    }

    const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */

    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {}
    }
    /* Use createHTMLDocument in case DOMParser is not available */


    if (!doc || !doc.documentElement) {
      doc = implementation.createDocument(NAMESPACE, 'template', null);

      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_) {// Syntax error if dirtyPayload is invalid xml
      }
    }

    const body = doc.body || doc.documentElement;

    if (dirty && leadingWhitespace) {
      body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }
    /* Work on whole document or just its body */


    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
    }

    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };
  /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */


  const _createNodeIterator = function _createNodeIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
  };
  /**
   * _isClobbered
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */


  const _isClobbered = function _isClobbered(element) {
    return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
  };
  /**
   * Checks whether the given object is a DOM node.
   *
   * @param value object to check whether it's a DOM node
   * @return true is object is a DOM node
   */


  const _isNode = function _isNode(value) {
    return typeof Node === 'function' && value instanceof Node;
  };

  function _executeHooks(hooks, currentNode, data) {
    arrayForEach(hooks, hook => {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  }
  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */


  const _sanitizeElements = function _sanitizeElements(currentNode) {
    let content = null;
    /* Execute a hook if present */

    _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
    /* Check if element is clobbered or can clobber */


    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);

      return true;
    }
    /* Now let's check the element's type and name */


    const tagName = transformCaseFunc(currentNode.nodeName);
    /* Execute a hook if present */

    _executeHooks(hooks.uponSanitizeElement, currentNode, {
      tagName,
      allowedTags: ALLOWED_TAGS
    });
    /* Detect mXSS attempts abusing namespace confusion */


    if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
      _forceRemove(currentNode);

      return true;
    }
    /* Remove any occurrence of processing instructions */


    if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
      _forceRemove(currentNode);

      return true;
    }
    /* Remove any kind of possibly harmful comments */


    if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
      _forceRemove(currentNode);

      return true;
    }
    /* Remove element if anything forbids its presence */


    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      /* Check if we have a custom element to handle */
      if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
          return false;
        }

        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
          return false;
        }
      }
      /* Keep content except for bad-listed elements */


      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
        const parentNode = getParentNode(currentNode) || currentNode.parentNode;
        const childNodes = getChildNodes(currentNode) || currentNode.childNodes;

        if (childNodes && parentNode) {
          const childCount = childNodes.length;

          for (let i = childCount - 1; i >= 0; --i) {
            const childClone = cloneNode(childNodes[i], true);
            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
            parentNode.insertBefore(childClone, getNextSibling(currentNode));
          }
        }
      }

      _forceRemove(currentNode);

      return true;
    }
    /* Check whether element has a valid namespace */


    if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);

      return true;
    }
    /* Make sure that older browsers don't get fallback-tag mXSS */


    if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);

      return true;
    }
    /* Sanitize element content to be template-safe */


    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
      /* Get the element's text content */
      content = currentNode.textContent;
      arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
        content = stringReplace(content, expr, ' ');
      });

      if (currentNode.textContent !== content) {
        arrayPush$1(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    /* Execute a hook if present */


    _executeHooks(hooks.afterSanitizeElements, currentNode, null);

    return false;
  };
  /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */
  // eslint-disable-next-line complexity


  const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }
    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */


    if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
      // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
      _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
      // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
      lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;else {
        return false;
      }
      /* Check value is safe. First, is attr inert? If so, is safe */
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ;else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;else if (value) {
      return false;
    }
    return true;
  };
  /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */


  const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
    return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
  };
  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */


  const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);

    const {
      attributes
    } = currentNode;
    /* Check if we have attributes; if not we might have a text node */

    if (!attributes || _isClobbered(currentNode)) {
      return;
    }

    const hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR,
      forceKeepAttr: undefined
    };
    let l = attributes.length;
    /* Go backwards over all attributes; safely remove bad ones */

    while (l--) {
      const attr = attributes[l];
      const {
        name,
        namespaceURI,
        value: attrValue
      } = attr;
      const lcName = transformCaseFunc(name);
      const initValue = attrValue;
      let value = name === 'value' ? initValue : stringTrim(initValue);
      /* Execute a hook if present */

      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

      _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);

      value = hookEvent.attrValue;
      /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */

      if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
        // Remove the attribute with this value
        _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


        value = SANITIZE_NAMED_PROPS_PREFIX + value;
      }
      /* Work around a security issue with comments inside attributes */


      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
        _removeAttribute(name, currentNode);

        continue;
      }
      /* Did the hooks approve of the attribute? */


      if (hookEvent.forceKeepAttr) {
        continue;
      }
      /* Did the hooks approve of the attribute? */


      if (!hookEvent.keepAttr) {
        _removeAttribute(name, currentNode);

        continue;
      }
      /* Work around a security issue in jQuery 3.0 */


      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
        _removeAttribute(name, currentNode);

        continue;
      }
      /* Sanitize attribute content to be template-safe */


      if (SAFE_FOR_TEMPLATES) {
        arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
          value = stringReplace(value, expr, ' ');
        });
      }
      /* Is `value` valid for this attribute? */


      const lcTag = transformCaseFunc(currentNode.nodeName);

      if (!_isValidAttribute(lcTag, lcName, value)) {
        _removeAttribute(name, currentNode);

        continue;
      }
      /* Handle attributes that require Trusted Types */


      if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
        if (namespaceURI) ;else {
          switch (trustedTypes.getAttributeType(lcTag, lcName)) {
            case 'TrustedHTML':
              {
                value = trustedTypesPolicy.createHTML(value);
                break;
              }

            case 'TrustedScriptURL':
              {
                value = trustedTypesPolicy.createScriptURL(value);
                break;
              }
          }
        }
      }
      /* Handle invalid data-* attribute set by try-catching it */


      if (value !== initValue) {
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
          } else {
            arrayPop(DOMPurify.removed);
          }
        } catch (_) {
          _removeAttribute(name, currentNode);
        }
      }
    }
    /* Execute a hook if present */


    _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
  };
  /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */


  const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
    let shadowNode = null;

    const shadowIterator = _createNodeIterator(fragment);
    /* Execute a hook if present */


    _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);

    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
      /* Sanitize tags and elements */


      _sanitizeElements(shadowNode);
      /* Check attributes next */


      _sanitizeAttributes(shadowNode);
      /* Deep shadow DOM detected */


      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(shadowNode.content);
      }
    }
    /* Execute a hook if present */


    _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
  }; // eslint-disable-next-line complexity


  DOMPurify.sanitize = function (dirty) {
    let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let body = null;
    let importedNode = null;
    let currentNode = null;
    let returnNode = null;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */

    IS_EMPTY_INPUT = !dirty;

    if (IS_EMPTY_INPUT) {
      dirty = '<!-->';
    }
    /* Stringify, in case dirty is an object */


    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      if (typeof dirty.toString === 'function') {
        dirty = dirty.toString();

        if (typeof dirty !== 'string') {
          throw typeErrorCreate('dirty is not a string, aborting');
        }
      } else {
        throw typeErrorCreate('toString is not a function');
      }
    }
    /* Return dirty HTML if DOMPurify cannot run */


    if (!DOMPurify.isSupported) {
      return dirty;
    }
    /* Assign config vars */


    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }
    /* Clean up removed elements */


    DOMPurify.removed = [];
    /* Check if dirty is correctly typed for IN_PLACE */

    if (typeof dirty === 'string') {
      IN_PLACE = false;
    }

    if (IN_PLACE) {
      /* Do some early pre-sanitization to avoid unsafe root nodes */
      if (dirty.nodeName) {
        const tagName = transformCaseFunc(dirty.nodeName);

        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
        }
      }
    } else if (dirty instanceof Node) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!---->');
      importedNode = body.ownerDocument.importNode(dirty, true);

      if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else if (importedNode.nodeName === 'HTML') {
        body = importedNode;
      } else {
        // eslint-disable-next-line unicorn/prefer-dom-node-append
        body.appendChild(importedNode);
      }
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf('<') === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }
      /* Initialize the document to work on */


      body = _initDocument(dirty);
      /* Check we have a DOM node from the data */

      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
      }
    }
    /* Remove first element node (ours) if FORCE_BODY is set */


    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    /* Get node iterator */


    const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
    /* Now start iterating over the created document */


    while (currentNode = nodeIterator.nextNode()) {
      /* Sanitize tags and elements */
      _sanitizeElements(currentNode);
      /* Check attributes next */


      _sanitizeAttributes(currentNode);
      /* Shadow DOM detected, sanitize it */


      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }
    }
    /* If we sanitized `dirty` in-place, return it. */


    if (IN_PLACE) {
      return dirty;
    }
    /* Return sanitized string or DOM */


    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);

        while (body.firstChild) {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }

      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
        /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }

      return returnNode;
    }

    let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    /* Serialize doctype if allowed */

    if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
    }
    /* Sanitize final string template-safe */


    if (SAFE_FOR_TEMPLATES) {
      arrayForEach([MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR], expr => {
        serializedHTML = stringReplace(serializedHTML, expr, ' ');
      });
    }

    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };

  DOMPurify.setConfig = function () {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _parseConfig(cfg);

    SET_CONFIG = true;
  };

  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };

  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }

    const lcTag = transformCaseFunc(tag);
    const lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };

  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }

    arrayPush$1(hooks[entryPoint], hookFunction);
  };

  DOMPurify.removeHook = function (entryPoint, hookFunction) {
    if (hookFunction !== undefined) {
      const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
      return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
    }

    return arrayPop(hooks[entryPoint]);
  };

  DOMPurify.removeHooks = function (entryPoint) {
    hooks[entryPoint] = [];
  };

  DOMPurify.removeAllHooks = function () {
    hooks = _createHooksMap();
  };

  return DOMPurify;
}

var purify = createDOMPurify();

var cleanHtml = function cleanHtml(value) {
  return purify.sanitize(value, {
    ALLOWED_TAGS: ["b", "i", "u", "p", "br", "span", "div", "strong", "em", "ul", "ol", "li"]
  });
};

function PendingIcon(_ref) {
  var iconName = _ref.iconName,
      color = _ref.color,
      tooltip = _ref.tooltip;
  return /*#__PURE__*/React__default.createElement(TooltipHost, {
    content: tooltip
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: iconName,
    styles: {
      root: {
        color: color,
        cursor: "default",
        paddingTop: 3
      }
    }
  })));
}
function getStatusColor(key) {
  switch (key) {
    case "REQUESTED":
      return "#ffaa44";

    case "APPROVED":
      return "#6bb700";

    case "DENIED":
      return "#c50f1f";

    default:
      return "#8a8886";
  }
} // Modal header text

function getHeaderText(status, type, action) {
  if (type === "ASSIGN_MANUAL_USERROLE") {
    switch (status) {
      case "REQUEST":
        return {
          header: action === "ADDED" ? i18n._(
          /*i18n*/
          {
            id: "Task: Request for assignment"
          }) : i18n._(
          /*i18n*/
          {
            id: "Task: Request for removal"
          }),
          subHeader: i18n._(
          /*i18n*/
          {
            id: "Information regarding assignment process"
          })
        };

      case "REQUESTED":
        return {
          header: action === "ADDED" ? i18n._(
          /*i18n*/
          {
            id: "Task: Request for assignment"
          }) : i18n._(
          /*i18n*/
          {
            id: "Task: Request for removal"
          }),
          subHeader: i18n._(
          /*i18n*/
          {
            id: "Information regarding assignment process"
          })
        };

      case "APPROVED":
        return {
          header: i18n._(
          /*i18n*/
          {
            id: "Task confirmed"
          }),
          subHeader: i18n._(
          /*i18n*/
          {
            id: "Information regarding assignment process"
          })
        };

      case "DENIED":
        return {
          header: i18n._(
          /*i18n*/
          {
            id: "Task declined"
          }),
          subHeader: i18n._(
          /*i18n*/
          {
            id: "Information regarding assignment process"
          })
        };

      default:
        return {
          header: "",
          subHeader: ""
        };
    }
  } else {
    switch (status) {
      case "REQUEST":
        return {
          header: i18n._(
          /*i18n*/
          {
            id: "Task: Request for approval"
          }),
          subHeader: i18n._(
          /*i18n*/
          {
            id: "Information regarding approval process"
          })
        };

      case "REQUESTED":
        return {
          header: i18n._(
          /*i18n*/
          {
            id: "Task: Request for approval"
          }),
          subHeader: i18n._(
          /*i18n*/
          {
            id: "Information regarding approval process"
          })
        };

      case "APPROVED":
        return {
          header: i18n._(
          /*i18n*/
          {
            id: "Task confirmed"
          }),
          subHeader: i18n._(
          /*i18n*/
          {
            id: "Information regarding approval process"
          })
        };

      case "DENIED":
        return {
          header: i18n._(
          /*i18n*/
          {
            id: "Task declined"
          }),
          subHeader: i18n._(
          /*i18n*/
          {
            id: "Information regarding approval process"
          })
        };

      default:
        return {
          header: "",
          subHeader: ""
        };
    }
  }
} // Current status for approval request

function getNewestStatus(items) {
  if (!items || !items.length) return "";
  return items[items.length - 1];
} // Creates a FlowHistory object

function createHistoryObject(item) {
  return {
    imageUrl: "",
    imageInitials: "",
    text: item.status,
    secondaryText: item.createdBy,
    tertiaryText: item.created && format$1("dd-MM-yyyy HH:mm")(item.created)
  };
} // FlowHistory props for approval status

function createHistoryProps(items, approvalType, action, receiver) {
  if (!items || !items.length) return;
  var sortedItems = items.sort(function (a, b) {
    return b.created - a.created;
  });
  var historyList = sortedItems.map(function (item) {
    return createHistoryObject(item);
  });
  var currentStatus = {
    imageUrl: "",
    imageInitials: "",
    text: approvalType === "ASSIGN_MANUAL_USERROLE" ? action === "ADDED" ? i18n._(
    /*i18n*/
    {
      id: "Waiting assignment"
    }) : i18n._(
    /*i18n*/
    {
      id: "Waiting removal"
    }) : i18n._(
    /*i18n*/
    {
      id: "Waiting approval"
    }),
    secondaryText: receiver,
    iconProps: {
      iconName: "CircleFill",
      color: getStatusColor("REQUESTED"),
      backgroundColor: getStatusColor("REQUESTED")
    }
  };
  return items.length === 1 ? [currentStatus].concat(_toConsumableArray(historyList)) : historyList;
}

function Approval(_ref) {
  var _item$comments;

  var showModal = _ref.showModal,
      items = _ref.items,
      requestProps = _ref.requestProps,
      onCancelSelection = _ref.onCancelSelection,
      handleItemAccept = _ref.handleItemAccept,
      handleItemDeny = _ref.handleItemDeny;
  if (!items) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      requester = _useState4[0],
      setRequester = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      historyProps = _useState6[0],
      setHistoryProps = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      comment = _useState8[0],
      setComment = _useState8[1];

  var item = useMemo(function () {
    if (!items) return;
    var item = items[index];
    if (!item) return;
    if (!item.comments) return {
      item: item
    };
    var statusId = getNewestStatus(_toConsumableArray(item === null || item === void 0 ? void 0 : item.comments).sort(function (a, b) {
      return a.created - b.created;
    })).statusId;
    return _objectSpread2(_objectSpread2({}, item), {}, {
      statusId: statusId
    });
  }, [index, items]);

  var _useMemo = useMemo(function () {
    if (!item) return {
      header: "",
      subHeader: ""
    };
    return getHeaderText(item.statusId, item.approvalType, item.action);
  }, [item]),
      header = _useMemo.header,
      subHeader = _useMemo.subHeader;

  var _useMemo2 = useMemo(function () {
    if (!item || !(item !== null && item !== void 0 && item.statusId)) return {
      isApproval: false,
      isRequest: false
    };
    return {
      isApproval: item.statusId === "REQUESTED",
      isRequest: item.statusId === "REQUEST"
    };
  }, [item]),
      isApproval = _useMemo2.isApproval,
      isRequest = _useMemo2.isRequest;

  var sendButtonDisabled = useMemo(function () {
    if (index !== items.length - 1) return true;
    if (isRequest && item.requiredComment && comment === "") return true;
    return false;
  }, [items, index, comment, item, isRequest]);
  var currentStatus = useMemo(function () {
    if (!(item !== null && item !== void 0 && item.comments)) return {
      statusId: "",
      status: ""
    };
    return getNewestStatus(_toConsumableArray(item.comments).sort(function (a, b) {
      return a.created - b.created;
    }));
  }, [item === null || item === void 0 ? void 0 : item.comments]);
  var flowHistoryProps = useMemo(function () {
    if (!item) return [];
    return requestProps(item);
  }, [item]);
  useEffect(function () {
    if (!(item !== null && item !== void 0 && item.comments)) return;
    if (!(item !== null && item !== void 0 && item.comments.some(function (comment) {
      return comment.statusId === "REQUEST";
    }))) setHistoryProps(createHistoryProps(item.comments, item.approvalType, item.action, item.receiver));

    var requestedBy = _toConsumableArray(item.comments).find(function (c) {
      return c.statusId === "REQUESTED";
    });

    if (requestedBy) setRequester(requestedBy.createdBy);
  }, [item]);
  useEffect(function () {
    if (!comment || !item || !items) return;
    items[index].newComment = comment;
  }, [comment]); // Reset page number and comment

  useEffect(function () {
    if (!showModal) return;
    setIndex(0);
    setComment("");
  }, [items, showModal]); // Empty comment on change og page

  useEffect(function () {
    setComment("");
  }, [index]);
  return /*#__PURE__*/React__default.createElement(Modal, {
    titleAriaId: i18n._(
    /*i18n*/
    {
      id: "Approvals"
    }),
    isOpen: showModal,
    onDismiss: onCancelSelection,
    isDarkOverlay: true,
    containerClassName: isRequest && item.addComment || isApproval && !item.readOnly ? contentStyles.containerTextField : contentStyles.container
  }, /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 16
    },
    styles: {
      root: {
        margin: 30
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "Completed",
    styles: {
      root: {
        color: DefaultPalette$2.blue,
        fontSize: "36px"
      }
    }
  }), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        paddingLeft: "20px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, header), /*#__PURE__*/React__default.createElement(Text, {
    variant: "small"
  }, subHeader))), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true
  }, /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 8
    },
    styles: {
      root: {
        width: "100vh",
        height: 380,
        paddingRight: isRequest ? 0 : 30
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    styles: {
      root: {
        fontWeight: FontWeights$2.semibold
      }
    }
  }, i18n._(
  /*i18n*/
  {
    id: "Request concerns:"
  })), /*#__PURE__*/React__default.createElement(FlowHistory, {
    props: flowHistoryProps
  }), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "small"
  }, i18n._(
  /*i18n*/
  {
    id: "Action:"
  })), (item === null || item === void 0 ? void 0 : item.action) === "ADDED" ? /*#__PURE__*/React__default.createElement(PendingIcon, {
    iconName: "CircleAddition",
    color: DefaultPalette$2.themePrimary,
    tooltip: i18n._(
    /*i18n*/
    {
      id: "Approval for assignment"
    })
  }) : /*#__PURE__*/React__default.createElement(PendingIcon, {
    iconName: "RemoveFilter",
    color: "#797673",
    tooltip: i18n._(
    /*i18n*/
    {
      id: "Approval for removal"
    })
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "small"
  }, (item === null || item === void 0 ? void 0 : item.action) === "ADDED" ? i18n._(
  /*i18n*/
  {
    id: "Assignment"
  }) : i18n._(
  /*i18n*/
  {
    id: "Unassignment"
  }))), isRequest ? /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus"
  }, i18n._(
  /*i18n*/
  {
    id: "Receiver:"
  })), item !== null && item !== void 0 && item.receiver ? /*#__PURE__*/React__default.createElement(Text, {
    variant: "small"
  }, item.receiver) : /*#__PURE__*/React__default.createElement(Text, {
    variant: "small",
    styles: {
      root: {
        fontStyle: "italic"
      }
    }
  }, i18n._(
  /*i18n*/
  {
    id: "There are no receiver"
  })))) : /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus"
  }, i18n._(
  /*i18n*/
  {
    id: "Status:"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "small",
    styles: {
      root: {
        color: getStatusColor(currentStatus.statusId)
      }
    }
  }, currentStatus.status)), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus"
  }, i18n._(
  /*i18n*/
  {
    id: "Approval ID:"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "small",
    styles: {
      root: {
        color: getStatusColor(currentStatus.identifier)
      }
    }
  }, currentStatus.identifier))), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        borderTop: "1px solid ".concat(DefaultPalette$2.neutralLight),
        marginTop: 10,
        paddingTop: 10,
        height: 200,
        overflowY: "auto"
      }
    },
    tokens: {
      childrenGap: 8
    }
  }, isApproval && requester && /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "smallPlus"
  }, i18n._(
  /*i18n*/
  {
    id: "Questions can be directed to"
  }), ":"), /*#__PURE__*/React__default.createElement(Text, {
    variant: "small"
  }, requester)), item !== null && item !== void 0 && item.name ? /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xLarge"
  }, item === null || item === void 0 ? void 0 : item.name), /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium"
  }, /*#__PURE__*/React__default.createElement(StringToHTML, {
    text: cleanHtml((item === null || item === void 0 ? void 0 : item.description) || "")
  }))) : !(item !== null && item !== void 0 && item.status) && /*#__PURE__*/React__default.createElement(MessageBar, {
    messageBarType: MessageBarType.warning,
    messageBarIconProps: {
      iconName: "Info",
      styles: {
        root: {
          color: "#ffaa44"
        }
      }
    },
    isMultiline: false,
    overflowButtonAriaLabel: "See more",
    onDismiss: null,
    dismissButtonAriaLabel: "Close"
  }, /*#__PURE__*/React__default.createElement(Text, null, /*#__PURE__*/React__default.createElement("b", null, i18n._(
  /*i18n*/
  {
    id: "Note"
  }), ": "), i18n._(
  /*i18n*/
  {
    id: "There is no system roles assigned to the role, and thereby no receiver. This means that no email can be sent."
  }))), item === null || item === void 0 ? void 0 : (_item$comments = item.comments) === null || _item$comments === void 0 ? void 0 : _item$comments.map(function (comment) {
    return (comment === null || comment === void 0 ? void 0 : comment.comment) && /*#__PURE__*/React__default.createElement(Stack, {
      styles: {
        root: {
          marginTop: 20
        }
      },
      key: comment === null || comment === void 0 ? void 0 : comment.created
    }, /*#__PURE__*/React__default.createElement(Stack, {
      styles: {
        root: {
          fontWeight: FontWeights$2.semibold
        }
      }
    }, (comment === null || comment === void 0 ? void 0 : comment.statusId) === "REQUESTED" ? i18n._(
    /*i18n*/
    {
      id: "Comment from requester"
    }) : (item === null || item === void 0 ? void 0 : item.approvalType) === "ASSIGN_MANUAL_USERROLE" ? i18n._(
    /*i18n*/
    {
      id: "Comment from assigner"
    }) : i18n._(
    /*i18n*/
    {
      id: "Comment from approver"
    }), ": ", " ", comment.createdBy), /*#__PURE__*/React__default.createElement(Text, {
      variant: "medium"
    }, /*#__PURE__*/React__default.createElement(StringToHTML, {
      text: comment.comment
    })));
  }))), isRequest ? /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        width: 0
      }
    }
  }) : /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        borderLeft: "1px solid ".concat(DefaultPalette$2.neutralLight),
        height: "calc(100vh - 1)",
        paddingLeft: 30,
        paddingRight: 20
      }
    },
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 8
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    styles: {
      root: {
        fontWeight: FontWeights$2.semibold
      }
    }
  }, i18n._(
  /*i18n*/
  {
    id: "Status:"
  })), /*#__PURE__*/React__default.createElement(Text, {
    styles: {
      root: {
        fontWeight: FontWeights$2.semibold,
        color: getStatusColor(currentStatus.statusId)
      }
    }
  }, currentStatus.status)), /*#__PURE__*/React__default.createElement(FlowHistory, {
    props: historyProps
  }))), /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 8
    }
  }, isRequest && item !== null && item !== void 0 && item.addComment || isApproval && !(item !== null && item !== void 0 && item.readOnly) ? /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 8
    }
  }, isApproval && /*#__PURE__*/React__default.createElement(MessageBar, {
    messageBarType: MessageBarType.warning,
    messageBarIconProps: {
      iconName: "Info",
      styles: {
        root: {
          color: "#ffaa44"
        }
      }
    },
    isMultiline: false,
    overflowButtonAriaLabel: "See more",
    onDismiss: null,
    dismissButtonAriaLabel: "Close"
  }, item.action === "ADDED" ? i18n._(
  /*i18n*/
  {
    id: "Notice: Do not press \"Assigned\" until the right has been assigned in the requested system."
  }) : i18n._(
  /*i18n*/
  {
    id: "Notice: Do not press \"Removed\" until the right has been deassigned in the requested system."
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {}
  }, /*#__PURE__*/React__default.createElement(CustomLabel, {
    label: i18n._(
    /*i18n*/
    {
      id: "Add a comment to the task"
    }),
    styles: {
      root: {
        fontWeight: "normal",
        fontSize: "12px"
      }
    },
    required: item.requiredComment,
    labelIconProps: {
      iconName: "Info",
      title: isRequest ? i18n._(
      /*i18n*/
      {
        id: "Comment will be added to the request and the email sent to the receiver(s) of this request."
      }) : i18n._(
      /*i18n*/
      {
        id: "Comment will be added to the request and the email sent to {requester}.",
        values: {
          requester: requester
        }
      }),
      callOutText: isRequest ? i18n._(
      /*i18n*/
      {
        id: "You can enter a comment to this request. Your comment will be added to the request and the email sent to the receiver(s) of this request."
      }) : i18n._(
      /*i18n*/
      {
        id: "You can enter a comment to this request. Your comment will be added to the request and the email sent to {requester}.",
        values: {
          requester: requester
        }
      })
    }
  })), /*#__PURE__*/React__default.createElement(TextField, {
    multiline: true,
    rows: 5,
    resizable: false,
    onChange: function onChange(e, value) {
      return setComment(value ? value.replaceAll("\n", "<br/>") : value);
    },
    value: comment.replaceAll("<br/>", "\n")
  })) : null, /*#__PURE__*/React__default.createElement(DialogFooter, null, /*#__PURE__*/React__default.createElement(DefaultButton, {
    text: isRequest || isApproval && !(item !== null && item !== void 0 && item.readOnly) ? i18n._(
    /*i18n*/
    {
      id: "Cancel"
    }) : i18n._(
    /*i18n*/
    {
      id: "Close"
    }),
    onClick: onCancelSelection
  }), (items === null || items === void 0 ? void 0 : items.length) > 1 && /*#__PURE__*/React__default.createElement(PrimaryButton, {
    text: i18n._(
    /*i18n*/
    {
      id: "Previous"
    }),
    onClick: function onClick() {
      setIndex(index - 1);
    },
    disabled: index === 0
  }), (items === null || items === void 0 ? void 0 : items.length) > 1 && index !== items.length - 1 && /*#__PURE__*/React__default.createElement(PrimaryButton, {
    text: i18n._(
    /*i18n*/
    {
      id: "Next"
    }),
    onClick: function onClick() {
      setIndex(index + 1);
    },
    disabled: index === items.length - 1 || item.requiredComment && comment === ""
  }), isApproval && !(item !== null && item !== void 0 && item.readOnly) ? /*#__PURE__*/React__default.createElement(DefaultButton, {
    text: i18n._(
    /*i18n*/
    {
      id: "Deny"
    }),
    onClick: handleItemDeny
  }) : null, (isRequest || isApproval && !(item !== null && item !== void 0 && item.readOnly)) && index === items.length - 1 ? /*#__PURE__*/React__default.createElement(PrimaryButton, {
    text: isRequest ? i18n._(
    /*i18n*/
    {
      id: "Send"
    }) : (item === null || item === void 0 ? void 0 : item.approvalType) === "ASSIGN_MANUAL_USERROLE" ? (item === null || item === void 0 ? void 0 : item.action) === "ADDED" ? i18n._(
    /*i18n*/
    {
      id: "Assigned"
    }) : i18n._(
    /*i18n*/
    {
      id: "Removed"
    }) : i18n._(
    /*i18n*/
    {
      id: "Approve"
    }),
    onClick: handleItemAccept,
    disabled: sendButtonDisabled
  }) : null))));
}
var theme = getTheme$1();
var contentStyles = mergeStyleSets({
  containerTextField: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
    width: 1000,
    height: 750
  },
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
    width: 1000,
    height: 570
  },
  header: [theme.fonts.large, {
    flex: "1 1 auto",
    borderTop: "4px solid ".concat(theme.palette.themePrimary),
    color: theme.palette.neutralPrimary,
    display: "flex",
    alignItems: "center"
  }]
});

var ItemGroupTitle = function ItemGroupTitle(_ref) {
  var iconName = _ref.iconName,
      title = _ref.title;
  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: iconName,
    styles: {
      root: {
        color: DefaultPalette$2.themePrimary,
        marginRight: 6
      }
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "mediumPlus"
  }, title));
};

function ItemGroup(_ref) {
  var title = _ref.title,
      value = _ref.value,
      textToCopy = _ref.textToCopy,
      href = _ref.href,
      horizontal = _ref.horizontal,
      titleWidth = _ref.titleWidth,
      _ref$titleVariant = _ref.titleVariant,
      titleVariant = _ref$titleVariant === void 0 ? "smallPlus" : _ref$titleVariant,
      _ref$textVariant = _ref.textVariant,
      textVariant = _ref$textVariant === void 0 ? "medium" : _ref$textVariant,
      tooltipText = _ref.tooltipText,
      _ref$icons = _ref.icons,
      icons = _ref$icons === void 0 ? [] : _ref$icons,
      onIconClick = _ref.onIconClick,
      fieldKey = _ref.fieldKey;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovering = _useState2[0],
      setIsHovering = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isCalloutVisible = _useState4[0],
      toggleIsCalloutVisible = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      copiedIconIndex = _useState6[0],
      setCopiedIconIndex = _useState6[1];

  var descriptionId = useId("description");
  var iconButtonId = useId("iconButton");
  var isRevealed = !/^\*+$/.test(value);
  var stackTokens = {
    childrenGap: 4,
    maxWidth: 300
  };
  var style = titleWidth ? {
    root: {
      paddingRight: 5,
      width: titleWidth
    }
  } : {
    root: {
      paddingRight: 5
    }
  };
  var iconButtonStyles = {
    root: {
      paddingRight: 5,
      color: DefaultPalette$2.blue,
      selectors: {
        "&:hover": {
          cursor: "pointer"
        }
      }
    }
  };
  var labelCalloutStackStyles = {
    root: {
      padding: 20
    }
  };

  var handleIconClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(icon, index) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(icon.iconType === "COPY_ICON" && !isRevealed)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!(icon.iconType === "COPY_ICON")) {
                _context.next = 15;
                break;
              }

              _context.prev = 3;
              _context.next = 6;
              return navigator.clipboard.writeText(textToCopy || value);

            case 6:
              setCopiedIconIndex(index);
              setTimeout(function () {
                return setCopiedIconIndex(null);
              }, 3000);
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              console.error("Failed to copy text: ", _context.t0);

            case 13:
              _context.next = 16;
              break;

            case 15:
              if (onIconClick) {
                onIconClick(fieldKey, icon.iconType, icon.action);
              }

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));

    return function handleIconClick(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    styles: {
      root: {
        minWidth: 250
      }
    },
    onMouseEnter: function onMouseEnter() {
      return setIsHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovering(false);
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: horizontal
  }, title ? /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: titleVariant,
    styles: style
  }, title, ":"), tooltipText && /*#__PURE__*/React__default.createElement(Icon, {
    id: iconButtonId,
    iconName: "Info",
    callOutText: HTMLToString(tooltipText),
    title: HTMLToString(tooltipText),
    onClick: function onClick() {
      return toggleIsCalloutVisible(true);
    },
    styles: iconButtonStyles
  })) : null, href ? /*#__PURE__*/React__default.createElement(Link$1, {
    href: href,
    styles: {
      root: {
        selectors: {
          "&:hover": {
            textDecoration: "none"
          }
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: textVariant
  }, value)) : /*#__PURE__*/React__default.createElement(Text, {
    variant: textVariant
  }, value)), icons.length > 0 && /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center"
  }, icons.map(function (iconObj, index) {
    // Determine which icon to use based on revealed state
    var iconToUse = isRevealed && iconObj.toggledIcon ? iconObj.toggledIcon : iconObj.icon;
    var iconStyleDto = iconToUse.styleIconDto; // Check if the copy icon should be visible

    var isCopyDisabled = iconToUse.iconType === "COPY_ICON" && !isRevealed; // Determine visibility based on limitToHovering setting

    var isVisible = !iconStyleDto.limitToHovering || iconStyleDto.limitToHovering && isHovering; //Determine tooltip content

    var tooltipContent;

    if (copiedIconIndex === index) {
      tooltipContent = iconStyleDto.onClickTooltip || i18n._(
      /*i18n*/
      {
        id: "Copied!"
      });
    } else {
      tooltipContent = iconStyleDto.mouseOverToolTip;
    }

    return /*#__PURE__*/React__default.createElement(TooltipHost, {
      key: index,
      content: isCopyDisabled ? i18n._(
      /*i18n*/
      {
        id: "Cannot copy masked value"
      }) : tooltipContent,
      directionalHint: DirectionalHint.topLeftEdge
    }, /*#__PURE__*/React__default.createElement(Stack, {
      horizontalAlign: "center",
      verticalAlign: "center",
      styles: {
        root: {
          width: 40,
          height: 50,
          marginLeft: 16,
          visibility: isVisible ? "visible" : "hidden",
          cursor: isCopyDisabled ? "not-allowed" : "pointer",
          opacity: isCopyDisabled ? 0.5 : 1,
          selectors: {
            "&:hover": {
              backgroundColor: isCopyDisabled ? "transparent" : DefaultPalette$2.neutralLight
            }
          }
        }
      },
      onClick: function onClick() {
        return !isCopyDisabled && handleIconClick(iconToUse, index);
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      iconName: iconStyleDto.key
    })));
  })), isCalloutVisible && tooltipText && /*#__PURE__*/React__default.createElement(Callout, {
    target: "#" + iconButtonId,
    setInitialFocus: true,
    onDismiss: function onDismiss() {
      return toggleIsCalloutVisible(false);
    },
    ariaDescribedBy: descriptionId,
    role: "alertdialog"
  }, /*#__PURE__*/React__default.createElement(Stack, {
    tokens: stackTokens,
    horizontalAlign: "start",
    styles: labelCalloutStackStyles
  }, /*#__PURE__*/React__default.createElement("span", {
    id: descriptionId,
    style: {
      whiteSpace: "pre-wrap"
    }
  }, HTMLToString(tooltipText)))));
}

/**
 * @description Flex wraped itemGroups
 * @param {object} props
 *  @param {string} key Uniq key
 *  @param {string=} iconName Group title icon
 *  @param {string=} title Group title text
 *  @param {Array} fieldCategories
 *    @param {object}
 *      @param {string} key Uniq key
 *      @param {string=} iconName
 *      @param {string=} title
 *      @param {Array} fields
 *        @param {object}
 *          @param {string} key Uniq key
 *          @param {string=} title Group item title
 *          @param {string=} value Group item value
 *          @param {string=} href Group item link
 */

var FlexWrapedItemGroups = function FlexWrapedItemGroups(props) {
  var iconName = props.iconName,
      title = props.title,
      _props$fieldCategorie = props.fieldCategories,
      fieldCategories = _props$fieldCategorie === void 0 ? [] : _props$fieldCategorie,
      onIconClick = props.onIconClick,
      getFieldValue = props.getFieldValue;
  return /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 16
    },
    styles: {
      root: {
        backgroundColor: "transparent",
        borderBottom: "1px solid ".concat(DefaultPalette$2.neutralLight),
        margin: 15
      }
    }
  }, /*#__PURE__*/React__default.createElement(ItemGroupTitle, {
    iconName: iconName,
    title: title
  }), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "top",
    styles: {
      root: {
        backgroundColor: "transparent",
        paddingLeft: 10,
        flexWrap: "wrap"
      }
    }
  }, fieldCategories.map(function (item) {
    return /*#__PURE__*/React__default.createElement(Text, {
      key: item.key
    }, item.title && /*#__PURE__*/React__default.createElement(ItemGroupTitle, {
      iconName: item.iconName ? item.iconName : "",
      title: item.title
    }), /*#__PURE__*/React__default.createElement(Stack, {
      styles: {
        root: {
          paddingBottom: 20
        }
      }
    }, item.fields.map(function (itemGroup) {
      return /*#__PURE__*/React__default.createElement(Stack, {
        key: itemGroup.key,
        styles: {
          root: {
            paddingTop: item.title ? 10 : 0,
            minWidth: 300
          }
        }
      }, /*#__PURE__*/React__default.createElement(ItemGroup, {
        fieldKey: itemGroup.key,
        title: itemGroup.title ? itemGroup.title : "",
        value: getFieldValue ? getFieldValue(itemGroup) : itemGroup.value,
        textToCopy: itemGroup.textToCopy ? itemGroup.textToCopy : "",
        href: itemGroup.href ? itemGroup.href : "",
        horizontal: itemGroup.horizontal ? itemGroup.horizontal : false,
        titleVariant: itemGroup.titleVariant ? itemGroup.titleVariant : undefined,
        textVariant: itemGroup.textVariant ? itemGroup.textVariant : undefined,
        icons: itemGroup.icons ? itemGroup.icons : [],
        onIconClick: onIconClick
      }));
    })));
  })));
};

/**
 * @description Employment boxes
 * @param {object} props
 *  @param {setAsPrimaryPosition} setAsPrimaryPosition
 *  @param {object} employment
 *    @param {string} name
 *    @param {string} activeFrom
 *    @param {string} activeTo
 *    @param {string} master
 *    @param {boolean} isUserAccount
 *    @param {string=} manager
 *    @param {object=} orgUnit
 *    @param {string=} name Group item text
 *    @param {string=} organisationName Group item link
 *  @param {Function} setEditPostion Edit handler
 *  @param {boolean=} canEditPosition Should show edit button: true/false
 */

function Employment(props) {
  var id = props.id,
      employment = props.employment,
      _props$isUserAccount = props.isUserAccount,
      isUserAccount = _props$isUserAccount === void 0 ? false : _props$isUserAccount,
      setEditPostion = props.setEditPostion,
      _props$canEditPositio = props.canEditPosition,
      canEditPosition = _props$canEditPositio === void 0 ? false : _props$canEditPositio,
      setAsPrimaryPosition = props.setAsPrimaryPosition,
      isPrimary = props.primary;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      hireDate = _useState2[0],
      setHireDate = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      leaveDate = _useState4[0],
      setLeaveDate = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      originCreated = _useState6[0],
      setOriginCreated = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      fields = _useState8[0],
      setFields = _useState8[1]; // Date handler


  useEffect(function () {
    if (!employment) return;
    if (employment.fields) setFields(employment.fields);
    if (employment.hireDate && employment.hireDate !== null) setHireDate(formatDateTime(employment.hireDate));
    if (employment.leaveDate && employment.leaveDate !== null) setLeaveDate(formatDateTime(employment.leaveDate));
    if (employment.originCreated && employment.originCreated !== null) setOriginCreated(formatDateTime(employment.originCreated));
  }, [employment]);
  if (!employment) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  return /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        minWidth: "200px",
        minHeight: "50px",
        padding: "10px",
        border: "1px solid ".concat(isPrimary ? DefaultPalette$2.themePrimary : DefaultPalette$2.neutralLight)
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    enableScopedSelectors: true,
    styles: {
      root: {
        marginBottom: 10,
        width: "100%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "Org",
    styles: {
      root: {
        color: DefaultPalette$2.green,
        padding: 8,
        fontSize: 14,
        border: "1px solid ".concat(DefaultPalette$2.themeLight),
        borderRadius: "50%",
        backgroundColor: DefaultPalette$2.white
      }
    }
  })), /*#__PURE__*/React__default.createElement(Stack, {
    verticalAlign: "center",
    grow: true
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium",
    styles: {
      root: {
        margin: "0 0 0px 14px"
      }
    }
  }, employment.name), employment.orgTitle && /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xSmall",
    styles: {
      root: {
        margin: "0 0 0px 14px"
      }
    }
  }, employment.orgTitle, employment.adminTitle ? /*#__PURE__*/React__default.createElement("br", null) : "", employment.adminTitle))), !isUserAccount && /*#__PURE__*/React__default.createElement(TooltipHost, {
    id: "".concat(id, "_tooltip"),
    content: isPrimary ? i18n._(
    /*i18n*/
    {
      id: "Primary employment"
    }) : i18n._(
    /*i18n*/
    {
      id: "Set as primary employment"
    })
  }, isPrimary ? /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "FavoriteStarFill",
    styles: {
      root: {
        color: DefaultPalette$2.themePrimary,
        padding: 8,
        fontSize: 14,
        borderRadius: "50%"
      }
    }
  }) : /*#__PURE__*/React__default.createElement(IconButton, {
    iconProps: {
      iconName: "FavoriteStar"
    },
    styles: {
      root: {
        padding: 8,
        fontSize: 14,
        borderRadius: "50%"
      }
    },
    onClick: function onClick() {
      return setAsPrimaryPosition(employment.id);
    }
  })), !isUserAccount && canEditPosition && /*#__PURE__*/React__default.createElement(Stack, {
    align: "end"
  }, /*#__PURE__*/React__default.createElement(TooltipHost, {
    id: id,
    content: i18n._(
    /*i18n*/
    {
      id: "Edit employment"
    })
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    iconName: employment.readOnly ? "Uneditable2" : "Edit",
    disabled: employment.readOnly,
    styles: {
      root: {
        padding: 8,
        fontSize: 14,
        borderRadius: "50%"
      }
    },
    iconProps: {
      iconName: employment.readOnly ? "Uneditable2" : "Edit"
    },
    onClick: setEditPostion
  })))), !isUserAccount ? /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(ItemGroup, {
    title: i18n._(
    /*i18n*/
    {
      id: "Active from"
    }),
    value: hireDate ? hireDate : "-",
    copyable: false,
    horizontal: true,
    titleVariant: "small",
    textVariant: "small",
    titleWidth: 70
  }), /*#__PURE__*/React__default.createElement(ItemGroup, {
    title: i18n._(
    /*i18n*/
    {
      id: "Active to"
    }),
    value: leaveDate ? leaveDate : "-",
    copyable: false,
    horizontal: true,
    titleVariant: "small",
    textVariant: "small",
    titleWidth: 70
  })), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        paddingTop: "10px",
        paddingBottom: "5px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(ItemGroup, {
    title: i18n._(
    /*i18n*/
    {
      id: "Manager employment"
    }),
    value: employment.manager ? i18n._(
    /*i18n*/
    {
      id: "Yes"
    }) : i18n._(
    /*i18n*/
    {
      id: "No"
    }),
    copyable: false,
    horizontal: true,
    titleVariant: "small",
    textVariant: "small"
  })), /*#__PURE__*/React__default.createElement(Stack, null, fields.map(function (field, index) {
    return /*#__PURE__*/React__default.createElement(Stack, {
      key: index
    }, /*#__PURE__*/React__default.createElement(ItemGroup, {
      title: field.title,
      value: field.value,
      copyable: field.copyable,
      tooltipText: field.tooltipText,
      horizontal: true,
      titleVariant: "small",
      textVariant: "small"
    }));
  }))) :
  /*#__PURE__*/

  /* Created */
  // IIV01-6298 TODO: Removed until BE returns orginCreated = when user is created in AD

  /*
  <ItemGroup
    title={i18n._(t`Created`)}
    value={originCreated ? originCreated : "-"}
    copyable={false}
    horizontal={true}
    titleVariant="small"
    textVariant="small"
    titleWidth={70}
  />
  */
  React__default.createElement(React__default.Fragment, null));
}

var translatedKeys = {
  home: i18n._(
  /*i18n*/
  {
    id: "Home"
  }),
  work: i18n._(
  /*i18n*/
  {
    id: "Work"
  }),
  mobile: i18n._(
  /*i18n*/
  {
    id: "Mobile"
  }),
  "default": i18n._(
  /*i18n*/
  {
    id: "Default"
  }),
  nationalId: i18n._(
  /*i18n*/
  {
    id: "Social Security number"
  })
};
/**
 * @description Profile informations
 * @param {object} props
 *  @param {string} tenant Tenant
 *  @param {boolean=} showEmployments Should show employments: true/false
 *  @param {boolean=} canEditPosition Should show edit button: true/false
 *  @param {object} profileInformation
 *    @param {string} key Uniq key
 *    @param {string=} title Group item title
 *    @param {string=} text Group item text
 *    @param {string=} href Group item link
 */

var Profile = function Profile(props) {
  var item = props.item,
      tenant = props.tenant,
      _props$showEmployment = props.showEmployments,
      showEmployments = _props$showEmployment === void 0 ? true : _props$showEmployment,
      _props$canEditPositio = props.canEditPosition,
      canEditPosition = _props$canEditPositio === void 0 ? false : _props$canEditPositio,
      setAsPrimaryPosition = props.setAsPrimaryPosition,
      apiCall = props.apiCall,
      urls = props.urls;
  var fieldInformation = item.fieldInformation,
      userAccount = item.userAccount; // TODO - Remove when BE returns profileInformation

  var positions = item.positions,
      emails = item.emails,
      phoneNumbers = item.phoneNumbers,
      otherInformation = item.otherInformation,
      displayname = item.displayname,
      id = item.id,
      userName = item.userName,
      salaryNumber = item.salaryNumber;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      contactInformations = _useState2[0],
      setContactInformations = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      otherInformations = _useState4[0],
      setOtherInformations = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      userAccountInformations = _useState6[0],
      setUserAccountInformations = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      employments = _useState8[0],
      setEmployments = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      accounts = _useState10[0],
      setAccounts = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      fieldCategories = _useState12[0],
      setFieldCategories = _useState12[1];

  var _useState13 = useState({}),
      _useState14 = _slicedToArray(_useState13, 2),
      fieldStates = _useState14[0],
      setFieldStates = _useState14[1];

  useEffect(function () {
    // TODO - Remove if when BE returns profileInformation
    if (!fieldInformation) {
      setContactInformations([{
        key: "label_emails",
        iconName: "Mail",
        title: i18n._(
        /*i18n*/
        {
          id: "Emails"
        }),
        fields: Object.keys(emails).map(function (type) {
          return {
            key: "emails".concat(type),
            title: translatedKeys[type],
            value: emails[type] ? emails[type] : i18n._(
            /*i18n*/
            {
              id: "No email addresses listed"
            }),
            href: emails[type] ? "mailto:".concat(emails[type]) : ""
          };
        })
      }, {
        key: "label_phoneNumbers",
        iconName: "Phone",
        title: i18n._(
        /*i18n*/
        {
          id: "Phone Numbers"
        }),
        fields: Object.keys(phoneNumbers).map(function (type) {
          return {
            key: "phones".concat(type),
            title: translatedKeys[type],
            value: phoneNumbers[type] ? phoneNumbers[type] : i18n._(
            /*i18n*/
            {
              id: "No phone numbers listed"
            })
          };
        })
      }]);
      setOtherInformations([{
        key: "label_displayname",
        iconName: "",
        title: "",
        fields: [{
          key: "displayname",
          title: i18n._(
          /*i18n*/
          {
            id: "Display name"
          }),
          value: displayname ? displayname : i18n._(
          /*i18n*/
          {
            id: "No display name listed"
          })
        }]
      }, {
        key: "label_salaryNumber",
        iconName: "",
        title: "",
        fields: [{
          key: "salarynumber",
          title: i18n._(
          /*i18n*/
          {
            id: "Salary number"
          }),
          value: salaryNumber ? salaryNumber : i18n._(
          /*i18n*/
          {
            id: "No salary number listed"
          })
        }]
      }]);
      setUserAccountInformations([{
        key: "label_id",
        iconName: "",
        title: "",
        fields: [{
          key: "id",
          title: i18n._(
          /*i18n*/
          {
            id: "User ID"
          }),
          value: id
        }]
      }, {
        key: "label_otherInformation",
        iconName: "",
        title: "",
        fields: Object.keys(otherInformation).map(function (type) {
          return {
            key: "otherinformation".concat(type),
            title: translatedKeys[type],
            value: otherInformation[type] ? otherInformation[type] : i18n._(
            /*i18n*/
            {
              id: "No {0} listed",
              values: {
                0: translatedKeys[type]
              }
            })
          };
        })
      }, {
        key: "label_userLogin",
        iconName: "",
        title: "",
        fields: [{
          key: "userlogin",
          title: i18n._(
          /*i18n*/
          {
            id: "User Login"
          }),
          value: "".concat(userName, " @ ").concat(tenant)
        }]
      }]);
    } else setFieldCategories(fieldInformation);
  }, [positions, emails, phoneNumbers, otherInformation, displayname, id, userName, tenant, salaryNumber]);
  useEffect(function () {
    if (!userAccount) return;
    userAccount.map(function (account) {
      account.orgTitle = "".concat(account.orgUnit.name, " (").concat(account.orgUnit.organisationName, ")");
      return account;
    });
    setAccounts(userAccount);
  }, [userAccount]);
  useEffect(function () {
    if (!positions) return;
    var pos = undefined;

    if (positions.administrative && positions.employments) {
      pos = positions.employments.concat(positions.administrative);
    }

    setEmployments(filterPositions(pos || positions));
  }, [positions]);

  function filterPositions(positions) {
    var positionsToRemove = [];
    positions.map(function (p) {
      if (p.orgUnit.organisationType === "PAYROLL") {
        var field = p.fields.find(function (field) {
          return field.key === "position_employmentnumber";
        });
        var employmentNumber = field && field.value ? field.value : null;
        var adminPosition = findAdminPosition(employmentNumber, positions);

        if (adminPosition) {
          positionsToRemove.push(adminPosition);
          p.adminPosition = adminPosition.orgUnit;
          p.orgTitle = "".concat(p.orgUnit.name, " (").concat(p.orgUnit.organisationName, ")");
          p.adminTitle = "".concat(adminPosition.orgUnit.name, " (").concat(adminPosition.orgUnit.organisationName, ")");
          p = _objectSpread2(_objectSpread2({}, p), mapDifferences(p, adminPosition));
        } else {
          p.orgTitle = "".concat(p.orgUnit.name, " (").concat(p.orgUnit.organisationName, ")");
        }
      } else {
        p.orgTitle = "".concat(p.orgUnit.name, " (").concat(p.orgUnit.organisationName, ")");
      }

      return p;
    });
    return positions.filter(function (p) {
      return !positionsToRemove.includes(p);
    });
  }

  function findAdminPosition(employmentNumber, positions) {
    return positions.find(function (p) {
      var _p$fields$find;

      return p.orgUnit.organisationType === "ADMINISTRATIVE" && ((_p$fields$find = p.fields.find(function (field) {
        return field && field.key === "position_employmentnumber";
      })) === null || _p$fields$find === void 0 ? void 0 : _p$fields$find.value) === employmentNumber;
    });
  }

  function mapDifferences(payroll, admin) {
    var newObj = {};
    var exeptedKeys = ["orgUnit", "adminPosition", "id"];
    Object.keys(payroll).forEach(function (key) {
      if (exeptedKeys.includes(key)) return;

      if (payroll[key] !== admin[key] && (payroll[key] === null || payroll[key] === undefined)) {
        newObj[key] = admin[key];
      }
    });
    return newObj;
  }

  function handlePrimaryPositionChange(id) {
    var updatedEmployments = employments.map(function (e) {
      return _objectSpread2(_objectSpread2({}, e), {}, {
        primary: e.id === id ? true : false
      });
    });
    setEmployments(updatedEmployments);
    setAsPrimaryPosition(id).then(function (success) {
      if (!success) {
        setEmployments(employments);
      }
    });
  }

  var handleIconClick = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fieldKey, iconType, action) {
      var _fieldStates$fieldKey, endpoint, url, res;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(iconType === "EYE_ICON" || iconType === "EYE_HIDE_ICON")) {
                _context.next = 17;
                break;
              }

              _context.prev = 1;

              if (!((_fieldStates$fieldKey = fieldStates[fieldKey]) !== null && _fieldStates$fieldKey !== void 0 && _fieldStates$fieldKey.isRevealed)) {
                _context.next = 6;
                break;
              }

              // Toggle back to original value
              setFieldStates(function (prev) {
                return _objectSpread2(_objectSpread2({}, prev), {}, _defineProperty({}, fieldKey, _objectSpread2(_objectSpread2({}, prev[fieldKey]), {}, {
                  isRevealed: false
                })));
              });
              _context.next = 12;
              break;

            case 6:
              // Fetch value from API
              endpoint = action.endpoint.replace("{userId}", item.id);
              url = "".concat(urls.api.base).concat(endpoint);
              _context.next = 10;
              return apiCall.get(url);

            case 10:
              res = _context.sent;
              // Store the real value and mark as revealed
              setFieldStates(function (prev) {
                return _objectSpread2(_objectSpread2({}, prev), {}, _defineProperty({}, fieldKey, {
                  realValue: res.nationalId,
                  isRevealed: true
                }));
              });

            case 12:
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              console.error("Error fetching data:", _context.t0);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(), [item.id, urls, apiCall, fieldStates]); // Function to get field value with overrides

  var getFieldValue = function getFieldValue(field) {
    var state = fieldStates[field.key];

    if (state !== null && state !== void 0 && state.isRevealed) {
      return state.realValue;
    }

    return field.value;
  };

  return /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "top",
    styles: {
      root: {
        flexWrap: "wrap"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    style: {
      flex: 1,
      flexWrap: "wrap",
      flexDirection: "row"
    }
  }, contactInformations.length > 0 && /*#__PURE__*/React__default.createElement(FlexWrapedItemGroups, {
    iconName: "ContactInfo",
    title: i18n._(
    /*i18n*/
    {
      id: "Contact Information"
    }),
    fieldCategories: contactInformations
  }), otherInformations.length > 0 && /*#__PURE__*/React__default.createElement(FlexWrapedItemGroups, {
    iconName: "Info",
    title: i18n._(
    /*i18n*/
    {
      id: "Other informations"
    }),
    fieldCategories: otherInformations
  }), userAccountInformations.length > 0 && /*#__PURE__*/React__default.createElement(FlexWrapedItemGroups, {
    iconName: "Badge",
    title: i18n._(
    /*i18n*/
    {
      id: "User account"
    }),
    fieldCategories: userAccountInformations
  }), fieldCategories && fieldCategories.length > 0 && fieldCategories.map(function (i) {
    return /*#__PURE__*/React__default.createElement(FlexWrapedItemGroups, {
      key: i.key,
      iconName: i.iconName,
      title: i.title,
      fieldCategories: i.fieldCategories,
      getFieldValue: getFieldValue,
      onIconClick: handleIconClick
    });
  })), showEmployments && /*#__PURE__*/React__default.createElement(Text, {
    style: {
      flex: 1,
      flexWrap: "wrap",
      flexDirection: "row",
      maxWidth: 400,
      borderLeft: "1px solid ".concat(DefaultPalette$2.neutralLight),
      paddingLeft: 15
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 16
    },
    styles: {
      root: {
        paddingTop: 15
      }
    }
  }, /*#__PURE__*/React__default.createElement(ItemGroupTitle, {
    iconName: "Work",
    title: i18n._(
    /*i18n*/
    {
      id: "User accounts"
    })
  }), accounts && accounts.length > 0 && accounts.map(function (position) {
    return /*#__PURE__*/React__default.createElement(Employment, {
      key: position.id,
      employment: position,
      isUserAccount: true
    });
  }), employments && employments.length > 0 && /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 16
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    styles: {
      root: {
        justifyContent: "space-between"
      }
    }
  }, /*#__PURE__*/React__default.createElement(ItemGroupTitle, {
    iconName: "Work",
    title: i18n._(
    /*i18n*/
    {
      id: "Employments"
    })
  })), employments.map(function (position) {
    return /*#__PURE__*/React__default.createElement(Employment, {
      key: position.id,
      employment: position,
      setEditPostion: function setEditPostion() {
        props.setEditPostion(position.id);
      },
      canEditPosition: canEditPosition,
      setAsPrimaryPosition: handlePrimaryPositionChange,
      primary: position.primary
    });
  })))));
};

/**
 * @description A card component that displays a title, description, and options.
 * @param {Array} options - An array of options to display in the card.
 * @param {String} title - The title of the card.
 * @param {String} description - The description of the card.
 * @param {String} icon - The icon to display in the card.
 * @param {Number} elevation - The elevation of the card.
 * @param {Function} onRenderFooter - The footer of the card.
 * @param {Number} iconSize - The size of the icon.
 * @param {String} iconColor - The color of the icon.
 * @param {Function} onRenderHeader - A function that renders the header of the card.
 * @param {Function} onRenderDescription - A function that renders the description of the card.
 * @returns {JSX} A card component.
 */

function Card(props) {
  var title = props.title,
      description = props.description,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      elevation = props.elevation,
      onRenderHeader = props.onRenderHeader,
      onRenderDescription = props.onRenderDescription,
      onRenderOptions = props.onRenderOptions,
      clickOnCard = props.clickOnCard,
      iconProps = props.iconProps;
  var iconName = iconProps.iconName,
      _iconProps$iconSize = iconProps.iconSize,
      iconSize = _iconProps$iconSize === void 0 ? 60 : _iconProps$iconSize,
      _iconProps$iconColor = iconProps.iconColor,
      iconColor = _iconProps$iconColor === void 0 ? "#4992db" : _iconProps$iconColor;
  var isCardClickable = clickOnCard ? true : false;

  var boxShadow = function boxShadow() {
    if (!elevation) return DefaultEffects$2.elevation8;
    return elevation === 4 ? DefaultEffects$2.elevation4 : elevation === 8 ? DefaultEffects$2.elevation8 : elevation === 16 ? DefaultEffects$2.elevation16 : elevation === 32 ? DefaultEffects$2.elevation32 : elevation === 64 ? DefaultEffects$2.elevation64 : DefaultEffects$2.elevation8;
  };

  var buttonStyle = {
    background: "none",
    border: "none",
    padding: "0",
    color: "#4992db",
    outline: "inherit",
    cursor: "pointer",
    fontWeight: "bold"
  };
  var stackStyle = clickOnCard ? {
    root: {
      borderRadius: "5px",
      width: "300px",
      height: "320px",
      padding: "10px",
      boxShadow: boxShadow(),
      transition: "all 0.2s ease-in-out",
      selectors: {
        "&:hover": {
          boxShadow: DefaultEffects$2.elevation16,
          backgroundColor: "#fff",
          cursor: "pointer"
        }
      }
    }
  } : {
    root: {
      borderRadius: "5px",
      width: "300px",
      height: "fit-content",
      padding: "10px",
      boxShadow: boxShadow(),
      transition: "all 0.2s ease-in-out"
    }
  };
  return /*#__PURE__*/React__default.createElement(Stack, {
    onClick: isCardClickable ? clickOnCard : function () {},
    styles: stackStyle
  }, onRenderHeader ? onRenderHeader : /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        textAlign: "Center",
        flex: "0 1 auto"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "large",
    styles: {
      root: {
        marginBottom: "10px"
      }
    }
  }, /*#__PURE__*/React__default.createElement("b", null, title))), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        textAlign: "Center",
        flex: "0 1 auto"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    styles: {
      root: {
        fontSize: iconSize,
        color: iconColor
      }
    },
    iconName: iconName
  })), /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        flex: "1 1 auto"
      }
    }
  }, onRenderDescription ? onRenderDescription : /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        marginTop: "20px",
        padding: "0px 20px 0px 20px",
        alignItems: "center"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "medium"
  }, description))), /*#__PURE__*/React__default.createElement(Separator, null), /*#__PURE__*/React__default.createElement(DialogFooter, null, /*#__PURE__*/React__default.createElement(Stack, null, onRenderOptions ? onRenderOptions : options.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement("button", {
      key: index,
      style: buttonStyle
    }, option);
  }))));
}

/** Gets KLE numbers from localStorage or the API, in that order. When getting
 * the KLEs from localStorage it calls the API for a checksum, and compares it
 * to the one stored locally. If they don't match, it gets a new list of KLEs
 * from the API.
 * @param {object} apiCall The specific `apiCall` for the application.
 * @returns An array of two values; kles and isFetchingKles.
 */

function useKles(apiCall) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isFetchingKles = _useState2[0],
      setIsFetchingKles = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      kles = _useState4[0],
      setKles = _useState4[1];

  var _useLocalStorage = useLocalStorage("kles"),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      localKles = _useLocalStorage2[0],
      setLocalKles = _useLocalStorage2[1];

  var getKles = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var get, urls, data, newKles, _iterator, _step, kle, newKle;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            get = apiCall.get, urls = apiCall.urls;
            _context.next = 3;
            return get(urls.api.kle);

          case 3:
            data = _context.sent;
            newKles = {
              checksum: data.checksum,
              active: [],
              inactive: [],
              numberToItemMap: {}
            };
            _iterator = _createForOfIteratorHelper(data.kles);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                kle = _step.value;
                newKle = createKleDetail(kle);

                if (kle.includes("[udgået]")) {
                  newKles.inactive.push(newKle);
                } else {
                  newKles.active.push(newKle);
                }

                newKles.numberToItemMap[newKle.number] = newKle;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            setKles(newKles);
            setIsFetchingKles(false);
            setLocalKles(newKles);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [apiCall]);
  var createKleDetail = useCallback(function (kle) {
    var _kle$split = kle.split(" "),
        _kle$split2 = _toArray(_kle$split),
        number = _kle$split2[0],
        words = _kle$split2.slice(1);

    var _number$split = number.split("."),
        _number$split2 = _slicedToArray(_number$split, 1),
        subject = _number$split2[0];

    var name = words.join(" ");
    return {
      kle: kle,
      number: number,
      subject: subject,
      name: name
    };
  }, []);
  var checkIfExpired = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            //const { get, urls } = apiCall;
            //const { checksum } = await get(`${urls.api.kle}/checksum`);
            //if (checksum !== localKles.checksum) {
            getKles(); //  return;
            //}

            setKles(localKles);
            setIsFetchingKles(false);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [getKles, setIsFetchingKles, setKles]);
  useEffect(function () {
    if (!localKles) {
      getKles();
    } else {
      checkIfExpired();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return [kles, isFetchingKles];
}

/**
 * Provides a means to call the API endpoints and redirect to a login page when
 * the user isn't logged in.
 * @param {Object} options Options object which can include:
 *   @param {Object} urls .env based urls for the api.
 *   @param {Function} logger Any logging function.
 *   @param {Object} notifications Notifications object.
 */

var ApiCall = function ApiCall(_options) {
  var _this = this;

  _classCallCheck(this, ApiCall);

  _defineProperty(this, "get", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, options, parameters) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this._fetch("GET", url, options, parameters);

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }());

  _defineProperty(this, "put", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, options) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this._fetch("PUT", url, options);

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }());

  _defineProperty(this, "post", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url, options) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this._fetch("POST", url, options);

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x6, _x7) {
      return _ref3.apply(this, arguments);
    };
  }());

  _defineProperty(this, "delete", /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url, options) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this._fetch("DELETE", url, options);

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x8, _x9) {
      return _ref4.apply(this, arguments);
    };
  }());

  _defineProperty(this, "_fetch", /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(method, url) {
      var options,
          parameters,
          lang,
          timezone,
          displayNotification,
          defaultSuccessMessage,
          newUrl,
          i,
          res,
          envName,
          appUrl,
          e,
          frontendError,
          contentDispositionHeaderContent,
          filename,
          file,
          _result$frontend,
          result,
          _err$frontend,
          _args5 = arguments;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
              parameters = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : {};
              lang = getPreferredLanguage();
              timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
              displayNotification = options.displayNotification || false;
              defaultSuccessMessage = options === null || options === void 0 ? void 0 : options.defaultSuccessMessage;
              delete options.displayNotification;
              delete options.defaultSuccessMessage; // Create a new URL object with language and timezone search params

              newUrl = new URL(url);
              newUrl.searchParams.append("lang", lang);
              newUrl.searchParams.append("timezone", timezone);

              for (i in parameters) {
                newUrl.searchParams.append(i, parameters[i]);
              }

              _context5.prev = 12;
              _context5.next = 15;
              return fetch(newUrl, _objectSpread2(_objectSpread2(_objectSpread2({
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json"
                }
              }, options), _this._corsOptions), {}, {
                method: method
              }));

            case 15:
              res = _context5.sent;

              if (res.ok) {
                _context5.next = 18;
                break;
              }

              throw res;

            case 18:
              _context5.next = 41;
              break;

            case 20:
              _context5.prev = 20;
              _context5.t0 = _context5["catch"](12);

              if (!((_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.status) === 401)) {
                _context5.next = 27;
                break;
              }

              window.location.href = "".concat(_this.urls.login, "?returnTo=").concat(encodeURIComponent(window.location.href));
              throw _context5.t0;

            case 27:
              if (!((_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.status) === 403)) {
                _context5.next = 34;
                break;
              }

              envName = "REACT_APP_".concat(process.env.REACT_APP_NAME.toUpperCase(), "_URL");
              appUrl = "".concat(process.env[envName], "/access-denied");
              window.location.href = appUrl;
              throw _context5.t0;

            case 34:
              _context5.next = 36;
              return _context5.t0.json();

            case 36:
              e = _context5.sent;
              frontendError = e.frontend;

              if (displayNotification && frontendError !== null && frontendError !== void 0 && frontendError.message && _this.notifications !== undefined) {
                _this.notifications.setError(function () {
                  return frontendError.message;
                }, true, e !== null && e !== void 0 && e.traceId ? e === null || e === void 0 ? void 0 : e.traceId : undefined);
              }

              _this._log("There was an error:", _context5.t0);

              throw _context5.t0;

            case 41:
              if (!(res.headers.get("Pragma") !== null && res.headers.get("Pragma").indexOf("attachment;") !== -1)) {
                _context5.next = 48;
                break;
              }

              // We are passing along the `Content-Disposition` header in the `Pragma`
              // header, to avoid CORS issues. The `Content-Disposition` header contains
              // the filename.
              contentDispositionHeaderContent = res.headers.get("Pragma");
              filename = contentDispositionHeaderContent.split("=")[1] // Remove the doublequotes at either end of the filename
              .slice(1, -1);
              _context5.next = 46;
              return res.blob();

            case 46:
              file = _context5.sent;
              return _context5.abrupt("return", {
                file: file,
                filename: filename
              });

            case 48:
              _context5.prev = 48;
              _context5.next = 51;
              return res.json();

            case 51:
              result = _context5.sent;

              if (displayNotification && _this.notifications !== undefined && (defaultSuccessMessage || result !== null && result !== void 0 && (_result$frontend = result.frontend) !== null && _result$frontend !== void 0 && _result$frontend.message)) {
                _this.notifications.setSuccess(function () {
                  var _result$frontend2;

                  return ((_result$frontend2 = result.frontend) === null || _result$frontend2 === void 0 ? void 0 : _result$frontend2.message) || defaultSuccessMessage;
                }, true, result !== null && result !== void 0 && result.traceId ? result.traceId : undefined);
              }

              return _context5.abrupt("return", result);

            case 56:
              _context5.prev = 56;
              _context5.t1 = _context5["catch"](48);

              if (displayNotification && _context5.t1 !== null && _context5.t1 !== void 0 && (_err$frontend = _context5.t1.frontend) !== null && _err$frontend !== void 0 && _err$frontend.message && _this.notifications !== undefined) {
                _this.notifications.setError(function () {
                  return _context5.t1.frontend.message;
                }, true, _context5.t1.traceId ? _context5.t1.traceId : undefined);
              }

              return _context5.abrupt("return", res);

            case 60:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[12, 20], [48, 56]]);
    }));

    return function (_x10, _x11) {
      return _ref5.apply(this, arguments);
    };
  }());

  _defineProperty(this, "_log", function (message) {
    _this._logger(message);
  });

  var urls = _options.urls,
      logger = _options.logger,
      notifications = _options.notifications;
  this.urls = urls;
  this._logger = logger;
  this.notifications = notifications;
  this._corsOptions = {
    mode: "cors",
    credentials: "include"
  };
  this._minRedirectInterval = 6000;
} // Request utility method
;

// NavBar constants
var LOCAL_NAVBARWIDTH_STRING = "navBarWidth";
var DEFAULT_NAVBAR_MIN_WIDTH = 220;
var LOCAL_ISCOLLAPSED_STRING = "isCollapsed";
var DEFAULT_NAVBAR_COLLAPSE_STATE = process.env.REACT_APP_NAME !== "role";
var OLD_WIDTH_WHILE_COLLAPSED_STATE_STRING = "widthBeforeCollapse";
var NAVBAR_COLLAPSED_WIDTH = 47; // SelectionMenu constants

var LOCAL_SELECTIONWIDTH_STRING = "selectionWidth";
var DEFAULT_SELECTION_MIN_WIDTH = 320;

/**
 * Gets and sets items to and from localstorage.
 * @returns {string} The string in localstorage (always returns a string)
 */

var LocalUiState = function LocalUiState(_ref) {
  var _this = this;

  var onChanged = _ref.onChanged;

  _classCallCheck(this, LocalUiState);

  _defineProperty(this, "_initializeUiState", function () {
    var _localState;

    var navbarWidth = DEFAULT_NAVBAR_COLLAPSE_STATE ? NAVBAR_COLLAPSED_WIDTH : DEFAULT_NAVBAR_MIN_WIDTH;
    var localState = (_localState = {}, _defineProperty(_localState, LOCAL_NAVBARWIDTH_STRING, _this._useLocalState(LOCAL_NAVBARWIDTH_STRING, navbarWidth)), _defineProperty(_localState, LOCAL_SELECTIONWIDTH_STRING, _this._useLocalState(LOCAL_SELECTIONWIDTH_STRING, DEFAULT_SELECTION_MIN_WIDTH)), _defineProperty(_localState, LOCAL_ISCOLLAPSED_STRING, _this._useLocalState(LOCAL_ISCOLLAPSED_STRING, DEFAULT_NAVBAR_COLLAPSE_STATE)), _defineProperty(_localState, OLD_WIDTH_WHILE_COLLAPSED_STATE_STRING, _this._useLocalState(OLD_WIDTH_WHILE_COLLAPSED_STATE_STRING, 0)), _localState);
    return localState;
  });

  _defineProperty(this, "_useLocalState", function (itemName, defaultValue) {
    var item = localStorage.getItem(itemName);

    if (item) {
      // Change strings to appropriate primitives
      if (itemName === LOCAL_ISCOLLAPSED_STRING) return item === "true";
      if (itemName === LOCAL_NAVBARWIDTH_STRING) return Number(item);
      if (itemName === LOCAL_SELECTIONWIDTH_STRING) return Number(item);
      if (itemName === OLD_WIDTH_WHILE_COLLAPSED_STATE_STRING) return Number(item);
      return item;
    }

    localStorage.setItem(itemName, defaultValue);
    return defaultValue;
  });

  _defineProperty(this, "getAll", function () {
    return _this._ui;
  });

  _defineProperty(this, "get", function (name) {
    return _this._ui[name];
  });

  _defineProperty(this, "set", function (item) {
    localStorage.setItem(item.name, item.value);
    _this._ui = _objectSpread2(_objectSpread2({}, _this._ui), {}, _defineProperty({}, item.name, item.value));

    _this._onChanged();
  });

  this._onChanged = onChanged;
  this._ui = this._initializeUiState();
};

var LoggedInUser =
/**
 * Get and maintain a logged in user.
 * @param {Object} options The options for the class.
 *   @param {Object} apiCall urls and utility methods for calling the api.
 *   @param {Function} onChanged Called when the user is updated.
 *   @param {boolean} addDefaultApps Whether to add the test data to apps.
 */
function LoggedInUser() {
  var _this = this;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, LoggedInUser);

  _defineProperty(this, "getLoggedInUser", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(firstAttempt) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.user) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _this._getProfile(firstAttempt);

            case 3:
              return _context.abrupt("return", _this.user);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());

  _defineProperty(this, "_getProfile", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(firstAttempt) {
      var profile;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this._apiCall.get(firstAttempt ? "".concat(_this.profileURL, "?firstAttempt=true") : _this.profileURL);

            case 2:
              profile = _context2.sent;
              _this.user = profile;

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }());

  var apiCall = options.apiCall,
      onChanged = options.onChanged,
      _options$addDefaultAp = options.addDefaultApps,
      addDefaultApps = _options$addDefaultAp === void 0 ? false : _options$addDefaultAp;
  this._apiCall = apiCall;
  this._onChanged = onChanged;
  this._addDefaultApps = addDefaultApps;
  this.profileURL = apiCall.urls.api.me;
  this.user = undefined;
}
/**
 * Gets the logged in user object. If the profile data doesn't
 * exist it starts the process of getting it from the API.
 */
;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;
/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/** Used to generate unique IDs. */

var idCounter = 0;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString$1 = objectProto$1.toString;
/** Built-in value references. */

var Symbol$1 = root$1.Symbol;
/** Used to convert symbols to primitives and strings. */

var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike$1(value) && objectToString$1.call(value) == symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString(value) {
  return value == null ? '' : baseToString(value);
}
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */


function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

var lodash_uniqueid = uniqueId;

var Notifications =
/**
 * Create and maintain a list of notifications.
 * @param {Object} options The options for the Notifications.
 * @param {Function} onNotificationsChanged Called when the list is updated.
 * @param {number} dismissTimeout Used to determine the timeout for temporary
 * messages.
 */
function Notifications() {
  var _this = this;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Notifications);

  _defineProperty(this, "_items", []);

  _defineProperty(this, "getItems", function () {
    return _this._items;
  });

  _defineProperty(this, "setItems", function (items, shouldClear) {
    // Clear the existing list if required
    if (shouldClear) {
      _this._items = [];
    }

    var newItemsWithKeys = _this._normaliseInputData(items);

    _this._items = [].concat(_toConsumableArray(newItemsWithKeys), _toConsumableArray(_this._items));

    _this._onNotificationsChanged(); // Set the new items to be automatically dismissed if they are temporary


    var tempItems = newItemsWithKeys.filter(function (item) {
      return !item.perm;
    });

    _this._setItemsToBeDismissed(tempItems);
  });

  _defineProperty(this, "defaultMessage", function (isSuccess) {
    isSuccess ? _this.setDefaultSuccess() : _this.setDefaultError();
  });

  _defineProperty(this, "setSuccess", function (item, shouldClear, traceId) {
    if (shouldClear) {
      _this._items = [];
    }

    var newItem = {
      message: item,
      key: lodash_uniqueid(),
      type: "success",
      traceId: traceId
    };
    _this._items = [newItem].concat(_toConsumableArray(_this._items));

    _this._onNotificationsChanged();

    _this._setItemsToBeDismissed([newItem]);
  });

  _defineProperty(this, "setDefaultSuccess", function () {
    var newItem = {
      message: function message() {
        return /*#__PURE__*/React__default.createElement("span", null, i18n._(
        /*i18n*/
        {
          id: "Update Successful"
        }));
      },
      key: lodash_uniqueid(),
      type: "success"
    };
    _this._items = [newItem].concat(_toConsumableArray(_this._items));

    _this._onNotificationsChanged();

    _this._setItemsToBeDismissed([newItem]);
  });

  _defineProperty(this, "setError", function (item, shouldClear, traceId) {
    if (shouldClear) {
      _this._items = [];
    }

    _this._items = [{
      message: item,
      key: lodash_uniqueid(),
      type: "error",
      perm: true,
      traceId: traceId
    }].concat(_toConsumableArray(_this._items));

    _this._onNotificationsChanged();
  });

  _defineProperty(this, "setDefaultError", function () {
    var newItem = {
      message: function message() {
        return /*#__PURE__*/React__default.createElement("span", null, i18n._(
        /*i18n*/
        {
          id: "Update failed. Please try again."
        }));
      },
      key: lodash_uniqueid(),
      type: "error",
      perm: true
    };
    _this._items = [newItem].concat(_toConsumableArray(_this._items));

    _this._onNotificationsChanged();
  });

  _defineProperty(this, "_normaliseInputData", function (items) {
    switch (_typeof(items)) {
      case "string":
        return [{
          message: items,
          key: lodash_uniqueid()
        }];

      case "object":
        if (!Array.isArray(items)) {
          if (typeof items.message === "string") {
            items.message = function () {
              return /*#__PURE__*/React__default.createElement("span", null, items.message);
            };
          }

          return [_objectSpread2(_objectSpread2({}, items), {}, {
            key: lodash_uniqueid()
          })];
        }

        return items.map(function (item) {
          return _this._normaliseInputData(item);
        });

      default:
        console.error("Incorrect items type: ".concat(_typeof(items)));
        console.error("Message content is: ".concat(JSON.stringify(items)));
        return [{
          message: JSON.stringify(items),
          key: lodash_uniqueid()
        }];
    }
  });

  _defineProperty(this, "_setItemsToBeDismissed", function (items) {
    items.forEach(function (item) {
      setTimeout(function () {
        _this.onDismiss(item.key);
      }, _this.dismissTimeout);
    });
  });

  _defineProperty(this, "onDismiss", function (key) {
    _this._items = _this._items.filter(function (item) {
      return item.key !== key;
    });

    _this._onNotificationsChanged();
  });

  var onNotificationsChanged = options.onNotificationsChanged;
  this.dismissTimeout = options.dismissTimeout || 3000;
  this._onNotificationsChanged = onNotificationsChanged;
}
/**
 * @description Gets the current list of items
 * @returns {Object[]} The list of notification objects
 * */
;

var translations = {
  home: i18n._(
  /*i18n*/
  {
    id: "home"
  }),
  work: i18n._(
  /*i18n*/
  {
    id: "work"
  }),
  mobile: i18n._(
  /*i18n*/
  {
    id: "mobile"
  }),
  "default": i18n._(
  /*i18n*/
  {
    id: "default"
  })
}; // Utility function for translating keys in profile info objects, like `emails`
// and `phoneNumbers`.

var translateEntryKeys = function translateEntryKeys(entries) {
  if (!entries) {
    return;
  }

  return Object.keys(entries).map(function (entryType) {
    return _defineProperty({}, translations[entryType], entries[entryType]);
  }).reduce(function (acc, entry) {
    return _objectSpread2(_objectSpread2({}, acc), entry);
  }, {});
};

var index$3 = (function (items, column) {
  var asc = !column.isSorted ? "asc" : column.isSortedDescending ? "desc" : "asc";
  return items.sort(function (a, b) {
    if (asc === "asc") {
      return a[column.fieldName].localeCompare(b[column.fieldName]);
    } else {
      return b[column.fieldName].localeCompare(a[column.fieldName]);
    }
  });
});

var cpexcel = createCommonjsModule(function (module) {
/*! cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */

/*jshint -W100 */
var cptable = {
  version: "1.15.0"
};

cptable[437] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[620] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[737] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[850] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[852] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[857] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[861] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[865] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[866] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[874] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[895] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[932] = function () {
  var d = [],
      e = {},
      D = [],
      j;
  D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");

  for (j = 0; j != D[0].length; ++j) if (D[0][j].charCodeAt(0) !== 0xFFFD) {
    e[D[0][j]] = 0 + j;
    d[0 + j] = D[0][j];
  }

  D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");

  for (j = 0; j != D[129].length; ++j) if (D[129][j].charCodeAt(0) !== 0xFFFD) {
    e[D[129][j]] = 33024 + j;
    d[33024 + j] = D[129][j];
  }

  D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");

  for (j = 0; j != D[130].length; ++j) if (D[130][j].charCodeAt(0) !== 0xFFFD) {
    e[D[130][j]] = 33280 + j;
    d[33280 + j] = D[130][j];
  }

  D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");

  for (j = 0; j != D[131].length; ++j) if (D[131][j].charCodeAt(0) !== 0xFFFD) {
    e[D[131][j]] = 33536 + j;
    d[33536 + j] = D[131][j];
  }

  D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");

  for (j = 0; j != D[132].length; ++j) if (D[132][j].charCodeAt(0) !== 0xFFFD) {
    e[D[132][j]] = 33792 + j;
    d[33792 + j] = D[132][j];
  }

  D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[135].length; ++j) if (D[135][j].charCodeAt(0) !== 0xFFFD) {
    e[D[135][j]] = 34560 + j;
    d[34560 + j] = D[135][j];
  }

  D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");

  for (j = 0; j != D[136].length; ++j) if (D[136][j].charCodeAt(0) !== 0xFFFD) {
    e[D[136][j]] = 34816 + j;
    d[34816 + j] = D[136][j];
  }

  D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");

  for (j = 0; j != D[137].length; ++j) if (D[137][j].charCodeAt(0) !== 0xFFFD) {
    e[D[137][j]] = 35072 + j;
    d[35072 + j] = D[137][j];
  }

  D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");

  for (j = 0; j != D[138].length; ++j) if (D[138][j].charCodeAt(0) !== 0xFFFD) {
    e[D[138][j]] = 35328 + j;
    d[35328 + j] = D[138][j];
  }

  D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");

  for (j = 0; j != D[139].length; ++j) if (D[139][j].charCodeAt(0) !== 0xFFFD) {
    e[D[139][j]] = 35584 + j;
    d[35584 + j] = D[139][j];
  }

  D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");

  for (j = 0; j != D[140].length; ++j) if (D[140][j].charCodeAt(0) !== 0xFFFD) {
    e[D[140][j]] = 35840 + j;
    d[35840 + j] = D[140][j];
  }

  D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");

  for (j = 0; j != D[141].length; ++j) if (D[141][j].charCodeAt(0) !== 0xFFFD) {
    e[D[141][j]] = 36096 + j;
    d[36096 + j] = D[141][j];
  }

  D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");

  for (j = 0; j != D[142].length; ++j) if (D[142][j].charCodeAt(0) !== 0xFFFD) {
    e[D[142][j]] = 36352 + j;
    d[36352 + j] = D[142][j];
  }

  D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");

  for (j = 0; j != D[143].length; ++j) if (D[143][j].charCodeAt(0) !== 0xFFFD) {
    e[D[143][j]] = 36608 + j;
    d[36608 + j] = D[143][j];
  }

  D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");

  for (j = 0; j != D[144].length; ++j) if (D[144][j].charCodeAt(0) !== 0xFFFD) {
    e[D[144][j]] = 36864 + j;
    d[36864 + j] = D[144][j];
  }

  D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");

  for (j = 0; j != D[145].length; ++j) if (D[145][j].charCodeAt(0) !== 0xFFFD) {
    e[D[145][j]] = 37120 + j;
    d[37120 + j] = D[145][j];
  }

  D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");

  for (j = 0; j != D[146].length; ++j) if (D[146][j].charCodeAt(0) !== 0xFFFD) {
    e[D[146][j]] = 37376 + j;
    d[37376 + j] = D[146][j];
  }

  D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");

  for (j = 0; j != D[147].length; ++j) if (D[147][j].charCodeAt(0) !== 0xFFFD) {
    e[D[147][j]] = 37632 + j;
    d[37632 + j] = D[147][j];
  }

  D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");

  for (j = 0; j != D[148].length; ++j) if (D[148][j].charCodeAt(0) !== 0xFFFD) {
    e[D[148][j]] = 37888 + j;
    d[37888 + j] = D[148][j];
  }

  D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");

  for (j = 0; j != D[149].length; ++j) if (D[149][j].charCodeAt(0) !== 0xFFFD) {
    e[D[149][j]] = 38144 + j;
    d[38144 + j] = D[149][j];
  }

  D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");

  for (j = 0; j != D[150].length; ++j) if (D[150][j].charCodeAt(0) !== 0xFFFD) {
    e[D[150][j]] = 38400 + j;
    d[38400 + j] = D[150][j];
  }

  D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");

  for (j = 0; j != D[151].length; ++j) if (D[151][j].charCodeAt(0) !== 0xFFFD) {
    e[D[151][j]] = 38656 + j;
    d[38656 + j] = D[151][j];
  }

  D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");

  for (j = 0; j != D[152].length; ++j) if (D[152][j].charCodeAt(0) !== 0xFFFD) {
    e[D[152][j]] = 38912 + j;
    d[38912 + j] = D[152][j];
  }

  D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");

  for (j = 0; j != D[153].length; ++j) if (D[153][j].charCodeAt(0) !== 0xFFFD) {
    e[D[153][j]] = 39168 + j;
    d[39168 + j] = D[153][j];
  }

  D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");

  for (j = 0; j != D[154].length; ++j) if (D[154][j].charCodeAt(0) !== 0xFFFD) {
    e[D[154][j]] = 39424 + j;
    d[39424 + j] = D[154][j];
  }

  D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");

  for (j = 0; j != D[155].length; ++j) if (D[155][j].charCodeAt(0) !== 0xFFFD) {
    e[D[155][j]] = 39680 + j;
    d[39680 + j] = D[155][j];
  }

  D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");

  for (j = 0; j != D[156].length; ++j) if (D[156][j].charCodeAt(0) !== 0xFFFD) {
    e[D[156][j]] = 39936 + j;
    d[39936 + j] = D[156][j];
  }

  D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");

  for (j = 0; j != D[157].length; ++j) if (D[157][j].charCodeAt(0) !== 0xFFFD) {
    e[D[157][j]] = 40192 + j;
    d[40192 + j] = D[157][j];
  }

  D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");

  for (j = 0; j != D[158].length; ++j) if (D[158][j].charCodeAt(0) !== 0xFFFD) {
    e[D[158][j]] = 40448 + j;
    d[40448 + j] = D[158][j];
  }

  D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");

  for (j = 0; j != D[159].length; ++j) if (D[159][j].charCodeAt(0) !== 0xFFFD) {
    e[D[159][j]] = 40704 + j;
    d[40704 + j] = D[159][j];
  }

  D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");

  for (j = 0; j != D[224].length; ++j) if (D[224][j].charCodeAt(0) !== 0xFFFD) {
    e[D[224][j]] = 57344 + j;
    d[57344 + j] = D[224][j];
  }

  D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");

  for (j = 0; j != D[225].length; ++j) if (D[225][j].charCodeAt(0) !== 0xFFFD) {
    e[D[225][j]] = 57600 + j;
    d[57600 + j] = D[225][j];
  }

  D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");

  for (j = 0; j != D[226].length; ++j) if (D[226][j].charCodeAt(0) !== 0xFFFD) {
    e[D[226][j]] = 57856 + j;
    d[57856 + j] = D[226][j];
  }

  D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");

  for (j = 0; j != D[227].length; ++j) if (D[227][j].charCodeAt(0) !== 0xFFFD) {
    e[D[227][j]] = 58112 + j;
    d[58112 + j] = D[227][j];
  }

  D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");

  for (j = 0; j != D[228].length; ++j) if (D[228][j].charCodeAt(0) !== 0xFFFD) {
    e[D[228][j]] = 58368 + j;
    d[58368 + j] = D[228][j];
  }

  D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");

  for (j = 0; j != D[229].length; ++j) if (D[229][j].charCodeAt(0) !== 0xFFFD) {
    e[D[229][j]] = 58624 + j;
    d[58624 + j] = D[229][j];
  }

  D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");

  for (j = 0; j != D[230].length; ++j) if (D[230][j].charCodeAt(0) !== 0xFFFD) {
    e[D[230][j]] = 58880 + j;
    d[58880 + j] = D[230][j];
  }

  D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");

  for (j = 0; j != D[231].length; ++j) if (D[231][j].charCodeAt(0) !== 0xFFFD) {
    e[D[231][j]] = 59136 + j;
    d[59136 + j] = D[231][j];
  }

  D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");

  for (j = 0; j != D[232].length; ++j) if (D[232][j].charCodeAt(0) !== 0xFFFD) {
    e[D[232][j]] = 59392 + j;
    d[59392 + j] = D[232][j];
  }

  D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");

  for (j = 0; j != D[233].length; ++j) if (D[233][j].charCodeAt(0) !== 0xFFFD) {
    e[D[233][j]] = 59648 + j;
    d[59648 + j] = D[233][j];
  }

  D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[234].length; ++j) if (D[234][j].charCodeAt(0) !== 0xFFFD) {
    e[D[234][j]] = 59904 + j;
    d[59904 + j] = D[234][j];
  }

  D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");

  for (j = 0; j != D[237].length; ++j) if (D[237][j].charCodeAt(0) !== 0xFFFD) {
    e[D[237][j]] = 60672 + j;
    d[60672 + j] = D[237][j];
  }

  D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");

  for (j = 0; j != D[238].length; ++j) if (D[238][j].charCodeAt(0) !== 0xFFFD) {
    e[D[238][j]] = 60928 + j;
    d[60928 + j] = D[238][j];
  }

  D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");

  for (j = 0; j != D[250].length; ++j) if (D[250][j].charCodeAt(0) !== 0xFFFD) {
    e[D[250][j]] = 64000 + j;
    d[64000 + j] = D[250][j];
  }

  D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");

  for (j = 0; j != D[251].length; ++j) if (D[251][j].charCodeAt(0) !== 0xFFFD) {
    e[D[251][j]] = 64256 + j;
    d[64256 + j] = D[251][j];
  }

  D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[252].length; ++j) if (D[252][j].charCodeAt(0) !== 0xFFFD) {
    e[D[252][j]] = 64512 + j;
    d[64512 + j] = D[252][j];
  }

  return {
    "enc": e,
    "dec": d
  };
}();

cptable[936] = function () {
  var d = [],
      e = {},
      D = [],
      j;
  D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[0].length; ++j) if (D[0][j].charCodeAt(0) !== 0xFFFD) {
    e[D[0][j]] = 0 + j;
    d[0 + j] = D[0][j];
  }

  D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");

  for (j = 0; j != D[129].length; ++j) if (D[129][j].charCodeAt(0) !== 0xFFFD) {
    e[D[129][j]] = 33024 + j;
    d[33024 + j] = D[129][j];
  }

  D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");

  for (j = 0; j != D[130].length; ++j) if (D[130][j].charCodeAt(0) !== 0xFFFD) {
    e[D[130][j]] = 33280 + j;
    d[33280 + j] = D[130][j];
  }

  D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");

  for (j = 0; j != D[131].length; ++j) if (D[131][j].charCodeAt(0) !== 0xFFFD) {
    e[D[131][j]] = 33536 + j;
    d[33536 + j] = D[131][j];
  }

  D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");

  for (j = 0; j != D[132].length; ++j) if (D[132][j].charCodeAt(0) !== 0xFFFD) {
    e[D[132][j]] = 33792 + j;
    d[33792 + j] = D[132][j];
  }

  D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");

  for (j = 0; j != D[133].length; ++j) if (D[133][j].charCodeAt(0) !== 0xFFFD) {
    e[D[133][j]] = 34048 + j;
    d[34048 + j] = D[133][j];
  }

  D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");

  for (j = 0; j != D[134].length; ++j) if (D[134][j].charCodeAt(0) !== 0xFFFD) {
    e[D[134][j]] = 34304 + j;
    d[34304 + j] = D[134][j];
  }

  D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");

  for (j = 0; j != D[135].length; ++j) if (D[135][j].charCodeAt(0) !== 0xFFFD) {
    e[D[135][j]] = 34560 + j;
    d[34560 + j] = D[135][j];
  }

  D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");

  for (j = 0; j != D[136].length; ++j) if (D[136][j].charCodeAt(0) !== 0xFFFD) {
    e[D[136][j]] = 34816 + j;
    d[34816 + j] = D[136][j];
  }

  D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");

  for (j = 0; j != D[137].length; ++j) if (D[137][j].charCodeAt(0) !== 0xFFFD) {
    e[D[137][j]] = 35072 + j;
    d[35072 + j] = D[137][j];
  }

  D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");

  for (j = 0; j != D[138].length; ++j) if (D[138][j].charCodeAt(0) !== 0xFFFD) {
    e[D[138][j]] = 35328 + j;
    d[35328 + j] = D[138][j];
  }

  D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");

  for (j = 0; j != D[139].length; ++j) if (D[139][j].charCodeAt(0) !== 0xFFFD) {
    e[D[139][j]] = 35584 + j;
    d[35584 + j] = D[139][j];
  }

  D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");

  for (j = 0; j != D[140].length; ++j) if (D[140][j].charCodeAt(0) !== 0xFFFD) {
    e[D[140][j]] = 35840 + j;
    d[35840 + j] = D[140][j];
  }

  D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");

  for (j = 0; j != D[141].length; ++j) if (D[141][j].charCodeAt(0) !== 0xFFFD) {
    e[D[141][j]] = 36096 + j;
    d[36096 + j] = D[141][j];
  }

  D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");

  for (j = 0; j != D[142].length; ++j) if (D[142][j].charCodeAt(0) !== 0xFFFD) {
    e[D[142][j]] = 36352 + j;
    d[36352 + j] = D[142][j];
  }

  D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");

  for (j = 0; j != D[143].length; ++j) if (D[143][j].charCodeAt(0) !== 0xFFFD) {
    e[D[143][j]] = 36608 + j;
    d[36608 + j] = D[143][j];
  }

  D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");

  for (j = 0; j != D[144].length; ++j) if (D[144][j].charCodeAt(0) !== 0xFFFD) {
    e[D[144][j]] = 36864 + j;
    d[36864 + j] = D[144][j];
  }

  D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");

  for (j = 0; j != D[145].length; ++j) if (D[145][j].charCodeAt(0) !== 0xFFFD) {
    e[D[145][j]] = 37120 + j;
    d[37120 + j] = D[145][j];
  }

  D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");

  for (j = 0; j != D[146].length; ++j) if (D[146][j].charCodeAt(0) !== 0xFFFD) {
    e[D[146][j]] = 37376 + j;
    d[37376 + j] = D[146][j];
  }

  D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");

  for (j = 0; j != D[147].length; ++j) if (D[147][j].charCodeAt(0) !== 0xFFFD) {
    e[D[147][j]] = 37632 + j;
    d[37632 + j] = D[147][j];
  }

  D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");

  for (j = 0; j != D[148].length; ++j) if (D[148][j].charCodeAt(0) !== 0xFFFD) {
    e[D[148][j]] = 37888 + j;
    d[37888 + j] = D[148][j];
  }

  D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");

  for (j = 0; j != D[149].length; ++j) if (D[149][j].charCodeAt(0) !== 0xFFFD) {
    e[D[149][j]] = 38144 + j;
    d[38144 + j] = D[149][j];
  }

  D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");

  for (j = 0; j != D[150].length; ++j) if (D[150][j].charCodeAt(0) !== 0xFFFD) {
    e[D[150][j]] = 38400 + j;
    d[38400 + j] = D[150][j];
  }

  D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");

  for (j = 0; j != D[151].length; ++j) if (D[151][j].charCodeAt(0) !== 0xFFFD) {
    e[D[151][j]] = 38656 + j;
    d[38656 + j] = D[151][j];
  }

  D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");

  for (j = 0; j != D[152].length; ++j) if (D[152][j].charCodeAt(0) !== 0xFFFD) {
    e[D[152][j]] = 38912 + j;
    d[38912 + j] = D[152][j];
  }

  D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");

  for (j = 0; j != D[153].length; ++j) if (D[153][j].charCodeAt(0) !== 0xFFFD) {
    e[D[153][j]] = 39168 + j;
    d[39168 + j] = D[153][j];
  }

  D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");

  for (j = 0; j != D[154].length; ++j) if (D[154][j].charCodeAt(0) !== 0xFFFD) {
    e[D[154][j]] = 39424 + j;
    d[39424 + j] = D[154][j];
  }

  D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");

  for (j = 0; j != D[155].length; ++j) if (D[155][j].charCodeAt(0) !== 0xFFFD) {
    e[D[155][j]] = 39680 + j;
    d[39680 + j] = D[155][j];
  }

  D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");

  for (j = 0; j != D[156].length; ++j) if (D[156][j].charCodeAt(0) !== 0xFFFD) {
    e[D[156][j]] = 39936 + j;
    d[39936 + j] = D[156][j];
  }

  D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");

  for (j = 0; j != D[157].length; ++j) if (D[157][j].charCodeAt(0) !== 0xFFFD) {
    e[D[157][j]] = 40192 + j;
    d[40192 + j] = D[157][j];
  }

  D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");

  for (j = 0; j != D[158].length; ++j) if (D[158][j].charCodeAt(0) !== 0xFFFD) {
    e[D[158][j]] = 40448 + j;
    d[40448 + j] = D[158][j];
  }

  D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");

  for (j = 0; j != D[159].length; ++j) if (D[159][j].charCodeAt(0) !== 0xFFFD) {
    e[D[159][j]] = 40704 + j;
    d[40704 + j] = D[159][j];
  }

  D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");

  for (j = 0; j != D[160].length; ++j) if (D[160][j].charCodeAt(0) !== 0xFFFD) {
    e[D[160][j]] = 40960 + j;
    d[40960 + j] = D[160][j];
  }

  D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");

  for (j = 0; j != D[161].length; ++j) if (D[161][j].charCodeAt(0) !== 0xFFFD) {
    e[D[161][j]] = 41216 + j;
    d[41216 + j] = D[161][j];
  }

  D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");

  for (j = 0; j != D[162].length; ++j) if (D[162][j].charCodeAt(0) !== 0xFFFD) {
    e[D[162][j]] = 41472 + j;
    d[41472 + j] = D[162][j];
  }

  D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");

  for (j = 0; j != D[163].length; ++j) if (D[163][j].charCodeAt(0) !== 0xFFFD) {
    e[D[163][j]] = 41728 + j;
    d[41728 + j] = D[163][j];
  }

  D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");

  for (j = 0; j != D[164].length; ++j) if (D[164][j].charCodeAt(0) !== 0xFFFD) {
    e[D[164][j]] = 41984 + j;
    d[41984 + j] = D[164][j];
  }

  D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");

  for (j = 0; j != D[165].length; ++j) if (D[165][j].charCodeAt(0) !== 0xFFFD) {
    e[D[165][j]] = 42240 + j;
    d[42240 + j] = D[165][j];
  }

  D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");

  for (j = 0; j != D[166].length; ++j) if (D[166][j].charCodeAt(0) !== 0xFFFD) {
    e[D[166][j]] = 42496 + j;
    d[42496 + j] = D[166][j];
  }

  D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");

  for (j = 0; j != D[167].length; ++j) if (D[167][j].charCodeAt(0) !== 0xFFFD) {
    e[D[167][j]] = 42752 + j;
    d[42752 + j] = D[167][j];
  }

  D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");

  for (j = 0; j != D[168].length; ++j) if (D[168][j].charCodeAt(0) !== 0xFFFD) {
    e[D[168][j]] = 43008 + j;
    d[43008 + j] = D[168][j];
  }

  D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");

  for (j = 0; j != D[169].length; ++j) if (D[169][j].charCodeAt(0) !== 0xFFFD) {
    e[D[169][j]] = 43264 + j;
    d[43264 + j] = D[169][j];
  }

  D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[170].length; ++j) if (D[170][j].charCodeAt(0) !== 0xFFFD) {
    e[D[170][j]] = 43520 + j;
    d[43520 + j] = D[170][j];
  }

  D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[171].length; ++j) if (D[171][j].charCodeAt(0) !== 0xFFFD) {
    e[D[171][j]] = 43776 + j;
    d[43776 + j] = D[171][j];
  }

  D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[172].length; ++j) if (D[172][j].charCodeAt(0) !== 0xFFFD) {
    e[D[172][j]] = 44032 + j;
    d[44032 + j] = D[172][j];
  }

  D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[173].length; ++j) if (D[173][j].charCodeAt(0) !== 0xFFFD) {
    e[D[173][j]] = 44288 + j;
    d[44288 + j] = D[173][j];
  }

  D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[174].length; ++j) if (D[174][j].charCodeAt(0) !== 0xFFFD) {
    e[D[174][j]] = 44544 + j;
    d[44544 + j] = D[174][j];
  }

  D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[175].length; ++j) if (D[175][j].charCodeAt(0) !== 0xFFFD) {
    e[D[175][j]] = 44800 + j;
    d[44800 + j] = D[175][j];
  }

  D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");

  for (j = 0; j != D[176].length; ++j) if (D[176][j].charCodeAt(0) !== 0xFFFD) {
    e[D[176][j]] = 45056 + j;
    d[45056 + j] = D[176][j];
  }

  D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");

  for (j = 0; j != D[177].length; ++j) if (D[177][j].charCodeAt(0) !== 0xFFFD) {
    e[D[177][j]] = 45312 + j;
    d[45312 + j] = D[177][j];
  }

  D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");

  for (j = 0; j != D[178].length; ++j) if (D[178][j].charCodeAt(0) !== 0xFFFD) {
    e[D[178][j]] = 45568 + j;
    d[45568 + j] = D[178][j];
  }

  D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");

  for (j = 0; j != D[179].length; ++j) if (D[179][j].charCodeAt(0) !== 0xFFFD) {
    e[D[179][j]] = 45824 + j;
    d[45824 + j] = D[179][j];
  }

  D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");

  for (j = 0; j != D[180].length; ++j) if (D[180][j].charCodeAt(0) !== 0xFFFD) {
    e[D[180][j]] = 46080 + j;
    d[46080 + j] = D[180][j];
  }

  D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");

  for (j = 0; j != D[181].length; ++j) if (D[181][j].charCodeAt(0) !== 0xFFFD) {
    e[D[181][j]] = 46336 + j;
    d[46336 + j] = D[181][j];
  }

  D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");

  for (j = 0; j != D[182].length; ++j) if (D[182][j].charCodeAt(0) !== 0xFFFD) {
    e[D[182][j]] = 46592 + j;
    d[46592 + j] = D[182][j];
  }

  D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");

  for (j = 0; j != D[183].length; ++j) if (D[183][j].charCodeAt(0) !== 0xFFFD) {
    e[D[183][j]] = 46848 + j;
    d[46848 + j] = D[183][j];
  }

  D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");

  for (j = 0; j != D[184].length; ++j) if (D[184][j].charCodeAt(0) !== 0xFFFD) {
    e[D[184][j]] = 47104 + j;
    d[47104 + j] = D[184][j];
  }

  D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");

  for (j = 0; j != D[185].length; ++j) if (D[185][j].charCodeAt(0) !== 0xFFFD) {
    e[D[185][j]] = 47360 + j;
    d[47360 + j] = D[185][j];
  }

  D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");

  for (j = 0; j != D[186].length; ++j) if (D[186][j].charCodeAt(0) !== 0xFFFD) {
    e[D[186][j]] = 47616 + j;
    d[47616 + j] = D[186][j];
  }

  D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");

  for (j = 0; j != D[187].length; ++j) if (D[187][j].charCodeAt(0) !== 0xFFFD) {
    e[D[187][j]] = 47872 + j;
    d[47872 + j] = D[187][j];
  }

  D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");

  for (j = 0; j != D[188].length; ++j) if (D[188][j].charCodeAt(0) !== 0xFFFD) {
    e[D[188][j]] = 48128 + j;
    d[48128 + j] = D[188][j];
  }

  D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");

  for (j = 0; j != D[189].length; ++j) if (D[189][j].charCodeAt(0) !== 0xFFFD) {
    e[D[189][j]] = 48384 + j;
    d[48384 + j] = D[189][j];
  }

  D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");

  for (j = 0; j != D[190].length; ++j) if (D[190][j].charCodeAt(0) !== 0xFFFD) {
    e[D[190][j]] = 48640 + j;
    d[48640 + j] = D[190][j];
  }

  D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");

  for (j = 0; j != D[191].length; ++j) if (D[191][j].charCodeAt(0) !== 0xFFFD) {
    e[D[191][j]] = 48896 + j;
    d[48896 + j] = D[191][j];
  }

  D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");

  for (j = 0; j != D[192].length; ++j) if (D[192][j].charCodeAt(0) !== 0xFFFD) {
    e[D[192][j]] = 49152 + j;
    d[49152 + j] = D[192][j];
  }

  D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");

  for (j = 0; j != D[193].length; ++j) if (D[193][j].charCodeAt(0) !== 0xFFFD) {
    e[D[193][j]] = 49408 + j;
    d[49408 + j] = D[193][j];
  }

  D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");

  for (j = 0; j != D[194].length; ++j) if (D[194][j].charCodeAt(0) !== 0xFFFD) {
    e[D[194][j]] = 49664 + j;
    d[49664 + j] = D[194][j];
  }

  D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");

  for (j = 0; j != D[195].length; ++j) if (D[195][j].charCodeAt(0) !== 0xFFFD) {
    e[D[195][j]] = 49920 + j;
    d[49920 + j] = D[195][j];
  }

  D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");

  for (j = 0; j != D[196].length; ++j) if (D[196][j].charCodeAt(0) !== 0xFFFD) {
    e[D[196][j]] = 50176 + j;
    d[50176 + j] = D[196][j];
  }

  D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");

  for (j = 0; j != D[197].length; ++j) if (D[197][j].charCodeAt(0) !== 0xFFFD) {
    e[D[197][j]] = 50432 + j;
    d[50432 + j] = D[197][j];
  }

  D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");

  for (j = 0; j != D[198].length; ++j) if (D[198][j].charCodeAt(0) !== 0xFFFD) {
    e[D[198][j]] = 50688 + j;
    d[50688 + j] = D[198][j];
  }

  D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");

  for (j = 0; j != D[199].length; ++j) if (D[199][j].charCodeAt(0) !== 0xFFFD) {
    e[D[199][j]] = 50944 + j;
    d[50944 + j] = D[199][j];
  }

  D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");

  for (j = 0; j != D[200].length; ++j) if (D[200][j].charCodeAt(0) !== 0xFFFD) {
    e[D[200][j]] = 51200 + j;
    d[51200 + j] = D[200][j];
  }

  D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");

  for (j = 0; j != D[201].length; ++j) if (D[201][j].charCodeAt(0) !== 0xFFFD) {
    e[D[201][j]] = 51456 + j;
    d[51456 + j] = D[201][j];
  }

  D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");

  for (j = 0; j != D[202].length; ++j) if (D[202][j].charCodeAt(0) !== 0xFFFD) {
    e[D[202][j]] = 51712 + j;
    d[51712 + j] = D[202][j];
  }

  D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");

  for (j = 0; j != D[203].length; ++j) if (D[203][j].charCodeAt(0) !== 0xFFFD) {
    e[D[203][j]] = 51968 + j;
    d[51968 + j] = D[203][j];
  }

  D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");

  for (j = 0; j != D[204].length; ++j) if (D[204][j].charCodeAt(0) !== 0xFFFD) {
    e[D[204][j]] = 52224 + j;
    d[52224 + j] = D[204][j];
  }

  D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");

  for (j = 0; j != D[205].length; ++j) if (D[205][j].charCodeAt(0) !== 0xFFFD) {
    e[D[205][j]] = 52480 + j;
    d[52480 + j] = D[205][j];
  }

  D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");

  for (j = 0; j != D[206].length; ++j) if (D[206][j].charCodeAt(0) !== 0xFFFD) {
    e[D[206][j]] = 52736 + j;
    d[52736 + j] = D[206][j];
  }

  D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");

  for (j = 0; j != D[207].length; ++j) if (D[207][j].charCodeAt(0) !== 0xFFFD) {
    e[D[207][j]] = 52992 + j;
    d[52992 + j] = D[207][j];
  }

  D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");

  for (j = 0; j != D[208].length; ++j) if (D[208][j].charCodeAt(0) !== 0xFFFD) {
    e[D[208][j]] = 53248 + j;
    d[53248 + j] = D[208][j];
  }

  D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");

  for (j = 0; j != D[209].length; ++j) if (D[209][j].charCodeAt(0) !== 0xFFFD) {
    e[D[209][j]] = 53504 + j;
    d[53504 + j] = D[209][j];
  }

  D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");

  for (j = 0; j != D[210].length; ++j) if (D[210][j].charCodeAt(0) !== 0xFFFD) {
    e[D[210][j]] = 53760 + j;
    d[53760 + j] = D[210][j];
  }

  D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");

  for (j = 0; j != D[211].length; ++j) if (D[211][j].charCodeAt(0) !== 0xFFFD) {
    e[D[211][j]] = 54016 + j;
    d[54016 + j] = D[211][j];
  }

  D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");

  for (j = 0; j != D[212].length; ++j) if (D[212][j].charCodeAt(0) !== 0xFFFD) {
    e[D[212][j]] = 54272 + j;
    d[54272 + j] = D[212][j];
  }

  D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");

  for (j = 0; j != D[213].length; ++j) if (D[213][j].charCodeAt(0) !== 0xFFFD) {
    e[D[213][j]] = 54528 + j;
    d[54528 + j] = D[213][j];
  }

  D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");

  for (j = 0; j != D[214].length; ++j) if (D[214][j].charCodeAt(0) !== 0xFFFD) {
    e[D[214][j]] = 54784 + j;
    d[54784 + j] = D[214][j];
  }

  D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");

  for (j = 0; j != D[215].length; ++j) if (D[215][j].charCodeAt(0) !== 0xFFFD) {
    e[D[215][j]] = 55040 + j;
    d[55040 + j] = D[215][j];
  }

  D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");

  for (j = 0; j != D[216].length; ++j) if (D[216][j].charCodeAt(0) !== 0xFFFD) {
    e[D[216][j]] = 55296 + j;
    d[55296 + j] = D[216][j];
  }

  D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");

  for (j = 0; j != D[217].length; ++j) if (D[217][j].charCodeAt(0) !== 0xFFFD) {
    e[D[217][j]] = 55552 + j;
    d[55552 + j] = D[217][j];
  }

  D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");

  for (j = 0; j != D[218].length; ++j) if (D[218][j].charCodeAt(0) !== 0xFFFD) {
    e[D[218][j]] = 55808 + j;
    d[55808 + j] = D[218][j];
  }

  D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");

  for (j = 0; j != D[219].length; ++j) if (D[219][j].charCodeAt(0) !== 0xFFFD) {
    e[D[219][j]] = 56064 + j;
    d[56064 + j] = D[219][j];
  }

  D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");

  for (j = 0; j != D[220].length; ++j) if (D[220][j].charCodeAt(0) !== 0xFFFD) {
    e[D[220][j]] = 56320 + j;
    d[56320 + j] = D[220][j];
  }

  D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");

  for (j = 0; j != D[221].length; ++j) if (D[221][j].charCodeAt(0) !== 0xFFFD) {
    e[D[221][j]] = 56576 + j;
    d[56576 + j] = D[221][j];
  }

  D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");

  for (j = 0; j != D[222].length; ++j) if (D[222][j].charCodeAt(0) !== 0xFFFD) {
    e[D[222][j]] = 56832 + j;
    d[56832 + j] = D[222][j];
  }

  D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");

  for (j = 0; j != D[223].length; ++j) if (D[223][j].charCodeAt(0) !== 0xFFFD) {
    e[D[223][j]] = 57088 + j;
    d[57088 + j] = D[223][j];
  }

  D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");

  for (j = 0; j != D[224].length; ++j) if (D[224][j].charCodeAt(0) !== 0xFFFD) {
    e[D[224][j]] = 57344 + j;
    d[57344 + j] = D[224][j];
  }

  D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");

  for (j = 0; j != D[225].length; ++j) if (D[225][j].charCodeAt(0) !== 0xFFFD) {
    e[D[225][j]] = 57600 + j;
    d[57600 + j] = D[225][j];
  }

  D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");

  for (j = 0; j != D[226].length; ++j) if (D[226][j].charCodeAt(0) !== 0xFFFD) {
    e[D[226][j]] = 57856 + j;
    d[57856 + j] = D[226][j];
  }

  D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");

  for (j = 0; j != D[227].length; ++j) if (D[227][j].charCodeAt(0) !== 0xFFFD) {
    e[D[227][j]] = 58112 + j;
    d[58112 + j] = D[227][j];
  }

  D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");

  for (j = 0; j != D[228].length; ++j) if (D[228][j].charCodeAt(0) !== 0xFFFD) {
    e[D[228][j]] = 58368 + j;
    d[58368 + j] = D[228][j];
  }

  D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");

  for (j = 0; j != D[229].length; ++j) if (D[229][j].charCodeAt(0) !== 0xFFFD) {
    e[D[229][j]] = 58624 + j;
    d[58624 + j] = D[229][j];
  }

  D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");

  for (j = 0; j != D[230].length; ++j) if (D[230][j].charCodeAt(0) !== 0xFFFD) {
    e[D[230][j]] = 58880 + j;
    d[58880 + j] = D[230][j];
  }

  D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");

  for (j = 0; j != D[231].length; ++j) if (D[231][j].charCodeAt(0) !== 0xFFFD) {
    e[D[231][j]] = 59136 + j;
    d[59136 + j] = D[231][j];
  }

  D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");

  for (j = 0; j != D[232].length; ++j) if (D[232][j].charCodeAt(0) !== 0xFFFD) {
    e[D[232][j]] = 59392 + j;
    d[59392 + j] = D[232][j];
  }

  D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");

  for (j = 0; j != D[233].length; ++j) if (D[233][j].charCodeAt(0) !== 0xFFFD) {
    e[D[233][j]] = 59648 + j;
    d[59648 + j] = D[233][j];
  }

  D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");

  for (j = 0; j != D[234].length; ++j) if (D[234][j].charCodeAt(0) !== 0xFFFD) {
    e[D[234][j]] = 59904 + j;
    d[59904 + j] = D[234][j];
  }

  D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");

  for (j = 0; j != D[235].length; ++j) if (D[235][j].charCodeAt(0) !== 0xFFFD) {
    e[D[235][j]] = 60160 + j;
    d[60160 + j] = D[235][j];
  }

  D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");

  for (j = 0; j != D[236].length; ++j) if (D[236][j].charCodeAt(0) !== 0xFFFD) {
    e[D[236][j]] = 60416 + j;
    d[60416 + j] = D[236][j];
  }

  D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");

  for (j = 0; j != D[237].length; ++j) if (D[237][j].charCodeAt(0) !== 0xFFFD) {
    e[D[237][j]] = 60672 + j;
    d[60672 + j] = D[237][j];
  }

  D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");

  for (j = 0; j != D[238].length; ++j) if (D[238][j].charCodeAt(0) !== 0xFFFD) {
    e[D[238][j]] = 60928 + j;
    d[60928 + j] = D[238][j];
  }

  D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");

  for (j = 0; j != D[239].length; ++j) if (D[239][j].charCodeAt(0) !== 0xFFFD) {
    e[D[239][j]] = 61184 + j;
    d[61184 + j] = D[239][j];
  }

  D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");

  for (j = 0; j != D[240].length; ++j) if (D[240][j].charCodeAt(0) !== 0xFFFD) {
    e[D[240][j]] = 61440 + j;
    d[61440 + j] = D[240][j];
  }

  D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");

  for (j = 0; j != D[241].length; ++j) if (D[241][j].charCodeAt(0) !== 0xFFFD) {
    e[D[241][j]] = 61696 + j;
    d[61696 + j] = D[241][j];
  }

  D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");

  for (j = 0; j != D[242].length; ++j) if (D[242][j].charCodeAt(0) !== 0xFFFD) {
    e[D[242][j]] = 61952 + j;
    d[61952 + j] = D[242][j];
  }

  D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");

  for (j = 0; j != D[243].length; ++j) if (D[243][j].charCodeAt(0) !== 0xFFFD) {
    e[D[243][j]] = 62208 + j;
    d[62208 + j] = D[243][j];
  }

  D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");

  for (j = 0; j != D[244].length; ++j) if (D[244][j].charCodeAt(0) !== 0xFFFD) {
    e[D[244][j]] = 62464 + j;
    d[62464 + j] = D[244][j];
  }

  D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");

  for (j = 0; j != D[245].length; ++j) if (D[245][j].charCodeAt(0) !== 0xFFFD) {
    e[D[245][j]] = 62720 + j;
    d[62720 + j] = D[245][j];
  }

  D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");

  for (j = 0; j != D[246].length; ++j) if (D[246][j].charCodeAt(0) !== 0xFFFD) {
    e[D[246][j]] = 62976 + j;
    d[62976 + j] = D[246][j];
  }

  D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");

  for (j = 0; j != D[247].length; ++j) if (D[247][j].charCodeAt(0) !== 0xFFFD) {
    e[D[247][j]] = 63232 + j;
    d[63232 + j] = D[247][j];
  }

  D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[248].length; ++j) if (D[248][j].charCodeAt(0) !== 0xFFFD) {
    e[D[248][j]] = 63488 + j;
    d[63488 + j] = D[248][j];
  }

  D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[249].length; ++j) if (D[249][j].charCodeAt(0) !== 0xFFFD) {
    e[D[249][j]] = 63744 + j;
    d[63744 + j] = D[249][j];
  }

  D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[250].length; ++j) if (D[250][j].charCodeAt(0) !== 0xFFFD) {
    e[D[250][j]] = 64000 + j;
    d[64000 + j] = D[250][j];
  }

  D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[251].length; ++j) if (D[251][j].charCodeAt(0) !== 0xFFFD) {
    e[D[251][j]] = 64256 + j;
    d[64256 + j] = D[251][j];
  }

  D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[252].length; ++j) if (D[252][j].charCodeAt(0) !== 0xFFFD) {
    e[D[252][j]] = 64512 + j;
    d[64512 + j] = D[252][j];
  }

  D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[253].length; ++j) if (D[253][j].charCodeAt(0) !== 0xFFFD) {
    e[D[253][j]] = 64768 + j;
    d[64768 + j] = D[253][j];
  }

  D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[254].length; ++j) if (D[254][j].charCodeAt(0) !== 0xFFFD) {
    e[D[254][j]] = 65024 + j;
    d[65024 + j] = D[254][j];
  }

  return {
    "enc": e,
    "dec": d
  };
}();

cptable[949] = function () {
  var d = [],
      e = {},
      D = [],
      j;
  D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[0].length; ++j) if (D[0][j].charCodeAt(0) !== 0xFFFD) {
    e[D[0][j]] = 0 + j;
    d[0 + j] = D[0][j];
  }

  D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");

  for (j = 0; j != D[129].length; ++j) if (D[129][j].charCodeAt(0) !== 0xFFFD) {
    e[D[129][j]] = 33024 + j;
    d[33024 + j] = D[129][j];
  }

  D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");

  for (j = 0; j != D[130].length; ++j) if (D[130][j].charCodeAt(0) !== 0xFFFD) {
    e[D[130][j]] = 33280 + j;
    d[33280 + j] = D[130][j];
  }

  D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");

  for (j = 0; j != D[131].length; ++j) if (D[131][j].charCodeAt(0) !== 0xFFFD) {
    e[D[131][j]] = 33536 + j;
    d[33536 + j] = D[131][j];
  }

  D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");

  for (j = 0; j != D[132].length; ++j) if (D[132][j].charCodeAt(0) !== 0xFFFD) {
    e[D[132][j]] = 33792 + j;
    d[33792 + j] = D[132][j];
  }

  D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");

  for (j = 0; j != D[133].length; ++j) if (D[133][j].charCodeAt(0) !== 0xFFFD) {
    e[D[133][j]] = 34048 + j;
    d[34048 + j] = D[133][j];
  }

  D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");

  for (j = 0; j != D[134].length; ++j) if (D[134][j].charCodeAt(0) !== 0xFFFD) {
    e[D[134][j]] = 34304 + j;
    d[34304 + j] = D[134][j];
  }

  D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");

  for (j = 0; j != D[135].length; ++j) if (D[135][j].charCodeAt(0) !== 0xFFFD) {
    e[D[135][j]] = 34560 + j;
    d[34560 + j] = D[135][j];
  }

  D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");

  for (j = 0; j != D[136].length; ++j) if (D[136][j].charCodeAt(0) !== 0xFFFD) {
    e[D[136][j]] = 34816 + j;
    d[34816 + j] = D[136][j];
  }

  D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");

  for (j = 0; j != D[137].length; ++j) if (D[137][j].charCodeAt(0) !== 0xFFFD) {
    e[D[137][j]] = 35072 + j;
    d[35072 + j] = D[137][j];
  }

  D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");

  for (j = 0; j != D[138].length; ++j) if (D[138][j].charCodeAt(0) !== 0xFFFD) {
    e[D[138][j]] = 35328 + j;
    d[35328 + j] = D[138][j];
  }

  D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");

  for (j = 0; j != D[139].length; ++j) if (D[139][j].charCodeAt(0) !== 0xFFFD) {
    e[D[139][j]] = 35584 + j;
    d[35584 + j] = D[139][j];
  }

  D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");

  for (j = 0; j != D[140].length; ++j) if (D[140][j].charCodeAt(0) !== 0xFFFD) {
    e[D[140][j]] = 35840 + j;
    d[35840 + j] = D[140][j];
  }

  D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");

  for (j = 0; j != D[141].length; ++j) if (D[141][j].charCodeAt(0) !== 0xFFFD) {
    e[D[141][j]] = 36096 + j;
    d[36096 + j] = D[141][j];
  }

  D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");

  for (j = 0; j != D[142].length; ++j) if (D[142][j].charCodeAt(0) !== 0xFFFD) {
    e[D[142][j]] = 36352 + j;
    d[36352 + j] = D[142][j];
  }

  D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");

  for (j = 0; j != D[143].length; ++j) if (D[143][j].charCodeAt(0) !== 0xFFFD) {
    e[D[143][j]] = 36608 + j;
    d[36608 + j] = D[143][j];
  }

  D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");

  for (j = 0; j != D[144].length; ++j) if (D[144][j].charCodeAt(0) !== 0xFFFD) {
    e[D[144][j]] = 36864 + j;
    d[36864 + j] = D[144][j];
  }

  D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");

  for (j = 0; j != D[145].length; ++j) if (D[145][j].charCodeAt(0) !== 0xFFFD) {
    e[D[145][j]] = 37120 + j;
    d[37120 + j] = D[145][j];
  }

  D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");

  for (j = 0; j != D[146].length; ++j) if (D[146][j].charCodeAt(0) !== 0xFFFD) {
    e[D[146][j]] = 37376 + j;
    d[37376 + j] = D[146][j];
  }

  D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");

  for (j = 0; j != D[147].length; ++j) if (D[147][j].charCodeAt(0) !== 0xFFFD) {
    e[D[147][j]] = 37632 + j;
    d[37632 + j] = D[147][j];
  }

  D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");

  for (j = 0; j != D[148].length; ++j) if (D[148][j].charCodeAt(0) !== 0xFFFD) {
    e[D[148][j]] = 37888 + j;
    d[37888 + j] = D[148][j];
  }

  D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");

  for (j = 0; j != D[149].length; ++j) if (D[149][j].charCodeAt(0) !== 0xFFFD) {
    e[D[149][j]] = 38144 + j;
    d[38144 + j] = D[149][j];
  }

  D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");

  for (j = 0; j != D[150].length; ++j) if (D[150][j].charCodeAt(0) !== 0xFFFD) {
    e[D[150][j]] = 38400 + j;
    d[38400 + j] = D[150][j];
  }

  D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");

  for (j = 0; j != D[151].length; ++j) if (D[151][j].charCodeAt(0) !== 0xFFFD) {
    e[D[151][j]] = 38656 + j;
    d[38656 + j] = D[151][j];
  }

  D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");

  for (j = 0; j != D[152].length; ++j) if (D[152][j].charCodeAt(0) !== 0xFFFD) {
    e[D[152][j]] = 38912 + j;
    d[38912 + j] = D[152][j];
  }

  D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");

  for (j = 0; j != D[153].length; ++j) if (D[153][j].charCodeAt(0) !== 0xFFFD) {
    e[D[153][j]] = 39168 + j;
    d[39168 + j] = D[153][j];
  }

  D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");

  for (j = 0; j != D[154].length; ++j) if (D[154][j].charCodeAt(0) !== 0xFFFD) {
    e[D[154][j]] = 39424 + j;
    d[39424 + j] = D[154][j];
  }

  D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");

  for (j = 0; j != D[155].length; ++j) if (D[155][j].charCodeAt(0) !== 0xFFFD) {
    e[D[155][j]] = 39680 + j;
    d[39680 + j] = D[155][j];
  }

  D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");

  for (j = 0; j != D[156].length; ++j) if (D[156][j].charCodeAt(0) !== 0xFFFD) {
    e[D[156][j]] = 39936 + j;
    d[39936 + j] = D[156][j];
  }

  D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");

  for (j = 0; j != D[157].length; ++j) if (D[157][j].charCodeAt(0) !== 0xFFFD) {
    e[D[157][j]] = 40192 + j;
    d[40192 + j] = D[157][j];
  }

  D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");

  for (j = 0; j != D[158].length; ++j) if (D[158][j].charCodeAt(0) !== 0xFFFD) {
    e[D[158][j]] = 40448 + j;
    d[40448 + j] = D[158][j];
  }

  D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");

  for (j = 0; j != D[159].length; ++j) if (D[159][j].charCodeAt(0) !== 0xFFFD) {
    e[D[159][j]] = 40704 + j;
    d[40704 + j] = D[159][j];
  }

  D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");

  for (j = 0; j != D[160].length; ++j) if (D[160][j].charCodeAt(0) !== 0xFFFD) {
    e[D[160][j]] = 40960 + j;
    d[40960 + j] = D[160][j];
  }

  D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");

  for (j = 0; j != D[161].length; ++j) if (D[161][j].charCodeAt(0) !== 0xFFFD) {
    e[D[161][j]] = 41216 + j;
    d[41216 + j] = D[161][j];
  }

  D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");

  for (j = 0; j != D[162].length; ++j) if (D[162][j].charCodeAt(0) !== 0xFFFD) {
    e[D[162][j]] = 41472 + j;
    d[41472 + j] = D[162][j];
  }

  D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");

  for (j = 0; j != D[163].length; ++j) if (D[163][j].charCodeAt(0) !== 0xFFFD) {
    e[D[163][j]] = 41728 + j;
    d[41728 + j] = D[163][j];
  }

  D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");

  for (j = 0; j != D[164].length; ++j) if (D[164][j].charCodeAt(0) !== 0xFFFD) {
    e[D[164][j]] = 41984 + j;
    d[41984 + j] = D[164][j];
  }

  D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");

  for (j = 0; j != D[165].length; ++j) if (D[165][j].charCodeAt(0) !== 0xFFFD) {
    e[D[165][j]] = 42240 + j;
    d[42240 + j] = D[165][j];
  }

  D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");

  for (j = 0; j != D[166].length; ++j) if (D[166][j].charCodeAt(0) !== 0xFFFD) {
    e[D[166][j]] = 42496 + j;
    d[42496 + j] = D[166][j];
  }

  D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");

  for (j = 0; j != D[167].length; ++j) if (D[167][j].charCodeAt(0) !== 0xFFFD) {
    e[D[167][j]] = 42752 + j;
    d[42752 + j] = D[167][j];
  }

  D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");

  for (j = 0; j != D[168].length; ++j) if (D[168][j].charCodeAt(0) !== 0xFFFD) {
    e[D[168][j]] = 43008 + j;
    d[43008 + j] = D[168][j];
  }

  D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");

  for (j = 0; j != D[169].length; ++j) if (D[169][j].charCodeAt(0) !== 0xFFFD) {
    e[D[169][j]] = 43264 + j;
    d[43264 + j] = D[169][j];
  }

  D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");

  for (j = 0; j != D[170].length; ++j) if (D[170][j].charCodeAt(0) !== 0xFFFD) {
    e[D[170][j]] = 43520 + j;
    d[43520 + j] = D[170][j];
  }

  D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");

  for (j = 0; j != D[171].length; ++j) if (D[171][j].charCodeAt(0) !== 0xFFFD) {
    e[D[171][j]] = 43776 + j;
    d[43776 + j] = D[171][j];
  }

  D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");

  for (j = 0; j != D[172].length; ++j) if (D[172][j].charCodeAt(0) !== 0xFFFD) {
    e[D[172][j]] = 44032 + j;
    d[44032 + j] = D[172][j];
  }

  D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[173].length; ++j) if (D[173][j].charCodeAt(0) !== 0xFFFD) {
    e[D[173][j]] = 44288 + j;
    d[44288 + j] = D[173][j];
  }

  D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[174].length; ++j) if (D[174][j].charCodeAt(0) !== 0xFFFD) {
    e[D[174][j]] = 44544 + j;
    d[44544 + j] = D[174][j];
  }

  D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[175].length; ++j) if (D[175][j].charCodeAt(0) !== 0xFFFD) {
    e[D[175][j]] = 44800 + j;
    d[44800 + j] = D[175][j];
  }

  D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");

  for (j = 0; j != D[176].length; ++j) if (D[176][j].charCodeAt(0) !== 0xFFFD) {
    e[D[176][j]] = 45056 + j;
    d[45056 + j] = D[176][j];
  }

  D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");

  for (j = 0; j != D[177].length; ++j) if (D[177][j].charCodeAt(0) !== 0xFFFD) {
    e[D[177][j]] = 45312 + j;
    d[45312 + j] = D[177][j];
  }

  D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");

  for (j = 0; j != D[178].length; ++j) if (D[178][j].charCodeAt(0) !== 0xFFFD) {
    e[D[178][j]] = 45568 + j;
    d[45568 + j] = D[178][j];
  }

  D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");

  for (j = 0; j != D[179].length; ++j) if (D[179][j].charCodeAt(0) !== 0xFFFD) {
    e[D[179][j]] = 45824 + j;
    d[45824 + j] = D[179][j];
  }

  D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");

  for (j = 0; j != D[180].length; ++j) if (D[180][j].charCodeAt(0) !== 0xFFFD) {
    e[D[180][j]] = 46080 + j;
    d[46080 + j] = D[180][j];
  }

  D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");

  for (j = 0; j != D[181].length; ++j) if (D[181][j].charCodeAt(0) !== 0xFFFD) {
    e[D[181][j]] = 46336 + j;
    d[46336 + j] = D[181][j];
  }

  D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");

  for (j = 0; j != D[182].length; ++j) if (D[182][j].charCodeAt(0) !== 0xFFFD) {
    e[D[182][j]] = 46592 + j;
    d[46592 + j] = D[182][j];
  }

  D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");

  for (j = 0; j != D[183].length; ++j) if (D[183][j].charCodeAt(0) !== 0xFFFD) {
    e[D[183][j]] = 46848 + j;
    d[46848 + j] = D[183][j];
  }

  D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");

  for (j = 0; j != D[184].length; ++j) if (D[184][j].charCodeAt(0) !== 0xFFFD) {
    e[D[184][j]] = 47104 + j;
    d[47104 + j] = D[184][j];
  }

  D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");

  for (j = 0; j != D[185].length; ++j) if (D[185][j].charCodeAt(0) !== 0xFFFD) {
    e[D[185][j]] = 47360 + j;
    d[47360 + j] = D[185][j];
  }

  D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");

  for (j = 0; j != D[186].length; ++j) if (D[186][j].charCodeAt(0) !== 0xFFFD) {
    e[D[186][j]] = 47616 + j;
    d[47616 + j] = D[186][j];
  }

  D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");

  for (j = 0; j != D[187].length; ++j) if (D[187][j].charCodeAt(0) !== 0xFFFD) {
    e[D[187][j]] = 47872 + j;
    d[47872 + j] = D[187][j];
  }

  D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");

  for (j = 0; j != D[188].length; ++j) if (D[188][j].charCodeAt(0) !== 0xFFFD) {
    e[D[188][j]] = 48128 + j;
    d[48128 + j] = D[188][j];
  }

  D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");

  for (j = 0; j != D[189].length; ++j) if (D[189][j].charCodeAt(0) !== 0xFFFD) {
    e[D[189][j]] = 48384 + j;
    d[48384 + j] = D[189][j];
  }

  D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");

  for (j = 0; j != D[190].length; ++j) if (D[190][j].charCodeAt(0) !== 0xFFFD) {
    e[D[190][j]] = 48640 + j;
    d[48640 + j] = D[190][j];
  }

  D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");

  for (j = 0; j != D[191].length; ++j) if (D[191][j].charCodeAt(0) !== 0xFFFD) {
    e[D[191][j]] = 48896 + j;
    d[48896 + j] = D[191][j];
  }

  D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");

  for (j = 0; j != D[192].length; ++j) if (D[192][j].charCodeAt(0) !== 0xFFFD) {
    e[D[192][j]] = 49152 + j;
    d[49152 + j] = D[192][j];
  }

  D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");

  for (j = 0; j != D[193].length; ++j) if (D[193][j].charCodeAt(0) !== 0xFFFD) {
    e[D[193][j]] = 49408 + j;
    d[49408 + j] = D[193][j];
  }

  D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");

  for (j = 0; j != D[194].length; ++j) if (D[194][j].charCodeAt(0) !== 0xFFFD) {
    e[D[194][j]] = 49664 + j;
    d[49664 + j] = D[194][j];
  }

  D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");

  for (j = 0; j != D[195].length; ++j) if (D[195][j].charCodeAt(0) !== 0xFFFD) {
    e[D[195][j]] = 49920 + j;
    d[49920 + j] = D[195][j];
  }

  D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");

  for (j = 0; j != D[196].length; ++j) if (D[196][j].charCodeAt(0) !== 0xFFFD) {
    e[D[196][j]] = 50176 + j;
    d[50176 + j] = D[196][j];
  }

  D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");

  for (j = 0; j != D[197].length; ++j) if (D[197][j].charCodeAt(0) !== 0xFFFD) {
    e[D[197][j]] = 50432 + j;
    d[50432 + j] = D[197][j];
  }

  D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");

  for (j = 0; j != D[198].length; ++j) if (D[198][j].charCodeAt(0) !== 0xFFFD) {
    e[D[198][j]] = 50688 + j;
    d[50688 + j] = D[198][j];
  }

  D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");

  for (j = 0; j != D[199].length; ++j) if (D[199][j].charCodeAt(0) !== 0xFFFD) {
    e[D[199][j]] = 50944 + j;
    d[50944 + j] = D[199][j];
  }

  D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");

  for (j = 0; j != D[200].length; ++j) if (D[200][j].charCodeAt(0) !== 0xFFFD) {
    e[D[200][j]] = 51200 + j;
    d[51200 + j] = D[200][j];
  }

  D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");

  for (j = 0; j != D[202].length; ++j) if (D[202][j].charCodeAt(0) !== 0xFFFD) {
    e[D[202][j]] = 51712 + j;
    d[51712 + j] = D[202][j];
  }

  D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");

  for (j = 0; j != D[203].length; ++j) if (D[203][j].charCodeAt(0) !== 0xFFFD) {
    e[D[203][j]] = 51968 + j;
    d[51968 + j] = D[203][j];
  }

  D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");

  for (j = 0; j != D[204].length; ++j) if (D[204][j].charCodeAt(0) !== 0xFFFD) {
    e[D[204][j]] = 52224 + j;
    d[52224 + j] = D[204][j];
  }

  D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");

  for (j = 0; j != D[205].length; ++j) if (D[205][j].charCodeAt(0) !== 0xFFFD) {
    e[D[205][j]] = 52480 + j;
    d[52480 + j] = D[205][j];
  }

  D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");

  for (j = 0; j != D[206].length; ++j) if (D[206][j].charCodeAt(0) !== 0xFFFD) {
    e[D[206][j]] = 52736 + j;
    d[52736 + j] = D[206][j];
  }

  D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");

  for (j = 0; j != D[207].length; ++j) if (D[207][j].charCodeAt(0) !== 0xFFFD) {
    e[D[207][j]] = 52992 + j;
    d[52992 + j] = D[207][j];
  }

  D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");

  for (j = 0; j != D[208].length; ++j) if (D[208][j].charCodeAt(0) !== 0xFFFD) {
    e[D[208][j]] = 53248 + j;
    d[53248 + j] = D[208][j];
  }

  D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");

  for (j = 0; j != D[209].length; ++j) if (D[209][j].charCodeAt(0) !== 0xFFFD) {
    e[D[209][j]] = 53504 + j;
    d[53504 + j] = D[209][j];
  }

  D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");

  for (j = 0; j != D[210].length; ++j) if (D[210][j].charCodeAt(0) !== 0xFFFD) {
    e[D[210][j]] = 53760 + j;
    d[53760 + j] = D[210][j];
  }

  D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");

  for (j = 0; j != D[211].length; ++j) if (D[211][j].charCodeAt(0) !== 0xFFFD) {
    e[D[211][j]] = 54016 + j;
    d[54016 + j] = D[211][j];
  }

  D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");

  for (j = 0; j != D[212].length; ++j) if (D[212][j].charCodeAt(0) !== 0xFFFD) {
    e[D[212][j]] = 54272 + j;
    d[54272 + j] = D[212][j];
  }

  D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");

  for (j = 0; j != D[213].length; ++j) if (D[213][j].charCodeAt(0) !== 0xFFFD) {
    e[D[213][j]] = 54528 + j;
    d[54528 + j] = D[213][j];
  }

  D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");

  for (j = 0; j != D[214].length; ++j) if (D[214][j].charCodeAt(0) !== 0xFFFD) {
    e[D[214][j]] = 54784 + j;
    d[54784 + j] = D[214][j];
  }

  D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");

  for (j = 0; j != D[215].length; ++j) if (D[215][j].charCodeAt(0) !== 0xFFFD) {
    e[D[215][j]] = 55040 + j;
    d[55040 + j] = D[215][j];
  }

  D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");

  for (j = 0; j != D[216].length; ++j) if (D[216][j].charCodeAt(0) !== 0xFFFD) {
    e[D[216][j]] = 55296 + j;
    d[55296 + j] = D[216][j];
  }

  D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");

  for (j = 0; j != D[217].length; ++j) if (D[217][j].charCodeAt(0) !== 0xFFFD) {
    e[D[217][j]] = 55552 + j;
    d[55552 + j] = D[217][j];
  }

  D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");

  for (j = 0; j != D[218].length; ++j) if (D[218][j].charCodeAt(0) !== 0xFFFD) {
    e[D[218][j]] = 55808 + j;
    d[55808 + j] = D[218][j];
  }

  D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");

  for (j = 0; j != D[219].length; ++j) if (D[219][j].charCodeAt(0) !== 0xFFFD) {
    e[D[219][j]] = 56064 + j;
    d[56064 + j] = D[219][j];
  }

  D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");

  for (j = 0; j != D[220].length; ++j) if (D[220][j].charCodeAt(0) !== 0xFFFD) {
    e[D[220][j]] = 56320 + j;
    d[56320 + j] = D[220][j];
  }

  D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");

  for (j = 0; j != D[221].length; ++j) if (D[221][j].charCodeAt(0) !== 0xFFFD) {
    e[D[221][j]] = 56576 + j;
    d[56576 + j] = D[221][j];
  }

  D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");

  for (j = 0; j != D[222].length; ++j) if (D[222][j].charCodeAt(0) !== 0xFFFD) {
    e[D[222][j]] = 56832 + j;
    d[56832 + j] = D[222][j];
  }

  D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");

  for (j = 0; j != D[223].length; ++j) if (D[223][j].charCodeAt(0) !== 0xFFFD) {
    e[D[223][j]] = 57088 + j;
    d[57088 + j] = D[223][j];
  }

  D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");

  for (j = 0; j != D[224].length; ++j) if (D[224][j].charCodeAt(0) !== 0xFFFD) {
    e[D[224][j]] = 57344 + j;
    d[57344 + j] = D[224][j];
  }

  D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");

  for (j = 0; j != D[225].length; ++j) if (D[225][j].charCodeAt(0) !== 0xFFFD) {
    e[D[225][j]] = 57600 + j;
    d[57600 + j] = D[225][j];
  }

  D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");

  for (j = 0; j != D[226].length; ++j) if (D[226][j].charCodeAt(0) !== 0xFFFD) {
    e[D[226][j]] = 57856 + j;
    d[57856 + j] = D[226][j];
  }

  D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");

  for (j = 0; j != D[227].length; ++j) if (D[227][j].charCodeAt(0) !== 0xFFFD) {
    e[D[227][j]] = 58112 + j;
    d[58112 + j] = D[227][j];
  }

  D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");

  for (j = 0; j != D[228].length; ++j) if (D[228][j].charCodeAt(0) !== 0xFFFD) {
    e[D[228][j]] = 58368 + j;
    d[58368 + j] = D[228][j];
  }

  D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");

  for (j = 0; j != D[229].length; ++j) if (D[229][j].charCodeAt(0) !== 0xFFFD) {
    e[D[229][j]] = 58624 + j;
    d[58624 + j] = D[229][j];
  }

  D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");

  for (j = 0; j != D[230].length; ++j) if (D[230][j].charCodeAt(0) !== 0xFFFD) {
    e[D[230][j]] = 58880 + j;
    d[58880 + j] = D[230][j];
  }

  D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");

  for (j = 0; j != D[231].length; ++j) if (D[231][j].charCodeAt(0) !== 0xFFFD) {
    e[D[231][j]] = 59136 + j;
    d[59136 + j] = D[231][j];
  }

  D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");

  for (j = 0; j != D[232].length; ++j) if (D[232][j].charCodeAt(0) !== 0xFFFD) {
    e[D[232][j]] = 59392 + j;
    d[59392 + j] = D[232][j];
  }

  D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");

  for (j = 0; j != D[233].length; ++j) if (D[233][j].charCodeAt(0) !== 0xFFFD) {
    e[D[233][j]] = 59648 + j;
    d[59648 + j] = D[233][j];
  }

  D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");

  for (j = 0; j != D[234].length; ++j) if (D[234][j].charCodeAt(0) !== 0xFFFD) {
    e[D[234][j]] = 59904 + j;
    d[59904 + j] = D[234][j];
  }

  D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");

  for (j = 0; j != D[235].length; ++j) if (D[235][j].charCodeAt(0) !== 0xFFFD) {
    e[D[235][j]] = 60160 + j;
    d[60160 + j] = D[235][j];
  }

  D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");

  for (j = 0; j != D[236].length; ++j) if (D[236][j].charCodeAt(0) !== 0xFFFD) {
    e[D[236][j]] = 60416 + j;
    d[60416 + j] = D[236][j];
  }

  D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");

  for (j = 0; j != D[237].length; ++j) if (D[237][j].charCodeAt(0) !== 0xFFFD) {
    e[D[237][j]] = 60672 + j;
    d[60672 + j] = D[237][j];
  }

  D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");

  for (j = 0; j != D[238].length; ++j) if (D[238][j].charCodeAt(0) !== 0xFFFD) {
    e[D[238][j]] = 60928 + j;
    d[60928 + j] = D[238][j];
  }

  D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");

  for (j = 0; j != D[239].length; ++j) if (D[239][j].charCodeAt(0) !== 0xFFFD) {
    e[D[239][j]] = 61184 + j;
    d[61184 + j] = D[239][j];
  }

  D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");

  for (j = 0; j != D[240].length; ++j) if (D[240][j].charCodeAt(0) !== 0xFFFD) {
    e[D[240][j]] = 61440 + j;
    d[61440 + j] = D[240][j];
  }

  D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");

  for (j = 0; j != D[241].length; ++j) if (D[241][j].charCodeAt(0) !== 0xFFFD) {
    e[D[241][j]] = 61696 + j;
    d[61696 + j] = D[241][j];
  }

  D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");

  for (j = 0; j != D[242].length; ++j) if (D[242][j].charCodeAt(0) !== 0xFFFD) {
    e[D[242][j]] = 61952 + j;
    d[61952 + j] = D[242][j];
  }

  D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");

  for (j = 0; j != D[243].length; ++j) if (D[243][j].charCodeAt(0) !== 0xFFFD) {
    e[D[243][j]] = 62208 + j;
    d[62208 + j] = D[243][j];
  }

  D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");

  for (j = 0; j != D[244].length; ++j) if (D[244][j].charCodeAt(0) !== 0xFFFD) {
    e[D[244][j]] = 62464 + j;
    d[62464 + j] = D[244][j];
  }

  D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");

  for (j = 0; j != D[245].length; ++j) if (D[245][j].charCodeAt(0) !== 0xFFFD) {
    e[D[245][j]] = 62720 + j;
    d[62720 + j] = D[245][j];
  }

  D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");

  for (j = 0; j != D[246].length; ++j) if (D[246][j].charCodeAt(0) !== 0xFFFD) {
    e[D[246][j]] = 62976 + j;
    d[62976 + j] = D[246][j];
  }

  D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");

  for (j = 0; j != D[247].length; ++j) if (D[247][j].charCodeAt(0) !== 0xFFFD) {
    e[D[247][j]] = 63232 + j;
    d[63232 + j] = D[247][j];
  }

  D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");

  for (j = 0; j != D[248].length; ++j) if (D[248][j].charCodeAt(0) !== 0xFFFD) {
    e[D[248][j]] = 63488 + j;
    d[63488 + j] = D[248][j];
  }

  D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");

  for (j = 0; j != D[249].length; ++j) if (D[249][j].charCodeAt(0) !== 0xFFFD) {
    e[D[249][j]] = 63744 + j;
    d[63744 + j] = D[249][j];
  }

  D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");

  for (j = 0; j != D[250].length; ++j) if (D[250][j].charCodeAt(0) !== 0xFFFD) {
    e[D[250][j]] = 64000 + j;
    d[64000 + j] = D[250][j];
  }

  D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");

  for (j = 0; j != D[251].length; ++j) if (D[251][j].charCodeAt(0) !== 0xFFFD) {
    e[D[251][j]] = 64256 + j;
    d[64256 + j] = D[251][j];
  }

  D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");

  for (j = 0; j != D[252].length; ++j) if (D[252][j].charCodeAt(0) !== 0xFFFD) {
    e[D[252][j]] = 64512 + j;
    d[64512 + j] = D[252][j];
  }

  D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");

  for (j = 0; j != D[253].length; ++j) if (D[253][j].charCodeAt(0) !== 0xFFFD) {
    e[D[253][j]] = 64768 + j;
    d[64768 + j] = D[253][j];
  }

  return {
    "enc": e,
    "dec": d
  };
}();

cptable[950] = function () {
  var d = [],
      e = {},
      D = [],
      j;
  D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[0].length; ++j) if (D[0][j].charCodeAt(0) !== 0xFFFD) {
    e[D[0][j]] = 0 + j;
    d[0 + j] = D[0][j];
  }

  D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");

  for (j = 0; j != D[161].length; ++j) if (D[161][j].charCodeAt(0) !== 0xFFFD) {
    e[D[161][j]] = 41216 + j;
    d[41216 + j] = D[161][j];
  }

  D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");

  for (j = 0; j != D[162].length; ++j) if (D[162][j].charCodeAt(0) !== 0xFFFD) {
    e[D[162][j]] = 41472 + j;
    d[41472 + j] = D[162][j];
  }

  D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");

  for (j = 0; j != D[163].length; ++j) if (D[163][j].charCodeAt(0) !== 0xFFFD) {
    e[D[163][j]] = 41728 + j;
    d[41728 + j] = D[163][j];
  }

  D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");

  for (j = 0; j != D[164].length; ++j) if (D[164][j].charCodeAt(0) !== 0xFFFD) {
    e[D[164][j]] = 41984 + j;
    d[41984 + j] = D[164][j];
  }

  D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");

  for (j = 0; j != D[165].length; ++j) if (D[165][j].charCodeAt(0) !== 0xFFFD) {
    e[D[165][j]] = 42240 + j;
    d[42240 + j] = D[165][j];
  }

  D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");

  for (j = 0; j != D[166].length; ++j) if (D[166][j].charCodeAt(0) !== 0xFFFD) {
    e[D[166][j]] = 42496 + j;
    d[42496 + j] = D[166][j];
  }

  D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");

  for (j = 0; j != D[167].length; ++j) if (D[167][j].charCodeAt(0) !== 0xFFFD) {
    e[D[167][j]] = 42752 + j;
    d[42752 + j] = D[167][j];
  }

  D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");

  for (j = 0; j != D[168].length; ++j) if (D[168][j].charCodeAt(0) !== 0xFFFD) {
    e[D[168][j]] = 43008 + j;
    d[43008 + j] = D[168][j];
  }

  D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");

  for (j = 0; j != D[169].length; ++j) if (D[169][j].charCodeAt(0) !== 0xFFFD) {
    e[D[169][j]] = 43264 + j;
    d[43264 + j] = D[169][j];
  }

  D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");

  for (j = 0; j != D[170].length; ++j) if (D[170][j].charCodeAt(0) !== 0xFFFD) {
    e[D[170][j]] = 43520 + j;
    d[43520 + j] = D[170][j];
  }

  D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");

  for (j = 0; j != D[171].length; ++j) if (D[171][j].charCodeAt(0) !== 0xFFFD) {
    e[D[171][j]] = 43776 + j;
    d[43776 + j] = D[171][j];
  }

  D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");

  for (j = 0; j != D[172].length; ++j) if (D[172][j].charCodeAt(0) !== 0xFFFD) {
    e[D[172][j]] = 44032 + j;
    d[44032 + j] = D[172][j];
  }

  D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");

  for (j = 0; j != D[173].length; ++j) if (D[173][j].charCodeAt(0) !== 0xFFFD) {
    e[D[173][j]] = 44288 + j;
    d[44288 + j] = D[173][j];
  }

  D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");

  for (j = 0; j != D[174].length; ++j) if (D[174][j].charCodeAt(0) !== 0xFFFD) {
    e[D[174][j]] = 44544 + j;
    d[44544 + j] = D[174][j];
  }

  D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");

  for (j = 0; j != D[175].length; ++j) if (D[175][j].charCodeAt(0) !== 0xFFFD) {
    e[D[175][j]] = 44800 + j;
    d[44800 + j] = D[175][j];
  }

  D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");

  for (j = 0; j != D[176].length; ++j) if (D[176][j].charCodeAt(0) !== 0xFFFD) {
    e[D[176][j]] = 45056 + j;
    d[45056 + j] = D[176][j];
  }

  D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");

  for (j = 0; j != D[177].length; ++j) if (D[177][j].charCodeAt(0) !== 0xFFFD) {
    e[D[177][j]] = 45312 + j;
    d[45312 + j] = D[177][j];
  }

  D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");

  for (j = 0; j != D[178].length; ++j) if (D[178][j].charCodeAt(0) !== 0xFFFD) {
    e[D[178][j]] = 45568 + j;
    d[45568 + j] = D[178][j];
  }

  D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");

  for (j = 0; j != D[179].length; ++j) if (D[179][j].charCodeAt(0) !== 0xFFFD) {
    e[D[179][j]] = 45824 + j;
    d[45824 + j] = D[179][j];
  }

  D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");

  for (j = 0; j != D[180].length; ++j) if (D[180][j].charCodeAt(0) !== 0xFFFD) {
    e[D[180][j]] = 46080 + j;
    d[46080 + j] = D[180][j];
  }

  D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");

  for (j = 0; j != D[181].length; ++j) if (D[181][j].charCodeAt(0) !== 0xFFFD) {
    e[D[181][j]] = 46336 + j;
    d[46336 + j] = D[181][j];
  }

  D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");

  for (j = 0; j != D[182].length; ++j) if (D[182][j].charCodeAt(0) !== 0xFFFD) {
    e[D[182][j]] = 46592 + j;
    d[46592 + j] = D[182][j];
  }

  D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");

  for (j = 0; j != D[183].length; ++j) if (D[183][j].charCodeAt(0) !== 0xFFFD) {
    e[D[183][j]] = 46848 + j;
    d[46848 + j] = D[183][j];
  }

  D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");

  for (j = 0; j != D[184].length; ++j) if (D[184][j].charCodeAt(0) !== 0xFFFD) {
    e[D[184][j]] = 47104 + j;
    d[47104 + j] = D[184][j];
  }

  D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");

  for (j = 0; j != D[185].length; ++j) if (D[185][j].charCodeAt(0) !== 0xFFFD) {
    e[D[185][j]] = 47360 + j;
    d[47360 + j] = D[185][j];
  }

  D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");

  for (j = 0; j != D[186].length; ++j) if (D[186][j].charCodeAt(0) !== 0xFFFD) {
    e[D[186][j]] = 47616 + j;
    d[47616 + j] = D[186][j];
  }

  D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");

  for (j = 0; j != D[187].length; ++j) if (D[187][j].charCodeAt(0) !== 0xFFFD) {
    e[D[187][j]] = 47872 + j;
    d[47872 + j] = D[187][j];
  }

  D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");

  for (j = 0; j != D[188].length; ++j) if (D[188][j].charCodeAt(0) !== 0xFFFD) {
    e[D[188][j]] = 48128 + j;
    d[48128 + j] = D[188][j];
  }

  D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");

  for (j = 0; j != D[189].length; ++j) if (D[189][j].charCodeAt(0) !== 0xFFFD) {
    e[D[189][j]] = 48384 + j;
    d[48384 + j] = D[189][j];
  }

  D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");

  for (j = 0; j != D[190].length; ++j) if (D[190][j].charCodeAt(0) !== 0xFFFD) {
    e[D[190][j]] = 48640 + j;
    d[48640 + j] = D[190][j];
  }

  D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");

  for (j = 0; j != D[191].length; ++j) if (D[191][j].charCodeAt(0) !== 0xFFFD) {
    e[D[191][j]] = 48896 + j;
    d[48896 + j] = D[191][j];
  }

  D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");

  for (j = 0; j != D[192].length; ++j) if (D[192][j].charCodeAt(0) !== 0xFFFD) {
    e[D[192][j]] = 49152 + j;
    d[49152 + j] = D[192][j];
  }

  D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");

  for (j = 0; j != D[193].length; ++j) if (D[193][j].charCodeAt(0) !== 0xFFFD) {
    e[D[193][j]] = 49408 + j;
    d[49408 + j] = D[193][j];
  }

  D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");

  for (j = 0; j != D[194].length; ++j) if (D[194][j].charCodeAt(0) !== 0xFFFD) {
    e[D[194][j]] = 49664 + j;
    d[49664 + j] = D[194][j];
  }

  D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");

  for (j = 0; j != D[195].length; ++j) if (D[195][j].charCodeAt(0) !== 0xFFFD) {
    e[D[195][j]] = 49920 + j;
    d[49920 + j] = D[195][j];
  }

  D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");

  for (j = 0; j != D[196].length; ++j) if (D[196][j].charCodeAt(0) !== 0xFFFD) {
    e[D[196][j]] = 50176 + j;
    d[50176 + j] = D[196][j];
  }

  D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");

  for (j = 0; j != D[197].length; ++j) if (D[197][j].charCodeAt(0) !== 0xFFFD) {
    e[D[197][j]] = 50432 + j;
    d[50432 + j] = D[197][j];
  }

  D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[198].length; ++j) if (D[198][j].charCodeAt(0) !== 0xFFFD) {
    e[D[198][j]] = 50688 + j;
    d[50688 + j] = D[198][j];
  }

  D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");

  for (j = 0; j != D[201].length; ++j) if (D[201][j].charCodeAt(0) !== 0xFFFD) {
    e[D[201][j]] = 51456 + j;
    d[51456 + j] = D[201][j];
  }

  D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");

  for (j = 0; j != D[202].length; ++j) if (D[202][j].charCodeAt(0) !== 0xFFFD) {
    e[D[202][j]] = 51712 + j;
    d[51712 + j] = D[202][j];
  }

  D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");

  for (j = 0; j != D[203].length; ++j) if (D[203][j].charCodeAt(0) !== 0xFFFD) {
    e[D[203][j]] = 51968 + j;
    d[51968 + j] = D[203][j];
  }

  D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");

  for (j = 0; j != D[204].length; ++j) if (D[204][j].charCodeAt(0) !== 0xFFFD) {
    e[D[204][j]] = 52224 + j;
    d[52224 + j] = D[204][j];
  }

  D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");

  for (j = 0; j != D[205].length; ++j) if (D[205][j].charCodeAt(0) !== 0xFFFD) {
    e[D[205][j]] = 52480 + j;
    d[52480 + j] = D[205][j];
  }

  D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");

  for (j = 0; j != D[206].length; ++j) if (D[206][j].charCodeAt(0) !== 0xFFFD) {
    e[D[206][j]] = 52736 + j;
    d[52736 + j] = D[206][j];
  }

  D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");

  for (j = 0; j != D[207].length; ++j) if (D[207][j].charCodeAt(0) !== 0xFFFD) {
    e[D[207][j]] = 52992 + j;
    d[52992 + j] = D[207][j];
  }

  D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");

  for (j = 0; j != D[208].length; ++j) if (D[208][j].charCodeAt(0) !== 0xFFFD) {
    e[D[208][j]] = 53248 + j;
    d[53248 + j] = D[208][j];
  }

  D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");

  for (j = 0; j != D[209].length; ++j) if (D[209][j].charCodeAt(0) !== 0xFFFD) {
    e[D[209][j]] = 53504 + j;
    d[53504 + j] = D[209][j];
  }

  D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");

  for (j = 0; j != D[210].length; ++j) if (D[210][j].charCodeAt(0) !== 0xFFFD) {
    e[D[210][j]] = 53760 + j;
    d[53760 + j] = D[210][j];
  }

  D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");

  for (j = 0; j != D[211].length; ++j) if (D[211][j].charCodeAt(0) !== 0xFFFD) {
    e[D[211][j]] = 54016 + j;
    d[54016 + j] = D[211][j];
  }

  D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");

  for (j = 0; j != D[212].length; ++j) if (D[212][j].charCodeAt(0) !== 0xFFFD) {
    e[D[212][j]] = 54272 + j;
    d[54272 + j] = D[212][j];
  }

  D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");

  for (j = 0; j != D[213].length; ++j) if (D[213][j].charCodeAt(0) !== 0xFFFD) {
    e[D[213][j]] = 54528 + j;
    d[54528 + j] = D[213][j];
  }

  D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");

  for (j = 0; j != D[214].length; ++j) if (D[214][j].charCodeAt(0) !== 0xFFFD) {
    e[D[214][j]] = 54784 + j;
    d[54784 + j] = D[214][j];
  }

  D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");

  for (j = 0; j != D[215].length; ++j) if (D[215][j].charCodeAt(0) !== 0xFFFD) {
    e[D[215][j]] = 55040 + j;
    d[55040 + j] = D[215][j];
  }

  D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");

  for (j = 0; j != D[216].length; ++j) if (D[216][j].charCodeAt(0) !== 0xFFFD) {
    e[D[216][j]] = 55296 + j;
    d[55296 + j] = D[216][j];
  }

  D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");

  for (j = 0; j != D[217].length; ++j) if (D[217][j].charCodeAt(0) !== 0xFFFD) {
    e[D[217][j]] = 55552 + j;
    d[55552 + j] = D[217][j];
  }

  D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");

  for (j = 0; j != D[218].length; ++j) if (D[218][j].charCodeAt(0) !== 0xFFFD) {
    e[D[218][j]] = 55808 + j;
    d[55808 + j] = D[218][j];
  }

  D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");

  for (j = 0; j != D[219].length; ++j) if (D[219][j].charCodeAt(0) !== 0xFFFD) {
    e[D[219][j]] = 56064 + j;
    d[56064 + j] = D[219][j];
  }

  D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");

  for (j = 0; j != D[220].length; ++j) if (D[220][j].charCodeAt(0) !== 0xFFFD) {
    e[D[220][j]] = 56320 + j;
    d[56320 + j] = D[220][j];
  }

  D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");

  for (j = 0; j != D[221].length; ++j) if (D[221][j].charCodeAt(0) !== 0xFFFD) {
    e[D[221][j]] = 56576 + j;
    d[56576 + j] = D[221][j];
  }

  D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");

  for (j = 0; j != D[222].length; ++j) if (D[222][j].charCodeAt(0) !== 0xFFFD) {
    e[D[222][j]] = 56832 + j;
    d[56832 + j] = D[222][j];
  }

  D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");

  for (j = 0; j != D[223].length; ++j) if (D[223][j].charCodeAt(0) !== 0xFFFD) {
    e[D[223][j]] = 57088 + j;
    d[57088 + j] = D[223][j];
  }

  D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");

  for (j = 0; j != D[224].length; ++j) if (D[224][j].charCodeAt(0) !== 0xFFFD) {
    e[D[224][j]] = 57344 + j;
    d[57344 + j] = D[224][j];
  }

  D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");

  for (j = 0; j != D[225].length; ++j) if (D[225][j].charCodeAt(0) !== 0xFFFD) {
    e[D[225][j]] = 57600 + j;
    d[57600 + j] = D[225][j];
  }

  D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");

  for (j = 0; j != D[226].length; ++j) if (D[226][j].charCodeAt(0) !== 0xFFFD) {
    e[D[226][j]] = 57856 + j;
    d[57856 + j] = D[226][j];
  }

  D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");

  for (j = 0; j != D[227].length; ++j) if (D[227][j].charCodeAt(0) !== 0xFFFD) {
    e[D[227][j]] = 58112 + j;
    d[58112 + j] = D[227][j];
  }

  D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");

  for (j = 0; j != D[228].length; ++j) if (D[228][j].charCodeAt(0) !== 0xFFFD) {
    e[D[228][j]] = 58368 + j;
    d[58368 + j] = D[228][j];
  }

  D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");

  for (j = 0; j != D[229].length; ++j) if (D[229][j].charCodeAt(0) !== 0xFFFD) {
    e[D[229][j]] = 58624 + j;
    d[58624 + j] = D[229][j];
  }

  D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");

  for (j = 0; j != D[230].length; ++j) if (D[230][j].charCodeAt(0) !== 0xFFFD) {
    e[D[230][j]] = 58880 + j;
    d[58880 + j] = D[230][j];
  }

  D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");

  for (j = 0; j != D[231].length; ++j) if (D[231][j].charCodeAt(0) !== 0xFFFD) {
    e[D[231][j]] = 59136 + j;
    d[59136 + j] = D[231][j];
  }

  D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");

  for (j = 0; j != D[232].length; ++j) if (D[232][j].charCodeAt(0) !== 0xFFFD) {
    e[D[232][j]] = 59392 + j;
    d[59392 + j] = D[232][j];
  }

  D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");

  for (j = 0; j != D[233].length; ++j) if (D[233][j].charCodeAt(0) !== 0xFFFD) {
    e[D[233][j]] = 59648 + j;
    d[59648 + j] = D[233][j];
  }

  D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");

  for (j = 0; j != D[234].length; ++j) if (D[234][j].charCodeAt(0) !== 0xFFFD) {
    e[D[234][j]] = 59904 + j;
    d[59904 + j] = D[234][j];
  }

  D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");

  for (j = 0; j != D[235].length; ++j) if (D[235][j].charCodeAt(0) !== 0xFFFD) {
    e[D[235][j]] = 60160 + j;
    d[60160 + j] = D[235][j];
  }

  D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");

  for (j = 0; j != D[236].length; ++j) if (D[236][j].charCodeAt(0) !== 0xFFFD) {
    e[D[236][j]] = 60416 + j;
    d[60416 + j] = D[236][j];
  }

  D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");

  for (j = 0; j != D[237].length; ++j) if (D[237][j].charCodeAt(0) !== 0xFFFD) {
    e[D[237][j]] = 60672 + j;
    d[60672 + j] = D[237][j];
  }

  D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");

  for (j = 0; j != D[238].length; ++j) if (D[238][j].charCodeAt(0) !== 0xFFFD) {
    e[D[238][j]] = 60928 + j;
    d[60928 + j] = D[238][j];
  }

  D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");

  for (j = 0; j != D[239].length; ++j) if (D[239][j].charCodeAt(0) !== 0xFFFD) {
    e[D[239][j]] = 61184 + j;
    d[61184 + j] = D[239][j];
  }

  D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");

  for (j = 0; j != D[240].length; ++j) if (D[240][j].charCodeAt(0) !== 0xFFFD) {
    e[D[240][j]] = 61440 + j;
    d[61440 + j] = D[240][j];
  }

  D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");

  for (j = 0; j != D[241].length; ++j) if (D[241][j].charCodeAt(0) !== 0xFFFD) {
    e[D[241][j]] = 61696 + j;
    d[61696 + j] = D[241][j];
  }

  D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");

  for (j = 0; j != D[242].length; ++j) if (D[242][j].charCodeAt(0) !== 0xFFFD) {
    e[D[242][j]] = 61952 + j;
    d[61952 + j] = D[242][j];
  }

  D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");

  for (j = 0; j != D[243].length; ++j) if (D[243][j].charCodeAt(0) !== 0xFFFD) {
    e[D[243][j]] = 62208 + j;
    d[62208 + j] = D[243][j];
  }

  D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");

  for (j = 0; j != D[244].length; ++j) if (D[244][j].charCodeAt(0) !== 0xFFFD) {
    e[D[244][j]] = 62464 + j;
    d[62464 + j] = D[244][j];
  }

  D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");

  for (j = 0; j != D[245].length; ++j) if (D[245][j].charCodeAt(0) !== 0xFFFD) {
    e[D[245][j]] = 62720 + j;
    d[62720 + j] = D[245][j];
  }

  D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");

  for (j = 0; j != D[246].length; ++j) if (D[246][j].charCodeAt(0) !== 0xFFFD) {
    e[D[246][j]] = 62976 + j;
    d[62976 + j] = D[246][j];
  }

  D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");

  for (j = 0; j != D[247].length; ++j) if (D[247][j].charCodeAt(0) !== 0xFFFD) {
    e[D[247][j]] = 63232 + j;
    d[63232 + j] = D[247][j];
  }

  D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");

  for (j = 0; j != D[248].length; ++j) if (D[248][j].charCodeAt(0) !== 0xFFFD) {
    e[D[248][j]] = 63488 + j;
    d[63488 + j] = D[248][j];
  }

  D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");

  for (j = 0; j != D[249].length; ++j) if (D[249][j].charCodeAt(0) !== 0xFFFD) {
    e[D[249][j]] = 63744 + j;
    d[63744 + j] = D[249][j];
  }

  return {
    "enc": e,
    "dec": d
  };
}();

cptable[1250] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[1251] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[1252] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[1253] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[1254] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[1255] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[1256] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[1257] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[1258] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[10000] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[10006] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[10007] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[10008] = function () {
  var d = [],
      e = {},
      D = [],
      j;
  D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");

  for (j = 0; j != D[0].length; ++j) if (D[0][j].charCodeAt(0) !== 0xFFFD) {
    e[D[0][j]] = 0 + j;
    d[0 + j] = D[0][j];
  }

  D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");

  for (j = 0; j != D[161].length; ++j) if (D[161][j].charCodeAt(0) !== 0xFFFD) {
    e[D[161][j]] = 41216 + j;
    d[41216 + j] = D[161][j];
  }

  D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");

  for (j = 0; j != D[162].length; ++j) if (D[162][j].charCodeAt(0) !== 0xFFFD) {
    e[D[162][j]] = 41472 + j;
    d[41472 + j] = D[162][j];
  }

  D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");

  for (j = 0; j != D[163].length; ++j) if (D[163][j].charCodeAt(0) !== 0xFFFD) {
    e[D[163][j]] = 41728 + j;
    d[41728 + j] = D[163][j];
  }

  D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");

  for (j = 0; j != D[164].length; ++j) if (D[164][j].charCodeAt(0) !== 0xFFFD) {
    e[D[164][j]] = 41984 + j;
    d[41984 + j] = D[164][j];
  }

  D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");

  for (j = 0; j != D[165].length; ++j) if (D[165][j].charCodeAt(0) !== 0xFFFD) {
    e[D[165][j]] = 42240 + j;
    d[42240 + j] = D[165][j];
  }

  D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");

  for (j = 0; j != D[166].length; ++j) if (D[166][j].charCodeAt(0) !== 0xFFFD) {
    e[D[166][j]] = 42496 + j;
    d[42496 + j] = D[166][j];
  }

  D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");

  for (j = 0; j != D[167].length; ++j) if (D[167][j].charCodeAt(0) !== 0xFFFD) {
    e[D[167][j]] = 42752 + j;
    d[42752 + j] = D[167][j];
  }

  D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");

  for (j = 0; j != D[168].length; ++j) if (D[168][j].charCodeAt(0) !== 0xFFFD) {
    e[D[168][j]] = 43008 + j;
    d[43008 + j] = D[168][j];
  }

  D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");

  for (j = 0; j != D[169].length; ++j) if (D[169][j].charCodeAt(0) !== 0xFFFD) {
    e[D[169][j]] = 43264 + j;
    d[43264 + j] = D[169][j];
  }

  D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");

  for (j = 0; j != D[176].length; ++j) if (D[176][j].charCodeAt(0) !== 0xFFFD) {
    e[D[176][j]] = 45056 + j;
    d[45056 + j] = D[176][j];
  }

  D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");

  for (j = 0; j != D[177].length; ++j) if (D[177][j].charCodeAt(0) !== 0xFFFD) {
    e[D[177][j]] = 45312 + j;
    d[45312 + j] = D[177][j];
  }

  D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");

  for (j = 0; j != D[178].length; ++j) if (D[178][j].charCodeAt(0) !== 0xFFFD) {
    e[D[178][j]] = 45568 + j;
    d[45568 + j] = D[178][j];
  }

  D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");

  for (j = 0; j != D[179].length; ++j) if (D[179][j].charCodeAt(0) !== 0xFFFD) {
    e[D[179][j]] = 45824 + j;
    d[45824 + j] = D[179][j];
  }

  D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");

  for (j = 0; j != D[180].length; ++j) if (D[180][j].charCodeAt(0) !== 0xFFFD) {
    e[D[180][j]] = 46080 + j;
    d[46080 + j] = D[180][j];
  }

  D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");

  for (j = 0; j != D[181].length; ++j) if (D[181][j].charCodeAt(0) !== 0xFFFD) {
    e[D[181][j]] = 46336 + j;
    d[46336 + j] = D[181][j];
  }

  D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");

  for (j = 0; j != D[182].length; ++j) if (D[182][j].charCodeAt(0) !== 0xFFFD) {
    e[D[182][j]] = 46592 + j;
    d[46592 + j] = D[182][j];
  }

  D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");

  for (j = 0; j != D[183].length; ++j) if (D[183][j].charCodeAt(0) !== 0xFFFD) {
    e[D[183][j]] = 46848 + j;
    d[46848 + j] = D[183][j];
  }

  D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");

  for (j = 0; j != D[184].length; ++j) if (D[184][j].charCodeAt(0) !== 0xFFFD) {
    e[D[184][j]] = 47104 + j;
    d[47104 + j] = D[184][j];
  }

  D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");

  for (j = 0; j != D[185].length; ++j) if (D[185][j].charCodeAt(0) !== 0xFFFD) {
    e[D[185][j]] = 47360 + j;
    d[47360 + j] = D[185][j];
  }

  D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");

  for (j = 0; j != D[186].length; ++j) if (D[186][j].charCodeAt(0) !== 0xFFFD) {
    e[D[186][j]] = 47616 + j;
    d[47616 + j] = D[186][j];
  }

  D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");

  for (j = 0; j != D[187].length; ++j) if (D[187][j].charCodeAt(0) !== 0xFFFD) {
    e[D[187][j]] = 47872 + j;
    d[47872 + j] = D[187][j];
  }

  D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");

  for (j = 0; j != D[188].length; ++j) if (D[188][j].charCodeAt(0) !== 0xFFFD) {
    e[D[188][j]] = 48128 + j;
    d[48128 + j] = D[188][j];
  }

  D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");

  for (j = 0; j != D[189].length; ++j) if (D[189][j].charCodeAt(0) !== 0xFFFD) {
    e[D[189][j]] = 48384 + j;
    d[48384 + j] = D[189][j];
  }

  D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");

  for (j = 0; j != D[190].length; ++j) if (D[190][j].charCodeAt(0) !== 0xFFFD) {
    e[D[190][j]] = 48640 + j;
    d[48640 + j] = D[190][j];
  }

  D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");

  for (j = 0; j != D[191].length; ++j) if (D[191][j].charCodeAt(0) !== 0xFFFD) {
    e[D[191][j]] = 48896 + j;
    d[48896 + j] = D[191][j];
  }

  D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");

  for (j = 0; j != D[192].length; ++j) if (D[192][j].charCodeAt(0) !== 0xFFFD) {
    e[D[192][j]] = 49152 + j;
    d[49152 + j] = D[192][j];
  }

  D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");

  for (j = 0; j != D[193].length; ++j) if (D[193][j].charCodeAt(0) !== 0xFFFD) {
    e[D[193][j]] = 49408 + j;
    d[49408 + j] = D[193][j];
  }

  D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");

  for (j = 0; j != D[194].length; ++j) if (D[194][j].charCodeAt(0) !== 0xFFFD) {
    e[D[194][j]] = 49664 + j;
    d[49664 + j] = D[194][j];
  }

  D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");

  for (j = 0; j != D[195].length; ++j) if (D[195][j].charCodeAt(0) !== 0xFFFD) {
    e[D[195][j]] = 49920 + j;
    d[49920 + j] = D[195][j];
  }

  D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");

  for (j = 0; j != D[196].length; ++j) if (D[196][j].charCodeAt(0) !== 0xFFFD) {
    e[D[196][j]] = 50176 + j;
    d[50176 + j] = D[196][j];
  }

  D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");

  for (j = 0; j != D[197].length; ++j) if (D[197][j].charCodeAt(0) !== 0xFFFD) {
    e[D[197][j]] = 50432 + j;
    d[50432 + j] = D[197][j];
  }

  D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");

  for (j = 0; j != D[198].length; ++j) if (D[198][j].charCodeAt(0) !== 0xFFFD) {
    e[D[198][j]] = 50688 + j;
    d[50688 + j] = D[198][j];
  }

  D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");

  for (j = 0; j != D[199].length; ++j) if (D[199][j].charCodeAt(0) !== 0xFFFD) {
    e[D[199][j]] = 50944 + j;
    d[50944 + j] = D[199][j];
  }

  D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");

  for (j = 0; j != D[200].length; ++j) if (D[200][j].charCodeAt(0) !== 0xFFFD) {
    e[D[200][j]] = 51200 + j;
    d[51200 + j] = D[200][j];
  }

  D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");

  for (j = 0; j != D[201].length; ++j) if (D[201][j].charCodeAt(0) !== 0xFFFD) {
    e[D[201][j]] = 51456 + j;
    d[51456 + j] = D[201][j];
  }

  D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");

  for (j = 0; j != D[202].length; ++j) if (D[202][j].charCodeAt(0) !== 0xFFFD) {
    e[D[202][j]] = 51712 + j;
    d[51712 + j] = D[202][j];
  }

  D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");

  for (j = 0; j != D[203].length; ++j) if (D[203][j].charCodeAt(0) !== 0xFFFD) {
    e[D[203][j]] = 51968 + j;
    d[51968 + j] = D[203][j];
  }

  D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");

  for (j = 0; j != D[204].length; ++j) if (D[204][j].charCodeAt(0) !== 0xFFFD) {
    e[D[204][j]] = 52224 + j;
    d[52224 + j] = D[204][j];
  }

  D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");

  for (j = 0; j != D[205].length; ++j) if (D[205][j].charCodeAt(0) !== 0xFFFD) {
    e[D[205][j]] = 52480 + j;
    d[52480 + j] = D[205][j];
  }

  D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");

  for (j = 0; j != D[206].length; ++j) if (D[206][j].charCodeAt(0) !== 0xFFFD) {
    e[D[206][j]] = 52736 + j;
    d[52736 + j] = D[206][j];
  }

  D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");

  for (j = 0; j != D[207].length; ++j) if (D[207][j].charCodeAt(0) !== 0xFFFD) {
    e[D[207][j]] = 52992 + j;
    d[52992 + j] = D[207][j];
  }

  D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");

  for (j = 0; j != D[208].length; ++j) if (D[208][j].charCodeAt(0) !== 0xFFFD) {
    e[D[208][j]] = 53248 + j;
    d[53248 + j] = D[208][j];
  }

  D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");

  for (j = 0; j != D[209].length; ++j) if (D[209][j].charCodeAt(0) !== 0xFFFD) {
    e[D[209][j]] = 53504 + j;
    d[53504 + j] = D[209][j];
  }

  D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");

  for (j = 0; j != D[210].length; ++j) if (D[210][j].charCodeAt(0) !== 0xFFFD) {
    e[D[210][j]] = 53760 + j;
    d[53760 + j] = D[210][j];
  }

  D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");

  for (j = 0; j != D[211].length; ++j) if (D[211][j].charCodeAt(0) !== 0xFFFD) {
    e[D[211][j]] = 54016 + j;
    d[54016 + j] = D[211][j];
  }

  D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");

  for (j = 0; j != D[212].length; ++j) if (D[212][j].charCodeAt(0) !== 0xFFFD) {
    e[D[212][j]] = 54272 + j;
    d[54272 + j] = D[212][j];
  }

  D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");

  for (j = 0; j != D[213].length; ++j) if (D[213][j].charCodeAt(0) !== 0xFFFD) {
    e[D[213][j]] = 54528 + j;
    d[54528 + j] = D[213][j];
  }

  D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");

  for (j = 0; j != D[214].length; ++j) if (D[214][j].charCodeAt(0) !== 0xFFFD) {
    e[D[214][j]] = 54784 + j;
    d[54784 + j] = D[214][j];
  }

  D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");

  for (j = 0; j != D[215].length; ++j) if (D[215][j].charCodeAt(0) !== 0xFFFD) {
    e[D[215][j]] = 55040 + j;
    d[55040 + j] = D[215][j];
  }

  D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");

  for (j = 0; j != D[216].length; ++j) if (D[216][j].charCodeAt(0) !== 0xFFFD) {
    e[D[216][j]] = 55296 + j;
    d[55296 + j] = D[216][j];
  }

  D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");

  for (j = 0; j != D[217].length; ++j) if (D[217][j].charCodeAt(0) !== 0xFFFD) {
    e[D[217][j]] = 55552 + j;
    d[55552 + j] = D[217][j];
  }

  D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");

  for (j = 0; j != D[218].length; ++j) if (D[218][j].charCodeAt(0) !== 0xFFFD) {
    e[D[218][j]] = 55808 + j;
    d[55808 + j] = D[218][j];
  }

  D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");

  for (j = 0; j != D[219].length; ++j) if (D[219][j].charCodeAt(0) !== 0xFFFD) {
    e[D[219][j]] = 56064 + j;
    d[56064 + j] = D[219][j];
  }

  D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");

  for (j = 0; j != D[220].length; ++j) if (D[220][j].charCodeAt(0) !== 0xFFFD) {
    e[D[220][j]] = 56320 + j;
    d[56320 + j] = D[220][j];
  }

  D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");

  for (j = 0; j != D[221].length; ++j) if (D[221][j].charCodeAt(0) !== 0xFFFD) {
    e[D[221][j]] = 56576 + j;
    d[56576 + j] = D[221][j];
  }

  D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");

  for (j = 0; j != D[222].length; ++j) if (D[222][j].charCodeAt(0) !== 0xFFFD) {
    e[D[222][j]] = 56832 + j;
    d[56832 + j] = D[222][j];
  }

  D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");

  for (j = 0; j != D[223].length; ++j) if (D[223][j].charCodeAt(0) !== 0xFFFD) {
    e[D[223][j]] = 57088 + j;
    d[57088 + j] = D[223][j];
  }

  D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");

  for (j = 0; j != D[224].length; ++j) if (D[224][j].charCodeAt(0) !== 0xFFFD) {
    e[D[224][j]] = 57344 + j;
    d[57344 + j] = D[224][j];
  }

  D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");

  for (j = 0; j != D[225].length; ++j) if (D[225][j].charCodeAt(0) !== 0xFFFD) {
    e[D[225][j]] = 57600 + j;
    d[57600 + j] = D[225][j];
  }

  D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");

  for (j = 0; j != D[226].length; ++j) if (D[226][j].charCodeAt(0) !== 0xFFFD) {
    e[D[226][j]] = 57856 + j;
    d[57856 + j] = D[226][j];
  }

  D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");

  for (j = 0; j != D[227].length; ++j) if (D[227][j].charCodeAt(0) !== 0xFFFD) {
    e[D[227][j]] = 58112 + j;
    d[58112 + j] = D[227][j];
  }

  D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");

  for (j = 0; j != D[228].length; ++j) if (D[228][j].charCodeAt(0) !== 0xFFFD) {
    e[D[228][j]] = 58368 + j;
    d[58368 + j] = D[228][j];
  }

  D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");

  for (j = 0; j != D[229].length; ++j) if (D[229][j].charCodeAt(0) !== 0xFFFD) {
    e[D[229][j]] = 58624 + j;
    d[58624 + j] = D[229][j];
  }

  D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");

  for (j = 0; j != D[230].length; ++j) if (D[230][j].charCodeAt(0) !== 0xFFFD) {
    e[D[230][j]] = 58880 + j;
    d[58880 + j] = D[230][j];
  }

  D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");

  for (j = 0; j != D[231].length; ++j) if (D[231][j].charCodeAt(0) !== 0xFFFD) {
    e[D[231][j]] = 59136 + j;
    d[59136 + j] = D[231][j];
  }

  D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");

  for (j = 0; j != D[232].length; ++j) if (D[232][j].charCodeAt(0) !== 0xFFFD) {
    e[D[232][j]] = 59392 + j;
    d[59392 + j] = D[232][j];
  }

  D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");

  for (j = 0; j != D[233].length; ++j) if (D[233][j].charCodeAt(0) !== 0xFFFD) {
    e[D[233][j]] = 59648 + j;
    d[59648 + j] = D[233][j];
  }

  D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");

  for (j = 0; j != D[234].length; ++j) if (D[234][j].charCodeAt(0) !== 0xFFFD) {
    e[D[234][j]] = 59904 + j;
    d[59904 + j] = D[234][j];
  }

  D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");

  for (j = 0; j != D[235].length; ++j) if (D[235][j].charCodeAt(0) !== 0xFFFD) {
    e[D[235][j]] = 60160 + j;
    d[60160 + j] = D[235][j];
  }

  D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");

  for (j = 0; j != D[236].length; ++j) if (D[236][j].charCodeAt(0) !== 0xFFFD) {
    e[D[236][j]] = 60416 + j;
    d[60416 + j] = D[236][j];
  }

  D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");

  for (j = 0; j != D[237].length; ++j) if (D[237][j].charCodeAt(0) !== 0xFFFD) {
    e[D[237][j]] = 60672 + j;
    d[60672 + j] = D[237][j];
  }

  D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");

  for (j = 0; j != D[238].length; ++j) if (D[238][j].charCodeAt(0) !== 0xFFFD) {
    e[D[238][j]] = 60928 + j;
    d[60928 + j] = D[238][j];
  }

  D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");

  for (j = 0; j != D[239].length; ++j) if (D[239][j].charCodeAt(0) !== 0xFFFD) {
    e[D[239][j]] = 61184 + j;
    d[61184 + j] = D[239][j];
  }

  D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");

  for (j = 0; j != D[240].length; ++j) if (D[240][j].charCodeAt(0) !== 0xFFFD) {
    e[D[240][j]] = 61440 + j;
    d[61440 + j] = D[240][j];
  }

  D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");

  for (j = 0; j != D[241].length; ++j) if (D[241][j].charCodeAt(0) !== 0xFFFD) {
    e[D[241][j]] = 61696 + j;
    d[61696 + j] = D[241][j];
  }

  D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");

  for (j = 0; j != D[242].length; ++j) if (D[242][j].charCodeAt(0) !== 0xFFFD) {
    e[D[242][j]] = 61952 + j;
    d[61952 + j] = D[242][j];
  }

  D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");

  for (j = 0; j != D[243].length; ++j) if (D[243][j].charCodeAt(0) !== 0xFFFD) {
    e[D[243][j]] = 62208 + j;
    d[62208 + j] = D[243][j];
  }

  D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");

  for (j = 0; j != D[244].length; ++j) if (D[244][j].charCodeAt(0) !== 0xFFFD) {
    e[D[244][j]] = 62464 + j;
    d[62464 + j] = D[244][j];
  }

  D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");

  for (j = 0; j != D[245].length; ++j) if (D[245][j].charCodeAt(0) !== 0xFFFD) {
    e[D[245][j]] = 62720 + j;
    d[62720 + j] = D[245][j];
  }

  D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");

  for (j = 0; j != D[246].length; ++j) if (D[246][j].charCodeAt(0) !== 0xFFFD) {
    e[D[246][j]] = 62976 + j;
    d[62976 + j] = D[246][j];
  }

  D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");

  for (j = 0; j != D[247].length; ++j) if (D[247][j].charCodeAt(0) !== 0xFFFD) {
    e[D[247][j]] = 63232 + j;
    d[63232 + j] = D[247][j];
  }

  return {
    "enc": e,
    "dec": d
  };
}();

cptable[10029] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[10079] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[10081] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}();

cptable[28591] = function () {
  var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ",
      D = [],
      e = {};

  for (var i = 0; i != d.length; ++i) {
    if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
    D[i] = d.charAt(i);
  }

  return {
    "enc": e,
    "dec": D
  };
}(); // eslint-disable-next-line no-undef


if ( module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
/*! cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */

/* vim: set ft=javascript: */

/*jshint newcap: false */

(function (root, factory) {

  if (typeof cptable === "undefined") {
    if (typeof commonjsRequire !== "undefined") {
      var cpt = cptable;
      if ( module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);else root.cptable = factory(cpt);
    } else throw new Error("cptable not found");
  } else cptable = factory(cptable);
  /*eslint-enable */

  /*jshint ignore:end */

})(commonjsGlobal, function (cpt) {
  /*global module, Buffer */

  var magic = {
    "1200": "utf16le",
    "1201": "utf16be",
    "12000": "utf32le",
    "12001": "utf32be",
    "16969": "utf64le",
    "20127": "ascii",
    "65000": "utf7",
    "65001": "utf8"
  };
  var sbcs_cache = [874, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 10000];
  var dbcs_cache = [932, 936, 949, 950];
  var magic_cache = [65001];
  var magic_decode = {};
  var magic_encode = {};
  var cpdcache = {};
  var cpecache = {};

  var sfcc = function sfcc(x) {
    return String.fromCharCode(x);
  };

  var cca = function cca(x) {
    return x.charCodeAt(0);
  };

  var has_buf = typeof Buffer !== 'undefined';

  var Buffer_from = function () {};

  if (has_buf) {
    var nbfs = !Buffer.from;
    if (!nbfs) try {
      Buffer.from("foo", "utf8");
    } catch (e) {
      nbfs = true;
    }
    Buffer_from = nbfs ? function (buf, enc) {
      return enc ? new Buffer(buf, enc) : new Buffer(buf);
    } : Buffer.from.bind(Buffer); // $FlowIgnore

    if (!Buffer.allocUnsafe) Buffer.allocUnsafe = function (n) {
      return new Buffer(n);
    };
    var mdl = 1024,
        mdb = Buffer.allocUnsafe(mdl);

    var make_EE = function make_EE(E) {
      var EE = Buffer.allocUnsafe(65536);

      for (var i = 0; i < 65536; ++i) EE[i] = 0;

      var keys = Object.keys(E),
          len = keys.length;

      for (var ee = 0, e = keys[ee]; ee < len; ++ee) {
        if (!(e = keys[ee])) continue;
        EE[e.charCodeAt(0)] = E[e];
      }

      return EE;
    };

    var sbcs_encode = function make_sbcs_encode(cp) {
      var EE = make_EE(cpt[cp].enc);
      return function sbcs_e(data, ofmt) {
        var len = data.length;
        var out,
            i = 0,
            j = 0,
            D = 0,
            w = 0;

        if (typeof data === 'string') {
          out = Buffer.allocUnsafe(len);

          for (i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
        } else if (Buffer.isBuffer(data)) {
          out = Buffer.allocUnsafe(2 * len);
          j = 0;

          for (i = 0; i < len; ++i) {
            D = data[i];
            if (D < 128) out[j++] = EE[D];else if (D < 224) {
              out[j++] = EE[((D & 31) << 6) + (data[i + 1] & 63)];
              ++i;
            } else if (D < 240) {
              out[j++] = EE[((D & 15) << 12) + ((data[i + 1] & 63) << 6) + (data[i + 2] & 63)];
              i += 2;
            } else {
              w = ((D & 7) << 18) + ((data[i + 1] & 63) << 12) + ((data[i + 2] & 63) << 6) + (data[i + 3] & 63);
              i += 3;
              if (w < 65536) out[j++] = EE[w];else {
                w -= 65536;
                out[j++] = EE[0xD800 + (w >> 10 & 1023)];
                out[j++] = EE[0xDC00 + (w & 1023)];
              }
            }
          }

          out = out.slice(0, j);
        } else {
          out = Buffer.allocUnsafe(len);

          for (i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
        }

        if (!ofmt || ofmt === 'buf') return out;
        if (ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
      };
    };

    var sbcs_decode = function make_sbcs_decode(cp) {
      var D = cpt[cp].dec;
      var DD = Buffer.allocUnsafe(131072),
          d = 0,
          c = "";

      for (d = 0; d < D.length; ++d) {
        if (!(c = D[d])) continue;
        var w = c.charCodeAt(0);
        DD[2 * d] = w & 255;
        DD[2 * d + 1] = w >> 8;
      }

      return function sbcs_d(data) {
        var len = data.length,
            i = 0,
            j = 0;

        if (2 * len > mdl) {
          mdl = 2 * len;
          mdb = Buffer.allocUnsafe(mdl);
        }

        if (Buffer.isBuffer(data)) {
          for (i = 0; i < len; i++) {
            j = 2 * data[i];
            mdb[2 * i] = DD[j];
            mdb[2 * i + 1] = DD[j + 1];
          }
        } else if (typeof data === "string") {
          for (i = 0; i < len; i++) {
            j = 2 * data.charCodeAt(i);
            mdb[2 * i] = DD[j];
            mdb[2 * i + 1] = DD[j + 1];
          }
        } else {
          for (i = 0; i < len; i++) {
            j = 2 * data[i];
            mdb[2 * i] = DD[j];
            mdb[2 * i + 1] = DD[j + 1];
          }
        }

        return mdb.slice(0, 2 * len).toString('ucs2');
      };
    };

    var dbcs_encode = function make_dbcs_encode(cp) {
      var E = cpt[cp].enc;
      var EE = Buffer.allocUnsafe(131072);

      for (var i = 0; i < 131072; ++i) EE[i] = 0;

      var keys = Object.keys(E);

      for (var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
        if (!(e = keys[ee])) continue;
        var f = e.charCodeAt(0);
        EE[2 * f] = E[e] & 255;
        EE[2 * f + 1] = E[e] >> 8;
      }

      return function dbcs_e(data, ofmt) {
        var len = data.length,
            out = Buffer.allocUnsafe(2 * len),
            i = 0,
            j = 0,
            jj = 0,
            k = 0,
            D = 0;

        if (typeof data === 'string') {
          for (i = k = 0; i < len; ++i) {
            j = data.charCodeAt(i) * 2;
            out[k++] = EE[j + 1] || EE[j];
            if (EE[j + 1] > 0) out[k++] = EE[j];
          }

          out = out.slice(0, k);
        } else if (Buffer.isBuffer(data)) {
          for (i = k = 0; i < len; ++i) {
            D = data[i];
            if (D < 128) j = D;else if (D < 224) {
              j = ((D & 31) << 6) + (data[i + 1] & 63);
              ++i;
            } else if (D < 240) {
              j = ((D & 15) << 12) + ((data[i + 1] & 63) << 6) + (data[i + 2] & 63);
              i += 2;
            } else {
              j = ((D & 7) << 18) + ((data[i + 1] & 63) << 12) + ((data[i + 2] & 63) << 6) + (data[i + 3] & 63);
              i += 3;
            }

            if (j < 65536) {
              j *= 2;
              out[k++] = EE[j + 1] || EE[j];
              if (EE[j + 1] > 0) out[k++] = EE[j];
            } else {
              jj = j - 65536;
              j = 2 * (0xD800 + (jj >> 10 & 1023));
              out[k++] = EE[j + 1] || EE[j];
              if (EE[j + 1] > 0) out[k++] = EE[j];
              j = 2 * (0xDC00 + (jj & 1023));
              out[k++] = EE[j + 1] || EE[j];
              if (EE[j + 1] > 0) out[k++] = EE[j];
            }
          }

          out = out.slice(0, k);
        } else {
          for (i = k = 0; i < len; i++) {
            j = data[i].charCodeAt(0) * 2;
            out[k++] = EE[j + 1] || EE[j];
            if (EE[j + 1] > 0) out[k++] = EE[j];
          }
        }

        if (!ofmt || ofmt === 'buf') return out;
        if (ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
      };
    };

    var dbcs_decode = function make_dbcs_decode(cp) {
      var D = cpt[cp].dec;
      var DD = Buffer.allocUnsafe(131072),
          d = 0,
          c,
          w = 0,
          j = 0,
          i = 0;

      for (i = 0; i < 65536; ++i) {
        DD[2 * i] = 0xFF;
        DD[2 * i + 1] = 0xFD;
      }

      for (d = 0; d < D.length; ++d) {
        if (!(c = D[d])) continue;
        w = c.charCodeAt(0);
        j = 2 * d;
        DD[j] = w & 255;
        DD[j + 1] = w >> 8;
      }

      return function dbcs_d(data) {
        var len = data.length,
            out = Buffer.allocUnsafe(2 * len),
            i = 0,
            j = 0,
            k = 0;

        if (Buffer.isBuffer(data)) {
          for (i = 0; i < len; i++) {
            j = 2 * data[i];

            if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
              j = 2 * ((data[i] << 8) + data[i + 1]);
              ++i;
            }

            out[k++] = DD[j];
            out[k++] = DD[j + 1];
          }
        } else if (typeof data === "string") {
          for (i = 0; i < len; i++) {
            j = 2 * data.charCodeAt(i);

            if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
              j = 2 * ((data.charCodeAt(i) << 8) + data.charCodeAt(i + 1));
              ++i;
            }

            out[k++] = DD[j];
            out[k++] = DD[j + 1];
          }
        } else {
          for (i = 0; i < len; i++) {
            j = 2 * data[i];

            if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
              j = 2 * ((data[i] << 8) + data[i + 1]);
              ++i;
            }

            out[k++] = DD[j];
            out[k++] = DD[j + 1];
          }
        }

        return out.slice(0, k).toString('ucs2');
      };
    };

    magic_decode[65001] = function utf8_d(data) {
      if (typeof data === "string") return utf8_d(data.split("").map(cca));
      var len = data.length,
          w = 0,
          ww = 0;

      if (4 * len > mdl) {
        mdl = 4 * len;
        mdb = Buffer.allocUnsafe(mdl);
      }

      var i = 0;
      if (len >= 3 && data[0] == 0xEF) if (data[1] == 0xBB && data[2] == 0xBF) i = 3;

      for (var j = 1, k = 0, D = 0; i < len; i += j) {
        j = 1;
        D = data[i];
        if (D < 128) w = D;else if (D < 224) {
          w = (D & 31) * 64 + (data[i + 1] & 63);
          j = 2;
        } else if (D < 240) {
          w = ((D & 15) << 12) + (data[i + 1] & 63) * 64 + (data[i + 2] & 63);
          j = 3;
        } else {
          w = (D & 7) * 262144 + ((data[i + 1] & 63) << 12) + (data[i + 2] & 63) * 64 + (data[i + 3] & 63);
          j = 4;
        }

        if (w < 65536) {
          mdb[k++] = w & 255;
          mdb[k++] = w >> 8;
        } else {
          w -= 65536;
          ww = 0xD800 + (w >> 10 & 1023);
          w = 0xDC00 + (w & 1023);
          mdb[k++] = ww & 255;
          mdb[k++] = ww >>> 8;
          mdb[k++] = w & 255;
          mdb[k++] = w >>> 8 & 255;
        }
      }

      return mdb.slice(0, k).toString('ucs2');
    };

    magic_encode[65001] = function utf8_e(data, ofmt) {
      if (has_buf && Buffer.isBuffer(data)) {
        if (!ofmt || ofmt === 'buf') return data;
        if (ofmt !== 'arr') return data.toString('binary');
        return [].slice.call(data);
      }

      var len = data.length,
          w = 0,
          ww = 0,
          j = 0;
      var direct = typeof data === "string";

      if (4 * len > mdl) {
        mdl = 4 * len;
        mdb = Buffer.allocUnsafe(mdl);
      }

      for (var i = 0; i < len; ++i) {
        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
        if (w <= 0x007F) mdb[j++] = w;else if (w <= 0x07FF) {
          mdb[j++] = 192 + (w >> 6);
          mdb[j++] = 128 + (w & 63);
        } else if (w >= 0xD800 && w <= 0xDFFF) {
          w -= 0xD800;
          ++i;
          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
          mdb[j++] = 240 + (ww >>> 18 & 0x07);
          mdb[j++] = 144 + (ww >>> 12 & 0x3F);
          mdb[j++] = 128 + (ww >>> 6 & 0x3F);
          mdb[j++] = 128 + (ww & 0x3F);
        } else {
          mdb[j++] = 224 + (w >> 12);
          mdb[j++] = 128 + (w >> 6 & 63);
          mdb[j++] = 128 + (w & 63);
        }
      }

      if (!ofmt || ofmt === 'buf') return mdb.slice(0, j);
      if (ofmt !== 'arr') return mdb.slice(0, j).toString('binary');
      return [].slice.call(mdb, 0, j);
    };
  }

  var encache = function encache() {
    if (has_buf) {
      if (cpdcache[sbcs_cache[0]]) return;
      var i = 0,
          s = 0;

      for (i = 0; i < sbcs_cache.length; ++i) {
        s = sbcs_cache[i];

        if (cpt[s]) {
          cpdcache[s] = sbcs_decode(s);
          cpecache[s] = sbcs_encode(s);
        }
      }

      for (i = 0; i < dbcs_cache.length; ++i) {
        s = dbcs_cache[i];

        if (cpt[s]) {
          cpdcache[s] = dbcs_decode(s);
          cpecache[s] = dbcs_encode(s);
        }
      }

      for (i = 0; i < magic_cache.length; ++i) {
        s = magic_cache[i];
        if (magic_decode[s]) cpdcache[s] = magic_decode[s];
        if (magic_encode[s]) cpecache[s] = magic_encode[s];
      }
    }
  };

  var null_enc = function (data, ofmt) {
    return "";
  };

  var cp_decache = function cp_decache(cp) {
    delete cpdcache[cp];
    delete cpecache[cp];
  };

  var decache = function decache() {
    if (has_buf) {
      if (!cpdcache[sbcs_cache[0]]) return;
      sbcs_cache.forEach(cp_decache);
      dbcs_cache.forEach(cp_decache);
      magic_cache.forEach(cp_decache);
    }

    last_enc = null_enc;
    last_cp = 0;
  };

  var cache = {
    encache: encache,
    decache: decache,
    sbcs: sbcs_cache,
    dbcs: dbcs_cache
  };
  encache();
  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
  var last_enc = null_enc,
      last_cp = 0;

  var encode = function encode(cp, data, ofmt) {
    if (cp === last_cp && last_enc) {
      return last_enc(data, ofmt);
    }

    if (cpecache[cp]) {
      last_enc = cpecache[last_cp = cp];
      return last_enc(data, ofmt);
    }

    if (has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
    var len = data.length;
    var out = has_buf ? Buffer.allocUnsafe(4 * len) : [],
        w = 0,
        i = 0,
        j = 0,
        ww = 0;
    var C = cpt[cp],
        E,
        M = "";
    var isstr = typeof data === 'string';
    if (C && (E = C.enc)) for (i = 0; i < len; ++i, ++j) {
      w = E[isstr ? data.charAt(i) : data[i]];

      if (w > 255) {
        out[j] = w >> 8;
        out[++j] = w & 255;
      } else out[j] = w & 255;
    } else if (M = magic[cp]) switch (M) {
      case "utf8":
        if (has_buf && isstr) {
          out = Buffer_from(data, M);
          j = out.length;
          break;
        }

        for (i = 0; i < len; ++i, ++j) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if (w <= 0x007F) out[j] = w;else if (w <= 0x07FF) {
            out[j] = 192 + (w >> 6);
            out[++j] = 128 + (w & 63);
          } else if (w >= 0xD800 && w <= 0xDFFF) {
            w -= 0xD800;
            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
            out[j] = 240 + (ww >>> 18 & 0x07);
            out[++j] = 144 + (ww >>> 12 & 0x3F);
            out[++j] = 128 + (ww >>> 6 & 0x3F);
            out[++j] = 128 + (ww & 0x3F);
          } else {
            out[j] = 224 + (w >> 12);
            out[++j] = 128 + (w >> 6 & 63);
            out[++j] = 128 + (w & 63);
          }
        }

        break;

      case "ascii":
        if (has_buf && typeof data === "string") {
          out = Buffer_from(data, M);
          j = out.length;
          break;
        }

        for (i = 0; i < len; ++i, ++j) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if (w <= 0x007F) out[j] = w;else throw new Error("bad ascii " + w);
        }

        break;

      case "utf16le":
        if (has_buf && typeof data === "string") {
          out = Buffer_from(data, M);
          j = out.length;
          break;
        }

        for (i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          out[j++] = w & 255;
          out[j++] = w >> 8;
        }

        break;

      case "utf16be":
        for (i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          out[j++] = w >> 8;
          out[j++] = w & 255;
        }

        break;

      case "utf32le":
        for (i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if (w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + (w - 0xD800 << 10) + (data[++i].charCodeAt(0) - 0xDC00);
          out[j++] = w & 255;
          w >>= 8;
          out[j++] = w & 255;
          w >>= 8;
          out[j++] = w & 255;
          w >>= 8;
          out[j++] = w & 255;
        }

        break;

      case "utf32be":
        for (i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if (w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + (w - 0xD800 << 10) + (data[++i].charCodeAt(0) - 0xDC00);
          out[j + 3] = w & 255;
          w >>= 8;
          out[j + 2] = w & 255;
          w >>= 8;
          out[j + 1] = w & 255;
          w >>= 8;
          out[j] = w & 255;
          j += 4;
        }

        break;

      case "utf7":
        for (i = 0; i < len; i++) {
          var c = isstr ? data.charAt(i) : data[i].charAt(0);

          if (c === "+") {
            out[j++] = 0x2b;
            out[j++] = 0x2d;
            continue;
          }

          if (SetD.indexOf(c) > -1) {
            out[j++] = c.charCodeAt(0);
            continue;
          }

          var tt = encode(1201, c);
          out[j++] = 0x2b;
          out[j++] = BM.charCodeAt(tt[0] >> 2);
          out[j++] = BM.charCodeAt(((tt[0] & 0x03) << 4) + ((tt[1] || 0) >> 4));
          out[j++] = BM.charCodeAt(((tt[1] & 0x0F) << 2) + ((tt[2] || 0) >> 6));
          out[j++] = 0x2d;
        }

        break;

      default:
        throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
    } else throw new Error("Unrecognized CP: " + cp);
    out = out.slice(0, j);
    if (!has_buf) return ofmt == 'str' ? out.map(sfcc).join("") : out;
    if (!ofmt || ofmt === 'buf') return out;
    if (ofmt !== 'arr') return out.toString('binary');
    return [].slice.call(out);
  };

  var decode = function decode(cp, data) {
    var F;
    if (F = cpdcache[cp]) return F(data);
    if (typeof data === "string") return decode(cp, data.split("").map(cca));
    var len = data.length,
        out = new Array(len),
        s = "",
        w = 0,
        i = 0,
        j = 1,
        k = 0,
        ww = 0;
    var C = cpt[cp],
        D,
        M = "";

    if (C && (D = C.dec)) {
      for (i = 0; i < len; i += j) {
        j = 2;
        s = D[(data[i] << 8) + data[i + 1]];

        if (!s) {
          j = 1;
          s = D[data[i]];
        }

        if (!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i + j - 1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
        out[k++] = s;
      }
    } else if (M = magic[cp]) switch (M) {
      case "utf8":
        if (len >= 3 && data[0] == 0xEF) if (data[1] == 0xBB && data[2] == 0xBF) i = 3;

        for (; i < len; i += j) {
          j = 1;
          if (data[i] < 128) w = data[i];else if (data[i] < 224) {
            w = (data[i] & 31) * 64 + (data[i + 1] & 63);
            j = 2;
          } else if (data[i] < 240) {
            w = ((data[i] & 15) << 12) + (data[i + 1] & 63) * 64 + (data[i + 2] & 63);
            j = 3;
          } else {
            w = (data[i] & 7) * 262144 + ((data[i + 1] & 63) << 12) + (data[i + 2] & 63) * 64 + (data[i + 3] & 63);
            j = 4;
          }

          if (w < 65536) {
            out[k++] = String.fromCharCode(w);
          } else {
            w -= 65536;
            ww = 0xD800 + (w >> 10 & 1023);
            w = 0xDC00 + (w & 1023);
            out[k++] = String.fromCharCode(ww);
            out[k++] = String.fromCharCode(w);
          }
        }

        break;

      case "ascii":
        if (has_buf && Buffer.isBuffer(data)) return data.toString(M);

        for (i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);

        k = len;
        break;

      case "utf16le":
        if (len >= 2 && data[0] == 0xFF) if (data[1] == 0xFE) i = 2;
        if (has_buf && Buffer.isBuffer(data)) return data.toString(M);
        j = 2;

        for (; i + 1 < len; i += j) {
          out[k++] = String.fromCharCode((data[i + 1] << 8) + data[i]);
        }

        break;

      case "utf16be":
        if (len >= 2 && data[0] == 0xFE) if (data[1] == 0xFF) i = 2;
        j = 2;

        for (; i + 1 < len; i += j) {
          out[k++] = String.fromCharCode((data[i] << 8) + data[i + 1]);
        }

        break;

      case "utf32le":
        if (len >= 4 && data[0] == 0xFF) if (data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
        j = 4;

        for (; i < len; i += j) {
          w = (data[i + 3] << 24) + (data[i + 2] << 16) + (data[i + 1] << 8) + data[i];

          if (w > 0xFFFF) {
            w -= 0x10000;
            out[k++] = String.fromCharCode(0xD800 + (w >> 10 & 0x3FF));
            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
          } else out[k++] = String.fromCharCode(w);
        }

        break;

      case "utf32be":
        if (len >= 4 && data[3] == 0xFF) if (data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
        j = 4;

        for (; i < len; i += j) {
          w = (data[i] << 24) + (data[i + 1] << 16) + (data[i + 2] << 8) + data[i + 3];

          if (w > 0xFFFF) {
            w -= 0x10000;
            out[k++] = String.fromCharCode(0xD800 + (w >> 10 & 0x3FF));
            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
          } else out[k++] = String.fromCharCode(w);
        }

        break;

      case "utf7":
        if (len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
          if (len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;else if (data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
        }

        for (; i < len; i += j) {
          if (data[i] !== 0x2b) {
            j = 1;
            out[k++] = String.fromCharCode(data[i]);
            continue;
          }

          j = 1;

          if (data[i + 1] === 0x2d) {
            j = 2;
            out[k++] = "+";
            continue;
          } // eslint-disable-next-line no-useless-escape


          while (String.fromCharCode(data[i + j]).match(/[A-Za-z0-9+\/]/)) j++;

          var dash = 0;

          if (data[i + j] === 0x2d) {
            ++j;
            dash = 1;
          }

          var tt = [];
          var o64 = "";
          var c1 = 0,
              c2 = 0,
              c3 = 0;
          var e1 = 0,
              e2 = 0,
              e3 = 0,
              e4 = 0;

          for (var l = 1; l < j - dash;) {
            e1 = BM.indexOf(String.fromCharCode(data[i + l++]));
            e2 = BM.indexOf(String.fromCharCode(data[i + l++]));
            c1 = e1 << 2 | e2 >> 4;
            tt.push(c1);
            e3 = BM.indexOf(String.fromCharCode(data[i + l++]));
            if (e3 === -1) break;
            c2 = (e2 & 15) << 4 | e3 >> 2;
            tt.push(c2);
            e4 = BM.indexOf(String.fromCharCode(data[i + l++]));
            if (e4 === -1) break;
            c3 = (e3 & 3) << 6 | e4;
            if (e4 < 64) tt.push(c3);
          }

          o64 = decode(1201, tt);

          for (l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
        }

        break;

      default:
        throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
    } else throw new Error("Unrecognized CP: " + cp);

    return out.slice(0, k).join("");
  };

  var hascp = function hascp(cp) {
    return !!(cpt[cp] || magic[cp]);
  };

  cpt.utils = {
    decode: decode,
    encode: encode,
    hascp: hascp,
    magic: magic,
    cache: cache
  };
  return cpt;
});
});

var jszip = createCommonjsModule(function (module, exports) {
/*

JSZip - A Javascript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/master/LICENSE

Note: since JSZip 3 removed critical functionality, this version assigns to the
`JSZipSync` variable.  Another JSZip version can be loaded in parallel.
*/
(function (e) {
  if ( "undefined" == typeof DO_NOT_EXPORT_JSZIP) module.exports = e();else {
    var f;
    "undefined" != typeof globalThis ? f = globalThis : "undefined" != typeof window ? f = window : "undefined" != typeof commonjsGlobal ? f = commonjsGlobal : "undefined" != typeof $ && $.global ? f = $.global : "undefined" != typeof self && (f = self), f.JSZipSync = e();
  }
})(function () {
  return function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof commonjsRequire == "function" && commonjsRequire;
          if (!u && a) return a(o, !0);
          if (i) return i(o, !0);
          throw new Error("Cannot find module '" + o + "'");
        }

        var f = n[o] = {
          exports: {}
        };
        t[o][0].call(f.exports, function (e) {
          var n = t[o][1][e];
          return s(n ? n : e);
        }, f, f.exports, e, t, n, r);
      }

      return n[o].exports;
    }

    var i = typeof commonjsRequire == "function" && commonjsRequire;

    for (var o = 0; o < r.length; o++) s(r[o]);

    return s;
  }({
    1: [function (_dereq_, module, exports) {

      var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="; // public method for encoding

      exports.encode = function (input, utf8) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        while (i < input.length) {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);
          enc1 = chr1 >> 2;
          enc2 = (chr1 & 3) << 4 | chr2 >> 4;
          enc3 = (chr2 & 15) << 2 | chr3 >> 6;
          enc4 = chr3 & 63;

          if (isNaN(chr2)) {
            enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
            enc4 = 64;
          }

          output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
        }

        return output;
      }; // public method for decoding


      exports.decode = function (input, utf8) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        while (i < input.length) {
          enc1 = _keyStr.indexOf(input.charAt(i++));
          enc2 = _keyStr.indexOf(input.charAt(i++));
          enc3 = _keyStr.indexOf(input.charAt(i++));
          enc4 = _keyStr.indexOf(input.charAt(i++));
          chr1 = enc1 << 2 | enc2 >> 4;
          chr2 = (enc2 & 15) << 4 | enc3 >> 2;
          chr3 = (enc3 & 3) << 6 | enc4;
          output = output + String.fromCharCode(chr1);

          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
          }

          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
          }
        }

        return output;
      };
    }, {}],
    2: [function (_dereq_, module, exports) {

      function CompressedObject() {
        this.compressedSize = 0;
        this.uncompressedSize = 0;
        this.crc32 = 0;
        this.compressionMethod = null;
        this.compressedContent = null;
      }

      CompressedObject.prototype = {
        /**
         * Return the decompressed content in an unspecified format.
         * The format will depend on the decompressor.
         * @return {Object} the decompressed content.
         */
        getContent: function () {
          return null; // see implementation
        },

        /**
         * Return the compressed content in an unspecified format.
         * The format will depend on the compressed conten source.
         * @return {Object} the compressed content.
         */
        getCompressedContent: function () {
          return null; // see implementation
        }
      };
      module.exports = CompressedObject;
    }, {}],
    3: [function (_dereq_, module, exports) {

      exports.STORE = {
        magic: "\x00\x00",
        compress: function (content) {
          return content; // no compression
        },
        uncompress: function (content) {
          return content; // no compression
        },
        compressInputType: null,
        uncompressInputType: null
      };
      exports.DEFLATE = _dereq_('./flate');
    }, {
      "./flate": 8
    }],
    4: [function (_dereq_, module, exports) {

      var utils = _dereq_('./utils');

      var table = [0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE, 0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B, 0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924, 0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01, 0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2, 0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F, 0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8, 0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5, 0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236, 0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713, 0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C, 0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9, 0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D];
      /**
       *
       *  Javascript crc32
       *  http://www.webtoolkit.info/
       *
       */

      module.exports = function crc32(input, crc) {
        if (typeof input === "undefined" || !input.length) {
          return 0;
        }

        var isArray = utils.getTypeOf(input) !== "string";

        if (typeof crc == "undefined") {
          crc = 0;
        }

        var x = 0;
        var y = 0;
        var b = 0;
        crc = crc ^ -1;

        for (var i = 0, iTop = input.length; i < iTop; i++) {
          b = isArray ? input[i] : input.charCodeAt(i);
          y = (crc ^ b) & 0xFF;
          x = table[y];
          crc = crc >>> 8 ^ x;
        }

        return crc ^ -1;
      }; // vim: set shiftwidth=4 softtabstop=4:

    }, {
      "./utils": 21
    }],
    5: [function (_dereq_, module, exports) {

      var utils = _dereq_('./utils');

      function DataReader(data) {
        this.data = null; // type : see implementation

        this.length = 0;
        this.index = 0;
      }

      DataReader.prototype = {
        /**
         * Check that the offset will not go too far.
         * @param {string} offset the additional offset to check.
         * @throws {Error} an Error if the offset is out of bounds.
         */
        checkOffset: function (offset) {
          this.checkIndex(this.index + offset);
        },

        /**
         * Check that the specifed index will not be too far.
         * @param {string} newIndex the index to check.
         * @throws {Error} an Error if the index is out of bounds.
         */
        checkIndex: function (newIndex) {
          if (this.length < newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + newIndex + "). Corrupted zip ?");
          }
        },

        /**
         * Change the index.
         * @param {number} newIndex The new index.
         * @throws {Error} if the new index is out of the data.
         */
        setIndex: function (newIndex) {
          this.checkIndex(newIndex);
          this.index = newIndex;
        },

        /**
         * Skip the next n bytes.
         * @param {number} n the number of bytes to skip.
         * @throws {Error} if the new index is out of the data.
         */
        skip: function (n) {
          this.setIndex(this.index + n);
        },

        /**
         * Get the byte at the specified index.
         * @param {number} i the index to use.
         * @return {number} a byte.
         */
        byteAt: function (i) {// see implementations
        },

        /**
         * Get the next number with a given byte size.
         * @param {number} size the number of bytes to read.
         * @return {number} the corresponding number.
         */
        readInt: function (size) {
          var result = 0,
              i;
          this.checkOffset(size);

          for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
          }

          this.index += size;
          return result;
        },

        /**
         * Get the next string with a given byte size.
         * @param {number} size the number of bytes to read.
         * @return {string} the corresponding string.
         */
        readString: function (size) {
          return utils.transformTo("string", this.readData(size));
        },

        /**
         * Get raw data without conversion, <size> bytes.
         * @param {number} size the number of bytes to read.
         * @return {Object} the raw data, implementation specific.
         */
        readData: function (size) {// see implementations
        },

        /**
         * Find the last occurrence of a zip signature (4 bytes).
         * @param {string} sig the signature to find.
         * @return {number} the index of the last occurrence, -1 if not found.
         */
        lastIndexOfSignature: function (sig) {// see implementations
        },

        /**
         * Get the next date.
         * @return {Date} the date.
         */
        readDate: function () {
          var dostime = this.readInt(4);
          return new Date((dostime >> 25 & 0x7f) + 1980, // year
          (dostime >> 21 & 0x0f) - 1, // month
          dostime >> 16 & 0x1f, // day
          dostime >> 11 & 0x1f, // hour
          dostime >> 5 & 0x3f, // minute
          (dostime & 0x1f) << 1); // second
        }
      };
      module.exports = DataReader;
    }, {
      "./utils": 21
    }],
    6: [function (_dereq_, module, exports) {

      exports.base64 = false;
      exports.binary = false;
      exports.dir = false;
      exports.createFolders = false;
      exports.date = null;
      exports.compression = null;
      exports.comment = null;
    }, {}],
    7: [function (_dereq_, module, exports) {

      var utils = _dereq_('./utils');
      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */


      exports.string2binary = function (str) {
        return utils.string2binary(str);
      };
      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */


      exports.string2Uint8Array = function (str) {
        return utils.transformTo("uint8array", str);
      };
      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */


      exports.uint8Array2String = function (array) {
        return utils.transformTo("string", array);
      };
      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */


      exports.string2Blob = function (str) {
        var buffer = utils.transformTo("arraybuffer", str);
        return utils.arrayBuffer2Blob(buffer);
      };
      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */


      exports.arrayBuffer2Blob = function (buffer) {
        return utils.arrayBuffer2Blob(buffer);
      };
      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */


      exports.transformTo = function (outputType, input) {
        return utils.transformTo(outputType, input);
      };
      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */


      exports.getTypeOf = function (input) {
        return utils.getTypeOf(input);
      };
      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */


      exports.checkSupport = function (type) {
        return utils.checkSupport(type);
      };
      /**
       * @deprecated
       * This value will be removed in a future version without replacement.
       */


      exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;
      /**
       * @deprecated
       * This value will be removed in a future version without replacement.
       */

      exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;
      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */

      exports.pretty = function (str) {
        return utils.pretty(str);
      };
      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */


      exports.findCompression = function (compressionMethod) {
        return utils.findCompression(compressionMethod);
      };
      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */


      exports.isRegExp = function (object) {
        return utils.isRegExp(object);
      };
    }, {
      "./utils": 21
    }],
    8: [function (_dereq_, module, exports) {

      var USE_TYPEDARRAY = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Uint32Array !== 'undefined';

      var pako = _dereq_("pako");

      exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
      exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
      exports.magic = "\x08\x00";

      exports.compress = function (input) {
        return pako.deflateRaw(input);
      };

      exports.uncompress = function (input) {
        return pako.inflateRaw(input);
      };
    }, {
      "pako": 24
    }],
    9: [function (_dereq_, module, exports) {

      var base64 = _dereq_('./base64');
      /**
      Usage:
         zip = new JSZip();
         zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
         zip.folder("images").file("smile.gif", base64Data, {base64: true});
         zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
         zip.remove("tempfile");
      
         base64zip = zip.generate();
      
      **/

      /**
       * Representation a of zip file in js
       * @constructor
       * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
       * @param {Object=} options the options for creating this objects (optional).
       */


      function JSZipSync(data, options) {
        // if this constructor is used without `new`, it adds `new` before itself:
        if (!(this instanceof JSZipSync)) return new JSZipSync(data, options); // object containing the files :
        // {
        //   "folder/" : {...},
        //   "folder/data.txt" : {...}
        // }

        this.files = {};
        this.comment = null; // Where we are in the hierarchy

        this.root = "";

        if (data) {
          this.load(data, options);
        }

        this.clone = function () {
          var newObj = new JSZipSync();

          for (var i in this) {
            if (typeof this[i] !== "function") {
              newObj[i] = this[i];
            }
          }

          return newObj;
        };
      }

      JSZipSync.prototype = _dereq_('./object');
      JSZipSync.prototype.load = _dereq_('./load');
      JSZipSync.support = _dereq_('./support');
      JSZipSync.defaults = _dereq_('./defaults');
      /**
       * @deprecated
       * This namespace will be removed in a future version without replacement.
       */

      JSZipSync.utils = _dereq_('./deprecatedPublicUtils');
      JSZipSync.base64 = {
        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        encode: function (input) {
          return base64.encode(input);
        },

        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        decode: function (input) {
          return base64.decode(input);
        }
      };
      JSZipSync.compressions = _dereq_('./compressions');
      module.exports = JSZipSync;
    }, {
      "./base64": 1,
      "./compressions": 3,
      "./defaults": 6,
      "./deprecatedPublicUtils": 7,
      "./load": 10,
      "./object": 13,
      "./support": 17
    }],
    10: [function (_dereq_, module, exports) {

      var base64 = _dereq_('./base64');

      var ZipEntries = _dereq_('./zipEntries');

      module.exports = function (data, options) {
        var files, zipEntries, i, input;
        options = options || {};

        if (options.base64) {
          data = base64.decode(data);
        }

        zipEntries = new ZipEntries(data, options);
        files = zipEntries.files;

        for (i = 0; i < files.length; i++) {
          input = files[i];
          this.file(input.fileName, input.decompressed, {
            binary: true,
            optimizedBinaryString: true,
            date: input.date,
            dir: input.dir,
            comment: input.fileComment.length ? input.fileComment : null,
            createFolders: options.createFolders
          });
        }

        if (zipEntries.zipComment.length) {
          this.comment = zipEntries.zipComment;
        }

        return this;
      };
    }, {
      "./base64": 1,
      "./zipEntries": 22
    }],
    11: [function (_dereq_, module, exports) {
      (function (Buffer) {

        var Buffer_from =
        /*::(*/
        function () {}
        /*:: :any)*/
        ;

        if (typeof Buffer !== 'undefined') {
          var nbfs = !Buffer.from;
          if (!nbfs) try {
            Buffer.from("foo", "utf8");
          } catch (e) {
            nbfs = true;
          }
          Buffer_from = nbfs ? function (buf, enc) {
            return enc ? new Buffer(buf, enc) : new Buffer(buf);
          } : Buffer.from.bind(Buffer); // $FlowIgnore

          if (!Buffer.alloc) Buffer.alloc = function (n) {
            return new Buffer(n);
          };
        }

        module.exports = function (data, encoding) {
          return typeof data == 'number' ? Buffer.alloc(data) : Buffer_from(data, encoding);
        };

        module.exports.test = function (b) {
          return Buffer.isBuffer(b);
        };
      }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
    }, {}],
    12: [function (_dereq_, module, exports) {

      var Uint8ArrayReader = _dereq_('./uint8ArrayReader');

      function NodeBufferReader(data) {
        this.data = data;
        this.length = this.data.length;
        this.index = 0;
      }

      NodeBufferReader.prototype = new Uint8ArrayReader();
      /**
       * @see DataReader.readData
       */

      NodeBufferReader.prototype.readData = function (size) {
        this.checkOffset(size);
        var result = this.data.slice(this.index, this.index + size);
        this.index += size;
        return result;
      };

      module.exports = NodeBufferReader;
    }, {
      "./uint8ArrayReader": 18
    }],
    13: [function (_dereq_, module, exports) {

      var support = _dereq_('./support');

      var utils = _dereq_('./utils');

      var crc32 = _dereq_('./crc32');

      var signature = _dereq_('./signature');

      var defaults = _dereq_('./defaults');

      var base64 = _dereq_('./base64');

      var compressions = _dereq_('./compressions');

      var CompressedObject = _dereq_('./compressedObject');

      var nodeBuffer = _dereq_('./nodeBuffer');

      var utf8 = _dereq_('./utf8');

      var StringWriter = _dereq_('./stringWriter');

      var Uint8ArrayWriter = _dereq_('./uint8ArrayWriter');
      /**
       * Returns the raw data of a ZipObject, decompress the content if necessary.
       * @param {ZipObject} file the file to use.
       * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
       */


      var getRawData = function (file) {
        if (file._data instanceof CompressedObject) {
          file._data = file._data.getContent();
          file.options.binary = true;
          file.options.base64 = false;

          if (utils.getTypeOf(file._data) === "uint8array") {
            var copy = file._data; // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).

            file._data = new Uint8Array(copy.length); // with an empty Uint8Array, Opera fails with a "Offset larger than array size"

            if (copy.length !== 0) {
              file._data.set(copy, 0);
            }
          }
        }

        return file._data;
      };
      /**
       * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
       * @param {ZipObject} file the file to use.
       * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
       */


      var getBinaryData = function (file) {
        var result = getRawData(file),
            type = utils.getTypeOf(result);

        if (type === "string") {
          if (!file.options.binary) {
            // unicode text !
            // unicode string => binary string is a painful process, check if we can avoid it.
            if (support.nodebuffer) {
              return nodeBuffer(result, "utf-8");
            }
          }

          return file.asBinary();
        }

        return result;
      };
      /**
       * Transform this._data into a string.
       * @param {function} filter a function String -> String, applied if not null on the result.
       * @return {String} the string representing this._data.
       */


      var dataToString = function (asUTF8) {
        var result = getRawData(this);

        if (result === null || typeof result === "undefined") {
          return "";
        } // if the data is a base64 string, we decode it before checking the encoding !


        if (this.options.base64) {
          result = base64.decode(result);
        }

        if (asUTF8 && this.options.binary) {
          // JSZip.prototype.utf8decode supports arrays as input
          // skip to array => string step, utf8decode will do it.
          result = out.utf8decode(result);
        } else {
          // no utf8 transformation, do the array => string step.
          result = utils.transformTo("string", result);
        }

        if (!asUTF8 && !this.options.binary) {
          result = utils.transformTo("string", out.utf8encode(result));
        }

        return result;
      };
      /**
       * A simple object representing a file in the zip file.
       * @constructor
       * @param {string} name the name of the file
       * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
       * @param {Object} options the options of the file
       */


      var ZipObject = function (name, data, options) {
        this.name = name;
        this.dir = options.dir;
        this.date = options.date;
        this.comment = options.comment;
        this._data = data;
        this.options = options;
        /*
         * This object contains initial values for dir and date.
         * With them, we can check if the user changed the deprecated metadata in
         * `ZipObject#options` or not.
         */

        this._initialMetadata = {
          dir: options.dir,
          date: options.date
        };
      };

      ZipObject.prototype = {
        /**
         * Return the content as UTF8 string.
         * @return {string} the UTF8 string.
         */
        asText: function () {
          return dataToString.call(this, true);
        },

        /**
         * Returns the binary content.
         * @return {string} the content as binary.
         */
        asBinary: function () {
          return dataToString.call(this, false);
        },

        /**
         * Returns the content as a nodejs Buffer.
         * @return {Buffer} the content as a Buffer.
         */
        asNodeBuffer: function () {
          var result = getBinaryData(this);
          return utils.transformTo("nodebuffer", result);
        },

        /**
         * Returns the content as an Uint8Array.
         * @return {Uint8Array} the content as an Uint8Array.
         */
        asUint8Array: function () {
          var result = getBinaryData(this);
          return utils.transformTo("uint8array", result);
        },

        /**
         * Returns the content as an ArrayBuffer.
         * @return {ArrayBuffer} the content as an ArrayBufer.
         */
        asArrayBuffer: function () {
          return this.asUint8Array().buffer;
        }
      };
      /**
       * Transform an integer into a string in hexadecimal.
       * @private
       * @param {number} dec the number to convert.
       * @param {number} bytes the number of bytes to generate.
       * @returns {string} the result.
       */

      var decToHex = function (dec, bytes) {
        var hex = "",
            i;

        for (i = 0; i < bytes; i++) {
          hex += String.fromCharCode(dec & 0xff);
          dec = dec >>> 8;
        }

        return hex;
      };
      /**
       * Merge the objects passed as parameters into a new one.
       * @private
       * @param {...Object} var_args All objects to merge.
       * @return {Object} a new object with the data of the others.
       */


      var extend = function () {
        var result = {},
            i,
            attr;

        for (i = 0; i < arguments.length; i++) {
          // arguments is not enumerable in some browsers
          for (attr in arguments[i]) {
            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
              result[attr] = arguments[i][attr];
            }
          }
        }

        return result;
      };
      /**
       * Transforms the (incomplete) options from the user into the complete
       * set of options to create a file.
       * @private
       * @param {Object} o the options from the user.
       * @return {Object} the complete set of options.
       */


      var prepareFileAttrs = function (o) {
        o = o || {};

        if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
          o.binary = true;
        }

        o = extend(o, defaults);
        o.date = o.date || new Date();
        if (o.compression !== null) o.compression = o.compression.toUpperCase();
        return o;
      };
      /**
       * Add a file in the current folder.
       * @private
       * @param {string} name the name of the file
       * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
       * @param {Object} o the options of the file
       * @return {Object} the new file.
       */


      var fileAdd = function (name, data, o) {
        // be sure sub folders exist
        var dataType = utils.getTypeOf(data),
            parent;
        o = prepareFileAttrs(o);

        if (o.createFolders && (parent = parentFolder(name))) {
          folderAdd.call(this, parent, true);
        }

        if (o.dir || data === null || typeof data === "undefined") {
          o.base64 = false;
          o.binary = false;
          data = null;
        } else if (dataType === "string") {
          if (o.binary && !o.base64) {
            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
            if (o.optimizedBinaryString !== true) {
              // this is a string, not in a base64 format.
              // Be sure that this is a correct "binary string"
              data = utils.string2binary(data);
            }
          }
        } else {
          // arraybuffer, uint8array, ...
          o.base64 = false;
          o.binary = true;

          if (!dataType && !(data instanceof CompressedObject)) {
            throw new Error("The data of '" + name + "' is in an unsupported format !");
          } // special case : it's way easier to work with Uint8Array than with ArrayBuffer


          if (dataType === "arraybuffer") {
            data = utils.transformTo("uint8array", data);
          }
        }

        var object = new ZipObject(name, data, o);
        this.files[name] = object;
        return object;
      };
      /**
       * Find the parent folder of the path.
       * @private
       * @param {string} path the path to use
       * @return {string} the parent folder, or ""
       */


      var parentFolder = function (path) {
        if (path.slice(-1) == '/') {
          path = path.substring(0, path.length - 1);
        }

        var lastSlash = path.lastIndexOf('/');
        return lastSlash > 0 ? path.substring(0, lastSlash) : "";
      };
      /**
       * Add a (sub) folder in the current folder.
       * @private
       * @param {string} name the folder's name
       * @param {boolean=} [createFolders] If true, automatically create sub
       *  folders. Defaults to false.
       * @return {Object} the new folder.
       */


      var folderAdd = function (name, createFolders) {
        // Check the name ends with a /
        if (name.slice(-1) != "/") {
          name += "/"; // IE doesn't like substr(-1)
        }

        createFolders = typeof createFolders !== 'undefined' ? createFolders : false; // Does this folder already exist?

        if (!this.files[name]) {
          fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
          });
        }

        return this.files[name];
      };
      /**
       * Generate a JSZip.CompressedObject for a given zipOject.
       * @param {ZipObject} file the object to read.
       * @param {JSZip.compression} compression the compression to use.
       * @return {JSZip.CompressedObject} the compressed result.
       */


      var generateCompressedObjectFrom = function (file, compression) {
        var result = new CompressedObject(),
            content; // the data has not been decompressed, we might reuse things !

        if (file._data instanceof CompressedObject) {
          result.uncompressedSize = file._data.uncompressedSize;
          result.crc32 = file._data.crc32;

          if (result.uncompressedSize === 0 || file.dir) {
            compression = compressions['STORE'];
            result.compressedContent = "";
            result.crc32 = 0;
          } else if (file._data.compressionMethod === compression.magic) {
            result.compressedContent = file._data.getCompressedContent();
          } else {
            content = file._data.getContent(); // need to decompress / recompress

            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
          }
        } else {
          // have uncompressed data
          content = getBinaryData(file);

          if (!content || content.length === 0 || file.dir) {
            compression = compressions['STORE'];
            content = "";
          }

          result.uncompressedSize = content.length;
          result.crc32 = crc32(content);
          result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
        }

        result.compressedSize = result.compressedContent.length;
        result.compressionMethod = compression.magic;
        return result;
      };
      /**
       * Generate the various parts used in the construction of the final zip file.
       * @param {string} name the file name.
       * @param {ZipObject} file the file content.
       * @param {JSZip.CompressedObject} compressedObject the compressed object.
       * @param {number} offset the current offset from the start of the zip file.
       * @return {object} the zip parts.
       */


      var generateZipParts = function (name, file, compressedObject, offset) {
        var data = compressedObject.compressedContent,
            utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
            comment = file.comment || "",
            utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
            useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
            useUTF8ForComment = utfEncodedComment.length !== comment.length,
            o = file.options,
            dosTime,
            dosDate,
            extraFields = "",
            unicodePathExtraField = "",
            unicodeCommentExtraField = "",
            dir,
            date; // handle the deprecated options.dir

        if (file._initialMetadata.dir !== file.dir) {
          dir = file.dir;
        } else {
          dir = o.dir;
        } // handle the deprecated options.date


        if (file._initialMetadata.date !== file.date) {
          date = file.date;
        } else {
          date = o.date;
        }

        dosTime = date.getHours();
        dosTime = dosTime << 6;
        dosTime = dosTime | date.getMinutes();
        dosTime = dosTime << 5;
        dosTime = dosTime | date.getSeconds() / 2;
        dosDate = date.getFullYear() - 1980;
        dosDate = dosDate << 4;
        dosDate = dosDate | date.getMonth() + 1;
        dosDate = dosDate << 5;
        dosDate = dosDate | date.getDate();

        if (useUTF8ForFileName) {
          // set the unicode path extra field. unzip needs at least one extra
          // field to correctly handle unicode path, so using the path is as good
          // as any other information. This could improve the situation with
          // other archive managers too.
          // This field is usually used without the utf8 flag, with a non
          // unicode path in the header (winrar, winzip). This helps (a bit)
          // with the messy Windows' default compressed folders feature but
          // breaks on p7zip which doesn't seek the unicode path extra field.
          // So for now, UTF-8 everywhere !
          unicodePathExtraField = // Version
          decToHex(1, 1) + // NameCRC32
          decToHex(crc32(utfEncodedFileName), 4) + // UnicodeName
          utfEncodedFileName;
          extraFields += // Info-ZIP Unicode Path Extra Field
          "\x75\x70" + // size
          decToHex(unicodePathExtraField.length, 2) + // content
          unicodePathExtraField;
        }

        if (useUTF8ForComment) {
          unicodeCommentExtraField = // Version
          decToHex(1, 1) + // CommentCRC32
          decToHex(this.crc32(utfEncodedComment), 4) + // UnicodeName
          utfEncodedComment;
          extraFields += // Info-ZIP Unicode Path Extra Field
          "\x75\x63" + // size
          decToHex(unicodeCommentExtraField.length, 2) + // content
          unicodeCommentExtraField;
        }

        var header = ""; // version needed to extract

        header += "\x0A\x00"; // general purpose bit flag
        // set bit 11 if utf8

        header += useUTF8ForFileName || useUTF8ForComment ? "\x00\x08" : "\x00\x00"; // compression method

        header += compressedObject.compressionMethod; // last mod file time

        header += decToHex(dosTime, 2); // last mod file date

        header += decToHex(dosDate, 2); // crc-32

        header += decToHex(compressedObject.crc32, 4); // compressed size

        header += decToHex(compressedObject.compressedSize, 4); // uncompressed size

        header += decToHex(compressedObject.uncompressedSize, 4); // file name length

        header += decToHex(utfEncodedFileName.length, 2); // extra field length

        header += decToHex(extraFields.length, 2);
        var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;
        var dirRecord = signature.CENTRAL_FILE_HEADER + // version made by (00: DOS)
        "\x14\x00" + // file header (common to file and central directory)
        header + // file comment length
        decToHex(utfEncodedComment.length, 2) + // disk number start
        "\x00\x00" + // internal file attributes TODO
        "\x00\x00" + ( // external file attributes
        dir === true ? "\x10\x00\x00\x00" : "\x00\x00\x00\x00") + // relative offset of local header
        decToHex(offset, 4) + // file name
        utfEncodedFileName + // extra field
        extraFields + // file comment
        utfEncodedComment;
        return {
          fileRecord: fileRecord,
          dirRecord: dirRecord,
          compressedObject: compressedObject
        };
      }; // return the actual prototype of JSZip


      var out = {
        /**
         * Read an existing zip and merge the data in the current JSZip object.
         * The implementation is in jszip-load.js, don't forget to include it.
         * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
         * @param {Object} options Options for loading the stream.
         *  options.base64 : is the stream in base64 ? default : false
         * @return {JSZip} the current JSZip object
         */
        load: function (stream, options) {
          throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
        },

        /**
         * Filter nested files/folders with the specified function.
         * @param {Function} search the predicate to use :
         * function (relativePath, file) {...}
         * It takes 2 arguments : the relative path and the file.
         * @return {Array} An array of matching elements.
         */
        filter: function (search) {
          var result = [],
              filename,
              relativePath,
              file,
              fileClone;

          for (filename in this.files) {
            if (!this.files.hasOwnProperty(filename)) {
              continue;
            }

            file = this.files[filename]; // return a new object, don't let the user mess with our internal objects :)

            fileClone = new ZipObject(file.name, file._data, extend(file.options));
            relativePath = filename.slice(this.root.length, filename.length);

            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
            search(relativePath, fileClone)) {
              // and the file matches the function
              result.push(fileClone);
            }
          }

          return result;
        },

        /**
         * Add a file to the zip file, or search a file.
         * @param   {string|RegExp} name The name of the file to add (if data is defined),
         * the name of the file to find (if no data) or a regex to match files.
         * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
         * @param   {Object} o     File options
         * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
         * a file (when searching by string) or an array of files (when searching by regex).
         */
        file: function (name, data, o) {
          if (arguments.length === 1) {
            if (utils.isRegExp(name)) {
              var regexp = name;
              return this.filter(function (relativePath, file) {
                return !file.dir && regexp.test(relativePath);
              });
            } else {
              // text
              return this.filter(function (relativePath, file) {
                return !file.dir && relativePath === name;
              })[0] || null;
            }
          } else {
            // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
          }

          return this;
        },

        /**
         * Add a directory to the zip file, or search.
         * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
         * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
         */
        folder: function (arg) {
          if (!arg) {
            return this;
          }

          if (utils.isRegExp(arg)) {
            return this.filter(function (relativePath, file) {
              return file.dir && arg.test(relativePath);
            });
          } // else, name is a new folder


          var name = this.root + arg;
          var newFolder = folderAdd.call(this, name); // Allow chaining by returning a new object with this folder as the root

          var ret = this.clone();
          ret.root = newFolder.name;
          return ret;
        },

        /**
         * Delete a file, or a directory and all sub-files, from the zip
         * @param {string} name the name of the file to delete
         * @return {JSZip} this JSZip object
         */
        remove: function (name) {
          name = this.root + name;
          var file = this.files[name];

          if (!file) {
            // Look for any folders
            if (name.slice(-1) != "/") {
              name += "/";
            }

            file = this.files[name];
          }

          if (file && !file.dir) {
            // file
            delete this.files[name];
          } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function (relativePath, file) {
              return file.name.slice(0, name.length) === name;
            });

            for (var i = 0; i < kids.length; i++) {
              delete this.files[kids[i].name];
            }
          }

          return this;
        },

        /**
         * Generate the complete zip file
         * @param {Object} options the options to generate the zip file :
         * - base64, (deprecated, use type instead) true to generate base64.
         * - compression, "STORE" by default.
         * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
         * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
         */
        generate: function (options) {
          options = extend(options || {}, {
            base64: true,
            compression: "STORE",
            type: "base64",
            comment: null
          });
          utils.checkSupport(options.type);
          var zipData = [],
              localDirLength = 0,
              centralDirLength = 0,
              writer,
              i,
              utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || "")); // first, generate all the zip parts.

          for (var name in this.files) {
            if (!this.files.hasOwnProperty(name)) {
              continue;
            }

            var file = this.files[name];
            var compressionName = file.options.compression || options.compression.toUpperCase();
            var compression = compressions[compressionName];

            if (!compression) {
              throw new Error(compressionName + " is not a valid compression method !");
            }

            var compressedObject = generateCompressedObjectFrom.call(this, file, compression);
            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength);
            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
            centralDirLength += zipPart.dirRecord.length;
            zipData.push(zipPart);
          }

          var dirEnd = ""; // end of central dir signature

          dirEnd = signature.CENTRAL_DIRECTORY_END + // number of this disk
          "\x00\x00" + // number of the disk with the start of the central directory
          "\x00\x00" + // total number of entries in the central directory on this disk
          decToHex(zipData.length, 2) + // total number of entries in the central directory
          decToHex(zipData.length, 2) + // size of the central directory   4 bytes
          decToHex(centralDirLength, 4) + // offset of start of central directory with respect to the starting disk number
          decToHex(localDirLength, 4) + // .ZIP file comment length
          decToHex(utfEncodedComment.length, 2) + // .ZIP file comment
          utfEncodedComment; // we have all the parts (and the total length)
          // time to create a writer !

          var typeName = options.type.toLowerCase();

          if (typeName === "uint8array" || typeName === "arraybuffer" || typeName === "blob" || typeName === "nodebuffer") {
            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
          } else {
            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
          }

          for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].fileRecord);
            writer.append(zipData[i].compressedObject.compressedContent);
          }

          for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].dirRecord);
          }

          writer.append(dirEnd);
          var zip = writer.finalize();

          switch (options.type.toLowerCase()) {
            // case "zip is an Uint8Array"
            case "uint8array":
            case "arraybuffer":
            case "nodebuffer":
              return utils.transformTo(options.type.toLowerCase(), zip);

            case "blob":
              return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip));
            // case "zip is a string"

            case "base64":
              return options.base64 ? base64.encode(zip) : zip;

            default:
              // case "string" :
              return zip;
          }
        },

        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        crc32: function (input, crc) {
          return crc32(input, crc);
        },

        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        utf8encode: function (string) {
          return utils.transformTo("string", utf8.utf8encode(string));
        },

        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        utf8decode: function (input) {
          return utf8.utf8decode(input);
        }
      };
      module.exports = out;
    }, {
      "./base64": 1,
      "./compressedObject": 2,
      "./compressions": 3,
      "./crc32": 4,
      "./defaults": 6,
      "./nodeBuffer": 11,
      "./signature": 14,
      "./stringWriter": 16,
      "./support": 17,
      "./uint8ArrayWriter": 19,
      "./utf8": 20,
      "./utils": 21
    }],
    14: [function (_dereq_, module, exports) {

      exports.LOCAL_FILE_HEADER = "PK\x03\x04";
      exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
      exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
      exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
      exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
      exports.DATA_DESCRIPTOR = "PK\x07\x08";
    }, {}],
    15: [function (_dereq_, module, exports) {

      var DataReader = _dereq_('./dataReader');

      var utils = _dereq_('./utils');

      function StringReader(data, optimizedBinaryString) {
        this.data = data;

        if (!optimizedBinaryString) {
          this.data = utils.string2binary(this.data);
        }

        this.length = this.data.length;
        this.index = 0;
      }

      StringReader.prototype = new DataReader();
      /**
       * @see DataReader.byteAt
       */

      StringReader.prototype.byteAt = function (i) {
        return this.data.charCodeAt(i);
      };
      /**
       * @see DataReader.lastIndexOfSignature
       */


      StringReader.prototype.lastIndexOfSignature = function (sig) {
        return this.data.lastIndexOf(sig);
      };
      /**
       * @see DataReader.readData
       */


      StringReader.prototype.readData = function (size) {
        this.checkOffset(size); // this will work because the constructor applied the "& 0xff" mask.

        var result = this.data.slice(this.index, this.index + size);
        this.index += size;
        return result;
      };

      module.exports = StringReader;
    }, {
      "./dataReader": 5,
      "./utils": 21
    }],
    16: [function (_dereq_, module, exports) {

      var utils = _dereq_('./utils');
      /**
       * An object to write any content to a string.
       * @constructor
       */


      var StringWriter = function () {
        this.data = [];
      };

      StringWriter.prototype = {
        /**
         * Append any content to the current string.
         * @param {Object} input the content to add.
         */
        append: function (input) {
          input = utils.transformTo("string", input);
          this.data.push(input);
        },

        /**
         * Finalize the construction an return the result.
         * @return {string} the generated string.
         */
        finalize: function () {
          return this.data.join("");
        }
      };
      module.exports = StringWriter;
    }, {
      "./utils": 21
    }],
    17: [function (_dereq_, module, exports) {
      (function (Buffer) {

        exports.base64 = true;
        exports.array = true;
        exports.string = true;
        exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined"; // contains true if JSZip can read/generate nodejs Buffer, false otherwise.
        // Browserify will provide a Buffer implementation for browsers, which is
        // an augmented Uint8Array (i.e., can be used as either Buffer or U8).

        exports.nodebuffer = typeof Buffer !== "undefined"; // contains true if JSZip can read/generate Uint8Array, false otherwise.

        exports.uint8array = typeof Uint8Array !== "undefined";

        if (typeof ArrayBuffer === "undefined") {
          exports.blob = false;
        } else {
          var buffer = new ArrayBuffer(0);

          try {
            exports.blob = new Blob([buffer], {
              type: "application/zip"
            }).size === 0;
          } catch (e) {
            try {
              var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
              var builder = new Builder();
              builder.append(buffer);
              exports.blob = builder.getBlob('application/zip').size === 0;
            } catch (e) {
              exports.blob = false;
            }
          }
        }
      }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
    }, {}],
    18: [function (_dereq_, module, exports) {

      var DataReader = _dereq_('./dataReader');

      function Uint8ArrayReader(data) {
        if (data) {
          this.data = data;
          this.length = this.data.length;
          this.index = 0;
        }
      }

      Uint8ArrayReader.prototype = new DataReader();
      /**
       * @see DataReader.byteAt
       */

      Uint8ArrayReader.prototype.byteAt = function (i) {
        return this.data[i];
      };
      /**
       * @see DataReader.lastIndexOfSignature
       */


      Uint8ArrayReader.prototype.lastIndexOfSignature = function (sig) {
        var sig0 = sig.charCodeAt(0),
            sig1 = sig.charCodeAt(1),
            sig2 = sig.charCodeAt(2),
            sig3 = sig.charCodeAt(3);

        for (var i = this.length - 4; i >= 0; --i) {
          if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i;
          }
        }

        return -1;
      };
      /**
       * @see DataReader.readData
       */


      Uint8ArrayReader.prototype.readData = function (size) {
        this.checkOffset(size);

        if (size === 0) {
          // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
          return new Uint8Array(0);
        }

        var result = this.data.subarray(this.index, this.index + size);
        this.index += size;
        return result;
      };

      module.exports = Uint8ArrayReader;
    }, {
      "./dataReader": 5
    }],
    19: [function (_dereq_, module, exports) {

      var utils = _dereq_('./utils');
      /**
       * An object to write any content to an Uint8Array.
       * @constructor
       * @param {number} length The length of the array.
       */


      var Uint8ArrayWriter = function (length) {
        this.data = new Uint8Array(length);
        this.index = 0;
      };

      Uint8ArrayWriter.prototype = {
        /**
         * Append any content to the current array.
         * @param {Object} input the content to add.
         */
        append: function (input) {
          if (input.length !== 0) {
            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
            input = utils.transformTo("uint8array", input);
            this.data.set(input, this.index);
            this.index += input.length;
          }
        },

        /**
         * Finalize the construction an return the result.
         * @return {Uint8Array} the generated array.
         */
        finalize: function () {
          return this.data;
        }
      };
      module.exports = Uint8ArrayWriter;
    }, {
      "./utils": 21
    }],
    20: [function (_dereq_, module, exports) {

      var utils = _dereq_('./utils');

      var support = _dereq_('./support');

      var nodeBuffer = _dereq_('./nodeBuffer');
      /**
       * The following functions come from pako, from pako/lib/utils/strings
       * released under the MIT license, see pako https://github.com/nodeca/pako/
       */
      // Table with utf8 lengths (calculated by first byte of sequence)
      // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
      // because max possible codepoint is 0x10ffff


      var _utf8len = new Array(256);

      for (var i = 0; i < 256; i++) {
        _utf8len[i] = i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1;
      }

      _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
      // convert string to array (typed, when possible)

      var string2buf = function (str) {
        var buf,
            c,
            c2,
            m_pos,
            i,
            str_len = str.length,
            buf_len = 0; // count binary size

        for (m_pos = 0; m_pos < str_len; m_pos++) {
          c = str.charCodeAt(m_pos);

          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);

            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }

          buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
        } // allocate buffer


        if (support.uint8array) {
          buf = new Uint8Array(buf_len);
        } else {
          buf = new Array(buf_len);
        } // convert


        for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
          c = str.charCodeAt(m_pos);

          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);

            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }

          if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
          } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
          } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          } else {
            /* four bytes */
            buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          }
        }

        return buf;
      }; // Calculate max possible position in utf8 buffer,
      // that will not break sequence. If that's not possible
      // - (very small limits) return max size as is.
      //
      // buf[] - utf8 bytes array
      // max   - length limit (mandatory);


      var utf8border = function (buf, max) {
        var pos;
        max = max || buf.length;

        if (max > buf.length) {
          max = buf.length;
        } // go back from last position, until start of sequence found


        pos = max - 1;

        while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) {
          pos--;
        } // Fuckup - very small and broken sequence,
        // return max, because we should return something anyway.


        if (pos < 0) {
          return max;
        } // If we came to start of buffer - that means vuffer is too small,
        // return max too.


        if (pos === 0) {
          return max;
        }

        return pos + _utf8len[buf[pos]] > max ? pos : max;
      }; // convert array to string


      var buf2string = function (buf) {
        var i, out, c, c_len;
        var len = buf.length; // Reserve max possible length (2 words per char)
        // NB: by unknown reasons, Array is significantly faster for
        //     String.fromCharCode.apply than Uint16Array.

        var utf16buf = new Array(len * 2);

        for (out = 0, i = 0; i < len;) {
          c = buf[i++]; // quick process ascii

          if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
          }

          c_len = _utf8len[c]; // skip 5 & 6 byte codes

          if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
          } // apply mask on first byte


          c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07; // join the rest

          while (c_len > 1 && i < len) {
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
          } // terminated by end of string?


          if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
          }

          if (c < 0x10000) {
            utf16buf[out++] = c;
          } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
          }
        } // shrinkBuf(utf16buf, out)


        if (utf16buf.length !== out) {
          if (utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
          } else {
            utf16buf.length = out;
          }
        } // return String.fromCharCode.apply(null, utf16buf);


        return utils.applyFromCharCode(utf16buf);
      }; // That's all for the pako functions.

      /**
       * Transform a javascript string into an array (typed if possible) of bytes,
       * UTF-8 encoded.
       * @param {String} str the string to encode
       * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
       */


      exports.utf8encode = function utf8encode(str) {
        if (support.nodebuffer) {
          return nodeBuffer(str, "utf-8");
        }

        return string2buf(str);
      };
      /**
       * Transform a bytes array (or a representation) representing an UTF-8 encoded
       * string into a javascript string.
       * @param {Array|Uint8Array|Buffer} buf the data de decode
       * @return {String} the decoded string.
       */


      exports.utf8decode = function utf8decode(buf) {
        if (support.nodebuffer) {
          return utils.transformTo("nodebuffer", buf).toString("utf-8");
        }

        buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf); // return buf2string(buf);
        // Chrome prefers to work with "small" chunks of data
        // for the method buf2string.
        // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.

        var result = [],
            k = 0,
            len = buf.length,
            chunk = 65536;

        while (k < len) {
          var nextBoundary = utf8border(buf, Math.min(k + chunk, len));

          if (support.uint8array) {
            result.push(buf2string(buf.subarray(k, nextBoundary)));
          } else {
            result.push(buf2string(buf.slice(k, nextBoundary)));
          }

          k = nextBoundary;
        }

        return result.join("");
      }; // vim: set shiftwidth=4 softtabstop=4:

    }, {
      "./nodeBuffer": 11,
      "./support": 17,
      "./utils": 21
    }],
    21: [function (_dereq_, module, exports) {

      var support = _dereq_('./support');

      var compressions = _dereq_('./compressions');

      var nodeBuffer = _dereq_('./nodeBuffer');
      /**
       * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
       * @param {string} str the string to transform.
       * @return {String} the binary string.
       */


      exports.string2binary = function (str) {
        var result = "";

        for (var i = 0; i < str.length; i++) {
          result += String.fromCharCode(str.charCodeAt(i) & 0xff);
        }

        return result;
      };

      exports.arrayBuffer2Blob = function (buffer) {
        exports.checkSupport("blob");

        try {
          // Blob constructor
          return new Blob([buffer], {
            type: "application/zip"
          });
        } catch (e) {
          try {
            // deprecated, browser only, old way
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            return builder.getBlob('application/zip');
          } catch (e) {
            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      /**
       * The identity function.
       * @param {Object} input the input.
       * @return {Object} the same input.
       */


      function identity(input) {
        return input;
      }
      /**
       * Fill in an array with a string.
       * @param {String} str the string to use.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
       * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
       */


      function stringToArrayLike(str, array) {
        for (var i = 0; i < str.length; ++i) {
          array[i] = str.charCodeAt(i) & 0xFF;
        }

        return array;
      }
      /**
       * Transform an array-like object to a string.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
       * @return {String} the result.
       */


      function arrayLikeToString(array) {
        // Performances notes :
        // --------------------
        // String.fromCharCode.apply(null, array) is the fastest, see
        // see http://jsperf.com/converting-a-uint8array-to-a-string/2
        // but the stack is limited (and we can get huge arrays !).
        //
        // result += String.fromCharCode(array[i]); generate too many strings !
        //
        // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
        var chunk = 65536;
        var result = [],
            len = array.length,
            type = exports.getTypeOf(array),
            k = 0,
            canUseApply = true;

        try {
          switch (type) {
            case "uint8array":
              String.fromCharCode.apply(null, new Uint8Array(0));
              break;

            case "nodebuffer":
              String.fromCharCode.apply(null, nodeBuffer(0));
              break;
          }
        } catch (e) {
          canUseApply = false;
        } // no apply : slow and painful algorithm
        // default browser on android 4.*


        if (!canUseApply) {
          var resultStr = "";

          for (var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
          }

          return resultStr;
        }

        while (k < len && chunk > 1) {
          try {
            if (type === "array" || type === "nodebuffer") {
              result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            } else {
              result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }

            k += chunk;
          } catch (e) {
            chunk = Math.floor(chunk / 2);
          }
        }

        return result.join("");
      }

      exports.applyFromCharCode = arrayLikeToString;
      /**
       * Copy the data from an array-like to an other array-like.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
       * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
       */

      function arrayLikeToArrayLike(arrayFrom, arrayTo) {
        for (var i = 0; i < arrayFrom.length; i++) {
          arrayTo[i] = arrayFrom[i];
        }

        return arrayTo;
      } // a matrix containing functions to transform everything into everything.


      var transform = {}; // string to ?

      transform["string"] = {
        "string": identity,
        "array": function (input) {
          return stringToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function (input) {
          return transform["string"]["uint8array"](input).buffer;
        },
        "uint8array": function (input) {
          return stringToArrayLike(input, new Uint8Array(input.length));
        },
        "nodebuffer": function (input) {
          return stringToArrayLike(input, nodeBuffer(input.length));
        }
      }; // array to ?

      transform["array"] = {
        "string": arrayLikeToString,
        "array": identity,
        "arraybuffer": function (input) {
          return new Uint8Array(input).buffer;
        },
        "uint8array": function (input) {
          return new Uint8Array(input);
        },
        "nodebuffer": function (input) {
          return nodeBuffer(input);
        }
      }; // arraybuffer to ?

      transform["arraybuffer"] = {
        "string": function (input) {
          return arrayLikeToString(new Uint8Array(input));
        },
        "array": function (input) {
          return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
        },
        "arraybuffer": identity,
        "uint8array": function (input) {
          return new Uint8Array(input);
        },
        "nodebuffer": function (input) {
          return nodeBuffer(new Uint8Array(input));
        }
      }; // uint8array to ?

      transform["uint8array"] = {
        "string": arrayLikeToString,
        "array": function (input) {
          return arrayLikeToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function (input) {
          return input.buffer;
        },
        "uint8array": identity,
        "nodebuffer": function (input) {
          return nodeBuffer(input);
        }
      }; // nodebuffer to ?

      transform["nodebuffer"] = {
        "string": arrayLikeToString,
        "array": function (input) {
          return arrayLikeToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function (input) {
          return transform["nodebuffer"]["uint8array"](input).buffer;
        },
        "uint8array": function (input) {
          return arrayLikeToArrayLike(input, new Uint8Array(input.length));
        },
        "nodebuffer": identity
      };
      /**
       * Transform an input into any type.
       * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
       * If no output type is specified, the unmodified input will be returned.
       * @param {String} outputType the output type.
       * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
       * @throws {Error} an Error if the browser doesn't support the requested output type.
       */

      exports.transformTo = function (outputType, input) {
        if (!input) {
          // undefined, null, etc
          // an empty string won't harm.
          input = "";
        }

        if (!outputType) {
          return input;
        }

        exports.checkSupport(outputType);
        var inputType = exports.getTypeOf(input);
        var result = transform[inputType][outputType](input);
        return result;
      };
      /**
       * Return the type of the input.
       * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
       * @param {Object} input the input to identify.
       * @return {String} the (lowercase) type of the input.
       */


      exports.getTypeOf = function (input) {
        if (typeof input === "string") {
          return "string";
        }

        if (Object.prototype.toString.call(input) === "[object Array]") {
          return "array";
        }

        if (support.nodebuffer && nodeBuffer.test(input)) {
          return "nodebuffer";
        }

        if (support.uint8array && input instanceof Uint8Array) {
          return "uint8array";
        }

        if (support.arraybuffer && input instanceof ArrayBuffer) {
          return "arraybuffer";
        }
      };
      /**
       * Throw an exception if the type is not supported.
       * @param {String} type the type to check.
       * @throws {Error} an Error if the browser doesn't support the requested type.
       */


      exports.checkSupport = function (type) {
        var supported = support[type.toLowerCase()];

        if (!supported) {
          throw new Error(type + " is not supported by this browser");
        }
      };

      exports.MAX_VALUE_16BITS = 65535;
      exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

      /**
       * Prettify a string read as binary.
       * @param {string} str the string to prettify.
       * @return {string} a pretty string.
       */

      exports.pretty = function (str) {
        var res = '',
            code,
            i;

        for (i = 0; i < (str || "").length; i++) {
          code = str.charCodeAt(i);
          res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
        }

        return res;
      };
      /**
       * Find a compression registered in JSZip.
       * @param {string} compressionMethod the method magic to find.
       * @return {Object|null} the JSZip compression object, null if none found.
       */


      exports.findCompression = function (compressionMethod) {
        for (var method in compressions) {
          if (!compressions.hasOwnProperty(method)) {
            continue;
          }

          if (compressions[method].magic === compressionMethod) {
            return compressions[method];
          }
        }

        return null;
      };
      /**
      * Cross-window, cross-Node-context regular expression detection
      * @param  {Object}  object Anything
      * @return {Boolean}        true if the object is a regular expression,
      * false otherwise
      */


      exports.isRegExp = function (object) {
        return Object.prototype.toString.call(object) === "[object RegExp]";
      };
    }, {
      "./compressions": 3,
      "./nodeBuffer": 11,
      "./support": 17
    }],
    22: [function (_dereq_, module, exports) {

      var StringReader = _dereq_('./stringReader');

      var NodeBufferReader = _dereq_('./nodeBufferReader');

      var Uint8ArrayReader = _dereq_('./uint8ArrayReader');

      var utils = _dereq_('./utils');

      var sig = _dereq_('./signature');

      var ZipEntry = _dereq_('./zipEntry');

      var support = _dereq_('./support');

      var jszipProto = _dereq_('./object'); //  class ZipEntries {{{

      /**
       * All the entries in the zip file.
       * @constructor
       * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
       * @param {Object} loadOptions Options for loading the stream.
       */


      function ZipEntries(data, loadOptions) {
        this.files = [];
        this.loadOptions = loadOptions;

        if (data) {
          this.load(data);
        }
      }

      ZipEntries.prototype = {
        /**
         * Check that the reader is on the speficied signature.
         * @param {string} expectedSignature the expected signature.
         * @throws {Error} if it is an other signature.
         */
        checkSignature: function (expectedSignature) {
          var signature = this.reader.readString(4);

          if (signature !== expectedSignature) {
            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
          }
        },

        /**
         * Read the end of the central directory.
         */
        readBlockEndOfCentral: function () {
          this.diskNumber = this.reader.readInt(2);
          this.diskWithCentralDirStart = this.reader.readInt(2);
          this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
          this.centralDirRecords = this.reader.readInt(2);
          this.centralDirSize = this.reader.readInt(4);
          this.centralDirOffset = this.reader.readInt(4);
          this.zipCommentLength = this.reader.readInt(2); // warning : the encoding depends of the system locale
          // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
          // On a windows machine, this field is encoded with the localized windows code page.

          this.zipComment = this.reader.readString(this.zipCommentLength); // To get consistent behavior with the generation part, we will assume that
          // this is utf8 encoded.

          this.zipComment = jszipProto.utf8decode(this.zipComment);
        },

        /**
         * Read the end of the Zip 64 central directory.
         * Not merged with the method readEndOfCentral :
         * The end of central can coexist with its Zip64 brother,
         * I don't want to read the wrong number of bytes !
         */
        readBlockZip64EndOfCentral: function () {
          this.zip64EndOfCentralSize = this.reader.readInt(8);
          this.versionMadeBy = this.reader.readString(2);
          this.versionNeeded = this.reader.readInt(2);
          this.diskNumber = this.reader.readInt(4);
          this.diskWithCentralDirStart = this.reader.readInt(4);
          this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
          this.centralDirRecords = this.reader.readInt(8);
          this.centralDirSize = this.reader.readInt(8);
          this.centralDirOffset = this.reader.readInt(8);
          this.zip64ExtensibleData = {};
          var extraDataSize = this.zip64EndOfCentralSize - 44,
              index = 0,
              extraFieldId,
              extraFieldLength,
              extraFieldValue;

          while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readString(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
              id: extraFieldId,
              length: extraFieldLength,
              value: extraFieldValue
            };
          }
        },

        /**
         * Read the end of the Zip 64 central directory locator.
         */
        readBlockZip64EndOfCentralLocator: function () {
          this.diskWithZip64CentralDirStart = this.reader.readInt(4);
          this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
          this.disksCount = this.reader.readInt(4);

          if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
          }
        },

        /**
         * Read the local files, based on the offset read in the central part.
         */
        readLocalFiles: function () {
          var i, file;

          for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
          }
        },

        /**
         * Read the central directory.
         */
        readCentralDir: function () {
          var file;
          this.reader.setIndex(this.centralDirOffset);

          while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
            file = new ZipEntry({
              zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
          }
        },

        /**
         * Read the end of central directory.
         */
        readEndOfCentral: function () {
          var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);

          if (offset === -1) {
            throw new Error("Corrupted zip : can't find end of central directory");
          }

          this.reader.setIndex(offset);
          this.checkSignature(sig.CENTRAL_DIRECTORY_END);
          this.readBlockEndOfCentral();
          /* extract from the zip spec :
              4)  If one of the fields in the end of central directory
                  record is too small to hold required data, the field
                  should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                  ZIP64 format record should be created.
              5)  The end of central directory record and the
                  Zip64 end of central directory locator record must
                  reside on the same disk when splitting or spanning
                  an archive.
           */

          if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;
            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */
            // should look for a zip64 EOCD locator

            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);

            if (offset === -1) {
              throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
            }

            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator(); // now the zip64 EOCD record

            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
          }
        },
        prepareReader: function (data) {
          var type = utils.getTypeOf(data);

          if (type === "string" && !support.uint8array) {
            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
          } else if (type === "nodebuffer") {
            this.reader = new NodeBufferReader(data);
          } else {
            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
          }
        },

        /**
         * Read a zip file and create ZipEntries.
         * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
         */
        load: function (data) {
          this.prepareReader(data);
          this.readEndOfCentral();
          this.readCentralDir();
          this.readLocalFiles();
        }
      }; // }}} end of ZipEntries

      module.exports = ZipEntries;
    }, {
      "./nodeBufferReader": 12,
      "./object": 13,
      "./signature": 14,
      "./stringReader": 15,
      "./support": 17,
      "./uint8ArrayReader": 18,
      "./utils": 21,
      "./zipEntry": 23
    }],
    23: [function (_dereq_, module, exports) {

      var StringReader = _dereq_('./stringReader');

      var utils = _dereq_('./utils');

      var CompressedObject = _dereq_('./compressedObject');

      var jszipProto = _dereq_('./object'); // class ZipEntry {{{

      /**
       * An entry in the zip file.
       * @constructor
       * @param {Object} options Options of the current file.
       * @param {Object} loadOptions Options for loading the stream.
       */


      function ZipEntry(options, loadOptions) {
        this.options = options;
        this.loadOptions = loadOptions;
      }

      ZipEntry.prototype = {
        /**
         * say if the file is encrypted.
         * @return {boolean} true if the file is encrypted, false otherwise.
         */
        isEncrypted: function () {
          // bit 1 is set
          return (this.bitFlag & 0x0001) === 0x0001;
        },

        /**
         * say if the file has utf-8 filename/comment.
         * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
         */
        useUTF8: function () {
          // bit 11 is set
          return (this.bitFlag & 0x0800) === 0x0800;
        },

        /**
         * Prepare the function used to generate the compressed content from this ZipFile.
         * @param {DataReader} reader the reader to use.
         * @param {number} from the offset from where we should read the data.
         * @param {number} length the length of the data to read.
         * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
         */
        prepareCompressedContent: function (reader, from, length) {
          return function () {
            var previousIndex = reader.index;
            reader.setIndex(from);
            var compressedFileData = reader.readData(length);
            reader.setIndex(previousIndex);
            return compressedFileData;
          };
        },

        /**
         * Prepare the function used to generate the uncompressed content from this ZipFile.
         * @param {DataReader} reader the reader to use.
         * @param {number} from the offset from where we should read the data.
         * @param {number} length the length of the data to read.
         * @param {JSZip.compression} compression the compression used on this file.
         * @param {number} uncompressedSize the uncompressed size to expect.
         * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
         */
        prepareContent: function (reader, from, length, compression, uncompressedSize) {
          return function () {
            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
            var uncompressedFileData = compression.uncompress(compressedFileData);

            if (uncompressedFileData.length !== uncompressedSize) {
              throw new Error("Bug : uncompressed data size mismatch");
            }

            return uncompressedFileData;
          };
        },

        /**
         * Read the local part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readLocalPart: function (reader) {
          var compression, localExtraFieldsLength; // we already know everything from the central dir !
          // If the central dir data are false, we are doomed.
          // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
          // The less data we get here, the more reliable this should be.
          // Let's skip the whole header and dash to the data !

          reader.skip(22); // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
          // Strangely, the filename here is OK.
          // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
          // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
          // Search "unzip mismatching "local" filename continuing with "central" filename version" on
          // the internet.
          //
          // I think I see the logic here : the central directory is used to display
          // content and the local directory is used to extract the files. Mixing / and \
          // may be used to display \ to windows users and use / when extracting the files.
          // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394

          this.fileNameLength = reader.readInt(2);
          localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir

          this.fileName = reader.readString(this.fileNameLength);
          reader.skip(localExtraFieldsLength);

          if (this.compressedSize == -1 || this.uncompressedSize == -1) {
            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
          }

          compression = utils.findCompression(this.compressionMethod);

          if (compression === null) {
            // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
          }

          this.decompressed = new CompressedObject();
          this.decompressed.compressedSize = this.compressedSize;
          this.decompressed.uncompressedSize = this.uncompressedSize;
          this.decompressed.crc32 = this.crc32;
          this.decompressed.compressionMethod = this.compressionMethod;
          this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
          this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize); // we need to compute the crc32...

          if (this.loadOptions.checkCRC32) {
            this.decompressed = utils.transformTo("string", this.decompressed.getContent());

            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
              throw new Error("Corrupted zip : CRC32 mismatch");
            }
          }
        },

        /**
         * Read the central part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readCentralPart: function (reader) {
          this.versionMadeBy = reader.readString(2);
          this.versionNeeded = reader.readInt(2);
          this.bitFlag = reader.readInt(2);
          this.compressionMethod = reader.readString(2);
          this.date = reader.readDate();
          this.crc32 = reader.readInt(4);
          this.compressedSize = reader.readInt(4);
          this.uncompressedSize = reader.readInt(4);
          this.fileNameLength = reader.readInt(2);
          this.extraFieldsLength = reader.readInt(2);
          this.fileCommentLength = reader.readInt(2);
          this.diskNumberStart = reader.readInt(2);
          this.internalFileAttributes = reader.readInt(2);
          this.externalFileAttributes = reader.readInt(4);
          this.localHeaderOffset = reader.readInt(4);

          if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
          }

          this.fileName = reader.readString(this.fileNameLength);
          this.readExtraFields(reader);
          this.parseZIP64ExtraField(reader);
          this.fileComment = reader.readString(this.fileCommentLength); // warning, this is true only for zip with madeBy == DOS (plateform dependent feature)

          this.dir = this.externalFileAttributes & 0x00000010 ? true : false;
        },

        /**
         * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
         * @param {DataReader} reader the reader to use.
         */
        parseZIP64ExtraField: function (reader) {
          if (!this.extraFields[0x0001]) {
            return;
          } // should be something, preparing the extra reader


          var extraReader = new StringReader(this.extraFields[0x0001].value); // I really hope that these 64bits integer can fit in 32 bits integer, because js
          // won't let us have more.

          if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
          }

          if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
          }

          if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
          }

          if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
          }
        },

        /**
         * Read the central part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readExtraFields: function (reader) {
          var start = reader.index,
              extraFieldId,
              extraFieldLength,
              extraFieldValue;
          this.extraFields = this.extraFields || {};

          while (reader.index < start + this.extraFieldsLength) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readString(extraFieldLength);
            this.extraFields[extraFieldId] = {
              id: extraFieldId,
              length: extraFieldLength,
              value: extraFieldValue
            };
          }
        },

        /**
         * Apply an UTF8 transformation if needed.
         */
        handleUTF8: function () {
          if (this.useUTF8()) {
            this.fileName = jszipProto.utf8decode(this.fileName);
            this.fileComment = jszipProto.utf8decode(this.fileComment);
          } else {
            var upath = this.findExtraFieldUnicodePath();

            if (upath !== null) {
              this.fileName = upath;
            }

            var ucomment = this.findExtraFieldUnicodeComment();

            if (ucomment !== null) {
              this.fileComment = ucomment;
            }
          }
        },

        /**
         * Find the unicode path declared in the extra field, if any.
         * @return {String} the unicode path, null otherwise.
         */
        findExtraFieldUnicodePath: function () {
          var upathField = this.extraFields[0x7075];

          if (upathField) {
            var extraReader = new StringReader(upathField.value); // wrong version

            if (extraReader.readInt(1) !== 1) {
              return null;
            } // the crc of the filename changed, this field is out of date.


            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
              return null;
            }

            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
          }

          return null;
        },

        /**
         * Find the unicode comment declared in the extra field, if any.
         * @return {String} the unicode comment, null otherwise.
         */
        findExtraFieldUnicodeComment: function () {
          var ucommentField = this.extraFields[0x6375];

          if (ucommentField) {
            var extraReader = new StringReader(ucommentField.value); // wrong version

            if (extraReader.readInt(1) !== 1) {
              return null;
            } // the crc of the comment changed, this field is out of date.


            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
              return null;
            }

            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
          }

          return null;
        }
      };
      module.exports = ZipEntry;
    }, {
      "./compressedObject": 2,
      "./object": 13,
      "./stringReader": 15,
      "./utils": 21
    }],
    24: [function (_dereq_, module, exports) {

      var assign = _dereq_('./lib/utils/common').assign;

      var deflate = _dereq_('./lib/deflate');

      var inflate = _dereq_('./lib/inflate');

      var constants = _dereq_('./lib/zlib/constants');

      var pako = {};
      assign(pako, deflate, inflate, constants);
      module.exports = pako;
    }, {
      "./lib/deflate": 25,
      "./lib/inflate": 26,
      "./lib/utils/common": 27,
      "./lib/zlib/constants": 30
    }],
    25: [function (_dereq_, module, exports) {

      var zlib_deflate = _dereq_('./zlib/deflate.js');

      var utils = _dereq_('./utils/common');

      var strings = _dereq_('./utils/strings');

      var msg = _dereq_('./zlib/messages');

      var zstream = _dereq_('./zlib/zstream');
      /* Public constants ==========================================================*/

      /* ===========================================================================*/


      var Z_NO_FLUSH = 0;
      var Z_FINISH = 4;
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      var Z_DEFAULT_COMPRESSION = -1;
      var Z_DEFAULT_STRATEGY = 0;
      var Z_DEFLATED = 8;
      /* ===========================================================================*/

      /**
       * class Deflate
       *
       * Generic JS-style wrapper for zlib calls. If you don't need
       * streaming behaviour - use more simple functions: [[deflate]],
       * [[deflateRaw]] and [[gzip]].
       **/

      /* internal
       * Deflate.chunks -> Array
       *
       * Chunks of output data, if [[Deflate#onData]] not overriden.
       **/

      /**
       * Deflate.result -> Uint8Array|Array
       *
       * Compressed result, generated by default [[Deflate#onData]]
       * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
       * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
       **/

      /**
       * Deflate.err -> Number
       *
       * Error code after deflate finished. 0 (Z_OK) on success.
       * You will not need it in real life, because deflate errors
       * are possible only on wrong options or bad `onData` / `onEnd`
       * custom handlers.
       **/

      /**
       * Deflate.msg -> String
       *
       * Error message, if [[Deflate.err]] != 0
       **/

      /**
       * new Deflate(options)
       * - options (Object): zlib deflate options.
       *
       * Creates new deflator instance with specified params. Throws exception
       * on bad params. Supported options:
       *
       * - `level`
       * - `windowBits`
       * - `memLevel`
       * - `strategy`
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Additional options, for internal needs:
       *
       * - `chunkSize` - size of generated data chunks (16K by default)
       * - `raw` (Boolean) - do raw deflate
       * - `gzip` (Boolean) - create gzip wrapper
       * - `to` (String) - if equal to 'string', then result will be "binary string"
       *    (each char code [0..255])
       * - `header` (Object) - custom header for gzip
       *   - `text` (Boolean) - true if compressed data believed to be text
       *   - `time` (Number) - modification time, unix timestamp
       *   - `os` (Number) - operation system code
       *   - `extra` (Array) - array of bytes with extra data (max 65536)
       *   - `name` (String) - file name (binary string)
       *   - `comment` (String) - comment (binary string)
       *   - `hcrc` (Boolean) - true if header crc should be added
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
       *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
       *
       * var deflate = new pako.Deflate({ level: 3});
       *
       * deflate.push(chunk1, false);
       * deflate.push(chunk2, true);  // true -> last chunk
       *
       * if (deflate.err) { throw new Error(deflate.err); }
       *
       * console.log(deflate.result);
       * ```
       **/

      var Deflate = function (options) {
        this.options = utils.assign({
          level: Z_DEFAULT_COMPRESSION,
          method: Z_DEFLATED,
          chunkSize: 16384,
          windowBits: 15,
          memLevel: 8,
          strategy: Z_DEFAULT_STRATEGY,
          to: ''
        }, options || {});
        var opt = this.options;

        if (opt.raw && opt.windowBits > 0) {
          opt.windowBits = -opt.windowBits;
        } else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
          opt.windowBits += 16;
        }

        this.err = 0; // error code, if happens (0 = Z_OK)

        this.msg = ''; // error message

        this.ended = false; // used to avoid multiple onEnd() calls

        this.chunks = []; // chunks of compressed data

        this.strm = new zstream();
        this.strm.avail_out = 0;
        var status = zlib_deflate.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);

        if (status !== Z_OK) {
          throw new Error(msg[status]);
        }

        if (opt.header) {
          zlib_deflate.deflateSetHeader(this.strm, opt.header);
        }
      };
      /**
       * Deflate#push(data[, mode]) -> Boolean
       * - data (Uint8Array|Array|String): input data. Strings will be converted to
       *   utf8 byte sequence.
       * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
       *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
       *
       * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
       * new compressed chunks. Returns `true` on success. The last data block must have
       * mode Z_FINISH (or `true`). That flush internal pending buffers and call
       * [[Deflate#onEnd]].
       *
       * On fail call [[Deflate#onEnd]] with error code and return false.
       *
       * We strongly recommend to use `Uint8Array` on input for best speed (output
       * array format is detected automatically). Also, don't skip last param and always
       * use the same type in your code (boolean or number). That will improve JS speed.
       *
       * For regular `Array`-s make sure all elements are [0..255].
       *
       * ##### Example
       *
       * ```javascript
       * push(chunk, false); // push one of data chunks
       * ...
       * push(chunk, true);  // push last chunk
       * ```
       **/


      Deflate.prototype.push = function (data, mode) {
        var strm = this.strm;
        var chunkSize = this.options.chunkSize;

        var status, _mode;

        if (this.ended) {
          return false;
        }

        _mode = mode === ~~mode ? mode : mode === true ? Z_FINISH : Z_NO_FLUSH; // Convert data if needed

        if (typeof data === 'string') {
          // If we need to compress text, change encoding to utf8.
          strm.input = strings.string2buf(data);
        } else {
          strm.input = data;
        }

        strm.next_in = 0;
        strm.avail_in = strm.input.length;

        do {
          if (strm.avail_out === 0) {
            strm.output = new utils.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }

          status = zlib_deflate.deflate(strm, _mode);
          /* no bad return value */

          if (status !== Z_STREAM_END && status !== Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
          }

          if (strm.avail_out === 0 || strm.avail_in === 0 && _mode === Z_FINISH) {
            if (this.options.to === 'string') {
              this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
            } else {
              this.onData(utils.shrinkBuf(strm.output, strm.next_out));
            }
          }
        } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END); // Finalize on the last chunk.


        if (_mode === Z_FINISH) {
          status = zlib_deflate.deflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === Z_OK;
        }

        return true;
      };
      /**
       * Deflate#onData(chunk) -> Void
       * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
       *   on js engine support. When string output requested, each chunk
       *   will be string.
       *
       * By default, stores data blocks in `chunks[]` property and glue
       * those in `onEnd`. Override this handler, if you need another behaviour.
       **/


      Deflate.prototype.onData = function (chunk) {
        this.chunks.push(chunk);
      };
      /**
       * Deflate#onEnd(status) -> Void
       * - status (Number): deflate status. 0 (Z_OK) on success,
       *   other if not.
       *
       * Called once after you tell deflate that input stream complete
       * or error happenned. By default - join collected chunks,
       * free memory and fill `results` / `err` properties.
       **/


      Deflate.prototype.onEnd = function (status) {
        // On success - join
        if (status === Z_OK) {
          if (this.options.to === 'string') {
            this.result = this.chunks.join('');
          } else {
            this.result = utils.flattenChunks(this.chunks);
          }
        }

        this.chunks = [];
        this.err = status;
        this.msg = this.strm.msg;
      };
      /**
       * deflate(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * Compress `data` with deflate alrorythm and `options`.
       *
       * Supported options are:
       *
       * - level
       * - windowBits
       * - memLevel
       * - strategy
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Sugar (options):
       *
       * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
       *   negative windowBits implicitly.
       * - `to` (String) - if equal to 'string', then result will be "binary string"
       *    (each char code [0..255])
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
       *
       * console.log(pako.deflate(data));
       * ```
       **/


      function deflate(input, options) {
        var deflator = new Deflate(options);
        deflator.push(input, true); // That will never happens, if you don't cheat with options :)

        if (deflator.err) {
          throw deflator.msg;
        }

        return deflator.result;
      }
      /**
       * deflateRaw(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * The same as [[deflate]], but creates raw data, without wrapper
       * (header and adler32 crc).
       **/


      function deflateRaw(input, options) {
        options = options || {};
        options.raw = true;
        return deflate(input, options);
      }
      /**
       * gzip(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * The same as [[deflate]], but create gzip wrapper instead of
       * deflate one.
       **/


      function gzip(input, options) {
        options = options || {};
        options.gzip = true;
        return deflate(input, options);
      }

      exports.Deflate = Deflate;
      exports.deflate = deflate;
      exports.deflateRaw = deflateRaw;
      exports.gzip = gzip;
    }, {
      "./utils/common": 27,
      "./utils/strings": 28,
      "./zlib/deflate.js": 32,
      "./zlib/messages": 37,
      "./zlib/zstream": 39
    }],
    26: [function (_dereq_, module, exports) {

      var zlib_inflate = _dereq_('./zlib/inflate.js');

      var utils = _dereq_('./utils/common');

      var strings = _dereq_('./utils/strings');

      var c = _dereq_('./zlib/constants');

      var msg = _dereq_('./zlib/messages');

      var zstream = _dereq_('./zlib/zstream');

      var gzheader = _dereq_('./zlib/gzheader');
      /**
       * class Inflate
       *
       * Generic JS-style wrapper for zlib calls. If you don't need
       * streaming behaviour - use more simple functions: [[inflate]]
       * and [[inflateRaw]].
       **/

      /* internal
       * inflate.chunks -> Array
       *
       * Chunks of output data, if [[Inflate#onData]] not overriden.
       **/

      /**
       * Inflate.result -> Uint8Array|Array|String
       *
       * Uncompressed result, generated by default [[Inflate#onData]]
       * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
       * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
       **/

      /**
       * Inflate.err -> Number
       *
       * Error code after inflate finished. 0 (Z_OK) on success.
       * Should be checked if broken data possible.
       **/

      /**
       * Inflate.msg -> String
       *
       * Error message, if [[Inflate.err]] != 0
       **/

      /**
       * new Inflate(options)
       * - options (Object): zlib inflate options.
       *
       * Creates new inflator instance with specified params. Throws exception
       * on bad params. Supported options:
       *
       * - `windowBits`
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Additional options, for internal needs:
       *
       * - `chunkSize` - size of generated data chunks (16K by default)
       * - `raw` (Boolean) - do raw inflate
       * - `to` (String) - if equal to 'string', then result will be converted
       *   from utf8 to utf16 (javascript) string. When string output requested,
       *   chunk length can differ from `chunkSize`, depending on content.
       *
       * By default, when no options set, autodetect deflate/gzip data format via
       * wrapper header.
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
       *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
       *
       * var inflate = new pako.Inflate({ level: 3});
       *
       * inflate.push(chunk1, false);
       * inflate.push(chunk2, true);  // true -> last chunk
       *
       * if (inflate.err) { throw new Error(inflate.err); }
       *
       * console.log(inflate.result);
       * ```
       **/


      var Inflate = function (options) {
        this.options = utils.assign({
          chunkSize: 16384,
          windowBits: 0,
          to: ''
        }, options || {});
        var opt = this.options; // Force window size for `raw` data, if not set directly,
        // because we have no header for autodetect.

        if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
          opt.windowBits = -opt.windowBits;

          if (opt.windowBits === 0) {
            opt.windowBits = -15;
          }
        } // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate


        if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) {
          opt.windowBits += 32;
        } // Gzip header has no info about windows size, we can do autodetect only
        // for deflate. So, if window size not set, force it to max when gzip possible


        if (opt.windowBits > 15 && opt.windowBits < 48) {
          // bit 3 (16) -> gzipped data
          // bit 4 (32) -> autodetect gzip/deflate
          if ((opt.windowBits & 15) === 0) {
            opt.windowBits |= 15;
          }
        }

        this.err = 0; // error code, if happens (0 = Z_OK)

        this.msg = ''; // error message

        this.ended = false; // used to avoid multiple onEnd() calls

        this.chunks = []; // chunks of compressed data

        this.strm = new zstream();
        this.strm.avail_out = 0;
        var status = zlib_inflate.inflateInit2(this.strm, opt.windowBits);

        if (status !== c.Z_OK) {
          throw new Error(msg[status]);
        }

        this.header = new gzheader();
        zlib_inflate.inflateGetHeader(this.strm, this.header);
      };
      /**
       * Inflate#push(data[, mode]) -> Boolean
       * - data (Uint8Array|Array|String): input data
       * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
       *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
       *
       * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
       * new output chunks. Returns `true` on success. The last data block must have
       * mode Z_FINISH (or `true`). That flush internal pending buffers and call
       * [[Inflate#onEnd]].
       *
       * On fail call [[Inflate#onEnd]] with error code and return false.
       *
       * We strongly recommend to use `Uint8Array` on input for best speed (output
       * format is detected automatically). Also, don't skip last param and always
       * use the same type in your code (boolean or number). That will improve JS speed.
       *
       * For regular `Array`-s make sure all elements are [0..255].
       *
       * ##### Example
       *
       * ```javascript
       * push(chunk, false); // push one of data chunks
       * ...
       * push(chunk, true);  // push last chunk
       * ```
       **/


      Inflate.prototype.push = function (data, mode) {
        var strm = this.strm;
        var chunkSize = this.options.chunkSize;

        var status, _mode;

        var next_out_utf8, tail, utf8str;

        if (this.ended) {
          return false;
        }

        _mode = mode === ~~mode ? mode : mode === true ? c.Z_FINISH : c.Z_NO_FLUSH; // Convert data if needed

        if (typeof data === 'string') {
          // Only binary strings can be decompressed on practice
          strm.input = strings.binstring2buf(data);
        } else {
          strm.input = data;
        }

        strm.next_in = 0;
        strm.avail_in = strm.input.length;

        do {
          if (strm.avail_out === 0) {
            strm.output = new utils.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }

          status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);
          /* no bad return value */

          if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
          }

          if (strm.next_out) {
            if (strm.avail_out === 0 || status === c.Z_STREAM_END || strm.avail_in === 0 && _mode === c.Z_FINISH) {
              if (this.options.to === 'string') {
                next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
                tail = strm.next_out - next_out_utf8;
                utf8str = strings.buf2string(strm.output, next_out_utf8); // move tail

                strm.next_out = tail;
                strm.avail_out = chunkSize - tail;

                if (tail) {
                  utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                }

                this.onData(utf8str);
              } else {
                this.onData(utils.shrinkBuf(strm.output, strm.next_out));
              }
            }
          }
        } while (strm.avail_in > 0 && status !== c.Z_STREAM_END);

        if (status === c.Z_STREAM_END) {
          _mode = c.Z_FINISH;
        } // Finalize on the last chunk.


        if (_mode === c.Z_FINISH) {
          status = zlib_inflate.inflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === c.Z_OK;
        }

        return true;
      };
      /**
       * Inflate#onData(chunk) -> Void
       * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
       *   on js engine support. When string output requested, each chunk
       *   will be string.
       *
       * By default, stores data blocks in `chunks[]` property and glue
       * those in `onEnd`. Override this handler, if you need another behaviour.
       **/


      Inflate.prototype.onData = function (chunk) {
        this.chunks.push(chunk);
      };
      /**
       * Inflate#onEnd(status) -> Void
       * - status (Number): inflate status. 0 (Z_OK) on success,
       *   other if not.
       *
       * Called once after you tell inflate that input stream complete
       * or error happenned. By default - join collected chunks,
       * free memory and fill `results` / `err` properties.
       **/


      Inflate.prototype.onEnd = function (status) {
        // On success - join
        if (status === c.Z_OK) {
          if (this.options.to === 'string') {
            // Glue & convert here, until we teach pako to send
            // utf8 alligned strings to onData
            this.result = this.chunks.join('');
          } else {
            this.result = utils.flattenChunks(this.chunks);
          }
        }

        this.chunks = [];
        this.err = status;
        this.msg = this.strm.msg;
      };
      /**
       * inflate(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * Decompress `data` with inflate/ungzip and `options`. Autodetect
       * format via wrapper header by default. That's why we don't provide
       * separate `ungzip` method.
       *
       * Supported options are:
       *
       * - windowBits
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information.
       *
       * Sugar (options):
       *
       * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
       *   negative windowBits implicitly.
       * - `to` (String) - if equal to 'string', then result will be converted
       *   from utf8 to utf16 (javascript) string. When string output requested,
       *   chunk length can differ from `chunkSize`, depending on content.
       *
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
       *   , output;
       *
       * try {
       *   output = pako.inflate(input);
       * } catch (err)
       *   console.log(err);
       * }
       * ```
       **/


      function inflate(input, options) {
        var inflator = new Inflate(options);
        inflator.push(input, true); // That will never happens, if you don't cheat with options :)

        if (inflator.err) {
          throw inflator.msg;
        }

        return inflator.result;
      }
      /**
       * inflateRaw(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * The same as [[inflate]], but creates raw data, without wrapper
       * (header and adler32 crc).
       **/


      function inflateRaw(input, options) {
        options = options || {};
        options.raw = true;
        return inflate(input, options);
      }
      /**
       * ungzip(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * Just shortcut to [[inflate]], because it autodetects format
       * by header.content. Done for convenience.
       **/


      exports.Inflate = Inflate;
      exports.inflate = inflate;
      exports.inflateRaw = inflateRaw;
      exports.ungzip = inflate;
    }, {
      "./utils/common": 27,
      "./utils/strings": 28,
      "./zlib/constants": 30,
      "./zlib/gzheader": 33,
      "./zlib/inflate.js": 35,
      "./zlib/messages": 37,
      "./zlib/zstream": 39
    }],
    27: [function (_dereq_, module, exports) {

      var TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';

      exports.assign = function (obj
      /*from1, from2, from3, ...*/
      ) {
        var sources = Array.prototype.slice.call(arguments, 1);

        while (sources.length) {
          var source = sources.shift();

          if (!source) {
            continue;
          }

          if (typeof source !== 'object') {
            throw new TypeError(source + 'must be non-object');
          }

          for (var p in source) {
            if (source.hasOwnProperty(p)) {
              obj[p] = source[p];
            }
          }
        }

        return obj;
      }; // reduce buffer size, avoiding mem copy


      exports.shrinkBuf = function (buf, size) {
        if (buf.length === size) {
          return buf;
        }

        if (buf.subarray) {
          return buf.subarray(0, size);
        }

        buf.length = size;
        return buf;
      };

      var fnTyped = {
        arraySet: function (dest, src, src_offs, len, dest_offs) {
          if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
          } // Fallback to ordinary array


          for (var i = 0; i < len; i++) {
            dest[dest_offs + i] = src[src_offs + i];
          }
        },
        // Join array of chunks to single array.
        flattenChunks: function (chunks) {
          var i, l, len, pos, chunk, result; // calculate data length

          len = 0;

          for (i = 0, l = chunks.length; i < l; i++) {
            len += chunks[i].length;
          } // join chunks


          result = new Uint8Array(len);
          pos = 0;

          for (i = 0, l = chunks.length; i < l; i++) {
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
          }

          return result;
        }
      };
      var fnUntyped = {
        arraySet: function (dest, src, src_offs, len, dest_offs) {
          for (var i = 0; i < len; i++) {
            dest[dest_offs + i] = src[src_offs + i];
          }
        },
        // Join array of chunks to single array.
        flattenChunks: function (chunks) {
          return [].concat.apply([], chunks);
        }
      }; // Enable/Disable typed arrays use, for testing
      //

      exports.setTyped = function (on) {
        if (on) {
          exports.Buf8 = Uint8Array;
          exports.Buf16 = Uint16Array;
          exports.Buf32 = Int32Array;
          exports.assign(exports, fnTyped);
        } else {
          exports.Buf8 = Array;
          exports.Buf16 = Array;
          exports.Buf32 = Array;
          exports.assign(exports, fnUntyped);
        }
      };

      exports.setTyped(TYPED_OK);
    }, {}],
    28: [function (_dereq_, module, exports) {

      var utils = _dereq_('./common'); // Quick check if we can use fast array to bin string conversion
      //
      // - apply(Array) can fail on Android 2.2
      // - apply(Uint8Array) can fail on iOS 5.1 Safary
      //


      var STR_APPLY_OK = true;
      var STR_APPLY_UIA_OK = true;

      try {
        String.fromCharCode.apply(null, [0]);
      } catch (__) {
        STR_APPLY_OK = false;
      }

      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch (__) {
        STR_APPLY_UIA_OK = false;
      } // Table with utf8 lengths (calculated by first byte of sequence)
      // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
      // because max possible codepoint is 0x10ffff


      var _utf8len = new utils.Buf8(256);

      for (var i = 0; i < 256; i++) {
        _utf8len[i] = i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1;
      }

      _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
      // convert string to array (typed, when possible)

      exports.string2buf = function (str) {
        var buf,
            c,
            c2,
            m_pos,
            i,
            str_len = str.length,
            buf_len = 0; // count binary size

        for (m_pos = 0; m_pos < str_len; m_pos++) {
          c = str.charCodeAt(m_pos);

          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);

            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }

          buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
        } // allocate buffer


        buf = new utils.Buf8(buf_len); // convert

        for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
          c = str.charCodeAt(m_pos);

          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);

            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }

          if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
          } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
          } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          } else {
            /* four bytes */
            buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          }
        }

        return buf;
      }; // Helper (used in 2 places)


      function buf2binstring(buf, len) {
        // use fallback for big arrays to avoid stack overflow
        if (len < 65537) {
          if (buf.subarray && STR_APPLY_UIA_OK || !buf.subarray && STR_APPLY_OK) {
            return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
          }
        }

        var result = '';

        for (var i = 0; i < len; i++) {
          result += String.fromCharCode(buf[i]);
        }

        return result;
      } // Convert byte array to binary string


      exports.buf2binstring = function (buf) {
        return buf2binstring(buf, buf.length);
      }; // Convert binary string (typed, when possible)


      exports.binstring2buf = function (str) {
        var buf = new utils.Buf8(str.length);

        for (var i = 0, len = buf.length; i < len; i++) {
          buf[i] = str.charCodeAt(i);
        }

        return buf;
      }; // convert array to string


      exports.buf2string = function (buf, max) {
        var i, out, c, c_len;
        var len = max || buf.length; // Reserve max possible length (2 words per char)
        // NB: by unknown reasons, Array is significantly faster for
        //     String.fromCharCode.apply than Uint16Array.

        var utf16buf = new Array(len * 2);

        for (out = 0, i = 0; i < len;) {
          c = buf[i++]; // quick process ascii

          if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
          }

          c_len = _utf8len[c]; // skip 5 & 6 byte codes

          if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
          } // apply mask on first byte


          c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07; // join the rest

          while (c_len > 1 && i < len) {
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
          } // terminated by end of string?


          if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
          }

          if (c < 0x10000) {
            utf16buf[out++] = c;
          } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
          }
        }

        return buf2binstring(utf16buf, out);
      }; // Calculate max possible position in utf8 buffer,
      // that will not break sequence. If that's not possible
      // - (very small limits) return max size as is.
      //
      // buf[] - utf8 bytes array
      // max   - length limit (mandatory);


      exports.utf8border = function (buf, max) {
        var pos;
        max = max || buf.length;

        if (max > buf.length) {
          max = buf.length;
        } // go back from last position, until start of sequence found


        pos = max - 1;

        while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) {
          pos--;
        } // Fuckup - very small and broken sequence,
        // return max, because we should return something anyway.


        if (pos < 0) {
          return max;
        } // If we came to start of buffer - that means vuffer is too small,
        // return max too.


        if (pos === 0) {
          return max;
        }

        return pos + _utf8len[buf[pos]] > max ? pos : max;
      };
    }, {
      "./common": 27
    }],
    29: [function (_dereq_, module, exports) {
      // It doesn't worth to make additional optimizationa as in original.
      // Small size is preferable.

      function adler32(adler, buf, len, pos) {
        var s1 = adler & 0xffff | 0,
            s2 = adler >>> 16 & 0xffff | 0,
            n = 0;

        while (len !== 0) {
          // Set limit ~ twice less than 5552, to keep
          // s2 in 31-bits, because we force signed ints.
          // in other case %= will fail.
          n = len > 2000 ? 2000 : len;
          len -= n;

          do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
          } while (--n);

          s1 %= 65521;
          s2 %= 65521;
        }

        return s1 | s2 << 16 | 0;
      }

      module.exports = adler32;
    }, {}],
    30: [function (_dereq_, module, exports) {
      module.exports = {
        /* Allowed flush values; see deflate() and inflate() below for details */
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,

        /* Return codes for the compression/decompression functions. Negative values
        * are errors, positive values are used for special but normal events.
        */
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        //Z_MEM_ERROR:     -4,
        Z_BUF_ERROR: -5,
        //Z_VERSION_ERROR: -6,

        /* compression levels */
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,

        /* Possible values of the data_type field (though see inflate()) */
        Z_BINARY: 0,
        Z_TEXT: 1,
        //Z_ASCII:                1, // = Z_TEXT (deprecated)
        Z_UNKNOWN: 2,

        /* The deflate compression method */
        Z_DEFLATED: 8 //Z_NULL:                 null // Use -1 or null inline, depending on var type

      };
    }, {}],
    31: [function (_dereq_, module, exports) {
      // So write code to minimize size - no pregenerated tables
      // and array tools dependencies.
      // Use ordinary array, since untyped makes no boost here

      function makeTable() {
        var c,
            table = [];

        for (var n = 0; n < 256; n++) {
          c = n;

          for (var k = 0; k < 8; k++) {
            c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
          }

          table[n] = c;
        }

        return table;
      } // Create table on load. Just 255 signed longs. Not a problem.


      var crcTable = makeTable();

      function crc32(crc, buf, len, pos) {
        var t = crcTable,
            end = pos + len;
        crc = crc ^ -1;

        for (var i = pos; i < end; i++) {
          crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
        }

        return crc ^ -1; // >>> 0;
      }

      module.exports = crc32;
    }, {}],
    32: [function (_dereq_, module, exports) {

      var utils = _dereq_('../utils/common');

      var trees = _dereq_('./trees');

      var adler32 = _dereq_('./adler32');

      var crc32 = _dereq_('./crc32');

      var msg = _dereq_('./messages');
      /* Public constants ==========================================================*/

      /* ===========================================================================*/

      /* Allowed flush values; see deflate() and inflate() below for details */


      var Z_NO_FLUSH = 0;
      var Z_PARTIAL_FLUSH = 1; //var Z_SYNC_FLUSH    = 2;

      var Z_FULL_FLUSH = 3;
      var Z_FINISH = 4;
      var Z_BLOCK = 5; //var Z_TREES         = 6;

      /* Return codes for the compression/decompression functions. Negative values
       * are errors, positive values are used for special but normal events.
       */

      var Z_OK = 0;
      var Z_STREAM_END = 1; //var Z_NEED_DICT     = 2;
      //var Z_ERRNO         = -1;

      var Z_STREAM_ERROR = -2;
      var Z_DATA_ERROR = -3; //var Z_MEM_ERROR     = -4;

      var Z_BUF_ERROR = -5; //var Z_VERSION_ERROR = -6;

      /* compression levels */
      //var Z_NO_COMPRESSION      = 0;
      //var Z_BEST_SPEED          = 1;
      //var Z_BEST_COMPRESSION    = 9;

      var Z_DEFAULT_COMPRESSION = -1;
      var Z_FILTERED = 1;
      var Z_HUFFMAN_ONLY = 2;
      var Z_RLE = 3;
      var Z_FIXED = 4;
      var Z_DEFAULT_STRATEGY = 0;
      /* Possible values of the data_type field (though see inflate()) */
      //var Z_BINARY              = 0;
      //var Z_TEXT                = 1;
      //var Z_ASCII               = 1; // = Z_TEXT

      var Z_UNKNOWN = 2;
      /* The deflate compression method */

      var Z_DEFLATED = 8;
      /*============================================================================*/

      var MAX_MEM_LEVEL = 9;
      /* Maximum value for memLevel in deflateInit2 */

      var MAX_WBITS = 15;
      /* 32K LZ77 window */

      var DEF_MEM_LEVEL = 8;
      var LENGTH_CODES = 29;
      /* number of length codes, not counting the special END_BLOCK code */

      var LITERALS = 256;
      /* number of literal bytes 0..255 */

      var L_CODES = LITERALS + 1 + LENGTH_CODES;
      /* number of Literal or Length codes, including the END_BLOCK code */

      var D_CODES = 30;
      /* number of distance codes */

      var BL_CODES = 19;
      /* number of codes used to transfer the bit lengths */

      var HEAP_SIZE = 2 * L_CODES + 1;
      /* maximum heap size */

      var MAX_BITS = 15;
      /* All codes must not exceed MAX_BITS bits */

      var MIN_MATCH = 3;
      var MAX_MATCH = 258;
      var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
      var PRESET_DICT = 0x20;
      var INIT_STATE = 42;
      var EXTRA_STATE = 69;
      var NAME_STATE = 73;
      var COMMENT_STATE = 91;
      var HCRC_STATE = 103;
      var BUSY_STATE = 113;
      var FINISH_STATE = 666;
      var BS_NEED_MORE = 1;
      /* block not completed, need more input or more output */

      var BS_BLOCK_DONE = 2;
      /* block flush performed */

      var BS_FINISH_STARTED = 3;
      /* finish started, need only more output at next deflate */

      var BS_FINISH_DONE = 4;
      /* finish done, accept no more input or output */

      var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

      function err(strm, errorCode) {
        strm.msg = msg[errorCode];
        return errorCode;
      }

      function rank(f) {
        return (f << 1) - (f > 4 ? 9 : 0);
      }

      function zero(buf) {
        var len = buf.length;

        while (--len >= 0) {
          buf[len] = 0;
        }
      }
      /* =========================================================================
       * Flush as much pending output as possible. All deflate() output goes
       * through this function so some applications may wish to modify it
       * to avoid allocating a large strm->output buffer and copying into it.
       * (See also read_buf()).
       */


      function flush_pending(strm) {
        var s = strm.state; //_tr_flush_bits(s);

        var len = s.pending;

        if (len > strm.avail_out) {
          len = strm.avail_out;
        }

        if (len === 0) {
          return;
        }

        utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
        strm.next_out += len;
        s.pending_out += len;
        strm.total_out += len;
        strm.avail_out -= len;
        s.pending -= len;

        if (s.pending === 0) {
          s.pending_out = 0;
        }
      }

      function flush_block_only(s, last) {
        trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);

        s.block_start = s.strstart;
        flush_pending(s.strm);
      }

      function put_byte(s, b) {
        s.pending_buf[s.pending++] = b;
      }
      /* =========================================================================
       * Put a short in the pending buffer. The 16-bit value is put in MSB order.
       * IN assertion: the stream state is correct and there is enough room in
       * pending_buf.
       */


      function putShortMSB(s, b) {
        //  put_byte(s, (Byte)(b >> 8));
        //  put_byte(s, (Byte)(b & 0xff));
        s.pending_buf[s.pending++] = b >>> 8 & 0xff;
        s.pending_buf[s.pending++] = b & 0xff;
      }
      /* ===========================================================================
       * Read a new buffer from the current input stream, update the adler32
       * and total number of bytes read.  All deflate() input goes through
       * this function so some applications may wish to modify it to avoid
       * allocating a large strm->input buffer and copying from it.
       * (See also flush_pending()).
       */


      function read_buf(strm, buf, start, size) {
        var len = strm.avail_in;

        if (len > size) {
          len = size;
        }

        if (len === 0) {
          return 0;
        }

        strm.avail_in -= len;
        utils.arraySet(buf, strm.input, strm.next_in, len, start);

        if (strm.state.wrap === 1) {
          strm.adler = adler32(strm.adler, buf, len, start);
        } else if (strm.state.wrap === 2) {
          strm.adler = crc32(strm.adler, buf, len, start);
        }

        strm.next_in += len;
        strm.total_in += len;
        return len;
      }
      /* ===========================================================================
       * Set match_start to the longest match starting at the given string and
       * return its length. Matches shorter or equal to prev_length are discarded,
       * in which case the result is equal to prev_length and match_start is
       * garbage.
       * IN assertions: cur_match is the head of the hash chain for the current
       *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
       * OUT assertion: the match length is not greater than s->lookahead.
       */


      function longest_match(s, cur_match) {
        var chain_length = s.max_chain_length;
        /* max hash chain length */

        var scan = s.strstart;
        /* current string */

        var match;
        /* matched string */

        var len;
        /* length of current match */

        var best_len = s.prev_length;
        /* best match length so far */

        var nice_match = s.nice_match;
        /* stop if match long enough */

        var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0
        /*NIL*/
        ;
        var _win = s.window; // shortcut

        var wmask = s.w_mask;
        var prev = s.prev;
        /* Stop when cur_match becomes <= limit. To simplify the code,
         * we prevent matches with the string of window index 0.
         */

        var strend = s.strstart + MAX_MATCH;
        var scan_end1 = _win[scan + best_len - 1];
        var scan_end = _win[scan + best_len];
        /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
         * It is easy to get rid of this optimization if necessary.
         */
        // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

        /* Do not waste too much time if we already have a good match: */

        if (s.prev_length >= s.good_match) {
          chain_length >>= 2;
        }
        /* Do not look for matches beyond the end of the input. This is necessary
         * to make deflate deterministic.
         */


        if (nice_match > s.lookahead) {
          nice_match = s.lookahead;
        } // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");


        do {
          // Assert(cur_match < s->strstart, "no future");
          match = cur_match;
          /* Skip to next match if the match length cannot increase
           * or if the match length is less than 2.  Note that the checks below
           * for insufficient lookahead only occur occasionally for performance
           * reasons.  Therefore uninitialized memory will be accessed, and
           * conditional jumps will be made that depend on those values.
           * However the length of the match is limited to the lookahead, so
           * the output of deflate is not affected by the uninitialized values.
           */

          if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) {
            continue;
          }
          /* The check at best_len-1 can be removed because it will be made
           * again later. (This heuristic is not always a win.)
           * It is not necessary to compare scan[2] and match[2] since they
           * are always equal when the other bytes match, given that
           * the hash keys are equal and that HASH_BITS >= 8.
           */


          scan += 2;
          match++; // Assert(*scan == *match, "match[2]?");

          /* We check for insufficient lookahead only every 8th comparison;
           * the 256th check will be made at strstart+258.
           */

          do {
            /*jshint noempty:false*/
          } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend); // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");


          len = MAX_MATCH - (strend - scan);
          scan = strend - MAX_MATCH;

          if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;

            if (len >= nice_match) {
              break;
            }

            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
          }
        } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

        if (best_len <= s.lookahead) {
          return best_len;
        }

        return s.lookahead;
      }
      /* ===========================================================================
       * Fill the window when the lookahead becomes insufficient.
       * Updates strstart and lookahead.
       *
       * IN assertion: lookahead < MIN_LOOKAHEAD
       * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
       *    At least one byte has been read, or avail_in == 0; reads are
       *    performed for at least two bytes (required for the zip translate_eol
       *    option -- not supported here).
       */


      function fill_window(s) {
        var _w_size = s.w_size;
        var p, n, m, more, str; //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

        do {
          more = s.window_size - s.lookahead - s.strstart; // JS ints have 32 bit, block below not needed

          /* Deal with !@#$% 64K limit: */
          //if (sizeof(int) <= 2) {
          //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
          //        more = wsize;
          //
          //  } else if (more == (unsigned)(-1)) {
          //        /* Very unlikely, but possible on 16 bit machine if
          //         * strstart == 0 && lookahead == 1 (input done a byte at time)
          //         */
          //        more--;
          //    }
          //}

          /* If the window is almost full and there is insufficient lookahead,
           * move the upper half to the lower one to make room in the upper half.
           */

          if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */

            s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
             at the expense of memory usage). We slide even when level == 0
             to keep the hash table consistent if we switch back to level > 0
             later. (Using level 0 permanently is not an optimal usage of
             zlib, so we don't care about this pathological case.)
             */

            n = s.hash_size;
            p = n;

            do {
              m = s.head[--p];
              s.head[p] = m >= _w_size ? m - _w_size : 0;
            } while (--n);

            n = _w_size;
            p = n;

            do {
              m = s.prev[--p];
              s.prev[p] = m >= _w_size ? m - _w_size : 0;
              /* If n is not on any hash chain, prev[n] is garbage but
               * its value will never be used.
               */
            } while (--n);

            more += _w_size;
          }

          if (s.strm.avail_in === 0) {
            break;
          }
          /* If there was no sliding:
           *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
           *    more == window_size - lookahead - strstart
           * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
           * => more >= window_size - 2*WSIZE + 2
           * In the BIG_MEM or MMAP case (not yet supported),
           *   window_size == input_size + MIN_LOOKAHEAD  &&
           *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
           * Otherwise, window_size == 2*WSIZE so more >= 2.
           * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
           */
          //Assert(more >= 2, "more < 2");


          n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
          s.lookahead += n;
          /* Initialize the hash value now that we have some input: */

          if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */

            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask; //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif

            while (s.insert) {
              /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
              s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
              s.prev[str & s.w_mask] = s.head[s.ins_h];
              s.head[s.ins_h] = str;
              str++;
              s.insert--;

              if (s.lookahead + s.insert < MIN_MATCH) {
                break;
              }
            }
          }
          /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
           * but this is not important since only literal bytes will be emitted.
           */

        } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
        /* If the WIN_INIT bytes after the end of the current data have never been
         * written, then zero those bytes in order to avoid memory check reports of
         * the use of uninitialized (or uninitialised as Julian writes) bytes by
         * the longest match routines.  Update the high water mark for the next
         * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
         * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
         */
        //  if (s.high_water < s.window_size) {
        //    var curr = s.strstart + s.lookahead;
        //    var init = 0;
        //
        //    if (s.high_water < curr) {
        //      /* Previous high water mark below current data -- zero WIN_INIT
        //       * bytes or up to end of window, whichever is less.
        //       */
        //      init = s.window_size - curr;
        //      if (init > WIN_INIT)
        //        init = WIN_INIT;
        //      zmemzero(s->window + curr, (unsigned)init);
        //      s->high_water = curr + init;
        //    }
        //    else if (s->high_water < (ulg)curr + WIN_INIT) {
        //      /* High water mark at or above current data, but below current data
        //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
        //       * to end of window, whichever is less.
        //       */
        //      init = (ulg)curr + WIN_INIT - s->high_water;
        //      if (init > s->window_size - s->high_water)
        //        init = s->window_size - s->high_water;
        //      zmemzero(s->window + s->high_water, (unsigned)init);
        //      s->high_water += init;
        //    }
        //  }
        //
        //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
        //    "not enough room for search");

      }
      /* ===========================================================================
       * Copy without compression as much as possible from the input stream, return
       * the current block state.
       * This function does not insert new strings in the dictionary since
       * uncompressible data is probably not useful. This function is used
       * only for the level=0 compression option.
       * NOTE: this function should be optimized to avoid extra copying from
       * window to pending_buf.
       */


      function deflate_stored(s, flush) {
        /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
         * to pending_buf_size, and each stored block has a 5 byte header:
         */
        var max_block_size = 0xffff;

        if (max_block_size > s.pending_buf_size - 5) {
          max_block_size = s.pending_buf_size - 5;
        }
        /* Copy as much as possible from input to output: */


        for (;;) {
          /* Fill the window as much as possible: */
          if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            fill_window(s);

            if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }

            if (s.lookahead === 0) {
              break;
            }
            /* flush the current block */

          } //Assert(s->block_start >= 0L, "block gone");
          //    if (s.block_start < 0) throw new Error("block gone");


          s.strstart += s.lookahead;
          s.lookahead = 0;
          /* Emit a stored block if pending_buf will be full: */

          var max_start = s.block_start + max_block_size;

          if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */
            s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/

            flush_block_only(s, false);

            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/

          }
          /* Flush if we may have to slide, otherwise block_start may become
           * negative and the data will be gone:
           */


          if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);

            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/

          }
        }

        s.insert = 0;

        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);

          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/


          return BS_FINISH_DONE;
        }

        if (s.strstart > s.block_start) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/

        }

        return BS_NEED_MORE;
      }
      /* ===========================================================================
       * Compress as much as possible from the input stream, return the current
       * block state.
       * This function does not perform lazy evaluation of matches and inserts
       * new strings in the dictionary only for unmatched strings or for short
       * matches. It is used only for the fast compression options.
       */


      function deflate_fast(s, flush) {
        var hash_head;
        /* head of the hash chain */

        var bflush;
        /* set if current block must be flushed */

        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the next match, plus MIN_MATCH bytes to insert the
           * string following the next match.
           */
          if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);

            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }

            if (s.lookahead === 0) {
              break;
              /* flush the current block */
            }
          }
          /* Insert the string window[strstart .. strstart+2] in the
           * dictionary, and set hash_head to the head of the hash chain:
           */


          hash_head = 0
          /*NIL*/
          ;

          if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
            /***/
          }
          /* Find the longest match, discarding those <= prev_length.
           * At this point we have always match_length < MIN_MATCH
           */


          if (hash_head !== 0
          /*NIL*/
          && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
             * of window index 0 (in particular we have to avoid a match
             * of the string with itself at the start of the input file).
             */
            s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */
          }

          if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                           s.match_length - MIN_MATCH, bflush); ***/
            bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
             * is not too large. This saves time but degrades compression.
             */

            if (s.match_length <= s.max_lazy_match
            /*max_insert_length*/
            && s.lookahead >= MIN_MATCH) {
              s.match_length--;
              /* string at strstart already in table */

              do {
                s.strstart++;
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/

                s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
                /***/

                /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                 * always MIN_MATCH bytes ahead.
                 */
              } while (--s.match_length !== 0);

              s.strstart++;
            } else {
              s.strstart += s.match_length;
              s.match_length = 0;
              s.ins_h = s.window[s.strstart];
              /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */

              s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask; //#if MIN_MATCH != 3
              //                Call UPDATE_HASH() MIN_MATCH-3 more times
              //#endif

              /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
               * matter since it will be recomputed at next deflate call.
               */
            }
          } else {
            /* No match, output a literal byte */
            //Tracevv((stderr,"%c", s.window[s.strstart]));

            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
          }

          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);

            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/

          }
        }

        s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;

        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);

          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/


          return BS_FINISH_DONE;
        }

        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/

        }

        return BS_BLOCK_DONE;
      }
      /* ===========================================================================
       * Same as above, but achieves better compression. We use a lazy
       * evaluation for matches: a match is finally adopted only if there is
       * no better match at the next window position.
       */


      function deflate_slow(s, flush) {
        var hash_head;
        /* head of hash chain */

        var bflush;
        /* set if current block must be flushed */

        var max_insert;
        /* Process the input block. */

        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the next match, plus MIN_MATCH bytes to insert the
           * string following the next match.
           */
          if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);

            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }

            if (s.lookahead === 0) {
              break;
            }
            /* flush the current block */

          }
          /* Insert the string window[strstart .. strstart+2] in the
           * dictionary, and set hash_head to the head of the hash chain:
           */


          hash_head = 0
          /*NIL*/
          ;

          if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
            /***/
          }
          /* Find the longest match, discarding those <= prev_length.
           */


          s.prev_length = s.match_length;
          s.prev_match = s.match_start;
          s.match_length = MIN_MATCH - 1;

          if (hash_head !== 0
          /*NIL*/
          && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
          /*MAX_DIST(s)*/
          ) {
            /* To simplify the code, we prevent matches with the string
             * of window index 0 (in particular we have to avoid a match
             * of the string with itself at the start of the input file).
             */
            s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */

            if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096
            /*TOO_FAR*/
            )) {
              /* If prev_match is also MIN_MATCH, match_start is garbage
               * but we will ignore the current match anyway.
               */
              s.match_length = MIN_MATCH - 1;
            }
          }
          /* If there was a match at the previous step and the current
           * match is not better, output the previous match:
           */


          if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */
            //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                           s.prev_length - MIN_MATCH, bflush);***/

            bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
             * strstart-1 and strstart are already inserted. If there is not
             * enough lookahead, the last two strings are not inserted in
             * the hash table.
             */

            s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;

            do {
              if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
                /***/
              }
            } while (--s.prev_length !== 0);

            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;

            if (bflush) {
              /*** FLUSH_BLOCK(s, 0); ***/
              flush_block_only(s, false);

              if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
              }
              /***/

            }
          } else if (s.match_available) {
            /* If there was no match at the previous position, output a
             * single literal. If there was a match but the current match
             * is longer, truncate the previous match to a single literal.
             */
            //Tracevv((stderr,"%c", s->window[s->strstart-1]));

            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

            if (bflush) {
              /*** FLUSH_BLOCK_ONLY(s, 0) ***/
              flush_block_only(s, false);
              /***/
            }

            s.strstart++;
            s.lookahead--;

            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
          } else {
            /* There is no previous match to compare with, wait for
             * the next step to decide.
             */
            s.match_available = 1;
            s.strstart++;
            s.lookahead--;
          }
        } //Assert (flush != Z_NO_FLUSH, "no flush?");


        if (s.match_available) {
          //Tracevv((stderr,"%c", s->window[s->strstart-1]));

          /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
          bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
          s.match_available = 0;
        }

        s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;

        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);

          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/


          return BS_FINISH_DONE;
        }

        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/

        }

        return BS_BLOCK_DONE;
      }
      /* ===========================================================================
       * For Z_RLE, simply look for runs of bytes, generate matches only of distance
       * one.  Do not maintain a hash table.  (It will be regenerated if this run of
       * deflate switches away from Z_RLE.)
       */


      function deflate_rle(s, flush) {
        var bflush;
        /* set if current block must be flushed */

        var prev;
        /* byte at distance one to match */

        var scan, strend;
        /* scan goes up to strend for length of run */

        var _win = s.window;

        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the longest run, plus one for the unrolled loop.
           */
          if (s.lookahead <= MAX_MATCH) {
            fill_window(s);

            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }

            if (s.lookahead === 0) {
              break;
            }
            /* flush the current block */

          }
          /* See how many times the previous byte repeats */


          s.match_length = 0;

          if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];

            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
              strend = s.strstart + MAX_MATCH;

              do {
                /*jshint noempty:false*/
              } while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);

              s.match_length = MAX_MATCH - (strend - scan);

              if (s.match_length > s.lookahead) {
                s.match_length = s.lookahead;
              }
            } //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");

          }
          /* Emit match if have run of MIN_MATCH or longer, else emit literal */


          if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);

            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
            bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
          } else {
            /* No match, output a literal byte */
            //Tracevv((stderr,"%c", s->window[s->strstart]));

            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
          }

          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);

            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/

          }
        }

        s.insert = 0;

        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);

          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/


          return BS_FINISH_DONE;
        }

        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/

        }

        return BS_BLOCK_DONE;
      }
      /* ===========================================================================
       * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
       * (It will be regenerated if this run of deflate switches away from Huffman.)
       */


      function deflate_huff(s, flush) {
        var bflush;
        /* set if current block must be flushed */

        for (;;) {
          /* Make sure that we have a literal to write. */
          if (s.lookahead === 0) {
            fill_window(s);

            if (s.lookahead === 0) {
              if (flush === Z_NO_FLUSH) {
                return BS_NEED_MORE;
              }

              break;
              /* flush the current block */
            }
          }
          /* Output a literal byte */


          s.match_length = 0; //Tracevv((stderr,"%c", s->window[s->strstart]));

          /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/

          bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
          s.lookahead--;
          s.strstart++;

          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);

            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/

          }
        }

        s.insert = 0;

        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);

          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/


          return BS_FINISH_DONE;
        }

        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/

        }

        return BS_BLOCK_DONE;
      }
      /* Values for max_lazy_match, good_match and max_chain_length, depending on
       * the desired pack level (0..9). The values given below have been tuned to
       * exclude worst case performance for pathological files. Better values may be
       * found for specific files.
       */


      var Config = function (good_length, max_lazy, nice_length, max_chain, func) {
        this.good_length = good_length;
        this.max_lazy = max_lazy;
        this.nice_length = nice_length;
        this.max_chain = max_chain;
        this.func = func;
      };

      var configuration_table;
      configuration_table = [
      /*      good lazy nice chain */
      new Config(0, 0, 0, 0, deflate_stored),
      /* 0 store only */
      new Config(4, 4, 8, 4, deflate_fast),
      /* 1 max speed, no lazy matches */
      new Config(4, 5, 16, 8, deflate_fast),
      /* 2 */
      new Config(4, 6, 32, 32, deflate_fast),
      /* 3 */
      new Config(4, 4, 16, 16, deflate_slow),
      /* 4 lazy matches */
      new Config(8, 16, 32, 32, deflate_slow),
      /* 5 */
      new Config(8, 16, 128, 128, deflate_slow),
      /* 6 */
      new Config(8, 32, 128, 256, deflate_slow),
      /* 7 */
      new Config(32, 128, 258, 1024, deflate_slow),
      /* 8 */
      new Config(32, 258, 258, 4096, deflate_slow)
      /* 9 max compression */
      ];
      /* ===========================================================================
       * Initialize the "longest match" routines for a new zlib stream
       */

      function lm_init(s) {
        s.window_size = 2 * s.w_size;
        /*** CLEAR_HASH(s); ***/

        zero(s.head); // Fill with NIL (= 0);

        /* Set the default configuration parameters:
         */

        s.max_lazy_match = configuration_table[s.level].max_lazy;
        s.good_match = configuration_table[s.level].good_length;
        s.nice_match = configuration_table[s.level].nice_length;
        s.max_chain_length = configuration_table[s.level].max_chain;
        s.strstart = 0;
        s.block_start = 0;
        s.lookahead = 0;
        s.insert = 0;
        s.match_length = s.prev_length = MIN_MATCH - 1;
        s.match_available = 0;
        s.ins_h = 0;
      }

      function DeflateState() {
        this.strm = null;
        /* pointer back to this zlib stream */

        this.status = 0;
        /* as the name implies */

        this.pending_buf = null;
        /* output still pending */

        this.pending_buf_size = 0;
        /* size of pending_buf */

        this.pending_out = 0;
        /* next pending byte to output to the stream */

        this.pending = 0;
        /* nb of bytes in the pending buffer */

        this.wrap = 0;
        /* bit 0 true for zlib, bit 1 true for gzip */

        this.gzhead = null;
        /* gzip header information to write */

        this.gzindex = 0;
        /* where in extra, name, or comment */

        this.method = Z_DEFLATED;
        /* can only be DEFLATED */

        this.last_flush = -1;
        /* value of flush param for previous deflate call */

        this.w_size = 0;
        /* LZ77 window size (32K by default) */

        this.w_bits = 0;
        /* log2(w_size)  (8..16) */

        this.w_mask = 0;
        /* w_size - 1 */

        this.window = null;
        /* Sliding window. Input bytes are read into the second half of the window,
         * and move to the first half later to keep a dictionary of at least wSize
         * bytes. With this organization, matches are limited to a distance of
         * wSize-MAX_MATCH bytes, but this ensures that IO is always
         * performed with a length multiple of the block size.
         */

        this.window_size = 0;
        /* Actual size of window: 2*wSize, except when the user input buffer
         * is directly used as sliding window.
         */

        this.prev = null;
        /* Link to older string with same hash index. To limit the size of this
         * array to 64K, this link is maintained only for the last 32K strings.
         * An index in this array is thus a window index modulo 32K.
         */

        this.head = null;
        /* Heads of the hash chains or NIL. */

        this.ins_h = 0;
        /* hash index of string to be inserted */

        this.hash_size = 0;
        /* number of elements in hash table */

        this.hash_bits = 0;
        /* log2(hash_size) */

        this.hash_mask = 0;
        /* hash_size-1 */

        this.hash_shift = 0;
        /* Number of bits by which ins_h must be shifted at each input
         * step. It must be such that after MIN_MATCH steps, the oldest
         * byte no longer takes part in the hash key, that is:
         *   hash_shift * MIN_MATCH >= hash_bits
         */

        this.block_start = 0;
        /* Window position at the beginning of the current output block. Gets
         * negative when the window is moved backwards.
         */

        this.match_length = 0;
        /* length of best match */

        this.prev_match = 0;
        /* previous match */

        this.match_available = 0;
        /* set if previous match exists */

        this.strstart = 0;
        /* start of string to insert */

        this.match_start = 0;
        /* start of matching string */

        this.lookahead = 0;
        /* number of valid bytes ahead in window */

        this.prev_length = 0;
        /* Length of the best match at previous step. Matches not greater than this
         * are discarded. This is used in the lazy match evaluation.
         */

        this.max_chain_length = 0;
        /* To speed up deflation, hash chains are never searched beyond this
         * length.  A higher limit improves compression ratio but degrades the
         * speed.
         */

        this.max_lazy_match = 0;
        /* Attempt to find a better match only when the current match is strictly
         * smaller than this value. This mechanism is used only for compression
         * levels >= 4.
         */
        // That's alias to max_lazy_match, don't use directly
        //this.max_insert_length = 0;

        /* Insert new strings in the hash table only if the match length is not
         * greater than this length. This saves time but degrades compression.
         * max_insert_length is used only for compression levels <= 3.
         */

        this.level = 0;
        /* compression level (1..9) */

        this.strategy = 0;
        /* favor or force Huffman coding*/

        this.good_match = 0;
        /* Use a faster search when the previous match is longer than this */

        this.nice_match = 0;
        /* Stop searching when current match exceeds this */

        /* used by trees.c: */

        /* Didn't use ct_data typedef below to suppress compiler warning */
        // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
        // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
        // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
        // Use flat array of DOUBLE size, with interleaved fata,
        // because JS does not support effective

        this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
        this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
        this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
        zero(this.dyn_ltree);
        zero(this.dyn_dtree);
        zero(this.bl_tree);
        this.l_desc = null;
        /* desc. for literal tree */

        this.d_desc = null;
        /* desc. for distance tree */

        this.bl_desc = null;
        /* desc. for bit length tree */
        //ush bl_count[MAX_BITS+1];

        this.bl_count = new utils.Buf16(MAX_BITS + 1);
        /* number of codes at each bit length for an optimal tree */
        //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */

        this.heap = new utils.Buf16(2 * L_CODES + 1);
        /* heap used to build the Huffman trees */

        zero(this.heap);
        this.heap_len = 0;
        /* number of elements in the heap */

        this.heap_max = 0;
        /* element of largest frequency */

        /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
         * The same heap array is used to build all trees.
         */

        this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];

        zero(this.depth);
        /* Depth of each subtree used as tie breaker for trees of equal frequency
         */

        this.l_buf = 0;
        /* buffer index for literals or lengths */

        this.lit_bufsize = 0;
        /* Size of match buffer for literals/lengths.  There are 4 reasons for
         * limiting lit_bufsize to 64K:
         *   - frequencies can be kept in 16 bit counters
         *   - if compression is not successful for the first block, all input
         *     data is still in the window so we can still emit a stored block even
         *     when input comes from standard input.  (This can also be done for
         *     all blocks if lit_bufsize is not greater than 32K.)
         *   - if compression is not successful for a file smaller than 64K, we can
         *     even emit a stored file instead of a stored block (saving 5 bytes).
         *     This is applicable only for zip (not gzip or zlib).
         *   - creating new Huffman trees less frequently may not provide fast
         *     adaptation to changes in the input data statistics. (Take for
         *     example a binary file with poorly compressible code followed by
         *     a highly compressible string table.) Smaller buffer sizes give
         *     fast adaptation but have of course the overhead of transmitting
         *     trees more frequently.
         *   - I can't count above 4
         */

        this.last_lit = 0;
        /* running index in l_buf */

        this.d_buf = 0;
        /* Buffer index for distances. To simplify the code, d_buf and l_buf have
         * the same number of elements. To use different lengths, an extra flag
         * array would be necessary.
         */

        this.opt_len = 0;
        /* bit length of current block with optimal trees */

        this.static_len = 0;
        /* bit length of current block with static trees */

        this.matches = 0;
        /* number of string matches in current block */

        this.insert = 0;
        /* bytes at end of window left to insert */

        this.bi_buf = 0;
        /* Output buffer. bits are inserted starting at the bottom (least
         * significant bits).
         */

        this.bi_valid = 0;
        /* Number of valid bits in bi_buf.  All bits above the last valid bit
         * are always zero.
         */
        // Used for window memory init. We safely ignore it for JS. That makes
        // sense only for pointers and memory check tools.
        //this.high_water = 0;

        /* High water mark offset in window for initialized bytes -- bytes above
         * this are set to zero in order to avoid memory check warnings when
         * longest match routines access bytes past the input.  This is then
         * updated to the new high water mark.
         */
      }

      function deflateResetKeep(strm) {
        var s;

        if (!strm || !strm.state) {
          return err(strm, Z_STREAM_ERROR);
        }

        strm.total_in = strm.total_out = 0;
        strm.data_type = Z_UNKNOWN;
        s = strm.state;
        s.pending = 0;
        s.pending_out = 0;

        if (s.wrap < 0) {
          s.wrap = -s.wrap;
          /* was made negative by deflate(..., Z_FINISH); */
        }

        s.status = s.wrap ? INIT_STATE : BUSY_STATE;
        strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
        : 1; // adler32(0, Z_NULL, 0)

        s.last_flush = Z_NO_FLUSH;

        trees._tr_init(s);

        return Z_OK;
      }

      function deflateReset(strm) {
        var ret = deflateResetKeep(strm);

        if (ret === Z_OK) {
          lm_init(strm.state);
        }

        return ret;
      }

      function deflateSetHeader(strm, head) {
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }

        if (strm.state.wrap !== 2) {
          return Z_STREAM_ERROR;
        }

        strm.state.gzhead = head;
        return Z_OK;
      }

      function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
        if (!strm) {
          // === Z_NULL
          return Z_STREAM_ERROR;
        }

        var wrap = 1;

        if (level === Z_DEFAULT_COMPRESSION) {
          level = 6;
        }

        if (windowBits < 0) {
          /* suppress zlib wrapper */
          wrap = 0;
          windowBits = -windowBits;
        } else if (windowBits > 15) {
          wrap = 2;
          /* write gzip wrapper instead */

          windowBits -= 16;
        }

        if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) {
          return err(strm, Z_STREAM_ERROR);
        }

        if (windowBits === 8) {
          windowBits = 9;
        }
        /* until 256-byte window bug fixed */


        var s = new DeflateState();
        strm.state = s;
        s.strm = strm;
        s.wrap = wrap;
        s.gzhead = null;
        s.w_bits = windowBits;
        s.w_size = 1 << s.w_bits;
        s.w_mask = s.w_size - 1;
        s.hash_bits = memLevel + 7;
        s.hash_size = 1 << s.hash_bits;
        s.hash_mask = s.hash_size - 1;
        s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
        s.window = new utils.Buf8(s.w_size * 2);
        s.head = new utils.Buf16(s.hash_size);
        s.prev = new utils.Buf16(s.w_size); // Don't need mem init magic for JS.
        //s.high_water = 0;  /* nothing written to s->window yet */

        s.lit_bufsize = 1 << memLevel + 6;
        /* 16K elements by default */

        s.pending_buf_size = s.lit_bufsize * 4;
        s.pending_buf = new utils.Buf8(s.pending_buf_size);
        s.d_buf = s.lit_bufsize >> 1;
        s.l_buf = (1 + 2) * s.lit_bufsize;
        s.level = level;
        s.strategy = strategy;
        s.method = method;
        return deflateReset(strm);
      }

      function deflateInit(strm, level) {
        return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
      }

      function deflate(strm, flush) {
        var old_flush, s;
        var beg, val; // for gzip header write only

        if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
          return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
        }

        s = strm.state;

        if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) {
          return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
        }

        s.strm = strm;
        /* just in case */

        old_flush = s.last_flush;
        s.last_flush = flush;
        /* Write the header */

        if (s.status === INIT_STATE) {
          if (s.wrap === 2) {
            // GZIP header
            strm.adler = 0; //crc32(0L, Z_NULL, 0);

            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);

            if (!s.gzhead) {
              // s->gzhead == Z_NULL
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
              put_byte(s, OS_CODE);
              s.status = BUSY_STATE;
            } else {
              put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
              put_byte(s, s.gzhead.time & 0xff);
              put_byte(s, s.gzhead.time >> 8 & 0xff);
              put_byte(s, s.gzhead.time >> 16 & 0xff);
              put_byte(s, s.gzhead.time >> 24 & 0xff);
              put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
              put_byte(s, s.gzhead.os & 0xff);

              if (s.gzhead.extra && s.gzhead.extra.length) {
                put_byte(s, s.gzhead.extra.length & 0xff);
                put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
              }

              if (s.gzhead.hcrc) {
                strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
              }

              s.gzindex = 0;
              s.status = EXTRA_STATE;
            }
          } else // DEFLATE header
            {
              var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
              var level_flags = -1;

              if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                level_flags = 0;
              } else if (s.level < 6) {
                level_flags = 1;
              } else if (s.level === 6) {
                level_flags = 2;
              } else {
                level_flags = 3;
              }

              header |= level_flags << 6;

              if (s.strstart !== 0) {
                header |= PRESET_DICT;
              }

              header += 31 - header % 31;
              s.status = BUSY_STATE;
              putShortMSB(s, header);
              /* Save the adler32 of the preset dictionary: */

              if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
              }

              strm.adler = 1; // adler32(0L, Z_NULL, 0);
            }
        } //#ifdef GZIP


        if (s.status === EXTRA_STATE) {
          if (s.gzhead.extra
          /* != Z_NULL*/
          ) {
            beg = s.pending;
            /* start of bytes to update crc */

            while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }

                flush_pending(strm);
                beg = s.pending;

                if (s.pending === s.pending_buf_size) {
                  break;
                }
              }

              put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
              s.gzindex++;
            }

            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }

            if (s.gzindex === s.gzhead.extra.length) {
              s.gzindex = 0;
              s.status = NAME_STATE;
            }
          } else {
            s.status = NAME_STATE;
          }
        }

        if (s.status === NAME_STATE) {
          if (s.gzhead.name
          /* != Z_NULL*/
          ) {
            beg = s.pending;
            /* start of bytes to update crc */
            //int val;

            do {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }

                flush_pending(strm);
                beg = s.pending;

                if (s.pending === s.pending_buf_size) {
                  val = 1;
                  break;
                }
              } // JS specific: little magic to add zero terminator to end of string


              if (s.gzindex < s.gzhead.name.length) {
                val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
              } else {
                val = 0;
              }

              put_byte(s, val);
            } while (val !== 0);

            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }

            if (val === 0) {
              s.gzindex = 0;
              s.status = COMMENT_STATE;
            }
          } else {
            s.status = COMMENT_STATE;
          }
        }

        if (s.status === COMMENT_STATE) {
          if (s.gzhead.comment
          /* != Z_NULL*/
          ) {
            beg = s.pending;
            /* start of bytes to update crc */
            //int val;

            do {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }

                flush_pending(strm);
                beg = s.pending;

                if (s.pending === s.pending_buf_size) {
                  val = 1;
                  break;
                }
              } // JS specific: little magic to add zero terminator to end of string


              if (s.gzindex < s.gzhead.comment.length) {
                val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
              } else {
                val = 0;
              }

              put_byte(s, val);
            } while (val !== 0);

            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }

            if (val === 0) {
              s.status = HCRC_STATE;
            }
          } else {
            s.status = HCRC_STATE;
          }
        }

        if (s.status === HCRC_STATE) {
          if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
              flush_pending(strm);
            }

            if (s.pending + 2 <= s.pending_buf_size) {
              put_byte(s, strm.adler & 0xff);
              put_byte(s, strm.adler >> 8 & 0xff);
              strm.adler = 0; //crc32(0L, Z_NULL, 0);

              s.status = BUSY_STATE;
            }
          } else {
            s.status = BUSY_STATE;
          }
        } //#endif

        /* Flush as much pending output as possible */


        if (s.pending !== 0) {
          flush_pending(strm);

          if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
             * more output space, but possibly with both pending and
             * avail_in equal to zero. There won't be anything to do,
             * but this is not an error situation so make sure we
             * return OK instead of BUF_ERROR at next call of deflate:
             */
            s.last_flush = -1;
            return Z_OK;
          }
          /* Make sure there is something to do and avoid duplicate consecutive
           * flushes. For repeated and useless calls with Z_FINISH, we keep
           * returning Z_STREAM_END instead of Z_BUF_ERROR.
           */

        } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
          return err(strm, Z_BUF_ERROR);
        }
        /* User must not provide more input after the first FINISH: */


        if (s.status === FINISH_STATE && strm.avail_in !== 0) {
          return err(strm, Z_BUF_ERROR);
        }
        /* Start a new block or continue the current one.
         */


        if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
          var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);

          if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
            s.status = FINISH_STATE;
          }

          if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) {
              s.last_flush = -1;
              /* avoid BUF_ERROR next call, see above */
            }

            return Z_OK;
            /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
             * of deflate should use the same flush parameter to make sure
             * that the flush is complete. So we don't have to output an
             * empty block here, this will be done at next call. This also
             * ensures that for a very small output buffer, we emit at most
             * one empty block.
             */
          }

          if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) {
              trees._tr_align(s);
            } else if (flush !== Z_BLOCK) {
              /* FULL_FLUSH or SYNC_FLUSH */
              trees._tr_stored_block(s, 0, 0, false);
              /* For a full flush, this empty block will be recognized
               * as a special marker by inflate_sync().
               */


              if (flush === Z_FULL_FLUSH) {
                /*** CLEAR_HASH(s); ***/

                /* forget history */
                zero(s.head); // Fill with NIL (= 0);

                if (s.lookahead === 0) {
                  s.strstart = 0;
                  s.block_start = 0;
                  s.insert = 0;
                }
              }
            }

            flush_pending(strm);

            if (strm.avail_out === 0) {
              s.last_flush = -1;
              /* avoid BUF_ERROR at next call, see above */

              return Z_OK;
            }
          }
        } //Assert(strm->avail_out > 0, "bug2");
        //if (strm.avail_out <= 0) { throw new Error("bug2");}


        if (flush !== Z_FINISH) {
          return Z_OK;
        }

        if (s.wrap <= 0) {
          return Z_STREAM_END;
        }
        /* Write the trailer */


        if (s.wrap === 2) {
          put_byte(s, strm.adler & 0xff);
          put_byte(s, strm.adler >> 8 & 0xff);
          put_byte(s, strm.adler >> 16 & 0xff);
          put_byte(s, strm.adler >> 24 & 0xff);
          put_byte(s, strm.total_in & 0xff);
          put_byte(s, strm.total_in >> 8 & 0xff);
          put_byte(s, strm.total_in >> 16 & 0xff);
          put_byte(s, strm.total_in >> 24 & 0xff);
        } else {
          putShortMSB(s, strm.adler >>> 16);
          putShortMSB(s, strm.adler & 0xffff);
        }

        flush_pending(strm);
        /* If avail_out is zero, the application will call deflate again
         * to flush the rest.
         */

        if (s.wrap > 0) {
          s.wrap = -s.wrap;
        }
        /* write the trailer only once! */


        return s.pending !== 0 ? Z_OK : Z_STREAM_END;
      }

      function deflateEnd(strm) {
        var status;

        if (!strm
        /*== Z_NULL*/
        || !strm.state
        /*== Z_NULL*/
        ) {
          return Z_STREAM_ERROR;
        }

        status = strm.state.status;

        if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) {
          return err(strm, Z_STREAM_ERROR);
        }

        strm.state = null;
        return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
      }
      /* =========================================================================
       * Copy the source state to the destination state
       */
      //function deflateCopy(dest, source) {
      //
      //}


      exports.deflateInit = deflateInit;
      exports.deflateInit2 = deflateInit2;
      exports.deflateReset = deflateReset;
      exports.deflateResetKeep = deflateResetKeep;
      exports.deflateSetHeader = deflateSetHeader;
      exports.deflate = deflate;
      exports.deflateEnd = deflateEnd;
      exports.deflateInfo = 'pako deflate (from Nodeca project)';
      /* Not implemented
      exports.deflateBound = deflateBound;
      exports.deflateCopy = deflateCopy;
      exports.deflateSetDictionary = deflateSetDictionary;
      exports.deflateParams = deflateParams;
      exports.deflatePending = deflatePending;
      exports.deflatePrime = deflatePrime;
      exports.deflateTune = deflateTune;
      */
    }, {
      "../utils/common": 27,
      "./adler32": 29,
      "./crc32": 31,
      "./messages": 37,
      "./trees": 38
    }],
    33: [function (_dereq_, module, exports) {

      function GZheader() {
        /* true if compressed data believed to be text */
        this.text = 0;
        /* modification time */

        this.time = 0;
        /* extra flags (not used when writing a gzip file) */

        this.xflags = 0;
        /* operating system */

        this.os = 0;
        /* pointer to extra field or Z_NULL if none */

        this.extra = null;
        /* extra field length (valid if extra != Z_NULL) */

        this.extra_len = 0; // Actually, we don't need it in JS,
        // but leave for few code modifications
        //
        // Setup limits is not necessary because in js we should not preallocate memory
        // for inflate use constant limit in 65536 bytes
        //

        /* space at extra (only when reading header) */
        // this.extra_max  = 0;

        /* pointer to zero-terminated file name or Z_NULL */

        this.name = '';
        /* space at name (only when reading header) */
        // this.name_max   = 0;

        /* pointer to zero-terminated comment or Z_NULL */

        this.comment = '';
        /* space at comment (only when reading header) */
        // this.comm_max   = 0;

        /* true if there was or will be a header crc */

        this.hcrc = 0;
        /* true when done reading gzip header (not used when writing a gzip file) */

        this.done = false;
      }

      module.exports = GZheader;
    }, {}],
    34: [function (_dereq_, module, exports) {

      var BAD = 30;
      /* got a data error -- remain here until reset */

      var TYPE = 12;
      /* i: waiting for type bits, including last-flag bit */

      /*
         Decode literal, length, and distance codes and write out the resulting
         literal and match bytes until either not enough input or output is
         available, an end-of-block is encountered, or a data error is encountered.
         When large enough input and output buffers are supplied to inflate(), for
         example, a 16K input buffer and a 64K output buffer, more than 95% of the
         inflate execution time is spent in this routine.
      
         Entry assumptions:
      
              state.mode === LEN
              strm.avail_in >= 6
              strm.avail_out >= 258
              start >= strm.avail_out
              state.bits < 8
      
         On return, state.mode is one of:
      
              LEN -- ran out of enough output space or enough available input
              TYPE -- reached end of block code, inflate() to interpret next block
              BAD -- error in block data
      
         Notes:
      
          - The maximum input bits used by a length/distance pair is 15 bits for the
            length code, 5 bits for the length extra, 15 bits for the distance code,
            and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
            Therefore if strm.avail_in >= 6, then there is enough input to avoid
            checking for available input while decoding.
      
          - The maximum bytes that a single length/distance pair can output is 258
            bytes, which is the maximum length that can be coded.  inflate_fast()
            requires strm.avail_out >= 258 for each loop to avoid checking for
            output space.
       */

      module.exports = function inflate_fast(strm, start) {
        var state;

        var _in;
        /* local strm.input */


        var last;
        /* have enough input while in < last */

        var _out;
        /* local strm.output */


        var beg;
        /* inflate()'s initial strm.output */

        var end;
        /* while out < end, enough space available */
        //#ifdef INFLATE_STRICT

        var dmax;
        /* maximum distance from zlib header */
        //#endif

        var wsize;
        /* window size or zero if not using window */

        var whave;
        /* valid bytes in the window */

        var wnext;
        /* window write index */

        var window;
        /* allocated sliding window, if wsize != 0 */

        var hold;
        /* local strm.hold */

        var bits;
        /* local strm.bits */

        var lcode;
        /* local strm.lencode */

        var dcode;
        /* local strm.distcode */

        var lmask;
        /* mask for first level of length codes */

        var dmask;
        /* mask for first level of distance codes */

        var here;
        /* retrieved table entry */

        var op;
        /* code bits, operation, extra bits, or */

        /*  window position, window bytes to copy */

        var len;
        /* match length, unused bytes */

        var dist;
        /* match distance */

        var from;
        /* where to copy match from */

        var from_source;
        var input, output; // JS specific, because we have no pointers

        /* copy state to local variables */

        state = strm.state; //here = state.here;

        _in = strm.next_in;
        input = strm.input;
        last = _in + (strm.avail_in - 5);
        _out = strm.next_out;
        output = strm.output;
        beg = _out - (start - strm.avail_out);
        end = _out + (strm.avail_out - 257); //#ifdef INFLATE_STRICT

        dmax = state.dmax; //#endif

        wsize = state.wsize;
        whave = state.whave;
        wnext = state.wnext;
        window = state.window;
        hold = state.hold;
        bits = state.bits;
        lcode = state.lencode;
        dcode = state.distcode;
        lmask = (1 << state.lenbits) - 1;
        dmask = (1 << state.distbits) - 1;
        /* decode literals and length/distances until end-of-block or not enough
           input data or output space */

        top: do {
          if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
          }

          here = lcode[hold & lmask];

          dolen: for (;;) {
            // Goto emulation
            op = here >>> 24
            /*here.bits*/
            ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff
            /*here.op*/
            ;

            if (op === 0) {
              /* literal */
              //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
              //        "inflate:         literal '%c'\n" :
              //        "inflate:         literal 0x%02x\n", here.val));
              output[_out++] = here & 0xffff
              /*here.val*/
              ;
            } else if (op & 16) {
              /* length base */
              len = here & 0xffff
              /*here.val*/
              ;
              op &= 15;
              /* number of extra bits */

              if (op) {
                if (bits < op) {
                  hold += input[_in++] << bits;
                  bits += 8;
                }

                len += hold & (1 << op) - 1;
                hold >>>= op;
                bits -= op;
              } //Tracevv((stderr, "inflate:         length %u\n", len));


              if (bits < 15) {
                hold += input[_in++] << bits;
                bits += 8;
                hold += input[_in++] << bits;
                bits += 8;
              }

              here = dcode[hold & dmask];

              dodist: for (;;) {
                // goto emulation
                op = here >>> 24
                /*here.bits*/
                ;
                hold >>>= op;
                bits -= op;
                op = here >>> 16 & 0xff
                /*here.op*/
                ;

                if (op & 16) {
                  /* distance base */
                  dist = here & 0xffff
                  /*here.val*/
                  ;
                  op &= 15;
                  /* number of extra bits */

                  if (bits < op) {
                    hold += input[_in++] << bits;
                    bits += 8;

                    if (bits < op) {
                      hold += input[_in++] << bits;
                      bits += 8;
                    }
                  }

                  dist += hold & (1 << op) - 1; //#ifdef INFLATE_STRICT

                  if (dist > dmax) {
                    strm.msg = 'invalid distance too far back';
                    state.mode = BAD;
                    break top;
                  } //#endif


                  hold >>>= op;
                  bits -= op; //Tracevv((stderr, "inflate:         distance %u\n", dist));

                  op = _out - beg;
                  /* max distance in output */

                  if (dist > op) {
                    /* see if copy from window */
                    op = dist - op;
                    /* distance back in window */

                    if (op > whave) {
                      if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = BAD;
                        break top;
                      } // (!) This block is disabled in zlib defailts,
                      // don't enable it for binary compatibility
                      //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                      //                if (len <= op - whave) {
                      //                  do {
                      //                    output[_out++] = 0;
                      //                  } while (--len);
                      //                  continue top;
                      //                }
                      //                len -= op - whave;
                      //                do {
                      //                  output[_out++] = 0;
                      //                } while (--op > whave);
                      //                if (op === 0) {
                      //                  from = _out - dist;
                      //                  do {
                      //                    output[_out++] = output[from++];
                      //                  } while (--len);
                      //                  continue top;
                      //                }
                      //#endif

                    }

                    from = 0; // window index

                    from_source = window;

                    if (wnext === 0) {
                      /* very common case */
                      from += wsize - op;

                      if (op < len) {
                        /* some from window */
                        len -= op;

                        do {
                          output[_out++] = window[from++];
                        } while (--op);

                        from = _out - dist;
                        /* rest from output */

                        from_source = output;
                      }
                    } else if (wnext < op) {
                      /* wrap around window */
                      from += wsize + wnext - op;
                      op -= wnext;

                      if (op < len) {
                        /* some from end of window */
                        len -= op;

                        do {
                          output[_out++] = window[from++];
                        } while (--op);

                        from = 0;

                        if (wnext < len) {
                          /* some from start of window */
                          op = wnext;
                          len -= op;

                          do {
                            output[_out++] = window[from++];
                          } while (--op);

                          from = _out - dist;
                          /* rest from output */

                          from_source = output;
                        }
                      }
                    } else {
                      /* contiguous in window */
                      from += wnext - op;

                      if (op < len) {
                        /* some from window */
                        len -= op;

                        do {
                          output[_out++] = window[from++];
                        } while (--op);

                        from = _out - dist;
                        /* rest from output */

                        from_source = output;
                      }
                    }

                    while (len > 2) {
                      output[_out++] = from_source[from++];
                      output[_out++] = from_source[from++];
                      output[_out++] = from_source[from++];
                      len -= 3;
                    }

                    if (len) {
                      output[_out++] = from_source[from++];

                      if (len > 1) {
                        output[_out++] = from_source[from++];
                      }
                    }
                  } else {
                    from = _out - dist;
                    /* copy direct from output */

                    do {
                      /* minimum length is three */
                      output[_out++] = output[from++];
                      output[_out++] = output[from++];
                      output[_out++] = output[from++];
                      len -= 3;
                    } while (len > 2);

                    if (len) {
                      output[_out++] = output[from++];

                      if (len > 1) {
                        output[_out++] = output[from++];
                      }
                    }
                  }
                } else if ((op & 64) === 0) {
                  /* 2nd level distance code */
                  here = dcode[(here & 0xffff
                  /*here.val*/
                  ) + (hold & (1 << op) - 1)];
                  continue dodist;
                } else {
                  strm.msg = 'invalid distance code';
                  state.mode = BAD;
                  break top;
                }

                break; // need to emulate goto via "continue"
              }
            } else if ((op & 64) === 0) {
              /* 2nd level length code */
              here = lcode[(here & 0xffff
              /*here.val*/
              ) + (hold & (1 << op) - 1)];
              continue dolen;
            } else if (op & 32) {
              /* end-of-block */
              //Tracevv((stderr, "inflate:         end of block\n"));
              state.mode = TYPE;
              break top;
            } else {
              strm.msg = 'invalid literal/length code';
              state.mode = BAD;
              break top;
            }

            break; // need to emulate goto via "continue"
          }
        } while (_in < last && _out < end);
        /* return unused bytes (on entry, bits < 8, so in won't go too far back) */


        len = bits >> 3;
        _in -= len;
        bits -= len << 3;
        hold &= (1 << bits) - 1;
        /* update state and return */

        strm.next_in = _in;
        strm.next_out = _out;
        strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
        strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
        state.hold = hold;
        state.bits = bits;
        return;
      };
    }, {}],
    35: [function (_dereq_, module, exports) {

      var utils = _dereq_('../utils/common');

      var adler32 = _dereq_('./adler32');

      var crc32 = _dereq_('./crc32');

      var inflate_fast = _dereq_('./inffast');

      var inflate_table = _dereq_('./inftrees');

      var CODES = 0;
      var LENS = 1;
      var DISTS = 2;
      /* Public constants ==========================================================*/

      /* ===========================================================================*/

      /* Allowed flush values; see deflate() and inflate() below for details */
      //var Z_NO_FLUSH      = 0;
      //var Z_PARTIAL_FLUSH = 1;
      //var Z_SYNC_FLUSH    = 2;
      //var Z_FULL_FLUSH    = 3;

      var Z_FINISH = 4;
      var Z_BLOCK = 5;
      var Z_TREES = 6;
      /* Return codes for the compression/decompression functions. Negative values
       * are errors, positive values are used for special but normal events.
       */

      var Z_OK = 0;
      var Z_STREAM_END = 1;
      var Z_NEED_DICT = 2; //var Z_ERRNO         = -1;

      var Z_STREAM_ERROR = -2;
      var Z_DATA_ERROR = -3;
      var Z_MEM_ERROR = -4;
      var Z_BUF_ERROR = -5; //var Z_VERSION_ERROR = -6;

      /* The deflate compression method */

      var Z_DEFLATED = 8;
      /* STATES ====================================================================*/

      /* ===========================================================================*/

      var HEAD = 1;
      /* i: waiting for magic header */

      var FLAGS = 2;
      /* i: waiting for method and flags (gzip) */

      var TIME = 3;
      /* i: waiting for modification time (gzip) */

      var OS = 4;
      /* i: waiting for extra flags and operating system (gzip) */

      var EXLEN = 5;
      /* i: waiting for extra length (gzip) */

      var EXTRA = 6;
      /* i: waiting for extra bytes (gzip) */

      var NAME = 7;
      /* i: waiting for end of file name (gzip) */

      var COMMENT = 8;
      /* i: waiting for end of comment (gzip) */

      var HCRC = 9;
      /* i: waiting for header crc (gzip) */

      var DICTID = 10;
      /* i: waiting for dictionary check value */

      var DICT = 11;
      /* waiting for inflateSetDictionary() call */

      var TYPE = 12;
      /* i: waiting for type bits, including last-flag bit */

      var TYPEDO = 13;
      /* i: same, but skip check to exit inflate on new block */

      var STORED = 14;
      /* i: waiting for stored size (length and complement) */

      var COPY_ = 15;
      /* i/o: same as COPY below, but only first time in */

      var COPY = 16;
      /* i/o: waiting for input or output to copy stored block */

      var TABLE = 17;
      /* i: waiting for dynamic block table lengths */

      var LENLENS = 18;
      /* i: waiting for code length code lengths */

      var CODELENS = 19;
      /* i: waiting for length/lit and distance code lengths */

      var LEN_ = 20;
      /* i: same as LEN below, but only first time in */

      var LEN = 21;
      /* i: waiting for length/lit/eob code */

      var LENEXT = 22;
      /* i: waiting for length extra bits */

      var DIST = 23;
      /* i: waiting for distance code */

      var DISTEXT = 24;
      /* i: waiting for distance extra bits */

      var MATCH = 25;
      /* o: waiting for output space to copy string */

      var LIT = 26;
      /* o: waiting for output space to write literal */

      var CHECK = 27;
      /* i: waiting for 32-bit check value */

      var LENGTH = 28;
      /* i: waiting for 32-bit length (gzip) */

      var DONE = 29;
      /* finished check, done -- remain here until reset */

      var BAD = 30;
      /* got a data error -- remain here until reset */

      var MEM = 31;
      /* got an inflate() memory error -- remain here until reset */

      var SYNC = 32;
      /* looking for synchronization bytes to restart inflate() */

      /* ===========================================================================*/

      var ENOUGH_LENS = 852;
      var ENOUGH_DISTS = 592; //var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

      var MAX_WBITS = 15;
      /* 32K LZ77 window */

      var DEF_WBITS = MAX_WBITS;

      function ZSWAP32(q) {
        return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
      }

      function InflateState() {
        this.mode = 0;
        /* current inflate mode */

        this.last = false;
        /* true if processing last block */

        this.wrap = 0;
        /* bit 0 true for zlib, bit 1 true for gzip */

        this.havedict = false;
        /* true if dictionary provided */

        this.flags = 0;
        /* gzip header method and flags (0 if zlib) */

        this.dmax = 0;
        /* zlib header max distance (INFLATE_STRICT) */

        this.check = 0;
        /* protected copy of check value */

        this.total = 0;
        /* protected copy of output count */
        // TODO: may be {}

        this.head = null;
        /* where to save gzip header information */

        /* sliding window */

        this.wbits = 0;
        /* log base 2 of requested window size */

        this.wsize = 0;
        /* window size or zero if not using window */

        this.whave = 0;
        /* valid bytes in the window */

        this.wnext = 0;
        /* window write index */

        this.window = null;
        /* allocated sliding window, if needed */

        /* bit accumulator */

        this.hold = 0;
        /* input bit accumulator */

        this.bits = 0;
        /* number of bits in "in" */

        /* for string and stored block copying */

        this.length = 0;
        /* literal or length of data to copy */

        this.offset = 0;
        /* distance back to copy string from */

        /* for table and code decoding */

        this.extra = 0;
        /* extra bits needed */

        /* fixed and dynamic code tables */

        this.lencode = null;
        /* starting table for length/literal codes */

        this.distcode = null;
        /* starting table for distance codes */

        this.lenbits = 0;
        /* index bits for lencode */

        this.distbits = 0;
        /* index bits for distcode */

        /* dynamic table building */

        this.ncode = 0;
        /* number of code length code lengths */

        this.nlen = 0;
        /* number of length code lengths */

        this.ndist = 0;
        /* number of distance code lengths */

        this.have = 0;
        /* number of code lengths in lens[] */

        this.next = null;
        /* next available space in codes[] */

        this.lens = new utils.Buf16(320);
        /* temporary storage for code lengths */

        this.work = new utils.Buf16(288);
        /* work area for code table building */

        /*
         because we don't have pointers in js, we use lencode and distcode directly
         as buffers so we don't need codes
        */
        //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */

        this.lendyn = null;
        /* dynamic table for length/literal codes (JS specific) */

        this.distdyn = null;
        /* dynamic table for distance codes (JS specific) */

        this.sane = 0;
        /* if false, allow invalid distance too far */

        this.back = 0;
        /* bits back of last unprocessed length/lit */

        this.was = 0;
        /* initial length of match */
      }

      function inflateResetKeep(strm) {
        var state;

        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }

        state = strm.state;
        strm.total_in = strm.total_out = state.total = 0;
        strm.msg = '';
        /*Z_NULL*/

        if (state.wrap) {
          /* to support ill-conceived Java test suite */
          strm.adler = state.wrap & 1;
        }

        state.mode = HEAD;
        state.last = 0;
        state.havedict = 0;
        state.dmax = 32768;
        state.head = null
        /*Z_NULL*/
        ;
        state.hold = 0;
        state.bits = 0; //state.lencode = state.distcode = state.next = state.codes;

        state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
        state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
        state.sane = 1;
        state.back = -1; //Tracev((stderr, "inflate: reset\n"));

        return Z_OK;
      }

      function inflateReset(strm) {
        var state;

        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }

        state = strm.state;
        state.wsize = 0;
        state.whave = 0;
        state.wnext = 0;
        return inflateResetKeep(strm);
      }

      function inflateReset2(strm, windowBits) {
        var wrap;
        var state;
        /* get the state */

        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }

        state = strm.state;
        /* extract wrap request from windowBits parameter */

        if (windowBits < 0) {
          wrap = 0;
          windowBits = -windowBits;
        } else {
          wrap = (windowBits >> 4) + 1;

          if (windowBits < 48) {
            windowBits &= 15;
          }
        }
        /* set number of window bits, free window if different */


        if (windowBits && (windowBits < 8 || windowBits > 15)) {
          return Z_STREAM_ERROR;
        }

        if (state.window !== null && state.wbits !== windowBits) {
          state.window = null;
        }
        /* update state and reset the rest of it */


        state.wrap = wrap;
        state.wbits = windowBits;
        return inflateReset(strm);
      }

      function inflateInit2(strm, windowBits) {
        var ret;
        var state;

        if (!strm) {
          return Z_STREAM_ERROR;
        } //strm.msg = Z_NULL;                 /* in case we return an error */


        state = new InflateState(); //if (state === Z_NULL) return Z_MEM_ERROR;
        //Tracev((stderr, "inflate: allocated\n"));

        strm.state = state;
        state.window = null
        /*Z_NULL*/
        ;
        ret = inflateReset2(strm, windowBits);

        if (ret !== Z_OK) {
          strm.state = null
          /*Z_NULL*/
          ;
        }

        return ret;
      }

      function inflateInit(strm) {
        return inflateInit2(strm, DEF_WBITS);
      }
      /*
       Return state with length and distance decoding tables and index sizes set to
       fixed code decoding.  Normally this returns fixed tables from inffixed.h.
       If BUILDFIXED is defined, then instead this routine builds the tables the
       first time it's called, and returns those tables the first time and
       thereafter.  This reduces the size of the code by about 2K bytes, in
       exchange for a little execution time.  However, BUILDFIXED should not be
       used for threaded applications, since the rewriting of the tables and virgin
       may not be thread-safe.
       */


      var virgin = true;
      var lenfix, distfix; // We have no pointers in JS, so keep tables separate

      function fixedtables(state) {
        /* build fixed huffman tables if first call (may not be thread safe) */
        if (virgin) {
          var sym;
          lenfix = new utils.Buf32(512);
          distfix = new utils.Buf32(32);
          /* literal/length table */

          sym = 0;

          while (sym < 144) {
            state.lens[sym++] = 8;
          }

          while (sym < 256) {
            state.lens[sym++] = 9;
          }

          while (sym < 280) {
            state.lens[sym++] = 7;
          }

          while (sym < 288) {
            state.lens[sym++] = 8;
          }

          inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
          });
          /* distance table */

          sym = 0;

          while (sym < 32) {
            state.lens[sym++] = 5;
          }

          inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
          });
          /* do this just once */

          virgin = false;
        }

        state.lencode = lenfix;
        state.lenbits = 9;
        state.distcode = distfix;
        state.distbits = 5;
      }
      /*
       Update the window with the last wsize (normally 32K) bytes written before
       returning.  If window does not exist yet, create it.  This is only called
       when a window is already in use, or when output has been written during this
       inflate call, but the end of the deflate stream has not been reached yet.
       It is also called to create a window for dictionary data when a dictionary
       is loaded.
      
       Providing output buffers larger than 32K to inflate() should provide a speed
       advantage, since only the last 32K of output is copied to the sliding window
       upon return from inflate(), and since all distances after the first 32K of
       output will fall in the output data, making match copies simpler and faster.
       The advantage may be dependent on the size of the processor's data caches.
       */


      function updatewindow(strm, src, end, copy) {
        var dist;
        var state = strm.state;
        /* if it hasn't been done already, allocate space for the window */

        if (state.window === null) {
          state.wsize = 1 << state.wbits;
          state.wnext = 0;
          state.whave = 0;
          state.window = new utils.Buf8(state.wsize);
        }
        /* copy state->wsize or less output bytes into the circular window */


        if (copy >= state.wsize) {
          utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
          state.wnext = 0;
          state.whave = state.wsize;
        } else {
          dist = state.wsize - state.wnext;

          if (dist > copy) {
            dist = copy;
          } //zmemcpy(state->window + state->wnext, end - copy, dist);


          utils.arraySet(state.window, src, end - copy, dist, state.wnext);
          copy -= dist;

          if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            utils.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
          } else {
            state.wnext += dist;

            if (state.wnext === state.wsize) {
              state.wnext = 0;
            }

            if (state.whave < state.wsize) {
              state.whave += dist;
            }
          }
        }

        return 0;
      }

      function inflate(strm, flush) {
        var state;
        var input, output; // input/output buffers

        var next;
        /* next input INDEX */

        var put;
        /* next output INDEX */

        var have, left;
        /* available input and output */

        var hold;
        /* bit buffer */

        var bits;
        /* bits in bit buffer */

        var _in, _out;
        /* save starting available input and output */


        var copy;
        /* number of stored or match bytes to copy */

        var from;
        /* where to copy match bytes from */

        var from_source;
        var here = 0;
        /* current decoding table entry */

        var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
        //var last;                   /* parent table entry */

        var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)

        var len;
        /* length to copy for repeats, bits to drop */

        var ret;
        /* return code */

        var hbuf = new utils.Buf8(4);
        /* buffer for gzip header crc calculation */

        var opts;
        var n; // temporary var for NEED_BITS

        var order =
        /* permutation of code lengths */
        [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

        if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) {
          return Z_STREAM_ERROR;
        }

        state = strm.state;

        if (state.mode === TYPE) {
          state.mode = TYPEDO;
        }
        /* skip check */
        //--- LOAD() ---


        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits; //---

        _in = have;
        _out = left;
        ret = Z_OK;

        inf_leave: // goto emulation
        for (;;) {
          switch (state.mode) {
            case HEAD:
              if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
              } //=== NEEDBITS(16);


              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }

                have--;
                hold += input[next++] << bits;
                bits += 8;
              } //===//


              if (state.wrap & 2 && hold === 0x8b1f) {
                /* gzip header */
                state.check = 0
                /*crc32(0L, Z_NULL, 0)*/
                ; //=== CRC2(state.check, hold);

                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0); //===//
                //=== INITBITS();

                hold = 0;
                bits = 0; //===//

                state.mode = FLAGS;
                break;
              }

              state.flags = 0;
              /* expect zlib header */

              if (state.head) {
                state.head.done = false;
              }

              if (!(state.wrap & 1) ||
              /* check if zlib header allowed */
              (((hold & 0xff
              /*BITS(8)*/
              ) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = BAD;
                break;
              }

              if ((hold & 0x0f
              /*BITS(4)*/
              ) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
              } //--- DROPBITS(4) ---//


              hold >>>= 4;
              bits -= 4; //---//

              len = (hold & 0x0f
              /*BITS(4)*/
              ) + 8;

              if (state.wbits === 0) {
                state.wbits = len;
              } else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = BAD;
                break;
              }

              state.dmax = 1 << len; //Tracev((stderr, "inflate:   zlib header ok\n"));

              strm.adler = state.check = 1
              /*adler32(0L, Z_NULL, 0)*/
              ;
              state.mode = hold & 0x200 ? DICTID : TYPE; //=== INITBITS();

              hold = 0;
              bits = 0; //===//

              break;

            case FLAGS:
              //=== NEEDBITS(16); */
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }

                have--;
                hold += input[next++] << bits;
                bits += 8;
              } //===//


              state.flags = hold;

              if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
              }

              if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = BAD;
                break;
              }

              if (state.head) {
                state.head.text = hold >> 8 & 1;
              }

              if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0); //===//
              } //=== INITBITS();


              hold = 0;
              bits = 0; //===//

              state.mode = TIME;

            /* falls through */

            case TIME:
              //=== NEEDBITS(32); */
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }

                have--;
                hold += input[next++] << bits;
                bits += 8;
              } //===//


              if (state.head) {
                state.head.time = hold;
              }

              if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32(state.check, hbuf, 4, 0); //===
              } //=== INITBITS();


              hold = 0;
              bits = 0; //===//

              state.mode = OS;

            /* falls through */

            case OS:
              //=== NEEDBITS(16); */
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }

                have--;
                hold += input[next++] << bits;
                bits += 8;
              } //===//


              if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
              }

              if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0); //===//
              } //=== INITBITS();


              hold = 0;
              bits = 0; //===//

              state.mode = EXLEN;

            /* falls through */

            case EXLEN:
              if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while (bits < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                } //===//


                state.length = hold;

                if (state.head) {
                  state.head.extra_len = hold;
                }

                if (state.flags & 0x0200) {
                  //=== CRC2(state.check, hold);
                  hbuf[0] = hold & 0xff;
                  hbuf[1] = hold >>> 8 & 0xff;
                  state.check = crc32(state.check, hbuf, 2, 0); //===//
                } //=== INITBITS();


                hold = 0;
                bits = 0; //===//
              } else if (state.head) {
                state.head.extra = null
                /*Z_NULL*/
                ;
              }

              state.mode = EXTRA;

            /* falls through */

            case EXTRA:
              if (state.flags & 0x0400) {
                copy = state.length;

                if (copy > have) {
                  copy = have;
                }

                if (copy) {
                  if (state.head) {
                    len = state.head.extra_len - state.length;

                    if (!state.head.extra) {
                      // Use untyped array for more conveniend processing later
                      state.head.extra = new Array(state.head.extra_len);
                    }

                    utils.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                    // - no need for additional size check
                    copy,
                    /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                    len); //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                  }

                  if (state.flags & 0x0200) {
                    state.check = crc32(state.check, input, copy, next);
                  }

                  have -= copy;
                  next += copy;
                  state.length -= copy;
                }

                if (state.length) {
                  break inf_leave;
                }
              }

              state.length = 0;
              state.mode = NAME;

            /* falls through */

            case NAME:
              if (state.flags & 0x0800) {
                if (have === 0) {
                  break inf_leave;
                }

                copy = 0;

                do {
                  // TODO: 2 or 1 bytes?
                  len = input[next + copy++];
                  /* use constant limit because in js we should not preallocate memory */

                  if (state.head && len && state.length < 65536
                  /*state.head.name_max*/
                  ) {
                    state.head.name += String.fromCharCode(len);
                  }
                } while (len && copy < have);

                if (state.flags & 0x0200) {
                  state.check = crc32(state.check, input, copy, next);
                }

                have -= copy;
                next += copy;

                if (len) {
                  break inf_leave;
                }
              } else if (state.head) {
                state.head.name = null;
              }

              state.length = 0;
              state.mode = COMMENT;

            /* falls through */

            case COMMENT:
              if (state.flags & 0x1000) {
                if (have === 0) {
                  break inf_leave;
                }

                copy = 0;

                do {
                  len = input[next + copy++];
                  /* use constant limit because in js we should not preallocate memory */

                  if (state.head && len && state.length < 65536
                  /*state.head.comm_max*/
                  ) {
                    state.head.comment += String.fromCharCode(len);
                  }
                } while (len && copy < have);

                if (state.flags & 0x0200) {
                  state.check = crc32(state.check, input, copy, next);
                }

                have -= copy;
                next += copy;

                if (len) {
                  break inf_leave;
                }
              } else if (state.head) {
                state.head.comment = null;
              }

              state.mode = HCRC;

            /* falls through */

            case HCRC:
              if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while (bits < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                } //===//


                if (hold !== (state.check & 0xffff)) {
                  strm.msg = 'header crc mismatch';
                  state.mode = BAD;
                  break;
                } //=== INITBITS();


                hold = 0;
                bits = 0; //===//
              }

              if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
              }

              strm.adler = state.check = 0
              /*crc32(0L, Z_NULL, 0)*/
              ;
              state.mode = TYPE;
              break;

            case DICTID:
              //=== NEEDBITS(32); */
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }

                have--;
                hold += input[next++] << bits;
                bits += 8;
              } //===//


              strm.adler = state.check = ZSWAP32(hold); //=== INITBITS();

              hold = 0;
              bits = 0; //===//

              state.mode = DICT;

            /* falls through */

            case DICT:
              if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits; //---

                return Z_NEED_DICT;
              }

              strm.adler = state.check = 1
              /*adler32(0L, Z_NULL, 0)*/
              ;
              state.mode = TYPE;

            /* falls through */

            case TYPE:
              if (flush === Z_BLOCK || flush === Z_TREES) {
                break inf_leave;
              }

            /* falls through */

            case TYPEDO:
              if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7; //---//

                state.mode = CHECK;
                break;
              } //=== NEEDBITS(3); */


              while (bits < 3) {
                if (have === 0) {
                  break inf_leave;
                }

                have--;
                hold += input[next++] << bits;
                bits += 8;
              } //===//


              state.last = hold & 0x01
              /*BITS(1)*/
              ; //--- DROPBITS(1) ---//

              hold >>>= 1;
              bits -= 1; //---//

              switch (hold & 0x03
              /*BITS(2)*/
              ) {
                case 0:
                  /* stored block */
                  //Tracev((stderr, "inflate:     stored block%s\n",
                  //        state.last ? " (last)" : ""));
                  state.mode = STORED;
                  break;

                case 1:
                  /* fixed block */
                  fixedtables(state); //Tracev((stderr, "inflate:     fixed codes block%s\n",
                  //        state.last ? " (last)" : ""));

                  state.mode = LEN_;
                  /* decode codes */

                  if (flush === Z_TREES) {
                    //--- DROPBITS(2) ---//
                    hold >>>= 2;
                    bits -= 2; //---//

                    break inf_leave;
                  }

                  break;

                case 2:
                  /* dynamic block */
                  //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                  //        state.last ? " (last)" : ""));
                  state.mode = TABLE;
                  break;

                case 3:
                  strm.msg = 'invalid block type';
                  state.mode = BAD;
              } //--- DROPBITS(2) ---//


              hold >>>= 2;
              bits -= 2; //---//

              break;

            case STORED:
              //--- BYTEBITS() ---// /* go to byte boundary */
              hold >>>= bits & 7;
              bits -= bits & 7; //---//
              //=== NEEDBITS(32); */

              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }

                have--;
                hold += input[next++] << bits;
                bits += 8;
              } //===//


              if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = BAD;
                break;
              }

              state.length = hold & 0xffff; //Tracev((stderr, "inflate:       stored length %u\n",
              //        state.length));
              //=== INITBITS();

              hold = 0;
              bits = 0; //===//

              state.mode = COPY_;

              if (flush === Z_TREES) {
                break inf_leave;
              }

            /* falls through */

            case COPY_:
              state.mode = COPY;

            /* falls through */

            case COPY:
              copy = state.length;

              if (copy) {
                if (copy > have) {
                  copy = have;
                }

                if (copy > left) {
                  copy = left;
                }

                if (copy === 0) {
                  break inf_leave;
                } //--- zmemcpy(put, next, copy); ---


                utils.arraySet(output, input, next, copy, put); //---//

                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
              } //Tracev((stderr, "inflate:       stored end\n"));


              state.mode = TYPE;
              break;

            case TABLE:
              //=== NEEDBITS(14); */
              while (bits < 14) {
                if (have === 0) {
                  break inf_leave;
                }

                have--;
                hold += input[next++] << bits;
                bits += 8;
              } //===//


              state.nlen = (hold & 0x1f
              /*BITS(5)*/
              ) + 257; //--- DROPBITS(5) ---//

              hold >>>= 5;
              bits -= 5; //---//

              state.ndist = (hold & 0x1f
              /*BITS(5)*/
              ) + 1; //--- DROPBITS(5) ---//

              hold >>>= 5;
              bits -= 5; //---//

              state.ncode = (hold & 0x0f
              /*BITS(4)*/
              ) + 4; //--- DROPBITS(4) ---//

              hold >>>= 4;
              bits -= 4; //---//
              //#ifndef PKZIP_BUG_WORKAROUND

              if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = BAD;
                break;
              } //#endif
              //Tracev((stderr, "inflate:       table sizes ok\n"));


              state.have = 0;
              state.mode = LENLENS;

            /* falls through */

            case LENLENS:
              while (state.have < state.ncode) {
                //=== NEEDBITS(3);
                while (bits < 3) {
                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                } //===//


                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//

                hold >>>= 3;
                bits -= 3; //---//
              }

              while (state.have < 19) {
                state.lens[order[state.have++]] = 0;
              } // We have separate tables & no pointers. 2 commented lines below not needed.
              //state.next = state.codes;
              //state.lencode = state.next;
              // Switch to use dynamic table


              state.lencode = state.lendyn;
              state.lenbits = 7;
              opts = {
                bits: state.lenbits
              };
              ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
              state.lenbits = opts.bits;

              if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = BAD;
                break;
              } //Tracev((stderr, "inflate:       code lengths ok\n"));


              state.have = 0;
              state.mode = CODELENS;

            /* falls through */

            case CODELENS:
              while (state.have < state.nlen + state.ndist) {
                for (;;) {
                  here = state.lencode[hold & (1 << state.lenbits) - 1];
                  /*BITS(state.lenbits)*/

                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;

                  if (here_bits <= bits) {
                    break;
                  } //--- PULLBYTE() ---//


                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8; //---//
                }

                if (here_val < 16) {
                  //--- DROPBITS(here.bits) ---//
                  hold >>>= here_bits;
                  bits -= here_bits; //---//

                  state.lens[state.have++] = here_val;
                } else {
                  if (here_val === 16) {
                    //=== NEEDBITS(here.bits + 2);
                    n = here_bits + 2;

                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }

                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    } //===//
                    //--- DROPBITS(here.bits) ---//


                    hold >>>= here_bits;
                    bits -= here_bits; //---//

                    if (state.have === 0) {
                      strm.msg = 'invalid bit length repeat';
                      state.mode = BAD;
                      break;
                    }

                    len = state.lens[state.have - 1];
                    copy = 3 + (hold & 0x03); //BITS(2);
                    //--- DROPBITS(2) ---//

                    hold >>>= 2;
                    bits -= 2; //---//
                  } else if (here_val === 17) {
                    //=== NEEDBITS(here.bits + 3);
                    n = here_bits + 3;

                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }

                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    } //===//
                    //--- DROPBITS(here.bits) ---//


                    hold >>>= here_bits;
                    bits -= here_bits; //---//

                    len = 0;
                    copy = 3 + (hold & 0x07); //BITS(3);
                    //--- DROPBITS(3) ---//

                    hold >>>= 3;
                    bits -= 3; //---//
                  } else {
                    //=== NEEDBITS(here.bits + 7);
                    n = here_bits + 7;

                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }

                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    } //===//
                    //--- DROPBITS(here.bits) ---//


                    hold >>>= here_bits;
                    bits -= here_bits; //---//

                    len = 0;
                    copy = 11 + (hold & 0x7f); //BITS(7);
                    //--- DROPBITS(7) ---//

                    hold >>>= 7;
                    bits -= 7; //---//
                  }

                  if (state.have + copy > state.nlen + state.ndist) {
                    strm.msg = 'invalid bit length repeat';
                    state.mode = BAD;
                    break;
                  }

                  while (copy--) {
                    state.lens[state.have++] = len;
                  }
                }
              }
              /* handle error breaks in while */


              if (state.mode === BAD) {
                break;
              }
              /* check for end-of-block code (better have one) */


              if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = BAD;
                break;
              }
              /* build code tables -- note: do not change the lenbits or distbits
                 values here (9 and 6) without reading the comments in inftrees.h
                 concerning the ENOUGH constants, which depend on those values */


              state.lenbits = 9;
              opts = {
                bits: state.lenbits
              };
              ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts); // We have separate tables & no pointers. 2 commented lines below not needed.
              // state.next_index = opts.table_index;

              state.lenbits = opts.bits; // state.lencode = state.next;

              if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = BAD;
                break;
              }

              state.distbits = 6; //state.distcode.copy(state.codes);
              // Switch to use dynamic table

              state.distcode = state.distdyn;
              opts = {
                bits: state.distbits
              };
              ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts); // We have separate tables & no pointers. 2 commented lines below not needed.
              // state.next_index = opts.table_index;

              state.distbits = opts.bits; // state.distcode = state.next;

              if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = BAD;
                break;
              } //Tracev((stderr, 'inflate:       codes ok\n'));


              state.mode = LEN_;

              if (flush === Z_TREES) {
                break inf_leave;
              }

            /* falls through */

            case LEN_:
              state.mode = LEN;

            /* falls through */

            case LEN:
              if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits; //---

                inflate_fast(strm, _out); //--- LOAD() ---

                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits; //---

                if (state.mode === TYPE) {
                  state.back = -1;
                }

                break;
              }

              state.back = 0;

              for (;;) {
                here = state.lencode[hold & (1 << state.lenbits) - 1];
                /*BITS(state.lenbits)*/

                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;

                if (here_bits <= bits) {
                  break;
                } //--- PULLBYTE() ---//


                if (have === 0) {
                  break inf_leave;
                }

                have--;
                hold += input[next++] << bits;
                bits += 8; //---//
              }

              if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;

                for (;;) {
                  here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1
                  /*BITS(last.bits + last.op)*/
                  ) >> last_bits)];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;

                  if (last_bits + here_bits <= bits) {
                    break;
                  } //--- PULLBYTE() ---//


                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8; //---//
                } //--- DROPBITS(last.bits) ---//


                hold >>>= last_bits;
                bits -= last_bits; //---//

                state.back += last_bits;
              } //--- DROPBITS(here.bits) ---//


              hold >>>= here_bits;
              bits -= here_bits; //---//

              state.back += here_bits;
              state.length = here_val;

              if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
              }

              if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
              }

              if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = BAD;
                break;
              }

              state.extra = here_op & 15;
              state.mode = LENEXT;

            /* falls through */

            case LENEXT:
              if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;

                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                } //===//


                state.length += hold & (1 << state.extra) - 1
                /*BITS(state.extra)*/
                ; //--- DROPBITS(state.extra) ---//

                hold >>>= state.extra;
                bits -= state.extra; //---//

                state.back += state.extra;
              } //Tracevv((stderr, "inflate:         length %u\n", state.length));


              state.was = state.length;
              state.mode = DIST;

            /* falls through */

            case DIST:
              for (;;) {
                here = state.distcode[hold & (1 << state.distbits) - 1];
                /*BITS(state.distbits)*/

                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;

                if (here_bits <= bits) {
                  break;
                } //--- PULLBYTE() ---//


                if (have === 0) {
                  break inf_leave;
                }

                have--;
                hold += input[next++] << bits;
                bits += 8; //---//
              }

              if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;

                for (;;) {
                  here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1
                  /*BITS(last.bits + last.op)*/
                  ) >> last_bits)];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;

                  if (last_bits + here_bits <= bits) {
                    break;
                  } //--- PULLBYTE() ---//


                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8; //---//
                } //--- DROPBITS(last.bits) ---//


                hold >>>= last_bits;
                bits -= last_bits; //---//

                state.back += last_bits;
              } //--- DROPBITS(here.bits) ---//


              hold >>>= here_bits;
              bits -= here_bits; //---//

              state.back += here_bits;

              if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = BAD;
                break;
              }

              state.offset = here_val;
              state.extra = here_op & 15;
              state.mode = DISTEXT;

            /* falls through */

            case DISTEXT:
              if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;

                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                } //===//


                state.offset += hold & (1 << state.extra) - 1
                /*BITS(state.extra)*/
                ; //--- DROPBITS(state.extra) ---//

                hold >>>= state.extra;
                bits -= state.extra; //---//

                state.back += state.extra;
              } //#ifdef INFLATE_STRICT


              if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = BAD;
                break;
              } //#endif
              //Tracevv((stderr, "inflate:         distance %u\n", state.offset));


              state.mode = MATCH;

            /* falls through */

            case MATCH:
              if (left === 0) {
                break inf_leave;
              }

              copy = _out - left;

              if (state.offset > copy) {
                /* copy from window */
                copy = state.offset - copy;

                if (copy > state.whave) {
                  if (state.sane) {
                    strm.msg = 'invalid distance too far back';
                    state.mode = BAD;
                    break;
                  } // (!) This block is disabled in zlib defailts,
                  // don't enable it for binary compatibility
                  //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                  //          Trace((stderr, "inflate.c too far\n"));
                  //          copy -= state.whave;
                  //          if (copy > state.length) { copy = state.length; }
                  //          if (copy > left) { copy = left; }
                  //          left -= copy;
                  //          state.length -= copy;
                  //          do {
                  //            output[put++] = 0;
                  //          } while (--copy);
                  //          if (state.length === 0) { state.mode = LEN; }
                  //          break;
                  //#endif

                }

                if (copy > state.wnext) {
                  copy -= state.wnext;
                  from = state.wsize - copy;
                } else {
                  from = state.wnext - copy;
                }

                if (copy > state.length) {
                  copy = state.length;
                }

                from_source = state.window;
              } else {
                /* copy from output */
                from_source = output;
                from = put - state.offset;
                copy = state.length;
              }

              if (copy > left) {
                copy = left;
              }

              left -= copy;
              state.length -= copy;

              do {
                output[put++] = from_source[from++];
              } while (--copy);

              if (state.length === 0) {
                state.mode = LEN;
              }

              break;

            case LIT:
              if (left === 0) {
                break inf_leave;
              }

              output[put++] = state.length;
              left--;
              state.mode = LEN;
              break;

            case CHECK:
              if (state.wrap) {
                //=== NEEDBITS(32);
                while (bits < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }

                  have--; // Use '|' insdead of '+' to make sure that result is signed

                  hold |= input[next++] << bits;
                  bits += 8;
                } //===//


                _out -= left;
                strm.total_out += _out;
                state.total += _out;

                if (_out) {
                  strm.adler = state.check =
                  /*UPDATE(state.check, put - _out, _out);*/
                  state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                }

                _out = left; // NB: crc32 stored as signed 32-bit int, ZSWAP32 returns signed too

                if ((state.flags ? hold : ZSWAP32(hold)) !== state.check) {
                  strm.msg = 'incorrect data check';
                  state.mode = BAD;
                  break;
                } //=== INITBITS();


                hold = 0;
                bits = 0; //===//
                //Tracev((stderr, "inflate:   check matches trailer\n"));
              }

              state.mode = LENGTH;

            /* falls through */

            case LENGTH:
              if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while (bits < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }

                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                } //===//


                if (hold !== (state.total & 0xffffffff)) {
                  strm.msg = 'incorrect length check';
                  state.mode = BAD;
                  break;
                } //=== INITBITS();


                hold = 0;
                bits = 0; //===//
                //Tracev((stderr, "inflate:   length matches trailer\n"));
              }

              state.mode = DONE;

            /* falls through */

            case DONE:
              ret = Z_STREAM_END;
              break inf_leave;

            case BAD:
              ret = Z_DATA_ERROR;
              break inf_leave;

            case MEM:
              return Z_MEM_ERROR;

            case SYNC:
            /* falls through */

            default:
              return Z_STREAM_ERROR;
          }
        } // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

        /*
           Return from inflate(), updating the total counts and the check value.
           If there was no progress during the inflate() call, return a buffer
           error.  Call updatewindow() to create and/or update the window state.
           Note: a memory error from inflate() is non-recoverable.
         */
        //--- RESTORE() ---


        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits; //---

        if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
          if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) ;
        }

        _in -= strm.avail_in;
        _out -= strm.avail_out;
        strm.total_in += _in;
        strm.total_out += _out;
        state.total += _out;

        if (state.wrap && _out) {
          strm.adler = state.check =
          /*UPDATE(state.check, strm.next_out - _out, _out);*/
          state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
        }

        strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);

        if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) {
          ret = Z_BUF_ERROR;
        }

        return ret;
      }

      function inflateEnd(strm) {
        if (!strm || !strm.state
        /*|| strm->zfree == (free_func)0*/
        ) {
          return Z_STREAM_ERROR;
        }

        var state = strm.state;

        if (state.window) {
          state.window = null;
        }

        strm.state = null;
        return Z_OK;
      }

      function inflateGetHeader(strm, head) {
        var state;
        /* check state */

        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }

        state = strm.state;

        if ((state.wrap & 2) === 0) {
          return Z_STREAM_ERROR;
        }
        /* save header structure */


        state.head = head;
        head.done = false;
        return Z_OK;
      }

      exports.inflateReset = inflateReset;
      exports.inflateReset2 = inflateReset2;
      exports.inflateResetKeep = inflateResetKeep;
      exports.inflateInit = inflateInit;
      exports.inflateInit2 = inflateInit2;
      exports.inflate = inflate;
      exports.inflateEnd = inflateEnd;
      exports.inflateGetHeader = inflateGetHeader;
      exports.inflateInfo = 'pako inflate (from Nodeca project)';
      /* Not implemented
      exports.inflateCopy = inflateCopy;
      exports.inflateGetDictionary = inflateGetDictionary;
      exports.inflateMark = inflateMark;
      exports.inflatePrime = inflatePrime;
      exports.inflateSetDictionary = inflateSetDictionary;
      exports.inflateSync = inflateSync;
      exports.inflateSyncPoint = inflateSyncPoint;
      exports.inflateUndermine = inflateUndermine;
      */
    }, {
      "../utils/common": 27,
      "./adler32": 29,
      "./crc32": 31,
      "./inffast": 34,
      "./inftrees": 36
    }],
    36: [function (_dereq_, module, exports) {

      var utils = _dereq_('../utils/common');

      var MAXBITS = 15;
      var ENOUGH_LENS = 852;
      var ENOUGH_DISTS = 592; //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

      var CODES = 0;
      var LENS = 1;
      var DISTS = 2;
      var lbase = [
      /* Length codes 257..285 base */
      3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0];
      var lext = [
      /* Length codes 257..285 extra */
      16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78];
      var dbase = [
      /* Distance codes 0..29 base */
      1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0];
      var dext = [
      /* Distance codes 0..29 extra */
      16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];

      module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
        var bits = opts.bits; //here = opts.here; /* table entry for duplication */

        var len = 0;
        /* a code's length in bits */

        var sym = 0;
        /* index of code symbols */

        var min = 0,
            max = 0;
        /* minimum and maximum code lengths */

        var root = 0;
        /* number of index bits for root table */

        var curr = 0;
        /* number of index bits for current table */

        var drop = 0;
        /* code bits to drop for sub-table */

        var left = 0;
        /* number of prefix codes available */

        var used = 0;
        /* code entries in table used */

        var huff = 0;
        /* Huffman code */

        var incr;
        /* for incrementing code, index */

        var fill;
        /* index for replicating entries */

        var low;
        /* low bits for current root entry */

        var mask;
        /* mask for low root bits */

        var next;
        /* next available space in table */

        var base = null;
        /* base value table to use */

        var base_index = 0; //  var shoextra;    /* extra bits table to use */

        var end;
        /* use base and extra for symbol > end */

        var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */

        var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */

        var extra = null;
        var extra_index = 0;
        var here_bits, here_op, here_val;
        /*
         Process a set of code lengths to create a canonical Huffman code.  The
         code lengths are lens[0..codes-1].  Each length corresponds to the
         symbols 0..codes-1.  The Huffman code is generated by first sorting the
         symbols by length from short to long, and retaining the symbol order
         for codes with equal lengths.  Then the code starts with all zero bits
         for the first code of the shortest length, and the codes are integer
         increments for the same length, and zeros are appended as the length
         increases.  For the deflate format, these bits are stored backwards
         from their more natural integer increment ordering, and so when the
         decoding tables are built in the large loop below, the integer codes
         are incremented backwards.
          This routine assumes, but does not check, that all of the entries in
         lens[] are in the range 0..MAXBITS.  The caller must assure this.
         1..MAXBITS is interpreted as that code length.  zero means that that
         symbol does not occur in this code.
          The codes are sorted by computing a count of codes for each length,
         creating from that a table of starting indices for each length in the
         sorted table, and then entering the symbols in order in the sorted
         table.  The sorted table is work[], with that space being provided by
         the caller.
          The length counts are used for other purposes as well, i.e. finding
         the minimum and maximum length codes, determining if there are any
         codes at all, checking for a valid set of lengths, and looking ahead
         at length counts to determine sub-table sizes when building the
         decoding tables.
         */

        /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */

        for (len = 0; len <= MAXBITS; len++) {
          count[len] = 0;
        }

        for (sym = 0; sym < codes; sym++) {
          count[lens[lens_index + sym]]++;
        }
        /* bound code lengths, force root to be within code lengths */


        root = bits;

        for (max = MAXBITS; max >= 1; max--) {
          if (count[max] !== 0) {
            break;
          }
        }

        if (root > max) {
          root = max;
        }

        if (max === 0) {
          /* no symbols to code at all */
          //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
          //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
          //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
          table[table_index++] = 1 << 24 | 64 << 16 | 0; //table.op[opts.table_index] = 64;
          //table.bits[opts.table_index] = 1;
          //table.val[opts.table_index++] = 0;

          table[table_index++] = 1 << 24 | 64 << 16 | 0;
          opts.bits = 1;
          return 0;
          /* no symbols, but wait for decoding to report error */
        }

        for (min = 1; min < max; min++) {
          if (count[min] !== 0) {
            break;
          }
        }

        if (root < min) {
          root = min;
        }
        /* check for an over-subscribed or incomplete set of lengths */


        left = 1;

        for (len = 1; len <= MAXBITS; len++) {
          left <<= 1;
          left -= count[len];

          if (left < 0) {
            return -1;
          }
          /* over-subscribed */

        }

        if (left > 0 && (type === CODES || max !== 1)) {
          return -1;
          /* incomplete set */
        }
        /* generate offsets into symbol table for each length for sorting */


        offs[1] = 0;

        for (len = 1; len < MAXBITS; len++) {
          offs[len + 1] = offs[len] + count[len];
        }
        /* sort symbols by length, by symbol order within each length */


        for (sym = 0; sym < codes; sym++) {
          if (lens[lens_index + sym] !== 0) {
            work[offs[lens[lens_index + sym]]++] = sym;
          }
        }
        /*
         Create and fill in decoding tables.  In this loop, the table being
         filled is at next and has curr index bits.  The code being used is huff
         with length len.  That code is converted to an index by dropping drop
         bits off of the bottom.  For codes where len is less than drop + curr,
         those top drop + curr - len bits are incremented through all values to
         fill the table with replicated entries.
          root is the number of index bits for the root table.  When len exceeds
         root, sub-tables are created pointed to by the root entry with an index
         of the low root bits of huff.  This is saved in low to check for when a
         new sub-table should be started.  drop is zero when the root table is
         being filled, and drop is root when sub-tables are being filled.
          When a new sub-table is needed, it is necessary to look ahead in the
         code lengths to determine what size sub-table is needed.  The length
         counts are used for this, and so count[] is decremented as codes are
         entered in the tables.
          used keeps track of how many table entries have been allocated from the
         provided *table space.  It is checked for LENS and DIST tables against
         the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
         the initial root table size constants.  See the comments in inftrees.h
         for more information.
          sym increments through all symbols, and the loop terminates when
         all codes of length max, i.e. all codes, have been processed.  This
         routine permits incomplete codes, so another loop after this one fills
         in the rest of the decoding tables with invalid code markers.
         */

        /* set up for code type */
        // poor man optimization - use if-else instead of switch,
        // to avoid deopts in old v8


        if (type === CODES) {
          base = extra = work;
          /* dummy value--not used */

          end = 19;
        } else if (type === LENS) {
          base = lbase;
          base_index -= 257;
          extra = lext;
          extra_index -= 257;
          end = 256;
        } else {
          /* DISTS */
          base = dbase;
          extra = dext;
          end = -1;
        }
        /* initialize opts for loop */


        huff = 0;
        /* starting code */

        sym = 0;
        /* starting code symbol */

        len = min;
        /* starting code length */

        next = table_index;
        /* current table to fill in */

        curr = root;
        /* current table index bits */

        drop = 0;
        /* current bits to drop from code for index */

        low = -1;
        /* trigger new sub-table when len > root */

        used = 1 << root;
        /* use root table entries */

        mask = used - 1;
        /* mask for comparing low */

        /* check available table space */

        if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
          return 1;
        }
        /* process all codes and make table entries */

        for (;;) {
          /* create table entry */

          here_bits = len - drop;

          if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
          } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
          } else {
            here_op = 32 + 64;
            /* end of block */

            here_val = 0;
          }
          /* replicate for those indices with low len bits equal to huff */


          incr = 1 << len - drop;
          fill = 1 << curr;
          min = fill;
          /* save offset to next table */

          do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
          } while (fill !== 0);
          /* backwards increment the len-bit code huff */


          incr = 1 << len - 1;

          while (huff & incr) {
            incr >>= 1;
          }

          if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
          } else {
            huff = 0;
          }
          /* go to next symbol, update count, len */


          sym++;

          if (--count[len] === 0) {
            if (len === max) {
              break;
            }

            len = lens[lens_index + work[sym]];
          }
          /* create new sub-table if needed */


          if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */
            if (drop === 0) {
              drop = root;
            }
            /* increment past last table */


            next += min;
            /* here min is 1 << curr */

            /* determine length of next table */

            curr = len - drop;
            left = 1 << curr;

            while (curr + drop < max) {
              left -= count[curr + drop];

              if (left <= 0) {
                break;
              }

              curr++;
              left <<= 1;
            }
            /* check for enough space */


            used += 1 << curr;

            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
              return 1;
            }
            /* point entry in root table to sub-table */


            low = huff & mask;
            /*table.op[low] = curr;
            table.bits[low] = root;
            table.val[low] = next - opts.table_index;*/

            table[low] = root << 24 | curr << 16 | next - table_index | 0;
          }
        }
        /* fill in remaining table entry if code is incomplete (guaranteed to have
         at most one remaining entry, since if the code is incomplete, the
         maximum code length that was allowed to get this far is one bit) */


        if (huff !== 0) {
          //table.op[next + huff] = 64;            /* invalid code marker */
          //table.bits[next + huff] = len - drop;
          //table.val[next + huff] = 0;
          table[next + huff] = len - drop << 24 | 64 << 16 | 0;
        }
        /* set return parameters */
        //opts.table_index += used;


        opts.bits = root;
        return 0;
      };
    }, {
      "../utils/common": 27
    }],
    37: [function (_dereq_, module, exports) {

      module.exports = {
        '2': 'need dictionary',

        /* Z_NEED_DICT       2  */
        '1': 'stream end',

        /* Z_STREAM_END      1  */
        '0': '',

        /* Z_OK              0  */
        '-1': 'file error',

        /* Z_ERRNO         (-1) */
        '-2': 'stream error',

        /* Z_STREAM_ERROR  (-2) */
        '-3': 'data error',

        /* Z_DATA_ERROR    (-3) */
        '-4': 'insufficient memory',

        /* Z_MEM_ERROR     (-4) */
        '-5': 'buffer error',

        /* Z_BUF_ERROR     (-5) */
        '-6': 'incompatible version'
        /* Z_VERSION_ERROR (-6) */

      };
    }, {}],
    38: [function (_dereq_, module, exports) {

      var utils = _dereq_('../utils/common');
      /* Public constants ==========================================================*/

      /* ===========================================================================*/
      //var Z_FILTERED          = 1;
      //var Z_HUFFMAN_ONLY      = 2;
      //var Z_RLE               = 3;


      var Z_FIXED = 4; //var Z_DEFAULT_STRATEGY  = 0;

      /* Possible values of the data_type field (though see inflate()) */

      var Z_BINARY = 0;
      var Z_TEXT = 1; //var Z_ASCII             = 1; // = Z_TEXT

      var Z_UNKNOWN = 2;
      /*============================================================================*/

      function zero(buf) {
        var len = buf.length;

        while (--len >= 0) {
          buf[len] = 0;
        }
      } // From zutil.h


      var STORED_BLOCK = 0;
      var STATIC_TREES = 1;
      var DYN_TREES = 2;
      /* The three kinds of block type */

      var MIN_MATCH = 3;
      var MAX_MATCH = 258;
      /* The minimum and maximum match lengths */
      // From deflate.h

      /* ===========================================================================
       * Internal compression state.
       */

      var LENGTH_CODES = 29;
      /* number of length codes, not counting the special END_BLOCK code */

      var LITERALS = 256;
      /* number of literal bytes 0..255 */

      var L_CODES = LITERALS + 1 + LENGTH_CODES;
      /* number of Literal or Length codes, including the END_BLOCK code */

      var D_CODES = 30;
      /* number of distance codes */

      var BL_CODES = 19;
      /* number of codes used to transfer the bit lengths */

      var HEAP_SIZE = 2 * L_CODES + 1;
      /* maximum heap size */

      var MAX_BITS = 15;
      /* All codes must not exceed MAX_BITS bits */

      var Buf_size = 16;
      /* size of bit buffer in bi_buf */

      /* ===========================================================================
       * Constants
       */

      var MAX_BL_BITS = 7;
      /* Bit length codes must not exceed MAX_BL_BITS bits */

      var END_BLOCK = 256;
      /* end of block literal code */

      var REP_3_6 = 16;
      /* repeat previous bit length 3-6 times (2 bits of repeat count) */

      var REPZ_3_10 = 17;
      /* repeat a zero length 3-10 times  (3 bits of repeat count) */

      var REPZ_11_138 = 18;
      /* repeat a zero length 11-138 times  (7 bits of repeat count) */

      var extra_lbits =
      /* extra bits for each length code */
      [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0];
      var extra_dbits =
      /* extra bits for each distance code */
      [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];
      var extra_blbits =
      /* extra bits for each bit length code */
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7];
      var bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
      /* The lengths of the bit length codes are sent in order of decreasing
       * probability, to avoid transmitting the lengths for unused bit length codes.
       */

      /* ===========================================================================
       * Local data. These are initialized only once.
       */
      // We pre-fill arrays with 0 to avoid uninitialized gaps

      var DIST_CODE_LEN = 512;
      /* see definition of array dist_code below */
      // !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1

      var static_ltree = new Array((L_CODES + 2) * 2);
      zero(static_ltree);
      /* The static literal tree. Since the bit lengths are imposed, there is no
       * need for the L_CODES extra codes used during heap construction. However
       * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
       * below).
       */

      var static_dtree = new Array(D_CODES * 2);
      zero(static_dtree);
      /* The static distance tree. (Actually a trivial tree since all codes use
       * 5 bits.)
       */

      var _dist_code = new Array(DIST_CODE_LEN);

      zero(_dist_code);
      /* Distance codes. The first 256 values correspond to the distances
       * 3 .. 258, the last 256 values correspond to the top 8 bits of
       * the 15 bit distances.
       */

      var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);

      zero(_length_code);
      /* length code for each normalized match length (0 == MIN_MATCH) */

      var base_length = new Array(LENGTH_CODES);
      zero(base_length);
      /* First normalized length for each code (0 = MIN_MATCH) */

      var base_dist = new Array(D_CODES);
      zero(base_dist);
      /* First normalized distance for each code (0 = distance of 1) */

      var StaticTreeDesc = function (static_tree, extra_bits, extra_base, elems, max_length) {
        this.static_tree = static_tree;
        /* static tree or NULL */

        this.extra_bits = extra_bits;
        /* extra bits for each code or NULL */

        this.extra_base = extra_base;
        /* base index for extra_bits */

        this.elems = elems;
        /* max number of elements in the tree */

        this.max_length = max_length;
        /* max bit length for the codes */
        // show if `static_tree` has data or dummy - needed for monomorphic objects

        this.has_stree = static_tree && static_tree.length;
      };

      var static_l_desc;
      var static_d_desc;
      var static_bl_desc;

      var TreeDesc = function (dyn_tree, stat_desc) {
        this.dyn_tree = dyn_tree;
        /* the dynamic tree */

        this.max_code = 0;
        /* largest code with non zero frequency */

        this.stat_desc = stat_desc;
        /* the corresponding static tree */
      };

      function d_code(dist) {
        return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
      }
      /* ===========================================================================
       * Output a short LSB first on the stream.
       * IN assertion: there is enough room in pendingBuf.
       */


      function put_short(s, w) {
        //    put_byte(s, (uch)((w) & 0xff));
        //    put_byte(s, (uch)((ush)(w) >> 8));
        s.pending_buf[s.pending++] = w & 0xff;
        s.pending_buf[s.pending++] = w >>> 8 & 0xff;
      }
      /* ===========================================================================
       * Send a value on a given number of bits.
       * IN assertion: length <= 16 and value fits in length bits.
       */


      function send_bits(s, value, length) {
        if (s.bi_valid > Buf_size - length) {
          s.bi_buf |= value << s.bi_valid & 0xffff;
          put_short(s, s.bi_buf);
          s.bi_buf = value >> Buf_size - s.bi_valid;
          s.bi_valid += length - Buf_size;
        } else {
          s.bi_buf |= value << s.bi_valid & 0xffff;
          s.bi_valid += length;
        }
      }

      function send_code(s, c, tree) {
        send_bits(s, tree[c * 2]
        /*.Code*/
        , tree[c * 2 + 1]
        /*.Len*/
        );
      }
      /* ===========================================================================
       * Reverse the first len bits of a code, using straightforward code (a faster
       * method would use a table)
       * IN assertion: 1 <= len <= 15
       */


      function bi_reverse(code, len) {
        var res = 0;

        do {
          res |= code & 1;
          code >>>= 1;
          res <<= 1;
        } while (--len > 0);

        return res >>> 1;
      }
      /* ===========================================================================
       * Flush the bit buffer, keeping at most 7 bits in it.
       */


      function bi_flush(s) {
        if (s.bi_valid === 16) {
          put_short(s, s.bi_buf);
          s.bi_buf = 0;
          s.bi_valid = 0;
        } else if (s.bi_valid >= 8) {
          s.pending_buf[s.pending++] = s.bi_buf & 0xff;
          s.bi_buf >>= 8;
          s.bi_valid -= 8;
        }
      }
      /* ===========================================================================
       * Compute the optimal bit lengths for a tree and update the total bit length
       * for the current block.
       * IN assertion: the fields freq and dad are set, heap[heap_max] and
       *    above are the tree nodes sorted by increasing frequency.
       * OUT assertions: the field len is set to the optimal bit length, the
       *     array bl_count contains the frequencies for each bit length.
       *     The length opt_len is updated; static_len is also updated if stree is
       *     not null.
       */


      function gen_bitlen(s, desc) //    deflate_state *s;
      //    tree_desc *desc;    /* the tree descriptor */
      {
        var tree = desc.dyn_tree;
        var max_code = desc.max_code;
        var stree = desc.stat_desc.static_tree;
        var has_stree = desc.stat_desc.has_stree;
        var extra = desc.stat_desc.extra_bits;
        var base = desc.stat_desc.extra_base;
        var max_length = desc.stat_desc.max_length;
        var h;
        /* heap index */

        var n, m;
        /* iterate over the tree elements */

        var bits;
        /* bit length */

        var xbits;
        /* extra bits */

        var f;
        /* frequency */

        var overflow = 0;
        /* number of elements with bit length too large */

        for (bits = 0; bits <= MAX_BITS; bits++) {
          s.bl_count[bits] = 0;
        }
        /* In a first pass, compute the optimal bit lengths (which may
         * overflow in the case of the bit length tree).
         */


        tree[s.heap[s.heap_max] * 2 + 1]
        /*.Len*/
        = 0;
        /* root of the heap */

        for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
          n = s.heap[h];
          bits = tree[tree[n * 2 + 1]
          /*.Dad*/
          * 2 + 1]
          /*.Len*/
          + 1;

          if (bits > max_length) {
            bits = max_length;
            overflow++;
          }

          tree[n * 2 + 1]
          /*.Len*/
          = bits;
          /* We overwrite tree[n].Dad which is no longer needed */

          if (n > max_code) {
            continue;
          }
          /* not a leaf node */


          s.bl_count[bits]++;
          xbits = 0;

          if (n >= base) {
            xbits = extra[n - base];
          }

          f = tree[n * 2]
          /*.Freq*/
          ;
          s.opt_len += f * (bits + xbits);

          if (has_stree) {
            s.static_len += f * (stree[n * 2 + 1]
            /*.Len*/
            + xbits);
          }
        }

        if (overflow === 0) {
          return;
        } // Trace((stderr,"\nbit length overflow\n"));

        /* This happens for example on obj2 and pic of the Calgary corpus */

        /* Find the first bit length which could increase: */


        do {
          bits = max_length - 1;

          while (s.bl_count[bits] === 0) {
            bits--;
          }

          s.bl_count[bits]--;
          /* move one leaf down the tree */

          s.bl_count[bits + 1] += 2;
          /* move one overflow item as its brother */

          s.bl_count[max_length]--;
          /* The brother of the overflow item also moves one step up,
           * but this does not affect bl_count[max_length]
           */

          overflow -= 2;
        } while (overflow > 0);
        /* Now recompute all bit lengths, scanning in increasing frequency.
         * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
         * lengths instead of fixing only the wrong ones. This idea is taken
         * from 'ar' written by Haruhiko Okumura.)
         */


        for (bits = max_length; bits !== 0; bits--) {
          n = s.bl_count[bits];

          while (n !== 0) {
            m = s.heap[--h];

            if (m > max_code) {
              continue;
            }

            if (tree[m * 2 + 1]
            /*.Len*/
            !== bits) {
              // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
              s.opt_len += (bits - tree[m * 2 + 1]
              /*.Len*/
              ) * tree[m * 2]
              /*.Freq*/
              ;
              tree[m * 2 + 1]
              /*.Len*/
              = bits;
            }

            n--;
          }
        }
      }
      /* ===========================================================================
       * Generate the codes for a given tree and bit counts (which need not be
       * optimal).
       * IN assertion: the array bl_count contains the bit length statistics for
       * the given tree and the field len is set for all tree elements.
       * OUT assertion: the field code is set for all tree elements of non
       *     zero code length.
       */


      function gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
      //    int max_code;              /* largest code with non zero frequency */
      //    ushf *bl_count;            /* number of codes at each bit length */
      {
        var next_code = new Array(MAX_BITS + 1);
        /* next code value for each bit length */

        var code = 0;
        /* running code value */

        var bits;
        /* bit index */

        var n;
        /* code index */

        /* The distribution counts are first used to generate the code values
         * without bit reversal.
         */

        for (bits = 1; bits <= MAX_BITS; bits++) {
          next_code[bits] = code = code + bl_count[bits - 1] << 1;
        }
        /* Check that the bit counts in bl_count are consistent. The last code
         * must be all ones.
         */
        //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
        //        "inconsistent bit counts");
        //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));


        for (n = 0; n <= max_code; n++) {
          var len = tree[n * 2 + 1]
          /*.Len*/
          ;

          if (len === 0) {
            continue;
          }
          /* Now reverse the bits */


          tree[n * 2]
          /*.Code*/
          = bi_reverse(next_code[len]++, len); //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
          //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
        }
      }
      /* ===========================================================================
       * Initialize the various 'constant' tables.
       */


      function tr_static_init() {
        var n;
        /* iterates over tree elements */

        var bits;
        /* bit counter */

        var length;
        /* length value */

        var code;
        /* code value */

        var dist;
        /* distance index */

        var bl_count = new Array(MAX_BITS + 1);
        /* number of codes at each bit length for an optimal tree */
        // do check in _tr_init()
        //if (static_init_done) return;

        /* For some embedded targets, global variables are not initialized: */

        /*#ifdef NO_INIT_GLOBAL_POINTERS
          static_l_desc.static_tree = static_ltree;
          static_l_desc.extra_bits = extra_lbits;
          static_d_desc.static_tree = static_dtree;
          static_d_desc.extra_bits = extra_dbits;
          static_bl_desc.extra_bits = extra_blbits;
        #endif*/

        /* Initialize the mapping length (0..255) -> length code (0..28) */

        length = 0;

        for (code = 0; code < LENGTH_CODES - 1; code++) {
          base_length[code] = length;

          for (n = 0; n < 1 << extra_lbits[code]; n++) {
            _length_code[length++] = code;
          }
        } //Assert (length == 256, "tr_static_init: length != 256");

        /* Note that the length 255 (match length 258) can be represented
         * in two different ways: code 284 + 5 bits or code 285, so we
         * overwrite length_code[255] to use the best encoding:
         */


        _length_code[length - 1] = code;
        /* Initialize the mapping dist (0..32K) -> dist code (0..29) */

        dist = 0;

        for (code = 0; code < 16; code++) {
          base_dist[code] = dist;

          for (n = 0; n < 1 << extra_dbits[code]; n++) {
            _dist_code[dist++] = code;
          }
        } //Assert (dist == 256, "tr_static_init: dist != 256");


        dist >>= 7;
        /* from now on, all distances are divided by 128 */

        for (; code < D_CODES; code++) {
          base_dist[code] = dist << 7;

          for (n = 0; n < 1 << extra_dbits[code] - 7; n++) {
            _dist_code[256 + dist++] = code;
          }
        } //Assert (dist == 256, "tr_static_init: 256+dist != 512");

        /* Construct the codes of the static literal tree */


        for (bits = 0; bits <= MAX_BITS; bits++) {
          bl_count[bits] = 0;
        }

        n = 0;

        while (n <= 143) {
          static_ltree[n * 2 + 1]
          /*.Len*/
          = 8;
          n++;
          bl_count[8]++;
        }

        while (n <= 255) {
          static_ltree[n * 2 + 1]
          /*.Len*/
          = 9;
          n++;
          bl_count[9]++;
        }

        while (n <= 279) {
          static_ltree[n * 2 + 1]
          /*.Len*/
          = 7;
          n++;
          bl_count[7]++;
        }

        while (n <= 287) {
          static_ltree[n * 2 + 1]
          /*.Len*/
          = 8;
          n++;
          bl_count[8]++;
        }
        /* Codes 286 and 287 do not exist, but we must include them in the
         * tree construction to get a canonical Huffman tree (longest code
         * all ones)
         */


        gen_codes(static_ltree, L_CODES + 1, bl_count);
        /* The static distance tree is trivial: */

        for (n = 0; n < D_CODES; n++) {
          static_dtree[n * 2 + 1]
          /*.Len*/
          = 5;
          static_dtree[n * 2]
          /*.Code*/
          = bi_reverse(n, 5);
        } // Now data ready and we can init static trees


        static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
        static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
        static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS); //static_init_done = true;
      }
      /* ===========================================================================
       * Initialize a new block.
       */


      function init_block(s) {
        var n;
        /* iterates over tree elements */

        /* Initialize the trees. */

        for (n = 0; n < L_CODES; n++) {
          s.dyn_ltree[n * 2]
          /*.Freq*/
          = 0;
        }

        for (n = 0; n < D_CODES; n++) {
          s.dyn_dtree[n * 2]
          /*.Freq*/
          = 0;
        }

        for (n = 0; n < BL_CODES; n++) {
          s.bl_tree[n * 2]
          /*.Freq*/
          = 0;
        }

        s.dyn_ltree[END_BLOCK * 2]
        /*.Freq*/
        = 1;
        s.opt_len = s.static_len = 0;
        s.last_lit = s.matches = 0;
      }
      /* ===========================================================================
       * Flush the bit buffer and align the output on a byte boundary
       */


      function bi_windup(s) {
        if (s.bi_valid > 8) {
          put_short(s, s.bi_buf);
        } else if (s.bi_valid > 0) {
          //put_byte(s, (Byte)s->bi_buf);
          s.pending_buf[s.pending++] = s.bi_buf;
        }

        s.bi_buf = 0;
        s.bi_valid = 0;
      }
      /* ===========================================================================
       * Copy a stored block, storing first the length and its
       * one's complement if requested.
       */


      function copy_block(s, buf, len, header) //DeflateState *s;
      //charf    *buf;    /* the input data */
      //unsigned len;     /* its length */
      //int      header;  /* true if block header must be written */
      {
        bi_windup(s);
        /* align on byte boundary */

        if (header) {
          put_short(s, len);
          put_short(s, ~len);
        } //  while (len--) {
        //    put_byte(s, *buf++);
        //  }


        utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
        s.pending += len;
      }
      /* ===========================================================================
       * Compares to subtrees, using the tree depth as tie breaker when
       * the subtrees have equal frequency. This minimizes the worst case length.
       */


      function smaller(tree, n, m, depth) {
        var _n2 = n * 2;

        var _m2 = m * 2;

        return tree[_n2]
        /*.Freq*/
        < tree[_m2]
        /*.Freq*/
        || tree[_n2]
        /*.Freq*/
        === tree[_m2]
        /*.Freq*/
        && depth[n] <= depth[m];
      }
      /* ===========================================================================
       * Restore the heap property by moving down the tree starting at node k,
       * exchanging a node with the smallest of its two sons if necessary, stopping
       * when the heap property is re-established (each father smaller than its
       * two sons).
       */


      function pqdownheap(s, tree, k) //    deflate_state *s;
      //    ct_data *tree;  /* the tree to restore */
      //    int k;               /* node to move down */
      {
        var v = s.heap[k];
        var j = k << 1;
        /* left son of k */

        while (j <= s.heap_len) {
          /* Set j to the smallest of the two sons: */
          if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
            j++;
          }
          /* Exit if v is smaller than both sons */


          if (smaller(tree, v, s.heap[j], s.depth)) {
            break;
          }
          /* Exchange v with the smallest son */


          s.heap[k] = s.heap[j];
          k = j;
          /* And continue down the tree, setting j to the left son of k */

          j <<= 1;
        }

        s.heap[k] = v;
      } // inlined manually
      // var SMALLEST = 1;

      /* ===========================================================================
       * Send the block data compressed using the given Huffman trees
       */


      function compress_block(s, ltree, dtree) //    deflate_state *s;
      //    const ct_data *ltree; /* literal tree */
      //    const ct_data *dtree; /* distance tree */
      {
        var dist;
        /* distance of matched string */

        var lc;
        /* match length or unmatched char (if dist == 0) */

        var lx = 0;
        /* running index in l_buf */

        var code;
        /* the code to send */

        var extra;
        /* number of extra bits to send */

        if (s.last_lit !== 0) {
          do {
            dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
            lc = s.pending_buf[s.l_buf + lx];
            lx++;

            if (dist === 0) {
              send_code(s, lc, ltree);
              /* send a literal byte */
              //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
            } else {
              /* Here, lc is the match length - MIN_MATCH */
              code = _length_code[lc];
              send_code(s, code + LITERALS + 1, ltree);
              /* send the length code */

              extra = extra_lbits[code];

              if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra);
                /* send the extra length bits */
              }

              dist--;
              /* dist is now the match distance - 1 */

              code = d_code(dist); //Assert (code < D_CODES, "bad d_code");

              send_code(s, code, dtree);
              /* send the distance code */

              extra = extra_dbits[code];

              if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra);
                /* send the extra distance bits */
              }
            }
            /* literal or match pair ? */

            /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
            //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
            //       "pendingBuf overflow");

          } while (lx < s.last_lit);
        }

        send_code(s, END_BLOCK, ltree);
      }
      /* ===========================================================================
       * Construct one Huffman tree and assigns the code bit strings and lengths.
       * Update the total bit length for the current block.
       * IN assertion: the field freq is set for all tree elements.
       * OUT assertions: the fields len and code are set to the optimal bit length
       *     and corresponding code. The length opt_len is updated; static_len is
       *     also updated if stree is not null. The field max_code is set.
       */


      function build_tree(s, desc) //    deflate_state *s;
      //    tree_desc *desc; /* the tree descriptor */
      {
        var tree = desc.dyn_tree;
        var stree = desc.stat_desc.static_tree;
        var has_stree = desc.stat_desc.has_stree;
        var elems = desc.stat_desc.elems;
        var n, m;
        /* iterate over heap elements */

        var max_code = -1;
        /* largest code with non zero frequency */

        var node;
        /* new node being created */

        /* Construct the initial heap, with least frequent element in
         * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
         * heap[0] is not used.
         */

        s.heap_len = 0;
        s.heap_max = HEAP_SIZE;

        for (n = 0; n < elems; n++) {
          if (tree[n * 2]
          /*.Freq*/
          !== 0) {
            s.heap[++s.heap_len] = max_code = n;
            s.depth[n] = 0;
          } else {
            tree[n * 2 + 1]
            /*.Len*/
            = 0;
          }
        }
        /* The pkzip format requires that at least one distance code exists,
         * and that at least one bit should be sent even if there is only one
         * possible code. So to avoid special checks later on we force at least
         * two codes of non zero frequency.
         */


        while (s.heap_len < 2) {
          node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
          tree[node * 2]
          /*.Freq*/
          = 1;
          s.depth[node] = 0;
          s.opt_len--;

          if (has_stree) {
            s.static_len -= stree[node * 2 + 1]
            /*.Len*/
            ;
          }
          /* node is 0 or 1 so it does not have extra bits */

        }

        desc.max_code = max_code;
        /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
         * establish sub-heaps of increasing lengths:
         */

        for (n = s.heap_len >> 1
        /*int /2*/
        ; n >= 1; n--) {
          pqdownheap(s, tree, n);
        }
        /* Construct the Huffman tree by repeatedly combining the least two
         * frequent nodes.
         */


        node = elems;
        /* next internal node of the tree */

        do {
          //pqremove(s, tree, n);  /* n = node of least frequency */

          /*** pqremove ***/
          n = s.heap[1
          /*SMALLEST*/
          ];
          s.heap[1
          /*SMALLEST*/
          ] = s.heap[s.heap_len--];
          pqdownheap(s, tree, 1
          /*SMALLEST*/
          );
          /***/

          m = s.heap[1
          /*SMALLEST*/
          ];
          /* m = node of next least frequency */

          s.heap[--s.heap_max] = n;
          /* keep the nodes sorted by frequency */

          s.heap[--s.heap_max] = m;
          /* Create a new node father of n and m */

          tree[node * 2]
          /*.Freq*/
          = tree[n * 2]
          /*.Freq*/
          + tree[m * 2]
          /*.Freq*/
          ;
          s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
          tree[n * 2 + 1]
          /*.Dad*/
          = tree[m * 2 + 1]
          /*.Dad*/
          = node;
          /* and insert the new node in the heap */

          s.heap[1
          /*SMALLEST*/
          ] = node++;
          pqdownheap(s, tree, 1
          /*SMALLEST*/
          );
        } while (s.heap_len >= 2);

        s.heap[--s.heap_max] = s.heap[1
        /*SMALLEST*/
        ];
        /* At this point, the fields freq and dad are set. We can now
         * generate the bit lengths.
         */

        gen_bitlen(s, desc);
        /* The field len is now set, we can generate the bit codes */

        gen_codes(tree, max_code, s.bl_count);
      }
      /* ===========================================================================
       * Scan a literal or distance tree to determine the frequencies of the codes
       * in the bit length tree.
       */


      function scan_tree(s, tree, max_code) //    deflate_state *s;
      //    ct_data *tree;   /* the tree to be scanned */
      //    int max_code;    /* and its largest code of non zero frequency */
      {
        var n;
        /* iterates over all tree elements */

        var prevlen = -1;
        /* last emitted length */

        var curlen;
        /* length of current code */

        var nextlen = tree[0 * 2 + 1]
        /*.Len*/
        ;
        /* length of next code */

        var count = 0;
        /* repeat count of the current code */

        var max_count = 7;
        /* max repeat count */

        var min_count = 4;
        /* min repeat count */

        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        }

        tree[(max_code + 1) * 2 + 1]
        /*.Len*/
        = 0xffff;
        /* guard */

        for (n = 0; n <= max_code; n++) {
          curlen = nextlen;
          nextlen = tree[(n + 1) * 2 + 1]
          /*.Len*/
          ;

          if (++count < max_count && curlen === nextlen) {
            continue;
          } else if (count < min_count) {
            s.bl_tree[curlen * 2]
            /*.Freq*/
            += count;
          } else if (curlen !== 0) {
            if (curlen !== prevlen) {
              s.bl_tree[curlen * 2] /*.Freq*/++;
            }

            s.bl_tree[REP_3_6 * 2] /*.Freq*/++;
          } else if (count <= 10) {
            s.bl_tree[REPZ_3_10 * 2] /*.Freq*/++;
          } else {
            s.bl_tree[REPZ_11_138 * 2] /*.Freq*/++;
          }

          count = 0;
          prevlen = curlen;

          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
          } else {
            max_count = 7;
            min_count = 4;
          }
        }
      }
      /* ===========================================================================
       * Send a literal or distance tree in compressed form, using the codes in
       * bl_tree.
       */


      function send_tree(s, tree, max_code) //    deflate_state *s;
      //    ct_data *tree; /* the tree to be scanned */
      //    int max_code;       /* and its largest code of non zero frequency */
      {
        var n;
        /* iterates over all tree elements */

        var prevlen = -1;
        /* last emitted length */

        var curlen;
        /* length of current code */

        var nextlen = tree[0 * 2 + 1]
        /*.Len*/
        ;
        /* length of next code */

        var count = 0;
        /* repeat count of the current code */

        var max_count = 7;
        /* max repeat count */

        var min_count = 4;
        /* min repeat count */

        /* tree[max_code+1].Len = -1; */

        /* guard already set */

        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        }

        for (n = 0; n <= max_code; n++) {
          curlen = nextlen;
          nextlen = tree[(n + 1) * 2 + 1]
          /*.Len*/
          ;

          if (++count < max_count && curlen === nextlen) {
            continue;
          } else if (count < min_count) {
            do {
              send_code(s, curlen, s.bl_tree);
            } while (--count !== 0);
          } else if (curlen !== 0) {
            if (curlen !== prevlen) {
              send_code(s, curlen, s.bl_tree);
              count--;
            } //Assert(count >= 3 && count <= 6, " 3_6?");


            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
          } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
          } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
          }

          count = 0;
          prevlen = curlen;

          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
          } else {
            max_count = 7;
            min_count = 4;
          }
        }
      }
      /* ===========================================================================
       * Construct the Huffman tree for the bit lengths and return the index in
       * bl_order of the last bit length code to send.
       */


      function build_bl_tree(s) {
        var max_blindex;
        /* index of last bit length code of non zero freq */

        /* Determine the bit length frequencies for literal and distance trees */

        scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
        scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
        /* Build the bit length tree: */

        build_tree(s, s.bl_desc);
        /* opt_len now includes the length of the tree representations, except
         * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
         */

        /* Determine the number of bit length codes to send. The pkzip format
         * requires that at least 4 bit length codes be sent. (appnote.txt says
         * 3 but the actual value used is 4.)
         */

        for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
          if (s.bl_tree[bl_order[max_blindex] * 2 + 1]
          /*.Len*/
          !== 0) {
            break;
          }
        }
        /* Update opt_len to include the bit length tree and counts */


        s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
        //        s->opt_len, s->static_len));

        return max_blindex;
      }
      /* ===========================================================================
       * Send the header for a block using dynamic Huffman trees: the counts, the
       * lengths of the bit length codes, the literal tree and the distance tree.
       * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
       */


      function send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
      //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
      {
        var rank;
        /* index in bl_order */
        //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
        //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
        //        "too many codes");
        //Tracev((stderr, "\nbl counts: "));

        send_bits(s, lcodes - 257, 5);
        /* not +255 as stated in appnote.txt */

        send_bits(s, dcodes - 1, 5);
        send_bits(s, blcodes - 4, 4);
        /* not -3 as stated in appnote.txt */

        for (rank = 0; rank < blcodes; rank++) {
          //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
          send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]
          /*.Len*/
          , 3);
        } //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));


        send_tree(s, s.dyn_ltree, lcodes - 1);
        /* literal tree */
        //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

        send_tree(s, s.dyn_dtree, dcodes - 1);
        /* distance tree */
        //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
      }
      /* ===========================================================================
       * Check if the data type is TEXT or BINARY, using the following algorithm:
       * - TEXT if the two conditions below are satisfied:
       *    a) There are no non-portable control characters belonging to the
       *       "black list" (0..6, 14..25, 28..31).
       *    b) There is at least one printable character belonging to the
       *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
       * - BINARY otherwise.
       * - The following partially-portable control characters form a
       *   "gray list" that is ignored in this detection algorithm:
       *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
       * IN assertion: the fields Freq of dyn_ltree are set.
       */


      function detect_data_type(s) {
        /* black_mask is the bit mask of black-listed bytes
         * set bits 0..6, 14..25, and 28..31
         * 0xf3ffc07f = binary 11110011111111111100000001111111
         */
        var black_mask = 0xf3ffc07f;
        var n;
        /* Check for non-textual ("black-listed") bytes. */

        for (n = 0; n <= 31; n++, black_mask >>>= 1) {
          if (black_mask & 1 && s.dyn_ltree[n * 2]
          /*.Freq*/
          !== 0) {
            return Z_BINARY;
          }
        }
        /* Check for textual ("white-listed") bytes. */


        if (s.dyn_ltree[9 * 2]
        /*.Freq*/
        !== 0 || s.dyn_ltree[10 * 2]
        /*.Freq*/
        !== 0 || s.dyn_ltree[13 * 2]
        /*.Freq*/
        !== 0) {
          return Z_TEXT;
        }

        for (n = 32; n < LITERALS; n++) {
          if (s.dyn_ltree[n * 2]
          /*.Freq*/
          !== 0) {
            return Z_TEXT;
          }
        }
        /* There are no "black-listed" or "white-listed" bytes:
         * this stream either is empty or has tolerated ("gray-listed") bytes only.
         */


        return Z_BINARY;
      }

      var static_init_done = false;
      /* ===========================================================================
       * Initialize the tree data structures for a new zlib stream.
       */

      function _tr_init(s) {
        if (!static_init_done) {
          tr_static_init();
          static_init_done = true;
        }

        s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
        s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
        s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
        s.bi_buf = 0;
        s.bi_valid = 0;
        /* Initialize the first block of the first file: */

        init_block(s);
      }
      /* ===========================================================================
       * Send a stored block
       */


      function _tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
      //charf *buf;       /* input block */
      //ulg stored_len;   /* length of input block */
      //int last;         /* one if this is the last block for a file */
      {
        send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
        /* send block type */

        copy_block(s, buf, stored_len, true);
        /* with header */
      }
      /* ===========================================================================
       * Send one empty static block to give enough lookahead for inflate.
       * This takes 10 bits, of which 7 may remain in the bit buffer.
       */


      function _tr_align(s) {
        send_bits(s, STATIC_TREES << 1, 3);
        send_code(s, END_BLOCK, static_ltree);
        bi_flush(s);
      }
      /* ===========================================================================
       * Determine the best encoding for the current block: dynamic trees, static
       * trees or store, and output the encoded block to the zip file.
       */


      function _tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
      //charf *buf;       /* input block, or NULL if too old */
      //ulg stored_len;   /* length of input block */
      //int last;         /* one if this is the last block for a file */
      {
        var opt_lenb, static_lenb;
        /* opt_len and static_len in bytes */

        var max_blindex = 0;
        /* index of last bit length code of non zero freq */

        /* Build the Huffman trees unless a stored block is forced */

        if (s.level > 0) {
          /* Check if the file is binary or text */
          if (s.strm.data_type === Z_UNKNOWN) {
            s.strm.data_type = detect_data_type(s);
          }
          /* Construct the literal and distance trees */


          build_tree(s, s.l_desc); // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
          //        s->static_len));

          build_tree(s, s.d_desc); // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
          //        s->static_len));

          /* At this point, opt_len and static_len are the total bit lengths of
           * the compressed block data, excluding the tree representations.
           */

          /* Build the bit length tree for the above two trees, and get the index
           * in bl_order of the last bit length code to send.
           */

          max_blindex = build_bl_tree(s);
          /* Determine the best encoding. Compute the block lengths in bytes. */

          opt_lenb = s.opt_len + 3 + 7 >>> 3;
          static_lenb = s.static_len + 3 + 7 >>> 3; // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
          //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
          //        s->last_lit));

          if (static_lenb <= opt_lenb) {
            opt_lenb = static_lenb;
          }
        } else {
          // Assert(buf != (char*)0, "lost buf");
          opt_lenb = static_lenb = stored_len + 5;
          /* force a stored block */
        }

        if (stored_len + 4 <= opt_lenb && buf !== -1) {
          /* 4: two words for the lengths */

          /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
           * Otherwise we can't have processed more than WSIZE input bytes since
           * the last block flush, because compression would have been
           * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
           * transform a block into a stored block.
           */
          _tr_stored_block(s, buf, stored_len, last);
        } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
          send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
          compress_block(s, static_ltree, static_dtree);
        } else {
          send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
          send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
          compress_block(s, s.dyn_ltree, s.dyn_dtree);
        } // Assert (s->compressed_len == s->bits_sent, "bad compressed size");

        /* The above check is made mod 2^32, for files larger than 512 MB
         * and uLong implemented on 32 bits.
         */


        init_block(s);

        if (last) {
          bi_windup(s);
        } // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
        //       s->compressed_len-7*last));

      }
      /* ===========================================================================
       * Save the match info and tally the frequency counts. Return true if
       * the current block must be flushed.
       */


      function _tr_tally(s, dist, lc) //    deflate_state *s;
      //    unsigned dist;  /* distance of matched string */
      //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
      {
        //var out_length, in_length, dcode;
        s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
        s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
        s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
        s.last_lit++;

        if (dist === 0) {
          /* lc is the unmatched char */
          s.dyn_ltree[lc * 2] /*.Freq*/++;
        } else {
          s.matches++;
          /* Here, lc is the match length - MIN_MATCH */

          dist--;
          /* dist = match distance - 1 */
          //Assert((ush)dist < (ush)MAX_DIST(s) &&
          //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
          //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

          s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /*.Freq*/++;
          s.dyn_dtree[d_code(dist) * 2] /*.Freq*/++;
        } // (!) This block is disabled in zlib defailts,
        // don't enable it for binary compatibility
        //#ifdef TRUNCATE_BLOCK
        //  /* Try to guess if it is profitable to stop the current block here */
        //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
        //    /* Compute an upper bound for the compressed length */
        //    out_length = s.last_lit*8;
        //    in_length = s.strstart - s.block_start;
        //
        //    for (dcode = 0; dcode < D_CODES; dcode++) {
        //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
        //    }
        //    out_length >>>= 3;
        //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
        //    //       s->last_lit, in_length, out_length,
        //    //       100L - out_length*100L/in_length));
        //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
        //      return true;
        //    }
        //  }
        //#endif


        return s.last_lit === s.lit_bufsize - 1;
        /* We avoid equality with lit_bufsize because of wraparound at 64K
         * on 16 bit machines and because stored blocks are restricted to
         * 64K-1 bytes.
         */
      }

      exports._tr_init = _tr_init;
      exports._tr_stored_block = _tr_stored_block;
      exports._tr_flush_block = _tr_flush_block;
      exports._tr_tally = _tr_tally;
      exports._tr_align = _tr_align;
    }, {
      "../utils/common": 27
    }],
    39: [function (_dereq_, module, exports) {

      function ZStream() {
        /* next input byte */
        this.input = null; // JS specific, because we have no pointers

        this.next_in = 0;
        /* number of bytes available at input */

        this.avail_in = 0;
        /* total number of input bytes read so far */

        this.total_in = 0;
        /* next output byte should be put there */

        this.output = null; // JS specific, because we have no pointers

        this.next_out = 0;
        /* remaining free space at output */

        this.avail_out = 0;
        /* total number of bytes output so far */

        this.total_out = 0;
        /* last error message, NULL if no error */

        this.msg = ''
        /*Z_NULL*/
        ;
        /* not visible by applications */

        this.state = null;
        /* best guess about the data type: binary or text */

        this.data_type = 2
        /*Z_UNKNOWN*/
        ;
        /* adler32 value of the uncompressed data */

        this.adler = 0;
      }

      module.exports = ZStream;
    }, {}]
  }, {}, [9])(9);
});
});

var xlsx = createCommonjsModule(function (module, exports) {
function make_xlsx_lib(XLSX){XLSX.version='0.17.2';var current_codepage=1200,current_ansi=1252;/*global cptable:true, window */if(typeof commonjsRequire!=='undefined'){if(typeof cptable==='undefined'){if(typeof commonjsGlobal!=='undefined')commonjsGlobal.cptable=cpexcel;else if(typeof window!=='undefined')window.cptable=cpexcel;}}var VALID_ANSI=[874,932,936,949,950];for(var i=0;i<=8;++i)VALID_ANSI.push(1250+i);/* ECMA-376 Part I 18.4.1 charset to codepage mapping */var CS2CP={0:1252,/* ANSI */1:65001,/* DEFAULT */2:65001,/* SYMBOL */77:10000,/* MAC */128:932,/* SHIFTJIS */129:949,/* HANGUL */130:1361,/* JOHAB */134:936,/* GB2312 */136:950,/* CHINESEBIG5 */161:1253,/* GREEK */162:1254,/* TURKISH */163:1258,/* VIETNAMESE */177:1255,/* HEBREW */178:1256,/* ARABIC */186:1257,/* BALTIC */204:1251,/* RUSSIAN */222:874,/* THAI */238:1250,/* EASTEUROPE */255:1252,/* OEM */69:6969/* MISC */};var set_ansi=function(cp){if(VALID_ANSI.indexOf(cp)==-1)return;current_ansi=CS2CP[0]=cp;};function reset_ansi(){set_ansi(1252);}var set_cp=function(cp){current_codepage=cp;set_ansi(cp);};function reset_cp(){set_cp(1200);reset_ansi();}function char_codes(data){var o=[];for(var i=0,len=data.length;i<len;++i)o[i]=data.charCodeAt(i);return o;}function utf16leread(data){var o=[];for(var i=0;i<data.length>>1;++i)o[i]=String.fromCharCode(data.charCodeAt(2*i)+(data.charCodeAt(2*i+1)<<8));return o.join("");}function utf16beread(data){var o=[];for(var i=0;i<data.length>>1;++i)o[i]=String.fromCharCode(data.charCodeAt(2*i+1)+(data.charCodeAt(2*i)<<8));return o.join("");}var debom=function(data){var c1=data.charCodeAt(0),c2=data.charCodeAt(1);if(c1==0xFF&&c2==0xFE)return utf16leread(data.slice(2));if(c1==0xFE&&c2==0xFF)return utf16beread(data.slice(2));if(c1==0xFEFF)return data.slice(1);return data;};var _getchar=function _gc1(x){return String.fromCharCode(x);};var _getansi=function _ga1(x){return String.fromCharCode(x);};if(typeof cptable!=='undefined'){set_cp=function(cp){current_codepage=cp;set_ansi(cp);};debom=function(data){if(data.charCodeAt(0)===0xFF&&data.charCodeAt(1)===0xFE){return cptable.utils.decode(1200,char_codes(data.slice(2)));}return data;};_getchar=function _gc2(x){if(current_codepage===1200)return String.fromCharCode(x);return cptable.utils.decode(current_codepage,[x&255,x>>8])[0];};_getansi=function _ga2(x){return cptable.utils.decode(current_ansi,[x])[0];};}var Base64=function make_b64(){var map="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";return {encode:function(input){var o="";var c1=0,c2=0,c3=0,e1=0,e2=0,e3=0,e4=0;for(var i=0;i<input.length;){c1=input.charCodeAt(i++);e1=c1>>2;c2=input.charCodeAt(i++);e2=(c1&3)<<4|c2>>4;c3=input.charCodeAt(i++);e3=(c2&15)<<2|c3>>6;e4=c3&63;if(isNaN(c2)){e3=e4=64;}else if(isNaN(c3)){e4=64;}o+=map.charAt(e1)+map.charAt(e2)+map.charAt(e3)+map.charAt(e4);}return o;},decode:function b64_decode(input){var o="";var c1=0,c2=0,c3=0,e1=0,e2=0,e3=0,e4=0;input=input.replace(/[^\w\+\/\=]/g,"");for(var i=0;i<input.length;){e1=map.indexOf(input.charAt(i++));e2=map.indexOf(input.charAt(i++));c1=e1<<2|e2>>4;o+=String.fromCharCode(c1);e3=map.indexOf(input.charAt(i++));c2=(e2&15)<<4|e3>>2;if(e3!==64){o+=String.fromCharCode(c2);}e4=map.indexOf(input.charAt(i++));c3=(e3&3)<<6|e4;if(e4!==64){o+=String.fromCharCode(c3);}}return o;}};}();var has_buf=typeof Buffer!=='undefined'&&typeof process!=='undefined'&&typeof process.versions!=='undefined'&&!!process.versions.node;var Buffer_from=function(){};if(typeof Buffer!=='undefined'){var nbfs=!Buffer.from;if(!nbfs)try{Buffer.from("foo","utf8");}catch(e){nbfs=true;}Buffer_from=nbfs?function(buf,enc){return enc?new Buffer(buf,enc):new Buffer(buf);}:Buffer.from.bind(Buffer);// $FlowIgnore
if(!Buffer.alloc)Buffer.alloc=function(n){return new Buffer(n);};// $FlowIgnore
if(!Buffer.allocUnsafe)Buffer.allocUnsafe=function(n){return new Buffer(n);};}function new_raw_buf(len){/* jshint -W056 */return has_buf?Buffer.alloc(len):new Array(len);/* jshint +W056 */}function new_unsafe_buf(len){/* jshint -W056 */return has_buf?Buffer.allocUnsafe(len):new Array(len);/* jshint +W056 */}var s2a=function s2a(s){if(has_buf)return Buffer_from(s,"binary");return s.split("").map(function(x){return x.charCodeAt(0)&0xff;});};function s2ab(s){if(typeof ArrayBuffer==='undefined')return s2a(s);var buf=new ArrayBuffer(s.length),view=new Uint8Array(buf);for(var i=0;i!=s.length;++i)view[i]=s.charCodeAt(i)&0xFF;return buf;}function a2s(data){if(Array.isArray(data))return data.map(function(c){return String.fromCharCode(c);}).join("");var o=[];for(var i=0;i<data.length;++i)o[i]=String.fromCharCode(data[i]);return o.join("");}function a2u(data){if(typeof Uint8Array==='undefined')throw new Error("Unsupported");return new Uint8Array(data);}function ab2a(data){if(typeof ArrayBuffer=='undefined')throw new Error("Unsupported");if(data instanceof ArrayBuffer)return ab2a(new Uint8Array(data));var o=new Array(data.length);for(var i=0;i<data.length;++i)o[i]=data[i];return o;}var bconcat=function(bufs){return [].concat.apply([],bufs);};var chr0=/\u0000/g,chr1=/[\u0001-\u0006]/g;/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */var SSF={};var make_ssf=function make_ssf(SSF){SSF.version='0.11.2';function _strrev(x){var o="",i=x.length-1;while(i>=0)o+=x.charAt(i--);return o;}function fill(c,l){var o="";while(o.length<l)o+=c;return o;}function pad0(v,d){var t=""+v;return t.length>=d?t:fill('0',d-t.length)+t;}function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}function rpad_(v,d){var t=""+v;return t.length>=d?t:t+fill(' ',d-t.length);}function pad0r1(v,d){var t=""+Math.round(v);return t.length>=d?t:fill('0',d-t.length)+t;}function pad0r2(v,d){var t=""+v;return t.length>=d?t:fill('0',d-t.length)+t;}var p2_32=Math.pow(2,32);function pad0r(v,d){if(v>p2_32||v<-p2_32)return pad0r1(v,d);var i=Math.round(v);return pad0r2(i,d);}function isgeneral(s,i){i=i||0;return s.length>=7+i&&(s.charCodeAt(i)|32)===103&&(s.charCodeAt(i+1)|32)===101&&(s.charCodeAt(i+2)|32)===110&&(s.charCodeAt(i+3)|32)===101&&(s.charCodeAt(i+4)|32)===114&&(s.charCodeAt(i+5)|32)===97&&(s.charCodeAt(i+6)|32)===108;}var days=[['Sun','Sunday'],['Mon','Monday'],['Tue','Tuesday'],['Wed','Wednesday'],['Thu','Thursday'],['Fri','Friday'],['Sat','Saturday']];var months=[['J','Jan','January'],['F','Feb','February'],['M','Mar','March'],['A','Apr','April'],['M','May','May'],['J','Jun','June'],['J','Jul','July'],['A','Aug','August'],['S','Sep','September'],['O','Oct','October'],['N','Nov','November'],['D','Dec','December']];function init_table(t){t[0]='General';t[1]='0';t[2]='0.00';t[3]='#,##0';t[4]='#,##0.00';t[9]='0%';t[10]='0.00%';t[11]='0.00E+00';t[12]='# ?/?';t[13]='# ??/??';t[14]='m/d/yy';t[15]='d-mmm-yy';t[16]='d-mmm';t[17]='mmm-yy';t[18]='h:mm AM/PM';t[19]='h:mm:ss AM/PM';t[20]='h:mm';t[21]='h:mm:ss';t[22]='m/d/yy h:mm';t[37]='#,##0 ;(#,##0)';t[38]='#,##0 ;[Red](#,##0)';t[39]='#,##0.00;(#,##0.00)';t[40]='#,##0.00;[Red](#,##0.00)';t[45]='mm:ss';t[46]='[h]:mm:ss';t[47]='mmss.0';t[48]='##0.0E+0';t[49]='@';t[56]='"上午/下午 "hh"時"mm"分"ss"秒 "';}var table_fmt={};init_table(table_fmt);/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */var default_map=[];var defi=0;//  5 -> 37 ...  8 -> 40
for(defi=5;defi<=8;++defi)default_map[defi]=32+defi;// 23 ->  0 ... 26 ->  0
for(defi=23;defi<=26;++defi)default_map[defi]=0;// 27 -> 14 ... 31 -> 14
for(defi=27;defi<=31;++defi)default_map[defi]=14;// 50 -> 14 ... 58 -> 14
for(defi=50;defi<=58;++defi)default_map[defi]=14;// 59 ->  1 ... 62 ->  4
for(defi=59;defi<=62;++defi)default_map[defi]=defi-58;// 67 ->  9 ... 68 -> 10
for(defi=67;defi<=68;++defi)default_map[defi]=defi-58;// 72 -> 14 ... 75 -> 17
for(defi=72;defi<=75;++defi)default_map[defi]=defi-58;// 69 -> 12 ... 71 -> 14
for(defi=67;defi<=68;++defi)default_map[defi]=defi-57;// 76 -> 20 ... 78 -> 22
for(defi=76;defi<=78;++defi)default_map[defi]=defi-56;// 79 -> 45 ... 81 -> 47
for(defi=79;defi<=81;++defi)default_map[defi]=defi-34;// 82 ->  0 ... 65536 -> 0 (omitted)
/* These formats technically refer to Accounting formats with no equivalent */var default_str=[];//  5 -- Currency,   0 decimal, black negative
default_str[5]=default_str[63]='"$"#,##0_);\\("$"#,##0\\)';//  6 -- Currency,   0 decimal, red   negative
default_str[6]=default_str[64]='"$"#,##0_);[Red]\\("$"#,##0\\)';//  7 -- Currency,   2 decimal, black negative
default_str[7]=default_str[65]='"$"#,##0.00_);\\("$"#,##0.00\\)';//  8 -- Currency,   2 decimal, red   negative
default_str[8]=default_str[66]='"$"#,##0.00_);[Red]\\("$"#,##0.00\\)';// 41 -- Accounting, 0 decimal, No Symbol
default_str[41]='_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)';// 42 -- Accounting, 0 decimal, $  Symbol
default_str[42]='_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)';// 43 -- Accounting, 2 decimal, No Symbol
default_str[43]='_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)';// 44 -- Accounting, 2 decimal, $  Symbol
default_str[44]='_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)';function frac(x,D,mixed){var sgn=x<0?-1:1;var B=x*sgn;var P_2=0,P_1=1,P=0;var Q_2=1,Q_1=0,Q=0;var A=Math.floor(B);while(Q_1<D){A=Math.floor(B);P=A*P_1+P_2;Q=A*Q_1+Q_2;if(B-A<0.00000005)break;B=1/(B-A);P_2=P_1;P_1=P;Q_2=Q_1;Q_1=Q;}if(Q>D){if(Q_1>D){Q=Q_2;P=P_2;}else {Q=Q_1;P=P_1;}}if(!mixed)return [0,sgn*P,Q];var q=Math.floor(sgn*P/Q);return [q,sgn*P-q*Q,Q];}function parse_date_code(v,opts,b2){if(v>2958465||v<0)return null;var date=v|0,time=Math.floor(86400*(v-date)),dow=0;var dout=[];var out={D:date,T:time,u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};if(Math.abs(out.u)<1e-6)out.u=0;if(opts&&opts.date1904)date+=1462;if(out.u>0.9999){out.u=0;if(++time==86400){out.T=time=0;++date;++out.D;}}if(date===60){dout=b2?[1317,10,29]:[1900,2,29];dow=3;}else if(date===0){dout=b2?[1317,8,29]:[1900,1,0];dow=6;}else {if(date>60)--date;/* 1 = Jan 1 1900 in Gregorian */var d=new Date(1900,0,1);d.setDate(d.getDate()+date-1);dout=[d.getFullYear(),d.getMonth()+1,d.getDate()];dow=d.getDay();if(date<60)dow=(dow+6)%7;if(b2)dow=fix_hijri(d,dout);}out.y=dout[0];out.m=dout[1];out.d=dout[2];out.S=time%60;time=Math.floor(time/60);out.M=time%60;time=Math.floor(time/60);out.H=time;out.q=dow;return out;}SSF.parse_date_code=parse_date_code;var basedate=new Date(1899,11,31,0,0,0);var dnthresh=basedate.getTime();var base1904=new Date(1900,2,1,0,0,0);function datenum_local(v,date1904){var epoch=v.getTime();if(date1904)epoch-=1461*24*60*60*1000;else if(v>=base1904)epoch+=24*60*60*1000;return (epoch-(dnthresh+(v.getTimezoneOffset()-basedate.getTimezoneOffset())*60000))/(24*60*60*1000);}/* The longest 32-bit integer text is "-4294967296", exactly 11 chars */function general_fmt_int(v){return v.toString(10);}SSF._general_int=general_fmt_int;/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */var general_fmt_num=function make_general_fmt_num(){var trailing_zeroes_and_decimal=/(?:\.0*|(\.\d*[1-9])0+)$/;function strip_decimal(o){return o.indexOf(".")==-1?o:o.replace(trailing_zeroes_and_decimal,"$1");}/* General Exponential always shows 2 digits exp and trims the mantissa */var mantissa_zeroes_and_decimal=/(?:\.0*|(\.\d*[1-9])0+)[Ee]/;var exp_with_single_digit=/(E[+-])(\d)$/;function normalize_exp(o){if(o.indexOf("E")==-1)return o;return o.replace(mantissa_zeroes_and_decimal,"$1E").replace(exp_with_single_digit,"$10$2");}/* exponent >= -9 and <= 9 */function small_exp(v){var w=v<0?12:11;var o=strip_decimal(v.toFixed(12));if(o.length<=w)return o;o=v.toPrecision(10);if(o.length<=w)return o;return v.toExponential(5);}/* exponent >= 11 or <= -10 likely exponential */function large_exp(v){var o=strip_decimal(v.toFixed(11));return o.length>(v<0?12:11)||o==="0"||o==="-0"?v.toPrecision(6):o;}function general_fmt_num_base(v){var V=Math.floor(Math.log(Math.abs(v))*Math.LOG10E),o;if(V>=-4&&V<=-1)o=v.toPrecision(10+V);else if(Math.abs(V)<=9)o=small_exp(v);else if(V===10)o=v.toFixed(10).substr(0,12);else o=large_exp(v);return strip_decimal(normalize_exp(o.toUpperCase()));}return general_fmt_num_base;}();SSF._general_num=general_fmt_num;/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	TODO: technically the display depends on the width of the cell
*/function general_fmt(v,opts){switch(typeof v){case'string':return v;case'boolean':return v?"TRUE":"FALSE";case'number':return (v|0)===v?v.toString(10):general_fmt_num(v);case'undefined':return "";case'object':if(v==null)return "";if(v instanceof Date)return format(14,datenum_local(v,opts&&opts.date1904),opts);}throw new Error("unsupported value in General format: "+v);}SSF._general=general_fmt;function fix_hijri(date,o){/* TODO: properly adjust y/m/d and  */o[0]-=581;var dow=date.getDay();if(date<60)dow=(dow+6)%7;return dow;}//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
/*jshint -W086 */function write_date(type,fmt,val,ss0){var o="",ss=0,tt=0,y=val.y,out,outl=0;switch(type){case 98:/* 'b' buddhist year */y=val.y+543;/* falls through */case 121:/* 'y' year */switch(fmt.length){case 1:case 2:out=y%100;outl=2;break;default:out=y%10000;outl=4;break;}break;case 109:/* 'm' month */switch(fmt.length){case 1:case 2:out=val.m;outl=fmt.length;break;case 3:return months[val.m-1][1];case 5:return months[val.m-1][0];default:return months[val.m-1][2];}break;case 100:/* 'd' day */switch(fmt.length){case 1:case 2:out=val.d;outl=fmt.length;break;case 3:return days[val.q][0];default:return days[val.q][1];}break;case 104:/* 'h' 12-hour */switch(fmt.length){case 1:case 2:out=1+(val.H+11)%12;outl=fmt.length;break;default:throw 'bad hour format: '+fmt;}break;case 72:/* 'H' 24-hour */switch(fmt.length){case 1:case 2:out=val.H;outl=fmt.length;break;default:throw 'bad hour format: '+fmt;}break;case 77:/* 'M' minutes */switch(fmt.length){case 1:case 2:out=val.M;outl=fmt.length;break;default:throw 'bad minute format: '+fmt;}break;case 115:/* 's' seconds */if(fmt!='s'&&fmt!='ss'&&fmt!='.0'&&fmt!='.00'&&fmt!='.000')throw 'bad second format: '+fmt;if(val.u===0&&(fmt=="s"||fmt=="ss"))return pad0(val.S,fmt.length);if(ss0>=2)tt=ss0===3?1000:100;else tt=ss0===1?10:1;ss=Math.round(tt*(val.S+val.u));if(ss>=60*tt)ss=0;if(fmt==='s')return ss===0?"0":""+ss/tt;o=pad0(ss,2+ss0);if(fmt==='ss')return o.substr(0,2);return "."+o.substr(2,fmt.length-1);case 90:/* 'Z' absolute time */switch(fmt){case'[h]':case'[hh]':out=val.D*24+val.H;break;case'[m]':case'[mm]':out=(val.D*24+val.H)*60+val.M;break;case'[s]':case'[ss]':out=((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u);break;default:throw 'bad abstime format: '+fmt;}outl=fmt.length===3?1:2;break;case 101:/* 'e' era */out=y;outl=1;break;}var outstr=outl>0?pad0(out,outl):"";return outstr;}/*jshint +W086 */function commaify(s){var w=3;if(s.length<=w)return s;var j=s.length%w,o=s.substr(0,j);for(;j!=s.length;j+=w)o+=(o.length>0?",":"")+s.substr(j,w);return o;}var write_num=function make_write_num(){var pct1=/%/g;function write_num_pct(type,fmt,val){var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul);}function write_num_cm(type,fmt,val){var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44)--idx;return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)));}function write_num_exp(fmt,val){var o;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){if(val==0)return "0.0E+0";else if(val<0)return "-"+write_num_exp(fmt,-val);var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf('E');var ee=Math.floor(Math.log(val)*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(o.indexOf("e")===-1){var fakee=Math.floor(Math.log(val)*Math.LOG10E);if(o.indexOf(".")===-1)o=o.charAt(0)+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);while(o.substr(0,2)==="0."){o=o.charAt(0)+o.substr(2,period)+"."+o.substr(2+period);o=o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");}o=o.replace(/\+-/,"-");}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E";});}else o=val.toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o.charAt(o.length-1);if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E");}var frac1=/# (\?+)( ?)\/( ?)(\d+)/;function write_num_f1(r,aval,sign){var den=parseInt(r[4],10),rr=Math.round(aval*den),base=Math.floor(rr/den);var myn=rr-base*den,myd=den;return sign+(base===0?"":""+base)+" "+(myn===0?fill(" ",r[1].length+1+r[4].length):pad_(myn,r[1].length)+r[2]+"/"+r[3]+pad0(myd,r[4].length));}function write_num_f2(r,aval,sign){return sign+(aval===0?"":""+aval)+fill(" ",r[1].length+2+r[4].length);}var dec1=/^#*0*\.([0#]+)/;var closeparen=/\).*[0#]/;var phone=/\(###\) ###\\?-####/;function hashq(str){var o="",cc;for(var i=0;i!=str.length;++i)switch(cc=str.charCodeAt(i)){case 35:break;case 63:o+=" ";break;case 48:o+="0";break;default:o+=String.fromCharCode(cc);}return o;}function rnd(val,d){var dd=Math.pow(10,d);return ""+Math.round(val*dd)/dd;}function dec(val,d){var _frac=val-Math.floor(val),dd=Math.pow(10,d);if(d<(''+Math.round(_frac*dd)).length)return 0;return Math.round(_frac*dd);}function carry(val,d){if(d<(''+Math.round((val-Math.floor(val))*Math.pow(10,d))).length){return 1;}return 0;}function flr(val){if(val<2147483647&&val>-2147483648)return ""+(val>=0?val|0:val-1|0);return ""+Math.floor(val);}function write_num_flt(type,fmt,val){if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_flt('n',ffmt,val);return '('+write_num_flt('n',ffmt,-val)+')';}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm(type,fmt,val);if(fmt.indexOf('%')!==-1)return write_num_pct(type,fmt,val);if(fmt.indexOf('E')!==-1)return write_num_exp(fmt,val);if(fmt.charCodeAt(0)===36)return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);var o;var r,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0r(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=pad0r(val,0);if(o==="0")o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(frac1))return write_num_f1(r,aval,sign);if(fmt.match(/^#+0+$/))return sign+pad0r(aval,fmt.length-fmt.indexOf("0"));if(r=fmt.match(dec1)){o=rnd(val,r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$,$1){return "."+$1+fill("0",hashq(r[1]).length-$1.length);});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".");}fmt=fmt.replace(/^#+([0.])/,"$1");if(r=fmt.match(/^(0*)\.(#*)$/)){return sign+rnd(aval,r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");}if(r=fmt.match(/^#{1,3},##0(\.?)$/))return sign+commaify(pad0r(aval,0));if(r=fmt.match(/^#,##0\.([#0]*0)$/)){return val<0?"-"+write_num_flt(type,fmt,-val):commaify(""+(Math.floor(val)+carry(val,r[1].length)))+"."+pad0(dec(val,r[1].length),r[1].length);}if(r=fmt.match(/^#,#*,#0/))return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);if(r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/)){o=_strrev(write_num_flt(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));}if(fmt.match(phone)){o=write_num_flt(type,"##########",val);return "("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);}var oa="";if(r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(r[4].length,7);ff=frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",r[1],ff[1]);if(oa.charAt(oa.length-1)==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+r[2]+"/"+r[3];oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o;}if(r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length));}if(r=fmt.match(/^[#0?]+$/)){o=pad0r(val,0);if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(/^([#0?]+)\.([#0]+)$/)){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres));}if(r=fmt.match(/^00,000\.([#0]*0)$/)){ri=dec(val,r[1].length);return val<0?"-"+write_num_flt(type,fmt,-val):commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return "00,"+($$.length<3?pad0(0,3-$$.length):"")+$$;})+"."+pad0(ri,r[1].length);}switch(fmt){case"###,##0.00":return write_num_flt(type,"#,##0.00",val);case"###,###":case"##,###":case"#,###":var x=commaify(pad0r(aval,0));return x!=="0"?sign+x:"";case"###,###.00":return write_num_flt(type,"###,##0.00",val).replace(/^0\./,".");case"#,###.00":return write_num_flt(type,"#,##0.00",val).replace(/^0\./,".");}throw new Error("unsupported format |"+fmt+"|");}function write_num_cm2(type,fmt,val){var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44)--idx;return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)));}function write_num_pct2(type,fmt,val){var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul);}function write_num_exp2(fmt,val){var o;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){if(val==0)return "0.0E+0";else if(val<0)return "-"+write_num_exp2(fmt,-val);var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf('E');var ee=Math.floor(Math.log(val)*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(!o.match(/[Ee]/)){var fakee=Math.floor(Math.log(val)*Math.LOG10E);if(o.indexOf(".")===-1)o=o.charAt(0)+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);o=o.replace(/\+-/,"-");}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E";});}else o=val.toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o.charAt(o.length-1);if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E");}function write_num_int(type,fmt,val){if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_int('n',ffmt,val);return '('+write_num_int('n',ffmt,-val)+')';}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm2(type,fmt,val);if(fmt.indexOf('%')!==-1)return write_num_pct2(type,fmt,val);if(fmt.indexOf('E')!==-1)return write_num_exp2(fmt,val);if(fmt.charCodeAt(0)===36)return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);var o;var r,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=""+val;if(val===0)o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(frac1))return write_num_f2(r,aval,sign);if(fmt.match(/^#+0+$/))return sign+pad0(aval,fmt.length-fmt.indexOf("0"));if(r=fmt.match(dec1)){o=(""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));o=o.replace(/\.(\d*)$/,function($$,$1){return "."+$1+fill("0",hashq(r[1]).length-$1.length);});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".");}fmt=fmt.replace(/^#+([0.])/,"$1");if(r=fmt.match(/^(0*)\.(#*)$/)){return sign+(""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");}if(r=fmt.match(/^#{1,3},##0(\.?)$/))return sign+commaify(""+aval);if(r=fmt.match(/^#,##0\.([#0]*0)$/)){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val)+"."+fill('0',r[1].length);}if(r=fmt.match(/^#,#*,#0/))return write_num_int(type,fmt.replace(/^#,#*,/,""),val);if(r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/)){o=_strrev(write_num_int(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));}if(fmt.match(phone)){o=write_num_int(type,"##########",val);return "("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);}var oa="";if(r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(r[4].length,7);ff=frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",r[1],ff[1]);if(oa.charAt(oa.length-1)==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+r[2]+"/"+r[3];oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o;}if(r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length));}if(r=fmt.match(/^[#0?]+$/)){o=""+val;if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(/^([#0]+)\.([#0]+)$/)){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres));}if(r=fmt.match(/^00,000\.([#0]*0)$/)){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return "00,"+($$.length<3?pad0(0,3-$$.length):"")+$$;})+"."+pad0(0,r[1].length);}switch(fmt){case"###,###":case"##,###":case"#,###":var x=commaify(""+aval);return x!=="0"?sign+x:"";default:if(fmt.match(/\.[0#?]*$/))return write_num_int(type,fmt.slice(0,fmt.lastIndexOf(".")),val)+hashq(fmt.slice(fmt.lastIndexOf(".")));}throw new Error("unsupported format |"+fmt+"|");}return function write_num(type,fmt,val){return (val|0)===val?write_num_int(type,fmt,val):write_num_flt(type,fmt,val);};}();function split_fmt(fmt){var out=[];var in_str=false/*, cc*/;for(var i=0,j=0;i<fmt.length;++i)switch(/*cc=*/fmt.charCodeAt(i)){case 34:/* '"' */in_str=!in_str;break;case 95:case 42:case 92:/* '_' '*' '\\' */++i;break;case 59:/* ';' */out[out.length]=fmt.substr(j,i-j);j=i+1;}out[out.length]=fmt.substr(j);if(in_str===true)throw new Error("Format |"+fmt+"| unterminated string ");return out;}SSF._split=split_fmt;var abstime=/\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;function fmt_is_date(fmt){var i=0,/*cc = 0,*/c="",o="";while(i<fmt.length){switch(c=fmt.charAt(i)){case'G':if(isgeneral(fmt,i))i+=6;i++;break;case'"':for(;/*cc=*/fmt.charCodeAt(++i)!==34&&i<fmt.length;){/*empty*/}++i;break;case'\\':i+=2;break;case'_':i+=2;break;case'@':++i;break;case'B':case'b':if(fmt.charAt(i+1)==="1"||fmt.charAt(i+1)==="2")return true;/* falls through */case'M':case'D':case'Y':case'H':case'S':case'E':/* falls through */case'm':case'd':case'y':case'h':case's':case'e':case'g':return true;case'A':case'a':case'上':if(fmt.substr(i,3).toUpperCase()==="A/P")return true;if(fmt.substr(i,5).toUpperCase()==="AM/PM")return true;if(fmt.substr(i,5).toUpperCase()==="上午/下午")return true;++i;break;case'[':o=c;while(fmt.charAt(i++)!==']'&&i<fmt.length)o+=fmt.charAt(i);if(o.match(abstime))return true;break;case'.':/* falls through */case'0':case'#':while(i<fmt.length&&("0#?.,E+-%".indexOf(c=fmt.charAt(++i))>-1||c=='\\'&&fmt.charAt(i+1)=="-"&&"0#".indexOf(fmt.charAt(i+2))>-1)){/* empty */}break;case'?':while(fmt.charAt(++i)===c){/* empty */}break;case'*':++i;if(fmt.charAt(i)==' '||fmt.charAt(i)=='*')++i;break;case'(':case')':++i;break;case'1':case'2':case'3':case'4':case'5':case'6':case'7':case'8':case'9':while(i<fmt.length&&"0123456789".indexOf(fmt.charAt(++i))>-1){/* empty */}break;case' ':++i;break;default:++i;break;}}return false;}SSF.is_date=fmt_is_date;function eval_fmt(fmt,v,opts,flen){var out=[],o="",i=0,c="",lst='t',dt,j,cc;var hr='H';/* Tokenize */while(i<fmt.length){switch(c=fmt.charAt(i)){case'G':/* General */if(!isgeneral(fmt,i))throw new Error('unrecognized character '+c+' in '+fmt);out[out.length]={t:'G',v:'General'};i+=7;break;case'"':/* Literal text */for(o="";(cc=fmt.charCodeAt(++i))!==34&&i<fmt.length;)o+=String.fromCharCode(cc);out[out.length]={t:'t',v:o};++i;break;case'\\':var w=fmt.charAt(++i),t=w==="("||w===")"?w:'t';out[out.length]={t:t,v:w};++i;break;case'_':out[out.length]={t:'t',v:" "};i+=2;break;case'@':/* Text Placeholder */out[out.length]={t:'T',v:v};++i;break;case'B':case'b':if(fmt.charAt(i+1)==="1"||fmt.charAt(i+1)==="2"){if(dt==null){dt=parse_date_code(v,opts,fmt.charAt(i+1)==="2");if(dt==null)return "";}out[out.length]={t:'X',v:fmt.substr(i,2)};lst=c;i+=2;break;}/* falls through */case'M':case'D':case'Y':case'H':case'S':case'E':c=c.toLowerCase();/* falls through */case'm':case'd':case'y':case'h':case's':case'e':case'g':if(v<0)return "";if(dt==null){dt=parse_date_code(v,opts);if(dt==null)return "";}o=c;while(++i<fmt.length&&fmt.charAt(i).toLowerCase()===c)o+=c;if(c==='m'&&lst.toLowerCase()==='h')c='M';if(c==='h')c=hr;out[out.length]={t:c,v:o};lst=c;break;case'A':case'a':case'上':var q={t:c,v:c};if(dt==null)dt=parse_date_code(v,opts);if(fmt.substr(i,3).toUpperCase()==="A/P"){if(dt!=null)q.v=dt.H>=12?"P":"A";q.t='T';hr='h';i+=3;}else if(fmt.substr(i,5).toUpperCase()==="AM/PM"){if(dt!=null)q.v=dt.H>=12?"PM":"AM";q.t='T';i+=5;hr='h';}else if(fmt.substr(i,5).toUpperCase()==="上午/下午"){if(dt!=null)q.v=dt.H>=12?"下午":"上午";q.t='T';i+=5;hr='h';}else {q.t="t";++i;}if(dt==null&&q.t==='T')return "";out[out.length]=q;lst=c;break;case'[':o=c;while(fmt.charAt(i++)!==']'&&i<fmt.length)o+=fmt.charAt(i);if(o.slice(-1)!==']')throw 'unterminated "[" block: |'+o+'|';if(o.match(abstime)){if(dt==null){dt=parse_date_code(v,opts);if(dt==null)return "";}out[out.length]={t:'Z',v:o.toLowerCase()};lst=o.charAt(1);}else if(o.indexOf("$")>-1){o=(o.match(/\$([^-\[\]]*)/)||[])[1]||"$";if(!fmt_is_date(fmt))out[out.length]={t:'t',v:o};}break;/* Numbers */case'.':if(dt!=null){o=c;while(++i<fmt.length&&(c=fmt.charAt(i))==="0")o+=c;out[out.length]={t:'s',v:o};break;}/* falls through */case'0':case'#':o=c;while(++i<fmt.length&&"0#?.,E+-%".indexOf(c=fmt.charAt(i))>-1)o+=c;out[out.length]={t:'n',v:o};break;case'?':o=c;while(fmt.charAt(++i)===c)o+=c;out[out.length]={t:c,v:o};lst=c;break;case'*':++i;if(fmt.charAt(i)==' '||fmt.charAt(i)=='*')++i;break;// **
case'(':case')':out[out.length]={t:flen===1?'t':c,v:c};++i;break;case'1':case'2':case'3':case'4':case'5':case'6':case'7':case'8':case'9':o=c;while(i<fmt.length&&"0123456789".indexOf(fmt.charAt(++i))>-1)o+=fmt.charAt(i);out[out.length]={t:'D',v:o};break;case' ':out[out.length]={t:c,v:c};++i;break;case'$':out[out.length]={t:'t',v:'$'};++i;break;default:if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c)===-1)throw new Error('unrecognized character '+c+' in '+fmt);out[out.length]={t:'t',v:c};++i;break;}}/* Scan for date/time parts */var bt=0,ss0=0,ssm;for(i=out.length-1,lst='t';i>=0;--i){switch(out[i].t){case'h':case'H':out[i].t=hr;lst='h';if(bt<1)bt=1;break;case's':if(ssm=out[i].v.match(/\.0+$/))ss0=Math.max(ss0,ssm[0].length-1);if(bt<3)bt=3;/* falls through */case'd':case'y':case'M':case'e':lst=out[i].t;break;case'm':if(lst==='s'){out[i].t='M';if(bt<2)bt=2;}break;case'X':/*if(out[i].v === "B2");*/break;case'Z':if(bt<1&&out[i].v.match(/[Hh]/))bt=1;if(bt<2&&out[i].v.match(/[Mm]/))bt=2;if(bt<3&&out[i].v.match(/[Ss]/))bt=3;}}/* time rounding depends on presence of minute / second / usec fields */switch(bt){case 0:break;case 1:if(dt.u>=0.5){dt.u=0;++dt.S;}if(dt.S>=60){dt.S=0;++dt.M;}if(dt.M>=60){dt.M=0;++dt.H;}break;case 2:if(dt.u>=0.5){dt.u=0;++dt.S;}if(dt.S>=60){dt.S=0;++dt.M;}break;}/* replace fields */var nstr="",jj;for(i=0;i<out.length;++i){switch(out[i].t){case't':case'T':case' ':case'D':break;case'X':out[i].v="";out[i].t=";";break;case'd':case'm':case'y':case'h':case'H':case'M':case's':case'e':case'b':case'Z':out[i].v=write_date(out[i].t.charCodeAt(0),out[i].v,dt,ss0);out[i].t='t';break;case'n':case'?':jj=i+1;while(out[jj]!=null&&((c=out[jj].t)==="?"||c==="D"||(c===" "||c==="t")&&out[jj+1]!=null&&(out[jj+1].t==='?'||out[jj+1].t==="t"&&out[jj+1].v==='/')||out[i].t==='('&&(c===' '||c==='n'||c===')')||c==='t'&&(out[jj].v==='/'||out[jj].v===' '&&out[jj+1]!=null&&out[jj+1].t=='?'))){out[i].v+=out[jj].v;out[jj]={v:"",t:";"};++jj;}nstr+=out[i].v;i=jj-1;break;case'G':out[i].t='t';out[i].v=general_fmt(v,opts);break;}}var vv="",myv,ostr;if(nstr.length>0){if(nstr.charCodeAt(0)==40)/* '(' */{myv=v<0&&nstr.charCodeAt(0)===45?-v:v;ostr=write_num('n',nstr,myv);}else {myv=v<0&&flen>1?-v:v;ostr=write_num('n',nstr,myv);if(myv<0&&out[0]&&out[0].t=='t'){ostr=ostr.substr(1);out[0].v="-"+out[0].v;}}jj=ostr.length-1;var decpt=out.length;for(i=0;i<out.length;++i)if(out[i]!=null&&out[i].t!='t'&&out[i].v.indexOf(".")>-1){decpt=i;break;}var lasti=out.length;if(decpt===out.length&&ostr.indexOf("E")===-1){for(i=out.length-1;i>=0;--i){if(out[i]==null||'n?'.indexOf(out[i].t)===-1)continue;if(jj>=out[i].v.length-1){jj-=out[i].v.length;out[i].v=ostr.substr(jj+1,out[i].v.length);}else if(jj<0)out[i].v="";else {out[i].v=ostr.substr(0,jj+1);jj=-1;}out[i].t='t';lasti=i;}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v;}else if(decpt!==out.length&&ostr.indexOf("E")===-1){jj=ostr.indexOf(".")-1;for(i=decpt;i>=0;--i){if(out[i]==null||'n?'.indexOf(out[i].t)===-1)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;vv=out[i].v.substr(j+1);for(;j>=0;--j){if(jj>=0&&(out[i].v.charAt(j)==="0"||out[i].v.charAt(j)==="#"))vv=ostr.charAt(jj--)+vv;}out[i].v=vv;out[i].t='t';lasti=i;}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v;jj=ostr.indexOf(".")+1;for(i=decpt;i<out.length;++i){if(out[i]==null||'n?('.indexOf(out[i].t)===-1&&i!==decpt)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;vv=out[i].v.substr(0,j);for(;j<out[i].v.length;++j){if(jj<ostr.length)vv+=ostr.charAt(jj++);}out[i].v=vv;out[i].t='t';lasti=i;}}}for(i=0;i<out.length;++i)if(out[i]!=null&&'n?'.indexOf(out[i].t)>-1){myv=flen>1&&v<0&&i>0&&out[i-1].v==="-"?-v:v;out[i].v=write_num(out[i].t,out[i].v,myv);out[i].t='t';}var retval="";for(i=0;i!==out.length;++i)if(out[i]!=null)retval+=out[i].v;return retval;}SSF._eval=eval_fmt;var cfregex=/\[[=<>]/;var cfregex2=/\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;function chkcond(v,rr){if(rr==null)return false;var thresh=parseFloat(rr[2]);switch(rr[1]){case"=":if(v==thresh)return true;break;case">":if(v>thresh)return true;break;case"<":if(v<thresh)return true;break;case"<>":if(v!=thresh)return true;break;case">=":if(v>=thresh)return true;break;case"<=":if(v<=thresh)return true;break;}return false;}function choose_fmt(f,v){var fmt=split_fmt(f);var l=fmt.length,lat=fmt[l-1].indexOf("@");if(l<4&&lat>-1)--l;if(fmt.length>4)throw new Error("cannot find right format for |"+fmt.join("|")+"|");if(typeof v!=="number")return [4,fmt.length===4||lat>-1?fmt[fmt.length-1]:"@"];switch(fmt.length){case 1:fmt=lat>-1?["General","General","General",fmt[0]]:[fmt[0],fmt[0],fmt[0],"@"];break;case 2:fmt=lat>-1?[fmt[0],fmt[0],fmt[0],fmt[1]]:[fmt[0],fmt[1],fmt[0],"@"];break;case 3:fmt=lat>-1?[fmt[0],fmt[1],fmt[0],fmt[2]]:[fmt[0],fmt[1],fmt[2],"@"];break;}var ff=v>0?fmt[0]:v<0?fmt[1]:fmt[2];if(fmt[0].indexOf("[")===-1&&fmt[1].indexOf("[")===-1)return [l,ff];if(fmt[0].match(cfregex)!=null||fmt[1].match(cfregex)!=null){var m1=fmt[0].match(cfregex2);var m2=fmt[1].match(cfregex2);return chkcond(v,m1)?[l,fmt[0]]:chkcond(v,m2)?[l,fmt[1]]:[l,fmt[m1!=null&&m2!=null?2:1]];}return [l,ff];}function format(fmt,v,o){if(o==null)o={};var sfmt="";switch(typeof fmt){case"string":if(fmt=="m/d/yy"&&o.dateNF)sfmt=o.dateNF;else sfmt=fmt;break;case"number":if(fmt==14&&o.dateNF)sfmt=o.dateNF;else sfmt=(o.table!=null?o.table:table_fmt)[fmt];if(sfmt==null)sfmt=o.table&&o.table[default_map[fmt]]||table_fmt[default_map[fmt]];if(sfmt==null)sfmt=default_str[fmt]||"General";break;}if(isgeneral(sfmt,0))return general_fmt(v,o);if(v instanceof Date)v=datenum_local(v,o.date1904);var f=choose_fmt(sfmt,v);if(isgeneral(f[1]))return general_fmt(v,o);if(v===true)v="TRUE";else if(v===false)v="FALSE";else if(v===""||v==null)return "";return eval_fmt(f[1],v,o,f[0]);}function load_entry(fmt,idx){if(typeof idx!='number'){idx=+idx||-1;for(var i=0;i<0x0188;++i){if(table_fmt[i]==undefined){if(idx<0)idx=i;continue;}if(table_fmt[i]==fmt){idx=i;break;}}if(idx<0)idx=0x187;}table_fmt[idx]=fmt;return idx;}SSF.load=load_entry;SSF._table=table_fmt;SSF.get_table=function get_table(){return table_fmt;};SSF.load_table=function load_table(tbl){for(var i=0;i!=0x0188;++i)if(tbl[i]!==undefined)load_entry(tbl[i],i);};SSF.init_table=init_table;SSF.format=format;};make_ssf(SSF);/* map from xlml named formats to SSF TODO: localize */var XLMLFormatMap/*{[string]:string}*/={"General Number":"General","General Date":SSF._table[22],"Long Date":"dddd, mmmm dd, yyyy","Medium Date":SSF._table[15],"Short Date":SSF._table[14],"Long Time":SSF._table[19],"Medium Time":SSF._table[18],"Short Time":SSF._table[20],"Currency":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"Fixed":SSF._table[2],"Standard":SSF._table[4],"Percent":SSF._table[10],"Scientific":SSF._table[11],"Yes/No":'"Yes";"Yes";"No";@',"True/False":'"True";"True";"False";@',"On/Off":'"Yes";"Yes";"No";@'};var SSFImplicit/*{[number]:string}*/={"5":'"$"#,##0_);\\("$"#,##0\\)',"6":'"$"#,##0_);[Red]\\("$"#,##0\\)',"7":'"$"#,##0.00_);\\("$"#,##0.00\\)',"8":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"23":'General',"24":'General',"25":'General',"26":'General',"27":'m/d/yy',"28":'m/d/yy',"29":'m/d/yy',"30":'m/d/yy',"31":'m/d/yy',"32":'h:mm:ss',"33":'h:mm:ss',"34":'h:mm:ss',"35":'h:mm:ss',"36":'m/d/yy',"41":'_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',"42":'_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',"43":'_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',"44":'_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',"50":'m/d/yy',"51":'m/d/yy',"52":'m/d/yy',"53":'m/d/yy',"54":'m/d/yy',"55":'m/d/yy',"56":'m/d/yy',"57":'m/d/yy',"58":'m/d/yy',"59":'0',"60":'0.00',"61":'#,##0',"62":'#,##0.00',"63":'"$"#,##0_);\\("$"#,##0\\)',"64":'"$"#,##0_);[Red]\\("$"#,##0\\)',"65":'"$"#,##0.00_);\\("$"#,##0.00\\)',"66":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"67":'0%',"68":'0.00%',"69":'# ?/?',"70":'# ??/??',"71":'m/d/yy',"72":'m/d/yy',"73":'d-mmm-yy',"74":'d-mmm',"75":'mmm-yy',"76":'h:mm',"77":'h:mm:ss',"78":'m/d/yy h:mm',"79":'mm:ss',"80":'[h]:mm:ss',"81":'mmss.0'};/* dateNF parse TODO: move to SSF */var dateNFregex=/[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;function dateNF_regex(dateNF){var fmt=typeof dateNF=="number"?SSF._table[dateNF]:dateNF;fmt=fmt.replace(dateNFregex,"(\\d+)");return new RegExp("^"+fmt+"$");}function dateNF_fix(str,dateNF,match){var Y=-1,m=-1,d=-1,H=-1,M=-1,S=-1;(dateNF.match(dateNFregex)||[]).forEach(function(n,i){var v=parseInt(match[i+1],10);switch(n.toLowerCase().charAt(0)){case'y':Y=v;break;case'd':d=v;break;case'h':H=v;break;case's':S=v;break;case'm':if(H>=0)M=v;else m=v;break;}});if(S>=0&&M==-1&&m>=0){M=m;m=-1;}var datestr=(""+(Y>=0?Y:new Date().getFullYear())).slice(-4)+"-"+("00"+(m>=1?m:1)).slice(-2)+"-"+("00"+(d>=1?d:1)).slice(-2);if(datestr.length==7)datestr="0"+datestr;if(datestr.length==8)datestr="20"+datestr;var timestr=("00"+(H>=0?H:0)).slice(-2)+":"+("00"+(M>=0?M:0)).slice(-2)+":"+("00"+(S>=0?S:0)).slice(-2);if(H==-1&&M==-1&&S==-1)return datestr;if(Y==-1&&m==-1&&d==-1)return timestr;return datestr+"T"+timestr;}var DO_NOT_EXPORT_CFB=true;/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */var CRC32;(function(factory){/*jshint ignore:start */ /*eslint-disable */factory(CRC32={});/*eslint-enable */ /*jshint ignore:end */})(function(CRC32){CRC32.version='1.2.0';/* see perf/crc32table.js */ /*global Int32Array */function signed_crc_table(){var c=0,table=new Array(256);for(var n=0;n!=256;++n){c=n;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;table[n]=c;}return typeof Int32Array!=='undefined'?new Int32Array(table):table;}var T=signed_crc_table();function crc32_bstr(bstr,seed){var C=seed^-1,L=bstr.length-1;for(var i=0;i<L;){C=C>>>8^T[(C^bstr.charCodeAt(i++))&0xFF];C=C>>>8^T[(C^bstr.charCodeAt(i++))&0xFF];}if(i===L)C=C>>>8^T[(C^bstr.charCodeAt(i))&0xFF];return C^-1;}function crc32_buf(buf,seed){if(buf.length>10000)return crc32_buf_8(buf,seed);var C=seed^-1,L=buf.length-3;for(var i=0;i<L;){C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];}while(i<L+3)C=C>>>8^T[(C^buf[i++])&0xFF];return C^-1;}function crc32_buf_8(buf,seed){var C=seed^-1,L=buf.length-7;for(var i=0;i<L;){C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];}while(i<L+7)C=C>>>8^T[(C^buf[i++])&0xFF];return C^-1;}function crc32_str(str,seed){var C=seed^-1;for(var i=0,L=str.length,c,d;i<L;){c=str.charCodeAt(i++);if(c<0x80){C=C>>>8^T[(C^c)&0xFF];}else if(c<0x800){C=C>>>8^T[(C^(192|c>>6&31))&0xFF];C=C>>>8^T[(C^(128|c&63))&0xFF];}else if(c>=0xD800&&c<0xE000){c=(c&1023)+64;d=str.charCodeAt(i++)&1023;C=C>>>8^T[(C^(240|c>>8&7))&0xFF];C=C>>>8^T[(C^(128|c>>2&63))&0xFF];C=C>>>8^T[(C^(128|d>>6&15|(c&3)<<4))&0xFF];C=C>>>8^T[(C^(128|d&63))&0xFF];}else {C=C>>>8^T[(C^(224|c>>12&15))&0xFF];C=C>>>8^T[(C^(128|c>>6&63))&0xFF];C=C>>>8^T[(C^(128|c&63))&0xFF];}}return C^-1;}CRC32.table=T;CRC32.bstr=crc32_bstr;CRC32.buf=crc32_buf;CRC32.str=crc32_str;});/* [MS-CFB] v20171201 */var CFB=function _CFB(){var exports={};exports.version='1.1.4';/* [MS-CFB] 2.6.4 */function namecmp(l,r){var L=l.split("/"),R=r.split("/");for(var i=0,c=0,Z=Math.min(L.length,R.length);i<Z;++i){if(c=L[i].length-R[i].length)return c;if(L[i]!=R[i])return L[i]<R[i]?-1:1;}return L.length-R.length;}function dirname(p){if(p.charAt(p.length-1)=="/")return p.slice(0,-1).indexOf("/")===-1?p:dirname(p.slice(0,-1));var c=p.lastIndexOf("/");return c===-1?p:p.slice(0,c+1);}function filename(p){if(p.charAt(p.length-1)=="/")return filename(p.slice(0,-1));var c=p.lastIndexOf("/");return c===-1?p:p.slice(c+1);}/* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */function write_dos_date(buf,date){if(typeof date==="string")date=new Date(date);var hms=date.getHours();hms=hms<<6|date.getMinutes();hms=hms<<5|date.getSeconds()>>>1;buf.write_shift(2,hms);var ymd=date.getFullYear()-1980;ymd=ymd<<4|date.getMonth()+1;ymd=ymd<<5|date.getDate();buf.write_shift(2,ymd);}/* read four bytes from buf and interpret as a DOS date */function parse_dos_date(buf){var hms=buf.read_shift(2)&0xFFFF;var ymd=buf.read_shift(2)&0xFFFF;var val=new Date();var d=ymd&0x1F;ymd>>>=5;var m=ymd&0x0F;ymd>>>=4;val.setMilliseconds(0);val.setFullYear(ymd+1980);val.setMonth(m-1);val.setDate(d);var S=hms&0x1F;hms>>>=5;var M=hms&0x3F;hms>>>=6;val.setHours(hms);val.setMinutes(M);val.setSeconds(S<<1);return val;}function parse_extra_field(blob){prep_blob(blob,0);var o={};var flags=0;while(blob.l<=blob.length-4){var type=blob.read_shift(2);var sz=blob.read_shift(2),tgt=blob.l+sz;var p={};switch(type){/* UNIX-style Timestamps */case 0x5455:{flags=blob.read_shift(1);if(flags&1)p.mtime=blob.read_shift(4);/* for some reason, CD flag corresponds to LFH */if(sz>5){if(flags&2)p.atime=blob.read_shift(4);if(flags&4)p.ctime=blob.read_shift(4);}if(p.mtime)p.mt=new Date(p.mtime*1000);}break;}blob.l=tgt;o[type]=p;}return o;}var fs$1;function get_fs(){return fs$1||(fs$1=fs);}function parse(file,options){if(file[0]==0x50&&file[1]==0x4b)return parse_zip(file,options);if(file.length<512)throw new Error("CFB file size "+file.length+" < 512");var mver=3;var ssz=512;var nmfs=0;// number of mini FAT sectors
var difat_sec_cnt=0;var dir_start=0;var minifat_start=0;var difat_start=0;var fat_addrs=[];// locations of FAT sectors
/* [MS-CFB] 2.2 Compound File Header */var blob=file.slice(0,512);prep_blob(blob,0);/* major version */var mv=check_get_mver(blob);mver=mv[0];switch(mver){case 3:ssz=512;break;case 4:ssz=4096;break;case 0:if(mv[1]==0)return parse_zip(file,options);/* falls through */default:throw new Error("Major Version: Expected 3 or 4 saw "+mver);}/* reprocess header */if(ssz!==512){blob=file.slice(0,ssz);prep_blob(blob,28/* blob.l */);}/* Save header for final object */var header=file.slice(0,ssz);check_shifts(blob,mver);// Number of Directory Sectors
var dir_cnt=blob.read_shift(4,'i');if(mver===3&&dir_cnt!==0)throw new Error('# Directory Sectors: Expected 0 saw '+dir_cnt);// Number of FAT Sectors
blob.l+=4;// First Directory Sector Location
dir_start=blob.read_shift(4,'i');// Transaction Signature
blob.l+=4;// Mini Stream Cutoff Size
blob.chk('00100000','Mini Stream Cutoff Size: ');// First Mini FAT Sector Location
minifat_start=blob.read_shift(4,'i');// Number of Mini FAT Sectors
nmfs=blob.read_shift(4,'i');// First DIFAT sector location
difat_start=blob.read_shift(4,'i');// Number of DIFAT Sectors
difat_sec_cnt=blob.read_shift(4,'i');// Grab FAT Sector Locations
for(var q=-1,j=0;j<109;++j){/* 109 = (512 - blob.l)>>>2; */q=blob.read_shift(4,'i');if(q<0)break;fat_addrs[j]=q;}/** Break the file up into sectors */var sectors=sectorify(file,ssz);sleuth_fat(difat_start,difat_sec_cnt,sectors,ssz,fat_addrs);/** Chains */var sector_list=make_sector_list(sectors,dir_start,fat_addrs,ssz);sector_list[dir_start].name="!Directory";if(nmfs>0&&minifat_start!==ENDOFCHAIN)sector_list[minifat_start].name="!MiniFAT";sector_list[fat_addrs[0]].name="!FAT";sector_list.fat_addrs=fat_addrs;sector_list.ssz=ssz;/* [MS-CFB] 2.6.1 Compound File Directory Entry */var files={},Paths=[],FileIndex=[],FullPaths=[];read_directory(dir_start,sector_list,sectors,Paths,nmfs,files,FileIndex,minifat_start);build_full_paths(FileIndex,FullPaths,Paths);Paths.shift();var o={FileIndex:FileIndex,FullPaths:FullPaths};// $FlowIgnore
if(options&&options.raw)o.raw={header:header,sectors:sectors};return o;}// parse
/* [MS-CFB] 2.2 Compound File Header -- read up to major version */function check_get_mver(blob){if(blob[blob.l]==0x50&&blob[blob.l+1]==0x4b)return [0,0];// header signature 8
blob.chk(HEADER_SIGNATURE,'Header Signature: ');// clsid 16
//blob.chk(HEADER_CLSID, 'CLSID: ');
blob.l+=16;// minor version 2
var mver=blob.read_shift(2,'u');return [blob.read_shift(2,'u'),mver];}function check_shifts(blob,mver){var shift=0x09;// Byte Order
//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
blob.l+=2;// Sector Shift
switch(shift=blob.read_shift(2)){case 0x09:if(mver!=3)throw new Error('Sector Shift: Expected 9 saw '+shift);break;case 0x0c:if(mver!=4)throw new Error('Sector Shift: Expected 12 saw '+shift);break;default:throw new Error('Sector Shift: Expected 9 or 12 saw '+shift);}// Mini Sector Shift
blob.chk('0600','Mini Sector Shift: ');// Reserved
blob.chk('000000000000','Reserved: ');}/** Break the file up into sectors */function sectorify(file,ssz){var nsectors=Math.ceil(file.length/ssz)-1;var sectors=[];for(var i=1;i<nsectors;++i)sectors[i-1]=file.slice(i*ssz,(i+1)*ssz);sectors[nsectors-1]=file.slice(nsectors*ssz);return sectors;}/* [MS-CFB] 2.6.4 Red-Black Tree */function build_full_paths(FI,FP,Paths){var i=0,L=0,R=0,C=0,j=0,pl=Paths.length;var dad=[],q=[];for(;i<pl;++i){dad[i]=q[i]=i;FP[i]=Paths[i];}for(;j<q.length;++j){i=q[j];L=FI[i].L;R=FI[i].R;C=FI[i].C;if(dad[i]===i){if(L!==-1/*NOSTREAM*/&&dad[L]!==L)dad[i]=dad[L];if(R!==-1&&dad[R]!==R)dad[i]=dad[R];}if(C!==-1/*NOSTREAM*/)dad[C]=i;if(L!==-1&&i!=dad[i]){dad[L]=dad[i];if(q.lastIndexOf(L)<j)q.push(L);}if(R!==-1&&i!=dad[i]){dad[R]=dad[i];if(q.lastIndexOf(R)<j)q.push(R);}}for(i=1;i<pl;++i)if(dad[i]===i){if(R!==-1/*NOSTREAM*/&&dad[R]!==R)dad[i]=dad[R];else if(L!==-1&&dad[L]!==L)dad[i]=dad[L];}for(i=1;i<pl;++i){if(FI[i].type===0/* unknown */)continue;j=i;if(j!=dad[j])do{j=dad[j];FP[i]=FP[j]+"/"+FP[i];}while(j!==0&&-1!==dad[j]&&j!=dad[j]);dad[i]=-1;}FP[0]+="/";for(i=1;i<pl;++i){if(FI[i].type!==2/* stream */)FP[i]+="/";}}function get_mfat_entry(entry,payload,mini){var start=entry.start,size=entry.size;//return (payload.slice(start*MSSZ, start*MSSZ + size));
var o=[];var idx=start;while(mini&&size>0&&idx>=0){o.push(payload.slice(idx*MSSZ,idx*MSSZ+MSSZ));size-=MSSZ;idx=__readInt32LE(mini,idx*4);}if(o.length===0)return new_buf(0);return bconcat(o).slice(0,entry.size);}/** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */function sleuth_fat(idx,cnt,sectors,ssz,fat_addrs){var q=ENDOFCHAIN;if(idx===ENDOFCHAIN){if(cnt!==0)throw new Error("DIFAT chain shorter than expected");}else if(idx!==-1/*FREESECT*/){var sector=sectors[idx],m=(ssz>>>2)-1;if(!sector)return;for(var i=0;i<m;++i){if((q=__readInt32LE(sector,i*4))===ENDOFCHAIN)break;fat_addrs.push(q);}sleuth_fat(__readInt32LE(sector,ssz-4),cnt-1,sectors,ssz,fat_addrs);}}/** Follow the linked list of sectors for a given starting point */function get_sector_list(sectors,start,fat_addrs,ssz,chkd){var buf=[],buf_chain=[];if(!chkd)chkd=[];var modulus=ssz-1,j=0,jj=0;for(j=start;j>=0;){chkd[j]=true;buf[buf.length]=j;buf_chain.push(sectors[j]);var addr=fat_addrs[Math.floor(j*4/ssz)];jj=j*4&modulus;if(ssz<4+jj)throw new Error("FAT boundary crossed: "+j+" 4 "+ssz);if(!sectors[addr])break;j=__readInt32LE(sectors[addr],jj);}return {nodes:buf,data:__toBuffer([buf_chain])};}/** Chase down the sector linked lists */function make_sector_list(sectors,dir_start,fat_addrs,ssz){var sl=sectors.length,sector_list=[];var chkd=[],buf=[],buf_chain=[];var modulus=ssz-1,i=0,j=0,k=0,jj=0;for(i=0;i<sl;++i){buf=[];k=i+dir_start;if(k>=sl)k-=sl;if(chkd[k])continue;buf_chain=[];var seen=[];for(j=k;j>=0;){seen[j]=true;chkd[j]=true;buf[buf.length]=j;buf_chain.push(sectors[j]);var addr=fat_addrs[Math.floor(j*4/ssz)];jj=j*4&modulus;if(ssz<4+jj)throw new Error("FAT boundary crossed: "+j+" 4 "+ssz);if(!sectors[addr])break;j=__readInt32LE(sectors[addr],jj);if(seen[j])break;}sector_list[k]={nodes:buf,data:__toBuffer([buf_chain])};}return sector_list;}/* [MS-CFB] 2.6.1 Compound File Directory Entry */function read_directory(dir_start,sector_list,sectors,Paths,nmfs,files,FileIndex,mini){var minifat_store=0,pl=Paths.length?2:0;var sector=sector_list[dir_start].data;var i=0,namelen=0,name;for(;i<sector.length;i+=128){var blob=sector.slice(i,i+128);prep_blob(blob,64);namelen=blob.read_shift(2);name=__utf16le(blob,0,namelen-pl);Paths.push(name);var o={name:name,type:blob.read_shift(1),color:blob.read_shift(1),L:blob.read_shift(4,'i'),R:blob.read_shift(4,'i'),C:blob.read_shift(4,'i'),clsid:blob.read_shift(16),state:blob.read_shift(4,'i'),start:0,size:0};var ctime=blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2);if(ctime!==0)o.ct=read_date(blob,blob.l-8);var mtime=blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2);if(mtime!==0)o.mt=read_date(blob,blob.l-8);o.start=blob.read_shift(4,'i');o.size=blob.read_shift(4,'i');if(o.size<0&&o.start<0){o.size=o.type=0;o.start=ENDOFCHAIN;o.name="";}if(o.type===5){/* root */minifat_store=o.start;if(nmfs>0&&minifat_store!==ENDOFCHAIN)sector_list[minifat_store].name="!StreamData";/*minifat_size = o.size;*/}else if(o.size>=4096/* MSCSZ */){o.storage='fat';if(sector_list[o.start]===undefined)sector_list[o.start]=get_sector_list(sectors,o.start,sector_list.fat_addrs,sector_list.ssz);sector_list[o.start].name=o.name;o.content=sector_list[o.start].data.slice(0,o.size);}else {o.storage='minifat';if(o.size<0)o.size=0;else if(minifat_store!==ENDOFCHAIN&&o.start!==ENDOFCHAIN&&sector_list[minifat_store]){o.content=get_mfat_entry(o,sector_list[minifat_store].data,(sector_list[mini]||{}).data);}}if(o.content)prep_blob(o.content,0);files[name]=o;FileIndex.push(o);}}function read_date(blob,offset){return new Date((__readUInt32LE(blob,offset+4)/1e7*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7-11644473600)*1000);}function read_file(filename,options){get_fs();return parse(fs$1.readFileSync(filename),options);}function read(blob,options){switch(options&&options.type||"base64"){case"file":return read_file(blob,options);case"base64":return parse(s2a(Base64.decode(blob)),options);case"binary":return parse(s2a(blob),options);}return parse(blob,options);}function init_cfb(cfb,opts){var o=opts||{},root=o.root||"Root Entry";if(!cfb.FullPaths)cfb.FullPaths=[];if(!cfb.FileIndex)cfb.FileIndex=[];if(cfb.FullPaths.length!==cfb.FileIndex.length)throw new Error("inconsistent CFB structure");if(cfb.FullPaths.length===0){cfb.FullPaths[0]=root+"/";cfb.FileIndex[0]={name:root,type:5};}if(o.CLSID)cfb.FileIndex[0].clsid=o.CLSID;seed_cfb(cfb);}function seed_cfb(cfb){var nm="\u0001Sh33tJ5";if(CFB.find(cfb,"/"+nm))return;var p=new_buf(4);p[0]=55;p[1]=p[3]=50;p[2]=54;cfb.FileIndex.push({name:nm,type:2,content:p,size:4,L:69,R:69,C:69});cfb.FullPaths.push(cfb.FullPaths[0]+nm);rebuild_cfb(cfb);}function rebuild_cfb(cfb,f){init_cfb(cfb);var gc=false,s=false;for(var i=cfb.FullPaths.length-1;i>=0;--i){var _file=cfb.FileIndex[i];switch(_file.type){case 0:if(s)gc=true;else {cfb.FileIndex.pop();cfb.FullPaths.pop();}break;case 1:case 2:case 5:s=true;if(isNaN(_file.R*_file.L*_file.C))gc=true;if(_file.R>-1&&_file.L>-1&&_file.R==_file.L)gc=true;break;default:gc=true;break;}}if(!gc&&!f)return;var now=new Date(1987,1,19),j=0;var data=[];for(i=0;i<cfb.FullPaths.length;++i){if(cfb.FileIndex[i].type===0)continue;data.push([cfb.FullPaths[i],cfb.FileIndex[i]]);}for(i=0;i<data.length;++i){var dad=dirname(data[i][0]);s=false;for(j=0;j<data.length;++j)if(data[j][0]===dad)s=true;if(!s)data.push([dad,{name:filename(dad).replace("/",""),type:1,clsid:HEADER_CLSID,ct:now,mt:now,content:null}]);}data.sort(function(x,y){return namecmp(x[0],y[0]);});cfb.FullPaths=[];cfb.FileIndex=[];for(i=0;i<data.length;++i){cfb.FullPaths[i]=data[i][0];cfb.FileIndex[i]=data[i][1];}for(i=0;i<data.length;++i){var elt=cfb.FileIndex[i];var nm=cfb.FullPaths[i];elt.name=filename(nm).replace("/","");elt.L=elt.R=elt.C=-(elt.color=1);elt.size=elt.content?elt.content.length:0;elt.start=0;elt.clsid=elt.clsid||HEADER_CLSID;if(i===0){elt.C=data.length>1?1:-1;elt.size=0;elt.type=5;}else if(nm.slice(-1)=="/"){for(j=i+1;j<data.length;++j)if(dirname(cfb.FullPaths[j])==nm)break;elt.C=j>=data.length?-1:j;for(j=i+1;j<data.length;++j)if(dirname(cfb.FullPaths[j])==dirname(nm))break;elt.R=j>=data.length?-1:j;elt.type=1;}else {if(dirname(cfb.FullPaths[i+1]||"")==dirname(nm))elt.R=i+1;elt.type=2;}}}function _write(cfb,options){var _opts=options||{};rebuild_cfb(cfb);if(_opts.fileType=='zip')return write_zip(cfb,_opts);var L=function(cfb){var mini_size=0,fat_size=0;for(var i=0;i<cfb.FileIndex.length;++i){var file=cfb.FileIndex[i];if(!file.content)continue;var flen=file.content.length;if(flen>0){if(flen<0x1000)mini_size+=flen+0x3F>>6;else fat_size+=flen+0x01FF>>9;}}var dir_cnt=cfb.FullPaths.length+3>>2;var mini_cnt=mini_size+7>>3;var mfat_cnt=mini_size+0x7F>>7;var fat_base=mini_cnt+fat_size+dir_cnt+mfat_cnt;var fat_cnt=fat_base+0x7F>>7;var difat_cnt=fat_cnt<=109?0:Math.ceil((fat_cnt-109)/0x7F);while(fat_base+fat_cnt+difat_cnt+0x7F>>7>fat_cnt)difat_cnt=++fat_cnt<=109?0:Math.ceil((fat_cnt-109)/0x7F);var L=[1,difat_cnt,fat_cnt,mfat_cnt,dir_cnt,fat_size,mini_size,0];cfb.FileIndex[0].size=mini_size<<6;L[7]=(cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+(L[6]+7>>3);return L;}(cfb);var o=new_buf(L[7]<<9);var i=0,T=0;{for(i=0;i<8;++i)o.write_shift(1,HEADER_SIG[i]);for(i=0;i<8;++i)o.write_shift(2,0);o.write_shift(2,0x003E);o.write_shift(2,0x0003);o.write_shift(2,0xFFFE);o.write_shift(2,0x0009);o.write_shift(2,0x0006);for(i=0;i<3;++i)o.write_shift(2,0);o.write_shift(4,0);o.write_shift(4,L[2]);o.write_shift(4,L[0]+L[1]+L[2]+L[3]-1);o.write_shift(4,0);o.write_shift(4,1<<12);o.write_shift(4,L[3]?L[0]+L[1]+L[2]-1:ENDOFCHAIN);o.write_shift(4,L[3]);o.write_shift(-4,L[1]?L[0]-1:ENDOFCHAIN);o.write_shift(4,L[1]);for(i=0;i<109;++i)o.write_shift(-4,i<L[2]?L[1]+i:-1);}if(L[1]){for(T=0;T<L[1];++T){for(;i<236+T*127;++i)o.write_shift(-4,i<L[2]?L[1]+i:-1);o.write_shift(-4,T===L[1]-1?ENDOFCHAIN:T+1);}}var chainit=function(w){for(T+=w;i<T-1;++i)o.write_shift(-4,i+1);if(w){++i;o.write_shift(-4,ENDOFCHAIN);}};T=i=0;for(T+=L[1];i<T;++i)o.write_shift(-4,consts.DIFSECT);for(T+=L[2];i<T;++i)o.write_shift(-4,consts.FATSECT);chainit(L[3]);chainit(L[4]);var j=0,flen=0;var file=cfb.FileIndex[0];for(;j<cfb.FileIndex.length;++j){file=cfb.FileIndex[j];if(!file.content)continue;flen=file.content.length;if(flen<0x1000)continue;file.start=T;chainit(flen+0x01FF>>9);}chainit(L[6]+7>>3);while(o.l&0x1FF)o.write_shift(-4,consts.ENDOFCHAIN);T=i=0;for(j=0;j<cfb.FileIndex.length;++j){file=cfb.FileIndex[j];if(!file.content)continue;flen=file.content.length;if(!flen||flen>=0x1000)continue;file.start=T;chainit(flen+0x3F>>6);}while(o.l&0x1FF)o.write_shift(-4,consts.ENDOFCHAIN);for(i=0;i<L[4]<<2;++i){var nm=cfb.FullPaths[i];if(!nm||nm.length===0){for(j=0;j<17;++j)o.write_shift(4,0);for(j=0;j<3;++j)o.write_shift(4,-1);for(j=0;j<12;++j)o.write_shift(4,0);continue;}file=cfb.FileIndex[i];if(i===0)file.start=file.size?file.start-1:ENDOFCHAIN;var _nm=i===0&&_opts.root||file.name;flen=2*(_nm.length+1);o.write_shift(64,_nm,"utf16le");o.write_shift(2,flen);o.write_shift(1,file.type);o.write_shift(1,file.color);o.write_shift(-4,file.L);o.write_shift(-4,file.R);o.write_shift(-4,file.C);if(!file.clsid)for(j=0;j<4;++j)o.write_shift(4,0);else o.write_shift(16,file.clsid,"hex");o.write_shift(4,file.state||0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,file.start);o.write_shift(4,file.size);o.write_shift(4,0);}for(i=1;i<cfb.FileIndex.length;++i){file=cfb.FileIndex[i];if(file.size>=0x1000){o.l=file.start+1<<9;for(j=0;j<file.size;++j)o.write_shift(1,file.content[j]);for(;j&0x1FF;++j)o.write_shift(1,0);}}for(i=1;i<cfb.FileIndex.length;++i){file=cfb.FileIndex[i];if(file.size>0&&file.size<0x1000){for(j=0;j<file.size;++j)o.write_shift(1,file.content[j]);for(;j&0x3F;++j)o.write_shift(1,0);}}while(o.l<o.length)o.write_shift(1,0);return o;}/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */function find(cfb,path){var UCFullPaths=cfb.FullPaths.map(function(x){return x.toUpperCase();});var UCPaths=UCFullPaths.map(function(x){var y=x.split("/");return y[y.length-(x.slice(-1)=="/"?2:1)];});var k=false;if(path.charCodeAt(0)===47/* "/" */){k=true;path=UCFullPaths[0].slice(0,-1)+path;}else k=path.indexOf("/")!==-1;var UCPath=path.toUpperCase();var w=k===true?UCFullPaths.indexOf(UCPath):UCPaths.indexOf(UCPath);if(w!==-1)return cfb.FileIndex[w];var m=!UCPath.match(chr1);UCPath=UCPath.replace(chr0,'');if(m)UCPath=UCPath.replace(chr1,'!');for(w=0;w<UCFullPaths.length;++w){if((m?UCFullPaths[w].replace(chr1,'!'):UCFullPaths[w]).replace(chr0,'')==UCPath)return cfb.FileIndex[w];if((m?UCPaths[w].replace(chr1,'!'):UCPaths[w]).replace(chr0,'')==UCPath)return cfb.FileIndex[w];}return null;}/** CFB Constants */var MSSZ=64;/* Mini Sector Size = 1<<6 */ //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
/* 2.1 Compound File Sector Numbers and Types */var ENDOFCHAIN=-2;/* 2.2 Compound File Header */var HEADER_SIGNATURE='d0cf11e0a1b11ae1';var HEADER_SIG=[0xD0,0xCF,0x11,0xE0,0xA1,0xB1,0x1A,0xE1];var HEADER_CLSID='00000000000000000000000000000000';var consts={/* 2.1 Compund File Sector Numbers and Types */MAXREGSECT:-6,DIFSECT:-4,FATSECT:-3,ENDOFCHAIN:ENDOFCHAIN,FREESECT:-1,/* 2.2 Compound File Header */HEADER_SIGNATURE:HEADER_SIGNATURE,HEADER_MINOR_VERSION:'3e00',MAXREGSID:-6,NOSTREAM:-1,HEADER_CLSID:HEADER_CLSID,/* 2.6.1 Compound File Directory Entry */EntryTypes:['unknown','storage','stream','lockbytes','property','root']};function write_file(cfb,filename,options){get_fs();var o=_write(cfb,options);fs$1.writeFileSync(filename,o);}function a2s(o){var out=new Array(o.length);for(var i=0;i<o.length;++i)out[i]=String.fromCharCode(o[i]);return out.join("");}function write(cfb,options){var o=_write(cfb,options);switch(options&&options.type){case"file":get_fs();fs$1.writeFileSync(options.filename,o);return o;case"binary":return a2s(o);case"base64":return Base64.encode(a2s(o));}return o;}/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */var _zlib;function use_zlib(zlib){try{var InflateRaw=zlib.InflateRaw;var InflRaw=new InflateRaw();InflRaw._processChunk(new Uint8Array([3,0]),InflRaw._finishFlushFlag);if(InflRaw.bytesRead)_zlib=zlib;else throw new Error("zlib does not expose bytesRead");}catch(e){console.error("cannot use native zlib: "+(e.message||e));}}function _inflateRawSync(payload,usz){if(!_zlib)return _inflate(payload,usz);var InflateRaw=_zlib.InflateRaw;var InflRaw=new InflateRaw();var out=InflRaw._processChunk(payload.slice(payload.l),InflRaw._finishFlushFlag);payload.l+=InflRaw.bytesRead;return out;}function _deflateRawSync(payload){return _zlib?_zlib.deflateRawSync(payload):_deflate(payload);}var CLEN_ORDER=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */var LEN_LN=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258];/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */var DST_LN=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577];function bit_swap_8(n){var t=(n<<1|n<<11)&0x22110|(n<<5|n<<15)&0x88440;return (t>>16|t>>8|t)&0xFF;}var use_typed_arrays=typeof Uint8Array!=='undefined';var bitswap8=use_typed_arrays?new Uint8Array(1<<8):[];for(var q=0;q<1<<8;++q)bitswap8[q]=bit_swap_8(q);function bit_swap_n(n,b){var rev=bitswap8[n&0xFF];if(b<=8)return rev>>>8-b;rev=rev<<8|bitswap8[n>>8&0xFF];if(b<=16)return rev>>>16-b;rev=rev<<8|bitswap8[n>>16&0xFF];return rev>>>24-b;}/* helpers for unaligned bit reads */function read_bits_2(buf,bl){var w=bl&7,h=bl>>>3;return (buf[h]|(w<=6?0:buf[h+1]<<8))>>>w&0x03;}function read_bits_3(buf,bl){var w=bl&7,h=bl>>>3;return (buf[h]|(w<=5?0:buf[h+1]<<8))>>>w&0x07;}function read_bits_4(buf,bl){var w=bl&7,h=bl>>>3;return (buf[h]|(w<=4?0:buf[h+1]<<8))>>>w&0x0F;}function read_bits_5(buf,bl){var w=bl&7,h=bl>>>3;return (buf[h]|(w<=3?0:buf[h+1]<<8))>>>w&0x1F;}function read_bits_7(buf,bl){var w=bl&7,h=bl>>>3;return (buf[h]|(w<=1?0:buf[h+1]<<8))>>>w&0x7F;}/* works up to n = 3 * 8 + 1 = 25 */function read_bits_n(buf,bl,n){var w=bl&7,h=bl>>>3,f=(1<<n)-1;var v=buf[h]>>>w;if(n<8-w)return v&f;v|=buf[h+1]<<8-w;if(n<16-w)return v&f;v|=buf[h+2]<<16-w;if(n<24-w)return v&f;v|=buf[h+3]<<24-w;return v&f;}/* until ArrayBuffer#realloc is a thing, fake a realloc */function realloc(b,sz){var L=b.length,M=2*L>sz?2*L:sz+5,i=0;if(L>=sz)return b;if(has_buf){var o=new_unsafe_buf(M);// $FlowIgnore
if(b.copy)b.copy(o);else for(;i<b.length;++i)o[i]=b[i];return o;}else if(use_typed_arrays){var a=new Uint8Array(M);if(a.set)a.set(b);else for(;i<b.length;++i)a[i]=b[i];return a;}b.length=M;return b;}/* zero-filled arrays for older browsers */function zero_fill_array(n){var o=new Array(n);for(var i=0;i<n;++i)o[i]=0;return o;}var _deflate=function(){var _deflateRaw=function(){return function deflateRaw(data,out){var boff=0;while(boff<data.length){var L=Math.min(0xFFFF,data.length-boff);var h=boff+L==data.length;/* TODO: this is only type 0 stored */out.write_shift(1,+h);out.write_shift(2,L);out.write_shift(2,~L&0xFFFF);while(L-->0)out[out.l++]=data[boff++];}return out.l;};}();return function(data){var buf=new_buf(50+Math.floor(data.length*1.1));var off=_deflateRaw(data,buf);return buf.slice(0,off);};}();/* modified inflate function also moves original read head */ /* build tree (used for literals and lengths) */function build_tree(clens,cmap,MAX){var maxlen=1,w=0,i=0,j=0,ccode=0,L=clens.length;var bl_count=use_typed_arrays?new Uint16Array(32):zero_fill_array(32);for(i=0;i<32;++i)bl_count[i]=0;for(i=L;i<MAX;++i)clens[i]=0;L=clens.length;var ctree=use_typed_arrays?new Uint16Array(L):zero_fill_array(L);// []
/* build code tree */for(i=0;i<L;++i){bl_count[w=clens[i]]++;if(maxlen<w)maxlen=w;ctree[i]=0;}bl_count[0]=0;for(i=1;i<=maxlen;++i)bl_count[i+16]=ccode=ccode+bl_count[i-1]<<1;for(i=0;i<L;++i){ccode=clens[i];if(ccode!=0)ctree[i]=bl_count[ccode+16]++;}/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */var cleni=0;for(i=0;i<L;++i){cleni=clens[i];if(cleni!=0){ccode=bit_swap_n(ctree[i],maxlen)>>maxlen-cleni;for(j=(1<<maxlen+4-cleni)-1;j>=0;--j)cmap[ccode|j<<cleni]=cleni&15|i<<4;}}return maxlen;}var fix_lmap=use_typed_arrays?new Uint16Array(512):zero_fill_array(512);var fix_dmap=use_typed_arrays?new Uint16Array(32):zero_fill_array(32);if(!use_typed_arrays){for(var i=0;i<512;++i)fix_lmap[i]=0;for(i=0;i<32;++i)fix_dmap[i]=0;}(function(){var dlens=[];var i=0;for(;i<32;i++)dlens.push(5);build_tree(dlens,fix_dmap,32);var clens=[];i=0;for(;i<=143;i++)clens.push(8);for(;i<=255;i++)clens.push(9);for(;i<=279;i++)clens.push(7);for(;i<=287;i++)clens.push(8);build_tree(clens,fix_lmap,288);})();var dyn_lmap=use_typed_arrays?new Uint16Array(32768):zero_fill_array(32768);var dyn_dmap=use_typed_arrays?new Uint16Array(32768):zero_fill_array(32768);var dyn_cmap=use_typed_arrays?new Uint16Array(128):zero_fill_array(128);var dyn_len_1=1,dyn_len_2=1;/* 5.5.3 Expanding Huffman Codes */function dyn(data,boff){/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */var _HLIT=read_bits_5(data,boff)+257;boff+=5;var _HDIST=read_bits_5(data,boff)+1;boff+=5;var _HCLEN=read_bits_4(data,boff)+4;boff+=4;var w=0;/* grab and store code lengths */var clens=use_typed_arrays?new Uint8Array(19):zero_fill_array(19);var ctree=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];var maxlen=1;var bl_count=use_typed_arrays?new Uint8Array(8):zero_fill_array(8);var next_code=use_typed_arrays?new Uint8Array(8):zero_fill_array(8);var L=clens.length;/* 19 */for(var i=0;i<_HCLEN;++i){clens[CLEN_ORDER[i]]=w=read_bits_3(data,boff);if(maxlen<w)maxlen=w;bl_count[w]++;boff+=3;}/* build code tree */var ccode=0;bl_count[0]=0;for(i=1;i<=maxlen;++i)next_code[i]=ccode=ccode+bl_count[i-1]<<1;for(i=0;i<L;++i)if((ccode=clens[i])!=0)ctree[i]=next_code[ccode]++;/* cmap[7 bits from stream] = (off&7) + (lit<<3) */var cleni=0;for(i=0;i<L;++i){cleni=clens[i];if(cleni!=0){ccode=bitswap8[ctree[i]]>>8-cleni;for(var j=(1<<7-cleni)-1;j>=0;--j)dyn_cmap[ccode|j<<cleni]=cleni&7|i<<3;}}/* read literal and dist codes at once */var hcodes=[];maxlen=1;for(;hcodes.length<_HLIT+_HDIST;){ccode=dyn_cmap[read_bits_7(data,boff)];boff+=ccode&7;switch(ccode>>>=3){case 16:w=3+read_bits_2(data,boff);boff+=2;ccode=hcodes[hcodes.length-1];while(w-->0)hcodes.push(ccode);break;case 17:w=3+read_bits_3(data,boff);boff+=3;while(w-->0)hcodes.push(0);break;case 18:w=11+read_bits_7(data,boff);boff+=7;while(w-->0)hcodes.push(0);break;default:hcodes.push(ccode);if(maxlen<ccode)maxlen=ccode;break;}}/* build literal / length trees */var h1=hcodes.slice(0,_HLIT),h2=hcodes.slice(_HLIT);for(i=_HLIT;i<286;++i)h1[i]=0;for(i=_HDIST;i<30;++i)h2[i]=0;dyn_len_1=build_tree(h1,dyn_lmap,286);dyn_len_2=build_tree(h2,dyn_dmap,30);return boff;}/* return [ data, bytesRead ] */function inflate(data,usz){/* shortcircuit for empty buffer [0x03, 0x00] */if(data[0]==3&&!(data[1]&0x3)){return [new_raw_buf(usz),2];}/* bit offset */var boff=0;/* header includes final bit and type bits */var header=0;var outbuf=new_unsafe_buf(usz?usz:1<<18);var woff=0;var OL=outbuf.length>>>0;var max_len_1=0,max_len_2=0;while((header&1)==0){header=read_bits_3(data,boff);boff+=3;if(header>>>1==0){/* Stored block */if(boff&7)boff+=8-(boff&7);/* 2 bytes sz, 2 bytes bit inverse */var sz=data[boff>>>3]|data[(boff>>>3)+1]<<8;boff+=32;/* push sz bytes */if(!usz&&OL<woff+sz){outbuf=realloc(outbuf,woff+sz);OL=outbuf.length;}if(typeof data.copy==='function'){// $FlowIgnore
data.copy(outbuf,woff,boff>>>3,(boff>>>3)+sz);woff+=sz;boff+=8*sz;}else while(sz-->0){outbuf[woff++]=data[boff>>>3];boff+=8;}continue;}else if(header>>>1==1){/* Fixed Huffman */max_len_1=9;max_len_2=5;}else {/* Dynamic Huffman */boff=dyn(data,boff);max_len_1=dyn_len_1;max_len_2=dyn_len_2;}if(!usz&&OL<woff+32767){outbuf=realloc(outbuf,woff+32767);OL=outbuf.length;}for(;;){// while(true) is apparently out of vogue in modern JS circles
/* ingest code and move read head */var bits=read_bits_n(data,boff,max_len_1);var code=header>>>1==1?fix_lmap[bits]:dyn_lmap[bits];boff+=code&15;code>>>=4;/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */if((code>>>8&0xFF)===0)outbuf[woff++]=code;else if(code==256)break;else {code-=257;var len_eb=code<8?0:code-4>>2;if(len_eb>5)len_eb=0;var tgt=woff+LEN_LN[code];/* length extra bits */if(len_eb>0){tgt+=read_bits_n(data,boff,len_eb);boff+=len_eb;}/* dist code */bits=read_bits_n(data,boff,max_len_2);code=header>>>1==1?fix_dmap[bits]:dyn_dmap[bits];boff+=code&15;code>>>=4;var dst_eb=code<4?0:code-2>>1;var dst=DST_LN[code];/* dist extra bits */if(dst_eb>0){dst+=read_bits_n(data,boff,dst_eb);boff+=dst_eb;}/* in the common case, manual byte copy is faster than TA set / Buffer copy */if(!usz&&OL<tgt){outbuf=realloc(outbuf,tgt);OL=outbuf.length;}while(woff<tgt){outbuf[woff]=outbuf[woff-dst];++woff;}}}}return [usz?outbuf:outbuf.slice(0,woff),boff+7>>>3];}function _inflate(payload,usz){var data=payload.slice(payload.l||0);var out=inflate(data,usz);payload.l+=out[1];return out[0];}function warn_or_throw(wrn,msg){if(wrn){if(typeof console!=='undefined')console.error(msg);}else throw new Error(msg);}function parse_zip(file,options){var blob=file;prep_blob(blob,0);var FileIndex=[],FullPaths=[];var o={FileIndex:FileIndex,FullPaths:FullPaths};init_cfb(o,{root:options.root});/* find end of central directory, start just after signature */var i=blob.length-4;while((blob[i]!=0x50||blob[i+1]!=0x4b||blob[i+2]!=0x05||blob[i+3]!=0x06)&&i>=0)--i;blob.l=i+4;/* parse end of central directory */blob.l+=4;var fcnt=blob.read_shift(2);blob.l+=6;var start_cd=blob.read_shift(4);/* parse central directory */blob.l=start_cd;for(i=0;i<fcnt;++i){/* trust local file header instead of CD entry */blob.l+=20;var csz=blob.read_shift(4);var usz=blob.read_shift(4);var namelen=blob.read_shift(2);var efsz=blob.read_shift(2);var fcsz=blob.read_shift(2);blob.l+=8;var offset=blob.read_shift(4);var EF=parse_extra_field(blob.slice(blob.l+namelen,blob.l+namelen+efsz));blob.l+=namelen+efsz+fcsz;var L=blob.l;blob.l=offset+4;parse_local_file(blob,csz,usz,o,EF);blob.l=L;}return o;}/* head starts just after local file header signature */function parse_local_file(blob,csz,usz,o,EF){/* [local file header] */blob.l+=2;var flags=blob.read_shift(2);var meth=blob.read_shift(2);var date=parse_dos_date(blob);if(flags&0x2041)throw new Error("Unsupported ZIP encryption");var crc32=blob.read_shift(4);var _csz=blob.read_shift(4);var _usz=blob.read_shift(4);var namelen=blob.read_shift(2);var efsz=blob.read_shift(2);// TODO: flags & (1<<11) // UTF8
var name="";for(var i=0;i<namelen;++i)name+=String.fromCharCode(blob[blob.l++]);if(efsz){var ef=parse_extra_field(blob.slice(blob.l,blob.l+efsz));if((ef[0x5455]||{}).mt)date=ef[0x5455].mt;if(((EF||{})[0x5455]||{}).mt)date=EF[0x5455].mt;}blob.l+=efsz;/* [encryption header] */ /* [file data] */var data=blob.slice(blob.l,blob.l+_csz);switch(meth){case 8:data=_inflateRawSync(blob,_usz);break;case 0:break;default:throw new Error("Unsupported ZIP Compression method "+meth);}/* [data descriptor] */var wrn=false;if(flags&8){crc32=blob.read_shift(4);if(crc32==0x08074b50){crc32=blob.read_shift(4);wrn=true;}_csz=blob.read_shift(4);_usz=blob.read_shift(4);}if(_csz!=csz)warn_or_throw(wrn,"Bad compressed size: "+csz+" != "+_csz);if(_usz!=usz)warn_or_throw(wrn,"Bad uncompressed size: "+usz+" != "+_usz);var _crc32=CRC32.buf(data,0);if(crc32>>0!=_crc32>>0)warn_or_throw(wrn,"Bad CRC32 checksum: "+crc32+" != "+_crc32);cfb_add(o,name,data,{unsafe:true,mt:date});}function write_zip(cfb,options){var _opts=options||{};var out=[],cdirs=[];var o=new_buf(1);var method=_opts.compression?8:0,flags=0;var i=0,j=0;var start_cd=0,fcnt=0;var root=cfb.FullPaths[0],fp=root,fi=cfb.FileIndex[0];var crcs=[];var sz_cd=0;for(i=1;i<cfb.FullPaths.length;++i){fp=cfb.FullPaths[i].slice(root.length);fi=cfb.FileIndex[i];if(!fi.size||!fi.content||fp=="\u0001Sh33tJ5")continue;var start=start_cd;/* TODO: CP437 filename */var namebuf=new_buf(fp.length);for(j=0;j<fp.length;++j)namebuf.write_shift(1,fp.charCodeAt(j)&0x7F);namebuf=namebuf.slice(0,namebuf.l);crcs[fcnt]=CRC32.buf(fi.content,0);var outbuf=fi.content;if(method==8)outbuf=_deflateRawSync(outbuf);/* local file header */o=new_buf(30);o.write_shift(4,0x04034b50);o.write_shift(2,20);o.write_shift(2,flags);o.write_shift(2,method);/* TODO: last mod file time/date */if(fi.mt)write_dos_date(o,fi.mt);else o.write_shift(4,0);o.write_shift(-4,crcs[fcnt]);o.write_shift(4,outbuf.length);o.write_shift(4,fi.content.length);o.write_shift(2,namebuf.length);o.write_shift(2,0);start_cd+=o.length;out.push(o);start_cd+=namebuf.length;out.push(namebuf);/* TODO: encryption header ? */start_cd+=outbuf.length;out.push(outbuf);/* central directory */o=new_buf(46);o.write_shift(4,0x02014b50);o.write_shift(2,0);o.write_shift(2,20);o.write_shift(2,flags);o.write_shift(2,method);o.write_shift(4,0);/* TODO: last mod file time/date */o.write_shift(-4,crcs[fcnt]);o.write_shift(4,outbuf.length);o.write_shift(4,fi.content.length);o.write_shift(2,namebuf.length);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(4,0);o.write_shift(4,start);sz_cd+=o.l;cdirs.push(o);sz_cd+=namebuf.length;cdirs.push(namebuf);++fcnt;}/* end of central directory */o=new_buf(22);o.write_shift(4,0x06054b50);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,fcnt);o.write_shift(2,fcnt);o.write_shift(4,sz_cd);o.write_shift(4,start_cd);o.write_shift(2,0);return bconcat([bconcat(out),bconcat(cdirs),o]);}function cfb_new(opts){var o={};init_cfb(o,opts);return o;}function cfb_add(cfb,name,content,opts){var unsafe=opts&&opts.unsafe;if(!unsafe)init_cfb(cfb);var file=!unsafe&&CFB.find(cfb,name);if(!file){var fpath=cfb.FullPaths[0];if(name.slice(0,fpath.length)==fpath)fpath=name;else {if(fpath.slice(-1)!="/")fpath+="/";fpath=(fpath+name).replace("//","/");}file={name:filename(name),type:2};cfb.FileIndex.push(file);cfb.FullPaths.push(fpath);if(!unsafe)CFB.utils.cfb_gc(cfb);}file.content=content;file.size=content?content.length:0;if(opts){if(opts.CLSID)file.clsid=opts.CLSID;if(opts.mt)file.mt=opts.mt;if(opts.ct)file.ct=opts.ct;}return file;}function cfb_del(cfb,name){init_cfb(cfb);var file=CFB.find(cfb,name);if(file)for(var j=0;j<cfb.FileIndex.length;++j)if(cfb.FileIndex[j]==file){cfb.FileIndex.splice(j,1);cfb.FullPaths.splice(j,1);return true;}return false;}function cfb_mov(cfb,old_name,new_name){init_cfb(cfb);var file=CFB.find(cfb,old_name);if(file)for(var j=0;j<cfb.FileIndex.length;++j)if(cfb.FileIndex[j]==file){cfb.FileIndex[j].name=filename(new_name);cfb.FullPaths[j]=new_name;return true;}return false;}function cfb_gc(cfb){rebuild_cfb(cfb,true);}exports.find=find;exports.read=read;exports.parse=parse;exports.write=write;exports.writeFile=write_file;exports.utils={cfb_new:cfb_new,cfb_add:cfb_add,cfb_del:cfb_del,cfb_mov:cfb_mov,cfb_gc:cfb_gc,ReadShift:ReadShift,CheckField:CheckField,prep_blob:prep_blob,bconcat:bconcat,use_zlib:use_zlib,_deflateRaw:_deflate,_inflateRaw:_inflate,consts:consts};return exports;}();if(typeof commonjsRequire!=='undefined'&&'object'!=='undefined'&&typeof DO_NOT_EXPORT_CFB==='undefined'){module.exports=CFB;}var _fs;if(typeof commonjsRequire!=='undefined')try{_fs=fs;}catch(e){}/* normalize data for blob ctor */function blobify(data){if(typeof data==="string")return s2ab(data);if(Array.isArray(data))return a2u(data);return data;}/* write or download file */function write_dl(fname,payload,enc){/*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */if(typeof _fs!=='undefined'&&_fs.writeFileSync)return enc?_fs.writeFileSync(fname,payload,enc):_fs.writeFileSync(fname,payload);var data=enc=="utf8"?utf8write(payload):payload;if(typeof IE_SaveFile!=='undefined')return IE_SaveFile(data,fname);if(typeof Blob!=='undefined'){var blob=new Blob([blobify(data)],{type:"application/octet-stream"});if(typeof navigator!=='undefined'&&navigator.msSaveBlob)return navigator.msSaveBlob(blob,fname);if(typeof saveAs!=='undefined')return saveAs(blob,fname);if(typeof URL!=='undefined'&&typeof document!=='undefined'&&document.createElement&&URL.createObjectURL){var url=URL.createObjectURL(blob);if(typeof chrome==='object'&&typeof(chrome.downloads||{}).download=="function"){if(URL.revokeObjectURL&&typeof setTimeout!=='undefined')setTimeout(function(){URL.revokeObjectURL(url);},60000);return chrome.downloads.download({url:url,filename:fname,saveAs:true});}var a=document.createElement("a");if(a.download!=null){a.download=fname;a.href=url;document.body.appendChild(a);a.click();document.body.removeChild(a);if(URL.revokeObjectURL&&typeof setTimeout!=='undefined')setTimeout(function(){URL.revokeObjectURL(url);},60000);return url;}}}// $FlowIgnore
if(typeof $!=='undefined'&&typeof File!=='undefined'&&typeof Folder!=='undefined')try{// extendscript
// $FlowIgnore
var out=File(fname);out.open("w");out.encoding="binary";if(Array.isArray(payload))payload=a2s(payload);out.write(payload);out.close();return payload;}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e;}throw new Error("cannot save file "+fname);}/* read binary data from file */function read_binary(path){if(typeof _fs!=='undefined')return _fs.readFileSync(path);// $FlowIgnore
if(typeof $!=='undefined'&&typeof File!=='undefined'&&typeof Folder!=='undefined')try{// extendscript
// $FlowIgnore
var infile=File(path);infile.open("r");infile.encoding="binary";var data=infile.read();infile.close();return data;}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e;}throw new Error("Cannot access file "+path);}function keys(o){var ks=Object.keys(o),o2=[];for(var i=0;i<ks.length;++i)if(Object.prototype.hasOwnProperty.call(o,ks[i]))o2.push(ks[i]);return o2;}function evert_key(obj,key){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i)if(o[obj[K[i]][key]]==null)o[obj[K[i]][key]]=K[i];return o;}function evert(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i)o[obj[K[i]]]=K[i];return o;}function evert_num(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i)o[obj[K[i]]]=parseInt(K[i],10);return o;}function evert_arr(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i){if(o[obj[K[i]]]==null)o[obj[K[i]]]=[];o[obj[K[i]]].push(K[i]);}return o;}var basedate=new Date(1899,11,30,0,0,0);// 2209161600000
function datenum(v,date1904){var epoch=v.getTime();if(date1904)epoch-=1462*24*60*60*1000;var dnthresh=basedate.getTime()+(v.getTimezoneOffset()-basedate.getTimezoneOffset())*60000;return (epoch-dnthresh)/(24*60*60*1000);}var refdate=new Date();var dnthresh=basedate.getTime()+(refdate.getTimezoneOffset()-basedate.getTimezoneOffset())*60000;var refoffset=refdate.getTimezoneOffset();function numdate(v){var out=new Date();out.setTime(v*24*60*60*1000+dnthresh);if(out.getTimezoneOffset()!==refoffset){out.setTime(out.getTime()+(out.getTimezoneOffset()-refoffset)*60000);}return out;}/* ISO 8601 Duration */function parse_isodur(s){var sec=0,mt=0,time=false;var m=s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);if(!m)throw new Error("|"+s+"| is not an ISO8601 Duration");for(var i=1;i!=m.length;++i){if(!m[i])continue;mt=1;if(i>3)time=true;switch(m[i].slice(m[i].length-1)){case'Y':throw new Error("Unsupported ISO Duration Field: "+m[i].slice(m[i].length-1));case'D':mt*=24;/* falls through */case'H':mt*=60;/* falls through */case'M':if(!time)throw new Error("Unsupported ISO Duration Field: M");else mt*=60;}sec+=mt*parseInt(m[i],10);}return sec;}var good_pd_date=new Date('2017-02-19T19:06:09.000Z');if(isNaN(good_pd_date.getFullYear()))good_pd_date=new Date('2/19/17');var good_pd=good_pd_date.getFullYear()==2017;/* parses a date as a local date */function parseDate(str,fixdate){var d=new Date(str);if(good_pd){if(fixdate>0)d.setTime(d.getTime()+d.getTimezoneOffset()*60*1000);else if(fixdate<0)d.setTime(d.getTime()-d.getTimezoneOffset()*60*1000);return d;}if(str instanceof Date)return str;if(good_pd_date.getFullYear()==1917&&!isNaN(d.getFullYear())){var s=d.getFullYear();if(str.indexOf(""+s)>-1)return d;d.setFullYear(d.getFullYear()+100);return d;}var n=str.match(/\d+/g)||["2017","2","19","0","0","0"];var out=new Date(+n[0],+n[1]-1,+n[2],+n[3]||0,+n[4]||0,+n[5]||0);if(str.indexOf("Z")>-1)out=new Date(out.getTime()-out.getTimezoneOffset()*60*1000);return out;}function cc2str(arr){var o="";for(var i=0;i!=arr.length;++i)o+=String.fromCharCode(arr[i]);return o;}function dup(o){if(typeof JSON!='undefined'&&!Array.isArray(o))return JSON.parse(JSON.stringify(o));if(typeof o!='object'||o==null)return o;if(o instanceof Date)return new Date(o.getTime());var out={};for(var k in o)if(Object.prototype.hasOwnProperty.call(o,k))out[k]=dup(o[k]);return out;}function fill(c,l){var o="";while(o.length<l)o+=c;return o;}/* TODO: stress test */function fuzzynum(s){var v=Number(s);if(isFinite(v))return v;if(!isNaN(v))return NaN;if(!/\d/.test(s))return v;var wt=1;var ss=s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g,function(){wt*=100;return "";});if(!isNaN(v=Number(ss)))return v/wt;ss=ss.replace(/[(](.*)[)]/,function($$,$1){wt=-wt;return $1;});if(!isNaN(v=Number(ss)))return v/wt;return v;}function fuzzydate(s){var o=new Date(s),n=new Date(NaN);var y=o.getYear(),m=o.getMonth(),d=o.getDate();if(isNaN(d))return n;if(y<0||y>8099)return n;if((m>0||d>1)&&y!=101)return o;if(s.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/))return o;if(s.match(/[^-0-9:,\/\\]/))return n;return o;}var safe_split_regex="abacaba".split(/(:?b)/i).length==5;function split_regex(str,re,def){if(safe_split_regex||typeof re=="string")return str.split(re);var p=str.split(re),o=[p[0]];for(var i=1;i<p.length;++i){o.push(def);o.push(p[i]);}return o;}function getdatastr(data){if(!data)return null;if(data.data)return debom(data.data);if(data.asNodeBuffer&&has_buf)return debom(data.asNodeBuffer().toString('binary'));if(data.asBinary)return debom(data.asBinary());if(data._data&&data._data.getContent)return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));if(data.content&&data.type)return debom(cc2str(data.content));return null;}function getdatabin(data){if(!data)return null;if(data.data)return char_codes(data.data);if(data.asNodeBuffer&&has_buf)return data.asNodeBuffer();if(data._data&&data._data.getContent){var o=data._data.getContent();if(typeof o=="string")return char_codes(o);return Array.prototype.slice.call(o);}if(data.content&&data.type)return data.content;return null;}function getdata(data){return data&&data.name.slice(-4)===".bin"?getdatabin(data):getdatastr(data);}/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */function safegetzipfile(zip,file){var k=zip.FullPaths||keys(zip.files);var f=file.toLowerCase(),g=f.replace(/\//g,'\\');for(var i=0;i<k.length;++i){var n=k[i].toLowerCase();if(f==n||g==n)return zip.files[k[i]];}return null;}function getzipfile(zip,file){var o=safegetzipfile(zip,file);if(o==null)throw new Error("Cannot find file "+file+" in zip");return o;}function getzipdata(zip,file,safe){if(!safe)return getdata(getzipfile(zip,file));if(!file)return null;try{return getzipdata(zip,file);}catch(e){return null;}}function getzipstr(zip,file,safe){if(!safe)return getdatastr(getzipfile(zip,file));if(!file)return null;try{return getzipstr(zip,file);}catch(e){return null;}}function zipentries(zip){var k=zip.FullPaths||keys(zip.files),o=[];for(var i=0;i<k.length;++i)if(k[i].slice(-1)!='/')o.push(k[i]);return o.sort();}function zip_add_file(zip,path,content){if(zip.FullPaths)CFB.utils.cfb_add(zip,path,content);else zip.file(path,content);}var jszip$1;/*global JSZipSync:true */if(typeof JSZipSync!=='undefined')jszip$1=JSZipSync;{if(module.exports){if(typeof jszip$1==='undefined')jszip$1=jszip;}}function zip_new(){if(!jszip$1)return CFB.utils.cfb_new();return new jszip$1();}function zip_read(d,o){var zip;if(jszip$1)switch(o.type){case"base64":zip=new jszip$1(d,{base64:true});break;case"binary":case"array":zip=new jszip$1(d,{base64:false});break;case"buffer":zip=new jszip$1(d);break;default:throw new Error("Unrecognized type "+o.type);}else switch(o.type){case"base64":zip=CFB.read(d,{type:"base64"});break;case"binary":zip=CFB.read(d,{type:"binary"});break;case"buffer":case"array":zip=CFB.read(d,{type:"buffer"});break;default:throw new Error("Unrecognized type "+o.type);}return zip;}function resolve_path(path,base){if(path.charAt(0)=="/")return path.slice(1);var result=base.split('/');if(base.slice(-1)!="/")result.pop();// folder path
var target=path.split('/');while(target.length!==0){var step=target.shift();if(step==='..')result.pop();else if(step!=='.')result.push(step);}return result.join('/');}var XML_HEADER='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;var tagregex=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg;if(!XML_HEADER.match(tagregex))tagregex=/<[^>]*>/g;var nsregex=/<\w*:/,nsregex2=/<(\/?)\w+:/;function parsexmltag(tag,skip_root,skip_LC){var z={};var eq=0,c=0;for(;eq!==tag.length;++eq)if((c=tag.charCodeAt(eq))===32||c===10||c===13)break;if(!skip_root)z[0]=tag.slice(0,eq);if(eq===tag.length)return z;var m=tag.match(attregexg),j=0,v="",i=0,q="",cc="",quot=1;if(m)for(i=0;i!=m.length;++i){cc=m[i];for(c=0;c!=cc.length;++c)if(cc.charCodeAt(c)===61)break;q=cc.slice(0,c).trim();while(cc.charCodeAt(c+1)==32)++c;quot=(eq=cc.charCodeAt(c+1))==34||eq==39?1:0;v=cc.slice(c+1+quot,cc.length-quot);for(j=0;j!=q.length;++j)if(q.charCodeAt(j)===58)break;if(j===q.length){if(q.indexOf("_")>0)q=q.slice(0,q.indexOf("_"));// from ods
z[q]=v;if(!skip_LC)z[q.toLowerCase()]=v;}else {var k=(j===5&&q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);if(z[k]&&q.slice(j-3,j)=="ext")continue;// from ods
z[k]=v;if(!skip_LC)z[k.toLowerCase()]=v;}}return z;}function strip_ns(x){return x.replace(nsregex2,"<$1");}var encodings={'&quot;':'"','&apos;':"'",'&gt;':'>','&lt;':'<','&amp;':'&'};var rencoding=evert(encodings);//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var unescapexml=function(){/* 22.4.2.4 bstr (Basic String) */var encregex=/&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig,coderegex=/_x([\da-fA-F]{4})_/ig;return function unescapexml(text){var s=text+'',i=s.indexOf("<![CDATA[");if(i==-1)return s.replace(encregex,function($$,$1){return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$;}).replace(coderegex,function(m,c){return String.fromCharCode(parseInt(c,16));});var j=s.indexOf("]]>");return unescapexml(s.slice(0,i))+s.slice(i+9,j)+unescapexml(s.slice(j+3));};}();var decregex=/[&<>'"]/g,charegex=/[\u0000-\u0008\u000b-\u001f]/g;function escapexml(text){var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(charegex,function(s){return "_x"+("000"+s.charCodeAt(0).toString(16)).slice(-4)+"_";});}function escapexmltag(text){return escapexml(text).replace(/ /g,"_x0020_");}var htmlcharegex=/[\u0000-\u001f]/g;function escapehtml(text){var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(/\n/g,"<br/>").replace(htmlcharegex,function(s){return "&#x"+("000"+s.charCodeAt(0).toString(16)).slice(-4)+";";});}function escapexlml(text){var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(htmlcharegex,function(s){return "&#x"+s.charCodeAt(0).toString(16).toUpperCase()+";";});}/* TODO: handle codepages */var xlml_fixstr=function(){var entregex=/&#(\d+);/g;function entrepl($$,$1){return String.fromCharCode(parseInt($1,10));}return function xlml_fixstr(str){return str.replace(entregex,entrepl);};}();var xlml_unfixstr=function(){return function xlml_unfixstr(str){return str.replace(/(\r\n|[\r\n])/g,"\&#10;");};}();function parsexmlbool(value){switch(value){case 1:case true:case'1':case'true':case'TRUE':return true;/* case '0': case 'false': case 'FALSE':*/default:return false;}}var utf8read=function utf8reada(orig){var out="",i=0,c=0,d=0,e=0,f=0,w=0;while(i<orig.length){c=orig.charCodeAt(i++);if(c<128){out+=String.fromCharCode(c);continue;}d=orig.charCodeAt(i++);if(c>191&&c<224){f=(c&31)<<6;f|=d&63;out+=String.fromCharCode(f);continue;}e=orig.charCodeAt(i++);if(c<240){out+=String.fromCharCode((c&15)<<12|(d&63)<<6|e&63);continue;}f=orig.charCodeAt(i++);w=((c&7)<<18|(d&63)<<12|(e&63)<<6|f&63)-65536;out+=String.fromCharCode(0xD800+(w>>>10&1023));out+=String.fromCharCode(0xDC00+(w&1023));}return out;};var utf8write=function(orig){var out=[],i=0,c=0,d=0;while(i<orig.length){c=orig.charCodeAt(i++);switch(true){case c<128:out.push(String.fromCharCode(c));break;case c<2048:out.push(String.fromCharCode(192+(c>>6)));out.push(String.fromCharCode(128+(c&63)));break;case c>=55296&&c<57344:c-=55296;d=orig.charCodeAt(i++)-56320+(c<<10);out.push(String.fromCharCode(240+(d>>18&7)));out.push(String.fromCharCode(144+(d>>12&63)));out.push(String.fromCharCode(128+(d>>6&63)));out.push(String.fromCharCode(128+(d&63)));break;default:out.push(String.fromCharCode(224+(c>>12)));out.push(String.fromCharCode(128+(c>>6&63)));out.push(String.fromCharCode(128+(c&63)));}}return out.join("");};if(has_buf){var utf8readb=function utf8readb(data){var out=Buffer.alloc(2*data.length),w,i,j=1,k=0,ww=0,c;for(i=0;i<data.length;i+=j){j=1;if((c=data.charCodeAt(i))<128)w=c;else if(c<224){w=(c&31)*64+(data.charCodeAt(i+1)&63);j=2;}else if(c<240){w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63);j=3;}else {j=4;w=(c&7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);w-=65536;ww=0xD800+(w>>>10&1023);w=0xDC00+(w&1023);}if(ww!==0){out[k++]=ww&255;out[k++]=ww>>>8;ww=0;}out[k++]=w%256;out[k++]=w>>>8;}return out.slice(0,k).toString('ucs2');};var corpus="foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";if(utf8read(corpus)==utf8readb(corpus))utf8read=utf8readb;var utf8readc=function utf8readc(data){return Buffer_from(data,'binary').toString('utf8');};if(utf8read(corpus)==utf8readc(corpus))utf8read=utf8readc;utf8write=function(data){return Buffer_from(data,'utf8').toString("binary");};}// matches <foo>...</foo> extracts content
var matchtag=function(){var mtcache={};return function matchtag(f,g){var t=f+"|"+(g||"");if(mtcache[t])return mtcache[t];return mtcache[t]=new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',g||"");};}();var htmldecode=function(){var entities=[['nbsp',' '],['middot','·'],['quot','"'],['apos',"'"],['gt','>'],['lt','<'],['amp','&']].map(function(x){return [new RegExp('&'+x[0]+';',"ig"),x[1]];});return function htmldecode(str){var o=str// Remove new lines and spaces from start of content
.replace(/^[\t\n\r ]+/,"")// Remove new lines and spaces from end of content
.replace(/[\t\n\r ]+$/,"")// Added line which removes any white space characters after and before html tags
.replace(/>\s+/g,">").replace(/\s+</g,"<")// Replace remaining new lines and spaces with space
.replace(/[\t\n\r ]+/g," ")// Replace <br> tags with new lines
.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")// Strip HTML elements
.replace(/<[^>]*>/g,"");for(var i=0;i<entities.length;++i)o=o.replace(entities[i][0],entities[i][1]);return o;};}();var vtregex=function(){var vt_cache={};return function vt_regex(bt){if(vt_cache[bt]!==undefined)return vt_cache[bt];return vt_cache[bt]=new RegExp("<(?:vt:)?"+bt+">([\\s\\S]*?)</(?:vt:)?"+bt+">",'g');};}();var vtvregex=/<\/?(?:vt:)?variant>/g,vtmregex=/<(?:vt:)([^>]*)>([\s\S]*)</;function parseVector(data,opts){var h=parsexmltag(data);var matches=data.match(vtregex(h.baseType))||[];var res=[];if(matches.length!=h.size){if(opts.WTF)throw new Error("unexpected vector length "+matches.length+" != "+h.size);return res;}matches.forEach(function(x){var v=x.replace(vtvregex,"").match(vtmregex);if(v)res.push({v:utf8read(v[2]),t:v[1]});});return res;}var wtregex=/(^\s|\s$|\n)/;function writetag(f,g){return '<'+f+(g.match(wtregex)?' xml:space="preserve"':"")+'>'+g+'</'+f+'>';}function wxt_helper(h){return keys(h).map(function(k){return " "+k+'="'+h[k]+'"';}).join("");}function writextag(f,g,h){return '<'+f+(h!=null?wxt_helper(h):"")+(g!=null?(g.match(wtregex)?' xml:space="preserve"':"")+'>'+g+'</'+f:"/")+'>';}function write_w3cdtf(d,t){try{return d.toISOString().replace(/\.\d*/,"");}catch(e){if(t)throw e;}return "";}function write_vt(s,xlsx){switch(typeof s){case'string':var o=writextag('vt:lpwstr',escapexml(s));if(xlsx)o=o.replace(/&quot;/g,"_x0022_");return o;case'number':return writextag((s|0)==s?'vt:i4':'vt:r8',escapexml(String(s)));case'boolean':return writextag('vt:bool',s?'true':'false');}if(s instanceof Date)return writextag('vt:filetime',write_w3cdtf(s));throw new Error("Unable to serialize "+s);}var XMLNS={'dc':'http://purl.org/dc/elements/1.1/','dcterms':'http://purl.org/dc/terms/','dcmitype':'http://purl.org/dc/dcmitype/','mx':'http://schemas.microsoft.com/office/mac/excel/2008/main','r':'http://schemas.openxmlformats.org/officeDocument/2006/relationships','sjs':'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties','vt':'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes','xsi':'http://www.w3.org/2001/XMLSchema-instance','xsd':'http://www.w3.org/2001/XMLSchema'};XMLNS.main=['http://schemas.openxmlformats.org/spreadsheetml/2006/main','http://purl.oclc.org/ooxml/spreadsheetml/main','http://schemas.microsoft.com/office/excel/2006/main','http://schemas.microsoft.com/office/excel/2006/2'];var XLMLNS={'o':'urn:schemas-microsoft-com:office:office','x':'urn:schemas-microsoft-com:office:excel','ss':'urn:schemas-microsoft-com:office:spreadsheet','dt':'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882','mv':'http://macVmlSchemaUri','v':'urn:schemas-microsoft-com:vml','html':'http://www.w3.org/TR/REC-html40'};function read_double_le(b,idx){var s=1-2*(b[idx+7]>>>7);var e=((b[idx+7]&0x7f)<<4)+(b[idx+6]>>>4&0x0f);var m=b[idx+6]&0x0f;for(var i=5;i>=0;--i)m=m*256+b[idx+i];if(e==0x7ff)return m==0?s*Infinity:NaN;if(e==0)e=-1022;else {e-=1023;m+=Math.pow(2,52);}return s*Math.pow(2,e-52)*m;}function write_double_le(b,v,idx){var bs=(v<0||1/v==-Infinity?1:0)<<7,e=0,m=0;var av=bs?-v:v;if(!isFinite(av)){e=0x7ff;m=isNaN(v)?0x6969:0;}else if(av==0)e=m=0;else {e=Math.floor(Math.log(av)/Math.LN2);m=av*Math.pow(2,52-e);if(e<=-1023&&(!isFinite(m)||m<Math.pow(2,52))){e=-1022;}else {m-=Math.pow(2,52);e+=1023;}}for(var i=0;i<=5;++i,m/=256)b[idx+i]=m&0xff;b[idx+6]=(e&0x0f)<<4|m&0xf;b[idx+7]=e>>4|bs;}var __toBuffer=function(bufs){var x=[],w=10240;for(var i=0;i<bufs[0].length;++i)if(bufs[0][i])for(var j=0,L=bufs[0][i].length;j<L;j+=w)x.push.apply(x,bufs[0][i].slice(j,j+w));return x;};var ___toBuffer=__toBuffer;var __utf16le=function(b,s,e){var ss=[];for(var i=s;i<e;i+=2)ss.push(String.fromCharCode(__readUInt16LE(b,i)));return ss.join("").replace(chr0,'');};var ___utf16le=__utf16le;var __hexlify=function(b,s,l){var ss=[];for(var i=s;i<s+l;++i)ss.push(("0"+b[i].toString(16)).slice(-2));return ss.join("");};var ___hexlify=__hexlify;var __utf8=function(b,s,e){var ss=[];for(var i=s;i<e;i++)ss.push(String.fromCharCode(__readUInt8(b,i)));return ss.join("");};var ___utf8=__utf8;var __lpstr=function(b,i){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var ___lpstr=__lpstr;var __cpstr=function(b,i){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var ___cpstr=__cpstr;var __lpwstr=function(b,i){var len=2*__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var ___lpwstr=__lpwstr;var __lpp4,___lpp4;__lpp4=___lpp4=function lpp4_(b,i){var len=__readUInt32LE(b,i);return len>0?__utf16le(b,i+4,i+4+len):"";};var __8lpp4=function(b,i){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len):"";};var ___8lpp4=__8lpp4;var __double,___double;__double=___double=function(b,idx){return read_double_le(b,idx);};var is_buf=function is_buf_a(a){return Array.isArray(a);};if(has_buf){__utf16le=function(b,s,e){if(!Buffer.isBuffer(b))return ___utf16le(b,s,e);return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/;};__hexlify=function(b,s,l){return Buffer.isBuffer(b)?b.toString('hex',s,s+l):___hexlify(b,s,l);};__lpstr=function lpstr_b(b,i){if(!Buffer.isBuffer(b))return ___lpstr(b,i);var len=b.readUInt32LE(i);return len>0?b.toString('utf8',i+4,i+4+len-1):"";};__cpstr=function cpstr_b(b,i){if(!Buffer.isBuffer(b))return ___cpstr(b,i);var len=b.readUInt32LE(i);return len>0?b.toString('utf8',i+4,i+4+len-1):"";};__lpwstr=function lpwstr_b(b,i){if(!Buffer.isBuffer(b))return ___lpwstr(b,i);var len=2*b.readUInt32LE(i);return b.toString('utf16le',i+4,i+4+len-1);};__lpp4=function lpp4_b(b,i){if(!Buffer.isBuffer(b))return ___lpp4(b,i);var len=b.readUInt32LE(i);return b.toString('utf16le',i+4,i+4+len);};__8lpp4=function lpp4_8b(b,i){if(!Buffer.isBuffer(b))return ___8lpp4(b,i);var len=b.readUInt32LE(i);return b.toString('utf8',i+4,i+4+len);};__utf8=function utf8_b(b,s,e){return Buffer.isBuffer(b)?b.toString('utf8',s,e):___utf8(b,s,e);};__toBuffer=function(bufs){return bufs[0].length>0&&Buffer.isBuffer(bufs[0][0])?Buffer.concat(bufs[0]):___toBuffer(bufs);};bconcat=function(bufs){return Buffer.isBuffer(bufs[0])?Buffer.concat(bufs):[].concat.apply([],bufs);};__double=function double_(b,i){if(Buffer.isBuffer(b))return b.readDoubleLE(i);return ___double(b,i);};is_buf=function is_buf_b(a){return Buffer.isBuffer(a)||Array.isArray(a);};}/* from js-xls */if(typeof cptable!=='undefined'){__utf16le=function(b,s,e){return cptable.utils.decode(1200,b.slice(s,e)).replace(chr0,'');};__utf8=function(b,s,e){return cptable.utils.decode(65001,b.slice(s,e));};__lpstr=function(b,i){var len=__readUInt32LE(b,i);return len>0?cptable.utils.decode(current_ansi,b.slice(i+4,i+4+len-1)):"";};__cpstr=function(b,i){var len=__readUInt32LE(b,i);return len>0?cptable.utils.decode(current_codepage,b.slice(i+4,i+4+len-1)):"";};__lpwstr=function(b,i){var len=2*__readUInt32LE(b,i);return len>0?cptable.utils.decode(1200,b.slice(i+4,i+4+len-1)):"";};__lpp4=function(b,i){var len=__readUInt32LE(b,i);return len>0?cptable.utils.decode(1200,b.slice(i+4,i+4+len)):"";};__8lpp4=function(b,i){var len=__readUInt32LE(b,i);return len>0?cptable.utils.decode(65001,b.slice(i+4,i+4+len)):"";};}var __readUInt8=function(b,idx){return b[idx];};var __readUInt16LE=function(b,idx){return b[idx+1]*(1<<8)+b[idx];};var __readInt16LE=function(b,idx){var u=b[idx+1]*(1<<8)+b[idx];return u<0x8000?u:(0xffff-u+1)*-1;};var __readUInt32LE=function(b,idx){return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx];};var __readInt32LE=function(b,idx){return b[idx+3]<<24|b[idx+2]<<16|b[idx+1]<<8|b[idx];};var __readInt32BE=function(b,idx){return b[idx]<<24|b[idx+1]<<16|b[idx+2]<<8|b[idx+3];};function ReadShift(size,t){var o="",oI,oR,oo=[],w,vv,i,loc;switch(t){case'dbcs':loc=this.l;if(has_buf&&Buffer.isBuffer(this))o=this.slice(this.l,this.l+2*size).toString("utf16le");else for(i=0;i<size;++i){o+=String.fromCharCode(__readUInt16LE(this,loc));loc+=2;}size*=2;break;case'utf8':o=__utf8(this,this.l,this.l+size);break;case'utf16le':size*=2;o=__utf16le(this,this.l,this.l+size);break;case'wstr':if(typeof cptable!=='undefined')o=cptable.utils.decode(current_codepage,this.slice(this.l,this.l+2*size));else return ReadShift.call(this,size,'dbcs');size=2*size;break;/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */case'lpstr-ansi':o=__lpstr(this,this.l);size=4+__readUInt32LE(this,this.l);break;case'lpstr-cp':o=__cpstr(this,this.l);size=4+__readUInt32LE(this,this.l);break;/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */case'lpwstr':o=__lpwstr(this,this.l);size=4+2*__readUInt32LE(this,this.l);break;/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */case'lpp4':size=4+__readUInt32LE(this,this.l);o=__lpp4(this,this.l);if(size&0x02)size+=2;break;/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */case'8lpp4':size=4+__readUInt32LE(this,this.l);o=__8lpp4(this,this.l);if(size&0x03)size+=4-(size&0x03);break;case'cstr':size=0;o="";while((w=__readUInt8(this,this.l+size++))!==0)oo.push(_getchar(w));o=oo.join("");break;case'_wstr':size=0;o="";while((w=__readUInt16LE(this,this.l+size))!==0){oo.push(_getchar(w));size+=2;}size+=2;o=oo.join("");break;/* sbcs and dbcs support continue records in the SST way TODO codepages */case'dbcs-cont':o="";loc=this.l;for(i=0;i<size;++i){if(this.lens&&this.lens.indexOf(loc)!==-1){w=__readUInt8(this,loc);this.l=loc+1;vv=ReadShift.call(this,size-i,w?'dbcs-cont':'sbcs-cont');return oo.join("")+vv;}oo.push(_getchar(__readUInt16LE(this,loc)));loc+=2;}o=oo.join("");size*=2;break;case'cpstr':if(typeof cptable!=='undefined'){o=cptable.utils.decode(current_codepage,this.slice(this.l,this.l+size));break;}/* falls through */case'sbcs-cont':o="";loc=this.l;for(i=0;i!=size;++i){if(this.lens&&this.lens.indexOf(loc)!==-1){w=__readUInt8(this,loc);this.l=loc+1;vv=ReadShift.call(this,size-i,w?'dbcs-cont':'sbcs-cont');return oo.join("")+vv;}oo.push(_getchar(__readUInt8(this,loc)));loc+=1;}o=oo.join("");break;default:switch(size){case 1:oI=__readUInt8(this,this.l);this.l++;return oI;case 2:oI=(t==='i'?__readInt16LE:__readUInt16LE)(this,this.l);this.l+=2;return oI;case 4:case-4:if(t==='i'||(this[this.l+3]&0x80)===0){oI=(size>0?__readInt32LE:__readInt32BE)(this,this.l);this.l+=4;return oI;}else {oR=__readUInt32LE(this,this.l);this.l+=4;}return oR;case 8:case-8:if(t==='f'){if(size==8)oR=__double(this,this.l);else oR=__double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]],0);this.l+=8;return oR;}else size=8;/* falls through */case 16:o=__hexlify(this,this.l,size);break;}}this.l+=size;return o;}var __writeUInt32LE=function(b,val,idx){b[idx]=val&0xFF;b[idx+1]=val>>>8&0xFF;b[idx+2]=val>>>16&0xFF;b[idx+3]=val>>>24&0xFF;};var __writeInt32LE=function(b,val,idx){b[idx]=val&0xFF;b[idx+1]=val>>8&0xFF;b[idx+2]=val>>16&0xFF;b[idx+3]=val>>24&0xFF;};var __writeUInt16LE=function(b,val,idx){b[idx]=val&0xFF;b[idx+1]=val>>>8&0xFF;};function WriteShift(t,val,f){var size=0,i=0;if(f==='dbcs'){for(i=0;i!=val.length;++i)__writeUInt16LE(this,val.charCodeAt(i),this.l+2*i);size=2*val.length;}else if(f==='sbcs'){if(typeof cptable!=='undefined'&&current_ansi==874){/* TODO: use tables directly, don't encode */for(i=0;i!=val.length;++i){var cppayload=cptable.utils.encode(current_ansi,val.charAt(i));this[this.l+i]=cppayload[0];}}else {val=val.replace(/[^\x00-\x7F]/g,"_");for(i=0;i!=val.length;++i)this[this.l+i]=val.charCodeAt(i)&0xFF;}size=val.length;}else if(f==='hex'){for(;i<t;++i){this[this.l++]=parseInt(val.slice(2*i,2*i+2),16)||0;}return this;}else if(f==='utf16le'){var end=Math.min(this.l+t,this.length);for(i=0;i<Math.min(val.length,t);++i){var cc=val.charCodeAt(i);this[this.l++]=cc&0xff;this[this.l++]=cc>>8;}while(this.l<end)this[this.l++]=0;return this;}else switch(t){case 1:size=1;this[this.l]=val&0xFF;break;case 2:size=2;this[this.l]=val&0xFF;val>>>=8;this[this.l+1]=val&0xFF;break;case 3:size=3;this[this.l]=val&0xFF;val>>>=8;this[this.l+1]=val&0xFF;val>>>=8;this[this.l+2]=val&0xFF;break;case 4:size=4;__writeUInt32LE(this,val,this.l);break;case 8:size=8;if(f==='f'){write_double_le(this,val,this.l);break;}/* falls through */case 16:break;case-4:size=4;__writeInt32LE(this,val,this.l);break;}this.l+=size;return this;}function CheckField(hexstr,fld){var m=__hexlify(this,this.l,hexstr.length>>1);if(m!==hexstr)throw new Error(fld+'Expected '+hexstr+' saw '+m);this.l+=hexstr.length>>1;}function prep_blob(blob,pos){blob.l=pos;blob.read_shift=ReadShift;blob.chk=CheckField;blob.write_shift=WriteShift;}function parsenoop(blob,length){blob.l+=length;}function new_buf(sz){var o=new_raw_buf(sz);prep_blob(o,0);return o;}/* [MS-XLSB] 2.1.4 Record */function recordhopper(data,cb,opts){if(!data)return;var tmpbyte,cntbyte,length;prep_blob(data,data.l||0);var L=data.length,RT=0,tgt=0;while(data.l<L){RT=data.read_shift(1);if(RT&0x80)RT=(RT&0x7F)+((data.read_shift(1)&0x7F)<<7);var R=XLSBRecordEnum[RT]||XLSBRecordEnum[0xFFFF];tmpbyte=data.read_shift(1);length=tmpbyte&0x7F;for(cntbyte=1;cntbyte<4&&tmpbyte&0x80;++cntbyte)length+=((tmpbyte=data.read_shift(1))&0x7F)<<7*cntbyte;tgt=data.l+length;var d=(R.f||parsenoop)(data,length,opts);data.l=tgt;if(cb(d,R.n,RT))return;}}/* control buffer usage for fixed-length buffers */function buf_array(){var bufs=[],blksz=has_buf?256:2048;var newblk=function ba_newblk(sz){var o=new_buf(sz);prep_blob(o,0);return o;};var curbuf=newblk(blksz);var endbuf=function ba_endbuf(){if(!curbuf)return;if(curbuf.length>curbuf.l){curbuf=curbuf.slice(0,curbuf.l);curbuf.l=curbuf.length;}if(curbuf.length>0)bufs.push(curbuf);curbuf=null;};var next=function ba_next(sz){if(curbuf&&sz<curbuf.length-curbuf.l)return curbuf;endbuf();return curbuf=newblk(Math.max(sz+1,blksz));};var end=function ba_end(){endbuf();return __toBuffer([bufs]);};var push=function ba_push(buf){endbuf();curbuf=buf;if(curbuf.l==null)curbuf.l=curbuf.length;next(blksz);};return {next:next,push:push,end:end,_bufs:bufs};}function write_record(ba,type,payload,length){var t=+XLSBRE[type],l;if(isNaN(t))return;// TODO: throw something here?
if(!length)length=XLSBRecordEnum[t].p||(payload||[]).length||0;l=1+(t>=0x80?1:0)+1/* + length*/;if(length>=0x80)++l;if(length>=0x4000)++l;if(length>=0x200000)++l;var o=ba.next(l);if(t<=0x7F)o.write_shift(1,t);else {o.write_shift(1,(t&0x7F)+0x80);o.write_shift(1,t>>7);}for(var i=0;i!=4;++i){if(length>=0x80){o.write_shift(1,(length&0x7F)+0x80);length>>=7;}else {o.write_shift(1,length);break;}}if(length>0&&is_buf(payload))ba.push(payload);}/* XLS ranges enforced */function shift_cell_xls(cell,tgt,opts){var out=dup(cell);if(tgt.s){if(out.cRel)out.c+=tgt.s.c;if(out.rRel)out.r+=tgt.s.r;}else {if(out.cRel)out.c+=tgt.c;if(out.rRel)out.r+=tgt.r;}if(!opts||opts.biff<12){while(out.c>=0x100)out.c-=0x100;while(out.r>=0x10000)out.r-=0x10000;}return out;}function shift_range_xls(cell,range,opts){var out=dup(cell);out.s=shift_cell_xls(out.s,range.s,opts);out.e=shift_cell_xls(out.e,range.s,opts);return out;}function encode_cell_xls(c,biff){if(c.cRel&&c.c<0){c=dup(c);while(c.c<0)c.c+=biff>8?0x4000:0x100;}if(c.rRel&&c.r<0){c=dup(c);while(c.r<0)c.r+=biff>8?0x100000:biff>5?0x10000:0x4000;}var s=encode_cell(c);if(!c.cRel&&c.cRel!=null)s=fix_col(s);if(!c.rRel&&c.rRel!=null)s=fix_row(s);return s;}function encode_range_xls(r,opts){if(r.s.r==0&&!r.s.rRel){if(r.e.r==(opts.biff>=12?0xFFFFF:opts.biff>=8?0x10000:0x4000)&&!r.e.rRel){return (r.s.cRel?"":"$")+encode_col(r.s.c)+":"+(r.e.cRel?"":"$")+encode_col(r.e.c);}}if(r.s.c==0&&!r.s.cRel){if(r.e.c==(opts.biff>=12?0x3FFF:0xFF)&&!r.e.cRel){return (r.s.rRel?"":"$")+encode_row(r.s.r)+":"+(r.e.rRel?"":"$")+encode_row(r.e.r);}}return encode_cell_xls(r.s,opts.biff)+":"+encode_cell_xls(r.e,opts.biff);}var OFFCRYPTO={};var make_offcrypto=function(O,_crypto){var crypto;if(typeof _crypto!=='undefined')crypto=_crypto;else if(typeof commonjsRequire!=='undefined'){try{crypto=crypto$1;}catch(e){crypto=null;}}O.rc4=function(key,data){var S=new Array(256);var c=0,i=0,j=0,t=0;for(i=0;i!=256;++i)S[i]=i;for(i=0;i!=256;++i){j=j+S[i]+key[i%key.length].charCodeAt(0)&255;t=S[i];S[i]=S[j];S[j]=t;}// $FlowIgnore
i=j=0;var out=new_raw_buf(data.length);for(c=0;c!=data.length;++c){i=i+1&255;j=(j+S[i])%256;t=S[i];S[i]=S[j];S[j]=t;out[c]=data[c]^S[S[i]+S[j]&255];}return out;};O.md5=function(hex){if(!crypto)throw new Error("Unsupported crypto");return crypto.createHash('md5').update(hex).digest('hex');};};/*global crypto:true */make_offcrypto(OFFCRYPTO,typeof crypto!=="undefined"?crypto:undefined);function decode_row(rowstr){return parseInt(unfix_row(rowstr),10)-1;}function encode_row(row){return ""+(row+1);}function fix_row(cstr){return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2");}function unfix_row(cstr){return cstr.replace(/\$(\d+)$/,"$1");}function decode_col(colstr){var c=unfix_col(colstr),d=0,i=0;for(;i!==c.length;++i)d=26*d+c.charCodeAt(i)-64;return d-1;}function encode_col(col){if(col<0)throw new Error("invalid column "+col);var s="";for(++col;col;col=Math.floor((col-1)/26))s=String.fromCharCode((col-1)%26+65)+s;return s;}function fix_col(cstr){return cstr.replace(/^([A-Z])/,"$$$1");}function unfix_col(cstr){return cstr.replace(/^\$([A-Z])/,"$1");}function split_cell(cstr){return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(",");}//function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function decode_cell(cstr){var R=0,C=0;for(var i=0;i<cstr.length;++i){var cc=cstr.charCodeAt(i);if(cc>=48&&cc<=57)R=10*R+(cc-48);else if(cc>=65&&cc<=90)C=26*C+(cc-64);}return {c:C-1,r:R-1};}//function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
function encode_cell(cell){var col=cell.c+1;var s="";for(;col;col=(col-1)/26|0)s=String.fromCharCode((col-1)%26+65)+s;return s+(cell.r+1);}function decode_range(range){var idx=range.indexOf(":");if(idx==-1)return {s:decode_cell(range),e:decode_cell(range)};return {s:decode_cell(range.slice(0,idx)),e:decode_cell(range.slice(idx+1))};}function encode_range(cs,ce){if(typeof ce==='undefined'||typeof ce==='number'){return encode_range(cs.s,cs.e);}if(typeof cs!=='string')cs=encode_cell(cs);if(typeof ce!=='string')ce=encode_cell(ce);return cs==ce?cs:cs+":"+ce;}function safe_decode_range(range){var o={s:{c:0,r:0},e:{c:0,r:0}};var idx=0,i=0,cc=0;var len=range.length;for(idx=0;i<len;++i){if((cc=range.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}o.s.c=--idx;for(idx=0;i<len;++i){if((cc=range.charCodeAt(i)-48)<0||cc>9)break;idx=10*idx+cc;}o.s.r=--idx;if(i===len||range.charCodeAt(++i)===58){o.e.c=o.s.c;o.e.r=o.s.r;return o;}for(idx=0;i!=len;++i){if((cc=range.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}o.e.c=--idx;for(idx=0;i!=len;++i){if((cc=range.charCodeAt(i)-48)<0||cc>9)break;idx=10*idx+cc;}o.e.r=--idx;return o;}function safe_format_cell(cell,v){var q=cell.t=='d'&&v instanceof Date;if(cell.z!=null)try{return cell.w=SSF.format(cell.z,q?datenum(v):v);}catch(e){}try{return cell.w=SSF.format((cell.XF||{}).numFmtId||(q?14:0),q?datenum(v):v);}catch(e){return ''+v;}}function format_cell(cell,v,o){if(cell==null||cell.t==null||cell.t=='z')return "";if(cell.w!==undefined)return cell.w;if(cell.t=='d'&&!cell.z&&o&&o.dateNF)cell.z=o.dateNF;if(v==undefined)return safe_format_cell(cell,cell.v);return safe_format_cell(cell,v);}function sheet_to_workbook(sheet,opts){var n=opts&&opts.sheet?opts.sheet:"Sheet1";var sheets={};sheets[n]=sheet;return {SheetNames:[n],Sheets:sheets};}function sheet_add_aoa(_ws,data,opts){var o=opts||{};var dense=_ws?Array.isArray(_ws):o.dense;var ws=_ws||(dense?[]:{});var _R=0,_C=0;if(ws&&o.origin!=null){if(typeof o.origin=='number')_R=o.origin;else {var _origin=typeof o.origin=="string"?decode_cell(o.origin):o.origin;_R=_origin.r;_C=_origin.c;}if(!ws["!ref"])ws["!ref"]="A1:A1";}var range={s:{c:10000000,r:10000000},e:{c:0,r:0}};if(ws['!ref']){var _range=safe_decode_range(ws['!ref']);range.s.c=_range.s.c;range.s.r=_range.s.r;range.e.c=Math.max(range.e.c,_range.e.c);range.e.r=Math.max(range.e.r,_range.e.r);if(_R==-1)range.e.r=_R=_range.e.r+1;}for(var R=0;R!=data.length;++R){if(!data[R])continue;if(!Array.isArray(data[R]))throw new Error("aoa_to_sheet expects an array of arrays");for(var C=0;C!=data[R].length;++C){if(typeof data[R][C]==='undefined')continue;var cell={v:data[R][C]};var __R=_R+R,__C=_C+C;if(range.s.r>__R)range.s.r=__R;if(range.s.c>__C)range.s.c=__C;if(range.e.r<__R)range.e.r=__R;if(range.e.c<__C)range.e.c=__C;if(data[R][C]&&typeof data[R][C]==='object'&&!Array.isArray(data[R][C])&&!(data[R][C]instanceof Date))cell=data[R][C];else {if(Array.isArray(cell.v)){cell.f=data[R][C][1];cell.v=cell.v[0];}if(cell.v===null){if(cell.f)cell.t='n';else if(!o.sheetStubs)continue;else cell.t='z';}else if(typeof cell.v==='number')cell.t='n';else if(typeof cell.v==='boolean')cell.t='b';else if(cell.v instanceof Date){cell.z=o.dateNF||SSF._table[14];if(o.cellDates){cell.t='d';cell.w=SSF.format(cell.z,datenum(cell.v));}else {cell.t='n';cell.v=datenum(cell.v);cell.w=SSF.format(cell.z,cell.v);}}else cell.t='s';}if(dense){if(!ws[__R])ws[__R]=[];if(ws[__R][__C]&&ws[__R][__C].z)cell.z=ws[__R][__C].z;ws[__R][__C]=cell;}else {var cell_ref=encode_cell({c:__C,r:__R});if(ws[cell_ref]&&ws[cell_ref].z)cell.z=ws[cell_ref].z;ws[cell_ref]=cell;}}}if(range.s.c<10000000)ws['!ref']=encode_range(range);return ws;}function aoa_to_sheet(data,opts){return sheet_add_aoa(null,data,opts);}function write_UInt32LE(x,o){if(!o)o=new_buf(4);o.write_shift(4,x);return o;}/* [MS-XLSB] 2.5.168 */function parse_XLWideString(data){var cchCharacters=data.read_shift(4);return cchCharacters===0?"":data.read_shift(cchCharacters,'dbcs');}function write_XLWideString(data,o){var _null=false;if(o==null){_null=true;o=new_buf(4+2*data.length);}o.write_shift(4,data.length);if(data.length>0)o.write_shift(0,data,'dbcs');return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data) {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */function parse_StrRun(data){return {ich:data.read_shift(2),ifnt:data.read_shift(2)};}function write_StrRun(run,o){if(!o)o=new_buf(4);o.write_shift(2,run.ich||0);o.write_shift(2,run.ifnt||0);return o;}/* [MS-XLSB] 2.5.121 */function parse_RichStr(data,length){var start=data.l;var flags=data.read_shift(1);var str=parse_XLWideString(data);var rgsStrRun=[];var z={t:str,h:str};if((flags&1)!==0){/* fRichStr */ /* TODO: formatted string */var dwSizeStrRun=data.read_shift(4);for(var i=0;i!=dwSizeStrRun;++i)rgsStrRun.push(parse_StrRun(data));z.r=rgsStrRun;}else z.r=[{ich:0,ifnt:0}];//if((flags & 2) !== 0) { /* fExtStr */
//	/* TODO: phonetic string */
//}
data.l=start+length;return z;}function write_RichStr(str,o){/* TODO: formatted string */var _null=false;if(o==null){_null=true;o=new_buf(15+4*str.t.length);}o.write_shift(1,0);write_XLWideString(str.t,o);return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */var parse_BrtCommentText=parse_RichStr;function write_BrtCommentText(str,o){/* TODO: formatted string */var _null=false;if(o==null){_null=true;o=new_buf(23+4*str.t.length);}o.write_shift(1,1);write_XLWideString(str.t,o);o.write_shift(4,1);write_StrRun({ich:0,ifnt:0},o);return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.5.9 */function parse_XLSBCell(data){var col=data.read_shift(4);var iStyleRef=data.read_shift(2);iStyleRef+=data.read_shift(1)<<16;data.l++;//var fPhShow = data.read_shift(1);
return {c:col,iStyleRef:iStyleRef};}function write_XLSBCell(cell,o){if(o==null)o=new_buf(8);o.write_shift(-4,cell.c);o.write_shift(3,cell.iStyleRef||cell.s);o.write_shift(1,0);/* fPhShow */return o;}/* Short XLSB Cell does not include column */function parse_XLSBShortCell(data){var iStyleRef=data.read_shift(2);iStyleRef+=data.read_shift(1)<<16;data.l++;//var fPhShow = data.read_shift(1);
return {c:-1,iStyleRef:iStyleRef};}function write_XLSBShortCell(cell,o){if(o==null)o=new_buf(4);o.write_shift(3,cell.iStyleRef||cell.s);o.write_shift(1,0);/* fPhShow */return o;}/* [MS-XLSB] 2.5.21 */var parse_XLSBCodeName=parse_XLWideString;var write_XLSBCodeName=write_XLWideString;/* [MS-XLSB] 2.5.166 */function parse_XLNullableWideString(data){var cchCharacters=data.read_shift(4);return cchCharacters===0||cchCharacters===0xFFFFFFFF?"":data.read_shift(cchCharacters,'dbcs');}function write_XLNullableWideString(data,o){var _null=false;if(o==null){_null=true;o=new_buf(127);}o.write_shift(4,data.length>0?data.length:0xFFFFFFFF);if(data.length>0)o.write_shift(0,data,'dbcs');return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.5.165 */var parse_XLNameWideString=parse_XLWideString;//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */var parse_RelID=parse_XLNullableWideString;var write_RelID=write_XLNullableWideString;/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */function parse_RkNumber(data){var b=data.slice(data.l,data.l+4);var fX100=b[0]&1,fInt=b[0]&2;data.l+=4;b[0]&=0xFC;// b[0] &= ~3;
var RK=fInt===0?__double([0,0,0,0,b[0],b[1],b[2],b[3]],0):__readInt32LE(b,0)>>2;return fX100?RK/100:RK;}function write_RkNumber(data,o){if(o==null)o=new_buf(4);var fX100=0,fInt=0,d100=data*100;if(data==(data|0)&&data>=-(1<<29)&&data<1<<29){fInt=1;}else if(d100==(d100|0)&&d100>=-(1<<29)&&d100<1<<29){fInt=1;fX100=1;}if(fInt)o.write_shift(-4,((fX100?d100:data)<<2)+(fX100+2));else throw new Error("unsupported RkNumber "+data);// TODO
}/* [MS-XLSB] 2.5.117 RfX */function parse_RfX(data){var cell={s:{},e:{}};cell.s.r=data.read_shift(4);cell.e.r=data.read_shift(4);cell.s.c=data.read_shift(4);cell.e.c=data.read_shift(4);return cell;}function write_RfX(r,o){if(!o)o=new_buf(16);o.write_shift(4,r.s.r);o.write_shift(4,r.e.r);o.write_shift(4,r.s.c);o.write_shift(4,r.e.c);return o;}/* [MS-XLSB] 2.5.153 UncheckedRfX */var parse_UncheckedRfX=parse_RfX;var write_UncheckedRfX=write_RfX;/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */function parse_Xnum(data){if(data.length-data.l<8)throw "XLS Xnum Buffer underflow";return data.read_shift(8,'f');}function write_Xnum(data,o){return (o||new_buf(8)).write_shift(8,data,'f');}/* [MS-XLSB] 2.4.324 BrtColor */function parse_BrtColor(data){var out={};var d=data.read_shift(1);//var fValidRGB = d & 1;
var xColorType=d>>>1;var index=data.read_shift(1);var nTS=data.read_shift(2,'i');var bR=data.read_shift(1);var bG=data.read_shift(1);var bB=data.read_shift(1);data.l++;//var bAlpha = data.read_shift(1);
switch(xColorType){case 0:out.auto=1;break;case 1:out.index=index;var icv=XLSIcv[index];/* automatic pseudo index 81 */if(icv)out.rgb=rgb2Hex(icv);break;case 2:/* if(!fValidRGB) throw new Error("invalid"); */out.rgb=rgb2Hex([bR,bG,bB]);break;case 3:out.theme=index;break;}if(nTS!=0)out.tint=nTS>0?nTS/32767:nTS/32768;return out;}function write_BrtColor(color,o){if(!o)o=new_buf(8);if(!color||color.auto){o.write_shift(4,0);o.write_shift(4,0);return o;}if(color.index!=null){o.write_shift(1,0x02);o.write_shift(1,color.index);}else if(color.theme!=null){o.write_shift(1,0x06);o.write_shift(1,color.theme);}else {o.write_shift(1,0x05);o.write_shift(1,0);}var nTS=color.tint||0;if(nTS>0)nTS*=32767;else if(nTS<0)nTS*=32768;o.write_shift(2,nTS);if(!color.rgb||color.theme!=null){o.write_shift(2,0);o.write_shift(1,0);o.write_shift(1,0);}else {var rgb=color.rgb||'FFFFFF';if(typeof rgb=='number')rgb=("000000"+rgb.toString(16)).slice(-6);o.write_shift(1,parseInt(rgb.slice(0,2),16));o.write_shift(1,parseInt(rgb.slice(2,4),16));o.write_shift(1,parseInt(rgb.slice(4,6),16));o.write_shift(1,0xFF);}return o;}/* [MS-XLSB] 2.5.52 */function parse_FontFlags(data){var d=data.read_shift(1);data.l++;var out={fBold:d&0x01,fItalic:d&0x02,fUnderline:d&0x04,fStrikeout:d&0x08,fOutline:d&0x10,fShadow:d&0x20,fCondense:d&0x40,fExtend:d&0x80};return out;}function write_FontFlags(font,o){if(!o)o=new_buf(2);var grbit=(font.italic?0x02:0)|(font.strike?0x08:0)|(font.outline?0x10:0)|(font.shadow?0x20:0)|(font.condense?0x40:0)|(font.extend?0x80:0);o.write_shift(1,grbit);o.write_shift(1,0);return o;}/* [MS-OLEDS] 2.3.1 and 2.3.2 */function parse_ClipboardFormatOrString(o,w){// $FlowIgnore
var ClipFmt={2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};var m=o.read_shift(4);switch(m){case 0x00000000:return "";case 0xffffffff:case 0xfffffffe:return ClipFmt[o.read_shift(4)]||"";}if(m>0x190)throw new Error("Unsupported Clipboard: "+m.toString(16));o.l-=4;return o.read_shift(0,w==1?"lpstr":"lpwstr");}function parse_ClipboardFormatOrAnsiString(o){return parse_ClipboardFormatOrString(o,1);}function parse_ClipboardFormatOrUnicodeString(o){return parse_ClipboardFormatOrString(o,2);}/* [MS-OLEPS] 2.2 PropertyType */ //var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var VT_I2=0x0002;var VT_I4=0x0003;//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var VT_BOOL=0x000B;var VT_VARIANT=0x000C;//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var VT_UI4=0x0013;//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var VT_LPSTR=0x001E;//var VT_LPWSTR   = 0x001F;
var VT_FILETIME=0x0040;var VT_BLOB=0x0041;//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var VT_CF=0x0047;//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var VT_VECTOR=0x1000;//var VT_ARRAY    = 0x2000;
var VT_STRING=0x0050;// 2.3.3.1.11 VtString
var VT_USTR=0x0051;// 2.3.3.1.12 VtUnalignedString
var VT_CUSTOM=[VT_STRING,VT_USTR];/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */var DocSummaryPIDDSI={0x01:{n:'CodePage',t:VT_I2},0x02:{n:'Category',t:VT_STRING},0x03:{n:'PresentationFormat',t:VT_STRING},0x04:{n:'ByteCount',t:VT_I4},0x05:{n:'LineCount',t:VT_I4},0x06:{n:'ParagraphCount',t:VT_I4},0x07:{n:'SlideCount',t:VT_I4},0x08:{n:'NoteCount',t:VT_I4},0x09:{n:'HiddenCount',t:VT_I4},0x0a:{n:'MultimediaClipCount',t:VT_I4},0x0b:{n:'ScaleCrop',t:VT_BOOL},0x0c:{n:'HeadingPairs',t:VT_VECTOR|VT_VARIANT},0x0d:{n:'TitlesOfParts',t:VT_VECTOR|VT_LPSTR},0x0e:{n:'Manager',t:VT_STRING},0x0f:{n:'Company',t:VT_STRING},0x10:{n:'LinksUpToDate',t:VT_BOOL},0x11:{n:'CharacterCount',t:VT_I4},0x13:{n:'SharedDoc',t:VT_BOOL},0x16:{n:'HyperlinksChanged',t:VT_BOOL},0x17:{n:'AppVersion',t:VT_I4,p:'version'},0x18:{n:'DigSig',t:VT_BLOB},0x1A:{n:'ContentType',t:VT_STRING},0x1B:{n:'ContentStatus',t:VT_STRING},0x1C:{n:'Language',t:VT_STRING},0x1D:{n:'Version',t:VT_STRING},0xFF:{}};/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */var SummaryPIDSI={0x01:{n:'CodePage',t:VT_I2},0x02:{n:'Title',t:VT_STRING},0x03:{n:'Subject',t:VT_STRING},0x04:{n:'Author',t:VT_STRING},0x05:{n:'Keywords',t:VT_STRING},0x06:{n:'Comments',t:VT_STRING},0x07:{n:'Template',t:VT_STRING},0x08:{n:'LastAuthor',t:VT_STRING},0x09:{n:'RevNumber',t:VT_STRING},0x0A:{n:'EditTime',t:VT_FILETIME},0x0B:{n:'LastPrinted',t:VT_FILETIME},0x0C:{n:'CreatedDate',t:VT_FILETIME},0x0D:{n:'ModifiedDate',t:VT_FILETIME},0x0E:{n:'PageCount',t:VT_I4},0x0F:{n:'WordCount',t:VT_I4},0x10:{n:'CharCount',t:VT_I4},0x11:{n:'Thumbnail',t:VT_CF},0x12:{n:'Application',t:VT_STRING},0x13:{n:'DocSecurity',t:VT_I4},0xFF:{}};/* [MS-OLEPS] 2.18 */var SpecialProperties={0x80000000:{n:'Locale',t:VT_UI4},0x80000003:{n:'Behavior',t:VT_UI4},0x72627262:{}};(function(){for(var y in SpecialProperties)if(Object.prototype.hasOwnProperty.call(SpecialProperties,y))DocSummaryPIDDSI[y]=SummaryPIDSI[y]=SpecialProperties[y];})();var DocSummaryRE=evert_key(DocSummaryPIDDSI,"n");var SummaryRE=evert_key(SummaryPIDSI,"n");/* [MS-XLS] 2.4.63 Country/Region codes */var CountryEnum={0x0001:"US",// United States
0x0002:"CA",// Canada
0x0003:"",// Latin America (except Brazil)
0x0007:"RU",// Russia
0x0014:"EG",// Egypt
0x001E:"GR",// Greece
0x001F:"NL",// Netherlands
0x0020:"BE",// Belgium
0x0021:"FR",// France
0x0022:"ES",// Spain
0x0024:"HU",// Hungary
0x0027:"IT",// Italy
0x0029:"CH",// Switzerland
0x002B:"AT",// Austria
0x002C:"GB",// United Kingdom
0x002D:"DK",// Denmark
0x002E:"SE",// Sweden
0x002F:"NO",// Norway
0x0030:"PL",// Poland
0x0031:"DE",// Germany
0x0034:"MX",// Mexico
0x0037:"BR",// Brazil
0x003d:"AU",// Australia
0x0040:"NZ",// New Zealand
0x0042:"TH",// Thailand
0x0051:"JP",// Japan
0x0052:"KR",// Korea
0x0054:"VN",// Viet Nam
0x0056:"CN",// China
0x005A:"TR",// Turkey
0x0069:"JS",// Ramastan
0x00D5:"DZ",// Algeria
0x00D8:"MA",// Morocco
0x00DA:"LY",// Libya
0x015F:"PT",// Portugal
0x0162:"IS",// Iceland
0x0166:"FI",// Finland
0x01A4:"CZ",// Czech Republic
0x0376:"TW",// Taiwan
0x03C1:"LB",// Lebanon
0x03C2:"JO",// Jordan
0x03C3:"SY",// Syria
0x03C4:"IQ",// Iraq
0x03C5:"KW",// Kuwait
0x03C6:"SA",// Saudi Arabia
0x03CB:"AE",// United Arab Emirates
0x03CC:"IL",// Israel
0x03CE:"QA",// Qatar
0x03D5:"IR",// Iran
0xFFFF:"US"// United States
};/* [MS-XLS] 2.5.127 */var XLSFillPattern=[null,'solid','mediumGray','darkGray','lightGray','darkHorizontal','darkVertical','darkDown','darkUp','darkGrid','darkTrellis','lightHorizontal','lightVertical','lightDown','lightUp','lightGrid','lightTrellis','gray125','gray0625'];function rgbify(arr){return arr.map(function(x){return [x>>16&255,x>>8&255,x&255];});}/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */var _XLSIcv=rgbify([/* Color Constants */0x000000,0xFFFFFF,0xFF0000,0x00FF00,0x0000FF,0xFFFF00,0xFF00FF,0x00FFFF,/* Overridable Defaults */0x000000,0xFFFFFF,0xFF0000,0x00FF00,0x0000FF,0xFFFF00,0xFF00FF,0x00FFFF,0x800000,0x008000,0x000080,0x808000,0x800080,0x008080,0xC0C0C0,0x808080,0x9999FF,0x993366,0xFFFFCC,0xCCFFFF,0x660066,0xFF8080,0x0066CC,0xCCCCFF,0x000080,0xFF00FF,0xFFFF00,0x00FFFF,0x800080,0x800000,0x008080,0x0000FF,0x00CCFF,0xCCFFFF,0xCCFFCC,0xFFFF99,0x99CCFF,0xFF99CC,0xCC99FF,0xFFCC99,0x3366FF,0x33CCCC,0x99CC00,0xFFCC00,0xFF9900,0xFF6600,0x666699,0x969696,0x003366,0x339966,0x003300,0x333300,0x993300,0x993366,0x333399,0x333333,/* Other entries to appease BIFF8/12 */0xFFFFFF,/* 0x40 icvForeground ?? */0x000000,/* 0x41 icvBackground ?? */0x000000,/* 0x42 icvFrame ?? */0x000000,/* 0x43 icv3D ?? */0x000000,/* 0x44 icv3DText ?? */0x000000,/* 0x45 icv3DHilite ?? */0x000000,/* 0x46 icv3DShadow ?? */0x000000,/* 0x47 icvHilite ?? */0x000000,/* 0x48 icvCtlText ?? */0x000000,/* 0x49 icvCtlScrl ?? */0x000000,/* 0x4A icvCtlInv ?? */0x000000,/* 0x4B icvCtlBody ?? */0x000000,/* 0x4C icvCtlFrame ?? */0x000000,/* 0x4D icvCtlFore ?? */0x000000,/* 0x4E icvCtlBack ?? */0x000000,/* 0x4F icvCtlNeutral */0x000000,/* 0x50 icvInfoBk ?? */0x000000/* 0x51 icvInfoText ?? */]);var XLSIcv=dup(_XLSIcv);/* [MS-XLSB] 2.5.97.2 */var BErr={0x00:"#NULL!",0x07:"#DIV/0!",0x0F:"#VALUE!",0x17:"#REF!",0x1D:"#NAME?",0x24:"#NUM!",0x2A:"#N/A",0x2B:"#GETTING_DATA",0xFF:"#WTF?"};var RBErr=evert_num(BErr);/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */var ct2type/*{[string]:string}*/={/* Workbook */"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":"workbooks",/* Worksheet */"application/vnd.ms-excel.binIndexWs":"TODO",/* Binary Index */ /* Macrosheet */"application/vnd.ms-excel.intlmacrosheet":"TODO","application/vnd.ms-excel.binIndexMs":"TODO",/* Binary Index */ /* File Properties */"application/vnd.openxmlformats-package.core-properties+xml":"coreprops","application/vnd.openxmlformats-officedocument.custom-properties+xml":"custprops","application/vnd.openxmlformats-officedocument.extended-properties+xml":"extprops",/* Custom Data Properties */"application/vnd.openxmlformats-officedocument.customXmlProperties+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":"TODO",/* PivotTable */"application/vnd.ms-excel.pivotTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":"TODO",/* Chart Objects */"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":"TODO",/* Chart Colors */"application/vnd.ms-office.chartcolorstyle+xml":"TODO",/* Chart Style */"application/vnd.ms-office.chartstyle+xml":"TODO",/* Chart Advanced */"application/vnd.ms-office.chartex+xml":"TODO",/* Calculation Chain */"application/vnd.ms-excel.calcChain":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":"calcchains",/* Printer Settings */"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":"TODO",/* ActiveX */"application/vnd.ms-office.activeX":"TODO","application/vnd.ms-office.activeX+xml":"TODO",/* Custom Toolbars */"application/vnd.ms-excel.attachedToolbars":"TODO",/* External Data Connections */"application/vnd.ms-excel.connections":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":"TODO",/* External Links */"application/vnd.ms-excel.externalLink":"links","application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":"links",/* Metadata */"application/vnd.ms-excel.sheetMetadata":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":"TODO",/* PivotCache */"application/vnd.ms-excel.pivotCacheDefinition":"TODO","application/vnd.ms-excel.pivotCacheRecords":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":"TODO",/* Query Table */"application/vnd.ms-excel.queryTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":"TODO",/* Shared Workbook */"application/vnd.ms-excel.userNames":"TODO","application/vnd.ms-excel.revisionHeaders":"TODO","application/vnd.ms-excel.revisionLog":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":"TODO",/* Single Cell Table */"application/vnd.ms-excel.tableSingleCells":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":"TODO",/* Slicer */"application/vnd.ms-excel.slicer":"TODO","application/vnd.ms-excel.slicerCache":"TODO","application/vnd.ms-excel.slicer+xml":"TODO","application/vnd.ms-excel.slicerCache+xml":"TODO",/* Sort Map */"application/vnd.ms-excel.wsSortMap":"TODO",/* Table */"application/vnd.ms-excel.table":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":"TODO",/* Themes */"application/vnd.openxmlformats-officedocument.theme+xml":"themes",/* Theme Override */"application/vnd.openxmlformats-officedocument.themeOverride+xml":"TODO",/* Timeline */"application/vnd.ms-excel.Timeline+xml":"TODO",/* verify */"application/vnd.ms-excel.TimelineCache+xml":"TODO",/* verify */ /* VBA */"application/vnd.ms-office.vbaProject":"vba","application/vnd.ms-office.vbaProjectSignature":"vba",/* Volatile Dependencies */"application/vnd.ms-office.volatileDependencies":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":"TODO",/* Control Properties */"application/vnd.ms-excel.controlproperties+xml":"TODO",/* Data Model */"application/vnd.openxmlformats-officedocument.model+data":"TODO",/* Survey */"application/vnd.ms-excel.Survey+xml":"TODO",/* Drawing */"application/vnd.openxmlformats-officedocument.drawing+xml":"drawings","application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":"TODO",/* VML */"application/vnd.openxmlformats-officedocument.vmlDrawing":"TODO","application/vnd.openxmlformats-package.relationships+xml":"rels","application/vnd.openxmlformats-officedocument.oleObject":"TODO",/* Image */"image/png":"TODO","sheet":"js"};var CT_LIST=function(){var o={workbooks:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",xlsm:"application/vnd.ms-excel.sheet.macroEnabled.main+xml",xlsb:"application/vnd.ms-excel.sheet.binary.macroEnabled.main",xlam:"application/vnd.ms-excel.addin.macroEnabled.main+xml",xltx:"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"},strs:{/* Shared Strings */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",xlsb:"application/vnd.ms-excel.sharedStrings"},comments:{/* Comments */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",xlsb:"application/vnd.ms-excel.comments"},sheets:{/* Worksheet */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",xlsb:"application/vnd.ms-excel.worksheet"},charts:{/* Chartsheet */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",xlsb:"application/vnd.ms-excel.chartsheet"},dialogs:{/* Dialogsheet */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",xlsb:"application/vnd.ms-excel.dialogsheet"},macros:{/* Macrosheet (Excel 4.0 Macros) */xlsx:"application/vnd.ms-excel.macrosheet+xml",xlsb:"application/vnd.ms-excel.macrosheet"},styles:{/* Styles */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",xlsb:"application/vnd.ms-excel.styles"}};keys(o).forEach(function(k){["xlsm","xlam"].forEach(function(v){if(!o[k][v])o[k][v]=o[k].xlsx;});});keys(o).forEach(function(k){keys(o[k]).forEach(function(v){ct2type[o[k][v]]=k;});});return o;}();var type2ct/*{[string]:Array<string>}*/=evert_arr(ct2type);XMLNS.CT='http://schemas.openxmlformats.org/package/2006/content-types';function new_ct(){return {workbooks:[],sheets:[],charts:[],dialogs:[],macros:[],rels:[],strs:[],comments:[],links:[],coreprops:[],extprops:[],custprops:[],themes:[],styles:[],calcchains:[],vba:[],drawings:[],TODO:[],xmlns:""};}function parse_ct(data){var ct=new_ct();if(!data||!data.match)return ct;var ctext={};(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0].replace(nsregex,"<")){case'<?xml':break;case'<Types':ct.xmlns=y['xmlns'+(y[0].match(/<(\w+):/)||["",""])[1]];break;case'<Default':ctext[y.Extension]=y.ContentType;break;case'<Override':if(ct[ct2type[y.ContentType]]!==undefined)ct[ct2type[y.ContentType]].push(y.PartName);break;}});if(ct.xmlns!==XMLNS.CT)throw new Error("Unknown Namespace: "+ct.xmlns);ct.calcchain=ct.calcchains.length>0?ct.calcchains[0]:"";ct.sst=ct.strs.length>0?ct.strs[0]:"";ct.style=ct.styles.length>0?ct.styles[0]:"";ct.defaults=ctext;delete ct.calcchains;return ct;}var CTYPE_XML_ROOT=writextag('Types',null,{'xmlns':XMLNS.CT,'xmlns:xsd':XMLNS.xsd,'xmlns:xsi':XMLNS.xsi});var CTYPE_DEFAULTS=[['xml','application/xml'],['bin','application/vnd.ms-excel.sheet.binary.macroEnabled.main'],['vml','application/vnd.openxmlformats-officedocument.vmlDrawing'],['data','application/vnd.openxmlformats-officedocument.model+data'],/* from test files */['bmp','image/bmp'],['png','image/png'],['gif','image/gif'],['emf','image/x-emf'],['wmf','image/x-wmf'],['jpg','image/jpeg'],['jpeg','image/jpeg'],['tif','image/tiff'],['tiff','image/tiff'],['pdf','application/pdf'],['rels',type2ct.rels[0]]].map(function(x){return writextag('Default',null,{'Extension':x[0],'ContentType':x[1]});});function write_ct(ct,opts){var o=[],v;o[o.length]=XML_HEADER;o[o.length]=CTYPE_XML_ROOT;o=o.concat(CTYPE_DEFAULTS);/* only write first instance */var f1=function(w){if(ct[w]&&ct[w].length>0){v=ct[w][0];o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':CT_LIST[w][opts.bookType||'xlsx']});}};/* book type-specific */var f2=function(w){(ct[w]||[]).forEach(function(v){o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':CT_LIST[w][opts.bookType||'xlsx']});});};/* standard type */var f3=function(t){(ct[t]||[]).forEach(function(v){o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':type2ct[t][0]});});};f1('workbooks');f2('sheets');f2('charts');f3('themes');['strs','styles'].forEach(f1);['coreprops','extprops','custprops'].forEach(f3);f3('vba');f3('comments');f3('drawings');if(o.length>2){o[o.length]='</Types>';o[1]=o[1].replace("/>",">");}return o.join("");}/* 9.3 Relationships */var RELS={WB:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",SHEET:"http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",HLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",VML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",XPATH:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",XMISS:"http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",XLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",CXML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",CXMLP:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",VBA:"http://schemas.microsoft.com/office/2006/relationships/vbaProject"};/* 9.3.3 Representing Relationships */function get_rels_path(file){var n=file.lastIndexOf("/");return file.slice(0,n+1)+'_rels/'+file.slice(n+1)+".rels";}function parse_rels(data,currentFilePath){var rels={"!id":{}};if(!data)return rels;if(currentFilePath.charAt(0)!=='/'){currentFilePath='/'+currentFilePath;}var hash={};(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);/* 9.3.2.2 OPC_Relationships */if(y[0]==='<Relationship'){var rel={};rel.Type=y.Type;rel.Target=y.Target;rel.Id=y.Id;rel.TargetMode=y.TargetMode;var canonictarget=y.TargetMode==='External'?y.Target:resolve_path(y.Target,currentFilePath);rels[canonictarget]=rel;hash[y.Id]=rel;}});rels["!id"]=hash;return rels;}XMLNS.RELS='http://schemas.openxmlformats.org/package/2006/relationships';var RELS_ROOT=writextag('Relationships',null,{//'xmlns:ns0': XMLNS.RELS,
'xmlns':XMLNS.RELS});/* TODO */function write_rels(rels){var o=[XML_HEADER,RELS_ROOT];keys(rels['!id']).forEach(function(rid){o[o.length]=writextag('Relationship',null,rels['!id'][rid]);});if(o.length>2){o[o.length]='</Relationships>';o[1]=o[1].replace("/>",">");}return o.join("");}var RELS_EXTERN=[RELS.HLINK,RELS.XPATH,RELS.XMISS];function add_rels(rels,rId,f,type,relobj,targetmode){if(!relobj)relobj={};if(!rels['!id'])rels['!id']={};if(rId<0)for(rId=1;rels['!id']['rId'+rId];++rId){/* empty */}relobj.Id='rId'+rId;relobj.Type=type;relobj.Target=f;if(targetmode)relobj.TargetMode=targetmode;else if(RELS_EXTERN.indexOf(relobj.Type)>-1)relobj.TargetMode="External";if(rels['!id'][relobj.Id])throw new Error("Cannot rewrite rId "+rId);rels['!id'][relobj.Id]=relobj;rels[('/'+relobj.Target).replace("//","/")]=relobj;return rId;}/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */ /* Part 3 Section 4 Manifest File */var CT_ODS="application/vnd.oasis.opendocument.spreadsheet";function parse_manifest(d,opts){var str=xlml_normalize(d);var Rn;var FEtag;while(Rn=xlmlregex.exec(str))switch(Rn[3]){case'manifest':break;// 4.2 <manifest:manifest>
case'file-entry':// 4.3 <manifest:file-entry>
FEtag=parsexmltag(Rn[0],false);if(FEtag.path=='/'&&FEtag.type!==CT_ODS)throw new Error("This OpenDocument is not a spreadsheet");break;case'encryption-data':// 4.4 <manifest:encryption-data>
case'algorithm':// 4.5 <manifest:algorithm>
case'start-key-generation':// 4.6 <manifest:start-key-generation>
case'key-derivation':// 4.7 <manifest:key-derivation>
throw new Error("Unsupported ODS Encryption");default:if(opts&&opts.WTF)throw Rn;}}function write_manifest(manifest){var o=[XML_HEADER];o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');for(var i=0;i<manifest.length;++i)o.push('  <manifest:file-entry manifest:full-path="'+manifest[i][0]+'" manifest:media-type="'+manifest[i][1]+'"/>\n');o.push('</manifest:manifest>');return o.join("");}/* Part 3 Section 6 Metadata Manifest File */function write_rdf_type(file,res,tag){return ['  <rdf:Description rdf:about="'+file+'">\n','    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/'+(tag||"odf")+'#'+res+'"/>\n','  </rdf:Description>\n'].join("");}function write_rdf_has(base,file){return ['  <rdf:Description rdf:about="'+base+'">\n','    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="'+file+'"/>\n','  </rdf:Description>\n'].join("");}function write_rdf(rdf){var o=[XML_HEADER];o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');for(var i=0;i!=rdf.length;++i){o.push(write_rdf_type(rdf[i][0],rdf[i][1]));o.push(write_rdf_has("",rdf[i][0]));}o.push(write_rdf_type("","Document","pkg"));o.push('</rdf:RDF>');return o.join("");}/* TODO: pull properties */var write_meta_ods=function(){var payload='<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet'+'JS '+XLSX.version+'</meta:generator></office:meta></office:document-meta>';return function wmo(){return payload;};}();/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */var CORE_PROPS=[["cp:category","Category"],["cp:contentStatus","ContentStatus"],["cp:keywords","Keywords"],["cp:lastModifiedBy","LastAuthor"],["cp:lastPrinted","LastPrinted"],["cp:revision","RevNumber"],["cp:version","Version"],["dc:creator","Author"],["dc:description","Comments"],["dc:identifier","Identifier"],["dc:language","Language"],["dc:subject","Subject"],["dc:title","Title"],["dcterms:created","CreatedDate",'date'],["dcterms:modified","ModifiedDate",'date']];XMLNS.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/metadata/core-properties";RELS.CORE_PROPS='http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';var CORE_PROPS_REGEX=function(){var r=new Array(CORE_PROPS.length);for(var i=0;i<CORE_PROPS.length;++i){var f=CORE_PROPS[i];var g="(?:"+f[0].slice(0,f[0].indexOf(":"))+":)"+f[0].slice(f[0].indexOf(":")+1);r[i]=new RegExp("<"+g+"[^>]*>([\\s\\S]*?)<\/"+g+">");}return r;}();function parse_core_props(data){var p={};data=utf8read(data);for(var i=0;i<CORE_PROPS.length;++i){var f=CORE_PROPS[i],cur=data.match(CORE_PROPS_REGEX[i]);if(cur!=null&&cur.length>0)p[f[1]]=unescapexml(cur[1]);if(f[2]==='date'&&p[f[1]])p[f[1]]=parseDate(p[f[1]]);}return p;}var CORE_PROPS_XML_ROOT=writextag('cp:coreProperties',null,{//'xmlns': XMLNS.CORE_PROPS,
'xmlns:cp':XMLNS.CORE_PROPS,'xmlns:dc':XMLNS.dc,'xmlns:dcterms':XMLNS.dcterms,'xmlns:dcmitype':XMLNS.dcmitype,'xmlns:xsi':XMLNS.xsi});function cp_doit(f,g,h,o,p){if(p[f]!=null||g==null||g==="")return;p[f]=g;g=escapexml(g);o[o.length]=h?writextag(f,g,h):writetag(f,g);}function write_core_props(cp,_opts){var opts=_opts||{};var o=[XML_HEADER,CORE_PROPS_XML_ROOT],p={};if(!cp&&!opts.Props)return o.join("");if(cp){if(cp.CreatedDate!=null)cp_doit("dcterms:created",typeof cp.CreatedDate==="string"?cp.CreatedDate:write_w3cdtf(cp.CreatedDate,opts.WTF),{"xsi:type":"dcterms:W3CDTF"},o,p);if(cp.ModifiedDate!=null)cp_doit("dcterms:modified",typeof cp.ModifiedDate==="string"?cp.ModifiedDate:write_w3cdtf(cp.ModifiedDate,opts.WTF),{"xsi:type":"dcterms:W3CDTF"},o,p);}for(var i=0;i!=CORE_PROPS.length;++i){var f=CORE_PROPS[i];var v=opts.Props&&opts.Props[f[1]]!=null?opts.Props[f[1]]:cp?cp[f[1]]:null;if(v===true)v="1";else if(v===false)v="0";else if(typeof v=="number")v=String(v);if(v!=null)cp_doit(f[0],v,null,o,p);}if(o.length>2){o[o.length]='</cp:coreProperties>';o[1]=o[1].replace("/>",">");}return o.join("");}/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */var EXT_PROPS=[["Application","Application","string"],["AppVersion","AppVersion","string"],["Company","Company","string"],["DocSecurity","DocSecurity","string"],["Manager","Manager","string"],["HyperlinksChanged","HyperlinksChanged","bool"],["SharedDoc","SharedDoc","bool"],["LinksUpToDate","LinksUpToDate","bool"],["ScaleCrop","ScaleCrop","bool"],["HeadingPairs","HeadingPairs","raw"],["TitlesOfParts","TitlesOfParts","raw"]];XMLNS.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";RELS.EXT_PROPS='http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';var PseudoPropsPairs=["Worksheets","SheetNames","NamedRanges","DefinedNames","Chartsheets","ChartNames"];function load_props_pairs(HP,TOP,props,opts){var v=[];if(typeof HP=="string")v=parseVector(HP,opts);else for(var j=0;j<HP.length;++j)v=v.concat(HP[j].map(function(hp){return {v:hp};}));var parts=typeof TOP=="string"?parseVector(TOP,opts).map(function(x){return x.v;}):TOP;var idx=0,len=0;if(parts.length>0)for(var i=0;i!==v.length;i+=2){len=+v[i+1].v;switch(v[i].v){case"Worksheets":case"工作表":case"Листы":case"أوراق العمل":case"ワークシート":case"גליונות עבודה":case"Arbeitsblätter":case"Çalışma Sayfaları":case"Feuilles de calcul":case"Fogli di lavoro":case"Folhas de cálculo":case"Planilhas":case"Regneark":case"Hojas de cálculo":case"Werkbladen":props.Worksheets=len;props.SheetNames=parts.slice(idx,idx+len);break;case"Named Ranges":case"Rangos con nombre":case"名前付き一覧":case"Benannte Bereiche":case"Navngivne områder":props.NamedRanges=len;props.DefinedNames=parts.slice(idx,idx+len);break;case"Charts":case"Diagramme":props.Chartsheets=len;props.ChartNames=parts.slice(idx,idx+len);break;}idx+=len;}}function parse_ext_props(data,p,opts){var q={};if(!p)p={};data=utf8read(data);EXT_PROPS.forEach(function(f){var xml=(data.match(matchtag(f[0]))||[])[1];switch(f[2]){case"string":if(xml)p[f[1]]=unescapexml(xml);break;case"bool":p[f[1]]=xml==="true";break;case"raw":var cur=data.match(new RegExp("<"+f[0]+"[^>]*>([\\s\\S]*?)<\/"+f[0]+">"));if(cur&&cur.length>0)q[f[1]]=cur[1];break;}});if(q.HeadingPairs&&q.TitlesOfParts)load_props_pairs(q.HeadingPairs,q.TitlesOfParts,p,opts);return p;}var EXT_PROPS_XML_ROOT=writextag('Properties',null,{'xmlns':XMLNS.EXT_PROPS,'xmlns:vt':XMLNS.vt});function write_ext_props(cp){var o=[],W=writextag;if(!cp)cp={};cp.Application="SheetJS";o[o.length]=XML_HEADER;o[o.length]=EXT_PROPS_XML_ROOT;EXT_PROPS.forEach(function(f){if(cp[f[1]]===undefined)return;var v;switch(f[2]){case'string':v=escapexml(String(cp[f[1]]));break;case'bool':v=cp[f[1]]?'true':'false';break;}if(v!==undefined)o[o.length]=W(f[0],v);});/* TODO: HeadingPairs, TitlesOfParts */o[o.length]=W('HeadingPairs',W('vt:vector',W('vt:variant','<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant',W('vt:i4',String(cp.Worksheets))),{size:2,baseType:"variant"}));o[o.length]=W('TitlesOfParts',W('vt:vector',cp.SheetNames.map(function(s){return "<vt:lpstr>"+escapexml(s)+"</vt:lpstr>";}).join(""),{size:cp.Worksheets,baseType:"lpstr"}));if(o.length>2){o[o.length]='</Properties>';o[1]=o[1].replace("/>",">");}return o.join("");}/* 15.2.12.2 Custom File Properties Part */XMLNS.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";RELS.CUST_PROPS='http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';var custregex=/<[^>]+>[^<]*/g;function parse_cust_props(data,opts){var p={},name="";var m=data.match(custregex);if(m)for(var i=0;i!=m.length;++i){var x=m[i],y=parsexmltag(x);switch(y[0]){case'<?xml':break;case'<Properties':break;case'<property':name=unescapexml(y.name);break;case'</property>':name=null;break;default:if(x.indexOf('<vt:')===0){var toks=x.split('>');var type=toks[0].slice(4),text=toks[1];/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */switch(type){case'lpstr':case'bstr':case'lpwstr':p[name]=unescapexml(text);break;case'bool':p[name]=parsexmlbool(text);break;case'i1':case'i2':case'i4':case'i8':case'int':case'uint':p[name]=parseInt(text,10);break;case'r4':case'r8':case'decimal':p[name]=parseFloat(text);break;case'filetime':case'date':p[name]=parseDate(text);break;case'cy':case'error':p[name]=unescapexml(text);break;default:if(type.slice(-1)=='/')break;if(opts.WTF&&typeof console!=='undefined')console.warn('Unexpected',x,type,toks);}}else if(x.slice(0,2)==="</");else if(opts.WTF)throw new Error(x);}}return p;}var CUST_PROPS_XML_ROOT=writextag('Properties',null,{'xmlns':XMLNS.CUST_PROPS,'xmlns:vt':XMLNS.vt});function write_cust_props(cp){var o=[XML_HEADER,CUST_PROPS_XML_ROOT];if(!cp)return o.join("");var pid=1;keys(cp).forEach(function custprop(k){++pid;o[o.length]=writextag('property',write_vt(cp[k],true),{'fmtid':'{D5CDD505-2E9C-101B-9397-08002B2CF9AE}','pid':pid,'name':escapexml(k)});});if(o.length>2){o[o.length]='</Properties>';o[1]=o[1].replace("/>",">");}return o.join("");}/* Common Name -> XLML Name */var XLMLDocPropsMap={Title:'Title',Subject:'Subject',Author:'Author',Keywords:'Keywords',Comments:'Description',LastAuthor:'LastAuthor',RevNumber:'Revision',Application:'AppName',/* TotalTime: 'TotalTime', */LastPrinted:'LastPrinted',CreatedDate:'Created',ModifiedDate:'LastSaved',/* Pages */ /* Words */ /* Characters */Category:'Category',/* PresentationFormat */Manager:'Manager',Company:'Company',/* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */AppVersion:'Version',ContentStatus:'ContentStatus',/* NOTE: missing from schema */Identifier:'Identifier',/* NOTE: missing from schema */Language:'Language'/* NOTE: missing from schema */};var evert_XLMLDPM=evert(XLMLDocPropsMap);function xlml_set_prop(Props,tag,val){tag=evert_XLMLDPM[tag]||tag;Props[tag]=val;}function xlml_write_docprops(Props,opts){var o=[];keys(XLMLDocPropsMap).map(function(m){for(var i=0;i<CORE_PROPS.length;++i)if(CORE_PROPS[i][1]==m)return CORE_PROPS[i];for(i=0;i<EXT_PROPS.length;++i)if(EXT_PROPS[i][1]==m)return EXT_PROPS[i];throw m;}).forEach(function(p){if(Props[p[1]]==null)return;var m=opts&&opts.Props&&opts.Props[p[1]]!=null?opts.Props[p[1]]:Props[p[1]];switch(p[2]){case'date':m=new Date(m).toISOString().replace(/\.\d*Z/,"Z");break;}if(typeof m=='number')m=String(m);else if(m===true||m===false){m=m?"1":"0";}else if(m instanceof Date)m=new Date(m).toISOString().replace(/\.\d*Z/,"");o.push(writetag(XLMLDocPropsMap[p[1]]||p[1],m));});return writextag('DocumentProperties',o.join(""),{xmlns:XLMLNS.o});}function xlml_write_custprops(Props,Custprops){var BLACKLIST=["Worksheets","SheetNames"];var T='CustomDocumentProperties';var o=[];if(Props)keys(Props).forEach(function(k){if(!Object.prototype.hasOwnProperty.call(Props,k))return;for(var i=0;i<CORE_PROPS.length;++i)if(k==CORE_PROPS[i][1])return;for(i=0;i<EXT_PROPS.length;++i)if(k==EXT_PROPS[i][1])return;for(i=0;i<BLACKLIST.length;++i)if(k==BLACKLIST[i])return;var m=Props[k];var t="string";if(typeof m=='number'){t="float";m=String(m);}else if(m===true||m===false){t="boolean";m=m?"1":"0";}else m=String(m);o.push(writextag(escapexmltag(k),m,{"dt:dt":t}));});if(Custprops)keys(Custprops).forEach(function(k){if(!Object.prototype.hasOwnProperty.call(Custprops,k))return;if(Props&&Object.prototype.hasOwnProperty.call(Props,k))return;var m=Custprops[k];var t="string";if(typeof m=='number'){t="float";m=String(m);}else if(m===true||m===false){t="boolean";m=m?"1":"0";}else if(m instanceof Date){t="dateTime.tz";m=m.toISOString();}else m=String(m);o.push(writextag(escapexmltag(k),m,{"dt:dt":t}));});return '<'+T+' xmlns="'+XLMLNS.o+'">'+o.join("")+'</'+T+'>';}/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */function parse_FILETIME(blob){var dwLowDateTime=blob.read_shift(4),dwHighDateTime=blob.read_shift(4);return new Date((dwHighDateTime/1e7*Math.pow(2,32)+dwLowDateTime/1e7-11644473600)*1000).toISOString().replace(/\.000/,"");}function write_FILETIME(time){var date=typeof time=="string"?new Date(Date.parse(time)):time;var t=date.getTime()/1000+11644473600;var l=t%Math.pow(2,32),h=(t-l)/Math.pow(2,32);l*=1e7;h*=1e7;var w=l/Math.pow(2,32)|0;if(w>0){l=l%Math.pow(2,32);h+=w;}var o=new_buf(8);o.write_shift(4,l);o.write_shift(4,h);return o;}/* [MS-OSHARED] 2.3.3.1.4 Lpstr */function parse_lpstr(blob,type,pad){var start=blob.l;var str=blob.read_shift(0,'lpstr-cp');if(pad)while(blob.l-start&3)++blob.l;return str;}/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */function parse_lpwstr(blob,type,pad){var str=blob.read_shift(0,'lpwstr');if(pad)blob.l+=4-(str.length+1&3)&3;return str;}/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */function parse_VtStringBase(blob,stringType,pad){if(stringType===0x1F/*VT_LPWSTR*/)return parse_lpwstr(blob);return parse_lpstr(blob,stringType,pad);}function parse_VtString(blob,t,pad){return parse_VtStringBase(blob,t,pad===false?0:4);}function parse_VtUnalignedString(blob,t){if(!t)throw new Error("VtUnalignedString must have positive length");return parse_VtStringBase(blob,t,0);}/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */function parse_VtVecUnalignedLpstrValue(blob){var length=blob.read_shift(4);var ret=[];for(var i=0;i!=length;++i)ret[i]=blob.read_shift(0,'lpstr-cp').replace(chr0,'');return ret;}/* [MS-OSHARED] 2.3.3.1.10 VtVecUnalignedLpstr */function parse_VtVecUnalignedLpstr(blob){return parse_VtVecUnalignedLpstrValue(blob);}/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */function parse_VtHeadingPair(blob){var headingString=parse_TypedPropertyValue(blob,VT_USTR);var headerParts=parse_TypedPropertyValue(blob,VT_I4);return [headingString,headerParts];}/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */function parse_VtVecHeadingPairValue(blob){var cElements=blob.read_shift(4);var out=[];for(var i=0;i!=cElements/2;++i)out.push(parse_VtHeadingPair(blob));return out;}/* [MS-OSHARED] 2.3.3.1.15 VtVecHeadingPair */function parse_VtVecHeadingPair(blob){// NOTE: When invoked, wType & padding were already consumed
return parse_VtVecHeadingPairValue(blob);}/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */function parse_dictionary(blob,CodePage){var cnt=blob.read_shift(4);var dict={};for(var j=0;j!=cnt;++j){var pid=blob.read_shift(4);var len=blob.read_shift(4);dict[pid]=blob.read_shift(len,CodePage===0x4B0?'utf16le':'utf8').replace(chr0,'').replace(chr1,'!');if(CodePage===0x4B0&&len%2)blob.l+=2;}if(blob.l&3)blob.l=blob.l>>2+1<<2;return dict;}/* [MS-OLEPS] 2.9 BLOB */function parse_BLOB(blob){var size=blob.read_shift(4);var bytes=blob.slice(blob.l,blob.l+size);blob.l+=size;if((size&3)>0)blob.l+=4-(size&3)&3;return bytes;}/* [MS-OLEPS] 2.11 ClipboardData */function parse_ClipboardData(blob){// TODO
var o={};o.Size=blob.read_shift(4);//o.Format = blob.read_shift(4);
blob.l+=o.Size+3-(o.Size-1)%4;return o;}/* [MS-OLEPS] 2.15 TypedPropertyValue */function parse_TypedPropertyValue(blob,type,_opts){var t=blob.read_shift(2),ret,opts=_opts||{};blob.l+=2;if(type!==VT_VARIANT)if(t!==type&&VT_CUSTOM.indexOf(type)===-1)throw new Error('Expected type '+type+' saw '+t);switch(type===VT_VARIANT?t:type){case 0x02/*VT_I2*/:ret=blob.read_shift(2,'i');if(!opts.raw)blob.l+=2;return ret;case 0x03/*VT_I4*/:ret=blob.read_shift(4,'i');return ret;case 0x0B/*VT_BOOL*/:return blob.read_shift(4)!==0x0;case 0x13/*VT_UI4*/:ret=blob.read_shift(4);return ret;case 0x1E/*VT_LPSTR*/:return parse_lpstr(blob,t,4).replace(chr0,'');case 0x1F/*VT_LPWSTR*/:return parse_lpwstr(blob);case 0x40/*VT_FILETIME*/:return parse_FILETIME(blob);case 0x41/*VT_BLOB*/:return parse_BLOB(blob);case 0x47/*VT_CF*/:return parse_ClipboardData(blob);case 0x50/*VT_STRING*/:return parse_VtString(blob,t,!opts.raw).replace(chr0,'');case 0x51/*VT_USTR*/:return parse_VtUnalignedString(blob,t/*, 4*/).replace(chr0,'');case 0x100C/*VT_VECTOR|VT_VARIANT*/:return parse_VtVecHeadingPair(blob);case 0x101E/*VT_LPSTR*/:return parse_VtVecUnalignedLpstr(blob);default:throw new Error("TypedPropertyValue unrecognized type "+type+" "+t);}}function write_TypedPropertyValue(type,value){var o=new_buf(4),p=new_buf(4);o.write_shift(4,type==0x50?0x1F:type);switch(type){case 0x03/*VT_I4*/:p.write_shift(-4,value);break;case 0x05/*VT_I4*/:p=new_buf(8);p.write_shift(8,value,'f');break;case 0x0B/*VT_BOOL*/:p.write_shift(4,value?0x01:0x00);break;case 0x40/*VT_FILETIME*/:p=write_FILETIME(value);break;case 0x1F/*VT_LPWSTR*/:case 0x50/*VT_STRING*/:p=new_buf(4+2*(value.length+1)+(value.length%2?0:2));p.write_shift(4,value.length+1);p.write_shift(0,value,"dbcs");while(p.l!=p.length)p.write_shift(1,0);break;default:throw new Error("TypedPropertyValue unrecognized type "+type+" "+value);}return bconcat([o,p]);}/* [MS-OLEPS] 2.20 PropertySet */function parse_PropertySet(blob,PIDSI){var start_addr=blob.l;var size=blob.read_shift(4);var NumProps=blob.read_shift(4);var Props=[],i=0;var CodePage=0;var Dictionary=-1,DictObj={};for(i=0;i!=NumProps;++i){var PropID=blob.read_shift(4);var Offset=blob.read_shift(4);Props[i]=[PropID,Offset+start_addr];}Props.sort(function(x,y){return x[1]-y[1];});var PropH={};for(i=0;i!=NumProps;++i){if(blob.l!==Props[i][1]){var fail=true;if(i>0&&PIDSI)switch(PIDSI[Props[i-1][0]].t){case 0x02/*VT_I2*/:if(blob.l+2===Props[i][1]){blob.l+=2;fail=false;}break;case 0x50/*VT_STRING*/:if(blob.l<=Props[i][1]){blob.l=Props[i][1];fail=false;}break;case 0x100C/*VT_VECTOR|VT_VARIANT*/:if(blob.l<=Props[i][1]){blob.l=Props[i][1];fail=false;}break;}if((!PIDSI||i==0)&&blob.l<=Props[i][1]){fail=false;blob.l=Props[i][1];}if(fail)throw new Error("Read Error: Expected address "+Props[i][1]+' at '+blob.l+' :'+i);}if(PIDSI){var piddsi=PIDSI[Props[i][0]];PropH[piddsi.n]=parse_TypedPropertyValue(blob,piddsi.t,{raw:true});if(piddsi.p==='version')PropH[piddsi.n]=String(PropH[piddsi.n]>>16)+"."+("0000"+String(PropH[piddsi.n]&0xFFFF)).slice(-4);if(piddsi.n=="CodePage")switch(PropH[piddsi.n]){case 0:PropH[piddsi.n]=1252;/* falls through */case 874:case 932:case 936:case 949:case 950:case 1250:case 1251:case 1253:case 1254:case 1255:case 1256:case 1257:case 1258:case 10000:case 1200:case 1201:case 1252:case 65000:case-536:case 65001:case-535:set_cp(CodePage=PropH[piddsi.n]>>>0&0xFFFF);break;default:throw new Error("Unsupported CodePage: "+PropH[piddsi.n]);}}else {if(Props[i][0]===0x1){CodePage=PropH.CodePage=parse_TypedPropertyValue(blob,VT_I2);set_cp(CodePage);if(Dictionary!==-1){var oldpos=blob.l;blob.l=Props[Dictionary][1];DictObj=parse_dictionary(blob,CodePage);blob.l=oldpos;}}else if(Props[i][0]===0){if(CodePage===0){Dictionary=i;blob.l=Props[i+1][1];continue;}DictObj=parse_dictionary(blob,CodePage);}else {var name=DictObj[Props[i][0]];var val;/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */switch(blob[blob.l]){case 0x41/*VT_BLOB*/:blob.l+=4;val=parse_BLOB(blob);break;case 0x1E/*VT_LPSTR*/:blob.l+=4;val=parse_VtString(blob,blob[blob.l-4]).replace(/\u0000+$/,"");break;case 0x1F/*VT_LPWSTR*/:blob.l+=4;val=parse_VtString(blob,blob[blob.l-4]).replace(/\u0000+$/,"");break;case 0x03/*VT_I4*/:blob.l+=4;val=blob.read_shift(4,'i');break;case 0x13/*VT_UI4*/:blob.l+=4;val=blob.read_shift(4);break;case 0x05/*VT_R8*/:blob.l+=4;val=blob.read_shift(8,'f');break;case 0x0B/*VT_BOOL*/:blob.l+=4;val=parsebool(blob,4);break;case 0x40/*VT_FILETIME*/:blob.l+=4;val=parseDate(parse_FILETIME(blob));break;default:throw new Error("unparsed value: "+blob[blob.l]);}PropH[name]=val;}}}blob.l=start_addr+size;/* step ahead to skip padding */return PropH;}var XLSPSSkip=["CodePage","Thumbnail","_PID_LINKBASE","_PID_HLINKS","SystemIdentifier","FMTID"].concat(PseudoPropsPairs);function guess_property_type(val){switch(typeof val){case"boolean":return 0x0B;case"number":return (val|0)==val?0x03:0x05;case"string":return 0x1F;case"object":if(val instanceof Date)return 0x40;break;}return -1;}function write_PropertySet(entries,RE,PIDSI){var hdr=new_buf(8),piao=[],prop=[];var sz=8,i=0;var pr=new_buf(8),pio=new_buf(8);pr.write_shift(4,0x0002);pr.write_shift(4,0x04B0);pio.write_shift(4,0x0001);prop.push(pr);piao.push(pio);sz+=8+pr.length;if(!RE){pio=new_buf(8);pio.write_shift(4,0);piao.unshift(pio);var bufs=[new_buf(4)];bufs[0].write_shift(4,entries.length);for(i=0;i<entries.length;++i){var value=entries[i][0];pr=new_buf(4+4+2*(value.length+1)+(value.length%2?0:2));pr.write_shift(4,i+2);pr.write_shift(4,value.length+1);pr.write_shift(0,value,"dbcs");while(pr.l!=pr.length)pr.write_shift(1,0);bufs.push(pr);}pr=bconcat(bufs);prop.unshift(pr);sz+=8+pr.length;}for(i=0;i<entries.length;++i){if(RE&&!RE[entries[i][0]])continue;if(XLSPSSkip.indexOf(entries[i][0])>-1)continue;if(entries[i][1]==null)continue;var val=entries[i][1],idx=0;if(RE){idx=+RE[entries[i][0]];var pinfo=PIDSI[idx];if(pinfo.p=="version"&&typeof val=="string"){var arr=val.split(".");val=(+arr[0]<<16)+(+arr[1]||0);}pr=write_TypedPropertyValue(pinfo.t,val);}else {var T=guess_property_type(val);if(T==-1){T=0x1F;val=String(val);}pr=write_TypedPropertyValue(T,val);}prop.push(pr);pio=new_buf(8);pio.write_shift(4,!RE?2+i:idx);piao.push(pio);sz+=8+pr.length;}var w=8*(prop.length+1);for(i=0;i<prop.length;++i){piao[i].write_shift(4,w);w+=prop[i].length;}hdr.write_shift(4,sz);hdr.write_shift(4,prop.length);return bconcat([hdr].concat(piao).concat(prop));}/* [MS-OLEPS] 2.21 PropertySetStream */function parse_PropertySetStream(file,PIDSI,clsid){var blob=file.content;if(!blob)return {};prep_blob(blob,0);var NumSets,FMTID0,FMTID1,Offset0,Offset1=0;blob.chk('feff','Byte Order: ');/*var vers = */blob.read_shift(2);// TODO: check version
var SystemIdentifier=blob.read_shift(4);var CLSID=blob.read_shift(16);if(CLSID!==CFB.utils.consts.HEADER_CLSID&&CLSID!==clsid)throw new Error("Bad PropertySet CLSID "+CLSID);NumSets=blob.read_shift(4);if(NumSets!==1&&NumSets!==2)throw new Error("Unrecognized #Sets: "+NumSets);FMTID0=blob.read_shift(16);Offset0=blob.read_shift(4);if(NumSets===1&&Offset0!==blob.l)throw new Error("Length mismatch: "+Offset0+" !== "+blob.l);else if(NumSets===2){FMTID1=blob.read_shift(16);Offset1=blob.read_shift(4);}var PSet0=parse_PropertySet(blob,PIDSI);var rval={SystemIdentifier:SystemIdentifier};for(var y in PSet0)rval[y]=PSet0[y];//rval.blob = blob;
rval.FMTID=FMTID0;//rval.PSet0 = PSet0;
if(NumSets===1)return rval;if(Offset1-blob.l==2)blob.l+=2;if(blob.l!==Offset1)throw new Error("Length mismatch 2: "+blob.l+" !== "+Offset1);var PSet1;try{PSet1=parse_PropertySet(blob,null);}catch(e){/* empty */}for(y in PSet1)rval[y]=PSet1[y];rval.FMTID=[FMTID0,FMTID1];// TODO: verify FMTID0/1
return rval;}function write_PropertySetStream(entries,clsid,RE,PIDSI,entries2,clsid2){var hdr=new_buf(entries2?68:48);var bufs=[hdr];hdr.write_shift(2,0xFFFE);hdr.write_shift(2,0x0000);/* TODO: type 1 props */hdr.write_shift(4,0x32363237);hdr.write_shift(16,CFB.utils.consts.HEADER_CLSID,"hex");hdr.write_shift(4,entries2?2:1);hdr.write_shift(16,clsid,"hex");hdr.write_shift(4,entries2?68:48);var ps0=write_PropertySet(entries,RE,PIDSI);bufs.push(ps0);if(entries2){var ps1=write_PropertySet(entries2,null,null);hdr.write_shift(16,clsid2,"hex");hdr.write_shift(4,68+ps0.length);bufs.push(ps1);}return bconcat(bufs);}function parsenoop2(blob,length){blob.read_shift(length);return null;}function writezeroes(n,o){if(!o)o=new_buf(n);for(var j=0;j<n;++j)o.write_shift(1,0);return o;}function parslurp(blob,length,cb){var arr=[],target=blob.l+length;while(blob.l<target)arr.push(cb(blob,target-blob.l));if(target!==blob.l)throw new Error("Slurp error");return arr;}function parsebool(blob,length){return blob.read_shift(length)===0x1;}function writebool(v,o){if(!o)o=new_buf(2);o.write_shift(2,+!!v);return o;}function parseuint16(blob){return blob.read_shift(2,'u');}function writeuint16(v,o){if(!o)o=new_buf(2);o.write_shift(2,v);return o;}function parseuint16a(blob,length){return parslurp(blob,length,parseuint16);}/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */function parse_Bes(blob){var v=blob.read_shift(1),t=blob.read_shift(1);return t===0x01?v:v===0x01;}function write_Bes(v,t,o){if(!o)o=new_buf(2);o.write_shift(1,+v);o.write_shift(1,t=='e'?1:0);return o;}/* [MS-XLS] 2.5.240 ShortXLUnicodeString */function parse_ShortXLUnicodeString(blob,length,opts){var cch=blob.read_shift(opts&&opts.biff>=12?2:1);var encoding='sbcs-cont';var cp=current_codepage;if(opts&&opts.biff>=8)current_codepage=1200;if(!opts||opts.biff==8){var fHighByte=blob.read_shift(1);if(fHighByte){encoding='dbcs-cont';}}else if(opts.biff==12){encoding='wstr';}if(opts.biff>=2&&opts.biff<=5)encoding='cpstr';var o=cch?blob.read_shift(cch,encoding):"";current_codepage=cp;return o;}/* 2.5.293 XLUnicodeRichExtendedString */function parse_XLUnicodeRichExtendedString(blob){var cp=current_codepage;current_codepage=1200;var cch=blob.read_shift(2),flags=blob.read_shift(1);var/*fHighByte = flags & 0x1,*/fExtSt=flags&0x4,fRichSt=flags&0x8;var width=1+(flags&0x1);// 0x0 -> utf8, 0x1 -> dbcs
var cRun=0,cbExtRst;var z={};if(fRichSt)cRun=blob.read_shift(2);if(fExtSt)cbExtRst=blob.read_shift(4);var encoding=width==2?'dbcs-cont':'sbcs-cont';var msg=cch===0?"":blob.read_shift(cch,encoding);if(fRichSt)blob.l+=4*cRun;//TODO: parse this
if(fExtSt)blob.l+=cbExtRst;//TODO: parse this
z.t=msg;if(!fRichSt){z.raw="<t>"+z.t+"</t>";z.r=z.t;}current_codepage=cp;return z;}function write_XLUnicodeRichExtendedString(xlstr){var str=xlstr.t||"";var hdr=new_buf(3+(0));hdr.write_shift(2,str.length);hdr.write_shift(1,(0x00)|0x01);var otext=new_buf(2*str.length);otext.write_shift(2*str.length,str,'utf16le');var out=[hdr,otext];return bconcat(out);}/* 2.5.296 XLUnicodeStringNoCch */function parse_XLUnicodeStringNoCch(blob,cch,opts){var retval;if(opts){if(opts.biff>=2&&opts.biff<=5)return blob.read_shift(cch,'cpstr');if(opts.biff>=12)return blob.read_shift(cch,'dbcs-cont');}var fHighByte=blob.read_shift(1);if(fHighByte===0){retval=blob.read_shift(cch,'sbcs-cont');}else {retval=blob.read_shift(cch,'dbcs-cont');}return retval;}/* 2.5.294 XLUnicodeString */function parse_XLUnicodeString(blob,length,opts){var cch=blob.read_shift(opts&&opts.biff==2?1:2);if(cch===0){blob.l++;return "";}return parse_XLUnicodeStringNoCch(blob,cch,opts);}/* BIFF5 override */function parse_XLUnicodeString2(blob,length,opts){if(opts.biff>5)return parse_XLUnicodeString(blob,length,opts);var cch=blob.read_shift(1);if(cch===0){blob.l++;return "";}return blob.read_shift(cch,opts.biff<=4||!blob.lens?'cpstr':'sbcs-cont');}/* TODO: BIFF5 and lower, codepage awareness */function write_XLUnicodeString(str,opts,o){if(!o)o=new_buf(3+2*str.length);o.write_shift(2,str.length);o.write_shift(1,1);o.write_shift(31,str,'utf16le');return o;}/* [MS-XLS] 2.5.61 ControlInfo */function parse_ControlInfo(blob){var flags=blob.read_shift(1);blob.l++;var accel=blob.read_shift(2);blob.l+=2;return [flags,accel];}/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */function parse_URLMoniker(blob){var len=blob.read_shift(4),start=blob.l;var extra=false;if(len>24){/* look ahead */blob.l+=len-24;if(blob.read_shift(16)==="795881f43b1d7f48af2c825dc4852763")extra=true;blob.l=start;}var url=blob.read_shift((extra?len-24:len)>>1,'utf16le').replace(chr0,"");if(extra)blob.l+=24;return url;}/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */function parse_FileMoniker(blob){blob.l+=2;//var cAnti = blob.read_shift(2);
var ansiPath=blob.read_shift(0,'lpstr-ansi');blob.l+=2;//var endServer = blob.read_shift(2);
if(blob.read_shift(2)!=0xDEAD)throw new Error("Bad FileMoniker");var sz=blob.read_shift(4);if(sz===0)return ansiPath.replace(/\\/g,"/");var bytes=blob.read_shift(4);if(blob.read_shift(2)!=3)throw new Error("Bad FileMoniker");var unicodePath=blob.read_shift(bytes>>1,'utf16le').replace(chr0,"");return unicodePath;}/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */function parse_HyperlinkMoniker(blob,length){var clsid=blob.read_shift(16);switch(clsid){case"e0c9ea79f9bace118c8200aa004ba90b":return parse_URLMoniker(blob);case"0303000000000000c000000000000046":return parse_FileMoniker(blob);default:throw new Error("Unsupported Moniker "+clsid);}}/* [MS-OSHARED] 2.3.7.9 HyperlinkString */function parse_HyperlinkString(blob){var len=blob.read_shift(4);var o=len>0?blob.read_shift(len,'utf16le').replace(chr0,""):"";return o;}/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */function parse_Hyperlink(blob,length){var end=blob.l+length;var sVer=blob.read_shift(4);if(sVer!==2)throw new Error("Unrecognized streamVersion: "+sVer);var flags=blob.read_shift(2);blob.l+=2;var displayName,targetFrameName,moniker,oleMoniker,Loc="",guid,fileTime;if(flags&0x0010)displayName=parse_HyperlinkString(blob,end-blob.l);if(flags&0x0080)targetFrameName=parse_HyperlinkString(blob,end-blob.l);if((flags&0x0101)===0x0101)moniker=parse_HyperlinkString(blob,end-blob.l);if((flags&0x0101)===0x0001)oleMoniker=parse_HyperlinkMoniker(blob,end-blob.l);if(flags&0x0008)Loc=parse_HyperlinkString(blob,end-blob.l);if(flags&0x0020)guid=blob.read_shift(16);if(flags&0x0040)fileTime=parse_FILETIME(blob/*, 8*/);blob.l=end;var target=targetFrameName||moniker||oleMoniker||"";if(target&&Loc)target+="#"+Loc;if(!target)target="#"+Loc;var out={Target:target};if(guid)out.guid=guid;if(fileTime)out.time=fileTime;if(displayName)out.Tooltip=displayName;return out;}function write_Hyperlink(hl){var out=new_buf(512),i=0;var Target=hl.Target;var F=Target.indexOf("#")>-1?0x1f:0x17;switch(Target.charAt(0)){case"#":F=0x1c;break;case".":F&=~2;break;}out.write_shift(4,2);out.write_shift(4,F);var data=[8,6815827,6619237,4849780,83];for(i=0;i<data.length;++i)out.write_shift(4,data[i]);if(F==0x1C){Target=Target.slice(1);out.write_shift(4,Target.length+1);for(i=0;i<Target.length;++i)out.write_shift(2,Target.charCodeAt(i));out.write_shift(2,0);}else if(F&0x02){data="e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(i=0;i<data.length;++i)out.write_shift(1,parseInt(data[i],16));out.write_shift(4,2*(Target.length+1));for(i=0;i<Target.length;++i)out.write_shift(2,Target.charCodeAt(i));out.write_shift(2,0);}else {data="03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");for(i=0;i<data.length;++i)out.write_shift(1,parseInt(data[i],16));var P=0;while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\")++P;out.write_shift(2,P);out.write_shift(4,Target.length+1);for(i=0;i<Target.length;++i)out.write_shift(1,Target.charCodeAt(i)&0xFF);out.write_shift(1,0);out.write_shift(2,0xFFFF);out.write_shift(2,0xDEAD);for(i=0;i<6;++i)out.write_shift(4,0);}return out.slice(0,out.l);}/* 2.5.178 LongRGBA */function parse_LongRGBA(blob){var r=blob.read_shift(1),g=blob.read_shift(1),b=blob.read_shift(1),a=blob.read_shift(1);return [r,g,b,a];}/* 2.5.177 LongRGB */function parse_LongRGB(blob,length){var x=parse_LongRGBA(blob);x[3]=0;return x;}/* [MS-XLS] 2.5.19 */function parse_XLSCell(blob){var rw=blob.read_shift(2);// 0-indexed
var col=blob.read_shift(2);var ixfe=blob.read_shift(2);return {r:rw,c:col,ixfe:ixfe};}function write_XLSCell(R,C,ixfe,o){if(!o)o=new_buf(6);o.write_shift(2,R);o.write_shift(2,C);o.write_shift(2,ixfe||0);return o;}/* [MS-XLS] 2.5.134 */function parse_frtHeader(blob){var rt=blob.read_shift(2);var flags=blob.read_shift(2);// TODO: parse these flags
blob.l+=8;return {type:rt,flags:flags};}function parse_OptXLUnicodeString(blob,length,opts){return length===0?"":parse_XLUnicodeString2(blob,length,opts);}/* [MS-XLS] 2.5.344 */function parse_XTI(blob,length,opts){var w=opts.biff>8?4:2;var iSupBook=blob.read_shift(w),itabFirst=blob.read_shift(w,'i'),itabLast=blob.read_shift(w,'i');return [iSupBook,itabFirst,itabLast];}/* [MS-XLS] 2.5.218 */function parse_RkRec(blob){var ixfe=blob.read_shift(2);var RK=parse_RkNumber(blob);return [ixfe,RK];}/* [MS-XLS] 2.5.1 */function parse_AddinUdf(blob,length,opts){blob.l+=4;length-=4;var l=blob.l+length;var udfName=parse_ShortXLUnicodeString(blob,length,opts);var cb=blob.read_shift(2);l-=blob.l;if(cb!==l)throw new Error("Malformed AddinUdf: padding = "+l+" != "+cb);blob.l+=cb;return udfName;}/* [MS-XLS] 2.5.209 TODO: Check sizes */function parse_Ref8U(blob){var rwFirst=blob.read_shift(2);var rwLast=blob.read_shift(2);var colFirst=blob.read_shift(2);var colLast=blob.read_shift(2);return {s:{c:colFirst,r:rwFirst},e:{c:colLast,r:rwLast}};}function write_Ref8U(r,o){if(!o)o=new_buf(8);o.write_shift(2,r.s.r);o.write_shift(2,r.e.r);o.write_shift(2,r.s.c);o.write_shift(2,r.e.c);return o;}/* [MS-XLS] 2.5.211 */function parse_RefU(blob){var rwFirst=blob.read_shift(2);var rwLast=blob.read_shift(2);var colFirst=blob.read_shift(1);var colLast=blob.read_shift(1);return {s:{c:colFirst,r:rwFirst},e:{c:colLast,r:rwLast}};}/* [MS-XLS] 2.5.207 */var parse_Ref=parse_RefU;/* [MS-XLS] 2.5.143 */function parse_FtCmo(blob){blob.l+=4;var ot=blob.read_shift(2);var id=blob.read_shift(2);var flags=blob.read_shift(2);blob.l+=12;return [id,ot,flags];}/* [MS-XLS] 2.5.149 */function parse_FtNts(blob){var out={};blob.l+=4;blob.l+=16;// GUID TODO
out.fSharedNote=blob.read_shift(2);blob.l+=4;return out;}/* [MS-XLS] 2.5.142 */function parse_FtCf(blob){var out={};blob.l+=4;blob.cf=blob.read_shift(2);return out;}/* [MS-XLS] 2.5.140 - 2.5.154 and friends */function parse_FtSkip(blob){blob.l+=2;blob.l+=blob.read_shift(2);}var FtTab={0x00:parse_FtSkip,/* FtEnd */0x04:parse_FtSkip,/* FtMacro */0x05:parse_FtSkip,/* FtButton */0x06:parse_FtSkip,/* FtGmo */0x07:parse_FtCf,/* FtCf */0x08:parse_FtSkip,/* FtPioGrbit */0x09:parse_FtSkip,/* FtPictFmla */0x0A:parse_FtSkip,/* FtCbls */0x0B:parse_FtSkip,/* FtRbo */0x0C:parse_FtSkip,/* FtSbs */0x0D:parse_FtNts,/* FtNts */0x0E:parse_FtSkip,/* FtSbsFmla */0x0F:parse_FtSkip,/* FtGboData */0x10:parse_FtSkip,/* FtEdoData */0x11:parse_FtSkip,/* FtRboData */0x12:parse_FtSkip,/* FtCblsData */0x13:parse_FtSkip,/* FtLbsData */0x14:parse_FtSkip,/* FtCblsFmla */0x15:parse_FtCmo};function parse_FtArray(blob,length){var tgt=blob.l+length;var fts=[];while(blob.l<tgt){var ft=blob.read_shift(2);blob.l-=2;try{fts.push(FtTab[ft](blob,tgt-blob.l));}catch(e){blob.l=tgt;return fts;}}if(blob.l!=tgt)blob.l=tgt;//throw new Error("bad Object Ft-sequence");
return fts;}/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */function parse_BOF(blob,length){var o={BIFFVer:0,dt:0};o.BIFFVer=blob.read_shift(2);length-=2;if(length>=2){o.dt=blob.read_shift(2);blob.l-=2;}switch(o.BIFFVer){case 0x0600:/* BIFF8 */case 0x0500:/* BIFF5 */case 0x0400:/* BIFF4 */case 0x0300:/* BIFF3 */case 0x0200:/* BIFF2 */case 0x0002:case 0x0007:/* BIFF2 */break;default:if(length>6)throw new Error("Unexpected BIFF Ver "+o.BIFFVer);}blob.read_shift(length);return o;}function write_BOF(wb,t,o){var h=0x0600,w=16;switch(o.bookType){case'biff8':break;case'biff5':h=0x0500;w=8;break;case'biff4':h=0x0004;w=6;break;case'biff3':h=0x0003;w=6;break;case'biff2':h=0x0002;w=4;break;case'xla':break;default:throw new Error("unsupported BIFF version");}var out=new_buf(w);out.write_shift(2,h);out.write_shift(2,t);if(w>4)out.write_shift(2,0x7262);if(w>6)out.write_shift(2,0x07CD);if(w>8){out.write_shift(2,0xC009);out.write_shift(2,0x0001);out.write_shift(2,0x0706);out.write_shift(2,0x0000);}return out;}/* [MS-XLS] 2.4.146 */function parse_InterfaceHdr(blob,length){if(length===0)return 0x04b0;if(blob.read_shift(2)!==0x04b0);return 0x04b0;}/* [MS-XLS] 2.4.349 */function parse_WriteAccess(blob,length,opts){if(opts.enc){blob.l+=length;return "";}var l=blob.l;// TODO: make sure XLUnicodeString doesnt overrun
var UserName=parse_XLUnicodeString2(blob,0,opts);blob.read_shift(length+l-blob.l);return UserName;}function write_WriteAccess(s,opts){var b8=!opts||opts.biff==8;var o=new_buf(b8?112:54);o.write_shift(opts.biff==8?2:1,7);if(b8)o.write_shift(1,0);o.write_shift(4,0x33336853);o.write_shift(4,0x00534A74|(b8?0:0x20000000));while(o.l<o.length)o.write_shift(1,b8?0:32);return o;}/* [MS-XLS] 2.4.351 */function parse_WsBool(blob,length,opts){var flags=opts&&opts.biff==8||length==2?blob.read_shift(2):(blob.l+=length,0);return {fDialog:flags&0x10};}/* [MS-XLS] 2.4.28 */function parse_BoundSheet8(blob,length,opts){var pos=blob.read_shift(4);var hidden=blob.read_shift(1)&0x03;var dt=blob.read_shift(1);switch(dt){case 0:dt='Worksheet';break;case 1:dt='Macrosheet';break;case 2:dt='Chartsheet';break;case 6:dt='VBAModule';break;}var name=parse_ShortXLUnicodeString(blob,0,opts);if(name.length===0)name="Sheet1";return {pos:pos,hs:hidden,dt:dt,name:name};}function write_BoundSheet8(data,opts){var w=!opts||opts.biff>=8?2:1;var o=new_buf(8+w*data.name.length);o.write_shift(4,data.pos);o.write_shift(1,data.hs||0);o.write_shift(1,data.dt);o.write_shift(1,data.name.length);if(opts.biff>=8)o.write_shift(1,1);o.write_shift(w*data.name.length,data.name,opts.biff<8?'sbcs':'utf16le');var out=o.slice(0,o.l);out.l=o.l;return out;}/* [MS-XLS] 2.4.265 TODO */function parse_SST(blob,length){var end=blob.l+length;var cnt=blob.read_shift(4);var ucnt=blob.read_shift(4);var strs=[];for(var i=0;i!=ucnt&&blob.l<end;++i){strs.push(parse_XLUnicodeRichExtendedString(blob));}strs.Count=cnt;strs.Unique=ucnt;return strs;}function write_SST(sst,opts){var header=new_buf(8);header.write_shift(4,sst.Count);header.write_shift(4,sst.Unique);var strs=[];for(var j=0;j<sst.length;++j)strs[j]=write_XLUnicodeRichExtendedString(sst[j]);var o=bconcat([header].concat(strs));o.parts=[header.length].concat(strs.map(function(str){return str.length;}));return o;}/* [MS-XLS] 2.4.107 */function parse_ExtSST(blob,length){var extsst={};extsst.dsst=blob.read_shift(2);blob.l+=length-2;return extsst;}/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */function parse_Row(blob){var z={};z.r=blob.read_shift(2);z.c=blob.read_shift(2);z.cnt=blob.read_shift(2)-z.c;var miyRw=blob.read_shift(2);blob.l+=4;// reserved(2), unused(2)
var flags=blob.read_shift(1);// various flags
blob.l+=3;// reserved(8), ixfe(12), flags(4)
if(flags&0x07)z.level=flags&0x07;// collapsed: flags & 0x10
if(flags&0x20)z.hidden=true;if(flags&0x40)z.hpt=miyRw/20;return z;}/* [MS-XLS] 2.4.125 */function parse_ForceFullCalculation(blob){var header=parse_frtHeader(blob);if(header.type!=0x08A3)throw new Error("Invalid Future Record "+header.type);var fullcalc=blob.read_shift(4);return fullcalc!==0x0;}/* [MS-XLS] 2.4.215 rt */function parse_RecalcId(blob){blob.read_shift(2);return blob.read_shift(4);}/* [MS-XLS] 2.4.87 */function parse_DefaultRowHeight(blob,length,opts){var f=0;if(!(opts&&opts.biff==2)){f=blob.read_shift(2);}var miyRw=blob.read_shift(2);if(opts&&opts.biff==2){f=1-(miyRw>>15);miyRw&=0x7fff;}var fl={Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};return [fl,miyRw];}/* [MS-XLS] 2.4.345 TODO */function parse_Window1(blob){var xWn=blob.read_shift(2),yWn=blob.read_shift(2),dxWn=blob.read_shift(2),dyWn=blob.read_shift(2);var flags=blob.read_shift(2),iTabCur=blob.read_shift(2),iTabFirst=blob.read_shift(2);var ctabSel=blob.read_shift(2),wTabRatio=blob.read_shift(2);return {Pos:[xWn,yWn],Dim:[dxWn,dyWn],Flags:flags,CurTab:iTabCur,FirstTab:iTabFirst,Selected:ctabSel,TabRatio:wTabRatio};}function write_Window1(){var o=new_buf(18);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0x7260);o.write_shift(2,0x44c0);o.write_shift(2,0x38);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,1);o.write_shift(2,0x01f4);return o;}/* [MS-XLS] 2.4.346 TODO */function parse_Window2(blob,length,opts){if(opts&&opts.biff>=2&&opts.biff<5)return {};var f=blob.read_shift(2);return {RTL:f&0x40};}function write_Window2(view){var o=new_buf(18),f=0x6b6;if(view&&view.RTL)f|=0x40;o.write_shift(2,f);o.write_shift(4,0);o.write_shift(4,64);o.write_shift(4,0);o.write_shift(4,0);return o;}/* [MS-XLS] 2.4.189 TODO */function/*blob, length, opts*/parse_Pane(){}/* [MS-XLS] 2.4.122 TODO */function parse_Font(blob,length,opts){var o={dyHeight:blob.read_shift(2),fl:blob.read_shift(2)};switch(opts&&opts.biff||8){case 2:break;case 3:case 4:blob.l+=2;break;default:blob.l+=10;break;}o.name=parse_ShortXLUnicodeString(blob,0,opts);return o;}function write_Font(data,opts){var name=data.name||"Arial";var b5=opts&&opts.biff==5,w=b5?15+name.length:16+2*name.length;var o=new_buf(w);o.write_shift(2,(data.sz||12)*20);o.write_shift(4,0);o.write_shift(2,400);o.write_shift(4,0);o.write_shift(2,0);o.write_shift(1,name.length);if(!b5)o.write_shift(1,1);o.write_shift((b5?1:2)*name.length,name,b5?"sbcs":"utf16le");return o;}/* [MS-XLS] 2.4.149 */function parse_LabelSst(blob){var cell=parse_XLSCell(blob);cell.isst=blob.read_shift(4);return cell;}function write_LabelSst(R,C,v,os){var o=new_buf(10);write_XLSCell(R,C,os,o);o.write_shift(4,v);return o;}/* [MS-XLS] 2.4.148 */function parse_Label(blob,length,opts){var target=blob.l+length;var cell=parse_XLSCell(blob);if(opts.biff==2)blob.l++;var str=parse_XLUnicodeString(blob,target-blob.l,opts);cell.val=str;return cell;}function write_Label(R,C,v,os,opts){var b8=!opts||opts.biff==8;var o=new_buf(6+2+ +b8+(1+b8)*v.length);write_XLSCell(R,C,os,o);o.write_shift(2,v.length);if(b8)o.write_shift(1,1);o.write_shift((1+b8)*v.length,v,b8?'utf16le':'sbcs');return o;}/* [MS-XLS] 2.4.126 Number Formats */function parse_Format(blob,length,opts){var numFmtId=blob.read_shift(2);var fmtstr=parse_XLUnicodeString2(blob,0,opts);return [numFmtId,fmtstr];}function write_Format(i,f,opts,o){var b5=opts&&opts.biff==5;if(!o)o=new_buf(b5?3+f.length:5+2*f.length);o.write_shift(2,i);o.write_shift(b5?1:2,f.length);if(!b5)o.write_shift(1,1);o.write_shift((b5?1:2)*f.length,f,b5?'sbcs':'utf16le');var out=o.length>o.l?o.slice(0,o.l):o;if(out.l==null)out.l=out.length;return out;}var parse_BIFF2Format=parse_XLUnicodeString2;/* [MS-XLS] 2.4.90 */function parse_Dimensions(blob,length,opts){var end=blob.l+length;var w=opts.biff==8||!opts.biff?4:2;var r=blob.read_shift(w),R=blob.read_shift(w);var c=blob.read_shift(2),C=blob.read_shift(2);blob.l=end;return {s:{r:r,c:c},e:{r:R,c:C}};}function write_Dimensions(range,opts){var w=opts.biff==8||!opts.biff?4:2;var o=new_buf(2*w+6);o.write_shift(w,range.s.r);o.write_shift(w,range.e.r+1);o.write_shift(2,range.s.c);o.write_shift(2,range.e.c+1);o.write_shift(2,0);return o;}/* [MS-XLS] 2.4.220 */function parse_RK(blob){var rw=blob.read_shift(2),col=blob.read_shift(2);var rkrec=parse_RkRec(blob);return {r:rw,c:col,ixfe:rkrec[0],rknum:rkrec[1]};}/* [MS-XLS] 2.4.175 */function parse_MulRk(blob,length){var target=blob.l+length-2;var rw=blob.read_shift(2),col=blob.read_shift(2);var rkrecs=[];while(blob.l<target)rkrecs.push(parse_RkRec(blob));if(blob.l!==target)throw new Error("MulRK read error");var lastcol=blob.read_shift(2);if(rkrecs.length!=lastcol-col+1)throw new Error("MulRK length mismatch");return {r:rw,c:col,C:lastcol,rkrec:rkrecs};}/* [MS-XLS] 2.4.174 */function parse_MulBlank(blob,length){var target=blob.l+length-2;var rw=blob.read_shift(2),col=blob.read_shift(2);var ixfes=[];while(blob.l<target)ixfes.push(blob.read_shift(2));if(blob.l!==target)throw new Error("MulBlank read error");var lastcol=blob.read_shift(2);if(ixfes.length!=lastcol-col+1)throw new Error("MulBlank length mismatch");return {r:rw,c:col,C:lastcol,ixfe:ixfes};}/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */function parse_CellStyleXF(blob,length,style,opts){var o={};var a=blob.read_shift(4),b=blob.read_shift(4);var c=blob.read_shift(4),d=blob.read_shift(2);o.patternType=XLSFillPattern[c>>26];if(!opts.cellStyles)return o;o.alc=a&0x07;o.fWrap=a>>3&0x01;o.alcV=a>>4&0x07;o.fJustLast=a>>7&0x01;o.trot=a>>8&0xFF;o.cIndent=a>>16&0x0F;o.fShrinkToFit=a>>20&0x01;o.iReadOrder=a>>22&0x02;o.fAtrNum=a>>26&0x01;o.fAtrFnt=a>>27&0x01;o.fAtrAlc=a>>28&0x01;o.fAtrBdr=a>>29&0x01;o.fAtrPat=a>>30&0x01;o.fAtrProt=a>>31&0x01;o.dgLeft=b&0x0F;o.dgRight=b>>4&0x0F;o.dgTop=b>>8&0x0F;o.dgBottom=b>>12&0x0F;o.icvLeft=b>>16&0x7F;o.icvRight=b>>23&0x7F;o.grbitDiag=b>>30&0x03;o.icvTop=c&0x7F;o.icvBottom=c>>7&0x7F;o.icvDiag=c>>14&0x7F;o.dgDiag=c>>21&0x0F;o.icvFore=d&0x7F;o.icvBack=d>>7&0x7F;o.fsxButton=d>>14&0x01;return o;}//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */function parse_XF(blob,length,opts){var o={};o.ifnt=blob.read_shift(2);o.numFmtId=blob.read_shift(2);o.flags=blob.read_shift(2);o.fStyle=o.flags>>2&0x01;length-=6;o.data=parse_CellStyleXF(blob,length,o.fStyle,opts);return o;}function write_XF(data,ixfeP,opts,o){var b5=opts&&opts.biff==5;if(!o)o=new_buf(b5?16:20);o.write_shift(2,0);if(data.style){o.write_shift(2,data.numFmtId||0);o.write_shift(2,0xFFF4);}else {o.write_shift(2,data.numFmtId||0);o.write_shift(2,ixfeP<<4);}o.write_shift(4,0);o.write_shift(4,0);if(!b5)o.write_shift(4,0);o.write_shift(2,0);return o;}/* [MS-XLS] 2.4.134 */function parse_Guts(blob){blob.l+=4;var out=[blob.read_shift(2),blob.read_shift(2)];if(out[0]!==0)out[0]--;if(out[1]!==0)out[1]--;if(out[0]>7||out[1]>7)throw new Error("Bad Gutters: "+out.join("|"));return out;}function write_Guts(guts){var o=new_buf(8);o.write_shift(4,0);o.write_shift(2,guts[0]?guts[0]+1:0);o.write_shift(2,guts[1]?guts[1]+1:0);return o;}/* [MS-XLS] 2.4.24 */function parse_BoolErr(blob,length,opts){var cell=parse_XLSCell(blob);if(opts.biff==2)++blob.l;var val=parse_Bes(blob);cell.val=val;cell.t=val===true||val===false?'b':'e';return cell;}function write_BoolErr(R,C,v,os,opts,t){var o=new_buf(8);write_XLSCell(R,C,os,o);write_Bes(v,t,o);return o;}/* [MS-XLS] 2.4.180 Number */function parse_Number(blob){var cell=parse_XLSCell(blob);var xnum=parse_Xnum(blob);cell.val=xnum;return cell;}function write_Number(R,C,v,os){var o=new_buf(14);write_XLSCell(R,C,os,o);write_Xnum(v,o);return o;}var parse_XLHeaderFooter=parse_OptXLUnicodeString;// TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */function parse_SupBook(blob,length,opts){var end=blob.l+length;var ctab=blob.read_shift(2);var cch=blob.read_shift(2);opts.sbcch=cch;if(cch==0x0401||cch==0x3A01)return [cch,ctab];if(cch<0x01||cch>0xff)throw new Error("Unexpected SupBook type: "+cch);var virtPath=parse_XLUnicodeStringNoCch(blob,cch);/* TODO: 2.5.277 Virtual Path */var rgst=[];while(end>blob.l)rgst.push(parse_XLUnicodeString(blob));return [cch,ctab,virtPath,rgst];}/* [MS-XLS] 2.4.105 TODO */function parse_ExternName(blob,length,opts){var flags=blob.read_shift(2);var body;var o={fBuiltIn:flags&0x01,fWantAdvise:flags>>>1&0x01,fWantPict:flags>>>2&0x01,fOle:flags>>>3&0x01,fOleLink:flags>>>4&0x01,cf:flags>>>5&0x3FF,fIcon:flags>>>15&0x01};if(opts.sbcch===0x3A01)body=parse_AddinUdf(blob,length-2,opts);//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
o.body=body||blob.read_shift(length-2);if(typeof body==="string")o.Name=body;return o;}/* [MS-XLS] 2.4.150 TODO */var XLSLblBuiltIn=["_xlnm.Consolidate_Area","_xlnm.Auto_Open","_xlnm.Auto_Close","_xlnm.Extract","_xlnm.Database","_xlnm.Criteria","_xlnm.Print_Area","_xlnm.Print_Titles","_xlnm.Recorder","_xlnm.Data_Form","_xlnm.Auto_Activate","_xlnm.Auto_Deactivate","_xlnm.Sheet_Title","_xlnm._FilterDatabase"];function parse_Lbl(blob,length,opts){var target=blob.l+length;var flags=blob.read_shift(2);var chKey=blob.read_shift(1);var cch=blob.read_shift(1);var cce=blob.read_shift(opts&&opts.biff==2?1:2);var itab=0;if(!opts||opts.biff>=5){if(opts.biff!=5)blob.l+=2;itab=blob.read_shift(2);if(opts.biff==5)blob.l+=2;blob.l+=4;}var name=parse_XLUnicodeStringNoCch(blob,cch,opts);if(flags&0x20)name=XLSLblBuiltIn[name.charCodeAt(0)];var npflen=target-blob.l;if(opts&&opts.biff==2)--npflen;var rgce=target==blob.l||cce===0||!(npflen>0)?[]:parse_NameParsedFormula(blob,npflen,opts,cce);return {chKey:chKey,Name:name,itab:itab,rgce:rgce};}/* [MS-XLS] 2.4.106 TODO: verify filename encoding */function parse_ExternSheet(blob,length,opts){if(opts.biff<8)return parse_BIFF5ExternSheet(blob,length,opts);var o=[],target=blob.l+length,len=blob.read_shift(opts.biff>8?4:2);while(len--!==0)o.push(parse_XTI(blob,opts.biff>8?12:6,opts));// [iSupBook, itabFirst, itabLast];
if(blob.l!=target)throw new Error("Bad ExternSheet: "+blob.l+" != "+target);return o;}function parse_BIFF5ExternSheet(blob,length,opts){if(blob[blob.l+1]==0x03)blob[blob.l]++;var o=parse_ShortXLUnicodeString(blob,length,opts);return o.charCodeAt(0)==0x03?o.slice(1):o;}/* [MS-XLS] 2.4.176 TODO: check older biff */function parse_NameCmt(blob,length,opts){if(opts.biff<8){blob.l+=length;return;}var cchName=blob.read_shift(2);var cchComment=blob.read_shift(2);var name=parse_XLUnicodeStringNoCch(blob,cchName,opts);var comment=parse_XLUnicodeStringNoCch(blob,cchComment,opts);return [name,comment];}/* [MS-XLS] 2.4.260 */function parse_ShrFmla(blob,length,opts){var ref=parse_RefU(blob);blob.l++;var cUse=blob.read_shift(1);length-=8;return [parse_SharedParsedFormula(blob,length,opts),cUse,ref];}/* [MS-XLS] 2.4.4 TODO */function parse_Array(blob,length,opts){var ref=parse_Ref(blob);/* TODO: fAlwaysCalc */switch(opts.biff){case 2:blob.l++;length-=7;break;case 3:case 4:blob.l+=2;length-=8;break;default:blob.l+=6;length-=12;}return [ref,parse_ArrayParsedFormula(blob,length,opts)];}/* [MS-XLS] 2.4.173 */function parse_MTRSettings(blob){var fMTREnabled=blob.read_shift(4)!==0x00;var fUserSetThreadCount=blob.read_shift(4)!==0x00;var cUserThreadCount=blob.read_shift(4);return [fMTREnabled,fUserSetThreadCount,cUserThreadCount];}/* [MS-XLS] 2.5.186 TODO: BIFF5 */function parse_NoteSh(blob,length,opts){if(opts.biff<8)return;var row=blob.read_shift(2),col=blob.read_shift(2);var flags=blob.read_shift(2),idObj=blob.read_shift(2);var stAuthor=parse_XLUnicodeString2(blob,0,opts);if(opts.biff<8)blob.read_shift(1);return [{r:row,c:col},stAuthor,idObj,flags];}/* [MS-XLS] 2.4.179 */function parse_Note(blob,length,opts){/* TODO: Support revisions */return parse_NoteSh(blob,length,opts);}/* [MS-XLS] 2.4.168 */function parse_MergeCells(blob,length){var merges=[];var cmcs=blob.read_shift(2);while(cmcs--)merges.push(parse_Ref8U(blob));return merges;}function write_MergeCells(merges){var o=new_buf(2+merges.length*8);o.write_shift(2,merges.length);for(var i=0;i<merges.length;++i)write_Ref8U(merges[i],o);return o;}/* [MS-XLS] 2.4.181 TODO: parse all the things! */function parse_Obj(blob,length,opts){if(opts&&opts.biff<8)return parse_BIFF5Obj(blob,length,opts);var cmo=parse_FtCmo(blob);// id, ot, flags
var fts=parse_FtArray(blob,length-22);return {cmo:cmo,ft:fts};}/* from older spec */var parse_BIFF5OT=[];parse_BIFF5OT[0x08]=function(blob,length){var tgt=blob.l+length;blob.l+=10;// todo
var cf=blob.read_shift(2);blob.l+=4;blob.l+=2;//var cbPictFmla = blob.read_shift(2);
blob.l+=2;blob.l+=2;//var grbit = blob.read_shift(2);
blob.l+=4;var cchName=blob.read_shift(1);blob.l+=cchName;// TODO: stName
blob.l=tgt;// TODO: fmla
return {fmt:cf};};function parse_BIFF5Obj(blob,length,opts){blob.l+=4;//var cnt = blob.read_shift(4);
var ot=blob.read_shift(2);var id=blob.read_shift(2);var grbit=blob.read_shift(2);blob.l+=2;//var colL = blob.read_shift(2);
blob.l+=2;//var dxL = blob.read_shift(2);
blob.l+=2;//var rwT = blob.read_shift(2);
blob.l+=2;//var dyT = blob.read_shift(2);
blob.l+=2;//var colR = blob.read_shift(2);
blob.l+=2;//var dxR = blob.read_shift(2);
blob.l+=2;//var rwB = blob.read_shift(2);
blob.l+=2;//var dyB = blob.read_shift(2);
blob.l+=2;//var cbMacro = blob.read_shift(2);
blob.l+=6;length-=36;var fts=[];fts.push((parse_BIFF5OT[ot]||parsenoop)(blob,length,opts));return {cmo:[id,ot,grbit],ft:fts};}/* [MS-XLS] 2.4.329 TODO: parse properly */function parse_TxO(blob,length,opts){var s=blob.l;var texts="";try{blob.l+=4;var ot=(opts.lastobj||{cmo:[0,0]}).cmo[1];var controlInfo;// eslint-disable-line no-unused-vars
if([0,5,7,11,12,14].indexOf(ot)==-1)blob.l+=6;else controlInfo=parse_ControlInfo(blob,6,opts);var cchText=blob.read_shift(2);/*var cbRuns = */blob.read_shift(2);/*var ifntEmpty = */parseuint16(blob,2);var len=blob.read_shift(2);blob.l+=len;//var fmla = parse_ObjFmla(blob, s + length - blob.l);
for(var i=1;i<blob.lens.length-1;++i){if(blob.l-s!=blob.lens[i])throw new Error("TxO: bad continue record");var hdr=blob[blob.l];var t=parse_XLUnicodeStringNoCch(blob,blob.lens[i+1]-blob.lens[i]-1);texts+=t;if(texts.length>=(hdr?cchText:2*cchText))break;}if(texts.length!==cchText&&texts.length!==cchText*2){throw new Error("cchText: "+cchText+" != "+texts.length);}blob.l=s+length;/* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
//	var cchText2 = blob.read_shift(2);
//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
//	blob.l += 6;
//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
return {t:texts};}catch(e){blob.l=s+length;return {t:texts};}}/* [MS-XLS] 2.4.140 */function parse_HLink(blob,length){var ref=parse_Ref8U(blob);blob.l+=16;/* CLSID */var hlink=parse_Hyperlink(blob,length-24);return [ref,hlink];}function write_HLink(hl){var O=new_buf(24);var ref=decode_cell(hl[0]);O.write_shift(2,ref.r);O.write_shift(2,ref.r);O.write_shift(2,ref.c);O.write_shift(2,ref.c);var clsid="d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(var i=0;i<16;++i)O.write_shift(1,parseInt(clsid[i],16));return bconcat([O,write_Hyperlink(hl[1])]);}/* [MS-XLS] 2.4.141 */function parse_HLinkTooltip(blob,length){blob.read_shift(2);var ref=parse_Ref8U(blob);var wzTooltip=blob.read_shift((length-10)/2,'dbcs-cont');wzTooltip=wzTooltip.replace(chr0,"");return [ref,wzTooltip];}function write_HLinkTooltip(hl){var TT=hl[1].Tooltip;var O=new_buf(10+2*(TT.length+1));O.write_shift(2,0x0800);var ref=decode_cell(hl[0]);O.write_shift(2,ref.r);O.write_shift(2,ref.r);O.write_shift(2,ref.c);O.write_shift(2,ref.c);for(var i=0;i<TT.length;++i)O.write_shift(2,TT.charCodeAt(i));O.write_shift(2,0);return O;}/* [MS-XLS] 2.4.63 */function parse_Country(blob){var o=[0,0],d;d=blob.read_shift(2);o[0]=CountryEnum[d]||d;d=blob.read_shift(2);o[1]=CountryEnum[d]||d;return o;}function write_Country(o){if(!o)o=new_buf(4);o.write_shift(2,0x01);o.write_shift(2,0x01);return o;}/* [MS-XLS] 2.4.50 ClrtClient */function parse_ClrtClient(blob){var ccv=blob.read_shift(2);var o=[];while(ccv-->0)o.push(parse_LongRGB(blob));return o;}/* [MS-XLS] 2.4.188 */function parse_Palette(blob){var ccv=blob.read_shift(2);var o=[];while(ccv-->0)o.push(parse_LongRGB(blob));return o;}/* [MS-XLS] 2.4.354 */function parse_XFCRC(blob){blob.l+=2;var o={cxfs:0,crc:0};o.cxfs=blob.read_shift(2);o.crc=blob.read_shift(4);return o;}/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */function parse_ColInfo(blob,length,opts){if(!opts.cellStyles)return parsenoop(blob,length);var w=opts&&opts.biff>=12?4:2;var colFirst=blob.read_shift(w);var colLast=blob.read_shift(w);var coldx=blob.read_shift(w);var ixfe=blob.read_shift(w);var flags=blob.read_shift(2);if(w==2)blob.l+=2;var o={s:colFirst,e:colLast,w:coldx,ixfe:ixfe,flags:flags};if(opts.biff>=5||!opts.biff)o.level=flags>>8&0x7;return o;}function write_ColInfo(col,idx){var o=new_buf(12);o.write_shift(2,idx);o.write_shift(2,idx);o.write_shift(2,col.width*256);o.write_shift(2,0);var f=0;if(col.hidden)f|=1;o.write_shift(1,f);f=col.level||0;o.write_shift(1,f);o.write_shift(2,0);return o;}/* [MS-XLS] 2.4.257 */function parse_Setup(blob,length){var o={};if(length<32)return o;blob.l+=16;o.header=parse_Xnum(blob);o.footer=parse_Xnum(blob);blob.l+=2;return o;}/* [MS-XLS] 2.4.261 */function parse_ShtProps(blob,length,opts){var def={area:false};if(opts.biff!=5){blob.l+=length;return def;}var d=blob.read_shift(1);blob.l+=3;if(d&0x10)def.area=true;return def;}/* [MS-XLS] 2.4.241 */function write_RRTabId(n){var out=new_buf(2*n);for(var i=0;i<n;++i)out.write_shift(2,i+1);return out;}var parse_Blank=parse_XLSCell;/* [MS-XLS] 2.4.20 Just the cell */var parse_Scl=parseuint16a;/* [MS-XLS] 2.4.247 num, den */var parse_String=parse_XLUnicodeString;/* [MS-XLS] 2.4.268 */ /* --- Specific to versions before BIFF8 --- */function parse_ImData(blob){var cf=blob.read_shift(2);var env=blob.read_shift(2);var lcb=blob.read_shift(4);var o={fmt:cf,env:env,len:lcb,data:blob.slice(blob.l,blob.l+lcb)};blob.l+=lcb;return o;}/* BIFF2_??? where ??? is the name from [XLS] */function parse_BIFF2STR(blob,length,opts){var cell=parse_XLSCell(blob);++blob.l;var str=parse_XLUnicodeString2(blob,length-7,opts);cell.t='str';cell.val=str;return cell;}function parse_BIFF2NUM(blob){var cell=parse_XLSCell(blob);++blob.l;var num=parse_Xnum(blob);cell.t='n';cell.val=num;return cell;}function write_BIFF2NUM(r,c,val){var out=new_buf(15);write_BIFF2Cell(out,r,c);out.write_shift(8,val,'f');return out;}function parse_BIFF2INT(blob){var cell=parse_XLSCell(blob);++blob.l;var num=blob.read_shift(2);cell.t='n';cell.val=num;return cell;}function write_BIFF2INT(r,c,val){var out=new_buf(9);write_BIFF2Cell(out,r,c);out.write_shift(2,val);return out;}function parse_BIFF2STRING(blob){var cch=blob.read_shift(1);if(cch===0){blob.l++;return "";}return blob.read_shift(cch,'sbcs-cont');}/* TODO: convert to BIFF8 font struct */function parse_BIFF2FONTXTRA(blob,length){blob.l+=6;// unknown
blob.l+=2;// font weight "bls"
blob.l+=1;// charset
blob.l+=3;// unknown
blob.l+=1;// font family
blob.l+=length-13;}/* TODO: parse rich text runs */function parse_RString(blob,length,opts){var end=blob.l+length;var cell=parse_XLSCell(blob);var cch=blob.read_shift(2);var str=parse_XLUnicodeStringNoCch(blob,cch,opts);blob.l=end;cell.t='str';cell.val=str;return cell;}/* from js-harb (C) 2014-present  SheetJS */var DBF=function(){var dbf_codepage_map={/* Code Pages Supported by Visual FoxPro */0x01:437,0x02:850,0x03:1252,0x04:10000,0x64:852,0x65:866,0x66:865,0x67:861,0x68:895,0x69:620,0x6A:737,0x6B:857,0x78:950,0x79:949,0x7A:936,0x7B:932,0x7C:874,0x7D:1255,0x7E:1256,0x96:10007,0x97:10029,0x98:10006,0xC8:1250,0xC9:1251,0xCA:1254,0xCB:1253,/* shapefile DBF extension */0x00:20127,0x08:865,0x09:437,0x0A:850,0x0B:437,0x0D:437,0x0E:850,0x0F:437,0x10:850,0x11:437,0x12:850,0x13:932,0x14:850,0x15:437,0x16:850,0x17:865,0x18:437,0x19:437,0x1A:850,0x1B:437,0x1C:863,0x1D:850,0x1F:852,0x22:852,0x23:852,0x24:860,0x25:850,0x26:866,0x37:850,0x40:852,0x4D:936,0x4E:949,0x4F:950,0x50:874,0x57:1252,0x58:1252,0x59:1252,0x6C:863,0x86:737,0x87:852,0x88:857,0xCC:1257,0xFF:16969};var dbf_reverse_map=evert({0x01:437,0x02:850,0x03:1252,0x04:10000,0x64:852,0x65:866,0x66:865,0x67:861,0x68:895,0x69:620,0x6A:737,0x6B:857,0x78:950,0x79:949,0x7A:936,0x7B:932,0x7C:874,0x7D:1255,0x7E:1256,0x96:10007,0x97:10029,0x98:10006,0xC8:1250,0xC9:1251,0xCA:1254,0xCB:1253,0x00:20127});var DBF_SUPPORTED_VERSIONS=[0x02,0x03,0x30,0x31,0x83,0x8B,0x8C,0xF5];/* TODO: find an actual specification */function dbf_to_aoa(buf,opts){var out=[];var d=new_raw_buf(1);switch(opts.type){case'base64':d=s2a(Base64.decode(buf));break;case'binary':d=s2a(buf);break;case'buffer':case'array':d=buf;break;}prep_blob(d,0);/* header */var ft=d.read_shift(1);var memo=!!(ft&0x88);var vfp=false,l7=false;switch(ft){case 0x02:break;// dBASE II
case 0x03:break;// dBASE III
case 0x30:vfp=true;memo=true;break;// VFP
case 0x31:vfp=true;memo=true;break;// VFP with autoincrement
// 0x43 dBASE IV SQL table files
// 0x63 dBASE IV SQL system files
case 0x83:break;// dBASE III with memo
case 0x8B:break;// dBASE IV with memo
case 0x8C:l7=true;break;// dBASE Level 7 with memo
// case 0xCB dBASE IV SQL table files with memo
case 0xF5:break;// FoxPro 2.x with memo
// case 0xFB FoxBASE
default:throw new Error("DBF Unsupported Version: "+ft.toString(16));}var nrow=0,fpos=0x0209;if(ft==0x02)nrow=d.read_shift(2);d.l+=3;// dBASE II stores DDMMYY date, others use YYMMDD
if(ft!=0x02)nrow=d.read_shift(4);if(nrow>1048576)nrow=1e6;if(ft!=0x02)fpos=d.read_shift(2);// header length
var rlen=d.read_shift(2);// record length
var/*flags = 0,*/current_cp=opts.codepage||1252;if(ft!=0x02){// 20 reserved bytes
d.l+=16;/*flags = */d.read_shift(1);//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
/* codepage present in FoxPro and dBASE Level 7 */if(d[d.l]!==0)current_cp=dbf_codepage_map[d[d.l]];d.l+=1;d.l+=2;}if(l7)d.l+=36;// Level 7: 32 byte "Language driver name", 4 byte reserved
var fields=[],field={};var hend=Math.min(d.length,ft==0x02?0x209:fpos-10-(vfp?264:0));var ww=l7?32:11;while(d.l<hend&&d[d.l]!=0x0d){field={};field.name=cptable.utils.decode(current_cp,d.slice(d.l,d.l+ww)).replace(/[\u0000\r\n].*$/g,"");d.l+=ww;field.type=String.fromCharCode(d.read_shift(1));if(ft!=0x02&&!l7)field.offset=d.read_shift(4);field.len=d.read_shift(1);if(ft==0x02)field.offset=d.read_shift(2);field.dec=d.read_shift(1);if(field.name.length)fields.push(field);if(ft!=0x02)d.l+=l7?13:14;switch(field.type){case'B':// Double (VFP) / Binary (dBASE L7)
if((!vfp||field.len!=8)&&opts.WTF)console.log('Skipping '+field.name+':'+field.type);break;case'G':// General (FoxPro and dBASE L7)
case'P':// Picture (FoxPro and dBASE L7)
if(opts.WTF)console.log('Skipping '+field.name+':'+field.type);break;case'+':// Autoincrement (dBASE L7 only)
case'0':// _NullFlags (VFP only)
case'@':// Timestamp (dBASE L7 only)
case'C':// Character (dBASE II)
case'D':// Date (dBASE III)
case'F':// Float (dBASE IV)
case'I':// Long (VFP and dBASE L7)
case'L':// Logical (dBASE II)
case'M':// Memo (dBASE III)
case'N':// Number (dBASE II)
case'O':// Double (dBASE L7 only)
case'T':// Datetime (VFP only)
case'Y':// Currency (VFP only)
break;default:throw new Error('Unknown Field Type: '+field.type);}}if(d[d.l]!==0x0D)d.l=fpos-1;if(d.read_shift(1)!==0x0D)throw new Error("DBF Terminator not found "+d.l+" "+d[d.l]);d.l=fpos;/* data */var R=0,C=0;out[0]=[];for(C=0;C!=fields.length;++C)out[0][C]=fields[C].name;while(nrow-->0){if(d[d.l]===0x2A){// TODO: record marked as deleted -- create a hidden row?
d.l+=rlen;continue;}++d.l;out[++R]=[];C=0;for(C=0;C!=fields.length;++C){var dd=d.slice(d.l,d.l+fields[C].len);d.l+=fields[C].len;prep_blob(dd,0);var s=cptable.utils.decode(current_cp,dd);switch(fields[C].type){case'C':// NOTE: it is conventional to write '  /  /  ' for empty dates
if(s.trim().length)out[R][C]=s.replace(/\s+$/,"");break;case'D':if(s.length===8)out[R][C]=new Date(+s.slice(0,4),+s.slice(4,6)-1,+s.slice(6,8));else out[R][C]=s;break;case'F':out[R][C]=parseFloat(s.trim());break;case'+':case'I':out[R][C]=l7?dd.read_shift(-4,'i')^0x80000000:dd.read_shift(4,'i');break;case'L':switch(s.trim().toUpperCase()){case'Y':case'T':out[R][C]=true;break;case'N':case'F':out[R][C]=false;break;case'':case'?':break;default:throw new Error("DBF Unrecognized L:|"+s+"|");}break;case'M':/* TODO: handle memo files */if(!memo)throw new Error("DBF Unexpected MEMO for type "+ft.toString(16));out[R][C]="##MEMO##"+(l7?parseInt(s.trim(),10):dd.read_shift(4));break;case'N':s=s.replace(/\u0000/g,"").trim();// NOTE: dBASE II interprets "  .  " as 0
if(s&&s!=".")out[R][C]=+s||0;break;case'@':// NOTE: dBASE specs appear to be incorrect
out[R][C]=new Date(dd.read_shift(-8,'f')-0x388317533400);break;case'T':out[R][C]=new Date((dd.read_shift(4)-0x253D8C)*0x5265C00+dd.read_shift(4));break;case'Y':out[R][C]=dd.read_shift(4,'i')/1e4;break;case'O':out[R][C]=-dd.read_shift(-8,'f');break;case'B':if(vfp&&fields[C].len==8){out[R][C]=dd.read_shift(8,'f');break;}/* falls through */case'G':case'P':dd.l+=fields[C].len;break;case'0':if(fields[C].name==='_NullFlags')break;/* falls through */default:throw new Error("DBF Unsupported data type "+fields[C].type);}}}if(ft!=0x02)if(d.l<d.length&&d[d.l++]!=0x1A)throw new Error("DBF EOF Marker missing "+(d.l-1)+" of "+d.length+" "+d[d.l-1].toString(16));if(opts&&opts.sheetRows)out=out.slice(0,opts.sheetRows);return out;}function dbf_to_sheet(buf,opts){var o=opts||{};if(!o.dateNF)o.dateNF="yyyymmdd";return aoa_to_sheet(dbf_to_aoa(buf,o),o);}function dbf_to_workbook(buf,opts){try{return sheet_to_workbook(dbf_to_sheet(buf,opts),opts);}catch(e){if(opts&&opts.WTF)throw e;}return {SheetNames:[],Sheets:{}};}var _RLEN={'B':8,'C':250,'L':1,'D':8,'?':0,'':0};function sheet_to_dbf(ws,opts){var o=opts||{};if(+o.codepage>=0)set_cp(+o.codepage);if(o.type=="string")throw new Error("Cannot write DBF to JS string");var ba=buf_array();var aoa=sheet_to_json(ws,{header:1,raw:true,cellDates:true});var headers=aoa[0],data=aoa.slice(1);var i=0,j=0,hcnt=0,rlen=1;for(i=0;i<headers.length;++i){if(i==null)continue;++hcnt;if(typeof headers[i]==='number')headers[i]=headers[i].toString(10);if(typeof headers[i]!=='string')throw new Error("DBF Invalid column name "+headers[i]+" |"+typeof headers[i]+"|");if(headers.indexOf(headers[i])!==i)for(j=0;j<1024;++j)if(headers.indexOf(headers[i]+"_"+j)==-1){headers[i]+="_"+j;break;}}var range=safe_decode_range(ws['!ref']);var coltypes=[];for(i=0;i<=range.e.c-range.s.c;++i){var col=[];for(j=0;j<data.length;++j){if(data[j][i]!=null)col.push(data[j][i]);}if(col.length==0||headers[i]==null){coltypes[i]='?';continue;}var guess='',_guess='';for(j=0;j<col.length;++j){switch(typeof col[j]){/* TODO: check if L2 compat is desired */case'number':_guess='B';break;case'string':_guess='C';break;case'boolean':_guess='L';break;case'object':_guess=col[j]instanceof Date?'D':'C';break;default:_guess='C';}guess=guess&&guess!=_guess?'C':_guess;if(guess=='C')break;}rlen+=_RLEN[guess]||0;coltypes[i]=guess;}var h=ba.next(32);h.write_shift(4,0x13021130);h.write_shift(4,data.length);h.write_shift(2,296+32*hcnt);h.write_shift(2,rlen);for(i=0;i<4;++i)h.write_shift(4,0);h.write_shift(4,0x00000000|(+dbf_reverse_map[current_ansi]||0x03)<<8);for(i=0,j=0;i<headers.length;++i){if(headers[i]==null)continue;var hf=ba.next(32);var _f=(headers[i].slice(-10)+"\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0,11);hf.write_shift(1,_f,"sbcs");hf.write_shift(1,coltypes[i]=='?'?'C':coltypes[i],"sbcs");hf.write_shift(4,j);hf.write_shift(1,_RLEN[coltypes[i]]||0);hf.write_shift(1,0);hf.write_shift(1,0x02);hf.write_shift(4,0);hf.write_shift(1,0);hf.write_shift(4,0);hf.write_shift(4,0);j+=_RLEN[coltypes[i]]||0;}var hb=ba.next(264);hb.write_shift(4,0x0000000D);for(i=0;i<65;++i)hb.write_shift(4,0x00000000);for(i=0;i<data.length;++i){var rout=ba.next(rlen);rout.write_shift(1,0);for(j=0;j<headers.length;++j){if(headers[j]==null)continue;switch(coltypes[j]){case'L':rout.write_shift(1,data[i][j]==null?0x3F:data[i][j]?0x54:0x46);break;case'B':rout.write_shift(8,data[i][j]||0,'f');break;case'D':if(!data[i][j])rout.write_shift(8,"00000000","sbcs");else {rout.write_shift(4,("0000"+data[i][j].getFullYear()).slice(-4),"sbcs");rout.write_shift(2,("00"+(data[i][j].getMonth()+1)).slice(-2),"sbcs");rout.write_shift(2,("00"+data[i][j].getDate()).slice(-2),"sbcs");}break;case'C':var _s=String(data[i][j]||"");rout.write_shift(1,_s,"sbcs");for(hcnt=0;hcnt<250-_s.length;++hcnt)rout.write_shift(1,0x20);break;}}// data
}ba.next(1).write_shift(1,0x1A);return ba.end();}return {versions:DBF_SUPPORTED_VERSIONS,to_workbook:dbf_to_workbook,to_sheet:dbf_to_sheet,from_sheet:sheet_to_dbf};}();var SYLK=function(){/* TODO: stress test sequences */var sylk_escapes={AA:'À',BA:'Á',CA:'Â',DA:195,HA:'Ä',JA:197,AE:'È',BE:'É',CE:'Ê',HE:'Ë',AI:'Ì',BI:'Í',CI:'Î',HI:'Ï',AO:'Ò',BO:'Ó',CO:'Ô',DO:213,HO:'Ö',AU:'Ù',BU:'Ú',CU:'Û',HU:'Ü',Aa:'à',Ba:'á',Ca:'â',Da:227,Ha:'ä',Ja:229,Ae:'è',Be:'é',Ce:'ê',He:'ë',Ai:'ì',Bi:'í',Ci:'î',Hi:'ï',Ao:'ò',Bo:'ó',Co:'ô',Do:245,Ho:'ö',Au:'ù',Bu:'ú',Cu:'û',Hu:'ü',KC:'Ç',Kc:'ç',q:'æ',z:'œ',a:'Æ',j:'Œ',DN:209,Dn:241,Hy:255,S:169,c:170,R:174,B:180,0:176,1:177,2:178,3:179,5:181,6:182,7:183,Q:185,k:186,b:208,i:216,l:222,s:240,y:248,"!":161,'"':162,"#":163,"(":164,"%":165,"'":167,"H ":168,"+":171,";":187,"<":188,"=":189,">":190,"?":191,"{":223};var sylk_char_regex=new RegExp("\u001BN("+keys(sylk_escapes).join("|").replace(/\|\|\|/,"|\\||").replace(/([?()+])/g,"\\$1")+"|\\|)","gm");var sylk_char_fn=function(_,$1){var o=sylk_escapes[$1];return typeof o=="number"?_getansi(o):o;};var decode_sylk_char=function($$,$1,$2){var newcc=$1.charCodeAt(0)-0x20<<4|$2.charCodeAt(0)-0x30;return newcc==59?$$:_getansi(newcc);};sylk_escapes["|"]=254;/* TODO: find an actual specification */function sylk_to_aoa(d,opts){switch(opts.type){case'base64':return sylk_to_aoa_str(Base64.decode(d),opts);case'binary':return sylk_to_aoa_str(d,opts);case'buffer':return sylk_to_aoa_str(d.toString('binary'),opts);case'array':return sylk_to_aoa_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}function sylk_to_aoa_str(str,opts){var records=str.split(/[\n\r]+/),R=-1,C=-1,ri=0,rj=0,arr=[];var formats=[];var next_cell_format=null;var sht={},rowinfo=[],colinfo=[],cw=[];var Mval=0,j;if(+opts.codepage>=0)set_cp(+opts.codepage);for(;ri!==records.length;++ri){Mval=0;var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g,decode_sylk_char).replace(sylk_char_regex,sylk_char_fn);var record=rstr.replace(/;;/g,"\u0000").split(";").map(function(x){return x.replace(/\u0000/g,";");});var RT=record[0],val;if(rstr.length>0)switch(RT){case'ID':break;/* header */case'E':break;/* EOF */case'B':break;/* dimensions */case'O':break;/* options? */case'P':if(record[1].charAt(0)=='P')formats.push(rstr.slice(3).replace(/;;/g,";"));break;case'C':var C_seen_K=false,C_seen_X=false,C_seen_S=false,C_seen_E=false,_R=-1,_C=-1;for(rj=1;rj<record.length;++rj)switch(record[rj].charAt(0)){case'A':break;// TODO: comment
case'X':C=parseInt(record[rj].slice(1))-1;C_seen_X=true;break;case'Y':R=parseInt(record[rj].slice(1))-1;if(!C_seen_X)C=0;for(j=arr.length;j<=R;++j)arr[j]=[];break;case'K':val=record[rj].slice(1);if(val.charAt(0)==='"')val=val.slice(1,val.length-1);else if(val==='TRUE')val=true;else if(val==='FALSE')val=false;else if(!isNaN(fuzzynum(val))){val=fuzzynum(val);if(next_cell_format!==null&&SSF.is_date(next_cell_format))val=numdate(val);}else if(!isNaN(fuzzydate(val).getDate())){val=parseDate(val);}if(typeof cptable!=='undefined'&&typeof val=="string"&&(opts||{}).type!="string"&&(opts||{}).codepage)val=cptable.utils.decode(opts.codepage,val);C_seen_K=true;break;case'E':C_seen_E=true;var formula=rc_to_a1(record[rj].slice(1),{r:R,c:C});arr[R][C]=[arr[R][C],formula];break;case'S':C_seen_S=true;arr[R][C]=[arr[R][C],"S5S"];break;case'G':break;// unknown
case'R':_R=parseInt(record[rj].slice(1))-1;break;case'C':_C=parseInt(record[rj].slice(1))-1;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}if(C_seen_K){if(arr[R][C]&&arr[R][C].length==2)arr[R][C][0]=val;else arr[R][C]=val;next_cell_format=null;}if(C_seen_S){if(C_seen_E)throw new Error("SYLK shared formula cannot have own formula");var shrbase=_R>-1&&arr[_R][_C];if(!shrbase||!shrbase[1])throw new Error("SYLK shared formula cannot find base");arr[R][C][1]=shift_formula_str(shrbase[1],{r:R-_R,c:C-_C});}break;case'F':var F_seen=0;for(rj=1;rj<record.length;++rj)switch(record[rj].charAt(0)){case'X':C=parseInt(record[rj].slice(1))-1;++F_seen;break;case'Y':R=parseInt(record[rj].slice(1))-1;/*C = 0;*/for(j=arr.length;j<=R;++j)arr[j]=[];break;case'M':Mval=parseInt(record[rj].slice(1))/20;break;case'F':break;/* ??? */case'G':break;/* hide grid */case'P':next_cell_format=formats[parseInt(record[rj].slice(1))];break;case'S':break;/* cell style */case'D':break;/* column */case'N':break;/* font */case'W':cw=record[rj].slice(1).split(" ");for(j=parseInt(cw[0],10);j<=parseInt(cw[1],10);++j){Mval=parseInt(cw[2],10);colinfo[j-1]=Mval===0?{hidden:true}:{wch:Mval};process_col(colinfo[j-1]);}break;case'C':/* default column format */C=parseInt(record[rj].slice(1))-1;if(!colinfo[C])colinfo[C]={};break;case'R':/* row properties */R=parseInt(record[rj].slice(1))-1;if(!rowinfo[R])rowinfo[R]={};if(Mval>0){rowinfo[R].hpt=Mval;rowinfo[R].hpx=pt2px(Mval);}else if(Mval===0)rowinfo[R].hidden=true;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}if(F_seen<1)next_cell_format=null;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}}if(rowinfo.length>0)sht['!rows']=rowinfo;if(colinfo.length>0)sht['!cols']=colinfo;if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return [arr,sht];}function sylk_to_sheet(d,opts){var aoasht=sylk_to_aoa(d,opts);var aoa=aoasht[0],ws=aoasht[1];var o=aoa_to_sheet(aoa,opts);keys(ws).forEach(function(k){o[k]=ws[k];});return o;}function sylk_to_workbook(d,opts){return sheet_to_workbook(sylk_to_sheet(d,opts),opts);}function write_ws_cell_sylk(cell,ws,R,C){var o="C;Y"+(R+1)+";X"+(C+1)+";K";switch(cell.t){case'n':o+=cell.v||0;if(cell.f&&!cell.F)o+=";E"+a1_to_rc(cell.f,{r:R,c:C});break;case'b':o+=cell.v?"TRUE":"FALSE";break;case'e':o+=cell.w||cell.v;break;case'd':o+='"'+(cell.w||cell.v)+'"';break;case's':o+='"'+cell.v.replace(/"/g,"")+'"';break;}return o;}function write_ws_cols_sylk(out,cols){cols.forEach(function(col,i){var rec="F;W"+(i+1)+" "+(i+1)+" ";if(col.hidden)rec+="0";else {if(typeof col.width=='number')col.wpx=width2px(col.width);if(typeof col.wpx=='number')col.wch=px2char(col.wpx);if(typeof col.wch=='number')rec+=Math.round(col.wch);}if(rec.charAt(rec.length-1)!=" ")out.push(rec);});}function write_ws_rows_sylk(out,rows){rows.forEach(function(row,i){var rec="F;";if(row.hidden)rec+="M0;";else if(row.hpt)rec+="M"+20*row.hpt+";";else if(row.hpx)rec+="M"+20*px2pt(row.hpx)+";";if(rec.length>2)out.push(rec+"R"+(i+1));});}function sheet_to_sylk(ws,opts){var preamble=["ID;PWXL;N;E"],o=[];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);var RS="\r\n";preamble.push("P;PGeneral");preamble.push("F;P0;DG0G8;M255");if(ws['!cols'])write_ws_cols_sylk(preamble,ws['!cols']);if(ws['!rows'])write_ws_rows_sylk(preamble,ws['!rows']);preamble.push("B;Y"+(r.e.r-r.s.r+1)+";X"+(r.e.c-r.s.c+1)+";D"+[r.s.c,r.s.r,r.e.c,r.e.r].join(" "));for(var R=r.s.r;R<=r.e.r;++R){for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null&&(!cell.f||cell.F))continue;o.push(write_ws_cell_sylk(cell,ws,R,C));}}return preamble.join(RS)+RS+o.join(RS)+RS+"E"+RS;}return {to_workbook:sylk_to_workbook,to_sheet:sylk_to_sheet,from_sheet:sheet_to_sylk};}();var DIF=function(){function dif_to_aoa(d,opts){switch(opts.type){case'base64':return dif_to_aoa_str(Base64.decode(d),opts);case'binary':return dif_to_aoa_str(d,opts);case'buffer':return dif_to_aoa_str(d.toString('binary'),opts);case'array':return dif_to_aoa_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}function dif_to_aoa_str(str,opts){var records=str.split('\n'),R=-1,C=-1,ri=0,arr=[];for(;ri!==records.length;++ri){if(records[ri].trim()==='BOT'){arr[++R]=[];C=0;continue;}if(R<0)continue;var metadata=records[ri].trim().split(",");var type=metadata[0],value=metadata[1];++ri;var data=records[ri].trim();switch(+type){case-1:if(data==='BOT'){arr[++R]=[];C=0;continue;}else if(data!=='EOD')throw new Error("Unrecognized DIF special command "+data);break;case 0:if(data==='TRUE')arr[R][C]=true;else if(data==='FALSE')arr[R][C]=false;else if(!isNaN(fuzzynum(value)))arr[R][C]=fuzzynum(value);else if(!isNaN(fuzzydate(value).getDate()))arr[R][C]=parseDate(value);else arr[R][C]=value;++C;break;case 1:data=data.slice(1,data.length-1);arr[R][C++]=data!==''?data:null;break;}if(data==='EOD')break;}if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return arr;}function dif_to_sheet(str,opts){return aoa_to_sheet(dif_to_aoa(str,opts),opts);}function dif_to_workbook(str,opts){return sheet_to_workbook(dif_to_sheet(str,opts),opts);}var sheet_to_dif=function(){var push_field=function pf(o,topic,v,n,s){o.push(topic);o.push(v+","+n);o.push('"'+s.replace(/"/g,'""')+'"');};var push_value=function po(o,type,v,s){o.push(type+","+v);o.push(type==1?'"'+s.replace(/"/g,'""')+'"':s);};return function sheet_to_dif(ws){var o=[];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);push_field(o,"TABLE",0,1,"sheetjs");push_field(o,"VECTORS",0,r.e.r-r.s.r+1,"");push_field(o,"TUPLES",0,r.e.c-r.s.c+1,"");push_field(o,"DATA",0,0,"");for(var R=r.s.r;R<=r.e.r;++R){push_value(o,-1,0,"BOT");for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell){push_value(o,1,0,"");continue;}switch(cell.t){case'n':var val=cell.w;if(!val&&cell.v!=null)val=cell.v;if(val==null){if(cell.f&&!cell.F)push_value(o,1,0,"="+cell.f);else push_value(o,1,0,"");}else push_value(o,0,val,"V");break;case'b':push_value(o,0,cell.v?1:0,cell.v?"TRUE":"FALSE");break;case's':push_value(o,1,0,isNaN(cell.v)?cell.v:'="'+cell.v+'"');break;case'd':if(!cell.w)cell.w=SSF.format(cell.z||SSF._table[14],datenum(parseDate(cell.v)));push_value(o,0,cell.w,"V");break;default:push_value(o,1,0,"");}}}push_value(o,-1,0,"EOD");var RS="\r\n";var oo=o.join(RS);//while((oo.length & 0x7F) != 0) oo += "\0";
return oo;};}();return {to_workbook:dif_to_workbook,to_sheet:dif_to_sheet,from_sheet:sheet_to_dif};}();var ETH=function(){function decode(s){return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n");}function encode(s){return s.replace(/\\/g,"\\b").replace(/:/g,"\\c").replace(/\n/g,"\\n");}function eth_to_aoa(str,opts){var records=str.split('\n'),R=-1,C=-1,ri=0,arr=[];for(;ri!==records.length;++ri){var record=records[ri].trim().split(":");if(record[0]!=='cell')continue;var addr=decode_cell(record[1]);if(arr.length<=addr.r)for(R=arr.length;R<=addr.r;++R)if(!arr[R])arr[R]=[];R=addr.r;C=addr.c;switch(record[2]){case't':arr[R][C]=decode(record[3]);break;case'v':arr[R][C]=+record[3];break;case'vtf':var _f=record[record.length-1];/* falls through */case'vtc':switch(record[3]){case'nl':arr[R][C]=+record[4]?true:false;break;default:arr[R][C]=+record[4];break;}if(record[2]=='vtf')arr[R][C]=[arr[R][C],_f];}}if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return arr;}function eth_to_sheet(d,opts){return aoa_to_sheet(eth_to_aoa(d,opts),opts);}function eth_to_workbook(d,opts){return sheet_to_workbook(eth_to_sheet(d,opts),opts);}var header=["socialcalc:version:1.5","MIME-Version: 1.0","Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"].join("\n");var sep=["--SocialCalcSpreadsheetControlSave","Content-type: text/plain; charset=UTF-8"].join("\n")+"\n";/* TODO: the other parts */var meta=["# SocialCalc Spreadsheet Control Save","part:sheet"].join("\n");var end="--SocialCalcSpreadsheetControlSave--";function sheet_to_eth_data(ws){if(!ws||!ws['!ref'])return "";var o=[],oo=[],cell,coord="";var r=decode_range(ws['!ref']);var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){for(var C=r.s.c;C<=r.e.c;++C){coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null||cell.t==='z')continue;oo=["cell",coord,'t'];switch(cell.t){case's':case'str':oo.push(encode(cell.v));break;case'n':if(!cell.f){oo[2]='v';oo[3]=cell.v;}else {oo[2]='vtf';oo[3]='n';oo[4]=cell.v;oo[5]=encode(cell.f);}break;case'b':oo[2]='vt'+(cell.f?'f':'c');oo[3]='nl';oo[4]=cell.v?"1":"0";oo[5]=encode(cell.f||(cell.v?'TRUE':'FALSE'));break;case'd':var t=datenum(parseDate(cell.v));oo[2]='vtc';oo[3]='nd';oo[4]=""+t;oo[5]=cell.w||SSF.format(cell.z||SSF._table[14],t);break;case'e':continue;}o.push(oo.join(":"));}}o.push("sheet:c:"+(r.e.c-r.s.c+1)+":r:"+(r.e.r-r.s.r+1)+":tvf:1");o.push("valueformat:1:text-wiki");//o.push("copiedfrom:" + ws['!ref']); // clipboard only
return o.join("\n");}function sheet_to_eth(ws){return [header,sep,meta,sep,sheet_to_eth_data(ws),end].join("\n");// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
}return {to_workbook:eth_to_workbook,to_sheet:eth_to_sheet,from_sheet:sheet_to_eth};}();var PRN=function(){function set_text_arr(data,arr,R,C,o){if(o.raw)arr[R][C]=data;else if(data==="");else if(data==='TRUE')arr[R][C]=true;else if(data==='FALSE')arr[R][C]=false;else if(!isNaN(fuzzynum(data)))arr[R][C]=fuzzynum(data);else if(!isNaN(fuzzydate(data).getDate()))arr[R][C]=parseDate(data);else arr[R][C]=data;}function prn_to_aoa_str(f,opts){var o=opts||{};var arr=[];if(!f||f.length===0)return arr;var lines=f.split(/[\r\n]/);var L=lines.length-1;while(L>=0&&lines[L].length===0)--L;var start=10,idx=0;var R=0;for(;R<=L;++R){idx=lines[R].indexOf(" ");if(idx==-1)idx=lines[R].length;else idx++;start=Math.max(start,idx);}for(R=0;R<=L;++R){arr[R]=[];/* TODO: confirm that widths are always 10 */var C=0;set_text_arr(lines[R].slice(0,start).trim(),arr,R,C,o);for(C=1;C<=(lines[R].length-start)/10+1;++C)set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);}if(o.sheetRows)arr=arr.slice(0,o.sheetRows);return arr;}// List of accepted CSV separators
var guess_seps={0x2C:',',0x09:"\t",0x3B:';'};// CSV separator weights to be used in case of equal numbers
var guess_sep_weights={0x2C:3,0x09:2,0x3B:1};function guess_sep(str){var cnt={},instr=false,end=0,cc=0;for(;end<str.length;++end){if((cc=str.charCodeAt(end))==0x22)instr=!instr;else if(!instr&&cc in guess_seps)cnt[cc]=(cnt[cc]||0)+1;}cc=[];for(end in cnt)if(Object.prototype.hasOwnProperty.call(cnt,end)){cc.push([cnt[end],end]);}if(!cc.length){cnt=guess_sep_weights;for(end in cnt)if(Object.prototype.hasOwnProperty.call(cnt,end)){cc.push([cnt[end],end]);}}cc.sort(function(a,b){return a[0]-b[0]||guess_sep_weights[a[1]]-guess_sep_weights[b[1]];});return guess_seps[cc.pop()[1]];}function dsv_to_sheet_str(str,opts){var o=opts||{};var sep="";var ws=o.dense?[]:{};var range={s:{c:0,r:0},e:{c:0,r:0}};if(str.slice(0,4)=="sep="){// If the line ends in \r\n
if(str.charCodeAt(5)==13&&str.charCodeAt(6)==10){sep=str.charAt(4);str=str.slice(7);}// If line ends in \r OR \n
else if(str.charCodeAt(5)==13||str.charCodeAt(5)==10){sep=str.charAt(4);str=str.slice(6);}else sep=guess_sep(str.slice(0,1024));}else sep=guess_sep(str.slice(0,1024));var R=0,C=0,v=0;var start=0,end=0,sepcc=sep.charCodeAt(0),instr=false,cc=0,startcc=str.charCodeAt(0);str=str.replace(/\r\n/mg,"\n");var _re=o.dateNF!=null?dateNF_regex(o.dateNF):null;function finish_cell(){var s=str.slice(start,end);var cell={};if(s.charAt(0)=='"'&&s.charAt(s.length-1)=='"')s=s.slice(1,-1).replace(/""/g,'"');if(s.length===0)cell.t='z';else if(o.raw){cell.t='s';cell.v=s;}else if(s.trim().length===0){cell.t='s';cell.v=s;}else if(s.charCodeAt(0)==0x3D){if(s.charCodeAt(1)==0x22&&s.charCodeAt(s.length-1)==0x22){cell.t='s';cell.v=s.slice(2,-1).replace(/""/g,'"');}else if(fuzzyfmla(s)){cell.t='n';cell.f=s.slice(1);}else {cell.t='s';cell.v=s;}}else if(s=="TRUE"){cell.t='b';cell.v=true;}else if(s=="FALSE"){cell.t='b';cell.v=false;}else if(!isNaN(v=fuzzynum(s))){cell.t='n';if(o.cellText!==false)cell.w=s;cell.v=v;}else if(!isNaN(fuzzydate(s).getDate())||_re&&s.match(_re)){cell.z=o.dateNF||SSF._table[14];var k=0;if(_re&&s.match(_re)){s=dateNF_fix(s,o.dateNF,s.match(_re)||[]);k=1;}if(o.cellDates){cell.t='d';cell.v=parseDate(s,k);}else {cell.t='n';cell.v=datenum(parseDate(s,k));}if(o.cellText!==false)cell.w=SSF.format(cell.z,cell.v instanceof Date?datenum(cell.v):cell.v);if(!o.cellNF)delete cell.z;}else {cell.t='s';cell.v=s;}if(cell.t=='z');else if(o.dense){if(!ws[R])ws[R]=[];ws[R][C]=cell;}else ws[encode_cell({c:C,r:R})]=cell;start=end+1;startcc=str.charCodeAt(start);if(range.e.c<C)range.e.c=C;if(range.e.r<R)range.e.r=R;if(cc==sepcc)++C;else {C=0;++R;if(o.sheetRows&&o.sheetRows<=R)return true;}}outer:for(;end<str.length;++end)switch(cc=str.charCodeAt(end)){case 0x22:if(startcc===0x22)instr=!instr;break;case sepcc:case 0x0a:case 0x0d:if(!instr&&finish_cell())break outer;break;}if(end-start>0)finish_cell();ws['!ref']=encode_range(range);return ws;}function prn_to_sheet_str(str,opts){if(!(opts&&opts.PRN))return dsv_to_sheet_str(str,opts);if(str.slice(0,4)=="sep=")return dsv_to_sheet_str(str,opts);if(str.indexOf("\t")>=0||str.indexOf(",")>=0||str.indexOf(";")>=0)return dsv_to_sheet_str(str,opts);return aoa_to_sheet(prn_to_aoa_str(str,opts),opts);}function prn_to_sheet(d,opts){var str="",bytes=opts.type=='string'?[0,0,0,0]:firstbyte(d,opts);switch(opts.type){case'base64':str=Base64.decode(d);break;case'binary':str=d;break;case'buffer':if(opts.codepage==65001)str=d.toString('utf8');else if(opts.codepage&&typeof cptable!=='undefined')str=cptable.utils.decode(opts.codepage,d);else str=d.toString('binary');break;case'array':str=cc2str(d);break;case'string':str=d;break;default:throw new Error("Unrecognized type "+opts.type);}if(bytes[0]==0xEF&&bytes[1]==0xBB&&bytes[2]==0xBF)str=utf8read(str.slice(3));else if(opts.type=='binary'&&typeof cptable!=='undefined'&&opts.codepage)str=cptable.utils.decode(opts.codepage,cptable.utils.encode(28591,str));if(str.slice(0,19)=="socialcalc:version:")return ETH.to_sheet(opts.type=='string'?str:utf8read(str),opts);return prn_to_sheet_str(str,opts);}function prn_to_workbook(d,opts){return sheet_to_workbook(prn_to_sheet(d,opts),opts);}function sheet_to_prn(ws){var o=[];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){var oo=[];for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null){oo.push("          ");continue;}var w=(cell.w||(format_cell(cell),cell.w)||"").slice(0,10);while(w.length<10)w+=" ";oo.push(w+(C===0?" ":""));}o.push(oo.join(""));}return o.join("\n");}return {to_workbook:prn_to_workbook,to_sheet:prn_to_sheet,from_sheet:sheet_to_prn};}();/* Excel defaults to SYLK but warns if data is not valid */function read_wb_ID(d,opts){var o=opts||{},OLD_WTF=!!o.WTF;o.WTF=true;try{var out=SYLK.to_workbook(d,o);o.WTF=OLD_WTF;return out;}catch(e){o.WTF=OLD_WTF;if(!e.message.match(/SYLK bad record ID/)&&OLD_WTF)throw e;return PRN.to_workbook(d,opts);}}var WK_=function(){function lotushopper(data,cb,opts){if(!data)return;prep_blob(data,data.l||0);var Enum=opts.Enum||WK1Enum;while(data.l<data.length){var RT=data.read_shift(2);var R=Enum[RT]||Enum[0xFF];var length=data.read_shift(2);var tgt=data.l+length;var d=(R.f||parsenoop)(data,length,opts);data.l=tgt;if(cb(d,R.n,RT))return;}}function lotus_to_workbook(d,opts){switch(opts.type){case'base64':return lotus_to_workbook_buf(s2a(Base64.decode(d)),opts);case'binary':return lotus_to_workbook_buf(s2a(d),opts);case'buffer':case'array':return lotus_to_workbook_buf(d,opts);}throw "Unsupported type "+opts.type;}function lotus_to_workbook_buf(d,opts){if(!d)return d;var o=opts||{};var s=o.dense?[]:{},n="Sheet1",sidx=0;var sheets={},snames=[n];var refguess={s:{r:0,c:0},e:{r:0,c:0}};var sheetRows=o.sheetRows||0;if(d[2]==0x02)o.Enum=WK1Enum;else if(d[2]==0x1a)o.Enum=WK3Enum;else if(d[2]==0x0e){o.Enum=WK3Enum;o.qpro=true;d.l=0;}else throw new Error("Unrecognized LOTUS BOF "+d[2]);lotushopper(d,function(val,Rn,RT){if(d[2]==0x02)switch(RT){case 0x00:o.vers=val;if(val>=0x1000)o.qpro=true;break;case 0x06:refguess=val;break;/* RANGE */case 0x0F:/* LABEL */if(!o.qpro)val[1].v=val[1].v.slice(1);/* falls through */case 0x0D:/* INTEGER */case 0x0E:/* NUMBER */case 0x10:/* FORMULA */case 0x33:/* STRING */ /* TODO: actual translation of the format code */if(RT==0x0E&&(val[2]&0x70)==0x70&&(val[2]&0x0F)>1&&(val[2]&0x0F)<15){val[1].z=o.dateNF||SSF._table[14];if(o.cellDates){val[1].t='d';val[1].v=numdate(val[1].v);}}if(o.dense){if(!s[val[0].r])s[val[0].r]=[];s[val[0].r][val[0].c]=val[1];}else s[encode_cell(val[0])]=val[1];break;}else switch(RT){case 0x16:/* LABEL16 */val[1].v=val[1].v.slice(1);/* falls through */case 0x17:/* NUMBER17 */case 0x18:/* NUMBER18 */case 0x19:/* FORMULA19 */case 0x25:/* NUMBER25 */case 0x27:/* NUMBER27 */case 0x28:/* FORMULA28 */if(val[3]>sidx){s["!ref"]=encode_range(refguess);sheets[n]=s;s=o.dense?[]:{};refguess={s:{r:0,c:0},e:{r:0,c:0}};sidx=val[3];n="Sheet"+(sidx+1);snames.push(n);}if(sheetRows>0&&val[0].r>=sheetRows)break;if(o.dense){if(!s[val[0].r])s[val[0].r]=[];s[val[0].r][val[0].c]=val[1];}else s[encode_cell(val[0])]=val[1];if(refguess.e.c<val[0].c)refguess.e.c=val[0].c;if(refguess.e.r<val[0].r)refguess.e.r=val[0].r;break;}},o);s["!ref"]=encode_range(refguess);sheets[n]=s;return {SheetNames:snames,Sheets:sheets};}function parse_RANGE(blob){var o={s:{c:0,r:0},e:{c:0,r:0}};o.s.c=blob.read_shift(2);o.s.r=blob.read_shift(2);o.e.c=blob.read_shift(2);o.e.r=blob.read_shift(2);if(o.s.c==0xFFFF)o.s.c=o.e.c=o.s.r=o.e.r=0;return o;}function parse_cell(blob,length,opts){var o=[{c:0,r:0},{t:'n',v:0},0];if(opts.qpro&&opts.vers!=0x5120){o[0].c=blob.read_shift(1);blob.l++;o[0].r=blob.read_shift(2);blob.l+=2;}else {o[2]=blob.read_shift(1);o[0].c=blob.read_shift(2);o[0].r=blob.read_shift(2);}return o;}function parse_LABEL(blob,length,opts){var tgt=blob.l+length;var o=parse_cell(blob,length,opts);o[1].t='s';if(opts.vers==0x5120){blob.l++;var len=blob.read_shift(1);o[1].v=blob.read_shift(len,'utf8');return o;}if(opts.qpro)blob.l++;o[1].v=blob.read_shift(tgt-blob.l,'cstr');return o;}function parse_INTEGER(blob,length,opts){var o=parse_cell(blob,length,opts);o[1].v=blob.read_shift(2,'i');return o;}function parse_NUMBER(blob,length,opts){var o=parse_cell(blob,length,opts);o[1].v=blob.read_shift(8,'f');return o;}function parse_FORMULA(blob,length,opts){var tgt=blob.l+length;var o=parse_cell(blob,length,opts);/* TODO: formula */o[1].v=blob.read_shift(8,'f');if(opts.qpro)blob.l=tgt;else {var flen=blob.read_shift(2);blob.l+=flen;}return o;}function parse_cell_3(blob){var o=[{c:0,r:0},{t:'n',v:0},0];o[0].r=blob.read_shift(2);o[3]=blob[blob.l++];o[0].c=blob[blob.l++];return o;}function parse_LABEL_16(blob,length){var o=parse_cell_3(blob);o[1].t='s';o[1].v=blob.read_shift(length-4,'cstr');return o;}function parse_NUMBER_18(blob,length){var o=parse_cell_3(blob);o[1].v=blob.read_shift(2);var v=o[1].v>>1;/* TODO: figure out all of the corner cases */if(o[1].v&0x1){switch(v&0x07){case 1:v=(v>>3)*500;break;case 2:v=(v>>3)/20;break;case 4:v=(v>>3)/2000;break;case 6:v=(v>>3)/16;break;case 7:v=(v>>3)/64;break;default:throw "unknown NUMBER_18 encoding "+(v&0x07);}}o[1].v=v;return o;}function parse_NUMBER_17(blob,length){var o=parse_cell_3(blob);var v1=blob.read_shift(4);var v2=blob.read_shift(4);var e=blob.read_shift(2);if(e==0xFFFF){o[1].v=0;return o;}var s=e&0x8000;e=(e&0x7FFF)-16446;o[1].v=(s*2-1)*((e>0?v2<<e:v2>>>-e)+(e>-32?v1<<e+32:v1>>>-(e+32)));return o;}function parse_FORMULA_19(blob,length){var o=parse_NUMBER_17(blob);blob.l+=length-14;/* TODO: formula */return o;}function parse_NUMBER_25(blob,length){var o=parse_cell_3(blob);var v1=blob.read_shift(4);o[1].v=v1>>6;return o;}function parse_NUMBER_27(blob,length){var o=parse_cell_3(blob);var v1=blob.read_shift(8,'f');o[1].v=v1;return o;}function parse_FORMULA_28(blob,length){var o=parse_NUMBER_27(blob);blob.l+=length-10;/* TODO: formula */return o;}var WK1Enum={0x0000:{n:"BOF",f:parseuint16},0x0001:{n:"EOF"},0x0002:{n:"CALCMODE"},0x0003:{n:"CALCORDER"},0x0004:{n:"SPLIT"},0x0005:{n:"SYNC"},0x0006:{n:"RANGE",f:parse_RANGE},0x0007:{n:"WINDOW1"},0x0008:{n:"COLW1"},0x0009:{n:"WINTWO"},0x000A:{n:"COLW2"},0x000B:{n:"NAME"},0x000C:{n:"BLANK"},0x000D:{n:"INTEGER",f:parse_INTEGER},0x000E:{n:"NUMBER",f:parse_NUMBER},0x000F:{n:"LABEL",f:parse_LABEL},0x0010:{n:"FORMULA",f:parse_FORMULA},0x0018:{n:"TABLE"},0x0019:{n:"ORANGE"},0x001A:{n:"PRANGE"},0x001B:{n:"SRANGE"},0x001C:{n:"FRANGE"},0x001D:{n:"KRANGE1"},0x0020:{n:"HRANGE"},0x0023:{n:"KRANGE2"},0x0024:{n:"PROTEC"},0x0025:{n:"FOOTER"},0x0026:{n:"HEADER"},0x0027:{n:"SETUP"},0x0028:{n:"MARGINS"},0x0029:{n:"LABELFMT"},0x002A:{n:"TITLES"},0x002B:{n:"SHEETJS"},0x002D:{n:"GRAPH"},0x002E:{n:"NGRAPH"},0x002F:{n:"CALCCOUNT"},0x0030:{n:"UNFORMATTED"},0x0031:{n:"CURSORW12"},0x0032:{n:"WINDOW"},0x0033:{n:"STRING",f:parse_LABEL},0x0037:{n:"PASSWORD"},0x0038:{n:"LOCKED"},0x003C:{n:"QUERY"},0x003D:{n:"QUERYNAME"},0x003E:{n:"PRINT"},0x003F:{n:"PRINTNAME"},0x0040:{n:"GRAPH2"},0x0041:{n:"GRAPHNAME"},0x0042:{n:"ZOOM"},0x0043:{n:"SYMSPLIT"},0x0044:{n:"NSROWS"},0x0045:{n:"NSCOLS"},0x0046:{n:"RULER"},0x0047:{n:"NNAME"},0x0048:{n:"ACOMM"},0x0049:{n:"AMACRO"},0x004A:{n:"PARSE"},0x00FF:{n:"",f:parsenoop}};var WK3Enum={0x0000:{n:"BOF"},0x0001:{n:"EOF"},0x0003:{n:"??"},0x0004:{n:"??"},0x0005:{n:"??"},0x0006:{n:"??"},0x0007:{n:"??"},0x0009:{n:"??"},0x000a:{n:"??"},0x000b:{n:"??"},0x000c:{n:"??"},0x000e:{n:"??"},0x000f:{n:"??"},0x0010:{n:"??"},0x0011:{n:"??"},0x0012:{n:"??"},0x0013:{n:"??"},0x0015:{n:"??"},0x0016:{n:"LABEL16",f:parse_LABEL_16},0x0017:{n:"NUMBER17",f:parse_NUMBER_17},0x0018:{n:"NUMBER18",f:parse_NUMBER_18},0x0019:{n:"FORMULA19",f:parse_FORMULA_19},0x001a:{n:"??"},0x001b:{n:"??"},0x001c:{n:"??"},0x001d:{n:"??"},0x001e:{n:"??"},0x001f:{n:"??"},0x0021:{n:"??"},0x0025:{n:"NUMBER25",f:parse_NUMBER_25},0x0027:{n:"NUMBER27",f:parse_NUMBER_27},0x0028:{n:"FORMULA28",f:parse_FORMULA_28},0x00FF:{n:"",f:parsenoop}};return {to_workbook:lotus_to_workbook};}();/* 18.4.7 rPr CT_RPrElt */function parse_rpr(rpr){var font={},m=rpr.match(tagregex),i=0;var pass=false;if(m)for(;i!=m.length;++i){var y=parsexmltag(m[i]);switch(y[0].replace(/\w*:/g,"")){/* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */case'<condense':break;/* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */case'<extend':break;/* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */case'<shadow':if(!y.val)break;/* falls through */case'<shadow>':case'<shadow/>':font.shadow=1;break;case'</shadow>':break;/* 18.4.1 charset CT_IntProperty TODO */case'<charset':if(y.val=='1')break;font.cp=CS2CP[parseInt(y.val,10)];break;/* 18.4.2 outline CT_BooleanProperty TODO */case'<outline':if(!y.val)break;/* falls through */case'<outline>':case'<outline/>':font.outline=1;break;case'</outline>':break;/* 18.4.5 rFont CT_FontName */case'<rFont':font.name=y.val;break;/* 18.4.11 sz CT_FontSize */case'<sz':font.sz=y.val;break;/* 18.4.10 strike CT_BooleanProperty */case'<strike':if(!y.val)break;/* falls through */case'<strike>':case'<strike/>':font.strike=1;break;case'</strike>':break;/* 18.4.13 u CT_UnderlineProperty */case'<u':if(!y.val)break;switch(y.val){case'double':font.uval="double";break;case'singleAccounting':font.uval="single-accounting";break;case'doubleAccounting':font.uval="double-accounting";break;}/* falls through */case'<u>':case'<u/>':font.u=1;break;case'</u>':break;/* 18.8.2 b */case'<b':if(y.val=='0')break;/* falls through */case'<b>':case'<b/>':font.b=1;break;case'</b>':break;/* 18.8.26 i */case'<i':if(y.val=='0')break;/* falls through */case'<i>':case'<i/>':font.i=1;break;case'</i>':break;/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */case'<color':if(y.rgb)font.color=y.rgb.slice(2,8);break;/* 18.8.18 family ST_FontFamily */case'<family':font.family=y.val;break;/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */case'<vertAlign':font.valign=y.val;break;/* 18.8.35 scheme CT_FontScheme TODO */case'<scheme':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(y[0].charCodeAt(1)!==47&&!pass)throw new Error('Unrecognized rich format '+y[0]);}}return font;}var parse_rs=function(){var tregex=matchtag("t"),rpregex=matchtag("rPr");/* 18.4.4 r CT_RElt */function parse_r(r){/* 18.4.12 t ST_Xstring */var t=r.match(tregex)/*, cp = 65001*/;if(!t)return {t:"s",v:""};var o={t:'s',v:unescapexml(t[1])};var rpr=r.match(rpregex);if(rpr)o.s=parse_rpr(rpr[1]);return o;}var rregex=/<(?:\w+:)?r>/g,rend=/<\/(?:\w+:)?r>/;return function parse_rs(rs){return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r){return r.v;});};}();/* Parse a list of <r> tags */var rs_to_html=function parse_rs_factory(){var nlregex=/(\r\n|\n)/g;function parse_rpr2(font,intro,outro){var style=[];if(font.u)style.push("text-decoration: underline;");if(font.uval)style.push("text-underline-style:"+font.uval+";");if(font.sz)style.push("font-size:"+font.sz+"pt;");if(font.outline)style.push("text-effect: outline;");if(font.shadow)style.push("text-shadow: auto;");intro.push('<span style="'+style.join("")+'">');if(font.b){intro.push("<b>");outro.push("</b>");}if(font.i){intro.push("<i>");outro.push("</i>");}if(font.strike){intro.push("<s>");outro.push("</s>");}var align=font.valign||"";if(align=="superscript"||align=="super")align="sup";else if(align=="subscript")align="sub";if(align!=""){intro.push("<"+align+">");outro.push("</"+align+">");}outro.push("</span>");return font;}/* 18.4.4 r CT_RElt */function r_to_html(r){var terms=[[],r.v,[]];if(!r.v)return "";if(r.s)parse_rpr2(r.s,terms[0],terms[2]);return terms[0].join("")+terms[1].replace(nlregex,'<br/>')+terms[2].join("");}return function parse_rs(rs){return rs.map(r_to_html).join("");};}();/* 18.4.8 si CT_Rst */var sitregex=/<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,sirregex=/<(?:\w+:)?r>/;var sirphregex=/<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;function parse_si(x,opts){var html=opts?opts.cellHTML:true;var z={};if(!x)return {t:""};//var y;
/* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)){z.t=unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));z.r=utf8read(x);if(html)z.h=escapehtml(z.t);}/* 18.4.4 r CT_RElt (Rich Text Run) */else if(/*y = */x.match(sirregex)){z.r=utf8read(x);z.t=unescapexml(utf8read((x.replace(sirphregex,'').match(sitregex)||[]).join("").replace(tagregex,"")));if(html)z.h=rs_to_html(parse_rs(z.r));}/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */return z;}/* 18.4 Shared String Table */var sstr0=/<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;var sstr1=/<(?:\w+:)?(?:si|sstItem)>/g;var sstr2=/<\/(?:\w+:)?(?:si|sstItem)>/;function parse_sst_xml(data,opts){var s=[],ss="";if(!data)return s;/* 18.4.9 sst CT_Sst */var sst=data.match(sstr0);if(sst){ss=sst[2].replace(sstr1,"").split(sstr2);for(var i=0;i!=ss.length;++i){var o=parse_si(ss[i].trim(),opts);if(o!=null)s[s.length]=o;}sst=parsexmltag(sst[1]);s.Count=sst.count;s.Unique=sst.uniqueCount;}return s;}RELS.SST="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";var straywsregex=/^\s|\s$|[\t\n\r]/;function write_sst_xml(sst,opts){if(!opts.bookSST)return "";var o=[XML_HEADER];o[o.length]=writextag('sst',null,{xmlns:XMLNS.main[0],count:sst.Count,uniqueCount:sst.Unique});for(var i=0;i!=sst.length;++i){if(sst[i]==null)continue;var s=sst[i];var sitag="<si>";if(s.r)sitag+=s.r;else {sitag+="<t";if(!s.t)s.t="";if(s.t.match(straywsregex))sitag+=' xml:space="preserve"';sitag+=">"+escapexml(s.t)+"</t>";}sitag+="</si>";o[o.length]=sitag;}if(o.length>2){o[o.length]='</sst>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.221 BrtBeginSst */function parse_BrtBeginSst(data){return [data.read_shift(4),data.read_shift(4)];}/* [MS-XLSB] 2.1.7.45 Shared Strings */function parse_sst_bin(data,opts){var s=[];var pass=false;recordhopper(data,function hopper_sst(val,R_n,RT){switch(RT){case 0x009F:/* 'BrtBeginSst' */s.Count=val[0];s.Unique=val[1];break;case 0x0013:/* 'BrtSSTItem' */s.push(val);break;case 0x00A0:/* 'BrtEndSst' */return true;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;default:if(R_n.indexOf("Begin")>0);else if(R_n.indexOf("End")>0);if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R_n);}});return s;}function write_BrtBeginSst(sst,o){if(!o)o=new_buf(8);o.write_shift(4,sst.Count);o.write_shift(4,sst.Unique);return o;}var write_BrtSSTItem=write_RichStr;function write_sst_bin(sst){var ba=buf_array();write_record(ba,"BrtBeginSst",write_BrtBeginSst(sst));for(var i=0;i<sst.length;++i)write_record(ba,"BrtSSTItem",write_BrtSSTItem(sst[i]));/* FRTSST */write_record(ba,"BrtEndSst");return ba.end();}function _JS2ANSI(str){if(typeof cptable!=='undefined')return cptable.utils.encode(current_ansi,str);var o=[],oo=str.split("");for(var i=0;i<oo.length;++i)o[i]=oo[i].charCodeAt(0);return o;}/* [MS-OFFCRYPTO] 2.1.4 Version */function parse_CRYPTOVersion(blob,length){var o={};o.Major=blob.read_shift(2);o.Minor=blob.read_shift(2);if(length>=4)blob.l+=length-4;return o;}/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */function parse_DataSpaceVersionInfo(blob){var o={};o.id=blob.read_shift(0,'lpp4');o.R=parse_CRYPTOVersion(blob,4);o.U=parse_CRYPTOVersion(blob,4);o.W=parse_CRYPTOVersion(blob,4);return o;}/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */function parse_DataSpaceMapEntry(blob){var len=blob.read_shift(4);var end=blob.l+len-4;var o={};var cnt=blob.read_shift(4);var comps=[];/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */while(cnt-->0)comps.push({t:blob.read_shift(4),v:blob.read_shift(0,'lpp4')});o.name=blob.read_shift(0,'lpp4');o.comps=comps;if(blob.l!=end)throw new Error("Bad DataSpaceMapEntry: "+blob.l+" != "+end);return o;}/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */function parse_DataSpaceMap(blob){var o=[];blob.l+=4;// must be 0x8
var cnt=blob.read_shift(4);while(cnt-->0)o.push(parse_DataSpaceMapEntry(blob));return o;}/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */function parse_DataSpaceDefinition(blob){var o=[];blob.l+=4;// must be 0x8
var cnt=blob.read_shift(4);while(cnt-->0)o.push(blob.read_shift(0,'lpp4'));return o;}/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */function parse_TransformInfoHeader(blob){var o={};/*var len = */blob.read_shift(4);blob.l+=4;// must be 0x1
o.id=blob.read_shift(0,'lpp4');o.name=blob.read_shift(0,'lpp4');o.R=parse_CRYPTOVersion(blob,4);o.U=parse_CRYPTOVersion(blob,4);o.W=parse_CRYPTOVersion(blob,4);return o;}function parse_Primary(blob){/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */var hdr=parse_TransformInfoHeader(blob);/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */hdr.ename=blob.read_shift(0,'8lpp4');hdr.blksz=blob.read_shift(4);hdr.cmode=blob.read_shift(4);if(blob.read_shift(4)!=0x04)throw new Error("Bad !Primary record");return hdr;}/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */function parse_EncryptionHeader(blob,length){var tgt=blob.l+length;var o={};o.Flags=blob.read_shift(4)&0x3F;blob.l+=4;o.AlgID=blob.read_shift(4);var valid=false;switch(o.AlgID){case 0x660E:case 0x660F:case 0x6610:valid=o.Flags==0x24;break;case 0x6801:valid=o.Flags==0x04;break;case 0:valid=o.Flags==0x10||o.Flags==0x04||o.Flags==0x24;break;default:throw 'Unrecognized encryption algorithm: '+o.AlgID;}if(!valid)throw new Error("Encryption Flags/AlgID mismatch");o.AlgIDHash=blob.read_shift(4);o.KeySize=blob.read_shift(4);o.ProviderType=blob.read_shift(4);blob.l+=8;o.CSPName=blob.read_shift(tgt-blob.l>>1,'utf16le');blob.l=tgt;return o;}/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */function parse_EncryptionVerifier(blob,length){var o={},tgt=blob.l+length;blob.l+=4;// SaltSize must be 0x10
o.Salt=blob.slice(blob.l,blob.l+16);blob.l+=16;o.Verifier=blob.slice(blob.l,blob.l+16);blob.l+=16;/*var sz = */blob.read_shift(4);o.VerifierHash=blob.slice(blob.l,tgt);blob.l=tgt;return o;}/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */function parse_EncryptionInfo(blob){var vers=parse_CRYPTOVersion(blob);switch(vers.Minor){case 0x02:return [vers.Minor,parse_EncInfoStd(blob)];case 0x03:return [vers.Minor,parse_EncInfoExt()];case 0x04:return [vers.Minor,parse_EncInfoAgl(blob)];}throw new Error("ECMA-376 Encrypted file unrecognized Version: "+vers.Minor);}/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */function parse_EncInfoStd(blob){var flags=blob.read_shift(4);if((flags&0x3F)!=0x24)throw new Error("EncryptionInfo mismatch");var sz=blob.read_shift(4);//var tgt = blob.l + sz;
var hdr=parse_EncryptionHeader(blob,sz);var verifier=parse_EncryptionVerifier(blob,blob.length-blob.l);return {t:"Std",h:hdr,v:verifier};}/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */function parse_EncInfoExt(){throw new Error("File is password-protected: ECMA-376 Extensible");}/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */function parse_EncInfoAgl(blob){var KeyData=["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];blob.l+=4;var xml=blob.read_shift(blob.length-blob.l,'utf8');var o={};xml.replace(tagregex,function xml_agile(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;case'<encryption':case'</encryption>':break;case'<keyData':KeyData.forEach(function(k){o[k]=y[k];});break;case'<dataIntegrity':o.encryptedHmacKey=y.encryptedHmacKey;o.encryptedHmacValue=y.encryptedHmacValue;break;case'<keyEncryptors>':case'<keyEncryptors':o.encs=[];break;case'</keyEncryptors>':break;case'<keyEncryptor':o.uri=y.uri;break;case'</keyEncryptor>':break;case'<encryptedKey':o.encs.push(y);break;default:throw y[0];}});return o;}/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */function parse_RC4CryptoHeader(blob,length){var o={};var vers=o.EncryptionVersionInfo=parse_CRYPTOVersion(blob,4);length-=4;if(vers.Minor!=2)throw new Error('unrecognized minor version code: '+vers.Minor);if(vers.Major>4||vers.Major<2)throw new Error('unrecognized major version code: '+vers.Major);o.Flags=blob.read_shift(4);length-=4;var sz=blob.read_shift(4);length-=4;o.EncryptionHeader=parse_EncryptionHeader(blob,sz);length-=sz;o.EncryptionVerifier=parse_EncryptionVerifier(blob,length);return o;}/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */function parse_RC4Header(blob){var o={};var vers=o.EncryptionVersionInfo=parse_CRYPTOVersion(blob,4);if(vers.Major!=1||vers.Minor!=1)throw 'unrecognized version code '+vers.Major+' : '+vers.Minor;o.Salt=blob.read_shift(16);o.EncryptedVerifier=blob.read_shift(16);o.EncryptedVerifierHash=blob.read_shift(16);return o;}/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */function crypto_CreatePasswordVerifier_Method1(Password){var Verifier=0x0000,PasswordArray;var PasswordDecoded=_JS2ANSI(Password);var len=PasswordDecoded.length+1,i,PasswordByte;var Intermediate1,Intermediate2,Intermediate3;PasswordArray=new_raw_buf(len);PasswordArray[0]=PasswordDecoded.length;for(i=1;i!=len;++i)PasswordArray[i]=PasswordDecoded[i-1];for(i=len-1;i>=0;--i){PasswordByte=PasswordArray[i];Intermediate1=(Verifier&0x4000)===0x0000?0:1;Intermediate2=Verifier<<1&0x7FFF;Intermediate3=Intermediate1|Intermediate2;Verifier=Intermediate3^PasswordByte;}return Verifier^0xCE4B;}/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */var crypto_CreateXorArray_Method1=function(){var PadArray=[0xBB,0xFF,0xFF,0xBA,0xFF,0xFF,0xB9,0x80,0x00,0xBE,0x0F,0x00,0xBF,0x0F,0x00];var InitialCode=[0xE1F0,0x1D0F,0xCC9C,0x84C0,0x110C,0x0E10,0xF1CE,0x313E,0x1872,0xE139,0xD40F,0x84F9,0x280C,0xA96A,0x4EC3];var XorMatrix=[0xAEFC,0x4DD9,0x9BB2,0x2745,0x4E8A,0x9D14,0x2A09,0x7B61,0xF6C2,0xFDA5,0xEB6B,0xC6F7,0x9DCF,0x2BBF,0x4563,0x8AC6,0x05AD,0x0B5A,0x16B4,0x2D68,0x5AD0,0x0375,0x06EA,0x0DD4,0x1BA8,0x3750,0x6EA0,0xDD40,0xD849,0xA0B3,0x5147,0xA28E,0x553D,0xAA7A,0x44D5,0x6F45,0xDE8A,0xAD35,0x4A4B,0x9496,0x390D,0x721A,0xEB23,0xC667,0x9CEF,0x29FF,0x53FE,0xA7FC,0x5FD9,0x47D3,0x8FA6,0x0F6D,0x1EDA,0x3DB4,0x7B68,0xF6D0,0xB861,0x60E3,0xC1C6,0x93AD,0x377B,0x6EF6,0xDDEC,0x45A0,0x8B40,0x06A1,0x0D42,0x1A84,0x3508,0x6A10,0xAA51,0x4483,0x8906,0x022D,0x045A,0x08B4,0x1168,0x76B4,0xED68,0xCAF1,0x85C3,0x1BA7,0x374E,0x6E9C,0x3730,0x6E60,0xDCC0,0xA9A1,0x4363,0x86C6,0x1DAD,0x3331,0x6662,0xCCC4,0x89A9,0x0373,0x06E6,0x0DCC,0x1021,0x2042,0x4084,0x8108,0x1231,0x2462,0x48C4];var Ror=function(Byte){return (Byte/2|Byte*128)&0xFF;};var XorRor=function(byte1,byte2){return Ror(byte1^byte2);};var CreateXorKey_Method1=function(Password){var XorKey=InitialCode[Password.length-1];var CurrentElement=0x68;for(var i=Password.length-1;i>=0;--i){var Char=Password[i];for(var j=0;j!=7;++j){if(Char&0x40)XorKey^=XorMatrix[CurrentElement];Char*=2;--CurrentElement;}}return XorKey;};return function(password){var Password=_JS2ANSI(password);var XorKey=CreateXorKey_Method1(Password);var Index=Password.length;var ObfuscationArray=new_raw_buf(16);for(var i=0;i!=16;++i)ObfuscationArray[i]=0x00;var Temp,PasswordLastChar,PadIndex;if((Index&1)===1){Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(PadArray[0],Temp);--Index;Temp=XorKey&0xFF;PasswordLastChar=Password[Password.length-1];ObfuscationArray[Index]=XorRor(PasswordLastChar,Temp);}while(Index>0){--Index;Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(Password[Index],Temp);--Index;Temp=XorKey&0xFF;ObfuscationArray[Index]=XorRor(Password[Index],Temp);}Index=15;PadIndex=15-Password.length;while(PadIndex>0){Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(PadArray[PadIndex],Temp);--Index;--PadIndex;Temp=XorKey&0xFF;ObfuscationArray[Index]=XorRor(Password[Index],Temp);--Index;--PadIndex;}return ObfuscationArray;};}();/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */var crypto_DecryptData_Method1=function(password,Data,XorArrayIndex,XorArray,O){/* If XorArray is set, use it; if O is not set, make changes in-place */if(!O)O=Data;if(!XorArray)XorArray=crypto_CreateXorArray_Method1(password);var Index,Value;for(Index=0;Index!=Data.length;++Index){Value=Data[Index];Value^=XorArray[XorArrayIndex];Value=(Value>>5|Value<<3)&0xFF;O[Index]=Value;++XorArrayIndex;}return [O,XorArrayIndex,XorArray];};var crypto_MakeXorDecryptor=function(password){var XorArrayIndex=0,XorArray=crypto_CreateXorArray_Method1(password);return function(Data){var O=crypto_DecryptData_Method1("",Data,XorArrayIndex,XorArray);XorArrayIndex=O[1];return O[0];};};/* 2.5.343 */function parse_XORObfuscation(blob,length,opts,out){var o={key:parseuint16(blob),verificationBytes:parseuint16(blob)};if(opts.password)o.verifier=crypto_CreatePasswordVerifier_Method1(opts.password);out.valid=o.verificationBytes===o.verifier;if(out.valid)out.insitu=crypto_MakeXorDecryptor(opts.password);return o;}/* 2.4.117 */function parse_FilePassHeader(blob,length,oo){var o=oo||{};o.Info=blob.read_shift(2);blob.l-=2;if(o.Info===1)o.Data=parse_RC4Header(blob);else o.Data=parse_RC4CryptoHeader(blob,length);return o;}function parse_FilePass(blob,length,opts){var o={Type:opts.biff>=8?blob.read_shift(2):0};/* wEncryptionType */if(o.Type)parse_FilePassHeader(blob,length-2,o);else parse_XORObfuscation(blob,opts.biff>=8?length:length-2,opts,o);return o;}var RTF=function(){function rtf_to_sheet(d,opts){switch(opts.type){case'base64':return rtf_to_sheet_str(Base64.decode(d),opts);case'binary':return rtf_to_sheet_str(d,opts);case'buffer':return rtf_to_sheet_str(d.toString('binary'),opts);case'array':return rtf_to_sheet_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}function rtf_to_sheet_str(str,opts){var o=opts||{};var ws=o.dense?[]:{};var range={s:{c:0,r:0},e:{c:0,r:0}};// TODO: parse
if(!str.match(/\\trowd/))throw new Error("RTF missing table");ws['!ref']=encode_range(range);return ws;}function rtf_to_workbook(d,opts){return sheet_to_workbook(rtf_to_sheet(d,opts),opts);}/* TODO: this is a stub */function sheet_to_rtf(ws){var o=["{\\rtf1\\ansi"];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){o.push("\\trowd\\trautofit1");for(var C=r.s.c;C<=r.e.c;++C)o.push("\\cellx"+(C+1));o.push("\\pard\\intbl");for(C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null&&(!cell.f||cell.F))continue;o.push(" "+(cell.w||(format_cell(cell),cell.w)));o.push("\\cell");}o.push("\\pard\\intbl\\row");}return o.join("")+"}";}return {to_workbook:rtf_to_workbook,to_sheet:rtf_to_sheet,from_sheet:sheet_to_rtf};}();function hex2RGB(h){var o=h.slice(h[0]==="#"?1:0).slice(0,6);return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];}function rgb2Hex(rgb){for(var i=0,o=1;i!=3;++i)o=o*256+(rgb[i]>255?255:rgb[i]<0?0:rgb[i]);return o.toString(16).toUpperCase().slice(1);}function rgb2HSL(rgb){var R=rgb[0]/255,G=rgb[1]/255,B=rgb[2]/255;var M=Math.max(R,G,B),m=Math.min(R,G,B),C=M-m;if(C===0)return [0,0,R];var H6=0,S=0,L2=M+m;S=C/(L2>1?2-L2:L2);switch(M){case R:H6=((G-B)/C+6)%6;break;case G:H6=(B-R)/C+2;break;case B:H6=(R-G)/C+4;break;}return [H6/6,S,L2/2];}function hsl2RGB(hsl){var H=hsl[0],S=hsl[1],L=hsl[2];var C=S*2*(L<0.5?L:1-L),m=L-C/2;var rgb=[m,m,m],h6=6*H;var X;if(S!==0)switch(h6|0){case 0:case 6:X=C*h6;rgb[0]+=C;rgb[1]+=X;break;case 1:X=C*(2-h6);rgb[0]+=X;rgb[1]+=C;break;case 2:X=C*(h6-2);rgb[1]+=C;rgb[2]+=X;break;case 3:X=C*(4-h6);rgb[1]+=X;rgb[2]+=C;break;case 4:X=C*(h6-4);rgb[2]+=C;rgb[0]+=X;break;case 5:X=C*(6-h6);rgb[2]+=X;rgb[0]+=C;break;}for(var i=0;i!=3;++i)rgb[i]=Math.round(rgb[i]*255);return rgb;}/* 18.8.3 bgColor tint algorithm */function rgb_tint(hex,tint){if(tint===0)return hex;var hsl=rgb2HSL(hex2RGB(hex));if(tint<0)hsl[2]=hsl[2]*(1+tint);else hsl[2]=1-(1-hsl[2])*(1-tint);return rgb2Hex(hsl2RGB(hsl));}/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */var DEF_MDW=6,MAX_MDW=15,MIN_MDW=1,MDW=DEF_MDW;function width2px(width){return Math.floor((width+Math.round(128/MDW)/256)*MDW);}function px2char(px){return Math.floor((px-5)/MDW*100+0.5)/100;}function char2width(chr){return Math.round((chr*MDW+5)/MDW*256)/256;}//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function cycle_width(collw){return char2width(px2char(width2px(collw)));}/* XLSX/XLSB/XLS specify width in units of MDW */function find_mdw_colw(collw){var delta=Math.abs(collw-cycle_width(collw)),_MDW=MDW;if(delta>0.005)for(MDW=MIN_MDW;MDW<MAX_MDW;++MDW)if(Math.abs(collw-cycle_width(collw))<=delta){delta=Math.abs(collw-cycle_width(collw));_MDW=MDW;}MDW=_MDW;}/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/function process_col(coll){if(coll.width){coll.wpx=width2px(coll.width);coll.wch=px2char(coll.wpx);coll.MDW=MDW;}else if(coll.wpx){coll.wch=px2char(coll.wpx);coll.width=char2width(coll.wch);coll.MDW=MDW;}else if(typeof coll.wch=='number'){coll.width=char2width(coll.wch);coll.wpx=width2px(coll.width);coll.MDW=MDW;}if(coll.customWidth)delete coll.customWidth;}var DEF_PPI=96,PPI=DEF_PPI;function px2pt(px){return px*96/PPI;}function pt2px(pt){return pt*PPI/96;}/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */var XLMLPatternTypeMap={"None":"none","Solid":"solid","Gray50":"mediumGray","Gray75":"darkGray","Gray25":"lightGray","HorzStripe":"darkHorizontal","VertStripe":"darkVertical","ReverseDiagStripe":"darkDown","DiagStripe":"darkUp","DiagCross":"darkGrid","ThickDiagCross":"darkTrellis","ThinHorzStripe":"lightHorizontal","ThinVertStripe":"lightVertical","ThinReverseDiagStripe":"lightDown","ThinHorzCross":"lightGrid"};/* 18.8.5 borders CT_Borders */function parse_borders(t,styles,themes,opts){styles.Borders=[];var border={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<borders':case'<borders>':case'</borders>':break;/* 18.8.4 border CT_Border */case'<border':case'<border>':case'<border/>':border={};if(y.diagonalUp)border.diagonalUp=parsexmlbool(y.diagonalUp);if(y.diagonalDown)border.diagonalDown=parsexmlbool(y.diagonalDown);styles.Borders.push(border);break;case'</border>':break;/* note: not in spec, appears to be CT_BorderPr */case'<left/>':break;case'<left':case'<left>':break;case'</left>':break;/* note: not in spec, appears to be CT_BorderPr */case'<right/>':break;case'<right':case'<right>':break;case'</right>':break;/* 18.8.43 top CT_BorderPr */case'<top/>':break;case'<top':case'<top>':break;case'</top>':break;/* 18.8.6 bottom CT_BorderPr */case'<bottom/>':break;case'<bottom':case'<bottom>':break;case'</bottom>':break;/* 18.8.13 diagonal CT_BorderPr */case'<diagonal':case'<diagonal>':case'<diagonal/>':break;case'</diagonal>':break;/* 18.8.25 horizontal CT_BorderPr */case'<horizontal':case'<horizontal>':case'<horizontal/>':break;case'</horizontal>':break;/* 18.8.44 vertical CT_BorderPr */case'<vertical':case'<vertical>':case'<vertical/>':break;case'</vertical>':break;/* 18.8.37 start CT_BorderPr */case'<start':case'<start>':case'<start/>':break;case'</start>':break;/* 18.8.16 end CT_BorderPr */case'<end':case'<end>':case'<end/>':break;case'</end>':break;/* 18.8.? color CT_Color */case'<color':case'<color>':break;case'<color/>':case'</color>':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in borders');}}});}/* 18.8.21 fills CT_Fills */function parse_fills(t,styles,themes,opts){styles.Fills=[];var fill={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<fills':case'<fills>':case'</fills>':break;/* 18.8.20 fill CT_Fill */case'<fill>':case'<fill':case'<fill/>':fill={};styles.Fills.push(fill);break;case'</fill>':break;/* 18.8.24 gradientFill CT_GradientFill */case'<gradientFill>':break;case'<gradientFill':case'</gradientFill>':styles.Fills.push(fill);fill={};break;/* 18.8.32 patternFill CT_PatternFill */case'<patternFill':case'<patternFill>':if(y.patternType)fill.patternType=y.patternType;break;case'<patternFill/>':case'</patternFill>':break;/* 18.8.3 bgColor CT_Color */case'<bgColor':if(!fill.bgColor)fill.bgColor={};if(y.indexed)fill.bgColor.indexed=parseInt(y.indexed,10);if(y.theme)fill.bgColor.theme=parseInt(y.theme,10);if(y.tint)fill.bgColor.tint=parseFloat(y.tint);/* Excel uses ARGB strings */if(y.rgb)fill.bgColor.rgb=y.rgb.slice(-6);break;case'<bgColor/>':case'</bgColor>':break;/* 18.8.19 fgColor CT_Color */case'<fgColor':if(!fill.fgColor)fill.fgColor={};if(y.theme)fill.fgColor.theme=parseInt(y.theme,10);if(y.tint)fill.fgColor.tint=parseFloat(y.tint);/* Excel uses ARGB strings */if(y.rgb!=null)fill.fgColor.rgb=y.rgb.slice(-6);break;case'<fgColor/>':case'</fgColor>':break;/* 18.8.38 stop CT_GradientStop */case'<stop':case'<stop/>':break;case'</stop>':break;/* 18.8.? color CT_Color */case'<color':case'<color/>':break;case'</color>':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in fills');}}});}/* 18.8.23 fonts CT_Fonts */function parse_fonts(t,styles,themes,opts){styles.Fonts=[];var font={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<fonts':case'<fonts>':case'</fonts>':break;/* 18.8.22 font CT_Font */case'<font':case'<font>':break;case'</font>':case'<font/>':styles.Fonts.push(font);font={};break;/* 18.8.29 name CT_FontName */case'<name':if(y.val)font.name=utf8read(y.val);break;case'<name/>':case'</name>':break;/* 18.8.2  b CT_BooleanProperty */case'<b':font.bold=y.val?parsexmlbool(y.val):1;break;case'<b/>':font.bold=1;break;/* 18.8.26 i CT_BooleanProperty */case'<i':font.italic=y.val?parsexmlbool(y.val):1;break;case'<i/>':font.italic=1;break;/* 18.4.13 u CT_UnderlineProperty */case'<u':switch(y.val){case"none":font.underline=0x00;break;case"single":font.underline=0x01;break;case"double":font.underline=0x02;break;case"singleAccounting":font.underline=0x21;break;case"doubleAccounting":font.underline=0x22;break;}break;case'<u/>':font.underline=1;break;/* 18.4.10 strike CT_BooleanProperty */case'<strike':font.strike=y.val?parsexmlbool(y.val):1;break;case'<strike/>':font.strike=1;break;/* 18.4.2  outline CT_BooleanProperty */case'<outline':font.outline=y.val?parsexmlbool(y.val):1;break;case'<outline/>':font.outline=1;break;/* 18.8.36 shadow CT_BooleanProperty */case'<shadow':font.shadow=y.val?parsexmlbool(y.val):1;break;case'<shadow/>':font.shadow=1;break;/* 18.8.12 condense CT_BooleanProperty */case'<condense':font.condense=y.val?parsexmlbool(y.val):1;break;case'<condense/>':font.condense=1;break;/* 18.8.17 extend CT_BooleanProperty */case'<extend':font.extend=y.val?parsexmlbool(y.val):1;break;case'<extend/>':font.extend=1;break;/* 18.4.11 sz CT_FontSize */case'<sz':if(y.val)font.sz=+y.val;break;case'<sz/>':case'</sz>':break;/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */case'<vertAlign':if(y.val)font.vertAlign=y.val;break;case'<vertAlign/>':case'</vertAlign>':break;/* 18.8.18 family CT_FontFamily */case'<family':if(y.val)font.family=parseInt(y.val,10);break;case'<family/>':case'</family>':break;/* 18.8.35 scheme CT_FontScheme */case'<scheme':if(y.val)font.scheme=y.val;break;case'<scheme/>':case'</scheme>':break;/* 18.4.1 charset CT_IntProperty */case'<charset':if(y.val=='1')break;y.codepage=CS2CP[parseInt(y.val,10)];break;/* 18.?.? color CT_Color */case'<color':if(!font.color)font.color={};if(y.auto)font.color.auto=parsexmlbool(y.auto);if(y.rgb)font.color.rgb=y.rgb.slice(-6);else if(y.indexed){font.color.index=parseInt(y.indexed,10);var icv=XLSIcv[font.color.index];if(font.color.index==81)icv=XLSIcv[1];if(!icv)throw new Error(x);font.color.rgb=icv[0].toString(16)+icv[1].toString(16)+icv[2].toString(16);}else if(y.theme){font.color.theme=parseInt(y.theme,10);if(y.tint)font.color.tint=parseFloat(y.tint);if(y.theme&&themes.themeElements&&themes.themeElements.clrScheme){font.color.rgb=rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb,font.color.tint||0);}}break;case'<color/>':case'</color>':break;/* note: sometimes mc:AlternateContent appears bare */case'<AlternateContent':pass=true;break;case'</AlternateContent>':pass=false;break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in fonts');}}});}/* 18.8.31 numFmts CT_NumFmts */function parse_numFmts(t,styles,opts){styles.NumberFmt=[];var k/*Array<number>*/=keys(SSF._table);for(var i=0;i<k.length;++i)styles.NumberFmt[k[i]]=SSF._table[k[i]];var m=t[0].match(tagregex);if(!m)return;for(i=0;i<m.length;++i){var y=parsexmltag(m[i]);switch(strip_ns(y[0])){case'<numFmts':case'</numFmts>':case'<numFmts/>':case'<numFmts>':break;case'<numFmt':{var f=unescapexml(utf8read(y.formatCode)),j=parseInt(y.numFmtId,10);styles.NumberFmt[j]=f;if(j>0){if(j>0x188){for(j=0x188;j>0x3c;--j)if(styles.NumberFmt[j]==null)break;styles.NumberFmt[j]=f;}SSF.load(f,j);}}break;case'</numFmt>':break;default:if(opts.WTF)throw new Error('unrecognized '+y[0]+' in numFmts');}}}function write_numFmts(NF){var o=["<numFmts>"];[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){for(var i=r[0];i<=r[1];++i)if(NF[i]!=null)o[o.length]=writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])});});if(o.length===1)return "";o[o.length]="</numFmts>";o[0]=writextag('numFmts',null,{count:o.length-2}).replace("/>",">");return o.join("");}/* 18.8.10 cellXfs CT_CellXfs */var cellXF_uint=["numFmtId","fillId","fontId","borderId","xfId"];var cellXF_bool=["applyAlignment","applyBorder","applyFill","applyFont","applyNumberFormat","applyProtection","pivotButton","quotePrefix"];function parse_cellXfs(t,styles,opts){styles.CellXf=[];var xf;var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x),i=0;switch(strip_ns(y[0])){case'<cellXfs':case'<cellXfs>':case'<cellXfs/>':case'</cellXfs>':break;/* 18.8.45 xf CT_Xf */case'<xf':case'<xf/>':xf=y;delete xf[0];for(i=0;i<cellXF_uint.length;++i)if(xf[cellXF_uint[i]])xf[cellXF_uint[i]]=parseInt(xf[cellXF_uint[i]],10);for(i=0;i<cellXF_bool.length;++i)if(xf[cellXF_bool[i]])xf[cellXF_bool[i]]=parsexmlbool(xf[cellXF_bool[i]]);if(styles.NumberFmt&&xf.numFmtId>0x188){for(i=0x188;i>0x3c;--i)if(styles.NumberFmt[xf.numFmtId]==styles.NumberFmt[i]){xf.numFmtId=i;break;}}styles.CellXf.push(xf);break;case'</xf>':break;/* 18.8.1 alignment CT_CellAlignment */case'<alignment':case'<alignment/>':var alignment={};if(y.vertical)alignment.vertical=y.vertical;if(y.horizontal)alignment.horizontal=y.horizontal;if(y.textRotation!=null)alignment.textRotation=y.textRotation;if(y.indent)alignment.indent=y.indent;if(y.wrapText)alignment.wrapText=parsexmlbool(y.wrapText);xf.alignment=alignment;break;case'</alignment>':break;/* 18.8.33 protection CT_CellProtection */case'<protection':break;case'</protection>':case'<protection/>':break;/* note: sometimes mc:AlternateContent appears bare */case'<AlternateContent':pass=true;break;case'</AlternateContent>':pass=false;break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in cellXfs');}}});}function write_cellXfs(cellXfs){var o=[];o[o.length]=writextag('cellXfs',null);cellXfs.forEach(function(c){o[o.length]=writextag('xf',null,c);});o[o.length]="</cellXfs>";if(o.length===2)return "";o[0]=writextag('cellXfs',null,{count:o.length-2}).replace("/>",">");return o.join("");}/* 18.8 Styles CT_Stylesheet*/var parse_sty_xml=function make_pstyx(){var numFmtRegex=/<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;var cellXfRegex=/<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;var fillsRegex=/<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;var fontsRegex=/<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;var bordersRegex=/<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;return function parse_sty_xml(data,themes,opts){var styles={};if(!data)return styles;data=data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");/* 18.8.39 styleSheet CT_Stylesheet */var t;/* 18.8.31 numFmts CT_NumFmts ? */if(t=data.match(numFmtRegex))parse_numFmts(t,styles,opts);/* 18.8.23 fonts CT_Fonts ? */if(t=data.match(fontsRegex))parse_fonts(t,styles,themes,opts);/* 18.8.21 fills CT_Fills ? */if(t=data.match(fillsRegex))parse_fills(t,styles,themes,opts);/* 18.8.5  borders CT_Borders ? */if(t=data.match(bordersRegex))parse_borders(t,styles,themes,opts);/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */if(t=data.match(cellXfRegex))parse_cellXfs(t,styles,opts);/* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */return styles;};}();var STYLES_XML_ROOT=writextag('styleSheet',null,{'xmlns':XMLNS.main[0],'xmlns:vt':XMLNS.vt});RELS.STY="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";function write_sty_xml(wb,opts){var o=[XML_HEADER,STYLES_XML_ROOT],w;if(wb.SSF&&(w=write_numFmts(wb.SSF))!=null)o[o.length]=w;o[o.length]='<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';o[o.length]='<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';o[o.length]='<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';o[o.length]='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';if(w=write_cellXfs(opts.cellXfs))o[o.length]=w;o[o.length]='<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';o[o.length]='<dxfs count="0"/>';o[o.length]='<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';if(o.length>2){o[o.length]='</styleSheet>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.657 BrtFmt */function parse_BrtFmt(data,length){var numFmtId=data.read_shift(2);var stFmtCode=parse_XLWideString(data);return [numFmtId,stFmtCode];}function write_BrtFmt(i,f,o){if(!o)o=new_buf(6+4*f.length);o.write_shift(2,i);write_XLWideString(f,o);var out=o.length>o.l?o.slice(0,o.l):o;if(o.l==null)o.l=o.length;return out;}/* [MS-XLSB] 2.4.659 BrtFont TODO */function parse_BrtFont(data,length,opts){var out={};out.sz=data.read_shift(2)/20;var grbit=parse_FontFlags(data);if(grbit.fItalic)out.italic=1;if(grbit.fCondense)out.condense=1;if(grbit.fExtend)out.extend=1;if(grbit.fShadow)out.shadow=1;if(grbit.fOutline)out.outline=1;if(grbit.fStrikeout)out.strike=1;var bls=data.read_shift(2);if(bls===0x02BC)out.bold=1;switch(data.read_shift(2)){/* case 0: out.vertAlign = "baseline"; break; */case 1:out.vertAlign="superscript";break;case 2:out.vertAlign="subscript";break;}var underline=data.read_shift(1);if(underline!=0)out.underline=underline;var family=data.read_shift(1);if(family>0)out.family=family;var bCharSet=data.read_shift(1);if(bCharSet>0)out.charset=bCharSet;data.l++;out.color=parse_BrtColor(data);switch(data.read_shift(1)){/* case 0: out.scheme = "none": break; */case 1:out.scheme="major";break;case 2:out.scheme="minor";break;}out.name=parse_XLWideString(data);return out;}function write_BrtFont(font,o){if(!o)o=new_buf(25+4*32);o.write_shift(2,font.sz*20);write_FontFlags(font,o);o.write_shift(2,font.bold?0x02BC:0x0190);var sss=0;if(font.vertAlign=="superscript")sss=1;else if(font.vertAlign=="subscript")sss=2;o.write_shift(2,sss);o.write_shift(1,font.underline||0);o.write_shift(1,font.family||0);o.write_shift(1,font.charset||0);o.write_shift(1,0);write_BrtColor(font.color,o);var scheme=0;if(font.scheme=="major")scheme=1;if(font.scheme=="minor")scheme=2;o.write_shift(1,scheme);write_XLWideString(font.name,o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.650 BrtFill */var XLSBFillPTNames=["none","solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];var rev_XLSBFillPTNames=evert(XLSBFillPTNames);/* TODO: gradient fill representation */var parse_BrtFill=parsenoop;function write_BrtFill(fill,o){if(!o)o=new_buf(4*3+8*7+16*1);var fls=rev_XLSBFillPTNames[fill.patternType];if(fls==null)fls=0x28;o.write_shift(4,fls);var j=0;if(fls!=0x28){/* TODO: custom FG Color */write_BrtColor({auto:1},o);/* TODO: custom BG Color */write_BrtColor({auto:1},o);for(;j<12;++j)o.write_shift(4,0);}else {for(;j<4;++j)o.write_shift(4,0);for(;j<12;++j)o.write_shift(4,0);/* TODO */ /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */}return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.824 BrtXF */function parse_BrtXF(data,length){var tgt=data.l+length;var ixfeParent=data.read_shift(2);var ifmt=data.read_shift(2);data.l=tgt;return {ixfe:ixfeParent,numFmtId:ifmt};}function write_BrtXF(data,ixfeP,o){if(!o)o=new_buf(16);o.write_shift(2,ixfeP||0);o.write_shift(2,data.numFmtId||0);o.write_shift(2,0);/* iFont */o.write_shift(2,0);/* iFill */o.write_shift(2,0);/* ixBorder */o.write_shift(1,0);/* trot */o.write_shift(1,0);/* indent */var flow=0;o.write_shift(1,flow);/* flags */o.write_shift(1,0);/* flags */o.write_shift(1,0);/* xfGrbitAtr */o.write_shift(1,0);return o;}/* [MS-XLSB] 2.5.4 Blxf TODO */function write_Blxf(data,o){if(!o)o=new_buf(10);o.write_shift(1,0);/* dg */o.write_shift(1,0);o.write_shift(4,0);/* color */o.write_shift(4,0);/* color */return o;}/* [MS-XLSB] 2.4.302 BrtBorder TODO */var parse_BrtBorder=parsenoop;function write_BrtBorder(border,o){if(!o)o=new_buf(51);o.write_shift(1,0);/* diagonal */write_Blxf(null,o);/* top */write_Blxf(null,o);/* bottom */write_Blxf(null,o);/* left */write_Blxf(null,o);/* right */write_Blxf(null,o);/* diag */return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.763 BrtStyle TODO */function write_BrtStyle(style,o){if(!o)o=new_buf(12+4*10);o.write_shift(4,style.xfId);o.write_shift(2,1);o.write_shift(1,+style.builtinId);o.write_shift(1,0);/* iLevel */write_XLNullableWideString(style.name||"",o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */function write_BrtBeginTableStyles(cnt,defTableStyle,defPivotStyle){var o=new_buf(4+256*2*4);o.write_shift(4,cnt);write_XLNullableWideString(defTableStyle,o);write_XLNullableWideString(defPivotStyle,o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.1.7.50 Styles */function parse_sty_bin(data,themes,opts){var styles={};styles.NumberFmt=[];for(var y in SSF._table)styles.NumberFmt[y]=SSF._table[y];styles.CellXf=[];styles.Fonts=[];var state=[];var pass=false;recordhopper(data,function hopper_sty(val,R_n,RT){switch(RT){case 0x002C:/* 'BrtFmt' */styles.NumberFmt[val[0]]=val[1];SSF.load(val[1],val[0]);break;case 0x002B:/* 'BrtFont' */styles.Fonts.push(val);if(val.color.theme!=null&&themes&&themes.themeElements&&themes.themeElements.clrScheme){val.color.rgb=rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb,val.color.tint||0);}break;case 0x0401:/* 'BrtKnownFonts' */break;case 0x002D:/* 'BrtFill' */break;case 0x002E:/* 'BrtBorder' */break;case 0x002F:/* 'BrtXF' */if(state[state.length-1]=="BrtBeginCellXFs"){styles.CellXf.push(val);}break;case 0x0030:/* 'BrtStyle' */case 0x01FB:/* 'BrtDXF' */case 0x023C:/* 'BrtMRUColor' */case 0x01DB:/* 'BrtIndexedColor': */break;case 0x0493:/* 'BrtDXF14' */case 0x0836:/* 'BrtDXF15' */case 0x046A:/* 'BrtSlicerStyleElement' */case 0x0200:/* 'BrtTableStyleElement' */case 0x082F:/* 'BrtTimelineStyleElement' */case 0x0C00:/* 'BrtUid' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;case 0x0025:/* 'BrtACBegin' */state.push(R_n);pass=true;break;case 0x0026:/* 'BrtACEnd' */state.pop();pass=false;break;default:if((R_n||"").indexOf("Begin")>0)state.push(R_n);else if((R_n||"").indexOf("End")>0)state.pop();else if(!pass||opts.WTF&&state[state.length-1]!="BrtACBegin")throw new Error("Unexpected record "+RT+" "+R_n);}});return styles;}function write_FMTS_bin(ba,NF){if(!NF)return;var cnt=0;[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){for(var i=r[0];i<=r[1];++i)if(NF[i]!=null)++cnt;});if(cnt==0)return;write_record(ba,"BrtBeginFmts",write_UInt32LE(cnt));[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){for(var i=r[0];i<=r[1];++i)if(NF[i]!=null)write_record(ba,"BrtFmt",write_BrtFmt(i,NF[i]));});write_record(ba,"BrtEndFmts");}function write_FONTS_bin(ba){var cnt=1;write_record(ba,"BrtBeginFonts",write_UInt32LE(cnt));write_record(ba,"BrtFont",write_BrtFont({sz:12,color:{theme:1},name:"Calibri",family:2,scheme:"minor"}));/* 1*65491BrtFont [ACFONTS] */write_record(ba,"BrtEndFonts");}function write_FILLS_bin(ba){var cnt=2;write_record(ba,"BrtBeginFills",write_UInt32LE(cnt));write_record(ba,"BrtFill",write_BrtFill({patternType:"none"}));write_record(ba,"BrtFill",write_BrtFill({patternType:"gray125"}));/* 1*65431BrtFill */write_record(ba,"BrtEndFills");}function write_BORDERS_bin(ba){var cnt=1;write_record(ba,"BrtBeginBorders",write_UInt32LE(cnt));write_record(ba,"BrtBorder",write_BrtBorder());/* 1*65430BrtBorder */write_record(ba,"BrtEndBorders");}function write_CELLSTYLEXFS_bin(ba){var cnt=1;write_record(ba,"BrtBeginCellStyleXFs",write_UInt32LE(cnt));write_record(ba,"BrtXF",write_BrtXF({numFmtId:0,fontId:0,fillId:0,borderId:0},0xFFFF));/* 1*65430(BrtXF *FRT) */write_record(ba,"BrtEndCellStyleXFs");}function write_CELLXFS_bin(ba,data){write_record(ba,"BrtBeginCellXFs",write_UInt32LE(data.length));data.forEach(function(c){write_record(ba,"BrtXF",write_BrtXF(c,0));});/* 1*65430(BrtXF *FRT) */write_record(ba,"BrtEndCellXFs");}function write_STYLES_bin(ba){var cnt=1;write_record(ba,"BrtBeginStyles",write_UInt32LE(cnt));write_record(ba,"BrtStyle",write_BrtStyle({xfId:0,builtinId:0,name:"Normal"}));/* 1*65430(BrtStyle *FRT) */write_record(ba,"BrtEndStyles");}function write_DXFS_bin(ba){var cnt=0;write_record(ba,"BrtBeginDXFs",write_UInt32LE(cnt));/* *2147483647(BrtDXF *FRT) */write_record(ba,"BrtEndDXFs");}function write_TABLESTYLES_bin(ba){var cnt=0;write_record(ba,"BrtBeginTableStyles",write_BrtBeginTableStyles(cnt,"TableStyleMedium9","PivotStyleMedium4"));/* *TABLESTYLE */write_record(ba,"BrtEndTableStyles");}/* [MS-XLSB] 2.1.7.50 Styles */function write_sty_bin(wb,opts){var ba=buf_array();write_record(ba,"BrtBeginStyleSheet");write_FMTS_bin(ba,wb.SSF);write_FONTS_bin(ba);write_FILLS_bin(ba);write_BORDERS_bin(ba);write_CELLSTYLEXFS_bin(ba);write_CELLXFS_bin(ba,opts.cellXfs);write_STYLES_bin(ba);write_DXFS_bin(ba);write_TABLESTYLES_bin(ba);/* FRTSTYLESHEET*/write_record(ba,"BrtEndStyleSheet");return ba.end();}RELS.THEME="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */var XLSXThemeClrScheme=['</a:lt1>','</a:dk1>','</a:lt2>','</a:dk2>','</a:accent1>','</a:accent2>','</a:accent3>','</a:accent4>','</a:accent5>','</a:accent6>','</a:hlink>','</a:folHlink>'];/* 20.1.6.2 clrScheme CT_ColorScheme */function parse_clrScheme(t,themes,opts){themes.themeElements.clrScheme=[];var color={};(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0]){/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */case'<a:clrScheme':case'</a:clrScheme>':break;/* 20.1.2.3.32 srgbClr CT_SRgbColor */case'<a:srgbClr':color.rgb=y.val;break;/* 20.1.2.3.33 sysClr CT_SystemColor */case'<a:sysClr':color.rgb=y.lastClr;break;/* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */case'<a:dk1>':case'</a:dk1>':case'<a:lt1>':case'</a:lt1>':case'<a:dk2>':case'</a:dk2>':case'<a:lt2>':case'</a:lt2>':case'<a:accent1>':case'</a:accent1>':case'<a:accent2>':case'</a:accent2>':case'<a:accent3>':case'</a:accent3>':case'<a:accent4>':case'</a:accent4>':case'<a:accent5>':case'</a:accent5>':case'<a:accent6>':case'</a:accent6>':case'<a:hlink>':case'</a:hlink>':case'<a:folHlink>':case'</a:folHlink>':if(y[0].charAt(1)==='/'){themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])]=color;color={};}else {color.name=y[0].slice(3,y[0].length-1);}break;default:if(opts&&opts.WTF)throw new Error('Unrecognized '+y[0]+' in clrScheme');}});}/* 20.1.4.1.18 fontScheme CT_FontScheme */function parse_fontScheme(){}/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */function parse_fmtScheme(){}var clrsregex=/<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;var fntsregex=/<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;var fmtsregex=/<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;/* 20.1.6.10 themeElements CT_BaseStyles */function parse_themeElements(data,themes,opts){themes.themeElements={};var t;[/* clrScheme CT_ColorScheme */['clrScheme',clrsregex,parse_clrScheme],/* fontScheme CT_FontScheme */['fontScheme',fntsregex,parse_fontScheme],/* fmtScheme CT_StyleMatrix */['fmtScheme',fmtsregex,parse_fmtScheme]].forEach(function(m){if(!(t=data.match(m[1])))throw new Error(m[0]+' not found in themeElements');m[2](t,themes,opts);});}var themeltregex=/<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;/* 14.2.7 Theme Part */function parse_theme_xml(data,opts){/* 20.1.6.9 theme CT_OfficeStyleSheet */if(!data||data.length===0)return parse_theme_xml(write_theme());var t;var themes={};/* themeElements CT_BaseStyles */if(!(t=data.match(themeltregex)))throw new Error('themeElements not found in theme');parse_themeElements(t[0],themes,opts);themes.raw=data;return themes;}function write_theme(Themes,opts){if(opts&&opts.themeXLSX)return opts.themeXLSX;if(Themes&&typeof Themes.raw=="string")return Themes.raw;var o=[XML_HEADER];o[o.length]='<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';o[o.length]='<a:themeElements>';o[o.length]='<a:clrScheme name="Office">';o[o.length]='<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';o[o.length]='<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';o[o.length]='<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';o[o.length]='<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';o[o.length]='<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';o[o.length]='<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';o[o.length]='<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';o[o.length]='<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';o[o.length]='<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';o[o.length]='<a:accent6><a:srgbClr val="F79646"/></a:accent6>';o[o.length]='<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';o[o.length]='<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';o[o.length]='</a:clrScheme>';o[o.length]='<a:fontScheme name="Office">';o[o.length]='<a:majorFont>';o[o.length]='<a:latin typeface="Cambria"/>';o[o.length]='<a:ea typeface=""/>';o[o.length]='<a:cs typeface=""/>';o[o.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';o[o.length]='<a:font script="Hang" typeface="맑은 고딕"/>';o[o.length]='<a:font script="Hans" typeface="宋体"/>';o[o.length]='<a:font script="Hant" typeface="新細明體"/>';o[o.length]='<a:font script="Arab" typeface="Times New Roman"/>';o[o.length]='<a:font script="Hebr" typeface="Times New Roman"/>';o[o.length]='<a:font script="Thai" typeface="Tahoma"/>';o[o.length]='<a:font script="Ethi" typeface="Nyala"/>';o[o.length]='<a:font script="Beng" typeface="Vrinda"/>';o[o.length]='<a:font script="Gujr" typeface="Shruti"/>';o[o.length]='<a:font script="Khmr" typeface="MoolBoran"/>';o[o.length]='<a:font script="Knda" typeface="Tunga"/>';o[o.length]='<a:font script="Guru" typeface="Raavi"/>';o[o.length]='<a:font script="Cans" typeface="Euphemia"/>';o[o.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';o[o.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';o[o.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';o[o.length]='<a:font script="Thaa" typeface="MV Boli"/>';o[o.length]='<a:font script="Deva" typeface="Mangal"/>';o[o.length]='<a:font script="Telu" typeface="Gautami"/>';o[o.length]='<a:font script="Taml" typeface="Latha"/>';o[o.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';o[o.length]='<a:font script="Orya" typeface="Kalinga"/>';o[o.length]='<a:font script="Mlym" typeface="Kartika"/>';o[o.length]='<a:font script="Laoo" typeface="DokChampa"/>';o[o.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';o[o.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';o[o.length]='<a:font script="Viet" typeface="Times New Roman"/>';o[o.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';o[o.length]='<a:font script="Geor" typeface="Sylfaen"/>';o[o.length]='</a:majorFont>';o[o.length]='<a:minorFont>';o[o.length]='<a:latin typeface="Calibri"/>';o[o.length]='<a:ea typeface=""/>';o[o.length]='<a:cs typeface=""/>';o[o.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';o[o.length]='<a:font script="Hang" typeface="맑은 고딕"/>';o[o.length]='<a:font script="Hans" typeface="宋体"/>';o[o.length]='<a:font script="Hant" typeface="新細明體"/>';o[o.length]='<a:font script="Arab" typeface="Arial"/>';o[o.length]='<a:font script="Hebr" typeface="Arial"/>';o[o.length]='<a:font script="Thai" typeface="Tahoma"/>';o[o.length]='<a:font script="Ethi" typeface="Nyala"/>';o[o.length]='<a:font script="Beng" typeface="Vrinda"/>';o[o.length]='<a:font script="Gujr" typeface="Shruti"/>';o[o.length]='<a:font script="Khmr" typeface="DaunPenh"/>';o[o.length]='<a:font script="Knda" typeface="Tunga"/>';o[o.length]='<a:font script="Guru" typeface="Raavi"/>';o[o.length]='<a:font script="Cans" typeface="Euphemia"/>';o[o.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';o[o.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';o[o.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';o[o.length]='<a:font script="Thaa" typeface="MV Boli"/>';o[o.length]='<a:font script="Deva" typeface="Mangal"/>';o[o.length]='<a:font script="Telu" typeface="Gautami"/>';o[o.length]='<a:font script="Taml" typeface="Latha"/>';o[o.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';o[o.length]='<a:font script="Orya" typeface="Kalinga"/>';o[o.length]='<a:font script="Mlym" typeface="Kartika"/>';o[o.length]='<a:font script="Laoo" typeface="DokChampa"/>';o[o.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';o[o.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';o[o.length]='<a:font script="Viet" typeface="Arial"/>';o[o.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';o[o.length]='<a:font script="Geor" typeface="Sylfaen"/>';o[o.length]='</a:minorFont>';o[o.length]='</a:fontScheme>';o[o.length]='<a:fmtScheme name="Office">';o[o.length]='<a:fillStyleLst>';o[o.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:lin ang="16200000" scaled="1"/>';o[o.length]='</a:gradFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:lin ang="16200000" scaled="0"/>';o[o.length]='</a:gradFill>';o[o.length]='</a:fillStyleLst>';o[o.length]='<a:lnStyleLst>';o[o.length]='<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='</a:lnStyleLst>';o[o.length]='<a:effectStyleLst>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='</a:effectStyle>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='</a:effectStyle>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';o[o.length]='<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';o[o.length]='</a:effectStyle>';o[o.length]='</a:effectStyleLst>';o[o.length]='<a:bgFillStyleLst>';o[o.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';o[o.length]='</a:gradFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';o[o.length]='</a:gradFill>';o[o.length]='</a:bgFillStyleLst>';o[o.length]='</a:fmtScheme>';o[o.length]='</a:themeElements>';o[o.length]='<a:objectDefaults>';o[o.length]='<a:spDef>';o[o.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';o[o.length]='</a:spDef>';o[o.length]='<a:lnDef>';o[o.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';o[o.length]='</a:lnDef>';o[o.length]='</a:objectDefaults>';o[o.length]='<a:extraClrSchemeLst/>';o[o.length]='</a:theme>';return o.join("");}/* [MS-XLS] 2.4.326 TODO: payload is a zip file */function parse_Theme(blob,length,opts){var end=blob.l+length;var dwThemeVersion=blob.read_shift(4);if(dwThemeVersion===124226)return;if(!opts.cellStyles||!jszip$1){blob.l=end;return;}var data=blob.slice(blob.l);blob.l=end;var zip;try{zip=new jszip$1(data);}catch(e){return;}var themeXML=getzipstr(zip,"theme/theme/theme1.xml",true);if(!themeXML)return;return parse_theme_xml(themeXML,opts);}/* 2.5.49 */function parse_ColorTheme(blob){return blob.read_shift(4);}/* 2.5.155 */function parse_FullColorExt(blob){var o={};o.xclrType=blob.read_shift(2);o.nTintShade=blob.read_shift(2);switch(o.xclrType){case 0:blob.l+=4;break;case 1:o.xclrValue=parse_IcvXF(blob,4);break;case 2:o.xclrValue=parse_LongRGBA(blob);break;case 3:o.xclrValue=parse_ColorTheme(blob);break;case 4:blob.l+=4;break;}blob.l+=8;return o;}/* 2.5.164 TODO: read 7 bits*/function parse_IcvXF(blob,length){return parsenoop(blob,length);}/* 2.5.280 */function parse_XFExtGradient(blob,length){return parsenoop(blob,length);}/* [MS-XLS] 2.5.108 */function parse_ExtProp(blob){var extType=blob.read_shift(2);var cb=blob.read_shift(2)-4;var o=[extType];switch(extType){case 0x04:case 0x05:case 0x07:case 0x08:case 0x09:case 0x0A:case 0x0B:case 0x0D:o[1]=parse_FullColorExt(blob);break;case 0x06:o[1]=parse_XFExtGradient(blob,cb);break;case 0x0E:case 0x0F:o[1]=blob.read_shift(cb===1?1:2);break;default:throw new Error("Unrecognized ExtProp type: "+extType+" "+cb);}return o;}/* 2.4.355 */function parse_XFExt(blob,length){var end=blob.l+length;blob.l+=2;var ixfe=blob.read_shift(2);blob.l+=2;var cexts=blob.read_shift(2);var ext=[];while(cexts-->0)ext.push(parse_ExtProp(blob,end-blob.l));return {ixfe:ixfe,ext:ext};}/* xf is an XF, see parse_XFExt for xfext */function update_xfext(xf,xfext){xfext.forEach(function(xfe){switch(xfe[0]){/* 2.5.108 extPropData *//* indentation level */}});}/* 18.6 Calculation Chain */function parse_cc_xml(data){var d=[];if(!data)return d;var i=1;(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0]){case'<?xml':break;/* 18.6.2  calcChain CT_CalcChain 1 */case'<calcChain':case'<calcChain>':case'</calcChain>':break;/* 18.6.1  c CT_CalcCell 1 */case'<c':delete y[0];if(y.i)i=y.i;else y.i=i;d.push(y);break;}});return d;}//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */function parse_BrtCalcChainItem$(data){var out={};out.i=data.read_shift(4);var cell={};cell.r=data.read_shift(4);cell.c=data.read_shift(4);out.r=encode_cell(cell);var flags=data.read_shift(1);if(flags&0x2)out.l='1';if(flags&0x8)out.a='1';return out;}/* 18.6 Calculation Chain */function parse_cc_bin(data,name,opts){var out=[];recordhopper(data,function hopper_cc(val,R_n,RT){switch(RT){case 0x003F:/* 'BrtCalcChainItem$' */out.push(val);break;default:if((R_n||"").indexOf("Begin")>0);else if((R_n||"").indexOf("End")>0);else throw new Error("Unexpected record "+RT+" "+R_n);}});return out;}//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */function parse_xlink_xml(){//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}/* [MS-XLSB] 2.1.7.25 External Link */function parse_xlink_bin(data,rel,name,_opts){if(!data)return data;var opts=_opts||{};var pass=false;recordhopper(data,function xlink_parse(val,R_n,RT){switch(RT){case 0x0167:/* 'BrtSupTabs' */case 0x016B:/* 'BrtExternTableStart' */case 0x016C:/* 'BrtExternTableEnd' */case 0x016E:/* 'BrtExternRowHdr' */case 0x016F:/* 'BrtExternCellBlank' */case 0x0170:/* 'BrtExternCellReal' */case 0x0171:/* 'BrtExternCellBool' */case 0x0172:/* 'BrtExternCellError' */case 0x0173:/* 'BrtExternCellString' */case 0x01D8:/* 'BrtExternValueMeta' */case 0x0241:/* 'BrtSupNameStart' */case 0x0242:/* 'BrtSupNameValueStart' */case 0x0243:/* 'BrtSupNameValueEnd' */case 0x0244:/* 'BrtSupNameNum' */case 0x0245:/* 'BrtSupNameErr' */case 0x0246:/* 'BrtSupNameSt' */case 0x0247:/* 'BrtSupNameNil' */case 0x0248:/* 'BrtSupNameBool' */case 0x0249:/* 'BrtSupNameFmla' */case 0x024A:/* 'BrtSupNameBits' */case 0x024B:/* 'BrtSupNameEnd' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;default:if((R_n||"").indexOf("Begin")>0);else if((R_n||"").indexOf("End")>0);else if(!pass||opts.WTF)throw new Error("Unexpected record "+RT.toString(16)+" "+R_n);}},opts);}/* 20.5 DrawingML - SpreadsheetML Drawing */RELS.IMG="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";RELS.DRAW="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";/* 20.5.2.35 wsDr CT_Drawing */function parse_drawing(data,rels){if(!data)return "??";/*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/var id=(data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];return rels['!id'][id].Target;}/* L.5.5.2 SpreadsheetML Comments + VML Schema */var _shapeid=1024;function write_comments_vml(rId,comments){var csize=[21600,21600];/* L.5.2.1.2 Path Attribute */var bbox=["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");var o=[writextag("xml",null,{'xmlns:v':XLMLNS.v,'xmlns:o':XLMLNS.o,'xmlns:x':XLMLNS.x,'xmlns:mv':XLMLNS.mv}).replace(/\/>/,">"),writextag("o:shapelayout",writextag("o:idmap",null,{'v:ext':"edit",'data':rId}),{'v:ext':"edit"}),writextag("v:shapetype",[writextag("v:stroke",null,{joinstyle:"miter"}),writextag("v:path",null,{gradientshapeok:"t",'o:connecttype':"rect"})].join(""),{id:"_x0000_t202",'o:spt':202,coordsize:csize.join(","),path:bbox})];while(_shapeid<rId*1000)_shapeid+=1000;comments.forEach(function(x){var c=decode_cell(x[0]);var fillopts={'color2':"#BEFF82",'type':"gradient"};if(fillopts.type=="gradient")fillopts.angle="-180";var fillparm=fillopts.type=="gradient"?writextag("o:fill",null,{type:"gradientUnscaled",'v:ext':"view"}):null;var fillxml=writextag('v:fill',fillparm,fillopts);var shadata={on:"t",'obscured':"t"};++_shapeid;o=o.concat(['<v:shape'+wxt_helper({id:'_x0000_s'+_shapeid,type:"#_x0000_t202",style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10"+(x[1].hidden?";visibility:hidden":""),fillcolor:"#ECFAD4",strokecolor:"#edeaa1"})+'>',fillxml,writextag("v:shadow",null,shadata),writextag("v:path",null,{'o:connecttype':"none"}),'<v:textbox><div style="text-align:left"></div></v:textbox>','<x:ClientData ObjectType="Note">','<x:MoveWithCells/>','<x:SizeWithCells/>',/* Part 4 19.4.2.3 Anchor (Anchor) */writetag('x:Anchor',[c.c+1,0,c.r+1,0,c.c+3,20,c.r+5,20].join(",")),writetag('x:AutoFill',"False"),writetag('x:Row',String(c.r)),writetag('x:Column',String(c.c)),x[1].hidden?'':'<x:Visible/>','</x:ClientData>','</v:shape>']);});o.push('</xml>');return o.join("");}RELS.CMNT="http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";function sheet_insert_comments(sheet,comments){var dense=Array.isArray(sheet);var cell;comments.forEach(function(comment){var r=decode_cell(comment.ref);if(dense){if(!sheet[r.r])sheet[r.r]=[];cell=sheet[r.r][r.c];}else cell=sheet[comment.ref];if(!cell){cell={t:"z"};if(dense)sheet[r.r][r.c]=cell;else sheet[comment.ref]=cell;var range=safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");if(range.s.r>r.r)range.s.r=r.r;if(range.e.r<r.r)range.e.r=r.r;if(range.s.c>r.c)range.s.c=r.c;if(range.e.c<r.c)range.e.c=r.c;var encoded=encode_range(range);if(encoded!==sheet["!ref"])sheet["!ref"]=encoded;}if(!cell.c)cell.c=[];var o={a:comment.author,t:comment.t,r:comment.r};if(comment.h)o.h=comment.h;cell.c.push(o);});}/* 18.7 Comments */function parse_comments_xml(data,opts){/* 18.7.6 CT_Comments */if(data.match(/<(?:\w+:)?comments *\/>/))return [];var authors=[];var commentList=[];var authtag=data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);if(authtag&&authtag[1])authtag[1].split(/<\/\w*:?author>/).forEach(function(x){if(x===""||x.trim()==="")return;var a=x.match(/<(?:\w+:)?author[^>]*>(.*)/);if(a)authors.push(a[1]);});var cmnttag=data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);if(cmnttag&&cmnttag[1])cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x){if(x===""||x.trim()==="")return;var cm=x.match(/<(?:\w+:)?comment[^>]*>/);if(!cm)return;var y=parsexmltag(cm[0]);var comment={author:y.authorId&&authors[y.authorId]||"sheetjsghost",ref:y.ref,guid:y.guid};var cell=decode_cell(y.ref);if(opts.sheetRows&&opts.sheetRows<=cell.r)return;var textMatch=x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);var rt=!!textMatch&&!!textMatch[1]&&parse_si(textMatch[1])||{r:"",t:"",h:""};comment.r=rt.r;if(rt.r=="<t></t>")rt.t=rt.h="";comment.t=(rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");if(opts.cellHTML)comment.h=rt.h;commentList.push(comment);});return commentList;}var CMNT_XML_ROOT=writextag('comments',null,{'xmlns':XMLNS.main[0]});function write_comments_xml(data){var o=[XML_HEADER,CMNT_XML_ROOT];var iauthor=[];o.push("<authors>");data.forEach(function(x){x[1].forEach(function(w){var a=escapexml(w.a);if(iauthor.indexOf(a)>-1)return;iauthor.push(a);o.push("<author>"+a+"</author>");});});o.push("</authors>");o.push("<commentList>");data.forEach(function(d){d[1].forEach(function(c){/* 18.7.3 CT_Comment */o.push('<comment ref="'+d[0]+'" authorId="'+iauthor.indexOf(escapexml(c.a))+'"><text>');o.push(writetag("t",c.t==null?"":escapexml(c.t)));o.push('</text></comment>');});});o.push("</commentList>");if(o.length>2){o[o.length]='</comments>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.28 BrtBeginComment */function parse_BrtBeginComment(data){var out={};out.iauthor=data.read_shift(4);var rfx=parse_UncheckedRfX(data);out.rfx=rfx.s;out.ref=encode_cell(rfx.s);data.l+=16;/*var guid = parse_GUID(data); */return out;}function write_BrtBeginComment(data,o){if(o==null)o=new_buf(36);o.write_shift(4,data[1].iauthor);write_UncheckedRfX(data[0],o);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);return o;}/* [MS-XLSB] 2.4.327 BrtCommentAuthor */var parse_BrtCommentAuthor=parse_XLWideString;function write_BrtCommentAuthor(data){return write_XLWideString(data.slice(0,54));}/* [MS-XLSB] 2.1.7.8 Comments */function parse_comments_bin(data,opts){var out=[];var authors=[];var c={};var pass=false;recordhopper(data,function hopper_cmnt(val,R_n,RT){switch(RT){case 0x0278:/* 'BrtCommentAuthor' */authors.push(val);break;case 0x027B:/* 'BrtBeginComment' */c=val;break;case 0x027D:/* 'BrtCommentText' */c.t=val.t;c.h=val.h;c.r=val.r;break;case 0x027C:/* 'BrtEndComment' */c.author=authors[c.iauthor];delete c.iauthor;if(opts.sheetRows&&c.rfx&&opts.sheetRows<=c.rfx.r)break;if(!c.t)c.t="";delete c.rfx;out.push(c);break;case 0x0C00:/* 'BrtUid' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;case 0x0025:/* 'BrtACBegin' */break;case 0x0026:/* 'BrtACEnd' */break;default:if((R_n||"").indexOf("Begin")>0);else if((R_n||"").indexOf("End")>0);else if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R_n);}});return out;}function write_comments_bin(data){var ba=buf_array();var iauthor=[];write_record(ba,"BrtBeginComments");write_record(ba,"BrtBeginCommentAuthors");data.forEach(function(comment){comment[1].forEach(function(c){if(iauthor.indexOf(c.a)>-1)return;iauthor.push(c.a.slice(0,54));write_record(ba,"BrtCommentAuthor",write_BrtCommentAuthor(c.a));});});write_record(ba,"BrtEndCommentAuthors");write_record(ba,"BrtBeginCommentList");data.forEach(function(comment){comment[1].forEach(function(c){c.iauthor=iauthor.indexOf(c.a);var range={s:decode_cell(comment[0]),e:decode_cell(comment[0])};write_record(ba,"BrtBeginComment",write_BrtBeginComment([range,c]));if(c.t&&c.t.length>0)write_record(ba,"BrtCommentText",write_BrtCommentText(c));write_record(ba,"BrtEndComment");delete c.iauthor;});});write_record(ba,"BrtEndCommentList");write_record(ba,"BrtEndComments");return ba.end();}var CT_VBA="application/vnd.ms-office.vbaProject";function make_vba_xls(cfb){var newcfb=CFB.utils.cfb_new({root:"R"});cfb.FullPaths.forEach(function(p,i){if(p.slice(-1)==="/"||!p.match(/_VBA_PROJECT_CUR/))return;var newpath=p.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/,"");CFB.utils.cfb_add(newcfb,newpath,cfb.FileIndex[i].content);});return CFB.write(newcfb);}function fill_vba_xls(cfb,vba){vba.FullPaths.forEach(function(p,i){if(i==0)return;var newpath=p.replace(/[^\/]*[\/]/,"/_VBA_PROJECT_CUR/");if(newpath.slice(-1)!=="/")CFB.utils.cfb_add(cfb,newpath,vba.FileIndex[i].content);});}var VBAFMTS=["xlsb","xlsm","xlam","biff8","xla"];RELS.DS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";RELS.MS="http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";/* macro and dialog sheet stubs */function parse_ds_bin(){return {'!type':'dialog'};}function parse_ds_xml(){return {'!type':'dialog'};}function parse_ms_bin(){return {'!type':'macro'};}function parse_ms_xml(){return {'!type':'macro'};}/* TODO: it will be useful to parse the function str */var rc_to_a1=function(){var rcregex=/(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;var rcbase={r:0,c:0};function rcfunc($$,$1,$2,$3){var cRel=false,rRel=false;if($2.length==0)rRel=true;else if($2.charAt(0)=="["){rRel=true;$2=$2.slice(1,-1);}if($3.length==0)cRel=true;else if($3.charAt(0)=="["){cRel=true;$3=$3.slice(1,-1);}var R=$2.length>0?parseInt($2,10)|0:0,C=$3.length>0?parseInt($3,10)|0:0;if(cRel)C+=rcbase.c;else --C;if(rRel)R+=rcbase.r;else --R;return $1+(cRel?"":"$")+encode_col(C)+(rRel?"":"$")+encode_row(R);}return function rc_to_a1(fstr,base){rcbase=base;return fstr.replace(rcregex,rcfunc);};}();var crefregex=/(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;var a1_to_rc=function(){return function a1_to_rc(fstr,base){return fstr.replace(crefregex,function($0,$1,$2,$3,$4,$5){var c=decode_col($3)-($2?0:base.c);var r=decode_row($5)-($4?0:base.r);var R=r==0?"":!$4?"["+r+"]":r+1;var C=c==0?"":!$2?"["+c+"]":c+1;return $1+"R"+R+"C"+C;});};}();/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */function shift_formula_str(f,delta){return f.replace(crefregex,function($0,$1,$2,$3,$4,$5){return $1+($2=="$"?$2+$3:encode_col(decode_col($3)+delta.c))+($4=="$"?$4+$5:encode_row(decode_row($5)+delta.r));});}function shift_formula_xlsx(f,range,cell){var r=decode_range(range),s=r.s,c=decode_cell(cell);var delta={r:c.r-s.r,c:c.c-s.c};return shift_formula_str(f,delta);}/* TODO: parse formula */function fuzzyfmla(f){if(f.length==1)return false;return true;}function _xlfn(f){return f.replace(/_xlfn\./g,"");}function parseread1(blob){blob.l+=1;return;}/* [MS-XLS] 2.5.51 */function parse_ColRelU(blob,length){var c=blob.read_shift(length==1?1:2);return [c&0x3FFF,c>>14&1,c>>15&1];}/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */function parse_RgceArea(blob,length,opts){var w=2;if(opts){if(opts.biff>=2&&opts.biff<=5)return parse_RgceArea_BIFF2(blob);else if(opts.biff==12)w=4;}var r=blob.read_shift(w),R=blob.read_shift(w);var c=parse_ColRelU(blob,2);var C=parse_ColRelU(blob,2);return {s:{r:r,c:c[0],cRel:c[1],rRel:c[2]},e:{r:R,c:C[0],cRel:C[1],rRel:C[2]}};}/* BIFF 2-5 encodes flags in the row field */function parse_RgceArea_BIFF2(blob){var r=parse_ColRelU(blob,2),R=parse_ColRelU(blob,2);var c=blob.read_shift(1);var C=blob.read_shift(1);return {s:{r:r[0],c:c,cRel:r[1],rRel:r[2]},e:{r:R[0],c:C,cRel:R[1],rRel:R[2]}};}/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */function parse_RgceAreaRel(blob,length,opts){if(opts.biff<8)return parse_RgceArea_BIFF2(blob);var r=blob.read_shift(opts.biff==12?4:2),R=blob.read_shift(opts.biff==12?4:2);var c=parse_ColRelU(blob,2);var C=parse_ColRelU(blob,2);return {s:{r:r,c:c[0],cRel:c[1],rRel:c[2]},e:{r:R,c:C[0],cRel:C[1],rRel:C[2]}};}/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */function parse_RgceLoc(blob,length,opts){if(opts&&opts.biff>=2&&opts.biff<=5)return parse_RgceLoc_BIFF2(blob);var r=blob.read_shift(opts&&opts.biff==12?4:2);var c=parse_ColRelU(blob,2);return {r:r,c:c[0],cRel:c[1],rRel:c[2]};}function parse_RgceLoc_BIFF2(blob){var r=parse_ColRelU(blob,2);var c=blob.read_shift(1);return {r:r[0],c:c,cRel:r[1],rRel:r[2]};}/* [MS-XLS] 2.5.198.107, 2.5.47 */function parse_RgceElfLoc(blob){var r=blob.read_shift(2);var c=blob.read_shift(2);return {r:r,c:c&0xFF,fQuoted:!!(c&0x4000),cRel:c>>15,rRel:c>>15};}/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */function parse_RgceLocRel(blob,length,opts){var biff=opts&&opts.biff?opts.biff:8;if(biff>=2&&biff<=5)return parse_RgceLocRel_BIFF2(blob);var r=blob.read_shift(biff>=12?4:2);var cl=blob.read_shift(2);var cRel=(cl&0x4000)>>14,rRel=(cl&0x8000)>>15;cl&=0x3FFF;if(rRel==1)while(r>0x7FFFF)r-=0x100000;if(cRel==1)while(cl>0x1FFF)cl=cl-0x4000;return {r:r,c:cl,cRel:cRel,rRel:rRel};}function parse_RgceLocRel_BIFF2(blob){var rl=blob.read_shift(2);var c=blob.read_shift(1);var rRel=(rl&0x8000)>>15,cRel=(rl&0x4000)>>14;rl&=0x3FFF;if(rRel==1&&rl>=0x2000)rl=rl-0x4000;if(cRel==1&&c>=0x80)c=c-0x100;return {r:rl,c:c,cRel:cRel,rRel:rRel};}/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */function parse_PtgArea(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var area=parse_RgceArea(blob,opts.biff>=2&&opts.biff<=5?6:8,opts);return [type,area];}/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */function parse_PtgArea3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2,'i');var w=8;if(opts)switch(opts.biff){case 5:blob.l+=12;w=6;break;case 12:w=12;break;}var area=parse_RgceArea(blob,w,opts);return [type,ixti,area];}/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */function parse_PtgAreaErr(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;blob.l+=opts&&opts.biff>8?12:opts.biff<8?6:8;return [type];}/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */function parse_PtgAreaErr3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2);var w=8;if(opts)switch(opts.biff){case 5:blob.l+=12;w=6;break;case 12:w=12;break;}blob.l+=w;return [type,ixti];}/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */function parse_PtgAreaN(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var area=parse_RgceAreaRel(blob,length-1,opts);return [type,area];}/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */function parse_PtgArray(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;blob.l+=opts.biff==2?6:opts.biff==12?14:7;return [type];}/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */function parse_PtgAttrBaxcel(blob){var bitSemi=blob[blob.l+1]&0x01;/* 1 = volatile */var bitBaxcel=1;blob.l+=4;return [bitSemi,bitBaxcel];}/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */function parse_PtgAttrChoose(blob,length,opts){blob.l+=2;var offset=blob.read_shift(opts&&opts.biff==2?1:2);var o=[];/* offset is 1 less than the number of elements */for(var i=0;i<=offset;++i)o.push(blob.read_shift(opts&&opts.biff==2?1:2));return o;}/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */function parse_PtgAttrGoto(blob,length,opts){var bitGoto=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return [bitGoto,blob.read_shift(opts&&opts.biff==2?1:2)];}/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */function parse_PtgAttrIf(blob,length,opts){var bitIf=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return [bitIf,blob.read_shift(opts&&opts.biff==2?1:2)];}/* [MS-XLSB] 2.5.97.28 */function parse_PtgAttrIfError(blob){var bitIf=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return [bitIf,blob.read_shift(2)];}/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */function parse_PtgAttrSemi(blob,length,opts){var bitSemi=blob[blob.l+1]&0xFF?1:0;blob.l+=opts&&opts.biff==2?3:4;return [bitSemi];}/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */function parse_PtgAttrSpaceType(blob){var type=blob.read_shift(1),cch=blob.read_shift(1);return [type,cch];}/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */function parse_PtgAttrSpace(blob){blob.read_shift(2);return parse_PtgAttrSpaceType(blob);}/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */function parse_PtgAttrSpaceSemi(blob){blob.read_shift(2);return parse_PtgAttrSpaceType(blob);}/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */function parse_PtgRef(blob,length,opts){//var ptg = blob[blob.l] & 0x1F;
var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var loc=parse_RgceLoc(blob,0,opts);return [type,loc];}/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */function parse_PtgRefN(blob,length,opts){var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var loc=parse_RgceLocRel(blob,0,opts);return [type,loc];}/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */function parse_PtgRef3d(blob,length,opts){var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var ixti=blob.read_shift(2);// XtiIndex
if(opts&&opts.biff==5)blob.l+=12;var loc=parse_RgceLoc(blob,0,opts);// TODO: or RgceLocRel
return [type,ixti,loc];}/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */function parse_PtgFunc(blob,length,opts){//var ptg = blob[blob.l] & 0x1F;
var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var iftab=blob.read_shift(opts&&opts.biff<=3?1:2);return [FtabArgc[iftab],Ftab[iftab],type];}/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */function parse_PtgFuncVar(blob,length,opts){var type=blob[blob.l++];var cparams=blob.read_shift(1),tab=opts&&opts.biff<=3?[type==0x58?-1:0,blob.read_shift(1)]:parsetab(blob);return [cparams,(tab[0]===0?Ftab:Cetab)[tab[1]]];}function parsetab(blob){return [blob[blob.l+1]>>7,blob.read_shift(2)&0x7FFF];}/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */function parse_PtgAttrSum(blob,length,opts){blob.l+=opts&&opts.biff==2?3:4;return;}/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */function parse_PtgExp(blob,length,opts){blob.l++;if(opts&&opts.biff==12)return [blob.read_shift(4,'i'),0];var row=blob.read_shift(2);var col=blob.read_shift(opts&&opts.biff==2?1:2);return [row,col];}/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */function parse_PtgErr(blob){blob.l++;return BErr[blob.read_shift(1)];}/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */function parse_PtgInt(blob){blob.l++;return blob.read_shift(2);}/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */function parse_PtgBool(blob){blob.l++;return blob.read_shift(1)!==0;}/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */function parse_PtgNum(blob){blob.l++;return parse_Xnum(blob);}/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */function parse_PtgStr(blob,length,opts){blob.l++;return parse_ShortXLUnicodeString(blob,length-1,opts);}/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */function parse_SerAr(blob,biff){var val=[blob.read_shift(1)];if(biff==12)switch(val[0]){case 0x02:val[0]=0x04;break;/* SerBool */case 0x04:val[0]=0x10;break;/* SerErr */case 0x00:val[0]=0x01;break;/* SerNum */case 0x01:val[0]=0x02;break;/* SerStr */}switch(val[0]){case 0x04:/* SerBool -- boolean */val[1]=parsebool(blob,1)?'TRUE':'FALSE';if(biff!=12)blob.l+=7;break;case 0x25:/* appears to be an alias */case 0x10:/* SerErr -- error */val[1]=BErr[blob[blob.l]];blob.l+=biff==12?4:8;break;case 0x00:/* SerNil -- honestly, I'm not sure how to reproduce this */blob.l+=8;break;case 0x01:/* SerNum -- Xnum */val[1]=parse_Xnum(blob);break;case 0x02:/* SerStr -- XLUnicodeString (<256 chars) */val[1]=parse_XLUnicodeString2(blob,0,{biff:biff>0&&biff<8?2:biff});break;default:throw new Error("Bad SerAr: "+val[0]);/* Unreachable */}return val;}/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */function parse_PtgExtraMem(blob,cce,opts){var count=blob.read_shift(opts.biff==12?4:2);var out=[];for(var i=0;i!=count;++i)out.push((opts.biff==12?parse_UncheckedRfX:parse_Ref8U)(blob,8));return out;}/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */function parse_PtgExtraArray(blob,length,opts){var rows=0,cols=0;if(opts.biff==12){rows=blob.read_shift(4);// DRw
cols=blob.read_shift(4);// DCol
}else {cols=1+blob.read_shift(1);//DColByteU
rows=1+blob.read_shift(2);//DRw
}if(opts.biff>=2&&opts.biff<8){--rows;if(--cols==0)cols=0x100;}// $FlowIgnore
for(var i=0,o=[];i!=rows&&(o[i]=[]);++i)for(var j=0;j!=cols;++j)o[i][j]=parse_SerAr(blob,opts.biff);return o;}/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */function parse_PtgName(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;var w=!opts||opts.biff>=8?4:2;var nameindex=blob.read_shift(w);switch(opts.biff){case 2:blob.l+=5;break;case 3:case 4:blob.l+=8;break;case 5:blob.l+=12;break;}return [type,0,nameindex];}/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */function parse_PtgNameX(blob,length,opts){if(opts.biff==5)return parse_PtgNameX_BIFF5(blob);var type=blob.read_shift(1)>>>5&0x03;var ixti=blob.read_shift(2);// XtiIndex
var nameindex=blob.read_shift(4);return [type,ixti,nameindex];}function parse_PtgNameX_BIFF5(blob){var type=blob.read_shift(1)>>>5&0x03;var ixti=blob.read_shift(2,'i');// XtiIndex
blob.l+=8;var nameindex=blob.read_shift(2);blob.l+=12;return [type,ixti,nameindex];}/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */function parse_PtgMemArea(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;blob.l+=opts&&opts.biff==2?3:4;var cce=blob.read_shift(opts&&opts.biff==2?1:2);return [type,cce];}/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */function parse_PtgMemFunc(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(opts&&opts.biff==2?1:2);return [type,cce];}/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */function parse_PtgRefErr(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;blob.l+=4;if(opts.biff<8)blob.l--;if(opts.biff==12)blob.l+=2;return [type];}/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */function parse_PtgRefErr3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2);var w=4;if(opts)switch(opts.biff){case 5:w=15;break;case 12:w=6;break;}blob.l+=w;return [type,ixti];}/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */var parse_PtgMemErr=parsenoop;/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */var parse_PtgMemNoMem=parsenoop;/* [MS-XLS] 2.5.198.92 */var parse_PtgTbl=parsenoop;function parse_PtgElfLoc(blob,length,opts){blob.l+=2;return [parse_RgceElfLoc(blob)];}function parse_PtgElfNoop(blob){blob.l+=6;return [];}/* [MS-XLS] 2.5.198.46 */var parse_PtgElfCol=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.47 */var parse_PtgElfColS=parse_PtgElfNoop;/* [MS-XLS] 2.5.198.48 */var parse_PtgElfColSV=parse_PtgElfNoop;/* [MS-XLS] 2.5.198.49 */var parse_PtgElfColV=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.50 */function parse_PtgElfLel(blob){blob.l+=2;return [parseuint16(blob),blob.read_shift(2)&0x01];}/* [MS-XLS] 2.5.198.51 */var parse_PtgElfRadical=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.52 */var parse_PtgElfRadicalLel=parse_PtgElfLel;/* [MS-XLS] 2.5.198.53 */var parse_PtgElfRadicalS=parse_PtgElfNoop;/* [MS-XLS] 2.5.198.54 */var parse_PtgElfRw=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.55 */var parse_PtgElfRwV=parse_PtgElfLoc;/* [MS-XLSB] 2.5.97.52 TODO */var PtgListRT=["Data","All","Headers","??","?Data2","??","?DataHeaders","??","Totals","??","??","??","?DataTotals","??","??","??","?Current"];function parse_PtgList(blob){blob.l+=2;var ixti=blob.read_shift(2);var flags=blob.read_shift(2);var idx=blob.read_shift(4);var c=blob.read_shift(2);var C=blob.read_shift(2);var rt=PtgListRT[flags>>2&0x1F];return {ixti:ixti,coltype:flags&0x3,rt:rt,idx:idx,c:c,C:C};}/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */function parse_PtgSxName(blob){blob.l+=2;return [blob.read_shift(4)];}/* [XLS] old spec */function parse_PtgSheet(blob,length,opts){blob.l+=5;blob.l+=2;blob.l+=opts.biff==2?1:4;return ["PTGSHEET"];}function parse_PtgEndSheet(blob,length,opts){blob.l+=opts.biff==2?4:5;return ["PTGENDSHEET"];}function parse_PtgMemAreaN(blob){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(2);return [type,cce];}function parse_PtgMemNoMemN(blob){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(2);return [type,cce];}function parse_PtgAttrNoop(blob){blob.l+=4;return [0,0];}/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */var PtgTypes={0x01:{n:'PtgExp',f:parse_PtgExp},0x02:{n:'PtgTbl',f:parse_PtgTbl},0x03:{n:'PtgAdd',f:parseread1},0x04:{n:'PtgSub',f:parseread1},0x05:{n:'PtgMul',f:parseread1},0x06:{n:'PtgDiv',f:parseread1},0x07:{n:'PtgPower',f:parseread1},0x08:{n:'PtgConcat',f:parseread1},0x09:{n:'PtgLt',f:parseread1},0x0A:{n:'PtgLe',f:parseread1},0x0B:{n:'PtgEq',f:parseread1},0x0C:{n:'PtgGe',f:parseread1},0x0D:{n:'PtgGt',f:parseread1},0x0E:{n:'PtgNe',f:parseread1},0x0F:{n:'PtgIsect',f:parseread1},0x10:{n:'PtgUnion',f:parseread1},0x11:{n:'PtgRange',f:parseread1},0x12:{n:'PtgUplus',f:parseread1},0x13:{n:'PtgUminus',f:parseread1},0x14:{n:'PtgPercent',f:parseread1},0x15:{n:'PtgParen',f:parseread1},0x16:{n:'PtgMissArg',f:parseread1},0x17:{n:'PtgStr',f:parse_PtgStr},0x1A:{n:'PtgSheet',f:parse_PtgSheet},0x1B:{n:'PtgEndSheet',f:parse_PtgEndSheet},0x1C:{n:'PtgErr',f:parse_PtgErr},0x1D:{n:'PtgBool',f:parse_PtgBool},0x1E:{n:'PtgInt',f:parse_PtgInt},0x1F:{n:'PtgNum',f:parse_PtgNum},0x20:{n:'PtgArray',f:parse_PtgArray},0x21:{n:'PtgFunc',f:parse_PtgFunc},0x22:{n:'PtgFuncVar',f:parse_PtgFuncVar},0x23:{n:'PtgName',f:parse_PtgName},0x24:{n:'PtgRef',f:parse_PtgRef},0x25:{n:'PtgArea',f:parse_PtgArea},0x26:{n:'PtgMemArea',f:parse_PtgMemArea},0x27:{n:'PtgMemErr',f:parse_PtgMemErr},0x28:{n:'PtgMemNoMem',f:parse_PtgMemNoMem},0x29:{n:'PtgMemFunc',f:parse_PtgMemFunc},0x2A:{n:'PtgRefErr',f:parse_PtgRefErr},0x2B:{n:'PtgAreaErr',f:parse_PtgAreaErr},0x2C:{n:'PtgRefN',f:parse_PtgRefN},0x2D:{n:'PtgAreaN',f:parse_PtgAreaN},0x2E:{n:'PtgMemAreaN',f:parse_PtgMemAreaN},0x2F:{n:'PtgMemNoMemN',f:parse_PtgMemNoMemN},0x39:{n:'PtgNameX',f:parse_PtgNameX},0x3A:{n:'PtgRef3d',f:parse_PtgRef3d},0x3B:{n:'PtgArea3d',f:parse_PtgArea3d},0x3C:{n:'PtgRefErr3d',f:parse_PtgRefErr3d},0x3D:{n:'PtgAreaErr3d',f:parse_PtgAreaErr3d},0xFF:{}};/* These are duplicated in the PtgTypes table */var PtgDupes={0x40:0x20,0x60:0x20,0x41:0x21,0x61:0x21,0x42:0x22,0x62:0x22,0x43:0x23,0x63:0x23,0x44:0x24,0x64:0x24,0x45:0x25,0x65:0x25,0x46:0x26,0x66:0x26,0x47:0x27,0x67:0x27,0x48:0x28,0x68:0x28,0x49:0x29,0x69:0x29,0x4A:0x2A,0x6A:0x2A,0x4B:0x2B,0x6B:0x2B,0x4C:0x2C,0x6C:0x2C,0x4D:0x2D,0x6D:0x2D,0x4E:0x2E,0x6E:0x2E,0x4F:0x2F,0x6F:0x2F,0x58:0x22,0x78:0x22,0x59:0x39,0x79:0x39,0x5A:0x3A,0x7A:0x3A,0x5B:0x3B,0x7B:0x3B,0x5C:0x3C,0x7C:0x3C,0x5D:0x3D,0x7D:0x3D};(function(){for(var y in PtgDupes)PtgTypes[y]=PtgTypes[PtgDupes[y]];})();var Ptg18={0x01:{n:'PtgElfLel',f:parse_PtgElfLel},0x02:{n:'PtgElfRw',f:parse_PtgElfRw},0x03:{n:'PtgElfCol',f:parse_PtgElfCol},0x06:{n:'PtgElfRwV',f:parse_PtgElfRwV},0x07:{n:'PtgElfColV',f:parse_PtgElfColV},0x0A:{n:'PtgElfRadical',f:parse_PtgElfRadical},0x0B:{n:'PtgElfRadicalS',f:parse_PtgElfRadicalS},0x0D:{n:'PtgElfColS',f:parse_PtgElfColS},0x0F:{n:'PtgElfColSV',f:parse_PtgElfColSV},0x10:{n:'PtgElfRadicalLel',f:parse_PtgElfRadicalLel},0x19:{n:'PtgList',f:parse_PtgList},0x1D:{n:'PtgSxName',f:parse_PtgSxName},0xFF:{}};var Ptg19={0x00:{n:'PtgAttrNoop',f:parse_PtgAttrNoop},0x01:{n:'PtgAttrSemi',f:parse_PtgAttrSemi},0x02:{n:'PtgAttrIf',f:parse_PtgAttrIf},0x04:{n:'PtgAttrChoose',f:parse_PtgAttrChoose},0x08:{n:'PtgAttrGoto',f:parse_PtgAttrGoto},0x10:{n:'PtgAttrSum',f:parse_PtgAttrSum},0x20:{n:'PtgAttrBaxcel',f:parse_PtgAttrBaxcel},0x40:{n:'PtgAttrSpace',f:parse_PtgAttrSpace},0x41:{n:'PtgAttrSpaceSemi',f:parse_PtgAttrSpaceSemi},0x80:{n:'PtgAttrIfError',f:parse_PtgAttrIfError},0xFF:{}};Ptg19[0x21]=Ptg19[0x20];/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */function parse_RgbExtra(blob,length,rgce,opts){if(opts.biff<8)return parsenoop(blob,length);var target=blob.l+length;var o=[];for(var i=0;i!==rgce.length;++i){switch(rgce[i][0]){case'PtgArray':/* PtgArray -> PtgExtraArray */rgce[i][1]=parse_PtgExtraArray(blob,0,opts);o.push(rgce[i][1]);break;case'PtgMemArea':/* PtgMemArea -> PtgExtraMem */rgce[i][2]=parse_PtgExtraMem(blob,rgce[i][1],opts);o.push(rgce[i][2]);break;case'PtgExp':/* PtgExp -> PtgExtraCol */if(opts&&opts.biff==12){rgce[i][1][1]=blob.read_shift(4);o.push(rgce[i][1]);}break;case'PtgList':/* TODO: PtgList -> PtgExtraList */case'PtgElfRadicalS':/* TODO: PtgElfRadicalS -> PtgExtraElf */case'PtgElfColS':/* TODO: PtgElfColS -> PtgExtraElf */case'PtgElfColSV':/* TODO: PtgElfColSV -> PtgExtraElf */throw "Unsupported "+rgce[i][0];}}length=target-blob.l;/* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
if(length!==0)o.push(parsenoop(blob,length));return o;}/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */function parse_Rgce(blob,length,opts){var target=blob.l+length;var R,id,ptgs=[];while(target!=blob.l){length=target-blob.l;id=blob[blob.l];R=PtgTypes[id];if(id===0x18||id===0x19)R=(id===0x18?Ptg18:Ptg19)[blob[blob.l+1]];if(!R||!R.f){/*ptgs.push*/parsenoop(blob,length);}else {ptgs.push([R.n,R.f(blob,length,opts)]);}}return ptgs;}function stringify_array(f){var o=[];for(var i=0;i<f.length;++i){var x=f[i],r=[];for(var j=0;j<x.length;++j){var y=x[j];if(y)switch(y[0]){// TODO: handle embedded quotes
case 0x02:r.push('"'+y[1].replace(/"/g,'""')+'"');break;default:r.push(y[1]);}else r.push("");}o.push(r.join(","));}return o.join(";");}/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */var PtgBinOp={PtgAdd:"+",PtgConcat:"&",PtgDiv:"/",PtgEq:"=",PtgGe:">=",PtgGt:">",PtgLe:"<=",PtgLt:"<",PtgMul:"*",PtgNe:"<>",PtgPower:"^",PtgSub:"-"};// List of invalid characters needs to be tested further
var quoteCharacters=new RegExp(/[^\w\u4E00-\u9FFF\u3040-\u30FF]/);function formula_quote_sheet_name(sname,opts){if(!sname&&!(opts&&opts.biff<=5&&opts.biff>=2))throw new Error("empty sheet name");if(quoteCharacters.test(sname))return "'"+sname+"'";return sname;}function get_ixti_raw(supbooks,ixti,opts){if(!supbooks)return "SH33TJSERR0";if(opts.biff>8&&(!supbooks.XTI||!supbooks.XTI[ixti]))return supbooks.SheetNames[ixti];if(!supbooks.XTI)return "SH33TJSERR6";var XTI=supbooks.XTI[ixti];if(opts.biff<8){if(ixti>10000)ixti-=65536;if(ixti<0)ixti=-ixti;return ixti==0?"":supbooks.XTI[ixti-1];}if(!XTI)return "SH33TJSERR1";var o="";if(opts.biff>8)switch(supbooks[XTI[0]][0]){case 0x0165:/* 'BrtSupSelf' */o=XTI[1]==-1?"#REF":supbooks.SheetNames[XTI[1]];return XTI[1]==XTI[2]?o:o+":"+supbooks.SheetNames[XTI[2]];case 0x0166:/* 'BrtSupSame' */if(opts.SID!=null)return supbooks.SheetNames[opts.SID];return "SH33TJSSAME"+supbooks[XTI[0]][0];case 0x0163:/* 'BrtSupBookSrc' */ /* falls through */default:return "SH33TJSSRC"+supbooks[XTI[0]][0];}switch(supbooks[XTI[0]][0][0]){case 0x0401:o=XTI[1]==-1?"#REF":supbooks.SheetNames[XTI[1]]||"SH33TJSERR3";return XTI[1]==XTI[2]?o:o+":"+supbooks.SheetNames[XTI[2]];case 0x3A01:return supbooks[XTI[0]].slice(1).map(function(name){return name.Name;}).join(";;");//return "SH33TJSERR8";
default:if(!supbooks[XTI[0]][0][3])return "SH33TJSERR2";o=XTI[1]==-1?"#REF":supbooks[XTI[0]][0][3][XTI[1]]||"SH33TJSERR4";return XTI[1]==XTI[2]?o:o+":"+supbooks[XTI[0]][0][3][XTI[2]];}}function get_ixti(supbooks,ixti,opts){return formula_quote_sheet_name(get_ixti_raw(supbooks,ixti,opts),opts);}function stringify_formula(formula/*Array<any>*/,range,cell,supbooks,opts){var biff=opts&&opts.biff||8;var _range=/*range != null ? range :*/{s:{c:0,r:0},e:{c:0,r:0}};var stack=[],e1,e2,c,ixti=0,nameidx=0,r,sname="";if(!formula[0]||!formula[0][0])return "";var last_sp=-1,sp="";for(var ff=0,fflen=formula[0].length;ff<fflen;++ff){var f=formula[0][ff];switch(f[0]){case'PtgUminus':/* [MS-XLS] 2.5.198.93 */stack.push("-"+stack.pop());break;case'PtgUplus':/* [MS-XLS] 2.5.198.95 */stack.push("+"+stack.pop());break;case'PtgPercent':/* [MS-XLS] 2.5.198.81 */stack.push(stack.pop()+"%");break;case'PtgAdd':/* [MS-XLS] 2.5.198.26 */case'PtgConcat':/* [MS-XLS] 2.5.198.43 */case'PtgDiv':/* [MS-XLS] 2.5.198.45 */case'PtgEq':/* [MS-XLS] 2.5.198.56 */case'PtgGe':/* [MS-XLS] 2.5.198.64 */case'PtgGt':/* [MS-XLS] 2.5.198.65 */case'PtgLe':/* [MS-XLS] 2.5.198.68 */case'PtgLt':/* [MS-XLS] 2.5.198.69 */case'PtgMul':/* [MS-XLS] 2.5.198.75 */case'PtgNe':/* [MS-XLS] 2.5.198.78 */case'PtgPower':/* [MS-XLS] 2.5.198.82 */case'PtgSub':/* [MS-XLS] 2.5.198.90 */e1=stack.pop();e2=stack.pop();if(last_sp>=0){switch(formula[0][last_sp][1][0]){case 0:// $FlowIgnore
sp=fill(" ",formula[0][last_sp][1][1]);break;case 1:// $FlowIgnore
sp=fill("\r",formula[0][last_sp][1][1]);break;default:sp="";// $FlowIgnore
if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+formula[0][last_sp][1][0]);}e2=e2+sp;last_sp=-1;}stack.push(e2+PtgBinOp[f[0]]+e1);break;case'PtgIsect':/* [MS-XLS] 2.5.198.67 */e1=stack.pop();e2=stack.pop();stack.push(e2+" "+e1);break;case'PtgUnion':/* [MS-XLS] 2.5.198.94 */e1=stack.pop();e2=stack.pop();stack.push(e2+","+e1);break;case'PtgRange':/* [MS-XLS] 2.5.198.83 */e1=stack.pop();e2=stack.pop();stack.push(e2+":"+e1);break;case'PtgAttrChoose':/* [MS-XLS] 2.5.198.34 */break;case'PtgAttrGoto':/* [MS-XLS] 2.5.198.35 */break;case'PtgAttrIf':/* [MS-XLS] 2.5.198.36 */break;case'PtgAttrIfError':/* [MS-XLSB] 2.5.97.28 */break;case'PtgRef':/* [MS-XLS] 2.5.198.84 */c=shift_cell_xls(f[1][1],_range,opts);stack.push(encode_cell_xls(c,biff));break;case'PtgRefN':/* [MS-XLS] 2.5.198.88 */c=cell?shift_cell_xls(f[1][1],cell,opts):f[1][1];stack.push(encode_cell_xls(c,biff));break;case'PtgRef3d':/* [MS-XLS] 2.5.198.85 */ixti=f[1][1];c=shift_cell_xls(f[1][2],_range,opts);sname=get_ixti(supbooks,ixti,opts);stack.push(sname+"!"+encode_cell_xls(c,biff));break;case'PtgFunc':/* [MS-XLS] 2.5.198.62 */case'PtgFuncVar':/* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */var argc=f[1][0],func=f[1][1];if(!argc)argc=0;argc&=0x7F;var args=argc==0?[]:stack.slice(-argc);stack.length-=argc;if(func==='User')func=args.shift();stack.push(func+"("+args.join(",")+")");break;case'PtgBool':/* [MS-XLS] 2.5.198.42 */stack.push(f[1]?"TRUE":"FALSE");break;case'PtgInt':/* [MS-XLS] 2.5.198.66 */stack.push(f[1]);break;case'PtgNum':/* [MS-XLS] 2.5.198.79 TODO: precision? */stack.push(String(f[1]));break;case'PtgStr':/* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
stack.push('"'+f[1].replace(/"/g,'""')+'"');break;case'PtgErr':/* [MS-XLS] 2.5.198.57 */stack.push(f[1]);break;case'PtgAreaN':/* [MS-XLS] 2.5.198.31 TODO */r=shift_range_xls(f[1][1],cell?{s:cell}:_range,opts);stack.push(encode_range_xls(r,opts));break;case'PtgArea':/* [MS-XLS] 2.5.198.27 TODO: fixed points */r=shift_range_xls(f[1][1],_range,opts);stack.push(encode_range_xls(r,opts));break;case'PtgArea3d':/* [MS-XLS] 2.5.198.28 TODO */ixti=f[1][1];r=f[1][2];sname=get_ixti(supbooks,ixti,opts);stack.push(sname+"!"+encode_range_xls(r,opts));break;case'PtgAttrSum':/* [MS-XLS] 2.5.198.41 */stack.push("SUM("+stack.pop()+")");break;case'PtgAttrBaxcel':/* [MS-XLS] 2.5.198.33 */case'PtgAttrSemi':/* [MS-XLS] 2.5.198.37 */break;case'PtgName':/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */nameidx=f[1][2];var lbl=(supbooks.names||[])[nameidx-1]||(supbooks[0]||[])[nameidx];var name=lbl?lbl.Name:"SH33TJSNAME"+String(nameidx);if(name in XLSXFutureFunctions)name=XLSXFutureFunctions[name];stack.push(name);break;case'PtgNameX':/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */var bookidx=f[1][1];nameidx=f[1][2];var externbook;/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */if(opts.biff<=5){if(bookidx<0)bookidx=-bookidx;if(supbooks[bookidx])externbook=supbooks[bookidx][nameidx];}else {var o="";if(((supbooks[bookidx]||[])[0]||[])[0]==0x3A01);else if(((supbooks[bookidx]||[])[0]||[])[0]==0x0401){if(supbooks[bookidx][nameidx]&&supbooks[bookidx][nameidx].itab>0){o=supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1]+"!";}}else o=supbooks.SheetNames[nameidx-1]+"!";if(supbooks[bookidx]&&supbooks[bookidx][nameidx])o+=supbooks[bookidx][nameidx].Name;else if(supbooks[0]&&supbooks[0][nameidx])o+=supbooks[0][nameidx].Name;else {var ixtidata=(get_ixti_raw(supbooks,bookidx,opts)||"").split(";;");if(ixtidata[nameidx-1])o=ixtidata[nameidx-1];// TODO: confirm this is correct
else o+="SH33TJSERRX";}stack.push(o);break;}if(!externbook)externbook={Name:"SH33TJSERRY"};stack.push(externbook.Name);break;case'PtgParen':/* [MS-XLS] 2.5.198.80 */var lp='(',rp=')';if(last_sp>=0){sp="";switch(formula[0][last_sp][1][0]){// $FlowIgnore
case 2:lp=fill(" ",formula[0][last_sp][1][1])+lp;break;// $FlowIgnore
case 3:lp=fill("\r",formula[0][last_sp][1][1])+lp;break;// $FlowIgnore
case 4:rp=fill(" ",formula[0][last_sp][1][1])+rp;break;// $FlowIgnore
case 5:rp=fill("\r",formula[0][last_sp][1][1])+rp;break;default:// $FlowIgnore
if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+formula[0][last_sp][1][0]);}last_sp=-1;}stack.push(lp+stack.pop()+rp);break;case'PtgRefErr':/* [MS-XLS] 2.5.198.86 */stack.push('#REF!');break;case'PtgRefErr3d':/* [MS-XLS] 2.5.198.87 */stack.push('#REF!');break;case'PtgExp':/* [MS-XLS] 2.5.198.58 TODO */c={c:f[1][1],r:f[1][0]};var q={c:cell.c,r:cell.r};if(supbooks.sharedf[encode_cell(c)]){var parsedf=supbooks.sharedf[encode_cell(c)];stack.push(stringify_formula(parsedf,_range,q,supbooks,opts));}else {var fnd=false;for(e1=0;e1!=supbooks.arrayf.length;++e1){/* TODO: should be something like range_has */e2=supbooks.arrayf[e1];if(c.c<e2[0].s.c||c.c>e2[0].e.c)continue;if(c.r<e2[0].s.r||c.r>e2[0].e.r)continue;stack.push(stringify_formula(e2[1],_range,q,supbooks,opts));fnd=true;break;}if(!fnd)stack.push(f[1]);}break;case'PtgArray':/* [MS-XLS] 2.5.198.32 TODO */stack.push("{"+stringify_array(f[1])+"}");break;case'PtgMemArea':/* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */ //stack.push("(" + f[2].map(encode_range).join(",") + ")");
break;case'PtgAttrSpace':/* [MS-XLS] 2.5.198.38 */case'PtgAttrSpaceSemi':/* [MS-XLS] 2.5.198.39 */last_sp=ff;break;case'PtgTbl':/* [MS-XLS] 2.5.198.92 TODO */break;case'PtgMemErr':/* [MS-XLS] 2.5.198.71 */break;case'PtgMissArg':/* [MS-XLS] 2.5.198.74 */stack.push("");break;case'PtgAreaErr':/* [MS-XLS] 2.5.198.29 */stack.push("#REF!");break;case'PtgAreaErr3d':/* [MS-XLS] 2.5.198.30 */stack.push("#REF!");break;case'PtgList':/* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
stack.push("Table"+f[1].idx+"[#"+f[1].rt+"]");break;case'PtgMemAreaN':case'PtgMemNoMemN':case'PtgAttrNoop':case'PtgSheet':case'PtgEndSheet':break;case'PtgMemFunc':/* [MS-XLS] 2.5.198.72 TODO */break;case'PtgMemNoMem':/* [MS-XLS] 2.5.198.73 TODO */break;case'PtgElfCol':/* [MS-XLS] 2.5.198.46 */case'PtgElfColS':/* [MS-XLS] 2.5.198.47 */case'PtgElfColSV':/* [MS-XLS] 2.5.198.48 */case'PtgElfColV':/* [MS-XLS] 2.5.198.49 */case'PtgElfLel':/* [MS-XLS] 2.5.198.50 */case'PtgElfRadical':/* [MS-XLS] 2.5.198.51 */case'PtgElfRadicalLel':/* [MS-XLS] 2.5.198.52 */case'PtgElfRadicalS':/* [MS-XLS] 2.5.198.53 */case'PtgElfRw':/* [MS-XLS] 2.5.198.54 */case'PtgElfRwV':/* [MS-XLS] 2.5.198.55 */throw new Error("Unsupported ELFs");case'PtgSxName':/* [MS-XLS] 2.5.198.91 TODO -- find a test case */throw new Error('Unrecognized Formula Token: '+String(f));default:throw new Error('Unrecognized Formula Token: '+String(f));}var PtgNonDisp=['PtgAttrSpace','PtgAttrSpaceSemi','PtgAttrGoto'];if(opts.biff!=3)if(last_sp>=0&&PtgNonDisp.indexOf(formula[0][ff][0])==-1){f=formula[0][last_sp];var _left=true;switch(f[1][0]){/* note: some bad XLSB files omit the PtgParen */case 4:_left=false;/* falls through */case 0:// $FlowIgnore
sp=fill(" ",f[1][1]);break;case 5:_left=false;/* falls through */case 1:// $FlowIgnore
sp=fill("\r",f[1][1]);break;default:sp="";// $FlowIgnore
if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+f[1][0]);}stack.push((_left?sp:"")+stack.pop()+(_left?"":sp));last_sp=-1;}}if(stack.length>1&&opts.WTF)throw new Error("bad formula stack");return stack[0];}/* [MS-XLS] 2.5.198.1 TODO */function parse_ArrayParsedFormula(blob,length,opts){var target=blob.l+length,len=opts.biff==2?1:2;var rgcb,cce=blob.read_shift(len);// length of rgce
if(cce==0xFFFF)return [[],parsenoop(blob,length-2)];var rgce=parse_Rgce(blob,cce,opts);if(length!==cce+len)rgcb=parse_RgbExtra(blob,length-cce-len,rgce,opts);blob.l=target;return [rgce,rgcb];}/* [MS-XLS] 2.5.198.3 TODO */function parse_XLSCellParsedFormula(blob,length,opts){var target=blob.l+length,len=opts.biff==2?1:2;var rgcb,cce=blob.read_shift(len);// length of rgce
if(cce==0xFFFF)return [[],parsenoop(blob,length-2)];var rgce=parse_Rgce(blob,cce,opts);if(length!==cce+len)rgcb=parse_RgbExtra(blob,length-cce-len,rgce,opts);blob.l=target;return [rgce,rgcb];}/* [MS-XLS] 2.5.198.21 */function parse_NameParsedFormula(blob,length,opts,cce){var target=blob.l+length;var rgce=parse_Rgce(blob,cce,opts);var rgcb;if(target!==blob.l)rgcb=parse_RgbExtra(blob,target-blob.l,rgce,opts);return [rgce,rgcb];}/* [MS-XLS] 2.5.198.118 TODO */function parse_SharedParsedFormula(blob,length,opts){var target=blob.l+length;var rgcb,cce=blob.read_shift(2);// length of rgce
var rgce=parse_Rgce(blob,cce,opts);if(cce==0xFFFF)return [[],parsenoop(blob,length-2)];if(length!==cce+2)rgcb=parse_RgbExtra(blob,target-cce-2,rgce,opts);return [rgce,rgcb];}/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */function parse_FormulaValue(blob){var b;if(__readUInt16LE(blob,blob.l+6)!==0xFFFF)return [parse_Xnum(blob),'n'];switch(blob[blob.l]){case 0x00:blob.l+=8;return ["String",'s'];case 0x01:b=blob[blob.l+2]===0x1;blob.l+=8;return [b,'b'];case 0x02:b=blob[blob.l+2];blob.l+=8;return [b,'e'];case 0x03:blob.l+=8;return ["",'s'];}return [];}function write_FormulaValue(value){if(value==null){// Blank String Value
var o=new_buf(8);o.write_shift(1,0x03);o.write_shift(1,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0xFFFF);return o;}else if(typeof value=="number")return write_Xnum(value);return write_Xnum(0);}/* [MS-XLS] 2.4.127 TODO */function parse_Formula(blob,length,opts){var end=blob.l+length;var cell=parse_XLSCell(blob);if(opts.biff==2)++blob.l;var val=parse_FormulaValue(blob);var flags=blob.read_shift(1);if(opts.biff!=2){blob.read_shift(1);if(opts.biff>=5){/*var chn = */blob.read_shift(4);}}var cbf=parse_XLSCellParsedFormula(blob,end-blob.l,opts);return {cell:cell,val:val[0],formula:cbf,shared:flags>>3&1,tt:val[1]};}function write_Formula(cell,R,C,opts,os){// Cell
var o1=write_XLSCell(R,C,os);// FormulaValue
var o2=write_FormulaValue(cell.v);// flags + cache
var o3=new_buf(6);var flags=0x01|0x20;o3.write_shift(2,flags);o3.write_shift(4,0);// CellParsedFormula
var bf=new_buf(cell.bf.length);for(var i=0;i<cell.bf.length;++i)bf[i]=cell.bf[i];var out=bconcat([o1,o2,o3,bf]);return out;}/* XLSB Parsed Formula records have the same shape */function parse_XLSBParsedFormula(data,length,opts){var cce=data.read_shift(4);var rgce=parse_Rgce(data,cce,opts);var cb=data.read_shift(4);var rgcb=cb>0?parse_RgbExtra(data,cb,rgce,opts):null;return [rgce,rgcb];}/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */var parse_XLSBArrayParsedFormula=parse_XLSBParsedFormula;/* [MS-XLSB] 2.5.97.4 CellParsedFormula */var parse_XLSBCellParsedFormula=parse_XLSBParsedFormula;/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */var parse_XLSBNameParsedFormula=parse_XLSBParsedFormula;/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */var parse_XLSBSharedParsedFormula=parse_XLSBParsedFormula;/* [MS-XLS] 2.5.198.4 */var Cetab={0x0000:'BEEP',0x0001:'OPEN',0x0002:'OPEN.LINKS',0x0003:'CLOSE.ALL',0x0004:'SAVE',0x0005:'SAVE.AS',0x0006:'FILE.DELETE',0x0007:'PAGE.SETUP',0x0008:'PRINT',0x0009:'PRINTER.SETUP',0x000A:'QUIT',0x000B:'NEW.WINDOW',0x000C:'ARRANGE.ALL',0x000D:'WINDOW.SIZE',0x000E:'WINDOW.MOVE',0x000F:'FULL',0x0010:'CLOSE',0x0011:'RUN',0x0016:'SET.PRINT.AREA',0x0017:'SET.PRINT.TITLES',0x0018:'SET.PAGE.BREAK',0x0019:'REMOVE.PAGE.BREAK',0x001A:'FONT',0x001B:'DISPLAY',0x001C:'PROTECT.DOCUMENT',0x001D:'PRECISION',0x001E:'A1.R1C1',0x001F:'CALCULATE.NOW',0x0020:'CALCULATION',0x0022:'DATA.FIND',0x0023:'EXTRACT',0x0024:'DATA.DELETE',0x0025:'SET.DATABASE',0x0026:'SET.CRITERIA',0x0027:'SORT',0x0028:'DATA.SERIES',0x0029:'TABLE',0x002A:'FORMAT.NUMBER',0x002B:'ALIGNMENT',0x002C:'STYLE',0x002D:'BORDER',0x002E:'CELL.PROTECTION',0x002F:'COLUMN.WIDTH',0x0030:'UNDO',0x0031:'CUT',0x0032:'COPY',0x0033:'PASTE',0x0034:'CLEAR',0x0035:'PASTE.SPECIAL',0x0036:'EDIT.DELETE',0x0037:'INSERT',0x0038:'FILL.RIGHT',0x0039:'FILL.DOWN',0x003D:'DEFINE.NAME',0x003E:'CREATE.NAMES',0x003F:'FORMULA.GOTO',0x0040:'FORMULA.FIND',0x0041:'SELECT.LAST.CELL',0x0042:'SHOW.ACTIVE.CELL',0x0043:'GALLERY.AREA',0x0044:'GALLERY.BAR',0x0045:'GALLERY.COLUMN',0x0046:'GALLERY.LINE',0x0047:'GALLERY.PIE',0x0048:'GALLERY.SCATTER',0x0049:'COMBINATION',0x004A:'PREFERRED',0x004B:'ADD.OVERLAY',0x004C:'GRIDLINES',0x004D:'SET.PREFERRED',0x004E:'AXES',0x004F:'LEGEND',0x0050:'ATTACH.TEXT',0x0051:'ADD.ARROW',0x0052:'SELECT.CHART',0x0053:'SELECT.PLOT.AREA',0x0054:'PATTERNS',0x0055:'MAIN.CHART',0x0056:'OVERLAY',0x0057:'SCALE',0x0058:'FORMAT.LEGEND',0x0059:'FORMAT.TEXT',0x005A:'EDIT.REPEAT',0x005B:'PARSE',0x005C:'JUSTIFY',0x005D:'HIDE',0x005E:'UNHIDE',0x005F:'WORKSPACE',0x0060:'FORMULA',0x0061:'FORMULA.FILL',0x0062:'FORMULA.ARRAY',0x0063:'DATA.FIND.NEXT',0x0064:'DATA.FIND.PREV',0x0065:'FORMULA.FIND.NEXT',0x0066:'FORMULA.FIND.PREV',0x0067:'ACTIVATE',0x0068:'ACTIVATE.NEXT',0x0069:'ACTIVATE.PREV',0x006A:'UNLOCKED.NEXT',0x006B:'UNLOCKED.PREV',0x006C:'COPY.PICTURE',0x006D:'SELECT',0x006E:'DELETE.NAME',0x006F:'DELETE.FORMAT',0x0070:'VLINE',0x0071:'HLINE',0x0072:'VPAGE',0x0073:'HPAGE',0x0074:'VSCROLL',0x0075:'HSCROLL',0x0076:'ALERT',0x0077:'NEW',0x0078:'CANCEL.COPY',0x0079:'SHOW.CLIPBOARD',0x007A:'MESSAGE',0x007C:'PASTE.LINK',0x007D:'APP.ACTIVATE',0x007E:'DELETE.ARROW',0x007F:'ROW.HEIGHT',0x0080:'FORMAT.MOVE',0x0081:'FORMAT.SIZE',0x0082:'FORMULA.REPLACE',0x0083:'SEND.KEYS',0x0084:'SELECT.SPECIAL',0x0085:'APPLY.NAMES',0x0086:'REPLACE.FONT',0x0087:'FREEZE.PANES',0x0088:'SHOW.INFO',0x0089:'SPLIT',0x008A:'ON.WINDOW',0x008B:'ON.DATA',0x008C:'DISABLE.INPUT',0x008E:'OUTLINE',0x008F:'LIST.NAMES',0x0090:'FILE.CLOSE',0x0091:'SAVE.WORKBOOK',0x0092:'DATA.FORM',0x0093:'COPY.CHART',0x0094:'ON.TIME',0x0095:'WAIT',0x0096:'FORMAT.FONT',0x0097:'FILL.UP',0x0098:'FILL.LEFT',0x0099:'DELETE.OVERLAY',0x009B:'SHORT.MENUS',0x009F:'SET.UPDATE.STATUS',0x00A1:'COLOR.PALETTE',0x00A2:'DELETE.STYLE',0x00A3:'WINDOW.RESTORE',0x00A4:'WINDOW.MAXIMIZE',0x00A6:'CHANGE.LINK',0x00A7:'CALCULATE.DOCUMENT',0x00A8:'ON.KEY',0x00A9:'APP.RESTORE',0x00AA:'APP.MOVE',0x00AB:'APP.SIZE',0x00AC:'APP.MINIMIZE',0x00AD:'APP.MAXIMIZE',0x00AE:'BRING.TO.FRONT',0x00AF:'SEND.TO.BACK',0x00B9:'MAIN.CHART.TYPE',0x00BA:'OVERLAY.CHART.TYPE',0x00BB:'SELECT.END',0x00BC:'OPEN.MAIL',0x00BD:'SEND.MAIL',0x00BE:'STANDARD.FONT',0x00BF:'CONSOLIDATE',0x00C0:'SORT.SPECIAL',0x00C1:'GALLERY.3D.AREA',0x00C2:'GALLERY.3D.COLUMN',0x00C3:'GALLERY.3D.LINE',0x00C4:'GALLERY.3D.PIE',0x00C5:'VIEW.3D',0x00C6:'GOAL.SEEK',0x00C7:'WORKGROUP',0x00C8:'FILL.GROUP',0x00C9:'UPDATE.LINK',0x00CA:'PROMOTE',0x00CB:'DEMOTE',0x00CC:'SHOW.DETAIL',0x00CE:'UNGROUP',0x00CF:'OBJECT.PROPERTIES',0x00D0:'SAVE.NEW.OBJECT',0x00D1:'SHARE',0x00D2:'SHARE.NAME',0x00D3:'DUPLICATE',0x00D4:'APPLY.STYLE',0x00D5:'ASSIGN.TO.OBJECT',0x00D6:'OBJECT.PROTECTION',0x00D7:'HIDE.OBJECT',0x00D8:'SET.EXTRACT',0x00D9:'CREATE.PUBLISHER',0x00DA:'SUBSCRIBE.TO',0x00DB:'ATTRIBUTES',0x00DC:'SHOW.TOOLBAR',0x00DE:'PRINT.PREVIEW',0x00DF:'EDIT.COLOR',0x00E0:'SHOW.LEVELS',0x00E1:'FORMAT.MAIN',0x00E2:'FORMAT.OVERLAY',0x00E3:'ON.RECALC',0x00E4:'EDIT.SERIES',0x00E5:'DEFINE.STYLE',0x00F0:'LINE.PRINT',0x00F3:'ENTER.DATA',0x00F9:'GALLERY.RADAR',0x00FA:'MERGE.STYLES',0x00FB:'EDITION.OPTIONS',0x00FC:'PASTE.PICTURE',0x00FD:'PASTE.PICTURE.LINK',0x00FE:'SPELLING',0x0100:'ZOOM',0x0103:'INSERT.OBJECT',0x0104:'WINDOW.MINIMIZE',0x0109:'SOUND.NOTE',0x010A:'SOUND.PLAY',0x010B:'FORMAT.SHAPE',0x010C:'EXTEND.POLYGON',0x010D:'FORMAT.AUTO',0x0110:'GALLERY.3D.BAR',0x0111:'GALLERY.3D.SURFACE',0x0112:'FILL.AUTO',0x0114:'CUSTOMIZE.TOOLBAR',0x0115:'ADD.TOOL',0x0116:'EDIT.OBJECT',0x0117:'ON.DOUBLECLICK',0x0118:'ON.ENTRY',0x0119:'WORKBOOK.ADD',0x011A:'WORKBOOK.MOVE',0x011B:'WORKBOOK.COPY',0x011C:'WORKBOOK.OPTIONS',0x011D:'SAVE.WORKSPACE',0x0120:'CHART.WIZARD',0x0121:'DELETE.TOOL',0x0122:'MOVE.TOOL',0x0123:'WORKBOOK.SELECT',0x0124:'WORKBOOK.ACTIVATE',0x0125:'ASSIGN.TO.TOOL',0x0127:'COPY.TOOL',0x0128:'RESET.TOOL',0x0129:'CONSTRAIN.NUMERIC',0x012A:'PASTE.TOOL',0x012E:'WORKBOOK.NEW',0x0131:'SCENARIO.CELLS',0x0132:'SCENARIO.DELETE',0x0133:'SCENARIO.ADD',0x0134:'SCENARIO.EDIT',0x0135:'SCENARIO.SHOW',0x0136:'SCENARIO.SHOW.NEXT',0x0137:'SCENARIO.SUMMARY',0x0138:'PIVOT.TABLE.WIZARD',0x0139:'PIVOT.FIELD.PROPERTIES',0x013A:'PIVOT.FIELD',0x013B:'PIVOT.ITEM',0x013C:'PIVOT.ADD.FIELDS',0x013E:'OPTIONS.CALCULATION',0x013F:'OPTIONS.EDIT',0x0140:'OPTIONS.VIEW',0x0141:'ADDIN.MANAGER',0x0142:'MENU.EDITOR',0x0143:'ATTACH.TOOLBARS',0x0144:'VBAActivate',0x0145:'OPTIONS.CHART',0x0148:'VBA.INSERT.FILE',0x014A:'VBA.PROCEDURE.DEFINITION',0x0150:'ROUTING.SLIP',0x0152:'ROUTE.DOCUMENT',0x0153:'MAIL.LOGON',0x0156:'INSERT.PICTURE',0x0157:'EDIT.TOOL',0x0158:'GALLERY.DOUGHNUT',0x015E:'CHART.TREND',0x0160:'PIVOT.ITEM.PROPERTIES',0x0162:'WORKBOOK.INSERT',0x0163:'OPTIONS.TRANSITION',0x0164:'OPTIONS.GENERAL',0x0172:'FILTER.ADVANCED',0x0175:'MAIL.ADD.MAILER',0x0176:'MAIL.DELETE.MAILER',0x0177:'MAIL.REPLY',0x0178:'MAIL.REPLY.ALL',0x0179:'MAIL.FORWARD',0x017A:'MAIL.NEXT.LETTER',0x017B:'DATA.LABEL',0x017C:'INSERT.TITLE',0x017D:'FONT.PROPERTIES',0x017E:'MACRO.OPTIONS',0x017F:'WORKBOOK.HIDE',0x0180:'WORKBOOK.UNHIDE',0x0181:'WORKBOOK.DELETE',0x0182:'WORKBOOK.NAME',0x0184:'GALLERY.CUSTOM',0x0186:'ADD.CHART.AUTOFORMAT',0x0187:'DELETE.CHART.AUTOFORMAT',0x0188:'CHART.ADD.DATA',0x0189:'AUTO.OUTLINE',0x018A:'TAB.ORDER',0x018B:'SHOW.DIALOG',0x018C:'SELECT.ALL',0x018D:'UNGROUP.SHEETS',0x018E:'SUBTOTAL.CREATE',0x018F:'SUBTOTAL.REMOVE',0x0190:'RENAME.OBJECT',0x019C:'WORKBOOK.SCROLL',0x019D:'WORKBOOK.NEXT',0x019E:'WORKBOOK.PREV',0x019F:'WORKBOOK.TAB.SPLIT',0x01A0:'FULL.SCREEN',0x01A1:'WORKBOOK.PROTECT',0x01A4:'SCROLLBAR.PROPERTIES',0x01A5:'PIVOT.SHOW.PAGES',0x01A6:'TEXT.TO.COLUMNS',0x01A7:'FORMAT.CHARTTYPE',0x01A8:'LINK.FORMAT',0x01A9:'TRACER.DISPLAY',0x01AE:'TRACER.NAVIGATE',0x01AF:'TRACER.CLEAR',0x01B0:'TRACER.ERROR',0x01B1:'PIVOT.FIELD.GROUP',0x01B2:'PIVOT.FIELD.UNGROUP',0x01B3:'CHECKBOX.PROPERTIES',0x01B4:'LABEL.PROPERTIES',0x01B5:'LISTBOX.PROPERTIES',0x01B6:'EDITBOX.PROPERTIES',0x01B7:'PIVOT.REFRESH',0x01B8:'LINK.COMBO',0x01B9:'OPEN.TEXT',0x01BA:'HIDE.DIALOG',0x01BB:'SET.DIALOG.FOCUS',0x01BC:'ENABLE.OBJECT',0x01BD:'PUSHBUTTON.PROPERTIES',0x01BE:'SET.DIALOG.DEFAULT',0x01BF:'FILTER',0x01C0:'FILTER.SHOW.ALL',0x01C1:'CLEAR.OUTLINE',0x01C2:'FUNCTION.WIZARD',0x01C3:'ADD.LIST.ITEM',0x01C4:'SET.LIST.ITEM',0x01C5:'REMOVE.LIST.ITEM',0x01C6:'SELECT.LIST.ITEM',0x01C7:'SET.CONTROL.VALUE',0x01C8:'SAVE.COPY.AS',0x01CA:'OPTIONS.LISTS.ADD',0x01CB:'OPTIONS.LISTS.DELETE',0x01CC:'SERIES.AXES',0x01CD:'SERIES.X',0x01CE:'SERIES.Y',0x01CF:'ERRORBAR.X',0x01D0:'ERRORBAR.Y',0x01D1:'FORMAT.CHART',0x01D2:'SERIES.ORDER',0x01D3:'MAIL.LOGOFF',0x01D4:'CLEAR.ROUTING.SLIP',0x01D5:'APP.ACTIVATE.MICROSOFT',0x01D6:'MAIL.EDIT.MAILER',0x01D7:'ON.SHEET',0x01D8:'STANDARD.WIDTH',0x01D9:'SCENARIO.MERGE',0x01DA:'SUMMARY.INFO',0x01DB:'FIND.FILE',0x01DC:'ACTIVE.CELL.FONT',0x01DD:'ENABLE.TIPWIZARD',0x01DE:'VBA.MAKE.ADDIN',0x01E0:'INSERTDATATABLE',0x01E1:'WORKGROUP.OPTIONS',0x01E2:'MAIL.SEND.MAILER',0x01E5:'AUTOCORRECT',0x01E9:'POST.DOCUMENT',0x01EB:'PICKLIST',0x01ED:'VIEW.SHOW',0x01EE:'VIEW.DEFINE',0x01EF:'VIEW.DELETE',0x01FD:'SHEET.BACKGROUND',0x01FE:'INSERT.MAP.OBJECT',0x01FF:'OPTIONS.MENONO',0x0205:'MSOCHECKS',0x0206:'NORMAL',0x0207:'LAYOUT',0x0208:'RM.PRINT.AREA',0x0209:'CLEAR.PRINT.AREA',0x020A:'ADD.PRINT.AREA',0x020B:'MOVE.BRK',0x0221:'HIDECURR.NOTE',0x0222:'HIDEALL.NOTES',0x0223:'DELETE.NOTE',0x0224:'TRAVERSE.NOTES',0x0225:'ACTIVATE.NOTES',0x026C:'PROTECT.REVISIONS',0x026D:'UNPROTECT.REVISIONS',0x0287:'OPTIONS.ME',0x028D:'WEB.PUBLISH',0x029B:'NEWWEBQUERY',0x02A1:'PIVOT.TABLE.CHART',0x02F1:'OPTIONS.SAVE',0x02F3:'OPTIONS.SPELL',0x0328:'HIDEALL.INKANNOTS'};/* [MS-XLS] 2.5.198.17 */ /* [MS-XLSB] 2.5.97.10 */var Ftab={0x0000:'COUNT',0x0001:'IF',0x0002:'ISNA',0x0003:'ISERROR',0x0004:'SUM',0x0005:'AVERAGE',0x0006:'MIN',0x0007:'MAX',0x0008:'ROW',0x0009:'COLUMN',0x000A:'NA',0x000B:'NPV',0x000C:'STDEV',0x000D:'DOLLAR',0x000E:'FIXED',0x000F:'SIN',0x0010:'COS',0x0011:'TAN',0x0012:'ATAN',0x0013:'PI',0x0014:'SQRT',0x0015:'EXP',0x0016:'LN',0x0017:'LOG10',0x0018:'ABS',0x0019:'INT',0x001A:'SIGN',0x001B:'ROUND',0x001C:'LOOKUP',0x001D:'INDEX',0x001E:'REPT',0x001F:'MID',0x0020:'LEN',0x0021:'VALUE',0x0022:'TRUE',0x0023:'FALSE',0x0024:'AND',0x0025:'OR',0x0026:'NOT',0x0027:'MOD',0x0028:'DCOUNT',0x0029:'DSUM',0x002A:'DAVERAGE',0x002B:'DMIN',0x002C:'DMAX',0x002D:'DSTDEV',0x002E:'VAR',0x002F:'DVAR',0x0030:'TEXT',0x0031:'LINEST',0x0032:'TREND',0x0033:'LOGEST',0x0034:'GROWTH',0x0035:'GOTO',0x0036:'HALT',0x0037:'RETURN',0x0038:'PV',0x0039:'FV',0x003A:'NPER',0x003B:'PMT',0x003C:'RATE',0x003D:'MIRR',0x003E:'IRR',0x003F:'RAND',0x0040:'MATCH',0x0041:'DATE',0x0042:'TIME',0x0043:'DAY',0x0044:'MONTH',0x0045:'YEAR',0x0046:'WEEKDAY',0x0047:'HOUR',0x0048:'MINUTE',0x0049:'SECOND',0x004A:'NOW',0x004B:'AREAS',0x004C:'ROWS',0x004D:'COLUMNS',0x004E:'OFFSET',0x004F:'ABSREF',0x0050:'RELREF',0x0051:'ARGUMENT',0x0052:'SEARCH',0x0053:'TRANSPOSE',0x0054:'ERROR',0x0055:'STEP',0x0056:'TYPE',0x0057:'ECHO',0x0058:'SET.NAME',0x0059:'CALLER',0x005A:'DEREF',0x005B:'WINDOWS',0x005C:'SERIES',0x005D:'DOCUMENTS',0x005E:'ACTIVE.CELL',0x005F:'SELECTION',0x0060:'RESULT',0x0061:'ATAN2',0x0062:'ASIN',0x0063:'ACOS',0x0064:'CHOOSE',0x0065:'HLOOKUP',0x0066:'VLOOKUP',0x0067:'LINKS',0x0068:'INPUT',0x0069:'ISREF',0x006A:'GET.FORMULA',0x006B:'GET.NAME',0x006C:'SET.VALUE',0x006D:'LOG',0x006E:'EXEC',0x006F:'CHAR',0x0070:'LOWER',0x0071:'UPPER',0x0072:'PROPER',0x0073:'LEFT',0x0074:'RIGHT',0x0075:'EXACT',0x0076:'TRIM',0x0077:'REPLACE',0x0078:'SUBSTITUTE',0x0079:'CODE',0x007A:'NAMES',0x007B:'DIRECTORY',0x007C:'FIND',0x007D:'CELL',0x007E:'ISERR',0x007F:'ISTEXT',0x0080:'ISNUMBER',0x0081:'ISBLANK',0x0082:'T',0x0083:'N',0x0084:'FOPEN',0x0085:'FCLOSE',0x0086:'FSIZE',0x0087:'FREADLN',0x0088:'FREAD',0x0089:'FWRITELN',0x008A:'FWRITE',0x008B:'FPOS',0x008C:'DATEVALUE',0x008D:'TIMEVALUE',0x008E:'SLN',0x008F:'SYD',0x0090:'DDB',0x0091:'GET.DEF',0x0092:'REFTEXT',0x0093:'TEXTREF',0x0094:'INDIRECT',0x0095:'REGISTER',0x0096:'CALL',0x0097:'ADD.BAR',0x0098:'ADD.MENU',0x0099:'ADD.COMMAND',0x009A:'ENABLE.COMMAND',0x009B:'CHECK.COMMAND',0x009C:'RENAME.COMMAND',0x009D:'SHOW.BAR',0x009E:'DELETE.MENU',0x009F:'DELETE.COMMAND',0x00A0:'GET.CHART.ITEM',0x00A1:'DIALOG.BOX',0x00A2:'CLEAN',0x00A3:'MDETERM',0x00A4:'MINVERSE',0x00A5:'MMULT',0x00A6:'FILES',0x00A7:'IPMT',0x00A8:'PPMT',0x00A9:'COUNTA',0x00AA:'CANCEL.KEY',0x00AB:'FOR',0x00AC:'WHILE',0x00AD:'BREAK',0x00AE:'NEXT',0x00AF:'INITIATE',0x00B0:'REQUEST',0x00B1:'POKE',0x00B2:'EXECUTE',0x00B3:'TERMINATE',0x00B4:'RESTART',0x00B5:'HELP',0x00B6:'GET.BAR',0x00B7:'PRODUCT',0x00B8:'FACT',0x00B9:'GET.CELL',0x00BA:'GET.WORKSPACE',0x00BB:'GET.WINDOW',0x00BC:'GET.DOCUMENT',0x00BD:'DPRODUCT',0x00BE:'ISNONTEXT',0x00BF:'GET.NOTE',0x00C0:'NOTE',0x00C1:'STDEVP',0x00C2:'VARP',0x00C3:'DSTDEVP',0x00C4:'DVARP',0x00C5:'TRUNC',0x00C6:'ISLOGICAL',0x00C7:'DCOUNTA',0x00C8:'DELETE.BAR',0x00C9:'UNREGISTER',0x00CC:'USDOLLAR',0x00CD:'FINDB',0x00CE:'SEARCHB',0x00CF:'REPLACEB',0x00D0:'LEFTB',0x00D1:'RIGHTB',0x00D2:'MIDB',0x00D3:'LENB',0x00D4:'ROUNDUP',0x00D5:'ROUNDDOWN',0x00D6:'ASC',0x00D7:'DBCS',0x00D8:'RANK',0x00DB:'ADDRESS',0x00DC:'DAYS360',0x00DD:'TODAY',0x00DE:'VDB',0x00DF:'ELSE',0x00E0:'ELSE.IF',0x00E1:'END.IF',0x00E2:'FOR.CELL',0x00E3:'MEDIAN',0x00E4:'SUMPRODUCT',0x00E5:'SINH',0x00E6:'COSH',0x00E7:'TANH',0x00E8:'ASINH',0x00E9:'ACOSH',0x00EA:'ATANH',0x00EB:'DGET',0x00EC:'CREATE.OBJECT',0x00ED:'VOLATILE',0x00EE:'LAST.ERROR',0x00EF:'CUSTOM.UNDO',0x00F0:'CUSTOM.REPEAT',0x00F1:'FORMULA.CONVERT',0x00F2:'GET.LINK.INFO',0x00F3:'TEXT.BOX',0x00F4:'INFO',0x00F5:'GROUP',0x00F6:'GET.OBJECT',0x00F7:'DB',0x00F8:'PAUSE',0x00FB:'RESUME',0x00FC:'FREQUENCY',0x00FD:'ADD.TOOLBAR',0x00FE:'DELETE.TOOLBAR',0x00FF:'User',0x0100:'RESET.TOOLBAR',0x0101:'EVALUATE',0x0102:'GET.TOOLBAR',0x0103:'GET.TOOL',0x0104:'SPELLING.CHECK',0x0105:'ERROR.TYPE',0x0106:'APP.TITLE',0x0107:'WINDOW.TITLE',0x0108:'SAVE.TOOLBAR',0x0109:'ENABLE.TOOL',0x010A:'PRESS.TOOL',0x010B:'REGISTER.ID',0x010C:'GET.WORKBOOK',0x010D:'AVEDEV',0x010E:'BETADIST',0x010F:'GAMMALN',0x0110:'BETAINV',0x0111:'BINOMDIST',0x0112:'CHIDIST',0x0113:'CHIINV',0x0114:'COMBIN',0x0115:'CONFIDENCE',0x0116:'CRITBINOM',0x0117:'EVEN',0x0118:'EXPONDIST',0x0119:'FDIST',0x011A:'FINV',0x011B:'FISHER',0x011C:'FISHERINV',0x011D:'FLOOR',0x011E:'GAMMADIST',0x011F:'GAMMAINV',0x0120:'CEILING',0x0121:'HYPGEOMDIST',0x0122:'LOGNORMDIST',0x0123:'LOGINV',0x0124:'NEGBINOMDIST',0x0125:'NORMDIST',0x0126:'NORMSDIST',0x0127:'NORMINV',0x0128:'NORMSINV',0x0129:'STANDARDIZE',0x012A:'ODD',0x012B:'PERMUT',0x012C:'POISSON',0x012D:'TDIST',0x012E:'WEIBULL',0x012F:'SUMXMY2',0x0130:'SUMX2MY2',0x0131:'SUMX2PY2',0x0132:'CHITEST',0x0133:'CORREL',0x0134:'COVAR',0x0135:'FORECAST',0x0136:'FTEST',0x0137:'INTERCEPT',0x0138:'PEARSON',0x0139:'RSQ',0x013A:'STEYX',0x013B:'SLOPE',0x013C:'TTEST',0x013D:'PROB',0x013E:'DEVSQ',0x013F:'GEOMEAN',0x0140:'HARMEAN',0x0141:'SUMSQ',0x0142:'KURT',0x0143:'SKEW',0x0144:'ZTEST',0x0145:'LARGE',0x0146:'SMALL',0x0147:'QUARTILE',0x0148:'PERCENTILE',0x0149:'PERCENTRANK',0x014A:'MODE',0x014B:'TRIMMEAN',0x014C:'TINV',0x014E:'MOVIE.COMMAND',0x014F:'GET.MOVIE',0x0150:'CONCATENATE',0x0151:'POWER',0x0152:'PIVOT.ADD.DATA',0x0153:'GET.PIVOT.TABLE',0x0154:'GET.PIVOT.FIELD',0x0155:'GET.PIVOT.ITEM',0x0156:'RADIANS',0x0157:'DEGREES',0x0158:'SUBTOTAL',0x0159:'SUMIF',0x015A:'COUNTIF',0x015B:'COUNTBLANK',0x015C:'SCENARIO.GET',0x015D:'OPTIONS.LISTS.GET',0x015E:'ISPMT',0x015F:'DATEDIF',0x0160:'DATESTRING',0x0161:'NUMBERSTRING',0x0162:'ROMAN',0x0163:'OPEN.DIALOG',0x0164:'SAVE.DIALOG',0x0165:'VIEW.GET',0x0166:'GETPIVOTDATA',0x0167:'HYPERLINK',0x0168:'PHONETIC',0x0169:'AVERAGEA',0x016A:'MAXA',0x016B:'MINA',0x016C:'STDEVPA',0x016D:'VARPA',0x016E:'STDEVA',0x016F:'VARA',0x0170:'BAHTTEXT',0x0171:'THAIDAYOFWEEK',0x0172:'THAIDIGIT',0x0173:'THAIMONTHOFYEAR',0x0174:'THAINUMSOUND',0x0175:'THAINUMSTRING',0x0176:'THAISTRINGLENGTH',0x0177:'ISTHAIDIGIT',0x0178:'ROUNDBAHTDOWN',0x0179:'ROUNDBAHTUP',0x017A:'THAIYEAR',0x017B:'RTD',0x017C:'CUBEVALUE',0x017D:'CUBEMEMBER',0x017E:'CUBEMEMBERPROPERTY',0x017F:'CUBERANKEDMEMBER',0x0180:'HEX2BIN',0x0181:'HEX2DEC',0x0182:'HEX2OCT',0x0183:'DEC2BIN',0x0184:'DEC2HEX',0x0185:'DEC2OCT',0x0186:'OCT2BIN',0x0187:'OCT2HEX',0x0188:'OCT2DEC',0x0189:'BIN2DEC',0x018A:'BIN2OCT',0x018B:'BIN2HEX',0x018C:'IMSUB',0x018D:'IMDIV',0x018E:'IMPOWER',0x018F:'IMABS',0x0190:'IMSQRT',0x0191:'IMLN',0x0192:'IMLOG2',0x0193:'IMLOG10',0x0194:'IMSIN',0x0195:'IMCOS',0x0196:'IMEXP',0x0197:'IMARGUMENT',0x0198:'IMCONJUGATE',0x0199:'IMAGINARY',0x019A:'IMREAL',0x019B:'COMPLEX',0x019C:'IMSUM',0x019D:'IMPRODUCT',0x019E:'SERIESSUM',0x019F:'FACTDOUBLE',0x01A0:'SQRTPI',0x01A1:'QUOTIENT',0x01A2:'DELTA',0x01A3:'GESTEP',0x01A4:'ISEVEN',0x01A5:'ISODD',0x01A6:'MROUND',0x01A7:'ERF',0x01A8:'ERFC',0x01A9:'BESSELJ',0x01AA:'BESSELK',0x01AB:'BESSELY',0x01AC:'BESSELI',0x01AD:'XIRR',0x01AE:'XNPV',0x01AF:'PRICEMAT',0x01B0:'YIELDMAT',0x01B1:'INTRATE',0x01B2:'RECEIVED',0x01B3:'DISC',0x01B4:'PRICEDISC',0x01B5:'YIELDDISC',0x01B6:'TBILLEQ',0x01B7:'TBILLPRICE',0x01B8:'TBILLYIELD',0x01B9:'PRICE',0x01BA:'YIELD',0x01BB:'DOLLARDE',0x01BC:'DOLLARFR',0x01BD:'NOMINAL',0x01BE:'EFFECT',0x01BF:'CUMPRINC',0x01C0:'CUMIPMT',0x01C1:'EDATE',0x01C2:'EOMONTH',0x01C3:'YEARFRAC',0x01C4:'COUPDAYBS',0x01C5:'COUPDAYS',0x01C6:'COUPDAYSNC',0x01C7:'COUPNCD',0x01C8:'COUPNUM',0x01C9:'COUPPCD',0x01CA:'DURATION',0x01CB:'MDURATION',0x01CC:'ODDLPRICE',0x01CD:'ODDLYIELD',0x01CE:'ODDFPRICE',0x01CF:'ODDFYIELD',0x01D0:'RANDBETWEEN',0x01D1:'WEEKNUM',0x01D2:'AMORDEGRC',0x01D3:'AMORLINC',0x01D4:'CONVERT',0x02D4:'SHEETJS',0x01D5:'ACCRINT',0x01D6:'ACCRINTM',0x01D7:'WORKDAY',0x01D8:'NETWORKDAYS',0x01D9:'GCD',0x01DA:'MULTINOMIAL',0x01DB:'LCM',0x01DC:'FVSCHEDULE',0x01DD:'CUBEKPIMEMBER',0x01DE:'CUBESET',0x01DF:'CUBESETCOUNT',0x01E0:'IFERROR',0x01E1:'COUNTIFS',0x01E2:'SUMIFS',0x01E3:'AVERAGEIF',0x01E4:'AVERAGEIFS'};var FtabArgc={0x0002:1,/* ISNA */0x0003:1,/* ISERROR */0x000A:0,/* NA */0x000F:1,/* SIN */0x0010:1,/* COS */0x0011:1,/* TAN */0x0012:1,/* ATAN */0x0013:0,/* PI */0x0014:1,/* SQRT */0x0015:1,/* EXP */0x0016:1,/* LN */0x0017:1,/* LOG10 */0x0018:1,/* ABS */0x0019:1,/* INT */0x001A:1,/* SIGN */0x001B:2,/* ROUND */0x001E:2,/* REPT */0x001F:3,/* MID */0x0020:1,/* LEN */0x0021:1,/* VALUE */0x0022:0,/* TRUE */0x0023:0,/* FALSE */0x0026:1,/* NOT */0x0027:2,/* MOD */0x0028:3,/* DCOUNT */0x0029:3,/* DSUM */0x002A:3,/* DAVERAGE */0x002B:3,/* DMIN */0x002C:3,/* DMAX */0x002D:3,/* DSTDEV */0x002F:3,/* DVAR */0x0030:2,/* TEXT */0x0035:1,/* GOTO */0x003D:3,/* MIRR */0x003F:0,/* RAND */0x0041:3,/* DATE */0x0042:3,/* TIME */0x0043:1,/* DAY */0x0044:1,/* MONTH */0x0045:1,/* YEAR */0x0046:1,/* WEEKDAY */0x0047:1,/* HOUR */0x0048:1,/* MINUTE */0x0049:1,/* SECOND */0x004A:0,/* NOW */0x004B:1,/* AREAS */0x004C:1,/* ROWS */0x004D:1,/* COLUMNS */0x004F:2,/* ABSREF */0x0050:2,/* RELREF */0x0053:1,/* TRANSPOSE */0x0055:0,/* STEP */0x0056:1,/* TYPE */0x0059:0,/* CALLER */0x005A:1,/* DEREF */0x005E:0,/* ACTIVE.CELL */0x005F:0,/* SELECTION */0x0061:2,/* ATAN2 */0x0062:1,/* ASIN */0x0063:1,/* ACOS */0x0065:3,/* HLOOKUP */0x0066:3,/* VLOOKUP */0x0069:1,/* ISREF */0x006A:1,/* GET.FORMULA */0x006C:2,/* SET.VALUE */0x006F:1,/* CHAR */0x0070:1,/* LOWER */0x0071:1,/* UPPER */0x0072:1,/* PROPER */0x0075:2,/* EXACT */0x0076:1,/* TRIM */0x0077:4,/* REPLACE */0x0079:1,/* CODE */0x007E:1,/* ISERR */0x007F:1,/* ISTEXT */0x0080:1,/* ISNUMBER */0x0081:1,/* ISBLANK */0x0082:1,/* T */0x0083:1,/* N */0x0085:1,/* FCLOSE */0x0086:1,/* FSIZE */0x0087:1,/* FREADLN */0x0088:2,/* FREAD */0x0089:2,/* FWRITELN */0x008A:2,/* FWRITE */0x008C:1,/* DATEVALUE */0x008D:1,/* TIMEVALUE */0x008E:3,/* SLN */0x008F:4,/* SYD */0x0090:4,/* DDB */0x00A1:1,/* DIALOG.BOX */0x00A2:1,/* CLEAN */0x00A3:1,/* MDETERM */0x00A4:1,/* MINVERSE */0x00A5:2,/* MMULT */0x00AC:1,/* WHILE */0x00AF:2,/* INITIATE */0x00B0:2,/* REQUEST */0x00B1:3,/* POKE */0x00B2:2,/* EXECUTE */0x00B3:1,/* TERMINATE */0x00B8:1,/* FACT */0x00BA:1,/* GET.WORKSPACE */0x00BD:3,/* DPRODUCT */0x00BE:1,/* ISNONTEXT */0x00C3:3,/* DSTDEVP */0x00C4:3,/* DVARP */0x00C5:1,/* TRUNC */0x00C6:1,/* ISLOGICAL */0x00C7:3,/* DCOUNTA */0x00C9:1,/* UNREGISTER */0x00CF:4,/* REPLACEB */0x00D2:3,/* MIDB */0x00D3:1,/* LENB */0x00D4:2,/* ROUNDUP */0x00D5:2,/* ROUNDDOWN */0x00D6:1,/* ASC */0x00D7:1,/* DBCS */0x00E1:0,/* END.IF */0x00E5:1,/* SINH */0x00E6:1,/* COSH */0x00E7:1,/* TANH */0x00E8:1,/* ASINH */0x00E9:1,/* ACOSH */0x00EA:1,/* ATANH */0x00EB:3,/* DGET */0x00F4:1,/* INFO */0x00F7:4,/* DB */0x00FC:2,/* FREQUENCY */0x0101:1,/* EVALUATE */0x0105:1,/* ERROR.TYPE */0x010F:1,/* GAMMALN */0x0111:4,/* BINOMDIST */0x0112:2,/* CHIDIST */0x0113:2,/* CHIINV */0x0114:2,/* COMBIN */0x0115:3,/* CONFIDENCE */0x0116:3,/* CRITBINOM */0x0117:1,/* EVEN */0x0118:3,/* EXPONDIST */0x0119:3,/* FDIST */0x011A:3,/* FINV */0x011B:1,/* FISHER */0x011C:1,/* FISHERINV */0x011D:2,/* FLOOR */0x011E:4,/* GAMMADIST */0x011F:3,/* GAMMAINV */0x0120:2,/* CEILING */0x0121:4,/* HYPGEOMDIST */0x0122:3,/* LOGNORMDIST */0x0123:3,/* LOGINV */0x0124:3,/* NEGBINOMDIST */0x0125:4,/* NORMDIST */0x0126:1,/* NORMSDIST */0x0127:3,/* NORMINV */0x0128:1,/* NORMSINV */0x0129:3,/* STANDARDIZE */0x012A:1,/* ODD */0x012B:2,/* PERMUT */0x012C:3,/* POISSON */0x012D:3,/* TDIST */0x012E:4,/* WEIBULL */0x012F:2,/* SUMXMY2 */0x0130:2,/* SUMX2MY2 */0x0131:2,/* SUMX2PY2 */0x0132:2,/* CHITEST */0x0133:2,/* CORREL */0x0134:2,/* COVAR */0x0135:3,/* FORECAST */0x0136:2,/* FTEST */0x0137:2,/* INTERCEPT */0x0138:2,/* PEARSON */0x0139:2,/* RSQ */0x013A:2,/* STEYX */0x013B:2,/* SLOPE */0x013C:4,/* TTEST */0x0145:2,/* LARGE */0x0146:2,/* SMALL */0x0147:2,/* QUARTILE */0x0148:2,/* PERCENTILE */0x014B:2,/* TRIMMEAN */0x014C:2,/* TINV */0x0151:2,/* POWER */0x0156:1,/* RADIANS */0x0157:1,/* DEGREES */0x015A:2,/* COUNTIF */0x015B:1,/* COUNTBLANK */0x015E:4,/* ISPMT */0x015F:3,/* DATEDIF */0x0160:1,/* DATESTRING */0x0161:2,/* NUMBERSTRING */0x0168:1,/* PHONETIC */0x0170:1,/* BAHTTEXT */0x0171:1,/* THAIDAYOFWEEK */0x0172:1,/* THAIDIGIT */0x0173:1,/* THAIMONTHOFYEAR */0x0174:1,/* THAINUMSOUND */0x0175:1,/* THAINUMSTRING */0x0176:1,/* THAISTRINGLENGTH */0x0177:1,/* ISTHAIDIGIT */0x0178:1,/* ROUNDBAHTDOWN */0x0179:1,/* ROUNDBAHTUP */0x017A:1,/* THAIYEAR */0x017E:3,/* CUBEMEMBERPROPERTY */0x0181:1,/* HEX2DEC */0x0188:1,/* OCT2DEC */0x0189:1,/* BIN2DEC */0x018C:2,/* IMSUB */0x018D:2,/* IMDIV */0x018E:2,/* IMPOWER */0x018F:1,/* IMABS */0x0190:1,/* IMSQRT */0x0191:1,/* IMLN */0x0192:1,/* IMLOG2 */0x0193:1,/* IMLOG10 */0x0194:1,/* IMSIN */0x0195:1,/* IMCOS */0x0196:1,/* IMEXP */0x0197:1,/* IMARGUMENT */0x0198:1,/* IMCONJUGATE */0x0199:1,/* IMAGINARY */0x019A:1,/* IMREAL */0x019E:4,/* SERIESSUM */0x019F:1,/* FACTDOUBLE */0x01A0:1,/* SQRTPI */0x01A1:2,/* QUOTIENT */0x01A4:1,/* ISEVEN */0x01A5:1,/* ISODD */0x01A6:2,/* MROUND */0x01A8:1,/* ERFC */0x01A9:2,/* BESSELJ */0x01AA:2,/* BESSELK */0x01AB:2,/* BESSELY */0x01AC:2,/* BESSELI */0x01AE:3,/* XNPV */0x01B6:3,/* TBILLEQ */0x01B7:3,/* TBILLPRICE */0x01B8:3,/* TBILLYIELD */0x01BB:2,/* DOLLARDE */0x01BC:2,/* DOLLARFR */0x01BD:2,/* NOMINAL */0x01BE:2,/* EFFECT */0x01BF:6,/* CUMPRINC */0x01C0:6,/* CUMIPMT */0x01C1:2,/* EDATE */0x01C2:2,/* EOMONTH */0x01D0:2,/* RANDBETWEEN */0x01D4:3,/* CONVERT */0x01DC:2,/* FVSCHEDULE */0x01DF:1,/* CUBESETCOUNT */0x01E0:2,/* IFERROR */0xFFFF:0};/* [MS-XLSX] 2.2.3 Functions */ /* [MS-XLSB] 2.5.97.10 Ftab */var XLSXFutureFunctions={"_xlfn.ACOT":"ACOT","_xlfn.ACOTH":"ACOTH","_xlfn.AGGREGATE":"AGGREGATE","_xlfn.ARABIC":"ARABIC","_xlfn.AVERAGEIF":"AVERAGEIF","_xlfn.AVERAGEIFS":"AVERAGEIFS","_xlfn.BASE":"BASE","_xlfn.BETA.DIST":"BETA.DIST","_xlfn.BETA.INV":"BETA.INV","_xlfn.BINOM.DIST":"BINOM.DIST","_xlfn.BINOM.DIST.RANGE":"BINOM.DIST.RANGE","_xlfn.BINOM.INV":"BINOM.INV","_xlfn.BITAND":"BITAND","_xlfn.BITLSHIFT":"BITLSHIFT","_xlfn.BITOR":"BITOR","_xlfn.BITRSHIFT":"BITRSHIFT","_xlfn.BITXOR":"BITXOR","_xlfn.CEILING.MATH":"CEILING.MATH","_xlfn.CEILING.PRECISE":"CEILING.PRECISE","_xlfn.CHISQ.DIST":"CHISQ.DIST","_xlfn.CHISQ.DIST.RT":"CHISQ.DIST.RT","_xlfn.CHISQ.INV":"CHISQ.INV","_xlfn.CHISQ.INV.RT":"CHISQ.INV.RT","_xlfn.CHISQ.TEST":"CHISQ.TEST","_xlfn.COMBINA":"COMBINA","_xlfn.CONCAT":"CONCAT","_xlfn.CONFIDENCE.NORM":"CONFIDENCE.NORM","_xlfn.CONFIDENCE.T":"CONFIDENCE.T","_xlfn.COT":"COT","_xlfn.COTH":"COTH","_xlfn.COUNTIFS":"COUNTIFS","_xlfn.COVARIANCE.P":"COVARIANCE.P","_xlfn.COVARIANCE.S":"COVARIANCE.S","_xlfn.CSC":"CSC","_xlfn.CSCH":"CSCH","_xlfn.DAYS":"DAYS","_xlfn.DECIMAL":"DECIMAL","_xlfn.ECMA.CEILING":"ECMA.CEILING","_xlfn.ERF.PRECISE":"ERF.PRECISE","_xlfn.ERFC.PRECISE":"ERFC.PRECISE","_xlfn.EXPON.DIST":"EXPON.DIST","_xlfn.F.DIST":"F.DIST","_xlfn.F.DIST.RT":"F.DIST.RT","_xlfn.F.INV":"F.INV","_xlfn.F.INV.RT":"F.INV.RT","_xlfn.F.TEST":"F.TEST","_xlfn.FILTERXML":"FILTERXML","_xlfn.FLOOR.MATH":"FLOOR.MATH","_xlfn.FLOOR.PRECISE":"FLOOR.PRECISE","_xlfn.FORECAST.ETS":"FORECAST.ETS","_xlfn.FORECAST.ETS.CONFINT":"FORECAST.ETS.CONFINT","_xlfn.FORECAST.ETS.SEASONALITY":"FORECAST.ETS.SEASONALITY","_xlfn.FORECAST.ETS.STAT":"FORECAST.ETS.STAT","_xlfn.FORECAST.LINEAR":"FORECAST.LINEAR","_xlfn.FORMULATEXT":"FORMULATEXT","_xlfn.GAMMA":"GAMMA","_xlfn.GAMMA.DIST":"GAMMA.DIST","_xlfn.GAMMA.INV":"GAMMA.INV","_xlfn.GAMMALN.PRECISE":"GAMMALN.PRECISE","_xlfn.GAUSS":"GAUSS","_xlfn.HYPGEOM.DIST":"HYPGEOM.DIST","_xlfn.IFERROR":"IFERROR","_xlfn.IFNA":"IFNA","_xlfn.IFS":"IFS","_xlfn.IMCOSH":"IMCOSH","_xlfn.IMCOT":"IMCOT","_xlfn.IMCSC":"IMCSC","_xlfn.IMCSCH":"IMCSCH","_xlfn.IMSEC":"IMSEC","_xlfn.IMSECH":"IMSECH","_xlfn.IMSINH":"IMSINH","_xlfn.IMTAN":"IMTAN","_xlfn.ISFORMULA":"ISFORMULA","_xlfn.ISO.CEILING":"ISO.CEILING","_xlfn.ISOWEEKNUM":"ISOWEEKNUM","_xlfn.LOGNORM.DIST":"LOGNORM.DIST","_xlfn.LOGNORM.INV":"LOGNORM.INV","_xlfn.MAXIFS":"MAXIFS","_xlfn.MINIFS":"MINIFS","_xlfn.MODE.MULT":"MODE.MULT","_xlfn.MODE.SNGL":"MODE.SNGL","_xlfn.MUNIT":"MUNIT","_xlfn.NEGBINOM.DIST":"NEGBINOM.DIST","_xlfn.NETWORKDAYS.INTL":"NETWORKDAYS.INTL","_xlfn.NIGBINOM":"NIGBINOM","_xlfn.NORM.DIST":"NORM.DIST","_xlfn.NORM.INV":"NORM.INV","_xlfn.NORM.S.DIST":"NORM.S.DIST","_xlfn.NORM.S.INV":"NORM.S.INV","_xlfn.NUMBERVALUE":"NUMBERVALUE","_xlfn.PDURATION":"PDURATION","_xlfn.PERCENTILE.EXC":"PERCENTILE.EXC","_xlfn.PERCENTILE.INC":"PERCENTILE.INC","_xlfn.PERCENTRANK.EXC":"PERCENTRANK.EXC","_xlfn.PERCENTRANK.INC":"PERCENTRANK.INC","_xlfn.PERMUTATIONA":"PERMUTATIONA","_xlfn.PHI":"PHI","_xlfn.POISSON.DIST":"POISSON.DIST","_xlfn.QUARTILE.EXC":"QUARTILE.EXC","_xlfn.QUARTILE.INC":"QUARTILE.INC","_xlfn.QUERYSTRING":"QUERYSTRING","_xlfn.RANK.AVG":"RANK.AVG","_xlfn.RANK.EQ":"RANK.EQ","_xlfn.RRI":"RRI","_xlfn.SEC":"SEC","_xlfn.SECH":"SECH","_xlfn.SHEET":"SHEET","_xlfn.SHEETS":"SHEETS","_xlfn.SKEW.P":"SKEW.P","_xlfn.STDEV.P":"STDEV.P","_xlfn.STDEV.S":"STDEV.S","_xlfn.SUMIFS":"SUMIFS","_xlfn.SWITCH":"SWITCH","_xlfn.T.DIST":"T.DIST","_xlfn.T.DIST.2T":"T.DIST.2T","_xlfn.T.DIST.RT":"T.DIST.RT","_xlfn.T.INV":"T.INV","_xlfn.T.INV.2T":"T.INV.2T","_xlfn.T.TEST":"T.TEST","_xlfn.TEXTJOIN":"TEXTJOIN","_xlfn.UNICHAR":"UNICHAR","_xlfn.UNICODE":"UNICODE","_xlfn.VAR.P":"VAR.P","_xlfn.VAR.S":"VAR.S","_xlfn.WEBSERVICE":"WEBSERVICE","_xlfn.WEIBULL.DIST":"WEIBULL.DIST","_xlfn.WORKDAY.INTL":"WORKDAY.INTL","_xlfn.XOR":"XOR","_xlfn.Z.TEST":"Z.TEST"};/* Part 3 TODO: actually parse formulae */function ods_to_csf_formula(f){if(f.slice(0,3)=="of:")f=f.slice(3);/* 5.2 Basic Expressions */if(f.charCodeAt(0)==61){f=f.slice(1);if(f.charCodeAt(0)==61)f=f.slice(1);}f=f.replace(/COM\.MICROSOFT\./g,"");/* Part 3 Section 5.8 References */f=f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g,function($$,$1){return $1.replace(/\./g,"");});/* TODO: something other than this */f=f.replace(/\[.(#[A-Z]*[?!])\]/g,"$1");return f.replace(/[;~]/g,",").replace(/\|/g,";");}function csf_to_ods_formula(f){var o="of:="+f.replace(crefregex,"$1[.$2$3$4$5]").replace(/\]:\[/g,":");/* TODO: something other than this */return o.replace(/;/g,"|").replace(/,/g,";");}function ods_to_csf_3D(r){var a=r.split(":");var s=a[0].split(".")[0];return [s,a[0].split(".")[1]+(a.length>1?":"+(a[1].split(".")[1]||a[1].split(".")[0]):"")];}function csf_to_ods_3D(r){return r.replace(/\./,"!");}var strs={};// shared strings
var _ssfopts={};// spreadsheet formatting options
RELS.WS=["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet","http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"];/*global Map */var browser_has_Map=typeof Map!=='undefined';function get_sst_id(sst,str,rev){var i=0,len=sst.length;if(rev){if(browser_has_Map?rev.has(str):Object.prototype.hasOwnProperty.call(rev,str)){var revarr=browser_has_Map?rev.get(str):rev[str];for(;i<revarr.length;++i){if(sst[revarr[i]].t===str){sst.Count++;return revarr[i];}}}}else for(;i<len;++i){if(sst[i].t===str){sst.Count++;return i;}}sst[len]={t:str};sst.Count++;sst.Unique++;if(rev){if(browser_has_Map){if(!rev.has(str))rev.set(str,[]);rev.get(str).push(len);}else {if(!Object.prototype.hasOwnProperty.call(rev,str))rev[str]=[];rev[str].push(len);}}return len;}function col_obj_w(C,col){var p={min:C+1,max:C+1};/* wch (chars), wpx (pixels) */var wch=-1;if(col.MDW)MDW=col.MDW;if(col.width!=null)p.customWidth=1;else if(col.wpx!=null)wch=px2char(col.wpx);else if(col.wch!=null)wch=col.wch;if(wch>-1){p.width=char2width(wch);p.customWidth=1;}else if(col.width!=null)p.width=col.width;if(col.hidden)p.hidden=true;return p;}function default_margins(margins,mode){if(!margins)return;var defs=[0.7,0.7,0.75,0.75,0.3,0.3];if(mode=='xlml')defs=[1,1,1,1,0.5,0.5];if(margins.left==null)margins.left=defs[0];if(margins.right==null)margins.right=defs[1];if(margins.top==null)margins.top=defs[2];if(margins.bottom==null)margins.bottom=defs[3];if(margins.header==null)margins.header=defs[4];if(margins.footer==null)margins.footer=defs[5];}function get_cell_style(styles,cell,opts){var z=opts.revssf[cell.z!=null?cell.z:"General"];var i=0x3c,len=styles.length;if(z==null&&opts.ssf){for(;i<0x188;++i)if(opts.ssf[i]==null){SSF.load(cell.z,i);// $FlowIgnore
opts.ssf[i]=cell.z;opts.revssf[cell.z]=z=i;break;}}for(i=0;i!=len;++i)if(styles[i].numFmtId===z)return i;styles[len]={numFmtId:z,fontId:0,fillId:0,borderId:0,xfId:0,applyNumberFormat:1};return len;}function safe_format(p,fmtid,fillid,opts,themes,styles){try{if(opts.cellNF)p.z=SSF._table[fmtid];}catch(e){if(opts.WTF)throw e;}if(p.t==='z'&&!opts.cellStyles)return;if(p.t==='d'&&typeof p.v==='string')p.v=parseDate(p.v);if((!opts||opts.cellText!==false)&&p.t!=='z')try{if(SSF._table[fmtid]==null)SSF.load(SSFImplicit[fmtid]||"General",fmtid);if(p.t==='e')p.w=p.w||BErr[p.v];else if(fmtid===0){if(p.t==='n'){if((p.v|0)===p.v)p.w=SSF._general_int(p.v);else p.w=SSF._general_num(p.v);}else if(p.t==='d'){var dd=datenum(p.v);if((dd|0)===dd)p.w=SSF._general_int(dd);else p.w=SSF._general_num(dd);}else if(p.v===undefined)return "";else p.w=SSF._general(p.v,_ssfopts);}else if(p.t==='d')p.w=SSF.format(fmtid,datenum(p.v),_ssfopts);else p.w=SSF.format(fmtid,p.v,_ssfopts);}catch(e){if(opts.WTF)throw e;}if(!opts.cellStyles)return;if(fillid!=null)try{p.s=styles.Fills[fillid];if(p.s.fgColor&&p.s.fgColor.theme&&!p.s.fgColor.rgb){p.s.fgColor.rgb=rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb,p.s.fgColor.tint||0);if(opts.WTF)p.s.fgColor.raw_rgb=themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;}if(p.s.bgColor&&p.s.bgColor.theme){p.s.bgColor.rgb=rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb,p.s.bgColor.tint||0);if(opts.WTF)p.s.bgColor.raw_rgb=themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;}}catch(e){if(opts.WTF&&styles.Fills)throw e;}}function check_ws(ws,sname,i){if(ws&&ws['!ref']){var range=safe_decode_range(ws['!ref']);if(range.e.c<range.s.c||range.e.r<range.s.r)throw new Error("Bad range ("+i+"): "+ws['!ref']);}}function parse_ws_xml_dim(ws,s){var d=safe_decode_range(s);if(d.s.r<=d.e.r&&d.s.c<=d.e.c&&d.s.r>=0&&d.s.c>=0)ws["!ref"]=encode_range(d);}var mergecregex=/<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;var sheetdataregex=/<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;var hlinkregex=/<(?:\w:)?hyperlink [^>]*>/mg;var dimregex=/"(\w*:\w*)"/;var colregex=/<(?:\w:)?col\b[^>]*[\/]?>/g;var afregex=/<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;var marginregex=/<(?:\w:)?pageMargins[^>]*\/>/g;var sheetprregex=/<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;var svsregex=/<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;/* 18.3 Worksheets */function parse_ws_xml(data,opts,idx,rels,wb,themes,styles){if(!data)return data;if(!rels)rels={'!id':{}};/* 18.3.1.99 worksheet CT_Worksheet */var s=opts.dense?[]:{};var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};var data1="",data2="";var mtch=data.match(sheetdataregex);if(mtch){data1=data.slice(0,mtch.index);data2=data.slice(mtch.index+mtch[0].length);}else data1=data2=data;/* 18.3.1.82 sheetPr CT_SheetPr */var sheetPr=data1.match(sheetprregex);if(sheetPr)parse_ws_xml_sheetpr(sheetPr[0],s,wb,idx);/* 18.3.1.35 dimension CT_SheetDimension */var ridx=(data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;if(ridx>0){var ref=data1.slice(ridx,ridx+50).match(dimregex);if(ref)parse_ws_xml_dim(s,ref[1]);}/* 18.3.1.88 sheetViews CT_SheetViews */var svs=data1.match(svsregex);if(svs&&svs[1])parse_ws_xml_sheetviews(svs[1],wb);/* 18.3.1.17 cols CT_Cols */var columns=[];if(opts.cellStyles){/* 18.3.1.13 col CT_Col */var cols=data1.match(colregex);if(cols)parse_ws_xml_cols(columns,cols);}/* 18.3.1.80 sheetData CT_SheetData ? */if(mtch)parse_ws_xml_data(mtch[1],s,opts,refguess,themes,styles);/* 18.3.1.2  autoFilter CT_AutoFilter */var afilter=data2.match(afregex);if(afilter)s['!autofilter']=parse_ws_xml_autofilter(afilter[0]);/* 18.3.1.55 mergeCells CT_MergeCells */var merges=[];var _merge=data2.match(mergecregex);if(_merge)for(ridx=0;ridx!=_merge.length;++ridx)merges[ridx]=safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));/* 18.3.1.48 hyperlinks CT_Hyperlinks */var hlink=data2.match(hlinkregex);if(hlink)parse_ws_xml_hlinks(s,hlink,rels);/* 18.3.1.62 pageMargins CT_PageMargins */var margins=data2.match(marginregex);if(margins)s['!margins']=parse_ws_xml_margins(parsexmltag(margins[0]));if(!s["!ref"]&&refguess.e.c>=refguess.s.c&&refguess.e.r>=refguess.s.r)s["!ref"]=encode_range(refguess);if(opts.sheetRows>0&&s["!ref"]){var tmpref=safe_decode_range(s["!ref"]);if(opts.sheetRows<=+tmpref.e.r){tmpref.e.r=opts.sheetRows-1;if(tmpref.e.r>refguess.e.r)tmpref.e.r=refguess.e.r;if(tmpref.e.r<tmpref.s.r)tmpref.s.r=tmpref.e.r;if(tmpref.e.c>refguess.e.c)tmpref.e.c=refguess.e.c;if(tmpref.e.c<tmpref.s.c)tmpref.s.c=tmpref.e.c;s["!fullref"]=s["!ref"];s["!ref"]=encode_range(tmpref);}}if(columns.length>0)s["!cols"]=columns;if(merges.length>0)s["!merges"]=merges;return s;}function write_ws_xml_merges(merges){if(merges.length===0)return "";var o='<mergeCells count="'+merges.length+'">';for(var i=0;i!=merges.length;++i)o+='<mergeCell ref="'+encode_range(merges[i])+'"/>';return o+'</mergeCells>';}/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */function parse_ws_xml_sheetpr(sheetPr,s,wb,idx){var data=parsexmltag(sheetPr);if(!wb.Sheets[idx])wb.Sheets[idx]={};if(data.codeName)wb.Sheets[idx].CodeName=unescapexml(utf8read(data.codeName));}function write_ws_xml_sheetpr(ws,wb,idx,opts,o){var needed=false;var props={},payload=null;if(opts.bookType!=='xlsx'&&wb.vbaraw){var cname=wb.SheetNames[idx];try{if(wb.Workbook)cname=wb.Workbook.Sheets[idx].CodeName||cname;}catch(e){}needed=true;props.codeName=utf8write(escapexml(cname));}if(ws&&ws["!outline"]){var outlineprops={summaryBelow:1,summaryRight:1};if(ws["!outline"].above)outlineprops.summaryBelow=0;if(ws["!outline"].left)outlineprops.summaryRight=0;payload=(payload||"")+writextag('outlinePr',null,outlineprops);}if(!needed&&!payload)return;o[o.length]=writextag('sheetPr',payload,props);}/* 18.3.1.85 sheetProtection CT_SheetProtection */var sheetprot_deffalse=["objects","scenarios","selectLockedCells","selectUnlockedCells"];var sheetprot_deftrue=["formatColumns","formatRows","formatCells","insertColumns","insertRows","insertHyperlinks","deleteColumns","deleteRows","sort","autoFilter","pivotTables"];function write_ws_xml_protection(sp){// algorithmName, hashValue, saltValue, spinCount
var o={sheet:1};sheetprot_deffalse.forEach(function(n){if(sp[n]!=null&&sp[n])o[n]="1";});sheetprot_deftrue.forEach(function(n){if(sp[n]!=null&&!sp[n])o[n]="0";});/* TODO: algorithm */if(sp.password)o.password=crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();return writextag('sheetProtection',null,o);}function parse_ws_xml_hlinks(s,data,rels){var dense=Array.isArray(s);for(var i=0;i!=data.length;++i){var val=parsexmltag(utf8read(data[i]),true);if(!val.ref)return;var rel=((rels||{})['!id']||[])[val.id];if(rel){val.Target=rel.Target;if(val.location)val.Target+="#"+val.location;}else {val.Target="#"+val.location;rel={Target:val.Target,TargetMode:'Internal'};}val.Rel=rel;if(val.tooltip){val.Tooltip=val.tooltip;delete val.tooltip;}var rng=safe_decode_range(val.ref);for(var R=rng.s.r;R<=rng.e.r;++R)for(var C=rng.s.c;C<=rng.e.c;++C){var addr=encode_cell({c:C,r:R});if(dense){if(!s[R])s[R]=[];if(!s[R][C])s[R][C]={t:"z",v:undefined};s[R][C].l=val;}else {if(!s[addr])s[addr]={t:"z",v:undefined};s[addr].l=val;}}}}function parse_ws_xml_margins(margin){var o={};["left","right","top","bottom","header","footer"].forEach(function(k){if(margin[k])o[k]=parseFloat(margin[k]);});return o;}function write_ws_xml_margins(margin){default_margins(margin);return writextag('pageMargins',null,margin);}function parse_ws_xml_cols(columns,cols){var seencol=false;for(var coli=0;coli!=cols.length;++coli){var coll=parsexmltag(cols[coli],true);if(coll.hidden)coll.hidden=parsexmlbool(coll.hidden);var colm=parseInt(coll.min,10)-1,colM=parseInt(coll.max,10)-1;delete coll.min;delete coll.max;coll.width=+coll.width;if(!seencol&&coll.width){seencol=true;find_mdw_colw(coll.width);}process_col(coll);while(colm<=colM)columns[colm++]=dup(coll);}}function write_ws_xml_cols(ws,cols){var o=["<cols>"],col;for(var i=0;i!=cols.length;++i){if(!(col=cols[i]))continue;o[o.length]=writextag('col',null,col_obj_w(i,col));}o[o.length]="</cols>";return o.join("");}function parse_ws_xml_autofilter(data){var o={ref:(data.match(/ref="([^"]*)"/)||[])[1]};return o;}function write_ws_xml_autofilter(data,ws,wb,idx){var ref=typeof data.ref=="string"?data.ref:encode_range(data.ref);if(!wb.Workbook)wb.Workbook={Sheets:[]};if(!wb.Workbook.Names)wb.Workbook.Names=[];var names=wb.Workbook.Names;var range=decode_range(ref);if(range.s.r==range.e.r){range.e.r=decode_range(ws["!ref"]).e.r;ref=encode_range(range);}for(var i=0;i<names.length;++i){var name=names[i];if(name.Name!='_xlnm._FilterDatabase')continue;if(name.Sheet!=idx)continue;name.Ref="'"+wb.SheetNames[idx]+"'!"+ref;break;}if(i==names.length)names.push({Name:'_xlnm._FilterDatabase',Sheet:idx,Ref:"'"+wb.SheetNames[idx]+"'!"+ref});return writextag("autoFilter",null,{ref:ref});}/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */var sviewregex=/<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;function parse_ws_xml_sheetviews(data,wb){if(!wb.Views)wb.Views=[{}];(data.match(sviewregex)||[]).forEach(function(r,i){var tag=parsexmltag(r);// $FlowIgnore
if(!wb.Views[i])wb.Views[i]={};// $FlowIgnore
if(+tag.zoomScale)wb.Views[i].zoom=+tag.zoomScale;// $FlowIgnore
if(parsexmlbool(tag.rightToLeft))wb.Views[i].RTL=true;});}function write_ws_xml_sheetviews(ws,opts,idx,wb){var sview={workbookViewId:"0"};// $FlowIgnore
if((((wb||{}).Workbook||{}).Views||[])[0])sview.rightToLeft=wb.Workbook.Views[0].RTL?"1":"0";return writextag("sheetViews",writextag("sheetView",null,sview),{});}function write_ws_xml_cell(cell,ref,ws,opts){if(cell.v===undefined&&typeof cell.f!=="string"||cell.t==='z')return "";var vv="";var oldt=cell.t,oldv=cell.v;if(cell.t!=="z")switch(cell.t){case'b':vv=cell.v?"1":"0";break;case'n':vv=''+cell.v;break;case'e':vv=BErr[cell.v];break;case'd':if(opts&&opts.cellDates)vv=parseDate(cell.v,-1).toISOString();else {cell=dup(cell);cell.t='n';vv=''+(cell.v=datenum(parseDate(cell.v)));}if(typeof cell.z==='undefined')cell.z=SSF._table[14];break;default:vv=cell.v;break;}var v=writetag('v',escapexml(vv)),o={r:ref};/* TODO: cell style */var os=get_cell_style(opts.cellXfs,cell,opts);if(os!==0)o.s=os;switch(cell.t){case'n':break;case'd':o.t="d";break;case'b':o.t="b";break;case'e':o.t="e";break;case'z':break;default:if(cell.v==null){delete cell.t;break;}if(opts&&opts.bookSST){v=writetag('v',''+get_sst_id(opts.Strings,cell.v,opts.revStrings));o.t="s";break;}o.t="str";break;}if(cell.t!=oldt){cell.t=oldt;cell.v=oldv;}if(typeof cell.f=="string"&&cell.f){var ff=cell.F&&cell.F.slice(0,ref.length)==ref?{t:"array",ref:cell.F}:null;v=writextag('f',escapexml(cell.f),ff)+(cell.v!=null?v:"");}if(cell.l)ws['!links'].push([ref,cell.l]);if(cell.c)ws['!comments'].push([ref,cell.c]);return writextag('c',v,o);}var parse_ws_xml_data=function(){var cellregex=/<(?:\w+:)?c[ \/>]/,rowregex=/<\/(?:\w+:)?row>/;var rregex=/r=["']([^"']*)["']/,isregex=/<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;var refregex=/ref=["']([^"']*)["']/;var match_v=matchtag("v"),match_f=matchtag("f");return function parse_ws_xml_data(sdata,s,opts,guess,themes,styles){var ri=0,x="",cells=[],cref=[],idx=0,i=0,cc=0,d="",p;var tag,tagr=0,tagc=0;var sstr,ftag;var fmtid=0,fillid=0;var do_format=Array.isArray(styles.CellXf),cf;var arrayf=[];var sharedf=[];var dense=Array.isArray(s);var rows=[],rowobj={},rowrite=false;var sheetStubs=!!opts.sheetStubs;for(var marr=sdata.split(rowregex),mt=0,marrlen=marr.length;mt!=marrlen;++mt){x=marr[mt].trim();var xlen=x.length;if(xlen===0)continue;/* 18.3.1.73 row CT_Row */for(ri=0;ri<xlen;++ri)if(x.charCodeAt(ri)===62)break;++ri;tag=parsexmltag(x.slice(0,ri),true);tagr=tag.r!=null?parseInt(tag.r,10):tagr+1;tagc=-1;if(opts.sheetRows&&opts.sheetRows<tagr)continue;if(guess.s.r>tagr-1)guess.s.r=tagr-1;if(guess.e.r<tagr-1)guess.e.r=tagr-1;if(opts&&opts.cellStyles){rowobj={};rowrite=false;if(tag.ht){rowrite=true;rowobj.hpt=parseFloat(tag.ht);rowobj.hpx=pt2px(rowobj.hpt);}if(tag.hidden=="1"){rowrite=true;rowobj.hidden=true;}if(tag.outlineLevel!=null){rowrite=true;rowobj.level=+tag.outlineLevel;}if(rowrite)rows[tagr-1]=rowobj;}/* 18.3.1.4 c CT_Cell */cells=x.slice(ri).split(cellregex);for(var rslice=0;rslice!=cells.length;++rslice)if(cells[rslice].trim().charAt(0)!="<")break;cells=cells.slice(rslice);for(ri=0;ri!=cells.length;++ri){x=cells[ri].trim();if(x.length===0)continue;cref=x.match(rregex);idx=ri;i=0;cc=0;x="<c "+(x.slice(0,1)=="<"?">":"")+x;if(cref!=null&&cref.length===2){idx=0;d=cref[1];for(i=0;i!=d.length;++i){if((cc=d.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}--idx;tagc=idx;}else ++tagc;for(i=0;i!=x.length;++i)if(x.charCodeAt(i)===62)break;++i;tag=parsexmltag(x.slice(0,i),true);if(!tag.r)tag.r=encode_cell({r:tagr-1,c:tagc});d=x.slice(i);p={t:""};if((cref=d.match(match_v))!=null&&cref[1]!=='')p.v=unescapexml(cref[1]);if(opts.cellFormula){if((cref=d.match(match_f))!=null&&cref[1]!==''){/* TODO: match against XLSXFutureFunctions */p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g,"\n");if(!opts.xlfn)p.f=_xlfn(p.f);if(cref[0].indexOf('t="array"')>-1){p.F=(d.match(refregex)||[])[1];if(p.F.indexOf(":")>-1)arrayf.push([safe_decode_range(p.F),p.F]);}else if(cref[0].indexOf('t="shared"')>-1){// TODO: parse formula
ftag=parsexmltag(cref[0]);var ___f=unescapexml(utf8read(cref[1]));if(!opts.xlfn)___f=_xlfn(___f);sharedf[parseInt(ftag.si,10)]=[ftag,___f,tag.r];}}else if(cref=d.match(/<f[^>]*\/>/)){ftag=parsexmltag(cref[0]);if(sharedf[ftag.si])p.f=shift_formula_xlsx(sharedf[ftag.si][1],sharedf[ftag.si][2]/*[0].ref*/,tag.r);}/* TODO: factor out contains logic */var _tag=decode_cell(tag.r);for(i=0;i<arrayf.length;++i)if(_tag.r>=arrayf[i][0].s.r&&_tag.r<=arrayf[i][0].e.r)if(_tag.c>=arrayf[i][0].s.c&&_tag.c<=arrayf[i][0].e.c)p.F=arrayf[i][1];}if(tag.t==null&&p.v===undefined){if(p.f||p.F){p.v=0;p.t="n";}else if(!sheetStubs)continue;else p.t="z";}else p.t=tag.t||"n";if(guess.s.c>tagc)guess.s.c=tagc;if(guess.e.c<tagc)guess.e.c=tagc;/* 18.18.11 t ST_CellType */switch(p.t){case'n':if(p.v==""||p.v==null){if(!sheetStubs)continue;p.t='z';}else p.v=parseFloat(p.v);break;case's':if(typeof p.v=='undefined'){if(!sheetStubs)continue;p.t='z';}else {sstr=strs[parseInt(p.v,10)];p.v=sstr.t;p.r=sstr.r;if(opts.cellHTML)p.h=sstr.h;}break;case'str':p.t="s";p.v=p.v!=null?utf8read(p.v):'';if(opts.cellHTML)p.h=escapehtml(p.v);break;case'inlineStr':cref=d.match(isregex);p.t='s';if(cref!=null&&(sstr=parse_si(cref[1]))){p.v=sstr.t;if(opts.cellHTML)p.h=sstr.h;}else p.v="";break;case'b':p.v=parsexmlbool(p.v);break;case'd':if(opts.cellDates)p.v=parseDate(p.v,1);else {p.v=datenum(parseDate(p.v,1));p.t='n';}break;/* error string in .w, number in .v */case'e':if(!opts||opts.cellText!==false)p.w=p.v;p.v=RBErr[p.v];break;}/* formatting */fmtid=fillid=0;cf=null;if(do_format&&tag.s!==undefined){cf=styles.CellXf[tag.s];if(cf!=null){if(cf.numFmtId!=null)fmtid=cf.numFmtId;if(opts.cellStyles){if(cf.fillId!=null)fillid=cf.fillId;}}}safe_format(p,fmtid,fillid,opts,themes,styles);if(opts.cellDates&&do_format&&p.t=='n'&&SSF.is_date(SSF._table[fmtid])){p.t='d';p.v=numdate(p.v);}if(dense){var _r=decode_cell(tag.r);if(!s[_r.r])s[_r.r]=[];s[_r.r][_r.c]=p;}else s[tag.r]=p;}}if(rows.length>0)s['!rows']=rows;};}();function write_ws_xml_data(ws,opts,idx,wb){var o=[],r=[],range=safe_decode_range(ws['!ref']),cell="",ref,rr="",cols=[],R=0,C=0,rows=ws['!rows'];var dense=Array.isArray(ws);var params={r:rr},row,height=-1;for(C=range.s.c;C<=range.e.c;++C)cols[C]=encode_col(C);for(R=range.s.r;R<=range.e.r;++R){r=[];rr=encode_row(R);for(C=range.s.c;C<=range.e.c;++C){ref=cols[C]+rr;var _cell=dense?(ws[R]||[])[C]:ws[ref];if(_cell===undefined)continue;if((cell=write_ws_xml_cell(_cell,ref,ws,opts))!=null)r.push(cell);}if(r.length>0||rows&&rows[R]){params={r:rr};if(rows&&rows[R]){row=rows[R];if(row.hidden)params.hidden=1;height=-1;if(row.hpx)height=px2pt(row.hpx);else if(row.hpt)height=row.hpt;if(height>-1){params.ht=height;params.customHeight=1;}if(row.level){params.outlineLevel=row.level;}}o[o.length]=writextag('row',r.join(""),params);}}if(rows)for(;R<rows.length;++R){if(rows&&rows[R]){params={r:R+1};row=rows[R];if(row.hidden)params.hidden=1;height=-1;if(row.hpx)height=px2pt(row.hpx);else if(row.hpt)height=row.hpt;if(height>-1){params.ht=height;params.customHeight=1;}if(row.level){params.outlineLevel=row.level;}o[o.length]=writextag('row',"",params);}}return o.join("");}var WS_XML_ROOT=writextag('worksheet',null,{'xmlns':XMLNS.main[0],'xmlns:r':XMLNS.r});function write_ws_xml(idx,opts,wb,rels){var o=[XML_HEADER,WS_XML_ROOT];var s=wb.SheetNames[idx],sidx=0,rdata="";var ws=wb.Sheets[s];if(ws==null)ws={};var ref=ws['!ref']||'A1';var range=safe_decode_range(ref);if(range.e.c>0x3FFF||range.e.r>0xFFFFF){if(opts.WTF)throw new Error("Range "+ref+" exceeds format limit A1:XFD1048576");range.e.c=Math.min(range.e.c,0x3FFF);range.e.r=Math.min(range.e.c,0xFFFFF);ref=encode_range(range);}if(!rels)rels={};ws['!comments']=[];var _drawing=[];write_ws_xml_sheetpr(ws,wb,idx,opts,o);o[o.length]=writextag('dimension',null,{'ref':ref});o[o.length]=write_ws_xml_sheetviews(ws,opts,idx,wb);/* TODO: store in WB, process styles */if(opts.sheetFormat)o[o.length]=writextag('sheetFormatPr',null,{defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',baseColWidth:opts.sheetFormat.baseColWidth||'10',outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'});if(ws['!cols']!=null&&ws['!cols'].length>0)o[o.length]=write_ws_xml_cols(ws,ws['!cols']);o[sidx=o.length]='<sheetData/>';ws['!links']=[];if(ws['!ref']!=null){rdata=write_ws_xml_data(ws,opts);if(rdata.length>0)o[o.length]=rdata;}if(o.length>sidx+1){o[o.length]='</sheetData>';o[sidx]=o[sidx].replace("/>",">");}/* sheetCalcPr */if(ws['!protect']!=null)o[o.length]=write_ws_xml_protection(ws['!protect']);/* protectedRanges */ /* scenarios */if(ws['!autofilter']!=null)o[o.length]=write_ws_xml_autofilter(ws['!autofilter'],ws,wb,idx);/* sortState */ /* dataConsolidate */ /* customSheetViews */if(ws['!merges']!=null&&ws['!merges'].length>0)o[o.length]=write_ws_xml_merges(ws['!merges']);/* phoneticPr */ /* conditionalFormatting */ /* dataValidations */var relc=-1,rel,rId=-1;if(ws['!links'].length>0){o[o.length]="<hyperlinks>";ws['!links'].forEach(function(l){if(!l[1].Target)return;rel={"ref":l[0]};if(l[1].Target.charAt(0)!="#"){rId=add_rels(rels,-1,escapexml(l[1].Target).replace(/#.*$/,""),RELS.HLINK);rel["r:id"]="rId"+rId;}if((relc=l[1].Target.indexOf("#"))>-1)rel.location=escapexml(l[1].Target.slice(relc+1));if(l[1].Tooltip)rel.tooltip=escapexml(l[1].Tooltip);o[o.length]=writextag("hyperlink",null,rel);});o[o.length]="</hyperlinks>";}delete ws['!links'];/* printOptions */if(ws['!margins']!=null)o[o.length]=write_ws_xml_margins(ws['!margins']);/* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */if(!opts||opts.ignoreEC||opts.ignoreEC==void 0)o[o.length]=writetag("ignoredErrors",writextag("ignoredError",null,{numberStoredAsText:1,sqref:ref}));/* smartTags */if(_drawing.length>0){rId=add_rels(rels,-1,"../drawings/drawing"+(idx+1)+".xml",RELS.DRAW);o[o.length]=writextag("drawing",null,{"r:id":"rId"+rId});ws['!drawing']=_drawing;}if(ws['!comments'].length>0){rId=add_rels(rels,-1,"../drawings/vmlDrawing"+(idx+1)+".vml",RELS.VML);o[o.length]=writextag("legacyDrawing",null,{"r:id":"rId"+rId});ws['!legacy']=rId;}/* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */if(o.length>1){o[o.length]='</worksheet>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.726 BrtRowHdr */function parse_BrtRowHdr(data,length){var z={};var tgt=data.l+length;z.r=data.read_shift(4);data.l+=4;// TODO: ixfe
var miyRw=data.read_shift(2);data.l+=1;// TODO: top/bot padding
var flags=data.read_shift(1);data.l=tgt;if(flags&0x07)z.level=flags&0x07;if(flags&0x10)z.hidden=true;if(flags&0x20)z.hpt=miyRw/20;return z;}function write_BrtRowHdr(R,range,ws){var o=new_buf(17+8*16);var row=(ws['!rows']||[])[R]||{};o.write_shift(4,R);o.write_shift(4,0);/* TODO: ixfe */var miyRw=0x0140;if(row.hpx)miyRw=px2pt(row.hpx)*20;else if(row.hpt)miyRw=row.hpt*20;o.write_shift(2,miyRw);o.write_shift(1,0);/* top/bot padding */var flags=0x0;if(row.level)flags|=row.level;if(row.hidden)flags|=0x10;if(row.hpx||row.hpt)flags|=0x20;o.write_shift(1,flags);o.write_shift(1,0);/* phonetic guide */ /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */var ncolspan=0,lcs=o.l;o.l+=4;var caddr={r:R,c:0};for(var i=0;i<16;++i){if(range.s.c>i+1<<10||range.e.c<i<<10)continue;var first=-1,last=-1;for(var j=i<<10;j<i+1<<10;++j){caddr.c=j;var cell=Array.isArray(ws)?(ws[caddr.r]||[])[caddr.c]:ws[encode_cell(caddr)];if(cell){if(first<0)first=j;last=j;}}if(first<0)continue;++ncolspan;o.write_shift(4,first);o.write_shift(4,last);}var l=o.l;o.l=lcs;o.write_shift(4,ncolspan);o.l=l;return o.length>o.l?o.slice(0,o.l):o;}function write_row_header(ba,ws,range,R){var o=write_BrtRowHdr(R,range,ws);if(o.length>17||(ws['!rows']||[])[R])write_record(ba,'BrtRowHdr',o);}/* [MS-XLSB] 2.4.820 BrtWsDim */var parse_BrtWsDim=parse_UncheckedRfX;var write_BrtWsDim=write_UncheckedRfX;/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */function parse_BrtWsFmtInfo(){}//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */function parse_BrtWsProp(data,length){var z={};/* TODO: pull flags */data.l+=19;z.name=parse_XLSBCodeName(data);return z;}function write_BrtWsProp(str,o){if(o==null)o=new_buf(84+4*str.length);for(var i=0;i<3;++i)o.write_shift(1,0);write_BrtColor({auto:1},o);o.write_shift(-4,-1);o.write_shift(-4,-1);write_XLSBCodeName(str,o);return o.slice(0,o.l);}/* [MS-XLSB] 2.4.306 BrtCellBlank */function parse_BrtCellBlank(data){var cell=parse_XLSBCell(data);return [cell];}function write_BrtCellBlank(cell,ncell,o){if(o==null)o=new_buf(8);return write_XLSBCell(ncell,o);}function parse_BrtShortBlank(data){var cell=parse_XLSBShortCell(data);return [cell];}function write_BrtShortBlank(cell,ncell,o){if(o==null)o=new_buf(4);return write_XLSBShortCell(ncell,o);}/* [MS-XLSB] 2.4.307 BrtCellBool */function parse_BrtCellBool(data){var cell=parse_XLSBCell(data);var fBool=data.read_shift(1);return [cell,fBool,'b'];}function write_BrtCellBool(cell,ncell,o){if(o==null)o=new_buf(9);write_XLSBCell(ncell,o);o.write_shift(1,cell.v?1:0);return o;}function parse_BrtShortBool(data){var cell=parse_XLSBShortCell(data);var fBool=data.read_shift(1);return [cell,fBool,'b'];}function write_BrtShortBool(cell,ncell,o){if(o==null)o=new_buf(5);write_XLSBShortCell(ncell,o);o.write_shift(1,cell.v?1:0);return o;}/* [MS-XLSB] 2.4.308 BrtCellError */function parse_BrtCellError(data){var cell=parse_XLSBCell(data);var bError=data.read_shift(1);return [cell,bError,'e'];}function write_BrtCellError(cell,ncell,o){if(o==null)o=new_buf(9);write_XLSBCell(ncell,o);o.write_shift(1,cell.v);return o;}function parse_BrtShortError(data){var cell=parse_XLSBShortCell(data);var bError=data.read_shift(1);return [cell,bError,'e'];}function write_BrtShortError(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);o.write_shift(1,cell.v);o.write_shift(2,0);o.write_shift(1,0);return o;}/* [MS-XLSB] 2.4.311 BrtCellIsst */function parse_BrtCellIsst(data){var cell=parse_XLSBCell(data);var isst=data.read_shift(4);return [cell,isst,'s'];}function write_BrtCellIsst(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBCell(ncell,o);o.write_shift(4,ncell.v);return o;}function parse_BrtShortIsst(data){var cell=parse_XLSBShortCell(data);var isst=data.read_shift(4);return [cell,isst,'s'];}function write_BrtShortIsst(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);o.write_shift(4,ncell.v);return o;}/* [MS-XLSB] 2.4.313 BrtCellReal */function parse_BrtCellReal(data){var cell=parse_XLSBCell(data);var value=parse_Xnum(data);return [cell,value,'n'];}function write_BrtCellReal(cell,ncell,o){if(o==null)o=new_buf(16);write_XLSBCell(ncell,o);write_Xnum(cell.v,o);return o;}function parse_BrtShortReal(data){var cell=parse_XLSBShortCell(data);var value=parse_Xnum(data);return [cell,value,'n'];}function write_BrtShortReal(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBShortCell(ncell,o);write_Xnum(cell.v,o);return o;}/* [MS-XLSB] 2.4.314 BrtCellRk */function parse_BrtCellRk(data){var cell=parse_XLSBCell(data);var value=parse_RkNumber(data);return [cell,value,'n'];}function write_BrtCellRk(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBCell(ncell,o);write_RkNumber(cell.v,o);return o;}function parse_BrtShortRk(data){var cell=parse_XLSBShortCell(data);var value=parse_RkNumber(data);return [cell,value,'n'];}function write_BrtShortRk(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);write_RkNumber(cell.v,o);return o;}/* [MS-XLSB] 2.4.317 BrtCellSt */function parse_BrtCellSt(data){var cell=parse_XLSBCell(data);var value=parse_XLWideString(data);return [cell,value,'str'];}function write_BrtCellSt(cell,ncell,o){if(o==null)o=new_buf(12+4*cell.v.length);write_XLSBCell(ncell,o);write_XLWideString(cell.v,o);return o.length>o.l?o.slice(0,o.l):o;}function parse_BrtShortSt(data){var cell=parse_XLSBShortCell(data);var value=parse_XLWideString(data);return [cell,value,'str'];}function write_BrtShortSt(cell,ncell,o){if(o==null)o=new_buf(8+4*cell.v.length);write_XLSBShortCell(ncell,o);write_XLWideString(cell.v,o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.653 BrtFmlaBool */function parse_BrtFmlaBool(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=data.read_shift(1);var o=[cell,value,'b'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.654 BrtFmlaError */function parse_BrtFmlaError(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=data.read_shift(1);var o=[cell,value,'e'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.655 BrtFmlaNum */function parse_BrtFmlaNum(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=parse_Xnum(data);var o=[cell,value,'n'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.656 BrtFmlaString */function parse_BrtFmlaString(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=parse_XLWideString(data);var o=[cell,value,'str'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.682 BrtMergeCell */var parse_BrtMergeCell=parse_UncheckedRfX;var write_BrtMergeCell=write_UncheckedRfX;/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */function write_BrtBeginMergeCells(cnt,o){if(o==null)o=new_buf(4);o.write_shift(4,cnt);return o;}/* [MS-XLSB] 2.4.662 BrtHLink */function parse_BrtHLink(data,length){var end=data.l+length;var rfx=parse_UncheckedRfX(data);var relId=parse_XLNullableWideString(data);var loc=parse_XLWideString(data);var tooltip=parse_XLWideString(data);var display=parse_XLWideString(data);data.l=end;var o={rfx:rfx,relId:relId,loc:loc,display:display};if(tooltip)o.Tooltip=tooltip;return o;}function write_BrtHLink(l,rId){var o=new_buf(50+4*(l[1].Target.length+(l[1].Tooltip||"").length));write_UncheckedRfX({s:decode_cell(l[0]),e:decode_cell(l[0])},o);write_RelID("rId"+rId,o);var locidx=l[1].Target.indexOf("#");var loc=locidx==-1?"":l[1].Target.slice(locidx+1);write_XLWideString(loc||"",o);write_XLWideString(l[1].Tooltip||"",o);write_XLWideString("",o);return o.slice(0,o.l);}/* [MS-XLSB] 2.4.692 BrtPane */function/*data, length, opts*/parse_BrtPane(){}/* [MS-XLSB] 2.4.6 BrtArrFmla */function parse_BrtArrFmla(data,length,opts){var end=data.l+length;var rfx=parse_RfX(data);var fAlwaysCalc=data.read_shift(1);var o=[rfx];o[2]=fAlwaysCalc;if(opts.cellFormula){var formula=parse_XLSBArrayParsedFormula(data,end-data.l,opts);o[1]=formula;}else data.l=end;return o;}/* [MS-XLSB] 2.4.750 BrtShrFmla */function parse_BrtShrFmla(data,length,opts){var end=data.l+length;var rfx=parse_UncheckedRfX(data);var o=[rfx];if(opts.cellFormula){var formula=parse_XLSBSharedParsedFormula(data,end-data.l,opts);o[1]=formula;data.l=end;}else data.l=end;return o;}/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */function write_BrtColInfo(C,col,o){if(o==null)o=new_buf(18);var p=col_obj_w(C,col);o.write_shift(-4,C);o.write_shift(-4,C);o.write_shift(4,(p.width||10)*256);o.write_shift(4,0/*ixfe*/);// style
var flags=0;if(col.hidden)flags|=0x01;if(typeof p.width=='number')flags|=0x02;if(col.level)flags|=col.level<<8;o.write_shift(2,flags);// bit flag
return o;}/* [MS-XLSB] 2.4.678 BrtMargins */var BrtMarginKeys=["left","right","top","bottom","header","footer"];function parse_BrtMargins(data){var margins={};BrtMarginKeys.forEach(function(k){margins[k]=parse_Xnum(data);});return margins;}function write_BrtMargins(margins,o){if(o==null)o=new_buf(6*8);default_margins(margins);BrtMarginKeys.forEach(function(k){write_Xnum(margins[k],o);});return o;}/* [MS-XLSB] 2.4.299 BrtBeginWsView */function parse_BrtBeginWsView(data){var f=data.read_shift(2);data.l+=28;return {RTL:f&0x20};}function write_BrtBeginWsView(ws,Workbook,o){if(o==null)o=new_buf(30);var f=0x39c;if((((Workbook||{}).Views||[])[0]||{}).RTL)f|=0x20;o.write_shift(2,f);// bit flag
o.write_shift(4,0);o.write_shift(4,0);// view first row
o.write_shift(4,0);// view first col
o.write_shift(1,0);// gridline color ICV
o.write_shift(1,0);o.write_shift(2,0);o.write_shift(2,100);// zoom scale
o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(4,0);// workbook view id
return o;}/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */function write_BrtCellIgnoreEC(ref){var o=new_buf(24);o.write_shift(4,4);o.write_shift(4,1);write_UncheckedRfX(ref,o);return o;}/* [MS-XLSB] 2.4.748 BrtSheetProtection */function write_BrtSheetProtection(sp,o){if(o==null)o=new_buf(16*4+2);o.write_shift(2,sp.password?crypto_CreatePasswordVerifier_Method1(sp.password):0);o.write_shift(4,1);// this record should not be written if no protection
[["objects",false],// fObjects
["scenarios",false],// fScenarios
["formatCells",true],// fFormatCells
["formatColumns",true],// fFormatColumns
["formatRows",true],// fFormatRows
["insertColumns",true],// fInsertColumns
["insertRows",true],// fInsertRows
["insertHyperlinks",true],// fInsertHyperlinks
["deleteColumns",true],// fDeleteColumns
["deleteRows",true],// fDeleteRows
["selectLockedCells",false],// fSelLockedCells
["sort",true],// fSort
["autoFilter",true],// fAutoFilter
["pivotTables",true],// fPivotTables
["selectUnlockedCells",false]// fSelUnlockedCells
].forEach(function(n){if(n[1])o.write_shift(4,sp[n[0]]!=null&&!sp[n[0]]?1:0);else o.write_shift(4,sp[n[0]]!=null&&sp[n[0]]?0:1);});return o;}function/*data, length, opts*/parse_BrtDVal(){}function/*data, length, opts*/parse_BrtDVal14(){}/* [MS-XLSB] 2.1.7.61 Worksheet */function parse_ws_bin(data,_opts,idx,rels,wb,themes,styles){if(!data)return data;var opts=_opts||{};if(!rels)rels={'!id':{}};var s=opts.dense?[]:{};var ref;var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};var pass=false,end=false;var row,p,cf,R,C,addr,sstr,rr,cell;var merges=[];opts.biff=12;opts['!row']=0;var ai=0,af=false;var arrayf=[];var sharedf={};var supbooks=opts.supbooks||wb.supbooks||[[]];supbooks.sharedf=sharedf;supbooks.arrayf=arrayf;supbooks.SheetNames=wb.SheetNames||wb.Sheets.map(function(x){return x.name;});if(!opts.supbooks){opts.supbooks=supbooks;if(wb.Names)for(var i=0;i<wb.Names.length;++i)supbooks[0][i+1]=wb.Names[i];}var colinfo=[],rowinfo=[];var seencol=false;XLSBRecordEnum[0x0010]={n:"BrtShortReal",f:parse_BrtShortReal};recordhopper(data,function ws_parse(val,R_n,RT){if(end)return;switch(RT){case 0x0094:/* 'BrtWsDim' */ref=val;break;case 0x0000:/* 'BrtRowHdr' */row=val;if(opts.sheetRows&&opts.sheetRows<=row.r)end=true;rr=encode_row(R=row.r);opts['!row']=row.r;if(val.hidden||val.hpt||val.level!=null){if(val.hpt)val.hpx=pt2px(val.hpt);rowinfo[val.r]=val;}break;case 0x0002:/* 'BrtCellRk' */case 0x0003:/* 'BrtCellError' */case 0x0004:/* 'BrtCellBool' */case 0x0005:/* 'BrtCellReal' */case 0x0006:/* 'BrtCellSt' */case 0x0007:/* 'BrtCellIsst' */case 0x0008:/* 'BrtFmlaString' */case 0x0009:/* 'BrtFmlaNum' */case 0x000A:/* 'BrtFmlaBool' */case 0x000B:/* 'BrtFmlaError' */case 0x000D:/* 'BrtShortRk' */case 0x000E:/* 'BrtShortError' */case 0x000F:/* 'BrtShortBool' */case 0x0010:/* 'BrtShortReal' */case 0x0011:/* 'BrtShortSt' */case 0x0012:/* 'BrtShortIsst' */p={t:val[2]};switch(val[2]){case'n':p.v=val[1];break;case's':sstr=strs[val[1]];p.v=sstr.t;p.r=sstr.r;break;case'b':p.v=val[1]?true:false;break;case'e':p.v=val[1];if(opts.cellText!==false)p.w=BErr[p.v];break;case'str':p.t='s';p.v=val[1];break;}if(cf=styles.CellXf[val[0].iStyleRef])safe_format(p,cf.numFmtId,null,opts,themes,styles);C=val[0].c==-1?C+1:val[0].c;if(opts.dense){if(!s[R])s[R]=[];s[R][C]=p;}else s[encode_col(C)+rr]=p;if(opts.cellFormula){af=false;for(ai=0;ai<arrayf.length;++ai){var aii=arrayf[ai];if(row.r>=aii[0].s.r&&row.r<=aii[0].e.r)if(C>=aii[0].s.c&&C<=aii[0].e.c){p.F=encode_range(aii[0]);af=true;}}if(!af&&val.length>3)p.f=val[3];}if(refguess.s.r>row.r)refguess.s.r=row.r;if(refguess.s.c>C)refguess.s.c=C;if(refguess.e.r<row.r)refguess.e.r=row.r;if(refguess.e.c<C)refguess.e.c=C;if(opts.cellDates&&cf&&p.t=='n'&&SSF.is_date(SSF._table[cf.numFmtId])){var _d=SSF.parse_date_code(p.v);if(_d){p.t='d';p.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}break;case 0x0001:/* 'BrtCellBlank' */case 0x000C:/* 'BrtShortBlank' */if(!opts.sheetStubs||pass)break;p={t:'z',v:undefined};C=val[0].c==-1?C+1:val[0].c;if(opts.dense){if(!s[R])s[R]=[];s[R][C]=p;}else s[encode_col(C)+rr]=p;if(refguess.s.r>row.r)refguess.s.r=row.r;if(refguess.s.c>C)refguess.s.c=C;if(refguess.e.r<row.r)refguess.e.r=row.r;if(refguess.e.c<C)refguess.e.c=C;break;case 0x00B0:/* 'BrtMergeCell' */merges.push(val);break;case 0x01EE:/* 'BrtHLink' */var rel=rels['!id'][val.relId];if(rel){val.Target=rel.Target;if(val.loc)val.Target+="#"+val.loc;val.Rel=rel;}else if(val.relId==''){val.Target="#"+val.loc;}for(R=val.rfx.s.r;R<=val.rfx.e.r;++R)for(C=val.rfx.s.c;C<=val.rfx.e.c;++C){if(opts.dense){if(!s[R])s[R]=[];if(!s[R][C])s[R][C]={t:'z',v:undefined};s[R][C].l=val;}else {addr=encode_cell({c:C,r:R});if(!s[addr])s[addr]={t:'z',v:undefined};s[addr].l=val;}}break;case 0x01AA:/* 'BrtArrFmla' */if(!opts.cellFormula)break;arrayf.push(val);cell=opts.dense?s[R][C]:s[encode_col(C)+rr];cell.f=stringify_formula(val[1],refguess,{r:row.r,c:C},supbooks,opts);cell.F=encode_range(val[0]);break;case 0x01AB:/* 'BrtShrFmla' */if(!opts.cellFormula)break;sharedf[encode_cell(val[0].s)]=val[1];cell=opts.dense?s[R][C]:s[encode_col(C)+rr];cell.f=stringify_formula(val[1],refguess,{r:row.r,c:C},supbooks,opts);break;/* identical to 'ColInfo' in XLS */case 0x003C:/* 'BrtColInfo' */if(!opts.cellStyles)break;while(val.e>=val.s){colinfo[val.e--]={width:val.w/256,hidden:!!(val.flags&0x01),level:val.level};if(!seencol){seencol=true;find_mdw_colw(val.w/256);}process_col(colinfo[val.e+1]);}break;case 0x00A1:/* 'BrtBeginAFilter' */s['!autofilter']={ref:encode_range(val)};break;case 0x01DC:/* 'BrtMargins' */s['!margins']=val;break;case 0x0093:/* 'BrtWsProp' */if(!wb.Sheets[idx])wb.Sheets[idx]={};if(val.name)wb.Sheets[idx].CodeName=val.name;break;case 0x0089:/* 'BrtBeginWsView' */if(!wb.Views)wb.Views=[{}];if(!wb.Views[0])wb.Views[0]={};if(val.RTL)wb.Views[0].RTL=true;break;case 0x01E5:/* 'BrtWsFmtInfo' */break;case 0x0040:/* 'BrtDVal' */case 0x041D:/* 'BrtDVal14' */break;case 0x0097:/* 'BrtPane' */break;case 0x0098:/* 'BrtSel' */case 0x00AF:/* 'BrtAFilterDateGroupItem' */case 0x0284:/* 'BrtActiveX' */case 0x0271:/* 'BrtBigName' */case 0x0232:/* 'BrtBkHim' */case 0x018C:/* 'BrtBrk' */case 0x0458:/* 'BrtCFIcon' */case 0x047A:/* 'BrtCFRuleExt' */case 0x01D7:/* 'BrtCFVO' */case 0x041A:/* 'BrtCFVO14' */case 0x0289:/* 'BrtCellIgnoreEC' */case 0x0451:/* 'BrtCellIgnoreEC14' */case 0x0031:/* 'BrtCellMeta' */case 0x024D:/* 'BrtCellSmartTagProperty' */case 0x025F:/* 'BrtCellWatch' */case 0x0234:/* 'BrtColor' */case 0x041F:/* 'BrtColor14' */case 0x00A8:/* 'BrtColorFilter' */case 0x00AE:/* 'BrtCustomFilter' */case 0x049C:/* 'BrtCustomFilter14' */case 0x01F3:/* 'BrtDRef' */case 0x01FB:/* 'BrtDXF' */case 0x0226:/* 'BrtDrawing' */case 0x00AB:/* 'BrtDynamicFilter' */case 0x00A7:/* 'BrtFilter' */case 0x0499:/* 'BrtFilter14' */case 0x00A9:/* 'BrtIconFilter' */case 0x049D:/* 'BrtIconFilter14' */case 0x0227:/* 'BrtLegacyDrawing' */case 0x0228:/* 'BrtLegacyDrawingHF' */case 0x0295:/* 'BrtListPart' */case 0x027F:/* 'BrtOleObject' */case 0x01DE:/* 'BrtPageSetup' */case 0x0219:/* 'BrtPhoneticInfo' */case 0x01DD:/* 'BrtPrintOptions' */case 0x0218:/* 'BrtRangeProtection' */case 0x044F:/* 'BrtRangeProtection14' */case 0x02A8:/* 'BrtRangeProtectionIso' */case 0x0450:/* 'BrtRangeProtectionIso14' */case 0x0400:/* 'BrtRwDescent' */case 0x0297:/* 'BrtSheetCalcProp' */case 0x0217:/* 'BrtSheetProtection' */case 0x02A6:/* 'BrtSheetProtectionIso' */case 0x01F8:/* 'BrtSlc' */case 0x0413:/* 'BrtSparkline' */case 0x01AC:/* 'BrtTable' */case 0x00AA:/* 'BrtTop10Filter' */case 0x0C00:/* 'BrtUid' */case 0x0032:/* 'BrtValueMeta' */case 0x0816:/* 'BrtWebExtension' */case 0x0415:/* 'BrtWsFmtInfoEx14' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;case 0x0025:pass=true;break;case 0x0026:pass=false;break;default:if((R_n||"").indexOf("Begin")>0);else if((R_n||"").indexOf("End")>0);else if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R_n);}},opts);delete opts.supbooks;delete opts['!row'];if(!s["!ref"]&&(refguess.s.r<2000000||ref&&(ref.e.r>0||ref.e.c>0||ref.s.r>0||ref.s.c>0)))s["!ref"]=encode_range(ref||refguess);if(opts.sheetRows&&s["!ref"]){var tmpref=safe_decode_range(s["!ref"]);if(opts.sheetRows<=+tmpref.e.r){tmpref.e.r=opts.sheetRows-1;if(tmpref.e.r>refguess.e.r)tmpref.e.r=refguess.e.r;if(tmpref.e.r<tmpref.s.r)tmpref.s.r=tmpref.e.r;if(tmpref.e.c>refguess.e.c)tmpref.e.c=refguess.e.c;if(tmpref.e.c<tmpref.s.c)tmpref.s.c=tmpref.e.c;s["!fullref"]=s["!ref"];s["!ref"]=encode_range(tmpref);}}if(merges.length>0)s["!merges"]=merges;if(colinfo.length>0)s["!cols"]=colinfo;if(rowinfo.length>0)s["!rows"]=rowinfo;return s;}/* TODO: something useful -- this is a stub */function write_ws_bin_cell(ba,cell,R,C,opts,ws,last_seen){if(cell.v===undefined)return false;var vv="";switch(cell.t){case'b':vv=cell.v?"1":"0";break;case'd':// no BrtCellDate :(
cell=dup(cell);cell.z=cell.z||SSF._table[14];cell.v=datenum(parseDate(cell.v));cell.t='n';break;/* falls through */case'n':case'e':vv=''+cell.v;break;default:vv=cell.v;break;}var o={r:R,c:C};/* TODO: cell style */o.s=get_cell_style(opts.cellXfs,cell,opts);if(cell.l)ws['!links'].push([encode_cell(o),cell.l]);if(cell.c)ws['!comments'].push([encode_cell(o),cell.c]);switch(cell.t){case's':case'str':if(opts.bookSST){vv=get_sst_id(opts.Strings,cell.v,opts.revStrings);o.t="s";o.v=vv;if(last_seen)write_record(ba,"BrtShortIsst",write_BrtShortIsst(cell,o));else write_record(ba,"BrtCellIsst",write_BrtCellIsst(cell,o));}else {o.t="str";if(last_seen)write_record(ba,"BrtShortSt",write_BrtShortSt(cell,o));else write_record(ba,"BrtCellSt",write_BrtCellSt(cell,o));}return true;case'n':/* TODO: determine threshold for Real vs RK */if(cell.v==(cell.v|0)&&cell.v>-1000&&cell.v<1000){if(last_seen)write_record(ba,"BrtShortRk",write_BrtShortRk(cell,o));else write_record(ba,"BrtCellRk",write_BrtCellRk(cell,o));}else {if(last_seen)write_record(ba,"BrtShortReal",write_BrtShortReal(cell,o));else write_record(ba,"BrtCellReal",write_BrtCellReal(cell,o));}return true;case'b':o.t="b";if(last_seen)write_record(ba,"BrtShortBool",write_BrtShortBool(cell,o));else write_record(ba,"BrtCellBool",write_BrtCellBool(cell,o));return true;case'e':o.t="e";if(last_seen)write_record(ba,"BrtShortError",write_BrtShortError(cell,o));else write_record(ba,"BrtCellError",write_BrtCellError(cell,o));return true;}if(last_seen)write_record(ba,"BrtShortBlank",write_BrtShortBlank(cell,o));else write_record(ba,"BrtCellBlank",write_BrtCellBlank(cell,o));return true;}function write_CELLTABLE(ba,ws,idx,opts){var range=safe_decode_range(ws['!ref']||"A1"),ref,rr="",cols=[];write_record(ba,'BrtBeginSheetData');var dense=Array.isArray(ws);var cap=range.e.r;if(ws['!rows'])cap=Math.max(range.e.r,ws['!rows'].length-1);for(var R=range.s.r;R<=cap;++R){rr=encode_row(R);/* [ACCELLTABLE] */ /* BrtRowHdr */write_row_header(ba,ws,range,R);var last_seen=false;if(R<=range.e.r)for(var C=range.s.c;C<=range.e.c;++C){/* *16384CELL */if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell){last_seen=false;continue;}/* write cell */last_seen=write_ws_bin_cell(ba,cell,R,C,opts,ws,last_seen);}}write_record(ba,'BrtEndSheetData');}function write_MERGECELLS(ba,ws){if(!ws||!ws['!merges'])return;write_record(ba,'BrtBeginMergeCells',write_BrtBeginMergeCells(ws['!merges'].length));ws['!merges'].forEach(function(m){write_record(ba,'BrtMergeCell',write_BrtMergeCell(m));});write_record(ba,'BrtEndMergeCells');}function write_COLINFOS(ba,ws){if(!ws||!ws['!cols'])return;write_record(ba,'BrtBeginColInfos');ws['!cols'].forEach(function(m,i){if(m)write_record(ba,'BrtColInfo',write_BrtColInfo(i,m));});write_record(ba,'BrtEndColInfos');}function write_IGNOREECS(ba,ws){if(!ws||!ws['!ref'])return;write_record(ba,'BrtBeginCellIgnoreECs');write_record(ba,'BrtCellIgnoreEC',write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));write_record(ba,'BrtEndCellIgnoreECs');}function write_HLINKS(ba,ws,rels){/* *BrtHLink */ws['!links'].forEach(function(l){if(!l[1].Target)return;var rId=add_rels(rels,-1,l[1].Target.replace(/#.*$/,""),RELS.HLINK);write_record(ba,"BrtHLink",write_BrtHLink(l,rId));});delete ws['!links'];}function write_LEGACYDRAWING(ba,ws,idx,rels){/* [BrtLegacyDrawing] */if(ws['!comments'].length>0){var rId=add_rels(rels,-1,"../drawings/vmlDrawing"+(idx+1)+".vml",RELS.VML);write_record(ba,"BrtLegacyDrawing",write_RelID("rId"+rId));ws['!legacy']=rId;}}function write_AUTOFILTER(ba,ws,wb,idx){if(!ws['!autofilter'])return;var data=ws['!autofilter'];var ref=typeof data.ref==="string"?data.ref:encode_range(data.ref);/* Update FilterDatabase defined name for the worksheet */if(!wb.Workbook)wb.Workbook={Sheets:[]};if(!wb.Workbook.Names)wb.Workbook.Names=[];var names=wb.Workbook.Names;var range=decode_range(ref);if(range.s.r==range.e.r){range.e.r=decode_range(ws["!ref"]).e.r;ref=encode_range(range);}for(var i=0;i<names.length;++i){var name=names[i];if(name.Name!='_xlnm._FilterDatabase')continue;if(name.Sheet!=idx)continue;name.Ref="'"+wb.SheetNames[idx]+"'!"+ref;break;}if(i==names.length)names.push({Name:'_xlnm._FilterDatabase',Sheet:idx,Ref:"'"+wb.SheetNames[idx]+"'!"+ref});write_record(ba,"BrtBeginAFilter",write_UncheckedRfX(safe_decode_range(ref)));/* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */write_record(ba,"BrtEndAFilter");}function write_WSVIEWS2(ba,ws,Workbook){write_record(ba,"BrtBeginWsViews");{/* 1*WSVIEW2 */ /* [ACUID] */write_record(ba,"BrtBeginWsView",write_BrtBeginWsView(ws,Workbook));/* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */write_record(ba,"BrtEndWsView");}/* *FRT */write_record(ba,"BrtEndWsViews");}function write_SHEETPROTECT(ba,ws){if(!ws['!protect'])return;/* [BrtSheetProtectionIso] */write_record(ba,"BrtSheetProtection",write_BrtSheetProtection(ws['!protect']));}function write_ws_bin(idx,opts,wb,rels){var ba=buf_array();var s=wb.SheetNames[idx],ws=wb.Sheets[s]||{};var c=s;try{if(wb&&wb.Workbook)c=wb.Workbook.Sheets[idx].CodeName||c;}catch(e){}var r=safe_decode_range(ws['!ref']||"A1");if(r.e.c>0x3FFF||r.e.r>0xFFFFF){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:XFD1048576");r.e.c=Math.min(r.e.c,0x3FFF);r.e.r=Math.min(r.e.c,0xFFFFF);}ws['!links']=[];/* passed back to write_zip and removed there */ws['!comments']=[];write_record(ba,"BrtBeginSheet");if(wb.vbaraw)write_record(ba,"BrtWsProp",write_BrtWsProp(c));write_record(ba,"BrtWsDim",write_BrtWsDim(r));write_WSVIEWS2(ba,ws,wb.Workbook);write_COLINFOS(ba,ws);write_CELLTABLE(ba,ws,idx,opts);/* [BrtSheetCalcProp] */write_SHEETPROTECT(ba,ws);/* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */write_AUTOFILTER(ba,ws,wb,idx);/* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */write_MERGECELLS(ba,ws);/* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */write_HLINKS(ba,ws,rels);/* [BrtPrintOptions] */if(ws['!margins'])write_record(ba,"BrtMargins",write_BrtMargins(ws['!margins']));/* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */if(!opts||opts.ignoreEC||opts.ignoreEC==void 0)write_IGNOREECS(ba,ws);/* [SMARTTAGS] */ /* [BrtDrawing] */write_LEGACYDRAWING(ba,ws,idx,rels);/* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */write_record(ba,"BrtEndSheet");return ba.end();}RELS.CHART="http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart";RELS.CHARTEX="http://schemas.microsoft.com/office/2014/relationships/chartEx";function parse_Cache(data){var col=[];var num=data.match(/^<c:numCache>/);var f;/* 21.2.2.150 pt CT_NumVal */(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt){var q=pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);if(!q)return;col[+q[1]]=num?+q[2]:q[2];});/* 21.2.2.71 formatCode CT_Xstring */var nf=unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/)||["","General"])[1]);(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F){f=F.replace(/<.*?>/g,"");});return [col,nf,f];}/* 21.2 DrawingML - Charts */function parse_chart(data,name,opts,rels,wb,csheet){var cs=csheet||{"!type":"chart"};if(!data)return csheet;/* 21.2.2.27 chart CT_Chart */var C=0,R=0,col="A";var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};/* 21.2.2.120 numCache CT_NumData */(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc){var cache=parse_Cache(nc);refguess.s.r=refguess.s.c=0;refguess.e.c=C;col=encode_col(C);cache[0].forEach(function(n,i){cs[col+encode_row(i)]={t:'n',v:n,z:cache[1]};R=i;});if(refguess.e.r<R)refguess.e.r=R;++C;});if(C>0)cs["!ref"]=encode_range(refguess);return cs;}RELS.CS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";var CS_XML_ROOT=writextag('chartsheet',null,{'xmlns':XMLNS.main[0],'xmlns:r':XMLNS.r});/* 18.3 Worksheets also covers Chartsheets */function parse_cs_xml(data,opts,idx,rels,wb){if(!data)return data;/* 18.3.1.12 chartsheet CT_ChartSheet */if(!rels)rels={'!id':{}};var s={'!type':"chart",'!drawel':null,'!rel':""};var m;/* 18.3.1.83 sheetPr CT_ChartsheetPr */var sheetPr=data.match(sheetprregex);if(sheetPr)parse_ws_xml_sheetpr(sheetPr[0],s,wb,idx);/* 18.3.1.36 drawing CT_Drawing */if(m=data.match(/drawing r:id="(.*?)"/))s['!rel']=m[1];if(rels['!id'][s['!rel']])s['!drawel']=rels['!id'][s['!rel']];return s;}/* [MS-XLSB] 2.4.331 BrtCsProp */function parse_BrtCsProp(data,length){data.l+=10;var name=parse_XLWideString(data);return {name:name};}/* [MS-XLSB] 2.1.7.7 Chart Sheet */function parse_cs_bin(data,opts,idx,rels,wb){if(!data)return data;if(!rels)rels={'!id':{}};var s={'!type':"chart",'!drawel':null,'!rel':""};var pass=false;recordhopper(data,function cs_parse(val,R_n,RT){switch(RT){case 0x0226:/* 'BrtDrawing' */s['!rel']=val;break;case 0x028B:/* 'BrtCsProp' */if(!wb.Sheets[idx])wb.Sheets[idx]={};if(val.name)wb.Sheets[idx].CodeName=val.name;break;case 0x0232:/* 'BrtBkHim' */case 0x028C:/* 'BrtCsPageSetup' */case 0x029D:/* 'BrtCsProtection' */case 0x02A7:/* 'BrtCsProtectionIso' */case 0x0227:/* 'BrtLegacyDrawing' */case 0x0228:/* 'BrtLegacyDrawingHF' */case 0x01DC:/* 'BrtMargins' */case 0x0C00:/* 'BrtUid' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;case 0x0025:break;case 0x0026:break;default:if((R_n||"").indexOf("Begin")>0);else if((R_n||"").indexOf("End")>0);else if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R_n);}},opts);if(rels['!id'][s['!rel']])s['!drawel']=rels['!id'][s['!rel']];return s;}/* 18.2.28 (CT_WorkbookProtection) Defaults */var WBPropsDef=[['allowRefreshQuery',false,"bool"],['autoCompressPictures',true,"bool"],['backupFile',false,"bool"],['checkCompatibility',false,"bool"],['CodeName',''],['date1904',false,"bool"],['defaultThemeVersion',0,"int"],['filterPrivacy',false,"bool"],['hidePivotFieldList',false,"bool"],['promptedSolutions',false,"bool"],['publishItems',false,"bool"],['refreshAllConnections',false,"bool"],['saveExternalLinkValues',true,"bool"],['showBorderUnselectedTables',true,"bool"],['showInkAnnotation',true,"bool"],['showObjects','all'],['showPivotChartFilter',false,"bool"],['updateLinks','userSet']];/* 18.2.30 (CT_BookView) Defaults */var WBViewDef=[['activeTab',0,"int"],['autoFilterDateGrouping',true,"bool"],['firstSheet',0,"int"],['minimized',false,"bool"],['showHorizontalScroll',true,"bool"],['showSheetTabs',true,"bool"],['showVerticalScroll',true,"bool"],['tabRatio',600,"int"],['visibility','visible']//window{Height,Width}, {x,y}Window
];/* 18.2.19 (CT_Sheet) Defaults */var SheetDef=[//['state', 'visible']
];/* 18.2.2  (CT_CalcPr) Defaults */var CalcPrDef=[['calcCompleted','true'],['calcMode','auto'],['calcOnSave','true'],['concurrentCalc','true'],['fullCalcOnLoad','false'],['fullPrecision','true'],['iterate','false'],['iterateCount','100'],['iterateDelta','0.001'],['refMode','A1']];/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/function push_defaults_array(target,defaults){for(var j=0;j!=target.length;++j){var w=target[j];for(var i=0;i!=defaults.length;++i){var z=defaults[i];if(w[z[0]]==null)w[z[0]]=z[1];else switch(z[2]){case"bool":if(typeof w[z[0]]=="string")w[z[0]]=parsexmlbool(w[z[0]]);break;case"int":if(typeof w[z[0]]=="string")w[z[0]]=parseInt(w[z[0]],10);break;}}}}function push_defaults(target,defaults){for(var i=0;i!=defaults.length;++i){var z=defaults[i];if(target[z[0]]==null)target[z[0]]=z[1];else switch(z[2]){case"bool":if(typeof target[z[0]]=="string")target[z[0]]=parsexmlbool(target[z[0]]);break;case"int":if(typeof target[z[0]]=="string")target[z[0]]=parseInt(target[z[0]],10);break;}}}function parse_wb_defaults(wb){push_defaults(wb.WBProps,WBPropsDef);push_defaults(wb.CalcPr,CalcPrDef);push_defaults_array(wb.WBView,WBViewDef);push_defaults_array(wb.Sheets,SheetDef);_ssfopts.date1904=parsexmlbool(wb.WBProps.date1904);}function safe1904(wb){/* TODO: store date1904 somewhere else */if(!wb.Workbook)return "false";if(!wb.Workbook.WBProps)return "false";return parsexmlbool(wb.Workbook.WBProps.date1904)?"true":"false";}var badchars="][*?\/\\".split("");function check_ws_name(n,safe){if(n.length>31){if(safe)return false;throw new Error("Sheet names cannot exceed 31 chars");}var _good=true;badchars.forEach(function(c){if(n.indexOf(c)==-1)return;if(!safe)throw new Error("Sheet name cannot contain : \\ / ? * [ ]");_good=false;});return _good;}function check_wb_names(N,S,codes){N.forEach(function(n,i){check_ws_name(n);for(var j=0;j<i;++j)if(n==N[j])throw new Error("Duplicate Sheet Name: "+n);if(codes){var cn=S&&S[i]&&S[i].CodeName||n;if(cn.charCodeAt(0)==95&&cn.length>22)throw new Error("Bad Code Name: Worksheet"+cn);}});}function check_wb(wb){if(!wb||!wb.SheetNames||!wb.Sheets)throw new Error("Invalid Workbook");if(!wb.SheetNames.length)throw new Error("Workbook is empty");var Sheets=wb.Workbook&&wb.Workbook.Sheets||[];check_wb_names(wb.SheetNames,Sheets,!!wb.vbaraw);for(var i=0;i<wb.SheetNames.length;++i)check_ws(wb.Sheets[wb.SheetNames[i]],wb.SheetNames[i],i);/* TODO: validate workbook */}/* 18.2 Workbook */var wbnsregex=/<\w+:workbook/;function parse_wb_xml(data,opts){if(!data)throw new Error("Could not find file");var wb={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},Names:[],xmlns:""};var pass=false,xmlns="xmlns";var dname={},dnstart=0;data.replace(tagregex,function xml_wb(x,idx){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;/* 18.2.27 workbook CT_Workbook 1 */case'<workbook':if(x.match(wbnsregex))xmlns="xmlns"+x.match(/<(\w+):/)[1];wb.xmlns=y[xmlns];break;case'</workbook>':break;/* 18.2.13 fileVersion CT_FileVersion ? */case'<fileVersion':delete y[0];wb.AppVersion=y;break;case'<fileVersion/>':case'</fileVersion>':break;/* 18.2.12 fileSharing CT_FileSharing ? */case'<fileSharing':break;case'<fileSharing/>':break;/* 18.2.28 workbookPr CT_WorkbookPr ? */case'<workbookPr':case'<workbookPr/>':WBPropsDef.forEach(function(w){if(y[w[0]]==null)return;switch(w[2]){case"bool":wb.WBProps[w[0]]=parsexmlbool(y[w[0]]);break;case"int":wb.WBProps[w[0]]=parseInt(y[w[0]],10);break;default:wb.WBProps[w[0]]=y[w[0]];}});if(y.codeName)wb.WBProps.CodeName=utf8read(y.codeName);break;case'</workbookPr>':break;/* 18.2.29 workbookProtection CT_WorkbookProtection ? */case'<workbookProtection':break;case'<workbookProtection/>':break;/* 18.2.1  bookViews CT_BookViews ? */case'<bookViews':case'<bookViews>':case'</bookViews>':break;/* 18.2.30   workbookView CT_BookView + */case'<workbookView':case'<workbookView/>':delete y[0];wb.WBView.push(y);break;case'</workbookView>':break;/* 18.2.20 sheets CT_Sheets 1 */case'<sheets':case'<sheets>':case'</sheets>':break;// aggregate sheet
/* 18.2.19   sheet CT_Sheet + */case'<sheet':switch(y.state){case"hidden":y.Hidden=1;break;case"veryHidden":y.Hidden=2;break;default:y.Hidden=0;}delete y.state;y.name=unescapexml(utf8read(y.name));delete y[0];wb.Sheets.push(y);break;case'</sheet>':break;/* 18.2.15 functionGroups CT_FunctionGroups ? */case'<functionGroups':case'<functionGroups/>':break;/* 18.2.14   functionGroup CT_FunctionGroup + */case'<functionGroup':break;/* 18.2.9  externalReferences CT_ExternalReferences ? */case'<externalReferences':case'</externalReferences>':case'<externalReferences>':break;/* 18.2.8    externalReference CT_ExternalReference + */case'<externalReference':break;/* 18.2.6  definedNames CT_DefinedNames ? */case'<definedNames/>':break;case'<definedNames>':case'<definedNames':pass=true;break;case'</definedNames>':pass=false;break;/* 18.2.5    definedName CT_DefinedName + */case'<definedName':{dname={};dname.Name=utf8read(y.name);if(y.comment)dname.Comment=y.comment;if(y.localSheetId)dname.Sheet=+y.localSheetId;if(parsexmlbool(y.hidden||"0"))dname.Hidden=true;dnstart=idx+x.length;}break;case'</definedName>':{dname.Ref=unescapexml(utf8read(data.slice(dnstart,idx)));wb.Names.push(dname);}break;case'<definedName/>':break;/* 18.2.2  calcPr CT_CalcPr ? */case'<calcPr':delete y[0];wb.CalcPr=y;break;case'<calcPr/>':delete y[0];wb.CalcPr=y;break;case'</calcPr>':break;/* 18.2.16 oleSize CT_OleSize ? (ref required) */case'<oleSize':break;/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */case'<customWorkbookViews>':case'</customWorkbookViews>':case'<customWorkbookViews':break;/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */case'<customWorkbookView':case'</customWorkbookView>':break;/* 18.2.18 pivotCaches CT_PivotCaches ? */case'<pivotCaches>':case'</pivotCaches>':case'<pivotCaches':break;/* 18.2.17 pivotCache CT_PivotCache ? */case'<pivotCache':break;/* 18.2.21 smartTagPr CT_SmartTagPr ? */case'<smartTagPr':case'<smartTagPr/>':break;/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */case'<smartTagTypes':case'<smartTagTypes>':case'</smartTagTypes>':break;/* 18.2.22 smartTagType CT_SmartTagType ? */case'<smartTagType':break;/* 18.2.24 webPublishing CT_WebPublishing ? */case'<webPublishing':case'<webPublishing/>':break;/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */case'<fileRecoveryPr':case'<fileRecoveryPr/>':break;/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */case'<webPublishObjects>':case'<webPublishObjects':case'</webPublishObjects>':break;/* 18.2.25 webPublishObject CT_WebPublishObject ? */case'<webPublishObject':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':case'<extLst/>':break;/* 18.2.7  ext CT_Extension + */case'<ext':pass=true;break;//TODO: check with versions of excel
case'</ext>':pass=false;break;/* Others */case'<ArchID':break;case'<AlternateContent':case'<AlternateContent>':pass=true;break;case'</AlternateContent>':pass=false;break;/* TODO */case'<revisionPtr':break;default:if(!pass&&opts.WTF)throw new Error('unrecognized '+y[0]+' in workbook');}return x;});if(XMLNS.main.indexOf(wb.xmlns)===-1)throw new Error("Unknown Namespace: "+wb.xmlns);parse_wb_defaults(wb);return wb;}var WB_XML_ROOT=writextag('workbook',null,{'xmlns':XMLNS.main[0],//'xmlns:mx': XMLNS.mx,
//'xmlns:s': XMLNS.main[0],
'xmlns:r':XMLNS.r});function write_wb_xml(wb){var o=[XML_HEADER];o[o.length]=WB_XML_ROOT;var write_names=wb.Workbook&&(wb.Workbook.Names||[]).length>0;/* fileVersion */ /* fileSharing */var workbookPr={codeName:"ThisWorkbook"};if(wb.Workbook&&wb.Workbook.WBProps){WBPropsDef.forEach(function(x){if(wb.Workbook.WBProps[x[0]]==null)return;if(wb.Workbook.WBProps[x[0]]==x[1])return;workbookPr[x[0]]=wb.Workbook.WBProps[x[0]];});if(wb.Workbook.WBProps.CodeName){workbookPr.codeName=wb.Workbook.WBProps.CodeName;delete workbookPr.CodeName;}}o[o.length]=writextag('workbookPr',null,workbookPr);/* workbookProtection */var sheets=wb.Workbook&&wb.Workbook.Sheets||[];var i=0;/* bookViews only written if first worksheet is hidden */if(sheets&&sheets[0]&&!!sheets[0].Hidden){o[o.length]="<bookViews>";for(i=0;i!=wb.SheetNames.length;++i){if(!sheets[i])break;if(!sheets[i].Hidden)break;}if(i==wb.SheetNames.length)i=0;o[o.length]='<workbookView firstSheet="'+i+'" activeTab="'+i+'"/>';o[o.length]="</bookViews>";}o[o.length]="<sheets>";for(i=0;i!=wb.SheetNames.length;++i){var sht={name:escapexml(wb.SheetNames[i].slice(0,31))};sht.sheetId=""+(i+1);sht["r:id"]="rId"+(i+1);if(sheets[i])switch(sheets[i].Hidden){case 1:sht.state="hidden";break;case 2:sht.state="veryHidden";break;}o[o.length]=writextag('sheet',null,sht);}o[o.length]="</sheets>";/* functionGroups */ /* externalReferences */if(write_names){o[o.length]="<definedNames>";if(wb.Workbook&&wb.Workbook.Names)wb.Workbook.Names.forEach(function(n){var d={name:n.Name};if(n.Comment)d.comment=n.Comment;if(n.Sheet!=null)d.localSheetId=""+n.Sheet;if(n.Hidden)d.hidden="1";if(!n.Ref)return;o[o.length]=writextag('definedName',escapexml(n.Ref),d);});o[o.length]="</definedNames>";}/* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */if(o.length>2){o[o.length]='</workbook>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.304 BrtBundleSh */function parse_BrtBundleSh(data,length){var z={};z.Hidden=data.read_shift(4);//hsState ST_SheetState
z.iTabID=data.read_shift(4);z.strRelID=parse_RelID(data);z.name=parse_XLWideString(data);return z;}function write_BrtBundleSh(data,o){if(!o)o=new_buf(127);o.write_shift(4,data.Hidden);o.write_shift(4,data.iTabID);write_RelID(data.strRelID,o);write_XLWideString(data.name.slice(0,31),o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.815 BrtWbProp */function parse_BrtWbProp(data,length){var o={};var flags=data.read_shift(4);o.defaultThemeVersion=data.read_shift(4);var strName=length>8?parse_XLWideString(data):"";if(strName.length>0)o.CodeName=strName;o.autoCompressPictures=!!(flags&0x10000);o.backupFile=!!(flags&0x40);o.checkCompatibility=!!(flags&0x1000);o.date1904=!!(flags&0x01);o.filterPrivacy=!!(flags&0x08);o.hidePivotFieldList=!!(flags&0x400);o.promptedSolutions=!!(flags&0x10);o.publishItems=!!(flags&0x800);o.refreshAllConnections=!!(flags&0x40000);o.saveExternalLinkValues=!!(flags&0x80);o.showBorderUnselectedTables=!!(flags&0x04);o.showInkAnnotation=!!(flags&0x20);o.showObjects=["all","placeholders","none"][flags>>13&0x03];o.showPivotChartFilter=!!(flags&0x8000);o.updateLinks=["userSet","never","always"][flags>>8&0x03];return o;}function write_BrtWbProp(data,o){if(!o)o=new_buf(72);var flags=0;if(data){/* TODO: mirror parse_BrtWbProp fields */if(data.filterPrivacy)flags|=0x08;}o.write_shift(4,flags);o.write_shift(4,0);write_XLSBCodeName(data&&data.CodeName||"ThisWorkbook",o);return o.slice(0,o.l);}function parse_BrtFRTArchID$(data,length){var o={};data.read_shift(4);o.ArchID=data.read_shift(4);data.l+=length-8;return o;}/* [MS-XLSB] 2.4.687 BrtName */function parse_BrtName(data,length,opts){var end=data.l+length;data.l+=4;//var flags = data.read_shift(4);
data.l+=1;//var chKey = data.read_shift(1);
var itab=data.read_shift(4);var name=parse_XLNameWideString(data);var formula=parse_XLSBNameParsedFormula(data,0,opts);var comment=parse_XLNullableWideString(data);//if(0 /* fProc */) {
// unusedstring1: XLNullableWideString
// description: XLNullableWideString
// helpTopic: XLNullableWideString
// unusedstring2: XLNullableWideString
//}
data.l=end;var out={Name:name,Ptg:formula};if(itab<0xFFFFFFF)out.Sheet=itab;if(comment)out.Comment=comment;return out;}/* [MS-XLSB] 2.1.7.61 Workbook */function parse_wb_bin(data,opts){var wb={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},xmlns:""};var state=[];var pass=false;if(!opts)opts={};opts.biff=12;var Names=[];var supbooks=[[]];supbooks.SheetNames=[];supbooks.XTI=[];XLSBRecordEnum[0x0010]={n:"BrtFRTArchID$",f:parse_BrtFRTArchID$};recordhopper(data,function hopper_wb(val,R_n,RT){switch(RT){case 0x009C:/* 'BrtBundleSh' */supbooks.SheetNames.push(val.name);wb.Sheets.push(val);break;case 0x0099:/* 'BrtWbProp' */wb.WBProps=val;break;case 0x0027:/* 'BrtName' */if(val.Sheet!=null)opts.SID=val.Sheet;val.Ref=stringify_formula(val.Ptg,null,null,supbooks,opts);delete opts.SID;delete val.Ptg;Names.push(val);break;case 0x040C:/* 'BrtNameExt' */break;case 0x0165:/* 'BrtSupSelf' */case 0x0166:/* 'BrtSupSame' */case 0x0163:/* 'BrtSupBookSrc' */case 0x029B:/* 'BrtSupAddin' */if(!supbooks[0].length)supbooks[0]=[RT,val];else supbooks.push([RT,val]);supbooks[supbooks.length-1].XTI=[];break;case 0x016A:/* 'BrtExternSheet' */if(supbooks.length===0){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].XTI=supbooks[supbooks.length-1].XTI.concat(val);supbooks.XTI=supbooks.XTI.concat(val);break;case 0x0169:/* 'BrtPlaceholderName' */break;case 0x0817:/* 'BrtAbsPath15' */case 0x009E:/* 'BrtBookView' */case 0x008F:/* 'BrtBeginBundleShs' */case 0x0298:/* 'BrtBeginFnGroup' */case 0x0161:/* 'BrtBeginExternals' */break;/* case 'BrtModelTimeGroupingCalcCol' */case 0x0C00:/* 'BrtUid' */case 0x0C01:/* 'BrtRevisionPtr' */case 0x0216:/* 'BrtBookProtection' */case 0x02A5:/* 'BrtBookProtectionIso' */case 0x009D:/* 'BrtCalcProp' */case 0x0262:/* 'BrtCrashRecErr' */case 0x0802:/* 'BrtDecoupledPivotCacheID' */case 0x009B:/* 'BrtFileRecover' */case 0x0224:/* 'BrtFileSharing' */case 0x02A4:/* 'BrtFileSharingIso' */case 0x0080:/* 'BrtFileVersion' */case 0x0299:/* 'BrtFnGroup' */case 0x0850:/* 'BrtModelRelationship' */case 0x084D:/* 'BrtModelTable' */case 0x0225:/* 'BrtOleSize' */case 0x0805:/* 'BrtPivotTableRef' */case 0x0254:/* 'BrtSmartTagType' */case 0x081C:/* 'BrtTableSlicerCacheID' */case 0x081B:/* 'BrtTableSlicerCacheIDs' */case 0x0822:/* 'BrtTimelineCachePivotCacheID' */case 0x018D:/* 'BrtUserBookView' */case 0x009A:/* 'BrtWbFactoid' */case 0x045D:/* 'BrtWbProp14' */case 0x0229:/* 'BrtWebOpt' */case 0x082B:/* 'BrtWorkBookPr15' */break;case 0x0023:/* 'BrtFRTBegin' */state.push(R_n);pass=true;break;case 0x0024:/* 'BrtFRTEnd' */state.pop();pass=false;break;case 0x0025:/* 'BrtACBegin' */state.push(R_n);pass=true;break;case 0x0026:/* 'BrtACEnd' */state.pop();pass=false;break;case 0x0010:/* 'BrtFRTArchID$' */break;default:if((R_n||"").indexOf("Begin")>0);else if((R_n||"").indexOf("End")>0);else if(!pass||opts.WTF&&state[state.length-1]!="BrtACBegin"&&state[state.length-1]!="BrtFRTBegin")throw new Error("Unexpected record "+RT+" "+R_n);}},opts);parse_wb_defaults(wb);// $FlowIgnore
wb.Names=Names;wb.supbooks=supbooks;return wb;}function write_BUNDLESHS(ba,wb){write_record(ba,"BrtBeginBundleShs");for(var idx=0;idx!=wb.SheetNames.length;++idx){var viz=wb.Workbook&&wb.Workbook.Sheets&&wb.Workbook.Sheets[idx]&&wb.Workbook.Sheets[idx].Hidden||0;var d={Hidden:viz,iTabID:idx+1,strRelID:'rId'+(idx+1),name:wb.SheetNames[idx]};write_record(ba,"BrtBundleSh",write_BrtBundleSh(d));}write_record(ba,"BrtEndBundleShs");}/* [MS-XLSB] 2.4.649 BrtFileVersion */function write_BrtFileVersion(data,o){if(!o)o=new_buf(127);for(var i=0;i!=4;++i)o.write_shift(4,0);write_XLWideString("SheetJS",o);write_XLWideString(XLSX.version,o);write_XLWideString(XLSX.version,o);write_XLWideString("7262",o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.301 BrtBookView */function write_BrtBookView(idx,o){if(!o)o=new_buf(29);o.write_shift(-4,0);o.write_shift(-4,460);o.write_shift(4,28800);o.write_shift(4,17600);o.write_shift(4,500);o.write_shift(4,idx);o.write_shift(4,idx);var flags=0x78;o.write_shift(1,flags);return o.length>o.l?o.slice(0,o.l):o;}function write_BOOKVIEWS(ba,wb){/* required if hidden tab appears before visible tab */if(!wb.Workbook||!wb.Workbook.Sheets)return;var sheets=wb.Workbook.Sheets;var i=0,vistab=-1,hidden=-1;for(;i<sheets.length;++i){if(!sheets[i]||!sheets[i].Hidden&&vistab==-1)vistab=i;else if(sheets[i].Hidden==1&&hidden==-1)hidden=i;}if(hidden>vistab)return;write_record(ba,"BrtBeginBookViews");write_record(ba,"BrtBookView",write_BrtBookView(vistab));/* 1*(BrtBookView *FRT) */write_record(ba,"BrtEndBookViews");}/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */function write_wb_bin(wb,opts){var ba=buf_array();write_record(ba,"BrtBeginBook");write_record(ba,"BrtFileVersion",write_BrtFileVersion());/* [[BrtFileSharingIso] BrtFileSharing] */write_record(ba,"BrtWbProp",write_BrtWbProp(wb.Workbook&&wb.Workbook.WBProps||null));/* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */write_BOOKVIEWS(ba,wb);write_BUNDLESHS(ba,wb);/* [FNGROUP] */ /* [EXTERNALS] */ /* *BrtName */ /* write_record(ba, "BrtCalcProp", write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, "BrtFileRecover", write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */write_record(ba,"BrtEndBook");return ba.end();}function parse_wb(data,name,opts){if(name.slice(-4)===".bin")return parse_wb_bin(data,opts);return parse_wb_xml(data,opts);}function parse_ws(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_ws_bin(data,opts,idx,rels,wb,themes,styles);return parse_ws_xml(data,opts,idx,rels,wb,themes,styles);}function parse_cs(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_cs_bin(data,opts,idx,rels,wb);return parse_cs_xml(data,opts,idx,rels,wb);}function parse_ms(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_ms_bin();return parse_ms_xml();}function parse_ds(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_ds_bin();return parse_ds_xml();}function parse_sty(data,name,themes,opts){if(name.slice(-4)===".bin")return parse_sty_bin(data,themes,opts);return parse_sty_xml(data,themes,opts);}function parse_theme(data,name,opts){return parse_theme_xml(data,opts);}function parse_sst(data,name,opts){if(name.slice(-4)===".bin")return parse_sst_bin(data,opts);return parse_sst_xml(data,opts);}function parse_cmnt(data,name,opts){if(name.slice(-4)===".bin")return parse_comments_bin(data,opts);return parse_comments_xml(data,opts);}function parse_cc(data,name,opts){if(name.slice(-4)===".bin")return parse_cc_bin(data);return parse_cc_xml(data);}function parse_xlink(data,rel,name,opts){if(name.slice(-4)===".bin")return parse_xlink_bin(data,rel,name,opts);return parse_xlink_xml();}function write_wb(wb,name,opts){return (name.slice(-4)===".bin"?write_wb_bin:write_wb_xml)(wb,opts);}function write_ws(data,name,opts,wb,rels){return (name.slice(-4)===".bin"?write_ws_bin:write_ws_xml)(data,opts,wb,rels);}// eslint-disable-next-line no-unused-vars
function write_sty(data,name,opts){return (name.slice(-4)===".bin"?write_sty_bin:write_sty_xml)(data,opts);}function write_sst(data,name,opts){return (name.slice(-4)===".bin"?write_sst_bin:write_sst_xml)(data,opts);}function write_cmnt(data,name,opts){return (name.slice(-4)===".bin"?write_comments_bin:write_comments_xml)(data,opts);}/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;function xlml_parsexmltag(tag,skip_root){var words=tag.split(/\s+/);var z=[];if(!skip_root)z[0]=words[0];if(words.length===1)return z;var m=tag.match(attregexg2),y,j,w,i;if(m)for(i=0;i!=m.length;++i){y=m[i].match(attregex2);if((j=y[1].indexOf(":"))===-1)z[y[1]]=y[2].slice(1,y[2].length-1);else {if(y[1].slice(0,6)==="xmlns:")w="xmlns"+y[1].slice(6);else w=y[1].slice(j+1);z[w]=y[2].slice(1,y[2].length-1);}}return z;}function xlml_parsexmltagobj(tag){var words=tag.split(/\s+/);var z={};if(words.length===1)return z;var m=tag.match(attregexg2),y,j,w,i;if(m)for(i=0;i!=m.length;++i){y=m[i].match(attregex2);if((j=y[1].indexOf(":"))===-1)z[y[1]]=y[2].slice(1,y[2].length-1);else {if(y[1].slice(0,6)==="xmlns:")w="xmlns"+y[1].slice(6);else w=y[1].slice(j+1);z[w]=y[2].slice(1,y[2].length-1);}}return z;}// ----
function xlml_format(format,value){var fmt=XLMLFormatMap[format]||unescapexml(format);if(fmt==="General")return SSF._general(value);return SSF.format(fmt,value);}function xlml_set_custprop(Custprops,key,cp,val){var oval=val;switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]){case"boolean":oval=parsexmlbool(val);break;case"i2":case"int":oval=parseInt(val,10);break;case"r4":case"float":oval=parseFloat(val);break;case"date":case"dateTime.tz":oval=parseDate(val);break;case"i8":case"string":case"fixed":case"uuid":case"bin.base64":break;default:throw new Error("bad custprop:"+cp[0]);}Custprops[unescapexml(key)]=oval;}function safe_format_xlml(cell,nf,o){if(cell.t==='z')return;if(!o||o.cellText!==false)try{if(cell.t==='e'){cell.w=cell.w||BErr[cell.v];}else if(nf==="General"){if(cell.t==='n'){if((cell.v|0)===cell.v)cell.w=SSF._general_int(cell.v);else cell.w=SSF._general_num(cell.v);}else cell.w=SSF._general(cell.v);}else cell.w=xlml_format(nf||"General",cell.v);}catch(e){if(o.WTF)throw e;}try{var z=XLMLFormatMap[nf]||nf||"General";if(o.cellNF)cell.z=z;if(o.cellDates&&cell.t=='n'&&SSF.is_date(z)){var _d=SSF.parse_date_code(cell.v);if(_d){cell.t='d';cell.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}}catch(e){if(o.WTF)throw e;}}function process_style_xlml(styles,stag,opts){if(opts.cellStyles){if(stag.Interior){var I=stag.Interior;if(I.Pattern)I.patternType=XLMLPatternTypeMap[I.Pattern]||I.Pattern;}}styles[stag.ID]=stag;}/* TODO: there must exist some form of OSP-blessed spec */function parse_xlml_data(xml,ss,data,cell,base,styles,csty,row,arrayf,o){var nf="General",sid=cell.StyleID,S={};o=o||{};var interiors=[];var i=0;if(sid===undefined&&row)sid=row.StyleID;if(sid===undefined&&csty)sid=csty.StyleID;while(styles[sid]!==undefined){if(styles[sid].nf)nf=styles[sid].nf;if(styles[sid].Interior)interiors.push(styles[sid].Interior);if(!styles[sid].Parent)break;sid=styles[sid].Parent;}switch(data.Type){case'Boolean':cell.t='b';cell.v=parsexmlbool(xml);break;case'String':cell.t='s';cell.r=xlml_fixstr(unescapexml(xml));cell.v=xml.indexOf("<")>-1?unescapexml(ss||xml).replace(/<.*?>/g,""):cell.r;// todo: BR etc
break;case'DateTime':if(xml.slice(-1)!="Z")xml+="Z";cell.v=(parseDate(xml)-new Date(Date.UTC(1899,11,30)))/(24*60*60*1000);if(cell.v!==cell.v)cell.v=unescapexml(xml);else if(cell.v<60)cell.v=cell.v-1;if(!nf||nf=="General")nf="yyyy-mm-dd";/* falls through */case'Number':if(cell.v===undefined)cell.v=+xml;if(!cell.t)cell.t='n';break;case'Error':cell.t='e';cell.v=RBErr[xml];if(o.cellText!==false)cell.w=xml;break;default:if(xml==""&&ss==""){cell.t='z';}else {cell.t='s';cell.v=xlml_fixstr(ss||xml);}break;}safe_format_xlml(cell,nf,o);if(o.cellFormula!==false){if(cell.Formula){var fstr=unescapexml(cell.Formula);/* strictly speaking, the leading = is required but some writers omit */if(fstr.charCodeAt(0)==61/* = */)fstr=fstr.slice(1);cell.f=rc_to_a1(fstr,base);delete cell.Formula;if(cell.ArrayRange=="RC")cell.F=rc_to_a1("RC:RC",base);else if(cell.ArrayRange){cell.F=rc_to_a1(cell.ArrayRange,base);arrayf.push([safe_decode_range(cell.F),cell.F]);}}else {for(i=0;i<arrayf.length;++i)if(base.r>=arrayf[i][0].s.r&&base.r<=arrayf[i][0].e.r)if(base.c>=arrayf[i][0].s.c&&base.c<=arrayf[i][0].e.c)cell.F=arrayf[i][1];}}if(o.cellStyles){interiors.forEach(function(x){if(!S.patternType&&x.patternType)S.patternType=x.patternType;});cell.s=S;}if(cell.StyleID!==undefined)cell.ixfe=cell.StyleID;}function xlml_clean_comment(comment){comment.t=comment.v||"";comment.t=comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");comment.v=comment.w=comment.ixfe=undefined;}function xlml_normalize(d){if(has_buf&&Buffer.isBuffer(d))return d.toString('utf8');if(typeof d==='string')return d;/* duktape */if(typeof Uint8Array!=='undefined'&&d instanceof Uint8Array)return utf8read(a2s(ab2a(d)));throw new Error("Bad input format: expected Buffer or string");}/* TODO: Everything */ /* UOS uses CJK in tags */var xlmlregex=/<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
function parse_xlml_xml(d,_opts){var opts=_opts||{};make_ssf(SSF);var str=debom(xlml_normalize(d));if(opts.type=='binary'||opts.type=='array'||opts.type=='base64'){if(typeof cptable!=='undefined')str=cptable.utils.decode(65001,char_codes(str));else str=utf8read(str);}var opening=str.slice(0,1024).toLowerCase(),ishtml=false;if(opening.indexOf("<?xml")==-1)["html","table","head","meta","script","style","div"].forEach(function(tag){if(opening.indexOf("<"+tag)>=0)ishtml=true;});if(ishtml)return HTML_.to_workbook(str,opts);var Rn;var state=[],tmp;var sheets={},sheetnames=[],cursheet=opts.dense?[]:{},sheetname="";var table={},cell={},row={};// eslint-disable-line no-unused-vars
var dtag=xlml_parsexmltag('<Data ss:Type="String">'),didx=0;var c=0,r=0;var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};var styles={},stag={};var ss="",fidx=0;var merges=[];var Props={},Custprops={},pidx=0,cp=[];var comments=[],comment={};var cstys=[],csty,seencol=false;var arrayf=[];var rowinfo=[],rowobj={},cc=0,rr=0;var Workbook={Sheets:[],WBProps:{date1904:false}},wsprops={};xlmlregex.lastIndex=0;str=str.replace(/<!--([\s\S]*?)-->/mg,"");var raw_Rn3="";while(Rn=xlmlregex.exec(str))switch(Rn[3]=(raw_Rn3=Rn[3]).toLowerCase()){case'data'/*case 'Data'*/:if(raw_Rn3=="data"){if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;}if(state[state.length-1][1])break;if(Rn[1]==='/')parse_xlml_data(str.slice(didx,Rn.index),ss,dtag,state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell,{c:c,r:r},styles,cstys[c],row,arrayf,opts);else {ss="";dtag=xlml_parsexmltag(Rn[0]);didx=Rn.index+Rn[0].length;}break;case'cell'/*case 'Cell'*/:if(Rn[1]==='/'){if(comments.length>0)cell.c=comments;if((!opts.sheetRows||opts.sheetRows>r)&&cell.v!==undefined){if(opts.dense){if(!cursheet[r])cursheet[r]=[];cursheet[r][c]=cell;}else cursheet[encode_col(c)+encode_row(r)]=cell;}if(cell.HRef){cell.l={Target:cell.HRef};if(cell.HRefScreenTip)cell.l.Tooltip=cell.HRefScreenTip;delete cell.HRef;delete cell.HRefScreenTip;}if(cell.MergeAcross||cell.MergeDown){cc=c+(parseInt(cell.MergeAcross,10)|0);rr=r+(parseInt(cell.MergeDown,10)|0);merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});}if(!opts.sheetStubs){if(cell.MergeAcross)c=cc+1;else ++c;}else if(cell.MergeAcross||cell.MergeDown){for(var cma=c;cma<=cc;++cma){for(var cmd=r;cmd<=rr;++cmd){if(cma>c||cmd>r){if(opts.dense){if(!cursheet[cmd])cursheet[cmd]=[];cursheet[cmd][cma]={t:'z'};}else cursheet[encode_col(cma)+encode_row(cmd)]={t:'z'};}}}c=cc+1;}else ++c;}else {cell=xlml_parsexmltagobj(Rn[0]);if(cell.Index)c=+cell.Index-1;if(c<refguess.s.c)refguess.s.c=c;if(c>refguess.e.c)refguess.e.c=c;if(Rn[0].slice(-2)==="/>")++c;comments=[];}break;case'row'/*case 'Row'*/:if(Rn[1]==='/'||Rn[0].slice(-2)==="/>"){if(r<refguess.s.r)refguess.s.r=r;if(r>refguess.e.r)refguess.e.r=r;if(Rn[0].slice(-2)==="/>"){row=xlml_parsexmltag(Rn[0]);if(row.Index)r=+row.Index-1;}c=0;++r;}else {row=xlml_parsexmltag(Rn[0]);if(row.Index)r=+row.Index-1;rowobj={};if(row.AutoFitHeight=="0"||row.Height){rowobj.hpx=parseInt(row.Height,10);rowobj.hpt=px2pt(rowobj.hpx);rowinfo[r]=rowobj;}if(row.Hidden=="1"){rowobj.hidden=true;rowinfo[r]=rowobj;}}break;case'worksheet'/*case 'Worksheet'*/:/* TODO: read range from FullRows/FullColumns */if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));sheetnames.push(sheetname);if(refguess.s.r<=refguess.e.r&&refguess.s.c<=refguess.e.c){cursheet["!ref"]=encode_range(refguess);if(opts.sheetRows&&opts.sheetRows<=refguess.e.r){cursheet["!fullref"]=cursheet["!ref"];refguess.e.r=opts.sheetRows-1;cursheet["!ref"]=encode_range(refguess);}}if(merges.length)cursheet["!merges"]=merges;if(cstys.length>0)cursheet["!cols"]=cstys;if(rowinfo.length>0)cursheet["!rows"]=rowinfo;sheets[sheetname]=cursheet;}else {refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};r=c=0;state.push([Rn[3],false]);tmp=xlml_parsexmltag(Rn[0]);sheetname=unescapexml(tmp.Name);cursheet=opts.dense?[]:{};merges=[];arrayf=[];rowinfo=[];wsprops={name:sheetname,Hidden:0};Workbook.Sheets.push(wsprops);}break;case'table'/*case 'Table'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].slice(-2)=="/>")break;else {table=xlml_parsexmltag(Rn[0]);state.push([Rn[3],false]);cstys=[];seencol=false;}break;case'style'/*case 'Style'*/:if(Rn[1]==='/')process_style_xlml(styles,stag,opts);else stag=xlml_parsexmltag(Rn[0]);break;case'numberformat'/*case 'NumberFormat'*/:stag.nf=unescapexml(xlml_parsexmltag(Rn[0]).Format||"General");if(XLMLFormatMap[stag.nf])stag.nf=XLMLFormatMap[stag.nf];for(var ssfidx=0;ssfidx!=0x188;++ssfidx)if(SSF._table[ssfidx]==stag.nf)break;if(ssfidx==0x188)for(ssfidx=0x39;ssfidx!=0x188;++ssfidx)if(SSF._table[ssfidx]==null){SSF.load(stag.nf,ssfidx);break;}break;case'column'/*case 'Column'*/:if(state[state.length-1][0]!==/*'Table'*/'table')break;csty=xlml_parsexmltag(Rn[0]);if(csty.Hidden){csty.hidden=true;delete csty.Hidden;}if(csty.Width)csty.wpx=parseInt(csty.Width,10);if(!seencol&&csty.wpx>10){seencol=true;MDW=DEF_MDW;//find_mdw_wpx(csty.wpx);
for(var _col=0;_col<cstys.length;++_col)if(cstys[_col])process_col(cstys[_col]);}if(seencol)process_col(csty);cstys[csty.Index-1||cstys.length]=csty;for(var i=0;i<+csty.Span;++i)cstys[cstys.length]=dup(csty);break;case'namedrange'/*case 'NamedRange'*/:if(Rn[1]==='/')break;if(!Workbook.Names)Workbook.Names=[];var _NamedRange=parsexmltag(Rn[0]);var _DefinedName={Name:_NamedRange.Name,Ref:rc_to_a1(_NamedRange.RefersTo.slice(1),{r:0,c:0})};if(Workbook.Sheets.length>0)_DefinedName.Sheet=Workbook.Sheets.length-1;Workbook.Names.push(_DefinedName);break;case'namedcell'/*case 'NamedCell'*/:break;case'b'/*case 'B'*/:break;case'i'/*case 'I'*/:break;case'u'/*case 'U'*/:break;case's'/*case 'S'*/:break;case'em'/*case 'EM'*/:break;case'h2'/*case 'H2'*/:break;case'h3'/*case 'H3'*/:break;case'sub'/*case 'Sub'*/:break;case'sup'/*case 'Sup'*/:break;case'span'/*case 'Span'*/:break;case'alignment'/*case 'Alignment'*/:break;case'borders'/*case 'Borders'*/:break;case'border'/*case 'Border'*/:break;case'font'/*case 'Font'*/:if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")ss+=str.slice(fidx,Rn.index);else fidx=Rn.index+Rn[0].length;break;case'interior'/*case 'Interior'*/:if(!opts.cellStyles)break;stag.Interior=xlml_parsexmltag(Rn[0]);break;case'protection'/*case 'Protection'*/:break;case'author'/*case 'Author'*/:case'title'/*case 'Title'*/:case'description'/*case 'Description'*/:case'created'/*case 'Created'*/:case'keywords'/*case 'Keywords'*/:case'subject'/*case 'Subject'*/:case'category'/*case 'Category'*/:case'company'/*case 'Company'*/:case'lastauthor'/*case 'LastAuthor'*/:case'lastsaved'/*case 'LastSaved'*/:case'lastprinted'/*case 'LastPrinted'*/:case'version'/*case 'Version'*/:case'revision'/*case 'Revision'*/:case'totaltime'/*case 'TotalTime'*/:case'hyperlinkbase'/*case 'HyperlinkBase'*/:case'manager'/*case 'Manager'*/:case'contentstatus'/*case 'ContentStatus'*/:case'identifier'/*case 'Identifier'*/:case'language'/*case 'Language'*/:case'appname'/*case 'AppName'*/:if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")xlml_set_prop(Props,raw_Rn3,str.slice(pidx,Rn.index));else pidx=Rn.index+Rn[0].length;break;case'paragraphs'/*case 'Paragraphs'*/:break;case'styles'/*case 'Styles'*/:case'workbook'/*case 'Workbook'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else state.push([Rn[3],false]);break;case'comment'/*case 'Comment'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));xlml_clean_comment(comment);comments.push(comment);}else {state.push([Rn[3],false]);tmp=xlml_parsexmltag(Rn[0]);comment={a:tmp.Author};}break;case'autofilter'/*case 'AutoFilter'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){var AutoFilter=xlml_parsexmltag(Rn[0]);cursheet['!autofilter']={ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"")};state.push([Rn[3],true]);}break;case'name'/*case 'Name'*/:break;case'datavalidation'/*case 'DataValidation'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else {if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);}break;case'pixelsperinch'/*case 'PixelsPerInch'*/:break;case'componentoptions'/*case 'ComponentOptions'*/:case'documentproperties'/*case 'DocumentProperties'*/:case'customdocumentproperties'/*case 'CustomDocumentProperties'*/:case'officedocumentsettings'/*case 'OfficeDocumentSettings'*/:case'pivottable'/*case 'PivotTable'*/:case'pivotcache'/*case 'PivotCache'*/:case'names'/*case 'Names'*/:case'mapinfo'/*case 'MapInfo'*/:case'pagebreaks'/*case 'PageBreaks'*/:case'querytable'/*case 'QueryTable'*/:case'sorting'/*case 'Sorting'*/:case'schema'/*case 'Schema'*/://case 'data' /*case 'data'*/:
case'conditionalformatting'/*case 'ConditionalFormatting'*/:case'smarttagtype'/*case 'SmartTagType'*/:case'smarttags'/*case 'SmartTags'*/:case'excelworkbook'/*case 'ExcelWorkbook'*/:case'workbookoptions'/*case 'WorkbookOptions'*/:case'worksheetoptions'/*case 'WorksheetOptions'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;default:/* FODS file root is <office:document> */if(state.length==0&&Rn[3]=="document")return parse_fods(str,opts);/* UOS file root is <uof:UOF> */if(state.length==0&&Rn[3]=="uof"/*"UOF"*/)return parse_fods(str,opts);var seen=true;switch(state[state.length-1][0]){/* OfficeDocumentSettings */case'officedocumentsettings'/*case 'OfficeDocumentSettings'*/:switch(Rn[3]){case'allowpng'/*case 'AllowPNG'*/:break;case'removepersonalinformation'/*case 'RemovePersonalInformation'*/:break;case'downloadcomponents'/*case 'DownloadComponents'*/:break;case'locationofcomponents'/*case 'LocationOfComponents'*/:break;case'colors'/*case 'Colors'*/:break;case'color'/*case 'Color'*/:break;case'index'/*case 'Index'*/:break;case'rgb'/*case 'RGB'*/:break;case'targetscreensize'/*case 'TargetScreenSize'*/:break;case'readonlyrecommended'/*case 'ReadOnlyRecommended'*/:break;default:seen=false;}break;/* ComponentOptions */case'componentoptions'/*case 'ComponentOptions'*/:switch(Rn[3]){case'toolbar'/*case 'Toolbar'*/:break;case'hideofficelogo'/*case 'HideOfficeLogo'*/:break;case'spreadsheetautofit'/*case 'SpreadsheetAutoFit'*/:break;case'label'/*case 'Label'*/:break;case'caption'/*case 'Caption'*/:break;case'maxheight'/*case 'MaxHeight'*/:break;case'maxwidth'/*case 'MaxWidth'*/:break;case'nextsheetnumber'/*case 'NextSheetNumber'*/:break;default:seen=false;}break;/* ExcelWorkbook */case'excelworkbook'/*case 'ExcelWorkbook'*/:switch(Rn[3]){case'date1904'/*case 'Date1904'*/:Workbook.WBProps.date1904=true;break;case'windowheight'/*case 'WindowHeight'*/:break;case'windowwidth'/*case 'WindowWidth'*/:break;case'windowtopx'/*case 'WindowTopX'*/:break;case'windowtopy'/*case 'WindowTopY'*/:break;case'tabratio'/*case 'TabRatio'*/:break;case'protectstructure'/*case 'ProtectStructure'*/:break;case'protectwindow'/*case 'ProtectWindow'*/:break;case'protectwindows'/*case 'ProtectWindows'*/:break;case'activesheet'/*case 'ActiveSheet'*/:break;case'displayinknotes'/*case 'DisplayInkNotes'*/:break;case'firstvisiblesheet'/*case 'FirstVisibleSheet'*/:break;case'supbook'/*case 'SupBook'*/:break;case'sheetname'/*case 'SheetName'*/:break;case'sheetindex'/*case 'SheetIndex'*/:break;case'sheetindexfirst'/*case 'SheetIndexFirst'*/:break;case'sheetindexlast'/*case 'SheetIndexLast'*/:break;case'dll'/*case 'Dll'*/:break;case'acceptlabelsinformulas'/*case 'AcceptLabelsInFormulas'*/:break;case'donotsavelinkvalues'/*case 'DoNotSaveLinkValues'*/:break;case'iteration'/*case 'Iteration'*/:break;case'maxiterations'/*case 'MaxIterations'*/:break;case'maxchange'/*case 'MaxChange'*/:break;case'path'/*case 'Path'*/:break;case'xct'/*case 'Xct'*/:break;case'count'/*case 'Count'*/:break;case'selectedsheets'/*case 'SelectedSheets'*/:break;case'calculation'/*case 'Calculation'*/:break;case'uncalced'/*case 'Uncalced'*/:break;case'startupprompt'/*case 'StartupPrompt'*/:break;case'crn'/*case 'Crn'*/:break;case'externname'/*case 'ExternName'*/:break;case'formula'/*case 'Formula'*/:break;case'colfirst'/*case 'ColFirst'*/:break;case'collast'/*case 'ColLast'*/:break;case'wantadvise'/*case 'WantAdvise'*/:break;case'boolean'/*case 'Boolean'*/:break;case'error'/*case 'Error'*/:break;case'text'/*case 'Text'*/:break;case'ole'/*case 'OLE'*/:break;case'noautorecover'/*case 'NoAutoRecover'*/:break;case'publishobjects'/*case 'PublishObjects'*/:break;case'donotcalculatebeforesave'/*case 'DoNotCalculateBeforeSave'*/:break;case'number'/*case 'Number'*/:break;case'refmoder1c1'/*case 'RefModeR1C1'*/:break;case'embedsavesmarttags'/*case 'EmbedSaveSmartTags'*/:break;default:seen=false;}break;/* WorkbookOptions */case'workbookoptions'/*case 'WorkbookOptions'*/:switch(Rn[3]){case'owcversion'/*case 'OWCVersion'*/:break;case'height'/*case 'Height'*/:break;case'width'/*case 'Width'*/:break;default:seen=false;}break;/* WorksheetOptions */case'worksheetoptions'/*case 'WorksheetOptions'*/:switch(Rn[3]){case'visible'/*case 'Visible'*/:if(Rn[0].slice(-2)==="/>");else if(Rn[1]==="/")switch(str.slice(pidx,Rn.index)){case"SheetHidden":wsprops.Hidden=1;break;case"SheetVeryHidden":wsprops.Hidden=2;break;}else pidx=Rn.index+Rn[0].length;break;case'header'/*case 'Header'*/:if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');cursheet['!margins'].header=parsexmltag(Rn[0]).Margin;break;case'footer'/*case 'Footer'*/:if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');cursheet['!margins'].footer=parsexmltag(Rn[0]).Margin;break;case'pagemargins'/*case 'PageMargins'*/:var pagemargins=parsexmltag(Rn[0]);if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');if(pagemargins.Top)cursheet['!margins'].top=pagemargins.Top;if(pagemargins.Left)cursheet['!margins'].left=pagemargins.Left;if(pagemargins.Right)cursheet['!margins'].right=pagemargins.Right;if(pagemargins.Bottom)cursheet['!margins'].bottom=pagemargins.Bottom;break;case'displayrighttoleft'/*case 'DisplayRightToLeft'*/:if(!Workbook.Views)Workbook.Views=[];if(!Workbook.Views[0])Workbook.Views[0]={};Workbook.Views[0].RTL=true;break;case'freezepanes'/*case 'FreezePanes'*/:break;case'frozennosplit'/*case 'FrozenNoSplit'*/:break;case'splithorizontal'/*case 'SplitHorizontal'*/:case'splitvertical'/*case 'SplitVertical'*/:break;case'donotdisplaygridlines'/*case 'DoNotDisplayGridlines'*/:break;case'activerow'/*case 'ActiveRow'*/:break;case'activecol'/*case 'ActiveCol'*/:break;case'toprowbottompane'/*case 'TopRowBottomPane'*/:break;case'leftcolumnrightpane'/*case 'LeftColumnRightPane'*/:break;case'unsynced'/*case 'Unsynced'*/:break;case'print'/*case 'Print'*/:break;case'panes'/*case 'Panes'*/:break;case'scale'/*case 'Scale'*/:break;case'pane'/*case 'Pane'*/:break;case'number'/*case 'Number'*/:break;case'layout'/*case 'Layout'*/:break;case'pagesetup'/*case 'PageSetup'*/:break;case'selected'/*case 'Selected'*/:break;case'protectobjects'/*case 'ProtectObjects'*/:break;case'enableselection'/*case 'EnableSelection'*/:break;case'protectscenarios'/*case 'ProtectScenarios'*/:break;case'validprinterinfo'/*case 'ValidPrinterInfo'*/:break;case'horizontalresolution'/*case 'HorizontalResolution'*/:break;case'verticalresolution'/*case 'VerticalResolution'*/:break;case'numberofcopies'/*case 'NumberofCopies'*/:break;case'activepane'/*case 'ActivePane'*/:break;case'toprowvisible'/*case 'TopRowVisible'*/:break;case'leftcolumnvisible'/*case 'LeftColumnVisible'*/:break;case'fittopage'/*case 'FitToPage'*/:break;case'rangeselection'/*case 'RangeSelection'*/:break;case'papersizeindex'/*case 'PaperSizeIndex'*/:break;case'pagelayoutzoom'/*case 'PageLayoutZoom'*/:break;case'pagebreakzoom'/*case 'PageBreakZoom'*/:break;case'filteron'/*case 'FilterOn'*/:break;case'fitwidth'/*case 'FitWidth'*/:break;case'fitheight'/*case 'FitHeight'*/:break;case'commentslayout'/*case 'CommentsLayout'*/:break;case'zoom'/*case 'Zoom'*/:break;case'lefttoright'/*case 'LeftToRight'*/:break;case'gridlines'/*case 'Gridlines'*/:break;case'allowsort'/*case 'AllowSort'*/:break;case'allowfilter'/*case 'AllowFilter'*/:break;case'allowinsertrows'/*case 'AllowInsertRows'*/:break;case'allowdeleterows'/*case 'AllowDeleteRows'*/:break;case'allowinsertcols'/*case 'AllowInsertCols'*/:break;case'allowdeletecols'/*case 'AllowDeleteCols'*/:break;case'allowinserthyperlinks'/*case 'AllowInsertHyperlinks'*/:break;case'allowformatcells'/*case 'AllowFormatCells'*/:break;case'allowsizecols'/*case 'AllowSizeCols'*/:break;case'allowsizerows'/*case 'AllowSizeRows'*/:break;case'nosummaryrowsbelowdetail'/*case 'NoSummaryRowsBelowDetail'*/:break;case'tabcolorindex'/*case 'TabColorIndex'*/:break;case'donotdisplayheadings'/*case 'DoNotDisplayHeadings'*/:break;case'showpagelayoutzoom'/*case 'ShowPageLayoutZoom'*/:break;case'nosummarycolumnsrightdetail'/*case 'NoSummaryColumnsRightDetail'*/:break;case'blackandwhite'/*case 'BlackAndWhite'*/:break;case'donotdisplayzeros'/*case 'DoNotDisplayZeros'*/:break;case'displaypagebreak'/*case 'DisplayPageBreak'*/:break;case'rowcolheadings'/*case 'RowColHeadings'*/:break;case'donotdisplayoutline'/*case 'DoNotDisplayOutline'*/:break;case'noorientation'/*case 'NoOrientation'*/:break;case'allowusepivottables'/*case 'AllowUsePivotTables'*/:break;case'zeroheight'/*case 'ZeroHeight'*/:break;case'viewablerange'/*case 'ViewableRange'*/:break;case'selection'/*case 'Selection'*/:break;case'protectcontents'/*case 'ProtectContents'*/:break;default:seen=false;}break;/* PivotTable */case'pivottable'/*case 'PivotTable'*/:case'pivotcache'/*case 'PivotCache'*/:switch(Rn[3]){case'immediateitemsondrop'/*case 'ImmediateItemsOnDrop'*/:break;case'showpagemultipleitemlabel'/*case 'ShowPageMultipleItemLabel'*/:break;case'compactrowindent'/*case 'CompactRowIndent'*/:break;case'location'/*case 'Location'*/:break;case'pivotfield'/*case 'PivotField'*/:break;case'orientation'/*case 'Orientation'*/:break;case'layoutform'/*case 'LayoutForm'*/:break;case'layoutsubtotallocation'/*case 'LayoutSubtotalLocation'*/:break;case'layoutcompactrow'/*case 'LayoutCompactRow'*/:break;case'position'/*case 'Position'*/:break;case'pivotitem'/*case 'PivotItem'*/:break;case'datatype'/*case 'DataType'*/:break;case'datafield'/*case 'DataField'*/:break;case'sourcename'/*case 'SourceName'*/:break;case'parentfield'/*case 'ParentField'*/:break;case'ptlineitems'/*case 'PTLineItems'*/:break;case'ptlineitem'/*case 'PTLineItem'*/:break;case'countofsameitems'/*case 'CountOfSameItems'*/:break;case'item'/*case 'Item'*/:break;case'itemtype'/*case 'ItemType'*/:break;case'ptsource'/*case 'PTSource'*/:break;case'cacheindex'/*case 'CacheIndex'*/:break;case'consolidationreference'/*case 'ConsolidationReference'*/:break;case'filename'/*case 'FileName'*/:break;case'reference'/*case 'Reference'*/:break;case'nocolumngrand'/*case 'NoColumnGrand'*/:break;case'norowgrand'/*case 'NoRowGrand'*/:break;case'blanklineafteritems'/*case 'BlankLineAfterItems'*/:break;case'hidden'/*case 'Hidden'*/:break;case'subtotal'/*case 'Subtotal'*/:break;case'basefield'/*case 'BaseField'*/:break;case'mapchilditems'/*case 'MapChildItems'*/:break;case'function'/*case 'Function'*/:break;case'refreshonfileopen'/*case 'RefreshOnFileOpen'*/:break;case'printsettitles'/*case 'PrintSetTitles'*/:break;case'mergelabels'/*case 'MergeLabels'*/:break;case'defaultversion'/*case 'DefaultVersion'*/:break;case'refreshname'/*case 'RefreshName'*/:break;case'refreshdate'/*case 'RefreshDate'*/:break;case'refreshdatecopy'/*case 'RefreshDateCopy'*/:break;case'versionlastrefresh'/*case 'VersionLastRefresh'*/:break;case'versionlastupdate'/*case 'VersionLastUpdate'*/:break;case'versionupdateablemin'/*case 'VersionUpdateableMin'*/:break;case'versionrefreshablemin'/*case 'VersionRefreshableMin'*/:break;case'calculation'/*case 'Calculation'*/:break;default:seen=false;}break;/* PageBreaks */case'pagebreaks'/*case 'PageBreaks'*/:switch(Rn[3]){case'colbreaks'/*case 'ColBreaks'*/:break;case'colbreak'/*case 'ColBreak'*/:break;case'rowbreaks'/*case 'RowBreaks'*/:break;case'rowbreak'/*case 'RowBreak'*/:break;case'colstart'/*case 'ColStart'*/:break;case'colend'/*case 'ColEnd'*/:break;case'rowend'/*case 'RowEnd'*/:break;default:seen=false;}break;/* AutoFilter */case'autofilter'/*case 'AutoFilter'*/:switch(Rn[3]){case'autofiltercolumn'/*case 'AutoFilterColumn'*/:break;case'autofiltercondition'/*case 'AutoFilterCondition'*/:break;case'autofilterand'/*case 'AutoFilterAnd'*/:break;case'autofilteror'/*case 'AutoFilterOr'*/:break;default:seen=false;}break;/* QueryTable */case'querytable'/*case 'QueryTable'*/:switch(Rn[3]){case'id'/*case 'Id'*/:break;case'autoformatfont'/*case 'AutoFormatFont'*/:break;case'autoformatpattern'/*case 'AutoFormatPattern'*/:break;case'querysource'/*case 'QuerySource'*/:break;case'querytype'/*case 'QueryType'*/:break;case'enableredirections'/*case 'EnableRedirections'*/:break;case'refreshedinxl9'/*case 'RefreshedInXl9'*/:break;case'urlstring'/*case 'URLString'*/:break;case'htmltables'/*case 'HTMLTables'*/:break;case'connection'/*case 'Connection'*/:break;case'commandtext'/*case 'CommandText'*/:break;case'refreshinfo'/*case 'RefreshInfo'*/:break;case'notitles'/*case 'NoTitles'*/:break;case'nextid'/*case 'NextId'*/:break;case'columninfo'/*case 'ColumnInfo'*/:break;case'overwritecells'/*case 'OverwriteCells'*/:break;case'donotpromptforfile'/*case 'DoNotPromptForFile'*/:break;case'textwizardsettings'/*case 'TextWizardSettings'*/:break;case'source'/*case 'Source'*/:break;case'number'/*case 'Number'*/:break;case'decimal'/*case 'Decimal'*/:break;case'thousandseparator'/*case 'ThousandSeparator'*/:break;case'trailingminusnumbers'/*case 'TrailingMinusNumbers'*/:break;case'formatsettings'/*case 'FormatSettings'*/:break;case'fieldtype'/*case 'FieldType'*/:break;case'delimiters'/*case 'Delimiters'*/:break;case'tab'/*case 'Tab'*/:break;case'comma'/*case 'Comma'*/:break;case'autoformatname'/*case 'AutoFormatName'*/:break;case'versionlastedit'/*case 'VersionLastEdit'*/:break;case'versionlastrefresh'/*case 'VersionLastRefresh'*/:break;default:seen=false;}break;case'datavalidation'/*case 'DataValidation'*/:switch(Rn[3]){case'range'/*case 'Range'*/:break;case'type'/*case 'Type'*/:break;case'min'/*case 'Min'*/:break;case'max'/*case 'Max'*/:break;case'sort'/*case 'Sort'*/:break;case'descending'/*case 'Descending'*/:break;case'order'/*case 'Order'*/:break;case'casesensitive'/*case 'CaseSensitive'*/:break;case'value'/*case 'Value'*/:break;case'errorstyle'/*case 'ErrorStyle'*/:break;case'errormessage'/*case 'ErrorMessage'*/:break;case'errortitle'/*case 'ErrorTitle'*/:break;case'inputmessage'/*case 'InputMessage'*/:break;case'inputtitle'/*case 'InputTitle'*/:break;case'combohide'/*case 'ComboHide'*/:break;case'inputhide'/*case 'InputHide'*/:break;case'condition'/*case 'Condition'*/:break;case'qualifier'/*case 'Qualifier'*/:break;case'useblank'/*case 'UseBlank'*/:break;case'value1'/*case 'Value1'*/:break;case'value2'/*case 'Value2'*/:break;case'format'/*case 'Format'*/:break;case'cellrangelist'/*case 'CellRangeList'*/:break;default:seen=false;}break;case'sorting'/*case 'Sorting'*/:case'conditionalformatting'/*case 'ConditionalFormatting'*/:switch(Rn[3]){case'range'/*case 'Range'*/:break;case'type'/*case 'Type'*/:break;case'min'/*case 'Min'*/:break;case'max'/*case 'Max'*/:break;case'sort'/*case 'Sort'*/:break;case'descending'/*case 'Descending'*/:break;case'order'/*case 'Order'*/:break;case'casesensitive'/*case 'CaseSensitive'*/:break;case'value'/*case 'Value'*/:break;case'errorstyle'/*case 'ErrorStyle'*/:break;case'errormessage'/*case 'ErrorMessage'*/:break;case'errortitle'/*case 'ErrorTitle'*/:break;case'cellrangelist'/*case 'CellRangeList'*/:break;case'inputmessage'/*case 'InputMessage'*/:break;case'inputtitle'/*case 'InputTitle'*/:break;case'combohide'/*case 'ComboHide'*/:break;case'inputhide'/*case 'InputHide'*/:break;case'condition'/*case 'Condition'*/:break;case'qualifier'/*case 'Qualifier'*/:break;case'useblank'/*case 'UseBlank'*/:break;case'value1'/*case 'Value1'*/:break;case'value2'/*case 'Value2'*/:break;case'format'/*case 'Format'*/:break;default:seen=false;}break;/* MapInfo (schema) */case'mapinfo'/*case 'MapInfo'*/:case'schema'/*case 'Schema'*/:case'data'/*case 'data'*/:switch(Rn[3]){case'map'/*case 'Map'*/:break;case'entry'/*case 'Entry'*/:break;case'range'/*case 'Range'*/:break;case'xpath'/*case 'XPath'*/:break;case'field'/*case 'Field'*/:break;case'xsdtype'/*case 'XSDType'*/:break;case'filteron'/*case 'FilterOn'*/:break;case'aggregate'/*case 'Aggregate'*/:break;case'elementtype'/*case 'ElementType'*/:break;case'attributetype'/*case 'AttributeType'*/:break;/* These are from xsd (XML Schema Definition) */case'schema'/*case 'schema'*/:case'element'/*case 'element'*/:case'complextype'/*case 'complexType'*/:case'datatype'/*case 'datatype'*/:case'all'/*case 'all'*/:case'attribute'/*case 'attribute'*/:case'extends'/*case 'extends'*/:break;case'row'/*case 'row'*/:break;default:seen=false;}break;/* SmartTags (can be anything) */case'smarttags'/*case 'SmartTags'*/:break;default:seen=false;break;}if(seen)break;/* CustomDocumentProperties */if(Rn[3].match(/!\[CDATA/))break;if(!state[state.length-1][1])throw 'Unrecognized tag: '+Rn[3]+"|"+state.join("|");if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties'){if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")xlml_set_custprop(Custprops,raw_Rn3,cp,str.slice(pidx,Rn.index));else {cp=Rn;pidx=Rn.index+Rn[0].length;}break;}if(opts.WTF)throw 'Unrecognized tag: '+Rn[3]+"|"+state.join("|");}var out={};if(!opts.bookSheets&&!opts.bookProps)out.Sheets=sheets;out.SheetNames=sheetnames;out.Workbook=Workbook;out.SSF=SSF.get_table();out.Props=Props;out.Custprops=Custprops;return out;}function parse_xlml(data,opts){fix_read_opts(opts=opts||{});switch(opts.type||"base64"){case"base64":return parse_xlml_xml(Base64.decode(data),opts);case"binary":case"buffer":case"file":return parse_xlml_xml(data,opts);case"array":return parse_xlml_xml(a2s(data),opts);}}/* TODO */function write_props_xlml(wb,opts){var o=[];/* DocumentProperties */if(wb.Props)o.push(xlml_write_docprops(wb.Props,opts));/* CustomDocumentProperties */if(wb.Custprops)o.push(xlml_write_custprops(wb.Props,wb.Custprops));return o.join("");}/* TODO */function write_wb_xlml(){/* OfficeDocumentSettings */ /* ExcelWorkbook */return "";}/* TODO */function write_sty_xlml(wb,opts){/* Styles */var styles=['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];opts.cellXfs.forEach(function(xf,id){var payload=[];payload.push(writextag('NumberFormat',null,{"ss:Format":escapexml(SSF._table[xf.numFmtId])}));var o={"ss:ID":"s"+(21+id)};styles.push(writextag('Style',payload.join(""),o));});return writextag("Styles",styles.join(""));}function write_name_xlml(n){return writextag("NamedRange",null,{"ss:Name":n.Name,"ss:RefersTo":"="+a1_to_rc(n.Ref,{r:0,c:0})});}function write_names_xlml(wb){if(!((wb||{}).Workbook||{}).Names)return "";var names=wb.Workbook.Names;var out=[];for(var i=0;i<names.length;++i){var n=names[i];if(n.Sheet!=null)continue;if(n.Name.match(/^_xlfn\./))continue;out.push(write_name_xlml(n));}return writextag("Names",out.join(""));}function write_ws_xlml_names(ws,opts,idx,wb){if(!ws)return "";if(!((wb||{}).Workbook||{}).Names)return "";var names=wb.Workbook.Names;var out=[];for(var i=0;i<names.length;++i){var n=names[i];if(n.Sheet!=idx)continue;/*switch(n.Name) {
			case "_": continue;
		}*/if(n.Name.match(/^_xlfn\./))continue;out.push(write_name_xlml(n));}return out.join("");}/* WorksheetOptions */function write_ws_xlml_wsopts(ws,opts,idx,wb){if(!ws)return "";var o=[];/* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */if(ws['!margins']){o.push("<PageSetup>");if(ws['!margins'].header)o.push(writextag("Header",null,{'x:Margin':ws['!margins'].header}));if(ws['!margins'].footer)o.push(writextag("Footer",null,{'x:Margin':ws['!margins'].footer}));o.push(writextag("PageMargins",null,{'x:Bottom':ws['!margins'].bottom||"0.75",'x:Left':ws['!margins'].left||"0.7",'x:Right':ws['!margins'].right||"0.7",'x:Top':ws['!margins'].top||"0.75"}));o.push("</PageSetup>");}/* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */if(wb&&wb.Workbook&&wb.Workbook.Sheets&&wb.Workbook.Sheets[idx]){/* Visible */if(wb.Workbook.Sheets[idx].Hidden)o.push(writextag("Visible",wb.Workbook.Sheets[idx].Hidden==1?"SheetHidden":"SheetVeryHidden",{}));else {/* Selected */for(var i=0;i<idx;++i)if(wb.Workbook.Sheets[i]&&!wb.Workbook.Sheets[i].Hidden)break;if(i==idx)o.push("<Selected/>");}}/* LeftColumnVisible */if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL)o.push("<DisplayRightToLeft/>");/* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */if(ws['!protect']){o.push(writetag("ProtectContents","True"));if(ws['!protect'].objects)o.push(writetag("ProtectObjects","True"));if(ws['!protect'].scenarios)o.push(writetag("ProtectScenarios","True"));if(ws['!protect'].selectLockedCells!=null&&!ws['!protect'].selectLockedCells)o.push(writetag("EnableSelection","NoSelection"));else if(ws['!protect'].selectUnlockedCells!=null&&!ws['!protect'].selectUnlockedCells)o.push(writetag("EnableSelection","UnlockedCells"));[["formatCells","AllowFormatCells"],["formatColumns","AllowSizeCols"],["formatRows","AllowSizeRows"],["insertColumns","AllowInsertCols"],["insertRows","AllowInsertRows"],["insertHyperlinks","AllowInsertHyperlinks"],["deleteColumns","AllowDeleteCols"],["deleteRows","AllowDeleteRows"],["sort","AllowSort"],["autoFilter","AllowFilter"],["pivotTables","AllowUsePivotTables"]].forEach(function(x){if(ws['!protect'][x[0]])o.push("<"+x[1]+"/>");});}if(o.length==0)return "";return writextag("WorksheetOptions",o.join(""),{xmlns:XLMLNS.x});}function write_ws_xlml_comment(comments){return comments.map(function(c){// TODO: formatted text
var t=xlml_unfixstr(c.t||"");var d=writextag("ss:Data",t,{"xmlns":"http://www.w3.org/TR/REC-html40"});return writextag("Comment",d,{"ss:Author":c.a});}).join("");}function write_ws_xlml_cell(cell,ref,ws,opts,idx,wb,addr){if(!cell||cell.v==undefined&&cell.f==undefined)return "";var attr={};if(cell.f)attr["ss:Formula"]="="+escapexml(a1_to_rc(cell.f,addr));if(cell.F&&cell.F.slice(0,ref.length)==ref){var end=decode_cell(cell.F.slice(ref.length+1));attr["ss:ArrayRange"]="RC:R"+(end.r==addr.r?"":"["+(end.r-addr.r)+"]")+"C"+(end.c==addr.c?"":"["+(end.c-addr.c)+"]");}if(cell.l&&cell.l.Target){attr["ss:HRef"]=escapexml(cell.l.Target);if(cell.l.Tooltip)attr["x:HRefScreenTip"]=escapexml(cell.l.Tooltip);}if(ws['!merges']){var marr=ws['!merges'];for(var mi=0;mi!=marr.length;++mi){if(marr[mi].s.c!=addr.c||marr[mi].s.r!=addr.r)continue;if(marr[mi].e.c>marr[mi].s.c)attr['ss:MergeAcross']=marr[mi].e.c-marr[mi].s.c;if(marr[mi].e.r>marr[mi].s.r)attr['ss:MergeDown']=marr[mi].e.r-marr[mi].s.r;}}var t="",p="";switch(cell.t){case'z':if(!opts.sheetStubs)return "";break;case'n':t='Number';p=String(cell.v);break;case'b':t='Boolean';p=cell.v?"1":"0";break;case'e':t='Error';p=BErr[cell.v];break;case'd':t='DateTime';p=new Date(cell.v).toISOString();if(cell.z==null)cell.z=cell.z||SSF._table[14];break;case's':t='String';p=escapexlml(cell.v||"");break;}/* TODO: cell style */var os=get_cell_style(opts.cellXfs,cell,opts);attr["ss:StyleID"]="s"+(21+os);attr["ss:Index"]=addr.c+1;var _v=cell.v!=null?p:"";var m=cell.t=='z'?"":'<Data ss:Type="'+t+'">'+_v+'</Data>';if((cell.c||[]).length>0)m+=write_ws_xlml_comment(cell.c);return writextag("Cell",m,attr);}function write_ws_xlml_row(R,row){var o='<Row ss:Index="'+(R+1)+'"';if(row){if(row.hpt&&!row.hpx)row.hpx=pt2px(row.hpt);if(row.hpx)o+=' ss:AutoFitHeight="0" ss:Height="'+row.hpx+'"';if(row.hidden)o+=' ss:Hidden="1"';}return o+'>';}/* TODO */function write_ws_xlml_table(ws,opts,idx,wb){if(!ws['!ref'])return "";var range=safe_decode_range(ws['!ref']);var marr=ws['!merges']||[],mi=0;var o=[];if(ws['!cols'])ws['!cols'].forEach(function(n,i){process_col(n);var w=!!n.width;var p=col_obj_w(i,n);var k={"ss:Index":i+1};if(w)k['ss:Width']=width2px(p.width);if(n.hidden)k['ss:Hidden']="1";o.push(writextag("Column",null,k));});var dense=Array.isArray(ws);for(var R=range.s.r;R<=range.e.r;++R){var row=[write_ws_xlml_row(R,(ws['!rows']||[])[R])];for(var C=range.s.c;C<=range.e.c;++C){var skip=false;for(mi=0;mi!=marr.length;++mi){if(marr[mi].s.c>C)continue;if(marr[mi].s.r>R)continue;if(marr[mi].e.c<C)continue;if(marr[mi].e.r<R)continue;if(marr[mi].s.c!=C||marr[mi].s.r!=R)skip=true;break;}if(skip)continue;var addr={r:R,c:C};var ref=encode_cell(addr),cell=dense?(ws[R]||[])[C]:ws[ref];row.push(write_ws_xlml_cell(cell,ref,ws,opts,idx,wb,addr));}row.push("</Row>");if(row.length>2)o.push(row.join(""));}return o.join("");}function write_ws_xlml(idx,opts,wb){var o=[];var s=wb.SheetNames[idx];var ws=wb.Sheets[s];var t=ws?write_ws_xlml_names(ws,opts,idx,wb):"";if(t.length>0)o.push("<Names>"+t+"</Names>");/* Table */t=ws?write_ws_xlml_table(ws,opts,idx,wb):"";if(t.length>0)o.push("<Table>"+t+"</Table>");/* WorksheetOptions */o.push(write_ws_xlml_wsopts(ws,opts,idx,wb));return o.join("");}function write_xlml(wb,opts){if(!opts)opts={};if(!wb.SSF)wb.SSF=SSF.get_table();if(wb.SSF){make_ssf(SSF);SSF.load_table(wb.SSF);// $FlowIgnore
opts.revssf=evert_num(wb.SSF);opts.revssf[wb.SSF[65535]]=0;opts.ssf=wb.SSF;opts.cellXfs=[];get_cell_style(opts.cellXfs,{},{revssf:{"General":0}});}var d=[];d.push(write_props_xlml(wb,opts));d.push(write_wb_xlml());d.push("");d.push("");for(var i=0;i<wb.SheetNames.length;++i)d.push(writextag("Worksheet",write_ws_xlml(i,opts,wb),{"ss:Name":escapexml(wb.SheetNames[i])}));d[2]=write_sty_xlml(wb,opts);d[3]=write_names_xlml(wb);return XML_HEADER+writextag("Workbook",d.join(""),{'xmlns':XLMLNS.ss,'xmlns:o':XLMLNS.o,'xmlns:x':XLMLNS.x,'xmlns:ss':XLMLNS.ss,'xmlns:dt':XLMLNS.dt,'xmlns:html':XLMLNS.html});}/* [MS-OLEDS] 2.3.8 CompObjStream */function parse_compobj(obj){var v={};var o=obj.content;/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */o.l=28;v.AnsiUserType=o.read_shift(0,"lpstr-ansi");v.AnsiClipboardFormat=parse_ClipboardFormatOrAnsiString(o);if(o.length-o.l<=4)return v;var m=o.read_shift(4);if(m==0||m>40)return v;o.l-=4;v.Reserved1=o.read_shift(0,"lpstr-ansi");if(o.length-o.l<=4)return v;m=o.read_shift(4);if(m!==0x71b239f4)return v;v.UnicodeClipboardFormat=parse_ClipboardFormatOrUnicodeString(o);m=o.read_shift(4);if(m==0||m>40)return v;o.l-=4;v.Reserved2=o.read_shift(0,"lpwstr");}/*
	Continue logic for:
	- 2.4.58 Continue
	- 2.4.59 ContinueBigName
	- 2.4.60 ContinueFrt
	- 2.4.61 ContinueFrt11
	- 2.4.62 ContinueFrt12
*/function slurp(R,blob,length,opts){var l=length;var bufs=[];var d=blob.slice(blob.l,blob.l+l);if(opts&&opts.enc&&opts.enc.insitu&&d.length>0)switch(R.n){case'BOF':case'FilePass':case'FileLock':case'InterfaceHdr':case'RRDInfo':case'RRDHead':case'UsrExcl':case'EOF':break;case'BoundSheet8':break;default:opts.enc.insitu(d);}bufs.push(d);blob.l+=l;var next=XLSRecordEnum[__readUInt16LE(blob,blob.l)];var start=0;while(next!=null&&next.n.slice(0,8)==='Continue'){l=__readUInt16LE(blob,blob.l+2);start=blob.l+4;if(next.n=='ContinueFrt')start+=4;else if(next.n.slice(0,11)=='ContinueFrt'){start+=12;}d=blob.slice(start,blob.l+4+l);bufs.push(d);blob.l+=4+l;next=XLSRecordEnum[__readUInt16LE(blob,blob.l)];}var b=bconcat(bufs);prep_blob(b,0);var ll=0;b.lens=[];for(var j=0;j<bufs.length;++j){b.lens.push(ll);ll+=bufs[j].length;}if(b.length<length)throw "XLS Record "+(R&&R.n||"??")+" Truncated: "+b.length+" < "+length;return R.f(b,b.length,opts);}function safe_format_xf(p,opts,date1904){if(p.t==='z')return;if(!p.XF)return;var fmtid=0;try{fmtid=p.z||p.XF.numFmtId||0;if(opts.cellNF)p.z=SSF._table[fmtid];}catch(e){if(opts.WTF)throw e;}if(!opts||opts.cellText!==false)try{if(p.t==='e'){p.w=p.w||BErr[p.v];}else if(fmtid===0||fmtid=="General"){if(p.t==='n'){if((p.v|0)===p.v)p.w=SSF._general_int(p.v);else p.w=SSF._general_num(p.v);}else p.w=SSF._general(p.v);}else p.w=SSF.format(fmtid,p.v,{date1904:!!date1904});}catch(e){if(opts.WTF)throw e;}if(opts.cellDates&&fmtid&&p.t=='n'&&SSF.is_date(SSF._table[fmtid]||String(fmtid))){var _d=SSF.parse_date_code(p.v);if(_d){p.t='d';p.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}}function make_cell(val,ixfe,t){return {v:val,ixfe:ixfe,t:t};}// 2.3.2
function parse_workbook(blob,options){var wb={opts:{}};var Sheets={};var out=options.dense?[]:{};var Directory={};var range={};var last_formula=null;var sst=[];var cur_sheet="";var Preamble={};var lastcell,last_cell="",cc,cmnt,rngC,rngR;var sharedf={};var arrayf=[];var temp_val;var country;var cell_valid=true;var XFs=[];/* XF records */var palette=[];var Workbook={Sheets:[],WBProps:{date1904:false},Views:[{}]},wsprops={};var get_rgb=function getrgb(icv){if(icv<8)return XLSIcv[icv];if(icv<64)return palette[icv-8]||XLSIcv[icv];return XLSIcv[icv];};var process_cell_style=function pcs(cell,line,options){var xfd=line.XF.data;if(!xfd||!xfd.patternType||!options||!options.cellStyles)return;line.s={};line.s.patternType=xfd.patternType;var t;if(t=rgb2Hex(get_rgb(xfd.icvFore))){line.s.fgColor={rgb:t};}if(t=rgb2Hex(get_rgb(xfd.icvBack))){line.s.bgColor={rgb:t};}};var addcell=function addcell(cell,line,options){if(file_depth>1)return;if(options.sheetRows&&cell.r>=options.sheetRows)cell_valid=false;if(!cell_valid)return;if(options.cellStyles&&line.XF&&line.XF.data)process_cell_style(cell,line,options);delete line.ixfe;delete line.XF;lastcell=cell;last_cell=encode_cell(cell);if(!range||!range.s||!range.e)range={s:{r:0,c:0},e:{r:0,c:0}};if(cell.r<range.s.r)range.s.r=cell.r;if(cell.c<range.s.c)range.s.c=cell.c;if(cell.r+1>range.e.r)range.e.r=cell.r+1;if(cell.c+1>range.e.c)range.e.c=cell.c+1;if(options.cellFormula&&line.f){for(var afi=0;afi<arrayf.length;++afi){if(arrayf[afi][0].s.c>cell.c||arrayf[afi][0].s.r>cell.r)continue;if(arrayf[afi][0].e.c<cell.c||arrayf[afi][0].e.r<cell.r)continue;line.F=encode_range(arrayf[afi][0]);if(arrayf[afi][0].s.c!=cell.c||arrayf[afi][0].s.r!=cell.r)delete line.f;if(line.f)line.f=""+stringify_formula(arrayf[afi][1],range,cell,supbooks,opts);break;}}{if(options.dense){if(!out[cell.r])out[cell.r]=[];out[cell.r][cell.c]=line;}else out[last_cell]=line;}};var opts={enc:false,// encrypted
sbcch:0,// cch in the preceding SupBook
snames:[],// sheetnames
sharedf:sharedf,// shared formulae by address
arrayf:arrayf,// array formulae array
rrtabid:[],// RRTabId
lastuser:"",// Last User from WriteAccess
biff:8,// BIFF version
codepage:0,// CP from CodePage record
winlocked:0,// fLockWn from WinProtect
cellStyles:!!options&&!!options.cellStyles,WTF:!!options&&!!options.wtf};if(options.password)opts.password=options.password;var themes;var merges=[];var objects=[];var colinfo=[],rowinfo=[];// eslint-disable-next-line no-unused-vars
var defwidth=0,defheight=0;// twips / MDW respectively
var seencol=false;var supbooks=[];// 1-indexed, will hold extern names
supbooks.SheetNames=opts.snames;supbooks.sharedf=opts.sharedf;supbooks.arrayf=opts.arrayf;supbooks.names=[];supbooks.XTI=[];var last_Rn='';var file_depth=0;/* TODO: make a real stack */var BIFF2Fmt=0,BIFF2FmtTable=[];var FilterDatabases=[];/* TODO: sort out supbooks and process elsewhere */var last_lbl;/* explicit override for some broken writers */opts.codepage=1200;set_cp(1200);var seen_codepage=false;while(blob.l<blob.length-1){var s=blob.l;var RecordType=blob.read_shift(2);if(RecordType===0&&last_Rn==='EOF')break;var length=blob.l===blob.length?0:blob.read_shift(2);var R=XLSRecordEnum[RecordType];//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
//if(!R) console.log(blob.slice(blob.l, blob.l + length));
if(R&&R.f){if(options.bookSheets){if(last_Rn==='BoundSheet8'&&R.n!=='BoundSheet8')break;}last_Rn=R.n;if(R.r===2||R.r==12){var rt=blob.read_shift(2);length-=2;if(!opts.enc&&rt!==RecordType&&((rt&0xFF)<<8|rt>>8)!==RecordType)throw new Error("rt mismatch: "+rt+"!="+RecordType);if(R.r==12){blob.l+=10;length-=10;}// skip FRT
}//console.error(R,blob.l,length,blob.length);
var val={};if(R.n==='EOF')val=R.f(blob,length,opts);else val=slurp(R,blob,length,opts);var Rn=R.n;if(file_depth==0&&Rn!='BOF')continue;/* nested switch statements to workaround V8 128 limit */switch(Rn){/* Workbook Options */case'Date1904':wb.opts.Date1904=Workbook.WBProps.date1904=val;break;case'WriteProtect':wb.opts.WriteProtect=true;break;case'FilePass':if(!opts.enc)blob.l=0;opts.enc=val;if(!options.password)throw new Error("File is password-protected");if(val.valid==null)throw new Error("Encryption scheme unsupported");if(!val.valid)throw new Error("Password is incorrect");break;case'WriteAccess':opts.lastuser=val;break;case'FileSharing':break;//TODO
case'CodePage':var cpval=Number(val);/* overrides based on test cases */switch(cpval){case 0x5212:cpval=1200;break;case 0x8000:cpval=10000;break;case 0x8001:cpval=1252;break;}set_cp(opts.codepage=cpval);seen_codepage=true;break;case'RRTabId':opts.rrtabid=val;break;case'WinProtect':opts.winlocked=val;break;case'Template':break;// TODO
case'BookBool':break;// TODO
case'UsesELFs':break;case'MTRSettings':break;case'RefreshAll':case'CalcCount':case'CalcDelta':case'CalcIter':case'CalcMode':case'CalcPrecision':case'CalcSaveRecalc':wb.opts[Rn]=val;break;case'CalcRefMode':opts.CalcRefMode=val;break;// TODO: implement R1C1
case'Uncalced':break;case'ForceFullCalculation':wb.opts.FullCalc=val;break;case'WsBool':if(val.fDialog)out["!type"]="dialog";break;// TODO
case'XF':XFs.push(val);break;case'ExtSST':break;// TODO
case'BookExt':break;// TODO
case'RichTextStream':break;case'BkHim':break;case'SupBook':supbooks.push([val]);supbooks[supbooks.length-1].XTI=[];break;case'ExternName':supbooks[supbooks.length-1].push(val);break;case'Index':break;// TODO
case'Lbl':last_lbl={Name:val.Name,Ref:stringify_formula(val.rgce,range,null,supbooks,opts)};if(val.itab>0)last_lbl.Sheet=val.itab-1;supbooks.names.push(last_lbl);if(!supbooks[0]){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].push(val);if(val.Name=="_xlnm._FilterDatabase"&&val.itab>0)if(val.rgce&&val.rgce[0]&&val.rgce[0][0]&&val.rgce[0][0][0]=='PtgArea3d')FilterDatabases[val.itab-1]={ref:encode_range(val.rgce[0][0][1][2])};break;case'ExternCount':opts.ExternCount=val;break;case'ExternSheet':if(supbooks.length==0){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].XTI=supbooks[supbooks.length-1].XTI.concat(val);supbooks.XTI=supbooks.XTI.concat(val);break;case'NameCmt':/* TODO: search for correct name */if(opts.biff<8)break;if(last_lbl!=null)last_lbl.Comment=val[1];break;case'Protect':out["!protect"]=val;break;/* for sheet or book */case'Password':if(val!==0&&opts.WTF)console.error("Password verifier: "+val);break;case'Prot4Rev':case'Prot4RevPass':break;/*TODO: Revision Control*/case'BoundSheet8':{Directory[val.pos]=val;opts.snames.push(val.name);}break;case'EOF':{if(--file_depth)break;if(range.e){if(range.e.r>0&&range.e.c>0){range.e.r--;range.e.c--;out["!ref"]=encode_range(range);if(options.sheetRows&&options.sheetRows<=range.e.r){var tmpri=range.e.r;range.e.r=options.sheetRows-1;out["!fullref"]=out["!ref"];out["!ref"]=encode_range(range);range.e.r=tmpri;}range.e.r++;range.e.c++;}if(merges.length>0)out["!merges"]=merges;if(objects.length>0)out["!objects"]=objects;if(colinfo.length>0)out["!cols"]=colinfo;if(rowinfo.length>0)out["!rows"]=rowinfo;Workbook.Sheets.push(wsprops);}if(cur_sheet==="")Preamble=out;else Sheets[cur_sheet]=out;out=options.dense?[]:{};}break;case'BOF':{if(opts.biff===8)opts.biff={0x0009:2,0x0209:3,0x0409:4}[RecordType]||{0x0200:2,0x0300:3,0x0400:4,0x0500:5,0x0600:8,0x0002:2,0x0007:2}[val.BIFFVer]||8;if(opts.biff==8&&val.BIFFVer==0&&val.dt==16)opts.biff=2;if(file_depth++)break;cell_valid=true;out=options.dense?[]:{};if(opts.biff<8&&!seen_codepage){seen_codepage=true;set_cp(opts.codepage=options.codepage||1252);}if(opts.biff<5){if(cur_sheet==="")cur_sheet="Sheet1";range={s:{r:0,c:0},e:{r:0,c:0}};/* fake BoundSheet8 */var fakebs8={pos:blob.l-length,name:cur_sheet};Directory[fakebs8.pos]=fakebs8;opts.snames.push(cur_sheet);}else cur_sheet=(Directory[s]||{name:""}).name;if(val.dt==0x20)out["!type"]="chart";if(val.dt==0x40)out["!type"]="macro";merges=[];objects=[];opts.arrayf=arrayf=[];colinfo=[];rowinfo=[];defwidth=defheight=0;seencol=false;wsprops={Hidden:(Directory[s]||{hs:0}).hs,name:cur_sheet};}break;case'Number':case'BIFF2NUM':case'BIFF2INT':{if(out["!type"]=="chart")if(options.dense?(out[val.r]||[])[val.c]:out[encode_cell({c:val.c,r:val.r})])++val.c;temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe]||{},v:val.val,t:'n'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x1F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case'BoolErr':{temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],v:val.val,t:val.t};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x1F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case'RK':{temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],v:val.rknum,t:'n'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x1F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case'MulRk':{for(var j=val.c;j<=val.C;++j){var ixfe=val.rkrec[j-val.c][0];temp_val={ixfe:ixfe,XF:XFs[ixfe],v:val.rkrec[j-val.c][1],t:'n'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x1F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:j,r:val.r},temp_val,options);}}break;case'Formula':{if(val.val=='String'){last_formula=val;break;}temp_val=make_cell(val.val,val.cell.ixfe,val.tt);temp_val.XF=XFs[temp_val.ixfe];if(options.cellFormula){var _f=val.formula;if(_f&&_f[0]&&_f[0][0]&&_f[0][0][0]=='PtgExp'){var _fr=_f[0][0][1][0],_fc=_f[0][0][1][1];var _fe=encode_cell({r:_fr,c:_fc});if(sharedf[_fe])temp_val.f=""+stringify_formula(val.formula,range,val.cell,supbooks,opts);else temp_val.F=((options.dense?(out[_fr]||[])[_fc]:out[_fe])||{}).F;}else temp_val.f=""+stringify_formula(val.formula,range,val.cell,supbooks,opts);}if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x1F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell(val.cell,temp_val,options);last_formula=val;}break;case'String':{if(last_formula){/* technically always true */last_formula.val=val;temp_val=make_cell(val,last_formula.cell.ixfe,'s');temp_val.XF=XFs[temp_val.ixfe];if(options.cellFormula){temp_val.f=""+stringify_formula(last_formula.formula,range,last_formula.cell,supbooks,opts);}if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x1F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell(last_formula.cell,temp_val,options);last_formula=null;}else throw new Error("String record expects Formula");}break;case'Array':{arrayf.push(val);var _arraystart=encode_cell(val[0].s);cc=options.dense?(out[val[0].s.r]||[])[val[0].s.c]:out[_arraystart];if(options.cellFormula&&cc){if(!last_formula)break;/* technically unreachable */if(!_arraystart||!cc)break;cc.f=""+stringify_formula(val[1],range,val[0],supbooks,opts);cc.F=encode_range(val[0]);}}break;case'ShrFmla':{if(!cell_valid)break;if(!options.cellFormula)break;if(last_cell){/* TODO: capture range */if(!last_formula)break;/* technically unreachable */sharedf[encode_cell(last_formula.cell)]=val[0];cc=options.dense?(out[last_formula.cell.r]||[])[last_formula.cell.c]:out[encode_cell(last_formula.cell)];(cc||{}).f=""+stringify_formula(val[0],range,lastcell,supbooks,opts);}}break;case'LabelSst':temp_val=make_cell(sst[val.isst].t,val.ixfe,'s');if(sst[val.isst].h)temp_val.h=sst[val.isst].h;temp_val.XF=XFs[temp_val.ixfe];if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x1F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);break;case'Blank':if(options.sheetStubs){temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],t:'z'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x1F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case'MulBlank':if(options.sheetStubs){for(var _j=val.c;_j<=val.C;++_j){var _ixfe=val.ixfe[_j-val.c];temp_val={ixfe:_ixfe,XF:XFs[_ixfe],t:'z'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x1F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:_j,r:val.r},temp_val,options);}}break;case'RString':case'Label':case'BIFF2STR':temp_val=make_cell(val.val,val.ixfe,'s');temp_val.XF=XFs[temp_val.ixfe];if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x1F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);break;case'Dimensions':{if(file_depth===1)range=val;/* TODO: stack */}break;case'SST':{sst=val;}break;case'Format':{/* val = [id, fmt] */if(opts.biff==4){BIFF2FmtTable[BIFF2Fmt++]=val[1];for(var b4idx=0;b4idx<BIFF2Fmt+163;++b4idx)if(SSF._table[b4idx]==val[1])break;if(b4idx>=163)SSF.load(val[1],BIFF2Fmt+163);}else SSF.load(val[1],val[0]);}break;case'BIFF2FORMAT':{BIFF2FmtTable[BIFF2Fmt++]=val;for(var b2idx=0;b2idx<BIFF2Fmt+163;++b2idx)if(SSF._table[b2idx]==val)break;if(b2idx>=163)SSF.load(val,BIFF2Fmt+163);}break;case'MergeCells':merges=merges.concat(val);break;case'Obj':objects[val.cmo[0]]=opts.lastobj=val;break;case'TxO':opts.lastobj.TxO=val;break;case'ImData':opts.lastobj.ImData=val;break;case'HLink':{for(rngR=val[0].s.r;rngR<=val[0].e.r;++rngR)for(rngC=val[0].s.c;rngC<=val[0].e.c;++rngC){cc=options.dense?(out[rngR]||[])[rngC]:out[encode_cell({c:rngC,r:rngR})];if(cc)cc.l=val[1];}}break;case'HLinkTooltip':{for(rngR=val[0].s.r;rngR<=val[0].e.r;++rngR)for(rngC=val[0].s.c;rngC<=val[0].e.c;++rngC){cc=options.dense?(out[rngR]||[])[rngC]:out[encode_cell({c:rngC,r:rngR})];if(cc&&cc.l)cc.l.Tooltip=val[1];}}break;/* Comments */case'Note':{if(opts.biff<=5&&opts.biff>=2)break;/* TODO: BIFF5 */cc=options.dense?(out[val[0].r]||[])[val[0].c]:out[encode_cell(val[0])];var noteobj=objects[val[2]];if(!cc){if(options.dense){if(!out[val[0].r])out[val[0].r]=[];cc=out[val[0].r][val[0].c]={t:"z"};}else {cc=out[encode_cell(val[0])]={t:"z"};}range.e.r=Math.max(range.e.r,val[0].r);range.s.r=Math.min(range.s.r,val[0].r);range.e.c=Math.max(range.e.c,val[0].c);range.s.c=Math.min(range.s.c,val[0].c);}if(!cc.c)cc.c=[];cmnt={a:val[1],t:noteobj.TxO.t};cc.c.push(cmnt);}break;default:switch(R.n){/* nested */case'ClrtClient':break;case'XFExt':update_xfext(XFs[val.ixfe],val.ext);break;case'DefColWidth':defwidth=val;break;case'DefaultRowHeight':defheight=val[1];break;// TODO: flags
case'ColInfo':{if(!opts.cellStyles)break;while(val.e>=val.s){colinfo[val.e--]={width:val.w/256};if(!seencol){seencol=true;find_mdw_colw(val.w/256);}process_col(colinfo[val.e+1]);}}break;case'Row':{var rowobj={};if(val.level!=null){rowinfo[val.r]=rowobj;rowobj.level=val.level;}if(val.hidden){rowinfo[val.r]=rowobj;rowobj.hidden=true;}if(val.hpt){rowinfo[val.r]=rowobj;rowobj.hpt=val.hpt;rowobj.hpx=pt2px(val.hpt);}}break;case'LeftMargin':case'RightMargin':case'TopMargin':case'BottomMargin':if(!out['!margins'])default_margins(out['!margins']={});out['!margins'][Rn.slice(0,-6).toLowerCase()]=val;break;case'Setup':// TODO
if(!out['!margins'])default_margins(out['!margins']={});out['!margins'].header=val.header;out['!margins'].footer=val.footer;break;case'Window2':// TODO
// $FlowIgnore
if(val.RTL)Workbook.Views[0].RTL=true;break;case'Header':break;// TODO
case'Footer':break;// TODO
case'HCenter':break;// TODO
case'VCenter':break;// TODO
case'Pls':break;// TODO
case'GCW':break;case'LHRecord':break;case'DBCell':break;// TODO
case'EntExU2':break;// TODO
case'SxView':break;// TODO
case'Sxvd':break;// TODO
case'SXVI':break;// TODO
case'SXVDEx':break;// TODO
case'SxIvd':break;// TODO
case'SXString':break;// TODO
case'Sync':break;case'Addin':break;case'SXDI':break;// TODO
case'SXLI':break;// TODO
case'SXEx':break;// TODO
case'QsiSXTag':break;// TODO
case'Selection':break;case'Feat':break;case'FeatHdr':case'FeatHdr11':break;case'Feature11':case'Feature12':case'List12':break;case'Country':country=val;break;case'RecalcId':break;case'DxGCol':break;// TODO: htmlify
case'Fbi':case'Fbi2':case'GelFrame':break;case'Font':break;// TODO
case'XFCRC':break;// TODO
case'Style':break;// TODO
case'StyleExt':break;// TODO
case'Palette':palette=val;break;case'Theme':themes=val;break;/* Protection */case'ScenarioProtect':break;case'ObjProtect':break;/* Conditional Formatting */case'CondFmt12':break;/* Table */case'Table':break;// TODO
case'TableStyles':break;// TODO
case'TableStyle':break;// TODO
case'TableStyleElement':break;// TODO
/* PivotTable */case'SXStreamID':break;// TODO
case'SXVS':break;// TODO
case'DConRef':break;// TODO
case'SXAddl':break;// TODO
case'DConBin':break;// TODO
case'DConName':break;// TODO
case'SXPI':break;// TODO
case'SxFormat':break;// TODO
case'SxSelect':break;// TODO
case'SxRule':break;// TODO
case'SxFilt':break;// TODO
case'SxItm':break;// TODO
case'SxDXF':break;// TODO
/* Scenario Manager */case'ScenMan':break;/* Data Consolidation */case'DCon':break;/* Watched Cell */case'CellWatch':break;/* Print Settings */case'PrintRowCol':break;case'PrintGrid':break;case'PrintSize':break;case'XCT':break;case'CRN':break;case'Scl':break;case'SheetExt':break;case'SheetExtOptional':break;/* VBA */case'ObNoMacros':break;case'ObProj':break;case'CodeName':{if(!cur_sheet)Workbook.WBProps.CodeName=val||"ThisWorkbook";else wsprops.CodeName=val||wsprops.name;}break;case'GUIDTypeLib':break;case'WOpt':break;// TODO: WTF?
case'PhoneticInfo':break;case'OleObjectSize':break;/* Differential Formatting */case'DXF':case'DXFN':case'DXFN12':case'DXFN12List':case'DXFN12NoCB':break;/* Data Validation */case'Dv':case'DVal':break;/* Data Series */case'BRAI':case'Series':case'SeriesText':break;/* Data Connection */case'DConn':break;case'DbOrParamQry':break;case'DBQueryExt':break;case'OleDbConn':break;case'ExtString':break;/* Formatting */case'IFmtRecord':break;case'CondFmt':case'CF':case'CF12':case'CFEx':break;/* Explicitly Ignored */case'Excel9File':break;case'Units':break;case'InterfaceHdr':case'Mms':case'InterfaceEnd':case'DSF':break;case'BuiltInFnGroupCount':/* 2.4.30 0x0E or 0x10 but excel 2011 generates 0x11? */break;/* View Stuff */case'Window1':case'HideObj':case'GridSet':case'Guts':case'UserBView':case'UserSViewBegin':case'UserSViewEnd':break;case'Pane':break;default:switch(R.n){/* nested */ /* Chart */case'Dat':case'Begin':case'End':case'StartBlock':case'EndBlock':case'Frame':case'Area':case'Axis':case'AxisLine':case'Tick':break;case'AxesUsed':case'CrtLayout12':case'CrtLayout12A':case'CrtLink':case'CrtLine':case'CrtMlFrt':case'CrtMlFrtContinue':break;case'LineFormat':case'AreaFormat':case'Chart':case'Chart3d':case'Chart3DBarShape':case'ChartFormat':case'ChartFrtInfo':break;case'PlotArea':case'PlotGrowth':break;case'SeriesList':case'SerParent':case'SerAuxTrend':break;case'DataFormat':case'SerToCrt':case'FontX':break;case'CatSerRange':case'AxcExt':case'SerFmt':break;case'ShtProps':break;case'DefaultText':case'Text':case'CatLab':break;case'DataLabExtContents':break;case'Legend':case'LegendException':break;case'Pie':case'Scatter':break;case'PieFormat':case'MarkerFormat':break;case'StartObject':case'EndObject':break;case'AlRuns':case'ObjectLink':break;case'SIIndex':break;case'AttachedLabel':case'YMult':break;/* Chart Group */case'Line':case'Bar':break;case'Surf':break;/* Axis Group */case'AxisParent':break;case'Pos':break;case'ValueRange':break;/* Pivot Chart */case'SXViewEx9':break;// TODO
case'SXViewLink':break;case'PivotChartBits':break;case'SBaseRef':break;case'TextPropsStream':break;/* Chart Misc */case'LnExt':break;case'MkrExt':break;case'CrtCoopt':break;/* Query Table */case'Qsi':case'Qsif':case'Qsir':case'QsiSXTag':break;case'TxtQry':break;/* Filter */case'FilterMode':break;case'AutoFilter':case'AutoFilterInfo':break;case'AutoFilter12':break;case'DropDownObjIds':break;case'Sort':break;case'SortData':break;/* Drawing */case'ShapePropsStream':break;case'MsoDrawing':case'MsoDrawingGroup':case'MsoDrawingSelection':break;/* Pub Stuff */case'WebPub':case'AutoWebPub':break;/* Print Stuff */case'HeaderFooter':case'HFPicture':case'PLV':case'HorizontalPageBreaks':case'VerticalPageBreaks':break;/* Behavioral */case'Backup':case'CompressPictures':case'Compat12':break;/* Should not Happen */case'Continue':case'ContinueFrt12':break;/* Future Records */case'FrtFontList':case'FrtWrapper':break;default:switch(R.n){/* nested */ /* BIFF5 records */case'TabIdConf':case'Radar':case'RadarArea':case'DropBar':case'Intl':case'CoordList':case'SerAuxErrBar':break;/* BIFF2-4 records */case'BIFF2FONTCLR':case'BIFF2FMTCNT':case'BIFF2FONTXTRA':break;case'BIFF2XF':case'BIFF3XF':case'BIFF4XF':break;case'BIFF4FMTCNT':case'BIFF2ROW':case'BIFF2WINDOW2':break;/* Miscellaneous */case'SCENARIO':case'DConBin':case'PicF':case'DataLabExt':case'Lel':case'BopPop':case'BopPopCustom':case'RealTimeData':case'Name':break;case'LHNGraph':case'FnGroupName':case'AddMenu':case'LPr':break;case'ListObj':case'ListField':break;case'RRSort':break;case'BigName':break;case'ToolbarHdr':case'ToolbarEnd':break;case'DDEObjName':break;case'FRTArchId$':break;default:if(options.WTF)throw 'Unrecognized Record '+R.n;}}}}}else blob.l+=length;}wb.SheetNames=keys(Directory).sort(function(a,b){return Number(a)-Number(b);}).map(function(x){return Directory[x].name;});if(!options.bookSheets)wb.Sheets=Sheets;if(wb.Sheets)FilterDatabases.forEach(function(r,i){wb.Sheets[wb.SheetNames[i]]['!autofilter']=r;});wb.Preamble=Preamble;wb.Strings=sst;wb.SSF=SSF.get_table();if(opts.enc)wb.Encryption=opts.enc;if(themes)wb.Themes=themes;wb.Metadata={};if(country!==undefined)wb.Metadata.Country=country;if(supbooks.names.length>0)Workbook.Names=supbooks.names;wb.Workbook=Workbook;return wb;}/* TODO: split props*/var PSCLSID={SI:"e0859ff2f94f6810ab9108002b27b3d9",DSI:"02d5cdd59c2e1b10939708002b2cf9ae",UDI:"05d5cdd59c2e1b10939708002b2cf9ae"};function parse_xls_props(cfb,props,o){/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */var DSI=CFB.find(cfb,'!DocumentSummaryInformation');if(DSI&&DSI.size>0)try{var DocSummary=parse_PropertySetStream(DSI,DocSummaryPIDDSI,PSCLSID.DSI);for(var d in DocSummary)props[d]=DocSummary[d];}catch(e){if(o.WTF)throw e;/* empty */}/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/var SI=CFB.find(cfb,'!SummaryInformation');if(SI&&SI.size>0)try{var Summary=parse_PropertySetStream(SI,SummaryPIDSI,PSCLSID.SI);for(var s in Summary)if(props[s]==null)props[s]=Summary[s];}catch(e){if(o.WTF)throw e;/* empty */}if(props.HeadingPairs&&props.TitlesOfParts){load_props_pairs(props.HeadingPairs,props.TitlesOfParts,props,o);delete props.HeadingPairs;delete props.TitlesOfParts;}}function write_xls_props(wb,cfb){var DSEntries=[],SEntries=[],CEntries=[];var i=0,Keys;if(wb.Props){Keys=keys(wb.Props);// $FlowIgnore
for(i=0;i<Keys.length;++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE,Keys[i])?DSEntries:Object.prototype.hasOwnProperty.call(SummaryRE,Keys[i])?SEntries:CEntries).push([Keys[i],wb.Props[Keys[i]]]);}if(wb.Custprops){Keys=keys(wb.Custprops);// $FlowIgnore
for(i=0;i<Keys.length;++i)if(!Object.prototype.hasOwnProperty.call(wb.Props||{},Keys[i]))(Object.prototype.hasOwnProperty.call(DocSummaryRE,Keys[i])?DSEntries:Object.prototype.hasOwnProperty.call(SummaryRE,Keys[i])?SEntries:CEntries).push([Keys[i],wb.Custprops[Keys[i]]]);}var CEntries2=[];for(i=0;i<CEntries.length;++i){if(XLSPSSkip.indexOf(CEntries[i][0])>-1)continue;if(CEntries[i][1]==null)continue;CEntries2.push(CEntries[i]);}if(SEntries.length)CFB.utils.cfb_add(cfb,"/\u0005SummaryInformation",write_PropertySetStream(SEntries,PSCLSID.SI,SummaryRE,SummaryPIDSI));if(DSEntries.length||CEntries2.length)CFB.utils.cfb_add(cfb,"/\u0005DocumentSummaryInformation",write_PropertySetStream(DSEntries,PSCLSID.DSI,DocSummaryRE,DocSummaryPIDDSI,CEntries2.length?CEntries2:null,PSCLSID.UDI));}function parse_xlscfb(cfb,options){if(!options)options={};fix_read_opts(options);reset_cp();if(options.codepage)set_ansi(options.codepage);var CompObj,WB;if(cfb.FullPaths){if(CFB.find(cfb,'/encryption'))throw new Error("File is password-protected");CompObj=CFB.find(cfb,'!CompObj');WB=CFB.find(cfb,'/Workbook')||CFB.find(cfb,'/Book');}else {switch(options.type){case'base64':cfb=s2a(Base64.decode(cfb));break;case'binary':cfb=s2a(cfb);break;case'buffer':break;case'array':if(!Array.isArray(cfb))cfb=Array.prototype.slice.call(cfb);break;}prep_blob(cfb,0);WB={content:cfb};}var WorkbookP;var _data;if(CompObj)parse_compobj(CompObj);if(options.bookProps&&!options.bookSheets)WorkbookP={};else {var T=has_buf?'buffer':'array';if(WB&&WB.content)WorkbookP=parse_workbook(WB.content,options);/* Quattro Pro 7-8 */else if((_data=CFB.find(cfb,'PerfectOffice_MAIN'))&&_data.content)WorkbookP=WK_.to_workbook(_data.content,(options.type=T,options));/* Quattro Pro 9 */else if((_data=CFB.find(cfb,'NativeContent_MAIN'))&&_data.content)WorkbookP=WK_.to_workbook(_data.content,(options.type=T,options));else throw new Error("Cannot find Workbook stream");if(options.bookVBA&&cfb.FullPaths&&CFB.find(cfb,'/_VBA_PROJECT_CUR/VBA/dir'))WorkbookP.vbaraw=make_vba_xls(cfb);}var props={};if(cfb.FullPaths)parse_xls_props(cfb,props,options);WorkbookP.Props=WorkbookP.Custprops=props;/* TODO: split up properties */if(options.bookFiles)WorkbookP.cfb=cfb;/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */return WorkbookP;}function write_xlscfb(wb,opts){var o=opts||{};var cfb=CFB.utils.cfb_new({root:"R"});var wbpath="/Workbook";switch(o.bookType||"xls"){case"xls":o.bookType="biff8";/* falls through */case"xla":if(!o.bookType)o.bookType="xla";/* falls through */case"biff8":wbpath="/Workbook";o.biff=8;break;case"biff5":wbpath="/Book";o.biff=5;break;default:throw new Error("invalid type "+o.bookType+" for XLS CFB");}CFB.utils.cfb_add(cfb,wbpath,write_biff_buf(wb,o));if(o.biff==8&&(wb.Props||wb.Custprops))write_xls_props(wb,cfb);// TODO: SI, DSI, CO
if(o.biff==8&&wb.vbaraw)fill_vba_xls(cfb,CFB.read(wb.vbaraw,{type:typeof wb.vbaraw=="string"?"binary":"buffer"}));return cfb;}/* [MS-XLSB] 2.3 Record Enumeration */var XLSBRecordEnum={0x0000:{n:"BrtRowHdr",f:parse_BrtRowHdr},0x0001:{n:"BrtCellBlank",f:parse_BrtCellBlank},0x0002:{n:"BrtCellRk",f:parse_BrtCellRk},0x0003:{n:"BrtCellError",f:parse_BrtCellError},0x0004:{n:"BrtCellBool",f:parse_BrtCellBool},0x0005:{n:"BrtCellReal",f:parse_BrtCellReal},0x0006:{n:"BrtCellSt",f:parse_BrtCellSt},0x0007:{n:"BrtCellIsst",f:parse_BrtCellIsst},0x0008:{n:"BrtFmlaString",f:parse_BrtFmlaString},0x0009:{n:"BrtFmlaNum",f:parse_BrtFmlaNum},0x000A:{n:"BrtFmlaBool",f:parse_BrtFmlaBool},0x000B:{n:"BrtFmlaError",f:parse_BrtFmlaError},0x000C:{n:"BrtShortBlank",f:parse_BrtShortBlank},0x000D:{n:"BrtShortRk",f:parse_BrtShortRk},0x000E:{n:"BrtShortError",f:parse_BrtShortError},0x000F:{n:"BrtShortBool",f:parse_BrtShortBool},0x0010:{n:"BrtShortReal",f:parse_BrtShortReal},0x0011:{n:"BrtShortSt",f:parse_BrtShortSt},0x0012:{n:"BrtShortIsst",f:parse_BrtShortIsst},0x0013:{n:"BrtSSTItem",f:parse_RichStr},0x0014:{n:"BrtPCDIMissing"},0x0015:{n:"BrtPCDINumber"},0x0016:{n:"BrtPCDIBoolean"},0x0017:{n:"BrtPCDIError"},0x0018:{n:"BrtPCDIString"},0x0019:{n:"BrtPCDIDatetime"},0x001A:{n:"BrtPCDIIndex"},0x001B:{n:"BrtPCDIAMissing"},0x001C:{n:"BrtPCDIANumber"},0x001D:{n:"BrtPCDIABoolean"},0x001E:{n:"BrtPCDIAError"},0x001F:{n:"BrtPCDIAString"},0x0020:{n:"BrtPCDIADatetime"},0x0021:{n:"BrtPCRRecord"},0x0022:{n:"BrtPCRRecordDt"},0x0023:{n:"BrtFRTBegin"},0x0024:{n:"BrtFRTEnd"},0x0025:{n:"BrtACBegin"},0x0026:{n:"BrtACEnd"},0x0027:{n:"BrtName",f:parse_BrtName},0x0028:{n:"BrtIndexRowBlock"},0x002A:{n:"BrtIndexBlock"},0x002B:{n:"BrtFont",f:parse_BrtFont},0x002C:{n:"BrtFmt",f:parse_BrtFmt},0x002D:{n:"BrtFill",f:parse_BrtFill},0x002E:{n:"BrtBorder",f:parse_BrtBorder},0x002F:{n:"BrtXF",f:parse_BrtXF},0x0030:{n:"BrtStyle"},0x0031:{n:"BrtCellMeta"},0x0032:{n:"BrtValueMeta"},0x0033:{n:"BrtMdb"},0x0034:{n:"BrtBeginFmd"},0x0035:{n:"BrtEndFmd"},0x0036:{n:"BrtBeginMdx"},0x0037:{n:"BrtEndMdx"},0x0038:{n:"BrtBeginMdxTuple"},0x0039:{n:"BrtEndMdxTuple"},0x003A:{n:"BrtMdxMbrIstr"},0x003B:{n:"BrtStr"},0x003C:{n:"BrtColInfo",f:parse_ColInfo},0x003E:{n:"BrtCellRString"},0x003F:{n:"BrtCalcChainItem$",f:parse_BrtCalcChainItem$},0x0040:{n:"BrtDVal",f:parse_BrtDVal},0x0041:{n:"BrtSxvcellNum"},0x0042:{n:"BrtSxvcellStr"},0x0043:{n:"BrtSxvcellBool"},0x0044:{n:"BrtSxvcellErr"},0x0045:{n:"BrtSxvcellDate"},0x0046:{n:"BrtSxvcellNil"},0x0080:{n:"BrtFileVersion"},0x0081:{n:"BrtBeginSheet"},0x0082:{n:"BrtEndSheet"},0x0083:{n:"BrtBeginBook",f:parsenoop,p:0},0x0084:{n:"BrtEndBook"},0x0085:{n:"BrtBeginWsViews"},0x0086:{n:"BrtEndWsViews"},0x0087:{n:"BrtBeginBookViews"},0x0088:{n:"BrtEndBookViews"},0x0089:{n:"BrtBeginWsView",f:parse_BrtBeginWsView},0x008A:{n:"BrtEndWsView"},0x008B:{n:"BrtBeginCsViews"},0x008C:{n:"BrtEndCsViews"},0x008D:{n:"BrtBeginCsView"},0x008E:{n:"BrtEndCsView"},0x008F:{n:"BrtBeginBundleShs"},0x0090:{n:"BrtEndBundleShs"},0x0091:{n:"BrtBeginSheetData"},0x0092:{n:"BrtEndSheetData"},0x0093:{n:"BrtWsProp",f:parse_BrtWsProp},0x0094:{n:"BrtWsDim",f:parse_BrtWsDim,p:16},0x0097:{n:"BrtPane",f:parse_BrtPane},0x0098:{n:"BrtSel"},0x0099:{n:"BrtWbProp",f:parse_BrtWbProp},0x009A:{n:"BrtWbFactoid"},0x009B:{n:"BrtFileRecover"},0x009C:{n:"BrtBundleSh",f:parse_BrtBundleSh},0x009D:{n:"BrtCalcProp"},0x009E:{n:"BrtBookView"},0x009F:{n:"BrtBeginSst",f:parse_BrtBeginSst},0x00A0:{n:"BrtEndSst"},0x00A1:{n:"BrtBeginAFilter",f:parse_UncheckedRfX},0x00A2:{n:"BrtEndAFilter"},0x00A3:{n:"BrtBeginFilterColumn"},0x00A4:{n:"BrtEndFilterColumn"},0x00A5:{n:"BrtBeginFilters"},0x00A6:{n:"BrtEndFilters"},0x00A7:{n:"BrtFilter"},0x00A8:{n:"BrtColorFilter"},0x00A9:{n:"BrtIconFilter"},0x00AA:{n:"BrtTop10Filter"},0x00AB:{n:"BrtDynamicFilter"},0x00AC:{n:"BrtBeginCustomFilters"},0x00AD:{n:"BrtEndCustomFilters"},0x00AE:{n:"BrtCustomFilter"},0x00AF:{n:"BrtAFilterDateGroupItem"},0x00B0:{n:"BrtMergeCell",f:parse_BrtMergeCell},0x00B1:{n:"BrtBeginMergeCells"},0x00B2:{n:"BrtEndMergeCells"},0x00B3:{n:"BrtBeginPivotCacheDef"},0x00B4:{n:"BrtEndPivotCacheDef"},0x00B5:{n:"BrtBeginPCDFields"},0x00B6:{n:"BrtEndPCDFields"},0x00B7:{n:"BrtBeginPCDField"},0x00B8:{n:"BrtEndPCDField"},0x00B9:{n:"BrtBeginPCDSource"},0x00BA:{n:"BrtEndPCDSource"},0x00BB:{n:"BrtBeginPCDSRange"},0x00BC:{n:"BrtEndPCDSRange"},0x00BD:{n:"BrtBeginPCDFAtbl"},0x00BE:{n:"BrtEndPCDFAtbl"},0x00BF:{n:"BrtBeginPCDIRun"},0x00C0:{n:"BrtEndPCDIRun"},0x00C1:{n:"BrtBeginPivotCacheRecords"},0x00C2:{n:"BrtEndPivotCacheRecords"},0x00C3:{n:"BrtBeginPCDHierarchies"},0x00C4:{n:"BrtEndPCDHierarchies"},0x00C5:{n:"BrtBeginPCDHierarchy"},0x00C6:{n:"BrtEndPCDHierarchy"},0x00C7:{n:"BrtBeginPCDHFieldsUsage"},0x00C8:{n:"BrtEndPCDHFieldsUsage"},0x00C9:{n:"BrtBeginExtConnection"},0x00CA:{n:"BrtEndExtConnection"},0x00CB:{n:"BrtBeginECDbProps"},0x00CC:{n:"BrtEndECDbProps"},0x00CD:{n:"BrtBeginECOlapProps"},0x00CE:{n:"BrtEndECOlapProps"},0x00CF:{n:"BrtBeginPCDSConsol"},0x00D0:{n:"BrtEndPCDSConsol"},0x00D1:{n:"BrtBeginPCDSCPages"},0x00D2:{n:"BrtEndPCDSCPages"},0x00D3:{n:"BrtBeginPCDSCPage"},0x00D4:{n:"BrtEndPCDSCPage"},0x00D5:{n:"BrtBeginPCDSCPItem"},0x00D6:{n:"BrtEndPCDSCPItem"},0x00D7:{n:"BrtBeginPCDSCSets"},0x00D8:{n:"BrtEndPCDSCSets"},0x00D9:{n:"BrtBeginPCDSCSet"},0x00DA:{n:"BrtEndPCDSCSet"},0x00DB:{n:"BrtBeginPCDFGroup"},0x00DC:{n:"BrtEndPCDFGroup"},0x00DD:{n:"BrtBeginPCDFGItems"},0x00DE:{n:"BrtEndPCDFGItems"},0x00DF:{n:"BrtBeginPCDFGRange"},0x00E0:{n:"BrtEndPCDFGRange"},0x00E1:{n:"BrtBeginPCDFGDiscrete"},0x00E2:{n:"BrtEndPCDFGDiscrete"},0x00E3:{n:"BrtBeginPCDSDTupleCache"},0x00E4:{n:"BrtEndPCDSDTupleCache"},0x00E5:{n:"BrtBeginPCDSDTCEntries"},0x00E6:{n:"BrtEndPCDSDTCEntries"},0x00E7:{n:"BrtBeginPCDSDTCEMembers"},0x00E8:{n:"BrtEndPCDSDTCEMembers"},0x00E9:{n:"BrtBeginPCDSDTCEMember"},0x00EA:{n:"BrtEndPCDSDTCEMember"},0x00EB:{n:"BrtBeginPCDSDTCQueries"},0x00EC:{n:"BrtEndPCDSDTCQueries"},0x00ED:{n:"BrtBeginPCDSDTCQuery"},0x00EE:{n:"BrtEndPCDSDTCQuery"},0x00EF:{n:"BrtBeginPCDSDTCSets"},0x00F0:{n:"BrtEndPCDSDTCSets"},0x00F1:{n:"BrtBeginPCDSDTCSet"},0x00F2:{n:"BrtEndPCDSDTCSet"},0x00F3:{n:"BrtBeginPCDCalcItems"},0x00F4:{n:"BrtEndPCDCalcItems"},0x00F5:{n:"BrtBeginPCDCalcItem"},0x00F6:{n:"BrtEndPCDCalcItem"},0x00F7:{n:"BrtBeginPRule"},0x00F8:{n:"BrtEndPRule"},0x00F9:{n:"BrtBeginPRFilters"},0x00FA:{n:"BrtEndPRFilters"},0x00FB:{n:"BrtBeginPRFilter"},0x00FC:{n:"BrtEndPRFilter"},0x00FD:{n:"BrtBeginPNames"},0x00FE:{n:"BrtEndPNames"},0x00FF:{n:"BrtBeginPName"},0x0100:{n:"BrtEndPName"},0x0101:{n:"BrtBeginPNPairs"},0x0102:{n:"BrtEndPNPairs"},0x0103:{n:"BrtBeginPNPair"},0x0104:{n:"BrtEndPNPair"},0x0105:{n:"BrtBeginECWebProps"},0x0106:{n:"BrtEndECWebProps"},0x0107:{n:"BrtBeginEcWpTables"},0x0108:{n:"BrtEndECWPTables"},0x0109:{n:"BrtBeginECParams"},0x010A:{n:"BrtEndECParams"},0x010B:{n:"BrtBeginECParam"},0x010C:{n:"BrtEndECParam"},0x010D:{n:"BrtBeginPCDKPIs"},0x010E:{n:"BrtEndPCDKPIs"},0x010F:{n:"BrtBeginPCDKPI"},0x0110:{n:"BrtEndPCDKPI"},0x0111:{n:"BrtBeginDims"},0x0112:{n:"BrtEndDims"},0x0113:{n:"BrtBeginDim"},0x0114:{n:"BrtEndDim"},0x0115:{n:"BrtIndexPartEnd"},0x0116:{n:"BrtBeginStyleSheet"},0x0117:{n:"BrtEndStyleSheet"},0x0118:{n:"BrtBeginSXView"},0x0119:{n:"BrtEndSXVI"},0x011A:{n:"BrtBeginSXVI"},0x011B:{n:"BrtBeginSXVIs"},0x011C:{n:"BrtEndSXVIs"},0x011D:{n:"BrtBeginSXVD"},0x011E:{n:"BrtEndSXVD"},0x011F:{n:"BrtBeginSXVDs"},0x0120:{n:"BrtEndSXVDs"},0x0121:{n:"BrtBeginSXPI"},0x0122:{n:"BrtEndSXPI"},0x0123:{n:"BrtBeginSXPIs"},0x0124:{n:"BrtEndSXPIs"},0x0125:{n:"BrtBeginSXDI"},0x0126:{n:"BrtEndSXDI"},0x0127:{n:"BrtBeginSXDIs"},0x0128:{n:"BrtEndSXDIs"},0x0129:{n:"BrtBeginSXLI"},0x012A:{n:"BrtEndSXLI"},0x012B:{n:"BrtBeginSXLIRws"},0x012C:{n:"BrtEndSXLIRws"},0x012D:{n:"BrtBeginSXLICols"},0x012E:{n:"BrtEndSXLICols"},0x012F:{n:"BrtBeginSXFormat"},0x0130:{n:"BrtEndSXFormat"},0x0131:{n:"BrtBeginSXFormats"},0x0132:{n:"BrtEndSxFormats"},0x0133:{n:"BrtBeginSxSelect"},0x0134:{n:"BrtEndSxSelect"},0x0135:{n:"BrtBeginISXVDRws"},0x0136:{n:"BrtEndISXVDRws"},0x0137:{n:"BrtBeginISXVDCols"},0x0138:{n:"BrtEndISXVDCols"},0x0139:{n:"BrtEndSXLocation"},0x013A:{n:"BrtBeginSXLocation"},0x013B:{n:"BrtEndSXView"},0x013C:{n:"BrtBeginSXTHs"},0x013D:{n:"BrtEndSXTHs"},0x013E:{n:"BrtBeginSXTH"},0x013F:{n:"BrtEndSXTH"},0x0140:{n:"BrtBeginISXTHRws"},0x0141:{n:"BrtEndISXTHRws"},0x0142:{n:"BrtBeginISXTHCols"},0x0143:{n:"BrtEndISXTHCols"},0x0144:{n:"BrtBeginSXTDMPS"},0x0145:{n:"BrtEndSXTDMPs"},0x0146:{n:"BrtBeginSXTDMP"},0x0147:{n:"BrtEndSXTDMP"},0x0148:{n:"BrtBeginSXTHItems"},0x0149:{n:"BrtEndSXTHItems"},0x014A:{n:"BrtBeginSXTHItem"},0x014B:{n:"BrtEndSXTHItem"},0x014C:{n:"BrtBeginMetadata"},0x014D:{n:"BrtEndMetadata"},0x014E:{n:"BrtBeginEsmdtinfo"},0x014F:{n:"BrtMdtinfo"},0x0150:{n:"BrtEndEsmdtinfo"},0x0151:{n:"BrtBeginEsmdb"},0x0152:{n:"BrtEndEsmdb"},0x0153:{n:"BrtBeginEsfmd"},0x0154:{n:"BrtEndEsfmd"},0x0155:{n:"BrtBeginSingleCells"},0x0156:{n:"BrtEndSingleCells"},0x0157:{n:"BrtBeginList"},0x0158:{n:"BrtEndList"},0x0159:{n:"BrtBeginListCols"},0x015A:{n:"BrtEndListCols"},0x015B:{n:"BrtBeginListCol"},0x015C:{n:"BrtEndListCol"},0x015D:{n:"BrtBeginListXmlCPr"},0x015E:{n:"BrtEndListXmlCPr"},0x015F:{n:"BrtListCCFmla"},0x0160:{n:"BrtListTrFmla"},0x0161:{n:"BrtBeginExternals"},0x0162:{n:"BrtEndExternals"},0x0163:{n:"BrtSupBookSrc",f:parse_RelID},0x0165:{n:"BrtSupSelf"},0x0166:{n:"BrtSupSame"},0x0167:{n:"BrtSupTabs"},0x0168:{n:"BrtBeginSupBook"},0x0169:{n:"BrtPlaceholderName"},0x016A:{n:"BrtExternSheet",f:parse_ExternSheet},0x016B:{n:"BrtExternTableStart"},0x016C:{n:"BrtExternTableEnd"},0x016E:{n:"BrtExternRowHdr"},0x016F:{n:"BrtExternCellBlank"},0x0170:{n:"BrtExternCellReal"},0x0171:{n:"BrtExternCellBool"},0x0172:{n:"BrtExternCellError"},0x0173:{n:"BrtExternCellString"},0x0174:{n:"BrtBeginEsmdx"},0x0175:{n:"BrtEndEsmdx"},0x0176:{n:"BrtBeginMdxSet"},0x0177:{n:"BrtEndMdxSet"},0x0178:{n:"BrtBeginMdxMbrProp"},0x0179:{n:"BrtEndMdxMbrProp"},0x017A:{n:"BrtBeginMdxKPI"},0x017B:{n:"BrtEndMdxKPI"},0x017C:{n:"BrtBeginEsstr"},0x017D:{n:"BrtEndEsstr"},0x017E:{n:"BrtBeginPRFItem"},0x017F:{n:"BrtEndPRFItem"},0x0180:{n:"BrtBeginPivotCacheIDs"},0x0181:{n:"BrtEndPivotCacheIDs"},0x0182:{n:"BrtBeginPivotCacheID"},0x0183:{n:"BrtEndPivotCacheID"},0x0184:{n:"BrtBeginISXVIs"},0x0185:{n:"BrtEndISXVIs"},0x0186:{n:"BrtBeginColInfos"},0x0187:{n:"BrtEndColInfos"},0x0188:{n:"BrtBeginRwBrk"},0x0189:{n:"BrtEndRwBrk"},0x018A:{n:"BrtBeginColBrk"},0x018B:{n:"BrtEndColBrk"},0x018C:{n:"BrtBrk"},0x018D:{n:"BrtUserBookView"},0x018E:{n:"BrtInfo"},0x018F:{n:"BrtCUsr"},0x0190:{n:"BrtUsr"},0x0191:{n:"BrtBeginUsers"},0x0193:{n:"BrtEOF"},0x0194:{n:"BrtUCR"},0x0195:{n:"BrtRRInsDel"},0x0196:{n:"BrtRREndInsDel"},0x0197:{n:"BrtRRMove"},0x0198:{n:"BrtRREndMove"},0x0199:{n:"BrtRRChgCell"},0x019A:{n:"BrtRREndChgCell"},0x019B:{n:"BrtRRHeader"},0x019C:{n:"BrtRRUserView"},0x019D:{n:"BrtRRRenSheet"},0x019E:{n:"BrtRRInsertSh"},0x019F:{n:"BrtRRDefName"},0x01A0:{n:"BrtRRNote"},0x01A1:{n:"BrtRRConflict"},0x01A2:{n:"BrtRRTQSIF"},0x01A3:{n:"BrtRRFormat"},0x01A4:{n:"BrtRREndFormat"},0x01A5:{n:"BrtRRAutoFmt"},0x01A6:{n:"BrtBeginUserShViews"},0x01A7:{n:"BrtBeginUserShView"},0x01A8:{n:"BrtEndUserShView"},0x01A9:{n:"BrtEndUserShViews"},0x01AA:{n:"BrtArrFmla",f:parse_BrtArrFmla},0x01AB:{n:"BrtShrFmla",f:parse_BrtShrFmla},0x01AC:{n:"BrtTable"},0x01AD:{n:"BrtBeginExtConnections"},0x01AE:{n:"BrtEndExtConnections"},0x01AF:{n:"BrtBeginPCDCalcMems"},0x01B0:{n:"BrtEndPCDCalcMems"},0x01B1:{n:"BrtBeginPCDCalcMem"},0x01B2:{n:"BrtEndPCDCalcMem"},0x01B3:{n:"BrtBeginPCDHGLevels"},0x01B4:{n:"BrtEndPCDHGLevels"},0x01B5:{n:"BrtBeginPCDHGLevel"},0x01B6:{n:"BrtEndPCDHGLevel"},0x01B7:{n:"BrtBeginPCDHGLGroups"},0x01B8:{n:"BrtEndPCDHGLGroups"},0x01B9:{n:"BrtBeginPCDHGLGroup"},0x01BA:{n:"BrtEndPCDHGLGroup"},0x01BB:{n:"BrtBeginPCDHGLGMembers"},0x01BC:{n:"BrtEndPCDHGLGMembers"},0x01BD:{n:"BrtBeginPCDHGLGMember"},0x01BE:{n:"BrtEndPCDHGLGMember"},0x01BF:{n:"BrtBeginQSI"},0x01C0:{n:"BrtEndQSI"},0x01C1:{n:"BrtBeginQSIR"},0x01C2:{n:"BrtEndQSIR"},0x01C3:{n:"BrtBeginDeletedNames"},0x01C4:{n:"BrtEndDeletedNames"},0x01C5:{n:"BrtBeginDeletedName"},0x01C6:{n:"BrtEndDeletedName"},0x01C7:{n:"BrtBeginQSIFs"},0x01C8:{n:"BrtEndQSIFs"},0x01C9:{n:"BrtBeginQSIF"},0x01CA:{n:"BrtEndQSIF"},0x01CB:{n:"BrtBeginAutoSortScope"},0x01CC:{n:"BrtEndAutoSortScope"},0x01CD:{n:"BrtBeginConditionalFormatting"},0x01CE:{n:"BrtEndConditionalFormatting"},0x01CF:{n:"BrtBeginCFRule"},0x01D0:{n:"BrtEndCFRule"},0x01D1:{n:"BrtBeginIconSet"},0x01D2:{n:"BrtEndIconSet"},0x01D3:{n:"BrtBeginDatabar"},0x01D4:{n:"BrtEndDatabar"},0x01D5:{n:"BrtBeginColorScale"},0x01D6:{n:"BrtEndColorScale"},0x01D7:{n:"BrtCFVO"},0x01D8:{n:"BrtExternValueMeta"},0x01D9:{n:"BrtBeginColorPalette"},0x01DA:{n:"BrtEndColorPalette"},0x01DB:{n:"BrtIndexedColor"},0x01DC:{n:"BrtMargins",f:parse_BrtMargins},0x01DD:{n:"BrtPrintOptions"},0x01DE:{n:"BrtPageSetup"},0x01DF:{n:"BrtBeginHeaderFooter"},0x01E0:{n:"BrtEndHeaderFooter"},0x01E1:{n:"BrtBeginSXCrtFormat"},0x01E2:{n:"BrtEndSXCrtFormat"},0x01E3:{n:"BrtBeginSXCrtFormats"},0x01E4:{n:"BrtEndSXCrtFormats"},0x01E5:{n:"BrtWsFmtInfo",f:parse_BrtWsFmtInfo},0x01E6:{n:"BrtBeginMgs"},0x01E7:{n:"BrtEndMGs"},0x01E8:{n:"BrtBeginMGMaps"},0x01E9:{n:"BrtEndMGMaps"},0x01EA:{n:"BrtBeginMG"},0x01EB:{n:"BrtEndMG"},0x01EC:{n:"BrtBeginMap"},0x01ED:{n:"BrtEndMap"},0x01EE:{n:"BrtHLink",f:parse_BrtHLink},0x01EF:{n:"BrtBeginDCon"},0x01F0:{n:"BrtEndDCon"},0x01F1:{n:"BrtBeginDRefs"},0x01F2:{n:"BrtEndDRefs"},0x01F3:{n:"BrtDRef"},0x01F4:{n:"BrtBeginScenMan"},0x01F5:{n:"BrtEndScenMan"},0x01F6:{n:"BrtBeginSct"},0x01F7:{n:"BrtEndSct"},0x01F8:{n:"BrtSlc"},0x01F9:{n:"BrtBeginDXFs"},0x01FA:{n:"BrtEndDXFs"},0x01FB:{n:"BrtDXF"},0x01FC:{n:"BrtBeginTableStyles"},0x01FD:{n:"BrtEndTableStyles"},0x01FE:{n:"BrtBeginTableStyle"},0x01FF:{n:"BrtEndTableStyle"},0x0200:{n:"BrtTableStyleElement"},0x0201:{n:"BrtTableStyleClient"},0x0202:{n:"BrtBeginVolDeps"},0x0203:{n:"BrtEndVolDeps"},0x0204:{n:"BrtBeginVolType"},0x0205:{n:"BrtEndVolType"},0x0206:{n:"BrtBeginVolMain"},0x0207:{n:"BrtEndVolMain"},0x0208:{n:"BrtBeginVolTopic"},0x0209:{n:"BrtEndVolTopic"},0x020A:{n:"BrtVolSubtopic"},0x020B:{n:"BrtVolRef"},0x020C:{n:"BrtVolNum"},0x020D:{n:"BrtVolErr"},0x020E:{n:"BrtVolStr"},0x020F:{n:"BrtVolBool"},0x0210:{n:"BrtBeginCalcChain$"},0x0211:{n:"BrtEndCalcChain$"},0x0212:{n:"BrtBeginSortState"},0x0213:{n:"BrtEndSortState"},0x0214:{n:"BrtBeginSortCond"},0x0215:{n:"BrtEndSortCond"},0x0216:{n:"BrtBookProtection"},0x0217:{n:"BrtSheetProtection"},0x0218:{n:"BrtRangeProtection"},0x0219:{n:"BrtPhoneticInfo"},0x021A:{n:"BrtBeginECTxtWiz"},0x021B:{n:"BrtEndECTxtWiz"},0x021C:{n:"BrtBeginECTWFldInfoLst"},0x021D:{n:"BrtEndECTWFldInfoLst"},0x021E:{n:"BrtBeginECTwFldInfo"},0x0224:{n:"BrtFileSharing"},0x0225:{n:"BrtOleSize"},0x0226:{n:"BrtDrawing",f:parse_RelID},0x0227:{n:"BrtLegacyDrawing"},0x0228:{n:"BrtLegacyDrawingHF"},0x0229:{n:"BrtWebOpt"},0x022A:{n:"BrtBeginWebPubItems"},0x022B:{n:"BrtEndWebPubItems"},0x022C:{n:"BrtBeginWebPubItem"},0x022D:{n:"BrtEndWebPubItem"},0x022E:{n:"BrtBeginSXCondFmt"},0x022F:{n:"BrtEndSXCondFmt"},0x0230:{n:"BrtBeginSXCondFmts"},0x0231:{n:"BrtEndSXCondFmts"},0x0232:{n:"BrtBkHim"},0x0234:{n:"BrtColor"},0x0235:{n:"BrtBeginIndexedColors"},0x0236:{n:"BrtEndIndexedColors"},0x0239:{n:"BrtBeginMRUColors"},0x023A:{n:"BrtEndMRUColors"},0x023C:{n:"BrtMRUColor"},0x023D:{n:"BrtBeginDVals"},0x023E:{n:"BrtEndDVals"},0x0241:{n:"BrtSupNameStart"},0x0242:{n:"BrtSupNameValueStart"},0x0243:{n:"BrtSupNameValueEnd"},0x0244:{n:"BrtSupNameNum"},0x0245:{n:"BrtSupNameErr"},0x0246:{n:"BrtSupNameSt"},0x0247:{n:"BrtSupNameNil"},0x0248:{n:"BrtSupNameBool"},0x0249:{n:"BrtSupNameFmla"},0x024A:{n:"BrtSupNameBits"},0x024B:{n:"BrtSupNameEnd"},0x024C:{n:"BrtEndSupBook"},0x024D:{n:"BrtCellSmartTagProperty"},0x024E:{n:"BrtBeginCellSmartTag"},0x024F:{n:"BrtEndCellSmartTag"},0x0250:{n:"BrtBeginCellSmartTags"},0x0251:{n:"BrtEndCellSmartTags"},0x0252:{n:"BrtBeginSmartTags"},0x0253:{n:"BrtEndSmartTags"},0x0254:{n:"BrtSmartTagType"},0x0255:{n:"BrtBeginSmartTagTypes"},0x0256:{n:"BrtEndSmartTagTypes"},0x0257:{n:"BrtBeginSXFilters"},0x0258:{n:"BrtEndSXFilters"},0x0259:{n:"BrtBeginSXFILTER"},0x025A:{n:"BrtEndSXFilter"},0x025B:{n:"BrtBeginFills"},0x025C:{n:"BrtEndFills"},0x025D:{n:"BrtBeginCellWatches"},0x025E:{n:"BrtEndCellWatches"},0x025F:{n:"BrtCellWatch"},0x0260:{n:"BrtBeginCRErrs"},0x0261:{n:"BrtEndCRErrs"},0x0262:{n:"BrtCrashRecErr"},0x0263:{n:"BrtBeginFonts"},0x0264:{n:"BrtEndFonts"},0x0265:{n:"BrtBeginBorders"},0x0266:{n:"BrtEndBorders"},0x0267:{n:"BrtBeginFmts"},0x0268:{n:"BrtEndFmts"},0x0269:{n:"BrtBeginCellXFs"},0x026A:{n:"BrtEndCellXFs"},0x026B:{n:"BrtBeginStyles"},0x026C:{n:"BrtEndStyles"},0x0271:{n:"BrtBigName"},0x0272:{n:"BrtBeginCellStyleXFs"},0x0273:{n:"BrtEndCellStyleXFs"},0x0274:{n:"BrtBeginComments"},0x0275:{n:"BrtEndComments"},0x0276:{n:"BrtBeginCommentAuthors"},0x0277:{n:"BrtEndCommentAuthors"},0x0278:{n:"BrtCommentAuthor",f:parse_BrtCommentAuthor},0x0279:{n:"BrtBeginCommentList"},0x027A:{n:"BrtEndCommentList"},0x027B:{n:"BrtBeginComment",f:parse_BrtBeginComment},0x027C:{n:"BrtEndComment"},0x027D:{n:"BrtCommentText",f:parse_BrtCommentText},0x027E:{n:"BrtBeginOleObjects"},0x027F:{n:"BrtOleObject"},0x0280:{n:"BrtEndOleObjects"},0x0281:{n:"BrtBeginSxrules"},0x0282:{n:"BrtEndSxRules"},0x0283:{n:"BrtBeginActiveXControls"},0x0284:{n:"BrtActiveX"},0x0285:{n:"BrtEndActiveXControls"},0x0286:{n:"BrtBeginPCDSDTCEMembersSortBy"},0x0288:{n:"BrtBeginCellIgnoreECs"},0x0289:{n:"BrtCellIgnoreEC"},0x028A:{n:"BrtEndCellIgnoreECs"},0x028B:{n:"BrtCsProp",f:parse_BrtCsProp},0x028C:{n:"BrtCsPageSetup"},0x028D:{n:"BrtBeginUserCsViews"},0x028E:{n:"BrtEndUserCsViews"},0x028F:{n:"BrtBeginUserCsView"},0x0290:{n:"BrtEndUserCsView"},0x0291:{n:"BrtBeginPcdSFCIEntries"},0x0292:{n:"BrtEndPCDSFCIEntries"},0x0293:{n:"BrtPCDSFCIEntry"},0x0294:{n:"BrtBeginListParts"},0x0295:{n:"BrtListPart"},0x0296:{n:"BrtEndListParts"},0x0297:{n:"BrtSheetCalcProp"},0x0298:{n:"BrtBeginFnGroup"},0x0299:{n:"BrtFnGroup"},0x029A:{n:"BrtEndFnGroup"},0x029B:{n:"BrtSupAddin"},0x029C:{n:"BrtSXTDMPOrder"},0x029D:{n:"BrtCsProtection"},0x029F:{n:"BrtBeginWsSortMap"},0x02A0:{n:"BrtEndWsSortMap"},0x02A1:{n:"BrtBeginRRSort"},0x02A2:{n:"BrtEndRRSort"},0x02A3:{n:"BrtRRSortItem"},0x02A4:{n:"BrtFileSharingIso"},0x02A5:{n:"BrtBookProtectionIso"},0x02A6:{n:"BrtSheetProtectionIso"},0x02A7:{n:"BrtCsProtectionIso"},0x02A8:{n:"BrtRangeProtectionIso"},0x02A9:{n:"BrtDValList"},0x0400:{n:"BrtRwDescent"},0x0401:{n:"BrtKnownFonts"},0x0402:{n:"BrtBeginSXTupleSet"},0x0403:{n:"BrtEndSXTupleSet"},0x0404:{n:"BrtBeginSXTupleSetHeader"},0x0405:{n:"BrtEndSXTupleSetHeader"},0x0406:{n:"BrtSXTupleSetHeaderItem"},0x0407:{n:"BrtBeginSXTupleSetData"},0x0408:{n:"BrtEndSXTupleSetData"},0x0409:{n:"BrtBeginSXTupleSetRow"},0x040A:{n:"BrtEndSXTupleSetRow"},0x040B:{n:"BrtSXTupleSetRowItem"},0x040C:{n:"BrtNameExt"},0x040D:{n:"BrtPCDH14"},0x040E:{n:"BrtBeginPCDCalcMem14"},0x040F:{n:"BrtEndPCDCalcMem14"},0x0410:{n:"BrtSXTH14"},0x0411:{n:"BrtBeginSparklineGroup"},0x0412:{n:"BrtEndSparklineGroup"},0x0413:{n:"BrtSparkline"},0x0414:{n:"BrtSXDI14"},0x0415:{n:"BrtWsFmtInfoEx14"},0x0416:{n:"BrtBeginConditionalFormatting14"},0x0417:{n:"BrtEndConditionalFormatting14"},0x0418:{n:"BrtBeginCFRule14"},0x0419:{n:"BrtEndCFRule14"},0x041A:{n:"BrtCFVO14"},0x041B:{n:"BrtBeginDatabar14"},0x041C:{n:"BrtBeginIconSet14"},0x041D:{n:"BrtDVal14",f:parse_BrtDVal14},0x041E:{n:"BrtBeginDVals14"},0x041F:{n:"BrtColor14"},0x0420:{n:"BrtBeginSparklines"},0x0421:{n:"BrtEndSparklines"},0x0422:{n:"BrtBeginSparklineGroups"},0x0423:{n:"BrtEndSparklineGroups"},0x0425:{n:"BrtSXVD14"},0x0426:{n:"BrtBeginSXView14"},0x0427:{n:"BrtEndSXView14"},0x0428:{n:"BrtBeginSXView16"},0x0429:{n:"BrtEndSXView16"},0x042A:{n:"BrtBeginPCD14"},0x042B:{n:"BrtEndPCD14"},0x042C:{n:"BrtBeginExtConn14"},0x042D:{n:"BrtEndExtConn14"},0x042E:{n:"BrtBeginSlicerCacheIDs"},0x042F:{n:"BrtEndSlicerCacheIDs"},0x0430:{n:"BrtBeginSlicerCacheID"},0x0431:{n:"BrtEndSlicerCacheID"},0x0433:{n:"BrtBeginSlicerCache"},0x0434:{n:"BrtEndSlicerCache"},0x0435:{n:"BrtBeginSlicerCacheDef"},0x0436:{n:"BrtEndSlicerCacheDef"},0x0437:{n:"BrtBeginSlicersEx"},0x0438:{n:"BrtEndSlicersEx"},0x0439:{n:"BrtBeginSlicerEx"},0x043A:{n:"BrtEndSlicerEx"},0x043B:{n:"BrtBeginSlicer"},0x043C:{n:"BrtEndSlicer"},0x043D:{n:"BrtSlicerCachePivotTables"},0x043E:{n:"BrtBeginSlicerCacheOlapImpl"},0x043F:{n:"BrtEndSlicerCacheOlapImpl"},0x0440:{n:"BrtBeginSlicerCacheLevelsData"},0x0441:{n:"BrtEndSlicerCacheLevelsData"},0x0442:{n:"BrtBeginSlicerCacheLevelData"},0x0443:{n:"BrtEndSlicerCacheLevelData"},0x0444:{n:"BrtBeginSlicerCacheSiRanges"},0x0445:{n:"BrtEndSlicerCacheSiRanges"},0x0446:{n:"BrtBeginSlicerCacheSiRange"},0x0447:{n:"BrtEndSlicerCacheSiRange"},0x0448:{n:"BrtSlicerCacheOlapItem"},0x0449:{n:"BrtBeginSlicerCacheSelections"},0x044A:{n:"BrtSlicerCacheSelection"},0x044B:{n:"BrtEndSlicerCacheSelections"},0x044C:{n:"BrtBeginSlicerCacheNative"},0x044D:{n:"BrtEndSlicerCacheNative"},0x044E:{n:"BrtSlicerCacheNativeItem"},0x044F:{n:"BrtRangeProtection14"},0x0450:{n:"BrtRangeProtectionIso14"},0x0451:{n:"BrtCellIgnoreEC14"},0x0457:{n:"BrtList14"},0x0458:{n:"BrtCFIcon"},0x0459:{n:"BrtBeginSlicerCachesPivotCacheIDs"},0x045A:{n:"BrtEndSlicerCachesPivotCacheIDs"},0x045B:{n:"BrtBeginSlicers"},0x045C:{n:"BrtEndSlicers"},0x045D:{n:"BrtWbProp14"},0x045E:{n:"BrtBeginSXEdit"},0x045F:{n:"BrtEndSXEdit"},0x0460:{n:"BrtBeginSXEdits"},0x0461:{n:"BrtEndSXEdits"},0x0462:{n:"BrtBeginSXChange"},0x0463:{n:"BrtEndSXChange"},0x0464:{n:"BrtBeginSXChanges"},0x0465:{n:"BrtEndSXChanges"},0x0466:{n:"BrtSXTupleItems"},0x0468:{n:"BrtBeginSlicerStyle"},0x0469:{n:"BrtEndSlicerStyle"},0x046A:{n:"BrtSlicerStyleElement"},0x046B:{n:"BrtBeginStyleSheetExt14"},0x046C:{n:"BrtEndStyleSheetExt14"},0x046D:{n:"BrtBeginSlicerCachesPivotCacheID"},0x046E:{n:"BrtEndSlicerCachesPivotCacheID"},0x046F:{n:"BrtBeginConditionalFormattings"},0x0470:{n:"BrtEndConditionalFormattings"},0x0471:{n:"BrtBeginPCDCalcMemExt"},0x0472:{n:"BrtEndPCDCalcMemExt"},0x0473:{n:"BrtBeginPCDCalcMemsExt"},0x0474:{n:"BrtEndPCDCalcMemsExt"},0x0475:{n:"BrtPCDField14"},0x0476:{n:"BrtBeginSlicerStyles"},0x0477:{n:"BrtEndSlicerStyles"},0x0478:{n:"BrtBeginSlicerStyleElements"},0x0479:{n:"BrtEndSlicerStyleElements"},0x047A:{n:"BrtCFRuleExt"},0x047B:{n:"BrtBeginSXCondFmt14"},0x047C:{n:"BrtEndSXCondFmt14"},0x047D:{n:"BrtBeginSXCondFmts14"},0x047E:{n:"BrtEndSXCondFmts14"},0x0480:{n:"BrtBeginSortCond14"},0x0481:{n:"BrtEndSortCond14"},0x0482:{n:"BrtEndDVals14"},0x0483:{n:"BrtEndIconSet14"},0x0484:{n:"BrtEndDatabar14"},0x0485:{n:"BrtBeginColorScale14"},0x0486:{n:"BrtEndColorScale14"},0x0487:{n:"BrtBeginSxrules14"},0x0488:{n:"BrtEndSxrules14"},0x0489:{n:"BrtBeginPRule14"},0x048A:{n:"BrtEndPRule14"},0x048B:{n:"BrtBeginPRFilters14"},0x048C:{n:"BrtEndPRFilters14"},0x048D:{n:"BrtBeginPRFilter14"},0x048E:{n:"BrtEndPRFilter14"},0x048F:{n:"BrtBeginPRFItem14"},0x0490:{n:"BrtEndPRFItem14"},0x0491:{n:"BrtBeginCellIgnoreECs14"},0x0492:{n:"BrtEndCellIgnoreECs14"},0x0493:{n:"BrtDxf14"},0x0494:{n:"BrtBeginDxF14s"},0x0495:{n:"BrtEndDxf14s"},0x0499:{n:"BrtFilter14"},0x049A:{n:"BrtBeginCustomFilters14"},0x049C:{n:"BrtCustomFilter14"},0x049D:{n:"BrtIconFilter14"},0x049E:{n:"BrtPivotCacheConnectionName"},0x0800:{n:"BrtBeginDecoupledPivotCacheIDs"},0x0801:{n:"BrtEndDecoupledPivotCacheIDs"},0x0802:{n:"BrtDecoupledPivotCacheID"},0x0803:{n:"BrtBeginPivotTableRefs"},0x0804:{n:"BrtEndPivotTableRefs"},0x0805:{n:"BrtPivotTableRef"},0x0806:{n:"BrtSlicerCacheBookPivotTables"},0x0807:{n:"BrtBeginSxvcells"},0x0808:{n:"BrtEndSxvcells"},0x0809:{n:"BrtBeginSxRow"},0x080A:{n:"BrtEndSxRow"},0x080C:{n:"BrtPcdCalcMem15"},0x0813:{n:"BrtQsi15"},0x0814:{n:"BrtBeginWebExtensions"},0x0815:{n:"BrtEndWebExtensions"},0x0816:{n:"BrtWebExtension"},0x0817:{n:"BrtAbsPath15"},0x0818:{n:"BrtBeginPivotTableUISettings"},0x0819:{n:"BrtEndPivotTableUISettings"},0x081B:{n:"BrtTableSlicerCacheIDs"},0x081C:{n:"BrtTableSlicerCacheID"},0x081D:{n:"BrtBeginTableSlicerCache"},0x081E:{n:"BrtEndTableSlicerCache"},0x081F:{n:"BrtSxFilter15"},0x0820:{n:"BrtBeginTimelineCachePivotCacheIDs"},0x0821:{n:"BrtEndTimelineCachePivotCacheIDs"},0x0822:{n:"BrtTimelineCachePivotCacheID"},0x0823:{n:"BrtBeginTimelineCacheIDs"},0x0824:{n:"BrtEndTimelineCacheIDs"},0x0825:{n:"BrtBeginTimelineCacheID"},0x0826:{n:"BrtEndTimelineCacheID"},0x0827:{n:"BrtBeginTimelinesEx"},0x0828:{n:"BrtEndTimelinesEx"},0x0829:{n:"BrtBeginTimelineEx"},0x082A:{n:"BrtEndTimelineEx"},0x082B:{n:"BrtWorkBookPr15"},0x082C:{n:"BrtPCDH15"},0x082D:{n:"BrtBeginTimelineStyle"},0x082E:{n:"BrtEndTimelineStyle"},0x082F:{n:"BrtTimelineStyleElement"},0x0830:{n:"BrtBeginTimelineStylesheetExt15"},0x0831:{n:"BrtEndTimelineStylesheetExt15"},0x0832:{n:"BrtBeginTimelineStyles"},0x0833:{n:"BrtEndTimelineStyles"},0x0834:{n:"BrtBeginTimelineStyleElements"},0x0835:{n:"BrtEndTimelineStyleElements"},0x0836:{n:"BrtDxf15"},0x0837:{n:"BrtBeginDxfs15"},0x0838:{n:"brtEndDxfs15"},0x0839:{n:"BrtSlicerCacheHideItemsWithNoData"},0x083A:{n:"BrtBeginItemUniqueNames"},0x083B:{n:"BrtEndItemUniqueNames"},0x083C:{n:"BrtItemUniqueName"},0x083D:{n:"BrtBeginExtConn15"},0x083E:{n:"BrtEndExtConn15"},0x083F:{n:"BrtBeginOledbPr15"},0x0840:{n:"BrtEndOledbPr15"},0x0841:{n:"BrtBeginDataFeedPr15"},0x0842:{n:"BrtEndDataFeedPr15"},0x0843:{n:"BrtTextPr15"},0x0844:{n:"BrtRangePr15"},0x0845:{n:"BrtDbCommand15"},0x0846:{n:"BrtBeginDbTables15"},0x0847:{n:"BrtEndDbTables15"},0x0848:{n:"BrtDbTable15"},0x0849:{n:"BrtBeginDataModel"},0x084A:{n:"BrtEndDataModel"},0x084B:{n:"BrtBeginModelTables"},0x084C:{n:"BrtEndModelTables"},0x084D:{n:"BrtModelTable"},0x084E:{n:"BrtBeginModelRelationships"},0x084F:{n:"BrtEndModelRelationships"},0x0850:{n:"BrtModelRelationship"},0x0851:{n:"BrtBeginECTxtWiz15"},0x0852:{n:"BrtEndECTxtWiz15"},0x0853:{n:"BrtBeginECTWFldInfoLst15"},0x0854:{n:"BrtEndECTWFldInfoLst15"},0x0855:{n:"BrtBeginECTWFldInfo15"},0x0856:{n:"BrtFieldListActiveItem"},0x0857:{n:"BrtPivotCacheIdVersion"},0x0858:{n:"BrtSXDI15"},0x0859:{n:"BrtBeginModelTimeGroupings"},0x085A:{n:"BrtEndModelTimeGroupings"},0x085B:{n:"BrtBeginModelTimeGrouping"},0x085C:{n:"BrtEndModelTimeGrouping"},0x085D:{n:"BrtModelTimeGroupingCalcCol"},0x0C00:{n:"BrtUid"},0x0C01:{n:"BrtRevisionPtr"},0x13e7:{n:"BrtBeginCalcFeatures"},0x13e8:{n:"BrtEndCalcFeatures"},0x13e9:{n:"BrtCalcFeature"},0xFFFF:{n:""}};var XLSBRE=evert_key(XLSBRecordEnum,'n');XLSBRE["BrtFRTArchID$"]=0x0010;/* [MS-XLS] 2.3 Record Enumeration */var XLSRecordEnum={0x0003:{n:"BIFF2NUM",f:parse_BIFF2NUM},0x0004:{n:"BIFF2STR",f:parse_BIFF2STR},0x0006:{n:"Formula",f:parse_Formula},0x0009:{n:'BOF',f:parse_BOF},0x000a:{n:'EOF',f:parsenoop2},0x000c:{n:"CalcCount",f:parseuint16},0x000d:{n:"CalcMode",f:parseuint16},0x000e:{n:"CalcPrecision",f:parsebool},0x000f:{n:"CalcRefMode",f:parsebool},0x0010:{n:"CalcDelta",f:parse_Xnum},0x0011:{n:"CalcIter",f:parsebool},0x0012:{n:"Protect",f:parsebool},0x0013:{n:"Password",f:parseuint16},0x0014:{n:"Header",f:parse_XLHeaderFooter},0x0015:{n:"Footer",f:parse_XLHeaderFooter},0x0017:{n:"ExternSheet",f:parse_ExternSheet},0x0018:{n:"Lbl",f:parse_Lbl},0x0019:{n:"WinProtect",f:parsebool},0x001a:{n:"VerticalPageBreaks"},0x001b:{n:"HorizontalPageBreaks"},0x001c:{n:"Note",f:parse_Note},0x001d:{n:"Selection"},0x0022:{n:"Date1904",f:parsebool},0x0023:{n:"ExternName",f:parse_ExternName},0x0024:{n:"COLWIDTH"},0x0026:{n:"LeftMargin",f:parse_Xnum},0x0027:{n:"RightMargin",f:parse_Xnum},0x0028:{n:"TopMargin",f:parse_Xnum},0x0029:{n:"BottomMargin",f:parse_Xnum},0x002a:{n:"PrintRowCol",f:parsebool},0x002b:{n:"PrintGrid",f:parsebool},0x002f:{n:"FilePass",f:parse_FilePass},0x0031:{n:"Font",f:parse_Font},0x0033:{n:"PrintSize",f:parseuint16},0x003c:{n:"Continue"},0x003d:{n:"Window1",f:parse_Window1},0x0040:{n:"Backup",f:parsebool},0x0041:{n:"Pane",f:parse_Pane},0x0042:{n:'CodePage',f:parseuint16},0x004d:{n:"Pls"},0x0050:{n:"DCon"},0x0051:{n:"DConRef"},0x0052:{n:"DConName"},0x0055:{n:"DefColWidth",f:parseuint16},0x0059:{n:"XCT"},0x005a:{n:"CRN"},0x005b:{n:"FileSharing"},0x005c:{n:'WriteAccess',f:parse_WriteAccess},0x005d:{n:"Obj",f:parse_Obj},0x005e:{n:"Uncalced"},0x005f:{n:"CalcSaveRecalc",f:parsebool},0x0060:{n:"Template"},0x0061:{n:"Intl"},0x0063:{n:"ObjProtect",f:parsebool},0x007d:{n:"ColInfo",f:parse_ColInfo},0x0080:{n:"Guts",f:parse_Guts},0x0081:{n:"WsBool",f:parse_WsBool},0x0082:{n:"GridSet",f:parseuint16},0x0083:{n:"HCenter",f:parsebool},0x0084:{n:"VCenter",f:parsebool},0x0085:{n:'BoundSheet8',f:parse_BoundSheet8},0x0086:{n:"WriteProtect"},0x008c:{n:"Country",f:parse_Country},0x008d:{n:"HideObj",f:parseuint16},0x0090:{n:"Sort"},0x0092:{n:"Palette",f:parse_Palette},0x0097:{n:"Sync"},0x0098:{n:"LPr"},0x0099:{n:"DxGCol"},0x009a:{n:"FnGroupName"},0x009b:{n:"FilterMode"},0x009c:{n:"BuiltInFnGroupCount",f:parseuint16},0x009d:{n:"AutoFilterInfo"},0x009e:{n:"AutoFilter"},0x00a0:{n:"Scl",f:parse_Scl},0x00a1:{n:"Setup",f:parse_Setup},0x00ae:{n:"ScenMan"},0x00af:{n:"SCENARIO"},0x00b0:{n:"SxView"},0x00b1:{n:"Sxvd"},0x00b2:{n:"SXVI"},0x00b4:{n:"SxIvd"},0x00b5:{n:"SXLI"},0x00b6:{n:"SXPI"},0x00b8:{n:"DocRoute"},0x00b9:{n:"RecipName"},0x00bd:{n:"MulRk",f:parse_MulRk},0x00be:{n:"MulBlank",f:parse_MulBlank},0x00c1:{n:'Mms',f:parsenoop2},0x00c5:{n:"SXDI"},0x00c6:{n:"SXDB"},0x00c7:{n:"SXFDB"},0x00c8:{n:"SXDBB"},0x00c9:{n:"SXNum"},0x00ca:{n:"SxBool",f:parsebool},0x00cb:{n:"SxErr"},0x00cc:{n:"SXInt"},0x00cd:{n:"SXString"},0x00ce:{n:"SXDtr"},0x00cf:{n:"SxNil"},0x00d0:{n:"SXTbl"},0x00d1:{n:"SXTBRGIITM"},0x00d2:{n:"SxTbpg"},0x00d3:{n:"ObProj"},0x00d5:{n:"SXStreamID"},0x00d7:{n:"DBCell"},0x00d8:{n:"SXRng"},0x00d9:{n:"SxIsxoper"},0x00da:{n:"BookBool",f:parseuint16},0x00dc:{n:"DbOrParamQry"},0x00dd:{n:"ScenarioProtect",f:parsebool},0x00de:{n:"OleObjectSize"},0x00e0:{n:"XF",f:parse_XF},0x00e1:{n:'InterfaceHdr',f:parse_InterfaceHdr},0x00e2:{n:'InterfaceEnd',f:parsenoop2},0x00e3:{n:"SXVS"},0x00e5:{n:"MergeCells",f:parse_MergeCells},0x00e9:{n:"BkHim"},0x00eb:{n:"MsoDrawingGroup"},0x00ec:{n:"MsoDrawing"},0x00ed:{n:"MsoDrawingSelection"},0x00ef:{n:"PhoneticInfo"},0x00f0:{n:"SxRule"},0x00f1:{n:"SXEx"},0x00f2:{n:"SxFilt"},0x00f4:{n:"SxDXF"},0x00f5:{n:"SxItm"},0x00f6:{n:"SxName"},0x00f7:{n:"SxSelect"},0x00f8:{n:"SXPair"},0x00f9:{n:"SxFmla"},0x00fb:{n:"SxFormat"},0x00fc:{n:"SST",f:parse_SST},0x00fd:{n:"LabelSst",f:parse_LabelSst},0x00ff:{n:"ExtSST",f:parse_ExtSST},0x0100:{n:"SXVDEx"},0x0103:{n:"SXFormula"},0x0122:{n:"SXDBEx"},0x0137:{n:"RRDInsDel"},0x0138:{n:"RRDHead"},0x013b:{n:"RRDChgCell"},0x013d:{n:"RRTabId",f:parseuint16a},0x013e:{n:"RRDRenSheet"},0x013f:{n:"RRSort"},0x0140:{n:"RRDMove"},0x014a:{n:"RRFormat"},0x014b:{n:"RRAutoFmt"},0x014d:{n:"RRInsertSh"},0x014e:{n:"RRDMoveBegin"},0x014f:{n:"RRDMoveEnd"},0x0150:{n:"RRDInsDelBegin"},0x0151:{n:"RRDInsDelEnd"},0x0152:{n:"RRDConflict"},0x0153:{n:"RRDDefName"},0x0154:{n:"RRDRstEtxp"},0x015f:{n:"LRng"},0x0160:{n:"UsesELFs",f:parsebool},0x0161:{n:"DSF",f:parsenoop2},0x0191:{n:"CUsr"},0x0192:{n:"CbUsr"},0x0193:{n:"UsrInfo"},0x0194:{n:"UsrExcl"},0x0195:{n:"FileLock"},0x0196:{n:"RRDInfo"},0x0197:{n:"BCUsrs"},0x0198:{n:"UsrChk"},0x01a9:{n:"UserBView"},0x01aa:{n:"UserSViewBegin"},0x01ab:{n:"UserSViewEnd"},0x01ac:{n:"RRDUserView"},0x01ad:{n:"Qsi"},0x01ae:{n:"SupBook",f:parse_SupBook},0x01af:{n:"Prot4Rev",f:parsebool},0x01b0:{n:"CondFmt"},0x01b1:{n:"CF"},0x01b2:{n:"DVal"},0x01b5:{n:"DConBin"},0x01b6:{n:"TxO",f:parse_TxO},0x01b7:{n:"RefreshAll",f:parsebool},0x01b8:{n:"HLink",f:parse_HLink},0x01b9:{n:"Lel"},0x01ba:{n:"CodeName",f:parse_XLUnicodeString},0x01bb:{n:"SXFDBType"},0x01bc:{n:"Prot4RevPass",f:parseuint16},0x01bd:{n:"ObNoMacros"},0x01be:{n:"Dv"},0x01c0:{n:"Excel9File",f:parsenoop2},0x01c1:{n:"RecalcId",f:parse_RecalcId,r:2},0x01c2:{n:"EntExU2",f:parsenoop2},0x0200:{n:"Dimensions",f:parse_Dimensions},0x0201:{n:"Blank",f:parse_Blank},0x0203:{n:"Number",f:parse_Number},0x0204:{n:"Label",f:parse_Label},0x0205:{n:"BoolErr",f:parse_BoolErr},0x0206:{n:"Formula",f:parse_Formula},0x0207:{n:"String",f:parse_String},0x0208:{n:'Row',f:parse_Row},0x020b:{n:"Index"},0x0221:{n:"Array",f:parse_Array},0x0225:{n:"DefaultRowHeight",f:parse_DefaultRowHeight},0x0236:{n:"Table"},0x023e:{n:"Window2",f:parse_Window2},0x027e:{n:"RK",f:parse_RK},0x0293:{n:"Style"},0x0406:{n:"Formula",f:parse_Formula},0x0418:{n:"BigName"},0x041e:{n:"Format",f:parse_Format},0x043c:{n:"ContinueBigName"},0x04bc:{n:"ShrFmla",f:parse_ShrFmla},0x0800:{n:"HLinkTooltip",f:parse_HLinkTooltip},0x0801:{n:"WebPub"},0x0802:{n:"QsiSXTag"},0x0803:{n:"DBQueryExt"},0x0804:{n:"ExtString"},0x0805:{n:"TxtQry"},0x0806:{n:"Qsir"},0x0807:{n:"Qsif"},0x0808:{n:"RRDTQSIF"},0x0809:{n:'BOF',f:parse_BOF},0x080a:{n:"OleDbConn"},0x080b:{n:"WOpt"},0x080c:{n:"SXViewEx"},0x080d:{n:"SXTH"},0x080e:{n:"SXPIEx"},0x080f:{n:"SXVDTEx"},0x0810:{n:"SXViewEx9"},0x0812:{n:"ContinueFrt"},0x0813:{n:"RealTimeData"},0x0850:{n:"ChartFrtInfo"},0x0851:{n:"FrtWrapper"},0x0852:{n:"StartBlock"},0x0853:{n:"EndBlock"},0x0854:{n:"StartObject"},0x0855:{n:"EndObject"},0x0856:{n:"CatLab"},0x0857:{n:"YMult"},0x0858:{n:"SXViewLink"},0x0859:{n:"PivotChartBits"},0x085a:{n:"FrtFontList"},0x0862:{n:"SheetExt"},0x0863:{n:"BookExt",r:12},0x0864:{n:"SXAddl"},0x0865:{n:"CrErr"},0x0866:{n:"HFPicture"},0x0867:{n:'FeatHdr',f:parsenoop2},0x0868:{n:"Feat"},0x086a:{n:"DataLabExt"},0x086b:{n:"DataLabExtContents"},0x086c:{n:"CellWatch"},0x0871:{n:"FeatHdr11"},0x0872:{n:"Feature11"},0x0874:{n:"DropDownObjIds"},0x0875:{n:"ContinueFrt11"},0x0876:{n:"DConn"},0x0877:{n:"List12"},0x0878:{n:"Feature12"},0x0879:{n:"CondFmt12"},0x087a:{n:"CF12"},0x087b:{n:"CFEx"},0x087c:{n:"XFCRC",f:parse_XFCRC,r:12},0x087d:{n:"XFExt",f:parse_XFExt,r:12},0x087e:{n:"AutoFilter12"},0x087f:{n:"ContinueFrt12"},0x0884:{n:"MDTInfo"},0x0885:{n:"MDXStr"},0x0886:{n:"MDXTuple"},0x0887:{n:"MDXSet"},0x0888:{n:"MDXProp"},0x0889:{n:"MDXKPI"},0x088a:{n:"MDB"},0x088b:{n:"PLV"},0x088c:{n:"Compat12",f:parsebool,r:12},0x088d:{n:"DXF"},0x088e:{n:"TableStyles",r:12},0x088f:{n:"TableStyle"},0x0890:{n:"TableStyleElement"},0x0892:{n:"StyleExt"},0x0893:{n:"NamePublish"},0x0894:{n:"NameCmt",f:parse_NameCmt,r:12},0x0895:{n:"SortData"},0x0896:{n:"Theme",f:parse_Theme,r:12},0x0897:{n:"GUIDTypeLib"},0x0898:{n:"FnGrp12"},0x0899:{n:"NameFnGrp12"},0x089a:{n:"MTRSettings",f:parse_MTRSettings,r:12},0x089b:{n:"CompressPictures",f:parsenoop2},0x089c:{n:"HeaderFooter"},0x089d:{n:"CrtLayout12"},0x089e:{n:"CrtMlFrt"},0x089f:{n:"CrtMlFrtContinue"},0x08a3:{n:"ForceFullCalculation",f:parse_ForceFullCalculation},0x08a4:{n:"ShapePropsStream"},0x08a5:{n:"TextPropsStream"},0x08a6:{n:"RichTextStream"},0x08a7:{n:"CrtLayout12A"},0x1001:{n:"Units"},0x1002:{n:"Chart"},0x1003:{n:"Series"},0x1006:{n:"DataFormat"},0x1007:{n:"LineFormat"},0x1009:{n:"MarkerFormat"},0x100a:{n:"AreaFormat"},0x100b:{n:"PieFormat"},0x100c:{n:"AttachedLabel"},0x100d:{n:"SeriesText"},0x1014:{n:"ChartFormat"},0x1015:{n:"Legend"},0x1016:{n:"SeriesList"},0x1017:{n:"Bar"},0x1018:{n:"Line"},0x1019:{n:"Pie"},0x101a:{n:"Area"},0x101b:{n:"Scatter"},0x101c:{n:"CrtLine"},0x101d:{n:"Axis"},0x101e:{n:"Tick"},0x101f:{n:"ValueRange"},0x1020:{n:"CatSerRange"},0x1021:{n:"AxisLine"},0x1022:{n:"CrtLink"},0x1024:{n:"DefaultText"},0x1025:{n:"Text"},0x1026:{n:"FontX",f:parseuint16},0x1027:{n:"ObjectLink"},0x1032:{n:"Frame"},0x1033:{n:"Begin"},0x1034:{n:"End"},0x1035:{n:"PlotArea"},0x103a:{n:"Chart3d"},0x103c:{n:"PicF"},0x103d:{n:"DropBar"},0x103e:{n:"Radar"},0x103f:{n:"Surf"},0x1040:{n:"RadarArea"},0x1041:{n:"AxisParent"},0x1043:{n:"LegendException"},0x1044:{n:"ShtProps",f:parse_ShtProps},0x1045:{n:"SerToCrt"},0x1046:{n:"AxesUsed"},0x1048:{n:"SBaseRef"},0x104a:{n:"SerParent"},0x104b:{n:"SerAuxTrend"},0x104e:{n:"IFmtRecord"},0x104f:{n:"Pos"},0x1050:{n:"AlRuns"},0x1051:{n:"BRAI"},0x105b:{n:"SerAuxErrBar"},0x105c:{n:"ClrtClient",f:parse_ClrtClient},0x105d:{n:"SerFmt"},0x105f:{n:"Chart3DBarShape"},0x1060:{n:"Fbi"},0x1061:{n:"BopPop"},0x1062:{n:"AxcExt"},0x1063:{n:"Dat"},0x1064:{n:"PlotGrowth"},0x1065:{n:"SIIndex"},0x1066:{n:"GelFrame"},0x1067:{n:"BopPopCustom"},0x1068:{n:"Fbi2"},0x0000:{n:"Dimensions",f:parse_Dimensions},0x0002:{n:"BIFF2INT",f:parse_BIFF2INT},0x0005:{n:"BoolErr",f:parse_BoolErr},0x0007:{n:"String",f:parse_BIFF2STRING},0x0008:{n:"BIFF2ROW"},0x000b:{n:"Index"},0x0016:{n:"ExternCount",f:parseuint16},0x001e:{n:"BIFF2FORMAT",f:parse_BIFF2Format},0x001f:{n:"BIFF2FMTCNT"},/* 16-bit cnt of BIFF2FORMAT records */0x0020:{n:"BIFF2COLINFO"},0x0021:{n:"Array",f:parse_Array},0x0025:{n:"DefaultRowHeight",f:parse_DefaultRowHeight},0x0032:{n:"BIFF2FONTXTRA",f:parse_BIFF2FONTXTRA},0x0034:{n:"DDEObjName"},0x003e:{n:"BIFF2WINDOW2"},0x0043:{n:"BIFF2XF"},0x0045:{n:"BIFF2FONTCLR"},0x0056:{n:"BIFF4FMTCNT"},/* 16-bit cnt, similar to BIFF2 */0x007e:{n:"RK"},/* Not necessarily same as 0x027e */0x007f:{n:"ImData",f:parse_ImData},0x0087:{n:"Addin"},0x0088:{n:"Edg"},0x0089:{n:"Pub"},0x0091:{n:"Sub"},0x0094:{n:"LHRecord"},0x0095:{n:"LHNGraph"},0x0096:{n:"Sound"},0x00a9:{n:"CoordList"},0x00ab:{n:"GCW"},0x00bc:{n:"ShrFmla"},/* Not necessarily same as 0x04bc */0x00bf:{n:"ToolbarHdr"},0x00c0:{n:"ToolbarEnd"},0x00c2:{n:"AddMenu"},0x00c3:{n:"DelMenu"},0x00d6:{n:"RString",f:parse_RString},0x00df:{n:"UDDesc"},0x00ea:{n:"TabIdConf"},0x0162:{n:"XL5Modify"},0x01a5:{n:"FileSharing2"},0x0209:{n:'BOF',f:parse_BOF},0x0218:{n:"Lbl",f:parse_Lbl},0x0223:{n:"ExternName",f:parse_ExternName},0x0231:{n:"Font"},0x0243:{n:"BIFF3XF"},0x0409:{n:'BOF',f:parse_BOF},0x0443:{n:"BIFF4XF"},0x086d:{n:"FeatInfo"},0x0873:{n:"FeatInfo11"},0x0881:{n:"SXAddl12"},0x08c0:{n:"AutoWebPub"},0x08c1:{n:"ListObj"},0x08c2:{n:"ListField"},0x08c3:{n:"ListDV"},0x08c4:{n:"ListCondFmt"},0x08c5:{n:"ListCF"},0x08c6:{n:"FMQry"},0x08c7:{n:"FMSQry"},0x08c8:{n:"PLV"},0x08c9:{n:"LnExt"},0x08ca:{n:"MkrExt"},0x08cb:{n:"CrtCoopt"},0x08d6:{n:"FRTArchId$",r:12},0x7262:{}};var XLSRE=evert_key(XLSRecordEnum,'n');function write_biff_rec(ba,type,payload,length){var t=+type||+XLSRE[type];if(isNaN(t))return;var len=length||(payload||[]).length||0;var o=ba.next(4);o.write_shift(2,t);o.write_shift(2,len);if(len>0&&is_buf(payload))ba.push(payload);}function write_biff_continue(ba,type,payload,length){var len=length||(payload||[]).length||0;if(len<=8224)return write_biff_rec(ba,type,payload,len);var t=+type||+XLSRE[type];if(isNaN(t))return;var parts=payload.parts||[],sidx=0;var i=0,w=0;while(w+(parts[sidx]||8224)<=8224){w+=parts[sidx]||8224;sidx++;}var o=ba.next(4);o.write_shift(2,t);o.write_shift(2,w);ba.push(payload.slice(i,i+w));i+=w;while(i<len){o=ba.next(4);o.write_shift(2,0x3c);// TODO: figure out correct continue type
w=0;while(w+(parts[sidx]||8224)<=8224){w+=parts[sidx]||8224;sidx++;}o.write_shift(2,w);ba.push(payload.slice(i,i+w));i+=w;}}function write_BIFF2Cell(out,r,c){if(!out)out=new_buf(7);out.write_shift(2,r);out.write_shift(2,c);out.write_shift(2,0);out.write_shift(1,0);return out;}function write_BIFF2BERR(r,c,val,t){var out=new_buf(9);write_BIFF2Cell(out,r,c);if(t=='e'){out.write_shift(1,val);out.write_shift(1,1);}else {out.write_shift(1,val?1:0);out.write_shift(1,0);}return out;}/* TODO: codepage, large strings */function write_BIFF2LABEL(r,c,val){var out=new_buf(8+2*val.length);write_BIFF2Cell(out,r,c);out.write_shift(1,val.length);out.write_shift(val.length,val,'sbcs');return out.l<out.length?out.slice(0,out.l):out;}function write_ws_biff2_cell(ba,cell,R,C){if(cell.v!=null)switch(cell.t){case'd':case'n':var v=cell.t=='d'?datenum(parseDate(cell.v)):cell.v;if(v==(v|0)&&v>=0&&v<65536)write_biff_rec(ba,0x0002,write_BIFF2INT(R,C,v));else write_biff_rec(ba,0x0003,write_BIFF2NUM(R,C,v));return;case'b':case'e':write_biff_rec(ba,0x0005,write_BIFF2BERR(R,C,cell.v,cell.t));return;/* TODO: codepage, sst */case's':case'str':write_biff_rec(ba,0x0004,write_BIFF2LABEL(R,C,cell.v));return;}write_biff_rec(ba,0x0001,write_BIFF2Cell(null,R,C));}function write_ws_biff2(ba,ws,idx,opts){var dense=Array.isArray(ws);var range=safe_decode_range(ws['!ref']||"A1"),ref,rr="",cols=[];if(range.e.c>0xFF||range.e.r>0x3FFF){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:IV16384");range.e.c=Math.min(range.e.c,0xFF);range.e.r=Math.min(range.e.c,0x3FFF);ref=encode_range(range);}for(var R=range.s.r;R<=range.e.r;++R){rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell)continue;/* write cell */write_ws_biff2_cell(ba,cell,R,C);}}}/* Based on test files */function write_biff2_buf(wb,opts){var o=opts||{};var ba=buf_array();var idx=0;for(var i=0;i<wb.SheetNames.length;++i)if(wb.SheetNames[i]==o.sheet)idx=i;if(idx==0&&!!o.sheet&&wb.SheetNames[0]!=o.sheet)throw new Error("Sheet not found: "+o.sheet);write_biff_rec(ba,0x0009,write_BOF(wb,0x10,o));/* ... */write_ws_biff2(ba,wb.Sheets[wb.SheetNames[idx]],idx,o);/* ... */write_biff_rec(ba,0x000A);return ba.end();}function write_FONTS_biff8(ba,data,opts){write_biff_rec(ba,"Font",write_Font({sz:12,color:{theme:1},name:"Arial",family:2,scheme:"minor"},opts));}function write_FMTS_biff8(ba,NF,opts){if(!NF)return;[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){for(var i=r[0];i<=r[1];++i)if(NF[i]!=null)write_biff_rec(ba,"Format",write_Format(i,NF[i],opts));});}function write_FEAT(ba,ws){/* [MS-XLS] 2.4.112 */var o=new_buf(19);o.write_shift(4,0x867);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(2,3);o.write_shift(1,1);o.write_shift(4,0);write_biff_rec(ba,"FeatHdr",o);/* [MS-XLS] 2.4.111 */o=new_buf(39);o.write_shift(4,0x868);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(2,3);o.write_shift(1,0);o.write_shift(4,0);o.write_shift(2,1);o.write_shift(4,4);o.write_shift(2,0);write_Ref8U(safe_decode_range(ws['!ref']||"A1"),o);o.write_shift(4,4);write_biff_rec(ba,"Feat",o);}function write_CELLXFS_biff8(ba,opts){for(var i=0;i<16;++i)write_biff_rec(ba,"XF",write_XF({numFmtId:0,style:true},0,opts));opts.cellXfs.forEach(function(c){write_biff_rec(ba,"XF",write_XF(c,0,opts));});}function write_ws_biff8_hlinks(ba,ws){for(var R=0;R<ws['!links'].length;++R){var HL=ws['!links'][R];write_biff_rec(ba,"HLink",write_HLink(HL));if(HL[1].Tooltip)write_biff_rec(ba,"HLinkTooltip",write_HLinkTooltip(HL));}delete ws['!links'];}function write_ws_cols_biff8(ba,cols,ws){if(!cols)return;var cnt=0;cols.forEach(function(col,idx){if(++cnt<=256&&col){write_biff_rec(ba,"ColInfo",write_ColInfo(col_obj_w(idx,col),idx));}});}function write_ws_biff8_cell(ba,cell,R,C,opts){var os=16+get_cell_style(opts.cellXfs,cell,opts);if(cell.v==null&&!cell.bf){write_biff_rec(ba,"Blank",write_XLSCell(R,C,os));return;}if(cell.bf)write_biff_rec(ba,"Formula",write_Formula(cell,R,C,opts,os));else switch(cell.t){case'd':case'n':var v=cell.t=='d'?datenum(parseDate(cell.v)):cell.v;/* TODO: emit RK as appropriate */write_biff_rec(ba,"Number",write_Number(R,C,v,os));break;case'b':case'e':write_biff_rec(ba,0x0205,write_BoolErr(R,C,cell.v,os,opts,cell.t));break;/* TODO: codepage, sst */case's':case'str':if(opts.bookSST){var isst=get_sst_id(opts.Strings,cell.v,opts.revStrings);write_biff_rec(ba,"LabelSst",write_LabelSst(R,C,isst,os));}else write_biff_rec(ba,"Label",write_Label(R,C,cell.v,os,opts));break;default:write_biff_rec(ba,"Blank",write_XLSCell(R,C,os));}}/* [MS-XLS] 2.1.7.20.5 */function write_ws_biff8(idx,opts,wb){var ba=buf_array();var s=wb.SheetNames[idx],ws=wb.Sheets[s]||{};var _WB=(wb||{}).Workbook||{};var _sheet=(_WB.Sheets||[])[idx]||{};var dense=Array.isArray(ws);var b8=opts.biff==8;var ref,rr="",cols=[];var range=safe_decode_range(ws['!ref']||"A1");var MAX_ROWS=b8?65536:16384;if(range.e.c>0xFF||range.e.r>=MAX_ROWS){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:IV16384");range.e.c=Math.min(range.e.c,0xFF);range.e.r=Math.min(range.e.c,MAX_ROWS-1);}write_biff_rec(ba,0x0809,write_BOF(wb,0x10,opts));/* [Uncalced] Index */write_biff_rec(ba,"CalcMode",writeuint16(1));write_biff_rec(ba,"CalcCount",writeuint16(100));write_biff_rec(ba,"CalcRefMode",writebool(true));write_biff_rec(ba,"CalcIter",writebool(false));write_biff_rec(ba,"CalcDelta",write_Xnum(0.001));write_biff_rec(ba,"CalcSaveRecalc",writebool(true));write_biff_rec(ba,"PrintRowCol",writebool(false));write_biff_rec(ba,"PrintGrid",writebool(false));write_biff_rec(ba,"GridSet",writeuint16(1));write_biff_rec(ba,"Guts",write_Guts([0,0]));/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */write_biff_rec(ba,"HCenter",writebool(false));write_biff_rec(ba,"VCenter",writebool(false));/* ... */if(b8)write_ws_cols_biff8(ba,ws["!cols"]);/* ... */write_biff_rec(ba,0x200,write_Dimensions(range,opts));/* ... */if(b8)ws['!links']=[];for(var R=range.s.r;R<=range.e.r;++R){rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell)continue;/* write cell */write_ws_biff8_cell(ba,cell,R,C,opts);if(b8&&cell.l)ws['!links'].push([ref,cell.l]);}}var cname=_sheet.CodeName||_sheet.name||s;/* ... */if(b8)write_biff_rec(ba,"Window2",write_Window2((_WB.Views||[])[0]));/* ... */if(b8&&(ws['!merges']||[]).length)write_biff_rec(ba,"MergeCells",write_MergeCells(ws['!merges']));/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */if(b8)write_ws_biff8_hlinks(ba,ws);/* [DVAL] */write_biff_rec(ba,"CodeName",write_XLUnicodeString(cname));/* *WebPub *CellWatch [SheetExt] */if(b8)write_FEAT(ba,ws);/* *FEAT11 *RECORD12 */write_biff_rec(ba,"EOF");return ba.end();}/* [MS-XLS] 2.1.7.20.3 */function write_biff8_global(wb,bufs,opts){var A=buf_array();var _WB=(wb||{}).Workbook||{};var _sheets=_WB.Sheets||[];var _wb=_WB.WBProps||{};var b8=opts.biff==8,b5=opts.biff==5;write_biff_rec(A,0x0809,write_BOF(wb,0x05,opts));if(opts.bookType=="xla")write_biff_rec(A,"Addin");write_biff_rec(A,"InterfaceHdr",b8?writeuint16(0x04b0):null);write_biff_rec(A,"Mms",writezeroes(2));if(b5)write_biff_rec(A,"ToolbarHdr");if(b5)write_biff_rec(A,"ToolbarEnd");write_biff_rec(A,"InterfaceEnd");write_biff_rec(A,"WriteAccess",write_WriteAccess("SheetJS",opts));/* [FileSharing] */write_biff_rec(A,"CodePage",writeuint16(b8?0x04b0:0x04E4));/* *2047 Lel */if(b8)write_biff_rec(A,"DSF",writeuint16(0));if(b8)write_biff_rec(A,"Excel9File");write_biff_rec(A,"RRTabId",write_RRTabId(wb.SheetNames.length));if(b8&&wb.vbaraw)write_biff_rec(A,"ObProj");/* [ObNoMacros] */if(b8&&wb.vbaraw){var cname=_wb.CodeName||"ThisWorkbook";write_biff_rec(A,"CodeName",write_XLUnicodeString(cname));}write_biff_rec(A,"BuiltInFnGroupCount",writeuint16(0x11));/* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */write_biff_rec(A,"WinProtect",writebool(false));write_biff_rec(A,"Protect",writebool(false));write_biff_rec(A,"Password",writeuint16(0));if(b8)write_biff_rec(A,"Prot4Rev",writebool(false));if(b8)write_biff_rec(A,"Prot4RevPass",writeuint16(0));write_biff_rec(A,"Window1",write_Window1());write_biff_rec(A,"Backup",writebool(false));write_biff_rec(A,"HideObj",writeuint16(0));write_biff_rec(A,"Date1904",writebool(safe1904(wb)=="true"));write_biff_rec(A,"CalcPrecision",writebool(true));if(b8)write_biff_rec(A,"RefreshAll",writebool(false));write_biff_rec(A,"BookBool",writeuint16(0));/* ... */write_FONTS_biff8(A,wb,opts);write_FMTS_biff8(A,wb.SSF,opts);write_CELLXFS_biff8(A,opts);/* ... */if(b8)write_biff_rec(A,"UsesELFs",writebool(false));var a=A.end();var C=buf_array();/* METADATA [MTRSettings] [ForceFullCalculation] */if(b8)write_biff_rec(C,"Country",write_Country());/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */ /* BIFF8: [SST *Continue] ExtSST */if(b8&&opts.Strings)write_biff_continue(C,"SST",write_SST(opts.Strings));/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */write_biff_rec(C,"EOF");var c=C.end();var B=buf_array();var blen=0,j=0;for(j=0;j<wb.SheetNames.length;++j)blen+=(b8?12:11)+(b8?2:1)*wb.SheetNames[j].length;var start=a.length+blen+c.length;for(j=0;j<wb.SheetNames.length;++j){var _sheet=_sheets[j]||{};write_biff_rec(B,"BoundSheet8",write_BoundSheet8({pos:start,hs:_sheet.Hidden||0,dt:0,name:wb.SheetNames[j]},opts));start+=bufs[j].length;}/* 1*BoundSheet8 */var b=B.end();if(blen!=b.length)throw new Error("BS8 "+blen+" != "+b.length);var out=[];if(a.length)out.push(a);if(b.length)out.push(b);if(c.length)out.push(c);return __toBuffer([out]);}/* [MS-XLS] 2.1.7.20 Workbook Stream */function write_biff8_buf(wb,opts){var o=opts||{};var bufs=[];if(wb&&!wb.SSF){wb.SSF=SSF.get_table();}if(wb&&wb.SSF){make_ssf(SSF);SSF.load_table(wb.SSF);// $FlowIgnore
o.revssf=evert_num(wb.SSF);o.revssf[wb.SSF[65535]]=0;o.ssf=wb.SSF;}o.Strings=[];o.Strings.Count=0;o.Strings.Unique=0;fix_write_opts(o);o.cellXfs=[];get_cell_style(o.cellXfs,{},{revssf:{"General":0}});if(!wb.Props)wb.Props={};for(var i=0;i<wb.SheetNames.length;++i)bufs[bufs.length]=write_ws_biff8(i,o,wb);bufs.unshift(write_biff8_global(wb,bufs,o));return __toBuffer([bufs]);}function write_biff_buf(wb,opts){var o=opts||{};switch(o.biff||2){case 8:case 5:return write_biff8_buf(wb,opts);case 4:case 3:case 2:return write_biff2_buf(wb,opts);}throw new Error("invalid type "+o.bookType+" for BIFF");}/* note: browser DOM element cannot see mso- style attrs, must parse */var HTML_=function(){function html_to_sheet(str,_opts){var opts=_opts||{};var ws=opts.dense?[]:{};str=str.replace(/<!--.*?-->/g,"");var mtch=str.match(/<table/i);if(!mtch)throw new Error("Invalid HTML: could not find <table>");var mtch2=str.match(/<\/table/i);var i=mtch.index,j=mtch2&&mtch2.index||str.length;var rows=split_regex(str.slice(i,j),/(:?<tr[^>]*>)/i,"<tr>");var R=-1,C=0,RS=0,CS=0;var range={s:{r:10000000,c:10000000},e:{r:0,c:0}};var merges=[];for(i=0;i<rows.length;++i){var row=rows[i].trim();var hd=row.slice(0,3).toLowerCase();if(hd=="<tr"){++R;if(opts.sheetRows&&opts.sheetRows<=R){--R;break;}C=0;continue;}if(hd!="<td"&&hd!="<th")continue;var cells=row.split(/<\/t[dh]>/i);for(j=0;j<cells.length;++j){var cell=cells[j].trim();if(!cell.match(/<t[dh]/i))continue;var m=cell,cc=0;/* TODO: parse styles etc */while(m.charAt(0)=="<"&&(cc=m.indexOf(">"))>-1)m=m.slice(cc+1);for(var midx=0;midx<merges.length;++midx){var _merge=merges[midx];if(_merge.s.c==C&&_merge.s.r<R&&R<=_merge.e.r){C=_merge.e.c+1;midx=-1;}}var tag=parsexmltag(cell.slice(0,cell.indexOf(">")));CS=tag.colspan?+tag.colspan:1;if((RS=+tag.rowspan)>1||CS>1)merges.push({s:{r:R,c:C},e:{r:R+(RS||1)-1,c:C+CS-1}});var _t=tag.t||"";/* TODO: generate stub cells */if(!m.length){C+=CS;continue;}m=htmldecode(m);if(range.s.r>R)range.s.r=R;if(range.e.r<R)range.e.r=R;if(range.s.c>C)range.s.c=C;if(range.e.c<C)range.e.c=C;if(!m.length)continue;var o={t:'s',v:m};if(opts.raw||!m.trim().length||_t=='s');else if(m==='TRUE')o={t:'b',v:true};else if(m==='FALSE')o={t:'b',v:false};else if(!isNaN(fuzzynum(m)))o={t:'n',v:fuzzynum(m)};else if(!isNaN(fuzzydate(m).getDate())){o={t:'d',v:parseDate(m)};if(!opts.cellDates)o={t:'n',v:datenum(o.v)};o.z=opts.dateNF||SSF._table[14];}if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]=o;}else ws[encode_cell({r:R,c:C})]=o;C+=CS;}}ws['!ref']=encode_range(range);if(merges.length)ws["!merges"]=merges;return ws;}function html_to_book(str,opts){return sheet_to_workbook(html_to_sheet(str,opts),opts);}function make_html_row(ws,r,R,o){var M=ws['!merges']||[];var oo=[];for(var C=r.s.c;C<=r.e.c;++C){var RS=0,CS=0;for(var j=0;j<M.length;++j){if(M[j].s.r>R||M[j].s.c>C)continue;if(M[j].e.r<R||M[j].e.c<C)continue;if(M[j].s.r<R||M[j].s.c<C){RS=-1;break;}RS=M[j].e.r-M[j].s.r+1;CS=M[j].e.c-M[j].s.c+1;break;}if(RS<0)continue;var coord=encode_cell({r:R,c:C});var cell=o.dense?(ws[R]||[])[C]:ws[coord];/* TODO: html entities */var w=cell&&cell.v!=null&&(cell.h||escapehtml(cell.w||(format_cell(cell),cell.w)||""))||"";var sp={};if(RS>1)sp.rowspan=RS;if(CS>1)sp.colspan=CS;sp.t=cell&&cell.t||'z';if(o.editable)w='<span contenteditable="true">'+w+'</span>';sp.id=(o.id||"sjs")+"-"+coord;if(sp.t!="z"){sp.v=cell.v;if(cell.z!=null)sp.z=cell.z;}oo.push(writextag('td',w,sp));}var preamble="<tr>";return preamble+oo.join("")+"</tr>";}function make_html_preamble(ws,R,o){var out=[];return out.join("")+'<table'+(o&&o.id?' id="'+o.id+'"':"")+'>';}var _BEGIN='<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';var _END='</body></html>';function sheet_to_html(ws,opts/*, wb:?Workbook*/){var o=opts||{};var header=o.header!=null?o.header:_BEGIN;var footer=o.footer!=null?o.footer:_END;var out=[header];var r=decode_range(ws['!ref']);o.dense=Array.isArray(ws);out.push(make_html_preamble(ws,r,o));for(var R=r.s.r;R<=r.e.r;++R)out.push(make_html_row(ws,r,R,o));out.push("</table>"+footer);return out.join("");}return {to_workbook:html_to_book,to_sheet:html_to_sheet,_row:make_html_row,BEGIN:_BEGIN,END:_END,_preamble:make_html_preamble,from_sheet:sheet_to_html};}();function sheet_add_dom(ws,table,_opts){var opts=_opts||{};var or_R=0,or_C=0;if(opts.origin!=null){if(typeof opts.origin=='number')or_R=opts.origin;else {var _origin=typeof opts.origin=="string"?decode_cell(opts.origin):opts.origin;or_R=_origin.r;or_C=_origin.c;}}var rows=table.getElementsByTagName('tr');var sheetRows=Math.min(opts.sheetRows||10000000,rows.length);var range={s:{r:0,c:0},e:{r:or_R,c:or_C}};if(ws["!ref"]){var _range=decode_range(ws["!ref"]);range.s.r=Math.min(range.s.r,_range.s.r);range.s.c=Math.min(range.s.c,_range.s.c);range.e.r=Math.max(range.e.r,_range.e.r);range.e.c=Math.max(range.e.c,_range.e.c);if(or_R==-1)range.e.r=or_R=_range.e.r+1;}var merges=[],midx=0;var rowinfo=ws["!rows"]||(ws["!rows"]=[]);var _R=0,R=0,_C=0,C=0,RS=0,CS=0;if(!ws["!cols"])ws['!cols']=[];for(;_R<rows.length&&R<sheetRows;++_R){var row=rows[_R];if(is_dom_element_hidden(row)){if(opts.display)continue;rowinfo[R]={hidden:true};}var elts=row.children;for(_C=C=0;_C<elts.length;++_C){var elt=elts[_C];if(opts.display&&is_dom_element_hidden(elt))continue;var v=elt.hasAttribute('v')?elt.getAttribute('v'):htmldecode(elt.innerHTML);var z=elt.getAttribute('z');for(midx=0;midx<merges.length;++midx){var m=merges[midx];if(m.s.c==C+or_C&&m.s.r<R+or_R&&R+or_R<=m.e.r){C=m.e.c+1-or_C;midx=-1;}}/* TODO: figure out how to extract nonstandard mso- style */CS=+elt.getAttribute("colspan")||1;if((RS=+elt.getAttribute("rowspan")||1)>1||CS>1)merges.push({s:{r:R+or_R,c:C+or_C},e:{r:R+or_R+(RS||1)-1,c:C+or_C+(CS||1)-1}});var o={t:'s',v:v};var _t=elt.getAttribute("t")||"";if(v!=null){if(v.length==0)o.t=_t||'z';else if(opts.raw||v.trim().length==0||_t=="s");else if(v==='TRUE')o={t:'b',v:true};else if(v==='FALSE')o={t:'b',v:false};else if(!isNaN(fuzzynum(v)))o={t:'n',v:fuzzynum(v)};else if(!isNaN(fuzzydate(v).getDate())){o={t:'d',v:parseDate(v)};if(!opts.cellDates)o={t:'n',v:datenum(o.v)};o.z=opts.dateNF||SSF._table[14];}}if(o.z===undefined&&z!=null)o.z=z;if(opts.dense){if(!ws[R+or_R])ws[R+or_R]=[];ws[R+or_R][C+or_C]=o;}else ws[encode_cell({c:C+or_C,r:R+or_R})]=o;if(range.e.c<C+or_C)range.e.c=C+or_C;C+=CS;}++R;}if(merges.length)ws['!merges']=(ws["!merges"]||[]).concat(merges);range.e.r=Math.max(range.e.r,R-1+or_R);ws['!ref']=encode_range(range);if(R>=sheetRows)ws['!fullref']=encode_range((range.e.r=rows.length-_R+R-1+or_R,range));// We can count the real number of rows to parse but we don't to improve the performance
return ws;}function parse_dom_table(table,_opts){var opts=_opts||{};var ws=opts.dense?[]:{};return sheet_add_dom(ws,table,_opts);}function table_to_book(table,opts){return sheet_to_workbook(parse_dom_table(table,opts),opts);}function is_dom_element_hidden(element){var display='';var get_computed_style=get_get_computed_style_function(element);if(get_computed_style)display=get_computed_style(element).getPropertyValue('display');if(!display)display=element.style.display;// Fallback for cases when getComputedStyle is not available (e.g. an old browser or some Node.js environments) or doesn't work (e.g. if the element is not inserted to a document)
return display==='none';}/* global getComputedStyle */function get_get_computed_style_function(element){// The proper getComputedStyle implementation is the one defined in the element window
if(element.ownerDocument.defaultView&&typeof element.ownerDocument.defaultView.getComputedStyle==='function')return element.ownerDocument.defaultView.getComputedStyle;// If it is not available, try to get one from the global namespace
if(typeof getComputedStyle==='function')return getComputedStyle;return null;}/* OpenDocument */var parse_content_xml=function(){var parse_text_p=function(text){/* 6.1.2 White Space Characters */var fixed=text.replace(/[\t\r\n]/g," ").trim().replace(/ +/g," ").replace(/<text:s\/>/g," ").replace(/<text:s text:c="(\d+)"\/>/g,function($$,$1){return Array(parseInt($1,10)+1).join(" ");}).replace(/<text:tab[^>]*\/>/g,"\t").replace(/<text:line-break\/>/g,"\n");var v=unescapexml(fixed.replace(/<[^>]*>/g,""));return [v];};var number_formats={/* ods name: [short ssf fmt, long ssf fmt] */day:["d","dd"],month:["m","mm"],year:["y","yy"],hours:["h","hh"],minutes:["m","mm"],seconds:["s","ss"],"am-pm":["A/P","AM/PM"],"day-of-week":["ddd","dddd"],era:["e","ee"],/* there is no native representation of LO "Q" format */quarter:["\\Qm","m\\\"th quarter\""]};return function pcx(d,_opts){var opts=_opts||{};var str=xlml_normalize(d);var state=[],tmp;var tag;var NFtag={name:""},NF="",pidx=0;var sheetag;var rowtag;var Sheets={},SheetNames=[];var ws=opts.dense?[]:{};var Rn,q;var ctag={value:""};var textp="",textpidx=0,textptag;var textR=[];var R=-1,C=-1,range={s:{r:1000000,c:10000000},e:{r:0,c:0}};var row_ol=0;var number_format_map={};var merges=[],mrange={},mR=0,mC=0;var rowinfo=[],rowpeat=1,colpeat=1;var arrayf=[];var WB={Names:[]};var atag={};var _Ref=["",""];var comments=[],comment={};var creator="",creatoridx=0;var isstub=false,intable=false;var i=0;xlmlregex.lastIndex=0;str=str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");while(Rn=xlmlregex.exec(str))switch(Rn[3]=Rn[3].replace(/_.*$/,"")){case'table':case'工作表':// 9.1.2 <table:table>
if(Rn[1]==='/'){if(range.e.c>=range.s.c&&range.e.r>=range.s.r)ws['!ref']=encode_range(range);else ws['!ref']="A1:A1";if(opts.sheetRows>0&&opts.sheetRows<=range.e.r){ws['!fullref']=ws['!ref'];range.e.r=opts.sheetRows-1;ws['!ref']=encode_range(range);}if(merges.length)ws['!merges']=merges;if(rowinfo.length)ws["!rows"]=rowinfo;sheetag.name=sheetag['名称']||sheetag.name;if(typeof JSON!=='undefined')JSON.stringify(sheetag);SheetNames.push(sheetag.name);Sheets[sheetag.name]=ws;intable=false;}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){sheetag=parsexmltag(Rn[0],false);R=C=-1;range.s.r=range.s.c=10000000;range.e.r=range.e.c=0;ws=opts.dense?[]:{};merges=[];rowinfo=[];intable=true;}break;case'table-row-group':// 9.1.9 <table:table-row-group>
if(Rn[1]==="/")--row_ol;else ++row_ol;break;case'table-row':case'行':// 9.1.3 <table:table-row>
if(Rn[1]==='/'){R+=rowpeat;rowpeat=1;break;}rowtag=parsexmltag(Rn[0],false);if(rowtag['行号'])R=rowtag['行号']-1;else if(R==-1)R=0;rowpeat=+rowtag['number-rows-repeated']||1;/* TODO: remove magic */if(rowpeat<10)for(i=0;i<rowpeat;++i)if(row_ol>0)rowinfo[R+i]={level:row_ol};C=-1;break;case'covered-table-cell':// 9.1.5 <table:covered-table-cell>
if(Rn[1]!=='/')++C;if(opts.sheetStubs){if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]={t:'z'};}else ws[encode_cell({r:R,c:C})]={t:'z'};}textp="";textR=[];break;/* stub */case'table-cell':case'数据':if(Rn[0].charAt(Rn[0].length-2)==='/'){++C;ctag=parsexmltag(Rn[0],false);colpeat=parseInt(ctag['number-columns-repeated']||"1",10);q={t:'z',v:null};if(ctag.formula&&opts.cellFormula!=false)q.f=ods_to_csf_formula(unescapexml(ctag.formula));if((ctag['数据类型']||ctag['value-type'])=="string"){q.t="s";q.v=unescapexml(ctag['string-value']||"");if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]=q;}else {ws[encode_cell({r:R,c:C})]=q;}}C+=colpeat-1;}else if(Rn[1]!=='/'){++C;colpeat=1;var rptR=rowpeat?R+rowpeat-1:R;if(C>range.e.c)range.e.c=C;if(C<range.s.c)range.s.c=C;if(R<range.s.r)range.s.r=R;if(rptR>range.e.r)range.e.r=rptR;ctag=parsexmltag(Rn[0],false);comments=[];comment={};q={t:ctag['数据类型']||ctag['value-type'],v:null};if(opts.cellFormula){if(ctag.formula)ctag.formula=unescapexml(ctag.formula);if(ctag['number-matrix-columns-spanned']&&ctag['number-matrix-rows-spanned']){mR=parseInt(ctag['number-matrix-rows-spanned'],10)||0;mC=parseInt(ctag['number-matrix-columns-spanned'],10)||0;mrange={s:{r:R,c:C},e:{r:R+mR-1,c:C+mC-1}};q.F=encode_range(mrange);arrayf.push([mrange,q.F]);}if(ctag.formula)q.f=ods_to_csf_formula(ctag.formula);else for(i=0;i<arrayf.length;++i)if(R>=arrayf[i][0].s.r&&R<=arrayf[i][0].e.r)if(C>=arrayf[i][0].s.c&&C<=arrayf[i][0].e.c)q.F=arrayf[i][1];}if(ctag['number-columns-spanned']||ctag['number-rows-spanned']){mR=parseInt(ctag['number-rows-spanned'],10)||0;mC=parseInt(ctag['number-columns-spanned'],10)||0;mrange={s:{r:R,c:C},e:{r:R+mR-1,c:C+mC-1}};merges.push(mrange);}/* 19.675.2 table:number-columns-repeated */if(ctag['number-columns-repeated'])colpeat=parseInt(ctag['number-columns-repeated'],10);/* 19.385 office:value-type */switch(q.t){case'boolean':q.t='b';q.v=parsexmlbool(ctag['boolean-value']);break;case'float':q.t='n';q.v=parseFloat(ctag.value);break;case'percentage':q.t='n';q.v=parseFloat(ctag.value);break;case'currency':q.t='n';q.v=parseFloat(ctag.value);break;case'date':q.t='d';q.v=parseDate(ctag['date-value']);if(!opts.cellDates){q.t='n';q.v=datenum(q.v);}q.z='m/d/yy';break;case'time':q.t='n';q.v=parse_isodur(ctag['time-value'])/86400;break;case'number':q.t='n';q.v=parseFloat(ctag['数据数值']);break;default:if(q.t==='string'||q.t==='text'||!q.t){q.t='s';if(ctag['string-value']!=null){textp=unescapexml(ctag['string-value']);textR=[];}}else throw new Error('Unsupported value type '+q.t);}}else {isstub=false;if(q.t==='s'){q.v=textp||'';if(textR.length)q.R=textR;isstub=textpidx==0;}if(atag.Target)q.l=atag;if(comments.length>0){q.c=comments;comments=[];}if(textp&&opts.cellText!==false)q.w=textp;if(isstub){q.t="z";delete q.v;}if(!isstub||opts.sheetStubs){if(!(opts.sheetRows&&opts.sheetRows<=R)){for(var rpt=0;rpt<rowpeat;++rpt){colpeat=parseInt(ctag['number-columns-repeated']||"1",10);if(opts.dense){if(!ws[R+rpt])ws[R+rpt]=[];ws[R+rpt][C]=rpt==0?q:dup(q);while(--colpeat>0)ws[R+rpt][C+colpeat]=dup(q);}else {ws[encode_cell({r:R+rpt,c:C})]=q;while(--colpeat>0)ws[encode_cell({r:R+rpt,c:C+colpeat})]=dup(q);}if(range.e.c<=C)range.e.c=C;}}}colpeat=parseInt(ctag['number-columns-repeated']||"1",10);C+=colpeat-1;colpeat=0;q={};textp="";textR=[];}atag={};break;// 9.1.4 <table:table-cell>
/* pure state */case'document':// TODO: <office:document> is the root for FODS
case'document-content':case'电子表格文档':// 3.1.3.2 <office:document-content>
case'spreadsheet':case'主体':// 3.7 <office:spreadsheet>
case'scripts':// 3.12 <office:scripts>
case'styles':// TODO <office:styles>
case'font-face-decls':// 3.14 <office:font-face-decls>
case'master-styles'://3.15.4 <office:master-styles> -- relevant for FODS
if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw "Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;case'annotation':// 14.1 <office:annotation>
if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw "Bad state: "+tmp;comment.t=textp;if(textR.length)comment.R=textR;comment.a=creator;comments.push(comment);}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){state.push([Rn[3],false]);}creator="";creatoridx=0;textp="";textpidx=0;textR=[];break;case'creator':// 4.3.2.7 <dc:creator>
if(Rn[1]==='/'){creator=str.slice(creatoridx,Rn.index);}else creatoridx=Rn.index+Rn[0].length;break;/* ignore state */case'meta':case'元数据':// TODO: <office:meta> <uof:元数据> FODS/UOF
case'settings':// TODO: <office:settings>
case'config-item-set':// TODO: <office:config-item-set>
case'config-item-map-indexed':// TODO: <office:config-item-map-indexed>
case'config-item-map-entry':// TODO: <office:config-item-map-entry>
case'config-item-map-named':// TODO: <office:config-item-map-entry>
case'shapes':// 9.2.8 <table:shapes>
case'frame':// 10.4.2 <draw:frame>
case'text-box':// 10.4.3 <draw:text-box>
case'image':// 10.4.4 <draw:image>
case'data-pilot-tables':// 9.6.2 <table:data-pilot-tables>
case'list-style':// 16.30 <text:list-style>
case'form':// 13.13 <form:form>
case'dde-links':// 9.8 <table:dde-links>
case'event-listeners':// TODO
case'chart':// TODO
if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw "Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],false]);textp="";textpidx=0;textR=[];break;case'scientific-number':// TODO: <number:scientific-number>
break;case'currency-symbol':// TODO: <number:currency-symbol>
break;case'currency-style':// TODO: <number:currency-style>
break;case'number-style':// 16.27.2 <number:number-style>
case'percentage-style':// 16.27.9 <number:percentage-style>
case'date-style':// 16.27.10 <number:date-style>
case'time-style':// 16.27.18 <number:time-style>
if(Rn[1]==='/'){number_format_map[NFtag.name]=NF;if((tmp=state.pop())[0]!==Rn[3])throw "Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){NF="";NFtag=parsexmltag(Rn[0],false);state.push([Rn[3],true]);}break;case'script':break;// 3.13 <office:script>
case'libraries':break;// TODO: <ooo:libraries>
case'automatic-styles':break;// 3.15.3 <office:automatic-styles>
case'default-style':// TODO: <style:default-style>
case'page-layout':break;// TODO: <style:page-layout>
case'style':// 16.2 <style:style>
break;case'map':break;// 16.3 <style:map>
case'font-face':break;// 16.21 <style:font-face>
case'paragraph-properties':break;// 17.6 <style:paragraph-properties>
case'table-properties':break;// 17.15 <style:table-properties>
case'table-column-properties':break;// 17.16 <style:table-column-properties>
case'table-row-properties':break;// 17.17 <style:table-row-properties>
case'table-cell-properties':break;// 17.18 <style:table-cell-properties>
case'number':// 16.27.3 <number:number>
switch(state[state.length-1][0]){case'time-style':case'date-style':tag=parsexmltag(Rn[0],false);NF+=number_formats[Rn[3]][tag.style==='long'?1:0];break;}break;case'fraction':break;// TODO 16.27.6 <number:fraction>
case'day':// 16.27.11 <number:day>
case'month':// 16.27.12 <number:month>
case'year':// 16.27.13 <number:year>
case'era':// 16.27.14 <number:era>
case'day-of-week':// 16.27.15 <number:day-of-week>
case'week-of-year':// 16.27.16 <number:week-of-year>
case'quarter':// 16.27.17 <number:quarter>
case'hours':// 16.27.19 <number:hours>
case'minutes':// 16.27.20 <number:minutes>
case'seconds':// 16.27.21 <number:seconds>
case'am-pm':// 16.27.22 <number:am-pm>
switch(state[state.length-1][0]){case'time-style':case'date-style':tag=parsexmltag(Rn[0],false);NF+=number_formats[Rn[3]][tag.style==='long'?1:0];break;}break;case'boolean-style':break;// 16.27.23 <number:boolean-style>
case'boolean':break;// 16.27.24 <number:boolean>
case'text-style':break;// 16.27.25 <number:text-style>
case'text':// 16.27.26 <number:text>
if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")switch(state[state.length-1][0]){case'number-style':case'date-style':case'time-style':NF+=str.slice(pidx,Rn.index);break;}else pidx=Rn.index+Rn[0].length;break;case'named-range':// 9.4.12 <table:named-range>
tag=parsexmltag(Rn[0],false);_Ref=ods_to_csf_3D(tag['cell-range-address']);var nrange={Name:tag.name,Ref:_Ref[0]+'!'+_Ref[1]};if(intable)nrange.Sheet=SheetNames.length;WB.Names.push(nrange);break;case'text-content':break;// 16.27.27 <number:text-content>
case'text-properties':break;// 16.27.27 <style:text-properties>
case'embedded-text':break;// 16.27.4 <number:embedded-text>
case'body':case'电子表格':break;// 3.3 16.9.6 19.726.3
case'forms':break;// 12.25.2 13.2
case'table-column':break;// 9.1.6 <table:table-column>
case'table-header-rows':break;// 9.1.7 <table:table-header-rows>
case'table-rows':break;// 9.1.12 <table:table-rows>
/* TODO: outline levels */case'table-column-group':break;// 9.1.10 <table:table-column-group>
case'table-header-columns':break;// 9.1.11 <table:table-header-columns>
case'table-columns':break;// 9.1.12 <table:table-columns>
case'null-date':break;// 9.4.2 <table:null-date> TODO: date1904
case'graphic-properties':break;// 17.21 <style:graphic-properties>
case'calculation-settings':break;// 9.4.1 <table:calculation-settings>
case'named-expressions':break;// 9.4.11 <table:named-expressions>
case'label-range':break;// 9.4.9 <table:label-range>
case'label-ranges':break;// 9.4.10 <table:label-ranges>
case'named-expression':break;// 9.4.13 <table:named-expression>
case'sort':break;// 9.4.19 <table:sort>
case'sort-by':break;// 9.4.20 <table:sort-by>
case'sort-groups':break;// 9.4.22 <table:sort-groups>
case'tab':break;// 6.1.4 <text:tab>
case'line-break':break;// 6.1.5 <text:line-break>
case'span':break;// 6.1.7 <text:span>
case'p':case'文本串':// 5.1.3 <text:p>
if(['master-styles'].indexOf(state[state.length-1][0])>-1)break;if(Rn[1]==='/'&&(!ctag||!ctag['string-value'])){var ptp=parse_text_p(str.slice(textpidx,Rn.index));textp=(textp.length>0?textp+"\n":"")+ptp[0];}else {textptag=parsexmltag(Rn[0],false);textpidx=Rn.index+Rn[0].length;}break;// <text:p>
case's':break;// <text:s>
case'database-range':// 9.4.15 <table:database-range>
if(Rn[1]==='/')break;try{_Ref=ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);Sheets[_Ref[0]]['!autofilter']={ref:_Ref[1]};}catch(e){/* empty */}break;case'date':break;// <*:date>
case'object':break;// 10.4.6.2 <draw:object>
case'title':case'标题':break;// <*:title> OR <uof:标题>
case'desc':break;// <*:desc>
case'binary-data':break;// 10.4.5 TODO: b64 blob
/* 9.2 Advanced Tables */case'table-source':break;// 9.2.6
case'scenario':break;// 9.2.6
case'iteration':break;// 9.4.3 <table:iteration>
case'content-validations':break;// 9.4.4 <table:
case'content-validation':break;// 9.4.5 <table:
case'help-message':break;// 9.4.6 <table:
case'error-message':break;// 9.4.7 <table:
case'database-ranges':break;// 9.4.14 <table:database-ranges>
case'filter':break;// 9.5.2 <table:filter>
case'filter-and':break;// 9.5.3 <table:filter-and>
case'filter-or':break;// 9.5.4 <table:filter-or>
case'filter-condition':break;// 9.5.5 <table:filter-condition>
case'list-level-style-bullet':break;// 16.31 <text:
case'list-level-style-number':break;// 16.32 <text:
case'list-level-properties':break;// 17.19 <style:
/* 7.3 Document Fields */case'sender-firstname':// 7.3.6.2
case'sender-lastname':// 7.3.6.3
case'sender-initials':// 7.3.6.4
case'sender-title':// 7.3.6.5
case'sender-position':// 7.3.6.6
case'sender-email':// 7.3.6.7
case'sender-phone-private':// 7.3.6.8
case'sender-fax':// 7.3.6.9
case'sender-company':// 7.3.6.10
case'sender-phone-work':// 7.3.6.11
case'sender-street':// 7.3.6.12
case'sender-city':// 7.3.6.13
case'sender-postal-code':// 7.3.6.14
case'sender-country':// 7.3.6.15
case'sender-state-or-province':// 7.3.6.16
case'author-name':// 7.3.7.1
case'author-initials':// 7.3.7.2
case'chapter':// 7.3.8
case'file-name':// 7.3.9
case'template-name':// 7.3.9
case'sheet-name':// 7.3.9
break;case'event-listener':break;/* TODO: FODS Properties */case'initial-creator':case'creation-date':case'print-date':case'generator':case'document-statistic':case'user-defined':case'editing-duration':case'editing-cycles':break;/* TODO: FODS Config */case'config-item':break;/* TODO: style tokens */case'page-number':break;// TODO <text:page-number>
case'page-count':break;// TODO <text:page-count>
case'time':break;// TODO <text:time>
/* 9.3 Advanced Table Cells */case'cell-range-source':break;// 9.3.1 <table:
case'detective':break;// 9.3.2 <table:
case'operation':break;// 9.3.3 <table:
case'highlighted-range':break;// 9.3.4 <table:
/* 9.6 Data Pilot Tables <table: */case'data-pilot-table':// 9.6.3
case'source-cell-range':// 9.6.5
case'source-service':// 9.6.6
case'data-pilot-field':// 9.6.7
case'data-pilot-level':// 9.6.8
case'data-pilot-subtotals':// 9.6.9
case'data-pilot-subtotal':// 9.6.10
case'data-pilot-members':// 9.6.11
case'data-pilot-member':// 9.6.12
case'data-pilot-display-info':// 9.6.13
case'data-pilot-sort-info':// 9.6.14
case'data-pilot-layout-info':// 9.6.15
case'data-pilot-field-reference':// 9.6.16
case'data-pilot-groups':// 9.6.17
case'data-pilot-group':// 9.6.18
case'data-pilot-group-member':// 9.6.19
break;/* 10.3 Drawing Shapes */case'rect':// 10.3.2
break;/* 14.6 DDE Connections */case'dde-connection-decls':// 14.6.2 <text:
case'dde-connection-decl':// 14.6.3 <text:
case'dde-link':// 14.6.4 <table:
case'dde-source':// 14.6.5 <office:
break;case'properties':break;// 13.7 <form:properties>
case'property':break;// 13.8 <form:property>
case'a':// 6.1.8 hyperlink
if(Rn[1]!=='/'){atag=parsexmltag(Rn[0],false);if(!atag.href)break;atag.Target=atag.href;delete atag.href;if(atag.Target.charAt(0)=="#"&&atag.Target.indexOf(".")>-1){_Ref=ods_to_csf_3D(atag.Target.slice(1));atag.Target="#"+_Ref[0]+"!"+_Ref[1];}}break;/* non-standard */case'table-protection':break;case'data-pilot-grand-total':break;// <table:
case'office-document-common-attrs':break;// bare
default:switch(Rn[2]){case'dc:':// TODO: properties
case'calcext:':// ignore undocumented extensions
case'loext:':// ignore undocumented extensions
case'ooo:':// ignore undocumented extensions
case'chartooo:':// ignore undocumented extensions
case'draw:':// TODO: drawing
case'style:':// TODO: styles
case'chart:':// TODO: charts
case'form:':// TODO: forms
case'uof:':// TODO: uof
case'表:':// TODO: uof
case'字:':// TODO: uof
break;default:if(opts.WTF)throw new Error(Rn);}}var out={Sheets:Sheets,SheetNames:SheetNames,Workbook:WB};if(opts.bookSheets)delete out.Sheets;return out;};}();function parse_ods(zip,opts){opts=opts||{};var ods=!!safegetzipfile(zip,'objectdata');if(ods)parse_manifest(getzipdata(zip,'META-INF/manifest.xml'),opts);var content=getzipstr(zip,'content.xml');if(!content)throw new Error("Missing content.xml in "+(ods?"ODS":"UOF")+" file");var wb=parse_content_xml(ods?content:utf8read(content),opts);if(safegetzipfile(zip,'meta.xml'))wb.Props=parse_core_props(getzipdata(zip,'meta.xml'));return wb;}function parse_fods(data,opts){return parse_content_xml(data,opts);}/* OpenDocument */var write_styles_ods=function(){var payload='<office:document-styles '+wxt_helper({'xmlns:office':"urn:oasis:names:tc:opendocument:xmlns:office:1.0",'xmlns:table':"urn:oasis:names:tc:opendocument:xmlns:table:1.0",'xmlns:style':"urn:oasis:names:tc:opendocument:xmlns:style:1.0",'xmlns:text':"urn:oasis:names:tc:opendocument:xmlns:text:1.0",'xmlns:draw':"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",'xmlns:fo':"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",'xmlns:xlink':"http://www.w3.org/1999/xlink",'xmlns:dc':"http://purl.org/dc/elements/1.1/",'xmlns:number':"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",'xmlns:svg':"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",'xmlns:of':"urn:oasis:names:tc:opendocument:xmlns:of:1.2",'office:version':"1.2"})+'></office:document-styles>';return function wso(){return XML_HEADER+payload;};}();var write_content_ods=function(){/* 6.1.2 White Space Characters */var write_text_p=function(text){return escapexml(text).replace(/  +/g,function($$){return '<text:s text:c="'+$$.length+'"/>';}).replace(/\t/g,"<text:tab/>").replace(/\n/g,"</text:p><text:p>").replace(/^ /,"<text:s/>").replace(/ $/,"<text:s/>");};var null_cell_xml='          <table:table-cell />\n';var covered_cell_xml='          <table:covered-table-cell/>\n';var write_ws=function(ws,wb,i){/* Section 9 Tables */var o=[];o.push('      <table:table table:name="'+escapexml(wb.SheetNames[i])+'" table:style-name="ta1">\n');var R=0,C=0,range=decode_range(ws['!ref']);var marr=ws['!merges']||[],mi=0;var dense=Array.isArray(ws);for(R=0;R<range.s.r;++R)o.push('        <table:table-row></table:table-row>\n');for(;R<=range.e.r;++R){o.push('        <table:table-row>\n');for(C=0;C<range.s.c;++C)o.push(null_cell_xml);for(;C<=range.e.c;++C){var skip=false,ct={},textp="";for(mi=0;mi!=marr.length;++mi){if(marr[mi].s.c>C)continue;if(marr[mi].s.r>R)continue;if(marr[mi].e.c<C)continue;if(marr[mi].e.r<R)continue;if(marr[mi].s.c!=C||marr[mi].s.r!=R)skip=true;ct['table:number-columns-spanned']=marr[mi].e.c-marr[mi].s.c+1;ct['table:number-rows-spanned']=marr[mi].e.r-marr[mi].s.r+1;break;}if(skip){o.push(covered_cell_xml);continue;}var ref=encode_cell({r:R,c:C}),cell=dense?(ws[R]||[])[C]:ws[ref];if(cell&&cell.f){ct['table:formula']=escapexml(csf_to_ods_formula(cell.f));if(cell.F){if(cell.F.slice(0,ref.length)==ref){var _Fref=decode_range(cell.F);ct['table:number-matrix-columns-spanned']=_Fref.e.c-_Fref.s.c+1;ct['table:number-matrix-rows-spanned']=_Fref.e.r-_Fref.s.r+1;}}}if(!cell){o.push(null_cell_xml);continue;}switch(cell.t){case'b':textp=cell.v?'TRUE':'FALSE';ct['office:value-type']="boolean";ct['office:boolean-value']=cell.v?'true':'false';break;case'n':textp=cell.w||String(cell.v||0);ct['office:value-type']="float";ct['office:value']=cell.v||0;break;case's':case'str':textp=cell.v==null?"":cell.v;ct['office:value-type']="string";break;case'd':textp=cell.w||parseDate(cell.v).toISOString();ct['office:value-type']="date";ct['office:date-value']=parseDate(cell.v).toISOString();ct['table:style-name']="ce1";break;//case 'e':
default:o.push(null_cell_xml);continue;}var text_p=write_text_p(textp);if(cell.l&&cell.l.Target){var _tgt=cell.l.Target;_tgt=_tgt.charAt(0)=="#"?"#"+csf_to_ods_3D(_tgt.slice(1)):_tgt;text_p=writextag('text:a',text_p,{'xlink:href':_tgt});}o.push('          '+writextag('table:table-cell',writextag('text:p',text_p,{}),ct)+'\n');}o.push('        </table:table-row>\n');}o.push('      </table:table>\n');return o.join("");};var write_automatic_styles_ods=function(o){o.push(' <office:automatic-styles>\n');o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');o.push('   <number:month number:style="long"/>\n');o.push('   <number:text>/</number:text>\n');o.push('   <number:day number:style="long"/>\n');o.push('   <number:text>/</number:text>\n');o.push('   <number:year/>\n');o.push('  </number:date-style>\n');/* table */o.push('  <style:style style:name="ta1" style:family="table">\n');// style:master-page-name="mp1">\n');
o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');o.push('  </style:style>\n');/* table cells, text */o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');/* page-layout */o.push(' </office:automatic-styles>\n');};return function wcx(wb,opts){var o=[XML_HEADER];/* 3.1.3.2 */var attr=wxt_helper({'xmlns:office':"urn:oasis:names:tc:opendocument:xmlns:office:1.0",'xmlns:table':"urn:oasis:names:tc:opendocument:xmlns:table:1.0",'xmlns:style':"urn:oasis:names:tc:opendocument:xmlns:style:1.0",'xmlns:text':"urn:oasis:names:tc:opendocument:xmlns:text:1.0",'xmlns:draw':"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",'xmlns:fo':"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",'xmlns:xlink':"http://www.w3.org/1999/xlink",'xmlns:dc':"http://purl.org/dc/elements/1.1/",'xmlns:meta':"urn:oasis:names:tc:opendocument:xmlns:meta:1.0",'xmlns:number':"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",'xmlns:presentation':"urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",'xmlns:svg':"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",'xmlns:chart':"urn:oasis:names:tc:opendocument:xmlns:chart:1.0",'xmlns:dr3d':"urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",'xmlns:math':"http://www.w3.org/1998/Math/MathML",'xmlns:form':"urn:oasis:names:tc:opendocument:xmlns:form:1.0",'xmlns:script':"urn:oasis:names:tc:opendocument:xmlns:script:1.0",'xmlns:ooo':"http://openoffice.org/2004/office",'xmlns:ooow':"http://openoffice.org/2004/writer",'xmlns:oooc':"http://openoffice.org/2004/calc",'xmlns:dom':"http://www.w3.org/2001/xml-events",'xmlns:xforms':"http://www.w3.org/2002/xforms",'xmlns:xsd':"http://www.w3.org/2001/XMLSchema",'xmlns:xsi':"http://www.w3.org/2001/XMLSchema-instance",'xmlns:sheet':"urn:oasis:names:tc:opendocument:sh33tjs:1.0",'xmlns:rpt':"http://openoffice.org/2005/report",'xmlns:of':"urn:oasis:names:tc:opendocument:xmlns:of:1.2",'xmlns:xhtml':"http://www.w3.org/1999/xhtml",'xmlns:grddl':"http://www.w3.org/2003/g/data-view#",'xmlns:tableooo':"http://openoffice.org/2009/table",'xmlns:drawooo':"http://openoffice.org/2010/draw",'xmlns:calcext':"urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",'xmlns:loext':"urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",'xmlns:field':"urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",'xmlns:formx':"urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",'xmlns:css3t':"http://www.w3.org/TR/css3-text/",'office:version':"1.2"});var fods=wxt_helper({'xmlns:config':"urn:oasis:names:tc:opendocument:xmlns:config:1.0",'office:mimetype':"application/vnd.oasis.opendocument.spreadsheet"});if(opts.bookType=="fods")o.push('<office:document'+attr+fods+'>\n');else o.push('<office:document-content'+attr+'>\n');write_automatic_styles_ods(o);o.push('  <office:body>\n');o.push('    <office:spreadsheet>\n');for(var i=0;i!=wb.SheetNames.length;++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]],wb,i));o.push('    </office:spreadsheet>\n');o.push('  </office:body>\n');if(opts.bookType=="fods")o.push('</office:document>');else o.push('</office:document-content>');return o.join("");};}();function write_ods(wb,opts){if(opts.bookType=="fods")return write_content_ods(wb,opts);var zip=zip_new();var f="";var manifest=[];var rdf=[];/* Part 3 Section 3.3 MIME Media Type */f="mimetype";zip_add_file(zip,f,"application/vnd.oasis.opendocument.spreadsheet");/* Part 1 Section 2.2 Documents */f="content.xml";zip_add_file(zip,f,write_content_ods(wb,opts));manifest.push([f,"text/xml"]);rdf.push([f,"ContentFile"]);/* TODO: these are hard-coded styles to satiate excel */f="styles.xml";zip_add_file(zip,f,write_styles_ods(wb,opts));manifest.push([f,"text/xml"]);rdf.push([f,"StylesFile"]);/* TODO: this is hard-coded to satiate excel */f="meta.xml";zip_add_file(zip,f,write_meta_ods());manifest.push([f,"text/xml"]);rdf.push([f,"MetadataFile"]);/* Part 3 Section 6 Metadata Manifest File */f="manifest.rdf";zip_add_file(zip,f,write_rdf(rdf/*, opts*/));manifest.push([f,"application/rdf+xml"]);/* Part 3 Section 4 Manifest File */f="META-INF/manifest.xml";zip_add_file(zip,f,write_manifest(manifest/*, opts*/));return zip;}function write_sheet_index(wb,sheet){if(!sheet)return 0;var idx=wb.SheetNames.indexOf(sheet);if(idx==-1)throw new Error("Sheet not found: "+sheet);return idx;}function write_obj_str(factory){return function write_str(wb,o){var idx=write_sheet_index(wb,o.sheet);return factory.from_sheet(wb.Sheets[wb.SheetNames[idx]],o,wb);};}var write_htm_str=write_obj_str(HTML_);var write_csv_str=write_obj_str({from_sheet:sheet_to_csv});var write_slk_str=write_obj_str(typeof SYLK!=="undefined"?SYLK:{});var write_dif_str=write_obj_str(typeof DIF!=="undefined"?DIF:{});var write_prn_str=write_obj_str(typeof PRN!=="undefined"?PRN:{});var write_rtf_str=write_obj_str(typeof RTF!=="undefined"?RTF:{});var write_txt_str=write_obj_str({from_sheet:sheet_to_txt});var write_dbf_buf=write_obj_str(typeof DBF!=="undefined"?DBF:{});var write_eth_str=write_obj_str(typeof ETH!=="undefined"?ETH:{});function fix_opts_func(defaults){return function fix_opts(opts){for(var i=0;i!=defaults.length;++i){var d=defaults[i];if(opts[d[0]]===undefined)opts[d[0]]=d[1];if(d[2]==='n')opts[d[0]]=Number(opts[d[0]]);}};}var fix_read_opts=function(opts){fix_opts_func([['cellNF',false],/* emit cell number format string as .z */['cellHTML',true],/* emit html string as .h */['cellFormula',true],/* emit formulae as .f */['cellStyles',false],/* emits style/theme as .s */['cellText',true],/* emit formatted text as .w */['cellDates',false],/* emit date cells with type `d` */['sheetStubs',false],/* emit empty cells */['sheetRows',0,'n'],/* read n rows (0 = read all rows) */['bookDeps',false],/* parse calculation chains */['bookSheets',false],/* only try to get sheet names (no Sheets) */['bookProps',false],/* only try to get properties (no Sheets) */['bookFiles',false],/* include raw file structure (keys, files, cfb) */['bookVBA',false],/* include vba raw data (vbaraw) */['password',''],/* password */['WTF',false]/* WTF mode (throws errors) */])(opts);};var fix_write_opts=fix_opts_func([['cellDates',false],/* write date cells with type `d` */['bookSST',false],/* Generate Shared String Table */['bookType','xlsx'],/* Type of workbook (xlsx/m/b) */['compression',false],/* Use file compression */['WTF',false]/* WTF mode (throws errors) */]);function get_sheet_type(n){if(RELS.WS.indexOf(n)>-1)return "sheet";if(RELS.CS&&n==RELS.CS)return "chart";if(RELS.DS&&n==RELS.DS)return "dialog";if(RELS.MS&&n==RELS.MS)return "macro";return n&&n.length?n:"sheet";}function safe_parse_wbrels(wbrels,sheets){if(!wbrels)return 0;try{wbrels=sheets.map(function pwbr(w){if(!w.id)w.id=w.strRelID;return [w.name,wbrels['!id'][w.id].Target,get_sheet_type(wbrels['!id'][w.id].Type)];});}catch(e){return null;}return !wbrels||wbrels.length===0?null:wbrels;}function safe_parse_sheet(zip,path,relsPath,sheet,idx,sheetRels,sheets,stype,opts,wb,themes,styles){try{sheetRels[sheet]=parse_rels(getzipstr(zip,relsPath,true),path);var data=getzipdata(zip,path);var _ws;switch(stype){case'sheet':_ws=parse_ws(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;case'chart':_ws=parse_cs(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);if(!_ws||!_ws['!drawel'])break;var dfile=resolve_path(_ws['!drawel'].Target,path);var drelsp=get_rels_path(dfile);var draw=parse_drawing(getzipstr(zip,dfile,true),parse_rels(getzipstr(zip,drelsp,true),dfile));var chartp=resolve_path(draw,dfile);var crelsp=get_rels_path(chartp);_ws=parse_chart(getzipstr(zip,chartp,true),chartp,opts,parse_rels(getzipstr(zip,crelsp,true),chartp),wb,_ws);break;case'macro':_ws=parse_ms(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;case'dialog':_ws=parse_ds(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;default:throw new Error("Unrecognized sheet type "+stype);}sheets[sheet]=_ws;/* scan rels for comments */var comments=[];if(sheetRels&&sheetRels[sheet])keys(sheetRels[sheet]).forEach(function(n){if(sheetRels[sheet][n].Type==RELS.CMNT){var dfile=resolve_path(sheetRels[sheet][n].Target,path);comments=parse_cmnt(getzipdata(zip,dfile,true),dfile,opts);if(!comments||!comments.length)return;sheet_insert_comments(_ws,comments);}});}catch(e){if(opts.WTF)throw e;}}function strip_front_slash(x){return x.charAt(0)=='/'?x.slice(1):x;}function parse_zip(zip,opts){make_ssf(SSF);opts=opts||{};fix_read_opts(opts);/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */if(safegetzipfile(zip,'META-INF/manifest.xml'))return parse_ods(zip,opts);/* UOC */if(safegetzipfile(zip,'objectdata.xml'))return parse_ods(zip,opts);/* Numbers */if(safegetzipfile(zip,'Index/Document.iwa'))throw new Error('Unsupported NUMBERS file');var entries=zipentries(zip);var dir=parse_ct(getzipstr(zip,'[Content_Types].xml'));var xlsb=false;var sheets,binname;if(dir.workbooks.length===0){binname="xl/workbook.xml";if(getzipdata(zip,binname,true))dir.workbooks.push(binname);}if(dir.workbooks.length===0){binname="xl/workbook.bin";if(!getzipdata(zip,binname,true))throw new Error("Could not find workbook");dir.workbooks.push(binname);xlsb=true;}if(dir.workbooks[0].slice(-3)=="bin")xlsb=true;var themes={};var styles={};if(!opts.bookSheets&&!opts.bookProps){strs=[];if(dir.sst)try{strs=parse_sst(getzipdata(zip,strip_front_slash(dir.sst)),dir.sst,opts);}catch(e){if(opts.WTF)throw e;}if(opts.cellStyles&&dir.themes.length)themes=parse_theme(getzipstr(zip,dir.themes[0].replace(/^\//,''),true)||"",dir.themes[0],opts);if(dir.style)styles=parse_sty(getzipdata(zip,strip_front_slash(dir.style)),dir.style,themes,opts);}/*var externbooks = */dir.links.map(function(link){try{var rels=parse_rels(getzipstr(zip,get_rels_path(strip_front_slash(link))),link);return parse_xlink(getzipdata(zip,strip_front_slash(link)),rels,link,opts);}catch(e){}});var wb=parse_wb(getzipdata(zip,strip_front_slash(dir.workbooks[0])),dir.workbooks[0],opts);var props={},propdata="";if(dir.coreprops.length){propdata=getzipdata(zip,strip_front_slash(dir.coreprops[0]),true);if(propdata)props=parse_core_props(propdata);if(dir.extprops.length!==0){propdata=getzipdata(zip,strip_front_slash(dir.extprops[0]),true);if(propdata)parse_ext_props(propdata,props,opts);}}var custprops={};if(!opts.bookSheets||opts.bookProps){if(dir.custprops.length!==0){propdata=getzipstr(zip,strip_front_slash(dir.custprops[0]),true);if(propdata)custprops=parse_cust_props(propdata,opts);}}var out={};if(opts.bookSheets||opts.bookProps){if(wb.Sheets)sheets=wb.Sheets.map(function pluck(x){return x.name;});else if(props.Worksheets&&props.SheetNames.length>0)sheets=props.SheetNames;if(opts.bookProps){out.Props=props;out.Custprops=custprops;}if(opts.bookSheets&&typeof sheets!=='undefined')out.SheetNames=sheets;if(opts.bookSheets?out.SheetNames:opts.bookProps)return out;}sheets={};var deps={};if(opts.bookDeps&&dir.calcchain)deps=parse_cc(getzipdata(zip,strip_front_slash(dir.calcchain)),dir.calcchain);var i=0;var sheetRels={};var path,relsPath;{var wbsheets=wb.Sheets;props.Worksheets=wbsheets.length;props.SheetNames=[];for(var j=0;j!=wbsheets.length;++j){props.SheetNames[j]=wbsheets[j].name;}}var wbext=xlsb?"bin":"xml";var wbrelsi=dir.workbooks[0].lastIndexOf("/");var wbrelsfile=(dir.workbooks[0].slice(0,wbrelsi+1)+"_rels/"+dir.workbooks[0].slice(wbrelsi+1)+".rels").replace(/^\//,"");if(!safegetzipfile(zip,wbrelsfile))wbrelsfile='xl/_rels/workbook.'+wbext+'.rels';var wbrels=parse_rels(getzipstr(zip,wbrelsfile,true),wbrelsfile);if(wbrels)wbrels=safe_parse_wbrels(wbrels,wb.Sheets);/* Numbers iOS hack */var nmode=getzipdata(zip,"xl/worksheets/sheet.xml",true)?1:0;wsloop:for(i=0;i!=props.Worksheets;++i){var stype="sheet";if(wbrels&&wbrels[i]){path='xl/'+wbrels[i][1].replace(/[\/]?xl\//,"");if(!safegetzipfile(zip,path))path=wbrels[i][1];if(!safegetzipfile(zip,path))path=wbrelsfile.replace(/_rels\/.*$/,"")+wbrels[i][1];stype=wbrels[i][2];}else {path='xl/worksheets/sheet'+(i+1-nmode)+"."+wbext;path=path.replace(/sheet0\./,"sheet.");}relsPath=path.replace(/^(.*)(\/)([^\/]*)$/,"$1/_rels/$3.rels");if(opts&&opts.sheets!=null)switch(typeof opts.sheets){case"number":if(i!=opts.sheets)continue wsloop;break;case"string":if(props.SheetNames[i].toLowerCase()!=opts.sheets.toLowerCase())continue wsloop;break;default:if(Array.isArray&&Array.isArray(opts.sheets)){var snjseen=false;for(var snj=0;snj!=opts.sheets.length;++snj){if(typeof opts.sheets[snj]=="number"&&opts.sheets[snj]==i)snjseen=1;if(typeof opts.sheets[snj]=="string"&&opts.sheets[snj].toLowerCase()==props.SheetNames[i].toLowerCase())snjseen=1;}if(!snjseen)continue wsloop;}}safe_parse_sheet(zip,path,relsPath,props.SheetNames[i],i,sheetRels,sheets,stype,opts,wb,themes,styles);}out={Directory:dir,Workbook:wb,Props:props,Custprops:custprops,Deps:deps,Sheets:sheets,SheetNames:props.SheetNames,Strings:strs,Styles:styles,Themes:themes,SSF:SSF.get_table()};if(opts&&opts.bookFiles){out.keys=entries;out.files=zip.files;}if(opts&&opts.bookVBA){if(dir.vba.length>0)out.vbaraw=getzipdata(zip,strip_front_slash(dir.vba[0]),true);else if(dir.defaults&&dir.defaults.bin===CT_VBA)out.vbaraw=getzipdata(zip,'xl/vbaProject.bin',true);}return out;}/* [MS-OFFCRYPTO] 2.1.1 */function parse_xlsxcfb(cfb,_opts){var opts=_opts||{};var f='Workbook',data=CFB.find(cfb,f);try{f='/!DataSpaces/Version';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);/*var version = */parse_DataSpaceVersionInfo(data.content);/* 2.3.4.1 */f='/!DataSpaces/DataSpaceMap';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var dsm=parse_DataSpaceMap(data.content);if(dsm.length!==1||dsm[0].comps.length!==1||dsm[0].comps[0].t!==0||dsm[0].name!=="StrongEncryptionDataSpace"||dsm[0].comps[0].v!=="EncryptedPackage")throw new Error("ECMA-376 Encrypted file bad "+f);/* 2.3.4.2 */f='/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var seds=parse_DataSpaceDefinition(data.content);if(seds.length!=1||seds[0]!="StrongEncryptionTransform")throw new Error("ECMA-376 Encrypted file bad "+f);/* 2.3.4.3 */f='/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);/*var hdr = */parse_Primary(data.content);}catch(e){}f='/EncryptionInfo';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var einfo=parse_EncryptionInfo(data.content);/* 2.3.4.4 */f='/EncryptedPackage';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);/*global decrypt_agile */if(einfo[0]==0x04&&typeof decrypt_agile!=='undefined')return decrypt_agile(einfo[1],data.content,opts.password||"",opts);/*global decrypt_std76 */if(einfo[0]==0x02&&typeof decrypt_std76!=='undefined')return decrypt_std76(einfo[1],data.content,opts.password||"",opts);throw new Error("File is password-protected");}function write_zip(wb,opts){_shapeid=1024;if(opts.bookType=="ods")return write_ods(wb,opts);if(wb&&!wb.SSF){wb.SSF=SSF.get_table();}if(wb&&wb.SSF){make_ssf(SSF);SSF.load_table(wb.SSF);// $FlowIgnore
opts.revssf=evert_num(wb.SSF);opts.revssf[wb.SSF[65535]]=0;opts.ssf=wb.SSF;}opts.rels={};opts.wbrels={};opts.Strings=[];opts.Strings.Count=0;opts.Strings.Unique=0;if(browser_has_Map)opts.revStrings=new Map();else {opts.revStrings={};opts.revStrings.foo=[];delete opts.revStrings.foo;}var wbext=opts.bookType=="xlsb"?"bin":"xml";var vbafmt=VBAFMTS.indexOf(opts.bookType)>-1;var ct=new_ct();fix_write_opts(opts=opts||{});var zip=zip_new();var f="",rId=0;opts.cellXfs=[];get_cell_style(opts.cellXfs,{},{revssf:{"General":0}});if(!wb.Props)wb.Props={};f="docProps/core.xml";zip_add_file(zip,f,write_core_props(wb.Props,opts));ct.coreprops.push(f);add_rels(opts.rels,2,f,RELS.CORE_PROPS);f="docProps/app.xml";if(wb.Props&&wb.Props.SheetNames);else if(!wb.Workbook||!wb.Workbook.Sheets)wb.Props.SheetNames=wb.SheetNames;else {var _sn=[];for(var _i=0;_i<wb.SheetNames.length;++_i)if((wb.Workbook.Sheets[_i]||{}).Hidden!=2)_sn.push(wb.SheetNames[_i]);wb.Props.SheetNames=_sn;}wb.Props.Worksheets=wb.Props.SheetNames.length;zip_add_file(zip,f,write_ext_props(wb.Props));ct.extprops.push(f);add_rels(opts.rels,3,f,RELS.EXT_PROPS);if(wb.Custprops!==wb.Props&&keys(wb.Custprops||{}).length>0){f="docProps/custom.xml";zip_add_file(zip,f,write_cust_props(wb.Custprops));ct.custprops.push(f);add_rels(opts.rels,4,f,RELS.CUST_PROPS);}for(rId=1;rId<=wb.SheetNames.length;++rId){var wsrels={'!id':{}};var ws=wb.Sheets[wb.SheetNames[rId-1]];var _type=(ws||{})["!type"]||"sheet";switch(_type){case"chart":/* falls through */default:f="xl/worksheets/sheet"+rId+"."+wbext;zip_add_file(zip,f,write_ws(rId-1,f,opts,wb,wsrels));ct.sheets.push(f);add_rels(opts.wbrels,-1,"worksheets/sheet"+rId+"."+wbext,RELS.WS[0]);}if(ws){var comments=ws['!comments'];var need_vml=false;if(comments&&comments.length>0){var cf="xl/comments"+rId+"."+wbext;zip_add_file(zip,cf,write_cmnt(comments,cf,opts));ct.comments.push(cf);add_rels(wsrels,-1,"../comments"+rId+"."+wbext,RELS.CMNT);need_vml=true;}if(ws['!legacy']){if(need_vml)zip_add_file(zip,"xl/drawings/vmlDrawing"+rId+".vml",write_comments_vml(rId,ws['!comments']));}delete ws['!comments'];delete ws['!legacy'];}if(wsrels['!id'].rId1)zip_add_file(zip,get_rels_path(f),write_rels(wsrels));}if(opts.Strings!=null&&opts.Strings.length>0){f="xl/sharedStrings."+wbext;zip_add_file(zip,f,write_sst(opts.Strings,f,opts));ct.strs.push(f);add_rels(opts.wbrels,-1,"sharedStrings."+wbext,RELS.SST);}f="xl/workbook."+wbext;zip_add_file(zip,f,write_wb(wb,f,opts));ct.workbooks.push(f);add_rels(opts.rels,1,f,RELS.WB);/* TODO: something more intelligent with themes */f="xl/theme/theme1.xml";zip_add_file(zip,f,write_theme(wb.Themes,opts));ct.themes.push(f);add_rels(opts.wbrels,-1,"theme/theme1.xml",RELS.THEME);/* TODO: something more intelligent with styles */f="xl/styles."+wbext;zip_add_file(zip,f,write_sty(wb,f,opts));ct.styles.push(f);add_rels(opts.wbrels,-1,"styles."+wbext,RELS.STY);if(wb.vbaraw&&vbafmt){f="xl/vbaProject.bin";zip_add_file(zip,f,wb.vbaraw);ct.vba.push(f);add_rels(opts.wbrels,-1,"vbaProject.bin",RELS.VBA);}zip_add_file(zip,"[Content_Types].xml",write_ct(ct,opts));zip_add_file(zip,'_rels/.rels',write_rels(opts.rels));zip_add_file(zip,'xl/_rels/workbook.'+wbext+'.rels',write_rels(opts.wbrels));delete opts.revssf;delete opts.ssf;return zip;}function firstbyte(f,o){var x="";switch((o||{}).type||"base64"){case'buffer':return [f[0],f[1],f[2],f[3],f[4],f[5],f[6],f[7]];case'base64':x=Base64.decode(f.slice(0,12));break;case'binary':x=f;break;case'array':return [f[0],f[1],f[2],f[3],f[4],f[5],f[6],f[7]];default:throw new Error("Unrecognized type "+(o&&o.type||"undefined"));}return [x.charCodeAt(0),x.charCodeAt(1),x.charCodeAt(2),x.charCodeAt(3),x.charCodeAt(4),x.charCodeAt(5),x.charCodeAt(6),x.charCodeAt(7)];}function read_cfb(cfb,opts){if(CFB.find(cfb,"EncryptedPackage"))return parse_xlsxcfb(cfb,opts);return parse_xlscfb(cfb,opts);}function read_zip(data,opts){var zip,d=data;var o=opts||{};if(!o.type)o.type=has_buf&&Buffer.isBuffer(data)?"buffer":"base64";zip=zip_read(d,o);return parse_zip(zip,o);}function read_plaintext(data,o){var i=0;main:while(i<data.length)switch(data.charCodeAt(i)){case 0x0A:case 0x0D:case 0x20:++i;break;case 0x3C:return parse_xlml(data.slice(i),o);default:break main;}return PRN.to_workbook(data,o);}function read_plaintext_raw(data,o){var str="",bytes=firstbyte(data,o);switch(o.type){case'base64':str=Base64.decode(data);break;case'binary':str=data;break;case'buffer':str=data.toString('binary');break;case'array':str=cc2str(data);break;default:throw new Error("Unrecognized type "+o.type);}if(bytes[0]==0xEF&&bytes[1]==0xBB&&bytes[2]==0xBF)str=utf8read(str);return read_plaintext(str,o);}function read_utf16(data,o){var d=data;if(o.type=='base64')d=Base64.decode(d);d=cptable.utils.decode(1200,d.slice(2),'str');o.type="binary";return read_plaintext(d,o);}function bstrify(data){return !data.match(/[^\x00-\x7F]/)?data:utf8write(data);}function read_prn(data,d,o,str){if(str){o.type="string";return PRN.to_workbook(data,o);}return PRN.to_workbook(d,o);}function readSync(data,opts){reset_cp();if(typeof ArrayBuffer!=='undefined'&&data instanceof ArrayBuffer)return readSync(new Uint8Array(data),opts);var d=data,n=[0,0,0,0],str=false;var o=opts||{};if(o.cellStyles){o.cellNF=true;o.sheetStubs=true;}_ssfopts={};if(o.dateNF)_ssfopts.dateNF=o.dateNF;if(!o.type)o.type=has_buf&&Buffer.isBuffer(data)?"buffer":"base64";if(o.type=="file"){o.type=has_buf?"buffer":"binary";d=read_binary(data);}if(o.type=="string"){str=true;o.type="binary";o.codepage=65001;d=bstrify(data);}if(o.type=='array'&&typeof Uint8Array!=='undefined'&&data instanceof Uint8Array&&typeof ArrayBuffer!=='undefined'){// $FlowIgnore
var ab=new ArrayBuffer(3),vu=new Uint8Array(ab);vu.foo="bar";// $FlowIgnore
if(!vu.foo){o=dup(o);o.type='array';return readSync(ab2a(d),o);}}switch((n=firstbyte(d,o))[0]){case 0xD0:if(n[1]===0xCF&&n[2]===0x11&&n[3]===0xE0&&n[4]===0xA1&&n[5]===0xB1&&n[6]===0x1A&&n[7]===0xE1)return read_cfb(CFB.read(d,o),o);break;case 0x09:if(n[1]<=0x04)return parse_xlscfb(d,o);break;case 0x3C:return parse_xlml(d,o);case 0x49:if(n[1]===0x49&&n[2]===0x2a&&n[3]===0x00)throw new Error("TIFF Image File is not a spreadsheet");if(n[1]===0x44)return read_wb_ID(d,o);break;case 0x54:if(n[1]===0x41&&n[2]===0x42&&n[3]===0x4C)return DIF.to_workbook(d,o);break;case 0x50:return n[1]===0x4B&&n[2]<0x09&&n[3]<0x09?read_zip(d,o):read_prn(data,d,o,str);case 0xEF:return n[3]===0x3C?parse_xlml(d,o):read_prn(data,d,o,str);case 0xFF:if(n[1]===0xFE){return read_utf16(d,o);}break;case 0x00:if(n[1]===0x00&&n[2]>=0x02&&n[3]===0x00)return WK_.to_workbook(d,o);break;case 0x03:case 0x83:case 0x8B:case 0x8C:return DBF.to_workbook(d,o);case 0x7B:if(n[1]===0x5C&&n[2]===0x72&&n[3]===0x74)return RTF.to_workbook(d,o);break;case 0x0A:case 0x0D:case 0x20:return read_plaintext_raw(d,o);}if(DBF.versions.indexOf(n[0])>-1&&n[2]<=12&&n[3]<=31)return DBF.to_workbook(d,o);return read_prn(data,d,o,str);}function readFileSync(filename,opts){var o=opts||{};o.type='file';return readSync(filename,o);}function write_cfb_ctr(cfb,o){switch(o.type){case"base64":case"binary":break;case"buffer":case"array":o.type="";break;case"file":return write_dl(o.file,CFB.write(cfb,{type:has_buf?'buffer':""}));case"string":throw new Error("'string' output type invalid for '"+o.bookType+"' files");default:throw new Error("Unrecognized type "+o.type);}return CFB.write(cfb,o);}function write_zip_type(wb,opts){var o=opts||{};var z=write_zip(wb,o);var oopts={};if(o.compression)oopts.compression='DEFLATE';if(o.password)oopts.type=has_buf?"nodebuffer":"string";else switch(o.type){case"base64":oopts.type="base64";break;case"binary":oopts.type="string";break;case"string":throw new Error("'string' output type invalid for '"+o.bookType+"' files");case"buffer":case"file":oopts.type=has_buf?"nodebuffer":"string";break;default:throw new Error("Unrecognized type "+o.type);}var out=z.FullPaths?CFB.write(z,{fileType:"zip",type:{"nodebuffer":"buffer","string":"binary"}[oopts.type]||oopts.type}):z.generate(oopts);/*jshint -W083 */if(o.password&&typeof encrypt_agile!=='undefined')return write_cfb_ctr(encrypt_agile(out,o.password),o);// eslint-disable-line no-undef
/*jshint +W083 */if(o.type==="file")return write_dl(o.file,out);return o.type=="string"?utf8read(out):out;}function write_cfb_type(wb,opts){var o=opts||{};var cfb=write_xlscfb(wb,o);return write_cfb_ctr(cfb,o);}function write_string_type(out,opts,bom){if(!bom)bom="";var o=bom+out;switch(opts.type){case"base64":return Base64.encode(utf8write(o));case"binary":return utf8write(o);case"string":return out;case"file":return write_dl(opts.file,o,'utf8');case"buffer":{if(has_buf)return Buffer_from(o,'utf8');else return write_string_type(o,{type:'binary'}).split("").map(function(c){return c.charCodeAt(0);});}}throw new Error("Unrecognized type "+opts.type);}function write_stxt_type(out,opts){switch(opts.type){case"base64":return Base64.encode(out);case"binary":return out;case"string":return out;/* override in sheet_to_txt */case"file":return write_dl(opts.file,out,'binary');case"buffer":{if(has_buf)return Buffer_from(out,'binary');else return out.split("").map(function(c){return c.charCodeAt(0);});}}throw new Error("Unrecognized type "+opts.type);}/* TODO: test consistency */function write_binary_type(out,opts){switch(opts.type){case"string":case"base64":case"binary":var bstr="";// $FlowIgnore
for(var i=0;i<out.length;++i)bstr+=String.fromCharCode(out[i]);return opts.type=='base64'?Base64.encode(bstr):opts.type=='string'?utf8read(bstr):bstr;case"file":return write_dl(opts.file,out);case"buffer":return out;default:throw new Error("Unrecognized type "+opts.type);}}function writeSync(wb,opts){reset_cp();check_wb(wb);var o=opts||{};if(o.cellStyles){o.cellNF=true;o.sheetStubs=true;}if(o.type=="array"){o.type="binary";var out=writeSync(wb,o);o.type="array";return s2ab(out);}switch(o.bookType||'xlsb'){case'xml':case'xlml':return write_string_type(write_xlml(wb,o),o);case'slk':case'sylk':return write_string_type(write_slk_str(wb,o),o);case'htm':case'html':return write_string_type(write_htm_str(wb,o),o);case'txt':return write_stxt_type(write_txt_str(wb,o),o);case'csv':return write_string_type(write_csv_str(wb,o),o,"\ufeff");case'dif':return write_string_type(write_dif_str(wb,o),o);case'dbf':return write_binary_type(write_dbf_buf(wb,o),o);case'prn':return write_string_type(write_prn_str(wb,o),o);case'rtf':return write_string_type(write_rtf_str(wb,o),o);case'eth':return write_string_type(write_eth_str(wb,o),o);case'fods':return write_string_type(write_ods(wb,o),o);case'biff2':if(!o.biff)o.biff=2;/* falls through */case'biff3':if(!o.biff)o.biff=3;/* falls through */case'biff4':if(!o.biff)o.biff=4;return write_binary_type(write_biff_buf(wb,o),o);case'biff5':if(!o.biff)o.biff=5;/* falls through */case'biff8':case'xla':case'xls':if(!o.biff)o.biff=8;return write_cfb_type(wb,o);case'xlsx':case'xlsm':case'xlam':case'xlsb':case'ods':return write_zip_type(wb,o);default:throw new Error("Unrecognized bookType |"+o.bookType+"|");}}function resolve_book_type(o){if(o.bookType)return;var _BT={"xls":"biff8","htm":"html","slk":"sylk","socialcalc":"eth","Sh33tJS":"WTF"};var ext=o.file.slice(o.file.lastIndexOf(".")).toLowerCase();if(ext.match(/^\.[a-z]+$/))o.bookType=ext.slice(1);o.bookType=_BT[o.bookType]||o.bookType;}function writeFileSync(wb,filename,opts){var o=opts||{};o.type='file';o.file=filename;resolve_book_type(o);return writeSync(wb,o);}function writeFileAsync(filename,wb,opts,cb){var o=opts||{};o.type='file';o.file=filename;resolve_book_type(o);o.type='buffer';var _cb=cb;if(!(_cb instanceof Function))_cb=opts;return _fs.writeFile(filename,writeSync(wb,o),_cb);}function make_json_row(sheet,r,R,cols,header,hdr,dense,o){var rr=encode_row(R);var defval=o.defval,raw=o.raw||!Object.prototype.hasOwnProperty.call(o,"raw");var isempty=true;var row=header===1?[]:{};if(header!==1){if(Object.defineProperty)try{Object.defineProperty(row,'__rowNum__',{value:R,enumerable:false});}catch(e){row.__rowNum__=R;}else row.__rowNum__=R;}if(!dense||sheet[R])for(var C=r.s.c;C<=r.e.c;++C){var val=dense?sheet[R][C]:sheet[cols[C]+rr];if(val===undefined||val.t===undefined){if(defval===undefined)continue;if(hdr[C]!=null){row[hdr[C]]=defval;}continue;}var v=val.v;switch(val.t){case'z':if(v==null)break;continue;case'e':v=void 0;break;case's':case'd':case'b':case'n':break;default:throw new Error('unrecognized type '+val.t);}if(hdr[C]!=null){if(v==null){if(defval!==undefined)row[hdr[C]]=defval;else if(raw&&v===null)row[hdr[C]]=null;else continue;}else {row[hdr[C]]=raw||o.rawNumbers&&val.t=="n"?v:format_cell(val,v,o);}if(v!=null)isempty=false;}}return {row:row,isempty:isempty};}function sheet_to_json(sheet,opts){if(sheet==null||sheet["!ref"]==null)return [];var val={t:'n',v:0},header=0,offset=1,hdr=[],v=0,vv="";var r={s:{r:0,c:0},e:{r:0,c:0}};var o=opts||{};var range=o.range!=null?o.range:sheet["!ref"];if(o.header===1)header=1;else if(o.header==="A")header=2;else if(Array.isArray(o.header))header=3;else if(o.header==null)header=0;switch(typeof range){case'string':r=safe_decode_range(range);break;case'number':r=safe_decode_range(sheet["!ref"]);r.s.r=range;break;default:r=range;}if(header>0)offset=0;var rr=encode_row(r.s.r);var cols=[];var out=[];var outi=0,counter=0;var dense=Array.isArray(sheet);var R=r.s.r,C=0,CC=0;if(dense&&!sheet[R])sheet[R]=[];for(C=r.s.c;C<=r.e.c;++C){cols[C]=encode_col(C);val=dense?sheet[R][C]:sheet[cols[C]+rr];switch(header){case 1:hdr[C]=C-r.s.c;break;case 2:hdr[C]=cols[C];break;case 3:hdr[C]=o.header[C-r.s.c];break;default:if(val==null)val={w:"__EMPTY",t:"s"};vv=v=format_cell(val,null,o);counter=0;for(CC=0;CC<hdr.length;++CC)if(hdr[CC]==vv)vv=v+"_"+ ++counter;hdr[C]=vv;}}for(R=r.s.r+offset;R<=r.e.r;++R){var row=make_json_row(sheet,r,R,cols,header,hdr,dense,o);if(row.isempty===false||(header===1?o.blankrows!==false:!!o.blankrows))out[outi++]=row.row;}out.length=outi;return out;}var qreg=/"/g;function make_csv_row(sheet,r,R,cols,fs,rs,FS,o){var isempty=true;var row=[],txt="",rr=encode_row(R);for(var C=r.s.c;C<=r.e.c;++C){if(!cols[C])continue;var val=o.dense?(sheet[R]||[])[C]:sheet[cols[C]+rr];if(val==null)txt="";else if(val.v!=null){isempty=false;txt=''+(o.rawNumbers&&val.t=="n"?val.v:format_cell(val,null,o));for(var i=0,cc=0;i!==txt.length;++i)if((cc=txt.charCodeAt(i))===fs||cc===rs||cc===34||o.forceQuotes){txt="\""+txt.replace(qreg,'""')+"\"";break;}if(txt=="ID")txt='"ID"';}else if(val.f!=null&&!val.F){isempty=false;txt='='+val.f;if(txt.indexOf(",")>=0)txt='"'+txt.replace(qreg,'""')+'"';}else txt="";/* NOTE: Excel CSV does not support array formulae */row.push(txt);}if(o.blankrows===false&&isempty)return null;return row.join(FS);}function sheet_to_csv(sheet,opts){var out=[];var o=opts==null?{}:opts;if(sheet==null||sheet["!ref"]==null)return "";var r=safe_decode_range(sheet["!ref"]);var FS=o.FS!==undefined?o.FS:",",fs=FS.charCodeAt(0);var RS=o.RS!==undefined?o.RS:"\n",rs=RS.charCodeAt(0);var endregex=new RegExp((FS=="|"?"\\|":FS)+"+$");var row="",cols=[];o.dense=Array.isArray(sheet);var colinfo=o.skipHidden&&sheet["!cols"]||[];var rowinfo=o.skipHidden&&sheet["!rows"]||[];for(var C=r.s.c;C<=r.e.c;++C)if(!(colinfo[C]||{}).hidden)cols[C]=encode_col(C);for(var R=r.s.r;R<=r.e.r;++R){if((rowinfo[R]||{}).hidden)continue;row=make_csv_row(sheet,r,R,cols,fs,rs,FS,o);if(row==null){continue;}if(o.strip)row=row.replace(endregex,"");out.push(row+RS);}delete o.dense;return out.join("");}function sheet_to_txt(sheet,opts){if(!opts)opts={};opts.FS="\t";opts.RS="\n";var s=sheet_to_csv(sheet,opts);if(typeof cptable=='undefined'||opts.type=='string')return s;var o=cptable.utils.encode(1200,s,'str');return String.fromCharCode(255)+String.fromCharCode(254)+o;}function sheet_to_formulae(sheet){var y="",x,val="";if(sheet==null||sheet["!ref"]==null)return [];var r=safe_decode_range(sheet['!ref']),rr="",cols=[],C;var cmds=[];var dense=Array.isArray(sheet);for(C=r.s.c;C<=r.e.c;++C)cols[C]=encode_col(C);for(var R=r.s.r;R<=r.e.r;++R){rr=encode_row(R);for(C=r.s.c;C<=r.e.c;++C){y=cols[C]+rr;x=dense?(sheet[R]||[])[C]:sheet[y];val="";if(x===undefined)continue;else if(x.F!=null){y=x.F;if(!x.f)continue;val=x.f;if(y.indexOf(":")==-1)y=y+":"+y;}if(x.f!=null)val=x.f;else if(x.t=='z')continue;else if(x.t=='n'&&x.v!=null)val=""+x.v;else if(x.t=='b')val=x.v?"TRUE":"FALSE";else if(x.w!==undefined)val="'"+x.w;else if(x.v===undefined)continue;else if(x.t=='s')val="'"+x.v;else val=""+x.v;cmds[cmds.length]=y+"="+val;}}return cmds;}function sheet_add_json(_ws,js,opts){var o=opts||{};var offset=+!o.skipHeader;var ws=_ws||{};var _R=0,_C=0;if(ws&&o.origin!=null){if(typeof o.origin=='number')_R=o.origin;else {var _origin=typeof o.origin=="string"?decode_cell(o.origin):o.origin;_R=_origin.r;_C=_origin.c;}}var cell;var range={s:{c:0,r:0},e:{c:_C,r:_R+js.length-1+offset}};if(ws['!ref']){var _range=safe_decode_range(ws['!ref']);range.e.c=Math.max(range.e.c,_range.e.c);range.e.r=Math.max(range.e.r,_range.e.r);if(_R==-1){_R=_range.e.r+1;range.e.r=_R+js.length-1+offset;}}else {if(_R==-1){_R=0;range.e.r=js.length-1+offset;}}var hdr=o.header||[],C=0;js.forEach(function(JS,R){keys(JS).forEach(function(k){if((C=hdr.indexOf(k))==-1)hdr[C=hdr.length]=k;var v=JS[k];var t='z';var z="";var ref=encode_cell({c:_C+C,r:_R+R+offset});cell=utils.sheet_get_cell(ws,ref);if(v&&typeof v==='object'&&!(v instanceof Date)){ws[ref]=v;}else {if(typeof v=='number')t='n';else if(typeof v=='boolean')t='b';else if(typeof v=='string')t='s';else if(v instanceof Date){t='d';if(!o.cellDates){t='n';v=datenum(v);}z=o.dateNF||SSF._table[14];}if(!cell)ws[ref]=cell={t:t,v:v};else {cell.t=t;cell.v=v;delete cell.w;delete cell.R;if(z)cell.z=z;}if(z)cell.z=z;}});});range.e.c=Math.max(range.e.c,_C+hdr.length-1);var __R=encode_row(_R);if(offset)for(C=0;C<hdr.length;++C)ws[encode_col(C+_C)+__R]={t:'s',v:hdr[C]};ws['!ref']=encode_range(range);return ws;}function json_to_sheet(js,opts){return sheet_add_json(null,js,opts);}var utils={encode_col:encode_col,encode_row:encode_row,encode_cell:encode_cell,encode_range:encode_range,decode_col:decode_col,decode_row:decode_row,split_cell:split_cell,decode_cell:decode_cell,decode_range:decode_range,format_cell:format_cell,get_formulae:sheet_to_formulae,make_csv:sheet_to_csv,make_json:sheet_to_json,make_formulae:sheet_to_formulae,sheet_add_aoa:sheet_add_aoa,sheet_add_json:sheet_add_json,sheet_add_dom:sheet_add_dom,aoa_to_sheet:aoa_to_sheet,json_to_sheet:json_to_sheet,table_to_sheet:parse_dom_table,table_to_book:table_to_book,sheet_to_csv:sheet_to_csv,sheet_to_txt:sheet_to_txt,sheet_to_json:sheet_to_json,sheet_to_html:HTML_.from_sheet,sheet_to_formulae:sheet_to_formulae,sheet_to_row_object_array:sheet_to_json};(function(utils){utils.consts=utils.consts||{};function add_consts(R/*Array<any>*/){R.forEach(function(a){utils.consts[a[0]]=a[1];});}function get_default(x,y,z){return x[y]!=null?x[y]:x[y]=z;}/* get cell, creating a stub if necessary */function ws_get_cell_stub(ws,R,C){/* A1 cell address */if(typeof R=="string"){/* dense */if(Array.isArray(ws)){var RC=decode_cell(R);if(!ws[RC.r])ws[RC.r]=[];return ws[RC.r][RC.c]||(ws[RC.r][RC.c]={t:'z'});}return ws[R]||(ws[R]={t:'z'});}/* cell address object */if(typeof R!="number")return ws_get_cell_stub(ws,encode_cell(R));/* R and C are 0-based indices */return ws_get_cell_stub(ws,encode_cell({r:R,c:C||0}));}utils.sheet_get_cell=ws_get_cell_stub;/* find sheet index for given name / validate index */function wb_sheet_idx(wb,sh){if(typeof sh=="number"){if(sh>=0&&wb.SheetNames.length>sh)return sh;throw new Error("Cannot find sheet # "+sh);}else if(typeof sh=="string"){var idx=wb.SheetNames.indexOf(sh);if(idx>-1)return idx;throw new Error("Cannot find sheet name |"+sh+"|");}else throw new Error("Cannot find sheet |"+sh+"|");}/* simple blank workbook object */utils.book_new=function(){return {SheetNames:[],Sheets:{}};};/* add a worksheet to the end of a given workbook */utils.book_append_sheet=function(wb,ws,name){if(!name)for(var i=1;i<=0xFFFF;++i,name=undefined)if(wb.SheetNames.indexOf(name="Sheet"+i)==-1)break;if(!name||wb.SheetNames.length>=0xFFFF)throw new Error("Too many worksheets");check_ws_name(name);if(wb.SheetNames.indexOf(name)>=0)throw new Error("Worksheet with name |"+name+"| already exists!");wb.SheetNames.push(name);wb.Sheets[name]=ws;};/* set sheet visibility (visible/hidden/very hidden) */utils.book_set_sheet_visibility=function(wb,sh,vis){get_default(wb,"Workbook",{});get_default(wb.Workbook,"Sheets",[]);var idx=wb_sheet_idx(wb,sh);// $FlowIgnore
get_default(wb.Workbook.Sheets,idx,{});switch(vis){case 0:case 1:case 2:break;default:throw new Error("Bad sheet visibility setting "+vis);}// $FlowIgnore
wb.Workbook.Sheets[idx].Hidden=vis;};add_consts([["SHEET_VISIBLE",0],["SHEET_HIDDEN",1],["SHEET_VERY_HIDDEN",2]]);/* set number format */utils.cell_set_number_format=function(cell,fmt){cell.z=fmt;return cell;};/* set cell hyperlink */utils.cell_set_hyperlink=function(cell,target,tooltip){if(!target){delete cell.l;}else {cell.l={Target:target};if(tooltip)cell.l.Tooltip=tooltip;}return cell;};utils.cell_set_internal_link=function(cell,range,tooltip){return utils.cell_set_hyperlink(cell,"#"+range,tooltip);};/* add to cell comments */utils.cell_add_comment=function(cell,text,author){if(!cell.c)cell.c=[];cell.c.push({t:text,a:author||"SheetJS"});};/* set array formula and flush related cells */utils.sheet_set_array_formula=function(ws,range,formula){var rng=typeof range!="string"?range:safe_decode_range(range);var rngstr=typeof range=="string"?range:encode_range(range);for(var R=rng.s.r;R<=rng.e.r;++R)for(var C=rng.s.c;C<=rng.e.c;++C){var cell=ws_get_cell_stub(ws,R,C);cell.t='n';cell.F=rngstr;delete cell.v;if(R==rng.s.r&&C==rng.s.c)cell.f=formula;}return ws;};return utils;})(utils);if(has_buf&&typeof commonjsRequire!='undefined')(function(){var Readable=stream.Readable;var write_csv_stream=function(sheet,opts){var stream=Readable();var o=opts==null?{}:opts;if(sheet==null||sheet["!ref"]==null){stream.push(null);return stream;}var r=safe_decode_range(sheet["!ref"]);var FS=o.FS!==undefined?o.FS:",",fs=FS.charCodeAt(0);var RS=o.RS!==undefined?o.RS:"\n",rs=RS.charCodeAt(0);var endregex=new RegExp((FS=="|"?"\\|":FS)+"+$");var row="",cols=[];o.dense=Array.isArray(sheet);var colinfo=o.skipHidden&&sheet["!cols"]||[];var rowinfo=o.skipHidden&&sheet["!rows"]||[];for(var C=r.s.c;C<=r.e.c;++C)if(!(colinfo[C]||{}).hidden)cols[C]=encode_col(C);var R=r.s.r;var BOM=false;stream._read=function(){if(!BOM){BOM=true;return stream.push("\uFEFF");}while(R<=r.e.r){++R;if((rowinfo[R-1]||{}).hidden)continue;row=make_csv_row(sheet,r,R-1,cols,fs,rs,FS,o);if(row!=null){if(o.strip)row=row.replace(endregex,"");stream.push(row+RS);break;}}if(R>r.e.r)return stream.push(null);};return stream;};var write_html_stream=function(ws,opts){var stream=Readable();var o=opts||{};var header=o.header!=null?o.header:HTML_.BEGIN;var footer=o.footer!=null?o.footer:HTML_.END;stream.push(header);var r=decode_range(ws['!ref']);o.dense=Array.isArray(ws);stream.push(HTML_._preamble(ws,r,o));var R=r.s.r;var end=false;stream._read=function(){if(R>r.e.r){if(!end){end=true;stream.push("</table>"+footer);}return stream.push(null);}while(R<=r.e.r){stream.push(HTML_._row(ws,r,R,o));++R;break;}};return stream;};var write_json_stream=function(sheet,opts){var stream=Readable({objectMode:true});if(sheet==null||sheet["!ref"]==null){stream.push(null);return stream;}var val={t:'n',v:0},header=0,offset=1,hdr=[],v=0,vv="";var r={s:{r:0,c:0},e:{r:0,c:0}};var o=opts||{};var range=o.range!=null?o.range:sheet["!ref"];if(o.header===1)header=1;else if(o.header==="A")header=2;else if(Array.isArray(o.header))header=3;switch(typeof range){case'string':r=safe_decode_range(range);break;case'number':r=safe_decode_range(sheet["!ref"]);r.s.r=range;break;default:r=range;}if(header>0)offset=0;var rr=encode_row(r.s.r);var cols=[];var counter=0;var dense=Array.isArray(sheet);var R=r.s.r,C=0,CC=0;if(dense&&!sheet[R])sheet[R]=[];for(C=r.s.c;C<=r.e.c;++C){cols[C]=encode_col(C);val=dense?sheet[R][C]:sheet[cols[C]+rr];switch(header){case 1:hdr[C]=C-r.s.c;break;case 2:hdr[C]=cols[C];break;case 3:hdr[C]=o.header[C-r.s.c];break;default:if(val==null)val={w:"__EMPTY",t:"s"};vv=v=format_cell(val,null,o);counter=0;for(CC=0;CC<hdr.length;++CC)if(hdr[CC]==vv)vv=v+"_"+ ++counter;hdr[C]=vv;}}R=r.s.r+offset;stream._read=function(){if(R>r.e.r)return stream.push(null);while(R<=r.e.r){//if ((rowinfo[R-1]||{}).hidden) continue;
var row=make_json_row(sheet,r,R,cols,header,hdr,dense,o);++R;if(row.isempty===false||(header===1?o.blankrows!==false:!!o.blankrows)){stream.push(row.row);break;}}};return stream;};XLSX.stream={to_json:write_json_stream,to_html:write_html_stream,to_csv:write_csv_stream};})();if(typeof parse_xlscfb!=="undefined")XLSX.parse_xlscfb=parse_xlscfb;XLSX.parse_zip=parse_zip;XLSX.read=readSync;//xlsread
XLSX.readFile=readFileSync;//readFile
XLSX.readFileSync=readFileSync;XLSX.write=writeSync;XLSX.writeFile=writeFileSync;XLSX.writeFileSync=writeFileSync;XLSX.writeFileAsync=writeFileAsync;XLSX.utils=utils;XLSX.SSF=SSF;if(typeof CFB!=="undefined")XLSX.CFB=CFB;}/*global define */make_xlsx_lib(exports);});

var downloadToExcel = function downloadToExcel(fileName, apiData, sheetNames) {
  var fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  var fileExtension = ".xlsx";
  var ws = xlsx.utils.json_to_sheet(apiData);
  var wb = {
    Sheets: _defineProperty({}, sheetNames[0], ws),
    SheetNames: sheetNames
  };
  var excelBuffer = xlsx.write(wb, {
    bookType: "xlsx",
    type: "array"
  });
  var data = new Blob([excelBuffer], {
    type: fileType
  }); // Create a link

  var link = document.createElement("a"); // Set link with the file for download

  link.href = window.URL.createObjectURL(new Blob([data]));
  link.setAttribute("download", fileName + fileExtension); // Add the link to the page, click it and remove it again.

  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};
var downloadToTxt = function downloadToTxt(fileName, data) {
  try {
    var fileData = data.replace(",", "\r\n");
    var blob = new Blob([fileData], {
      type: "text/plain"
    });
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.download = "".concat(fileName, ".txt");
    link.href = url;
    link.click();
    return true;
  } catch (e) {
    console.error(e);
  }
};
var downloadToCSV = function downloadToCSV(fileName, data) {
  try {
    var fileData = data.replace(",", "\r\n");
    var blob = new Blob([fileData], {
      type: "text/csv;charset=utf-8;"
    });
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.download = "".concat(fileName, ".csv");
    link.href = url;
    link.click();
    return true;
  } catch (e) {
    console.error(e);
  }
};

var formatItemOnfieldType = function formatItemOnfieldType(item, fieldType) {
  switch (fieldType) {
    case "Date":
      return formatDateTime(item);

    default:
      return item;
  }
};

var ArrUnique = function ArrUnique(arr) {
  var uniques = [];
  var stringify = {};

  for (var i = 0; i < arr.length; i++) {
    var keys = Object.keys(arr[i]);
    keys.sort(function (a, b) {
      return a - b;
    });
    var str = "";

    for (var j = 0; j < keys.length; j++) {
      str += JSON.stringify(keys[j]);
      str += JSON.stringify(arr[i][keys[j]]);
    }

    if (!stringify.hasOwnProperty(str)) {
      uniques.push(arr[i]);
      stringify[str] = true;
    }
  }

  return uniques;
};

var DetailListGroup = function DetailListGroup(currentGroups, items, key, isCollapsed) {
  var groups = items.map(function (i) {
    return {
      key: i[key],
      name: i[key],
      isCollapsed: currentGroups && currentGroups.filter(function (g) {
        return g.key === i[key];
      }).length ? currentGroups.filter(function (g) {
        return g.key === i[key];
      })[0].isCollapsed : isCollapsed
    };
  });
  return ArrUnique(groups);
};

function copyToClipboard(_x, _x2) {
  return _copyToClipboard.apply(this, arguments);
}

function _copyToClipboard() {
  _copyToClipboard = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(text, setMessage) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return navigator.clipboard.writeText(text);

          case 3:
            setMessage(true);
            setTimeout(function () {
              setMessage(false);
            }, 3000);
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            setMessage(false);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _copyToClipboard.apply(this, arguments);
}

function useDeepEffect(callback, dependencies) {
  function useCompare(value) {
    var ref = useRef(value);
    var signalRef = useRef(0);

    if (!deepCompare(value, ref.current)) {
      ref.current = value;
      signalRef.current += 1;
    }

    return useMemo(function () {
      return ref.current;
    }, [signalRef.current]);
  }

  return useEffect(callback, useCompare(dependencies));
}

function CustomDialog(props) {
  var iconProps = props.iconProps,
      footer = props.footer,
      childrenContainerProps = props.childrenContainerProps,
      containerProps = props.containerProps;
  return /*#__PURE__*/React__default.createElement(Modal, props, /*#__PURE__*/React__default.createElement(Stack, _extends({
    as: "section",
    styles: {
      root: (containerProps === null || containerProps === void 0 ? void 0 : containerProps.styles) || {
        marginLeft: 30,
        marginTop: 30,
        marginRight: 30,
        marginBottom: 10
      }
    }
  }, containerProps), iconProps && /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: iconProps === null || iconProps === void 0 ? void 0 : iconProps.iconName,
    styles: {
      root: (iconProps === null || iconProps === void 0 ? void 0 : iconProps.iconStyles) || {
        color: DefaultPalette$2.blue,
        fontSize: "36px"
      }
    }
  }), (iconProps === null || iconProps === void 0 ? void 0 : iconProps.title) && /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        paddingLeft: "20px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "large"
  }, iconProps === null || iconProps === void 0 ? void 0 : iconProps.title))), /*#__PURE__*/React__default.createElement(Stack, _extends({
    as: "section",
    styles: {
      root: (childrenContainerProps === null || childrenContainerProps === void 0 ? void 0 : childrenContainerProps.styles) || {
        display: "flex",
        flexDirection: "column"
      }
    }
  }, childrenContainerProps), props.children), footer && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Separator, null), /*#__PURE__*/React__default.createElement(DialogFooter, null, /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        display: "flex",
        flexDirection: "row",
        "float": "right",
        gap: "10px"
      }
    }
  }, footer)))));
}

CustomDialog.propTypes = {
  iconProps: PropTypes.shape({
    iconName: PropTypes.string.isRequired,
    iconStyles: PropTypes.object,
    title: PropTypes.string
  }),
  footer: PropTypes.node.isRequired,
  childrenContainerProps: PropTypes.object,
  containerProps: PropTypes.object,
  children: PropTypes.node.isRequired
};
CustomDialog.defaultProps = {
  iconProps: null,
  footer: null,
  childrenContainerProps: {},
  containerProps: {}
};

/**
 * @description Profile informations
 * @param {object} props
 *  @param {object} item
 * @returns {JSX.Element}
 */

var SectionedProfile = function SectionedProfile(props) {
  var sections = props.sections;
  return /*#__PURE__*/React__default.createElement(Stack, {
    tokens: {
      childrenGap: 15
    }
  }, sections.map(function (section, index) {
    return /*#__PURE__*/React__default.createElement(ProfileSection, {
      sectionInfo: section,
      key: section.key,
      defaultOpen: true
    }, /*#__PURE__*/React__default.createElement(ProfileFieldCategoryList, {
      fieldCategories: section.fieldInformation
    }));
  }));
};

var ProfileFieldCategoryList = function ProfileFieldCategoryList(_ref) {
  var fieldCategories = _ref.fieldCategories;
  if (!fieldCategories || fieldCategories.length === 0) return null;
  return fieldCategories.length > 0 && fieldCategories.map(function (i) {
    return /*#__PURE__*/React__default.createElement(FlexWrapedItemGroups, {
      key: i.key,
      iconName: i.iconName,
      title: i.title,
      fieldCategories: i.fieldCategories
    });
  });
};

var ProfileSection = function ProfileSection(_ref2) {
  var children = _ref2.children,
      sectionInfo = _ref2.sectionInfo,
      _ref2$defaultOpen = _ref2.defaultOpen,
      defaultOpen = _ref2$defaultOpen === void 0 ? false : _ref2$defaultOpen;

  var _useState = useState(defaultOpen),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var iconName = sectionInfo.iconName,
      title = sectionInfo.title;
  return /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        width: "100%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    styles: {
      root: {
        position: "relative",
        width: "100%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    verticalAlign: "center",
    styles: {
      root: {
        paddingTop: 15
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: iconName || "Org",
    styles: {
      root: {
        color: DefaultPalette$2.green,
        padding: 8,
        marginLeft: 8,
        marginRight: 6,
        fontSize: 18,
        width: 18,
        border: "1px solid ".concat(DefaultPalette$2.themeLight),
        borderRadius: "50%",
        backgroundColor: DefaultPalette$2.white
      }
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    variant: "mediumPlus"
  }, title)), /*#__PURE__*/React__default.createElement(Stack, {
    horizontal: true,
    styles: {
      root: {
        position: "absolute",
        top: "50%",
        right: 0,
        cursor: "pointer",
        fontSize: 9,
        color: "#605e5c"
      }
    },
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "small"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    iconName: isOpen ? "ChevronUp" : "ChevronDown",
    styles: {
      root: {
        marginRight: 7
      }
    }
  }), isOpen ? i18n._(
  /*i18n*/
  {
    id: "Hide details"
  }) : i18n._(
  /*i18n*/
  {
    id: "Show details"
  })))), isOpen && /*#__PURE__*/React__default.createElement(Stack, null, children));
};

export { AccessDenied, ActivityPanel, ApiCall, AppTile, Approval, ArrUnique, BaseApp, BaseLayout, BlockingSpinner, Card, ContextBar, CustomDialog, CustomLabel, DatePickerField, DateTimePeriodPicker, DateTimePickerField, DetailListGroup, DurationPickerField, FetchingUserProfile, FlexWrapedItemGroups, ItemContent, ItemDetails, ItemEditor, ItemGroup, ItemGroupTitle, ItemTop, LinkTile, LocalUiState, LoggedInUser, Logout, MessageBox, Metabar, MissingMultiFactor, NavMenu, NoItemSelected, NoUserProfileDataFound as NoUserProfileData, NotFound404, NotificationIcons, Notifications, NotificationsList, OrgHelper, Organisation, OusPickerField, PagedDetailList, PagingHeader, PagingSelectionList, PeoplePickerField, PivotMenu, Profile, ProfileTile, RegexpTextField, ReportTile, Retry, RetryKombit, SearchField$1 as SearchField, SectionedProfile, SelectionDetailsList, SelectionList, SelectionTreeList, StringToHTML, Tag, TimePickerField, TreeList, Urls, UserIdPickerField, ViewDetailsList, catalogs, cleanHtml, copyToClipboard, dateTimeFromDateTimeObj, deepCompare, diffenceInMinutes, downloadToCSV, downloadToExcel, downloadToTxt, durationInMinutes, formatDate, formatDateTime, formatDateTimeSeconds, formatItemOnfieldType, formatTime, getPreferredLanguage, getWeekNumber, getWeekday, handleSetCookies, i18n, isDateInLastMonth, isDateInLastWeek, isDateInThisMonth, isDateInThisWeek, isDateThreeWeekAgo, isDateToday, isDateYesterday, isValidDate, isValidDateObj, index$3 as orderListColumnItems, parseToBoolean, setPreferredLanguage, translateEntryKeys, useDeepEffect, useFuse, useKles, usePaging, useTreeSearch, validateRegex };
//# sourceMappingURL=index.es.js.map
